"use strict";

var app = angular.module("ipcam", ["ngResource", "ngAnimate", "pascalprecht.translate", "ui.router", "ui.swiper", "ngSanitize", "ipcam.config", "ngTouch", "tmh.dynamicLocale", "ngStorage", "infinite-scroll", "custom-infinite-scroll"]);
app.config(["$httpProvider", "tmhDynamicLocaleProvider", function ($httpProvider, tmhDynamicLocaleProvider) {
  $httpProvider.interceptors.push("AuthInterceptor");
  $httpProvider.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded";
  $httpProvider.defaults.headers.put["Content-Type"] = "application/x-www-form-urlencoded";
  $httpProvider.defaults.transformRequest = function (data) {
    if (data === undefined) {
      return data;
    }
    var i,
      queries = [];
    for (i in data) {
      if (data.hasOwnProperty(i)) {
        var str = encodeURIComponent(i) + "=" + encodeURIComponent(data[i]);
        queries.push(str);
      }
    }
    return queries.join("&");
  };
  tmhDynamicLocaleProvider.localeLocationPattern("/resources/vendor/angular-i18n/angular-locale_{{locale}}.js");
}]);

// 한글 model binding bug
app.config(["$provide", function ($provide) {
  $provide.decorator("inputDirective", function ($delegate, $log) {
    var directive = $delegate[0];
    angular.extend(directive.link, {
      post: function post(scope, element, attr, ctrls) {
        element.on("compositionupdate", function (event) {
          element.triggerHandler("compositionend");
        });
      }
    });
    return $delegate;
  });
}]);
app.config(function ($stateProvider, $urlRouterProvider) {
  $urlRouterProvider.otherwise("/");
  function buildTemplateUrl(url) {
    return url + "?t=" + window.buildTime;
  }
  $stateProvider.state("index", {
    url: "/index",
    onEnter: function onEnter($state, $rootScope, User, Utils) {
      User.me(function (data) {
        window.country = (data === null || data === void 0 ? void 0 : data.country) === "JP" ? "ja" : "ko";
        $rootScope.countryDomain = (data === null || data === void 0 ? void 0 : data.country) === "JP" ? "ja" : "ko";
        if (data.code === "ok") {
          $rootScope.me = data;
          $rootScope.isLanguageJp = Utils.getBrowserLanguage() === "ja_JP";
          $rootScope.isJp = (data === null || data === void 0 ? void 0 : data.country) === "JP" || Utils.getBrowserLanguage() === "ja_JP";
          var nextUrl = $rootScope.isJp ? "main.cameraGroup.group" : "main.dashboard.shop";
          $state.go(nextUrl);
        } else {
          $state.go("main");
        }
      }, function (err) {
        $state.go("main.error");
      });
    }
  }).state("lproc", {
    url: "/lproc",
    onEnter: function onEnter($state) {
      // ! 비밀번호 변경 후 유입
      if (location.href.indexOf("from=myInfoChangePwd.nhn") !== -1) {
        if (window.opener) {
          window.opener.location.reload();
          window.close();
        } else {
          location.href = "/#/index";
        }
        return;
      }
      if (opener != null) {
        opener.location = "/#/index";
        window.close();
      } else {
        location.href = "/#/index";
      }
    }
  }).state("signout", {
    url: "/signout",
    onEnter: function onEnter($state) {
      if (opener != null) {
        if (opener.signOutCheckCallback) {
          opener.signOutCheckCallback();
        }
        self.close();
      } else {
        location.href = "/#/error";
      }
    }
  }).state("resetCVRPassword", {
    url: "/resetCVRPassword",
    onEnter: function onEnter($state) {
      if (opener != null) {
        if (opener.confirmPaycoPasswordCallback) {
          opener.confirmPaycoPasswordCallback();
        }
        self.close();
      } else {
        location.href = "/#/error";
      }
    }
  }).state("passwordConfirm", {
    url: "/passwordConfirm",
    views: {
      content: {
        templateUrl: buildTemplateUrl("/templates/common/passwordConfirm.html"),
        controller: "PasswordConfirmCtrl"
      }
    }
  }).state("main", {
    url: "/",
    views: {
      header: {
        templateUrl: buildTemplateUrl("/templates/common/_top.html"),
        controller: "HeaderCtrl"
      },
      content: {
        templateUrl: buildTemplateUrl("/templates/login/loginSelect.html"),
        controller: "LoginSelectCtrl"
      },
      footer: {
        templateUrl: buildTemplateUrl("/templates/common/_bottom.html"),
        controller: "FooterCtrl"
      }
    }
  }).state("mobile", {
    url: "/mobile",
    views: {
      header: {
        templateUrl: buildTemplateUrl("/templates/common/_top_m.html"),
        controller: "HeaderMobileCtrl"
      },
      content: {
        templateUrl: buildTemplateUrl("/templates/partials/indexMobile2.html"),
        controller: "IndexMobileCtrl2"
      },
      footer: {
        templateUrl: buildTemplateUrl("/templates/common/_bottom_m.html")
      }
    }
  }).state("noticeM", {
    url: "/noticeMobile?lang",
    views: {
      content: {
        templateUrl: buildTemplateUrl("/templates/help/notice_mobile.html"),
        controller: "NoticeMobileCtrl"
      }
    }
  }).state("terms", {
    url: "/terms",
    views: {
      content: {
        templateUrl: buildTemplateUrl("/templates/common/content.html")
      }
    }
  }).state("termsJP", {
    url: "/termsJP",
    views: {
      content: {
        templateUrl: buildTemplateUrl("/templates/common/contentJP.html")
      }
    }
  }).state("shareTerms", {
    url: "/shareTerms",
    views: {
      content: {
        templateUrl: buildTemplateUrl("/templates/common/shareTerms.html")
      }
    }
  }).state("positionTermsJP", {
    url: "/positionTermsJP",
    views: {
      content: {
        templateUrl: buildTemplateUrl("/templates/common/positionInfoTermJP.html")
      }
    }
  }).state("positionTerms", {
    url: "/positionTerms",
    views: {
      content: {
        templateUrl: buildTemplateUrl("/templates/common/positionInfoTerm.html"),
        controller: "positionTerms"
      }
    }
    // ! gateway-ip / gateway-analog 구분이 생겼으나, 기존 url 을 활용할 수 있으므로 유지
  }).state("gatewayGuide", {
    url: "/gatewayGuide",
    views: {
      content: {
        templateUrl: buildTemplateUrl("/templates/common/gatewayGuide.html"),
        controller: "gatewayCtrl"
      }
    }
  }).state("gatewayIpGuide", {
    url: "/gatewayIpGuide",
    views: {
      content: {
        templateUrl: buildTemplateUrl("/templates/common/gatewayGuide.html"),
        controller: "gatewayCtrl"
      }
    }
  }).state("gatewayAnalogGuide", {
    url: "/gatewayAnalogGuide",
    views: {
      content: {
        templateUrl: buildTemplateUrl("/templates/common/gatewayAnalogGuide.html"),
        controller: "gatewayAnalogCtrl"
      }
    }
  }).state("partnerSignup", {
    url: "/partnerSignup",
    views: {
      content: {
        templateUrl: buildTemplateUrl("/templates/common/partnerSignup.html"),
        controller: "PartnerSignupCtrl"
      }
    }
  }).state("signup", {
    url: "/signup?lang&email&authKey",
    views: {
      "content@": {
        templateUrl: buildTemplateUrl("/templates/login/signup.html"),
        controller: "SignUpCtrl"
      }
    }
  }).state("main.error", {
    url: "error",
    views: {
      "content@": {
        templateUrl: buildTemplateUrl("/templates/err/error.html")
      }
    }
  })
  //FIXME: 사용되는지 체크필요 임시 주석처리
  .state("main.login", {
    url: "loginWithPayco?installKey",
    views: {
      "content@": {
        templateUrl: buildTemplateUrl("/templates/login/login.html"),
        controller: "LoginCtrl"
      }
    }
  }).state("main.loginWithEmail", {
    url: "loginWithEmail?installKey",
    views: {
      "content@": {
        templateUrl: buildTemplateUrl("/templates/login/loginWithEmail.html"),
        controller: "LoginWithEmailCtrl"
      }
    }
  }).state("main.notice", {
    url: "notice",
    views: {
      "content@": {
        templateUrl: buildTemplateUrl("/templates/notice/notice.html"),
        controller: "NoticeCtrl"
      }
    }
  }).state("main.help", {
    url: "",
    views: {
      "content@": {
        templateUrl: buildTemplateUrl("/templates/help/help_center.html"),
        controller: "HelpCenterCtrl"
      }
    }
  }).state("main.help.faq", {
    url: "help/faq?categoryNo",
    views: {
      "lnb@main.help": {
        templateUrl: buildTemplateUrl("/templates/help/_help_left_menu.html"),
        controller: "HelpMenuCtrl"
      },
      "content@main.help": {
        templateUrl: buildTemplateUrl("/templates/help/_help_faq.html"),
        controller: "FaqCtrl"
      }
    }
  }).state("main.help.faqM", {
    url: "help/faqM",
    views: {
      header: {
        templateUrl: buildTemplateUrl("/templates/common/_top_m.html")
      },
      content: {
        templateUrl: buildTemplateUrl("/templates/help/_help_faq_mobile.html"),
        controller: "FaqCtrl"
      },
      footer: {
        templateUrl: buildTemplateUrl("/templates/common/_bottom_m.html")
      }
    }
  }).state("main.help.support", {
    url: "support",
    views: {
      "lnb@main.help": {
        templateUrl: buildTemplateUrl("/templates/help/_help_left_menu.html"),
        controller: "HelpMenuCtrl"
      },
      "content@main.help": {
        templateUrl: buildTemplateUrl("/templates/help/_help_faq.html"),
        controller: "FaqCtrl"
      }
    }
  }).state("main.help.inquiry", {
    url: "help/inquiry?type",
    views: {
      "lnb@main.help": {
        templateUrl: buildTemplateUrl("/templates/help/_help_left_menu.html"),
        controller: "HelpMenuCtrl"
      },
      "content@main.help": {
        templateUrl: buildTemplateUrl("/templates/help/_help_inquiry.html"),
        controller: "InquiryCtrl"
      }
    }
  }).state("main.help.inquiryM", {
    url: "help/inquiryM",
    views: {
      header: {
        templateUrl: buildTemplateUrl("/templates/common/_top_m.html")
      },
      content: {
        templateUrl: buildTemplateUrl("/templates/help/_help_inquiry_mobile.html"),
        controller: "InquiryCtrl"
      },
      footer: {
        templateUrl: buildTemplateUrl("/templates/common/_bottom_m.html")
      }
    }
  }).state("main.help.inquiryMJP", {
    url: "help/inquiryMJP",
    views: {
      header: {
        templateUrl: buildTemplateUrl("/templates/common/_top_m.html")
      },
      content: {
        templateUrl: buildTemplateUrl("/templates/help/_help_inquiry_mobile_jp.html"),
        controller: "InquiryCtrl"
      },
      footer: {
        templateUrl: buildTemplateUrl("/templates/common/_bottom_m.html")
      }
    }
  }).state("main.help.inquiryResult", {
    url: "help/inquiryResult",
    views: {
      "lnb@main.help": {
        templateUrl: buildTemplateUrl("/templates/help/_help_left_menu.html"),
        controller: "HelpMenuCtrl"
      },
      "content@main.help": {
        templateUrl: buildTemplateUrl("/templates/help/_help_inquiry_result.html")
      }
    }
  }).state("main.help.inquiryResultM", {
    url: "help/inquiryResultM",
    views: {
      header: {
        templateUrl: buildTemplateUrl("/templates/common/_top_m.html")
      },
      content: {
        templateUrl: buildTemplateUrl("/templates/help/_help_inquiry_result_mobile.html"),
        controller: "InquiryCtrl"
      },
      footer: {
        templateUrl: buildTemplateUrl("/templates/common/_bottom_m.html")
      }
    }
  }).state("main.help.qna", {
    url: "help/qna",
    views: {
      "lnb@main.help": {
        templateUrl: buildTemplateUrl("/templates/help/_help_left_menu.html"),
        controller: "HelpMenuCtrl"
      },
      "content@main.help": {
        templateUrl: buildTemplateUrl("/templates/help/_help_qna.html"),
        controller: "QnaCtrl"
      }
    }
  }).state("main.help.api", {
    url: "help/api",
    views: {
      "lnb@main.help": {
        templateUrl: buildTemplateUrl("/templates/help/_help_left_menu.html"),
        controller: "HelpMenuCtrl"
      },
      "content@main.help": {
        templateUrl: buildTemplateUrl("/templates/help/_help_api.html")
        // controller: 'ApiCtrl'
      }
    }
  }).state("main.help.customerCenter", {
    url: "help/customerCenter",
    views: {
      "content@main.help": {
        templateUrl: buildTemplateUrl("/templates/help/_help_cs.html"),
        controller: "CustomerCenterCtrl"
      }
    }
  }).state("findPassword", {
    url: "/findPassword?email&authKey",
    views: {
      "content@": {
        templateUrl: buildTemplateUrl("/templates/user/_findPassword.html"),
        controller: "FindPasswordCtrl"
      }
    }
  })

  // FIXME: 사용되지 않는것으로 예상
  .state("main.findPassword", {
    url: "findPassword2",
    views: {
      "content@": {
        templateUrl: buildTemplateUrl("/templates/user/findPassword.html"),
        controller: "FindPasswordCtrl"
      }
    }
  }).state("myInfo", {
    url: "/myInfo?lang",
    views: {
      "content@": {
        templateUrl: buildTemplateUrl("/templates/user/myInfoMng.html"),
        controller: "MyInfoCtrl"
      }
    }
  }).state("main.settings", {
    url: "",
    views: {
      "content@": {
        templateUrl: buildTemplateUrl("/templates/settings/settings.html"),
        controller: "SettingsCtrl"
      }
    }
  }).state("main.settings.product", {
    url: "settings/product",
    views: {
      "settingsLnb@main.settings": {
        templateUrl: buildTemplateUrl("/templates/settings/left_menu.html"),
        controller: "SettingsMenuCtrl"
      },
      "settingsContent@main.settings": {
        templateUrl: buildTemplateUrl("/templates/settings/product.html"),
        controller: "SettingsProductCtrl"
      }
    },
    authenticate: true
  }).state("main.settings.firmware", {
    // 카메라 펌웨어 업데이트
    url: "settings/firmware",
    views: {
      "settingsLnb@main.settings": {
        templateUrl: buildTemplateUrl("/templates/settings/left_menu.html"),
        controller: "SettingsMenuCtrl"
      },
      "settingsContent@main.settings": {
        templateUrl: buildTemplateUrl("/templates/settings/firmware.html"),
        controller: "SettingsFirmwareCtrl"
      }
    },
    authenticate: true
  })

  //FIXME: 경로 체크 필요함
  .state("main.settings.policy", {
    // 약관 및 이용동의
    url: "settings/policy",
    views: {
      "settingsLnb@main.settings": {
        templateUrl: buildTemplateUrl("/templates/settings/left_menu.html"),
        controller: "SettingsMenuCtrl"
      },
      "settingsContent@main.settings": {
        templateUrl: buildTemplateUrl("/templates/settings/policy.html"),
        controller: "SettingsPolicyCtrl"
      }
    },
    authenticate: true
  }).state("main.settings.play", {
    // 플레이어 설정
    url: "settings/play",
    views: {
      "settingsLnb@main.settings": {
        templateUrl: buildTemplateUrl("/templates/settings/left_menu.html"),
        controller: "SettingsMenuCtrl"
      },
      "settingsContent@main.settings": {
        templateUrl: buildTemplateUrl("/templates/settings/play.html"),
        controller: "SettingsPlayCtrl"
      }
    },
    authenticate: true // 약관동의 여부 확인
  }).state("main.manage", {
    url: "manage",
    views: {
      "content@": {
        templateUrl: buildTemplateUrl("/templates/manage/manage.html"),
        controller: "ManageCtrl"
      },
      "manageLnb@main.manage": {
        // 추가된 부분
        templateUrl: buildTemplateUrl("/templates/manage/left_menu.html"),
        controller: "ManageMenuCtrl"
      }
    }
  }).state("main.manage.iothub", {
    url: "/iothub",
    views: {
      "manageLnb@main.manage": {
        templateUrl: buildTemplateUrl("/templates/manage/left_menu.html"),
        controller: "ManageMenuCtrl"
      },
      "manageContent@main.manage": {
        templateUrl: buildTemplateUrl("/templates/manage/iothub.html"),
        controller: "ManageIothubCtrl"
      }
    },
    authenticate: true // 약관동의 여부 확인
  }).state("main.manage.sensor", {
    url: "/sensor",
    views: {
      "manageLnb@main.manage": {
        templateUrl: buildTemplateUrl("/templates/manage/left_menu.html"),
        controller: "ManageMenuCtrl"
      },
      "manageContent@main.manage": {
        templateUrl: buildTemplateUrl("/templates/manage/sensor.html"),
        controller: "ManageSensorCtrl"
      }
    },
    authenticate: true // 약관동의 여부 확인
  }).state("main.manage.doorlock", {
    url: "/doorlock",
    views: {
      "manageLnb@main.manage": {
        templateUrl: buildTemplateUrl("/templates/manage/left_menu.html"),
        controller: "ManageMenuCtrl"
      },
      "manageContent@main.manage": {
        templateUrl: buildTemplateUrl("/templates/manage/doorlock.html"),
        controller: "ManageDoorlockCtrl"
      }
    },
    authenticate: true // 약관동의 여부 확인
  }).state("main.manage.did", {
    url: "/did",
    views: {
      "manageLnb@main.manage": {
        templateUrl: buildTemplateUrl("/templates/manage/left_menu.html"),
        controller: "ManageMenuCtrl"
      },
      "manageContent@main.manage": {
        templateUrl: buildTemplateUrl("/templates/manage/did.html"),
        controller: "ManageDidCtrl"
      }
    },
    authenticate: true // 약관동의 여부 확인
  }).state("main.manage.didcontents", {
    url: "/didcontents/:didId?shopId&didName&shopName",
    views: {
      "manageLnb@main.manage": {
        templateUrl: buildTemplateUrl("/templates/manage/left_menu.html"),
        controller: "ManageMenuCtrl"
      },
      "manageContent@main.manage": {
        templateUrl: buildTemplateUrl("/templates/manage/did_contents.html"),
        controller: "ManageDidContentCtrl"
      }
    },
    authenticate: true // 약관동의 여부 확인
  }).state("main.manage.staff", {
    url: "/staff",
    views: {
      "manageLnb@main.manage": {
        templateUrl: buildTemplateUrl("/templates/manage/left_menu.html"),
        controller: "ManageMenuCtrl"
      },
      "manageContent@main.manage": {
        templateUrl: buildTemplateUrl("/templates/manage/staff.html"),
        controller: "ManageStaffCtrl"
      }
    },
    authenticate: true // 약관동의 여부 확인
  }).state("main.manage.pos", {
    url: "/pos",
    views: {
      "manageLnb@main.manage": {
        templateUrl: buildTemplateUrl("/templates/manage/left_menu.html"),
        controller: "ManageMenuCtrl"
      },
      "manageContent@main.manage": {
        templateUrl: buildTemplateUrl("/templates/manage/pos.html"),
        controller: "ManagePosCtrl"
      }
    },
    authenticate: true // 약관동의 여부 확인
  }).state("main.manuals", {
    url: "manuals",
    views: {
      "content@": {
        templateUrl: buildTemplateUrl("/templates/manual/index.html"),
        controller: "ManualCtrl"
      }
    },
    authenticate: true
  }).state("main.demos", {
    url: "demos",
    views: {
      "content@": {
        templateUrl: buildTemplateUrl("/templates/dem/demo.html"),
        controller: "DemoListCtrl"
      }
    }
  }).state("main.demoShops", {
    url: "demoShops",
    views: {
      "content@": {
        templateUrl: buildTemplateUrl("/templates/dem/demoShop.html"),
        controller: "DemoShopCtrl"
      }
    }
  }).state("main.demoGateway", {
    url: "demoGateway",
    views: {
      "content@": {
        templateUrl: buildTemplateUrl("/templates/dem/demoGateway.html"),
        controller: "DemoGatewayCtrl"
      }
    }
  }).state("main.demoAccess", {
    url: "demoAccess",
    views: {
      "content@": {
        templateUrl: buildTemplateUrl("/templates/dem/demoAccess.html"),
        controller: "DemoAccessCtrl"
      }
    }
  }).state("main.cameraDemoDetail", {
    url: "demos/:cameraId?type",
    views: {
      "content@": {
        templateUrl: buildTemplateUrl("/templates/dem/demoView.html"),
        controller: "DemoViewCtrl"
      }
    }
  }).state("main.cameras", {
    url: "cameras",
    views: {
      "content@": {
        templateUrl: buildTemplateUrl("/templates/camera/list.html"),
        controller: "CameraListCtrl"
      }
    },
    authenticate: true // 약관동의 여부 확인
  }).state("main.aiZoneSet", {
    url: "aizoneset/:cameraId?type&id&shopId&peopleZone&seatZone",
    views: {
      "content@": {
        templateUrl: buildTemplateUrl("/templates/camera/ai_zone_set.html"),
        controller: "AiZoneSetCtrl"
      }
    },
    authenticate: true // 약관동의 여부 확인
  }).state("main.cameraDetail", {
    url: "cameras/:cameraId?type&id&time&shopId&shared&eventId",
    views: {
      "content@": {
        templateUrl: buildTemplateUrl("/templates/camera/view.html"),
        controller: "CameraViewCtrl2"
      }
    },
    authenticate: true // 약관동의 여부 확인
  }).state("main.cameraAudioChat", {
    url: "cameras/audioChat/:cameraId",
    views: {
      "content@": {
        templateUrl: buildTemplateUrl("/templates/camera/audio_chat.html"),
        controller: "AudioChat"
      }
    }
  }).state("main.dashboard", {
    url: "",
    views: {
      "content@": {
        templateUrl: buildTemplateUrl("/templates/shop/dashboard.html")
      },
      "shoplist@main.dashboard": {
        templateUrl: buildTemplateUrl("/templates/shop/dashboard_shop_left_menu.html"),
        controller: "DashboardShopListCtrl"
      }
    },
    authenticate: true // 약관동의 여부 확인
  }).state("main.dashboard.shop", {
    url: "dashboard/shop?shopId&myShop&posExists",
    views: {
      "content@main.dashboard": {
        templateUrl: buildTemplateUrl("/templates/shop/dashboard_shop.html"),
        controller: "DashboardShopCtrl"
      }
    },
    authenticate: true // 약관동의 여부 확인
  }).state("main.dashboard.event", {
    url: "dashboard/event/:shopId?shared&eventId&filter&regDate",
    views: {
      "content@main.dashboard": {
        templateUrl: buildTemplateUrl("/templates/shop/dashboard_event.html"),
        controller: "DashboardEventCtrl"
      }
    },
    authenticate: true // 약관동의 여부 확인
  }).state("main.dashboard.camera", {
    url: "dashboard/camera/:shopId?aiShop",
    views: {
      "content@main.dashboard": {
        templateUrl: buildTemplateUrl("/templates/shop/dashboard_camera.html"),
        controller: "DashboardCameraCtrl"
      }
    },
    authenticate: true // 약관동의 여부 확인
  }).state("main.dashboard.aishop", {
    url: "dashboard/aishop/:shopId",
    views: {
      "content@main.dashboard": {
        templateUrl: buildTemplateUrl("/templates/shop/dashboard_ai_shop.html"),
        controller: "DashboardAiShopCtrl"
      }
    },
    authenticate: true // 약관동의 여부 확인
  }).state("main.dashboard.aifacePeopleEvent", {
    url: "dashboard/aifacepeopleevent?shopId&shared&regDate",
    views: {
      "content@main.dashboard": {
        templateUrl: buildTemplateUrl("/templates/aiface/people_event.html"),
        controller: "AiFacePeopleEventCtrl"
      }
    },
    authenticate: true // 약관동의 여부 확인
  })
  //FIXME: 삭제될 것으로 예상
  .state("main.dashboard.staff", {
    url: "dashboard/staff/:shopId",
    views: {
      "content@main.dashboard": {
        templateUrl: buildTemplateUrl("/templates/shop/dashboard_staff.html"),
        controller: "DashboardStaffCtrl"
      }
    },
    authenticate: true // 약관동의 여부 확인
  })
  //FIXME: 삭제될 것으로 예상
  .state("main.dashboard.staffWeekly", {
    url: "dashboard/staffweekly/:shopId/:shopName/staffs/:staffId/weekly?searchDate",
    views: {
      "content@main.dashboard": {
        templateUrl: buildTemplateUrl("/templates/shop/dashboard_staff_weekly.html"),
        controller: "DashboardStaffWeeklyCtrl"
      }
    },
    authenticate: true // 약관동의 여부 확인
  })
  //FIXME: 삭제될 것으로 예상
  .state("main.dashboard.staffMonthly", {
    url: "dashboard/staffmonthly/:shopId/staffs/:staffId/:shopName/monthly?searchDate",
    views: {
      "content@main.dashboard": {
        templateUrl: buildTemplateUrl("/templates/shop/dashboard_staff_monthly.html"),
        controller: "DashboardStaffMonthlyCtrl"
      }
    },
    authenticate: true // 약관동의 여부 확인
  }).state("main.dashboard.pos", {
    url: "dashboard/pos/:shopId?cameraId&posId&type&filter",
    views: {
      "content@main.dashboard": {
        templateUrl: buildTemplateUrl("/templates/shop/dashboard_pos.html"),
        controller: "DashboardPosCtrl"
      }
    },
    authenticate: true // 약관동의 여부 확인
  }).state("main.dashboard.posView", {
    url: "dashboard/posview/:cameraId?type&id&posId&filters&date",
    views: {
      "content@main.dashboard": {
        templateUrl: buildTemplateUrl("/templates/shop/dashboard_posview.html"),
        controller: "DashboardPosViewCtrl"
      }
    },
    authenticate: true // 약관동의 여부 확인
  }).state("main.dashboard.posSales", {
    url: "dashboard/possales/:cameraId/sales?type&id&posId&filters&date&filterType",
    views: {
      "content@main.dashboard": {
        templateUrl: buildTemplateUrl("/templates/shop/dashboard_pos_sales.html"),
        controller: "DashboardPosSalesCtrl"
      }
    },
    authenticate: true // 약관동의 여부 확인
  }).state("main.dashboard.posItem", {
    url: "dashboard/positem/:cameraId/item?shopId&currentTab&accessDate",
    views: {
      "content@main.dashboard": {
        templateUrl: buildTemplateUrl("/templates/shop/dashboard_pos_item.html"),
        controller: "DashboardPosItemCtrl"
      }
    },
    authenticate: true // 약관동의 여부 확인
  })
  //FIXME: 사용되지 않는 페이지로 예상
  .state("main.cameraReceiveDetail", {
    url: "receive/:cameraId?shared",
    views: {
      "content@": {
        templateUrl: buildTemplateUrl("/templates/camera/view.html"),
        controller: "CameraViewCtrl2"
      }
    },
    authenticate: true // 약관동의 여부 확인
  }).state("main.updateUserInfo", {
    url: "updateUserInfo",
    views: {
      "content@": {
        templateUrl: buildTemplateUrl("/templates/user/settings.html"),
        controller: "SettingPhoneCtrl"
      }
    }
  }).state("main.passwordChange", {
    url: "passwordChange",
    views: {
      "content@": {
        templateUrl: buildTemplateUrl("/templates/user/settings.html"),
        controller: "SettingPasswordCtrl"
      }
    }
  }).state("main.clips", {
    url: "clips?type",
    views: {
      "content@": {
        templateUrl: buildTemplateUrl("/templates/clip/list.html"),
        controller: "ClipListCtrl"
      }
    },
    authenticate: true // 약관동의 여부 확인
  }).state("main.aiface", {
    url: "",
    views: {
      "content@": {
        templateUrl: buildTemplateUrl("/templates/aiface/setting.html"),
        controller: "AiFaceSetCtrl"
      },
      "list@main.aiface": {
        templateUrl: buildTemplateUrl("/templates/aiface/aiface_left_menu.html"),
        controller: "AiFaceSetListCtrl"
      }
    },
    authenticate: true // 약관동의 여부 확인
  }).state("main.aiface.content", {
    url: "aiface/setting?tab&user",
    views: {
      "content@main.aiface": {
        templateUrl: buildTemplateUrl("/templates/aiface/aiface_content.html"),
        controller: "AiFaceContentCtrl"
      }
    },
    authenticate: true // 약관동의 여부 확인
  })
  //FIXME: 사용되지 않는 페이지로 예상
  .state("main.dashboard.aifaceEvent", {
    url: "dashboard/aifaceevent?shopId&shared&regDate",
    views: {
      "content@main.dashboard": {
        templateUrl: buildTemplateUrl("/templates/aiface/event.html"),
        controller: "AiFaceEventCtrl"
      }
    },
    authenticate: true // 약관동의 여부 확인
  })
  // NOTE: 내부 확인용 AI 디버깅 페이지
  .state("main.aifacedebug", {
    url: "aifacedebug",
    views: {
      "content@": {
        templateUrl: buildTemplateUrl("/templates/aiface/debug.html"),
        controller: "AiFaceDebugCtrl"
      }
    },
    authenticate: true // 약관동의 여부 확인
  }).state("main.aifaceZoneSet", {
    url: "aifacezoneset/:cameraId",
    views: {
      "content@": {
        templateUrl: buildTemplateUrl("/templates/camera/aiface_zone_set.html"),
        controller: "AifaceZoneSetCtrl"
      }
    },
    authenticate: true // 약관동의 여부 확인
  }).state("main.monitorsDownload", {
    url: "monitors/download",
    views: {
      "content@": {
        templateUrl: buildTemplateUrl("/templates/monitor/download.html"),
        controller: "MonitorDownloadCtrl"
      }
    }
  }).state("main.monitors", {
    url: "monitors?demo",
    views: {
      "content@": {
        templateUrl: buildTemplateUrl("/templates/monitor/streamlist.html"),
        controller: "MonitorCtrl"
      }
    },
    authenticate: true // 약관동의 여부 확인
  }).state("main.monitorDetail", {
    url: "monitorDetail/:cameraId?type&id&time&shared&demo&shopId",
    views: {
      "content@": {
        templateUrl: buildTemplateUrl("/templates/monitor/detailview.html"),
        controller: "MonitorDetailCtrl"
      }
    }
  }).state("main.install", {
    url: "",
    views: {
      "content@": {
        templateUrl: buildTemplateUrl("/templates/setup/install.html")
      }
    }
  })
  //TODO: [설치]사용되는 페이지인지 체크
  .state("main.install.login", {
    url: "enroll/login?installKey",
    views: {
      "lnb@main.install": {
        templateUrl: buildTemplateUrl("/templates/setup/_install_left_menu.html"),
        controller: "InstallMenuCtrl"
      },
      "content@main.install": {
        templateUrl: buildTemplateUrl("/templates/setup/_login.html"),
        controller: "InstallLoginCtrl"
      }
    },
    authenticate: true // 약관동의 여부 확인
  })
  //TODO: [설치]사용되는 페이지인지 체크
  .state("main.install.wifiSetup", {
    url: "enroll/wifisetup",
    views: {
      "lnb@main.install": {
        templateUrl: buildTemplateUrl("/templates/setup/_install_left_menu.html"),
        controller: "InstallMenuCtrl"
      },
      "content@main.install": {
        templateUrl: buildTemplateUrl("/templates/setup/_wifi_setup.html"),
        controller: "SetupWifiCtrl"
      }
    }
  })
  //TODO: [설치]사용되는 페이지인지 체크
  .state("main.install.wifiConnect", {
    url: "enroll/wificonnect?MAC",
    views: {
      "lnb@main.install": {
        templateUrl: buildTemplateUrl("/templates/setup/_install_left_menu.html"),
        controller: "InstallMenuCtrl"
      },
      "content@main.install": {
        templateUrl: buildTemplateUrl("/templates/setup/_wifi_connect.html"),
        controller: "ConnectWifiCtrl"
      }
    }
  })
  //TODO: [설치]사용되는 페이지인지 체크
  .state("main.install.wifiFinish", {
    url: "enroll/wififinish",
    views: {
      "lnb@main.install": {
        templateUrl: buildTemplateUrl("/templates/setup/_install_left_menu.html"),
        controller: "InstallMenuCtrl"
      },
      "content@main.install": {
        templateUrl: buildTemplateUrl("/templates/setup/_wifi_finish.html"),
        controller: "FinishWifiCtrl"
      }
    }
  }).state("main.cameraGroup", {
    url: "",
    views: {
      "content@": {
        templateUrl: buildTemplateUrl("/templates/cameraGroup/cameraGroup.html"),
        controller: "CameraGroupCtrl"
      },
      "groupLnb@main.cameraGroup": {
        templateUrl: buildTemplateUrl("/templates/cameraGroup/_camera_group_left_menu.html"),
        controller: "GroupLnbCtrl"
      }
    },
    onEnter: function onEnter($rootScope, $state, User) {
      if ($rootScope.me === undefined) {
        User.me(function (data) {
          if (data.code == "ok" && data.isB2bUser !== "YES") {
            $state.go("main.cameras");
          }
        }, function (err) {
          $state.go("main.error");
        });
      } else {
        if ($rootScope.me.isB2bUser !== "YES") {
          $state.go("main.cameras");
        }
      }
    },
    authenticate: true // 약관동의 여부 확인
  }).state("main.cameraGroup.cameras", {
    url: "cameraGroup/cameras",
    views: {
      "groupContent@main.cameraGroup": {
        templateUrl: buildTemplateUrl("/templates/camera/list.html"),
        controller: "CameraListCtrl"
      }
    },
    authenticate: true // 약관동의 여부 확인
  }).state("main.cameraGroup.group", {
    url: "cameraGroup/group/:groupId?shareId",
    views: {
      "groupContent@main.cameraGroup": {
        templateUrl: buildTemplateUrl("/templates/cameraGroup/_camera_group.html"),
        controller: "GroupCtrl"
      }
    },
    authenticate: true // 약관동의 여부 확인
  })
  //FIXME: 경로 체크
  .state("main.cameraGroup.allGroup", {
    url: "cameraGroup/allgroup",
    views: {
      "groupContent@main.cameraGroup": {
        templateUrl: buildTemplateUrl("/templates/cameraGroup/_camera_all_group.html"),
        controller: "AllGroupCtrl"
      }
    },
    authenticate: true // 약관동의 여부 확인
  }).state("main.cameraGuide", {
    url: "",
    views: {
      "content@": {
        templateUrl: buildTemplateUrl("/templates/cameraGuide/camera_guide.html")
      }
    }
  }).state("main.cameraGuide.wifi", {
    url: "cameraGuide/wifi",
    views: {
      "guideLnb@main.cameraGuide": {
        templateUrl: buildTemplateUrl("/templates/cameraGuide/camera_guide_left_menu.html"),
        controller: "GuideMenuCtrl"
      },
      "guideContent@main.cameraGuide": {
        templateUrl: buildTemplateUrl("/templates/cameraGuide/camera_guide_wifi.html"),
        controller: "CameraGuideWifi"
      }
    }
  }).state("main.cameraGuide.shop", {
    url: "cameraGuide/shop",
    views: {
      "guideLnb@main.cameraGuide": {
        templateUrl: buildTemplateUrl("/templates/cameraGuide/camera_guide_left_menu.html"),
        controller: "GuideMenuCtrl"
      },
      "guideContent@main.cameraGuide": {
        templateUrl: buildTemplateUrl("/templates/cameraGuide/camera_guide_shop.html"),
        controller: "CameraGuideShop"
      }
    }
  }).state("main.cameraGuide.access", {
    url: "cameraGuide/access",
    views: {
      "guideLnb@main.cameraGuide": {
        templateUrl: buildTemplateUrl("/templates/cameraGuide/camera_guide_left_menu.html"),
        controller: "GuideMenuCtrl"
      },
      "guideContent@main.cameraGuide": {
        templateUrl: buildTemplateUrl("/templates/cameraGuide/camera_guide_access.html"),
        controller: "CameraGuideAccess"
      }
    }
  }).state("noticePopup", {
    url: "/noticePopup",
    views: {
      content: {
        templateUrl: buildTemplateUrl("/templates/common/notice.html"),
        controller: "NoticePopupCtrl"
      }
    }
  }).state("webviewNoticePopup", {
    url: "/webview/notice/popup",
    views: {
      content: {
        templateUrl: buildTemplateUrl("/templates/common/mobileNotice.html"),
        controller: "NoticePopupCtrl"
      }
    }
  });
});
app.run(function ($rootScope, $state, User, $location, ENV_VARS, $document, $translate, tmhDynamicLocale, DomainUtils, Utils) {
  var ua = navigator.userAgent;
  if (navigator.userAgent.indexOf("Googlebot") != -1 || navigator.userAgent.indexOf("GoogleBot") != -1 || navigator.userAgent.indexOf("googlebot") != -1) {
    tmhDynamicLocale.set("en");
  } else if (window.location.pathname && (window.location.pathname.indexOf("/ja/") != -1 || window.location.pathname.indexOf("/jp/") != -1)) {
    tmhDynamicLocale.set("ja");
  } else {
    if (ua.indexOf("MSIE 10.0") != -1) {
      if (navigator.userLanguage.indexOf("en") != -1) {
        tmhDynamicLocale.set("en");
      } else if (navigator.userLanguage.indexOf("ja") != -1) {
        tmhDynamicLocale.set("ja");
      } else {
        tmhDynamicLocale.set("ko");
      }
    } else {
      if (navigator.language.indexOf("en") != -1) {
        tmhDynamicLocale.set("en");
      } else if (navigator.language.indexOf("ja") != -1) {
        tmhDynamicLocale.set("ja");
      } else {
        tmhDynamicLocale.set("ko");
      }
    }
  }
  $rootScope.protocol = $location.protocol() + "://"; // thumbnail location protocol
  $rootScope.ENV_VARS = ENV_VARS;
  $rootScope.isLogin = false;
  $rootScope.isMain = $state.current.name === "main";
  $rootScope.isLocal = ENV_VARS.env === "local";
  User.me().$promise.then(function (data) {
    window.country = (data === null || data === void 0 ? void 0 : data.country) === "JP" ? "ja" : "ko";
    $rootScope.countryDomain = (data === null || data === void 0 ? void 0 : data.country) === "JP" ? "ja" : "ko";
    $rootScope.isLanguageJp = Utils.getBrowserLanguage() === "ja_JP";
    $rootScope.isJp = (data === null || data === void 0 ? void 0 : data.country) === "JP" || Utils.getBrowserLanguage() === "ja_JP";
    if (data.code == "ok" || data.code == "nok" && data.errorCode == "-2") {
      $rootScope.me = data;
      $rootScope.isLogin = true;
      ci = data.clientId;
      at = data.accessToken;
      // 약관동의 여부 확인
      if ($rootScope.me.code == "nok" && $rootScope.me.errorCode == "-2" && $rootScope.me.policyAgree != "ok") {
        if (location.href.indexOf("notice") === -1 && location.href.indexOf("Terms") === -1 && location.href.indexOf("terms") === -1) {
          var url = "/policyagree";
          window.open(url, "서비스 약관동의", "scrollbars=yes,toolbar=no,resizable=yes,width=420,height=550,left=600,top=200");
        }
      }
    } else {
      $rootScope.isLogin = false;
    }
  }, function (err) {
    window.country = "ko";
  });
  $rootScope.aiMenuShow = DomainUtils.isAllowedAiDomain();

  // 해당 페이지에선 top menu가 고정이 되지 않도록
  $rootScope.scrollNone = $state.name == "main.cameraDetail" || $state.name == "main.cameraDemoDetail";
  $rootScope.$on("$stateChangeStart", function (event, toState) {
    if (toState.name === "terms" || toState.name === "termsJP" || toState.name === "positionTerms" || toState.name === "positionTermsJP" || toState.name === "noticeM" || toState.name === "gatewayGuide") {
      document.body.style.minWidth = "0";
    }
    if ($state && $state.current) {
      $rootScope.previousState = $state.current.name;
    }
    if ($rootScope.me == undefined && $rootScope.needLoginFlag) {
      User.me().$promise.then(function (data) {
        if (data.code == "ok" || data.code == "nok" && data.errorCode == "-2") {
          $rootScope.me = data;
          $rootScope.isLogin = true;
          ci = data.clientId;
          at = data.accessToken;
        } else {
          $rootScope.isLogin = false;
          location.href = "/";
          var loginUrl = $state.href("login");

          // FIXME: 팝업 부분 수정 필요
          window.open(loginUrl, "Login", "scrollbars=yes,toolbar=no,resizable=yes,width=420,height=538,left=600,top=200");
        }
      }, function (err) {});
    }
    if (tmhDynamicLocale.get() == "ja" && appConfig.useJPLogin) {
      $rootScope.isJPLogin = true;
      // 해당 페이지에선 top menu가 고정이 되지 않도록
      $rootScope.scrollNone = toState.name === "main.cameraDetail" || toState.name === "main.cameraDemoDetail";
      $rootScope.isJpTopMenu = toState.name !== "main";
      //로그인 세션 끊겼을 경우를 위한 처리
      $rootScope.needLoginFlag = toState.name === "main.clips" || toState.name === "main.accessall" || toState.name === "main.cameraGroup.group" || toState.name === "main.cameraDetail";
      urlStatus = toState;
    } else {
      $rootScope.isJPLogin = false;
      var gnbChange = function gnbChange() {
        // 해당 페이지에선 top menu가 고정이 되지 않도록
        if (toState.name === "main.cameraDetail" || toState.name === "main.cameraDemoDetail") {
          $rootScope.scrollNone = true;
        } else {
          $rootScope.scrollNone = false;
        }
      };
      if ($rootScope.me !== undefined) {
        if (toState.authenticate && $rootScope.me.code == "nok" && $rootScope.me.errorCode == "-2") {
          event.preventDefault();
          User.me().$promise.then(function (data) {
            if (data.code == "ok" || data.code == "nok" && data.errorCode == "-2") {
              $rootScope.me = data;
              $rootScope.isLogin = true;
              ci = data.clientId;
              at = data.accessToken;
            } else {
              $rootScope.isLogin = false;
            }

            // 약관동의 여부 확인
            if ($rootScope.me.policyAgree != "ok" && toState.name != "main.error" && toState.name != "lproc") {
              if (location.href.indexOf("notice") === -1 && location.href.indexOf("Terms") === -1 && location.href.indexOf("terms") === -1) {
                var url = "/policyagree";
                window.open(url, "서비스 약관동의", "scrollbars=yes,toolbar=no,resizable=yes,width=420,height=550,left=600,top=200");
              }
            } else {
              $state.go(toState);
            }
          }, function (err) {});
        } else {
          gnbChange();
        }
      } else {
        gnbChange();
      }
      urlStatus = toState;
    }
  });
  $rootScope.$on("$stateChangeSuccess", function (event, toState) {
    $rootScope.isMain = toState.name === "main";
    if (toState.name === "main.cameraDetail") {
      $rootScope.useMute = $rootScope.previousState ? false : true;
    }
    if ($rootScope.previousState === "main.monitors") {
      if (toState.name !== "main" && toState.name !== "main.monitorDetail") {
        window.monitorDemoState = null;
      }
    } else if ($rootScope.previousState === "main.demoGateway") {
      if (toState.name !== "main") {
        window.gatewayDemoState = null;
      }
    } else {
      if (toState.name === "main.cameraDetail" || toState.name === "main.access") {
        $rootScope.scrollPosition = 0;
      }
    }
    if (typeof $rootScope.previousState === "string" && $rootScope.previousState.indexOf("main.dashboard") != -1) {
      if (typeof toState.name !== "string" || toState.name.indexOf("main.dashboard") == -1) {
        $rootScope.shopListScrollTop = 0;
      }
    }
    $document[0].body.scrollTop = $document[0].documentElement.scrollTop = 0;
  });
  $rootScope.$on("$translateChangeEnd", function (event) {
    var ids = ["toastcam_mall_menu", "toastcam_menu", "groupcamera_menu", "shopcamera_menu", "manage_menu", "clip_menu", "cloud_monitor_menu", "camera_guide_login", "demo_menu", "camera_guide", "partner_menu", "online_menu", "mailLogin", "mailSignup", "mailAskCustom", "main_title1", "main_title2", "dashboard_menu", "logoutMenu", "menu_help", "aiface_menu", "myInfoMenu", "userServiceMenu", "manages_menu", "manual_help", "jp_partner_menu", "camera_menu"];
    ids.forEach(function (id) {
      var element = document.getElementById(id);
      if (element) {
        var translationKey = getTranslationKey(id);
        element.innerHTML = $translate.instant(translationKey);
      }
    });
    document.querySelectorAll(".showcase_menu").forEach(function (element) {
      element.innerHTML = $translate.instant("SHOWCASE");
    });
    if (location.hash === "#/") {
      updateMainSwiper();
    }
    if (location.hash.indexOf("findPassword") !== -1) {
      updateFindPassword();
    }
  });
  function getTranslationKey(id) {
    var translationKeys = {
      toastcam_mall_menu: "STR_GO_BIZ_ONLINE_MALL",
      toastcam_menu: "TOAST_CAM",
      groupcamera_menu: "STR_SHOW_BY_GROUP",
      shopcamera_menu: "SHOP_BY_CAMERA",
      manage_menu: "MANAGE_ENTER",
      clip_menu: "MENU_CLIP",
      cloud_monitor_menu: "STR_CLOUD_MONITOR",
      camera_guide_login: "CAMERA_GUIDE",
      demo_menu: "MENU_DEMO",
      camera_guide: "CAMERA_GUIDE",
      partner_menu: "PARTNER_CENTER",
      online_menu: "ONLINE_BUY",
      mailLogin: "LOGIN",
      mailSignup: "LOGIN_SIGNUP",
      mailAskCustom: "MENU_HELP",
      main_title1: "STR_MAIN_BIZ_1",
      main_title2: "STR_MAIN_BIZ_2",
      dashboard_menu: "STR_SHOW_BY_STORE",
      logoutMenu: "LOGOUT",
      menu_help: "MENU_HELP",
      aiface_menu: "9rRqk7Vo_02361",
      myInfoMenu: "5mw2slvk_02181",
      userServiceMenu: "USER_SERVICE_MANAGEMENT",
      manages_menu: "STR_MANAGE",
      manual_help: "5mw2slvk_02171",
      jp_partner_menu: "9rRqk7Vo_02169",
      camera_menu: "CLIPS_SORT_BY_CAMERA"
    };
    return translationKeys[id] || "";
  }
  function updateMainSwiper() {
    var slides = [{
      selector: ".swiper-slide.loop01",
      title: "TOAST_HELP_19",
      subtitle: "TOAST_HELP_20"
    }, {
      selector: ".swiper-slide.loop02",
      title: "TOAST_HELP_21",
      subtitle: "TOAST_HELP_22"
    }, {
      selector: ".swiper-slide.loop03",
      title: "TOAST_HELP_23",
      subtitle: "TOAST_HELP_24"
    }, {
      selector: ".swiper-slide.loop04",
      title: "TOAST_HELP_25",
      subtitle: "TOAST_HELP_26"
    }];
    slides.forEach(function (slide) {
      var element = document.querySelector(slide.selector);
      if (element) {
        var titleElement = element.querySelector(".tit .b2b_stit");
        var subtitleElement = element.querySelector(".tit_sub");
        if (titleElement) titleElement.innerHTML = $translate.instant(slide.title);
        if (subtitleElement) subtitleElement.innerHTML = $translate.instant(slide.subtitle);
      }
    });
    var buyShopBtn = document.querySelector(".moveOnlineBuyShop");
    var toastServiceBtn = document.querySelector(".showToastCamServiceRequestLayer");
    if (buyShopBtn) {
      buyShopBtn.innerHTML = $translate.instant("ONLINE_BUY");
    }
    if (toastServiceBtn) {
      toastServiceBtn.innerHTML = $translate.instant("TALK_REQUEST");
    }
  }
  function updateFindPassword() {
    var elements = [{
      id: "find_user",
      translationKey: "LOGIN_FIND_USER"
    }, {
      id: "find_confirm",
      translationKey: "LOGIN_FIND_PW_CONFIRM1",
      translationKey2: "LOGIN_FIND_PW_CONFIRM2"
    }, {
      id: "pw",
      placeholderKey: "LOGIN_FIND_PASSWORD"
    }, {
      id: "pwc",
      placeholderKey: "LOGIN_FIND_PASSWORD_COMFIRM"
    }, {
      id: "btn_confirm",
      translationKey: "BUTTON_CONFIRM"
    }];
    elements.forEach(function (el) {
      var element = document.getElementById(el.id);
      if (element) {
        if (el.translationKey2) {
          element.innerHTML = "".concat($translate.instant(el.translationKey), "<br>").concat($translate.instant(el.translationKey2));
        } else if (el.translationKey) {
          element.innerHTML = $translate.instant(el.translationKey);
        } else if (el.placeholderKey) {
          element.placeholder = $translate.instant(el.placeholderKey);
        }
      }
    });
  }
  var sessionDlg = null;
  $rootScope.createSessionDlg = function (parentId) {
    if (sessionDlg) {
      sessionDlg.destroy();
    }
    sessionDlg = tCam.confirmDialog({
      elId: parentId ? parentId : "wrap",
      dlgStyle: {
        width: window.country === "ja" ? "477px" : "450px",
        padding: "24px 30px",
        boxSizing: "border-box",
        overflow: "auto"
      },
      noCloseBtn: true,
      description: $translate.instant("9rRqk7Vo_02170"),
      btns: [{
        name: "confirm",
        text: $translate.instant("BUTTON_CONFIRM"),
        style: "blue"
      }],
      eventHandler: function eventHandler(event) {
        if (sessionDlg) {
          sessionDlg.destroy();
          sessionDlg = null;
        }
        $rootScope.isLogin = false;
        $state.go("main", {}, {
          reload: true
        });
      }
    });
  };
  $rootScope.useMute = false;
  var confirmDlg = null;
  $rootScope.destroyConfirm = function () {
    if (confirmDlg) {
      confirmDlg.destroy();
      confirmDlg = null;
    }
  };
  $rootScope.createConfirm = function (dlgParam) {
    $rootScope.destroyConfirm();
    confirmDlg = tCam.confirmDialog({
      elId: "wrap",
      dlgStyle: {
        width: (dlgParam.width ? dlgParam.width : 482) + "px",
        padding: dlgParam.padding ? dlgParam.padding : "24px 30px",
        boxSizing: "border-box",
        overflow: "auto"
      },
      theme: dlgParam.theme,
      title: dlgParam.title,
      pCheckList: dlgParam.pCheckList,
      description: dlgParam.description,
      noCloseBtn: dlgParam.noCloseBtn,
      btns: dlgParam.btnCount === 1 ? [{
        name: "confirm",
        text: dlgParam.confText ? dlgParam.confText : $translate.instant("BUTTON_CONFIRM"),
        style: "blue"
      }] : [{
        name: "cancel",
        text: dlgParam.cancelText ? dlgParam.cancelText : $translate.instant("BUTTON_CANCEL"),
        "class": "white"
      }, {
        name: "confirm",
        text: dlgParam.confText ? dlgParam.confText : $translate.instant("BUTTON_CONFIRM"),
        style: "blue"
      }],
      eventHandler: function eventHandler(event) {
        var _dlgParam$closeHandle;
        $rootScope.destroyConfirm();
        if (event.name === "confirm") {
          if (dlgParam.handler) {
            dlgParam.handler(event);
          }
        } else if (event.name === "cancel") {
          if (dlgParam.cancelHandler) {
            dlgParam.cancelHandler(event);
          }
        }
        (_dlgParam$closeHandle = dlgParam.closeHandler) === null || _dlgParam$closeHandle === void 0 ? void 0 : _dlgParam$closeHandle.call(dlgParam, event);
      }
    });
  };
});
app.run(function ($rootScope, $state, Utils, User) {
  $rootScope.isCheckingAuth = false;
  $rootScope.$on("$stateChangeStart", function (event, toState, toParams) {
    if ($rootScope.isCheckingAuth) {
      return;
    }
    if (toState.name === "main" && toState.name !== "signup") {
      $rootScope.isCheckingAuth = true;
      $rootScope.isJp = $rootScope.countryDomain === "ja" || Utils.getBrowserLanguage() === "ja_JP";
      var nextUrl = $rootScope.isJp ? "main.cameraGroup.group" : "main.dashboard.shop";
      if (typeof $rootScope.me !== "undefined") {
        event.preventDefault();
        $state.go(nextUrl)["finally"](function () {
          $rootScope.isCheckingAuth = false;
        });
      } else {
        User.me().$promise.then(function (data) {
          if (data.code === "ok") {
            $rootScope.me = data;
            $rootScope.isLogin = true;
            $state.go(nextUrl);
          } else {
            $state.go("main")["finally"](function () {
              $rootScope.hideHeader = true;
              $rootScope.hideFooter = true;
            });
          }
        }, function (err) {
          $state.go("main.error");
        })["finally"](function () {
          $rootScope.isCheckingAuth = false;
        });
      }
    } else {
      $rootScope.hideHeader = false;
      $rootScope.hideFooter = false;

      // TODO: 로그인 접근 가능 경로 체크 및 route back 처리
    }
  });
});
"use strict";

var Validate = {
  isValidPhone: function isValidPhone(phone) {
    return /^(010|011|016|017|109)\-\d{3,4}\-\d{4}$/.test(phone);
  },
  isValidPassword: function isValidPassword(password) {
    var includeNumber = /\d/.test(password);
    var includeCharacter = /[a-zA-Z]/.test(password);
    var length = /^[^\s]{4,8}$/.test(password);
    if (includeNumber && includeCharacter && length) {
      return true;
    }
    return false;
  }
};
"use strict";

angular.module("ipcam.config", []).constant("ENV_VARS", {
  "env": "real",
  "marketUrl": "http://market.toast.com",
  "marketDealNo": "23435",
  "mainSnsShareVideoUrl": "http://t0a.st/6Fd",
  "appGuideUrl": "https://cam.toast.com/CF/[%ED%86%A0%EC%8A%A4%ED%8A%B8%20%EC%BA%A0]%20APP%EA%B0%80%EC%9D%B4%EB%93%9C.pdf",
  "hostUrl": "https:cam.toast.com",
  "gwInstallerUrl": "https://api-storage.cloud.toast.com/v1/AUTH_1001d0b9904242d69880487fe72ab2bb/firmware/NHNENT/Gateway-001/TCGW_Manager.zip",
  "baseUrl": "https://bizcam.toast.com",
  "paycoBaseUrl": "https://id.payco.com",
  "paycoClientId": "XBd9Ehbt70Y1kAA2tmrj",
  "toastcamCompanyUrl": "https://toastcam.com",
  "toastcamHomeUrl": "https://cam.toast.com",
  "icameCompanyUrl": "https://icame.co.jp",
  "parkingUrl": "https://parking.toastcam.com"
});
"use strict";

app.filter("timerange", function () {
  return function (input, value) {
    var start = parseInt(value.start);
    var end = parseInt(value.end);
    var step = value.step === undefined ? 1 : parseInt(value.step);
    for (var i = start; i <= end; i += step) {
      var out = i;
      if (i < 10) out = "0" + i;
      input.push(out.toString());
    }
    return input;
  };
});
app.filter("fillZeroToTime", function () {
  return function (value) {
    if (!value) {
      return "00:00";
    }
    var hour = value.split(":")[0],
      min = value.split(":")[1];
    if (hour.length === 1) {
      hour = "0" + hour;
    }
    if (min.length === 1) {
      min = "0" + min;
    }
    return hour + ":" + min;
  };
});
app.filter("textRange", function () {
  return function (input, value) {
    if (input.length > parseInt(value)) {
      return input.substring(0, parseInt(value)) + "...";
    } else {
      return input;
    }
  };
});
app.filter("secondsToDateTime", [function () {
  return function (seconds) {
    return new Date(1970, 0, 1).setSeconds(seconds);
  };
}]);
app.filter("strToDateTime", [function () {
  return function (dateStr) {
    return new Date(dateStr);
  };
}]);

// 전화번호 형식
app.filter("tel", function () {
  return function (value) {
    return typeof value === "string" ? value.replace(/(^02.{0}|^01.{1}|[0-9]{3})([0-9]+)([0-9]{4})/, "$1-$2-$3") : value;
  };
});

// 값이 없을 경우 defalutValue 지정
app.filter("defaultValue", function () {
  return function (value, defaultValue) {
    if (typeof value === "undefined" || value === null) {
      return defaultValue;
    }
    return value;
  };
});
app.filter("stringFormat", function () {
  return function (input) {
    if (arguments.length > 1) {
      var str = input,
        i,
        len,
        reg;
      for (i = 1, len = arguments.length; i < len; i += 1) {
        reg = new RegExp("\\{" + (i - 1) + "\\}");
        str = str.replace(reg, arguments[i]);
      }
      return str;
    }
    return input;
  };
});
app.filter("dateFormat", ["Utils", function (Utils) {
  return function (date, format) {
    var md = moment(date);
    return md.locale(Utils.getBrowserLanguage()).format(format);
  };
}]);
app.filter("shortenFileName", function () {
  return function (value) {
    if (!value) {
      return value;
    }
    if (value.length > 20) {
      return value.slice(0, 8) + "..." + value.slice(value.length - 10, value.length);
    } else {
      return value;
    }
  };
});
app.filter("shortenContentName", function () {
  return function (value) {
    if (!value) {
      return value;
    }
    if (value.length > 30) {
      return value.slice(0, 13) + "..." + value.slice(value.length - 15, value.length);
    } else {
      return value;
    }
  };
});
app.filter("shortenByMaxLength", function () {
  return function (value, maxlen) {
    if (!maxlen || !value) {
      return value;
    }
    if (value.length > maxlen) {
      return value.slice(0, maxlen) + "...";
    } else {
      return value;
    }
  };
});
app.filter("searchedCharacter", function ($sce) {
  return function (value, _char) {
    if (!_char) {
      return value;
    }
    var lowerChar = _char.toLowerCase();
    var reg = new RegExp(lowerChar, "i");
    var findStr = value.match(reg);
    value = value.replace(reg, '<span style="color:#4b96e6;">' + findStr + "</span>");
    return $sce.trustAsHtml(value);
  };
});
app.filter("idMasking", function () {
  return function (value) {
    if (!value) {
      return "";
    }
    var emailCheckReg = /^[A-Z0-9+_.-]+@[A-Z0-9.-]+$/gim;
    if (emailCheckReg.test(value)) {
      var email = value.split("@");
      if (email[0] && email[1]) {
        if (email[0].length > 2) {
          var result = email[0][0] + email[0][1],
            i,
            len;
          for (i = 0, len = email[0].length - 2; i < len; i += 1) {
            result += "*";
          }
          return result + "@" + email[1];
        } else {
          return value;
        }
      } else {
        return value;
      }
    } else {
      if (value.length === 12 || value.length === 11) {
        return value.slice(0, 6) + "**" + value.slice(8, 10) + "**";
      } else {
        return value.slice(0, 6) + "****";
      }
    }
  };
});
app.filter("convertToTimeStr", function ($translate) {
  var translater = function translater(strId) {
    return $translate.instant(strId);
  };
  return function (value) {
    if (!value) {
      return "0" + translater("MINUTE");
    }
    var timeVal = Math.floor(value / (3600 * 1000));
    var minVal = Math.floor((value - 3600 * 1000 * timeVal) / (60 * 1000));
    if (!timeVal) {
      return minVal + translater("MINUTE");
    }
    return timeVal + translater("HOUR") + " " + minVal + translater("MINUTE");
  };
});
"use strict";

// 출입관리 화면의 직원 출입 타임라인
app.directive('tcAccessTimeline', function ($filter, $translate) {
  return {
    restrict: 'E',
    template: '<div class="acc_timeline">' + '<div class="in_layer" ng-style="{\'transform\': inStyle, \'-webkit-transform\': inStyle, \'-ms-transform\': inStyle, \'z-index\': isInOver }" ng-show="isShowInTime" ng-mouseover="isInOver = 101; isOutOver = 100;"><span ng-style="{\'margin-left\': inLeft,\'margin-right\': inRight}"><span class="in_txt" translate="STR_IN_WORK" translate-compile></span>{{inTime}}</span><img src="/resources/im/ic_in_arrow.png"></div>' + '<div class="out_layer" ng-style="{\'transform\': outStyle, \'-webkit-transform\': outStyle, \'-ms-transform\': outStyle, \'z-index\': isOutOver }" ng-show="isShowOutTime" ng-mouseover="isInOver = 100; isOutOver = 101;"><span ng-style="{\'margin-right\': outRight,\'margin-left\': outLeft}"><span class="out_txt" translate="STR_NO_WORK" translate-compile>></span>{{outTime}}</span><img src="/resources/im/ic_out_arrow.png"></div>' + '<div class="in_now" ng-style="{\'transform\': curStyle, \'-webkit-transform\': curStyle, \'-ms-transform\': curStyle, \'z-index\': isOutOver }" ng-show="isShowCurTime" ng-mouseover="isInOver = 100; isOutOver = 101;"><p class="currentTimeDot" ng-show="todayFlag" style="height: 80px;border-left: 2px dotted #ef351c; position: absolute; top: -12px; opacity: .6;"></p></div>' +
    // '<div class="in_now" ng-style="{\'transform\': curStyle, \'-webkit-transform\': curStyle, \'-ms-transform\': curStyle, \'z-index\': isOutOver }" ng-show="isShowCurTime" ng-mouseover="isInOver = 100; isOutOver = 101;"><img src="/resources/im/ic_acc_in02.png" ng-style="{\'left\': leftPx}" ng-show="isInStaff"><p class="currentTimeDot" ng-show="todayFlag" style="height: 80px;border-left: 2.5px dotted #ef351c; position: absolute; top: -13px; opacity: .6;"></p></div>' +
    '</div>',
    replace: true,
    scope: {
      date: '=accessDate',
      staff: '=staffData'
    },
    // compile: function compile(tElement, tAttrs, transclude) {
    // return {
    // 	post: function postLink(scope, iElement, iAttrs, controller) { ... }
    // }
    // },
    link: function link(scope, element, attrs) {
      var staffEvent = scope.staff.staffEvent;
      var staffInfo = scope.staff;
      var mainContainer = d3.select(element[0]).append('svg')
      // .attr("preserveAspectRatio", "xMinYMin meet")
      // .attr("xmlns", "http://www.w3.org/2000/svg")
      // .attr("viewBox", "0 0 880 200")
      .attr({
        'width': '100%',
        'height': '100%'
      }).append('g').attr({
        'class': 'access-container',
        'transform': 'translate(0, -19)'
      });
      var axisContainer = mainContainer.append('g').attr({
        'class': 'access-axis',
        'transform': 'translate(0, 110)'
      });
      var domain = [moment(moment(scope.date).startOf('day')._d).add(6, 'hours'), moment(scope.date).add(1, 'd').startOf('day')._d];
      var curFlag = attrs.curtimeData;
      var xScale = d3.time.scale().domain(domain).range([30, element[0].clientWidth - 30]);

      // 큰 눈금 4시간 간격
      var bigTick = d3.svg.axis().scale(xScale).orient("bottom").tickSize(11, 0).ticks(d3.time.hours, 3).tickPadding(5).tickFormat(function (d, i) {
        return $filter('date')(d, 'HH:mm');
      });
      axisContainer.append('g').attr("class", "x-big-axis").call(bigTick);

      // 중간 눈금 1시간 간격
      var tick = d3.svg.axis().scale(xScale).orient("bottom").tickSize(10, 0).ticks(d3.time.hours, 1);
      axisContainer.append('g').attr("class", "x-axis").call(tick);

      // 작은 눈금 20분 간격
      var smallTick = d3.svg.axis().scale(xScale).orient("bottom").tickSize(5, 0).ticks(d3.time.minutes, 20);
      axisContainer.append('g').attr("class", "x-small-axis").call(smallTick);
      var isIE = /*@cc_on!@*/false || !!document.documentMode;
      var isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
      var isSafari = /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor);

      // 출입 이벤트
      var accessBar;
      accessBar = mainContainer.append('g').attr({
        'class': 'access-event',
        'transform': 'translate(0, 10)'
      });
      var dotY, timeHeight;
      if (isIE) {
        dotY = 89;
        timeHeight = 10;
      } else {
        dotY = 91;
        timeHeight = 30;
      }
      if (staffEvent) {
        accessBar.selectAll('.access-bar').data(staffEvent).enter().append('rect').attr({
          "class": 'access-bar',
          x: function x(d) {
            var x = xScale(d.enterDate);
            return x < 0 ? 30 : x;
          },
          y: dotY,
          width: function width(d) {
            var limitDate = domain[1] > new Date() ? new Date() : domain[1];
            var exitDate = d.exitDate > limitDate ? limitDate : d.exitDate;
            var enterDate = d.enterDate < domain[0] ? domain[0] : d.enterDate;
            var width = xScale(exitDate) - xScale(enterDate);
            if (width.toString == "NaN") {
              return 0;
            }
            if (width < 0) {
              width = 0;
            }
            return width;
          },
          height: timeHeight
        });
      }
      var firstEnterDate = 0;
      var lastExitDate = 0;
      var staffEventTempInfo;
      if (staffEvent) {
        staffEventTempInfo = _.find(staffEvent, {
          'onDuty': true
        });
      }
      var todayDate = moment(moment(scope.date).startOf('day')._d);
      if (staffEventTempInfo) {
        firstEnterDate = staffEventTempInfo.onDutyDisplayDate;
        if (moment(firstEnterDate, 'x') < moment(todayDate)) {
          firstEnterDate = 0;
        }
      }
      //처음 출근 제외한 출근 마킹 처리
      var inStyleTemp = "";
      if (staffEvent) {
        for (i = 0; i < staffEvent.length; i++) {
          if (moment(staffEvent[i].onDutyDisplayDate, 'x') < moment(todayDate)) {} else {
            if (staffEvent[i].onDuty == true && firstEnterDate != staffEvent[i].onDutyDisplayDate) {
              if (staffEventTempInfo && staffEventTempInfo.onDutyDisplayDate === staffEvent[i].onDutyDisplayDate) {} else {
                if ($filter('date')(staffEvent[i].onDutyDisplayDate, 'H') < 6) {
                  firstEnterDateTemp = moment(moment(staffEvent[i].onDutyDisplayDate).startOf('day')._d).add(6, 'hours');
                  inStyleTemp = "translate(" + (xScale(firstEnterDateTemp) - 40) + "px, 10px)";
                } else {
                  inStyleTemp = "translate(" + (xScale(staffEvent[i].onDutyDisplayDate) - 40) + "px, 10px)";
                }
                //var inlayerTemplate = '<div class="in_layer" style="cursor:pointer; top: 64px; transform: '+inStyleTemp+'"><span><img src="/resources/im/ic_in_arrow.png" title="출근 '+$filter('date')(staffEvent[i].onDutyDisplayDate, 'HH:mm')+'"></div>';
                var inlayerTemplate = '<div class="in_layer" style="cursor:pointer; transform: ' + inStyleTemp + '">' + '<span><span class="in_txt">' + $translate.instant('STR_IN_WORK') + '</span>' + $filter('date')(staffEvent[i].onDutyDisplayDate, 'HH:mm') + '</span><img src="/resources/im/ic_in_arrow.png"></div>';
                $(element[0]).prepend(inlayerTemplate);
              }
            }
          }
        }
      }
      if (firstEnterDate > 0) {
        scope.inTime = $filter('date')(firstEnterDate, 'HH:mm');
        if ($filter('date')(firstEnterDate, 'H') < 6) {
          firstEnterDate = moment(moment(firstEnterDate).startOf('day')._d).add(6, 'hours');
          scope.inStyle = "translate(" + (xScale(firstEnterDate) - 40) + "px, 10px)";
        } else {
          scope.inStyle = "translate(" + (xScale(firstEnterDate) - 40) + "px, 10px)";
        }
        scope.isShowInTime = true;
      } else {
        scope.isShowInTime = false;
      }
      scope.todayFlag = false;

      // if(staffInfo.staffEventStatus=="I"){
      //     scope.isShowOutTime = false;
      //     scope.isInStaff = true;
      // }
      var staffEventTempInfoOut;
      if (staffEvent) {
        for (i = staffEvent.length - 1; i >= 0; i--) {
          if (staffEvent[i].offDuty == true) {
            staffEventTempInfoOut = staffEvent[i];
            i = -1;
          }
        }
      }
      if (staffEventTempInfoOut) {
        if (moment(staffEventTempInfoOut.offDutyDisplayDate, 'x') > moment(scope.date).endOf('day')) {
          staffEventTempInfoOut = null;
        }
      }
      if (staffEventTempInfoOut) {
        lastExitDate = staffEventTempInfoOut.offDutyDisplayDate;
        scope.outTime = $filter('date')(lastExitDate, 'HH:mm');
        if ($filter('date')(lastExitDate, 'H') < 6) {
          lastExitDate = moment(moment(lastExitDate).startOf('day')._d).add(6, 'hours');
          scope.outStyle = "translate(" + (xScale(lastExitDate) - 21) + "px, 10px)";
        } else {
          scope.outStyle = "translate(" + (xScale(lastExitDate) - 21) + "px, 10px)";
        }
        scope.isShowOutTime = true;
      } else {
        scope.isShowOutTime = false;
      }

      //마지막 퇴근 제외한 퇴근 마킹 처리
      var outStyleTemp = "";
      if (staffEvent) {
        for (i = 0; i < staffEvent.length; i++) {
          if (moment(staffEvent[i].offDutyDisplayDate, 'x') > moment(scope.date).endOf('day')) {} else {
            if (staffEvent[i].offDuty == true && lastExitDate != staffEvent[i].offDutyDisplayDate) {
              if (staffEventTempInfoOut && staffEventTempInfoOut.offDutyDisplayDate === staffEvent[i].offDutyDisplayDate) {} else {
                if ($filter('date')(staffEvent[i].offDutyDisplayDate, 'H') < 6) {
                  exitDateTemp = moment(moment(staffEvent[i].offDutyDisplayDate).startOf('day')._d).add(6, 'hours');
                  outStyleTemp = "translate(" + (xScale(exitDateTemp) - 21) + "px, 10px)";
                } else {
                  outStyleTemp = "translate(" + (xScale(staffEvent[i].offDutyDisplayDate) - 21) + "px, 10px)";
                }
                //var outlayerTemplate = '<div class="out_layer" style="top: 64px; cursor:pointer; transform: '+outStyleTemp+'"><span><img src="/resources/im/ic_out_arrow.png" title="퇴근 '+$filter('date')(staffEvent[i].offDutyDisplayDate, 'HH:mm')+'"></div>';
                var outlayerTemplate = '<div class="out_layer" style="cursor:pointer; transform: ' + outStyleTemp + '">' + '<span><span class="out_txt">' + $translate.instant('STR_NO_WORK') + '</span>' + $filter('date')(staffEvent[i].offDutyDisplayDate, 'HH:mm') + '</span><img src="/resources/im/ic_out_arrow.png"></div>';
                $(element[0]).prepend(outlayerTemplate);
              }
            }
          }
        }
      }
      if (domain[0] < new Date() && domain[1] > new Date()) {
        scope.todayFlag = true;
      }
      if (true) {
        scope.isShowCurTime = true;
        scope.curStyle = "translate(" + (xScale(new Date()) + 5) + "px, 10px)";
      }
      var pxVal = 0;
      if (scope.isShowOutTime && scope.isShowInTime) {
        var inTime = scope.inTime;
        var outTime = scope.outTime;
        var diffMinute = moment(outTime, 'HH:mm').diff(moment(inTime, 'HH:mm'), 'minutes'); //moment(moment(outTime, 'HH:mm').diff(moment(inTime, 'HH:mm'))).format('m');
        scope.inLeft = "0px";
        scope.outRight = "0px";
        scope.inRight = "0px";
        scope.outLeft = "0px";
        if (inTime > outTime) {
          if (diffMinute > -70) {
            pxVal = 65 + diffMinute * 3 / 5;
            scope.inRight = -pxVal + "px";
            scope.outLeft = -pxVal + "px";
          }
        } else {
          if (diffMinute < 50) {
            pxVal = -65 + diffMinute * 3 / 5;
            scope.inLeft = pxVal + "px";
            scope.outRight = pxVal + "px";
          }
        }
      }
      //in아이콘 삭제로 주석처리
      // var curTime = moment().subtract(80, 'minute').format("HH:mm");
      // scope.leftPx = "-30px";
      // if(scope.isShowInTime && scope.isInStaff){
      //     var inTime = scope.inTime;
      //     var diffMinute =moment(inTime, 'HH:mm').diff(moment(curTime, 'HH:mm'),'minutes');
      //     if(inTime > curTime){
      //         var leftpxVal = diffMinute-40;
      //         if(diffMinute <=40){
      //             leftpxVal = 3;
      //         }
      // 				if(pxVal>0){
      // 					leftpxVal = (leftpxVal+pxVal)*2/3;
      // 				}
      //         scope.leftPx = leftpxVal+"px";
      //     }
      // }
      //
      // if((moment(scope.lastExitDate,'x') < moment())&& scope.isInStaff){
      //     var outTime = scope.outTime;
      //     var diffMinute =moment(outTime, 'HH:mm').diff(moment(curTime, 'HH:mm'),'minutes');
      //     if(outTime > curTime){
      //         var leftpxVal = diffMinute-40;
      //         if(diffMinute <=40){
      //             leftpxVal = 3;
      //         }
      // 				if(pxVal>0){
      // 					leftpxVal = (leftpxVal+pxVal)*2/3;
      // 				}
      //         scope.leftPx = leftpxVal+"px";
      //     }
      // }
    }
  };
});
"use strict";

app.directive('aiCamAddDialog', function () {
  return {
    restrict: 'E',
    scope: {},
    replace: true,
    transclude: true,
    controller: function controller($scope, $rootScope, $translate, $state, $timeout, $interval, Camera, Shop, CameraConfig, AiFace) {
      function initDialog() {
        $scope.shopId = $scope.$parent.shopId ? $scope.$parent.shopId : '';
        $scope.addCamLength = 0;
        fetchCams();
      }
      $scope.addCamLength = 0;
      function shopIncludeCheck() {
        $scope.aiCameras.forEach(function (item) {
          if (item.shopId === $scope.shopId) {
            item.isChecked = true;
          } else {
            item.isChecked = false;
            $scope.addCamLength += 1;
          }
        });
      }
      function fetchCams() {
        $scope.loadCams = true;
        AiFace.aiCameras(function (res) {
          $scope.loadCams = false;
          if (res.cameras) {
            res.cameras.sort(function (a, b) {
              var aLabel, bLabel;
              aLabel = a.label.toLowerCase();
              bLabel = b.label.toLowerCase();
              return aLabel < bLabel ? -1 : aLabel > bLabel ? 1 : 0;
            });
            $scope.aiCameras = res.cameras;
          } else {
            $scope.aiCameras = [];
          }
          shopIncludeCheck();
        }, function (err) {
          $scope.loadCams = false;
        });
      }
      $scope.checkCamera = function (camera) {
        if (!camera.isChecked && camera.shopId && camera.shopId !== $scope.shopId) {
          $rootScope.createConfirm({
            title: $translate.instant("SHOP_ADD"),
            description: $translate.instant("ALREADY") + "\'" + camera.shopName + "\' " + $translate.instant("SHOP_ALREADY_REGIST_CAMERA") + "<br><br>" + "\'" + camera.shopName + "\' " + $translate.instant("SHOP_REMOVE_CAMERA") + "<br>" + $translate.instant("9rRqk7Vo_02391"),
            handler: function handler() {
              camera.isChecked = !camera.isChecked;
              $scope.$apply();
            }
          });
        } else {
          camera.isChecked = !camera.isChecked;
        }
      };
      $scope.saveCamera = function () {
        var cameraIds = [],
          iotHubIds = [];
        if ($scope.$parent.shopObject.controllerList) {
          $scope.$parent.shopObject.controllerList.forEach(function (item) {
            if (item.cameraInfo && item.cameraInfo.isAiSupport === 1) {
              return;
            }
            if (item.deviceId.indexOf('IOTHUB') !== -1) {
              iotHubIds.push(item.deviceId);
            } else {
              cameraIds.push(item.deviceId);
            }
          });
        }
        $scope.aiCameras.forEach(function (camera) {
          if (camera.isChecked) {
            cameraIds.push(camera.id);
          }
        });
        var params = {
          shopName: $scope.$parent.shopObject.shopName,
          zipCode: $scope.$parent.shopObject.zipCode,
          address1: $scope.$parent.shopObject.address1,
          address2: $scope.$parent.shopObject.address2,
          timezone: $scope.$parent.shopObject.timezone,
          language: $scope.$parent.shopObject.language,
          access: $scope.$parent.shopObject.access,
          cameraIds: cameraIds,
          iotHubIds: iotHubIds
        };
        Shop.updateShopV2({
          shopId: $scope.shopId
        }, params, function (res) {
          if (res.code === 'ok') {
            $scope.closeDialog();
            $rootScope.$broadcast('updateShop', {
              shopId: $scope.shopId
            });
          } else {
            $rootScope.createConfirm({
              description: $translate.instant("SHOP_SET_CHANGE_FAIL"),
              btnCount: 1
            });
          }
        }, function (err) {
          $rootScope.createConfirm({
            title: $translate.instant("ACCESS_NET_FAIL"),
            description: $translate.instant("ACCESS_NET_FAIL_DESC"),
            btnCount: 1
          });
        });
      };
      $scope.aiCameras = [];
      $scope.loadCams = false;
      $scope.shopId = '';
      $scope.closeDialog = function () {
        $scope.$parent.isShowAiCamAddDialog = false;
      };
      $scope.$parent.$watch('isShowAiCamAddDialog', function (newValue, oldValue) {
        if (newValue !== oldValue) {
          if (newValue === true) {
            initDialog();
          } else {}
        }
      });
    },
    templateUrl: '/templates/aiface/aicam_add_dialog.html' + '?t=' + window.buildTime
  };
});
"use strict";

app.directive('aiCamModeSetDialog', function () {
  return {
    restrict: 'E',
    scope: {},
    replace: true,
    transclude: true,
    controller: function controller($scope, $rootScope, $translate, $state, $timeout, $interval, Camera, Shop, CameraConfig, AiFace) {
      function initDialog() {
        $scope.shopId = $scope.$parent.shopId ? $scope.$parent.shopId : '';
        $scope.notiMsg = '';
        if ($scope.notiTimeout) {
          $timeout.cancel($scope.notiTimeout);
        }
        fetchCams();
      }
      function filterAiCams(cameras) {
        if (!cameras) {
          return [];
        }
        return cameras.filter(function (item) {
          var camera = item.cameraInfo ? item.cameraInfo : item.camera;
          return camera && camera.isAiSupport === 1;
        }).map(function (item) {
          return item.cameraInfo ? item.cameraInfo : item.camera;
        });
      }
      function fetchCams() {
        if ($scope.shopId) {
          $scope.isLoadCams = true;
          Shop.dashboardShopV4({
            shopId: $scope.shopId
          }).$promise.then(function (res) {
            $scope.aiCameras = filterAiCams(res.shop.controllerList);
            $scope.aiCameras.forEach(function (camera) {
              camera.thumbnailPath = 'https://' + camera.thumbnailPath;
            });
            $scope.isLoadCams = false;
          }, function (err) {
            $scope.isLoadCams = false;
            $rootScope.createConfirm({
              title: $translate.instant("ACCESS_NET_FAIL"),
              description: $translate.instant("ACCESS_NET_FAIL_DESC"),
              btnCount: 1
            });
          });
        } else {
          $scope.isLoadCams = true;
          AiFace.aiCameras(function (data) {
            $scope.aiCameras = data.cameras;
            // ! 얼굴인식 카메라만 필터링
            $scope.aiFaceDetectCameras = _.filter(data.cameras || [], {
              aiType: 2
            });
            $scope.isLoadCams = false;
          }, function (err) {
            $scope.isLoadCams = false;
            $rootScope.createConfirm({
              title: $translate.instant("ACCESS_NET_FAIL"),
              description: $translate.instant("ACCESS_NET_FAIL_DESC"),
              btnCount: 1
            });
          });
        }
      }
      function showNotiMsg(msg) {
        $scope.notiMsg = msg;
        $('#aiface_dlg_noti').fadeIn(500);
        if ($scope.notiTimeout) {
          $timeout.cancel($scope.notiTimeout);
        }
        $scope.notiTimeout = $timeout(function () {
          $('#aiface_dlg_noti').fadeOut(500, function () {
            $scope.notiMsg = '';
          });
        }, 2000);
      }
      $scope.notiMsg = '';
      $scope.notiTimeout = null;
      $scope.aiCameras = [];
      $scope.aiFaceDetectCameras = [];
      $scope.loadCams = false;
      $scope.shopId = '';
      $scope.useAiPeopleCount = $rootScope.me ? $rootScope.me.useAiPeopleCount : false;
      $scope.useAiFaceDetect = $rootScope.me ? $rootScope.me.useAiFaceDetect : false;
      $scope.getCameraList = function () {
        if ($scope.shopId) {
          return $scope.aiCameras;
        } else {
          return $scope.aiFaceDetectCameras;
        }
      };
      $scope.goInquiry = function () {
        $state.go('main.help.inquiry');
      };
      $scope.showAiCamAddDlg = function () {
        $scope.$parent.$broadcast('showAiCamAddDlg');
      };
      $scope.aiTypeChange = function (camera, aiType) {
        if (aiType === 1 && !$rootScope.me.useAiPeopleCount) {
          showNotiMsg($translate.instant('9rRqk7Vo_02421'));
          return;
        }
        if (aiType === 2 && !$rootScope.me.useAiFaceDetect) {
          showNotiMsg($translate.instant('9rRqk7Vo_02343'));
          return;
        }
        if (camera.aiType !== 0) {
          $rootScope.createConfirm({
            title: $translate.instant('9rRqk7Vo_02325'),
            description: camera.aiType === 1 ? $translate.instant('9rRqk7Vo_02326') : $translate.instant('9rRqk7Vo_02327'),
            handler: function handler() {
              var sendAiType = camera.aiType === aiType ? 0 : aiType;
              CameraConfig.update({
                id: camera.id
              }, {
                aiType: sendAiType
              }, function (data) {
                if (data.code == "ok") {
                  camera.aiType = sendAiType;
                }
              }, function (err) {
                $rootScope.createConfirm({
                  title: $translate.instant("ACCESS_NET_FAIL"),
                  description: $translate.instant("ACCESS_NET_FAIL_DESC"),
                  btnCount: 1
                });
              });
            }
          });
        } else {
          var sendAiType = camera.aiType === aiType ? 0 : aiType;
          CameraConfig.update({
            id: camera.id
          }, {
            aiType: sendAiType
          }, function (data) {
            if (data.code == "ok") {
              camera.aiType = sendAiType;
            }
          }, function (err) {
            $rootScope.createConfirm({
              title: $translate.instant("ACCESS_NET_FAIL"),
              description: $translate.instant("ACCESS_NET_FAIL_DESC"),
              btnCount: 1
            });
          });
        }
      };
      $scope.$on('updateShop', function () {
        fetchCams();
      });
      function checkIsShopCameraChange() {
        var pAiCams;
        var i, j, pLen, aLen;
        if (!$scope.$parent.shopObject || !$scope.$parent.shopObject.controllerList) {
          return false;
        }
        pAiCams = filterAiCams($scope.$parent.shopObject.controllerList);
        pLen = pAiCams.length;
        aLen = $scope.aiCameras.length;
        if (pLen !== aLen) {
          return true;
        }
        for (i = 0; i < pLen; i += 1) {
          for (j = 0; j < aLen; j += 1) {
            if (pAiCams[i].id === $scope.aiCameras[j].id) {
              if (pAiCams[i].aiType !== $scope.aiCameras[j].aiType) {
                return true;
              }
            }
          }
        }
        return false;
      }
      $scope.closeDialog = function () {
        $('body').removeClass('blockScroll');
        $scope.$parent.$broadcast('hideAiCamModeSetDlg');
        if ($scope.shopId && checkIsShopCameraChange()) {
          $scope.$parent.$broadcast('updateShop');
        }
        if ($scope.notiTimeout) {
          $timeout.cancel($scope.notiTimeout);
        }
        $scope.$parent.isShowAiCamModeSetDialog = false;
      };
      $scope.$parent.$watch('isShowAiCamModeSetDialog', function (newValue, oldValue) {
        if (newValue !== oldValue) {
          if (newValue === true) {
            $('body').addClass('blockScroll');
            initDialog();
          } else {}
        }
      });
    },
    templateUrl: '/templates/aiface/aicam_mode_set_dialog.html' + '?t=' + window.buildTime
  };
});
"use strict";

// 출입관리 화면의 직원 출입 타임라인
app.directive('aiDetectTimeline', function ($filter, $translate) {
  return {
    restrict: 'E',
    template: '<div class="acc_timeline">' + '<div class="in_now" ng-style="{\'transform\': curStyle, \'-webkit-transform\': curStyle, \'-ms-transform\': curStyle, \'z-index\': isOutOver }" ng-show="isToday"><p class="currentTimeDot" ng-show="isToday" style="height: 86px;border-left: 2px dotted #ef351c; position: absolute; top: -12px; opacity: .6;"></p></div>' + '</div>',
    replace: true,
    scope: {
      startDate: '=startDate',
      endDate: '=endDate',
      peopleId: '=peopleId',
      aiEvents: '=aiEvents',
      isToday: '=isToday'
    },
    link: function link(scope, element, attrs) {
      var mainContainer = d3.select(element[0]).append('svg')
      // .attr("preserveAspectRatio", "xMinYMin meet")
      // .attr("xmlns", "http://www.w3.org/2000/svg")
      // .attr("viewBox", "0 0 880 200")
      .attr({
        'width': '100%',
        'height': '100%'
      }).append('g').attr({
        'class': 'access-container',
        'transform': 'translate(0, -19)'
      });
      var axisContainer = mainContainer.append('g').attr({
        'class': 'access-axis',
        'transform': 'translate(0, 110)'
      });
      var domain = [moment(moment(scope.startDate).startOf('day')._d).add(0, 'hours'), moment(scope.startDate).add(1, 'd').startOf('day')._d];
      var curFlag = attrs.curtimeData;
      var xScale = d3.time.scale().domain(domain).range([30, element[0].clientWidth - 30]);
      scope.curStyle = "translate(" + (xScale(new Date()) + 5) + "px, 10px)";

      // 큰 눈금 4시간 간격
      var bigTick = d3.svg.axis().scale(xScale).orient("bottom").tickSize(11, 0).ticks(d3.time.hours, 3).tickPadding(5).tickFormat(function (d, i) {
        var formatStr = $filter('date')(d, 'HH:mm');
        return formatStr === '00:00' && i !== 0 ? '24:00' : formatStr;
      });
      axisContainer.append('g').attr("class", "x-big-axis").call(bigTick);

      // 중간 눈금 1시간 간격
      var tick = d3.svg.axis().scale(xScale).orient("bottom").tickSize(10, 0).ticks(d3.time.hours, 1);
      axisContainer.append('g').attr("class", "x-axis").call(tick);

      // 작은 눈금 20분 간격
      var smallTick = d3.svg.axis().scale(xScale).orient("bottom").tickSize(5, 0).ticks(d3.time.minutes, 20);
      axisContainer.append('g').attr("class", "x-small-axis").call(smallTick);
      var isIE = /*@cc_on!@*/false || !!document.documentMode;
      var isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
      var isSafari = /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor);

      // 출입 이벤트
      var accessBar;
      accessBar = mainContainer.append('g').attr({
        'class': 'access-event',
        'transform': 'translate(0, 10)'
      });
      var i,
        inStyleTemp = "",
        inLClassList = "",
        classList = "",
        imgsrc = "",
        eventId = "";
      var peopleId = '';
      if (scope.peopleId) {
        peopleId = scope.peopleId.split(':')[1];
      }
      if (scope.aiEvents) {
        for (i = 0; i < scope.aiEvents.length; i += 1) {
          inStyleTemp = "translate(" + (xScale(scope.aiEvents[i].detectDate) - 40) + "px, 10px)";
          if (i === scope.aiEvents.length - 1) {
            classList = 'tooltiptext last';
            inLClassList = peopleId + ' in_layer tooltip last';
            imgsrc = '/resources/img/ic-camera-gps-red.svg';
          } else {
            classList = 'tooltiptext';
            inLClassList = peopleId + ' in_layer tooltip';
            imgsrc = '/resources/img/ic-camera-gps-tb.svg';
          }
          eventId = scope.aiEvents[i].eventId;
          var inlayerTemplate = '<div data-id="' + eventId + '" class="' + inLClassList + '" style="cursor:pointer; transform: ' + inStyleTemp + '">' + '<span>' + '<span class="in_txt">' + '</span>' + scope.aiEvents[i].detectTime + '</span>' + '<img src="' + imgsrc + '">' + '<span class="' + classList + '">' + '<img src="/resources/img/ic-camera-16.svg">' + '<span>' + scope.aiEvents[i].deviceName + '</span>' + '</span>' + '</div>';
          $(element[0]).prepend(inlayerTemplate);
          $('.in_layer.tooltip.' + peopleId).on('click', function (event) {
            var eventData;
            scope.aiEvents.some(function (evt) {
              if (evt.eventId === event.currentTarget.dataset.id) {
                eventData = evt;
                return true;
              }
              return false;
            });
            if (eventData) {
              scope.$parent.playAiEvent(eventData);
            }
          });
        }
      }
    }
  };
});
"use strict";

app.directive('aiFaceAddPeopleDialog', function () {
  return {
    restrict: 'E',
    scope: {},
    replace: true,
    transclude: true,
    controller: function controller($scope, $rootScope, $translate, $state, $timeout, $interval, AiFace) {
      function initDialog() {
        $scope.loadPeople = false;
        $scope.searchName = '';
        $scope.peopleList = [];
        $scope.candidates = [];
        $scope.searchMap = {};
        $scope.fetchPeople($scope.$parent.selectedAccount.userId);
      }
      function buildAddCandidates() {
        if ($scope.$parent.selectedGroup.persons) {
          $scope.candidates = $scope.peopleList.filter(function (people) {
            return !$scope.$parent.selectedGroup.persons.some(function (grpMember) {
              return people.id === grpMember.id;
            });
          });
        } else {
          $scope.candidates = $scope.peopleList;
        }
      }
      $scope.loadPeople = false;
      $scope.searchName = '';
      $scope.peopleList = [];
      $scope.candidates = [];
      $scope.searchMap = {};
      $scope.getSearchMapLength = function () {
        return Object.keys($scope.searchMap).length;
      };
      $scope.checkIsShowPeople = function (people) {
        var isShow = false;
        if (!$scope.searchName) {
          isShow = true;
        } else {
          isShow = people.name.indexOf($scope.searchName) !== -1;
        }
        if (isShow) {
          $scope.searchMap[people.id] = isShow;
        } else {
          delete $scope.searchMap[people.id];
        }
        return isShow;
      };
      $scope.closeDialog = function () {
        $scope.$parent.isShowAiFaceAddPeopleDialog = false;
      };
      $scope.saveGroup = function () {
        var addIds = [];
        $scope.candidates.forEach(function (candidate) {
          if (candidate.isChecked) {
            addIds.push(candidate.id);
          }
        });
        if (!addIds.length) {
          return;
        }
        AiFace.updateGroup({
          userId: $scope.$parent.selectedAccount.userId,
          groupId: $scope.$parent.selectedGroup.id
        }, {
          addIds: addIds
        }, function (res) {
          $rootScope.$broadcast('aifaceGroupUpdate', null);
          $scope.closeDialog();
        }, function (err) {
          $rootScope.createConfirm({
            title: $translate.instant("ACCESS_NET_FAIL"),
            description: $translate.instant("ACCESS_NET_FAIL_DESC"),
            btnCount: 1
          });
        });
      };
      $scope.fetchPeople = function (userId) {
        $scope.loadPeople = true;
        AiFace.persons({
          userId: userId
        }).$promise.then(function (res) {
          $scope.loadPeople = false;
          $scope.peopleList = res.persons ? res.persons : [];
          buildAddCandidates();
        }, function (err) {
          $scope.loadPeople = false;
        });
      };
      $scope.$parent.$watch('isShowAiFaceAddPeopleDialog', function (newValue, oldValue) {
        if (newValue !== oldValue) {
          if (newValue === true) {
            $('body').addClass('blockScroll');
            initDialog();
          } else {
            $('body').removeClass('blockScroll');
          }
        }
      });
    },
    templateUrl: '/templates/aiface/aiface_add_people_dialog.html' + '?t=' + window.buildTime
  };
});
"use strict";

app.directive('aiFaceAddPhotoDialog', function () {
  return {
    restrict: 'E',
    scope: {},
    replace: true,
    transclude: true,
    controller: function controller($scope, $rootScope, $translate, $state, $timeout, $interval, AiFace) {
      $scope.DIALOG_STATE = {
        EDIT: 'edit',
        REGISTING: 'registing',
        RESULT: 'result',
        NONE: 'none'
      };
      $scope.configStatus = $scope.DIALOG_STATE.EDIT;
      $scope.changeDialogState = function (state) {
        if ($scope.configStatus === state) {
          return;
        }
        $scope.configStatus = state;
        if (state === $scope.DIALOG_STATE.EDIT) {
          //
        } else if (state === $scope.DIALOG_STATE.REGISTING) {
          //
        } else if (state === $scope.DIALOG_STATE.RESULT) {} else {
          // NONE
          $scope.closeDialog();
        }
      };
      function initDialog() {
        $scope.changeDialogState($scope.DIALOG_STATE.EDIT);
        $scope.loadPeople = false;
        $scope.isSaving = false;
        $scope.searchName = '';
        $scope.searchMap = {};
        $scope.selectedPeople = null;
        $scope.peopleList = $scope.$parent.peopleList;
        $scope.peopleList.forEach(function (item) {
          item.selected = false;
        });
        $scope.selectFaces = $scope.$parent.poolSelectList;
      }
      $scope.loadPeople = false;
      $scope.isSaving = false;
      $scope.searchName = '';
      $scope.peopleList = null;
      $scope.selectedPeople = null;
      $scope.selectFaces = [];
      $scope.searchMap = {};
      $scope.getSearchMapLength = function () {
        return Object.keys($scope.searchMap).length;
      };
      $scope.checkIsShowPeople = function (people) {
        var isShow = false;
        if (!$scope.searchName) {
          isShow = true;
        } else {
          isShow = people.name.indexOf($scope.searchName) !== -1;
        }
        if (isShow) {
          $scope.searchMap[people.id] = isShow;
        } else {
          delete $scope.searchMap[people.id];
        }
        return isShow;
      };
      $scope.closeDialog = function () {
        $scope.$parent.isShowAiFaceAddPhotoDialog = false;
      };
      $scope.saveGroup = function () {
        if ($scope.isSaving) {
          $rootScope.createConfirm({
            description: $translate.instant('DATA_LOADING_CONTENT'),
            btnCount: 1
          });
          return;
        }
        if (!$scope.selectedPeople) {
          $rootScope.createConfirm({
            title: $translate.instant('9rRqk7Vo_02315'),
            description: $translate.instant('9rRqk7Vo_02328'),
            btnCount: 1
          });
          return;
        }
        var addPoolIds = [];
        $scope.selectFaces.forEach(function (item) {
          addPoolIds.push(item.id);
        });
        $scope.isSaving = true;
        $scope.changeDialogState($scope.DIALOG_STATE.REGISTING);
        AiFace.updatePeople({
          userId: $scope.$parent.selectedAccount.userId
        }, {
          personId: $scope.selectedPeople.id,
          addPoolIds: addPoolIds
        }).$promise.then(function (res) {
          $scope.isSaving = false;
          if (res.code === 'ok') {
            $scope.selectFaces.forEach(function (item) {
              item.registed = true;
            });
            $scope.changeDialogState($scope.DIALOG_STATE.RESULT);
            $scope.$parent.setPoolMode($scope.$parent.POOL_SHOW_MODE.NORMAL);
          } else {
            $scope.changeDialogState($scope.DIALOG_STATE.EDIT);
            $rootScope.createConfirm({
              title: $translate.instant('9rRqk7Vo_02315'),
              description: $translate.instant('9rRqk7Vo_02317'),
              btnCount: 1
            });
          }
        }, function (err) {
          $scope.isSaving = false;
          $scope.changeDialogState($scope.DIALOG_STATE.EDIT);
          $rootScope.createConfirm({
            title: $translate.instant("ACCESS_NET_FAIL"),
            description: $translate.instant("ACCESS_NET_FAIL_DESC"),
            btnCount: 1
          });
        });
      };
      $scope.selectPeople = function (people) {
        $scope.peopleList.forEach(function (item) {
          item.selected = false;
        });
        people.selected = true;
        $scope.selectedPeople = people;
      };
      $scope.$parent.$watch('isShowAiFaceAddPhotoDialog', function (newValue, oldValue) {
        if (newValue !== oldValue) {
          if (newValue === true) {
            $('body').addClass('blockScroll');
            initDialog();
          } else {
            $('body').removeClass('blockScroll');
          }
        }
      });
    },
    templateUrl: '/templates/aiface/aiface_add_photo_dialog.html' + '?t=' + window.buildTime
  };
});
"use strict";

app.directive('aiFaceEventFilterDialog', function () {
  return {
    restrict: 'E',
    scope: {},
    replace: true,
    transclude: true,
    controller: function controller($scope, $rootScope, $translate, $state, $timeout, $interval, AiFace) {
      function initDialog() {
        $scope.cameras = $scope.$parent.aiCameras;
        $scope.editCameras = JSON.parse(JSON.stringify($scope.cameras));
        var notAllChecked = $scope.editCameras.some(function (cam) {
          return !cam.isChecked;
        });
        $scope.allChecked = !notAllChecked;
      }
      $scope.editCameras = [];
      $scope.cameras = [];
      $scope.allChecked = false;
      $scope.closeDialog = function () {
        $scope.$parent.isShowAiFaceEventFilterDialog = false;
      };
      $scope.clickAllChecker = function () {
        $scope.allChecked = !$scope.allChecked;
        $scope.editCameras.forEach(function (item) {
          item.isChecked = $scope.allChecked;
        });
      };
      $scope.clickCamera = function (camera) {
        camera.isChecked = !camera.isChecked;
        var notAllChecked = $scope.editCameras.some(function (cam) {
          return !cam.isChecked;
        });
        $scope.allChecked = !notAllChecked;
      };
      $scope.confirmEventFilterSetting = function () {
        var filterIds = '';
        if (!$scope.allChecked) {
          $scope.editCameras.forEach(function (item) {
            if (item.isChecked) {
              if (filterIds) {
                filterIds += ',' + item.deviceId;
              } else {
                filterIds += item.deviceId;
              }
            }
          });
          if (!filterIds) {
            $rootScope.createConfirm({
              description: $translate.instant('9rRqk7Vo_02392'),
              btnCount: 1
            });
            return;
          }
        }
        $scope.$parent.aiCameras = $scope.editCameras;
        $scope.$parent.$broadcast('filterConfirm', filterIds);
        $scope.closeDialog();
      };
      $scope.$parent.$watch('isShowAiFaceEventFilterDialog', function (newValue, oldValue) {
        if (newValue !== oldValue) {
          if (newValue === true) {
            $('body').addClass('blockScroll');
            initDialog();
          } else {
            $('body').removeClass('blockScroll');
          }
        }
      });
    },
    templateUrl: '/templates/aiface/aiface_event_filter_dialog.html' + '?t=' + window.buildTime
  };
});
"use strict";

app.directive("aiFaceEventPlayDialog", function () {
  return {
    restrict: "E",
    scope: {},
    replace: true,
    transclude: true,
    controller: function controller($scope, $rootScope, $translate, $state, $timeout, $interval, $q, AiFace, Camera, Share, Utils) {
      var DURATION_SECONDS = 8;
      var EVT_FETCH_COUNT = 10;
      var EVENT_HEIGHT = 48;
      var EVENT_DAY_HEIGHT = 36;
      var throttleTime = 300;
      var fullScreenWidth = 0;
      var throttleFunc = null;
      var nextPageToken = "";
      var prevPageToken = "";
      var scrollTopCheckTimeout = null;
      $scope.EVT_FETCH_DIRECTION = {
        center: "center",
        next: "next",
        prev: "prev",
        none: "none"
      };
      function initDialog() {
        $scope.replaceShow = false;
        nextPageToken = "";
        prevPageToken = "";
        $scope.isPlayed = false;
        $scope.isShowAnimate = false;
        $scope.moreLoadingDirection = $scope.EVT_FETCH_DIRECTION.none;
        $scope.isShowFullscreenButton = true;
        $scope.events = [];
        $scope.isShared = $scope.$parent.isShared;
        $scope.shopObject = $scope.$parent.shopObject;
        $scope.eventInfo = $scope.$parent.eventInfo;
        $scope.playCameraInfo = getPlayCameraInfo($scope.eventInfo, $scope.shopObject);
        $scope.player = tCam.htmlSimplePlayer({
          elId: "player",
          eventHandler: function eventHandler(event) {
            //if (event.type === 'error') {}
          }
        });
        setFullScreenEvent();
        updateDlgStyle();
        initVideoBar();
        if ($scope.playCameraInfo) {
          $scope.eventPlay($scope.eventInfo);
        }
        fetchEvents($scope.eventInfo.eventId, $scope.EVT_FETCH_DIRECTION.center);
      }
      $scope.listScrollTop = 0;
      $scope.replaceShow = false;
      $scope.isPlayed = false;
      $scope.isShowAnimate = false;
      $scope.moreLoadingDirection = $scope.EVT_FETCH_DIRECTION.none;
      $scope.isShowFullscreenButton = true;
      $scope.isShared = false;
      $scope.shopObject = null;
      $scope.eventInfo = null;
      $scope.playCameraInfo = null;
      $scope.events = [];
      $scope.videoCursorPosition = 0;
      $scope.videoTimer = null;
      $scope.videoTime = 0;
      $scope.videoStartTime = 0;
      $scope.videoEndTime = 0;
      $scope.remainTime = 0;
      $scope.player = null;
      function updateDlgStyle() {
        var marginTopSize = 40;
        var headerSize = 63;
        var playerSize = 282;
        var marginBottom = 30;
        var windowHeight = $(window).height();
        var maxHeight = windowHeight - (marginTopSize + headerSize + playerSize + marginBottom);
        maxHeight = maxHeight < 180 ? 180 : maxHeight;
        $scope.evtsMaxHeight = maxHeight + "px";
      }
      function setEvtListScrollFn() {
        throttleFunc = new Utils.throttling().throttle(onScrollList, throttleTime);
        $("#ai_evt_area").on("scroll", throttleFunc);
      }
      function unsetEvtListScrollFn() {
        if (throttleFunc) {
          $("#ai_evt_area").off("scroll", throttleFunc);
          throttleFunc = null;
        }
      }
      function setLoadNexTimeout() {
        $timeout.cancel(scrollTopCheckTimeout);
        scrollTopCheckTimeout = $timeout(function () {
          if ($scope.listScrollTop === 0 && nextPageToken && $scope.moreLoadingDirection === $scope.EVT_FETCH_DIRECTION.none) {
            fetchEvents(nextPageToken, $scope.EVT_FETCH_DIRECTION.next);
          }
        }, 1000);
      }
      function getScrollFirstEvt(events, scrollTop) {
        var i,
          len = events.length,
          calcScrolltop = scrollTop;
        for (i = 0; i < len; i += 1) {
          calcScrolltop -= events[i].isDayFirst ? EVENT_HEIGHT + EVENT_DAY_HEIGHT : EVENT_HEIGHT;
          if (calcScrolltop <= 0) {
            return events[i];
          }
        }
        return null;
      }
      var tooltipTimeout = null;
      var currentYear = new Date().getFullYear();
      $scope.isShowDayTooltip = false;
      $scope.tooltipDay = 0;
      $scope.isSameYear = false;
      function showDayTooltip(date) {
        if (tooltipTimeout) {
          $timeout.cancel(tooltipTimeout);
        }
        $scope.tooltipDay = date;
        $scope.isSameYear = currentYear === new Date(date).getFullYear();
        $scope.isShowDayTooltip = true;
        $scope.$apply();
        tooltipTimeout = $timeout(function () {
          $scope.isShowDayTooltip = false;
        }, 1500);
      }
      var lastScrollDay = "";
      function onScrollList(evt) {
        var evtListEl = document.getElementById("ai_evt_area"),
          scrollTop = evtListEl.scrollTop,
          scrollHeight = evtListEl.scrollHeight,
          clientHeight = evtListEl.clientHeight;
        $scope.listScrollTop = scrollTop;
        var scFirstEvt = getScrollFirstEvt($scope.events, scrollTop);
        if (scFirstEvt) {
          var date = new Date(scFirstEvt.detectDate);
          var dateStr = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
          if (lastScrollDay !== dateStr) {
            lastScrollDay = dateStr;
            showDayTooltip(scFirstEvt.detectDate);
          }
        }
        if ($scope.events && $scope.events.length >= EVT_FETCH_COUNT) {
          var scrollPercent = $scope.listScrollTop / (scrollHeight - clientHeight) * 100;
          if ($scope.moreLoadingDirection === $scope.EVT_FETCH_DIRECTION.none) {
            if (scrollPercent < 20 && nextPageToken) {
              fetchEvents(nextPageToken, $scope.EVT_FETCH_DIRECTION.next);
            } else if (scrollPercent > 80 && prevPageToken) {
              fetchEvents(prevPageToken, $scope.EVT_FETCH_DIRECTION.prev);
            }
          }
        }
      }
      function getPlayCameraInfo(event, shop) {
        if (!event || !shop || !shop.controllerList) {
          return null;
        }
        var cameraInfo = null;
        shop.controllerList.some(function (device) {
          if (device.cameraInfo && device.cameraInfo.id === event.deviceId) {
            cameraInfo = device.cameraInfo;
            return true;
          }
          return false;
        });
        return cameraInfo;
      }
      function startVideoTimer() {
        $interval.cancel($scope.videoTimer);
        $scope.videoTimer = $interval(function () {
          if (!$scope.player) {
            $interval.cancel($scope.videoTimer);
            $scope.videoTimer = null;
            return;
          }
          if ($scope.player.getIsPlaying()) {
            var barWidth = parseInt(d3.select("#videoBar").style("width"));
            var tempCurser = $scope.videoCursorPosition + barWidth / DURATION_SECONDS;
            $scope.videoTime = parseInt(moment(moment($scope.videoTime, "x").add(1, "seconds")).format("x"));
            var endTime = $scope.videoEndTime;
            $scope.remainTime = parseInt(moment(endTime).diff($scope.videoTime, "seconds"));
            if (tempCurser >= barWidth) {
              tempCurser = barWidth;
            }
            $scope.videoCursorPosition = tempCurser;
            if (tempCurser === barWidth) {
              $scope.remainTime = 0;
              $scope.player.pause();
              $scope.replaceShow = true;
              $interval.cancel($scope.videoTimer);
            }
          }
        }, 1000);
      }
      function initVideoBar() {
        var barWidth = parseInt(d3.select("#videoBar").style("width"));
        var videoDrag = d3.behavior.drag().on("drag", function (e) {
          var x = d3.mouse(this)[0]; // for cursur center
          $scope.videoCursorPosition = x;
        }).on("dragstart", function () {
          $interval.cancel($scope.videoTimer);
        }).on("dragend", function () {
          var x = d3.mouse(this)[0]; // for cursur center
          $scope.videoCursorPosition = x;
          barWidth = parseInt(d3.select("#videoBar").style("width"));
          var diffTime = Math.round(DURATION_SECONDS * ($scope.videoCursorPosition / barWidth));
          $scope.videoTime = parseInt(moment($scope.videoStartTime).add(diffTime, "seconds").format("x"));
          $scope.playRequest($scope.videoTime);
        });
        d3.select("#videoCursor").call(videoDrag);
        d3.select("#videoBar").on("click", function () {
          var x = d3.mouse(this)[0]; // for cursur center
          $scope.videoCursorPosition = x;
          barWidth = parseInt(d3.select("#videoBar").style("width"));
          var diffTime = Math.round(DURATION_SECONDS * ($scope.videoCursorPosition / barWidth));
          $scope.videoTime = parseInt(moment($scope.videoStartTime).add(diffTime, "seconds").format("x"));
          $scope.playRequest($scope.videoTime);
        });
      }
      function eventsDayFirstEvtCheck(events) {
        var dayMap = {};
        events.forEach(function (event) {
          var date = new Date(event.detectDate);
          var dateStr = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
          if (dayMap[dateStr]) {
            event.isDayFirst = false;
          } else {
            event.isDayFirst = true;
            dayMap[dateStr] = true;
          }
        });
      }
      function fetchEvents(pivotId, direction) {
        $scope.moreLoadingDirection = direction;
        AiFace.eventsByPivot({
          shopId: $scope.shopObject.shopId,
          pivotId: pivotId,
          direction: direction,
          count: EVT_FETCH_COUNT
        }).$promise.then(function (res) {
          $scope.moreLoadingDirection = $scope.EVT_FETCH_DIRECTION.none;
          if (direction === $scope.EVT_FETCH_DIRECTION.center) {
            nextPageToken = res.nextPageToken;
            prevPageToken = res.prevPageToken;
            $scope.events = res.events;
            setTimeout(function () {
              var selectedEl = document.querySelector("#ai_evt_area li.selected");
              if (selectedEl) {
                selectedEl.scrollIntoView();
              }
              setTimeout(function () {
                setEvtListScrollFn();
              }, 500);
            }, 300);
          } else if (direction === $scope.EVT_FETCH_DIRECTION.next) {
            nextPageToken = res.nextPageToken;
            if (res.events) {
              $scope.events = res.events.concat($scope.events);
            }
            setLoadNexTimeout();
          } else if (direction === $scope.EVT_FETCH_DIRECTION.prev) {
            prevPageToken = res.prevPageToken;
            if (res.events) {
              $scope.events = $scope.events.concat(res.events);
            }
          }
          eventsDayFirstEvtCheck($scope.events);
        }, function (err) {
          $scope.moreLoadingDirection = $scope.EVT_FETCH_DIRECTION.none;
        });
      }
      $scope.videoPlay = function () {
        if ($scope.videoTime >= $scope.videoEndTime) {
          return;
        }
        if ($scope.player) {
          $scope.player.resume();
        }
        setTimeout(function () {
          startVideoTimer();
        }, 100);
        $scope.replaceShow = false;
        $scope.isPlayed = false;
        $scope.isShowAnimate = false;
      };
      $scope.videoStop = function () {
        if ($scope.videoTime >= $scope.videoEndTime) {
          return;
        }
        $scope.player.pause();
        $scope.isPlayed = true;
        $scope.isShowAnimate = true;
        $interval.cancel($scope.videoTimer);
      };
      $scope.eventPlay = function (evt) {
        $scope.eventInfo = evt;
        $scope.playCameraInfo = getPlayCameraInfo(evt, $scope.shopObject);
        $scope.videoCursorPosition = 0;
        $scope.remainTime = DURATION_SECONDS;
        if ($scope.videoTimer) {
          $interval.cancel($scope.videoTimer);
          $scope.videoTimer = null;
        }
        $scope.videoTime = $scope.videoStartTime = $scope.eventInfo.detectDate - DURATION_SECONDS / 2 * 1000;
        $scope.videoEndTime = $scope.eventInfo.detectDate + DURATION_SECONDS / 2 * 1000;
        $scope.playRequest($scope.videoTime);
      };
      $scope.playRequest = function (time) {
        if (!$scope.playCameraInfo) {
          return;
        }
        $scope.replaceShow = false;
        var tokenPromise = $scope.isShared ? Share.getToken({
          id: $scope.playCameraInfo.id
        }).$promise : Camera.getToken({
          id: $scope.playCameraInfo.id
        }).$promise;
        var camPromise = $scope.isShared ? Share.get({
          id: $scope.playCameraInfo.id
        }).$promise : Camera.get({
          id: $scope.playCameraInfo.id
        }).$promise;
        $q.all([tokenPromise, camPromise]).then(function (res) {
          var tokenRes = res[0];
          var camRes = res[1];
          $scope.player.play(camRes.mediaStreamURL + "?token=" + tokenRes.token + "&time=" + time);
          startVideoTimer();
        }, function (err) {});
      };
      $scope.goCamDetail = function () {
        if (!$scope.playCameraInfo) {
          return;
        }
        $scope.closeDialog();
        $state.go("main.cameraDetail", {
          cameraId: $scope.playCameraInfo.id,
          type: $scope.isShared ? "sharedshop" : "shop",
          id: $scope.isShared.shopId,
          time: $scope.videoStartTime,
          shared: $scope.isShared
        });
      };
      $scope.clipsReplay = function () {
        $scope.videoTime = $scope.videoStartTime;
        $scope.videoCursorPosition = 0;
        $scope.replaceShow = false;
        $scope.playRequest($scope.videoTime);
      };
      function updatePlayCursorFullEnter() {
        fullScreenWidth = parseInt(d3.select("#videoBar").style("width"));
        var tempPosition = $scope.videoCursorPosition * (fullScreenWidth / 500);
        if (fullScreenWidth < tempPosition) {
          $scope.videoCursorPosition = fullScreenWidth;
        } else if (tempPosition < 0) {
          $scope.videoCursorPosition = 0;
        } else {
          $scope.videoCursorPosition = tempPosition;
        }
      }
      function updatePlayCursorFullExit() {
        var barWidth = parseInt(d3.select("#videoBar").style("width"));
        var tempPosition = $scope.videoCursorPosition * (barWidth / fullScreenWidth);
        if (barWidth < tempPosition) {
          $scope.videoCursorPosition = barWidth;
        } else if (tempPosition < 0) {
          $scope.videoCursorPosition = 0;
        } else {
          $scope.videoCursorPosition = tempPosition;
        }
      }
      $scope.pressedFullScreenButton = function () {
        var element = document.getElementById("fullscreen");
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.webkitRequestFullscreen) {
          element.webkitRequestFullscreen();
        } else if (element.msRequestFullscreen) {
          element.msRequestFullscreen();
        }
        $scope.isShowFullscreenButton = false;
      };
      $scope.pressedExitFullScreenButton = function () {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
        $scope.isShowFullscreenButton = true;
      };
      $scope.formattedDetailDate = function (time) {
        return moment(new Date(time)).format("YYYY.MM.DD");
      };
      $scope.formattedDetailTime = function (time) {
        return moment(new Date(time)).format("HH:mm:ss");
      };
      $scope.timeCalcul = function (timeSec) {
        var absTimeSec = Math.abs(timeSec),
          min = Math.floor(absTimeSec / 60),
          sec = Math.floor(absTimeSec % 60);
        return min + ":" + (sec < 10 ? "0" : "") + (absTimeSec < 0 ? 1 : sec);
      };
      function fullscreenHandler() {
        var isFullScreen = !!(document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement);
        $scope.isShowFullscreenButton = !isFullScreen;
        setTimeout(function () {
          if (isFullScreen) {
            updatePlayCursorFullEnter();
          } else {
            updatePlayCursorFullExit();
          }
        }, 100);
        $scope.$apply();
      }
      function setFullScreenEvent() {
        document.addEventListener("webkitfullscreenchange", fullscreenHandler, false);
        document.addEventListener("mozfullscreenchange", fullscreenHandler, false);
        document.addEventListener("fullscreenchange", fullscreenHandler, false);
        document.addEventListener("MSFullscreenChange", fullscreenHandler, false);
      }
      function unsetFullScreenEvent() {
        document.removeEventListener("webkitfullscreenchange", fullscreenHandler, false);
        document.removeEventListener("mozfullscreenchange", fullscreenHandler, false);
        document.removeEventListener("fullscreenchange", fullscreenHandler, false);
        document.removeEventListener("MSFullscreenChange", fullscreenHandler, false);
      }
      $scope.closeDialog = function () {
        if ($scope.player) {
          $scope.player.destroy();
          $scope.player = null;
        }
        $scope.$parent.isShowAiFaceEventPlayDialog = false;
        unsetEvtListScrollFn();
        unsetFullScreenEvent();
        $timeout.cancel(scrollTopCheckTimeout);
        $timeout.cancel(tooltipTimeout);
        if ($scope.videoTimer) {
          $interval.cancel($scope.videoTimer);
          $scope.videoTimer = null;
        }
      };
      $scope.$parent.$watch("isShowAiFaceEventPlayDialog", function (newValue, oldValue) {
        if (newValue !== oldValue) {
          if (newValue === true) {
            document.body.classList.add("blockScroll");
            initDialog();
          } else {
            $("body").removeClass("blockScroll");
          }
        }
      });
    },
    templateUrl: "/templates/aiface/aiface_eventplay_dialog.html" + "?t=" + window.buildTime
  };
});
"use strict";

app.directive('aiFaceGroupDialog', function () {
  return {
    restrict: 'E',
    scope: {},
    replace: true,
    transclude: true,
    controller: function controller($scope, $rootScope, $translate, $state, $timeout, $interval, AiFace) {
      function initDialog() {
        $scope.loadPeople = false;
        $scope.searchName = '';
        $scope.groupName = '';
        $scope.peopleList = [];
        $scope.searchMap = {};
        $scope.fetchPeople($scope.$parent.selectedAccount.userId);
        $timeout(function () {
          document.getElementById('group_input').focus();
        }, 0);
      }
      $scope.loadPeople = false;
      $scope.searchName = '';
      $scope.groupName = '';
      $scope.peopleList = [];
      $scope.searchMap = {};
      $scope.getSearchMapLength = function () {
        return Object.keys($scope.searchMap).length;
      };
      $scope.checkIsShowPeople = function (people) {
        var isShow = false;
        if (!$scope.searchName) {
          isShow = true;
        } else {
          isShow = people.name.indexOf($scope.searchName) !== -1;
        }
        if (isShow) {
          $scope.searchMap[people.id] = isShow;
        } else {
          delete $scope.searchMap[people.id];
        }
        return isShow;
      };
      $scope.closeDialog = function () {
        $scope.$parent.isShowAiFaceGroupDialog = false;
      };
      $scope.checkedLength = function () {
        var count = 0;
        $scope.peopleList.forEach(function (people) {
          if (people.isChecked) {
            count += 1;
          }
        });
        return count ? count : '';
      };
      $scope.saveGroup = function () {
        if (!$scope.groupName) {
          $rootScope.createConfirm({
            title: $translate.instant('CAMERA_GROUP_ADD'),
            description: $translate.instant('9rRqk7Vo_02329'),
            btnCount: 1
          });
          return;
        }
        var personIds = [];
        $scope.peopleList.forEach(function (people) {
          if (people.isChecked) {
            personIds.push(people.id);
          }
        });
        AiFace.createGroup({
          userId: $scope.$parent.selectedAccount.userId
        }, {
          name: $scope.groupName,
          personIds: personIds
        }).$promise.then(function (res) {
          if (res.code === 'ok') {
            $rootScope.$broadcast('aifaceGroupAdd', res.groupId);
            $scope.closeDialog();
          } else {
            $rootScope.createConfirm({
              description: $translate.instant('9rRqk7Vo_02330'),
              btnCount: 1
            });
          }
        }, function (err) {
          $rootScope.createConfirm({
            title: $translate.instant("ACCESS_NET_FAIL"),
            description: $translate.instant("ACCESS_NET_FAIL_DESC"),
            btnCount: 1
          });
        });
      };
      $scope.fetchPeople = function (userId) {
        $scope.loadPeople = true;
        AiFace.persons({
          userId: userId
        }).$promise.then(function (res) {
          $scope.loadPeople = false;
          $scope.peopleList = res.persons ? res.persons : [];
        }, function (err) {
          $scope.loadPeople = false;
        });
      };
      $scope.$parent.$watch('isShowAiFaceGroupDialog', function (newValue, oldValue) {
        if (newValue !== oldValue) {
          if (newValue === true) {
            $('body').addClass('blockScroll');
            initDialog();
          } else {
            $('body').removeClass('blockScroll');
          }
        }
      });
    },
    templateUrl: '/templates/aiface/aiface_group_dialog.html' + '?t=' + window.buildTime
  };
});
"use strict";

app.directive("aiFacePeopleEventPlayDialog", function () {
  return {
    restrict: "E",
    scope: {},
    replace: true,
    transclude: true,
    controller: function controller($scope, $state, $timeout, $interval, $q, AiFace, Camera, Share, Utils) {
      var DURATION_SECONDS = 8;
      var EVT_FETCH_COUNT = 10;
      var EVENT_HEIGHT = 38;
      var EVENT_DAY_HEIGHT = 36;
      var throttleTime = 300;
      var fullScreenWidth = 0;
      var throttleFunc = null;
      var nextPageToken = "";
      var prevPageToken = "";
      var scrollTopCheckTimeout = null;
      $scope.EVT_FETCH_DIRECTION = {
        center: "center",
        next: "next",
        prev: "prev",
        none: "none"
      };
      function initDialog() {
        $scope.replaceShow = false;
        nextPageToken = "";
        prevPageToken = "";
        $scope.isPlayed = false;
        $scope.isShowAnimate = false;
        $scope.moreLoadingDirection = $scope.EVT_FETCH_DIRECTION.none;
        $scope.isShowFullscreenButton = true;
        $scope.events = [];
        $scope.eventInfo = $scope.$parent.eventInfo;
        $scope.isShared = $scope.$parent.isShared;
        $scope.person = $scope.$parent.person;
        $scope.player = tCam.htmlSimplePlayer({
          elId: "player_people",
          eventHandler: function eventHandler(event) {
            //if (event.type === 'error') {}
          }
        });
        setFullScreenEvent();
        updateDlgStyle();
        initVideoBar();
        $scope.eventPlay($scope.eventInfo);
        fetchEvents($scope.eventInfo.eventId, $scope.EVT_FETCH_DIRECTION.center);
      }
      $scope.listScrollTop = 0;
      $scope.replaceShow = false;
      $scope.isPlayed = false;
      $scope.isShowAnimate = false;
      $scope.moreLoadingDirection = $scope.EVT_FETCH_DIRECTION.none;
      $scope.isShowFullscreenButton = true;
      $scope.isShared = false;
      $scope.eventInfo = null;
      $scope.events = [];
      $scope.videoCursorPosition = 0;
      $scope.videoTimer = null;
      $scope.videoTime = 0;
      $scope.videoStartTime = 0;
      $scope.videoEndTime = 0;
      $scope.remainTime = 0;
      $scope.player = null;
      $scope.person = null;
      $scope.isShared = false;
      function updateDlgStyle() {
        var marginTopSize = 40;
        var headerSize = 63;
        var playerSize = 282;
        var marginBottom = 30;
        var windowHeight = $(window).height();
        var maxHeight = windowHeight - (marginTopSize + headerSize + playerSize + marginBottom);
        maxHeight = maxHeight < 180 ? 180 : maxHeight;
        $scope.evtsMaxHeight = maxHeight + "px";
      }
      function setEvtListScrollFn() {
        throttleFunc = new Utils.throttling().throttle(onScrollList, throttleTime);
        $("#ai_evt_area_people").on("scroll", throttleFunc);
      }
      function unsetEvtListScrollFn() {
        if (throttleFunc) {
          $("#ai_evt_area_people").off("scroll", throttleFunc);
          throttleFunc = null;
        }
      }
      function setLoadNexTimeout() {
        $timeout.cancel(scrollTopCheckTimeout);
        scrollTopCheckTimeout = $timeout(function () {
          if ($scope.listScrollTop === 0 && nextPageToken && $scope.moreLoadingDirection === $scope.EVT_FETCH_DIRECTION.none) {
            fetchEvents(nextPageToken, $scope.EVT_FETCH_DIRECTION.next);
          }
        }, 1000);
      }
      function getScrollFirstEvt(events, scrollTop) {
        var i,
          len = events.length,
          calcScrolltop = scrollTop;
        for (i = 0; i < len; i += 1) {
          calcScrolltop -= events[i].isDayFirst ? EVENT_HEIGHT + EVENT_DAY_HEIGHT : EVENT_HEIGHT;
          if (calcScrolltop <= 0) {
            return events[i];
          }
        }
        return null;
      }
      var tooltipTimeout = null;
      var currentYear = new Date().getFullYear();
      $scope.isShowDayTooltip = false;
      $scope.tooltipDay = 0;
      $scope.isSameYear = false;
      function showDayTooltip(date) {
        if (tooltipTimeout) {
          $timeout.cancel(tooltipTimeout);
        }
        $scope.tooltipDay = date;
        $scope.isSameYear = currentYear === new Date(date).getFullYear();
        $scope.isShowDayTooltip = true;
        $scope.$apply();
        tooltipTimeout = $timeout(function () {
          $scope.isShowDayTooltip = false;
        }, 1500);
      }
      var lastScrollDay = "";
      function onScrollList(evt) {
        var evtListEl = document.getElementById("ai_evt_area_people"),
          scrollTop = evtListEl.scrollTop,
          scrollHeight = evtListEl.scrollHeight,
          clientHeight = evtListEl.clientHeight;
        $scope.listScrollTop = scrollTop;
        var scFirstEvt = getScrollFirstEvt($scope.events, scrollTop);
        if (scFirstEvt) {
          var date = new Date(scFirstEvt.detectDate);
          var dateStr = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
          if (lastScrollDay !== dateStr) {
            lastScrollDay = dateStr;
            showDayTooltip(scFirstEvt.detectDate);
          }
        }
        if ($scope.events && $scope.events.length >= EVT_FETCH_COUNT) {
          var scrollPercent = $scope.listScrollTop / (scrollHeight - clientHeight) * 100;
          if ($scope.moreLoadingDirection === $scope.EVT_FETCH_DIRECTION.none) {
            if (scrollPercent < 20 && nextPageToken) {
              fetchEvents(nextPageToken, $scope.EVT_FETCH_DIRECTION.next);
            } else if (scrollPercent > 80 && prevPageToken) {
              fetchEvents(prevPageToken, $scope.EVT_FETCH_DIRECTION.prev);
            }
          }
        }
      }
      function startVideoTimer() {
        $interval.cancel($scope.videoTimer);
        $scope.videoTimer = $interval(function () {
          if (!$scope.player) {
            $interval.cancel($scope.videoTimer);
            $scope.videoTimer = null;
            return;
          }
          if ($scope.player.getIsPlaying()) {
            var barWidth = parseInt(d3.select("#videoBar_people").style("width"));
            var tempCurser = $scope.videoCursorPosition + barWidth / DURATION_SECONDS;
            $scope.videoTime = parseInt(moment(moment($scope.videoTime, "x").add(1, "seconds")).format("x"));
            var endTime = $scope.videoEndTime;
            $scope.remainTime = parseInt(moment(endTime).diff($scope.videoTime, "seconds"));
            if (tempCurser >= barWidth) {
              tempCurser = barWidth;
            }
            $scope.videoCursorPosition = tempCurser;
            if (tempCurser === barWidth) {
              $scope.remainTime = 0;
              $scope.player.pause();
              $scope.replaceShow = true;
              $interval.cancel($scope.videoTimer);
            }
          }
        }, 1000);
      }
      function initVideoBar() {
        var barWidth = parseInt(d3.select("#videoBar_people").style("width"));
        var videoDrag = d3.behavior.drag().on("drag", function (e) {
          var x = d3.mouse(this)[0]; // for cursur center
          $scope.videoCursorPosition = x;
        }).on("dragstart", function () {
          $interval.cancel($scope.videoTimer);
        }).on("dragend", function () {
          var x = d3.mouse(this)[0]; // for cursur center
          $scope.videoCursorPosition = x;
          barWidth = parseInt(d3.select("#videoBar_people").style("width"));
          var diffTime = Math.round(DURATION_SECONDS * ($scope.videoCursorPosition / barWidth));
          $scope.videoTime = parseInt(moment($scope.videoStartTime).add(diffTime, "seconds").format("x"));
          $scope.playRequest($scope.videoTime);
        });
        d3.select("#videoCursor_people").call(videoDrag);
        d3.select("#videoBar_people").on("click", function () {
          var x = d3.mouse(this)[0]; // for cursur center
          $scope.videoCursorPosition = x;
          barWidth = parseInt(d3.select("#videoBar_people").style("width"));
          var diffTime = Math.round(DURATION_SECONDS * ($scope.videoCursorPosition / barWidth));
          $scope.videoTime = parseInt(moment($scope.videoStartTime).add(diffTime, "seconds").format("x"));
          $scope.playRequest($scope.videoTime);
        });
      }
      function eventsDayFirstEvtCheck(events) {
        var dayMap = {};
        events.forEach(function (event) {
          var date = new Date(event.detectDate);
          var dateStr = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
          if (dayMap[dateStr]) {
            event.isDayFirst = false;
          } else {
            event.isDayFirst = true;
            dayMap[dateStr] = true;
          }
        });
      }
      function fetchEvents(pivotId, direction) {
        $scope.moreLoadingDirection = direction;
        AiFace.eventsPersonByPivot({
          personId: $scope.person.id,
          pivotId: pivotId,
          direction: direction,
          count: EVT_FETCH_COUNT
        }).$promise.then(function (res) {
          $scope.moreLoadingDirection = $scope.EVT_FETCH_DIRECTION.none;
          if (direction === $scope.EVT_FETCH_DIRECTION.center) {
            nextPageToken = res.nextPageToken;
            prevPageToken = res.prevPageToken;
            $scope.events = res.events;
            setTimeout(function () {
              var selectedEl = document.querySelector("#ai_evt_area_people li.selected");
              if (selectedEl) {
                selectedEl.scrollIntoView();
              }
              setTimeout(function () {
                setEvtListScrollFn();
              }, 500);
            }, 300);
          } else if (direction === $scope.EVT_FETCH_DIRECTION.next) {
            nextPageToken = res.nextPageToken;
            if (res.events) {
              $scope.events = res.events.concat($scope.events);
            }
            setLoadNexTimeout();
          } else if (direction === $scope.EVT_FETCH_DIRECTION.prev) {
            prevPageToken = res.prevPageToken;
            if (res.events) {
              $scope.events = $scope.events.concat(res.events);
            }
          }
          eventsDayFirstEvtCheck($scope.events);
        }, function (err) {
          $scope.moreLoadingDirection = $scope.EVT_FETCH_DIRECTION.none;
        });
      }
      $scope.videoPlay = function () {
        if ($scope.videoTime >= $scope.videoEndTime) {
          return;
        }
        if ($scope.player) {
          $scope.player.resume();
        }
        setTimeout(function () {
          startVideoTimer();
        }, 100);
        $scope.replaceShow = false;
        $scope.isPlayed = false;
        $scope.isShowAnimate = false;
      };
      $scope.videoStop = function () {
        if ($scope.videoTime >= $scope.videoEndTime) {
          return;
        }
        $scope.player.pause();
        $scope.isPlayed = true;
        $scope.isShowAnimate = true;
        $interval.cancel($scope.videoTimer);
      };
      $scope.eventPlay = function (evt) {
        $scope.eventInfo = evt;
        $scope.videoCursorPosition = 0;
        $scope.remainTime = DURATION_SECONDS;
        if ($scope.videoTimer) {
          $interval.cancel($scope.videoTimer);
          $scope.videoTimer = null;
        }
        $scope.videoTime = $scope.videoStartTime = $scope.eventInfo.detectDate - DURATION_SECONDS / 2 * 1000;
        $scope.videoEndTime = $scope.eventInfo.detectDate + DURATION_SECONDS / 2 * 1000;
        $scope.playRequest($scope.videoTime);
      };
      $scope.playRequest = function (time) {
        if (!$scope.eventInfo) {
          return;
        }
        $scope.replaceShow = false;
        var cameraId = $scope.eventInfo.deviceId;
        var tokenPromise = $scope.isShared ? Share.getToken({
          id: cameraId
        }).$promise : Camera.getToken({
          id: cameraId
        }).$promise;
        var camPromise = $scope.isShared ? Share.get({
          id: cameraId
        }).$promise : Camera.get({
          id: cameraId
        }).$promise;
        $q.all([tokenPromise, camPromise]).then(function (res) {
          var tokenRes = res[0];
          var camRes = res[1];
          $scope.player.play(camRes.mediaStreamURL + "?token=" + tokenRes.token + "&time=" + time);
          startVideoTimer();
        }, function (err) {});
      };
      $scope.goCamDetail = function () {
        if (!$scope.eventInfo) {
          return;
        }
        $scope.closeDialog();
        $state.go("main.cameraDetail", {
          cameraId: $scope.eventInfo.deviceId,
          type: $scope.isShared ? "sharedshop" : "shop",
          id: $scope.eventInfo.shopId,
          time: $scope.videoStartTime,
          shared: $scope.isShared
        });
      };
      $scope.clipsReplay = function () {
        $scope.videoTime = $scope.videoStartTime;
        $scope.videoCursorPosition = 0;
        $scope.replaceShow = false;
        $scope.playRequest($scope.videoTime);
      };
      function updatePlayCursorFullEnter() {
        fullScreenWidth = parseInt(d3.select("#videoBar_people").style("width"));
        var tempPosition = $scope.videoCursorPosition * (fullScreenWidth / 500);
        if (fullScreenWidth < tempPosition) {
          $scope.videoCursorPosition = fullScreenWidth;
        } else if (tempPosition < 0) {
          $scope.videoCursorPosition = 0;
        } else {
          $scope.videoCursorPosition = tempPosition;
        }
      }
      function updatePlayCursorFullExit() {
        var barWidth = parseInt(d3.select("#videoBar_people").style("width"));
        var tempPosition = $scope.videoCursorPosition * (barWidth / fullScreenWidth);
        if (barWidth < tempPosition) {
          $scope.videoCursorPosition = barWidth;
        } else if (tempPosition < 0) {
          $scope.videoCursorPosition = 0;
        } else {
          $scope.videoCursorPosition = tempPosition;
        }
      }
      $scope.pressedFullScreenButton = function () {
        var element = document.getElementById("fullscreen_people");
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.webkitRequestFullscreen) {
          element.webkitRequestFullscreen();
        } else if (element.msRequestFullscreen) {
          element.msRequestFullscreen();
        }
        $scope.isShowFullscreenButton = false;
      };
      $scope.pressedExitFullScreenButton = function () {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
        $scope.isShowFullscreenButton = true;
      };
      $scope.formattedDetailDate = function (time) {
        return moment(new Date(time)).format("YYYY.MM.DD");
      };
      $scope.formattedDetailTime = function (time) {
        return moment(new Date(time)).format("HH:mm:ss");
      };
      $scope.timeCalcul = function (timeSec) {
        var absTimeSec = Math.abs(timeSec),
          min = Math.floor(absTimeSec / 60),
          sec = Math.floor(absTimeSec % 60);
        return min + ":" + (sec < 10 ? "0" : "") + (absTimeSec < 0 ? 1 : sec);
      };
      function fullscreenHandler() {
        var isFullScreen = !!(document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement);
        $scope.isShowFullscreenButton = !isFullScreen;
        setTimeout(function () {
          if (isFullScreen) {
            updatePlayCursorFullEnter();
          } else {
            updatePlayCursorFullExit();
          }
        }, 100);
        $scope.$apply();
      }
      function setFullScreenEvent() {
        document.addEventListener("webkitfullscreenchange", fullscreenHandler, false);
        document.addEventListener("mozfullscreenchange", fullscreenHandler, false);
        document.addEventListener("fullscreenchange", fullscreenHandler, false);
        document.addEventListener("MSFullscreenChange", fullscreenHandler, false);
      }
      function unsetFullScreenEvent() {
        document.removeEventListener("webkitfullscreenchange", fullscreenHandler, false);
        document.removeEventListener("mozfullscreenchange", fullscreenHandler, false);
        document.removeEventListener("fullscreenchange", fullscreenHandler, false);
        document.removeEventListener("MSFullscreenChange", fullscreenHandler, false);
      }
      $scope.closeDialog = function () {
        if ($scope.player) {
          $scope.player.destroy();
          $scope.player = null;
        }
        $scope.$parent.isShowAiFacePeopleEventPlayDialog = false;
        unsetEvtListScrollFn();
        unsetFullScreenEvent();
        $timeout.cancel(scrollTopCheckTimeout);
        $timeout.cancel(tooltipTimeout);
        if ($scope.videoTimer) {
          $interval.cancel($scope.videoTimer);
          $scope.videoTimer = null;
        }
      };
      $scope.$parent.$watch("isShowAiFacePeopleEventPlayDialog", function (newValue, oldValue) {
        if (newValue !== oldValue) {
          if (newValue === true) {
            document.body.classList.add("blockScroll");
            initDialog();
          } else {
            $("body").removeClass("blockScroll");
          }
        }
      });
    },
    templateUrl: "/templates/aiface/aiface_people_eventplay_dialog.html" + "?t=" + window.buildTime
  };
});
"use strict";

app.directive('aiFaceRegistDialog', function () {
  return {
    restrict: 'E',
    scope: {},
    replace: true,
    transclude: true,
    controller: function controller($scope, $rootScope, $translate, $state, $timeout, $interval, AiFace) {
      $scope.DIALOG_STATE = {
        EDIT: 'edit',
        REGISTING: 'registing',
        RESULT: 'result',
        NONE: 'none'
      };
      $scope.configStatus = $scope.DIALOG_STATE.EDIT;
      $scope.regName = '';
      $scope.selectFaces = [];
      $scope.groups = [];
      $scope.selectGroupId = '';
      $scope.selectedGroup = null;
      $scope.isShowGrpList = false;
      $scope.registPerson = null;
      function stringFormat(input) {
        if (arguments.length > 1) {
          var str = input,
            i,
            len,
            reg;
          for (i = 1, len = arguments.length; i < len; i += 1) {
            reg = new RegExp("\\{" + (i - 1) + "\\}");
            str = str.replace(reg, arguments[i]);
          }
          return str;
        }
        return input;
      }
      function initDialog() {
        var i, len;
        $('body').addClass('blockScroll');
        $scope.changeDialogState($scope.DIALOG_STATE.EDIT);
        $scope.groups = $scope.$parent.groups.concat($scope.$parent.sysGroups);
        for (i = 0, len = $scope.groups.length; i < len; i += 1) {
          // remove no member group
          if (!$scope.groups[i].id) {
            $scope.groups.splice(i, 1);
            break;
          }
        }
        $scope.regName = '';
        $scope.selectFaces = [];
        $scope.selectGroupId = '';
        $scope.selectedGroup = null;
        $scope.isShowGrpList = false;
        $scope.selectFaces = $scope.$parent.poolSelectList;
      }
      $scope.closeGrps = function (event) {
        if (event.target.className.indexOf('grps_ar') !== -1) {
          return;
        }
        if ($scope.isShowGrpList) {
          $scope.isShowGrpList = false;
        }
      };
      $scope.changeDialogState = function (state) {
        if ($scope.configStatus === state) {
          return;
        }
        $scope.configStatus = state;
        if (state === $scope.DIALOG_STATE.EDIT) {
          //
        } else if (state === $scope.DIALOG_STATE.REGISTING) {
          //
        } else if (state === $scope.DIALOG_STATE.RESULT) {} else {
          // NONE
          $('body').removeClass('blockScroll');
          if ($scope.$parent.isShowAiFaceRegistDialog) {
            $scope.$parent.isShowAiFaceRegistDialog = false;
          }
        }
      };
      $scope.selectGroup = function (groupId) {
        $scope.groups.some(function (group) {
          if (group.id === groupId) {
            $scope.selectedGroup = group;
          }
        });
      };
      $scope.finishRegist = function (isSkip) {
        if (!$scope.selectedGroup || isSkip) {
          $scope.$parent.setPoolMode($scope.$parent.POOL_SHOW_MODE.NORMAL);
          $scope.changeDialogState($scope.DIALOG_STATE.NONE);
          return;
        }
        AiFace.updateGroup({
          userId: $scope.$parent.selectedAccount.userId,
          groupId: $scope.selectedGroup.id
        }, {
          addIds: [$scope.registPerson.id]
        }).$promise.then(function (res) {
          if (res.code === 'ok') {
            $scope.$parent.setPoolMode($scope.$parent.POOL_SHOW_MODE.NORMAL);
            $scope.changeDialogState($scope.DIALOG_STATE.NONE);
            $scope.$broadcast('aifaceGroupUpdate');
          } else {
            $rootScope.createConfirm({
              description: $translate.instant('9rRqk7Vo_02331'),
              btnCount: 1
            });
          }
        }, function (err) {
          $rootScope.createConfirm({
            title: $translate.instant("ACCESS_NET_FAIL"),
            description: $translate.instant("ACCESS_NET_FAIL_DESC"),
            btnCount: 1
          });
        });
      };
      $scope.registPeople = function () {
        if (!$scope.regName) {
          return;
        }
        $scope.changeDialogState($scope.DIALOG_STATE.REGISTING);
        var faceIds = [];
        $scope.selectFaces.forEach(function (item) {
          faceIds.push(item.id);
        });
        AiFace.createPeople({
          userId: $scope.$parent.selectedAccount.userId
        }, {
          name: $scope.regName,
          faceIds: faceIds,
          masterFaceId: faceIds[0]
        }).$promise.then(function (res) {
          if (res.code === 'ok') {
            $scope.selectFaces.forEach(function (item) {
              item.registed = true;
            });
            $scope.registPerson = res.person;
            $scope.registPerson.faces.some(function (face) {
              if ($scope.registPerson.masterFaceId === face.id) {
                $scope.registPerson.imageUrl = face.imageUrl;
              }
              return $scope.registPerson.masterFaceId === face.id;
            });
            $scope.changeDialogState($scope.DIALOG_STATE.RESULT);
            $rootScope.$broadcast('aifacePeopleUpdate', null);
          } else {
            $rootScope.createConfirm({
              title: $translate.instant('9rRqk7Vo_02332'),
              description: $translate.instant('ERROR_HAPPEN'),
              btnCount: 1
            });
            $scope.changeDialogState($scope.DIALOG_STATE.EDIT);
          }
        }, function (err) {
          $rootScope.createConfirm({
            title: $translate.instant("9rRqk7Vo_02332"),
            description: $translate.instant("ERROR_HAPPEN"),
            btnCount: 1
          });
        });
      };
      $scope.$parent.$watch('isShowAiFaceRegistDialog', function (newValue, oldValue) {
        if (newValue !== oldValue) {
          if (newValue === true) {
            initDialog();
          } else {
            $scope.changeDialogState($scope.DIALOG_STATE.NONE);
          }
        }
      });
    },
    templateUrl: '/templates/aiface/aiface_regist_dialog.html' + '?t=' + window.buildTime
  };
});
"use strict";

app.directive('aiFaceServiceRegDialog', function () {
  return {
    restrict: 'E',
    scope: {},
    replace: true,
    transclude: true,
    controller: function controller($scope, $rootScope, $translate, $state, $timeout, $interval, AiFace, User) {
      $scope.DIALOG_STATE = {
        NORMAL: 'normal',
        REGISTING: 'registing',
        RESULT_OK: 'result_ok',
        RESULT_ERR: 'result_err',
        NONE: 'none'
      };
      $scope.configStatus = $scope.DIALOG_STATE.NORMAL;
      $scope.errMsg = '';
      $scope.isRegisted = false;
      function initDialog() {
        $('body').addClass('blockScroll');
        $scope.errMsg = '';
        $scope.isRegisted = false;
        $scope.changeDialogState($scope.DIALOG_STATE.NORMAL);
      }
      $scope.reloadPage = function () {
        if ($state.$current.name.indexOf('main.aiface') !== -1) {
          location.reload();
        } else {
          $scope.changeDialogState($scope.DIALOG_STATE.NONE);
          User.me(function (data) {
            if (data.code === "ok") {
              $rootScope.me = data;
              $state.go('main.aiface.content', {}, {
                reload: true,
                inherit: true,
                notify: true
              });
            }
          }, function (err) {
            $state.go('main.aiface.content', {}, {
              reload: true,
              inherit: true,
              notify: true
            });
          });
        }
      };
      $scope.changeDialogState = function (state) {
        if ($scope.configStatus === state) {
          return;
        }
        $scope.configStatus = state;
        if (state === $scope.DIALOG_STATE.NONE) {
          // NONE
          $('body').removeClass('blockScroll');
          $scope.$parent.$broadcast('hideAiServRegDlg', $scope.isRegisted);
          if ($scope.$parent.isShowAiFaceServiceRegDialog) {
            $scope.$parent.isShowAiFaceServiceRegDialog = false;
          }
        }
      };
      $scope.enableService = function () {
        $scope.changeDialogState($scope.DIALOG_STATE.REGISTING);
        AiFace.enableService({
          userId: $scope.$parent.selectedAccount.userId
        }, {}).$promise.then(function (res) {
          if (res.code === 'ok') {
            $scope.isRegisted = true;
            $scope.changeDialogState($scope.DIALOG_STATE.RESULT_OK);
          } else {
            $scope.errMsg = res.msg ? res.msg : '';
            $scope.changeDialogState($scope.DIALOG_STATE.RESULT_ERR);
          }
        }, function (err) {
          $scope.errMsg = $translate.instant('ACCESS_NET_FAIL_DESC');
          $scope.changeDialogState($scope.DIALOG_STATE.RESULT_ERR);
        });
      };
      $scope.$parent.$watch('isShowAiFaceServiceRegDialog', function (newValue, oldValue) {
        if (newValue !== oldValue) {
          if (newValue === true) {
            initDialog();
          } else {}
        }
      });
    },
    templateUrl: '/templates/aiface/aiface_service_reg_dialog.html' + '?t=' + window.buildTime
  };
});
"use strict";

app.directive("aiFaceSetDialog", function () {
  return {
    restrict: "E",
    scope: {},
    replace: true,
    transclude: true,
    controller: function controller($scope, $rootScope, $translate, $state, AiFace, Utils) {
      $scope.DIALOG_STATE = {
        BASIC: "basic",
        NONE: "none"
      };
      $scope.configStatus = $scope.DIALOG_STATE.BASIC;
      $scope.percent = 0;
      var percentDegree = 0;
      var usageColor = "#4a96e6";
      $scope.selectedTab = "info";
      $scope.countryDomain = $("html").attr("lang");
      $scope.shareName = "";
      $scope.shareAccount = "";
      $scope.productInfo = null;
      $scope.sharedAccounts = [];
      $scope.remainDate = 0;
      $scope.aiCamCountInfo = {
        people: 0,
        face: 0,
        none: 0
      };
      $scope.aiCameras = [];
      $scope.showZoneInfo = false;
      function updateUsagePercent(percent) {
        var maxDegree = 180;
        if (percent >= 60 && percent < 80) {
          usageColor = "#ffa723";
        } else if (percent >= 80) {
          usageColor = "#fa4332";
        } else {
          usageColor = "#4a96e6";
        }
        $scope.percent = percent;
        percentDegree = maxDegree * percent / 100;
      }
      $scope.goZoneSetting = function (cameraId) {
        $state.go("main.aifaceZoneSet", {
          cameraId: cameraId
        });
      };
      $scope.selectTab = function (tab) {
        $scope.selectedTab = tab;
      };
      $scope.shareAiFace = function (name, account) {
        if (!name) {
          $rootScope.createConfirm({
            description: $translate.instant("ACCESS_ENTER_NAME"),
            btnCount: 1
          });
          return;
        }
        if (!account) {
          $rootScope.createConfirm({
            description: $translate.instant("9rRqk7Vo_02334"),
            btnCount: 1
          });
          return;
        }
        var validPhone = Utils.phoneNumberVaild(Utils.toFormattedPhoneNumber(account));
        var validEmail = Utils.emailValid(Utils.toFormattedPhoneNumber(account));
        if (!validPhone && !validEmail) {
          $rootScope.createConfirm({
            description: $translate.instant($scope.countryDomain === "ja" ? "CORRECT_EMAIL" : "ACCESS_ENTER_NUMBER"),
            btnCount: 1
          });
          return;
        }
        AiFace.updateSharedAccount({}, {
          name: name,
          account: account
        }).$promise.then(function (res) {
          if (res.code === "ok") {
            $scope.shareAccount = "";
            $scope.shareName = "";
            fetchSharedAccount();
          } else {
            $rootScope.createConfirm({
              description: res.msg ? res.msg : $translate.instant("ACCESS_FAIL"),
              btnCount: 1
            });
          }
        }, function (err) {
          $rootScope.createConfirm({
            title: $translate.instant("ACCESS_NET_FAIL"),
            description: $translate.instant("ACCESS_NET_FAIL_DESC"),
            btnCount: 1
          });
        });
      };
      $scope.getPercentDegreeStyle = function (isWrap) {
        return {
          transform: "rotate(" + percentDegree + "deg)",
          backgroundColor: isWrap ? "" : usageColor
        };
      };
      function fixedEncodeURIComponent(str) {
        return encodeURIComponent(str).replace(/[!’().*]/g, function (c) {
          return "%" + c.charCodeAt(0).toString(16);
        });
      }
      $scope.showShareRemoveConfirm = function (deleteId) {
        $rootScope.createConfirm({
          title: $translate.instant("SHARE_RELEASE"),
          description: $translate.instant("SHARE_REMOVE_MSG1") + " " + $translate.instant("SHARE_REMOVE_MSG2"),
          handler: function handler() {
            AiFace.deleteSharedAccount({
              deleteId: fixedEncodeURIComponent(deleteId)
            }).$promise.then(function (res) {
              if (res.code === "ok") {
                fetchSharedAccount();
              } else {
                $rootScope.createConfirm({
                  description: $translate.instant("SHARE_RELEASE_FAIL"),
                  btnCount: 1
                });
              }
            }, function (err) {
              $rootScope.createConfirm({
                title: $translate.instant("ACCESS_NET_FAIL"),
                description: $translate.instant("ACCESS_NET_FAIL_DESC"),
                btnCount: 1
              });
            });
          }
        });
      };
      $scope.showAiServRegDlg = function () {
        $scope.$parent.$broadcast("showAiServRegDlg");
      };
      $scope.showAiCamModeSetDlg = function () {
        $scope.$parent.$broadcast("showAiCamModeSetDlg");
      };
      $scope.showAiInquiryConfirm = function () {
        $rootScope.createConfirm({
          description: $translate.instant("9rRqk7Vo_02323") + "<br>" + $translate.instant("9rRqk7Vo_02324"),
          btnCount: 1,
          handler: function handler() {
            $scope.inquiry();
          }
        });
      };
      $scope.inquiry = function () {
        $state.go("main.help.inquiry");
      };
      function updateDlgStyle() {
        var marginTopSize = 100;
        var windowHeight = $(window).height();
        var dlgMaxHeight = windowHeight - marginTopSize > 600 ? 600 : windowHeight - marginTopSize;
        $scope.dlgMaxHeight = dlgMaxHeight + "px";
      }
      function getAiCameraCount(cameras) {
        var countInfo = {
          people: 0,
          face: 0,
          none: 0
        };
        cameras.forEach(function (item) {
          if (item.camera.isAiSupport) {
            if (item.camera.aiType === 3) {
              countInfo.people += 1;
              countInfo.face += 1;
            } else if (item.camera.aiType === 2) {
              countInfo.face += 1;
            } else if (item.camera.aiType === 1) {
              countInfo.people += 1;
            } else {
              countInfo.none += 1;
            }
          }
        });
        return countInfo;
      }
      function getRemainDate(expirationDate) {
        var today = new Date();
        var remainTimestamp = expirationDate - today;
        return parseInt(remainTimestamp / (1000 * 60 * 60 * 24)) + 1;
      }
      function fetchProductInfo() {
        AiFace.setting({
          snippet: "product"
        }, function (data) {
          $scope.productInfo = data.product;
          $scope.remainDate = getRemainDate($scope.productInfo.expirationDate);
        }, function (err) {});
      }
      function fetchSharedAccount() {
        AiFace.setting({
          snippet: "accounts"
        }, function (data) {
          $scope.sharedAccounts = data.accounts ? data.accounts : [];
        }, function (err) {
          $rootScope.createConfirm({
            title: $translate.instant("ACCESS_NET_FAIL"),
            description: $translate.instant("ACCESS_NET_FAIL_DESC"),
            btnCount: 1
          });
        });
      }
      function fetchSettings() {
        $scope.isLoadCams = true;
        AiFace.setting({
          snippet: "product,accounts,cameraCount,cameraDetectArea"
        }, function (data) {
          if (data.code === "ok") {
            $scope.sharedAccounts = data.accounts ? data.accounts : [];
            $scope.aiCamCountInfo = {
              people: data.cameraCount.peoplecount,
              face: data.cameraCount.facedetect,
              none: data.cameraCount.none
            };
            $scope.aiCameras = data.cameraDetectArea ? data.cameraDetectArea : [];
            $scope.productInfo = data.product;
            $scope.remainDate = getRemainDate($scope.productInfo.expirationDate);
          }
        }, function (err) {
          $scope.isLoadCams = false;
          $rootScope.createConfirm({
            title: $translate.instant("ACCESS_NET_FAIL"),
            description: $translate.instant("ACCESS_NET_FAIL_DESC"),
            btnCount: 1
          });
        });
      }
      function initDialog() {
        $scope.selectedTab = "info";
        $scope.showZoneInfo = false;
        $scope.shareName = "";
        $scope.shareAccount = "";
        $scope.productInfo = null;
        $scope.sharedAccounts = [];
        $scope.remainDate = 0;
        $scope.aiCamCountInfo = {
          people: 0,
          face: 0,
          none: 0
        };
        document.body.classList.add("blockScroll");
        $("body").on("click", globalClickCallback);
        // fetchProductInfo();
        // fetchSharedAccount();
        // fetchCameras();
        fetchSettings();
        $scope.changeDialogState($scope.DIALOG_STATE.BASIC);
        updateDlgStyle();
      }
      function globalClickCallback(event) {
        if (!$scope.showZoneInfo) {
          return;
        }
        if (event.target.className.indexOf("zone_set_desc_img") === -1) {
          $scope.showZoneInfo = false;
          $scope.$apply();
        }
      }
      $scope.changeDialogState = function (state) {
        if ($scope.configStatus === state) {
          return;
        }
        $scope.configStatus = state;
        if (state === $scope.DIALOG_STATE.BASIC) {
          //
        } else {
          // NONE
          $("body").removeClass("blockScroll");
          $("body").off("click", globalClickCallback);
          if ($scope.$parent.isShowAiFaceSetDialog) {
            $scope.$parent.isShowAiFaceSetDialog = false;
          }
        }
      };
      $scope.$parent.$watch("isShowAiFaceSetDialog", function (newValue, oldValue) {
        if (newValue !== oldValue) {
          if (newValue === true) {
            initDialog();
          } else {
            $scope.changeDialogState($scope.DIALOG_STATE.NONE);
          }
        }
      });
    },
    templateUrl: "/templates/aiface/aiface_set_dialog.html" + "?t=" + window.buildTime
  };
});
"use strict";

app.directive('aiFaceSetPeopleDialog', function () {
  return {
    restrict: 'E',
    scope: {},
    replace: true,
    transclude: true,
    controller: function controller($scope, $rootScope, $translate, $state, $timeout, $interval, AiFace) {
      function initDialog() {
        updateDlgStyle();
        savingName = false;
        $scope.editName = '';
        $scope.isEditName = false;
        $scope.selectedRegistFace = null;
        //$scope.isPersonEditMode = $scope.$parent.isPersonEditMode;
        $scope.masterImageUrl = '';
        $scope.isLoadPerson = false;
        $scope.isLoadEvents = false;
        $scope.person = null;
        $scope.isEditMode = false;
        $scope.events = [];
        $scope.selectedFaces = [];
        $scope.selectedTab = 'event';
        fetchPerson($scope.$parent.selectPersonId);
        $scope.selectDate = $scope.$parent.selectDate ? new Date($scope.$parent.selectDate.valueOf()) : new Date();
        $scope.todayDate = new Date();
        checkIsCurrentDate();
        createDatePicker();
        fetchEvents($scope.selectDate, $scope.$parent.selectPersonId);
      }
      function createDatePicker() {
        $scope.datePicker = new Pikaday({
          field: document.getElementById('accessDate'),
          bound: false,
          container: document.getElementById('datePickerContainer'),
          //minDate: $scope.installDate,
          maxDate: new Date(),
          defaultDate: new Date(),
          onSelect: function onSelect(date) {
            $scope.selectDate = date;
            checkIsCurrentDate();
            fetchEvents($scope.selectDate, $scope.$parent.selectPersonId);
            this.hide();
          }
        });
        $scope.datePicker.hide();
      }
      function fetchEvents(date, personId) {
        if (!date || !personId) {
          return;
        }
        var startDate = new Date(date.valueOf());
        var endDate = new Date(date.valueOf());
        startDate.setHours(0);
        startDate.setMinutes(0);
        startDate.setSeconds(0);
        endDate.setHours(23);
        endDate.setMinutes(59);
        endDate.setSeconds(59);
        $scope.isLoadEvents = true;
        AiFace.eventsPersonByRange({
          personId: personId,
          startDate: startDate.valueOf(),
          endDate: endDate.valueOf()
        }, function (res) {
          $scope.events = res.events ? res.events : [];
          $scope.isLoadEvents = false;
        }, function (err) {
          $scope.events = [];
          $scope.isLoadEvents = false;
        });
      }
      function checkIsCurrentDate() {
        if (!$scope.selectDate) {
          $scope.isCurrentDate = false;
          return;
        }
        if ($scope.selectDate.getFullYear() === $scope.todayDate.getFullYear() && $scope.selectDate.getMonth() === $scope.todayDate.getMonth() && $scope.selectDate.getDate() === $scope.todayDate.getDate()) {
          $scope.isCurrentDate = true;
        } else {
          $scope.isCurrentDate = false;
        }
      }
      function editKeyupHandler(event) {
        if (event.keyCode === 13) {
          $scope.saveName();
        } else if (event.keyCode === 27) {
          $('#name_editor').off('keyup', editKeyupHandler);
          $scope.isEditName = false;
          $scope.$apply();
        } else {
          $('#name_editor_dummy').text($(this).val() + 'aa');
          $(this).width($('#name_editor_dummy').width());
        }
      }
      function editNameSaveClickFn(event) {
        if (!$scope.isEditName) {
          return;
        }
        if (event.target.id.indexOf('name_editor') === -1) {
          $scope.saveName();
        }
      }
      function updateDlgStyle() {
        var maxContHeight = 574;
        var marginTopSize = 100;
        var headHeight = 50;
        var marginBottom = 50;
        var windowHeight = $(window).height();
        var contHeight = windowHeight - (marginTopSize + headHeight + marginBottom);
        contHeight = contHeight > maxContHeight ? maxContHeight : contHeight;
        $scope.dlgContHeight = contHeight + 'px';
      }
      function fetchPerson(id) {
        $scope.isLoadPerson = true;
        AiFace.personDetail({
          userId: $scope.$parent.selectedAccount.userId,
          personId: id
        }).$promise.then(function (res) {
          $scope.isLoadPerson = false;
          if (res.code === 'ok') {
            $scope.person = res.code === 'ok' ? res.person : null;
            $scope.isPersonEditMode = res.person.hasConfigPermission;
            if ($scope.isPersonEditMode) {
              $('body').on('click', editNameSaveClickFn);
            }
            $scope.masterImageUrl = getMasterFaceImage($scope.person.masterFaceId, $scope.person.faces);
          } else {
            if (res.errorCode === "33003") {
              $rootScope.createConfirm({
                description: $translate.instant('9rRqk7Vo_02397'),
                btnCount: 1
              });
            } else {
              $rootScope.createConfirm({
                description: $translate.instant('9rRqk7Vo_02398'),
                btnCount: 1
              });
            }
            $scope.closeDialog();
          }
        }, function (err) {
          $scope.isLoadPerson = false;
          $rootScope.createConfirm({
            description: $translate.instant('9rRqk7Vo_02398'),
            btnCount: 1
          });
          $scope.closeDialog();
        });
      }
      function getMasterFaceImage(masterId, faces) {
        if (!masterId || !faces || !faces.length) {
          return '';
        }
        var i,
          len = faces.length;
        for (i = 0; i < len; i += 1) {
          if (faces[i].id === masterId) {
            return faces[i].imageUrl;
          }
        }
        return '';
      }
      $scope.editName = '';
      $scope.isEditName = false;
      $scope.selectFaceXY = {
        x: 0,
        y: 0
      };
      $scope.selectedRegistFace = null;
      $scope.isPersonEditMode = false;
      $scope.dlgContHeight = 0;
      $scope.masterImageUrl = '';
      $scope.isLoadPerson = false;
      $scope.isLoadEvents = false;
      $scope.person = null;
      $scope.isEditMode = false;
      $scope.selectedFaces = [];
      $scope.selectedTab = 'event';
      $scope.datePicker = null;
      $scope.selectDate = null;
      $scope.todayDate = null;
      $scope.isCurrentDate = false;
      $scope.events = [];
      var savingName = false;
      $scope.selectTab = function (mode) {
        $scope.selectedTab = mode;
      };
      $scope.setNameEditMode = function (event) {
        $scope.isEditName = true;
        $scope.editName = $scope.person.name;
        $('#name_editor').on('keyup', editKeyupHandler);
        $('#name_editor').hide();
        setTimeout(function () {
          $('#name_editor_dummy').text($('#name_editor').val() + 'aa');
          $('#name_editor').width($('#name_editor_dummy').width());
          $('#name_editor').show();
          $('#name_editor').focus();
        }, 0);
        event.preventDefault();
        event.stopPropagation();
      };
      $scope.saveName = function () {
        $('#name_editor').off('keyup', editKeyupHandler);
        if (!$scope.editName || $scope.editName === $scope.person.name) {
          $scope.isEditName = false;
          $scope.$apply();
          return;
        }
        if (savingName) {
          return;
        }
        savingName = true;
        AiFace.updatePeople({
          userId: $scope.$parent.selectedAccount.userId
        }, {
          personId: $scope.person.id,
          name: $scope.editName
        }).$promise.then(function (res) {
          if (res.code === 'ok') {
            $scope.person.name = $scope.editName;
            $rootScope.$broadcast('aifacePeopleUpdate', null);
          }
          savingName = false;
          $scope.isEditName = false;
        }, function (err) {
          savingName = false;
          $scope.isEditName = false;
        });
      };
      $scope.clickEvent = function (eventInfo) {
        $rootScope.$broadcast('showPeopleEvtPlayerDlg', {
          eventInfo: eventInfo,
          person: $scope.person
        });
      };
      $scope.selectMasterFace = function (face) {
        AiFace.updatePeople({
          userId: $scope.$parent.selectedAccount.userId
        }, {
          personId: $scope.person.id,
          masterFaceId: face.id
        }).$promise.then(function (res) {
          if (res.code === 'ok') {
            $scope.selectedRegistFace = null;
            $scope.person.masterFaceId = face.id;
            $scope.masterImageUrl = getMasterFaceImage($scope.person.masterFaceId, $scope.person.faces);
            $rootScope.$broadcast('aifacePeopleUpdate', null);
          }
        }, function (err) {});
      };
      $scope.selectRegistedFace = function (face) {
        if (!$scope.isPersonEditMode || $scope.person.masterFaceId === face.id) {
          return;
        }
        if ($scope.isEditMode) {
          face.isChecked = !face.isChecked;
          $scope.selectedFaces = $scope.person.faces.filter(function (face) {
            return face.isChecked;
          });
        } else {
          if ($scope.selectedRegistFace && $scope.selectedRegistFace.id === face.id) {
            $scope.selectedRegistFace = null;
          } else {
            $scope.selectedRegistFace = face;
          }
        }
      };
      $scope.closeDialog = function () {
        $scope.$parent.isShowAiFaceSetPeopleDialog = false;
      };
      $scope.startEdit = function () {
        $scope.selectedRegistFace = null;
        $scope.selectedFaces = [];
        $scope.isEditMode = true;
      };
      $scope.cancelEdit = function () {
        if ($scope.person && $scope.person.faces) {
          $scope.person.faces.forEach(function (face) {
            face.isChecked = false;
          });
        }
        $scope.isEditMode = false;
      };
      $scope.requestDeleteSelected = function () {
        $rootScope.createConfirm({
          description: $translate.instant('9rRqk7Vo_02320'),
          handler: function handler() {
            var selectIds = [];
            $scope.person.faces.forEach(function (face) {
              if (face.isChecked) {
                selectIds.push(face.id);
              }
            });
            if (!selectIds.length) {
              $scope.isEditMode = false;
              return;
            }
            $scope.deleteFaces(selectIds);
          }
        });
      };
      $scope.showDeleteFaceConfirm = function (ids) {
        $rootScope.createConfirm({
          description: $translate.instant('9rRqk7Vo_02320'),
          handler: function handler() {
            $scope.deleteFaces(ids);
          }
        });
      };
      $scope.deleteFaces = function (ids) {
        AiFace.updatePeople({
          userId: $scope.$parent.selectedAccount.userId
        }, {
          personId: $scope.person.id,
          deleteIds: ids
        }).$promise.then(function (res) {
          if (res.code === 'ok') {
            $scope.selectedRegistFace = null;
            $scope.isEditMode = false;
            fetchPerson($scope.$parent.selectPersonId);
          }
        }, function (err) {});
      };
      $scope.deletePeople = function () {
        AiFace.deletePeople({
          userId: $scope.$parent.selectedAccount.userId,
          personIds: [$scope.person.id]
        }).$promise.then(function (res) {
          if (res.code === 'ok') {
            $rootScope.$broadcast('aifacePeopleUpdate', null);
            $rootScope.$broadcast('fetchPools');
            $scope.closeDialog();
          }
        }, function (err) {});
      };
      $scope.showPeopleDeleteConfirm = function () {
        $rootScope.createConfirm({
          title: $translate.instant('9rRqk7Vo_02335'),
          description: $translate.instant('9rRqk7Vo_02336'),
          handler: function handler() {
            $scope.deletePeople();
          }
        });
      };
      $scope.clickToday = function () {
        $scope.selectDate = new Date();
        checkIsCurrentDate();
        fetchEvents($scope.selectDate, $scope.$parent.selectPersonId);
      };
      $scope.moveDate = function (isPrev) {
        if (!$scope.selectDate) {
          return;
        }
        $scope.selectDate.setDate($scope.selectDate.getDate() + (isPrev ? -1 : 1));
        if ($scope.todayDate.getDate() !== $scope.selectDate.getDate() && $scope.todayDate.getTime() + 1000 < $scope.selectDate.getTime()) {
          $scope.selectDate.setDate($scope.selectDate.getDate() - 1);
          return;
        }
        // if ($scope.installDate) {
        //     if (($scope.installDate.getDate() !== $scope.selectDate.getDate()) && ($scope.installDate.getTime() > $scope.selectDate.getTime())) {
        //         $scope.selectDate.setDate($scope.selectDate.getDate() + 1);
        //         return;
        //     }
        // }
        checkIsCurrentDate();
        fetchEvents($scope.selectDate, $scope.$parent.selectPersonId);
      };
      $scope.toggleDatePicker = function () {
        if ($scope.datePicker.isVisible()) {
          $scope.datePicker.hide();
        } else {
          //$scope.datePicker._d = $scope.selectDate;
          $scope.datePicker.show();
        }
      };
      $scope.$parent.$watch('isShowAiFaceSetPeopleDialog', function (newValue, oldValue) {
        if (newValue !== oldValue) {
          if (newValue === true) {
            $('body').addClass('blockScroll');
            initDialog();
          } else {
            $('body').removeClass('blockScroll');
            $('body').off('click', editNameSaveClickFn);
            $('#name_editor').off('keyup', editKeyupHandler);
            if ($scope.datePicker) {
              $scope.datePicker.destroy();
              $scope.datePicker = null;
            }
            $scope.closeDialog();
          }
        }
      });
    },
    templateUrl: '/templates/aiface/aiface_set_people_dialog.html' + '?t=' + window.buildTime
  };
});
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
app.directive("cameraItem", function () {
  return {
    restrict: "E",
    scope: {
      camera: "=",
      id: "=",
      shopId: "<",
      settingOpenCallback: "&",
      isGroup: "<"
    },
    replace: true,
    transclude: true,
    controller: function controller($scope, $location, $state, Camera, CameraConfig, Utils, Market, Share) {
      $scope.config = {};
      $scope.isLoading = false;
      $scope.getThumbnailUrl = function () {
        var protocol = $location.protocol() + "://";
        if ($scope.camera.thumbnailPath.includes("http")) {
          return $scope.camera.thumbnailPath;
        }
        return "".concat($scope.camera.recorderType == "cvr" ? "http://" : protocol).concat($scope.camera.thumbnailPath);
      };
      $scope.getCameraStatusMessage = function (camera) {
        if (!camera || !camera.recordType || !camera.controlStatus) return null;
        var is = function is(v) {
          return camera.recordType === v;
        };
        var c = camera;
        if (["na", "event", "24h"].indexOf(c.recordType) === -1 && c.streamStatusConfig !== "on" && c.controlStatus === "on") {
          return "MY_CAMERA_STREAMING_OFF_MESSAGE";
        }
        if (["na", "event", "24h"].indexOf(c.recordType) === -1 && c.recorderType !== "recorder" && c.controlStatus !== "on") {
          return "CAMERA_DETAIL_TURN_OFF_CAMERA_MESSAGE";
        }
        if (c.serviceType === "0d" && is("live") && c.recorderType === "cvr" && c.controlStatus === "off") {
          return "CAMERA_DETAIL_TURN_OFF_CAMERA_MESSAGE";
        }
        if (c.serviceType !== "0d" && is("event") && c.recorderType === "cvr" && c.controlStatus === "off") {
          return "CAMERA_DETAIL_TURN_OFF_CAMERA_MESSAGE";
        }
        if (["na", "event", "24h"].indexOf(c.recordType) === -1 && !is("live") && c.streamStatusConfig === "on" && c.controlStatus === "on" && c.streamStatus !== "on") {
          return "MY_CAMERA_DELAY";
        }
        if (c.serviceType !== "0d" && is("24h") && c.recorderType === "cvr") {
          if (c.controlStatus === "on" && c.streamStatus === "off") {
            return "MY_CAMERA_NO_PLAYER";
          }
          if (c.controlStatus === "off") {
            return "CAMERA_DETAIL_TURN_OFF_CAMERA_MESSAGE";
          }
        }
        if (c.recorderType === "recorder" && c.controlStatus !== "on") {
          if (c.controlStatus === "RDE") return "STR_CONNECT_DVR";
          if (c.controlStatus === "off") return "STR_CONNECT_CAM_TO_DVR";
        }
        return null;
      };
      $scope.goDetail = function (cameraId, id) {
        if (!cameraId) {
          void 0;
          return;
        }
        var getGroupType = function getGroupType() {
          return $scope.camera.isShared ? "sharedgroup" : "group";
        };
        var getShopType = function getShopType() {
          return $scope.camera.isShared ? "sharedshop" : "shop";
        };
        var detailType = $scope.isGroup ? getGroupType() : getShopType();
        var stateParams = {
          cameraId: cameraId,
          id: id,
          shopId: $scope.shopId,
          type: detailType
        };
        if ($scope.camera.isShared) {
          stateParams.shared = true;
        }
        $state.go("main.cameraDetail", stateParams);
      };
      $scope.isOff = function (camera) {
        // 개별 조건 함수
        var isNaAndCvr = function isNaAndCvr() {
          return camera.serviceType === "0d" && camera.recordType === "na" && camera.recorderType === "cvr";
        };
        var isLiveAndCvrWithOffControl = function isLiveAndCvrWithOffControl() {
          return camera.serviceType === "0d" && camera.recordType === "live" && camera.recorderType === "cvr" && (camera.controlStatus === "off" && camera.streamStatus === "on" || camera.controlStatus === "off" && camera.streamStatus === "off");
        };
        var isEventAndCvrWithOffControl = function isEventAndCvrWithOffControl() {
          return camera.serviceType !== "0d" && camera.recordType === "event" && camera.recorderType === "cvr" && (camera.controlStatus === "off" && camera.streamStatus === "on" || camera.controlStatus === "off" && camera.streamStatus === "off");
        };
        var is24hAndCvrWithMixedControl = function is24hAndCvrWithMixedControl() {
          return camera.serviceType !== "0d" && camera.recordType === "24h" && camera.recorderType === "cvr" && (camera.controlStatus === "on" && camera.streamStatus === "off" || camera.controlStatus === "off" && camera.streamStatus === "on" || camera.controlStatus === "off" && camera.streamStatus === "off");
        };
        var isStreamConfigOffWithControlOn = function isStreamConfigOffWithControlOn() {
          return camera.streamStatusConfig !== "on" && camera.controlStatus === "on";
        };
        var isInvalidRecordTypeWithStreamConfigOn = function isInvalidRecordTypeWithStreamConfigOn() {
          return camera.recordType !== "live" && camera.recordType !== "event" && camera.streamStatusConfig === "on" && camera.controlStatus === "on" && camera.streamStatus !== "on";
        };
        var isInvalidRecorderTypeWithControlOff = function isInvalidRecorderTypeWithControlOff() {
          return camera.recorderType !== "recorder" && camera.controlStatus !== "on";
        };

        // 조건 통합
        return isNaAndCvr() || isLiveAndCvrWithOffControl() || isEventAndCvrWithOffControl() || is24hAndCvrWithMixedControl() || isStreamConfigOffWithControlOn() || isInvalidRecordTypeWithStreamConfigOn() || isInvalidRecorderTypeWithControlOff();
      };
      $scope.isRecordDelay = function (camera) {
        var hasRecordTypeIssues = camera.recordType !== "live" && camera.recordType !== "event" && camera.streamStatusConfig === "on" && camera.controlStatus === "on" && camera.streamStatus !== "on";
        var hasRecorderIssues = camera.recorderType !== "recorder" && camera.controlStatus !== "on";

        //가능한 조건 ?
        var cvrStreamStatusIssue = camera.recordType != "na" && camera.recordType != "event" && camera.recordType != "24h" && camera.recordType != "live" && camera.streamStatusConfig == "on" && camera.controlStatus == "on" && camera.streamStatus != "on";
        return hasRecordTypeIssues || hasRecorderIssues || cvrStreamStatusIssue;
      };
      $scope.isRecordDelay1 = function (camera) {
        return camera.recordType !== "live" && camera.recordType !== "event" && camera.streamStatusConfig === "on" && camera.controlStatus === "on" && camera.streamStatus !== "on";
      };
      $scope.isRecordDelay2 = function (camera) {
        return camera.controlStatus == "on" && camera.streamStatus == "off";
      };
      $scope.isRecordDelay3 = function (camera) {
        return camera.recordType != "na" && camera.recordType != "event" && camera.recordType != "24h" && camera.recordType != "live" && camera.streamStatusConfig == "on" && camera.controlStatus == "on" && camera.streamStatus != "on";
      };
      $scope.isCameraConnectionOff1 = function (camera) {
        return camera.recordType != "na" && camera.recordType != "event" && camera.recordType != "24h" && camera.recorderType != "recorder" && camera.controlStatus != "on";
      };
      $scope.isCameraConnectionOff2 = function (camera) {
        return camera.controlStatus == "off" && camera.streamStatus == "on";
      };
      $scope.isCameraConnectionOff3 = function (camera) {
        return camera.controlStatus == "off" && camera.streamStatus == "off";
      };
      $scope.isCameraConnectionOff4 = function (camera) {
        return camera.controlStatus == "off" && camera.streamStatus == "on";
      };
      $scope.isCameraConnectionOff5 = function (camera) {
        return camera.recorderType != "recorder" && camera.controlStatus != "on";
      };
      $scope.isCameraOff1 = function (camera) {
        return camera.recordType != "na" && camera.recordType != "event" && camera.recordType != "24h" && camera.recordType != "live" && camera.streamStatusConfig == "on" && camera.controlStatus == "on" && camera.streamStatus != "on";
      };
      $scope.isCameraOff2 = function (camera) {
        return camera.streamStatusConfig != "on" && camera.controlStatus == "on";
      };
      $scope.isCameraConnectionOff = function (camera) {
        var isTypeMatch = function isTypeMatch(type, record, control, stream) {
          return camera.recorderType === type && camera.recordType === record && camera.controlStatus === control && camera.streamStatus === stream;
        };
        var isService0d = camera.serviceType === "0d" && (isTypeMatch("cvr", "na", "off", "on") || isTypeMatch("cvr", "live", "off", "on") || isTypeMatch("cvr", "live", "off", "off"));
        var isServiceNot0d = camera.serviceType !== "0d" && (isTypeMatch("cvr", "event", "off", "on") || isTypeMatch("cvr", "event", "on", "off")) || isTypeMatch("cvr", "24h", "on", "off") || isTypeMatch("cvr", "24h", "off", "on") || isTypeMatch("cvr", "24h", "off", "off");
        var hasStreamStatusIssues = camera.streamStatusConfig !== "on" && camera.controlStatus === "on";
        return isService0d || isServiceNot0d || hasStreamStatusIssues;
      };
      $scope.showTextOff = function (camera) {
        return camera.recordType != "na" && camera.recordType != "event" && camera.recordType != "event" && camera.recordType != "24h" && camera.streamStatusConfig != "on" && camera.controlStatus == "on";
      };
      $scope.getCameraClass = function (camera) {
        return ["cam_item", $scope.isOff(camera) ? "off" : ""].filter(Boolean).join(" ");
      };
      $scope.loadCameraSetting = function (clickStatus) {
        var apiCallFn = $scope.camera.isShared ? CameraConfig.getSharedConfig : CameraConfig.get;
        apiCallFn({
          id: $scope.camera.id
        }, function (data) {
          angular.extend($scope.config, data);
          if (data !== null && data !== void 0 && data.cameraSchedule) {
            var _data$cameraSchedule = data.cameraSchedule,
              startAt = _data$cameraSchedule.startAt,
              stopAt = _data$cameraSchedule.stopAt,
              repeatOn = _data$cameraSchedule.repeatOn;
            $scope.config.parsedStartAt = Utils.configDateSeparate(startAt);
            $scope.config.parsedStopAt = Utils.configDateSeparate(stopAt);
            $scope.config.repeatOn = Utils.configRepeatOnSeparate(repeatOn);
          }
          if ($scope.config.resolution) {
            $scope.config.resolution = $scope.config.resolution.toUpperCase();
          }
        }, function (err) {
          void 0;
          $state.go("main", {}, {
            reload: true
          });
        });
      };
      var handleMarketData = function handleMarketData(cameraId) {
        return new Promise(function (resolve, reject) {
          Market.get({
            cameraId: cameraId
          }, function (data) {
            resolve(data.isFromToastMarket);
          }, function (err) {
            void 0;
            reject(err);
          });
        });
      };
      var showAlert = function showAlert(title, message) {
        $scope.showAlert = true;
        $scope.alertTitle = title;
        $scope.alertMessage = message;
        $(".display_show").show();
      };
      $scope.clickedCameraSettingButton = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var cameraApi, cameraData;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              $scope.isLoading = true;
              cameraApi = $scope.camera.isShared ? Share : Camera;
              _context.prev = 2;
              _context.next = 5;
              return new Promise(function (resolve, reject) {
                cameraApi.get({
                  id: $scope.camera.id
                }, function (response) {
                  return resolve(response);
                }, function (error) {
                  return reject(error);
                });
              });
            case 5:
              cameraData = _context.sent;
              $scope.isLoading = false;
              $scope.settingOpenCallback({
                isOpen: true,
                cameraData: cameraData,
                isShared: $scope.camera.isShared
              });
              _context.next = 14;
              break;
            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](2);
              void 0;
              $scope.isLoading = false;
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[2, 10]]);
      }));
      $scope.handleImageError = function (imgElement) {
        $scope.isImageError = true;
        imgElement.src = "/resources/img/img_camera_fail.svg";
        $scope.$apply();
      };
    },
    templateUrl: "/templates/camera/camera_item.html" + (window.buildTime ? "?t=" + window.buildTime : "")
  };
});
"use strict";

app.directive("cameraSettingDialog", function () {
  return {
    restrict: "E",
    scope: {
      fullscreen: "@",
      isShow: "=",
      cameraId: "=",
      serviceDay: "<",
      onRemoveCamera: "&",
      onChangeName: "&",
      isShared: "<",
      hasMenuSettingBadge: "<",
      playerObj: "<",
      playControl: "="
    },
    replace: true,
    transclude: true,
    controller: function controller($scope, $rootScope, $translate, $state, $timeout, $interval, Camera, CameraConfig, CameraNotifyConfig, Market, Timezone, Utils, Share, $window) {
      $scope.isLoading = false;
      $scope.currentCamera = {};
      $scope.DIALOG_STATE = {
        BASIC: "basic",
        NETWORK: "network",
        WIFI_SET: "wifi_set",
        ACTIVE_NET: "active_net",
        WIFI_CHANGE: "wifi_change",
        WIRE_SET: "wire_set",
        LTE_SET: "lte_set",
        SCHEDULE: "schedule",
        NONE: "none"
      };
      $scope.COMP_ID_MAP = {
        SECURE_TOGGLE: "secure_toggle",
        STREAM_STAT_TOGGLE: "stream_status_toggle",
        CAMERA_MOVE_TOGGLE: "camera_move_toggle",
        PUSH_NOTI_TOGGLE: "push_noti_toggle",
        STREAM_STAT_REV_TOGGLE: "stream_status_reserve_toggle",
        STREAM_OFF_TIME_SELECT: "stream_off_time_select",
        STREAM_ON_TIME_SELECT: "stream_on_time_select",
        STREAM_REV_DAYCHECK: "stream_rev_daycheck",
        NIGHT_MODE_RADIO: "night_mode_radio",
        EXPOSURE_MODE_RADIO: "exposure_mode_radio",
        RESOLUTION_MODE_RADIO: "resolution_mode_radio"
      };
      $scope.NET_IP_MODE = {
        DHCP: "dhcp",
        STATIC: "static"
      };
      $scope.NET_TYPE = {
        LTE: 1,
        WIFI: 2,
        WIRE: 4
      };
      $scope.countryDomain = $rootScope.countryDomain;
      $scope.netToastObj = {
        showNetToast: false,
        netToastMsg: "",
        timeoutObj: null
      };
      $scope.config = {};
      $scope.configStatus = $scope.DIALOG_STATE.BASIC;
      $scope.isEditingCameraName = false;
      $scope.camEditName = "";
      $scope.timezoneData = null;
      $scope.wifiPwdChange = false;
      $scope.notifyOn = null;
      $scope.isShowCamCloudInfo = false;
      $scope.isShowAgingLayer = false;
      $scope.isShowAgingConfirmLayer = false;
      $scope.volumeList = Array.from({
        length: 31
      }, function (_, i) {
        return i === 0 ? 1 : Math.ceil(i * 3.4);
      });
      $scope.netAvailsMap = {
        wifi: {
          label: "Wi-Fi",
          value: $scope.NET_TYPE.WIFI
        }
      };
      $scope.ipModeMap = {
        "static": {
          label: $translate.instant("9rRqk7Vo_02225"),
          value: $scope.NET_IP_MODE.STATIC
        },
        dhcp: {
          label: $translate.instant("9rRqk7Vo_02224"),
          value: $scope.NET_IP_MODE.DHCP
        }
      };
      $scope.netInfoShowFlag = false;
      $scope.curActiveNetwork = "";
      $scope.requestActiveNetwork = "";
      $scope.isRequestedActiveNet = false;
      // ! 업데이트 - 화면 꺼진 경우 안내 토스트
      $scope.showToastUpdateGuide = false;
      $scope.toastUpdateGuideTimeout = 0;
      $scope.serviceDay = $scope.serviceDay || 0;
      $scope.completeCallback = null;
      var activeReqTimeout = null;
      $scope.wireNetEditObj = {
        ipMode: "",
        localIp: "",
        gateway: "",
        subnetmask: ""
      };
      $scope.wifiEditObj = {
        ssid: "",
        wifiAuthMethod: "8",
        wifiPassword: "",
        eap: "0",
        secPhase: "1",
        userId: "",
        userPassword: ""
      };
      $scope.checkIpAddr = function (ipAddr) {
        var pattern = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/;
        return pattern.test(ipAddr);
      };
      $scope.getWireNetSavable = function () {
        if (!$scope.networkConfig) {
          return false;
        }
        if ($scope.networkConfig.controlStatus !== "on" || !$scope.netAvailsMap.wire) {
          return false;
        }
        if ($scope.wireNetEditObj.ipMode === $scope.NET_IP_MODE.DHCP) {
          return $scope.wireNetEditObj.ipMode !== $scope.networkConfig.ipMode;
        }
        // IP_MODE.STATIC
        if ($scope.wireNetEditObj.ipMode === $scope.networkConfig.ipMode && $scope.wireNetEditObj.localIp === $scope.networkConfig.localIp && $scope.wireNetEditObj.gateway === $scope.networkConfig.gateway && $scope.wireNetEditObj.subnetmask === $scope.networkConfig.subnetmask) {
          return false;
        }
        if (!$scope.checkIpAddr($scope.wireNetEditObj.localIp) || !$scope.checkIpAddr($scope.wireNetEditObj.gateway) || !$scope.checkIpAddr($scope.wireNetEditObj.subnetmask)) {
          return false;
        }
        return true;
      };
      $scope.getWifiSavable = function () {
        if (!$scope.networkConfig) {
          return false;
        }
        if ($scope.networkConfig.controlStatus !== "on" || !$scope.wifiEditObj.ssid) {
          return false;
        }
        if ($scope.wifiEditObj.wifiAuthMethod == 2 || $scope.wifiEditObj.wifiAuthMethod == 4 || $scope.wifiEditObj.wifiAuthMethod == 8) {
          if (!$scope.wifiEditObj.wifiPassword) {
            return false;
          }
        }
        if ($scope.wifiEditObj.wifiAuthMethod == 9) {
          if (!$scope.wifiEditObj.userPassword) {
            return false;
          }
        }
        return true;
      };
      $scope.saveWireNet = function () {
        if ($scope.getWireNetSavable() === false) {
          return;
        }
        var networkConfig = {
          ipMode: $scope.wireNetEditObj.ipMode
        };
        if (networkConfig.ipMode === "static") {
          networkConfig.localIp = $scope.wireNetEditObj.localIp;
          networkConfig.gateway = $scope.wireNetEditObj.gateway;
          networkConfig.subnetmask = $scope.wireNetEditObj.subnetmask;
        }
        CameraConfig.setNetworkIp({
          id: $scope.cameraId
        }, networkConfig, function (data) {
          if (data.code === "ok") {
            $scope.requestActiveNetwork = $scope.NET_TYPE.WIRE;
            $scope.isRequestedActiveNet = true;
            if (activeReqTimeout) {
              clearTimeout(activeReqTimeout);
            }
            activeReqTimeout = setTimeout(function () {
              $scope.isRequestedActiveNet = false;
              $scope.requestActiveNetwork = $scope.curActiveNetwork;
            }, 120 * 1000);
            $scope.settingChange($scope.DIALOG_STATE.NETWORK);
            $scope.showNetToastMsg($translate.instant("9rRqk7Vo_02230"));
          }
        }, function (err) {});
      };
      $scope.saveWifiSetting = function () {
        if ($scope.getWifiSavable() === false) {
          return;
        }
        var editObj;
        if ($scope.wifiEditObj.wifiAuthMethod == 9) {
          editObj = {
            ssid: $scope.wifiEditObj.ssid,
            isWifiSetup: "YES",
            wifiAuthMethod: $scope.wifiEditObj.wifiAuthMethod,
            e: $scope.wifiEditObj.eap + ":0:" + $scope.wifiEditObj.secPhase + ":" + $scope.wifiEditObj.userId + ":" + $scope.wifiEditObj.userPassword + ":"
          };
        } else {
          editObj = {
            ssid: $scope.wifiEditObj.ssid,
            isWifiSetup: "YES",
            wifiAuthMethod: $scope.wifiEditObj.wifiAuthMethod,
            wifiPassword: $scope.wifiEditObj.wifiPassword
          };
        }
        CameraConfig.update({
          id: $scope.cameraId
        }, editObj, function (data) {
          if (data.code == "ok") {
            $scope.requestSsid = editObj.ssid;
            $scope.requestActiveNetwork = $scope.NET_TYPE.WIFI;
            $scope.isRequestedActiveNet = true;
            if (activeReqTimeout) {
              clearTimeout(activeReqTimeout);
            }
            activeReqTimeout = setTimeout(function () {
              $scope.isRequestedActiveNet = false;
              $scope.requestActiveNetwork = $scope.curActiveNetwork;
            }, 120 * 1000);
            $scope.settingChange($scope.DIALOG_STATE.NETWORK);
            $scope.showNetToastMsg($translate.instant("9rRqk7Vo_02230"));
          }
        });
      };
      function netAvailMapCheck() {
        return Object.keys($scope.netAvailsMap).length > 1;
      }
      function getNetAvails(networkAvailables) {
        var lte = 1 << 0;
        var wifi = 1 << 1;
        var wire = 1 << 2;
        var result = {};
        result.wifi = {
          label: "Wi-Fi",
          value: $scope.NET_TYPE.WIFI
        };
        if (networkAvailables & lte) {
          result.lte = {
            label: "LTE",
            value: $scope.NET_TYPE.LTE
          };
        }
        if (networkAvailables & wire) {
          result.wire = {
            label: $translate.instant("9rRqk7Vo_02231"),
            value: $scope.NET_TYPE.WIRE
          };
        }
        return result;
      }
      var secureToggle, strStatToggle, camMoveToggle, pushNotiToggle, strStatRevToggle, strOffTimeSelect, strOnTimeSelect, strRevDaycheck, nightModeRadio, expModeRadio, resolutionModeRadio;
      var soundDragVal = 0;
      var soundSaveDrag = 0;
      var soundCursorDrag = null;
      var soundCursorFullDrag = null;
      var netConfigPollingId = null;
      var isFullScreen = function isFullScreen() {
        return !!(document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement);
      };
      function netConfigPollingStart() {
        netConfigPollingStop();
        netConfigPollingId = $interval(function () {
          CameraConfig.getNetworkConfig({
            id: $scope.cameraId
          }, function (data) {
            if (data.code === "ok") {
              $scope.networkConfig = data.networkConfig;
              updateNetInfo($scope.networkConfig);
            }
          }, function () {});
        }, 3000);
      }
      function netConfigPollingStop() {
        if (netConfigPollingId) {
          $interval.cancel(netConfigPollingId);
          netConfigPollingId = null;
        }
      }
      function stopNetToastTimeout() {
        if ($scope.netToastObj.timeoutObj) {
          $timeout.cancel($scope.netToastObj.timeoutObj);
          $scope.netToastObj.showNetToast = false;
          $scope.netToastObj.timeoutObj = null;
        }
      }
      $scope.requestChangeActiveNet = function (value) {
        $scope.requestActiveNetwork = value;
        if ($scope.requestActiveNetwork === $scope.curActiveNetwork) {
          return;
        }
        $scope.isRequestedActiveNet = true;
        if (activeReqTimeout) {
          clearTimeout(activeReqTimeout);
        }
        activeReqTimeout = setTimeout(function () {
          $scope.isRequestedActiveNet = false;
          $scope.requestActiveNetwork = $scope.curActiveNetwork;
        }, 120 * 1000);
        CameraConfig.setActiveNetwork({
          id: $scope.cameraId
        }, {
          networkActive: $scope.requestActiveNetwork
        }, function (data) {
          if (data.code === "ok") {
            $scope.showNetToastMsg($translate.instant("9rRqk7Vo_02230"));
            $scope.settingChange($scope.DIALOG_STATE.NETWORK);
          }
        }, function (err) {
          showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
        });
      };
      $scope.showNetToastMsg = function (msg) {
        if (msg === "no_active_net") {
          $scope.netToastObj.netToastMsg = $translate.instant("9rRqk7Vo_02229");
        } else {
          $scope.netToastObj.netToastMsg = msg ? msg : $translate.instant("9rRqk7Vo_02243");
        }
        $scope.netToastObj.showNetToast = true;
        if ($scope.netToastObj.timeoutObj) {
          $timeout.cancel($scope.netToastObj.timeoutObj);
        }
        $scope.netToastObj.timeoutObj = $timeout(function () {
          $scope.netToastObj.showNetToast = false;
          $scope.netToastObj.timeoutObj = null;
        }, 3000);
      };

      // 마켓 판매 상품인지 확인
      $scope.isFromToastMarket = false;
      var confirmFromToastMarket = function confirmFromToastMarket() {
        Market.get({
          cameraId: $scope.cameraId
        }, function (data) {
          $scope.isFromToastMarket = data.isFromToastMarket;
        }, function (err) {
          showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
        });
      };
      function updateNetInfo(networkConfig) {
        if (!networkConfig) {
          return;
        }
        $scope.netAvailsMap = getNetAvails(networkConfig.networkAvailables);
        $scope.curActiveNetwork = networkConfig.networkActive;
        if ($scope.isRequestedActiveNet) {
          if ($scope.requestActiveNetwork === $scope.curActiveNetwork) {
            if ($scope.requestActiveNetwork === $scope.NET_TYPE.WIFI) {
              if ($scope.requestSsid) {
                if (networkConfig.ssid === $scope.requestSsid) {
                  $scope.isRequestedActiveNet = false;
                }
              } else {
                $scope.isRequestedActiveNet = false;
              }
            } else {
              $scope.isRequestedActiveNet = false;
            }
          }
        } else {
          if (!$scope.requestActiveNetwork) {
            $scope.requestActiveNetwork = $scope.curActiveNetwork;
          }
        }
        $scope.wireNetEditObj.ipMode = networkConfig.ipMode;
        $scope.wireNetEditObj.localIp = networkConfig.localIp;
        $scope.wireNetEditObj.gateway = networkConfig.gateway;
        $scope.wireNetEditObj.subnetmask = networkConfig.subnetmask;
        $scope.wifiEditObj.ssid = networkConfig.ssid;
      }
      $scope.isExpiredCloud = function () {
        if ($scope.currentCamera) {
          return Utils.isCloudExpired($scope.currentCamera);
        } else {
          return false;
        }
      };
      $scope.setEditCameraNameMode = function () {
        $scope.isEditingCameraName = true;
        $scope.camEditName = $scope.config.name;
      };
      $scope.settingChange = function (status) {
        if (status === $scope.DIALOG_STATE.ACTIVE_NET) {
          if (!$scope.networkConfig.isNetworkActiveEditable) {
            $scope.isRequestedActiveNet = false;
            $scope.requestActiveNetwork = $scope.curActiveNetwork;
            $scope.showNetToastMsg($translate.instant("9rRqk7Vo_02244"));
            return;
          }
          if ($scope.networkConfig.controlStatus !== "on" || netAvailMapCheck() === false) {
            $scope.showNetToastMsg($translate.instant("9rRqk7Vo_02229"));
            return;
          }
          $scope.requestActiveNetwork = $scope.curActiveNetwork;
        }
        $scope.configStatus = status;
        if (status === $scope.DIALOG_STATE.BASIC || status === $scope.DIALOG_STATE.SCHEDULE) {
          $scope.loadCameraSetting();
        }
        if (status === $scope.DIALOG_STATE.NETWORK) {
          stopNetToastTimeout();
          CameraConfig.getNetworkConfig({
            id: $scope.cameraId
          }, function (data) {
            if (data.code === "ok") {
              $scope.networkConfig = data.networkConfig;
              updateNetInfo($scope.networkConfig);
            }
          }, function () {});
          netConfigPollingStart();
        } else {
          netConfigPollingStop();
        }
        // 라이브 상품이 아닌경우 마켓 판매 상품인지 확인 후 카메라 제거 or 서비스 해지 버튼 노출
        if (status == $scope.DIALOG_STATE.BASIC && !$scope.isExpiredCloud()) {
          confirmFromToastMarket();
        }
      };
      $scope.changedResolution = function (value) {
        CameraConfig.update({
          id: $scope.cameraId
        }, {
          resolution: value
        }, function (data) {
          if (data.code == "ok") {
            $scope.$parent.requestLivePlay();
          }
          $scope.getCameraConfig();
        }, function (err) {
          $scope.getCameraConfig();
        });
      };
      $scope.changedNightVision = function (value) {
        CameraConfig.update({
          id: $scope.cameraId
        }, {
          nightvision: value
        }, function (data) {
          if (data.code == "ok") {
            $scope.$parent.requestLivePlay();
          }
          $scope.getCameraConfig();
        }, function (err) {
          $scope.getCameraConfig();
        });
      };
      $scope.cameraStatusChange = function (status) {
        var _$scope$playControl, _$scope$playControl$e;
        (_$scope$playControl = $scope.playControl) === null || _$scope$playControl === void 0 ? void 0 : (_$scope$playControl$e = _$scope$playControl.errorStatusLayer) === null || _$scope$playControl$e === void 0 ? void 0 : _$scope$playControl$e.cameraStatusChange(status);
      };
      $scope.cameraStatusSet = function (clickStatus) {
        var _$scope$playControl2;
        if ($scope.currentCamera) {
          if ($scope.shareStatus && !$scope.currentCamera.hasConfigPermission) {
            $scope.configStatus = "share";
          }
        }
        if ($scope.playerObj && ((_$scope$playControl2 = $scope.playControl) === null || _$scope$playControl2 === void 0 ? void 0 : _$scope$playControl2.getData("isLive")) == true) {
          var cameraStatusNum = 0;
          if ($scope.config.streamStatus == "off") {
            cameraStatusNum = 1;
          } else {
            if ($scope.currentCamera) {
              if ($scope.currentCamera.controlStatus === "CS" || $scope.currentCamera.controlStatus === "on") {
                if ($scope.currentCamera.recordType != "event") {
                  if ($scope.currentCamera.streamStatus == "off" && clickStatus != "setting") {
                    if (Utils.isCloudExpired($scope.currentCamera)) {
                      cameraStatusNum = 0;
                    } else {
                      cameraStatusNum = 2;
                    }
                  }
                }
              } else if ($scope.currentCamera.controlStatus === "CE" || $scope.currentCamera.controlStatus === "off") {
                if ($scope.currentCamera.streamStatus == "off") {
                  cameraStatusNum = 4;
                } else {
                  cameraStatusNum = 3;
                }
              }
            }
          }
          $scope.cameraStatusChange(cameraStatusNum);
        }
      };
      $scope.changeExposureMode = function (value) {
        CameraConfig.update({
          id: $scope.cameraId
        }, {
          exposureMode: value
        }, function (data) {
          if (data.code == "ok") {
            $scope.$parent.requestLivePlay();
          }
          $scope.getCameraConfig();
        }, function (err) {
          $scope.getCameraConfig();
        });
      };
      $scope.ledOnOff = function (obj) {
        CameraConfig.update({
          id: $scope.cameraId
        }, {
          ledLight: obj
        }, function (data) {
          $scope.getCameraConfig();
        }, function (err) {
          $scope.getCameraConfig();
        });
      };
      $scope.changeRotation = function (rotation) {
        $scope.config.rotation = rotation;
        CameraConfig.update({
          id: $scope.cameraId
        }, {
          rotation: rotation
        }, function (data) {
          if (data.code == "ok") {
            $scope.$parent.requestLivePlay();
          }
          $scope.getCameraConfig();
        }, function (err) {
          $scope.getCameraConfig();
        });
      };
      $scope.changeMicStatus = function (status) {
        $scope.config.mic = status;
        if (status == "on") {
          $("#mute_no").removeAttr("disabled");
          $("#mute_yes").removeAttr("disabled");
          $("#mute_yes").removeClass("vol_on_non");
          $("#mute_no").removeClass("vol_off_non");
          $("#mute_yes").addClass("vol_on");
          $("#mute_no").addClass("vol_off");
        } else {
          $("#mute_no").attr("disabled", "disabled");
          $("#mute_yes").attr("disabled", "disabled");
          $("#mute_yes").removeClass("vol_on");
          $("#mute_no").removeClass("vol_off");
          $("#mute_yes").addClass("vol_on_non");
          $("#mute_no").addClass("vol_off_non");
        }
        CameraConfig.update({
          id: $scope.cameraId
        }, {
          mic: status
        }, function (data) {
          if (data.code == "ok") {
            $scope.$parent.requestLivePlay();
          }
          $scope.getCameraConfig();
        }, function (err) {
          $scope.getCameraConfig();
        });
      };
      $scope.setCameraData = function (data) {
        $scope.currentCamera = data;
        if ($scope.playerObj) {
          $scope.playerObj.setData("cameraData", $scope.currentCamera);
        }
      };
      $scope.changeCameraName = function () {
        if ($scope.camEditName.length == 0) {
          showAlert($translate.instant("INPUT_LENGTH_ZERO_SUBJECT"), $translate.instant("INPUT_LENGTH_ZERO_CONTENT20"));
          return;
        }
        CameraConfig.update({
          id: $scope.cameraId
        }, {
          name: $scope.camEditName
        }, function () {
          $scope.config.name = $scope.camEditName;
          $scope.isEditingCameraName = false;
          Camera.get({
            id: $scope.cameraId
          }, function (res) {
            $scope.setCameraData(res);
            $scope.getCameraConfig();
            location.reload();
          }, function (err) {
            $scope.getCameraConfig();
          });
        });
      };
      // 카메라 이름 변경 취소
      $scope.cancelCameraNameChange = function () {
        $scope.isEditingCameraName = false;
      };
      $scope.changeTimezone = function () {
        if (!$scope.config.tzCode) {
          return;
        }
        CameraConfig.update({
          id: $scope.cameraId
        }, {
          timezone: $scope.config.tzCode
        }, function (data) {
          if (data.code == "ok") {
            showAlert($translate.instant("CAMERA_SETTING"), $translate.instant("CAMERA_TIMEZONE_CHANGE_COMPLETE"));
            $scope.loadCameraSetting();
          } else {
            showAlert($translate.instant("CAMERA_SETTING"), $translate.instant("CAMERA_TIMEZONE_CHANGE_FAIL"));
          }
          $scope.getCameraConfig();
        }, function (err) {
          showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
        });
      };
      $scope.cameraUpgradeCheck = function () {
        // ! 카메라 꺼짐 상태 체크
        if ($scope.currentCamera.controlStatus === "off" || $scope.currentCamera.streamStatus === "off") {
          $scope.showToastUpdateGuide = true;
          if ($scope.toastUpdateGuideTimeout) {
            $timeout.cancel($scope.toastUpdateGuideTimeout);
          }
          $scope.toastUpdateGuideTimeout = $timeout(function () {
            $scope.showToastUpdateGuide = false;
          }, 3000);
          return;
        }
        $scope.$parent.cameraUpagradeAlert = true;
      };
      $scope.changedCameraStatus = function (streamStatus) {
        $scope.config.streamStatus = streamStatus;
        CameraConfig.update({
          id: $scope.cameraId
        }, {
          streamStatus: $scope.config.streamStatus
        }, function (data) {
          if (data.code == "ok") {
            if ($scope.config.streamStatus == "off") {
              $scope.$parent.updateCameraErrorStatus("recoff");
            } else {
              $scope.$parent.updateCameraErrorStatus();
              $scope.$parent.reloadCameraDetail("changeRec");
            }
          }
          $scope.getCameraConfig();
        }, function (err) {
          $scope.getCameraConfig();
        });
      };
      $scope.changeDetection = function (type, value) {
        var param = {
          motionDetect: value
        };
        $scope.config.motionDetect = value;
        CameraConfig.update({
          id: $scope.cameraId
        }, param, function (data) {
          if (data.code != "ok") {
            showAlert($translate.instant("ACCESS_ALARM_SET"), $translate.instant("ACCESS_SET_FAIL"));
          }
        }, function (err) {
          showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
        });
      };
      // 이벤트 감지 알림 설정 변경
      $scope.changeDetectionAlarm = function (value) {
        $scope.notifyOn = value;
        CameraNotifyConfig.update({
          cameraId: $scope.cameraId
        }, {
          notifyOn: value
        }, function (data) {
          if (data.code != "ok") {
            showAlert($translate.instant("ACCESS_ALARM_SET"), $translate.instant("ACCESS_SET_FAIL"));
          }
        }, function (err) {
          showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
        });
      };
      var arrDays = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
      $scope.changeScheduleOn = function (scheduleOn) {
        $scope.config.cameraSchedule.scheduleOn = scheduleOn;
        var isCheckedDays = _.includes($scope.config.repeatOn, true);
        if (!isCheckedDays && scheduleOn === "on") {
          $scope.config.repeatOn[arrDays[new Date().getDay()]] = true; // 예약을 켜짐으로 바꿨을시 체크된 요일이 없으면 오늘 요일을 default
        }
        if (scheduleOn === "on") {
          $scope.scheduleUpdate(true);
        } else {
          CameraConfig.update({
            id: $scope.cameraId
          }, {
            scheduleOn: scheduleOn
          }, function (data) {
            $scope.getCameraConfig();
            $scope.settingChange($scope.DIALOG_STATE.SCHEDULE);
          }, function () {
            $scope.getCameraConfig();
          });
        }
      };
      $scope.scheduleUpdate = function (noAlert) {
        var scheduleOn = $scope.config.cameraSchedule.scheduleOn;
        var startAt = strOffTimeSelect.getTimeStr();
        var stopAt = strOnTimeSelect.getTimeStr();
        var daycheckValue = strRevDaycheck.value;
        var repeatOn = Utils.configRepeatOnJoin({
          SUN: daycheckValue[0],
          MON: daycheckValue[1],
          TUE: daycheckValue[2],
          WED: daycheckValue[3],
          THU: daycheckValue[4],
          FRI: daycheckValue[5],
          SAT: daycheckValue[6]
        });
        if ($scope.config.cameraSchedule.scheduleOn === "off") {
          return;
        }
        if ($scope.config.cameraSchedule.scheduleOn && startAt === $scope.config.cameraSchedule.startAt && stopAt === $scope.config.cameraSchedule.stopAt && repeatOn === $scope.config.cameraSchedule.repeatOn) {
          return;
        }
        if (scheduleOn === "on" && repeatOn.length < 1) {
          showAlert($translate.instant("BUTTON_NOTI_SAVE"), $translate.instant("CAMERA_SHOULD_CHOOSE_DAY"));
          return;
        }
        CameraConfig.update({
          id: $scope.cameraId
        }, {
          scheduleOn: scheduleOn,
          startAt: startAt,
          stopAt: stopAt,
          repeatOn: repeatOn
        }, function (data) {
          if (data.code == "ok") {
            if (!noAlert) {
              showAlert($translate.instant("SCHEDULE_SAVE_SUBEJCT"), $translate.instant("SCHEDULE_SAVE_CONTENT"));
            }
          }
          $scope.getCameraConfig();
          $scope.settingChange($scope.DIALOG_STATE.SCHEDULE);
        }, function () {
          $scope.getCameraConfig();
        });
      };
      $scope.clickedRemoveCamera = function () {
        $("body").scrollTop(10);
        $scope.$parent.showRemoveCameraAlert = true;
      };
      $scope.clickedCameraSettingCloseButton = function () {
        $scope.changeDialogState($scope.DIALOG_STATE.NONE);
      };
      $scope.changeDialogState = function (state) {
        stopNetToastTimeout();
        if (state === $scope.DIALOG_STATE.NONE) {
          $("body").off("click", layerClick);
          destroyComponent();
          soundDragVal = 0;
          soundSaveDrag = 0;
          soundCursorDrag = null;
          soundCursorFullDrag = null;
          $scope.isEditingCameraName = false;
          $scope.timezoneData = null;
          $scope.wifiPwdChange = false;
          $scope.notifyOn = null;
          $scope.configStatus = $scope.DIALOG_STATE.BASIC;
          $scope.isShow = false;
          $scope.serviceDay = 0;
          $scope.config = {};
          $scope.currentCamera = {};
        }
      };
      $scope.changeMicVolume = function (dv) {
        if (!(parseInt($scope.micVolume) <= 30 && parseInt($scope.micVolume) >= 0)) {
          $scope.micVolume = 0;
        }
        var newVolume = parseInt($scope.micVolume) + dv;
        if (newVolume < 0) {
          newVolume = 0;
        } else if (newVolume > 30) {
          newVolume = 30;
        }
        $scope.micVolume = newVolume;
        $scope.config.micVolume = newVolume;
        $scope.volumeIdx = newVolume;
        CameraConfig.update({
          id: $scope.cameraId
        }, {
          micVolume: newVolume
        }, function () {
          $scope.getCameraConfig();
        }, function (err) {
          $scope.getCameraConfig();
        });
      };
      $rootScope.$watch("countryDomain", function () {
        $scope.countryDomain = $rootScope.countryDomain;
      });

      // ! toast message
      $scope.purchaseGuide = {
        hasToast: false,
        message: "",
        timeout: 0
      };
      $scope.showToastPurchaseGuideMessage = function (message) {
        $scope.purchaseGuide.message = message;
        $scope.purchaseGuide.hasToast = true;
        if ($scope.purchaseGuide.timeout) {
          $timeout.cancel($scope.purchaseGuide.timeout);
        }
        $scope.purchaseGuide.timeout = $timeout(function () {
          $scope.purchaseGuide.hasToast = false;
          $scope.purchaseGuide.message = "";
        }, 1000 * 3);
      };

      // 구매 확인 레이어 팝업 호출
      $scope.showPurchaseConfirmLayer = function () {
        // ie에서 풀스크린상태일 경우 레이어 팝업이 보이지 않는 문제로.. 풀스크린 해제
        if ($scope.countryDomain === "ja") {
          $state.go("main.help.customerCenter");
        } else {
          $state.go("main.help.inquiry", {
            type: "cam_buy"
          });
        }
      };
      function showAlert(title, message, callback) {
        $scope.showAlert = true;
        $scope.alertTitle = title;
        $scope.alertMessage = message;
        $scope.alertCallback = callback;
      }
      function getNotificationConfigData() {
        $scope.getCameraConfig();
        CameraNotifyConfig.get({
          cameraId: $scope.cameraId
        }, function (res) {
          if (res.code == "ok") {
            $scope.notifyOn = res.notifyOn;
            if (pushNotiToggle) {
              pushNotiToggle.value = $scope.notifyOn === "on" ? true : false;
            }
          }
        }, function (err) {
          showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
        });
      }
      function settingSoundBarDragEvent(barId, cursorId) {
        var dragObj = null;
        if (barId.indexOf("full") === -1) {
          soundCursorDrag = d3.behavior.drag();
          dragObj = soundCursorDrag;
        } else {
          soundCursorFullDrag = d3.behavior.drag();
          dragObj = soundCursorFullDrag;
        }
        dragObj.on("drag", function (e) {
          //
          if (soundDragVal == 0) {
            soundSaveDrag = parseInt($("#" + barId).css("width"));
            soundDragVal = parseInt($("#" + barId).css("width"));
          }
          var dx = d3.event.dx;
          soundDragVal += dx;
          if (soundDragVal > 102) {
            soundDragVal = 102;
          }
          if (soundDragVal < 1) {
            soundDragVal = 1;
          }
          if (soundDragVal >= 0 && soundDragVal <= 102) {} else {
            return;
          }
          if (soundDragVal == 1) {
            soundDragVal = 0;
          }
          $("#" + barId).css("width", soundDragVal + "px");
          if (soundDragVal == 0) {
            soundDragVal = 1;
          }
        }).on("dragend", function (e) {
          var chageVol = Math.ceil((parseInt($("#" + barId).css("width")) - soundSaveDrag) / 3.4);
          soundDragVal = 0;
          $scope.changeMicVolume(chageVol);
        });
        setTimeout(function () {
          d3.select("#" + cursorId).call(dragObj);
        }, 10);
      }
      function getElementId(elId) {
        return $scope.fullscreen ? elId + "_full" : elId;
      }
      function removeComponents(components) {
        if (components) {
          components.forEach(function (item) {
            if (item) {
              item.destroy();
            }
          });
        }
      }
      function setCompChangedHandler(component, handler) {
        if (!component || !handler) {
          return;
        }
        component.on("changed", handler);
      }
      $scope.handleCameraRebooting = function () {
        $scope.isLoading = true;
        Camera.postRebootingCamera({
          cameraId: $scope.cameraId
        }, {}, function (data) {
          if (data.code === "nok") {
            $scope.isLoading = false;
            showAlert($translate.instant("CAMERA_REBOOTING_FAIL"), $translate.instant("CAMERA_REBOOTING_FAIL_ALERT"));
            return;
          }
          $scope.isLoading = false;
          showAlert($translate.instant("CAMERA_REBOOTING_START"), $translate.instant("CAMERA_REBOOTING_START_ALERT"), function () {
            $window.location.reload();
          });
        }, function (err) {
          showAlert($translate.instant("CAMERA_REBOOTING_FAIL"), $translate.instant("CAMERA_REBOOTING_FAIL_ALERT"));
          void 0;
        });
      };
      function createComponent() {
        secureToggle = tCam.toggle(getElementId($scope.COMP_ID_MAP.SECURE_TOGGLE));
        strStatToggle = tCam.toggle(getElementId($scope.COMP_ID_MAP.STREAM_STAT_TOGGLE));
        camMoveToggle = tCam.toggle(getElementId($scope.COMP_ID_MAP.CAMERA_MOVE_TOGGLE));
        pushNotiToggle = tCam.toggle(getElementId($scope.COMP_ID_MAP.PUSH_NOTI_TOGGLE));
        strStatRevToggle = tCam.toggle(getElementId($scope.COMP_ID_MAP.STREAM_STAT_REV_TOGGLE));
        strOffTimeSelect = tCam.timeselect(getElementId($scope.COMP_ID_MAP.STREAM_OFF_TIME_SELECT));
        strOnTimeSelect = tCam.timeselect(getElementId($scope.COMP_ID_MAP.STREAM_ON_TIME_SELECT));
        strRevDaycheck = tCam.daycheck(getElementId($scope.COMP_ID_MAP.STREAM_REV_DAYCHECK));
        nightModeRadio = tCam.radiobtn(getElementId($scope.COMP_ID_MAP.NIGHT_MODE_RADIO));
        expModeRadio = tCam.radiobtn(getElementId($scope.COMP_ID_MAP.EXPOSURE_MODE_RADIO));
        resolutionModeRadio = tCam.radiobtn(getElementId($scope.COMP_ID_MAP.RESOLUTION_MODE_RADIO));
      }
      function destroyComponent() {
        removeComponents([secureToggle, strStatToggle, camMoveToggle, pushNotiToggle, strStatRevToggle, strOffTimeSelect, strOnTimeSelect, strRevDaycheck, nightModeRadio, expModeRadio, resolutionModeRadio]);
        secureToggle = null;
        strStatToggle = null;
        camMoveToggle = null;
        pushNotiToggle = null;
        strStatRevToggle = null;
        strOffTimeSelect = null;
        strOnTimeSelect = null;
        strRevDaycheck = null;
        nightModeRadio = null;
        expModeRadio = null;
        resolutionModeRadio = null;
      }
      function setComponentHandler() {
        setCompChangedHandler(secureToggle, function (event) {
          $scope.config.secureMode = event.value ? "on" : "off";
          $scope.$parent.changeSecureMode();
        });
        setCompChangedHandler(strStatToggle, function (event) {
          $scope.changedCameraStatus(event.value ? "on" : "off");
        });
        setCompChangedHandler(camMoveToggle, function (event) {
          $scope.changeDetection("motion", event.value ? "on" : "off");
        });
        setCompChangedHandler(pushNotiToggle, function (event) {
          $scope.changeDetectionAlarm(event.value ? "on" : "off");
        });
        setCompChangedHandler(strStatRevToggle, function (event) {
          $scope.changeScheduleOn(event.value ? "on" : "off");
        });
        setCompChangedHandler(nightModeRadio, function (event) {
          $scope.changedNightVision(event.value);
        });
        setCompChangedHandler(expModeRadio, function (event) {
          $scope.changeExposureMode(event.value);
        });
        setCompChangedHandler(resolutionModeRadio, function (event) {
          $scope.changedResolution(event.value);
        });
      }
      function setComponentData() {
        secureToggle.value = $scope.config.secureMode === "on";
        strStatToggle.value = $scope.config.streamStatus === "on";
        camMoveToggle.value = $scope.config.motionDetect === "on";
        strStatRevToggle.value = $scope.config.cameraSchedule && $scope.config.cameraSchedule.scheduleOn === "on";
        var offDate = new Date();
        offDate.setHours($scope.config.parsedStartAt ? $scope.config.parsedStartAt.hour : 0);
        offDate.setMinutes($scope.config.parsedStartAt ? $scope.config.parsedStartAt.minute : 0);
        strOffTimeSelect.value = offDate;
        var onDate = new Date();
        onDate.setHours($scope.config.parsedStopAt ? $scope.config.parsedStopAt.hour : 0);
        onDate.setMinutes($scope.config.parsedStopAt ? $scope.config.parsedStopAt.minute : 0);
        strOnTimeSelect.value = onDate;
        strRevDaycheck.value = [$scope.config.repeatOn.SUN, $scope.config.repeatOn.MON, $scope.config.repeatOn.TUE, $scope.config.repeatOn.WED, $scope.config.repeatOn.THU, $scope.config.repeatOn.FRI, $scope.config.repeatOn.SAT];
        nightModeRadio.items = [{
          value: "auto",
          text: $translate.instant("AUTO")
        }, {
          value: "on",
          text: $translate.instant("ON")
        }, {
          value: "off",
          text: $translate.instant("OFF")
        }];
        nightModeRadio.value = $scope.config.nightvision;
        expModeRadio.items = [{
          value: "1",
          text: "60Hz"
        }, {
          value: "0",
          text: "50Hz"
        }];
        expModeRadio.value = $scope.config.exposureMode;
        resolutionModeRadio.items = [{
          value: "HD",
          text: 'HD<span class="rdo_stxt">(1280*720)</span>'
        }, {
          value: "FHD",
          text: 'FHD<span class="rdo_stxt">(1920*1080)</span>'
        }];
        resolutionModeRadio.value = $scope.config.resolution;
      }
      var getCameraData = function getCameraData() {
        var setServiceDay = function setServiceDay(camera) {
          var now = moment();
          var currentTime = new Date().valueOf();
          var regDate = moment(camera.regDate);
          var isNvr = camera.recorderType === "nvr";
          var isPromotion = camera.isPromotion === 1;
          var saveEndDate = camera.saveEndDate;
          $scope.cloudOut = false;
          if ($scope.isExpiredCloud() || saveEndDate < currentTime) {
            $scope.cloudOut = true;
            return;
          }

          // 서비스 데이 계산
          $scope.serviceDay = isNvr ? now.diff(regDate, "days") + 1 : parseInt(camera.serviceType, 10);

          // 프로모션 여부와 클라우드 상태 확인
          if (isPromotion && saveEndDate <= currentTime) {
            $scope.cloudOut = true;
            return;
          }
          if ($scope.serviceDay < 1) {
            $scope.cloudOut = true;
          }
        };
        if (!$scope.isShared) {
          Camera.get({
            id: $scope.cameraId
          }, function (res) {
            $scope.currentCamera = res;
            setServiceDay(res);
          });
        } else {
          Share.get({
            id: $scope.cameraId
          }, function (res) {
            setServiceDay(res);
            $scope.currentCamera = res;
          });
        }
      };
      $scope.getCameraConfig = function (callback) {
        var apiCallFn = !$scope.isShared ? CameraConfig.get : CameraConfig.getSharedConfig;
        apiCallFn({
          id: $scope.cameraId
        }, function (data) {
          $scope.config = data;
          $scope.config.tzCode = $scope.config.timezone.split(",")[0];
          if (data && data.cameraSchedule) {
            $scope.scheduleOn = data.cameraSchedule.scheduleOn;
          }
          $scope.config.parsedStartAt = Utils.configDateSeparate($scope.config.cameraSchedule.startAt);
          $scope.config.parsedStopAt = Utils.configDateSeparate($scope.config.cameraSchedule.stopAt);
          $scope.config.repeatOn = Utils.configRepeatOnSeparate($scope.config.cameraSchedule.repeatOn);
          if (callback) {
            callback();
          }
        });
      };
      function initDialog() {
        $("body").click("on", layerClick);
        /* Component init */
        destroyComponent();
        createComponent();
        setComponentHandler();
        getCameraData();
        $scope.getCameraConfig(function () {
          setComponentData();
        });
        getNotificationConfigData();
        $scope.timezoneData = Timezone.query();
        if ($scope.fullscreen) {
          if (!soundCursorFullDrag) {
            settingSoundBarDragEvent("settingSoundbar_full", "soundCursor_full");
          }
        } else {
          if (!soundCursorDrag) {
            settingSoundBarDragEvent("settingSoundbar", "soundCursor");
          }
        }
      }
      $scope.nextEventList = function (idx) {
        if (idx == 0) {
          return;
        }
        $(".evnetListDate").hide();
        $scope.eventListDateIndex--;
        if ($scope.eventListDateIndex < 0) {
          $scope.eventListDateIndex = 0;
          return;
        }
        $scope.pressedEventListDateButton($scope.eventListDateIndex);
        $scope.initFlags();
        var idxNum = parseInt(idx) - 1;
        $("#evnetListDate_" + idxNum).show();
      };
      $scope.toggleNetInfo = function (event) {
        $scope.netInfoShowFlag = !$scope.netInfoShowFlag;
        event.stopPropagation();
      };
      $scope.goToInqueryPage = function () {
        $state.go("main.help.inquiry", {
          type: "cam_cancel"
        });
      };
      $scope.showAgingLayer = function () {
        $scope.isShowCamCloudInfo = false;
        $scope.isShowAgingLayer = true;
      };
      $scope.hideAgingLayer = function () {
        $scope.isShowAgingLayer = false;
      };
      $scope.showCamCloudInfo = function (callBack) {
        if ($scope.isShared) {
          showAlert("".concat($translate.instant("CLOUD_STORE"), " ").concat($translate.instant("SETTING"), " ").concat($translate.instant("ERROR")), $translate.instant("SHARED_CAMERA_CLOUD_SETTING_ERROR_TEXT"));
          return;
        }
        $scope.isShow = false;

        // ! 카메라 정보 조회
        Camera.getCamera({
          cameraId: $scope.cameraId
        }, function (data) {
          $scope.hasLastAgingDate = !!data.lastAgingDate && data.lastAgingDate !== -100;
          $scope.lastAgingDate = $scope.hasLastAgingDate ? data.lastAgingDate : "";
          $scope.displayLastAgingDate = moment(new Date($scope.lastAgingDate)).format("YYYY.MM.DD. HH:mm");
          $scope.isAgingDone = (data.agingDate || 0) <= 0;
          if (callBack && typeof callBack === "function") {
            callBack();
          }
        });

        // ! 카메라 - 서비스 만료일 조회
        Camera.saveEndDateInfo({
          cameraId: $scope.cameraId
        }, function (data) {
          $scope.saveEndDateText = data.saveEndDateText;
          $scope.saveEndDate = data.saveEndDate;
          $scope.isShowCamCloudInfo = true;
          $scope.isShowCameraSetting = false;
          $timeout.cancel($scope.displaySaveEndDateTimeout);
          $scope.setDisplaySaveEndDate();
          if (callBack && typeof callBack === "function") {
            callBack();
          }
        });
      };
      $scope.hideCamCloudInfo = function () {
        $scope.isShowCamCloudInfo = false;
      };
      $scope.backToCamSetting = function () {
        $scope.isShowCamCloudInfo = false;
        $scope.isShow = true;
      };
      $scope.isCountryJA = function () {
        return ($scope.countryDomain || window.country) === "ja";
      };
      $scope.setDisplaySaveEndDate = function () {
        var TIME_DELIMTER = {
          MINUTE: 1000 * 60,
          HOUR: 1000 * 60 * 60,
          DAY: 1000 * 60 * 60 * 24
        };
        var TIME_MESSAGES = {
          MINUTE: $translate.instant("5mw2slvk_02264"),
          // {MM}분
          HOUR: $translate.instant("5mw2slvk_02263"),
          // {HH}시
          DAY: $translate.instant("5mw2slvk_02262") // {DD}일
        };
        var diff = +new Date($scope.saveEndDate) - +new Date();
        var minute = Math.floor(diff / TIME_DELIMTER.MINUTE);
        var hour = Math.floor(diff / TIME_DELIMTER.HOUR);
        var day = Math.floor(diff / TIME_DELIMTER.DAY);
        var display = [];
        if (day) {
          display.push(TIME_MESSAGES.DAY.replace("{DD}", day)); // {DD}일
        }
        if (hour) {
          hour = hour > 24 ? hour % 24 : hour;
          display.push(TIME_MESSAGES.HOUR.replace("{HH}", hour)); // {HH}시
        }
        if (minute) {
          minute = minute > 60 ? minute % 60 : minute;
          display.push(TIME_MESSAGES.MINUTE.replace("{MM}", minute)); // {MM}분
        }
        $scope.disaplySaveEndDate = display.join(" ");
        $scope.displaySaveEndDateTimeout = $timeout(function () {
          $scope.setDisplaySaveEndDate();
        }, 1000 * 1);
      };

      // ! 녹화 영상 삭제 확인 컨펌
      $scope.showAgingConfirmLayer = function () {
        $scope.isShowAgingConfirmLayer = true;
      };
      $scope.hideAgingConfirmLayer = function () {
        $scope.isShowAgingConfirmLayer = false;
      };
      function layerClick(e) {
        if (e.target.className.indexOf("wire_set_info_wrap") === -1 && e.target.parentElement.className.indexOf("wire_set_info_wrap") === -1) {
          if ($scope.netInfoShowFlag) {
            $scope.netInfoShowFlag = false;
            $scope.$apply();
          }
        }
      }
      $scope.confirmAging = function () {
        // ! 두번째 파라미터에 {} 를 넘겨야, url :cameraId 에 cameraId 가 치환됨
        Camera.requestCameraAging({
          cameraId: $scope.cameraId
        }, {}, function () {
          $scope.hideAgingConfirmLayer();

          // ! 삭제 요청 후, 정보 갱신 처리
          $scope.showCamCloudInfo(function () {
            $scope.showAgingLayer();
            if ($scope.playerObj) {
              // ! 영상 타임라인 업데이트를 위함
              $scope.playerObj.requestPlay();

              // ! 이벤트 리스트 업데이트
              $scope.nextEventList(1);
              $("#evnetListDate_0").show();
            }
          });
        }, function () {
          $rootScope.createConfirm({
            title: $translate.instant("ACCESS_NET_FAIL"),
            description: $translate.instant("ACCESS_NET_FAIL_DESC"),
            btnCount: 1
          });
          $scope.hideAgingConfirmLayer();
        });
      };
      $scope.agingBackStep = function () {
        $scope.hideAgingLayer();
        $scope.isShowCamCloudInfo = true;
      };
      $scope.loadCameraSetting = function (callback, clickStatus) {
        var apiCallFn = !$scope.isShared ? CameraConfig.get : CameraConfig.getSharedConfig;
        apiCallFn({
          id: $scope.cameraId
        }, function (data) {
          angular.extend($scope.config, data);
          if (data && data.cameraSchedule) {
            $scope.scheduleOn = data.cameraSchedule.scheduleOn;
          }
          if ($scope.config.resolution) {
            $scope.config.resolution = $scope.config.resolution.toUpperCase();
          }
          $("#cameraNameView").html($scope.config.name);
          $scope.cameraStatusSet(clickStatus);
          if ($scope.config.cameraSchedule != undefined) {
            $scope.config.parsedStartAt = Utils.configDateSeparate($scope.config.cameraSchedule.startAt);
            $scope.config.parsedStopAt = Utils.configDateSeparate($scope.config.cameraSchedule.stopAt);
            $scope.config.repeatOn = Utils.configRepeatOnSeparate($scope.config.cameraSchedule.repeatOn);
          }
          if ($scope.config.timezone != undefined) {
            $scope.config.tzCode = $scope.config.timezone.split(",")[0];
            $scope.tzCode = $scope.config.tzCode;
            $scope.config.tzDisplayName = $scope.config.timezone.split(",")[1] + $scope.config.timezone.split(",")[3];
          }
          $scope.micVolume = $scope.config.micVolume;
          $scope.volumeIdx = $scope.config.micVolume;
          if ($scope.config.usageRate > 100) {
            $scope.config.usageRate = 100;
          }
          if ($scope.playerObj) {
            $scope.playerObj.setData("cameraConfig", $scope.config);
          }
          if (typeof callback === "function") {
            callback();
          }
        }, function (err) {
          // error
          $state.go("main", {}, {
            reload: true
          });
        });
      };
      $scope.hideAlert = function () {
        $scope.showAlert = false;
      };
      $scope.$watch("config.micVolume", function (newValue) {
        if ($scope.micVolume === undefined && $scope.volumeIdx === undefined) {
          $scope.micVolume = newValue;
          $scope.volumeIdx = newValue;
        }
      });
      $scope.$watch("config.secureMode", function (newValue, oldValue) {
        if (isFullScreen() !== !!$scope.fullscreen) {
          return;
        }
        if (newValue !== oldValue && secureToggle) {
          secureToggle.value = newValue === "on";
        }
      });
      $scope.$watch("config.nightvision", function (newValue) {
        if (nightModeRadio) {
          nightModeRadio.value = newValue;
        }
      });
      $scope.$watch("config.exposureMode", function (newValue) {
        if (expModeRadio) {
          expModeRadio.value = newValue;
        }
      });
      $scope.$watch("config.streamStatus", function (newValue, oldValue) {
        if (isFullScreen() !== !!$scope.fullscreen) {
          return;
        }
        if (newValue !== oldValue && strStatToggle) {
          strStatToggle.value = newValue === "on";
        }
      });
      $scope.$watch("isShow", function (newValue, oldValue) {
        if (newValue !== oldValue) {
          if (newValue) {
            if (isFullScreen() !== !!$scope.fullscreen) {
              return;
            }
            $scope.isLoading = true;
            initDialog();
            $scope.isLoading = false;
          } else {
            $scope.changeDialogState($scope.DIALOG_STATE.NONE);
            netConfigPollingStop();
          }
        }
      });
      $scope.$on("$destroy", function () {
        if (activeReqTimeout) {
          clearTimeout(activeReqTimeout);
          activeReqTimeout = null;
        }
        if ($scope.toastUpdateGuideTimeout) {
          $timeout.cancel($scope.toastUpdateGuideTimeout);
        }
        $scope.changeDialogState($scope.DIALOG_STATE.NONE);
        netConfigPollingStop();
      });
    },
    templateUrl: "/templates/camera/camera_setting_dialog.html" + "?t=" + window.buildTime
  };
});
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
app.directive("clipMakeDialog", function () {
  return {
    restrict: "E",
    scope: {
      idPrefix: "@",
      fullscreen: "@",
      fullscreenTargetContainerId: "@",
      isOpen: "="
    },
    replace: true,
    transclude: true,
    link: function link($scope, $document, $attrs) {
      $scope.isFullScreen = checkFullScreen();
      $scope.idPrefix = $attrs.idPrefix || "";
      var clipElement = document.getElementById("clip-make-dialog");
      var originalParentElement = clipElement === null || clipElement === void 0 ? void 0 : clipElement.parentElement;
      function checkFullScreen() {
        return !!(document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement);
      }
      function moveElementContainer() {
        if (!clipElement) return;
        if (!originalParentElement) {
          originalParentElement = clipElement.parentElement;
        }
        if ($scope.isFullScreen) {
          var fullscreenTarget = document.getElementById($attrs.fullscreenTargetContainerId);
          if (!fullscreenTarget || fullscreenTarget.contains(clipElement)) return;
          fullscreenTarget.appendChild(clipElement);
        } else {
          originalParentElement.appendChild(clipElement);
        }
      }

      // 전체 화면 변경 이벤트 리스너
      function onFullScreenChange() {
        $scope.isFullScreen = checkFullScreen();
        moveElementContainer();
        $scope.$apply();
      }
      document.addEventListener("fullscreenchange", onFullScreenChange);
      document.addEventListener("webkitfullscreenchange", onFullScreenChange);
      document.addEventListener("mozfullscreenchange", onFullScreenChange);
      document.addEventListener("MSFullscreenChange", onFullScreenChange);
      $document.on("fullscreenchange", onFullScreenChange);
      $scope.$on("$destroy", function () {
        document.removeEventListener("fullscreenchange", onFullScreenChange);
        document.removeEventListener("webkitfullscreenchange", onFullScreenChange);
        document.removeEventListener("mozfullscreenchange", onFullScreenChange);
        document.removeEventListener("MSFullscreenChange", onFullScreenChange);
      });
    },
    controller: function controller($scope, $rootScope, $translate, $timeout, Clip, Utils, $document) {
      $scope.DIALOG_STATE = {
        BASIC: "basic",
        NONE: "none"
      };
      $scope.configStatus = $scope.DIALOG_STATE.BASIC;
      $scope.COMP_ID_MAP = {
        SMART_CHECKBOX: "smart_checkbox"
      };
      $scope.labsNameFocus = false;
      // clip
      $scope.newClip = {
        playrate: "1",
        isSmart: false,
        timeOverlay: "No",
        outputDuration: "0s",
        placeholder: $translate.instant("CLIP_CREATE_CLIP_NEW_NAME"),
        name: "",
        defaultName: ""
      };
      var smartCheckbox = null;
      function getClipMoment() {
        var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "start";
        var time = arguments.length > 1 ? arguments[1] : undefined;
        var isStart = duration === "start";
        var dateMoment = isStart ? $scope.clipStartDatePicker.getMoment() : $scope.clipEndDatePicker.getMoment();
        var validTime = time === "Invalid date" ? "00 : 00 : 00" : time;
        return moment("".concat(dateMoment.format("YYYYMMDD"), " ").concat(validTime), "YYYYMMDD HH : mm : ss");
      }
      var getClipStartMoment = function getClipStartMoment() {
        return getClipMoment("start", $scope.newClip.startTime);
      };
      var getClipEndMoment = function getClipEndMoment() {
        return getClipMoment("end", $scope.newClip.endTime);
      };
      var getClipDurationString = function getClipDurationString(playrate) {
        var startTime = getClipStartMoment().toDate().getTime();
        var endTime = getClipEndMoment().toDate().getTime();
        return Utils.durationStringFromTwoTime(startTime, endTime, playrate);
      };
      function setClipTimeMoment(momentTime, timeType) {
        var momentInstance = typeof momentTime === "number" ? moment(momentTime) : momentTime;
        if (!momentInstance.isValid()) {
          void 0;
          return;
        }

        // 시간을 포맷팅하여 문자열로 변환
        var formattedTime = momentInstance.format("HH : mm : ss");
        var tokens = formattedTime.split(" : ");
        if (timeType === "start") {
          $scope.newClip.startTime = formattedTime;
          $scope.newClip.startHour = tokens[0];
          $scope.newClip.startMinute = tokens[1];
          $scope.newClip.startSecond = tokens[2];
        } else if (timeType === "end") {
          $scope.newClip.endTime = formattedTime;
          $scope.newClip.endHour = tokens[0];
          $scope.newClip.endMinute = tokens[1];
          $scope.newClip.endSecond = tokens[2];
        }
      }
      // 시작 시간 설정 함수
      var setClipStartTimeMoment = function setClipStartTimeMoment(m) {
        setClipTimeMoment(m, "start");
      };

      // 종료 시간 설정 함수
      var setClipEndTimeMoment = function setClipEndTimeMoment(m) {
        setClipTimeMoment(m, "end");
      };
      function adjustTime(val, max, isIncrement) {
        var time = parseInt(val) || 0;
        time = isIncrement ? time + 1 : time - 1;
        if (time > max) time = 0;
        if (time < 0) time = max;
        return time.toString().padStart(2, "0");
      }

      // 시간을 증가시키는 함수
      var pressedTimeUpButton = function pressedTimeUpButton(val, max) {
        return adjustTime(val, max, true);
      };

      // 시간을 감소시키는 함수
      var pressedTimeDownButton = function pressedTimeDownButton(val, max) {
        return adjustTime(val, max, false);
      };

      // 클립&타임랩스 변수값 초기화
      var resetClipValue = function resetClipValue() {
        $scope.isShowingStartTimePicker = false;
        $scope.isShowingEndTimePicker = false;
        $scope.newClip.playrate = "1";
        $scope.newClip.isSmart = false;
        $scope.newClip.timeOverlay = "No";
        $scope.newClip.outputDuration = "0s";
      };
      function closeDialog() {
        var _smartCheckbox;
        (_smartCheckbox = smartCheckbox) === null || _smartCheckbox === void 0 ? void 0 : _smartCheckbox.destroy();
        smartCheckbox = null;
        resetClipValue();
        $document.off("keydown");
        if ($scope.clipEndDatePicker) $scope.clipEndDatePicker.destroy();
        if ($scope.clipStartDatePicker) $scope.clipStartDatePicker.destroy();
        $scope.configStatus = $scope.DIALOG_STATE.BASIC;
        $scope.isOpen = false;
      }
      $scope.changeDialogState = function (state) {
        if (state !== $scope.DIALOG_STATE.BASIC) {
          closeDialog();
        }
      };

      // 클립&타임랩스 만들기
      $scope.createClip = function () {
        var startMoment = getClipStartMoment();
        var endMoment = getClipEndMoment();
        var startTime = startMoment.toDate().getTime();
        var endTime = endMoment.toDate().getTime();

        // 날짜 비교 함수
        function isInvalidDateRange() {
          if (startMoment.isAfter(endMoment, "day")) {
            showAlert($translate.instant("CLIPS_ERR_DATE_SUBJECT"), $translate.instant("CLIPS_ERR_DATE_CONTENT"));
            return true;
          }
          return false;
        }

        // 시간 비교 함수
        function isInvalidTimeRange() {
          if (startTime >= endTime) {
            showAlert($translate.instant("CLIPS_ERR_TIME_SUBJECT"), $translate.instant("CLIPS_ERR_TIME_CONTENT"));
            return true;
          }
          if (endMoment.diff(startMoment) < 5000 || endMoment.diff(startMoment) > 7200000) {
            showAlert($translate.instant("CLIPS_ERR_TIME_SUBJECT"), $translate.instant("CAMERA_5SEC_120MIN_CLIP"));
            return true;
          }
          if (endMoment.isAfter(moment())) {
            showAlert($translate.instant("CLIPS_ERR_TIME_SUBJECT"), $translate.instant("CAMERA_END_TIME_AHEAD"));
            return true;
          }
          return false;
        }
        if (isInvalidDateRange() || isInvalidTimeRange()) return;
        var usageTotTime = $scope.$parent.config.usageTotTime;
        var usageTime = $scope.$parent.config.usageTime;
        var createTime = endMoment.diff(startMoment);
        if (usageTotTime < usageTime + createTime) {
          showAlert($translate.instant("CAMERA_CLIP_FULL"), $translate.instant("CAMERA_CLIP_FULL_DESC"));
          return;
        }
        var clipType = $scope.newClip.isSmart ? "2" : $scope.newClip.playrate === "1" ? "0" : "1";
        var params = {
          cameraId: $scope.$parent.currentCamera.id,
          labelName: $scope.newClip.name || $scope.newClip.defaultName,
          start: startTime,
          end: endTime,
          timeOverlay: $scope.newClip.timeOverlay,
          speedx: $scope.newClip.playrate,
          type: clipType
        };
        Clip.save(params, function (data) {
          var alertData = {
            title: $translate.instant("MENU_CLIP"),
            msg: data.code === "ok" ? $translate.instant("CLIPS_MAKE") : data.code === "nok" && data.ableTime !== undefined ? $translate.instant("CAMERA_CLIP_FULL_DESC") : $translate.instant("CLIPS_MAKE_CANNOT")
          };
          $rootScope.$broadcast("showAlert", alertData);
        }, function () {
          $rootScope.$broadcast("showAlert", {
            title: $translate.instant("ACCESS_NET_FAIL"),
            msg: $translate.instant("ACCESS_NET_FAIL_DESC")
          });
        });
        $scope.changeDialogState($scope.DIALOG_STATE.NONE);
      };
      $scope.changedZipTime = function () {
        var playrate = $scope.newClip.playrate;

        // Clip duration 및 output duration 업데이트
        var durationString = getClipDurationString(playrate);
        $scope.newClip.duration = durationString;
        $scope.newClip.outputDuration = durationString;
      };

      // 스마트 타임랩스 체크 변경 이벤트 (클립&타임랩스명 기본값 설정)
      $scope.changeSmartCheck = function (value) {
        $scope.newClip.isSmart = value;
        $scope.$apply();
      };

      // 달력 토글 함수 (시작 또는 종료)
      $scope.toggleClipCalendar = function (picker, event) {
        var _event$stopPropagatio;
        if (picker.isVisible()) {
          picker.hide();
        } else {
          $scope.closeAllDialog();
          picker.show();
        }
        event === null || event === void 0 ? void 0 : (_event$stopPropagatio = event.stopPropagation) === null || _event$stopPropagatio === void 0 ? void 0 : _event$stopPropagatio.call(event);
      };

      // 시간 선택 토글 함수 (시작 또는 종료)
      $scope.toggleClipTimePicker = function (isStart) {
        if (isStart ? $scope.isShowingStartTimePicker : $scope.isShowingEndTimePicker) {
          var momentTime = moment(isStart ? $scope.newClip.startTime : $scope.newClip.endTime, "HH : mm : ss");
          if (isStart) {
            setClipStartTimeMoment(momentTime);
            $scope.isShowingStartTimePicker = false;
          } else {
            setClipEndTimeMoment(momentTime);
            $scope.isShowingEndTimePicker = false;
          }
          $scope.closeAllDialog();
        } else {
          $scope.closeAllDialog();
          if (isStart) {
            $scope.isShowingStartTimePicker = true;
          } else {
            $scope.isShowingEndTimePicker = true;
          }
        }
      };
      $scope.toggleStartClipCalendar = function (event) {
        $scope.toggleClipCalendar($scope.clipStartDatePicker, event);
      };
      $scope.toggleEndClipCalendar = function (event) {
        $scope.toggleClipCalendar($scope.clipEndDatePicker, event);
      };
      $scope.toggleStartClipTimePicker = function () {
        $scope.toggleClipTimePicker(true);
      };
      $scope.toggleEndClipTimePicker = function () {
        $scope.toggleClipTimePicker(false);
      };
      $scope.hideClipCreate = function () {
        $scope.changeDialogState($scope.DIALOG_STATE.NONE);
      };
      $scope.closeAllDialog = function () {
        var _$scope$clipStartDate, _$scope$clipEndDatePi;
        (_$scope$clipStartDate = $scope.clipStartDatePicker) === null || _$scope$clipStartDate === void 0 ? void 0 : _$scope$clipStartDate.hide();
        (_$scope$clipEndDatePi = $scope.clipEndDatePicker) === null || _$scope$clipEndDatePi === void 0 ? void 0 : _$scope$clipEndDatePi.hide();
        $scope.isShowingStartTimePicker = false;
        $scope.isShowingEndTimePicker = false;
      };
      $scope.pressedStartHourUpButton = function () {
        $scope.newClip.startHour = pressedTimeUpButton($scope.newClip.startHour, 23);
      };
      $scope.pressedStartMinuteUpButton = function () {
        $scope.newClip.startMinute = pressedTimeUpButton($scope.newClip.startMinute, 59);
      };
      $scope.pressedStartSecondUpButton = function () {
        $scope.newClip.startSecond = pressedTimeUpButton($scope.newClip.startSecond, 59);
      };
      $scope.pressedStartHourDownButton = function () {
        $scope.newClip.startHour = pressedTimeDownButton($scope.newClip.startHour, 23);
      };
      $scope.pressedStartMinuteDownButton = function () {
        $scope.newClip.startMinute = pressedTimeDownButton($scope.newClip.startMinute, 59);
      };
      $scope.pressedStartSecondDownButton = function () {
        $scope.newClip.startSecond = pressedTimeDownButton($scope.newClip.startSecond, 59);
      };
      $scope.pressedEndHourDownButton = function () {
        $scope.newClip.endHour = pressedTimeDownButton($scope.newClip.endHour, 23);
      };
      $scope.pressedEndMinuteDownButton = function () {
        $scope.newClip.endMinute = pressedTimeDownButton($scope.newClip.endMinute, 59);
      };
      $scope.pressedEndSecondDownButton = function () {
        $scope.newClip.endSecond = pressedTimeDownButton($scope.newClip.endSecond, 59);
      };
      $scope.pressedEndHourUpButton = function () {
        $scope.newClip.endHour = pressedTimeUpButton($scope.newClip.endHour, 23);
      };
      $scope.pressedEndMinuteUpButton = function () {
        $scope.newClip.endMinute = pressedTimeUpButton($scope.newClip.endMinute, 59);
      };
      $scope.pressedEndSecondUpButton = function () {
        $scope.newClip.endSecond = pressedTimeUpButton($scope.newClip.endSecond, 59);
      };
      function formatTimeUnit(unit) {
        var parsedUnit = parseInt(unit, 10);
        return parsedUnit < 10 && unit.length < 2 ? "0" + parsedUnit : unit;
      }
      $scope.pressedStartClipTimeSelect = function () {
        if ($scope.newClip.startHour.length < 1 || $scope.newClip.startMinute.length < 1 || $scope.newClip.startSecond.length < 1) {
          showAlert($translate.instant("CAMERA_INPUT_ERROR"), $translate.instant("CAMERA_ENTER_TIME"));
          return;
        }
        $scope.newClip.startTime = [formatTimeUnit($scope.newClip.startHour), formatTimeUnit($scope.newClip.startMinute), formatTimeUnit($scope.newClip.startSecond)].join(" : ");
        $scope.isShowingStartTimePicker = false;
        $scope.newClip.duration = getClipDurationString();
        $scope.newClip.outputDuration = getClipDurationString($scope.newClip.playrate);
        var isValid = checkClipTime("start");
        if (isValid) {
          $scope.closeAllDialog();
          $timeout(function () {
            var _$scope$clipEndDatePi2;
            (_$scope$clipEndDatePi2 = $scope.clipEndDatePicker) === null || _$scope$clipEndDatePi2 === void 0 ? void 0 : _$scope$clipEndDatePi2.show();
          }, 0);
        }
      };
      $scope.pressedEndClipTimeSelect = function () {
        if ($scope.newClip.endHour.length < 1 || $scope.newClip.endMinute.length < 1 || $scope.newClip.endSecond.length < 1) {
          showAlert($translate.instant("CAMERA_INPUT_ERROR"), $translate.instant("CAMERA_ENTER_TIME"));
          return;
        }
        $scope.newClip.endTime = [formatTimeUnit($scope.newClip.endHour), formatTimeUnit($scope.newClip.endMinute), formatTimeUnit($scope.newClip.endSecond)].join(" : ");
        $scope.isShowingEndTimePicker = false;
        $scope.newClip.duration = getClipDurationString();
        $scope.newClip.outputDuration = getClipDurationString($scope.newClip.playrate);
        checkClipTime("end");
      };
      function checkClipTime() {
        var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "start";
        var isStart = duration === "start";
        var timeLimitThreshold = new Date().valueOf() - 2 * 60 * 1000;
        var moment = isStart ? getClipStartMoment() : getClipEndMoment();
        var setClipMoment = isStart ? setClipStartTimeMoment : setClipEndTimeMoment;
        if (moment && moment._d.valueOf() > timeLimitThreshold) {
          setClipMoment(timeLimitThreshold);
          if (isStart && getClipEndMoment()._d.valueOf() < moment._d.valueOf()) {
            setClipEndTimeMoment(timeLimitThreshold);
          }
          $rootScope.$broadcast("showAlert", {
            title: $translate.instant("CLIP_CREATE_CLIP_TITLE"),
            msg: $translate.instant("9rRqk7Vo_02458")
          });
          return false;
        }
        setClipMoment(moment);
        return true;
      }
      function showAlert(title, message) {
        $scope.showAlert = true;
        $scope.alertTitle = title;
        $scope.alertMessage = message;
      }
      function initDialog() {
        return _initDialog.apply(this, arguments);
      }
      function _initDialog() {
        _initDialog = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          var minDate;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (!($scope.$parent.shareDisable() == true)) {
                  _context.next = 2;
                  break;
                }
                return _context.abrupt("return");
              case 2:
                resetClipValue();
                minDate = moment().subtract(parseInt($scope.$parent.currentCamera.serviceType), "d");
                smartCheckbox = tCam.checkbox($scope.COMP_ID_MAP.SMART_CHECKBOX);
                if (smartCheckbox) {
                  smartCheckbox.on("changed", function (event) {
                    $scope.changeSmartCheck(event.value);
                  });
                  smartCheckbox.text = $translate.instant("CLIP_CREATE_SMART_TIMELAPSE") + " <span>(" + $translate.instant("CLIP_CREATE_SMART_TIMELAPSE_DETAIL") + ")</span>";
                }
                $scope.clipStartDatePicker = new Pikaday({
                  field: document.getElementById("clipStartDate" + ($scope.isFullScreen ? "_full" : "")),
                  format: $translate.instant("CLIP_CREATE_CLIP_DATE_FORMAT"),
                  minDate: minDate.toDate(),
                  maxDate: new Date(),
                  position: "bottom right",
                  onSelect: function onSelect() {
                    $scope.closeAllDialog();
                    $scope.isShowingStartTimePicker = true;
                    $scope.newClip.duration = getClipDurationString();
                    $scope.newClip.outputDuration = getClipDurationString($scope.newClip.playrate);
                  },
                  container: document.getElementById("start-calendar-container" + ($scope.isFullScreen ? "_full" : ""))
                });
                $scope.clipEndDatePicker = new Pikaday({
                  field: document.getElementById("clipEndDate" + ($scope.isFullScreen ? "_full" : "")),
                  format: $translate.instant("CLIP_CREATE_CLIP_DATE_FORMAT"),
                  minDate: minDate.toDate(),
                  maxDate: new Date(),
                  defaultDate: new Date(),
                  position: "bottom right",
                  onSelect: function onSelect() {
                    $scope.closeAllDialog();
                    $scope.isShowingEndTimePicker = true;
                    $scope.newClip.duration = getClipDurationString();
                    $scope.newClip.outputDuration = getClipDurationString($scope.newClip.playrate);
                  },
                  container: document.getElementById("end-calendar-container" + ($scope.isFullScreen ? "_full" : ""))
                });
                _context.next = 10;
                return Clip.availableRange({
                  cameraId: $scope.$parent.currentCamera.id,
                  type: "0"
                }, function (data) {
                  if (!data.end) {
                    data.end = new Date().getTime() - 10 * 60 * 1000;
                  }
                  $scope.newClip.startDate = moment(parseInt(data.end)).add(-10, "m").locale(Utils.getBrowserLanguage()).format($translate.instant("CLIP_CREATE_CLIP_DATE_FORMAT"));
                  $scope.newClip.endDate = moment(parseInt(data.end)).locale(Utils.getBrowserLanguage()).format($translate.instant("CLIP_CREATE_CLIP_DATE_FORMAT"));
                  setClipStartTimeMoment(moment(parseInt(data.end)).add(-10, "m"));
                  setClipEndTimeMoment(moment(parseInt(data.end)));
                  $scope.newClip.duration = getClipDurationString();
                  $scope.newClip.outputDuration = getClipDurationString($scope.newClip.playrate);
                });
              case 10:
                $timeout(function () {
                  var nameInput = document.getElementById("labs_name");
                  nameInput.focus();
                }, 100);
                $document.on("keydown", function (event) {
                  //IME 입력 중에는 처리하지 않도록
                  var isIMETyping = event.isComposing || event.key === "Process";
                  if (isIMETyping) {
                    return;
                  }
                  if (event.key === "Tab") {
                    var _$scope$clipStartDate3, _$scope$clipEndDatePi4;
                    event.preventDefault();
                    if ($scope.labsNameFocus) {
                      var _$scope$clipStartDate2;
                      $scope.closeAllDialog();
                      (_$scope$clipStartDate2 = $scope.clipStartDatePicker) === null || _$scope$clipStartDate2 === void 0 ? void 0 : _$scope$clipStartDate2.show();
                      $scope.labsNameFocus = false;
                    } else if ((_$scope$clipStartDate3 = $scope.clipStartDatePicker) !== null && _$scope$clipStartDate3 !== void 0 && _$scope$clipStartDate3.isVisible()) {
                      $scope.closeAllDialog();
                      $scope.isShowingStartTimePicker = true;
                    } else if ($scope.isShowingStartTimePicker) {
                      var _$scope$clipEndDatePi3;
                      $scope.closeAllDialog();
                      (_$scope$clipEndDatePi3 = $scope.clipEndDatePicker) === null || _$scope$clipEndDatePi3 === void 0 ? void 0 : _$scope$clipEndDatePi3.show();
                    } else if ((_$scope$clipEndDatePi4 = $scope.clipEndDatePicker) !== null && _$scope$clipEndDatePi4 !== void 0 && _$scope$clipEndDatePi4.isVisible()) {
                      $scope.closeAllDialog();
                      $scope.isShowingEndTimePicker = true;
                    } else if ($scope.isShowingEndTimePicker) {
                      $scope.closeAllDialog();
                    }
                    $timeout(function () {
                      $scope.$apply();
                    });
                  }
                });
              case 12:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return _initDialog.apply(this, arguments);
      }
      $scope.hideAlert = function () {
        $scope.showAlert = false;
      };
      $scope.$watch("isOpen", function (newValue) {
        if (newValue) {
          initDialog();
        } else {
          $scope.newClip = {
            playrate: "1",
            isSmart: false,
            timeOverlay: "No",
            outputDuration: "0s",
            placeholder: $translate.instant("CLIP_CREATE_CLIP_NEW_NAME"),
            name: "",
            defaultName: ""
          };
          $scope.changeDialogState($scope.DIALOG_STATE.NONE);
        }
      });
      $scope.$watch("labsNameFocus", function (newValue, oldValue) {
        if (!newValue) {
          var nameInput = document.getElementById("labs_name");
          $timeout(function () {
            nameInput === null || nameInput === void 0 ? void 0 : nameInput.blur();
            $scope.$digest();
          }, 0);
        }
      });
      $scope.$watch("newClip.playrate", function (newValue) {
        var text = newValue !== "1" ? $translate.instant("CLIP_CREATE_TIMELAPSE_NEW_NAME") : $translate.instant("CLIP_CREATE_CLIP_NEW_NAME");
        $scope.newClip.placeholder = text;
        $scope.newClip.defaultName = text;
      });
      $scope.$watch("newClip.isSmart", function (newValue) {
        if (newValue) {
          var text = $translate.instant("CAMERA_NEW_TIMELAPS");
          $scope.newClip.placeholder = text;
          $scope.newClip.defaultName = text;
        } else {
          var _text = $scope.newClip.playrate !== "1" ? $translate.instant("CLIP_CREATE_TIMELAPSE_NEW_NAME") : $translate.instant("CLIP_CREATE_CLIP_NEW_NAME");
          $scope.newClip.placeholder = _text;
          $scope.newClip.defaultName = _text;
        }
      });
    },
    templateUrl: "/templates/camera/clip_make_dialog.html" + "?t=" + window.buildTime
  };
});
"use strict";

app.directive("modalDialog", function () {
  return {
    restrict: "E",
    scope: {
      show: "=",
      title: "@",
      body: "@",
      icon: "@",
      onComplete: "&"
    },
    replace: true,
    transclude: true,
    link: function link(scope, Utils) {
      scope.hide = function () {
        scope.show = false;
      };
      scope.complete = function () {
        scope.show = false;
        if (scope.onComplete) {
          scope.onComplete();
        }
      };
    },
    templateUrl: "/templates/partials/modalDialog.html" + "?t=" + window.buildTime
  };
});
app.directive("translateImage", function ($translate) {
  return {
    restrict: "A",
    link: function link(scope, element, attrs) {
      var browserLanguage = Utils.getBrowserLanguage();
      if (browserLanguage.indexOf("-") > 0) {
        browserLanguage = browserLanguage.split("-")[0];
      }
      element[0].src = "/resources/images/" + browserLanguage + "/" + attrs.translateImage;
    }
  };
});
app.directive("focusMe", function ($timeout) {
  return {
    scope: {
      trigger: "=focusMe"
    },
    link: function link(scope, element) {
      scope.$watch("trigger", function (value) {
        if (value === true) {
          $timeout(function () {
            element[0].focus();
          });
        }
      });
    }
  };
});
app.directive("onEnter", function () {
  return {
    link: function link(scope, elements, attrs) {
      elements.bind("keydown keypress", function (event) {
        if (event.which === 13) {
          scope.$apply(function () {
            scope.$eval(attrs.onEnter);
          });
          event.preventDefault();
        }
      });
    }
  };
});
app.directive("onLnb", ["$rootScope", function ($rootScope) {
  return {
    restrict: "A",
    link: function link(scope, element, attrs) {
      element.bind("click", function () {
        $("#toastFooter").addClass("lnbOn");
        $rootScope.isLnbOff = false;
        $rootScope.$apply();
      });
    }
  };
}]);
app.directive("offLnb", ["$rootScope", function ($rootScope) {
  return {
    restrict: "A",
    link: function link(scope, element, attrs) {
      setTimeout(function () {
        if (!$rootScope.isLnbOff) {
          $("#toastFooter").addClass("lnbOn");
        } else {
          $("#toastFooter").removeClass("lnbOn");
        }
      }, 100);
      element.bind("click", function () {
        $("#toastFooter").removeClass("lnbOn");
        $rootScope.isLnbOff = true;
        $rootScope.$apply();
      });
      scope.$on("$destroy", function () {
        $("#toastFooter").removeClass("lnbOn");
      });
    }
  };
}]);
app.directive("maxNumber", [function () {
  return {
    restrict: "A",
    require: "ngModel",
    link: function link(scope, elem, attrs, ngModel) {
      var max = parseInt(attrs.maxNumber);
      scope.$watch(attrs.ngModel, function (newValue, oldValue) {
        if (parseInt(newValue) > max || isNaN(newValue)) {
          ngModel.$setViewValue(oldValue);
          ngModel.$render();
        }
      });
    }
  };
}]);

// 메인 페이지 이미지 필터 버튼 드래그 이벤트
app.directive("filterDrag", function ($document) {
  return function (scope, element, attr) {
    var startX = 0,
      x = 540;
    element.on("mousedown", function (event) {
      event.preventDefault();
      startX = event.screenX - x;
      $document.on("mousemove", mousemove);
      $document.on("mouseup", mouseup);
    });
    function mousemove(event) {
      x = event.screenX - startX;
      if (x < 0 + 23) {
        x = 0 + 23;
      } else if (x > 1080 - 23) {
        x = 1080 - 23;
      }
      element.parent().parent().css("width", x + "px");
    }
    function mouseup() {
      $document.off("mousemove", mousemove);
      $document.off("mouseup", mouseup);
    }
  };
});

// main page scroll 이벤트
app.directive("scrollPlay", function ($window, $document, $timeout) {
  return {
    restrict: "A",
    link: function link(scope, element, attrs) {
      // video tag 브라우저 지원여부 확인
      var isVideoSupport = !!document.createElement("video").canPlayType;
      if (isVideoSupport) {
        var previousScrollTop = 0,
          scrollLock = false;
        var scrollEvent = function scrollEvent() {
          var elemenHeight = element[0].clientHeight;
          var windowTop = this.pageYOffset;
          var elementTop = element[0].getBoundingClientRect().top + windowTop;
          if (element[0].tagName == "VIDEO") {
            if (elemenHeight / 2 + elementTop > 0 && windowTop < elemenHeight / 2 + elementTop) {
              element[0].play();
            } else {
              element[0].pause();
            }
          }
          scope.$apply();
        };

        // scroll bind
        angular.element($window).bind("scroll", scrollEvent);
        scope.$on("$destroy", function () {
          angular.element($window).off("scroll");
        });
      } // if
    }
  };
});

// 메인 페이지 서브 동영상 마우스 오버 재생 directive
app.directive("playMovie", function () {
  return {
    restrict: "A",
    link: function link(scope, element, attrs) {
      element.bind("mouseover", function () {
        element.find("video")[0].play();
        element.parent().css("color", "#4b96e6");
      });
      element.bind("mouseleave", function () {
        // element.find("video")[0].currentTime = '0';
        if (!element.find("video")[0].pause) {
          element.find("video")[0].pause();
        }
        element.parent().css("color", "#777");
      });
      scope.$on("$destroy", function () {
        element.off("mouseleave");
        element.off("mouseover");
      });
    }
  };
});

// 메인 페이지 최상단 이미지 로테이션
app.directive("rotateImage", ["$interval", function ($interval) {
  return {
    restrict: "A",
    link: function link(scope, element, attrs) {
      var imgLength = element.find("img").length;
      var currentInddex = 0;
      scope.rotation.order = 0;
      $interval(function () {
        currentInddex++;
        if (currentInddex >= imgLength) {
          currentInddex = 0;
        }
        scope.rotation.order = currentInddex;
      }, 3000);
    }
  };
}]);

// 모바일 메인 페이지 이미지 필터 터치 이벤트
app.directive("filterTouch", function ($document) {
  return function (scope, element, attr) {
    var imageWidth = element.parent().parent().parent()[0].scrollWidth;
    var buttonWidth = element[0].scrollWidth;
    var startX = 0,
      x = 445;
    element.on("touchstart", function (event) {
      event.preventDefault();
      startX = event.changedTouches[0].pageX - x;
      element.on("touchmove", touchmove);
      element.on("touchend", touchend);
    });
    function touchmove(event) {
      x = event.changedTouches[0].pageX - startX;
      if (x < 0 + buttonWidth / 2) {
        x = 0 + buttonWidth / 2;
      } else if (x > imageWidth - buttonWidth / 2) {
        x = imageWidth - buttonWidth / 2;
      }
      element.parent().parent().css("width", x + "px");
    }
    function touchend() {
      element.off("touchmove", touchmove);
      element.off("touchend", touchend);
    }
  };
});

// 모바일 메인페이지 영상 재생
app.directive("togglePlay", function () {
  return {
    restrict: "A",
    scope: true,
    link: function link(scope, element, attrs) {
      scope.isShowPoster = true;
      var isVideoSupport = !!document.createElement("video").canPlayType;
      var video = element.find("video");
      if (isVideoSupport) {
        element.on("click", function () {
          if (video[0].paused) {
            scope.isShowPoster = false;
            scope.$apply();
            video[0].play();
          }
        });
      }
      video[0].addEventListener("ended", function () {
        scope.isShowPoster = true;
        scope.$apply();
      });
      scope.$on("$destroy", function () {
        element.off("click");
      });
    }
  };
});
app.directive("compileTemplate", function ($compile, $parse) {
  return {
    link: function link(scope, element, attr) {
      var parsed = $parse(attr.ngBindHtml);
      function getStringValue() {
        return (parsed(scope) || "").toString();
      }

      // Recompile if the template changes
      scope.$watch(getStringValue, function () {
        $compile(element, null, -9999)(scope); // The -9999 makes it skip directives so that we do not recompile ourselves
      });
    }
  };
});
app.directive("fileOnChange", function () {
  return {
    restrict: "A",
    link: function link(scope, element, attrs) {
      var onChangeHandler = scope.$eval(attrs.fileOnChange);
      element.bind("change", onChangeHandler);
    }
  };
});
"use strict";

app.directive('didContentsDialog', function () {
  return {
    restrict: 'E',
    scope: {},
    replace: true,
    transclude: true,
    controller: function controller($scope, $rootScope, $translate, $state, $timeout, $interval, DidFile) {
      var searchObj = null;
      var regVideoPattern = /^.+\.(mp4|MP4)$/;
      var regImagePattern = /^.+\.(jpg|png|JPG|PNG)$/;
      var VOLUME_KB = 1024;
      var VOLUME_MB = VOLUME_KB * VOLUME_KB;
      var VOLUME_GB = VOLUME_KB * VOLUME_MB;
      // ! 사용량 4.8GB 부터 빨강색 텍스트 처리
      var VOLUME_WARNING_SIZE = VOLUME_GB * 4.8;
      // ! 최대 사용량 5GB
      var MAX_SIZE = 5;
      var MAX_VOLUME_GB = VOLUME_GB * MAX_SIZE;
      $scope.isAllChecked = false;
      $scope.loadContent = false;
      $scope.contents = [];
      $scope.checkedContents = [];
      $scope.searchValue = '';
      $scope.isContentEdit = false;
      $scope.dlgMaxHeight = '';
      $scope.sizeSumStr = '0MB';
      $scope.isWarningVolume = false;
      // ! 콘텐츠 사이즈
      $scope.sizeSumBite = 0;
      // ! 최대용량 5GB
      $scope.maxSize = MAX_SIZE;
      // ! toast message
      $scope.toast = {
        hasToast: false,
        message: '',
        timeout: 0
      };
      $scope.isSearchEmpty = false;
      function initDialog() {
        $('body').addClass('blockScroll');
        $scope.isContentEdit = $scope.$parent.isContentEdit;
        $scope.isAllChecked = false;
        $scope.loadContent = false;
        $scope.contents = [];
        $scope.checkedContents = [];
        $scope.searchValue = '';
        $scope.isSearchEmpty = false;
        buildSearchInput();
        fetchContents();
      }
      function buildSearchInput() {
        if (searchObj) {
          searchObj.destroy();
          searchObj = null;
        }
        searchObj = tCam.search('search_contents');
        searchObj.on('changed', function (event) {
          $scope.searchValue = event.value;
          if (!$scope.searchValue) {
            $scope.isSearchEmpty = false;
          } else {
            var hasContent = 0;
            $scope.contents.forEach(function (content) {
              if (unorm.nfc(content.fileName).indexOf(unorm.nfc($scope.searchValue)) !== -1) {
                hasContent++;
              }
            });
            $scope.isSearchEmpty = !hasContent;
          }
          $scope.$apply();
        });
        searchObj.placeholder = $translate.instant('5mw2slvk_02156');
        searchObj.boxStyle = {
          width: '220px',
          height: '32px',
          border: '1px solid #cccccc',
          borderRadius: '2px',
          backgroundColor: '#ffffff'
        };
        searchObj.design = 'search';
      }
      function updateCheckedContents() {
        var isAllChecked = true;
        $scope.checkedContents = [];
        $scope.contents.forEach(function (content) {
          // ! DID 관리 페이지내( didContentsCtrl.js )에 등록된 콘텐츠인지 판단
          var isAdded = false;
          ($scope.$parent && $scope.$parent.contentList || []).forEach(function (contentItem) {
            // ! unique 값이 fileName 밖에 없는 것으로 보임, checksum 도 중복 케이스 확인됨
            if (unorm.nfc(contentItem.fileName) === unorm.nfc(content.fileName)) {
              isAdded = true;
              return;
            }
          });
          content.isAdded = isAdded;
          if (content.isChecked) {
            $scope.checkedContents.push(content);
          } else {
            if (!content.isLoading && !content.isUploadFail && !content.isAdded) {
              isAllChecked = false;
            }
          }
        });
        $scope.isAllChecked = isAllChecked;
      }
      function fetchContents() {
        DidFile.api.getContents({
          userId: $rootScope.me.userId
        }, function (res) {
          $scope.contents = res.content ? res.content : [];
          // ! 5GB 제한 - API 확인 필요
          // $scope.maxSize = res.maxSize ? res.maxSize : 4;

          if (!$scope.isContentEdit) {
            if ($scope.$parent.editContType === 'video') {
              $scope.contents = $scope.contents.filter(function (content) {
                return regVideoPattern.test(content.fileName);
              });
            } else if ($scope.$parent.editContType === 'img') {
              $scope.contents = $scope.contents.filter(function (content) {
                return regImagePattern.test(content.fileName);
              });
            } else {
              // Except
              // var contentList = $scope.$parent.contentList;
              // contentList.forEach(function(content) {
              //     var i, len = $scope.contents.length;
              //     for (i = 0; i < len; i+=1) {
              //         if (content.contentId === $scope.contents[i].contentId) {
              //             $scope.contents.splice(i, 1);
              //             break;
              //         }
              //     }
              // });
            }
          }
          updateCheckedContents();
          updateSizeSum();
          $rootScope.$broadcast('didContentsChanged', $scope.contents.length);
        }, function (err) {
          $scope.contents = [];
          updateCheckedContents();
          updateSizeSum();
        });
      }
      function makeMsgId() {
        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        for (var i = 0; i < 30; i++) text += possible.charAt(Math.floor(Math.random() * possible.length));
        return text;
      }
      function updateSizeSum() {
        var sumBite = $scope.contents.reduce(function (acc, cont) {
          return acc + (cont.fileSize ? cont.fileSize : 0);
        }, 0);
        if (sumBite >= VOLUME_GB) {
          $scope.sizeSumStr = Number((sumBite / VOLUME_GB).toFixed(3)).toFixed(2) + 'GB';
        } else if (sumBite >= VOLUME_MB) {
          $scope.sizeSumStr = Number((sumBite / VOLUME_MB).toFixed(3)).toFixed(2) + 'MB';
        } else {
          $scope.sizeSumStr = Number((sumBite / VOLUME_KB).toFixed(3)).toFixed(2) + 'KB';
        }
        $scope.sizeSumBite = sumBite;
        $scope.isWarningVolume = sumBite >= VOLUME_WARNING_SIZE;
      }
      $scope.isSearchMathing = function (fileName) {
        return $scope.searchValue && unorm.nfc(fileName).indexOf(unorm.nfc($scope.searchValue)) !== -1;
      };
      $scope.showToastMessage = function (message) {
        $scope.toast.message = message;
        $scope.toast.hasToast = true;
        if ($scope.toast.timeout) {
          $timeout.cancel($scope.toast.timeout);
        }
        $scope.toast.timeout = $timeout(function () {
          $scope.toast.hasToast = false;
          $scope.toast.message = '';
        }, 1000 * 3);
      };
      $scope.saveContents = function () {
        var selectedContents = $scope.contents.filter(function (content) {
          return content.isChecked;
        });
        if (!selectedContents.length) {
          return;
        }
        $rootScope.$broadcast('saveContents', {
          contents: selectedContents
        });
        $scope.closeDialog();
      };
      $scope.removeContents = function () {
        $rootScope.createConfirm({
          title: $translate.instant('5mw2slvk_02204'),
          description: $translate.instant('5mw2slvk_02205'),
          noCloseBtn: true,
          handler: function handler() {
            var cotentIds = $scope.contents.filter(function (content) {
              return content.isChecked;
            }).map(function (content) {
              return content.contentId;
            }).join(',');
            if (!cotentIds) {
              return;
            }
            $scope.isUpdate = true;
            $scope.$apply();
            $.ajax({
              url: '/json/biz/didContents/' + $rootScope.me.userId + '/contents?contentIds=' + cotentIds,
              type: "DELETE",
              success: function success(dataStr) {
                var dataJSON = JSON.parse(dataStr);
                if (dataJSON.code === 'ok') {
                  fetchContents();
                }
                $scope.isUpdate = false;
                $scope.$apply();
              },
              error: function error(e) {
                $scope.isUpdate = false;
                $scope.$apply();
              }
            });
          }
        });
      };
      $scope.fileChangeHandler = function (evt) {
        var hasSameFile = false;
        var uploadId, file, fileName, fileSize;

        // ! 파일 포맷
        if (!this.value || !(regVideoPattern.test(this.value) || regImagePattern.test(this.value))) {
          $rootScope.createConfirm({
            description: $translate.instant('5mw2slvk_02206'),
            noCloseBtn: true,
            btnCount: 1
          });
          this.value = null;
          return $scope.$apply();
        }

        // ! 파일 유효성 체크
        if (this.files && this.files[0]) {
          file = this.files[0];
          fileName = unorm.nfc(file.name.replace(/([^\./]+$)/, function ($1) {
            return $1.toLocaleLowerCase();
          }));
          fileSize = file.size;
          hasSameFile = false;

          // ! 용량 제한
          if (fileSize && fileSize > VOLUME_GB * 2) {
            $rootScope.createConfirm({
              description: $translate.instant('mn1k4t8s_01751'),
              confirmText: $translate.instant('mn1k4t8s_01707'),
              noCloseBtn: true,
              btnCount: 1
            });
            this.value = null;
            return $scope.$apply();
          }

          // ! 최대 사용 용량
          if ($scope.sizeSumBite + fileSize > MAX_VOLUME_GB) {
            // mn1k4t8s_01761
            // $scope.showToastMessage('최대 ' + $scope.maxSize + 'GB까지 업로드 가능합니다');
            $scope.showToastMessage($translate.instant('mn1k4t8s_01761').replace(/\dGB/, $scope.maxSize + 'GB'));
            this.value = null;
            return $scope.$apply();
          }

          // ! 파일명 업로드 불가 특수문자 포함 체크
          var invalidSpecialChar = /[!@#$%^&*(),?":{}|<>]/gi.test(fileName);
          if (invalidSpecialChar) {
            // 파일명에는 ~ 허용가능한 특수문자 안내 문구 노출
            $rootScope.createConfirm({
              title: $translate.instant('mn1k4t8s_01780'),
              description: $translate.instant('mn1k4t8s_01778'),
              confirmText: $translate.instant('mn1k4t8s_01707'),
              noCloseBtn: false,
              btnCount: 1
            });
            this.value = null;
            return $scope.$apply();
          }

          // ! 동일한 파일명 체크
          $scope.contents.forEach(function (content) {
            if (unorm.nfc(content.name) === fileName) {
              hasSameFile = true;
              return;
            }
          });
          if (hasSameFile) {
            // $scope.showToastMessage('동일한 이름의 파일이 있습니다. 확인 후 다시 추가해주세요.');
            $scope.showToastMessage($translate.instant('mn1k4t8s_01763'));
            this.value = null;
            return $scope.$apply();
          }
        }
        uploadId = makeMsgId();
        $scope.contents.splice(0, 0, {
          fileName: this.value,
          isLoading: true,
          isChecked: false,
          percent: 0,
          uploadId: uploadId
        });
        $scope.$apply();
        DidFile.uploadFile(this, uploadId);

        // ! 추가된 파일 위치, 스크롤 이동 처리
        if ($('[data-el="js-contents-list"]').length) {
          $('[data-el="js-contents-list"]').stop().animate({
            scrollTop: 0,
            duration: 0
          });
        }
      };
      $scope.toggleAllSelect = function () {
        if (!$scope.contents.length || $scope.$parent.selectedLayout === 'split') {
          return;
        }
        $scope.isAllChecked = !$scope.isAllChecked;
        $scope.contents.forEach(function (content) {
          if (content.isLoading || content.isUploadFail) {
            return;
          }
          if (!content.isAdded) {
            content.isChecked = $scope.isAllChecked;
          }
        });
        updateCheckedContents();
      };
      $scope.toggleCotentSelect = function (content) {
        if (!content || content.isLoading || content.isUploadFail) return;
        if ($scope.$parent.selectedLayout === 'split') {
          $scope.contents.forEach(function (cont) {
            if (cont.contentId === content.contentId) {
              return;
            }
            cont.isChecked = false;
          });
        }
        content.isChecked = !content.isChecked;
        updateCheckedContents();
      };
      $scope.closeDialog = function () {
        $scope.$parent.isShowDidContentsDialog = false;
        if (searchObj) {
          searchObj.destroy();
          searchObj = null;
        }
        $('body').removeClass('blockScroll');
      };
      $scope.removeUploadFailCont = function (content) {
        var i, len;
        for (i = 0, len = $scope.contents.length; i < len; i += 1) {
          if ($scope.contents[i].uploadId === content.uploadId) {
            $scope.contents.splice(i, 1);
            return;
          }
        }
      };
      $scope.$on('did-file-upload', function (event, data) {
        var i, len;
        for (i = 0, len = $scope.contents.length; i < len; i += 1) {
          if ($scope.contents[i].uploadId === data.uploadId) {
            if (data.type === 'progress') {
              $scope.contents[i].percent = data.data;
              $scope.$apply();
            } else if (data.type === 'result') {
              if (data.result) {
                $scope.contents[i] = data.content;
                $rootScope.$broadcast('didContentsChanged', $scope.contents.length);
                updateSizeSum();
              } else {
                $scope.contents[i].isUploadFail = true;
              }
              $scope.$apply();
            }
            return;
          }
        }
      });
      function updateDlgStyle() {
        var marginTopSize = 100;
        var windowHeight = $(window).height();
        $scope.dlgMaxHeight = windowHeight - marginTopSize + 'px';
      }
      $scope.$parent.$watch('isShowDidContentsDialog', function (newValue, oldValue) {
        if (newValue !== oldValue) {
          if (newValue === true) {
            updateDlgStyle();
            initDialog();
          }
        }
      });
    },
    templateUrl: '/templates/manage/did_contents_dialog.html' + '?t=' + window.buildTime
  };
});
"use strict";

app.directive('didDetailDialog', function () {
  return {
    restrict: 'E',
    scope: {},
    replace: true,
    transclude: true,
    controller: function controller($scope, $rootScope, $translate, $state, $timeout, $interval, $location, $window, Shop, User) {
      $scope.isNameEditMode = false;
      $scope.didName = '';
      $scope.didNameToEdit = '';
      $scope.dlgMaxHeight = '';
      $scope.DIALOG_STATE = {
        DETAIL: 'detail',
        SETTING: 'setting',
        NONE: 'none'
      };
      $scope.selectDid = null;
      $scope.isLoadingEvent = false;
      var shopId;
      $scope.changeDialogState = function (state) {
        $scope.isShowDidDetailDialog = false;
        $scope.isShowCameraSelectDialog = false;
        $scope.isShowDidSettingDialog = false;
        if (state === $scope.DIALOG_STATE.DETAIL) {
          $scope.isShowDidDetailDialog = true;
        } else if (state === $scope.DIALOG_STATE.SETTING) {
          $scope.isShowDidSettingDialog = true;
        } else {
          $scope.$parent.isShowDidSetDialog = false;
        }
      };
      $scope.didDelete = function () {
        $rootScope.createConfirm({
          title: $translate.instant('mn1k4t8s_01756'),
          description: $translate.instant('mn1k4t8s_01757'),
          confirmText: $translate.instant('BUTTON_DELETE'),
          handler: function handler() {
            Shop.deleteDid({
              shopId: shopId,
              didId: $scope.$parent.selectDid.didId
            }, function (data) {
              if (data.code === 'ok') {
                $rootScope.$broadcast('didUpdate');
                $scope.changeDialogState($scope.DIALOG_STATE.NONE);
              }
            });
          }
        });
      };
      $scope.goDidContentsSet = function () {
        User.me(function (data) {
          if (data.code === "ok") {
            $rootScope.me = data;
            if (!$rootScope.me || !$rootScope.me.useDid) {
              $rootScope.createConfirm({
                description: $translate.instant("mn1k4t8s_01754"),
                noCloseBtn: true,
                btnCount: 1
              });
              return;
            }
            $('body').removeClass('blockScroll');
            $state.go('main.manage.didcontents', {
              didId: $scope.$parent.selectDid.didId,
              shopId: shopId,
              didName: $scope.didName,
              shopName: $scope.$parent.shopObject ? $scope.$parent.shopObject.shopName : ''
            });
          }
        });
      };
      function showAlert(title, message) {
        $scope.showAlert = true;
        $scope.alertTitle = title;
        $scope.alertMessage = message;
      }
      function getDidDetailInfo() {
        if (!$scope.$parent.selectDid && !$scope.$parent.isShared) {
          return;
        }
        $scope.didName = $scope.$parent.selectDid.labelName;
        $scope.isLoadingEvent = true;
        // ! 매장 목록 > DID 관리, 관리 > DID 유입 케이스
        Shop.getDidInfo({
          shopId: shopId,
          didId: $scope.$parent.selectDid.didId
        }, function (res) {
          if (res.did) {
            $scope.isManage = res.isOwner;
            $scope.selectDid = res.did;

            // ! 설치일자
            if (!$scope.selectDid.installDateText && $scope.selectDid.regDate) {
              var installDateText = moment(new Date($scope.selectDid.regDate));
              $scope.selectDid.installDateText = installDateText.isValid() ? installDateText.format('YYYY.MM.DD') : '';
            }

            // ! 설치매장
            if (!$scope.selectDid.shopName) {
              $scope.selectDid.shopName = $scope.$parent.shopName || $scope.$parent.shopObject.shopName;
            }
          }
          if (res.didContentList) {
            $scope.contentList = res.didContentList;
          }
          $scope.isLoadingEvent = false;
        }, function (err) {
          $scope.isLoadingEvent = false;
          showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
        });
      }
      function initDialog() {
        var scrollTop = $(document).scrollTop();
        $scope.dialogTop = scrollTop < 175 ? 175 : scrollTop;
        $scope.isNameEditMode = false;
        $scope.didNameToEdit = '';
        if ($scope.$parent.shopObject) {
          shopId = $scope.$parent.shopObject.shopId;
        }
        $scope.isManage = $scope.$parent.isManage;
        getDidDetailInfo();
        $scope.changeDialogState($scope.DIALOG_STATE.DETAIL);
      }
      $scope.hideAlert = function () {
        $scope.showAlert = false;
      };
      $scope.setDidName = function (didName) {
        if ($scope.didName === didName) {
          $scope.setDidNameEditMode(false);
          return;
        }
        Shop.setDidName({
          shopId: shopId,
          didId: $scope.$parent.selectDid.didId
        }, {
          didName: didName
        }, function (res) {
          if (res.code === "ok") {
            $scope.didName = didName;
            $rootScope.$broadcast('didUpdate');
          }
          $scope.setDidNameEditMode(false);
        }, function (err) {
          $scope.setDidNameEditMode(false);
          showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
        });
      };
      $scope.setDidNameEditMode = function (isOn) {
        if (isOn) {
          $scope.didNameToEdit = $scope.didName;
        }
        $scope.isNameEditMode = isOn;
      };
      function updateDlgStyle() {
        var marginTopSize = 100;
        var windowHeight = $(window).height();
        var maxHeight = Math.min(windowHeight - marginTopSize, 580);
        $scope.dlgMaxHeight = maxHeight + 'px';
      }
      $scope.$parent.$watch('isShowDidSetDialog', function (newValue, oldValue) {
        if (newValue !== oldValue) {
          if (newValue === true) {
            $('body').addClass('blockScroll');
            updateDlgStyle();
            initDialog();
          } else {
            $('body').removeClass('blockScroll');
          }
        }
      });
    },
    templateUrl: '/templates/shop/did_detail_dialog.html' + '?t=' + window.buildTime
  };
});
"use strict";

app.directive("groupShareDialog", function () {
  return {
    restrict: "E",
    scope: {
      //show: '@',
    },
    replace: true,
    transclude: true,
    controller: function controller($scope, $rootScope, $translate, $state, $location, $window, Shop, CameraGroup, Monitor) {
      $scope.countryDomain = $("html").attr("lang");
      $scope.isShowGroupShareOptionConfigDialog = false;
      $scope.shareReceivers = [];
      $scope.shareAddModel = {
        receiverId: "",
        receiverName: ""
      };
      $scope.PMS_CHECKBOX_ID = "pms_checkbox";
      var pmsCheckbox = null;
      var selectedGroupShareId = "";
      function showAlert(title, message) {
        $scope.showAlert = true;
        $scope.alertTitle = title;
        $scope.alertMessage = message;
      }
      $scope.hideAlert = function () {
        $scope.showAlert = false;
      };
      function destroyCheckbox() {
        if (pmsCheckbox) {
          pmsCheckbox.destroy();
          pmsCheckbox = null;
        }
      }
      $scope.$parent.$watch("isShowGroupShareDialog", function (newValue, oldValue) {
        if (newValue !== oldValue) {
          if (newValue === true) {
            $scope.updateSharedReceivers();
            destroyCheckbox();
            if ($scope.$parent.currentGroup && $scope.$parent.currentGroup.depth == 1) {
              pmsCheckbox = tCam.checkbox($scope.PMS_CHECKBOX_ID);
              pmsCheckbox.text = $translate.instant("9rRqk7Vo_02113");
            }
          } else {
            $rootScope.destroyConfirm();
            destroyCheckbox();
          }
        }
      });
      $scope.hideDialog = function () {
        $scope.$parent.isShowGroupShareDialog = false;
      };
      $scope.shareGroup = function () {
        CameraGroup.shareGroup({
          groupId: $scope.$parent.currentGroup.groupId
        }, {
          receiverId: $scope.shareAddModel.receiverId,
          receiverName: $scope.shareAddModel.receiverName,
          subgroupPermission: pmsCheckbox ? pmsCheckbox.value : false
        }, function (res) {
          if (res.code === "ok") {
            $scope.shareAddModel.receiverId = "";
            $scope.shareAddModel.receiverName = "";
            $scope.updateSharedReceivers();
          } else {
            if (res.errorCode == "1") {
              showAlert($translate.instant("STR_GROUP_SHARE_SET"), $translate.instant("STR_CHECK_EMAIL_ADDR"));
            } else if (res.errorCode == "2") {
              showAlert($translate.instant("STR_GROUP_SHARE_SET"), $translate.instant("STR_NO_REGISTER_ID") + "<br>" + $translate.instant("STR_CHECK_EMAIL_ADDR"));
            } else if (res.errorCode == "3") {
              showAlert($translate.instant("STR_GROUP_SHARE_SET"), $translate.instant("STR_ALREADY_REGISTERED_GROUP"));
            } else if (res.errorCode == "4") {
              showAlert($translate.instant("STR_GROUP_SHARE_SET"), $translate.instant("STR_ALREADY_REGISTERED_GROUP") + "<br>" + $translate.instant("STR_ONLY_SHARE_SUB_GROUP"));
            } else {
              showAlert($translate.instant("STR_GROUP_SHARE_SET"), $translate.instant("ERROR_HAPPEN"));
            }
          }
        }, function (err) {
          showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
        });
      };
      $scope.saveGroupShareOption = function (event) {
        CameraGroup.updateGroupShareOption({
          shareId: selectedGroupShareId
        }, {
          subgroupPermission: event.value[0].value
        }, function (res) {
          if (res.code === "ok") {
            $scope.updateSharedReceivers();
          } else {
            showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
          }
        }, function (err) {
          showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
        });
      };

      /**
       * 클라우드 모니터 권한체크 및 처리
       */
      $scope.checkMonitorAccess = function () {
        Monitor.api.getInfo({}, function (data) {
          if (data.code === "ok") {
            if (data.isCloudMonitorUser) {
              $scope.isShowShareConfirm = true;
            } else {
              $scope.addGroupShare();
            }
          } else {
            showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
          }
        }, function (err) {
          showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
        });
      };
      $scope.addGroupShare = function () {
        if (!$scope.shareAddModel.receiverId) {
          showAlert($translate.instant("STR_GROUP_SHARE_SET"), $translate.instant("STR_CHECK_EMAIL_ADDR"));
          return;
        } else if (!$scope.shareAddModel.receiverName) {
          showAlert($translate.instant("STR_GROUP_SHARE_SET"), $translate.instant("ACCESS_ENTER_NAME"));
          return;
        }
        if ($scope.$parent.currentGroup) {
          CameraGroup.checkGroupShare({
            groupId: $scope.$parent.currentGroup.groupId,
            receiverId: $scope.shareAddModel.receiverId,
            receiverName: $scope.shareAddModel.receiverName,
            subgroupPermission: pmsCheckbox ? pmsCheckbox.value : false
          }, function (res) {
            if (res.code === "ok") {
              $scope.shareGroup();
            } else {
              if (res.errorCode == "1") {
                showAlert($translate.instant("STR_GROUP_SHARE_SET"), $translate.instant("9rRqk7Vo_02171") + "<br>" + $translate.instant("STR_CHECK_EMAIL_ADDR"));
              } else if (res.errorCode == "2") {
                showAlert($translate.instant("STR_GROUP_SHARE_SET"), $translate.instant("STR_NO_REGISTER_ID") + "<br>" + $translate.instant("STR_CHECK_EMAIL_ADDR"));
              } else if (res.errorCode == "3") {
                showAlert($translate.instant("STR_GROUP_SHARE_SET"), $translate.instant("STR_ALREADY_REGISTERED_GROUP"));
              } else if (res.errorCode == "4") {
                showAlert($translate.instant("STR_GROUP_SHARE_SET"), $translate.instant("STR_ALREADY_REGISTERED_GROUP") + "<br>" + $translate.instant("STR_ONLY_SHARE_SUB_GROUP"));
              } else if (res.errorCode == "5") {
                $scope.showShopShareConfirmDialog();
              } else {
                showAlert($translate.instant("STR_GROUP_SHARE_SET"), $translate.instant("ERROR_HAPPEN"));
              }
            }
          });
        } else {
          showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
        }
      };
      $scope.updateSharedReceivers = function () {
        CameraGroup.getSharedGroupReceivers({
          groupId: $scope.$parent.currentGroup.groupId
        }, function (res) {
          $scope.shareReceivers = res;
          if ($scope.shareReceivers) {
            $scope.shareReceivers.forEach(function (item) {
              item.depth = $scope.$parent.currentGroup.depth;
            });
            $scope.$parent.currentGroup.shareCount = $scope.shareReceivers.length;
          } else {
            $scope.$parent.currentGroup.shareCount = 0;
          }
        }, function (err) {});
      };
      $scope.cancelGroupShare = function () {
        CameraGroup.removeGroupShare({
          shareId: selectedGroupShareId
        }, function (res) {
          selectedGroupShareId = "";
          $scope.hideGroupShareCancelDialog();
          $scope.updateSharedReceivers();
        }, function (err) {});
      };
      $scope.showShopShareConfirmDialog = function () {
        $scope.isShowShopShareConfirm = true;
      };
      $scope.hideShopShareConfirmDialog = function () {
        $scope.isShowShopShareConfirm = false;
      };
      $scope.showGroupShareSetDialog = function (shareId, subgroupPermission) {
        selectedGroupShareId = shareId;
        $rootScope.createConfirm({
          title: $translate.instant("CAMERA_SHARE_SET_CHANGE"),
          width: 382,
          theme: "checker",
          pCheckList: [{
            id: "shareOpt1",
            text: $translate.instant("9rRqk7Vo_02113"),
            value: subgroupPermission
          }],
          handler: $scope.saveGroupShareOption
        });
      };
      $scope.showGroupShareCancelDialog = function (shareId) {
        selectedGroupShareId = shareId;
        $scope.isShowGroupShareCancelDialog = true;
      };
      $scope.hideGroupShareCancelDialog = function () {
        $scope.isShowGroupShareCancelDialog = false;
      };
      $scope.showGroupShareOptionConfigDialog = function () {
        $scope.isShowGroupShareOptionConfigDialog = true;
      };
    },
    templateUrl: "/templates/cameraGroup/group_share_dialog.html" + "?t=" + window.buildTime
  };
});
"use strict";

app.directive('iothubSetDialog', function () {
  return {
    restrict: 'E',
    scope: {
      //show: '@',
    },
    replace: true,
    transclude: true,
    controller: function controller($scope, $rootScope, $translate, $timeout, $interval, $state, $location, $window, Device) {
      $scope.dlgMaxHeight = '';
      $scope.ledToggleId = 'led-toggle';
      $scope.isEditingName = false;
      $scope.editName = '';
      $scope.showRemoveDevAlert = false;
      $scope.hasSensor = false;
      var ledToggleComp = null;
      var netConfigPollingId = null;
      $scope.NET_IP_MODE = {
        DHCP: 'dhcp',
        STATIC: 'static'
      };
      $scope.NET_TYPE = {
        LTE: 1,
        WIFI: 2,
        WIRE: 4
      };
      $scope.netToastObj = {
        showNetToast: false,
        netToastMsg: '',
        timeoutObj: null
      };
      $scope.DIALOG_STATE = {
        BASIC: 'basic',
        NETWORK: 'network',
        WIFI_SET: 'wifi_set',
        ACTIVE_NET: 'active_net',
        WIFI_CHANGE: 'wifi_change',
        WIRE_SET: 'wire_set',
        NONE: 'none'
      };
      $scope.configStatus = $scope.DIALOG_STATE.BASIC;
      $scope.netAvailsMap = {
        wifi: {
          label: 'Wi-Fi',
          value: $scope.NET_TYPE.WIFI
        }
      };
      $scope.ipModeMap = {
        "static": {
          label: $translate.instant('9rRqk7Vo_02225'),
          value: $scope.NET_IP_MODE.STATIC
        },
        dhcp: {
          label: $translate.instant('9rRqk7Vo_02224'),
          value: $scope.NET_IP_MODE.DHCP
        }
      };
      $scope.netInfoShowFlag = false;
      $scope.curActiveNetwork = '';
      $scope.requestActiveNetwork = '';
      $scope.isRequestedActiveNet = false;
      var activeReqTimeout = null;
      $scope.wireNetEditObj = {
        ipMode: '',
        localIp: '',
        gateway: '',
        subnetmask: ''
      };
      $scope.wifiEditObj = {
        ssid: '',
        wifiAuthMethod: '8',
        wifiPassword: '',
        eap: '0',
        secPhase: '1',
        userId: '',
        userPassword: ''
      };
      $scope.checkIpAddr = function (ipAddr) {
        var pattern = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/;
        return pattern.test(ipAddr);
      };
      $scope.getWireNetSavable = function () {
        if (!$scope.networkConfig) {
          return false;
        }
        if ($scope.networkConfig.controlStatus !== 'on' || !$scope.netAvailsMap.wire) {
          return false;
        }
        if ($scope.wireNetEditObj.ipMode === $scope.NET_IP_MODE.DHCP) {
          return $scope.wireNetEditObj.ipMode !== $scope.networkConfig.ipMode;
        }
        // IP_MODE.STATIC
        if ($scope.wireNetEditObj.ipMode === $scope.networkConfig.ipMode && $scope.wireNetEditObj.localIp === $scope.networkConfig.localIp && $scope.wireNetEditObj.gateway === $scope.networkConfig.gateway && $scope.wireNetEditObj.subnetmask === $scope.networkConfig.subnetmask) {
          return false;
        }
        if (!$scope.checkIpAddr($scope.wireNetEditObj.localIp) || !$scope.checkIpAddr($scope.wireNetEditObj.gateway) || !$scope.checkIpAddr($scope.wireNetEditObj.subnetmask)) {
          return false;
        }
        return true;
      };
      $scope.getWifiSavable = function () {
        if (!$scope.networkConfig) {
          return false;
        }
        if ($scope.networkConfig.controlStatus !== 'on' || !$scope.wifiEditObj.ssid) {
          return false;
        }
        if ($scope.wifiEditObj.wifiAuthMethod == 2 || $scope.wifiEditObj.wifiAuthMethod == 4 || $scope.wifiEditObj.wifiAuthMethod == 8) {
          if (!$scope.wifiEditObj.wifiPassword) {
            return false;
          }
        }
        if ($scope.wifiEditObj.wifiAuthMethod == 9) {
          if (!$scope.wifiEditObj.userPassword) {
            return false;
          }
        }
        return true;
      };
      $scope.saveWireNet = function () {
        if ($scope.getWireNetSavable() === false) {
          return;
        }
        var networkConfig = {
          ipMode: $scope.wireNetEditObj.ipMode
        };
        if (networkConfig.ipMode === 'static') {
          networkConfig.localIp = $scope.wireNetEditObj.localIp;
          networkConfig.gateway = $scope.wireNetEditObj.gateway;
          networkConfig.subnetmask = $scope.wireNetEditObj.subnetmask;
        }
        Device.setHubNetworkIp({
          id: $scope.$parent.selectIotHubConfig.id
        }, networkConfig, function (data) {
          if (data.code === 'ok') {
            $scope.requestActiveNetwork = $scope.NET_TYPE.WIRE;
            $scope.isRequestedActiveNet = true;
            if (activeReqTimeout) {
              clearTimeout(activeReqTimeout);
            }
            activeReqTimeout = setTimeout(function () {
              $scope.isRequestedActiveNet = false;
              $scope.requestActiveNetwork = $scope.curActiveNetwork;
            }, 120 * 1000);
            $scope.setting_change($scope.DIALOG_STATE.NETWORK);
            $scope.showNetToastMsg($translate.instant('9rRqk7Vo_02230'));
          }
        }, function (err) {});
      };
      $scope.saveWifiSetting = function () {
        if ($scope.getWifiSavable() === false) {
          return;
        }
        var editObj;
        if ($scope.wifiEditObj.wifiAuthMethod == 9) {
          editObj = {
            ssid: $scope.wifiEditObj.ssid,
            isWifiSetup: "YES",
            wifiAuthMethod: $scope.wifiEditObj.wifiAuthMethod,
            e: $scope.wifiEditObj.eap + ':0:' + $scope.wifiEditObj.secPhase + ':' + $scope.wifiEditObj.userId + ':' + $scope.wifiEditObj.userPassword + ':'
          };
        } else {
          editObj = {
            ssid: $scope.wifiEditObj.ssid,
            isWifiSetup: "YES",
            wifiAuthMethod: $scope.wifiEditObj.wifiAuthMethod,
            wifiPassword: $scope.wifiEditObj.wifiPassword
          };
        }
        Device.update({
          id: $scope.$parent.selectIotHubConfig.id
        }, editObj, function (data) {
          if (data.code == "ok") {
            $scope.requestSsid = $scope.wifiEditObj.ssid;
            $scope.requestActiveNetwork = $scope.NET_TYPE.WIFI;
            $scope.isRequestedActiveNet = true;
            if (activeReqTimeout) {
              clearTimeout(activeReqTimeout);
            }
            activeReqTimeout = setTimeout(function () {
              $scope.isRequestedActiveNet = false;
              $scope.requestActiveNetwork = $scope.curActiveNetwork;
            }, 120 * 1000);
            $scope.setting_change($scope.DIALOG_STATE.NETWORK);
            $scope.showNetToastMsg($translate.instant('9rRqk7Vo_02230'));
          }
        });
      };
      $scope.showNetToastMsg = function (msg) {
        if (msg === 'no_active_net') {
          $scope.netToastObj.netToastMsg = $translate.instant('9rRqk7Vo_02229');
        } else {
          $scope.netToastObj.netToastMsg = msg ? msg : $translate.instant('9rRqk7Vo_02243');
        }
        $scope.netToastObj.showNetToast = true;
        if ($scope.netToastObj.timeoutObj) {
          $timeout.cancel($scope.netToastObj.timeoutObj);
        }
        $scope.netToastObj.timeoutObj = $timeout(function () {
          $scope.netToastObj.showNetToast = false;
          $scope.netToastObj.timeoutObj = null;
        }, 3000);
      };
      function getNetAvails(networkAvailables) {
        var lte = 1 << 0;
        var wifi = 1 << 1;
        var wire = 1 << 2;
        var result = {};
        result.wifi = {
          label: 'Wi-Fi',
          value: $scope.NET_TYPE.WIFI
        };
        if (networkAvailables & lte) {
          result.lte = {
            label: 'LTE',
            value: $scope.NET_TYPE.LTE
          };
        }
        if (networkAvailables & wire) {
          result.wire = {
            label: $translate.instant('9rRqk7Vo_02231'),
            value: $scope.NET_TYPE.WIRE
          };
        }
        return result;
      }
      function netAvailMapCheck() {
        return Object.keys($scope.netAvailsMap).length > 1;
      }
      function updateNetInfo(networkConfig) {
        if (!networkConfig) {
          return;
        }
        $scope.netAvailsMap = getNetAvails(networkConfig.networkAvailables);
        $scope.curActiveNetwork = networkConfig.networkActive;
        if ($scope.isRequestedActiveNet) {
          if ($scope.requestActiveNetwork === $scope.curActiveNetwork) {
            if ($scope.requestActiveNetwork === $scope.NET_TYPE.WIFI) {
              if ($scope.requestSsid) {
                if (networkConfig.ssid === $scope.requestSsid) {
                  $scope.isRequestedActiveNet = false;
                }
              } else {
                $scope.isRequestedActiveNet = false;
              }
            } else {
              $scope.isRequestedActiveNet = false;
            }
          }
        } else {
          if (!$scope.requestActiveNetwork) {
            $scope.requestActiveNetwork = $scope.curActiveNetwork;
          }
        }
        $scope.wireNetEditObj.ipMode = networkConfig.ipMode;
        $scope.wireNetEditObj.localIp = networkConfig.localIp;
        $scope.wireNetEditObj.gateway = networkConfig.gateway;
        $scope.wireNetEditObj.subnetmask = networkConfig.subnetmask;
        $scope.wifiEditObj.ssid = networkConfig.ssid;
      }
      function netConfigPollingStart() {
        netConfigPollingStop();
        netConfigPollingId = $interval(function () {
          if ($scope.isShared) {
            return;
          }
          Device.getHubNetworkConfig({
            id: $scope.$parent.selectIotHubConfig.id
          }, function (data) {
            if (data.code === 'ok') {
              $scope.networkConfig = data.networkConfig;
              updateNetInfo($scope.networkConfig);
            }
          }, function () {
            //TODO:
            updateNetInfo($scope.networkConfig);
          });
        }, 3000);
      }
      function netConfigPollingStop() {
        if (netConfigPollingId) {
          $interval.cancel(netConfigPollingId);
          netConfigPollingId = null;
        }
      }
      function stopNetToastTimeout() {
        if ($scope.netToastObj.timeoutObj) {
          $timeout.cancel($scope.netToastObj.timeoutObj);
          $scope.netToastObj.showNetToast = false;
          $scope.netToastObj.timeoutObj = null;
        }
      }
      $scope.requestChangeActiveNet = function (value) {
        $scope.requestActiveNetwork = value;
        if ($scope.requestActiveNetwork === $scope.curActiveNetwork) {
          return;
        }
        $scope.isRequestedActiveNet = true;
        if (activeReqTimeout) {
          clearTimeout(activeReqTimeout);
        }
        activeReqTimeout = setTimeout(function () {
          $scope.isRequestedActiveNet = false;
          $scope.requestActiveNetwork = $scope.curActiveNetwork;
        }, 120 * 1000);
        Device.setHubActiveNetwork({
          id: $scope.$parent.selectIotHubConfig.id
        }, {
          networkActive: $scope.requestActiveNetwork
        }, function (data) {
          if (data.code === 'ok') {
            $scope.showNetToastMsg($translate.instant('9rRqk7Vo_02230'));
            $scope.setting_change($scope.DIALOG_STATE.NETWORK);
          }
        }, function (err) {
          showAlert($translate.instant('ACCESS_NET_FAIL'), $translate.instant('ACCESS_NET_FAIL_DESC'));
        });
      };
      $scope.setting_change = function (status) {
        if (status === $scope.DIALOG_STATE.ACTIVE_NET) {
          if (!$scope.networkConfig.isNetworkActiveEditable) {
            $scope.isRequestedActiveNet = false;
            $scope.requestActiveNetwork = $scope.curActiveNetwork;
            $scope.showNetToastMsg($translate.instant('9rRqk7Vo_02244'));
            return;
          }
          if ($scope.networkConfig.controlStatus !== 'on' || netAvailMapCheck() === false) {
            $scope.showNetToastMsg($translate.instant('9rRqk7Vo_02229'));
            return;
          }
          $scope.requestActiveNetwork = $scope.curActiveNetwork;
        }
        $scope.configStatus = status;
        if (status === $scope.DIALOG_STATE.NETWORK) {
          stopNetToastTimeout();
          if ($scope.isShared) {
            return;
          }
          Device.getHubNetworkConfig({
            id: $scope.$parent.selectIotHubConfig.id
          }, function (data) {
            if (data.code === 'ok') {
              $scope.networkConfig = data.networkConfig;
              updateNetInfo($scope.networkConfig);
            }
          }, function () {
            //TODO:
            updateNetInfo($scope.networkConfig);
          });
          netConfigPollingStart();
        } else {
          netConfigPollingStop();
        }
      };
      function showAlert(title, message) {
        $scope.showAlert = true;
        $scope.alertTitle = title;
        $scope.alertMessage = message;
      }
      $scope.hideAlert = function () {
        $scope.showAlert = false;
      };

      /* Name Setting */
      $scope.setEditNameMode = function (isEdit) {
        if (isEdit) {
          $scope.isEditingName = true;
          $scope.editName = $scope.$parent.selectIotHubConfig.labelName;
        } else {
          $scope.isEditingName = false;
        }
      };
      $scope.changeName = function () {
        Device.updateDeviceConfig({
          deviceType: 'IOTHUB',
          deviceId: $scope.$parent.selectIotHubConfig.id
        }, {
          "labelName": $scope.editName
        }, function (res) {
          if (res.code === 'ok') {
            $scope.$parent.selectIotHubConfig.labelName = $scope.editName;
            $rootScope.$broadcast('deviceUpdate', '');
          }
          $scope.setEditNameMode(false);
        }, function (err) {
          showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
          $scope.setEditNameMode(false);
        });
      };

      /* Firmware Upgrade */
      $scope.firmwareUpgrade = function () {
        $scope.devUpagradeAlert = false;
        Device.firmwareUpgrade({
          deviceType: 'IOTHUB',
          deviceId: $scope.$parent.selectIotHubConfig.id
        }, {}, function (data) {
          showAlert($translate.instant("CAMERA_UPGRADE"), $translate.instant("CAMERA_UPGRADE_MSG_START"));
        }, function (err) {
          showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
        });
      };
      $scope.confirmUpgrade = function () {
        if ($scope.$parent.selectIotHubConfig.controlStatus === 'on') {
          $scope.devUpagradeAlert = true;
        } else {
          showAlert($translate.instant("CAMERA_UPGRADE"), $translate.instant("9rRqk7Vo_02162"));
        }
      };

      /* Remove Device */
      $scope.showRemoveDevConfirm = function () {
        $scope.hasSensor = $scope.$parent.selectIotHubConfig.sensors && $scope.$parent.selectIotHubConfig.sensors.length;
        $scope.showRemoveDevAlert = true;
      };
      $scope.removeDevice = function () {
        $scope.showRemoveDevAlert = false;
        Device.removeDevice({
          deviceType: 'IOTHUB',
          deviceId: $scope.$parent.selectIotHubConfig.id
        }, function (res) {
          if (res.code === 'ok') {
            $scope.$parent.isShowIothubSetDialog = false;
            $rootScope.$broadcast('deviceUpdate', '');
          } else {
            showAlert($translate.instant("9rRqk7Vo_02124"), res.msg ? res.msg : $translate.instant("ACCESS_FAIL"));
          }
        }, function (err) {
          showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
        });
      };

      /* Sensor List */
      $scope.convertSensorTypeStr = function (type) {
        switch (type) {
          case 'TEMP_HUMID':
            return $translate.instant('STR_TEMP_HUMID');
          case 'MOTION':
            return $translate.instant('EVENT_LIST_MOTION');
          case 'MAGNETIC':
            return $translate.instant('STR_DOOR_OPEN');
          case 'DOORLOCK':
            return $translate.instant('STR_MAIN_BIZ_44');
          case 'GAS':
            return $translate.instant('STR_GAS');
          case 'SMOKE':
            return $translate.instant('STR_SMOKE');
          case 'PLUG':
            return $translate.instant('STR_PLUG');
          default:
            return '';
        }
      };
      $scope.goSensorDetail = function (sensorId) {
        $rootScope.$broadcast('sensorDetail', sensorId);
      };
      $scope.toggleNetInfo = function (event) {
        $scope.netInfoShowFlag = !$scope.netInfoShowFlag;
        event.stopPropagation();
      };

      /* Led Setting */
      function ledToggleHandler(event) {
        Device.updateDeviceConfig({
          deviceType: 'IOTHUB',
          deviceId: $scope.$parent.selectIotHubConfig.id
        }, {
          "ledLight": event.value ? 'on' : 'off'
        }, function (res) {
          if (res.code === 'ok') {
            $scope.$parent.selectIotHubConfig.ledLight = event.value ? 'on' : 'off';
            $rootScope.$broadcast('deviceUpdate', '');
          }
          ledToggleComp.value = $scope.$parent.selectIotHubConfig.ledLight === 'on';
        }, function (err) {
          showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
          ledToggleComp.value = $scope.$parent.selectIotHubConfig.ledLight === 'on';
        });
      }

      /* Dialog */
      function updateDlgStyle() {
        var marginTopSize = 50;
        var windowHeight = $(window).height();
        $scope.dlgMaxHeight = windowHeight - marginTopSize + 'px';
      }
      function initDialog() {
        $('body').addClass('blockScroll');
        updateDlgStyle();
        $('body').click('on', layerClick);
        $scope.isShared = $scope.$parent.isShared == true || $scope.$parent.isShared == "true";
        if (!$scope.isShared) {
          ledToggleComp = tCam.toggle($scope.ledToggleId);
          ledToggleComp.on('changed', ledToggleHandler);
          ledToggleComp.value = $scope.$parent.selectIotHubConfig.ledLight === 'on';
        }
      }
      function layerClick(e) {
        if (e.target.className.indexOf('wire_set_info_wrap') === -1 && e.target.parentElement.className.indexOf('wire_set_info_wrap') === -1) {
          if ($scope.netInfoShowFlag) {
            $scope.netInfoShowFlag = false;
            $scope.$apply();
          }
        }
      }
      $scope.changeDialogState = function (state) {
        stopNetToastTimeout();
        if (state === $scope.DIALOG_STATE.BASIC) {
          //
        } else if (state === $scope.DIALOG_STATE.NONE) {
          $('body').removeClass('blockScroll');
          $('body').off('click', layerClick);
          netConfigPollingStop();
          if (ledToggleComp) {
            ledToggleComp.destroy();
            ledToggleComp = null;
          }
          $scope.configStatus = $scope.DIALOG_STATE.BASIC;
        }
      };
      $scope.$parent.$watch('isShowIothubSetDialog', function (newValue, oldValue) {
        if (newValue !== oldValue) {
          if (newValue === true) {
            initDialog();
          } else {
            $scope.changeDialogState($scope.DIALOG_STATE.NONE);
          }
        }
      });
      $scope.hideIothubSetDialog = function () {
        $scope.$parent.isShowIothubSetDialog = false;
      };
      $scope.$on('$destroy', function () {
        if (activeReqTimeout) {
          clearTimeout(activeReqTimeout);
          activeReqTimeout = null;
        }
        $scope.changeDialogState($scope.DIALOG_STATE.NONE);
      });
    },
    templateUrl: '/templates/shop/iothub_set_dialog.html' + '?t=' + window.buildTime
  };
});
"use strict";

app.directive("loadingComponent", function () {
  return {
    restrict: "E",
    replace: true,
    scope: {
      isFullscreen: "=",
      isLoading: "="
    },
    transclude: true,
    controller: function controller($scope, $rootScope, $translate, $state, $timeout) {
      $scope.$watch("isLoading", function (newValue) {
        if (newValue) {
          var rootContainer = document.getElementById("rootContainer");
          $timeout(function () {
            rootContainer.style.overflow = "hidden";
            rootContainer.style.height = "100vh";
          }, 0);
        }
      });
    },
    templateUrl: "/templates/common/loading.html" + "?t=" + window.buildTime
  };
});
"use strict";

app.directive('lockFaceCamSelectDialog', function () {
  return {
    restrict: 'E',
    scope: {},
    replace: true,
    transclude: true,
    controller: function controller($scope, $rootScope, $translate, $state, $timeout, $interval, $q, Camera, Shop, CameraConfig, AiFace) {
      function initDialog() {
        $scope.shopId = $scope.$parent.shopId ? $scope.$parent.shopId : '';
        $scope.originSelectCams = [];
        $scope.aiCameras = [];
        fetchCams();
      }
      function camSelectedCheck(selectCams) {
        $scope.aiCameras.forEach(function (item) {
          selectCams.some(function (cam) {
            item.isChecked = item.id === cam.id;
            return item.isChecked;
          });
        });
      }
      function fetchCams() {
        if ($scope.$parent.shopObject.controllerList) {
          $scope.$parent.shopObject.controllerList.forEach(function (item) {
            if (item.cameraInfo && item.cameraInfo.isAiSupport === 1 && item.cameraInfo.aiType === 2) {
              $scope.aiCameras.push(item.cameraInfo);
            }
          });
          $scope.aiCameras.sort(function (a, b) {
            var aLabel, bLabel;
            aLabel = a.labelName.toLowerCase();
            bLabel = b.labelName.toLowerCase();
            return aLabel < bLabel ? -1 : aLabel > bLabel ? 1 : 0;
          });
          if ($scope.aiCameras.length) {
            AiFace.doorlockSetting({
              sensorId: $scope.$parent.selectSensor.id
            }, function (res) {
              if (res.config && res.config.cameras && res.config.cameras.length) {
                $scope.originSelectCams = res.config.cameras;
                camSelectedCheck(res.config.cameras);
              }
            }, function (err) {});
          }
        }
      }
      $scope.checkCamera = function (camera) {
        camera.isChecked = !camera.isChecked;
      };
      function deleteCamera(deleteCams) {
        var deferred = $q.defer();
        if (!deleteCams.length) {
          $timeout(function () {
            deferred.reject();
          }, 0);
        } else {
          AiFace.doorlockDeleteCamera({
            sensorId: $scope.$parent.selectSensor.id,
            cameraIds: deleteCams.map(function (p) {
              return p.id;
            }).join()
          }, function (res) {
            deferred.resolve();
          }, function (err) {
            deferred.reject();
          });
        }
        return deferred.promise;
      }
      function addCamera(addCams) {
        var deferred = $q.defer();
        if (!addCams.length) {
          $timeout(function () {
            deferred.reject();
          }, 0);
        } else {
          AiFace.doorlockAddCamera({
            sensorId: $scope.$parent.selectSensor.id
          }, {
            cameraIds: addCams.map(function (p) {
              return p.id;
            }).join()
          }, function (res) {
            deferred.resolve();
          }, function (err) {
            deferred.reject();
          });
        }
        return deferred.promise;
      }
      $scope.saveCamera = function () {
        var selectCams = [];
        $scope.aiCameras.forEach(function (camera) {
          if (camera.isChecked) {
            selectCams.push(camera);
          }
        });
        var deleteCams = $scope.originSelectCams.filter(function (originCam) {
          var isInclude = selectCams.some(function (selectCam) {
            return selectCam.id === originCam.id;
          });
          return !isInclude;
        });
        var addCams = selectCams.filter(function (selectCam) {
          var isNotNew = $scope.originSelectCams.some(function (originCam) {
            return originCam.id === selectCam.id;
          });
          return !isNotNew;
        });
        deleteCamera(deleteCams).then(function () {
          addCamera(addCams).then(function () {
            $rootScope.$broadcast('updateDoorlockFaceSet', null);
            $scope.closeDialog();
          }, function () {
            $rootScope.$broadcast('updateDoorlockFaceSet', null);
            $scope.closeDialog();
          });
        }, function () {
          addCamera(addCams).then(function () {
            $rootScope.$broadcast('updateDoorlockFaceSet', null);
            $scope.closeDialog();
          }, function () {
            $scope.closeDialog();
          });
        });
      };
      $scope.originSelectCams = [];
      $scope.aiCameras = [];
      $scope.shopId = '';
      $scope.closeDialog = function () {
        $scope.$parent.isShowLockFaceCamDialog = false;
      };
      $scope.$parent.$watch('isShowLockFaceCamDialog', function (newValue, oldValue) {
        if (newValue !== oldValue) {
          if (newValue === true) {
            initDialog();
          } else {}
        }
      });
    },
    templateUrl: '/templates/shop/lock_face_cam_select_dialog.html' + '?t=' + window.buildTime
  };
});
"use strict";

app.directive('lockFacePeopleSelectDialog', function () {
  return {
    restrict: 'E',
    scope: {},
    replace: true,
    transclude: true,
    controller: function controller($scope, $rootScope, $translate, $state, $timeout, $interval, $q, AiFace) {
      function initDialog() {
        $scope.loadPeople = false;
        $scope.searchName = '';
        $scope.groupName = '';
        $scope.originSelectPeopleList = [];
        $scope.peopleList = [];
        $scope.searchMap = {};
        $scope.fetchPeople($rootScope.me.userId);
        // $timeout(function() {
        //     document.getElementById('group_input').focus();
        // }, 0);
      }
      $scope.loadPeople = false;
      $scope.searchName = '';
      $scope.groupName = '';
      $scope.peopleList = [];
      $scope.originSelectPeopleList = [];
      $scope.searchMap = {};
      $scope.getSearchMapLength = function () {
        return Object.keys($scope.searchMap).length;
      };
      $scope.checkIsShowPeople = function (people) {
        var isShow = false;
        if (!$scope.searchName) {
          isShow = true;
        } else {
          isShow = people.name.indexOf($scope.searchName) !== -1;
        }
        if (isShow) {
          $scope.searchMap[people.id] = isShow;
        } else {
          delete $scope.searchMap[people.id];
        }
        return isShow;
      };
      $scope.closeDialog = function () {
        $scope.$parent.isShowLockFacePeopleDialog = false;
      };
      $scope.checkedLength = function () {
        var count = 0;
        $scope.peopleList.forEach(function (people) {
          if (people.isChecked) {
            count += 1;
          }
        });
        return count ? count : '';
      };
      function deletePeople(deletePersons) {
        var deferred = $q.defer();
        if (!deletePersons.length) {
          $timeout(function () {
            deferred.reject();
          }, 0);
        } else {
          AiFace.doorlockDeletePerson({
            sensorId: $scope.$parent.selectSensor.id,
            personIds: deletePersons.map(function (p) {
              return p.id;
            }).join()
          }, function (res) {
            deferred.resolve();
          }, function (err) {
            deferred.reject();
          });
        }
        return deferred.promise;
      }
      function addPeople(addPersons) {
        var deferred = $q.defer();
        if (!addPersons.length) {
          $timeout(function () {
            deferred.reject();
          }, 0);
        } else {
          AiFace.doorlockAddPerson({
            sensorId: $scope.$parent.selectSensor.id
          }, {
            personIds: addPersons.map(function (p) {
              return p.id;
            }).join()
          }, function (res) {
            deferred.resolve();
          }, function (err) {
            deferred.reject();
          });
        }
        return deferred.promise;
      }
      $scope.savePeopleList = function () {
        var selectPersons = [];
        $scope.peopleList.forEach(function (people) {
          if (people.isChecked) {
            selectPersons.push(people);
          }
        });
        var deletePersons = $scope.originSelectPeopleList.filter(function (originPerson) {
          var isInclude = selectPersons.some(function (selectPerson) {
            return selectPerson.id === originPerson.id;
          });
          return !isInclude;
        });
        var addPersons = selectPersons.filter(function (selectPerson) {
          var isNotNew = $scope.originSelectPeopleList.some(function (originPerson) {
            return originPerson.id === selectPerson.id;
          });
          return !isNotNew;
        });
        deletePeople(deletePersons).then(function () {
          addPeople(addPersons).then(function () {
            $rootScope.$broadcast('updateDoorlockFaceSet', null);
            $scope.closeDialog();
          }, function () {
            $rootScope.$broadcast('updateDoorlockFaceSet', null);
            $scope.closeDialog();
          });
        }, function () {
          addPeople(addPersons).then(function () {
            $rootScope.$broadcast('updateDoorlockFaceSet', null);
            $scope.closeDialog();
          }, function () {
            $scope.closeDialog();
          });
        });
      };
      function peopleSelectedCheck(selectPersons) {
        $scope.peopleList.forEach(function (item) {
          selectPersons.some(function (person) {
            item.isChecked = item.id === person.id;
            return item.isChecked;
          });
        });
      }
      $scope.fetchPeople = function (userId) {
        $scope.loadPeople = true;
        AiFace.persons({
          userId: userId
        }).$promise.then(function (res) {
          $scope.loadPeople = false;
          $scope.peopleList = res.persons ? res.persons : [];
          if ($scope.peopleList.length) {
            AiFace.doorlockSetting({
              sensorId: $scope.$parent.selectSensor.id
            }, function (res) {
              if (res.config && res.config.persons && res.config.persons.length) {
                $scope.originSelectPeopleList = res.config.persons;
                peopleSelectedCheck(res.config.persons);
              }
            }, function (err) {});
          }
        }, function (err) {
          $scope.loadPeople = false;
        });
      };
      $scope.$parent.$watch('isShowLockFacePeopleDialog', function (newValue, oldValue) {
        if (newValue !== oldValue) {
          if (newValue === true) {
            initDialog();
          } else {}
        }
      });
    },
    templateUrl: '/templates/shop/lock_face_people_select_dialog.html' + '?t=' + window.buildTime
  };
});
"use strict";

var mod;
mod = angular.module('custom-infinite-scroll', []);
mod.directive('customInfiniteScroll', ['$timeout', function ($timeout) {
  return {
    link: function link(scope, elem, attrs) {
      var x = null;
      var rangeUnderDetection = attrs.customInfiniteRangeUnderDetection;
      scope.template = angular.element(['<div class="of_y of_y_thum">', '<img src="/resources/img/progress_rolling_blue.svg" style="display:block;margin:auto; width:70px;height:70px; ">', '</div>'].join(''))[0];
      var removeTag = function removeTag() {
        var divTags = elem[0].getElementsByClassName('of_y of_y_thum')[0];
        if (divTags) {
          elem.off('scroll');
          divTags.remove();
          elem[0].scrollBy(0, divTags.scrollHeight);
        }
      };
      var handler = function handler() {
        if (calcDetection()) {
          if (x == null) {
            elem.append(scope.template); // appendTag 
            x = $timeout(function () {
              x = null;
              removeTag();
              elem.on('scroll', handler);
              return scope.$apply(attrs.customInfiniteScroll);
            }, attrs.customInfiniteDelay ? attrs.customInfiniteDelay : 500);
          } else {
            removeTag();
            $timeout(function () {
              elem.on('scroll', handler);
            }, attrs.customInfiniteDelay ? attrs.customInfiniteDelay : 500);
          }
        }
      };
      var calcDetection = function calcDetection() {
        var element = elem[0];
        if (!element) return false;
        var scrollTop = element.scrollTop;
        var clientHeight = element.clientHeight;
        var scrollHeight = element.scrollHeight;
        var scrollPosition = scrollTop + clientHeight;
        var allowRange = scrollHeight - (rangeUnderDetection ? rangeUnderDetection : 0);
        var isExistScroll = scrollHeight !== 0;
        return scrollPosition > allowRange && isExistScroll;
      };
      elem.on('scroll', handler);
      scope.$on('$destroy', function () {
        return elem.off('scroll'); //, handler);
      });
      return $timeout(function () {
        return handler();
      }, 0);
    }
  };
}]);
"use strict";

app.directive('autoPopup', function ($timeout) {
  return function (scope, element, attrs) {
    scope.$watch(attrs.ngShow, function (newValue) {
      $timeout(function () {
        var top = $(this).scrollTop() + 500;
        element.attr("style", "top:" + top + "px; position: absolute;");
      });
    }, true);
  };
});
app.directive('autoPopup2', function ($timeout) {
  return function (scope, element, attrs) {
    scope.$watch(attrs.ngShow, function (newValue) {
      $timeout(function () {
        var top = $(this).scrollTop() + 150;
        element.attr("style", "top:" + top + "px; position: absolute;");
      });
    }, true);
  };
});
app.directive('autoPopup3', function ($timeout) {
  return function (scope, element, attrs) {
    scope.$watch(attrs.ngShow, function (newValue) {
      $timeout(function () {
        var top = $(this).scrollTop();
        element.attr("style", "top:" + top + "px; position: absolute;");
      });
    }, true);
  };
});
app.directive('autoPopup4', function ($timeout) {
  return function (scope, element, attrs) {
    scope.$watch(attrs.ngShow, function (newValue) {
      $timeout(function () {
        var top = $(this).scrollTop() + 500;
        element.attr("style", "top:" + top + "px; position: absolute; width: 710px;");
      });
    }, true);
  };
});
app.directive('autoPopup5', function ($timeout) {
  return function (scope, element, attrs) {
    scope.$watch(attrs.ngShow, function (newValue) {
      $timeout(function () {
        var top = $(this).scrollTop() + 100;
        element.attr("style", "top:" + top + "px; position: absolute;");
      });
    }, true);
  };
});
"use strict";

app.directive('sensorDetailDialog', function () {
  return {
    restrict: 'E',
    scope: {},
    replace: true,
    transclude: true,
    controller: function controller($scope, $rootScope, $translate, $state, $timeout, $interval, $location, $window, $q, Shop, Camera, Sensor, Doorlock, AiFace) {
      $scope.protocol = $location.protocol() + '://';
      $scope.sensorDetail = null;
      $scope.sensorEvent = null;
      $scope.selectCameraId = '';
      $scope.selectedEvent = null;
      $scope.sensorEvents = [];
      $scope.latestEvents = [];
      $scope.shopCameraList = [];
      $scope.calendar = [];
      $scope.dateStr = '';
      $scope.isEditingSensorName = false;
      $scope.isEditingTempNotifyConfig = false;
      $scope.isLoadingEvent = false;
      $scope.sensor_power_err = false;
      $scope.sensor_err_flag = false;
      $scope.isCurrentDate = false;
      $scope.editSensorName = '';
      $scope.tempNotifyConfig = null;
      $scope.editTempNotifyConfig = null;
      $scope.dlgMaxHeight = '';
      $scope.doorlockFaceUse = false;
      $scope.doorlockFaceCameras = [];
      $scope.doorlockFacePersons = [];
      $scope.DIALOG_STATE = {
        EVENT: 'event',
        DETAIL: 'detail',
        SETTING: 'setting',
        CAM: 'cam',
        PW_CHANGE: 'pw_change',
        PW_TIME_CHANGE: 'pw_time_change',
        FACE_SET: 'face_set',
        NONE: 'none'
      };
      $scope.curStateToReturn = $scope.DIALOG_STATE.NONE;
      $scope.prevStateToGo = $scope.DIALOG_STATE.NONE;
      $scope.browserLang = $("html").attr("lang");
      var shopId,
        circleProgress = null,
        isOnCircleProgress = false,
        pollingIntervalId,
        pollingSensorIntervalId,
        pollingPwIntervalId,
        pollingDoorlockPwStatus,
        showNoticeId;
      var validStartDatePicker = null,
        validEndDatePicker = null,
        doorlockPwValidTempObj = null;
      $scope.changeDialogState = function (state) {
        $scope.isShowSensorEventDialog = false;
        $scope.isShowSensorDetailDialog = false;
        $scope.isShowCameraSelectDialog = false;
        $scope.isShowSensorSettingDialog = false;
        $scope.isShowDoorlockPwDialog = false;
        $scope.isShowDoorlockPwTimeDialog = false;
        $scope.isShowFaceSetDialog = false;
        isOnCircleProgress = false;
        if (circleProgress && circleProgress.destroy) {
          circleProgress.destroy();
          circleProgress = null;
        }
        stopPollingDoorlockStatus();
        stopPollingPlugStatus();
        if (state === $scope.DIALOG_STATE.EVENT) {
          $scope.prevStateToGo = $scope.curStateToReturn;
          $scope.curStateToReturn = state;
          if ($scope.$parent.selectSensor.sensorType === 'DOORLOCK' || $scope.$parent.selectSensor.sensorType === 'PLUG') {
            if ($scope.selectedEvent && $scope.selectedEvent.regDate) {
              initSelectDate($scope.selectedEvent.regDate);
            }
            $scope.isCurrentDate = checkDateDiffFromToday() === 0 ? true : false;
            getSensorEventList();
          }
          $scope.isShowSensorEventDialog = true;
        } else if (state === $scope.DIALOG_STATE.DETAIL) {
          $scope.prevStateToGo = $scope.curStateToReturn;
          $scope.isShowSensorDetailDialog = true;
        } else if (state === $scope.DIALOG_STATE.SETTING) {
          $scope.prevStateToGo = $scope.curStateToReturn;
          $scope.curStateToReturn = state;
          if ($scope.$parent.selectSensor.sensorType === 'DOORLOCK') {
            if (!$scope.sensor_power_err) {
              getLatestEvent();
              startPollingDoorlockStatus();
            }
          } else if ($scope.$parent.selectSensor.sensorType === 'PLUG') {
            if (!$scope.sensor_power_err) {
              getLatestEvent();
              startPollingPlugStatus();
            }
          }
          $scope.isShowSensorSettingDialog = true;
        } else if (state === $scope.DIALOG_STATE.CAM) {
          $scope.selectCameraId = $scope.sensorDetail.connectedCameraId;
          $scope.isShowCameraSelectDialog = true;
        } else if (state === $scope.DIALOG_STATE.PW_CHANGE) {
          $scope.door_pw = '';
          $scope.isShowDoorlockPwDialog = true;
        } else if (state === $scope.DIALOG_STATE.PW_TIME_CHANGE) {
          $scope.isShowDoorlockPwTimeDialog = true;
        } else if (state === $scope.DIALOG_STATE.FACE_SET) {
          $scope.isShowFaceSetDialog = true;
          fetchDoorlockSetting();
        } else {
          if ($scope.datePicker) {
            $scope.datePicker.destroy();
            $scope.datePicker = null;
          }
          $scope.prevStateToGo = $scope.DIALOG_STATE.NONE;
          $scope.curStateToReturn = $scope.DIALOG_STATE.NONE;
          $scope.$parent.isShowSensorSetDialog = false;
          $scope.isLoadingEvent = false;
          $scope.isCurrentDate = false;
          $scope.sensorDetail = null;
          $scope.sensorEvent = null;
          $scope.selectCameraId = '';
          $scope.selectedEvent = null;
          $scope.tempNotifyConfig = null;
          $scope.editTempNotifyConfig = null;
          $scope.isEditingSensorName = false;
          $scope.isEditingTempNotifyConfig = false;
          $scope.editSensorName = '';
          $scope.sensorEvents = [];
          $scope.latestEvents = [];
          $scope.shopCameraList = [];
          $scope.calendar = [];
          $scope.dateStr = '';
          if (validStartDatePicker) {
            validStartDatePicker.destroy();
            validStartDatePicker = null;
          }
          if (validEndDatePicker) {
            validEndDatePicker.destroy();
            validEndDatePicker = null;
          }
          $scope.targetDate = null;
        }
      };
      $scope.toggleFaceUse = function () {
        var originValue = $scope.doorlockFaceUse;
        var changeValue = !$scope.doorlockFaceUse;
        $scope.doorlockFaceUse = changeValue;
        AiFace.updateDoorlockFaceUse({
          sensorId: $scope.$parent.selectSensor.id
        }, {
          isUse: changeValue
        }, function (res) {
          if (res.code === 'ok') {
            $scope.doorlockFaceUse = changeValue;
            if ($scope.sensorDetail) {
              $scope.sensorDetail.useDoorLockFaceDetect = changeValue;
            }
          } else {
            $scope.doorlockFaceUse = originValue;
          }
        }, function (err) {
          $scope.doorlockFaceUse = originValue;
        });
      };
      function fetchDoorlockSetting() {
        AiFace.doorlockFaceUse({
          sensorId: $scope.$parent.selectSensor.id
        }, function (res) {
          $scope.doorlockFaceUse = res.isUse;
        }, function (err) {});
        AiFace.doorlockSetting({
          sensorId: $scope.$parent.selectSensor.id
        }, function (res) {
          $scope.doorlockFaceCameras = res.config && res.config.cameras ? res.config.cameras : [];
          $scope.doorlockFaceCameras.sort(function (a, b) {
            var aLabel, bLabel;
            aLabel = a.label.toLowerCase();
            bLabel = b.label.toLowerCase();
            return aLabel < bLabel ? -1 : aLabel > bLabel ? 1 : 0;
          });
          $scope.doorlockFacePersons = res.config && res.config.persons ? res.config.persons : [];
        }, function (err) {
          $scope.doorlockFaceCameras = [];
          $scope.doorlockFacePersons = [];
        });
      }
      $scope.$on('updateDoorlockFaceSet', function () {
        fetchDoorlockSetting();
      });
      function showAlert(title, message) {
        $scope.showAlert = true;
        $scope.alertTitle = title;
        $scope.alertMessage = message;
      }
      function convertChartLabelToInt(elementId) {
        var i,
          len,
          valueList = [],
          $labelList = $('#' + elementId + ' .tui-chart-axis-area.vertical .tui-chart-label span');
        if (!$labelList || !$labelList.length) {
          return;
        }
        len = $labelList.length;
        for (i = 0; i < len; i += 1) {
          if ($labelList[i].innerHTML.indexOf(".0") == -1) {
            return;
          }
        }
        for (i = 0; i < len; i += 1) {
          $labelList[i].innerHTML = parseInt($labelList[i].innerHTML, 10);
          if (_.find(valueList, {
            value: $labelList[i].innerHTML
          })) {
            $labelList[i].innerHTML = '';
          } else {
            valueList.push({
              value: $labelList[i].innerHTML
            });
          }
        }
      }
      function createLineChart(param) {
        var format,
          yTitle,
          container = document.getElementById(param.elementId);
        if (container) {
          while (container.firstChild) {
            container.removeChild(container.firstChild);
          }
        }
        var i,
          len = param.data.length;
        for (i = 0; i < len; i += 1) {
          if (!param.data[i]) {
            param.data[i] = null;
          }
        }
        if (param.elementId === 'tui_temp') {
          yTitle = '(℃)';
          format = '0.0';
        } else if (param.elementId === 'tui_humid') {
          yTitle = '(%)';
          format = '0.0';
        }
        var data = {
          categories: param.categories,
          series: [{
            name: param.name,
            data: param.data
          }]
        };
        var options = {
          chart: {
            width: 470,
            height: 242,
            format: format
          },
          yAxis: {
            title: yTitle,
            min: param.min,
            max: param.max
          },
          xAxis: {
            title: param.categoryTitle ? '(' + param.categoryTitle + ')' : null,
            labelInterval: param.labelInterval ? param.labelInterval : null
          },
          // series: {
          //     showDot: false,
          //     zoomable: true
          // },
          tooltip: {
            suffix: param.elementId === 'tui_temp' ? '℃' : '%'
          },
          legend: {
            align: 'top'
          },
          chartExportMenu: {
            visible: false
          }
        };
        var theme = {
          series: {
            colors: [param.color] // '#D95576, '#00628C', '#00A8DA', '#1EA399', '#F7A655'
          }
        };
        tui.chart.registerTheme(param.themeName, theme);
        options.theme = param.themeName;
        var chart = tui.chart.lineChart(container, data, options);
        if (!param.useHover) {
          $('#' + param.elementId + ' .tui-chart-series-custom-event-area').hide();
        }
        $('#' + param.elementId + ' .tui-chart-plot-area').hide();
        var diffDay = Math.round(($scope.todayDate.getTime() - $scope.selectDate.getTime()) / (1000 * 60 * 60 * 24));
        if (diffDay === 0) {
          var circleList = $('#' + param.elementId + ' .tui-chart-series-area svg circle');
          var x = 0,
            y = 0;
          for (var i = 0, len = circleList.length; i < len; i += 1) {
            if (circleList[i] && circleList[i].cy && circleList[i].cy.baseVal) {
              if (circleList[i].cy.baseVal.value != 0) {
                x = circleList[i].cx.baseVal.value;
                y = circleList[i].cy.baseVal.value;
              }
            }
          }
        }
        if (param.labelInterval === 16) {
          var labelList = $('#' + param.elementId + ' .tui-chart-axis-area.horizontal .tui-chart-label span');
          if (labelList.length) {
            labelList[labelList.length - 1].innerText = param.categories[param.categories.length - 1];
          }
        }
        $('#' + param.elementId + ' .tui-chart-axis-area.horizontal .tui-chart-label-area').css('left', '0px');
        $('#' + param.elementId + ' .tui-chart-axis-area .tui-chart-label-area').css('color', '#777777');
        $('#' + param.elementId + ' .tui-chart-axis-area .tui-chart-title-area').css('color', '#777777');
        $('#' + param.elementId + ' .tui-line-chart .tui-chart-axis-area.horizontal .tui-chart-tick-area').empty();
        $('#' + param.elementId + ' .tui-chart-legend .tui-chart-legend-rect').css({
          width: '8px',
          height: '8px',
          borderRadius: '8px',
          margin: '4px 4px 4px 30px'
        });
        convertChartLabelToInt(param.elementId);
      }
      function makeTempHumidChartDaily(tempData, humidData, graphData) {
        var dataNumber,
          i,
          len,
          categoriesData = [];
        if (!tempData || !humidData) {
          return;
        }
        len = tempData.length;
        for (i = 0; i < len; i += 1) {
          //00, 03, 06, 09 ...
          if (i % 72 === 0) {
            dataNumber = i / 24;
            dataNumber = dataNumber < 10 ? '0' + dataNumber : '' + dataNumber;
            categoriesData.push(dataNumber);
          } else {
            categoriesData.push('');
          }
        }
        categoriesData.push('24');
        tempData.push(tempData[tempData.length - 1]);
        humidData.push(humidData[humidData.length - 1]);
        createLineChart({
          elementId: 'tui_temp',
          categories: categoriesData,
          categoryTitle: $translate.instant('HOUR_COUNT'),
          name: $translate.instant('STR_TEMP'),
          data: tempData,
          color: '#ef351c',
          themeName: 'tempTheme',
          labelInterval: 72,
          min: graphData.minTemp,
          max: graphData.maxTemp,
          useHover: true
        });
        createLineChart({
          elementId: 'tui_humid',
          categories: categoriesData,
          categoryTitle: $translate.instant('HOUR_COUNT'),
          name: $translate.instant('STR_HUM'),
          data: humidData,
          color: '#4b96e6',
          themeName: 'humidTheme',
          labelInterval: 72,
          min: graphData.minHumid,
          max: graphData.maxHumid,
          useHover: true
        });
      }
      function makeTempHumidChartWeekly(tempData, humidData, graphData) {
        var categories = [$translate.instant('DAY_MON'), '', $translate.instant('DAY_TUE'), '', $translate.instant('DAY_WED'), '', $translate.instant('DAY_THU'), '', $translate.instant('DAY_FRI'), '', $translate.instant('DAY_SAT'), '', $translate.instant('DAY_SUN'), ''];
        createLineChart({
          elementId: 'tui_temp',
          categories: categories,
          name: $translate.instant('STR_TEMP'),
          data: tempData,
          color: '#ef351c',
          useHover: true,
          min: graphData.minTemp,
          max: graphData.maxTemp,
          themeName: 'tempTheme'
        });
        createLineChart({
          elementId: 'tui_humid',
          categories: categories,
          name: $translate.instant('STR_HUM'),
          data: humidData,
          color: '#4b96e6',
          useHover: true,
          min: graphData.minHumid,
          max: graphData.maxHumid,
          themeName: 'humidTheme'
        });
      }
      function makeTempHumidChartMonthly(tempData, humidData, graphData) {
        var categories = [];
        var i,
          len = tempData.length;
        for (i = 0; i < len; i += 1) {
          if (i === 0) {
            categories.push('' + (i + 1));
          } else {
            categories.push('' + Math.floor(i / 2));
          }
        }
        categories.push('' + len / 2);
        createLineChart({
          elementId: 'tui_temp',
          categories: categories,
          name: $translate.instant('STR_TEMP'),
          data: tempData,
          color: '#ef351c',
          useHover: true,
          min: graphData.minTemp,
          max: graphData.maxTemp,
          labelInterval: 16,
          themeName: 'tempTheme'
        });
        createLineChart({
          elementId: 'tui_humid',
          categories: categories,
          name: $translate.instant('STR_HUM'),
          data: humidData,
          color: '#4b96e6',
          useHover: true,
          min: graphData.minHumid,
          max: graphData.maxHumid,
          labelInterval: 16,
          themeName: 'humidTheme'
        });
      }
      function makeTempHumidChartYearly(tempData, humidData, graphData) {
        var i,
          len,
          category = [];
        if (!tempData || !humidData) {
          return;
        }
        len = tempData.length;
        for (i = 0; i < len; i += 1) {
          if (i === len - 1) {
            category.push('');
          } else {
            category.push('' + (Math.floor(i / 2) + 1));
          }
        }
        createLineChart({
          elementId: 'tui_temp',
          categories: category,
          categoryTitle: $translate.instant('DATE_MONTH'),
          name: $translate.instant('STR_TEMP'),
          data: tempData,
          color: '#ef351c',
          themeName: 'tempTheme',
          min: graphData.minTemp,
          max: graphData.maxTemp,
          labelInterval: 2,
          useHover: true
        });
        createLineChart({
          elementId: 'tui_humid',
          categories: category,
          categoryTitle: $translate.instant('DATE_MONTH'),
          name: $translate.instant('STR_HUM'),
          data: humidData,
          color: '#4b96e6',
          themeName: 'humidTheme',
          min: graphData.minHumid,
          max: graphData.maxHumid,
          labelInterval: 2,
          useHover: true
        });
      }
      function getDateString(isToday) {
        var today = isToday ? new Date() : $scope.selectDate;
        var dd = today.getDate();
        var mm = today.getMonth() + 1;
        var yyyy = today.getFullYear();
        if (dd < 10) {
          dd = '0' + dd;
        }
        if (mm < 10) {
          mm = '0' + mm;
        }
        return '' + yyyy + mm + dd;
      }
      function checkLastEventInHour() {
        if (!$scope.sensorEvents || !$scope.sensorEvents.length) {
          return;
        }
        var currentIndex = null;
        for (var i = 0, len = $scope.sensorEvents.length; i < len; i += 1) {
          if ($scope.sensorEvents[i] && $scope.sensorEvents[i].index) {
            if (currentIndex != $scope.sensorEvents[i].index) {
              currentIndex = $scope.sensorEvents[i].index;
              $scope.sensorEvents[i].lastEventInHour = true;
            }
          }
        }
      }
      function getSensorEvent() {
        return Sensor.getSensorEvent({
          sensorId: $scope.$parent.selectSensor.id
        }).$promise;
      }
      function getSensorEventList() {
        Sensor.getSensorEventList({
          shopId: shopId,
          sensorId: $scope.$parent.selectSensor.id,
          date: getDateString(false)
        }, function (res) {
          $scope.sensorEvents = res.shopEvents ? res.shopEvents : [];
          $scope.sensorEvents.forEach(function (evt) {
            if (evt.person) {
              evt.person.masterImageUrl = window.location.origin + '/' + evt.person.masterFace.imageUrl + '?shopId=' + shopId;
            }
          });
          checkLastEventInHour();
        }, function (err) {
          showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
        });
      }
      function getTempHumidData() {
        Sensor.getSensorDataMinute({
          shopId: shopId,
          sensorId: $scope.$parent.selectSensor.id,
          dayToTime: $scope.selectDate.valueOf()
        }, function (res) {
          makeTempHumidChartDaily(res.data.temp, res.data.humid, res.graph);
        }, function (err) {
          showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
        });
      }
      function convertDateToString(date) {
        var year = date.getFullYear(),
          month = date.getMonth() + 1,
          day = date.getDate();
        return '' + year + (month < 10 ? '0' + month : '' + month) + (day < 10 ? '0' + day : '' + day);
      }
      function getTempHumidDataWeekly() {
        Sensor.getSensorDataDaily({
          shopId: shopId,
          sensorId: $scope.$parent.selectSensor.id,
          startTime: $scope.weekDate.startDate.valueOf(),
          endTime: $scope.weekDate.endDate.valueOf()
        }, function (res) {
          makeTempHumidChartWeekly(res.data.temp, res.data.humid, res.graph);
        }, function (err) {
          showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
        });
      }
      function getTempHumidDataMonthly() {
        var lastDate = new Date($scope.monthDate.year, $scope.monthDate.month, 0);
        var firstDate = new Date(lastDate.valueOf());
        firstDate.setDate(1);
        Sensor.getSensorDataDaily({
          shopId: shopId,
          sensorId: $scope.$parent.selectSensor.id,
          startTime: firstDate.valueOf(),
          endTime: lastDate.valueOf()
        }, function (res) {
          makeTempHumidChartMonthly(res.data.temp, res.data.humid, res.graph);
        }, function (err) {
          showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
        });
      }
      function getTempHumidDataYearly() {
        var yearDate = new Date($scope.yearDate.year, 1, 0);
        Sensor.getSensorDataMonthly({
          shopId: shopId,
          sensorId: $scope.$parent.selectSensor.id,
          yearToTime: yearDate.valueOf()
        }, function (res) {
          makeTempHumidChartYearly(res.data.temp, res.data.humid, res.graph);
        }, function (err) {
          showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
        });
      }
      function getSensorDetailTitle() {
        switch ($scope.$parent.selectSensor.sensorType) {
          case 'TEMP_HUMID':
            $scope.sensorTypeStr = $translate.instant('STR_TEMP_HUMID');
            $scope.sensorManageStr = $translate.instant('STR_MANAGE_TEMPSENSOR');
            break;
          case 'MOTION':
            $scope.sensorTypeStr = $translate.instant('EVENT_LIST_MOTION');
            $scope.sensorManageStr = $translate.instant('STR_MANAGE_MOTIONSENSOR');
            break;
          case 'MAGNETIC':
            $scope.sensorTypeStr = $translate.instant('STR_DOOR_OPEN');
            $scope.sensorManageStr = $translate.instant('STR_MANAGE_DOORSENSOR');
            break;
          case 'DOORLOCK':
            $scope.sensorTypeStr = $translate.instant('STR_MAIN_BIZ_44');
            $scope.sensorManageStr = $translate.instant('STR_MANAGE_DOORLOCK');
            break;
          case 'GAS':
            $scope.sensorTypeStr = $translate.instant('STR_GAS');
            $scope.sensorManageStr = $translate.instant('STR_MANAGE_GASSENSOR');
            break;
          case 'SMOKE':
            $scope.sensorTypeStr = $translate.instant('STR_SMOKE');
            $scope.sensorManageStr = $translate.instant('STR_MANAGE_SMOKESENSOR');
            break;
          case 'PLUG':
            $scope.sensorTypeStr = $translate.instant('STR_PLUG');
            $scope.sensorManageStr = $translate.instant('STR_MANAGE_PLUGSENSOR');
            break;
          default:
            $scope.sensorTypeStr = '';
            $scope.sensorManageStr = '';
            break;
        }
      }
      function getTempSensorAlarmConfig() {
        Shop.getTempAlarmConfig({
          sensorId: $scope.$parent.selectSensor.id
        }, function (res) {
          $scope.tempNotifyConfig = {
            sensorId: res.sensorId,
            notifyOn: res.notifyOn,
            alarmConfig: res.alarmConfig,
            minTemp: res.minTemp,
            maxTemp: res.maxTemp,
            minHumid: res.minHumid,
            maxHumid: res.maxHumid
          };
          $scope.editTempNotifyConfig = {
            sensorId: res.sensorId,
            notifyOn: res.notifyOn,
            alarmConfig: res.alarmConfig,
            minTemp: res.minTemp,
            maxTemp: res.maxTemp,
            minHumid: res.minHumid,
            maxHumid: res.maxHumid
          };
          if ($scope.tempNotifyConfig.alarmConfig == 1) {
            $scope.tempNotifyConfig.alarmConfigStr = $translate.instant("STR_GOOD_ENV") + ' (' + $translate.instant("STR_TEMP") + ' 22 ~ 26℃, ' + $translate.instant("STR_HUM") + ' 40 ~ 60%)';
          } else if ($scope.tempNotifyConfig.alarmConfig == 2) {
            $scope.tempNotifyConfig.alarmConfigStr = $translate.instant("STR_FOOD_STORE") + ' (' + $translate.instant("STR_TEMP") + ' 5 ~ 15℃, ' + $translate.instant("STR_HUM") + ' 40 ~ 50%)';
          } else {
            $scope.tempNotifyConfig.alarmConfigStr = $translate.instant("STR_USER_SET") + ' (' + $translate.instant("STR_TEMP") + ' ' + $scope.tempNotifyConfig.minTemp + ' ~ ' + $scope.tempNotifyConfig.maxTemp + '℃, ' + $translate.instant("STR_HUM") + ' ' + $scope.tempNotifyConfig.minHumid + ' ~ ' + $scope.tempNotifyConfig.maxHumid + '%)';
          }
        }, function (err) {
          showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
        });
      }
      function adjustTempSensorAlarmConfig() {
        $scope.tempNotifyConfig = {
          sensorId: $scope.editTempNotifyConfig.sensorId,
          notifyOn: $scope.editTempNotifyConfig.notifyOn,
          alarmConfig: $scope.editTempNotifyConfig.alarmConfig,
          minTemp: $scope.editTempNotifyConfig.minTemp,
          maxTemp: $scope.editTempNotifyConfig.maxTemp,
          minHumid: $scope.editTempNotifyConfig.minHumid,
          maxHumid: $scope.editTempNotifyConfig.maxHumid
        };
        if ($scope.tempNotifyConfig.alarmConfig == 1) {
          $scope.tempNotifyConfig.alarmConfigStr = $translate.instant("STR_GOOD_ENV") + ' (' + $translate.instant("STR_TEMP") + ' 22 ~ 26℃, ' + $translate.instant("STR_HUM") + ' 40 ~ 60%)';
        } else if ($scope.tempNotifyConfig.alarmConfig == 2) {
          $scope.tempNotifyConfig.alarmConfigStr = $translate.instant("STR_FOOD_STORE") + ' (' + $translate.instant("STR_TEMP") + ' 5 ~ 15℃, ' + $translate.instant("STR_HUM") + ' 40 ~ 50%)';
        } else {
          $scope.tempNotifyConfig.alarmConfigStr = $translate.instant("STR_USER_SET") + ' (' + $translate.instant("STR_TEMP") + ' ' + $scope.tempNotifyConfig.minTemp + ' ~ ' + $scope.tempNotifyConfig.maxTemp + '℃, ' + $translate.instant("STR_HUM") + ' ' + $scope.tempNotifyConfig.minHumid + ' ~ ' + $scope.tempNotifyConfig.maxHumid + '%)';
        }
      }
      function getSensorDetailInfo() {
        getSensorDetailTitle();
        return Sensor.getSensorStatus({
          shopId: shopId,
          sensorId: $scope.$parent.selectSensor.id
        }).$promise;
      }
      function checkDateDiffFromToday() {
        var diffDay = Math.round(($scope.todayDate.getTime() - $scope.selectDate.getTime()) / (1000 * 60 * 60 * 24));
        if (diffDay === 0) {
          $scope.dateStr = $translate.instant('EVENT_LIST_DATE_TODAY');
        } else if (diffDay === 1) {
          $scope.dateStr = $translate.instant('EVENT_LIST_DATE_YESTERDAY');
        } else if (diffDay === 2) {
          $scope.dateStr = $translate.instant('STR_BEFORE_DAY_AFTER');
        } else {
          $scope.dateStr = '';
        }
        return diffDay;
      }
      function initSelectDate(timestamp) {
        if (timestamp) {
          $scope.selectDate = new Date(timestamp);
        } else {
          $scope.selectDate = new Date();
        }
        $scope.todayDate = new Date();
        $scope.todayDate.setHours($scope.selectDate.getHours());
        $scope.todayDate.setMinutes($scope.selectDate.getMinutes());
        $scope.todayDate.setSeconds($scope.selectDate.getSeconds());
        if ($scope.$parent.selectSensor.sensorType === "TEMP_HUMID") {
          checkIsCurrentDate();
        }
      }
      function showBatteryLowNotice() {
        if (showNoticeId) {
          $timeout.cancel(showNoticeId);
        }
        $scope.isShowLowBatteryNotice = true;
        showNoticeId = $timeout(function () {
          $scope.isShowLowBatteryNotice = false;
        }, 3000);
      }
      function updateSensorErrStatus(sensor) {
        if (sensor && (sensor.power === 'dead' || sensor.controllerStatus != 'on' || sensor.bracketStatus === false && (sensor.sensorType === 'MOTION' || sensor.sensorType === 'MAGNETIC'))) {
          $scope.sensor_power_err = true;
          $scope.sensor_err_flag = true;
          if (sensor.controllerStatus != 'on') {
            if (sensor.controllerType === 'IOTHUB') {
              $scope.sensor_err_type = 'no_control_iothub';
              $scope.sensor_err_title = $translate.instant('9rRqk7Vo_02139');
              $scope.sensor_err_desc = $translate.instant('9rRqk7Vo_02140');
            } else {
              $scope.sensor_err_type = 'no_control';
              $scope.sensor_err_title = $translate.instant('STR_SENSOR_ERR_NO_CONTROL');
              $scope.sensor_err_desc = $translate.instant('STR_SENSOR_ERR_NO_CONTROL_DESC');
            }
          } else if (sensor.power === 'dead') {
            if (sensor.sensorType === 'MOTION' || sensor.sensorType === 'MAGNETIC' || sensor.sensorType === 'SMOKE' || sensor.sensorType === 'TEMP_HUMID') {
              if (sensor.battery > 20) {
                $scope.sensor_err_type = 'no_sensor_reply';
                $scope.sensor_err_title = $translate.instant('9rRqk7Vo_01861');
                if (sensor.controllerType === 'IOTHUB') {
                  $scope.sensor_err_desc = $translate.instant('9rRqk7Vo_02137');
                } else {
                  $scope.sensor_err_desc = $translate.instant('9rRqk7Vo_01862');
                }
              } else {
                $scope.sensor_err_type = 'no_battery';
                $scope.sensor_err_title = $translate.instant('STR_SENSOR_ERR_NO_BATTERY');
                $scope.sensor_err_desc = $translate.instant('STR_SENSOR_ERR_NO_BATTERY_DESC');
              }
            } else {
              $scope.sensor_err_type = 'no_power';
              if (sensor.sensorType === 'DOORLOCK') {
                $scope.sensor_err_title = $translate.instant('STR_DOORLOCK_POWER_OFF');
                $scope.sensor_err_desc = $translate.instant('STR_DOORLOCK_POWER_OFF_DESC');
              } else {
                $scope.sensor_err_title = $translate.instant('STR_SENSOR_ERR_NO_POWER');
                $scope.sensor_err_desc = $translate.instant('STR_SENSOR_ERR_NO_POWER_DESC');
              }
            }
          } else if (sensor.bracketStatus === false && (sensor.sensorType === 'MOTION' || sensor.sensorType === 'MAGNETIC')) {
            $scope.sensor_err_type = 'no_bracket';
            $scope.sensor_err_title = $translate.instant('5mw2slvk_02167');
            $scope.sensor_err_desc = $translate.instant('5mw2slvk_02168');
          }
        } else {
          if (sensor && sensor.battery <= 20 && sensor.sensorType !== 'GAS' && sensor.sensorType !== 'DOORLOCK' && sensor.sensorType !== 'PLUG') {
            showBatteryLowNotice();
          }
          $scope.sensor_err_type = '';
          $scope.sensor_power_err = false;
          $scope.sensor_err_flag = false;
        }
      }
      function updateCalendarStartDate(timestamp) {
        if (!validStartDatePicker) {
          return;
        }
        var curTime = new Date(timestamp);
        validStartDatePicker._d = curTime;
        $scope.validStartDate.date = moment(parseInt(validStartDatePicker._d.getTime())).locale($("html").attr("lang")).format('YYYY.MM.DD');
      }
      function updateCalendarEndDate(timestamp) {
        if (!validEndDatePicker) {
          return;
        }
        var curTime = new Date(timestamp);
        validEndDatePicker._d = curTime;
        $scope.validEndDate.date = moment(parseInt(validEndDatePicker._d.getTime())).locale($("html").attr("lang")).format('YYYY.MM.DD');
      }
      $scope.toggleValidStartCalendar = function () {
        if (!validStartDatePicker) {
          return;
        }
        if (validStartDatePicker.isVisible()) {
          validStartDatePicker.hide();
        } else {
          validStartDatePicker.show();
        }
      };
      $scope.toggleValidEndCalendar = function () {
        if (!validEndDatePicker) {
          return;
        }
        if (validEndDatePicker.isVisible()) {
          validEndDatePicker.hide();
        } else {
          validEndDatePicker.show();
        }
      };
      function makePwValidStartTimePicker() {
        var minDate = moment().subtract(1, 'd');
        validStartDatePicker = new Pikaday({
          field: document.getElementById('validStartDate'),
          container: document.getElementById('startValidContainer'),
          format: 'YYYY.MM.DD',
          minDate: minDate.toDate(),
          maxDate: new Date('2099-12-31'),
          defaultDate: new Date(),
          position: 'bottom right'
        });
        $('#cal_start_select_btn').click(function () {
          $scope.toggleValidStartCalendar();
          $scope.$apply();
          return false;
        });
      }
      function makePwValidEndTimePicker() {
        var minDate = moment().subtract(1, 'd');
        validEndDatePicker = new Pikaday({
          field: document.getElementById('validEndDate'),
          container: document.getElementById('endValidContainer'),
          format: 'YYYY.MM.DD',
          minDate: minDate.toDate(),
          maxDate: new Date('2099-12-31'),
          defaultDate: new Date(),
          position: 'bottom right'
        });
        $('#cal_end_select_btn').click(function () {
          $scope.toggleValidEndCalendar();
          $scope.$apply();
          return false;
        });
      }
      function getTimeWithTimestamp(timestamp) {
        var date = new Date(timestamp);
        var hour = date.getHours(),
          min = date.getMinutes(),
          year = date.getFullYear(),
          month = date.getMonth() + 1,
          day = date.getDate();
        hour = hour < 10 ? '0' + hour : '' + hour;
        min = min < 10 ? '0' + min : '' + min;
        month = month < 10 ? '0' + month : '' + month;
        day = day < 10 ? '0' + day : '' + day;
        return {
          year: year,
          month: month,
          day: day,
          hour: hour,
          min: min
        };
      }
      $scope.getPwValidTimeString = function (startTimestamp, endTimestamp) {
        var startDateObj = getTimeWithTimestamp(startTimestamp);
        var endDateObj = getTimeWithTimestamp(endTimestamp);
        var startDateStr = startDateObj.year + '.' + startDateObj.month + '.' + startDateObj.day + ' ' + startDateObj.hour + ':' + startDateObj.min;
        var endDateStr = endDateObj.year + '.' + endDateObj.month + '.' + endDateObj.day + ' ' + endDateObj.hour + ':' + endDateObj.min;
        return startDateStr + ' ~ ' + endDateStr;
      };
      function initDoorlockPwValidTimePicker(startTimestamp, endTimestamp) {
        if (!validStartDatePicker) {
          makePwValidStartTimePicker();
        }
        if (!validEndDatePicker) {
          makePwValidEndTimePicker();
        }
        $scope.validStartDate = {};
        $scope.validEndDate = {};
        var startDateObj,
          endDateObj,
          todayTimestamp = new Date().valueOf();
        if (startTimestamp) {
          startDateObj = getTimeWithTimestamp(startTimestamp);
          updateCalendarStartDate(startTimestamp);
          $scope.doorValidStartTime = {
            hour: startDateObj.hour,
            min: startDateObj.min
          };
        } else {
          updateCalendarStartDate(todayTimestamp);
          $scope.doorValidStartTime = {
            hour: '00',
            min: '00'
          };
        }
        if (endTimestamp) {
          endDateObj = getTimeWithTimestamp(endTimestamp);
          updateCalendarEndDate(endTimestamp);
          $scope.doorValidEndTime = {
            hour: endDateObj.hour,
            min: endDateObj.min
          };
        } else {
          updateCalendarEndDate(todayTimestamp);
          $scope.doorValidEndTime = {
            hour: '23',
            min: '59'
          };
        }
      }
      function createDatePicker() {
        $scope.datePicker = new Pikaday({
          field: document.getElementById($scope.$parent.selectSensor.sensorType === "TEMP_HUMID" ? 'accessDateTemp' : 'accessDate'),
          bound: false,
          container: document.getElementById($scope.$parent.selectSensor.sensorType === "TEMP_HUMID" ? 'datePickerContainerTemp' : 'datePickerContainer'),
          minDate: $scope.installDate,
          maxDate: new Date(),
          defaultDate: new Date(),
          onSelect: function onSelect(date) {
            $scope.targetDate = angular.copy(date);
            if ($scope.$parent.selectSensor.sensorType === "TEMP_HUMID") {
              setTempHumGraphDate(date);
            } else {
              $scope.setEventDate(date);
            }
            this.hide();
          }
        });
        $scope.datePicker.hide();
      }
      $scope.toggleDatePicker = function () {
        if ($scope.datePicker.isVisible()) {
          $scope.datePicker.hide();
        } else {
          //$scope.datePicker._d = $scope.selectDate;
          $scope.datePicker.show();
        }
      };
      function initDialog() {
        var scrollTop = $(document).scrollTop();
        $scope.dialogTop = scrollTop < 175 ? 175 : scrollTop;
        $scope.isShared = $scope.$parent.isShared;
        $timeout(function () {
          var $evtArea = $('.sensor_evt_lst_area');
          $evtArea.length ? $evtArea[0].scrollTop = 0 : null;
        }, 0);
        if ($scope.$parent.selectSensor && $scope.$parent.selectSensor.sensorType != "TEMP_HUMID" && $scope.$parent.selectSensor.sensorType != "DOORLOCK" && $scope.$parent.selectSensor.sensorType != "PLUG" && $scope.$parent.selectSensor.eventRegDate) {
          initSelectDate($scope.$parent.selectSensor.eventRegDate);
        } else {
          initSelectDate();
        }
        var diffDate = checkDateDiffFromToday();
        if ($scope.$parent.selectSensor.sensorType != "TEMP_HUMID") {
          $scope.isCurrentDate = diffDate === 0 ? true : false;
        }
        if ($scope.$parent.shopObject) {
          $scope.shopCameraList = $scope.$parent.cameraList ? $scope.$parent.cameraList : [];
          shopId = $scope.$parent.shopObject.shopId;
        }
        if ($scope.$parent.selectSensor && ($scope.$parent.selectSensor.controllerStatus !== 'on' || $scope.$parent.selectSensor.sensorStatus !== 'connected')) {
          $scope.sensor_power_err = true;
          $scope.sensor_err_flag = true;
        }
        var promiseDetail = getSensorDetailInfo(),
          promiseEvent = getSensorEvent();
        $q.all([promiseDetail, promiseEvent]).then(function (res) {
          $scope.sensorDetail = res[0] ? res[0].sensor : {};
          if ($scope.sensorDetail) {
            if ($scope.sensorDetail.batteryIcon === 'LOW') {
              if (!!$scope.sensorDetail.battery == false || $scope.sensorDetail.battery < 10) {
                $scope.sensorDetail.battery = 10;
              }
            }
            initDoorlockPwValidTimePicker($scope.sensorDetail.startValidTime, $scope.sensorDetail.endValidTime);
          }
          updateSensorErrStatus($scope.sensorDetail);
          $scope.installDate = new Date($scope.$parent.shopObject.regDate);
          createDatePicker();
          $scope.eventDataUnit = 'day'; //'week', 'month', 'year'
          $scope.sensorEvent = {
            sensorStatus: res[1].status + ' ' + res[1].detectTime,
            detectTime: res[1].detectTime,
            sensor_err_notice: res[1].statusMessage,
            powerStatus: res[1].power,
            eventStatus: res[1].eventStatus,
            status: res[1].status
          };
          if ($scope.$parent.isManage) {
            $scope.changeDialogState($scope.DIALOG_STATE.DETAIL);
            return;
          }
          if ($scope.$parent.selectSensor.sensorType === 'DOORLOCK' || $scope.$parent.selectSensor.sensorType === 'PLUG') {
            $scope.changeDialogState($scope.DIALOG_STATE.SETTING);
            return;
          }
          $scope.changeDialogState($scope.DIALOG_STATE.EVENT);
        }, function (err) {
          showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
        });
      }
      function startCircleProgress(elementId) {
        if (circleProgress) {
          circleProgress.destroy();
          circleProgress = null;
        }
        var circleCount = 0;
        var makeCircle = function makeCircle() {
          circleCount += 1;
          if (circleCount === 25) {
            //timeout
            if (circleProgress) {
              circleProgress.destroy();
              circleProgress = null;
            }
            return;
          }
          if (isOnCircleProgress === true) {
            var element = document.getElementById(elementId);
            if (element) {
              var color = $scope.sensorEvent.eventStatus === 'open' ? '#e30c53' : '#3568c2';
              circleProgress = new ProgressBar.Circle(element, {
                strokeWidth: 1,
                easing: 'easeInOut',
                duration: 1200,
                color: color,
                trailColor: '#eee',
                trailWidth: 1,
                svgStyle: null
              });
              if (circleProgress) {
                circleProgress.animate(1.0, {}, function () {
                  if (circleProgress) {
                    circleProgress.destroy();
                    circleProgress = null;
                  }
                  makeCircle();
                });
              }
            }
          } else {
            if (circleProgress) {
              circleProgress.destroy();
              circleProgress = null;
            }
          }
        };
        isOnCircleProgress = true;
        makeCircle();
      }
      function stopCircleProgress() {
        isOnCircleProgress = false;
        if (circleProgress) {
          circleProgress.destroy();
          circleProgress = null;
        }
      }
      $scope.setSelectedEvent = function (selectEvent) {
        $scope.selectedEvent = selectEvent;
      };
      function getLatestEvent() {
        var filter = '';
        if ($scope.$parent.selectSensor.sensorType === 'DOORLOCK') {
          filter = 'DOORLOCK_EVENT';
        } else if ($scope.$parent.selectSensor.sensorType === 'PLUG') {
          filter = 'SENSOR_PLUG';
        }
        Shop.dashboardShopEvents({
          shopId: shopId,
          date: getDateString(true),
          limit: 3,
          filter: filter,
          sensorId: $scope.$parent.selectSensor.id,
          duration: 3
        }, function (res) {
          $scope.latestEvents = res.shopEvents ? res.shopEvents : [];
          $scope.latestEvents.forEach(function (evt) {
            if (evt.person) {
              evt.person.masterImageUrl = window.location.origin + '/' + evt.person.masterFace.imageUrl + '?shopId=' + shopId;
            }
          });
        }, function (err) {
          $scope.latestEvents = [];
        });
      }
      function startPollingPwChange(statusParam) {
        $scope.isDoorlockPwChangePolling = true;
        $('body').addClass('blockScroll');
        pollingDoorlockPwStatus = {
          count: 0,
          result: null,
          newStatus: statusParam.newStatus,
          prevStatus: statusParam.prevStatus,
          prevCode: statusParam.prevCode,
          startTimestamp: statusParam.startTimestamp,
          endTimestamp: statusParam.endTimestamp
        };
        pollingPwIntervalId = $interval(function () {
          pollingDoorlockPwStatus.count += 1;
          if (pollingDoorlockPwStatus.count > 30) {
            pollingDoorlockPwStatus.result = 'timeout';
            if (pollingDoorlockPwStatus.newStatus === 'validtime_enable' || pollingDoorlockPwStatus.newStatus === 'validtime_disable') {
              showAlert($translate.instant("9rRqk7Vo_01948"), $translate.instant("ACCESS_SET_FAIL"));
            } else {
              doorlockPwChangeError("-1000");
            }
            stopPollingPwChange();
          } else {
            Doorlock.getDoorlockStatus({
              sensorId: $scope.$parent.selectSensor.id
            }, function (res) {
              if (res.code === 'ok') {
                if (pollingDoorlockPwStatus.newStatus === 'validtime_enable' || pollingDoorlockPwStatus.newStatus === 'validtime_disable') {
                  if (pollingDoorlockPwStatus.newStatus === 'validtime_enable') {
                    if (res.isValidTimeOn && pollingDoorlockPwStatus.startTimestamp === res.startValidTime && pollingDoorlockPwStatus.endTimestamp === res.endValidTime) {
                      pollingDoorlockPwStatus.result = 'success';
                      showAlert($translate.instant("STR_MAIN_BIZ_14"), $translate.instant("SAVE_COMPLETE"));
                      stopPollingPwChange();
                    }
                  } else {
                    if (!res.isValidTimeOn) {
                      pollingDoorlockPwStatus.result = 'success';
                      showAlert($translate.instant("STR_MAIN_BIZ_14"), $translate.instant("SAVE_COMPLETE"));
                      stopPollingPwChange();
                    }
                  }
                } else {
                  if (pollingDoorlockPwStatus.newStatus === pollingDoorlockPwStatus.prevStatus) {
                    if (pollingDoorlockPwStatus.prevCode !== res.password) {
                      pollingDoorlockPwStatus.result = 'success';
                      showAlert($translate.instant("STR_MAIN_BIZ_14"), $translate.instant("SAVE_COMPLETE"));
                      stopPollingPwChange();
                    }
                  } else {
                    if (pollingDoorlockPwStatus.newStatus === 'password_enable' && res.isPasswordOn === true) {
                      pollingDoorlockPwStatus.result = 'success';
                      showAlert($translate.instant("STR_MAIN_BIZ_14"), $translate.instant("SAVE_COMPLETE"));
                      stopPollingPwChange();
                    } else if (pollingDoorlockPwStatus.newStatus === 'password_disable' && res.isPasswordOn === false) {
                      pollingDoorlockPwStatus.result = 'success';
                      showAlert($translate.instant("STR_MAIN_BIZ_14"), $translate.instant("SAVE_COMPLETE"));
                      stopPollingPwChange();
                    }
                  }
                }
              }
            });
          }
        }, 1000);
      }
      function startPollingDoorlockStatus() {
        pollingIntervalId = $interval(function () {
          Sensor.getSensorEvent({
            sensorId: $scope.$parent.selectSensor.id
          }, function (res) {
            if ($scope.sensorEvent) {
              if ($scope.sensorEvent.eventStatus != res.eventStatus) {
                getLatestEvent();
                stopCircleProgress();
                $rootScope.$broadcast('deviceUpdate', $scope.$parent.selectSensor.id);
              }
              $scope.sensorEvent.eventStatus = res.eventStatus;
              $scope.sensorEvent.status = res.status;
              $scope.sensorEvent.detectTime = res.detectTime;
            }
          }, function (error) {});
        }, 1500);
      }
      function startPollingPlugStatus() {
        pollingSensorIntervalId = $interval(function () {
          Sensor.getSensorEvent({
            sensorId: $scope.$parent.selectSensor.id
          }, function (res) {
            if ($scope.sensorEvent) {
              if ($scope.sensorEvent.eventStatus != res.eventStatus) {
                getLatestEvent();
                $scope.isLoadingEvent = false;
                $rootScope.$broadcast('deviceUpdate', $scope.$parent.selectSensor.id);
              }
              $scope.sensorEvent.eventStatus = res.eventStatus;
              $scope.sensorEvent.status = res.status;
              $scope.sensorEvent.detectTime = res.detectTime;
            }
          }, function (error) {});
        }, 1500);
      }
      function stopPollingPwChange() {
        $scope.isDoorlockPwChangePolling = false;
        $('body').removeClass('blockScroll');
        if (pollingPwIntervalId) {
          $interval.cancel(pollingPwIntervalId);
          pollingPwIntervalId = null;
        }
        if (pollingDoorlockPwStatus && pollingDoorlockPwStatus.result === 'success') {
          if (pollingDoorlockPwStatus.newStatus === 'validtime_enable' || pollingDoorlockPwStatus.newStatus === 'validtime_disable') {
            getSensorDetailInfo().then(function (res) {
              $scope.sensorDetail = res ? res.sensor : {};
              $rootScope.$broadcast('deviceUpdate', $scope.$parent.selectSensor.id);
            });
          } else {
            $scope.sensorDetail.isPasswordOn = pollingDoorlockPwStatus.newStatus === 'password_enable' ? true : false;
            $rootScope.$broadcast('deviceUpdate', $scope.$parent.selectSensor.id);
          }
        }
        pollingDoorlockPwStatus = null;
        $scope.changeDialogState($scope.DIALOG_STATE.DETAIL);
      }
      function stopPollingDoorlockStatus() {
        if (pollingIntervalId) {
          $interval.cancel(pollingIntervalId);
          pollingIntervalId = null;
        }
      }
      function stopPollingPlugStatus() {
        if (pollingSensorIntervalId) {
          $interval.cancel(pollingSensorIntervalId);
          pollingSensorIntervalId = null;
        }
      }
      $scope.showLockFaceCamDlg = function () {
        $rootScope.$broadcast('showLockFaceCamDlg');
      };
      $scope.showLockFacePeopleDlg = function () {
        $rootScope.$broadcast('showLockFacePeopleDlg');
      };
      $scope.goToFaceSetStatus = function () {
        if ($scope.sensorDetail.useAiFaceDetect) {
          $scope.changeDialogState($scope.DIALOG_STATE.FACE_SET);
        } else {
          $rootScope.createConfirm({
            title: $translate.instant("5mw2slvk_02150"),
            description: $translate.instant("5mw2slvk_02166"),
            confText: $translate.instant('9rRqk7Vo_02449'),
            cancelText: $translate.instant('BUTTON_CLOSE'),
            handler: function handler() {
              $rootScope.$broadcast('showAiFaceRegDlg');
              $scope.changeDialogState($scope.DIALOG_STATE.NONE);
              $scope.$apply();
            }
          });
        }
      };
      $scope.goToChangePwStatus = function () {
        if ($scope.sensorDetail.controllerStatus != 'on') {
          showAlert($translate.instant('STR_MAIN_BIZ_44') + $translate.instant("SETTING"), $translate.instant("9rRqk7Vo_01955"));
          return;
        }
        if ($scope.sensor_err_type === 'no_sensor_reply' || $scope.sensor_err_type === 'no_battery' || $scope.sensor_err_type === 'no_power') {
          showAlert($translate.instant('STR_MAIN_BIZ_44') + $translate.instant("SETTING"), $translate.instant("9rRqk7Vo_01969"));
          return;
        }
        $scope.changeDialogState($scope.DIALOG_STATE.PW_CHANGE);
      };
      $scope.goToSetPwTimeStatus = function () {
        if ($scope.sensorDetail.controllerStatus != 'on') {
          showAlert($translate.instant('STR_MAIN_BIZ_44') + $translate.instant("SETTING"), $translate.instant("9rRqk7Vo_01955"));
          return;
        }
        if ($scope.sensor_err_type === 'no_sensor_reply' || $scope.sensor_err_type === 'no_battery' || $scope.sensor_err_type === 'no_power') {
          showAlert($translate.instant('STR_MAIN_BIZ_44') + $translate.instant("SETTING"), $translate.instant("9rRqk7Vo_01969"));
          return;
        }
        $scope.changeDialogState($scope.DIALOG_STATE.PW_TIME_CHANGE);
      };
      function doorlockPwChangeError(errorCode) {
        if (errorCode == "-5000") {
          showAlert($translate.instant("STR_MAIN_BIZ_14"), $translate.instant("FAIL_PW_CHANGE"));
        } else if (errorCode == "-5001") {
          showAlert($translate.instant("STR_MAIN_BIZ_14"), $translate.instant("FAIL_PW_CHANGE"));
        } else if (errorCode == "-5002") {
          showAlert($translate.instant("STR_MAIN_BIZ_14"), $translate.instant("NO_SAME_PW_USE"));
        } else {
          showAlert($translate.instant("STR_MAIN_BIZ_14"), $translate.instant("FAIL_PW_CHANGE"));
        }
      }
      function setTempHumGraphDate(date) {
        var targetDate = date ? date : new Date();
        $scope.calendar = [];
        if ($scope.eventDataUnit === 'week') {
          $scope.weekDate = {
            //week
            startDate: targetDate,
            endDate: null
          };
          while ($scope.weekDate.startDate.getDay() != 1) {
            $scope.weekDate.startDate.setDate($scope.weekDate.startDate.getDate() - 1);
          }
          $scope.weekDate.endDate = new Date($scope.weekDate.startDate.valueOf());
          $scope.weekDate.endDate.setDate($scope.weekDate.endDate.getDate() + 6);
          getTempHumidDataWeekly();
        } else if ($scope.eventDataUnit === 'month') {
          $scope.monthDate = {
            year: targetDate.getFullYear(),
            month: targetDate.getMonth() + 1
          };
          getTempHumidDataMonthly();
        } else if ($scope.eventDataUnit === 'year') {
          $scope.yearDate = {
            year: targetDate.getFullYear()
          };
          getTempHumidDataYearly();
        } else {
          $scope.selectDate = targetDate;
          checkDateDiffFromToday();
          getTempHumidData();
        }
        checkIsCurrentDate();
      }
      $scope.selectEventDataUnit = function (unit) {
        if ($scope.eventDataUnit === unit) {
          return;
        }
        $scope.eventDataUnit = unit;
        setTempHumGraphDate($scope.targetDate ? angular.copy($scope.targetDate) : null);
      };
      $scope.getWeeklyDateStr = function () {
        if (!$scope.weekDate || !$scope.weekDate.startDate || !$scope.weekDate.endDate) {
          return '';
        }
        var startMonth = $scope.weekDate.startDate.getMonth() + 1,
          startDay = $scope.weekDate.startDate.getDate(),
          endMonth = $scope.weekDate.endDate.getMonth() + 1,
          endDay = $scope.weekDate.endDate.getDate();
        startMonth = startMonth < 10 ? '0' + startMonth : '' + startMonth;
        startDay = startDay < 10 ? '0' + startDay : '' + startDay;
        endMonth = endMonth < 10 ? '0' + endMonth : '' + endMonth;
        endDay = endDay < 10 ? '0' + endDay : '' + endDay;
        return startMonth + '.' + startDay + ' ~ ' + endMonth + '.' + endDay;
      };
      $scope.getMonthlyDateStr = function () {
        if (!$scope.monthDate || !$scope.monthDate.year || !$scope.monthDate.month) {
          return '';
        }
        return $scope.monthDate.year + '.' + ($scope.monthDate.month < 10 ? '0' + $scope.monthDate.month : $scope.monthDate.month);
      };
      $scope.getYearlyDateStr = function () {
        if (!$scope.yearDate || !$scope.yearDate.year) {
          return '';
        }
        return $scope.yearDate.year;
      };
      function checkIsCurrentDate() {
        var startDate, endDate;
        if ($scope.eventDataUnit === 'week') {
          if (!$scope.weekDate || !$scope.weekDate.startDate || !$scope.weekDate.endDate) {
            $scope.isCurrentDate = false;
            return;
          }
          startDate = new Date($scope.weekDate.startDate.valueOf());
          endDate = new Date($scope.weekDate.endDate.valueOf());
          startDate.setHours(0, 0, 0, 0);
          endDate.setHours(23, 59, 59, 999);
          if (startDate < $scope.todayDate && endDate > $scope.todayDate) {
            $scope.isCurrentDate = true;
          } else {
            $scope.isCurrentDate = false;
          }
        } else if ($scope.eventDataUnit === 'month') {
          if (!$scope.monthDate || !$scope.monthDate.year || !$scope.monthDate.month) {
            $scope.isCurrentDate = false;
            return;
          }
          if ($scope.todayDate.getFullYear() === $scope.monthDate.year && $scope.todayDate.getMonth() + 1 === $scope.monthDate.month) {
            $scope.isCurrentDate = true;
          } else {
            $scope.isCurrentDate = false;
          }
        } else if ($scope.eventDataUnit === 'year') {
          if (!$scope.yearDate || !$scope.yearDate.year) {
            $scope.isCurrentDate = false;
            return;
          }
          if ($scope.todayDate.getFullYear() === $scope.yearDate.year) {
            $scope.isCurrentDate = true;
          } else {
            $scope.isCurrentDate = false;
          }
        } else {
          if (!$scope.selectDate) {
            $scope.isCurrentDate = false;
            return;
          }
          if ($scope.selectDate.getFullYear() === $scope.todayDate.getFullYear() && $scope.selectDate.getMonth() === $scope.todayDate.getMonth() && $scope.selectDate.getDate() === $scope.todayDate.getDate()) {
            $scope.isCurrentDate = true;
          } else {
            $scope.isCurrentDate = false;
          }
        }
      }
      $scope.tempHumGraphCurrentDate = function () {
        setTempHumGraphDate();
      };
      $scope.tempHumGraphNextDate = function (isPrev) {
        var diffDay, todayMonth, todayYear, installMonth, installYear;
        if ($scope.eventDataUnit === 'week') {
          if (!$scope.weekDate || !$scope.weekDate.startDate || !$scope.weekDate.endDate) {
            return;
          }
          if (isPrev) {
            if ($scope.installDate) {
              diffDay = Math.round(($scope.weekDate.endDate.getTime() - $scope.installDate.getTime()) / (1000 * 60 * 60 * 24));
              if (diffDay > 6) {
                $scope.weekDate.startDate.setDate($scope.weekDate.startDate.getDate() - 7);
                $scope.weekDate.endDate.setDate($scope.weekDate.endDate.getDate() - 7);
              } else {
                return;
              }
            } else {
              $scope.weekDate.startDate.setDate($scope.weekDate.startDate.getDate() - 7);
              $scope.weekDate.endDate.setDate($scope.weekDate.endDate.getDate() - 7);
            }
          } else {
            diffDay = Math.round(($scope.todayDate.getTime() - $scope.weekDate.startDate.getTime()) / (1000 * 60 * 60 * 24));
            if (diffDay > 6) {
              $scope.weekDate.startDate.setDate($scope.weekDate.startDate.getDate() + 7);
              $scope.weekDate.endDate.setDate($scope.weekDate.endDate.getDate() + 7);
            } else {
              return;
            }
          }
          getTempHumidDataWeekly();
        } else if ($scope.eventDataUnit === 'month') {
          if (!$scope.monthDate || !$scope.monthDate.year || !$scope.monthDate.month) {
            return;
          }
          if (isPrev) {
            if ($scope.monthDate.month <= 1) {
              $scope.monthDate.year -= 1;
              $scope.monthDate.month = 12;
            } else {
              $scope.monthDate.month -= 1;
            }
            if ($scope.installDate) {
              installYear = $scope.installDate.getFullYear();
              installMonth = $scope.installDate.getMonth() + 1;
              if (installYear > $scope.monthDate.year || installYear === $scope.monthDate.year && installMonth > $scope.monthDate.month) {
                $scope.monthDate.year = installYear;
                $scope.monthDate.month = installMonth;
                return;
              }
            }
          } else {
            if ($scope.monthDate.month >= 12) {
              $scope.monthDate.year += 1;
              $scope.monthDate.month = 1;
            } else {
              $scope.monthDate.month += 1;
            }
            todayYear = $scope.todayDate.getFullYear();
            todayMonth = $scope.todayDate.getMonth() + 1;
            if (todayYear < $scope.monthDate.year || todayYear === $scope.monthDate.year && todayMonth < $scope.monthDate.month) {
              $scope.monthDate.year = todayYear;
              $scope.monthDate.month = todayMonth;
              return;
            }
          }
          getTempHumidDataMonthly();
        } else if ($scope.eventDataUnit === 'year') {
          if (!$scope.yearDate || !$scope.yearDate.year) {
            return;
          }
          if (isPrev) {
            $scope.yearDate.year -= 1;
            if ($scope.installDate) {
              installYear = $scope.installDate.getFullYear();
              if (installYear > $scope.yearDate.year) {
                $scope.yearDate.year = installYear;
                return;
              }
            }
          } else {
            $scope.yearDate.year += 1;
            todayYear = $scope.todayDate.getFullYear();
            if (todayYear < $scope.yearDate.year) {
              $scope.yearDate.year = todayYear;
              return;
            }
          }
          getTempHumidDataYearly();
        } else {
          //day
          if (!$scope.selectDate) {
            return;
          }
          $scope.selectDate.setDate($scope.selectDate.getDate() + (isPrev ? -1 : 1));
          if ($scope.todayDate.getDate() !== $scope.selectDate.getDate() && $scope.todayDate.getTime() + 1000 < $scope.selectDate.getTime()) {
            $scope.selectDate.setDate($scope.selectDate.getDate() - 1);
            return;
          }
          if ($scope.installDate) {
            if ($scope.installDate.getDate() !== $scope.selectDate.getDate() && $scope.installDate.getTime() > $scope.selectDate.getTime()) {
              $scope.selectDate.setDate($scope.selectDate.getDate() + 1);
              return;
            }
          }
          checkDateDiffFromToday();
          getTempHumidData();
        }
        checkIsCurrentDate();
      };
      $scope.hideSensorPowerErrorNotice = function () {
        $scope.sensor_err_flag = false;
        if ($scope.$parent.selectSensor.sensorType === 'DOORLOCK' || $scope.$parent.selectSensor.sensorType === 'PLUG') {
          $scope.setSelectedEvent(null);
          $scope.changeDialogState($scope.DIALOG_STATE.EVENT);
        }
      };
      $scope.moveToSensorEventPage = function () {
        $state.go('main.dashboard.event', {
          shopId: shopId,
          shared: $scope.$parent.isShared,
          filter: $scope.$parent.selectSensor.sensorType,
          regDate: $scope.$parent.selectSensor.eventRegDate
        });
      };
      $scope.hideAlert = function () {
        $scope.showAlert = false;
      };
      function updateDlgStyle() {
        var marginTopSize = 100;
        var windowHeight = $(window).height();
        $scope.dlgMaxHeight = windowHeight - marginTopSize + 'px';
      }
      $scope.$parent.$watch('isShowSensorSetDialog', function (newValue, oldValue) {
        if (newValue !== oldValue) {
          if (newValue === true) {
            $('body').addClass('blockScroll');
            updateDlgStyle();
            initDialog();
            if ($scope.$parent.selectSensor.sensorType === 'TEMP_HUMID') {
              getTempHumidData();
              getTempSensorAlarmConfig();
            } else {
              getSensorEventList();
            }
          } else {
            $('body').removeClass('blockScroll');
            if (showNoticeId) {
              $timeout.cancel(showNoticeId);
              showNoticeId = null;
            }
            $scope.isShowLowBatteryNotice = false;
          }
        }
      });
      $scope.selectMonitorCamera = function (value) {
        $scope.selectCameraId = value;
      };
      $scope.changeMonitorCamera = function (cameraId) {
        Sensor.setSensorConnectCamera({
          sensorId: $scope.$parent.selectSensor.id,
          cameraId: cameraId
        }, {}, function (res) {
          $scope.changeDialogState($scope.DIALOG_STATE.DETAIL);
          getSensorDetailInfo().then(function (res) {
            $scope.sensorDetail = res ? res.sensor : {};
          });
          $rootScope.$broadcast('deviceUpdate', $scope.$parent.selectSensor.id);
        }, function (err) {
          $scope.changeDialogState($scope.DIALOG_STATE.DETAIL);
        });
      };
      $scope.setDoorlockValidTime = function () {
        if ($scope.sensorDetail.controllerStatus != 'on') {
          showAlert($translate.instant('STR_MAIN_BIZ_44') + $translate.instant("SETTING"), $translate.instant("9rRqk7Vo_01955"));
          return;
        }
        var status = 'validtime_enable';
        var startTimestamp = 0,
          endTimestamp = 0;
        var startDateStr = $scope.validStartDate.date.replace(/\./g, "-");
        var endDateStr = $scope.validEndDate.date.replace(/\./g, "-");
        var startDate = new Date(startDateStr);
        var endDate = new Date(endDateStr);
        startDate.setHours(parseInt($scope.doorValidStartTime.hour));
        startDate.setMinutes(parseInt($scope.doorValidStartTime.min));
        endDate.setHours(parseInt($scope.doorValidEndTime.hour));
        endDate.setMinutes(parseInt($scope.doorValidEndTime.min));
        var startTimestamp = startDate.valueOf();
        var endTimestamp = endDate.valueOf();
        if (startTimestamp > endTimestamp) {
          showAlert($translate.instant("CLIPS_ERR_TIME_SUBJECT"), $translate.instant('CLIPS_ERR_TIME_CONTENT'));
          return;
        }
        Doorlock.setDoorlockPwd({
          shopId: shopId,
          sensorId: $scope.$parent.selectSensor.id
        }, {
          status: status,
          startValidTime: startTimestamp,
          endValidTime: endTimestamp
        }, function (res) {
          if (res.code === 'ok') {
            startPollingPwChange({
              newStatus: status,
              startTimestamp: startTimestamp,
              endTimestamp: endTimestamp
            });
          } else {
            showAlert($translate.instant("9rRqk7Vo_01948"), $translate.instant("ACCESS_SET_FAIL"));
          }
        }, function (error) {
          showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
        });
      };
      $scope.setDoorlockPw = function () {
        if ($scope.sensorDetail.controllerStatus != 'on') {
          showAlert($translate.instant('STR_MAIN_BIZ_44') + $translate.instant("SETTING"), $translate.instant("9rRqk7Vo_01955"));
          return;
        }
        var pwStatus = 'password_enable';
        var isPwCorrect = /^\d{4,10}$/.test($scope.door_pw);
        if (isPwCorrect) {
          Doorlock.setDoorlockPwd({
            shopId: shopId,
            sensorId: $scope.$parent.selectSensor.id
          }, {
            status: pwStatus,
            code: $scope.door_pw
          }, function (res) {
            if (res.code === 'ok') {
              startPollingPwChange({
                newStatus: pwStatus,
                prevStatus: $scope.sensorDetail.isPasswordOn == true ? 'password_enable' : 'password_disable',
                prevCode: $scope.sensorDetail.password
              });
            } else {
              doorlockPwChangeError(res.errorCode);
            }
          }, function (error) {
            showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
          });
        } else {
          showAlert($translate.instant("CAMERA_PASSWORD_INPUT"), $translate.instant("SHARE_FAIL3_MSG"));
        }
      };
      $scope.moveNextDate = function (isPrev) {
        if (!$scope.selectDate) {
          return;
        }
        $scope.selectDate.setDate($scope.selectDate.getDate() + (isPrev ? -1 : 1));
        if ($scope.todayDate.getDate() !== $scope.selectDate.getDate() && $scope.todayDate.getTime() + 1000 < $scope.selectDate.getTime()) {
          $scope.selectDate.setDate($scope.selectDate.getDate() - 1);
        }
        $scope.isCurrentDate = checkDateDiffFromToday() === 0 ? true : false;
        getSensorEventList();
      };
      $scope.setEventDate = function (date) {
        var targetDate = date ? date : new Date();
        $scope.selectDate = targetDate;
        $scope.isCurrentDate = checkDateDiffFromToday() === 0 ? true : false;
        getSensorEventList();
      };
      $scope.goCameraDetailInDoorlock = function (event) {
        if (event.target) {
          var className = event.target.className;
          if (className.indexOf('sensor_event_info') === -1 && className.indexOf('sensor_set_info') === -1 && className.indexOf('monitor_cam_show') === -1) {
            $scope.goCameraDetail();
          }
        }
      };
      $scope.goCameraDetail = function () {
        if ($scope.sensorDetail.connectedCameraId) {
          var isShared = $scope.$parent.isShared == true || $scope.$parent.isShared == "true";
          $state.go('main.cameraDetail', {
            cameraId: $scope.sensorDetail.connectedCameraId,
            type: isShared ? 'sharedshop' : 'shop',
            id: shopId,
            shared: isShared
          });
        }
      };
      $scope.playEvent = function (event) {
        if (event && $scope.sensorDetail && $scope.sensorDetail.connectedCameraId) {
          var isShared = $scope.$parent.isShared == true || $scope.$parent.isShared == "true";
          $state.go('main.cameraDetail', {
            cameraId: $scope.sensorDetail.connectedCameraId,
            type: isShared ? 'sharedshop' : 'shop',
            id: shopId,
            time: event.playStartTime || event.regDate,
            shared: isShared,
            eventId: event.eventId
          });
        }
      };
      $scope.setDoorlockState = function (event) {
        startCircleProgress('aniCircle');
        var setDoorlockStatus = $scope.sensorEvent.eventStatus === 'open' ? 'close' : 'open';
        Doorlock.setDoorlockState({
          shopId: shopId,
          sensorId: $scope.$parent.selectSensor.id
        }, {
          status: setDoorlockStatus,
          platform: 'web'
        }, function (res) {
          if (res.code !== 'ok') {
            stopCircleProgress();
          }
        }, function (error) {
          stopCircleProgress();
        });
      };
      $scope.setSensorState = function (status) {
        $scope.isLoadingEvent = true;
        Sensor.setSensorStatus({
          shopId: shopId,
          sensorId: $scope.$parent.selectSensor.id
        }, {
          status: status
        }, function (res) {
          if (res.code !== 'ok') {
            $scope.isLoadingEvent = false;
          }
        }, function (error) {
          $scope.isLoadingEvent = false;
        });
      };
      $scope.setEditSensorNameStatus = function (isEdit) {
        $scope.isEditingSensorName = isEdit;
        $scope.editSensorName = $scope.sensorDetail.sensorName;
      };
      $scope.changeSensorName = function (editSensorName) {
        if (editSensorName != $scope.sensorDetail.sensorName) {
          Sensor.setSensorConfig({
            sensorId: $scope.$parent.selectSensor.id
          }, {
            sensorName: editSensorName
          }, function (res) {
            if (res.code === 'ok') {
              $scope.sensorDetail.sensorName = editSensorName;
              $rootScope.$broadcast('deviceUpdate', $scope.$parent.selectSensor.id);
            }
            $scope.setEditSensorNameStatus(false);
          }, function (error) {
            $scope.setEditSensorNameStatus(false);
            showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
          });
        } else {
          $scope.setEditSensorNameStatus(false);
        }
      };
      $scope.toggleDoorLockPassword = function () {
        if ($scope.sensorDetail.controllerStatus != 'on') {
          showAlert($translate.instant('STR_MAIN_BIZ_44') + $translate.instant("SETTING"), $translate.instant("9rRqk7Vo_01955"));
          return;
        }
        var passwordStatus = $scope.sensorDetail.isPasswordOn == true ? 'password_disable' : 'password_enable';
        if (passwordStatus === 'password_enable') {
          $scope.changeDialogState($scope.DIALOG_STATE.PW_CHANGE);
        } else {
          Doorlock.setDoorlockPwd({
            shopId: shopId,
            sensorId: $scope.$parent.selectSensor.id
          }, {
            status: passwordStatus,
            code: ''
          }, function (res) {
            if (res.code === 'ok') {
              startPollingPwChange({
                newStatus: passwordStatus,
                prevStatus: $scope.sensorDetail.isPasswordOn == true ? 'password_enable' : 'password_disable',
                prevCode: $scope.sensorDetail.password
              });
            } else {
              doorlockPwChangeError(res.errorCode);
            }
          }, function (error) {
            showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
          });
        }
      };
      $scope.toggleDoorlockPwValidTime = function () {
        if ($scope.sensorDetail.controllerStatus != 'on') {
          showAlert($translate.instant('STR_MAIN_BIZ_44') + $translate.instant("SETTING"), $translate.instant("9rRqk7Vo_01955"));
          return;
        }
        var validTimeStatus = $scope.sensorDetail.isValidTimeOn == true ? 'validtime_disable' : 'validtime_enable';
        if (validTimeStatus === 'validtime_enable') {
          if ($scope.sensorDetail.startValidTime && $scope.sensorDetail.endValidTime) {
            Doorlock.setDoorlockPwd({
              shopId: shopId,
              sensorId: $scope.$parent.selectSensor.id
            }, {
              status: validTimeStatus,
              startValidTime: $scope.sensorDetail.startValidTime,
              endValidTime: $scope.sensorDetail.endValidTime
            }, function (res) {
              if (res.code === 'ok') {
                startPollingPwChange({
                  newStatus: validTimeStatus,
                  startTimestamp: $scope.sensorDetail.startValidTime,
                  endTimestamp: $scope.sensorDetail.endValidTime
                });
              } else {
                showAlert($translate.instant("9rRqk7Vo_01948"), $translate.instant("ACCESS_SET_FAIL"));
              }
            }, function (error) {
              showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
            });
          } else {
            $scope.changeDialogState($scope.DIALOG_STATE.PW_TIME_CHANGE);
          }
        } else {
          Doorlock.setDoorlockPwd({
            shopId: shopId,
            sensorId: $scope.$parent.selectSensor.id
          }, {
            status: validTimeStatus
          }, function (res) {
            if (res.code === 'ok') {
              startPollingPwChange({
                newStatus: validTimeStatus
              });
            } else {
              showAlert($translate.instant("9rRqk7Vo_01948"), $translate.instant("ACCESS_SET_FAIL"));
            }
          }, function (error) {
            showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
          });
        }
      };
      $scope.toggleSensorNotify = function () {
        var notify = $scope.sensorDetail.notifyOn == 'on' ? 'off' : 'on',
          type = $scope.$parent.selectSensor.sensorType === 'DOORLOCK' ? 'doorlock' : 'sensor';
        if ($scope.$parent.selectSensor.sensorType === 'PLUG') {
          Shop.setShopPlugAlarmConfig({
            shopId: shopId
          }, {
            id: $scope.$parent.selectSensor.id,
            type: type,
            notifyOn: notify
          }, function (res) {
            if (res.code === 'ok') {
              $scope.sensorDetail.notifyOn = notify;
            }
          }, function (err) {
            showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
          });
        } else if ($scope.$parent.selectSensor.sensorType === 'TEMP_HUMID') {
          Shop.updateTempAlarmConfig({
            sensorId: $scope.$parent.selectSensor.id
          }, {
            notifyOn: notify,
            alarmConfig: $scope.tempNotifyConfig.alarmConfig,
            minTemp: $scope.tempNotifyConfig.minTemp,
            maxTemp: $scope.tempNotifyConfig.maxTemp,
            minHumid: $scope.tempNotifyConfig.minHumid,
            maxHumid: $scope.tempNotifyConfig.maxHumid
          }, function (res) {
            if (res.code === 'ok') {
              $scope.sensorDetail.notifyOn = notify;
              $scope.tempNotifyConfig.notifyOn = notify;
              $scope.editTempNotifyConfig.notifyOn = notify;
              if (notify != 'on') {
                $scope.setEditTempSensorStatus(false);
              }
            }
          }, function (err) {
            showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
          });
        } else {
          Shop.updateShopSecAlarmConfig({
            shopId: shopId
          }, {
            id: $scope.$parent.selectSensor.id,
            type: type,
            notifyOn: notify
          }, function (res) {
            if (res.code === 'ok') {
              $scope.sensorDetail.notifyOn = notify;
            }
          }, function (err) {
            showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
          });
        }
      };
      $scope.setEditTempSensorStatus = function (isEdit) {
        $scope.isEditingTempNotifyConfig = isEdit;
        if ($scope.tempNotifyConfig) {
          $scope.editTempNotifyConfig = {
            sensorId: $scope.tempNotifyConfig.sensorId,
            notifyOn: $scope.tempNotifyConfig.notifyOn,
            alarmConfig: $scope.tempNotifyConfig.alarmConfig,
            minTemp: $scope.tempNotifyConfig.minTemp,
            maxTemp: $scope.tempNotifyConfig.maxTemp,
            minHumid: $scope.tempNotifyConfig.minHumid,
            maxHumid: $scope.tempNotifyConfig.maxHumid
          };
        }
      };
      $scope.setTempSensorNotifyConfig = function () {
        if (!$scope.editTempNotifyConfig) {
          return;
        }
        $scope.editTempNotifyConfig.minTemp = parseInt($scope.editTempNotifyConfig.minTemp, 10);
        $scope.editTempNotifyConfig.maxTemp = parseInt($scope.editTempNotifyConfig.maxTemp, 10);
        $scope.editTempNotifyConfig.minHumid = parseInt($scope.editTempNotifyConfig.minHumid, 10);
        $scope.editTempNotifyConfig.maxHumid = parseInt($scope.editTempNotifyConfig.maxHumid, 10);
        if (isNaN($scope.editTempNotifyConfig.minTemp) || isNaN($scope.editTempNotifyConfig.maxTemp) || isNaN($scope.editTempNotifyConfig.minHumid) || isNaN($scope.editTempNotifyConfig.maxHumid)) {
          showAlert($translate.instant("SHARE_FAIL3"), $translate.instant("SHARE_FAIL3_MSG"));
          return;
        }
        if ($scope.editTempNotifyConfig.maxTemp < $scope.editTempNotifyConfig.minTemp) {
          showAlert($translate.instant("SHARE_FAIL3"), $translate.instant("SHARE_FAIL3_MSG"));
          return;
        }
        if ($scope.editTempNotifyConfig.maxHumid < $scope.editTempNotifyConfig.minHumid) {
          showAlert($translate.instant("SHARE_FAIL3"), $translate.instant("SHARE_FAIL3_MSG"));
          return;
        }
        Shop.updateTempAlarmConfig({
          sensorId: $scope.$parent.selectSensor.id
        }, {
          notifyOn: $scope.editTempNotifyConfig.notifyOn,
          alarmConfig: $scope.editTempNotifyConfig.alarmConfig,
          minTemp: $scope.editTempNotifyConfig.minTemp,
          maxTemp: $scope.editTempNotifyConfig.maxTemp,
          minHumid: $scope.editTempNotifyConfig.minHumid,
          maxHumid: $scope.editTempNotifyConfig.maxHumid
        }, function (res) {
          if (res.code === 'ok') {
            adjustTempSensorAlarmConfig();
          }
          $scope.setEditTempSensorStatus(false);
        }, function (err) {
          $scope.setEditTempSensorStatus(false);
          showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
        });
      };
      $scope.showDoorlockManual = function () {
        $window.open('doorlockmanual?id=' + $scope.sensorDetail.sensorModelId, 'doorlockmanual', 'scrollbars=yes,toolbar=no,resizable=yes,width=600,height=720');
      };
      $scope.showResetManual = function () {
        $window.open('guide/sensor/reset', 'reset manual', 'scrollbars=yes,toolbar=no,resizable=yes,width=640,height=720');
      };
    },
    templateUrl: '/templates/shop/sensor_detail_dialog.html' + '?t=' + window.buildTime
  };
});
"use strict";

app.directive("sharedIcon", function () {
  return {
    restrict: "E",
    scope: {
      tooltipData: "<",
      position: "<?",
      className: "@?"
    },
    replace: true,
    controller: function controller($scope, $translate) {
      $scope.position = $scope.position || "left";
      $scope.tooltipData = $scope.tooltipData || $translate.instant("SHARED_TOOLTIP");
      $scope.$watch("tooltipData", function (newValue) {
        if (!newValue) {
          $scope.tooltipData = $translate.instant("SHARED_TOOLTIP");
        } else {
          $scope.tooltipData = newValue;
        }
      });
    },
    template: "\n      <div class=\"{{ className }}\">\n        <tooltip-component\n          class-name=\"shared-tooltip\"\n          text=\"tooltipData ? tooltipData : 'Default Tooltip'\"\n          position=\"bottom\"\n          type=\"'bubble'\"\n          style=\"width:100%\"\n          is-tooltip-show=\"true\">\n          <img class=\"tooltip-content share_img\"\n            src=\"/resources/img/ic-share-store-select-tit.svg\"\n          />\n        </tooltip-component>\n      </div>\n    "
  };
});
"use strict";

app.directive('shopModifyDialog', function () {
  return {
    restrict: 'E',
    scope: {
      //show: '@',
    },
    replace: true,
    transclude: true,
    controller: function controller($scope, $rootScope, $translate, $state, $location, $window, Shop, Device, NgUtils) {
      $scope.shopAddModel = {};
      $scope.searchQueryStr = "";
      $scope.inputDetailAddress = "";
      $scope.shopControllers = [];
      $scope.isKrUI = true;
      $scope.protocol = $location.protocol() + '://';
      $scope.dlgMaxHeight = '';
      $scope.isLoadCams = true;
      $scope.keydownEvent = function ($event) {
        if ($event.key == '\\') {
          $event.preventDefault(); // form submit prevent
          return false;
        }
        if ($event.key == 'Enter' && $event.isComposing === false) {
          $scope.searchController(true);
          $event.preventDefault(); // form submit prevent
        }
      };
      if (window.country === "ko") {
        $scope.isKrUI = true;
      } else {
        $scope.isKrUI = false;
      }
      function showAlert(title, message) {
        $scope.showAlert = true;
        $scope.alertTitle = title;
        $scope.alertMessage = message;
      }
      $scope.hideAlert = function () {
        $scope.showAlert = false;
      };
      $scope.$parent.$watch('isShowAddShopDialog', function (newValue, oldValue) {
        if (newValue !== oldValue) {
          if (newValue === true) {
            $('body').addClass('blockScroll');
            updateDlgStyle();
            $scope.showModifyShopDialog();
          } else {
            $('body').removeClass('blockScroll');
          }
        }
      });
      function updateDlgStyle() {
        var marginTopSize = 50;
        var windowHeight = $(window).height();
        $scope.dlgMaxHeight = windowHeight - marginTopSize + 'px';
      }
      $scope.iotControllersTotalCount = null;
      $scope.getIotControllersTotalCount = function () {
        Device.iotControllersCountV1({}, function (res) {
          if (res.code === 'ok') {
            $scope.iotControllersTotalCount = res.totalCount;
            $scope.pagingUtil.setTotalCount(res.totalCount);
          }
        });
      };

      /**
       * 매장 수정하기 레이어 열기
       */
      $scope.showModifyShopDialog = function () {
        $scope.shopControllers = [];
        $scope.pagingUtil = NgUtils.pagingUtil();
        $scope.pagingUtil.init();
        $scope.pagingUtil.setTotalCount(999999);
        $scope.pagingUtil.setCallBackFunc($scope.searchController);
        $scope.isLoadCams = true;

        //전체 카메라 개수 totalCount init
        if ($scope.iotControllersTotalCount === null) $scope.getIotControllersTotalCount();
        $scope.popupSearchData = {
          keyword: ''
        };
        $scope.shopAddModel = {
          shopName: '',
          zipCode: '',
          address1: '',
          address2: '',
          timezone: "268",
          language: "ko",
          access: "on"
        };
        if (!($scope.shopControllers && $scope.shopControllers.length)) {
          $scope.searchController();
        }
      };
      $scope.makeParam = function () {
        var param = Object.assign({}, $scope.popupSearchData);
        param.pageNumber = $scope.pagingUtil.pageNumber();
        param.count = 16;
        param.totalCount = true;
        return param;
      };
      $scope.searchController = function (initFlag) {
        if (initFlag) {
          $scope.shopControllers.splice(0);
          $scope.isLoadCams = true;
          $scope.pagingUtil.setPage(1);
        }
        var param = $scope.makeParam();
        Device.iotControllersV1(param, function (res) {
          if (res.code === 'ok') {
            res.list.forEach(function (controller) {
              controller.isChecked = $scope.myShopControllers.some(function (myController) {
                return controller.controllerId == myController.deviceId;
              }) ? true : false;
            });
            $scope.shopControllers = $scope.shopControllers.concat(res.list);
            $scope.isLoadCams = false;
          }
        }, function (err) {
          showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
        });
      };
      $scope.showSearchAddressDialog = function (isShow) {
        $scope.isShowSearchAddressDialog = isShow;
      };

      /**
       * 매장 추가/수정 저장
       */
      $scope.saveShop = function () {
        var title = $translate.instant("SHOP_ADD");
        var params,
          cameras = [],
          iothubs = [];
        if ($scope.shopControllers) {
          $scope.shopControllers.forEach(function (device) {
            if (device.controllerType === 'CAMERA') {
              cameras.push(device);
            } else if (device.controllerType === 'IOTHUB') {
              iothubs.push(device);
            }
          });
        }
        if ($scope.isKrUI) {
          params = {
            shopName: $scope.shopAddModel.shopName,
            // zipCode: $scope.shopAddModel.zipCode,
            // address1: $scope.shopAddModel.address1,
            // address2: $scope.shopAddModel.address2,
            timezone: $scope.shopAddModel.timezone,
            language: $scope.shopAddModel.language,
            access: $scope.shopAddModel.access,
            cameraIds: _.chain(cameras).filter('isChecked').map('controllerId').value().join(','),
            iotHubIds: _.chain(iothubs).filter('isChecked').map('controllerId').value().join(',')
          };
        } else {
          params = {
            shopName: $scope.shopAddModel.shopName,
            cameraIds: _.chain(cameras).filter('isChecked').map('controllerId').value().join(','),
            iotHubIds: _.chain(iothubs).filter('isChecked').map('controllerId').value().join(',')
          };
        }
        if (!params.shopName || params.shopName.trim() === '') {
          showAlert(title, $translate.instant("SHOP_NAME_INPUT"));
          return;
        }
        if (params.cameraIds.length < 1 && params.iotHubIds.length < 1) {
          showAlert(title, $translate.instant("POS_CAMERA_SELECT"));
          return;
        }

        // 2023-01-03 매장 주소 입력 제거 
        // if ($scope.isKrUI) {
        //     if (!params.zipCode || !params.address1 || !params.address2) {
        //         showAlert(title, $translate.instant("STR_INPUT_ADDRESS"));
        //         return;
        //     }
        // }

        if ($scope.isKrUI) {
          Shop.regShopV2(params, function (res) {
            if (res.code === 'ok') {
              $('body').removeClass('blockScroll');
              $scope.$parent.isShowAddShopDialog = false;
              showAlert(title, $translate.instant("SHOP_ADDED"));
              $rootScope.dashboardShopList = null;
              $window.location.reload();
            } else {
              showAlert(title, $translate.instant("SHOP_ADD_FAIL"));
            }
          }, function (err) {
            showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
          });
        } else {
          Shop.regShopV2(params, function (res) {
            if (res.code === 'ok') {
              $('body').removeClass('blockScroll');
              $scope.$parent.isShowAddShopDialog = false;
              showAlert(title, $translate.instant("SHOP_ADDED"));
              $rootScope.dashboardShopList = null;
              $window.location.reload();
            } else {
              showAlert(title, $translate.instant("SHOP_ADD_FAIL"));
            }
          }, function (err) {
            showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
          });
        }
      };

      /**
       * 매장 추가/수정 레이어 닫기
       */
      $scope.hideAddShopDialog = function () {
        $scope.$parent.isShowAddShopDialog = false;
      };

      /**
       * 매장 추가/수정 팝업에서 카메라 체크 확인 팝업 닫기
       */
      $scope.hideCheckedCameraConfirm = function () {
        $scope.isShowCheckedCameraConfirm = false;
      };

      /**
       * 매장 추가/수정 팝업에서 카메라 체크 취소
       */
      $scope.cancelCameraCheck = function () {
        $scope.checkedCamera.isChecked = false;
        $scope.controllerListCheckedToggle($scope.checkedCamera);
        $scope.isShowCheckedCameraConfirm = false;
      };

      /**
       * 매장 추가/수정 팝업 카메라 목록에서 다른 매장에 이미
       * 등록된 카메라 선택했을 시 알림 팝업 호출
       * @param  {Object} camera
       */
      $scope.myShopControllers = [];
      $scope.controllerListCheckedToggle = function (controller) {
        var index = $scope.myShopControllers.findIndex(function (myController) {
          return myController.deviceId == controller.controllerId;
        });
        if (index >= 0) {
          $scope.myShopControllers.splice(index, 1);
        } else {
          controller.deviceId = controller.controllerId;
          controller.deviceType = controller.controllerType;
          $scope.myShopControllers.push(controller);
        }
      };
      $scope.validController = function (controller, isShopEditMode) {
        /**
         * 등록일 경우엔 shopId가 없으면 팝업 열고,
         * 수정일 경우엔 현재 shopId와 다르거나 shopId가 존재하면 팝업 열기
         */
        $scope.controllerListCheckedToggle(controller);
        if (controller.isChecked !== true) return;
        if (!isShopEditMode && typeof controller.shopId !== 'undefined' && controller.shopId !== null || isShopEditMode && controller.shopId !== $scope.shopObject.shopId && typeof controller.shopId !== 'undefined' && controller.shopId !== null) {
          $scope.isShowCheckedCameraConfirm = true;
          $scope.checkedCamera = controller;
        }
      };
      $scope.searchAddress = function (queryStr) {
        Shop.queryAddress({
          q: queryStr,
          startRank: 1,
          returnCount: 100
        }, function (res) {
          if (res && res.addresses && res.addresses.length) {
            $scope.addrSearchResults = res.addresses;
          } else {
            $scope.addrSearchResults = [];
          }
        }, function (error) {
          showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
        });
      };
      $scope.selectSearchAddress = function (selectAddress) {
        $scope.selectedSearchAddress = selectAddress;
        if ($scope.selectedSearchAddress) {
          $scope.selectedZipCodeAddress = $scope.selectedSearchAddress.zipCode + ' ' + $scope.selectedSearchAddress.roadAddress;
        }
      };
      $scope.adjustSearchAddress = function (detailAddr) {
        $scope.shopAddModel.zipCode = $scope.selectedSearchAddress.zipCode;
        $scope.shopAddModel.address1 = $scope.selectedSearchAddress.roadAddress;
        $scope.shopAddModel.address2 = detailAddr;
        $scope.addrSearchResults = null;
        $scope.selectedSearchAddress = null;
        $scope.inputDetailAddress = "";
        $scope.isShowSearchAddressDialog = false;
      };
      $scope.showSearchAddressDialog = function (isShow) {
        $scope.isShowSearchAddressDialog = isShow;
      };
    },
    templateUrl: '/templates/shop/shop_modify_dialog.html' + '?t=' + window.buildTime
  };
});
"use strict";

app.directive("staffRegistDialog", function () {
  return {
    restrict: "E",
    scope: {
      //show: '@',
    },
    replace: true,
    transclude: true,
    controller: function controller($scope, $q, $translate, $location, $timeout, $filter, $window, Shop, GMap, Access, Utils) {
      $scope.protocol = $location.protocol() + "://";
      $scope.currentShop;
      $scope.configStatus;
      $scope.isOnlyUseEmail;
      $scope.currentStaffWorkingTime;
      $scope.currentWorkingDaySet;
      $scope.cameraLocationInfo;
      $scope.selectedDistance;
      $scope.locSetNickName;
      $scope.locSetDate;
      $scope.locSetId;
      $scope.deleteStaffObj;
      $scope.accessConfigShop;
      $scope.accessStaffAdd;
      $scope.accessConfigStaffs;
      $scope.accessCemaraModifyList;
      $scope.accessBeaconCameraList;
      $scope.accessCameraInputBox;
      $scope.lbsSetStatus;
      $scope.isShowLocSetRequestPopup = false;
      $scope.isShowCloseTimeSetGuide = false;
      $scope.isShowConfirmRequestGuide = false;
      $scope.isShowDistanceSet = false;
      $scope.isShowAccessCameraListLayer = false;
      $scope.isShowAccessStaffDeleteConfirm = false;
      $scope.focusMinInput = false;
      $scope.dlgStatus;
      $scope.dlgStatusStack = [];
      $scope.STATUS_NORMAL = "normal";
      $scope.STATUS_INPUT_DAYS = "input_days";
      $scope.STATUS_ADD_TIME = "add_time";
      $scope.STATUS_EDIT_DAY = "edit_day";
      $scope.addInputHour;
      $scope.addInputMin;
      $scope.dayOfWeekSelectJSON;
      $scope.browserLang = $("html").attr("lang");
      $scope.dlgMaxHeight = "";
      $scope.timeToggleId = "time-toggle";
      $scope.searchedLocationInfo;
      $scope.isShowCameraLocationSetting = false;
      var timeToggleComp = null;
      var currentSelectedSource;
      var showAlert = function showAlert(title, message) {
        $(".display_show").css("display", "");
        $scope.showAlert = true;
        $scope.alertTitle = title;
        $scope.alertMessage = message;
      };
      $scope.hideAlert = function () {
        $scope.showAlert = false;
      };
      var updateMarketCloseTime = function updateMarketCloseTime(closeTime) {
        var hour = 0,
          min = 0;
        if (closeTime) {
          hour = Math.floor(closeTime / 60);
          min = closeTime % 60;
        }
        $("#market_close_hour").val("" + hour);
        $("#market_close_min").val("" + min);
      };
      var setIsOnlyUseEmail = function setIsOnlyUseEmail() {
        if (window.country === "ko") {
          $scope.isOnlyUseEmail = false;
        } else if (window.country === "ja") {
          $scope.isOnlyUseEmail = true;
        } else if (window.country === "en") {
          $scope.isOnlyUseEmail = false;
        } else {
          $scope.isOnlyUseEmail = false;
        }
      };
      var syncFor = function syncFor(index, len, status, func) {
        func(index, status, function (res) {
          if (res == "next") {
            index++;
            if (index < len) {
              syncFor(index, len, "r", func);
            } else {
              return func(index, "done", function () {});
            }
          }
        });
      };
      var fillDoubleZero = function fillDoubleZero(value) {
        var strValue = "" + value,
          len = strValue.length;
        if (len < 2) {
          if (len === 1) {
            return "0" + strValue;
          } else {
            return "00";
          }
        } else {
          return strValue;
        }
      };
      $scope.checkWeekDayLength = function (dayOfWeeks) {
        return dayOfWeeks ? Object.keys(dayOfWeeks).length : 0;
      };
      $scope.setIsStaffEditMode = function (isOn) {
        $scope.isStaffEditMode = isOn;
      };
      $scope.setIsDayEditMode = function (isOn) {
        $scope.isDayEditMode = isOn;
      };
      $scope.removeSelectedStaff = function () {
        var i,
          len,
          promiseList = [];
        for (i = 0, len = $scope.accessConfigStaffs.list.length; i < len; i += 1) {
          if ($scope.accessConfigStaffs.list[i].isChecked) {
            promiseList.push({
              shopId: $scope.accessConfigStaffs.list[i].shopId,
              paycoId: $scope.accessConfigStaffs.list[i].paycoId,
              userId: $scope.accessConfigStaffs.list[i].userId
            });
          }
        }
        if (promiseList.length) {
          syncFor(0, promiseList.length, "start", function (i, status, call) {
            if (status === "done") {
              $scope.setIsStaffEditMode(false);
              $scope.accessConfigStaffs = Access.getShopStaffs({
                shopId: $scope.currentShop.shopId
              });
              $scope.checkStaff();
            } else {
              Access.deleteAccessStaff({
                shopId: promiseList[i].shopId,
                paycoId: promiseList[i].paycoId,
                userId: promiseList[i].userId
              }, function (data) {
                call("next");
              }, function (err) {
                call("next");
                showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
              });
            }
          });
        } else {
          $scope.setIsStaffEditMode(false);
        }
      };
      $scope.checkDayOfWeek = function () {
        if (!$scope.currentStaffWorkingTime || !$scope.currentStaffWorkingTime.workingTimeSettings || !$scope.currentStaffWorkingTime.workingTimeSettings.dayOfWeeks) {
          $scope.isCheckDayOfWeek = false;
          return;
        }
        var key;
        for (key in $scope.currentStaffWorkingTime.workingTimeSettings.dayOfWeeks) {
          if ($scope.currentStaffWorkingTime.workingTimeSettings.dayOfWeeks[key]) {
            if ($scope.currentStaffWorkingTime.workingTimeSettings.dayOfWeeks[key].isChecked) {
              $scope.isCheckDayOfWeek = true;
              return;
            }
          }
        }
        $scope.isCheckDayOfWeek = false;
        return;
      };
      $scope.checkStaff = function () {
        if (!$scope.accessConfigStaffs || !$scope.accessConfigStaffs.list) {
          $scope.isCheckStaff = false;
          return;
        }
        var i,
          len = $scope.accessConfigStaffs.list.length;
        for (i = 0; i < len; i += 1) {
          if ($scope.accessConfigStaffs.list[i].isChecked) {
            $scope.isCheckStaff = true;
            return;
          }
        }
        $scope.isCheckStaff = false;
        return;
      };
      $scope.removeSelectedDay = function () {
        var key,
          dayOfWeekIds = "";
        for (key in $scope.currentStaffWorkingTime.workingTimeSettings.dayOfWeeks) {
          if ($scope.currentStaffWorkingTime.workingTimeSettings.dayOfWeeks[key]) {
            if ($scope.currentStaffWorkingTime.workingTimeSettings.dayOfWeeks[key].isChecked) {
              if (dayOfWeekIds) {
                dayOfWeekIds += "," + key;
              } else {
                dayOfWeekIds += key;
              }
            }
          }
        }
        if (dayOfWeekIds) {
          Access.deleteStaffWorkingTime({
            shopId: $scope.currentShop.shopId,
            staffId: $scope.currentStaffWorkingTime.userId,
            dayOfWeekIds: dayOfWeekIds
          }, function (data) {
            Access.getStaffWorkingTime({
              shopId: $scope.currentShop.shopId,
              staffId: $scope.currentStaffWorkingTime.userId
            }, function (data) {
              $scope.currentStaffWorkingTime = data;
              $scope.checkDayOfWeek();
            });
            $scope.setIsDayEditMode(false);
          }, function (err) {
            showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
            $scope.setIsDayEditMode(false);
          });
        } else {
          $scope.setIsDayEditMode(false);
        }
      };
      $scope.goPrevStatus = function () {
        $scope.dlgStatusStack.pop();
        var prevStatus = $scope.dlgStatusStack.pop();
        if (prevStatus) {
          $scope.setDlgStatus(prevStatus);
        }
      };
      $scope.setDlgStatus = function (status, dayOfWeekId) {
        $scope.isStaffEditMode = false;
        $scope.isDayEditMode = false;
        if (status === $scope.STATUS_ADD_TIME) {
          $scope.addInputHour = "00";
          $scope.addInputMin = "00";
          $scope.dayOfWeekSelectJSON = {
            MON: false,
            TUE: false,
            WED: false,
            THU: false,
            FRI: false,
            SAT: false,
            SUN: false
          };
        } else if (status === $scope.STATUS_EDIT_DAY) {
          var daySet = $scope.currentStaffWorkingTime.workingTimeSettings.dayOfWeeks[dayOfWeekId];
          if (daySet) {
            $scope.currentWorkingDaySet = {
              hour: daySet.officeGoingTime.split(":")[0] ? fillDoubleZero(daySet.officeGoingTime.split(":")[0]) : "00",
              min: daySet.officeGoingTime.split(":")[1] ? fillDoubleZero(daySet.officeGoingTime.split(":")[1]) : "00",
              dayOfWeekId: dayOfWeekId
            };
          }
        }
        $scope.dlgStatusStack.push(status);
        $scope.dlgStatus = status;
      };
      function updateDlgStyle() {
        var marginTopSize = 50;
        var windowHeight = $(window).height();
        $scope.dlgMaxHeight = windowHeight - marginTopSize + "px";
      }
      function initDialog() {
        $("body").on("click", timeSetGuideHideFn);
        document.body.classList.add("blockScroll");
        timeToggleComp = tCam.toggle($scope.timeToggleId);
        timeToggleComp.on("changed", function (event) {
          $scope.updateIsShopOpen24Hours(event.value);
        });
        updateDlgStyle();
        $scope.dlgStatusStack = [$scope.STATUS_NORMAL];
        $scope.currentShop = $scope.$parent.currentShop;
        $scope.setDlgStatus($scope.STATUS_NORMAL);
        $scope.configStatus = "access";
        setIsOnlyUseEmail();
        $scope.showShopAccessConfigDialog();
      }
      function destroyDialog() {
        $("body").off("click", timeSetGuideHideFn);
        $("body").removeClass("blockScroll");
        if (timeToggleComp) {
          timeToggleComp.destroy();
          timeToggleComp = null;
        }
      }
      $scope.$parent.$watch("isShowStaffRegistDialog", function (newValue, oldValue) {
        if (newValue !== oldValue) {
          if (newValue === true) {
            initDialog();
          } else {
            destroyDialog();
          }
        }
      });
      $scope.clickWorkingSet = function (event, dayOfWeekId, alarmOn) {
        if (event.target.className.indexOf("toggle_btn") != -1) {
          $scope.toggleWorkingTimeAlarm(dayOfWeekId, alarmOn === "on" ? "off" : "on");
        } else if (event.target.className.indexOf("check_day") != -1) {
          return;
        } else {
          if (!$scope.isDayEditMode) {
            $scope.setDlgStatus($scope.STATUS_EDIT_DAY, dayOfWeekId);
          }
        }
      };
      $scope.setting_chnage = function (status) {
        $scope.configStatus = status;
      };
      $scope.toggleOfficeAlarm = function (value) {
        Access.setOfficeAccessAlarm({
          shopId: $scope.currentShop.shopId
        }, {
          officeGoingAlarmOn: value
        }, function (data) {
          if (data.code === "ok") {
            $scope.accessConfigStaffs.officeGoingAlarmOn = value;
          }
        });
      };
      $scope.toggleDayOfWeekSelect = function (dayOfWeekId, value) {
        if ($scope.dayOfWeekSelectJSON) {
          $scope.dayOfWeekSelectJSON[dayOfWeekId] = value;
        }
      };
      $scope.workingTimeAdd = function (addInputHour, addInputMin) {
        var dayOfWeekIds = "",
          key,
          hour = parseInt(addInputHour, 10),
          min = parseInt(addInputMin, 10);
        if (hour >= 0 && hour < 24 && (min === 0 || min === 30)) {
          for (key in $scope.dayOfWeekSelectJSON) {
            if ($scope.dayOfWeekSelectJSON[key]) {
              if (dayOfWeekIds) {
                dayOfWeekIds += "," + key;
              } else {
                dayOfWeekIds += key;
              }
            }
          }
          if (!dayOfWeekIds) {
            showAlert($translate.instant("STR_TIME_ADD"), $translate.instant("STR_SELECT_DAY"));
            return;
          }
          Access.setStaffWorkingTime({
            shopId: $scope.currentShop.shopId,
            staffId: $scope.currentStaffWorkingTime.userId
          }, {
            dayOfWeekIds: dayOfWeekIds,
            officeGoingTime: fillDoubleZero(hour) + ":" + fillDoubleZero(min)
          }, function (data) {
            if (data.code === "ok") {
              Access.getStaffWorkingTime({
                shopId: $scope.currentShop.shopId,
                staffId: $scope.currentStaffWorkingTime.userId
              }, function (data) {
                $scope.currentStaffWorkingTime = data;
                $scope.setDlgStatus($scope.STATUS_INPUT_DAYS);
              });
            }
          });
        } else {
          showAlert($translate.instant("SHARE_FAIL3"), $translate.instant("SHARE_FAIL3_MSG"));
          return;
        }
      };
      $scope.saveCurrentWorkingSetTime = function (hour, min) {
        var dayOfWeekIds = $scope.currentWorkingDaySet.dayOfWeekId,
          hour = parseInt(hour, 10),
          min = parseInt(min, 10);
        if (hour >= 0 && hour < 24 && (min === 0 || min === 30)) {
          Access.setStaffWorkingTime({
            shopId: $scope.currentShop.shopId,
            staffId: $scope.currentStaffWorkingTime.userId
          }, {
            dayOfWeekIds: dayOfWeekIds,
            officeGoingTime: fillDoubleZero(hour) + ":" + fillDoubleZero(min)
          }, function (data) {
            if (data.code === "ok") {
              Access.getStaffWorkingTime({
                shopId: $scope.currentShop.shopId,
                staffId: $scope.currentStaffWorkingTime.userId
              }, function (data) {
                $scope.currentStaffWorkingTime = data;
                $scope.setDlgStatus($scope.STATUS_INPUT_DAYS);
              });
            }
          });
        } else {
          showAlert($translate.instant("SHARE_FAIL3"), $translate.instant("SHARE_FAIL3_MSG"));
          return;
        }
      };
      $scope.convertDayIdToString = function (dayOfWeekId, isLong) {
        switch (dayOfWeekId) {
          case "MON":
            return isLong ? $translate.instant("DAY_MON1") : $translate.instant("DAY_MON");
          case "TUE":
            return isLong ? $translate.instant("DAY_TUE1") : $translate.instant("DAY_TUE");
          case "WED":
            return isLong ? $translate.instant("DAY_WED1") : $translate.instant("DAY_WED");
          case "THU":
            return isLong ? $translate.instant("DAY_THU1") : $translate.instant("DAY_THU");
          case "FRI":
            return isLong ? $translate.instant("DAY_FRI1") : $translate.instant("DAY_FRI");
          case "SAT":
            return isLong ? $translate.instant("DAY_SAT1") : $translate.instant("DAY_SAT");
          case "SUN":
            return isLong ? $translate.instant("DAY_SUN1") : $translate.instant("DAY_SUN");
          default:
            return "";
        }
      };
      $scope.toggleWorkingTimeAlarm = function (dayOfWeekId, alarmOn) {
        Access.setStaffWorkingAlarm({
          shopId: $scope.currentShop.shopId,
          staffId: $scope.currentStaffWorkingTime.userId
        }, {
          dayOfWeekIds: dayOfWeekId,
          alarmOn: alarmOn
        }, function (data) {
          if (data.code === "ok") {
            Access.getStaffWorkingTime({
              shopId: $scope.currentShop.shopId,
              staffId: $scope.currentStaffWorkingTime.userId
            }, function (data) {
              $scope.currentStaffWorkingTime = data;
            });
          }
        });
      };
      $scope.editStaffWorkingTime = function (staffId) {
        if (!staffId) {
          showAlert($translate.instant("STR_ACCESS_TIME_INPUT"), $translate.instant("STR_EDIT_TIME_ERR"));
          return;
        }
        Access.getStaffWorkingTime({
          shopId: $scope.currentShop.shopId,
          staffId: staffId
        }, function (data) {
          $scope.currentStaffWorkingTime = data;
          if ($scope.currentStaffWorkingTime.workingTimeSettings.dayOfWeeks && Object.keys($scope.currentStaffWorkingTime.workingTimeSettings.dayOfWeeks).length) {
            $scope.setDlgStatus($scope.STATUS_INPUT_DAYS);
          } else {
            $scope.setDlgStatus($scope.STATUS_ADD_TIME);
          }
        });
      };
      function getBeaconList(devList) {
        var beaconList = [];
        if (!devList) {
          return beaconList;
        }
        devList.forEach(function (device) {
          if (device.isBeacon) {
            device.checked = true;
            beaconList.push(device);
          }
        });
        return beaconList;
      }

      /**
       * 매장 출입설정 dialog open
       */
      $scope.showShopAccessConfigDialog = function () {
        Shop.getShopGeofence({
          shopId: $scope.currentShop.shopId
        }, function (data) {
          var latlng;
          $scope.cameraLocationInfo = {};
          if (data.shopId === $scope.currentShop.shopId) {
            if (data.position) {
              latlng = data.position.split(",");
              if (latlng.length >= 2) {
                $scope.cameraLocationInfo.lat = parseFloat(latlng[0]);
                $scope.cameraLocationInfo.lng = parseFloat(latlng[1]);
                GMap.getAddrWithGeocode(data.position).then(function (result) {
                  if (result) {
                    $scope.cameraLocationInfo.address = result;
                  }
                }, function (error) {
                  $scope.cameraLocationInfo.address = $translate.instant("DONT_KNOW_ADDR");
                });
              }
            }
            if (data.distance) {
              $scope.cameraLocationInfo.distance = data.distance;
              $scope.selectedDistance = data.distance;
            } else {
              $scope.cameraLocationInfo.distance = 0;
              $scope.selectedDistance = 0;
            }
          }
        }, function (err) {
          showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
        });
        var promise1 = Shop.getShopV2({
          shopId: $scope.currentShop.shopId
        }).$promise;
        var promise2 = Access.getShopStaffs({
          shopId: $scope.currentShop.shopId
        }).$promise;
        $q.all([promise1, promise2]).then(function (res) {
          $scope.accessConfigShop = res[0];
          $scope.accessConfigStaffs = res[1];
          if (timeToggleComp) {
            timeToggleComp.value = $scope.accessConfigShop.open24Hours;
          }
          $timeout(function () {
            if ($scope.accessConfigShop) {
              updateMarketCloseTime($scope.accessConfigShop.workTime);
            }
          }, 200);
          $scope.accessBeaconCameraList = getBeaconList(res[0].controllerList);
          var beacon = null;
          if ($scope.accessBeaconCameraList.length) {
            beacon = $scope.accessBeaconCameraList[0];
            $scope.accessCameraInputBox = beacon.deviceType === "IOTHUB" ? beacon.iotHubInfo.labelName : beacon.cameraInfo.labelName;
            if ($scope.accessBeaconCameraList.length > 1) {
              $scope.accessCameraInputBox += " " + $translate.instant("EXCEPT") + " " + ($scope.accessBeaconCameraList.length - 1) + $translate.instant("ITEM_COUNT");
            }
          } else {
            $scope.accessCameraInputBox = "";
          }
          $scope.accessStaffAdd = {};
        }, function (err) {
          showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
        });
      };
      function timeSetGuideHideFn(event) {
        if (event.target.id !== "btn_time_tooltip" && (event.target.parentNode ? event.target.parentNode.id !== "btn_time_tooltip" : true)) {
          if ($scope.isShowCloseTimeSetGuide) {
            $scope.isShowCloseTimeSetGuide = false;
            $scope.$apply();
          }
        }
      }
      $scope.toggleCloseTimeSetGuide = function () {
        if (!$scope.isShowCloseTimeSetGuide) {
          $scope.timeTooltipTop = $("#btn_time_tooltip")[0].offsetTop - 60;
          $scope.timeTooltipLeft = $("#btn_time_tooltip")[0].offsetLeft + 30;
          $scope.isShowCloseTimeSetGuide = true;
        } else {
          $scope.isShowCloseTimeSetGuide = false;
        }
      };
      $scope.showConfirmRequestGuide = function () {
        $scope.isShowConfirmRequestGuide = true;
      };
      $scope.hideConfirmRequestGuide = function () {
        $scope.isShowConfirmRequestGuide = false;
      };
      $scope.showAccessCameraListLayer = function () {
        var i,
          bleSupportDevices = [];
        if ($scope.accessConfigShop && $scope.accessConfigShop.controllerList) {
          $scope.accessConfigShop.controllerList.forEach(function (device) {
            if (device.deviceType === "CAMERA") {
              if (device.cameraInfo.isBleSupport === 1) {
                bleSupportDevices.push(device);
              }
            } else if (device.deviceType === "IOTHUB") {
              if (device.iotHubInfo.isBleSupport === 1) {
                bleSupportDevices.push(device);
              }
            }
          });
        }
        if (!bleSupportDevices || bleSupportDevices.length < 1) {
          showAlert($translate.instant("ACCESS_CAMERA_SECURITY_SELECT"), $translate.instant("9rRqk7Vo_02136"));
          return;
        }
        $scope.isShowAccessCameraListLayer = true;
        $("input[name='access_cameraList']").prop("checked", false);
        for (i = 0; i < $scope.accessBeaconCameraList.length; i++) {
          $("#label_" + $scope.accessBeaconCameraList[i].deviceId).prop("checked", true);
        }
      };
      $scope.showDistanceSetLayer = function (isShow) {
        $scope.isShowDistanceSet = isShow;
      };
      $scope.updateIsShopOpen24Hours = function (isOpen24Hours) {
        if ($scope.currentShop && $scope.accessConfigShop) {
          Shop.updateShopWorkTime({
            shopId: $scope.currentShop.shopId
          }, {
            workTime: $scope.accessConfigShop.workTime,
            open24Hours: isOpen24Hours
          }, function (res) {
            if (res.code === "ok") {
              Shop.getShopV2({
                shopId: $scope.accessConfigShop.shopId
              }, function (data) {
                $scope.accessConfigShop = data;
                if (timeToggleComp) {
                  timeToggleComp.value = $scope.accessConfigShop.open24Hours;
                }
                $timeout(function () {
                  if ($scope.accessConfigShop) {
                    updateMarketCloseTime($scope.accessConfigShop.workTime);
                  }
                }, 200);
              });
            }
          });
        }
      };
      $scope.updateShopWorkTime = function () {
        var hour = $("#market_close_hour").val(),
          min = $("#market_close_min").val(),
          workTimeValue = parseInt(hour, 10) * 60 + parseInt(min, 10);
        if ($scope.currentShop && $scope.accessConfigShop) {
          Shop.updateShopWorkTime({
            shopId: $scope.currentShop.shopId
          }, {
            workTime: workTimeValue,
            open24Hours: $scope.accessConfigShop.open24Hours
          }, function (res) {
            if (res.code === "ok") {
              Shop.getShopV2({
                shopId: $scope.accessConfigShop.shopId
              }, function (data) {
                $scope.accessConfigShop = data;
                $timeout(function () {
                  if ($scope.accessConfigShop) {
                    updateMarketCloseTime($scope.accessConfigShop.workTime);
                  }
                }, 200);
              });
              showAlert($translate.instant("MARKET_CLOSE_TIME"), $translate.instant("MARKET_CLOSE_TIME_SETTING_TXT4"));
            }
          });
        }
      };

      /**
       * 출입 직원 등록 추가
       */
      $scope.addAccessStaff = function () {
        if (!$scope.accessConfigShop.beaconId) {
          showAlert($translate.instant("ACCESS_ENROLL_ADD"), $translate.instant("ACCESS_CAMERA_SET_FIRST"));
          return;
        }
        var params = {
          shopId: $scope.currentShop.shopId,
          nickName: $scope.accessStaffAdd.nickName,
          paycoId: $scope.accessStaffAdd.paycoId
        };
        var validPhone = Utils.phoneNumberVaild(Utils.toFormattedPhoneNumber(params.paycoId));
        var validEmail = Utils.emailValid(Utils.toFormattedPhoneNumber(params.paycoId));
        if ($scope.isOnlyUseEmail == false) {
          if (validPhone == false && validEmail == false) {
            showAlert($translate.instant("ACCESS_ENROLL_ADD"), $translate.instant("ACCESS_ENTER_NUMBER"));
            return;
          } else if (validPhone == true && validEmail == false) {
            params.paycoId = params.paycoId.replace(/-/gi, ""); // mibile 계정일 경우 "-" 제거
          }
        } else {
          if (validEmail == false) {
            showAlert($translate.instant("ACCESS_ENROLL_ADD"), $translate.instant("CORRECT_EMAIL"));
            return;
          }
        }
        if (typeof params.nickName === "undefined" || params.nickName === "") {
          showAlert($translate.instant("ACCESS_ENROLL_ADD"), $translate.instant("ACCESS_ENTER_NAME"));
          return;
        }
        Access.regAccessStaff(params, function (res) {
          if (res.code === "ok") {
            $scope.accessConfigStaffs = Access.getShopStaffs({
              shopId: $scope.currentShop.shopId
            });
            $scope.accessStaffAdd = {};
          } else {
            showAlert($translate.instant("ACCESS_ENROLL_ADD"), res.msg);
          }
        }, function (err) {
          showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
        });
      };
      $scope.getStaffStatus = function (source) {
        if (!source) {
          return {
            status: "nosign",
            text: $translate.instant("ACCESS_WAIT_SIGNUP")
          };
        }
        if (source.userId) {
          if (source.lbsAgreed === "ok") {
            return {
              status: "ok"
            };
          } else {
            return {
              status: "notagree",
              text: $translate.instant("LOC_NOT_AGREE")
            };
          }
        } else {
          return {
            status: "nosign",
            text: $translate.instant("ACCESS_WAIT_SIGNUP")
          };
        }
      };
      $scope.showLocSetRequestPopup = function (isShow, source) {
        $scope.lbsSetStatus = "nosign";
        if (isShow && source) {
          currentSelectedSource = source;
          $scope.locSetNickName = source.nickName;
          $scope.locSetDate = $filter("date")(source.regDate, "yyyy.MM.dd");
          $scope.locSetId = source.paycoId;
          if (source.userId) {
            if (source.lbsAgreed === "ok") {
              $scope.lbsSetStatus = "ok";
            } else {
              $scope.lbsSetStatus = "notagree";
            }
          } else {
            $scope.lbsSetStatus = "nosign";
          }
        }
        $scope.isShowLocSetRequestPopup = isShow;
      };

      /**
       * 출입 직원 등록 해제 확인 팝업 open
       * @param {Object} staff
       */
      $scope.showAccessStaffDeleteConfirm = function (staff) {
        $scope.deleteStaffObj = staff;
        $scope.isShowAccessStaffDeleteConfirm = true;
      };

      /**
       * 매장 출입설정 dialog close
       */
      $scope.hideShopAccessConfigDialog = function () {
        $scope.$parent.isShowStaffRegistDialog = false;
      };
      $scope.setDistance = function (selectedDistance) {
        if ($scope.cameraLocationInfo && $scope.cameraLocationInfo.lat && $scope.cameraLocationInfo.lng) {
          //If Camera Geofence Info Exist
          var params = {
            position: $scope.cameraLocationInfo.lat + "," + $scope.cameraLocationInfo.lng,
            distance: selectedDistance
          };
          Shop.updateShopGeofence({
            shopId: $scope.currentShop.shopId
          }, params, function (data) {
            if (data.code === "ok") {
              $scope.cameraLocationInfo.distance = selectedDistance;
            } else {
              showAlert($translate.instant("FAIL"), $translate.instant("ACCESS_SET_FAIL"));
            }
          }, function (error) {
            showAlert($translate.instant("FAIL"), $translate.instant("ACCESS_SET_FAIL"));
          });
        } else {
          showAlert($translate.instant("FAIL"), $translate.instant("ACCESS_SET_FAIL"));
        }
        $scope.showDistanceSetLayer(false);
      };
      $scope.sendPush = function () {
        var param;
        if (currentSelectedSource) {
          if ($scope.lbsSetStatus === "bleoff") {
            param = {
              receiver: currentSelectedSource.paycoId,
              userId: currentSelectedSource.userId
            };
            Access.requestAccess({
              shopId: currentSelectedSource.shopId
            }, param, function (data) {
              if (data && data.code === "ok") {
                showAlert($translate.instant("SEND_COMPLETE"), $translate.instant("SEND_REQUEST"));
              } else {
                showAlert($translate.instant("FAIL"), $translate.instant("ACCESS_SET_FAIL"));
              }
            }, function (error) {
              showAlert($translate.instant("FAIL"), $translate.instant("ACCESS_SET_FAIL"));
            });
          } else if ($scope.lbsSetStatus === "notagree") {
            param = {
              receiver: currentSelectedSource.paycoId,
              userId: currentSelectedSource.userId
            };
            Access.requestSignAgree({
              shopId: currentSelectedSource.shopId
            }, param, function (data) {
              if (data && data.code === "ok") {
                showAlert($translate.instant("SEND_COMPLETE"), $translate.instant("SEND_REQUEST"));
              } else {
                showAlert($translate.instant("FAIL"), $translate.instant("ACCESS_SET_FAIL"));
              }
            }, function (error) {
              showAlert($translate.instant("FAIL"), $translate.instant("ACCESS_SET_FAIL"));
            });
          } else if ($scope.lbsSetStatus === "nosign") {
            param = {
              paycoId: currentSelectedSource.paycoId
            };
            Access.requestSignup({
              shopId: currentSelectedSource.shopId
            }, param, function (data) {
              if (data && data.code === "ok") {
                showAlert($translate.instant("SEND_COMPLETE"), $translate.instant("SEND_REQUEST"));
              } else {
                showAlert($translate.instant("FAIL"), $translate.instant("ACCESS_SET_FAIL"));
              }
            }, function (error) {
              showAlert($translate.instant("FAIL"), $translate.instant("ACCESS_SET_FAIL"));
            });
          } else {
            param = {
              receiver: currentSelectedSource.paycoId,
              userId: currentSelectedSource.userId
            };
            Access.requestAccess({
              shopId: currentSelectedSource.shopId
            }, param, function (data) {
              if (data && data.code === "ok") {
                showAlert($translate.instant("SEND_COMPLETE"), $translate.instant("SEND_REQUEST"));
              } else {
                showAlert($translate.instant("FAIL"), $translate.instant("ACCESS_SET_FAIL"));
              }
            }, function (error) {
              showAlert($translate.instant("FAIL"), $translate.instant("ACCESS_SET_FAIL"));
            });
          }
        }
      };
      $scope.releaseMember = function () {
        if (currentSelectedSource) {
          $scope.showAccessStaffDeleteConfirm(currentSelectedSource);
        }
      };
      $scope.showCameraLocationSetting = function () {
        var $locationInput = $("#location_input");
        $scope.isShowCameraLocationSetting = true;
        if ($scope.cameraLocationInfo && $scope.cameraLocationInfo.address) {
          $scope.searchedLocationInfo = {};
          $scope.searchedLocationInfo.lat = $scope.cameraLocationInfo.lat;
          $scope.searchedLocationInfo.lng = $scope.cameraLocationInfo.lng;
          $scope.searchedLocationInfo.address = $scope.cameraLocationInfo.address;
        }
        if ($locationInput.length > 0) {
          $locationInput.val("");
        }
        GMap.loadGoogleMap($scope.cameraLocationInfo);
      };
      $scope.hideCameraLocationSetting = function () {
        $scope.isShowCameraLocationSetting = false;
      };

      /**
       * 출입 카메라 변경 저장
       */
      $scope.saveAccessBeaconCamera = function () {
        var i, beaconCameraIdListString;
        $scope.accessCemaraModifyList = $("input[name='access_cameraList'].checked");
        if ($scope.accessCemaraModifyList.length < 1) {
          beaconCameraIdListString = "";
        } else {
          beaconCameraIdListString = $scope.accessCemaraModifyList[0].value;
          for (i = 1; i < $scope.accessCemaraModifyList.length; i++) {
            beaconCameraIdListString += "," + $scope.accessCemaraModifyList[i].value;
          }
        }
        var params = {
          beaconCameraId: beaconCameraIdListString
        };
        Shop.updateAccessBeaconCameraId({
          shopId: $scope.accessConfigShop.shopId
        }, params, function (res) {
          if (res.code === "ok") {
            $scope.closeAccessCameraListLayer();
            Shop.getShopV2({
              shopId: $scope.accessConfigShop.shopId
            }, function (res) {
              $scope.accessConfigShop = res;
              $scope.accessBeaconCameraList = getBeaconList(res.controllerList);
              var beacon = null;
              if ($scope.accessBeaconCameraList.length) {
                beacon = $scope.accessBeaconCameraList[0];
                $scope.accessCameraInputBox = beacon.deviceType === "IOTHUB" ? beacon.iotHubInfo.labelName : beacon.cameraInfo.labelName;
                if ($scope.accessBeaconCameraList.length > 1) {
                  $scope.accessCameraInputBox += " 외 " + ($scope.accessBeaconCameraList.length - 1) + "대";
                }
              } else {
                $scope.accessCameraInputBox = "";
              }
            });
          } else {
            showAlert($translate.instant("ACCESS_CAMERA_CHANGE"), $translate.instant("ACCESS_CAMERA_CHANGE_FAIL"));
          }
        }, function (err) {
          showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
        });
      };

      /**
       * 출입 설정 카메라 선택 팝업 닫기
       */
      $scope.closeAccessCameraListLayer = function () {
        $scope.isShowAccessCameraListLayer = false;
      };

      /**
       * 출입 직원 등록 삭제
       */
      $scope.deleteAccessStaff = function () {
        var params = {
          shopId: $scope.deleteStaffObj.shopId,
          paycoId: $scope.deleteStaffObj.paycoId,
          userId: $scope.deleteStaffObj.userId
        };
        Access.deleteAccessStaff(params, function (res) {
          if (res.code === "ok") {
            // showAlert($translate.instant("ACCESS_ENROLL_CLEAR"), $translate.instant("ACCESS_ENROLL_COMPLETE"));
            $scope.isShowAccessStaffDeleteConfirm = false;
            $scope.isShowLocSetRequestPopup = false;
            $scope.accessConfigStaffs = Access.getShopStaffs({
              shopId: $scope.currentShop.shopId
            });
          } else {
            showAlert($translate.instant("ACCESS_ENROLL_CLEAR"), $translate.instant("ACCESS_FAIL"));
          }
        }, function (err) {
          showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
        });
      };

      /**
       * 출입 직원 등록 해제 확인 팝업 close
       */
      $scope.hideAccessStaffDeleteConfirm = function () {
        $scope.isShowAccessStaffDeleteConfirm = false;
      };
    },
    templateUrl: "/templates/shop/staff_regist_dialog.html" + "?t=" + window.buildTime
  };
});
"use strict";

app.directive("tooltipComponent", function ($timeout, $document) {
  var tooltipElement;
  var activeScope = null;
  function createTooltipElement() {
    if (!tooltipElement) {
      tooltipElement = angular.element('<div class="custom-tooltip"></div>');
      angular.element(document.body).append(tooltipElement);
    }
  }
  return {
    restrict: "E",
    transclude: true,
    scope: {
      text: "<",
      type: "<",
      position: "@?",
      delay: "@?",
      className: "@?",
      detectEllipsis: "<"
    },
    template: "<div class=\"tooltip-wrapper {{ className }}\"\n                    ng-mouseenter=\"checkEllipsisAndShow()\" \n                    ng-mouseleave=\"hideTooltip()\">\n                    <ng-transclude class=\"tooltip-content\"></ng-transclude>\n                 </div>",
    link: function link(scope, element, attrs) {
      scope.position = attrs.position || "top";
      scope.delay = attrs.delay || 0;
      scope.type = attrs.type || "default";
      var timeout;
      var debounceTimeout;
      var rafId;
      var hideTimeout;
      var targetElement = element[0].querySelector("ng-transclude *"); // ng-transclude 내부 요소 가져오기

      function isTextEllipsis(el) {
        if (!el) return false;
        var parent = el.closest(".tooltip-wrapper") || el.parentElement;
        if (!parent) return false;
        return el.scrollWidth > parent.clientWidth || el.offsetWidth < el.scrollWidth;
      }
      function positionTooltip() {
        if (!tooltipElement) return;
        if (rafId) cancelAnimationFrame(rafId);
        rafId = requestAnimationFrame(function () {
          var elemRect = element[0].getBoundingClientRect();
          var tooltipRect = tooltipElement[0].getBoundingClientRect();
          var additionalOffset = scope.type === "bubble" ? 10 : 0;
          var positionAdjustments = {
            bottom: {
              top: elemRect.bottom + 2 + additionalOffset,
              left: elemRect.left + elemRect.width * 0.1 - additionalOffset
            },
            left: {
              top: elemRect.top + elemRect.width * 0.1,
              left: elemRect.left - tooltipRect.width - 2
            },
            right: {
              top: elemRect.top + (elemRect.height - tooltipRect.height) / 2,
              left: elemRect.right + 2
            },
            top: {
              top: elemRect.top - tooltipRect.height - 2 - additionalOffset,
              left: elemRect.left + (elemRect.width - tooltipRect.width) / 2 + additionalOffset
            }
          };
          var _ref = positionAdjustments[scope.position] || positionAdjustments.top,
            top = _ref.top,
            left = _ref.left;
          tooltipElement.css({
            top: "".concat(top + window.scrollY, "px"),
            left: "".concat(left + window.scrollX, "px")
          });
        });
      }
      scope.checkEllipsisAndShow = function () {
        scope.$applyAsync(function () {
          if (!scope.detectEllipsis || targetElement && isTextEllipsis(targetElement)) {
            if (activeScope === scope) return;
            activeScope = scope;
            createTooltipElement();
            tooltipElement.text(scope.text);
            tooltipElement.addClass("tooltip-visible");
            positionTooltip();
            tooltipElement.toggleClass("bubble-tooltip", scope.type === "bubble");
          }
        });
      };
      scope.hideTooltip = function () {
        if (!tooltipElement || !tooltipElement.hasClass("tooltip-visible")) return;
        if (timeout) $timeout.cancel(timeout);
        tooltipElement.removeClass("tooltip-visible");
        if (activeScope === scope) {
          activeScope = null;
        }
        hideTimeout = $timeout(function () {
          hideTimeout = null;
        }, 200);
      };
      scope.$on("$destroy", function () {
        if (activeScope === scope) {
          tooltipElement.removeClass("tooltip-visible");
          activeScope = null;
        }
      });
      element.on("mouseenter", function () {
        if (hideTimeout) {
          $timeout.cancel(hideTimeout);
          hideTimeout = null;
        }
        if (debounceTimeout) return;
        debounceTimeout = $timeout(function () {
          if (!tooltipElement || !tooltipElement.hasClass("tooltip-visible") || activeScope !== scope) {
            scope.checkEllipsisAndShow();
          }
          debounceTimeout = null;
        }, 10);
      });
      element.on("mouseleave", scope.hideTooltip);
    }
  };
});
"use strict";

// 매장 출입 관리
app.factory('Access', ['$resource', function ($resource) {
  return $resource('/json/biz/shop/access/sources', {}, {
    getShopStaffs: {
      url: '/json/biz/shop/:shopId/access/sources'
    },
    setOfficeAccessAlarm: {
      url: '/json/biz/shop/:shopId/officeGoingAlarmOn',
      method: 'PUT'
    },
    getStaffWorkingTime: {
      url: '/json/biz/shop/:shopId/staff/:staffId/workingTimes'
    },
    setStaffWorkingTime: {
      url: '/json/biz/shop/:shopId/staff/:staffId/workingTimeSettings',
      method: 'PUT'
    },
    deleteStaffWorkingTime: {
      url: '/json/biz/shop/:shopId/staff/:staffId/workingTimeSettings',
      method: 'DELETE'
    },
    setStaffWorkingAlarm: {
      url: '/json/biz/shop/:shopId/staff/:staffId/workingTimeSettings/officeGoingAlarmOn',
      method: 'PUT'
    },
    regAccessStaff: {
      url: '/json/biz/shop/access',
      method: 'POST'
    },
    deleteAccessStaff: {
      url: '/json/biz/shop/access',
      method: 'DELETE'
    },
    getAccessTargets: {
      url: '/json/biz/shop/access/targets'
    },
    deleteAccessTarget: {
      url: '/json/biz/shop/access/targets',
      method: 'DELETE'
    },
    getAccessStaffs: {
      url: '/json/biz/shop/access/staffs'
    },
    getAccessSummary: {
      url: '/json/biz/shop/access/summary'
    },
    downloadExcel: {
      url: '/json/biz/shop/access/staffs/excel'
    },
    getAccessManager: {
      url: '/json/biz/accessManager'
    },
    saveAccessStaffsDate: {
      url: '/json/biz/shop/:shopId/access/update',
      method: 'POST'
    },
    getAccessAlramConfig: {
      url: '/json/biz/shop/:shopId/notifyConfig',
      method: 'GET'
    },
    saveAccessAlramConfig: {
      url: '/json/biz/shop/:shopId/notifyConfig',
      method: 'PUT'
    },
    requestSignup: {
      url: '/json/biz/shop/:shopId/access/resendMessage',
      method: 'POST'
    },
    requestAccess: {
      url: '/json/biz/shop/:shopId/access/resendPush',
      method: 'POST'
    },
    requestSignAgree: {
      url: '/json/biz/shop/:shopId/lbsAgree/resendPush',
      method: 'POST'
    }
  });
}]);

//매장 출입 관리 - weekly
app.factory('AccessStaffWeekly', ['$resource', function ($resource) {
  return $resource('/json/biz/shop/:shopId/access/staffs/:staffId/weekly', {}, {
    getAccessStaffWeekly: {
      url: '/json/biz/shop/:shopId/access/staffs/:staffId/weekly'
    },
    getShopStaffs: {
      url: '/json/biz/shop/:shopId/staffs'
    }
  });
}]);

//매장 출입 관리 - monthly
app.factory('AccessStaffMonthly', ['$resource', function ($resource) {
  return $resource('/json/biz/shop/:shopId/access/staffs/:staffId/monthly', {}, {
    getAccessStaffMonthly: {
      url: '/json/biz/shop/:shopId/access/staffs/:staffId/monthly'
    }
  });
}]);
// JavaScript Document

//
"use strict";
"use strict";

app.factory("AiFace", ['$resource', function ($resource) {
  return $resource('/json/biz/ai/face/user/:userId/product', {}, {
    aiFaceDashboardEvents: {
      url: '/json/biz/dashboard/ai/face/shop/:shopId/events'
    },
    //shopEventLimit
    aiFaceEvents: {
      url: '/json/biz/ai/face/shop/:shopId/event'
    },
    //date(20200504), filterId(AAAACCAZ)
    eventGroups: {
      url: '/json/biz/ai/face/shop/:shopId/eventGroups'
    },
    // date, filterIds
    eventsByHourly: {
      url: '/json/biz/ai/face/shop/:shopId/eventsByHourly'
    },
    // date, filterIds
    eventsByPivot: {
      url: '/json/biz/ai/face/shop/:shopId/eventsByPivot'
    },
    // pivotId, direction(center or next or prev), count
    eventsByRange: {
      url: '/json/biz/ai/face/shop/:shopId/eventsByRange'
    },
    eventsPersonByPivot: {
      url: '/json/biz/ai/face/persons/:personId/eventsByPivot'
    },
    // pivotId, direction(center or next or prev), count(default20)
    eventsPersonByRange: {
      url: '/json/biz/ai/face/persons/:personId/eventsByRange'
    },
    // startDate, endDate
    doorlockSetting: {
      url: '/json/biz/ai/face/doorlocks/:sensorId'
    },
    doorlockFaceUse: {
      url: '/json/biz/ai/face/doorlocks/:sensorId/isUse'
    },
    updateDoorlockFaceUse: {
      url: '/json/biz/ai/face/doorlocks/:sensorId/isUse',
      method: 'PUT'
    },
    sharedAccounts: {
      url: '/json/biz/ai/face/sharedAccounts'
    },
    recievedAccounts: {
      url: '/json/biz/ai/face/recievedAccounts'
    },
    doorlockAddPerson: {
      url: '/json/biz/ai/face/doorlocks/:sensorId/persons',
      method: 'PUT'
    },
    //personIds
    doorlockDeletePerson: {
      url: '/json/biz/ai/face/doorlocks/:sensorId/persons',
      method: 'DELETE'
    },
    //personIds
    doorlockAddCamera: {
      url: '/json/biz/ai/face/doorlocks/:sensorId/cameras',
      method: 'PUT'
    },
    //cameraIds
    doorlockDeleteCamera: {
      url: '/json/biz/ai/face/doorlocks/:sensorId/cameras',
      method: 'DELETE'
    },
    //cameraIds
    accounts: {
      url: '/json/biz/ai/face/accounts'
    },
    groups: {
      url: '/json/biz/ai/face/user/:userId/groups'
    },
    persons: {
      url: '/json/biz/ai/face/user/:userId/persons'
    },
    personDetail: {
      url: '/json/biz/ai/face/user/:userId/person/:personId'
    },
    aiCamera: {
      url: '/json/biz/ai/face/user/:userId/cameras'
    },
    aiCameras: {
      url: '/json/biz/ai/cameras'
    },
    setting: {
      url: '/json/biz/ai/face/settings'
    },
    //snippet (product,accounts,cameraCount)
    faces: {
      url: '/json/biz/ai/face/user/:userId/pool'
    },
    //date(20200504), filterId(AAAACCAZ)
    history: {
      url: '/json/biz/ai/face/user/:userId/detect/debug'
    },
    enableService: {
      url: '/json/biz/ai/face/user/:userId/enable',
      method: 'POST'
    },
    createCollection: {
      url: '/json/biz/ai/face/user/:userId/collection',
      method: 'POST'
    },
    createProduct: {
      url: '/json/biz/ai/face/user/:userId/product',
      method: 'POST'
    },
    deleteFaces: {
      url: '/json/biz/ai/face/user/:userId/pool',
      method: 'DELETE'
    },
    //poolIds(List<String)
    createPeople: {
      url: '/json/biz/ai/face/user/:userId/person',
      method: 'POST'
    },
    //name(String), faceIds(List<String>), masterFaceId(String)
    deletePeople: {
      url: '/json/biz/ai/face/user/:userId/person',
      method: 'DELETE'
    },
    updatePeople: {
      url: '/json/biz/ai/face/user/:userId/person',
      method: 'PUT'
    },
    //personId, masterFaceId, name, addPoolIds(List<String>), deleteIds(List<String>)
    createGroup: {
      url: '/json/biz/ai/face/user/:userId/group',
      method: 'POST'
    },
    //name, personIds(List<String>)
    updateGroup: {
      url: '/json/biz/ai/face/user/:userId/group/:groupId',
      method: 'PUT'
    },
    //name, addIds(List<String>), deleteIds(List<String>)
    deleteGroup: {
      url: '/json/biz/ai/face/user/:userId/groups',
      method: 'DELETE'
    },
    deleteSharedAccount: {
      url: '/json/biz/ai/face/sharedAccount/:deleteId',
      method: 'DELETE'
    },
    updateSharedAccount: {
      url: '/json/biz/ai/face/sharedAccount',
      method: 'PUT'
    } //name, account, deleteId
  });
}]);
"use strict";

app.factory("AudioChat", ["$rootScope", "$window", "User", "Utils", function ($rootScope, $window, User, Utils) {
  var audioChat = {};
  var camera = {};
  var mediaConfig = {
    audio: true,
    video: false
  };
  var socket = null,
    cameraId,
    configValue = {
      peerConnectionConfig: {
        iceServers: [],
        iceTransportPolicy: "relay"
      },
      peerConnectionConstraints: {
        optional: [{
          DtlsSrtpKeyAgreement: true
        }]
      }
    },
    cameraId,
    sessionId,
    peer,
    socket,
    audioChatStatus,
    peerDatabase = {},
    localStream;
  audioChat.EVENT_STREAM_CONNECTING = "event_stream_connecting";
  audioChat.EVENT_STREAM_CONNECTED = "event_stream_connected";
  audioChat.EVENT_STREAM_DISCONNECTED = "event_stream_disconnected";
  audioChat.EVENT_STREAM_STOPPED = "event_stream_stopped";

  // Returns the result of getUserMedia as a Promise.
  function requestUserMedia(constraints) {
    return new Promise(function (resolve, reject) {
      var onSuccess = function onSuccess(stream) {
        resolve(stream);
      };
      var onError = function onError(error) {
        reject(error);
        $rootScope.$broadcast(audioChat.EVENT_STREAM_DISCONNECTED, {
          code: "nomike"
        });
      };
      try {
        getUserMedia(constraints).then(onSuccess)["catch"](onError);
      } catch (e) {
        reject(e);
        $rootScope.$broadcast(audioChat.EVENT_STREAM_DISCONNECTED, {
          code: "nomike"
        });
      }
    });
  }
  audioChat.getAudioChatStatus = function () {
    return audioChatStatus;
  };
  audioChat.audioChatStart = function (cameraIdValue) {
    var realURL;
    if ($rootScope.me && $rootScope.me.country === "JP") {
      realURL = controlServerJpUrl;
    } else {
      realURL = controlServerUrl;
    }
    if (socket) {
      socket.disconnect();
      socket = null;
      void 0;
    }
    audioChatStatus = audioChat.EVENT_STREAM_CONNECTING;
    requestUserMedia(mediaConfig).then(function (stream) {
      camera.preview = $window.document.getElementById("localVideo");
      attachMediaStream(camera.preview, stream);
      audioChat.setLocalStream(stream);
      camera.stream = stream;
      if (navigator.userAgent.indexOf("OPR") != -1) {
        socket = io.connect(realURL, {
          transports: ["xhr-polling", "websocket"],
          forceNew: true,
          secure: true
        });
      } else {
        socket = io.connect(realURL, {
          transports: ["websocket"],
          forceNew: true,
          secure: true
        });
      }
      cameraId = cameraIdValue;
      var timeObj = new Date();
      sessionId = Utils.getCookie("toastcam") + "_" + timeObj.getTime();
      socket.on("LoginRequired", function (data) {
        User.me(function (data) {
          if (socket) {
            socket.emit("login", {
              msgid: makeMsgId(),
              type: "req",
              messageversion: "s-2.0.0",
              devicetype: "WEB",
              deviceinfo: {
                userid: data.userId,
                appname: "toastcam_b2c",
                appversion: "1.1.1",
                browsertype: "chrome",
                osversion: "6.0",
                sessionid: sessionId
              }
            });
          } else {
            audioChatStatus = audioChat.EVENT_STREAM_DISCONNECTED;
            $rootScope.$broadcast(audioChat.EVENT_STREAM_DISCONNECTED, {
              code: "nosocket"
            });
          }
        });
      });
      socket.on("login", function (data) {
        void 0;
        if (data.code == 0) {
          if (socket) {
            socket.emit("webrtc_request", {
              msgid: makeMsgId(),
              type: "req",
              scenario: "voicechat",
              from: sessionId,
              to: cameraId
            });
          } else {
            audioChatStatus = audioChat.EVENT_STREAM_DISCONNECTED;
            $rootScope.$broadcast(audioChat.EVENT_STREAM_DISCONNECTED, {
              code: "nosocket"
            });
          }
        } else {
          audioChatStatus = audioChat.EVENT_STREAM_DISCONNECTED;
          $rootScope.$broadcast(audioChat.EVENT_STREAM_DISCONNECTED, {
            code: "loginfail"
          });
          //Code Define
          //: -1 - 유효하지 않은 sessionid인 경우
          //: -2 - 서버 내부 에러. (Master에서 client생성 ok가 오지않는 경우)
        }
      });
      socket.on("webrtc_request", function (data) {
        handleMessageRequest(data);
      });
      socket.on("webrtc_signaling", function (data) {
        handleMessage(data);
      });
    })["catch"](Error("Failed to get access to local media."));
  };
  audioChat.audioChatStop = function (cameraIdValue) {
    if (socket) {
      socket.disconnect();
      socket = null;
    }
    var peer = peerDatabase[cameraIdValue];
    if (peer) {
      peer.pc.close();
    }
    delete peerDatabase[cameraIdValue];
    if (camera.stream && camera.stream.getTracks) {
      var tracks = camera.stream.getTracks();
      for (var track in tracks) {
        if (tracks[track]) {
          tracks[track].stop();
        }
      }
    }
    if (camera.preview) {
      camera.preview.src = "";
    }
    audioChatStatus = audioChat.EVENT_STREAM_STOPPED;
  };
  audioChat.getId = function () {
    return localId;
  };
  audioChat.setLocalStream = function (stream) {
    // if local cam has been stopped, remove it from all outgoing streams.
    if (!stream) {
      for (id in peerDatabase) {
        pc = peerDatabase[id].pc;
        if (!!pc.getLocalStreams().length) {
          pc.removeStream(localStream);
          //offer(id);
        }
      }
    }
    localStream = stream;
  };
  audioChat.toggleLocalStream = function (remoteId) {
    peer = peerDatabase[remoteId] || addPeer(remoteId);
    toggleLocalStream(peer.pc);
  };
  audioChat.peerInit = function (remoteId) {
    peer = peerDatabase[remoteId] || addPeer(remoteId);
    send("init", remoteId, null);
  };
  audioChat.peerRenegociate = function (remoteId) {
    //offer(remoteId);
  };
  audioChat.send = function (type, payload) {
    if (socket) {
      socket.emit(type, payload);
    }
  };

  /********** Local Function ***********/
  function addPeer(remoteId) {
    var peer = new Peer(configValue.peerConnectionConfig, configValue.peerConnectionConstraints);
    peer.pc.onicecandidate = function (event) {
      if (event.candidate) {
        if (socket) {
          socket.emit("webrtc_signaling", {
            msgid: makeMsgId(),
            type: "noti",
            command: "candidate",
            from: Utils.getCookie("toastcam"),
            to: cameraId,
            payload: {
              id: event.candidate.sdpMid,
              label: event.candidate.sdpMLineIndex,
              candidate: event.candidate.candidate
            }
          });
        }
      }
    };
    peer.pc.onaddstream = function (event) {
      attachMediaStream(peer.remoteVideoEl, event.stream);
      var remoteChatContainer = document.getElementById("remoteChatContainer");
      if (remoteChatContainer) {
        remoteChatContainer.appendChild(peer.remoteVideoEl);
      }
      audioChatStatus = audioChat.EVENT_STREAM_CONNECTED;
      $rootScope.$broadcast(audioChat.EVENT_STREAM_CONNECTED, {});
    };
    peer.pc.onremovestream = function (event) {
      peer.remoteVideoEl.src = "";
      var remoteChatContainer = document.getElementById("remoteChatContainer");
      if (remoteChatContainer) {
        remoteChatContainer.removeChild(peer.remoteVideoEl);
      }
    };
    peer.pc.oniceconnectionstatechange = function (event) {
      switch ((event.srcElement ||
      // Chrome
      event.target).iceConnectionState // Firefox
      ) {
        case "disconnected":
          var remoteChatContainer = document.getElementById("remoteChatContainer");
          if (remoteChatContainer) {
            remoteChatContainer.removeChild(peer.remoteVideoEl);
          }
          audioChatStatus = audioChat.EVENT_STREAM_DISCONNECTED;
          $rootScope.$broadcast(audioChat.EVENT_STREAM_DISCONNECTED, {
            code: "disconnect"
          });
          break;
      }
    };
    peerDatabase[remoteId] = peer;
    return peer;
  }
  function answer(remoteId) {
    var pc = peerDatabase[remoteId].pc;
    pc.createAnswer(function (sessionDescription) {
      pc.setLocalDescription(sessionDescription);
      send("answer", remoteId, sessionDescription);
    }, error);
  }
  function offer(remoteId) {
    var pc = peerDatabase[remoteId].pc;
    pc.createOffer(function (sessionDescription) {
      // @see https://stackoverflow.com/questions/66641204/sessiondescription-is-null-in-web-rtc-after-updating-chrome-to-latest-v-89-wor
      // ! 최신 버전 webrtc에서 a=extmap-allow-mixed 항목이 추가 되었는데 하위 호환성이 없어서 오류가 나고 있는 문제 대응
      if (sessionDescription && sessionDescription.sdp) {
        sessionDescription.sdp = sessionDescription.sdp.replace(/\r\na=extmap-allow-mixed\r\n/, "\r\n");
      }
      pc.setLocalDescription(sessionDescription);
      //send('offer', remoteId, sessionDescription);
      void 0;
      if (socket) {
        socket.emit("webrtc_signaling", {
          msgid: makeMsgId(),
          type: "noti",
          command: "offer",
          form: Utils.getCookie("toastcam"),
          to: cameraId,
          payload: sessionDescription
        });
      }
    }, error);
  }
  function handleMessageRequest(message) {
    var from = cameraId,
      pc;
    void 0;
    if (message.code == 0) {
      configValue.peerConnectionConfig.iceServers = [];
      var i, len;
      if (message.turnserver) {
        if (Utils.isSafari() || Utils.isFireFox()) {
          for (i = 0, len = message.turnserver.length; i < len; i += 1) {
            if (i === 0) {
              configValue.peerConnectionConfig.iceServers.push(message.turnserver[i]);
              if (configValue.peerConnectionConfig.iceServers[0] && configValue.peerConnectionConfig.iceServers[0].url) {
                configValue.peerConnectionConfig.iceServers[0]["urls"] = [];
                configValue.peerConnectionConfig.iceServers[0]["urls"].push(configValue.peerConnectionConfig.iceServers[0].url);
                delete configValue.peerConnectionConfig.iceServers[0].url;
              }
            } else {
              if (configValue.peerConnectionConfig.iceServers[0] && configValue.peerConnectionConfig.iceServers[0].urls) {
                configValue.peerConnectionConfig.iceServers[0].urls.push(message.turnserver[i].url);
              }
            }
          }
        } else {
          for (i = 0, len = message.turnserver.length; i < len; i += 1) {
            configValue.peerConnectionConfig.iceServers.push(message.turnserver[i]);
          }
        }
      }
      pc = addPeer(from).pc;
      toggleLocalStream(pc);
      offer(cameraId);
    } else {
      audioChatStatus = audioChat.EVENT_STREAM_DISCONNECTED;
      $rootScope.$broadcast(audioChat.EVENT_STREAM_DISCONNECTED, {
        code: message.code
      });
    }
  }
  function handleMessage(message) {
    var type = message.command,
      from = cameraId,
      pc;
    void 0;
    switch (type) {
      case "offer":
        //pc.setRemoteDescription(new RTCSessionDescription(message.sdp), function(){}, error);
        //answer(from);
        break;
      case "answer":
        pc = peerDatabase[from].pc;
        var payloadJSON;
        if (typeof message.payload === "string") {
          payloadJSON = JSON.parse(message.payload);
        } else {
          payloadJSON = message.payload;
        }
        pc.setRemoteDescription(new RTCSessionDescription(payloadJSON), function () {}, error);
        break;
      case "candidate":
        pc = peerDatabase[from].pc;
        // ! answer > candidate 순서로 진행됨
        // ! answer 에서 setRemoteDescription 이후 remoteDescription 접근이 되는데
        // ! 정상적으로 생성되기전에 응답이 와서 정상동작 하지 않는 케이스 대응을 위함
        setTimeout(function () {
          if (pc.remoteDescription) {
            var candidateJSON;
            if (typeof message.payload === "string") {
              candidateJSON = JSON.parse(message.payload);
            } else {
              candidateJSON = message.payload;
            }
            pc.addIceCandidate(new RTCIceCandidate({
              sdpMLineIndex: candidateJSON.label,
              sdpMid: candidateJSON.id,
              candidate: candidateJSON.candidate
            }), function () {}, error);
          }
        }, 1000);
        break;
    }
  }
  function send(type, to, payload) {
    if (socket) {
      socket.emit("message", {
        to: to,
        type: type,
        payload: payload
      });
    } else {
      audioChatStatus = audioChat.EVENT_STREAM_DISCONNECTED;
      $rootScope.$broadcast(audioChat.EVENT_STREAM_DISCONNECTED, {
        code: "nosocket"
      });
    }
  }
  function toggleLocalStream(pc) {
    if (localStream) {
      !!pc.getLocalStreams().length ? pc.removeStream(localStream) : pc.addStream(localStream);
    }
  }
  function error(err) {
    void 0;
  }
  function Peer(pcConfig, pcConstraints) {
    this.pc = new RTCPeerConnection(pcConfig, pcConstraints);
    this.remoteVideoEl = document.createElement("video");
    this.remoteVideoEl.controls = true;
    this.remoteVideoEl.autoplay = true;
  }
  function makeMsgId() {
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for (var i = 0; i < 30; i++) text += possible.charAt(Math.floor(Math.random() * possible.length));
    return text;
  }
  return audioChat;
}]);
"use strict";

app.factory("CameraGroup", ["$resource", function ($resource) {
  return $resource("/json/biz/group/myGroups", {}, {
    getGroupDetail: {
      url: "/json/biz/group/:groupId"
    },
    getGroupDetailV2: {
      url: "/json/biz/v2/group/:groupId"
    },
    addGroup: {
      url: "/json/biz/group",
      method: "POST"
    },
    addSubGroup: {
      url: "/json/biz/group/:groupId/subGroup",
      method: "POST"
    },
    updateGroup: {
      url: "/json/biz/group/:groupId",
      method: "PUT"
    },
    deleteGroup: {
      url: "/json/biz/group/:groupId",
      method: "DELETE"
    },
    getCameras: {
      url: "/json/biz/group/cameras",
      isArray: true
    },
    getListV4: {
      url: "/json/biz/v4/cameras"
    },
    orderChange: {
      url: "/json/biz/group/:groupId/order",
      method: "PUT"
    },
    getSharedGroups: {
      url: "/json/biz/group/share/v2/groups",
      isArray: true
    },
    getSharedGroupDetail: {
      url: "/json/biz/group/shared/:groupId"
    },
    getSharedGroupDetailV2: {
      url: "/json/biz/v2/group/shared/:groupId"
    },
    getSharedGroupReceivers: {
      url: "/json/biz/group/share/:groupId/receiver",
      isArray: true
    },
    shareGroup: {
      url: "/json/biz/group/share/:groupId",
      method: "POST"
    },
    removeGroupShare: {
      url: "/json/biz/group/share/:shareId",
      method: "DELETE"
    },
    checkGroupShare: {
      url: "/json/biz/group/share/:groupId/check"
    },
    updateGroupShareOption: {
      url: "/json/biz/group/share/:shareId",
      method: "PUT"
    }
  });
}]);
app.factory("Camera", ["$resource", function ($resource) {
  return $resource("/json/biz/cameras/:id", {}, {
    getToken: {
      url: "/json/biz/cameras/:id/token"
    },
    getTokenList: {
      url: "/json/biz/cameras/token",
      method: "POST"
    },
    extendToken: {
      url: "/json/biz/cameras/token/:id",
      method: "PUT"
    },
    getList: {
      url: "/json/biz/v2/cameras",
      isArray: true
    },
    getListV3: {
      url: "/json/biz/v3/cameras"
    },
    getListV4: {
      url: "/json/biz/v4/cameras"
    },
    newTimeline: {
      url: "/json/biz/cameras/:id/v2/timeline"
    },
    eventGroup: {
      url: "/json/biz/v2/cameras/:id/eventGroups"
    },
    eventDaily: {
      url: "/json/biz/cameras/:id/events/daily"
    },
    newThumbnail: {
      url: "/json/biz/cameras/:id/v2/subEvents"
    },
    zones: {
      url: "/json/biz/cameras/:id/alarmZones"
    },
    isLastRecord: {
      url: "json/biz/cameras/:id/lastActivity"
    },
    createZone: {
      url: "/json/biz/cameras/:id/alarmZones",
      method: "POST"
    },
    deleteZone: {
      url: "/json/biz/cameras/:id/alarmZones/:zoneIndex",
      method: "DELETE"
    },
    upgradeCamera: {
      url: "/json/biz/cameras/firmwareUpgrade",
      method: "POST"
    },
    audioChat: {
      url: "/json/biz/cameras/:id/audioChat",
      method: "POST"
    },
    prevEventWithRange: {
      url: "/json/biz/cameras/:id/prevEventWithRange "
    },
    nextEventWithRange: {
      url: "/json/biz/cameras/:id/nextEventWithRange"
    },
    alarmZoneFilterOn: {
      url: "/json/biz/cameras/:cameraId/alarmZones/:zoneIndex/filter",
      method: "PUT"
    },
    alarmZoneFilterOff: {
      url: "/json/biz/cameras/:cameraId/alarmZones/:zoneIndex/filter",
      method: "DELETE"
    },
    updateAlarmZonesFiltersOnOff: {
      url: "/json/biz/cameras/:cameraId/alarmZones/filters",
      method: "PUT"
    },
    sortedCameras: {
      url: "/json/biz/cameras/sortedCameras",
      method: "PUT"
    },
    orderChange: {
      url: "/json/biz/cameras/order",
      method: "PUT"
    },
    findCVR: {
      url: "/json/biz/cameras/:cameraId/cvr/:cvrId"
    },
    getCamera: {
      url: "/json/biz/cameras/:cameraId"
    },
    saveEndDateInfo: {
      url: "/json/biz/cameras/:cameraId/saveEndDateInfo"
    },
    getGroupCameras: {
      url: "/json/biz/group/:groupId/camerasWithEvent"
    },
    getShopCameras: {
      url: "/json/biz/shop/:shopId/camerasWithEvent"
    },
    getMyCameras: {
      url: "/json/biz/v2/camerasWithEvent"
    },
    requestCameraAging: {
      url: "/json/biz/cameras/:cameraId/aging",
      method: "PUT"
    },
    ptzControl: {
      url: "/json/biz/ptz/:cameraId/control",
      method: "POST"
    },
    ptzZoomIn: {
      url: "/json/biz/ptz/:cameraId/areaZoomIn",
      method: "POST"
    },
    ptzZoomOut: {
      url: "/json/biz/ptz/:cameraId/areaZoomOut",
      method: "POST"
    },
    // AI
    aiReportByRange: {
      url: "/json/biz/aireport/cameras/:cameraId/range"
    },
    aiStats: {
      url: "/cameras/:cameraId/ai/stats"
    },
    aiDailyStats: {
      url: "/json/biz/aireport/cameras/:cameraId/stats/daily"
    },
    aiHourlyStats: {
      url: "/json/biz/aireport/cameras/:cameraId/stats/hourly"
    },
    aiMinStats: {
      url: "/json/biz/aireport/cameras/:cameraId/stats/tenminutes"
    },
    getAlarmZone: {
      url: "/json/biz/cameras/:cameraId/alarmZones"
    },
    getAlarmZoneByType: {
      url: "/json/biz/cameras/:cameraId/alarmZones/:zoneType"
    },
    setAlarmZones: {
      url: "/json/biz/cameras/:cameraId/alarmZones/:zoneType",
      method: "POST"
    },
    removeAlarmZone: {
      url: "/json/biz/cameras/:cameraId/alarmZones/:zoneType/:zoneIndex",
      method: "DELETE"
    },
    modifyAlarmZone: {
      url: "/json/biz/cameras/:cameraId/alarmZones/:zoneType/:zoneIndex",
      method: "PUT"
    },
    getAiChartByMin: {
      url: "/json/biz/cameras/:cameraId/ai/peopleArea/minute"
    },
    getAiChartByDay: {
      url: "/json/biz/cameras/:cameraId/ai/peopleArea/daily"
    },
    // streaming
    getStreamingServer: {
      url: "/json/biz/streamingServer"
    },
    //reboot
    postRebootingCamera: {
      url: "/json/biz/cameras/:cameraId/reboot",
      method: "POST"
    }
  });
}]);
app.factory("CameraConfig", ["$resource", function ($resource) {
  return $resource("/json/biz/cameras/:id/config", {}, {
    update: {
      method: "PUT"
    },
    regSecurePassword: {
      url: "/json/biz/cameras/:id/securePassword",
      method: "POST"
    },
    getSharedConfig: {
      url: "/json/biz/share/cameras/:id/config"
    },
    confirmSecure: {
      url: "/json/biz/cameras/:id/secure",
      method: "POST"
    },
    toggleSecure: {
      url: "/json/biz/cameras/:id/secure",
      method: "PUT"
    },
    deleteSecurePassword: {
      url: "/json/biz/cameras/:id/securePassword",
      method: "DELETE"
    },
    getNetworkConfig: {
      url: "/json/biz/devices/CAMERA/:id/networkConfig"
    },
    setActiveNetwork: {
      url: "/json/biz/devices/CAMERA/:id/networkConfig/selectActive",
      method: "PUT"
    },
    setNetworkIp: {
      url: "/json/biz/devices/CAMERA/:id/networkConfig/ip",
      method: "PUT"
    }
  });
}]);
app.factory("CameraNotifyConfig", ["$resource", function ($resource) {
  return $resource("/json/biz/cameras/:cameraId/notifyConfig", {}, {
    update: {
      url: "/json/biz/cameras/:cameraId/notifyConfig",
      method: "PUT"
    }
  });
}]);
app.factory("Install", ["$resource", function ($resource) {
  return $resource("/install/json/biz/camera", {}, {
    start: {
      url: "/install/json/biz/camera/startProcess",
      method: "POST"
    },
    wifilist: {
      url: "/install/json/biz/camera/wifiList",
      isArray: true
    },
    connectwifi: {
      url: "/install/json/biz/camera/wifi",
      method: "PUT"
    },
    connectstatus: {
      url: "/install/json/biz/:installKey/isRegistered"
    },
    getWifiInfo: {
      url: "/install/json/biz/wificonnect"
    }
  });
}]);
"use strict";

app.factory("CloudMonitor", ["$resource", function ($resource) {
  return $resource("", {}, {
    getAppDownload: {
      url: "/json/biz/v1/clmonitor/client/app/windows",
      method: "GET"
    },
    getAppManual: {
      url: "/json/biz/v1/clmonitor/client/manual/windows",
      method: "GET"
    }
  });
}]);
"use strict";

app.factory("Device", ['$resource', function ($resource) {
  return $resource('/json/biz/doorlocks', {}, {
    deviceConfig: {
      url: '/json/biz/devices/:deviceType/:deviceId/config'
    },
    updateDeviceConfig: {
      url: '/json/biz/devices/:deviceType/:deviceId/config',
      method: 'PUT'
    },
    removeDevice: {
      url: '/json/biz/devices/:deviceType/:deviceId',
      method: 'DELETE'
    },
    firmwareUpgrade: {
      url: '/json/biz/devices/:deviceType/:deviceId/firmwareUpgrade',
      method: 'POST'
    },
    iotControllers: {
      url: '/json/biz/controllers'
    },
    iotControllersV1: {
      url: '/json/biz/controllers/v1'
    },
    iotControllersCountV1: {
      url: '/json/biz/controllers/v1/count'
    },
    update: {
      url: '/json/biz/devices/IOTHUB/:id/config',
      method: 'PUT'
    },
    getHubNetworkConfig: {
      url: '/json/biz/devices/IOTHUB/:id/networkConfig'
    },
    setHubActiveNetwork: {
      url: '/json/biz/devices/IOTHUB/:id/networkConfig/selectActive',
      method: 'PUT'
    },
    setHubNetworkIp: {
      url: '/json/biz/devices/IOTHUB/:id/networkConfig/ip',
      method: 'PUT'
    }
  });
}]);
"use strict";

app.factory('DidFile', ['$rootScope', '$translate', '$http', '$q', '$resource', function ($rootScope, $translate, $http, $q, $resource) {
  var didFileSrv = {};
  didFileSrv.api = $resource('/json/biz/didContents/:userId', {}, {
    getContents: {
      url: '/json/biz/didContents/:userId'
    },
    uploadContent: {
      url: '/json/biz/didContents/:userId',
      method: 'POST'
    },
    deleteContent: {
      url: '/json/biz/didContents/:userId/contents',
      method: 'DELETE'
    },
    getDidContents: {
      url: '/json/biz/dids/:didId/contents'
    },
    addDidContent: {
      url: '/json/biz/dids/:didId/contents',
      method: 'POST'
    },
    deleteDidContent: {
      url: '/json/biz/dids/:didId/contents/:contentId',
      method: 'DELETE'
    },
    updateDidConfig: {
      url: '/json/biz/dids/:didId/v2/config',
      method: 'PUT'
    }
  });
  didFileSrv.uploadFile = function (fileEl, uploadId) {
    var formData = new FormData();
    var fileName = fileEl.value.replace(/.mp4/i, '.mp4');
    fileName = fileName.replace(/.jpg/i, '.jpg');
    fileName = fileName.replace(/.png/i, '.png');
    var splitName = fileName.split('\\');
    fileName = splitName[splitName.length - 1];
    formData.append("file", fileEl.files[0], fileName);
    $.ajax({
      type: "POST",
      url: '/json/biz/didContents/' + $rootScope.me.userId,
      processData: false,
      contentType: false,
      data: formData,
      xhr: function xhr() {
        var xhr = $.ajaxSettings.xhr();
        xhr.upload.onprogress = function (e) {
          var percent = e.loaded * 100 / e.total;
          $rootScope.$broadcast('did-file-upload', {
            type: 'progress',
            data: percent,
            uploadId: uploadId
          });
        };
        return xhr;
      },
      success: function success(data) {
        var dataJSON = JSON.parse(data);
        $rootScope.$broadcast('did-file-upload', {
          type: 'result',
          result: dataJSON.code === 'ok',
          uploadId: uploadId,
          content: dataJSON.content
        });
        if (fileEl) {
          fileEl.value = '';
        }
      },
      error: function error(_error) {
        $rootScope.$broadcast('did-file-upload', {
          type: 'result',
          result: false,
          uploadId: uploadId
        });
        if (fileEl) {
          fileEl.value = '';
        }
      }
    });
  };
  return didFileSrv;
}]);
"use strict";

app.factory("Doorlock", ['$resource', function ($resource) {
  return $resource('/json/biz/doorlocks', {}, {
    getDoorlocks: {
      url: '/json/biz/doorlocks'
    },
    getShopDoorlocks: {
      url: '/json/biz/shops/:shopId/doorlocks'
    },
    //매장에 있는 도어락 목록
    setDoorlockState: {
      url: '/json/biz/shops/:shopId/sensors/:sensorId',
      method: 'PUT'
    },
    setDoorlockPwd: {
      url: '/json/biz/shops/:shopId/doorlock/:sensorId',
      method: 'PUT'
    },
    getDoorlockStatus: {
      url: '/json/doorlock/:sensorId'
    }
  });
}]);
"use strict";

app.factory('GMap', ['$rootScope', '$translate', '$http', '$q', function ($rootScope, $translate, $http, $q) {
  var gMap = {};
  var GEOCODE_KEY = 'AIzaSyCAamoScf24Ry1HlWhBi11hmr2JCxJ3AQI';
  var MAP_KEY = 'AIzaSyDVPy7Zb-mlAe5PFPIA7jUV4-8t-PUKXy8';
  var MAP_ID = 'location_map';
  var SEARCHBOX_INPUT_ID = 'location_input';
  var SEARCHBOX_BTN_ID = 'location_button';
  var map = null;
  var marker = null;
  var searchBox = null;
  gMap.EVENT_LOC_UPDATE = 'gMapLocationUpdate';
  gMap.moveCenter = function (lat, lng) {
    if (map) {
      var center = new google.maps.LatLng(lat, lng);
      map.panTo(center);
    }
  };
  gMap.makeNewMarker = function (pos) {
    //Google Map Marker Create
    if (map) {
      if (marker) {
        marker.setMap(null);
        marker.setMap(map);
        marker.setPosition(pos);
      } else {
        marker = new google.maps.Marker({
          map: map,
          position: pos
        });
      }
    }
  };
  gMap.removeMapInstances = function () {
    if (marker) {
      marker.setMap(null);
      marker = null;
    }
    if (searchBox) {
      google.maps.event.clearListeners(searchBox, 'places_changed');
      searchBox = null;
    }
    if (map) {
      google.maps.event.clearListeners(map, 'bounds_changed');
      map = null;
      var elMap = document.getElementById('location_map');
      if (elMap) {
        elMap.innerHTML = '';
      }
    }
  };
  gMap.getAddrWithGeocode = function (position) {
    var deferred = $q.defer();
    $http({
      method: 'GET',
      url: 'https://maps.googleapis.com/maps/api/geocode/json?latlng=' + position + '&key=' + GEOCODE_KEY,
      dataType: 'json'
    }).success(function (data, status, headers, config) {
      var i, j, len, tLen;
      if (data && data.results && data.results.length > 0) {
        len = data.results.length;
        for (i = 0; i < len; i += 1) {
          if (data.results[i].types && data.results[i].types.length > 0) {
            tLen = data.results[i].types.length;
            for (j = 0; j < tLen; j += 1) {
              if (data.results[i].types[j] === 'sublocality') {
                deferred.resolve(data.results[i].formatted_address);
                return;
              }
            }
          }
        }
        deferred.resolve(data.results[0].formatted_address);
      } else {
        deferred.reject();
      }
    }).error(function (data, status, headers, config) {
      deferred.reject();
    });
    return deferred.promise;
  };
  gMap.loadGoogleMap = function (cameraLocInfo) {
    if (!map) {
      var langRegion,
        lang = $("html").attr("lang");
      if (lang === "en") {
        langRegion = 'language=en&region=US';
      } else if (lang === "ko") {
        langRegion = 'language=ko&region=KR';
      } else if (lang === "ja") {
        langRegion = 'language=ja&region=JP';
      } else {
        langRegion = 'language=ko&region=KR';
      }
      $.getScript('https://maps.googleapis.com/maps/api/js?key=' + MAP_KEY + '&libraries=places&' + langRegion, function () {
        if (window.google && window.google.maps) {
          initGoogleMap(cameraLocInfo);
        }
      });
    } else {
      if (cameraLocInfo && cameraLocInfo.lat && cameraLocInfo.lng) {
        gMap.makeNewMarker({
          lat: cameraLocInfo.lat,
          lng: cameraLocInfo.lng
        });
        gMap.moveCenter(cameraLocInfo.lat, cameraLocInfo.lng);
      }
    }
  };

  /********** Local Function ***********/
  var initGoogleMap = function initGoogleMap(cameraLocInfo) {
    var currentAddr,
      currentLat,
      currentLng,
      $inputWrap,
      $input,
      $button,
      centerControlDiv,
      centerControl,
      isNoData = false,
      $wait;
    gMap.removeMapInstances();
    /* set Position Data */
    if (cameraLocInfo && cameraLocInfo.lat && cameraLocInfo.lng) {
      currentLat = cameraLocInfo.lat;
      currentLng = cameraLocInfo.lng;
    } else {
      //nhn playmusium
      currentLat = 37.4;
      currentLng = 127.1;
      isNoData = true;
    }
    if (cameraLocInfo && cameraLocInfo.address) {
      currentAddr = cameraLocInfo.address;
    }

    /* Create Map */
    map = new google.maps.Map(document.getElementById(MAP_ID), {
      center: {
        lat: currentLat,
        lng: currentLng
      },
      zoom: 15,
      mapTypeId: 'roadmap',
      zoomControl: true,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: false
    });

    /* Create the search box and link it to the UI element. */
    /*
    $inputWrap = $('<div>', {class : 'acc_map_input'});
    $input = $('<input>', {id : SEARCHBOX_INPUT_ID, class: 'controls', placeholder: $translate.instant('SEARCH_ADDRESS')});
    $inputWrap.append($input);
    searchBox = new google.maps.places.SearchBox($input[0]);
    map.controls[google.maps.ControlPosition.TOP_LEFT].push($inputWrap[0]);
    */

    /* Make Marker */
    if (isNoData !== true) {
      gMap.makeNewMarker({
        lat: currentLat,
        lng: currentLng
      });
      $rootScope.$broadcast(gMap.EVENT_LOC_UPDATE, {
        lat: currentLat,
        lng: currentLng,
        address: currentAddr
      });
    }
    setSearchPlaceChangedListener();
    //setMapClickListener();

    /* make GPS button */
    centerControlDiv = document.createElement('div');
    //centerControl = new centerControlCreator(centerControlDiv, map);
    centerControlDiv.index = 1;
    map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(centerControlDiv);
    $wait = $('<div>', {
      'id': 'location_wait',
      'class': 'acc_map_now_wait',
      'style': 'display: none; margin-bottom: -8px; margin-right:42px;',
      'html': $translate.instant('FIND_MY_LOC') + '<img src="/resources/im/ic_acc_map_ar.png">'
    });
    map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push($wait[0]);
  };
  var centerControlCreator = function centerControlCreator(controlDiv, map) {
    var $currentGps = $('<div>', {
      "class": 'acc_map_now',
      html: '<img src="/resources/im/ic_map_mark.png">'
    });
    controlDiv.appendChild($currentGps[0]);

    // Setup the click event listeners: simply set the map to Chicago.
    $currentGps.click(function () {
      // Try HTML5 geolocation.
      var $locWait = $('#location_wait');
      $locWait.show();
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (position) {
          var pos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
          map.setCenter(pos);
          gMap.makeNewMarker(pos);
          $rootScope.$broadcast(gMap.EVENT_LOC_UPDATE, {
            lat: pos.lat,
            lng: pos.lng
          });
          $locWait.hide();
          gMap.getAddrWithGeocode(pos.lat + ',' + pos.lng).then(function (result) {
            if (result) {
              $rootScope.$broadcast(gMap.EVENT_LOC_UPDATE, {
                lat: pos.lat,
                lng: pos.lng,
                address: result
              });
            }
          }, function (error) {
            //error
          });
        }, function (error) {
          $locWait.hide();
        });
      } else {
        $locWait.hide();
      }
    });
  };
  var setSearchPlaceChangedListener = function setSearchPlaceChangedListener() {
    if (searchBox) {
      map.addListener('bounds_changed', function () {
        // Bias the SearchBox results towards current map's viewport.
        searchBox.setBounds(map.getBounds());
      });
      searchBox.addListener('places_changed', function () {
        var bounds,
          place,
          places = searchBox.getPlaces();
        if (places.length == 0) {
          return;
        }
        place = places[0];
        bounds = new google.maps.LatLngBounds();
        if (!place.geometry) {
          //place contains no geometry
          return;
        }
        gMap.makeNewMarker(place.geometry.location);
        $rootScope.$broadcast(gMap.EVENT_LOC_UPDATE, {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
          address: place.formatted_address
        });
        if (place.geometry.viewport) {
          // Only geocodes have viewport.
          bounds.union(place.geometry.viewport);
        } else {
          bounds.extend(place.geometry.location);
        }
        map.fitBounds(bounds);
      });
    }
  };
  var setMapClickListener = function setMapClickListener() {
    google.maps.event.addListener(map, 'click', function (event) {
      if (event.latLng) {
        var lat = event.latLng.lat(),
          lng = event.latLng.lng(),
          position = lat + ',' + lng;
        gMap.makeNewMarker(event.latLng);
        $rootScope.$broadcast(gMap.EVENT_LOC_UPDATE, {
          lat: lat,
          lng: lng
        });
        gMap.getAddrWithGeocode(position).then(function (result) {
          if (result) {
            $rootScope.$broadcast(gMap.EVENT_LOC_UPDATE, {
              lat: lat,
              lng: lng,
              address: result
            });
          }
        }, function (error) {
          //error
        });
      }
    });
  };
  return gMap;
}]);
"use strict";

app.factory("Monitor", ["$rootScope", "$resource", "Utils", function ($rootScope, $resource, Utils) {
  var monitor = {};
  var controlSocket = null;
  var socketList = Array(16).fill(null);
  monitor.EVENT_STREAM_CONNECTING = "event_stream_connecting";
  monitor.EVENT_STREAM_CONNECTED = "event_stream_connected";
  monitor.EVENT_STREAM_DISCONNECTED = "event_stream_disconnected";
  monitor.EVENT_UPDATE_STATUS = "event_update_status";
  monitor.CONTROL_STREAM_CONNECTED = "control_stream_connected";
  monitor.CONTROL_STREAM_DISCONNECTED = "control_stream_disconnected";
  monitor.CONTROL_STREAM_STOPPED = "control_stream_stopped";
  monitor.CONTROL_STREAM_CAMERAINFOS = "control_stream_camerainfos";
  monitor.THUMBNAIL_DATA = "thumbnail_data";
  var getServerUrl = function getServerUrl() {
    var isJp = $rootScope.me && $rootScope.me.country === "JP";
    return isJp ? controlServerJpUrl : controlServerUrl;
  };
  monitor.disconnectMonitorControlChannel = function () {
    if (controlSocket) {
      controlSocket.disconnect();
      controlSocket = null;
    }
  };
  monitor.connectMonitorControlChannel = function () {
    if (controlSocket) {
      controlSocket.disconnect();
      controlSocket = null;
    }
    var realURL = getServerUrl();
    if (navigator.userAgent.indexOf("OPR") != -1) {
      controlSocket = io.connect(realURL, {
        transports: ["xhr-polling", "websocket"],
        forceNew: true,
        secure: true
      });
    } else {
      controlSocket = io.connect(realURL, {
        transports: ["websocket"],
        forceNew: true,
        secure: true
      }); //,
    }
    var timeObj = new Date();
    var toastCookie = Utils.getCookie("toastcam");
    var sessionId = toastCookie + "_" + timeObj.getTime();
    controlSocket.on("LoginRequired", function (data) {
      if (controlSocket) {
        controlSocket.emit("login", {
          msgid: makeMsgId(),
          type: "req",
          messageversion: "s-2.0.0",
          devicetype: "WEB_CloudMonitor",
          deviceinfo: {
            userid: "monitorControl",
            appname: "monitorControl",
            appversion: "1.3.12",
            browsertype: "chrome",
            osversion: "6.0",
            sessionid: sessionId
          }
        });
      } else {
        $rootScope.$broadcast(monitor.CONTROL_STREAM_DISCONNECTED, {
          code: "nosocket"
        });
      }
    });
    controlSocket.on("login", function (data) {
      if (data.code == 0) {
        if (controlSocket) {
          $rootScope.$broadcast(monitor.CONTROL_STREAM_CONNECTED, {
            code: "ok"
          });
        } else {
          $rootScope.$broadcast(monitor.CONTROL_STREAM_DISCONNECTED, {
            code: "nosocket"
          });
        }
      } else {
        $rootScope.$broadcast(monitor.CONTROL_STREAM_DISCONNECTED, {
          code: "loginfail"
        });
      }
    });
    controlSocket.on("media_delayed", function (data) {
      $rootScope.$broadcast(monitor.EVENT_UPDATE_STATUS, {
        type: "media_delayed",
        data: data
      });
    });
    controlSocket.on("monitor_cameras_info", function (data) {
      var cameras = [];
      if (data && data.cameras) {
        cameras = data.cameras;
      }
      $rootScope.$broadcast(monitor.CONTROL_STREAM_CAMERAINFOS, {
        cameras: cameras
      });
    });
    controlSocket.on("start_monitor", function (data) {
      controlSocket.emit("get_all_status", {
        msgid: makeMsgId(),
        type: "req"
      });
    });
    controlSocket.on("start_monitor_jp", function (data) {
      controlSocket.emit("get_all_status", {
        msgid: makeMsgId(),
        type: "req"
      });
    });
    controlSocket.on("get_all_status", function (data) {
      if (data.code != 0) {
        return;
      }
      $rootScope.$broadcast(monitor.EVENT_UPDATE_STATUS, {
        type: "get_all_status",
        data: data.status
      });
    });
    controlSocket.on("iot_event", function (data) {
      $rootScope.$broadcast(monitor.EVENT_UPDATE_STATUS, {
        type: "iot_event",
        data: data
      });
    });
    controlSocket.on("media_status", function (data) {
      $rootScope.$broadcast(monitor.EVENT_UPDATE_STATUS, {
        type: "media_status",
        data: data
      });
    });
    controlSocket.on("sub_media_status", function (data) {
      $rootScope.$broadcast(monitor.EVENT_UPDATE_STATUS, {
        type: "sub_media_status",
        data: data
      });
    });
    controlSocket.on("control_status", function (data) {
      /*
           20230322  
           카메라 - 컨트롤 서버 연결 해제 상태에서
           클라우드 모니터 메뉴 접속 후 
           카메라 - 컨트롤서버 재연결 성공 시 
          */
      if (data.detail.status === 1 && !!data.deviceid) {
        // 컨트롤서버 접속 성공
        $rootScope.$broadcast(monitor.EVENT_UPDATE_STATUS, {
          type: $rootScope.me.country === "JP" ? "start_monitor_jp" : "start_monitor",
          data: data
        });
      }
      $rootScope.$broadcast(monitor.EVENT_UPDATE_STATUS, {
        type: "control_status",
        data: data
      });
    });
    controlSocket.on("motion_status", function (data) {
      $rootScope.$broadcast(monitor.EVENT_UPDATE_STATUS, {
        type: "motion_status",
        data: data
      });
    });
    controlSocket.on("get_media_url", function (data) {
      if (data.code != 0) {
        return;
      }
      $rootScope.$broadcast(monitor.EVENT_UPDATE_STATUS, {
        type: "get_media_url",
        data: data
      });
    });
  };
  monitor.requestMediaURL = function (cameraIds) {
    if (!controlSocket) {
      $rootScope.$broadcast(monitor.CONTROL_STREAM_DISCONNECTED, {
        code: "nosocket"
      });
      return;
    }
    controlSocket.emit("get_media_url", {
      msgid: makeMsgId(),
      type: "req",
      deviceids: cameraIds
    });
  };
  monitor.requestStartMonitor = function (cameraIds, cameraInfoMap) {
    if (!controlSocket) {
      $rootScope.$broadcast(monitor.CONTROL_STREAM_DISCONNECTED, {
        code: "nosocket"
      });
      return;
    }
    var isJpUser = $rootScope.me.country === "JP";
    controlSocket.emit(isJpUser ? "start_monitor_jp" : "start_monitor", {
      msgid: makeMsgId(),
      type: "req",
      deviceids: cameraIds,
      device_info_map: cameraInfoMap
    });
  };
  monitor.requestMonitorCamerasInfo = function (cameraIds) {
    if (!controlSocket) {
      $rootScope.$broadcast(monitor.CONTROL_STREAM_DISCONNECTED, {
        code: "nosocket"
      });
      return;
    }
    controlSocket.emit("monitor_cameras_info", {
      msgid: makeMsgId(),
      type: "req",
      cameras: cameraIds
    });
  };
  monitor.stopCameraMonitor = function (slot, cameraId) {
    if (socketList[slot]) {
      socketList[slot].emit("monitor_stop_request", {
        msgid: makeMsgId(),
        type: "req",
        cameraid: cameraId
      });
    }
    if (socketList[slot]) {
      socketList[slot].disconnect();
      socketList[slot] = null;
      void 0;
    }
  };
  monitor.startCameraMonitor = function (slot, cameraId, controlServerAddr, thumbnailSetting) {
    if (slot > socketList.length - 1) {
      void 0;
      return;
    }
    if (!cameraId) {
      void 0;
      return;
    }
    if (!controlServerAddr) {
      void 0;
      return;
    }
    if (socketList[slot]) {
      socketList[slot].disconnect();
      socketList[slot] = null;
      void 0;
    }
    if (navigator.userAgent.indexOf("OPR") != -1) {
      socketList[slot] = io.connect(controlServerAddr, {
        transports: ["xhr-polling", "websocket"],
        forceNew: true,
        secure: true
      });
    } else {
      socketList[slot] = io.connect(controlServerAddr, {
        transports: ["websocket"],
        forceNew: true,
        secure: true
      }); //,
    }
    var timeObj = new Date();
    var sessionId = Utils.getCookie("toastcam") + "_" + timeObj.getTime();
    socketList[slot].on("LoginRequired", function (data) {
      if (socketList[slot]) {
        socketList[slot].emit("login", {
          msgid: makeMsgId(),
          type: "req",
          messageversion: "s-2.0.0",
          devicetype: "WEB_CloudMonitor",
          deviceinfo: {
            userid: "monitor",
            appname: "monitor",
            appversion: "1.3.12",
            browsertype: "chrome",
            osversion: "6.0",
            sessionid: sessionId
          }
        });
      } else {
        $rootScope.$broadcast(monitor.EVENT_STREAM_DISCONNECTED, {
          code: "nosocket",
          slot: slot
        });
      }
    });
    socketList[slot].on("login", function (data) {
      void 0;
      if (data.code == 0) {
        if (socketList[slot]) {
          if (cameraId) {
            var width = 720,
              height = 480,
              quality = 90,
              interval = 1000;
            if (thumbnailSetting) {
              width = thumbnailSetting.width;
              height = thumbnailSetting.height;
              quality = thumbnailSetting.quality;
              interval = thumbnailSetting.interval;
            }
            socketList[slot].emit("monitor_start_request", {
              msgid: makeMsgId(),
              type: "req",
              cameraid: cameraId,
              interval: interval,
              width: width,
              height: height,
              quality: quality
            });
          } else {
            $rootScope.$broadcast(monitor.EVENT_STREAM_DISCONNECTED, {
              code: "nocamera",
              slot: slot
            });
          }
        } else {
          $rootScope.$broadcast(monitor.EVENT_STREAM_DISCONNECTED, {
            code: "nosocket",
            slot: slot
          });
        }
      } else {
        $rootScope.$broadcast(monitor.EVENT_STREAM_DISCONNECTED, {
          code: "loginfail",
          slot: slot
        });
      }
    });
    socketList[slot].on("monitor_thumbnail", function (data) {
      $rootScope.$broadcast(monitor.THUMBNAIL_DATA, {
        data: data.data,
        timestamp: data.timestamp,
        slot: slot
      });
    });
  };
  monitor.api = $resource("/json/biz/cloudMonitor/info", {}, {
    getInfo: {
      url: "/json/biz/cloudMonitor/info"
    }
  });

  /********** Local Function ***********/
  function makeMsgId() {
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for (var i = 0; i < 30; i++) text += possible.charAt(Math.floor(Math.random() * possible.length));
    return text;
  }
  function error(err) {
    void 0;
  }
  return monitor;
}]);
"use strict";

app.factory('Notice', ['$resource', function ($resource) {
  return $resource('/json/biz/notice/:seq', {}, {
    getList: {
      url: '/json/biz/notices'
    },
    updateNotice: {
      url: '/json/biz/notices/:seq',
      method: 'PUT'
    },
    createNotice: {
      url: '/json/biz/notices',
      method: 'POST'
    },
    getNotice: {
      url: '/json/biz/notices/:seq'
    }
  });
}]);

//공지사항 API
app.factory('NoticePopup', ['$resource', function ($resource) {
  return $resource('/json/biz/notices/popup', {}, {});
}]);
"use strict";

// POS 관련 API
app.factory('Pos', ['$resource', function ($resource) {
  return $resource('/json/bizpos/shop/:shopId/pos/:posId', {}, {
    insertPos: {
      url: '/json/bizpos/shop/:shopId/pos/:posId/camera/:cameraId',
      method: 'POST'
    },
    //매장에 POS 등록
    updatePos: {
      url: '/json/bizpos/shop/:shopId/pos/:posId/camera/:cameraId',
      method: 'PUT'
    },
    //매장에 POS 수정
    getPosNotifyConfig: {
      url: '/json/bizpos/shop/:shopId/notify'
    },
    //매장 POS알림설정 가져오기
    saveNotifyConfig: {
      url: '/json/bizpos/shop/:shopId/notify',
      method: 'PUT'
    },
    //매장 POS알림설정
    getShopPosList: {
      url: '/json/bizpos/shop/:shopId/posList'
    },
    //매장 POS리스트
    getPosInfo: {
      url: '/json/bizpos/shop/:shopId/pos/:posId'
    },
    //매장 POS 정보
    getPosTimeline: {
      url: '/json/bizpos/shop/:shopId/timeline/camera/:cameraId'
    },
    //매출 타임라인 (CVR포함)
    getFindEventGroup: {
      url: '/json/bizpos/shop/:shopId/findEventGroup'
    },
    //앞/뒤 이벤트 그룹 찾기
    getGroupDetailPos: {
      url: '/json/bizpos/shop/:shopId/timeline/events'
    },
    //그룹별 상세 매출
    getEventType: {
      url: '/json/bizpos/shop/:shopId/pos/:posId/eventTypes'
    },
    //이벤트 종류
    getEventList: {
      url: '/json/bizpos/shop/:shopId/events'
    },
    //이벤트 리스트
    getBillDetail: {
      url: '/json/bizpos/shop/:shopId/pos/:posId/billNo/:billNo'
    } //매출 상세
  });
}]);

//POS SUMMARY 관련 API
app.factory('PosSummary', ['$resource', function ($resource) {
  return $resource('/json/bizpos/shop/:shopId/sales/summary', {}, {
    getPosSummary: {
      url: '/json/bizpos/posManager',
      cancellable: true
    },
    getTodaySales: {
      url: '/json/bizpos/shop/:shopId/sales/summary',
      method: 'GET'
    },
    //오늘 매출 리포트
    getSalesDaily: {
      url: '/json/bizpos/shop/:shopId/sales/daily',
      method: 'GET'
    },
    //일간 매출 통계
    getSalesWeekly: {
      url: '/json/bizpos/shop/:shopId/sales/weekly',
      method: 'GET'
    },
    //주간 매출 통계
    getSalesMonthly: {
      url: '/json/bizpos/shop/:shopId/sales/monthly',
      method: 'GET'
    } //월간 매출 통계
  });
}]);
"use strict";

app.factory("Sensor", ['$resource', function ($resource) {
  return $resource('', {}, {
    getSensors: {
      url: ' /json/biz/sensors'
    },
    getShopSensorList: {
      url: '/json/biz/shops/:shopId/sensors'
    },
    getSensorStatus: {
      url: '/json/biz/shops/:shopId/sensors/:sensorId'
    },
    //센서 상세
    getSensorData: {
      url: '/json/biz/shops/:shopId/sensors/:sensorId/data'
    },
    //센서 데이터
    setSensorConnectCamera: {
      url: '/json/biz/sensor/:sensorId/camera/:cameraId',
      method: 'PUT'
    },
    //센서 연결된 카메라 변경    {"code": "ok/nok"
    getSensorSupportCameras: {
      url: '/json/biz/install/cameras/isSensorSupport',
      isArray: true
    },
    //센서지원 카메라목록을 가져온다.
    getSensorEventList: {
      url: '/json/biz/event/shop/:shopId/sensors/:sensorId'
    },
    getSensorEvent: {
      url: '/json/biz/sensors/:sensorId/event'
    },
    setSensorStatus: {
      url: '/json/biz/shops/:shopId/sensors/:sensorId',
      method: 'PUT'
    },
    getTempSensorAlarmConfig: {
      url: '/json/biz/sensors/:sensorId/airNotifyConfig'
    },
    setTempSensorAlarmConfig: {
      url: '/json/biz/sensors/:sensorId/airNotifyConfig',
      method: 'PUT'
    },
    setSensorConfig: {
      url: '/json/biz/sensor/:sensorId',
      method: 'POST'
    },
    getControllerStatus: {
      url: '/json/biz/shops/:shopId/controllerstatus'
    },
    getSensorDataDaily: {
      url: '/json/biz/shops/:shopId/sensors/:sensorId/data/daily'
    },
    getSensorDataMonthly: {
      url: '/json/biz/shops/:shopId/sensors/:sensorId/data/monthly'
    },
    getSensorDataMinute: {
      url: '/json/biz/shops/:shopId/sensors/:sensorId/data/minute'
    }
  });
}]);
"use strict";

app.factory("Demos", ["$resource", function ($resource) {
  return $resource("/json/biz/demo/cameras/:id", {}, {
    getDemoList: {
      url: "/json/biz/demo/cameras",
      isArray: true
    },
    getGatewayDemoList: {
      url: "/json/biz/demo/gateway/cameras",
      isArray: true
    },
    newTimeline: {
      url: "/json/biz/demo/cameras/:id/v2/timeline"
    },
    newThumbnail: {
      url: "/json/biz/demo/cameras/:id/v2/subEvents"
    },
    eventDaily: {
      url: "/json/biz/demo/cameras/:id/events/daily"
    },
    getToken: {
      url: "/json/biz/demo/cameras/:id/token"
    },
    extendToken: {
      url: "/json/biz/demo/cameras/token/:id",
      method: "PUT"
    },
    isLastRecord: {
      url: "/json/biz/demo/cameras/:id/lastActivity"
    },
    zones: {
      url: "/json/biz/demo/cameras/:id/alarmZones"
    },
    getMonitorDemoList: {
      url: "/json/biz/demo/cloudmonitor/cameras",
      isArray: true
    },
    getMonitorDemoToken: {
      url: "/json/biz/demo/cameras/token"
    }
  });
}]);
app.factory("ZoneUpdate", ["$resource", function ($resource) {
  return $resource("/json/biz/cameras/:id/alarmZones/:zoneIndex", {}, {
    update: {
      method: "PUT"
    }
  });
}]);
app.factory("Timezone", ["$resource", function ($resource) {
  return $resource("/json/biz/timezone", {}, {});
}]);
app.factory("Clip", ["$resource", function ($resource) {
  return $resource("/json/biz/clips/:id", {}, {
    availableRange: {
      url: "/json/biz/clips/availableRange"
    },
    shareSnsInfo: {
      url: "/json/biz/clips/:clipId/shareURL",
      method: "GET"
    },
    update: {
      method: "PUT"
    },
    getClipListV2: {
      url: "/json/biz/v2/clips/:id"
    },
    getClipCameraListV2: {
      url: "/json/biz/v2/clips/cameras"
    },
    getClipListByCamera: {
      url: "/api/v1/biz/camera/clip/legacy"
    },
    getCameraClipList: {
      url: "/api/v1/biz/camera/:cameraId/clip/legacy"
    }
  });
}]);

// 토스트 마켓 관련 api
app.factory("Market", ["$resource", function ($resource) {
  return $resource("/json/biz/cameras/isFromToastMarket", {}, {}); //서비스 해지시 마켓에서 판매된 상품인지 여부확인
}]);
app.factory("Service", ["$resource", function ($resource) {
  return $resource("/json/biz/camera/request", {}, {
    serviceRequest: {
      url: "/json/biz/camera/request",
      method: "POST"
    }
  });
}]);
"use strict";

app.factory("Share", ["$resource", function ($resource) {
  return $resource("/json/biz/share/cameras/:id", {}, {
    getList: {
      url: "/json/biz/share/cameras/received",
      isArray: true
    },
    shareCamera: {
      url: "/json/biz/share/cameras",
      method: "POST"
    },
    getMySharedList: {
      url: "/json/biz/share/cameras/:id/receivers",
      isArray: true
    },
    removeMyShared: {
      url: " /json/biz/share/cameras/:id/:sharedCameraUid/",
      method: "DELETE"
    },
    rejectSharedCamera: {
      url: "/json/biz/share/cameras/:sharedCameraUid",
      method: "PUT"
    },
    shareConfig: {
      url: "/json/biz/share/cameras/received/config"
    },
    newTimeline: {
      url: "/json/biz/share/cameras/:id/v2/timeline"
    },
    newThumbnail: {
      url: "/json/biz/share/cameras/:id/v2/subEvents"
    },
    eventDaily: {
      url: "/json/biz/share/cameras/:id/events/daily"
    },
    getToken: {
      url: "/json/biz/share/cameras/:id/token"
    },
    isLastRecord: {
      url: "/json/biz/share/cameras/:id/lastActivity"
    },
    zones: {
      url: "/json/biz/share/cameras/:id/alarmZones"
    },
    shareOptions: {
      url: "/json/biz/share/cameras/:shareId/shareOptions"
    },
    updateShareOptions: {
      url: "/json/biz/share/cameras/:shareId/shareOptions",
      method: "PUT"
    }
  });
}]);
"use strict";

app.factory("Shop", ['$resource', function ($resource) {
  return $resource('/json/biz/shop/myShops', {}, {
    getShop: {
      url: '/json/biz/shop/:shopId'
    },
    regShop: {
      url: '/json/biz/shop',
      method: 'POST'
    },
    updateShop: {
      url: '/json/biz/shop/:shopId',
      method: 'PUT'
    },
    deleteShop: {
      url: '/json/biz/shop/:shopId',
      method: 'DELETE'
    },
    getAllCameras: {
      url: '/json/biz/shop/cameras',
      isArray: true
    },
    updateShopOrder: {
      url: '/json/biz/shop/order',
      method: 'PUT'
    },
    updateShopCameraOrder: {
      url: '/json/biz/shop/:shopId/order',
      method: 'PUT'
    },
    regShopShare: {
      url: '/json/biz/shop/share/:shopId',
      method: 'POST'
    },
    getShopShareOption: {
      url: '/json/biz/shop/share/:shareId/shareOption'
    },
    updateShopShareOption: {
      url: '/json/biz/shop/share/:shareId/shareOption',
      method: 'PUT'
    },
    rejectShopShare: {
      url: '/json/biz/shop/share/:shareId/reject',
      method: 'PUT'
    },
    deleteShopShare: {
      url: '/json/biz/shop/share/:shareId',
      method: 'DELETE'
    },
    getSharedShops: {
      url: '/json/biz/shop/share/sharedShops',
      isArray: true
    },
    getSharedShop: {
      url: '/json/biz/shop/shared/:shopId'
    },
    getShareReceivers: {
      url: '/json/biz/shop/share/:shopId/receiver',
      isArray: true
    },
    updateAccessBeaconCameraId: {
      url: '/json/biz/shop/:shopId/inOut',
      method: 'PUT'
    },
    getSharedShopReceived: {
      url: '/json/biz/shop/shared/:shopId/received',
      isArray: true
    },
    getSharedShopCamera: {
      url: '/json/biz/shop/shared/:shopId/camera/:cameraId'
    },
    getHiredShops: {
      url: '/json/biz/shop/hiredShops',
      isArray: true
    },
    getShopGeofence: {
      url: '/json/biz/shop/:shopId/geofence'
    },
    registerShopGeofence: {
      url: '/json/biz/shop/:shopId/geofence',
      method: 'POST'
    },
    updateShopGeofence: {
      url: '/json/biz/shop/:shopId/geofence',
      method: 'PUT'
    },
    updateShopWorkTime: {
      url: '/json/biz/shop/:shopId/worktime',
      method: 'PUT'
    },
    // Shop Alarm Setting
    getShopAlarmConfig: {
      url: '/json/biz/shop/:shopId/notifyConfig2'
    },
    updateShopAlarmConfig: {
      url: '/json/biz/shop/:shopId/notifyConfig2',
      method: 'PUT'
    },
    getShopSecAlarmConfig: {
      url: '/json/biz/shop/:shopId/notifyConfig2/secNotify'
    },
    updateShopSecAlarmConfig: {
      url: '/json/biz/shop/:shopId/notifyConfig2/secNotify',
      method: 'PUT'
    },
    getShopTempAlarmConfig: {
      url: '/json/biz/shop/:shopId/notifyConfig2/airNotify'
    },
    updateShopTempAlarmConfig: {
      url: '/json/biz/shop/:shopId/notifyConfig2/airNotify',
      method: 'PUT'
    },
    getTempAlarmConfig: {
      url: '/json/biz/sensors/:sensorId/airNotifyConfig'
    },
    updateTempAlarmConfig: {
      url: '/json/biz/sensors/:sensorId/airNotifyConfig',
      method: 'PUT'
    },
    getShopPosAlarmConfig: {
      url: '/json/biz/shop/:shopId/notifyConfig2/posNotify'
    },
    updateShopPosAlarmConfig: {
      url: '/json/biz/shop/:shopId/notifyConfig2/posNotify',
      method: 'PUT'
    },
    getShopPlugAlarmConfig: {
      url: '/json/biz/shop/:shopId/notifyConfig2/plugNotify'
    },
    setShopPlugAlarmConfig: {
      url: 'json/biz/shop/:shopId/notifyConfig2/plugNotify',
      method: 'PUT'
    },
    dashboardShopV2: {
      url: '/json/biz/dashboard/v2/shops/:shopId'
    },
    dashboardShopEventV2: {
      url: '/json/biz/dashboard/v1/shops/:shopId/events'
    },
    dashboardShopEventV3: {
      url: '/json/biz/dashboard/v2/shops/:shopId/events'
    },
    //NEW API
    getIothubs: {
      url: '/json/biz/devices/IOTHUB/manage'
    },
    getDids: {
      url: '/json/biz/dids'
    },
    getShopV2: {
      url: '/json/biz/v2/shop/:shopId'
    },
    getSharedShopV2: {
      url: '/json/biz/v2/shop/shared/:shopId'
    },
    dashboardShopV3: {
      url: '/json/biz/dashboard/v3/shops/:shopId'
    },
    dashboardShopV4: {
      url: '/json/biz/dashboard/v4/shops/:shopId'
    },
    appDashboardShops: {
      url: '/json/biz/app/dashboard/shops'
    },
    appDashboardShop: {
      url: '/json/biz/app/dashboard/shops/:shopId'
    },
    dashboardShops: {
      url: '/json/biz/shops'
    },
    //대시보드용 매장리스트
    dashboardShopEvents: {
      url: '/json/biz/event/shop/:shopId',
      headers: {
        'Accept-Language': $("html").attr("lang")
      }
    },
    //대시보드용 매장 이벤트리스트 (Request Parameter {date (String : yyyyMMdd), limit (int : Option), filter (String : Option)})
    dashboardEventFilters: {
      url: '/json/biz/event/filter'
    },
    dashboardShopEventFilters: {
      url: '/json/biz/event/shop/:shopId/filter'
    },
    dashboardShopStaffs: {
      url: '/json/biz/shop/:shopId/staff/dashboard'
    },
    //대시보드용 근태관리
    dashboardDidList: {
      url: '/json/biz/shops/:shopId/dids'
    },
    dashboardIoTSummary: {
      url: '/json/biz/event/shops/:shopId/summaryByDevice'
    },
    getDidInfo: {
      url: '/json/biz/shops/:shopId/dids/:didId'
    },
    setDidName: {
      url: '/json/biz/shops/:shopId/dids/:didId',
      method: 'PUT'
    },
    deleteDid: {
      url: '/json/biz/shops/:shopId/dids/:didId',
      method: 'DELETE'
    },
    queryAddress: {
      url: '/json/biz/common/address'
    },
    regShopV2: {
      url: '/json/biz/v2/shop',
      method: 'POST'
    },
    //shopName, zipCode, address1: 주소기본, address2: 주소상세, cameraIds, timezone, language, access: 매장 단위로 출입감지를 사용할지 여부를 설정.
    updateShopV2: {
      url: '/json/biz/v2/shop/:shopId',
      method: 'PUT'
    },
    //shopName, zipCode, address1: 주소기본, address2: 주소상세, cameraIds, timezone, language, access: 매장 단위로 출입감지를 사용할지 여부를 설정.
    // AI
    aiStats: {
      url: '/json/biz/shop/:shopId/ai/stats'
    },
    aiDailyStats: {
      url: '/json/biz/aireport/shops/:shopId/stats/daily'
    },
    aiHourlyStats: {
      url: '/json/biz/aireport/shops/:shopId/stats/hourly'
    },
    aiMinStats: {
      url: '/json/biz/aireport/shops/:shopId/stats/tenminutes'
    },
    aiShopInfo: {
      url: '/json/biz/shop/:shopId/aiShopInfo'
    },
    setAiShopInfo: {
      url: '/json/biz/shop/:shopId/aiShopInfo',
      method: 'POST'
    },
    getAiShopData: {
      url: '/json/biz/dashboard/v1/shops/:shopId/ai'
    },
    getAiChartByMin: {
      url: '/json/biz/shops/:shopId/ai/peopleArea/minute'
    },
    getAiChartByDay: {
      url: '/json/biz/shops/:shopId/ai/peopleArea/daily'
    },
    getAiShopSetting: {
      url: '/json/biz/shops/:shopId/ai'
    },
    setAiShopSetting: {
      url: '/json/biz/shops/:shopId/ai',
      method: 'PUT'
    }
  });
}]);
"use strict";

var passUlrs = ["/login", "/mobile", "/findPassword", "/signup", "/monitor", "/demo", "/help", "/faq", "/qna", "/inquiry", "/notice", "/main", "/error", "/terms", "/noticeMobile"];
app.factory("AuthInterceptor", ["$q", function ($q) {
  return {
    responseError: function responseError(_responseError) {
      if (_responseError.status === 401) {
        var checkUrl = -1;
        for (var i = 0; i < passUlrs.length; i++) {
          checkUrl = location.href.indexOf(passUlrs[i]);
          if (checkUrl != -1) {
            break;
          }
        }
        if (checkUrl == -1) {
          location.href = "/#/";
        }
      }
      return $q.reject(_responseError);
    }
  };
}]);
app.factory("User", ["$resource", function ($resource) {
  return $resource("/json/biz/users/:id", {}, {
    me: {
      url: "/json/biz/v2/users/me"
    },
    extraService: {
      url: "/json/biz/v2/users/me/extra-service"
    },
    signOut: {
      url: "/json/biz/v2/users/me",
      method: "DELETE"
    },
    logout: {
      method: "GET",
      url: "/json/biz/logout"
    },
    lbsAgree: {
      url: "/json/biz/users/me/lbsAgreed",
      method: "PUT"
    },
    customerCenterInfo: {
      url: "/json/biz/customerCenterInfo",
      method: "GET"
    },
    loginSessionExpand: {
      url: "/json/biz/login/expanding",
      method: "POST"
    }
  });
}]);
app.factory("Acount", ["$resource", function ($resource) {
  return $resource("/json/biz/bizToastcamUser/checkEmailDup", {}, {
    creatUser: {
      url: "/json/biz/bizToastcamUser",
      method: "POST"
    },
    sendAuthEmail: {
      url: "/json/biz/bizToastcamUser/sendAuthEmail",
      method: "PUT"
    },
    emailAuth: {
      url: "/json/biz/bizToastcamUser/emailAuth",
      method: "PUT"
    },
    checkEmail: {
      url: "/json/biz/bizToastcamUser/checkEmail",
      method: "GET"
    },
    searchPassword: {
      url: "/json/biz/bizToastcamUser/searchPassword",
      method: "PUT"
    },
    emailAuthPassword: {
      url: "/json/biz/bizToastcamUser/emailAuthPassword",
      method: "POST"
    },
    checkPassword: {
      url: "/json/biz/bizToastcamUser/checkPassword",
      method: "POST"
    },
    updatePassword: {
      url: "/json/biz/bizToastcamUser/updatePassword",
      method: "POST"
    },
    login: {
      url: "/json/biz/bizToastcamUser/login",
      method: "POST"
    },
    logout: {
      url: "/json/biz/bizToastcamUser/logout",
      method: "GET"
    }
  });
}]);
"use strict";

app.factory("WebRTC", ["$rootScope", "$window", "User", "Utils", function ($rootScope, $window, User, Utils) {
  var webRTC = {};
  var camera = {};
  var mediaConfig = {
    audio: false,
    video: {
      mandatory: {},
      optional: []
    }
  };
  var socket = null,
    configValue = {
      peerConnectionConfig: {
        iceServers: [],
        iceTransportPolicy: "relay"
      },
      peerConnectionConstraints: {
        optional: [{
          DtlsSrtpKeyAgreement: true
        }]
      }
    },
    cameraId,
    dvrId,
    channelId,
    peer,
    socket,
    webRTCStatus,
    peerDatabase = {},
    localStream,
    sessionId,
    timeoutId,
    remoteVideoContainer = document.getElementById("remoteVideosContainer");
  camera.preview = $window.document.getElementById("localVideo");
  webRTC.EVENT_STREAM_CONNECTING = "event_stream_connecting";
  webRTC.EVENT_STREAM_CONNECTED = "event_stream_connected";
  webRTC.EVENT_STREAM_DISCONNECTED = "event_stream_disconnected";
  webRTC.EVENT_STREAM_STOPPED = "event_stream_stopped";

  // Returns the result of getUserMedia as a Promise.
  function requestUserMedia(constraints) {
    return new Promise(function (resolve, reject) {
      var onSuccess = function onSuccess(stream) {
        resolve(stream);
      };
      var onError = function onError(error) {
        reject(error);
      };
      try {
        //getUserMedia(constraints, onSuccess, onError);
      } catch (e) {
        reject(e);
      }
    });
  }
  webRTC.getWebRTCStatus = function () {
    return webRTCStatus;
  };
  webRTC.webRTCStart = function (cameraIdValue, timestamp) {
    var realURL;
    if ($rootScope.me && $rootScope.me.country === "JP") {
      realURL = controlServerJpUrl;
    } else {
      realURL = controlServerUrl;
    }
    if (socket) {
      socket.disconnect();
      socket = null;
      void 0;
    }
    webRTCStatus = webRTC.EVENT_STREAM_CONNECTING;
    if (navigator.userAgent.indexOf("OPR") != -1) {
      socket = io.connect(realURL, {
        transports: ["xhr-polling", "websocket"],
        forceNew: true,
        secure: true
      });
    } else {
      socket = io.connect(realURL, {
        transports: ["websocket"],
        forceNew: true,
        secure: true
      }); //,
    }
    var cameraInfos = cameraIdValue.split("@");
    dvrId = cameraInfos[0];
    channelId = cameraInfos[1];
    var timeObj = new Date();
    sessionId = Utils.getCookie("toastcam") + "_" + timeObj.getTime();
    socket.on("LoginRequired", function (data) {
      void 0;
      User.me(function (data) {
        if (socket) {
          socket.emit("login", {
            msgid: makeMsgId(),
            type: "req",
            messageversion: "s-2.0.0",
            devicetype: "WEB",
            deviceinfo: {
              userid: data.userId,
              appname: "toastcam_b2b",
              appversion: "1.3.12",
              browsertype: "chrome",
              osversion: "6.0",
              sessionid: sessionId
            }
          });
        } else {
          webRTCStatus = webRTC.EVENT_STREAM_DISCONNECTED;
          $rootScope.$broadcast(webRTC.EVENT_STREAM_DISCONNECTED, {
            code: "nosocket"
          });
        }
      });
    });
    socket.on("login", function (data) {
      void 0;
      if (data.code == 0) {
        if (socket) {
          if (dvrId && channelId) {
            socket.emit("webrtc_request", {
              msgid: makeMsgId(),
              type: "req",
              scenario: "livestream",
              channel: channelId,
              resolution: "HD",
              timestamp: timestamp,
              from: sessionId,
              to: dvrId
            });
            if (timeoutId) {
              clearTimeout(timeoutId);
            }
            timeoutId = setTimeout(function () {
              $rootScope.$broadcast(webRTC.EVENT_STREAM_DISCONNECTED, {
                code: "timeout"
              });
            }, 15 * 1000);
          } else {
            webRTCStatus = webRTC.EVENT_STREAM_DISCONNECTED;
            $rootScope.$broadcast(webRTC.EVENT_STREAM_DISCONNECTED, {
              code: "nocamera"
            });
          }
        } else {
          webRTCStatus = webRTC.EVENT_STREAM_DISCONNECTED;
          $rootScope.$broadcast(webRTC.EVENT_STREAM_DISCONNECTED, {
            code: "nosocket"
          });
        }
      } else {
        webRTCStatus = webRTC.EVENT_STREAM_DISCONNECTED;
        $rootScope.$broadcast(webRTC.EVENT_STREAM_DISCONNECTED, {
          code: "loginfail"
        });
        //Code Define
        //: -1 - 유효하지 않은 sessionid인 경우
        //: -2 - 서버 내부 에러. (Master에서 client생성 ok가 오지않는 경우)
      }
    });
    socket.on("webrtc_request", function (data) {
      if (timeoutId) {
        clearTimeout(timeoutId);
        timeoutId = null;
      }
      handleMessageRequest(data);
    });
    socket.on("webrtc_signaling", function (data) {
      handleMessage(data);
    });
  };
  webRTC.webRTCStop = function (cameraIdValue) {
    if (socket) {
      socket.disconnect();
      socket = null;
    }
    var cameraInfos = cameraIdValue.split("@");
    var peer = peerDatabase[cameraInfos[0]];
    if (peer) {
      peer.pc.close();
    }
    delete peerDatabase[cameraInfos[0]];
    if (camera.stream && camera.stream.getTracks) {
      var tracks = camera.stream.getTracks();
      for (var track in tracks) {
        if (tracks[track]) {
          tracks[track].stop();
        }
      }
    }
    if (camera.preview) {
      camera.preview.src = "";
    }
    webRTCStatus = webRTC.EVENT_STREAM_STOPPED;
  };
  webRTC.getId = function () {
    return localId;
  };
  webRTC.setLocalStream = function (stream) {
    // if local cam has been stopped, remove it from all outgoing streams.
    if (!stream) {
      for (id in peerDatabase) {
        pc = peerDatabase[id].pc;
        if (!!pc.getLocalStreams().length) {
          pc.removeStream(localStream);
          //offer(id);
        }
      }
    }
    localStream = stream;
  };
  webRTC.toggleLocalStream = function (remoteId) {
    peer = peerDatabase[remoteId] || addPeer(remoteId);
    toggleLocalStream(peer.pc);
  };
  webRTC.peerInit = function (remoteId) {
    peer = peerDatabase[remoteId] || addPeer(remoteId);
    send("init", remoteId, null);
  };
  webRTC.peerRenegociate = function (remoteId) {
    //offer(remoteId);
  };
  webRTC.send = function (type, payload) {
    if (socket) {
      socket.emit(type, payload);
    }
  };

  /********** Local Function ***********/
  function startStream() {
    return requestUserMedia(mediaConfig).then(function (stream) {
      attachMediaStream(camera.preview, stream);
      webRTC.setLocalStream(stream);
      camera.stream = stream;
    })["catch"](Error("Failed to get access to local media."));
  }
  function callStream(stream, callback) {
    /* If json isn't loaded yet, construct a new stream
     * This happens when you load <serverUrl>/<socketId> :
     * it calls socketId immediatly.
     **/
    if (!stream.id) {
      stream = {
        id: stream,
        isPlaying: false
      };
    }
    startStream().then(function (result) {
      webRTC.toggleLocalStream(stream.id);
      if (stream.isPlaying) {
        webRTC.peerRenegociate(stream.id);
      } else {
        webRTC.peerInit(stream.id);
      }
      stream.isPlaying = !stream.isPlaying;
      callback();
    })["catch"](function (err) {
      void 0;
    });
  }
  function addPeer(remoteId) {
    var peer = new Peer(configValue.peerConnectionConfig, configValue.peerConnectionConstraints);
    peer.pc.onicecandidate = function (event) {
      if (event.candidate) {
        if (socket) {
          var candidateJSON = {
            msgid: makeMsgId(),
            type: "noti",
            command: "candidate",
            from: sessionId,
            to: dvrId,
            payload: {
              id: event.candidate.sdpMid,
              label: event.candidate.sdpMLineIndex,
              candidate: event.candidate.candidate
            }
          };
          socket.emit("webrtc_signaling", candidateJSON);
        }
      }
    };
    if (Utils.isFireFox()) {
      peer.pc.ontrack = function (event) {
        attachMediaStream(peer.remoteVideoEl, event.streams[0]);
        remoteVideosContainer.appendChild(peer.remoteVideoEl);
        webRTCStatus = webRTC.EVENT_STREAM_CONNECTED;
        $rootScope.$broadcast(webRTC.EVENT_STREAM_CONNECTED, {});
      };
    } else {
      peer.pc.onaddstream = function (event) {
        attachMediaStream(peer.remoteVideoEl, event.stream);
        remoteVideosContainer.appendChild(peer.remoteVideoEl);
        webRTCStatus = webRTC.EVENT_STREAM_CONNECTED;
        $rootScope.$broadcast(webRTC.EVENT_STREAM_CONNECTED, {});
      };
    }
    peer.pc.onremovestream = function (event) {
      peer.remoteVideoEl.src = "";
      remoteVideosContainer.removeChild(peer.remoteVideoEl);
    };
    peer.pc.oniceconnectionstatechange = function (event) {
      switch ((event.srcElement ||
      // Chrome
      event.target).iceConnectionState // Firefox
      ) {
        case "disconnected":
          remoteVideosContainer.removeChild(peer.remoteVideoEl);
          webRTCStatus = webRTC.EVENT_STREAM_DISCONNECTED;
          $rootScope.$broadcast(webRTC.EVENT_STREAM_DISCONNECTED, {});
          break;
      }
    };
    peerDatabase[remoteId] = peer;
    return peer;
  }
  function answer(remoteId) {
    var pc = peerDatabase[remoteId].pc;
    pc.createAnswer(function (sessionDescription) {
      pc.setLocalDescription(sessionDescription);
      send("answer", remoteId, sessionDescription);
    }, error);
  }
  function offer(remoteId) {
    var pc = peerDatabase[remoteId].pc;
    var constraints;
    if (webrtcDetectedBrowser === "firefox") {
      constraints = {
        offerToReceiveVideo: 1,
        offerToReceiveAudio: 1
      };
    } else {
      constraints = {
        optional: [],
        mandatory: {
          OfferToReceiveAudio: true,
          OfferToReceiveVideo: true
        }
      };
    }
    if (Utils.isSafari()) {
      pc.addTransceiver("audio");
      pc.addTransceiver("video");
    }
    pc.createOffer(function (sessionDescription) {
      pc.setLocalDescription(sessionDescription);
      if (socket) {
        socket.emit("webrtc_signaling", {
          msgid: makeMsgId(),
          type: "noti",
          command: "offer",
          from: sessionId,
          to: dvrId,
          payload: sessionDescription
        });
      }
    }, error, constraints);
  }
  function handleMessageRequest(message) {
    var from = dvrId,
      pc;
    if (message.code == 0) {
      configValue.peerConnectionConfig.iceServers = [];
      var i, len;
      if (message.turnserver) {
        if (Utils.isFireFox()) {
          for (i = 0, len = message.turnserver.length; i < len; i += 1) {
            if (i === 0) {
              configValue.peerConnectionConfig.iceServers.push(message.turnserver[i]);
              if (configValue.peerConnectionConfig.iceServers[0] && configValue.peerConnectionConfig.iceServers[0].url) {
                configValue.peerConnectionConfig.iceServers[0]["urls"] = [];
                configValue.peerConnectionConfig.iceServers[0]["urls"].push(configValue.peerConnectionConfig.iceServers[0].url);
                delete configValue.peerConnectionConfig.iceServers[0].url;
              }
            } else {
              if (configValue.peerConnectionConfig.iceServers[0] && configValue.peerConnectionConfig.iceServers[0].urls) {
                configValue.peerConnectionConfig.iceServers[0].urls.push(message.turnserver[i].url);
              }
            }
          }
        } else {
          for (i = 0, len = message.turnserver.length; i < len; i += 1) {
            configValue.peerConnectionConfig.iceServers.push(message.turnserver[i]);
          }
        }
      }
      pc = addPeer(from).pc;
      toggleLocalStream(pc);
      offer(dvrId);
    } else {
      webRTCStatus = webRTC.EVENT_STREAM_DISCONNECTED;
      $rootScope.$broadcast(webRTC.EVENT_STREAM_DISCONNECTED, {
        code: message.code
      });
    }
  }
  function handleMessage(message) {
    var type = message.command,
      from = dvrId,
      pc;
    switch (type) {
      case "offer":
        break;
      case "answer":
        pc = peerDatabase[from].pc;
        var payloadJSON;
        if (typeof message.payload === "string") {
          payloadJSON = JSON.parse(message.payload);
        } else {
          payloadJSON = message.payload;
        }
        pc.setRemoteDescription(new RTCSessionDescription(payloadJSON), function () {}, error);
        break;
      case "candidate":
        pc = peerDatabase[from].pc;
        if (pc.remoteDescription) {
          var candidateJSON;
          if (typeof message.payload === "string") {
            candidateJSON = JSON.parse(message.payload);
          } else {
            candidateJSON = message.payload;
          }
          pc.addIceCandidate(new RTCIceCandidate({
            sdpMLineIndex: candidateJSON.label,
            sdpMid: candidateJSON.id,
            candidate: candidateJSON.candidate
          }), function () {}, error);
        }
        break;
    }
  }
  function send(type, to, payload) {
    if (socket) {
      socket.emit("message", {
        to: to,
        type: type,
        payload: payload
      });
    } else {
      webRTCStatus = webRTC.EVENT_STREAM_DISCONNECTED;
      $rootScope.$broadcast(webRTC.EVENT_STREAM_DISCONNECTED, {
        code: "nosocket"
      });
    }
  }
  function toggleLocalStream(pc) {}
  function error(err) {
    void 0;
  }
  function Peer(pcConfig, pcConstraints) {
    this.pc = new RTCPeerConnection(pcConfig, pcConstraints);
    this.remoteVideoEl = document.createElement("video");
    this.remoteVideoEl.controls = false;
    this.remoteVideoEl.autoplay = true;
  }
  function makeMsgId() {
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for (var i = 0; i < 30; i++) text += possible.charAt(Math.floor(Math.random() * possible.length));
    return text;
  }
  return webRTC;
}]);
"use strict";

app.factory("DomainUtils", function ($window) {
  var isAllowedAiDomain = function isAllowedAiDomain() {
    var allowedDomains = ["dev-face.toastcam.com", "dev-face.toast.com", "face.toastcam.com", "face.toast.com"];
    var currentDomain = $window.location.host;
    return allowedDomains.includes(currentDomain);
  };
  return {
    isAllowedAiDomain: isAllowedAiDomain
  };
});
"use strict";

app.factory("NgUtils", function () {
  return {
    pagingUtil: function pagingUtil() {
      var pageNumber = 1;
      var count = 16;
      var pageCount = 10;
      var pageViews = [];
      var firstPageView = 1; // 하단 첫 페이지 넘버 1, 11, 21...
      var lastPageView = 1; // 하단 끝 페이지 넘버 10, 20, 30,,,
      var totalCount = 1;
      var firstPageNum = 1; // 첫페이지 넘버 1고정
      var lastPageNum = 1; // 가장 끝 페이지 넘버  Math.ceil(totalCount / count); 
      var callBackFunc = function callBackFunc() {};
      var init = function init() {
        pageNumber = 1;
        count = 16;
        totalCount = 1;
        pageViews.splice(0, pageViews.length);
        calcPageData();
      };
      var calcPageData = function calcPageData() {
        if (totalCount == 0) {
          pageViews.splice(0, pageViews.length);
          return;
        }
        lastPageNum = Math.ceil(totalCount / count);
        var i = 1;
        var j = lastPageNum <= pageCount ? lastPageNum : pageCount;
        for (; j <= lastPageNum; i += pageCount) {
          if (i <= pageNumber && pageNumber <= j) {
            firstPageView = i;
            lastPageView = j;
            break;
          }
          if (j + pageCount <= lastPageNum) j += pageCount;else j = lastPageNum;
        }
        pageViews.splice(0, pageViews.length);
        for (var i = firstPageView; i <= lastPageView; i++) {
          pageViews.push(i);
        }
      };
      var setTotalCount = function setTotalCount(count) {
        totalCount = count;
        calcPageData();
      };
      var goPage = function goPage(page, data) {
        pageNumber = page;
        callBackFunc(data);
      };
      var prevPage = function prevPage() {
        if (pageNumber >= 2) goPage(pageNumber >= 2 ? pageNumber - 1 : pageNumber);
      };
      var nextPage = function nextPage() {
        if (pageNumber < lastPageNum) goPage(pageNumber < lastPageNum ? pageNumber + 1 : pageNumber);
      };
      var firstPage = function firstPage(data) {
        pageNumber = 1;
        calcPageData();
        callBackFunc(data);
      };
      var lastPage = function lastPage(data) {
        pageNumber = lastPageNum;
        calcPageData();
        callBackFunc(data);
      };
      var setCallBackFunc = function setCallBackFunc(func) {
        callBackFunc = func;
      };
      var getPagingNum = function getPagingNum() {
        return pageNumber;
      };
      var setPage = function setPage(page) {
        pageNumber = page;
      };
      return {
        pageNumber: getPagingNum,
        init: init,
        setCallBackFunc: setCallBackFunc,
        setTotalCount: setTotalCount,
        goPage: goPage,
        prevPage: prevPage,
        nextPage: nextPage,
        firstPage: firstPage,
        lastPage: lastPage,
        pageViews: pageViews,
        setPage: setPage
      };
    }
  };
});
"use strict";

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
app.factory("Utils", [function () {
  function throttling() {
    this.throttleCheck = null;
  }
  throttling.prototype.throttle = function (callback, milliseconds) {
    var self = this;
    return function () {
      var arg = arguments;
      if (!self.throttleCheck) {
        self.throttleCheck = setTimeout(function () {
          callback.apply(null, arg);
          self.throttleCheck = null;
        }, milliseconds);
      }
    };
  };
  function debouncing() {
    this.debounceCheck = null;
  }
  debouncing.prototype.debounce = function (callback, milliseconds) {
    var self = this;
    return function () {
      var arg = arguments;
      clearTimeout(self.debounceCheck);
      self.debounceCheck = setTimeout(function () {
        callback.apply(null, arg);
      }, milliseconds);
    };
  };
  function getBrowserType() {
    if ((navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf("OPR")) != -1) {
      return "opera";
    } else if (navigator.userAgent.indexOf("Chrome") != -1) {
      return "chrome";
    } else if (navigator.userAgent.indexOf("Safari") != -1) {
      return "safari";
    } else if (navigator.userAgent.indexOf("Firefox") != -1) {
      return "firefox";
    } else if (navigator.userAgent.indexOf("MSIE") != -1 || !!document.documentMode == true) {
      //IF IE > 10
      return "ie";
    } else {
      return "unknown";
    }
  }
  return {
    throttling: throttling,
    debouncing: debouncing,
    getBrowserType: getBrowserType,
    strCheck: function strCheck(a) {
      a = a.replace(/</g, "&lt;");
      a = a.replace(/>/g, "&gt;");
      a = a.replace('"', "&gt;");
      a = a.replace("&", "&amp;");
      a = a.replace("%00", null);
      a = a.replace('"', "&#34;");
      a = a.replace("'", "&#39;");
      a = a.replace("%", "&#37;");
      a = a.replace("../", "");
      a = a.replace("..\\\\", "");
      a = a.replace("./", "");
      a = a.replace("%2F", "");
      a = a.replace("&lt;p&gt;", "<p>");
      a = a.replace("&lt;P&gt;", "<P>");
      a = a.replace("&lt;br&gt;", "<br>");
      a = a.replace("&lt;BR&gt;", "<BR>");
      return a;
    },
    getLastPathComponent: function getLastPathComponent() {
      var paths = location.pathname.split("/");
      return paths[paths.length - 1];
    },
    configDateSeparate: function configDateSeparate(dateString) {
      if (typeof dateString !== "string" || dateString === "") {
        return {
          hour: "01",
          minute: "00"
        };
      }
      var pattern = /(\d+):(\d+)$/;
      var matches = dateString.match(pattern);
      var hour = matches[1];
      if (hour.length === 1) {
        hour = "0" + hour;
      }
      var minute = matches[2];
      if (minute.length === 1) {
        minute = "0" + minute;
      }
      return {
        hour: hour,
        minute: minute
      };
    },
    configDateJoin: function configDateJoin(dateObject) {
      return dateObject.hour + ":" + dateObject.minute;
    },
    configRepeatOnSeparate: function configRepeatOnSeparate(repeatString) {
      var defaultObject = {
        MON: false,
        TUE: false,
        WED: false,
        THU: false,
        FRI: false,
        SAT: false,
        SUN: false
      };
      if (typeof repeatString !== "string" || repeatString === "") {
        return defaultObject;
      }
      var tokens = repeatString.split(",");
      for (var i in tokens) {
        defaultObject[tokens[i.toUpperCase()]] = true;
      }
      return defaultObject;
    },
    configRepeatOnJoin: function configRepeatOnJoin(repeatObject) {
      var repeatOn = [];
      for (var i in repeatObject) {
        if (repeatObject[i]) {
          repeatOn.push(i);
        }
      }
      return repeatOn.join(",");
    },
    notifyEventTypeSeparate: function notifyEventTypeSeparate(eventTypeArr) {
      var defaultObject = {
        MOTION: false,
        AUDIO: false,
        ACCESS: false
      };
      if (eventTypeArr === null || eventTypeArr.length === 0) {
        return defaultObject;
      }
      for (var i in eventTypeArr) {
        defaultObject[eventTypeArr[i].toUpperCase()] = true;
      }
      return defaultObject;
    },
    notifyEventTypeJoin: function notifyEventTypeJoin(eventTypeObject) {
      var eventTypes = [];
      for (var i in eventTypeObject) {
        if (eventTypeObject[i] && typeof i === "string") {
          eventTypes.push(i.toLowerCase());
        }
      }
      return eventTypes.join(",");
    },
    isCloudExpired: function isCloudExpired(camera) {
      if ((camera.serviceType === "n/a" || camera.serviceType === "0d" || camera.saveEndDate < Date.now()) && camera.recorderType !== "nvr") {
        return true;
      }
      return false;
    },
    isTurnOffCamera: function isTurnOffCamera(camera) {
      return camera.controlStatus !== "on";
    },
    getBrowserLanguage: function getBrowserLanguage() {
      var langMap = {
        en: "en_US",
        ko: "ko_KR",
        ja: "ja_JP"
      };
      var htmlLang = document.documentElement.getAttribute("lang");
      return langMap[htmlLang] || "en_US";
    },
    durationStringFromTwoTime: function durationStringFromTwoTime(startTime, endTime, playrate) {
      var durationSeconds = parseInt((endTime - startTime) / 1000);
      if (playrate !== undefined) {
        durationSeconds = durationSeconds / playrate;
      }
      var seconds = Math.ceil(parseInt(durationSeconds % 60 * 100) / 100);
      var minutes = 0;
      if (durationSeconds >= 60) {
        minutes = parseInt(durationSeconds / 60);
      }
      var arr = [];
      minutes = minutes < 0 ? "00" : minutes < 10 ? "0" + minutes : minutes;
      arr.push(minutes + ":");
      seconds = seconds < 0 ? "00" : seconds < 10 ? "0" + seconds : seconds;
      arr.push(seconds);
      return arr.join(" ");
    },
    imageBackgroundLocation: function imageBackgroundLocation(index, width, height) {
      if (width === undefined) {
        width = 160;
      }
      if (height === undefined) {
        height = 90;
      }
      var top = 0;
      if (index / 5 >= 1) {
        top = -height;
      }
      var left = index % 5 * width;
      return {
        top: top,
        left: left
      };
    },
    toFormattedPhoneNumber: function toFormattedPhoneNumber(phone) {
      if (phone == undefined || phone == "") {
        return phone;
      }
      var rawNumber = phone.replace(/-/g, "");
      var localNumber, phoneNumber;
      var match = /^(010|011|016|017|018|019)(\d+)$/.exec(rawNumber);
      if (match != null) {
        localNumber = match[1];
        phoneNumber = match[2];
      } else {
        return rawNumber;
      }
      var formatted;
      if (phoneNumber.length < 8) {
        formatted = phoneNumber.replace(/(\d{3})(\d{1,4})/, "$1-$2");
      } else {
        formatted = phoneNumber.replace(/(\d{4})(\d{1,4})$/, "$1-$2");
      }
      return localNumber + "-" + formatted;
    },
    phoneNumberReturn: function phoneNumberReturn(phone) {
      return phone.replace(/-/gi, "");
    },
    phoneNumberVaild: function phoneNumberVaild(phone) {
      var rgEx = /(01[016789])[-](\d{4}|\d{3})[-]\d{4}$/g;
      var chkFlg = rgEx.test(phone);
      return chkFlg;
    },
    emailValid: function emailValid(email) {
      var re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
      return re.test(email);
    },
    userNameNimAdd: function userNameNimAdd() {
      var userNim = "";
      if ($("html").attr("lang") == "ko") {
        userNim = " 님";
      }
      return userNim;
    },
    getContextPath: function getContextPath() {
      var offset = location.href.indexOf(location.host) + location.host.length;
      var ctxPath = location.href.substring(offset, location.href.indexOf("/", offset + 1));
      return ctxPath;
    },
    getContextHtmlPath: function getContextHtmlPath() {
      var offset = location.href.indexOf(location.host) + location.host.length;
      var ctxPath = location.href.substring(offset, location.href.indexOf("/", offset + 1)) + "/html";
      return ctxPath;
    },
    getServerPath: function getServerPath() {
      return "http://localhost";
    },
    getParameters: function getParameters(param) {
      var returnValue;
      var url = location.href;
      var parameters = url.slice(url.indexOf("?") + 1, url.length).split("&");
      for (var i = 0; i < parameters.length; i++) {
        var varName = parameters[i].split("=")[0];
        if (varName.toUpperCase() == param.toUpperCase()) {
          returnValue = parameters[i].split("=")[1];
          return decodeURIComponent(returnValue);
        }
      }
    },
    getServerIp: function getServerIp(data) {
      var returnUrl = "";
      if (data == "" || data == undefined) {
        return "";
      }
      var rtIdx = data.indexOf("//");
      var rt = "";
      if (rtIdx != -1) {
        rt = data.substring(0, rtIdx + 2);
      }
      var tmp = data.substring(rtIdx + 2, data.length);
      if (tmp.indexOf("/") != -1) {
        returnUrl = rt + tmp.substring(0, tmp.indexOf("/"));
      }

      //alert(returnUrl);
      tmp = "";
      if (navigator.userAgent.indexOf("MSIE") !== -1 || navigator.appVersion.indexOf("Trident/") > 0) {
        tmp = returnUrl.replace("rtmps://", "rtmp://");
        returnUrl = tmp.replace(":8081", ":1935");
      }
      return returnUrl;
    },
    getLiveServerUrl: function getLiveServerUrl(data) {
      var returnUrl = "";
      if (data == "" || data == undefined) {
        return "";
      }
      var rtIdx = data.indexOf("//");
      var rt = "";
      if (rtIdx != -1) {
        rt = data.substring(0, rtIdx + 2);
      }
      var tmp = data.substring(rtIdx + 2, data.length);
      if (tmp.indexOf("/") != -1) {
        returnUrl = rt + tmp.substring(0, tmp.indexOf("/"));
      }
      tmp = returnUrl.replace("://", "");
      var getPort = parseInt(tmp.substring(tmp.indexOf(":") + 1, tmp.length));
      var iePort = getPort + 1;
      if (navigator.userAgent.indexOf("MSIE") !== -1 || navigator.appVersion.indexOf("Trident/") > 0) {
        returnUrl = returnUrl.replace(getPort, iePort);
      }
      return returnUrl;
    },
    getMonitoringLiveServerUrl: function getMonitoringLiveServerUrl(data) {
      var returnUrl = "";
      if (data == "" || data == undefined) {
        return "";
      }
      var rtIdx = data.indexOf("//");
      var rt = "";
      if (rtIdx != -1) {
        rt = data.substring(0, rtIdx + 2);
      }
      var tmp = data.substring(rtIdx + 2, data.length);
      if (tmp.indexOf("/") != -1) {
        returnUrl = rt + tmp.substring(0, tmp.indexOf("/"));
      }
      return returnUrl;
    },
    getCvrServerUrl: function getCvrServerUrl(data) {
      var returnUrl = "";
      if (data == "" || data == undefined) {
        return "";
      }
      returnUrl = data;
      var tmp = returnUrl.replace("://", "");
      var getPort = parseInt(tmp.substring(tmp.indexOf(":") + 1, tmp.length));
      var iePort = getPort + 1;
      if (navigator.userAgent.indexOf("MSIE") !== -1 || navigator.appVersion.indexOf("Trident/") > 0) {
        returnUrl = returnUrl.replace(getPort, iePort);
      }
      return returnUrl;
    },
    getNvrServerUrl: function getNvrServerUrl(data) {
      var returnUrl = "";
      if (data == "" || data == undefined) {
        return "";
      }
      var rtIdx = data.indexOf("//");
      var rt = "";
      if (rtIdx != -1) {
        rt = data.substring(0, rtIdx + 2);
      }
      var tmp = data.substring(rtIdx + 2, data.length);
      if (tmp.indexOf("/") != -1) {
        returnUrl = rt + tmp.substring(0, tmp.indexOf("/"));
      }
      return returnUrl;
    },
    setCookie: function setCookie(cName, cValue) {
      var cDays = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 7;
      var expire = new Date();
      expire.setDate(expire.getDate() + cDays);
      var cookie = "".concat(cName, "=").concat(encodeURIComponent(cValue), "; path=/; expires=").concat(expire.toUTCString(), ";");
      document.cookie = cookie;
    },
    getCookie: function getCookie(cName) {
      var name = "".concat(cName, "=");
      var decodedCookie = decodeURIComponent(document.cookie);
      var cookieArray = decodedCookie.split(";");
      var _iterator = _createForOfIteratorHelper(cookieArray),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var cookie = _step.value;
          cookie = cookie.trim();
          if (cookie.indexOf(name) === 0) {
            return cookie.substring(name.length, cookie.length);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return "";
    },
    getOs: function getOs() {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
      if (/windows phone/i.test(userAgent)) {
        return "Windows Phone";
      }
      if (/windows/i.test(userAgent)) {
        return "Windows";
      }
      if (/macintosh|mac os x/i.test(userAgent)) {
        return "Mac OS";
      }
      if (/android/i.test(userAgent)) {
        return "Android";
      }
      if (/linux/i.test(userAgent)) {
        return "Linux";
      }
      if (/iphone|ipad|ipod/i.test(userAgent)) {
        return "iOS";
      }
      return "Unknown OS";
    },
    isSafari: function isSafari() {
      return getBrowserType() === "safari";
    },
    isChrome: function isChrome() {
      return getBrowserType() === "chrome";
    },
    isOpera: function isOpera() {
      return getBrowserType() === "opera";
    },
    isFireFox: function isFireFox() {
      return getBrowserType() === "firefox";
    },
    isIE: function isIE() {
      return getBrowserType() === "ie";
    },
    getGraphMaxIndex: function getGraphMaxIndex(array) {
      var counter,
        max = -1,
        hasSame = false;
      for (counter = 0; counter < array.length; counter += 1) {
        if (max === -1) {
          if (parseInt(array[counter]) > 0) {
            max = counter;
            hasSame = false;
          }
        } else {
          if (parseInt(array[max]) < parseInt(array[counter])) {
            max = counter;
            hasSame = false;
          } else if (parseInt(array[max]) === parseInt(array[counter])) {
            hasSame = true;
          }
        }
      }
      return hasSame ? -1 : max;
    },
    getGraphMinIndex: function getGraphMinIndex(array) {
      var counter,
        min = -1,
        hasSame = false;
      for (counter = 0; counter < array.length; counter += 1) {
        if (min === -1) {
          if (parseInt(array[counter]) > 0) {
            min = counter;
            hasSame = false;
          }
        } else {
          if (parseInt(array[counter]) > 0) {
            if (parseInt(array[min]) > parseInt(array[counter])) {
              min = counter;
              hasSame = false;
            } else if (parseInt(array[min]) === parseInt(array[counter])) {
              hasSame = true;
            }
          }
        }
      }
      return hasSame ? -1 : min;
    },
    applyTuiChartMaxMinColor: function applyTuiChartMaxMinColor(id, maxColor, minColor, maxIdx, minIdx) {
      var svgRects = document.querySelectorAll("#" + id + " .tui-chart-series-area svg rect");
      var maxRect = svgRects[maxIdx],
        minRect = svgRects[minIdx];
      if (maxRect) {
        maxRect.setAttribute("fill", maxColor);
      }
      if (maxIdx !== minIdx && minRect) {
        minRect.setAttribute("fill", minColor);
      }
    },
    getBrowserVersion: function getBrowserVersion() {
      var userAgent = navigator.userAgent,
        match = userAgent.match(/(opera|chrome|crios|safari|ucbrowser|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [],
        result = {},
        tem;
      try {
        if (/trident/i.test(match[1])) {
          tem = /\brv[ :]+(\d+)/g.exec(userAgent) || [];
          result.name = "Internet Explorer";
        } else if (match[1] === "Chrome") {
          tem = userAgent.match(/\b(OPR|Edge)\/(\d+)/);
          if (tem && tem[1]) {
            result.name = tem[0].indexOf("Edge") === 0 ? "Edge" : "Opera";
          }
        }
        if (!result.name) {
          tem = userAgent.match(/version\/(\d+)/i); // iOS support
          result.name = match[0].replace(/\/.*/, "");
          if (result.name.indexOf("MSIE") === 0) {
            result.name = "Internet Explorer";
          }
          if (userAgent.match("CriOS")) {
            result.name = "Chrome";
          }
        }
        if (tem && tem.length) {
          match[match.length - 1] = tem[tem.length - 1];
        }
        result.version = Number(match[match.length - 1]);
      } catch (e) {
        result.name = "unknown";
        result.version = 0;
      }

      /*  Result
      {name: "Opera", version: 63}
      {name: "Firefox", version: 69}
      {name: "Safari", version: 12}
      {name: "Chrome", version: 77}
      {name: "Internet Explorer", version: 11}
      {name: "Edge", version: 17}
      */
      return result;
    },
    getIsHlsSupport: function getIsHlsSupport() {
      var browser = this.getBrowserVersion();
      var isSupport = true;
      switch (browser.name) {
        case "Internet Explorer":
          isSupport = false;
          break;
        case "Safari":
          if (browser.version < 10) {
            isSupport = false;
          }
          break;
        case "Chrome":
          if (browser.version < 45) {
            isSupport = false;
          }
          break;
        case "Firefox":
          if (browser.version < 42) {
            isSupport = false;
          }
          break;
      }
      return isSupport;
    },
    // 전각(全角)을 반각(半角)으로 변환
    toHalfWidth: function toHalfWidth(str) {
      return str.replace(/[！-～]/g, function (ch) {
        return String.fromCharCode(ch.charCodeAt(0) - 0xfee0);
      }).replace(/　/g, " "); // 전각 스페이스를 반각 스페이스로 변환
    },
    removeSpaces: function removeSpaces(str) {
      return str.replace(/\s+/g, "").replace(/　+/g, "");
    }
  };
}]);
"use strict";

function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
app.component("modalComponent", {
  bindings: {
    modalId: "@",
    isVisible: "<",
    title: "@",
    hasCloseBtn: "<",
    classNames: "<",
    size: "<"
  },
  transclude: true,
  templateUrl: "/app/components/modal/index.html",
  controller: ["$scope", "$document", "$element", "$timeout", function ($scope, $document, $element, $timeout) {
    var _this = this;
    $scope.showModal = false;
    $scope.$watch(function () {
      return _this.isVisible;
    }, function (newVal) {
      _this.size = _this.size || "small";
      $scope.showModal = newVal;
      if (newVal) {
        $document.on("keydown", handleEscapeKey);

        /** 부모 스크롤 제어 */
        $document[0].body.style.overflow = "hidden";
        $timeout(function () {
          var modalElement = $element[0].querySelector(".modal-container");
          if (modalElement) {
            if (_this.size === "small" || _this.size === "medium") {
              modalElement.classList.add(_this.size);
            }
            if (_this.classNames) {
              var _modalElement$classLi;
              (_modalElement$classLi = modalElement.classList).add.apply(_modalElement$classLi, _toConsumableArray(_this.classNames.split(" ")));
            }
          }
        }, 0);
      } else {
        $document[0].body.style.overflow = "auto";
        $document.off("keydown", handleEscapeKey);
      }
    });
    var handleEscapeKey = function handleEscapeKey(event) {
      if (event.key === "Escape" || event.keyCode === 27) {
        $scope.$apply(function () {
          $scope.closeModal();
        });
      }
    };
    $scope.closeModal = function () {
      $scope.showModal = false;
      if ($scope.$parent.closeModal) {
        $scope.$parent.closeModal($scope.$ctrl.modalId);
      }
    };
  }]
});
"use strict";

app.controller("FindPasswordCtrl", ["$scope", "Acount", "$stateParams", "$translate", "Utils", "$state", function ($scope, Acount, $stateParams, $translate, Utils, $state) {
  document.querySelectorAll(".cont_min").forEach(function (element) {
    element.style.minHeight = "550px";
  });
  $scope.findPWInfo = {
    emailId: "",
    password: "",
    pwComf: ""
  };
  $scope.findPwErr1 = false;
  var uagentLow = navigator.userAgent.toLocaleLowerCase();
  $scope.isMobile = uagentLow.search("android") > -1 || uagentLow.search("iphone") > -1;
  if ($stateParams.authKey && $stateParams.email) {
    $scope.findPWStop1 = false;
    $scope.findPWStop2 = true;
    $scope.findPWInfo.emailId = $stateParams.email;
    document.getElementById("pw").focus();
  } else {
    $scope.findPWStop1 = true;
    $scope.findPWStop2 = false;
    document.getElementById("id").focus();
  }
  $scope.removeEmailId = function () {
    $scope.findPWInfo.emailId = "";
  };
  $scope.removePassword = function () {
    $scope.findPWInfo.password = "";
  };
  $scope.removePwComf = function () {
    $scope.findPWInfo.pwComf = "";
  };
  var showAlert = function showAlert(title, message) {
    $scope.showAlert = true;
    $scope.alertTitle = title;
    $scope.alertMessage = message;
  };
  $scope.hideAlert = function () {
    $scope.showAlert = false;
  };
  $scope.closeForm = function () {
    $scope.isShowFindPWSendMail = false;
    if ($scope.isMobile) {
      location.href = "/#/login?lang=ja_JP";
    } else {
      location.href = "/";
    }
  };
  $scope.initSendEamil = function () {
    $scope.findPwErr1 = false;
    $scope.findPwErr2 = false;
    if ($scope.findPWInfo.emailId == "") {
      showAlert($translate.instant("LOGIN_FIND_PW"), $translate.instant("LOGIN_FIND_PW_EMAIL_INPUT"));
      return;
    }
    Acount.checkEmail({
      email: Utils.strCheck($scope.findPWInfo.emailId)
    }, function (data) {
      if (data.code == "ok") {
        $scope.sendEamil();
      } else {
        $scope.findPwErr1 = true;
        return;
      }
    });
  };
  $scope.sendEamil = function () {
    $scope.isLoadingComplete = true;
    Acount.searchPassword({
      email: Utils.strCheck($scope.findPWInfo.emailId)
    }, function (data) {
      if (data.code == "ok") {
        $scope.isLoadingComplete = false;
        $scope.isShowFindPWSendMail = true;
      } else {
        $scope.isLoadingComplete = false;
        $scope.findPwErr2 = true;
        return;
      }
    });
  };
  $scope.changePassword = function () {
    $scope.changPwErr1 = false;
    $scope.changPwErr2 = false;
    var checkNumber = $scope.findPWInfo.password.search(/[0-9]/g);
    var checkEnglish = $scope.findPWInfo.password.search(/[a-z]/gi);
    var checkflag = false;
    if (checkNumber < 0 || checkEnglish < 0) {
      checkflag = true;
    }

    // ! 영문,숫자,특수문자 8 ~ 15
    if (!/^(?=(?:[^a-z]*[a-z]))(?=(?:[^0-9]*[0-9]))(?=.*[!-\/:-@\[-`{-~]).{8,15}$/i.test($scope.findPWInfo.password) || checkflag) {
      $scope.changPwErr1 = true;
      return false;
    }
    if ($scope.findPWInfo.password != $scope.findPWInfo.pwComf) {
      $scope.changPwErr2 = true;
      return;
    }
    var param = {
      email: Utils.strCheck($scope.findPWInfo.emailId),
      authKey: Utils.strCheck($stateParams.authKey),
      password: Utils.strCheck($scope.findPWInfo.password)
    };
    $scope.isLoadingComplete = true;
    Acount.emailAuthPassword(param, function (data) {
      if (data.code == "ok") {
        $scope.isShowChangePwComplate = true;
      } else {
        if (data.errorCode == 1) {
          showAlert($translate.instant("LOGIN_FIND_PW"), $translate.instant("LOGIN_FIND_PW_SERVER_ERR1"));
        } else if (data.errorCode == 2) {
          showAlert($translate.instant("LOGIN_FIND_PW"), $translate.instant("LOGIN_FIND_PW_SERVER_ERR2"));
        } else if (data.errorCode == 3) {
          showAlert($translate.instant("LOGIN_FIND_PW"), $translate.instant("LOGIN_FIND_PW_SERVER_ERR5"));
        } else if (data.errorCode == 4) {
          showAlert($translate.instant("LOGIN_FIND_PW"), $translate.instant("LOGIN_FIND_PW_SERVER_ERR4"));
        } else {
          showAlert($translate.instant("LOGIN_FIND_PW"), $translate.instant("LOGIN_FIND_PW_SERVER_ERR99"));
        }
      }
      $scope.isLoadingComplete = false;
    });
  };
  $scope.moveMainPage = function () {
    Acount.login({
      email: Utils.strCheck($scope.findPWInfo.emailId),
      password: Utils.strCheck($scope.findPWInfo.password)
    }, function (data) {
      if (data.code == "ok") {
        if ($scope.isMobile) {
          location.href = "callapp://mailtoapp?logintoken=" + Utils.getCookie("toastcam");
        } else {
          location.href = "https://" + location.hostname;
        }
      } else {
        if ($scope.isMobile) {
          location.href = "callapp://mailtoapp?logintoken=";
        } else {
          location.href = "https://" + location.hostname;
        }
      }
    });
  };
}]);
"use strict";

app.controller("InstallLoginCtrl", ["$rootScope", "$scope", "$http", "$state", "$translate", "User", "Utils", function ($rootScope, $scope, $http, $state, $translate, User, Utils) {
  $scope.phone = "", $scope.password = "";
  if ($rootScope.userId != undefined) {
    $scope.phone = Utils.toFormattedPhoneNumber($rootScope.userId);
  }
  var showAlert = function showAlert(title, message) {
    $scope.showAlert = true;
    $scope.alertTitle = title;
    $scope.alertMessage = message;
  };
  $scope.hideAlert = function () {
    $scope.showAlert = false;
  };
  $scope.login = function () {
    if (event.preventDefault) {
      event.preventDefault();
    } else {
      event.returnValue = false;
    }
    if ($scope.phone === "" || $scope.password === "") {
      showAlert($translate.instant("LOGIN_ERROR_TITLE_INPUT"), $translate.instant("LOGIN_ERROR_MESSAGE_INPUT"));
      return;
    }
    var rawNumber = $scope.phone.replace(/-/g, "");
    var stay = $scope.stay ? "on" : "off";
    var params = {
      userId: rawNumber,
      password: $scope.password,
      stay: stay,
      deviceType: "web"
    };
    $http.post("/json/v2/login", params).success(function (data, status, headers, config) {
      if (data.code === "ok") {
        $rootScope.isLogin = true;
        User.me(function (data) {
          $rootScope.me = data;
        });
        $state.go("main.cameras");
      } else {
        showAlert($translate.instant("LOGIN_ERROR_TITLE"), $translate.instant("LOGIN_ERROR_MSG"));
      }
    });
  };
  /*
  $scope.loginWithFacebook = function () {
  if (event.preventDefault) {
  event.preventDefault();
  } else {
  event.returnValue = false;
  }
  Facebook.login(function(res) {
  var token = res.authResponse.accessToken;
  $http.post('/json/v2/fbLogin', { fbToken: token, deviceType: 'web' })
  .success(function (data, status, headers, config) {
  	if (data.code === 'ok') {
  		$rootScope.isLogin = true;
  		User.me(function (data) {
  			$rootScope.me = data;
  		});
  		$state.go('cameras');
  	}
  });
  });
  }*/

  $scope.loginWithPayco = function () {
    showLogoAlert($translate.instant("ACCOUNT_PAYCO_LOGIN"), $translate.instant("ACCOUNT_PREPARING"));
  };
  var showLogoAlert = function showLogoAlert(title, message) {
    $scope.showLogoAlert = true;
    $scope.logoAlertTitle = title;
    $scope.logoAlertMessage = message;
  };
  $scope.changedPhoneNumber = function () {
    $scope.phone = Utils.toFormattedPhoneNumber($scope.phone);
  };
  $scope.goEmailLogin = function () {
    $state.go("loginWithEmail");
  };
}]);
app.controller("InstallLoginWithEmailCtrl", ["$rootScope", "$scope", "$http", "$state", /*'Facebook',*/"User", "$translate", function ($rootScope, $scope, $http, $state, /*Facebook,*/User, $translate) {
  $scope.email = "", $scope.password = "";
  if ($rootScope.userId != undefined) {
    $scope.email = $rootScope.userId;
  }
  var showAlert = function showAlert(title, message) {
    $scope.showAlert = true;
    $scope.alertTitle = title;
    $scope.alertMessage = message;
  };
  $scope.hideAlert = function () {
    $scope.showAlert = false;
  };
  $scope.login = function () {
    if ($scope.email === "" || $scope.password === "") {
      showAlert($translate.instant("LOGIN_ERROR_TITLE_INPUT"), $translate.instant("LOGIN_ERROR_MESSAGE_INPUT_EMAIL"));
      if (event.preventDefault) {
        event.preventDefault();
      } else {
        event.returnValue = false;
      }
      return;
    }
    var stay = $scope.stay ? "on" : "off";
    var params = {
      userId: $scope.email,
      password: $scope.password,
      stay: stay,
      deviceType: "web"
    };
    $http.post("/json/login", params).success(function (data, status, headers, config) {
      if (data.code === "ok") {
        $rootScope.isLogin = true;
        User.me(function (data) {
          $rootScope.me = data;
        });
        $state.go("main.cameras");
      } else {
        showAlert($translate.instant("LOGIN_ERROR_TITLE"), $translate.instant("LOGIN_ERROR_MSG"));
      }
    });
  };
  /*
  $scope.loginWithFacebook = function () {
  if (event.preventDefault) {
  event.preventDefault();
  } else {
  event.returnValue = false;
  }
  Facebook.login(function(res) {
  var token = res.authResponse.accessToken;
  $http.post('/json/v2/fbLogin', { fbToken: token, deviceType: 'web' })
  .success(function (data, status, headers, config) {
  	if (data.code === 'ok') {
  		$rootScope.isLogin = true;
  		User.me(function (data) {
  			$rootScope.me = data;
  		});
  		$state.go('cameras');
  	}
  });
  });
  }*/

  $scope.loginWithPayco = function () {
    showLogoAlert($translate.instant("ACCOUNT_PAYCO_LOGIN"), $translate.instant("ACCOUNT_PREPARING"));
  };
  var showLogoAlert = function showLogoAlert(title, message) {
    $scope.showLogoAlert = true;
    $scope.logoAlertTitle = title;
    $scope.logoAlertMessage = message;
  };
  $scope.goPhoneLogin = function () {
    $state.go("login");
  };
}]);
"use strict";

app.controller("LoginCtrl", ["$rootScope", "$scope", "$http", "$state", "$translate", "User", "$stateParams", "Utils", function ($rootScope, $scope, $http, $state, $translate, User, $stateParams, Utils) {
  $scope.templates = [{
    name: "top.html",
    url: "/templates/common/_top.html"
  }, {
    name: "left.html",
    url: "/templates/login/_write_left_menu.html"
  }, {
    name: "bottom.html",
    url: "/templates/common/_bottom.html"
  }];
  function showLoginPopup() {
    var $login = document.querySelector("#toastUtil .menu_lst .signup a");
    if ($login.length > 0) {
      $login.trigger("click");
    } else {
      $scope.loginWithPayco();
    }
  }
  setTimeout(function () {
    if ($scope.isLogin == true) {
      if (location.hash.indexOf("installKey") != -1) {
        showLoginPopup();
        $state.go("main");
      } else {
        $scope.loginWithPayco();
        User.logout(function (data) {
          logoutSuccess();
        });
      }
    } else {
      Utils.isSafar() ? document.body.scrollTop = 0 : document.documentElement.scrollTop = 0;
      document.getElementById("left_menu").innerHTML = "";
      showLoginPopup();
      $state.go("main");
    }
  }, 200);
  $scope.clickedTopMenu = function () {
    $scope.isTopMenuLayer = !$scope.isTopMenuLayer;
    menuOpen($scope.isTopMenuLayer);
  };
  $scope.clickedUserMenu = function () {
    $scope.isUserMenuLayer = !$scope.isUserMenuLayer;
    openUserMenu($scope.isUserMenuLayer);
  };
  document.getElementById("wrap").addEventListener("click", function (e) {
    $scope.isUserMenuLayer = false;
    document.getElementById("topUserMenu").classList.remove("clicked");
  });
  $scope.phone = "", $scope.password = "";
  if ($rootScope.userId != undefined) {
    $scope.phone = Utils.toFormattedPhoneNumber($rootScope.userId);
  }
  var showAlert = function showAlert(title, message) {
    $scope.showAlert = true;
    $scope.alertTitle = title;
    $scope.alertMessage = message;
  };
  $scope.hideAlert = function () {
    $scope.showAlert = false;
  };

  //사용 안함
  $scope.join = function () {
    location.href = paycoUrl + "join.nhn?serviceProviderCode=BIZCAM&svcType=APP&migrationCode=&smsAuthInfoYn=&client_id=ALP6knIYb56iRwFExYWr&nextURL=&response_type=code&redirect_uri=https%3A%2F%2Fdev.toastcam.com%2Foauth2.0%2FappCallback%3Fnext_uri%3Dhttps%3A%2F%2Fdev.toastcam.com%2Flproc%2F%3FdeviceType%3Dweb";
  };

  //사용 안함
  $scope.login = function () {
    if (event.preventDefault) {
      event.preventDefault();
    } else {
      event.returnValue = false;
    }
    $scope.phone = Utils.strCheck(document.getElementById("phone").value.split("-").join(""));
    $scope.password = Utils.strCheck(document.getElementById("password").value);
    if ($scope.phone === "" || $scope.password === "") {
      showAlert($translate.instant("LOGIN_ERROR_TITLE"), $translate.instant("LOGIN_ERROR_MESSAGE_INPUT"));
      return;
    }
    var rawNumber = $scope.phone.replace(/-/g, "");
    var stay = document.getElementById("save").value ? "on" : "off";
    var params = {
      userId: Utils.strCheck(rawNumber),
      password: Utils.strCheck($scope.password),
      stay: stay,
      deviceType: "web"
    };
    $http.post("/json/v2/login", params).success(function (data, status, headers, config) {
      if (data.code === "ok") {
        $scope.changedPhoneNumber();
        Utils.setCookie("user_id_save", document.getElementById("phone").value);
        User.me(function (data) {
          $rootScope.isLogin = true;
          $rootScope.me = data;
          if ($stateParams.installKey !== undefined && /[^\s]+/.test($stateParams.installKey)) {
            // 설치
            $state.go("installLogin", {
              installKey: $stateParams.installKey
            });
            return;
          }
          var params = Utils.getParameters("url");
          if (params == undefined) {
            $state.go("main.cameras");
          } else if (params == "inquiry") {
            $state.go("main.help.inquiry");
          } else if (params == "qna") {
            $state.go("main.help.qna");
          }
        });
      } else {
        showAlert($translate.instant("LOGIN_ERROR_TITLE"), $translate.instant("LOGIN_ERROR_MSG"));
      }
    });
  };
  $scope.loginWithPayco = function () {
    loginWithPayco();
  };
  $scope.changedPhoneNumber = function () {
    var phoneElement = document.getElementById("phone");
    var cursor = phoneElement.selectionStart;
    $scope.phone = phoneElement.value();
    phoneElement.value = Utils.phoneNumberReturn($scope.phone);
    if (phoneElement.value.length >= 11) {
      phoneElement.value = Utils.toFormattedPhoneNumber($scope.phone);
      cursor = cursor + 2;
    }
    phoneElement.setSelectionRange(cursor, cursor);
  };
}]);

//TODO: controller 이름 변경
app.controller("LoginSelectCtrl", ["Utils", "$document", "$state", "$scope", "ENV_VARS", "$window", "$rootScope", "$stateParams", "Acount", function (Utils, $document, $state, $scope, ENV_VARS, $window, $rootScope, $stateParams, Acount) {
  $document.title = "로그인";
  $scope.loginFailFlag = false;
  $scope.emailFail = false;
  $scope.passwordFail = false;
  $scope.isLoadingComplete = false;
  $scope.user = {
    emailId: Utils.getCookie("saveCheck") === "true" ? Utils.getCookie("userId") || "" : "",
    userPw: "",
    saveId: Utils.getCookie("saveCheck") === "true"
  };
  $scope.handleLoginFooterLink = function (type) {
    if (type === "company") {
      window.location.href = ENV_VARS.toastcamCompanyUrl;
      return;
    }
    if (type === "home") {
      window.location.href = ENV_VARS.toastcamHomeUrl;
      return;
    }
    if (type === "icame") {
      window.location.href = ENV_VARS.icameCompanyUrl;
      return;
    }
    if (type === "parking") {
      window.location.href = ENV_VARS.parkingUrl;
      return;
    }
  };
  var showAlert = function showAlert(title, message) {
    $scope.showAlert = true;
    $scope.alertTitle = title;
    $scope.alertMessage = message;
  };
  $scope.hideAlert = function () {
    $scope.showAlert = false;
  };
  $scope.login = function (event) {
    event && event.preventDefault();
    if ($scope.user.emailId == "") {
      var _document$getElementB;
      $scope.emailFail = true;
      (_document$getElementB = document.getElementById("email")) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.focus();
      return;
    }
    if ($scope.user.userPw == "") {
      var _document$getElementB2;
      $scope.passwordFail = true;
      (_document$getElementB2 = document.getElementById("pw")) === null || _document$getElementB2 === void 0 ? void 0 : _document$getElementB2.focus();
      return;
    }
    Utils.setCookie("saveCheck", $scope.user.saveId);
    if ($scope.user.saveId) {
      Utils.setCookie("userId", $scope.user.emailId);
    } else {
      Utils.setCookie("userId", "", -1);
    }
    $scope.isLoadingComplete = true;
    Acount.login({
      email: $scope.user.emailId,
      password: Utils.removeSpaces(Utils.toHalfWidth($scope.user.userPw))
    }, handleLoginResponse);
  };
  $scope.handleBlurInput = function (type) {
    if (type === "email") {
      $scope.emailFail = false;
    } else {
      $scope.passwordFail = false;
    }
  };
  function handleLoginResponse(data) {
    $scope.isLoadingComplete = false;
    if (data.code === "ok") {
      $rootScope.isLogin = true;
      handleLoginSuccess();
    } else {
      handleLoginFailure(data.errorCode);
    }
  }
  function handleLoginSuccess() {
    var userAgent = navigator.userAgent.toLowerCase();
    var isMobile = !!window.TCB2BInterface;
    $scope.emailFail = false;
    $scope.passwordFail = false;
    if (isMobile || userAgent.includes("android") || userAgent.includes("iphone")) {
      handleMobileLogin();
    } else {
      handleDesktopLogin();
    }
  }
  $scope.linkToSignUp = function () {
    $state.go("signup");
  };
  function handleMobileLogin() {
    if (window.TCB2BInterface) {
      window.TCB2BInterface.functionLogin(Utils.getCookie("toastcam"));
    }
  }
  function handleDesktopLogin() {
    location.href = "/#/index";
  }
  function handleLoginFailure(errorCode) {
    $scope.loginFailFlag = true;
    if (errorCode !== "1" && errorCode !== "2") {
      showAlert($translate.instant("LOGIN_FAIL"), $translate.instant("LOGIN_FAIL_ERR"));
    }
  }
  if ($scope.user.emailId == "") {
    var _document$getElementB3;
    (_document$getElementB3 = document.getElementById("id")) === null || _document$getElementB3 === void 0 ? void 0 : _document$getElementB3.focus();
  } else {
    var _document$getElementB4;
    (_document$getElementB4 = document.getElementById("pw")) === null || _document$getElementB4 === void 0 ? void 0 : _document$getElementB4.focus();
  }
  $scope.removePassword = function () {
    $scope.user.userPw = "";
  };
  $scope.removeEmailId = function () {
    $scope.user.emailId = "";
  };
  $scope.goPaycoLogin = function () {
    var BASE_URL = $rootScope.isLocal ? ENV_VARS.baseUrl : "".concat($window.location.protocol, "//").concat($window.location.host);
    var paycoNextUrl = encodeURIComponent("".concat(BASE_URL, "/lproc?deviceType=web&state=1"));
    var paycoServiceCallbackUrl = encodeURIComponent("".concat(BASE_URL, "/json/biz/payco/logIn?next_uri=").concat(paycoNextUrl));
    var paycoRedirectUrl = "".concat(BASE_URL, "/payco/authorize?client_id=").concat(ENV_VARS.paycoClientId, "&serviceCallbackUrl=").concat(paycoServiceCallbackUrl);
    var paycoLoginUrl = new URLSearchParams({
      response_type: "code",
      client_id: ENV_VARS.paycoClientId,
      serviceProviderCode: "BIZCAM",
      userLocale: "ko_KR",
      redirect_uri: paycoRedirectUrl
    });
    window.open("".concat(ENV_VARS.paycoBaseUrl, "/oauth2.0/authorize?").concat(paycoLoginUrl.toString()), "payco 로그인", "width=600,height=400");
  };
}]);

//사용 안함
app.controller("LoginWithEmailCtrl", ["$rootScope", "$scope", "$http", "$state", "User", "$translate", "$stateParams", function ($rootScope, $scope, $http, $state, User, $translate, $stateParams) {
  $scope.templates = [{
    name: "top.html",
    url: "common/_top.html"
  }, {
    name: "left.html",
    url: "login/_loginWithEmail_left_menu.html"
  }, {
    name: "bottom.html",
    url: "common/_bottom.html"
  }];
  $scope.clickedTopMenu = function () {
    $scope.isTopMenuLayer = !$scope.isTopMenuLayer;
    menuOpen($scope.isTopMenuLayer);
  };
  $scope.clickedUserMenu = function () {
    $scope.isUserMenuLayer = !$scope.isUserMenuLayer;
    openUserMenu($scope.isUserMenuLayer);
  };
  setTimeout(function () {
    var userid = Utils.getCookie("user_email_save");
    if (userid != "" || userid.length > 0) {
      document.getElementById("email").value = userid;
    }
  }, 200);
  document.getElementById("wrap").addEventListener("click", function (e) {
    $scope.isUserMenuLayer = false;
    document.getElementById("topUserMenu").classList.remove("clicked");
  });
  $scope.email = "", $scope.password = "";
  if ($rootScope.userId != undefined) {
    $scope.email = $rootScope.userId;
  }
  var showAlert = function showAlert(title, message) {
    $scope.showAlert = true;
    $scope.alertTitle = title;
    $scope.alertMessage = message;
  };
  $scope.hideAlert = function () {
    $scope.showAlert = false;
  };
  $scope.login = function () {
    $scope.email = Utils.strCheck(document.getElementById("email").value);
    $scope.password = Utils.strCheck(document.getElementById("password").value);
    if ($scope.email === "" || $scope.password === "") {
      showAlert($translate.instant("LOGIN_ERROR_TITLE_INPUT"), $translate.instant("LOGIN_ERROR_MESSAGE_INPUT_EMAIL"));
      if (event.preventDefault) {
        event.preventDefault();
      } else {
        event.returnValue = false;
      }
      return;
    }
    var stay = document.getElementById("save").value ? "on" : "off";
    var params = {
      userId: Utils.strCheck($scope.email),
      password: Utils.strCheck($scope.password),
      stay: stay,
      deviceType: "web"
    };
    $http.post("/json/login", params).success(function (data, status, headers, config) {
      if (data.code === "ok") {
        Utils.setCookie("user_email_save", document.getElementById("email").value);
        User.me(function (data) {
          $rootScope.isLogin = true;
          $rootScope.me = data;
          if ($stateParams.installKey !== undefined && /[^\s]+/.test($stateParams.installKey)) {
            // 설치
            $state.go("installLogin", {
              installKey: $stateParams.installKey
            });
            return;
          }
          $state.go("main.cameras");
        });
      } else {
        showAlert($translate.instant("LOGIN_ERROR_TITLE"), $translate.instant("LOGIN_ERROR_MSG"));
      }
    });
  };
  $scope.goPhoneLogin = function () {
    var params = Utils.getParameters("url");
    if (params == undefined) {
      $state.go("login", {
        installKey: $stateParams.installKey
      });
    } else if (params == "inquiry") {
      location.href = "/#/login?url=" + params;
    } else if (params == "qna") {
      location.href = "/#/login?url=" + params;
    }
  };
  Utils.setCookie = function (cName, cValue) {
    var expire = new Date();
    expire.setDate(expire.getDate() + 7);
    cookies = cName + "=" + escape(cValue) + "; path=/ "; //쿠키 저장
    if (typeof cDay != "undefined") cookies += ";expires=" + expire.toGMTString() + ";";
    document.cookie = cookies;
  };
}]);
"use strict";

app.controller("MyInfoCtrl", ["$rootScope", "$scope", "Acount", "$translate", "Utils", function ($rootScope, $scope, Acount, $translate, Utils) {
  document.querySelectorAll(".cont_min").forEach(function (element) {
    element.style.minHeight = "550px";
  });
  $scope.myInfo = {
    emailId: "",
    password: "",
    oldPassword: "",
    newPassword: "",
    pwComf: ""
  };
  $scope.myInfoIdCheck = true;
  $scope.showMyInfoMenu = false;
  document.getElementById("checkId").focus();
  $scope.removePassword = function () {
    $scope.myInfo.password = "";
    document.getElementById("checkId").focus();
  };
  $scope.removeOldPassword = function () {
    $scope.myInfo.oldPassword = "";
    document.getElementById("oldPw").focus();
  };
  $scope.removeNewPassword = function () {
    $scope.myInfo.newPassword = "";
    document.getElementById("newPw").focus();
  };
  $scope.removePwComf = function () {
    $scope.myInfo.pwComf = "";
    document.getElementById("pwc").focus();
  };
  var showAlert = function showAlert(title, message) {
    $scope.showAlert = true;
    $scope.alertTitle = title;
    $scope.alertMessage = message;
  };
  $scope.hideAlert = function () {
    $scope.showAlert = false;
  };
  $scope.closeForm = function () {
    window.close();
  };
  $scope.checkUserPw = function () {
    $scope.myInfoErr1 = false;
    if ($scope.myInfo.password == "") {
      showAlert($translate.instant("MY_INFO"), $translate.instant("LOGIN_CHANGE_PW_INPUT"));
      return;
    }
    $scope.myInfo.password = Utils.removeSpaces(Utils.toHalfWidth($scope.myInfo.password));
    $scope.isLoadingComplete = true;
    Acount.checkPassword({
      password: $scope.myInfo.password
    }, function (data) {
      if (data.code == "ok") {
        $scope.myInfo.emailId = $rootScope.me.email;
        $scope.myInfo.password = "";
        $scope.myInfoIdCheck = false;
        $scope.showMyInfoMenu = true;
      } else {
        $scope.myInfoErr1 = true;
      }
      $scope.isLoadingComplete = false;
    });
  };
  $scope.moveChangePassword = function () {
    $scope.showMyInfoMenu = false;
    $scope.showChangePassword = true;
    $scope.myInfo.oldPassword = "";
    $scope.myInfo.newPassword = "";
    $scope.myInfo.pwComf = "";
    document.getElementById("oldPw").focus();
  };
  $scope.initChangePassword = function () {
    $scope.isLoadingComplete = true;
    $scope.changPwErr0 = false;
    $scope.changPwErr1 = false;
    $scope.changPwErr2 = false;
    $scope.myInfo.oldPassword = Utils.removeSpaces(Utils.toHalfWidth($scope.myInfo.oldPassword));
    Acount.checkPassword({
      password: $scope.myInfo.oldPassword
    }, function (data) {
      if (data.code == "ok") {
        $scope.changePassword();
      } else {
        $scope.changPwErr0 = true;
      }
      $scope.isLoadingComplete = false;
    });
  };
  $scope.changePassword = function () {
    $scope.myInfo.newPassword = Utils.removeSpaces(Utils.toHalfWidth($scope.myInfo.newPassword));
    var checkNumber = $scope.myInfo.newPassword.search(/[0-9]/g);
    var checkEnglish = $scope.myInfo.newPassword.search(/[a-z]/gi);
    var checkflag = false;
    $scope.myInfo.pwComf = Utils.removeSpaces(Utils.toHalfWidth($scope.myInfo.pwComf));
    if (checkNumber < 0 || checkEnglish < 0) {
      checkflag = true;
    }

    // ! 영문,숫자,특수문자 8 ~ 15
    if (!/^(?=(?:[^a-z]*[a-z]))(?=(?:[^0-9]*[0-9]))(?=.*[!-\/:-@\[-`{-~]).{8,15}$/i.test($scope.myInfo.newPassword) || checkflag) {
      $scope.changPwErr1 = true;
      return false;
    }
    if ($scope.myInfo.newPassword != $scope.myInfo.pwComf) {
      $scope.changPwErr2 = true;
      return;
    }
    var param = {
      password: $scope.myInfo.oldPassword,
      newPassword: $scope.myInfo.newPassword
    };
    $scope.isLoadingComplete = true;
    Acount.updatePassword(param, function (data) {
      if (data.code == "ok") {
        $scope.isShowChangePwComplate = true;
      } else {
        if (data.errorCode == 1) {
          showAlert($translate.instant("LOGIN_CHANGE_PW"), $translate.instant("LOGIN_CHANGE_PW_SERVER_ERR1"));
        } else if (data.errorCode == 2) {
          showAlert($translate.instant("LOGIN_CHANGE_PW"), $translate.instant("LOGIN_CHANGE_PW_SERVER_ERR2"));
        } else {
          showAlert($translate.instant("LOGIN_CHANGE_PW"), $translate.instant("LOGIN_CHANGE_PW_SERVER_ERR99"));
        }
      }
      $scope.isLoadingComplete = false;
    });
  };
  $scope.moveMainPage = function () {
    $scope.isShowChangePwComplate = false;
    $scope.showMyInfoMenu = true;
    $scope.showChangePassword = false;
    $scope.myInfo.oldPassword = "";
    $scope.myInfo.newPassword = "";
    $scope.myInfo.pwComf = "";
  };
}]);
"use strict";

app.controller("SettingAccessCtrl", ["$scope", "$translate", "Access", "$location", "$state", function ($scope, $translate, Access, $location, $state) {
  $scope.isUseGeofence = appConfig.useGeofence;
  $scope.currentTab = "staff";
  $scope.protocol = $location.protocol() + "://"; // thumbnail location protocol

  var showAlert = function showAlert(title, message) {
    document.querySelectorAll(".display_show").forEach(function (element) {
      element.style.display = "";
    });
    void 0;
    $scope.showAlert = true;
    $scope.alertTitle = title;
    $scope.alertMessage = message;
  };
  (function () {
    getAccessList();
  })();

  /**
   * 매장 목록 및 매장별 내가 등록한 직원 목록
   */
  function getAccessList() {
    Access.get(function (res) {
      if (res.code === "ok") {
        $scope.shopList = res.list;
        $scope.accessShopList = res.list;
        $scope.currentShopId = "total";
      } else {
        showAlert($translate.instant("ACCOUNT_STORE_LIST"), $translate.instant("ACCOUNT_GET_STORE_LIST_FAIL"));
      }
    }, function (err) {
      showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
    });
  }

  /**
   * 나를 등록한 매장 목록
   */
  function getTargetList() {
    Access.getAccessTargets(function (data) {
      if (data.code === "ok") {
        $scope.targetList = data.list;
      } else {
        showAlert($translate.instant("FAIL"), $translate.instant("ACCESS_SET_FAIL"));
      }
    }, function (err) {
      showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
    });
  }

  /**
   * 탭 변경 staff <-> shop
   * @return {String} tabName 'staff' or 'shop'
   */
  $scope.changeTab = function (tabName) {
    if (tabName === $scope.currentTab) return;
    $scope.currentTab = tabName;
    if (tabName === "staff") {
      getAccessList();
    } else {
      getTargetList();
    }
  };
  var deleteStaffObj = {};
  /**
   * 출입 등록 직원 해제 확인 팝업 open
   * @param  {Object} staff
   */
  $scope.showAccessStaffDeleteConfirm = function (shop, staff) {
    deleteStaffObj = staff;
    deleteStaffObj["shopId"] = shop.shopId;
    $scope.isShowAccessStaffDeleteConfirm = true;
  };

  /**
   * 출입 등록 직원 해제 확인 팝업 close
   */
  $scope.hideAccessStaffDeleteConfirm = function () {
    $scope.isShowAccessStaffDeleteConfirm = false;
  };

  /**
   * 출입 직원 등록 삭제
   */
  $scope.deleteAccessStaff = function () {
    var params = {
      shopId: deleteStaffObj.shopId,
      paycoId: deleteStaffObj.paycoAccount,
      userId: deleteStaffObj.staffId
    };
    Access.deleteAccessStaff(params, function (res) {
      if (res.code === "ok") {
        $scope.hideAccessStaffDeleteConfirm();
        if ($scope.currentShopId == "total") {
          getAccessList();
        } else {
          $scope.getShop($scope.currentShopId);
        }
      } else {
        showAlert($translate.instant("ACCOUNT_STORE_ALARM_CLEAR"), $translate.instant("ACCOUNT_STORE_ALARM_CLEAR_FAIL"));
      }
    }, function (err) {
      showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
    });
  };
  var deleteTargetObj = {};
  /**
   * 나를 등록한 매장 해제 확인 팝업 open
   * @param  {Object} target
   */
  $scope.showTargetDeleteConfirm = function (target) {
    deleteTargetObj = target;
    $scope.isShowTargetDeleteConfirm = true;
  };

  /**
   * 나를 등록한 매장 해제 확인 팝업 close
   */
  $scope.hideTargetDeleteConfirm = function () {
    $scope.isShowTargetDeleteConfirm = false;
  };

  /**
   * 나를 등록한 매장에서 해제 처리
   */
  $scope.deleteTarget = function () {
    var params = {
      shopId: deleteTargetObj.shopId,
      userId: deleteTargetObj.userId
    };
    Access.deleteAccessTarget(params, function (data) {
      if (data.code === "ok") {
        $scope.hideTargetDeleteConfirm();
        getTargetList();
      } else {
        showAlert($translate.instant("ACCOUNT_STORE_ALARM_CLEAR"), $translate.instant("ACCOUNT_STORE_ALARM_CLEAR_FAIL"));
      }
    }, function (err) {
      showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
    });
  };

  /**
   * 내가 등록한 직원 탭의 매장 클릭시 해당 매장 상세
   * @param  {String} shopId
   */
  $scope.getShop = function (shopId) {
    Access.get(function (res) {
      if (res.code === "ok") {
        $scope.shopList = res.list;
        $scope.accessShopList = [];
        $scope.accessShopList[0] = _.find(res.list, {
          shopId: shopId
        });
        // $scope.shop = res;
        $scope.currentShopId = shopId;
      }
    }, function (err) {
      showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
    });
  };

  /**
   * 내가 등록한 직원 탭의 모든 매장 목록
   */
  $scope.getShopList = function () {
    getAccessList();
  };
  if ($scope.isUseGeofence) {
    $scope.showLocSetRequestPopup = function (isShow, shop, shopStaff) {
      $scope.lbsSetStatus = "nosign";
      if (isShow && shop && shopStaff) {
        $scope.currentShopName = shop.shopName;
        $scope.selecShopId = shop.shopId;
        $scope.currentSource = shopStaff;
        $scope.isShowLocSetRequestPopup = true;
        Access.getShopStaffs({
          shopId: $scope.selecShopId
        }, function (data) {
          var i, len, findSource;
          if (data.code === "ok") {
            if (data.list) {
              len = data.list.length;
              for (i = 0; i < len; i += 1) {
                if (data.list[i].paycoId === $scope.currentSource.paycoAccount) {
                  findSource = data.list[i];
                  if (findSource.userId) {
                    if (findSource.lbsAgreed === "ok") {
                      $scope.lbsSetStatus = "ok";
                    } else {
                      $scope.lbsSetStatus = "notagree";
                    }
                    $scope.currentSource.userId = findSource.userId;
                  } else {
                    $scope.lbsSetStatus = "nosign";
                  }
                  $scope.isShowLocSetRequestPopup = true;
                  return;
                }
              }
            }
          } else {
            $scope.isShowLocSetRequestPopup = false;
            showAlert($translate.instant("FAIL"), $translate.instant("ACCESS_SET_FAIL"));
          }
        }, function (err) {
          $scope.isShowLocSetRequestPopup = false;
          showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
        });
      } else {
        $scope.isShowLocSetRequestPopup = false;
      }
    };
    $scope.sendPush = function () {
      var param;
      if ($scope.currentSource) {
        if ($scope.lbsSetStatus === "bleoff") {
          param = {
            receiver: $scope.currentSource.paycoAccount,
            userId: $scope.currentSource.userId
          };
          Access.requestAccess({
            shopId: $scope.selecShopId
          }, param, function (data) {
            if (data && data.code === "ok") {
              showAlert($translate.instant("SEND_COMPLETE"), $translate.instant("SEND_REQUEST"));
            } else {
              showAlert($translate.instant("FAIL"), $translate.instant("ACCESS_SET_FAIL"));
            }
          }, function (error) {
            showAlert($translate.instant("FAIL"), $translate.instant("ACCESS_SET_FAIL"));
          });
        } else if ($scope.lbsSetStatus === "notagree") {
          param = {
            receiver: $scope.currentSource.paycoAccount,
            userId: $scope.currentSource.userId
          };
          Access.requestSignAgree({
            shopId: $scope.selecShopId
          }, param, function (data) {
            if (data && data.code === "ok") {
              showAlert($translate.instant("SEND_COMPLETE"), $translate.instant("SEND_REQUEST"));
            } else {
              showAlert($translate.instant("FAIL"), $translate.instant("ACCESS_SET_FAIL"));
            }
          }, function (error) {
            showAlert($translate.instant("FAIL"), $translate.instant("ACCESS_SET_FAIL"));
          });
        } else if ($scope.lbsSetStatus === "nosign") {
          param = {
            paycoId: $scope.currentSource.paycoAccount
          };
          Access.requestSignup({
            shopId: $scope.selecShopId
          }, param, function (data) {
            if (data && data.code === "ok") {
              showAlert($translate.instant("SEND_COMPLETE"), $translate.instant("SEND_REQUEST"));
            } else {
              showAlert($translate.instant("FAIL"), $translate.instant("ACCESS_SET_FAIL"));
            }
          }, function (error) {
            showAlert($translate.instant("FAIL"), $translate.instant("ACCESS_SET_FAIL"));
          });
        } else {
          param = {
            receiver: $scope.currentSource.paycoAccount,
            userId: $scope.currentSource.userId
          };
          Access.requestAccess({
            shopId: $scope.selecShopId
          }, param, function (data) {
            if (data && data.code === "ok") {
              showAlert($translate.instant("SEND_COMPLETE"), $translate.instant("SEND_REQUEST"));
            } else {
              showAlert($translate.instant("FAIL"), $translate.instant("ACCESS_SET_FAIL"));
            }
          }, function (error) {
            showAlert($translate.instant("FAIL"), $translate.instant("ACCESS_SET_FAIL"));
          });
        }
      }
    };
    $scope.goAccManagePage = function (shopId) {
      $state.go("main.dashboard.staff", {
        shopId: shopId
      });
    };
  }
}]);
"use strict";

app.controller("SettingAccountCtrl", ["$rootScope", "$scope", "Camera", "$translate", "$state", "User", "$window", "Utils", function ($rootScope, $scope, Camera, $translate, $state, User, $window, Utils) {
  $scope.getContextPath = Utils.getContextPath();
  $scope.getPath = "settings";
  $scope.countryDomain = $rootScope.countryDomain;
  $scope.clickedTopMenu = function () {
    $scope.isTopMenuLayer = !$scope.isTopMenuLayer;
    menuOpen($scope.isTopMenuLayer);
  };
  $scope.clickedUserMenu = function () {
    $scope.isUserMenuLayer = !$scope.isUserMenuLayer;
    openUserMenu($scope.isUserMenuLayer);
  };
  document.getElementById("wrap").addEventListener("click", function (e) {
    $scope.isUserMenuLayer = false;
    document.getElementById("topUserMenu").classList.remove("clicked");
  });
  $scope.logout = function () {
    User.logout(function (data) {
      logoutSuccess();
    });
  };
  $scope.goToInqueryPage = function () {
    $state.go("main.help.inquiry", {
      type: "cam_cancel"
    });
  };
  $scope.showCameraCloudInfo = function (camera) {
    $scope.currentCamera = camera;
    $scope.serviceDay = parseInt($scope.currentCamera.serviceType);
    Camera.saveEndDateInfo({
      cameraId: camera.id
    }, function (data) {
      $scope.saveEndDateText = data.saveEndDateText;
      $scope.isShowCamCloudInfo = true;
    });
  };
  $scope.hideCameraCloudInfo = function () {
    $scope.isShowCamCloudInfo = false;
  };
  $scope.getCameraList = function () {
    Camera.getList(function (data) {
      for (var i = 0; i < data.length; i++) {
        if (location.port != "") {
          data[i].thumbnailPath = location.protocol + "//" + data[i].thumbnailPath.replace(".com/", ".com:" + location.port + "/");
        } else {
          data[i].thumbnailPath = location.protocol + "//" + data[i].thumbnailPath;
        }

        // 클라우드 미사용 여부 확인
        data[i].isExpiredCloud = Utils.isCloudExpired(data[i]);
      }
      $scope.cameras = data;
      $scope.cameraListShow = data.length > 0;
      document.getElementById("camera_manager_list").style.display = "block";
    });
  };
  $scope.getCameraList();
  if ($rootScope.me !== undefined) {
    $scope.me = $rootScope.me;
  } else {
    $rootScope.$watch("me", function (value) {
      $scope.me = value;
    });
  }
  var showAlert = function showAlert(title, message) {
    var elements = document.getElementsByClassName("display_show");
    for (var i = 0; i < elements.length; i++) {
      elements[i].style.display = "";
    }
    $scope.showAlert = true;
    $scope.alertTitle = title;
    $scope.alertMessage = message;
  };
  $scope.hideAlert = function () {
    $scope.showAlert = false;
  };
  var serviceTypes = {};
  $translate(["DAY7", "DAY10", "DAY30", "DAY60", "DAY3"]).then(function (t) {
    serviceTypes = {
      "7d": t.DAY7,
      "10d": t.DAY10,
      "30d": t.DAY30,
      "60d": t.DAY60,
      "3d": t.DAY3,
      "n/a": ""
    };
  });
  var words = {};
  $translate(["CLOUD_STORE", "ACCOUNT_EXPIRED"]).then(function (t) {
    words.CLOUD_STORE = t.CLOUD_STORE;
    words.ACCOUNT_EXPIRED = t.ACCOUNT_EXPIRED;
  });
  $scope.formattedPhoneNumber = function (phone) {
    return Utils.toFormattedPhoneNumber(phone);
  };
  $scope.formattedServiceType = function (serviceType) {
    var formatted = "";
    if (serviceType !== "n/a") {
      formatted = words.CLOUD_STORE + " " + serviceTypes[serviceType];
    }
    return formatted;
  };
  $scope.formattedServiceEndDate = function (time) {
    var momentDate = moment(new Date(parseInt(time)));
    if (parseInt(time) === 0) {
      return words.ACCOUNT_EXPIRED;
    }
    return momentDate.format("YYYY.MM.DD");
  };
  $scope.showPayCloudModal = function (cameraId) {
    $scope.nowPayingCameraId = cameraId;
    // $scope.isShowPayCloud = true;
    $scope.showBuyCloudConfirm = true;
  };
  var popUpOpen = function popUpOpen(url) {
    window.open(url, "popup", "width=650px,height=600px");
  };
  $scope.pay = function () {
    if ($scope.serviceType === undefined) {
      void 0;
      return;
    }
    var url = "";
    var selectedOption = document.querySelector('input[name="option"]:checked');
    if (selectedOption.value == "10d") {
      url = "http://buycam.co.kr/shop/goods/goods_view.php?goodsno=93&category=006";
    } else if (selectedOption.value == "30d") {
      url = "http://buycam.co.kr/shop/goods/goods_view.php?goodsno=94&category=006";
    }
    window.open(url, "_blank");
  };
  $scope.goChangeNumber = function () {
    $state.go("changePhoneNumber");
  };
  var idx = 0;
  $scope.selectedHasSensor = false;
  $scope.clickedRemoveCamera = function (index, hasSensor) {
    idx = index;
    $scope.selectedHasSensor = hasSensor;
    $scope.showRemoveCameraAlert = true;
  };

  // 카메라 제거하기
  $scope.removeCameraConfirm = function () {
    Camera.remove({
      id: idx
    }, function () {
      $scope.hideRemoveCameraAlert();
      idx = "";
      $scope.getCameraList();
    });
  };
  $scope.hideRemoveCameraAlert = function () {
    $scope.showRemoveCameraAlert = false;
  };

  // 토스트 마켓 상품 상세 페이지 이동
  $scope.goMaket = function () {
    $window.location.href = $rootScope.ENV_VARS.marketUrl + "/product/CAM/" + $rootScope.ENV_VARS.marketDealNo + "?itemSerial=" + purchaseCameraId;
  };

  // 구매 확인 레이어 팝업 호출
  var purchaseCameraId;
  $scope.showPurchaseConfirmLayer = function (cameraId) {
    purchaseCameraId = cameraId;
    //$scope.isShowPurchaseConfirmLayer = true;
    if ($scope.countryDomain === "ja") {
      showAlert($translate.instant("CAMERA_BUY_CLOUD"), $translate.instant("ACCOUNT_PREPARING"));
    } else {
      $state.go("main.help.inquiry", {
        type: "cam_buy"
      });
    }
  };

  // 구매 확인 레이어 팝업 닫기
  $scope.hidePurchageConfirmLayer = function () {
    $scope.isShowPurchaseConfirmLayer = false;
  };

  // 서비스 해지 확인 레이어 팝업 호출
  $scope.showRefundConfirmLayer = function () {
    $scope.isShowRefundConfirmLayer = true;
  };

  // 서비스 해지 확인 레이어 팝업 닫기
  $scope.hideRefundConfirmLayer = function () {
    $scope.isShowRefundConfirmLayer = false;
  };

  // 토스트마켓 서비스 해지 페이지 이동
  $scope.goMarketRefund = function () {
    $window.location.href = $rootScope.ENV_VARS.marketUrl + "/usage";
  };
}]);
app.controller("SettingPhoneCtrl", ["$rootScope", "$scope", "$translate", "$state", "$interval", "User", function ($rootScope, $scope, $translate, $state, $interval, User) {
  $scope.templates = [{
    name: "top_menu.html",
    url: "/templates/common/_top.html"
  }, {
    name: "left_menu.html",
    url: "/templates/user/_account_left_menu.html"
  }, {
    name: "camera.html",
    url: "/templates/user/_account_phone_setting.html"
  }, {
    name: "bottom.html",
    url: "/templates/common/_bottom.html"
  }];
  $scope.getContextPath = Utils.getContextPath();
  $scope.getPath = "updateUserInfo";
  $scope.clickedTopMenu = function () {
    $scope.isTopMenuLayer = !$scope.isTopMenuLayer;
    menuOpen($scope.isTopMenuLayer);
  };
  $scope.clickedUserMenu = function () {
    $scope.isUserMenuLayer = !$scope.isUserMenuLayer;
    openUserMenu($scope.isUserMenuLayer);
  };
  document.getElementById("wrap").addEventListener("click", function (e) {
    $scope.isUserMenuLayer = false;
    document.getElementById("topUserMenu").classList.remove("clicked");
  });
  $scope.logout = function () {
    User.logout(function (data) {
      logoutSuccess();
    });
  };
  if ($rootScope.me !== undefined) {
    $scope.me = $rootScope.me;
  } else {
    $rootScope.$watch("me", function (value) {
      $scope.me = value;
    });
  }
  var showAlert = function showAlert(title, message) {
    $scope.showAlert = true;
    $scope.alertTitle = title;
    $scope.alertMessage = message;
  };
  $scope.hideAlert = function () {
    $scope.showAlert = false;
  };
  $scope.pressedRequestButton = function () {
    if (event.preventDefault) {
      event.preventDefault();
    } else {
      event.returnValue = false;
    }
    $scope.phone = document.getElementById("phone").value;
    if ($scope.phone === "") {
      showAlert($translate.instant("FIND_PASSWORD_ERROR_TITLE_MOBILE"), $translate.instant("FIND_PASSWORD_ERROR_MESSAGE_MOBILE"));
      return;
    }
    var rawNumber = $scope.phone.replace(/-/g, "");
    if (rawNumber.indexOf("070") == 0) {
      showAlert($translate.instant("SIGNUP_ERROR_TITLE_MOBILE"), $translate.instant("ACCOUNT_NO_070_NUMBER"));
      return;
    }
    if (!Validate.isValidPhone(document.getElementById("phone").value)) {
      showAlert($translate.instant("SIGNUP_ERROR_TITLE_MOBILE"), $translate.instant("SIGNUP_ERROR_MESSAGE_MOBILE"));
      return;
    }
    var result = User.requestChangePasswordSms({
      phoneNumber: rawNumber
    }, function () {
      $scope.sentSms = true;
      $scope.isValidAuthNumber = false;
      $scope.startTimer();
      showLogoAlert($translate.instant("FIND_PASSWORD_MESSAGE_SENT_AUTH_NUMBER"), result.msg);
    });
  };
  $scope.changedPhoneNumber = function () {
    $scope.phone = document.getElementById("phone").value;
    document.getElementById("phone").value = Utils.toFormattedPhoneNumber($scope.phone);
  };
  var remainSeconds = 180;
  $scope.remainTime = "3:00";
  $scope.startTimer = function () {
    if ($scope.timer === undefined) {
      $scope.timer = $interval(function () {
        var minute = parseInt(remainSeconds / 60);
        var second = remainSeconds - minute * 60;
        if (second < 10) {
          second = "0" + second;
        }
        $scope.remainTime = minute + ":" + second;
        remainSeconds -= 1;
        if (remainSeconds < 0) {
          $scope.stopTimer();
          $scope.phone = "";
          $scope.authNumber = "";
          $scope.sentSms = false;
          showAlert($translate.instant("FIND_PASSWORD_ERROR_TITLE_LIMITED_TIME"), $translate.instant("FIND_PASSWORD_MESSAGE_LIMITED_TIME"));
        }
      }, 1000);
    }
  };
  $scope.stopTimer = function () {
    if ($scope.timer !== undefined) {
      $interval.cancel($scope.timer);
    }
  };
  var showLogoAlert = function showLogoAlert(title, message) {
    $scope.showLogoAlert = true;
    $scope.logoAlertTitle = title;
    $scope.logoAlertMessage = message;
  };
  $scope.velifyAuthNumber = function () {
    if (event.preventDefault) {
      event.preventDefault();
    } else {
      event.returnValue = false;
    }
    var rawNumber = $scope.phone.replace(/-/g, "");
    var authNumElement = document.getElementById("authNum");
    if (authNumElement.value === "") {
      showAlert($translate.instant("SIGNUP_ERROR_TITLE"), $translate.instant("ACCOUNT_AUTH_NUMBER"));
      return;
    }
    $scope.authNumber = authNumElement.value;
    $scope.newPhoneNumber = rawNumber;
    $scope.authResult = User.authWithNewPhoneSmsCode({
      phoneNumber: rawNumber
    }, function (data) {
      if (data.code === "ok") {
        $scope.authNumber = data.authNumber;
        $scope.stopTimer();
        $scope.isValidAuthNumber = true;
        $scope.sentSms = false;
        $scope.changePhoneNum = true;
      } else {
        showAlert($translate.instant("SIGNUP_ERROR_TITLE"), $scope.authResult.msg);
        return;
      }
    });
  };
  $scope.changePhoneNumber = function () {
    $scope.authResult = User.authWithNewPhoneChange({
      phoneNumber: $scope.me.userId,
      newPhoneNumber: $scope.newPhoneNumber,
      authNumber: $scope.authNumber
    }, function (data) {
      if (data.code === "ok") {
        $scope.authNumber = data.authNumber;
        $scope.stopTimer();
        $scope.isValidAuthNumber = true;
        $scope.sentSms = false;
        $scope.changeComplate = true;
      } else {
        showAlert($translate.instant("SIGNUP_ERROR_TITLE"), $scope.authResult.msg);
        return;
      }
    });
  };
  $scope.goCameras = function () {
    $state.go("main.cameras");
  };
  $scope.openUpdateUserInfo();
}]);
app.controller("SettingPasswordCtrl", ["$scope", "$translate", "$state", "User", function ($scope, $translate, $state, User) {
  $scope.templates = [{
    name: "top_menu.html",
    url: "/templates/common/_top.html"
  }, {
    name: "left_menu.html",
    url: "/templates/user/_account_left_menu.html"
  }, {
    name: "camera.html",
    url: "/templates/user/_account_password_setting.html"
  }, {
    name: "bottom.html",
    url: "/templates/common/_bottom.html"
  }];
  $scope.getContextPath = Utils.getContextPath();
  $scope.getPath = "passwordChange";
  $scope.clickedTopMenu = function () {
    $scope.isTopMenuLayer = !$scope.isTopMenuLayer;
    menuOpen($scope.isTopMenuLayer);
  };
  $scope.goCameras = function () {
    $state.go("main.cameras");
  };
  $scope.clickedUserMenu = function () {
    $scope.isUserMenuLayer = !$scope.isUserMenuLayer;
    openUserMenu($scope.isUserMenuLayer);
  };
  document.getElementById("wrap").addEventListener("click", function (e) {
    $scope.isUserMenuLayer = false;
    document.getElementById("topUserMenu").classList.remove("clicked");
  });
  $scope.logout = function () {
    User.logout(function (data) {
      logoutSuccess();
    });
  };
  var showAlert = function showAlert(title, message) {
    $scope.showAlert = true;
    $scope.alertTitle = title;
    $scope.alertMessage = message;
  };
  $scope.submitChangePassword = function () {
    var noPwdElement = document.getElementById("noPwd");
    var newPwdElement = document.getElementById("newPwd");
    var checkPwdElement = document.getElementById("checkPwd");
    $scope.currentPassword = Utils.strCheck(noPwdElement.value);
    $scope.newPassword = Utils.strCheck(newPwdElement.value);
    $scope.passwordConfirmation = Utils.strCheck(checkPwdElement.value);
    var errorTitle = $translate.instant("CHANGE_PASSWORD_ERROR_TITLE");
    var title = $translate.instant("CHANGE_PASSWORD_TITLE");
    var passwordNotMatchMessage = $translate.instant("SIGNUP_ERROR_MESSAGE_PASSWORD_NOT_MATCH");
    var passwordEmptyMessage = $translate.instant("SIGNUP_ERROR_MESSAGE_PASSWORD_EMPTY");
    var invalidPasswordMessage = $translate.instant("SIGNUP_PASSWORD_INFOMATION");
    var requireNewPasswordMessage = $translate.instant("CHANGE_PASSWORD_ERROR_MESSAGE_REQUIRE_NEW_PASSWORD");
    if ($scope.currentPassword.length === 0 || $scope.newPassword.length === 0 || $scope.passwordConfirmation.length === 0) {
      showAlert(errorTitle, passwordEmptyMessage);
      return;
    }
    if (Validate.isValidPassword($scope.newPassword) === false) {
      showAlert(errorTitle, invalidPasswordMessage);
      return;
    }
    if ($scope.newPassword !== $scope.passwordConfirmation) {
      showAlert(errorTitle, passwordNotMatchMessage);
      return;
    }
    if ($scope.currentPassword === $scope.newPassword) {
      showAlert(errorTitle, requireNewPasswordMessage);
      return;
    }
    var result = User.setPassword({
      userId: $scope.me.userId
    }, {
      prevPassword: $scope.currentPassword,
      newPassword: $scope.newPassword
    }, function () {
      if (result.code === "ok") {
        $scope.isPasswordChangeMode = false;
        $scope.currentPassword = "";
        $scope.newPassword = "";
        $scope.passwordConfirmation = "";
        $scope.showPasswordChangeCompleteAlert = true;
      } else {
        showAlert(result.msg, result.msg);
      }
    });
  };
}]);
app.controller("SettingUserCtrl", ["$scope", "User", function ($scope, User) {
  $scope.templates = [{
    name: "top_menu.html",
    url: "/templates/common/_top.html"
  }, {
    name: "left_menu.html",
    url: "/templates/user/_account_left_menu.html"
  }, {
    name: "camera.html",
    url: "/templates/user/_account_user_clean_setting.html"
  }, {
    name: "bottom.html",
    url: "/templates/common/_bottom.html"
  }];
  $scope.getContextPath = Utils.getContextPath();
  $scope.getPath = "userclean";
  $scope.clickedTopMenu = function () {
    $scope.isTopMenuLayer = !$scope.isTopMenuLayer;
    menuOpen($scope.isTopMenuLayer);
  };
  $scope.clickedUserMenu = function () {
    $scope.isUserMenuLayer = !$scope.isUserMenuLayer;
    openUserMenu($scope.isUserMenuLayer);
  };
  document.getElementById("wrap").addEventListener("click", function (e) {
    $scope.isUserMenuLayer = false;
    document.getElementById("topUserMenu").classList.remove("clicked");
  });
  $scope.logout = function () {
    User.logout(function (data) {
      logoutSuccess();
    });
  };
  var showAlert = function showAlert(title, message) {
    $scope.showAlert = true;
    $scope.alertTitle = title;
    $scope.alertMessage = message;
  };
  $scope.hideAlert = function () {
    $scope.showAlert = false;
  };
  $scope.removeUser = function () {
    $scope.showUserConfirm = true;
  };
  $scope.processRemoveUser = function () {
    User.deleteUser(function (data) {
      $scope.logout();
    });
  };
}]);
app.controller("SettingMenuCtrl", ["$rootScope", "$scope", "$location", function ($rootScope, $scope, $location) {
  $scope.isUseGeofence = appConfig.useGeofence;
  $scope.getPath = $location.path();
  $scope.country = $rootScope.me && $rootScope.me.country === "JP" ? "ja" : "ko";
}]);
app.controller("SettingCtrl", ["$rootScope", "$scope", "Camera", "$translate", "$state", "User", "$window", function ($rootScope, $scope, Camera, $translate, $state, User, $window) {
  var playLimitToggle = null;
  $scope.$on("$destroy", function () {
    if (playLimitToggle) {
      playLimitToggle.destroy();
      playLimitToggle = null;
    }
  });

  // 서비스 탈퇴
  $scope.signOutCheck = function () {
    var url,
      httpUrl = location.origin;
    if (httpUrl == undefined) {
      httpUrl = location.protocol + "//" + location.hostname;
    }
    if ($rootScope.me && $rootScope.me.country === "JP") {
      url = "/checkpw?nextUrl=signout";
      window.open(url, "checkpw", "scrollbars=yes,toolbar=no,resizable=yes,width=420,height=538,left=600,top=200");
    } else {
      url = paycoUrl + "login.nhn?m=bridge&client_id=" + ci + "&access_token=" + encodeURIComponent(at) + "&nextUrl=" + encodeURIComponent(paycoUrl + "auth/confirmPwd.nhn?serviceProviderCode=BIZCAM&reason=CONFIRM_PWD&treatmentUrl=" + httpUrl + "/signout?deviceType=web&userLocale=ko_KR");
      openInfoWin(url, "popup", 630, 560); // window.open
    }
  };
  $window.signOutCheckCallback = function () {
    $scope.isSignOut = !$scope.isSignOut;
    $scope.$apply();
  };
  $scope.signOut = function () {
    $scope.isLoading = true;
    User.signOut(function (data) {
      $scope.isLoading = false;
      if (data.code == "ok") {
        $scope.isSignOut = !$scope.isSignOut;
        $scope.isSignOutSuccess = !$scope.isSignOutSuccess;
      } else {
        showAlert($translate.instant("USER_DELETE_CONFIRM"), data.msg ? data.msg : $translate.instant("ACCESS_FAIL"));
      }
    }, function (error) {
      $scope.isLoading = false;
      location.href = "/error";
    });
  };
  $scope.signOutConfirm = function () {
    $window.location.href = "/";
  };
  var showAlert = function showAlert(title, message) {
    $scope.showAlert = true;
    $scope.alertTitle = title;
    $scope.alertMessage = message;
  };

  // 위치기반 서비스 메뉴
  $scope.positionTermMng = function () {
    $scope.positionTermsPopup = true;
    User.me(function (data) {
      if (data && data.lbsAgreed === "ok") {
        $scope.isPostionTermAgree = true;
      } else {
        $scope.isPostionTermAgree = false;
      }
    }, function (error) {
      $scope.isPostionTermAgree = false;
      showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
    });
  };
  $scope.positionTermDetail = function () {
    var treatmentUrl = document.URL;
    var httpUrl = location.origin;
    if (httpUrl == undefined) {
      httpUrl = location.protocol + "//" + location.hostname;
    }
    var url;
    if ($scope.$root.isJPLogin) {
      url = httpUrl + "/#/positionTermsJP";
    } else {
      url = httpUrl + "/#/positionTerms";
    }
    openInfoWin(url, "popup", 630, 560, "yes"); // window.open
  };
  $scope.closePositionMngPopup = function () {
    $scope.positionTermsPopup = false;
  };
  $scope.setPositionTermAgree = function (isAgree) {
    $scope.isPostionTermAgree = isAgree;
  };
  $scope.savePositionTerm = function () {
    var param;
    if ($scope.isPostionTermAgree === true) {
      param = {
        isAgreed: "ok"
      };
    } else {
      param = {
        isAgreed: "nok"
      };
    }
    User.lbsAgree(param, function (data) {
      if (data.code === "ok") {
        $scope.positionTermsPopup = false;
      } else {
        showAlert($translate.instant("FAIL"), $translate.instant("ACCESS_SET_FAIL"));
      }
    }, function (error) {
      showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
    });
  };
  var getCameraFirmwareSetting = function getCameraFirmwareSetting() {
    return localStorage.getItem("biz-camera-firmware-update-" + $rootScope.me.userId);
  };
  var setCameraFirmwareSetting = function setCameraFirmwareSetting(value) {
    localStorage.setItem("biz-camera-firmware-update-" + $rootScope.me.userId, value);
  };
  $scope.showCameraFirmwareSettingPopup = function (isShow) {
    // ! 카메라 목록이 없을 경우, 별도 안내 팝업 제공
    if (!$scope.cameraListShow) {
      $scope.cameraEmptyPopup = isShow;
      return;
    }
    $scope.cameraFirmwareUpdatePopup = isShow;
    if (!$scope.cameraFirmwareUpdatePopup) {
      return;
    }
    if (cameraFirmwareToggle) {
      cameraFirmwareToggle.destroy();
    }
    cameraFirmwareToggle = tCam.toggle("camera_firmware_toggle");
    cameraFirmwareToggle.on("changed", function (event) {
      setCameraFirmwareSetting(event.value ? "true" : "false");
    });
    cameraFirmwareToggle.value = getCameraFirmwareSetting() !== "false";
  };
  var getPlayLimitSetting = function getPlayLimitSetting() {
    return localStorage.getItem("biz-play-limit-" + $rootScope.me.userId);
  };
  var setPlayLimitSetting = function setPlayLimitSetting(value) {
    localStorage.setItem("biz-play-limit-" + $rootScope.me.userId, value);
  };
  $scope.showPlayerSettingPopup = function (isShow) {
    $scope.playerSetPopup = isShow;
    if (!$scope.playerSetPopup) {
      return;
    }
    if (playLimitToggle) {
      playLimitToggle.destroy();
    }
    playLimitToggle = tCam.toggle("play_limit_toggle");
    playLimitToggle.on("changed", function (event) {
      setPlayLimitSetting(event.value ? "true" : "false");
    });
    playLimitToggle.value = getPlayLimitSetting() !== "false";
  };

  // 소뱅 미적용
  $scope.getCameraList = function () {
    Camera.getList(function (data) {
      $scope.cameraListShow = data.length > 0;
    });
  };
  $scope.getCameraList();
}]);
"use strict";

app.controller("SignUpCtrl", ["$scope", "$stateParams", "Acount", "$translate", "Utils", "$state", function ($scope, $stateParams, Acount, $translate, Utils, $state) {
  var uagentLow = navigator.userAgent.toLocaleLowerCase();
  document.querySelectorAll(".cont_min").forEach(function (element) {
    element.style.minHeight = "550px";
  });
  $scope.isShowToastCamTerm = false;
  $scope.isShowToastCamGPSTerm = false;
  $scope.signupErr0 = false;
  $scope.signupErr1 = false;
  $scope.signupErr2 = false;
  $scope.mailAuthState = "";
  $scope.termsShow = false;
  $scope.signupInfo = {
    emailId: "",
    password: "",
    pwComf: "",
    allTermCheck: false,
    useTerm: false
  };
  $scope.signupSubmit = function () {
    resetSignupErrors();
    var _$scope$signupInfo = $scope.signupInfo,
      emailId = _$scope$signupInfo.emailId,
      password = _$scope$signupInfo.password,
      pwComf = _$scope$signupInfo.pwComf;
    var agreeTerm = document.getElementById("private_agree").checked;
    if (!isEmailValid(emailId)) {
      showAlert($translate.instant("SIGN_UP_EMAIL_ADDRESS"), $translate.instant("LOGIN_FIND_PW_EMAIL_INPUT"));
      return;
    }
    if (!isPasswordValid(password)) {
      $scope.signupErr1 = true;
      return false;
    }
    if (password !== pwComf) {
      $scope.signupErr2 = true;
      return;
    }
    if (!agreeTerm) {
      showAlert($translate.instant("SIGNUP_ERROR_TITLE_POLICY"), $translate.instant("SIGNUP_ERROR_MESSAGE_POLYCY"));
      return;
    }
    Acount.get({
      email: emailId
    }, handleAccountResponse);
  };
  function resetSignupErrors() {
    $scope.signupErr0 = false;
    $scope.signupErr1 = false;
    $scope.signupErr2 = false;
  }
  function isEmailValid(email) {
    if (email === "") return false;
    var emailPattern = /^[a-z0-9_+.-]+@([a-z0-9-]+\.)+[a-z0-9]{2,4}$/;
    if (!emailPattern.test(email)) {
      $scope.isShowEmailValidCheckLayer = true;
      return false;
    }
    return true;
  }
  function isPasswordValid(password) {
    var containsNumber = /[0-9]/.test(password);
    var containsEnglish = /[a-z]/i.test(password);
    var passwordPattern = /^(?=.*[a-z])(?=.*[0-9])(?=.*[!-\/:-@\[-`{-~]).{8,15}$/i;
    return containsNumber && containsEnglish && passwordPattern.test(password);
  }
  function handleAccountResponse(data) {
    if (data.code == "ok") {
      $scope.registBizToastcamUser();
    } else {
      $scope.signupErr0 = true;
    }
  }
  $scope.registBizToastcamUser = function () {
    $scope.isLoadingComplete = true;
    var countryVal = $stateParams.lang.split("_")[1];
    var param = {
      email: Utils.strCheck($scope.signupInfo.emailId),
      password: Utils.strCheck($scope.signupInfo.password),
      country: countryVal
    };
    Acount.creatUser(param, function (data) {
      $scope.signUpStep1 = false;
      $scope.signUpStep2 = true;
      $scope.isLoadingComplete = false;
    });
  };
  $scope.sendAuthEmail = function () {
    $scope.isLoadingComplete = true;
    Acount.sendAuthEmail({
      email: Utils.strCheck($scope.signupInfo.emailId)
    }, function (data) {
      if (data.code == "ok") {
        showAlert($translate.instant("SIGN_UP_AUTH_EMAIL_SEND"), $translate.instant("SIGN_UP_AUTH_EMAIL_SEND_SUCCESS"));
      } else {
        showAlert($translate.instant("SIGN_UP_AUTH_EMAIL_SEND"), $translate.instant("LOGIN_FIND_PW_ERR2"));
      }
      $scope.isLoadingComplete = false;
    });
  };
  $scope.closeEamilValidCheckLayer = function () {
    $scope.isShowEmailValidCheckLayer = false;
  };
  $scope.removeEmailId = function () {
    $scope.signupInfo.emailId = "";
  };
  $scope.removePassword = function () {
    $scope.signupInfo.password = "";
  };
  $scope.removePwComf = function () {
    $scope.signupInfo.pwComf = "";
  };
  var showAlert = function showAlert(title, message) {
    $scope.showAlert = true;
    $scope.alertTitle = title;
    $scope.alertMessage = message;
  };
  $scope.hideAlert = function () {
    $scope.showAlert = false;
  };
  $scope.toggleShowTerms = function () {
    $scope.termsShow = !$scope.termsShow;
    var termsIframeElement = document.getElementById("toastCamTermContainer");
    var lang = Utils.getBrowserLanguage();
    var termsUrl = $state.href(lang === "ja_JP" ? "termsJP" : "terms");
    termsIframeElement.setAttribute("src", $scope.termsShow ? termsUrl : "");
  };
  $scope.moveMainPage = function () {
    if (uagentLow.search("android") > -1 || uagentLow.search("iphone") > -1) {
      //For Mobile
      if ($scope.mailAuthState === "ok") {
        location.href = "callapp://mailtoapp?logintoken=" + Utils.getCookie("toastcam");
      } else {
        location.href = "callapp://mailtoapp?logintoken=";
      }
    } else {
      location.href = "https://" + location.hostname;
    }
  };
  $scope.authEmailComplete = function () {
    $scope.isLoadingComplete = true;
    var param = {
      email: Utils.strCheck($stateParams.email || ""),
      authKey: Utils.strCheck($stateParams.authKey || "")
    };
    Acount.emailAuth(param, function (data) {
      $scope.mailAuthState = data.code;
      if (data.code == "ok") {
        $scope.signUpAuthMessage = $translate.instant("SIGU_UP_COMPLETE");
      } else if (data.code == "nok") {
        if (data.errorCode == 1) {
          $scope.signUpAuthMessage = $translate.instant("LOGIN_FIND_PW_SERVER_ERR1");
        } else if (data.errorCode == 2) {
          $scope.signUpAuthMessage = $translate.instant("LOGIN_FIND_PW_SERVER_ERR2");
        } else if (data.errorCode == 3) {
          $scope.signUpAuthMessage = $translate.instant("LOGIN_FIND_PW_SERVER_ERR3");
        } else {
          $scope.signUpAuthMessage = $translate.instant("SIGU_UP_SERVER_ERR99");
        }
      }
      $scope.isLoadingComplete = false;
    });
  };
  if ($stateParams.authKey) {
    $scope.signUpStep1 = false;
    $scope.signUpStep2 = false;
    $scope.signUpStep3 = true;
    $scope.authEmailComplete();
  } else {
    $scope.signUpStep1 = true;
    $scope.signUpStep2 = false;
    $scope.signUpStep3 = false;
    document.getElementById("id").focus();
  }
}]);
"use strict";

app.controller("AiFaceContentCtrl", ["$scope", "$rootScope", "$translate", "$timeout", "$stateParams", "$http", function ($scope, $rootScope, $translate, $timeout, $stateParams, $http) {
  $scope.showToast = false;
  $scope.groupSelectPeoplList = [];
  $scope.aiCameras = [];
  $scope.searchResult = [];
  $scope.poolSelectList = [];
  $scope.showSearchResult = false;
  $scope.searchStr = "";
  $scope.selectedFilterIdx = null;
  $scope.poolOptNotRegisted = true;
  $scope.poolOptHighQuality = true;
  $scope.selectedSearchResult = null;
  $scope.isToday = false;
  $scope.isShowFaceAddOptions = false;
  $scope.groupEditName = "";
  $scope.showFilterCams = false;
  $scope.showDragNoti = false;
  $scope.showPoolOption = false;
  $scope.selectDate = null;
  $scope.timelineDatePicker = null;
  $scope.peopleList = [];
  $scope.POOL_SHOW_MODE = {
    NORMAL: "1",
    EDIT: "2",
    SELECT: "3"
  };
  $scope.poolShowMode = $scope.POOL_SHOW_MODE.NORMAL;
  $scope.poolShowOptions = [{
    text: $translate.instant("9rRqk7Vo_02401"),
    value: "noreg"
  }, {
    text: $translate.instant("5mw2slvk_02147"),
    value: "quality"
  }];
  $scope.request_user = {
    info: "",
    name: "",
    status: 0,
    id: "",
    image: "",
    regDate: 0
  };
  $scope.request_user_manager = {
    info: "",
    name: ""
  };
  $scope.regist_step = 1;
  $scope.request_user_list = [];
  $scope.selected_user = null;
  $scope.count_request_ing = 0;
  $scope.count_request_res = 0;
  $scope.imageManagerSelected = null;
  $scope.managerPicStep = 0;
  $scope.emailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  $scope.hpFormat = /\d{11,11}/;
  $scope.image_canvas = null;
  $scope.snap_width = 0;
  $scope.snap_height = 0;
  $scope.snapshot_data = "";
  $scope.face_data = "";
  $scope.wasUrlForRequest = "";
  var toastTimeout = null;
  var dragNotiTimeout = null;
  $scope.resentReason = [{
    code: "0",
    reason: "재요청 사유 선택"
  }, {
    code: "1",
    reason: "밝은 곳에서 촬영"
  }, {
    code: "2",
    reason: "얼굴 크기를 좀더 크게 좔영"
  }, {
    code: "3",
    reason: "사용자 자신의 얼굴 직접 촬영"
  }];
  $scope.resentReasonSelected = $scope.resentReason[0];
  function checkIsToday(graphDate) {
    if (!graphDate) {
      return true;
    }
    var today = new Date();
    if (today <= graphDate || today.getFullYear() === graphDate.getFullYear() && today.getMonth() === graphDate.getMonth() && today.getDate() === graphDate.getDate()) {
      return true;
    } else {
      return false;
    }
  }
  function getDateString(timestamp) {
    var dateObj;
    if (timestamp) {
      dateObj = new Date(parseInt(timestamp, 10));
    } else {
      dateObj = new Date();
    }
    var dd = dateObj.getDate();
    var mm = dateObj.getMonth() + 1;
    var yyyy = dateObj.getFullYear();
    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }
    return "" + yyyy + mm + dd;
  }
  $scope.addAIRegistRequest = function (info) {
    $scope.request_user_list.push(info);
    return $scope.request_user_list.length;
  };
  $scope.showPoolByOption = function (pool) {
    var isShow = true;
    if ($scope.poolOptNotRegisted && pool.registed) {
      isShow = false;
    }
    if ($scope.poolOptHighQuality && !pool.isHighQuality) {
      isShow = false;
    }
    return isShow;
  };
  $scope.poolSelectAll = function (isSelect) {
    $scope.$parent.poolList.forEach(function (item) {
      item.isChecked = isSelect ? true : false;
    });
    if (isSelect) {
      $scope.poolSelectList = $scope.$parent.poolList.filter(function (item) {
        var isValid = true;
        if ($scope.poolOptNotRegisted && item.registed) {
          isValid = false;
        }
        if ($scope.poolOptHighQuality && !item.isHighQuality) {
          isValid = false;
        }
        return item.isChecked && isValid;
      });
    } else {
      $scope.poolSelectList = [];
    }
  };
  $scope.setDate = function (date) {
    $scope.selectDate = date;
    $scope.isToday = checkIsToday($scope.selectDate);
    curDateStr = getDateString($scope.selectDate.valueOf());
  };
  $scope.getCurSelectDate = function () {
    return $scope.selectDate;
  };
  $scope.setPoolMode = function (mode) {
    $scope.poolShowMode = "";
    $timeout(function () {
      $scope.poolShowMode = mode;
      if ($scope.poolShowMode === $scope.POOL_SHOW_MODE.NORMAL) {
        if (dragNotiTimeout) {
          $timeout.cancel(dragNotiTimeout);
          dragNotiTimeout = null;
        }
        $scope.showDragNoti = false;
      }
      if ($scope.poolShowMode !== $scope.POOL_SHOW_MODE.SELECT) {
        $scope.poolSelectAll(false);
      }
    }, 100);
  };
  $scope.selectPoolItem = function (poolItem) {
    if ($scope.$parent.peopleEditMode === $scope.$parent.PEOPLE_EDIT_MODE.EDIT || poolItem.registed || !poolItem.isHighQuality) {
      return;
    }
    poolItem.isChecked = !poolItem.isChecked;
    if (poolItem.isChecked) {
      $scope.poolSelectList.push(poolItem);
    } else {
      var i,
        len = $scope.poolSelectList.length;
      for (i = 0; i < len; i += 1) {
        if ($scope.poolSelectList[i].id === poolItem.id) {
          $scope.poolSelectList.splice(i, 1);
          break;
        }
      }
    }
    $scope.dragGhostEl.empty();
    $scope.dragGhostImgEls = [];
    $scope.poolSelectList.forEach(function (selected) {
      var $img = document.createElement("img");
      $img.setAttribute("src", selected.imageUrl);
      $img.poolId = selected.id;
      $scope.dragGhostEl.appendChild($img);
      $scope.dragGhostImgEls.push($img);
    });
    if ($scope.poolShowMode === $scope.POOL_SHOW_MODE.NORMAL) {
      if ($scope.poolSelectList.length > 0) {
        $scope.showDragNoti = true;
        $(".drag_noti").fadeIn(500);
        if (dragNotiTimeout) {
          $timeout.cancel(dragNotiTimeout);
        }
        dragNotiTimeout = $timeout(function () {
          $(".drag_noti").fadeOut(500, function () {
            $scope.showDragNoti = false;
          });
        }, 2000);
        $scope.setPoolMode($scope.POOL_SHOW_MODE.SELECT);
      }
    } else if ($scope.poolShowMode === $scope.POOL_SHOW_MODE.SELECT) {
      if ($scope.poolSelectList.length === 0) {
        $scope.setPoolMode($scope.POOL_SHOW_MODE.NORMAL);
      }
    }
  };
  function editKeyupHandler(event) {
    var editor = document.getElementById("group_name_editor");
    var dummy = document.getElementById("group_name_editor_dummy");
    if (event.keyCode === 13) {
      $scope.$parent.$broadcast("saveGroupName", $scope.groupEditName);
    } else if (event.keyCode === 27) {
      editor.removeEventListener("keyup", editKeyupHandler);
      $scope.$parent.$broadcast("setGroupEditMode", $scope.$parent.GROUP_EDIT_MODE.NORMAL);
      $scope.$apply();
    } else {
      dummy.textContent = editor.value + "aa";
      editor.style.width = dummy.offsetWidth + "px";
    }
  }
  $scope.changeGroupEditMode = function (mode) {
    $scope.$parent.$broadcast("setGroupEditMode", mode);
  };
  $scope.setGroupEditMode = function (mode) {
    var editor = document.getElementById("group_name_editor");
    var dummy = document.getElementById("group_name_editor_dummy");
    editor.removeEventListener("keyup", editKeyupHandler);
    if (mode === $scope.$parent.GROUP_EDIT_MODE.PERSON_LIST) {
      if ($scope.$parent.selectedGroup && $scope.$parent.selectedGroup.persons) {
        $scope.groupSelectPeoplList = [];
      }
    } else if (mode === $scope.$parent.GROUP_EDIT_MODE.GROUP_LIST) {
      if ($scope.groups) {
        $scope.groups.forEach(function (item) {
          item.isChecked = false;
        });
        $scope.groupSelectList = [];
      }
    } else if (mode === $scope.GROUP_EDIT_MODE.GROUP_NAME) {
      $scope.groupEditName = $scope.$parent.selectedGroup.name;
      editor.style.display = "none";
      editor.addEventListener("keyup", editKeyupHandler);
      setTimeout(function () {
        dummy.textContent = editor.value + "aa";
        editor.style.width = dummy.offsetWidth + "px";
        editor.style.display = "block";
        editor.focus();
      }, 0);
    }
  };
  $scope.deleteGroupSelectPeoples = function () {
    var deleteIds = [];
    $scope.groupSelectPeoplList.forEach(function (item) {
      deleteIds.push(item.id);
    });
    $scope.$parent.$broadcast("updateGroup", {
      deleteIds: deleteIds
    });
  };
  $scope.showNotiMsg = function (msg) {
    $scope.notiMsg = msg;
    $("#aiface_content_noti").fadeIn(500);
    if ($scope.notiTimeout) {
      $timeout.cancel($scope.notiTimeout);
    }
    $scope.notiTimeout = $timeout(function () {
      $("#aiface_content_noti").fadeOut(500, function () {
        $scope.notiMsg = "";
      });
    }, 2000);
  };
  $scope.showPoolDeleteConfirm = function () {
    $rootScope.createConfirm({
      description: $translate.instant("9rRqk7Vo_02320"),
      padding: "24px 24px 40px 24px",
      handler: function handler() {
        $scope.$parent.$broadcast("deletePools", {
          poolSelectList: $scope.poolSelectList
        });
      }
    });
  };
  $scope.showAiFaceGroupDlg = function () {
    $scope.$parent.$broadcast("showAiFaceGroupDlg");
  };
  $scope.showAiFaceAddPeopleDlg = function () {
    $scope.$parent.$broadcast("showAiFaceAddPeopleDlg");
  };
  $scope.showAiFaceAddPhotoDlg = function () {
    $scope.$parent.$broadcast("showAiFaceAddPhotoDlg");
  };
  $scope.showAiFaceRegistDlg = function () {
    $scope.$parent.$broadcast("showAiFaceRegistDlg");
  };
  $scope.selectFilter = function (index) {
    $scope.selectedFilterIdx = index;
    $scope.showFilterCams = false;
    $scope.$parent.$broadcast("fetchPools");
  };
  $scope.selectPoolShowOption = function (option, event) {
    if (option.value === "noreg") {
      $scope.poolOptNotRegisted = !$scope.poolOptNotRegisted;
    } else if (option.value === "quality") {
      $scope.poolOptHighQuality = !$scope.poolOptHighQuality;
    }
    event.preventDefault();
    event.stopPropagation();
  };
  $scope.toggleTimelineCalendar = function (event) {
    if ($scope.timelineDatePicker) {
      if ($scope.timelineDatePicker.isVisible()) {
        $scope.timelineDatePicker.hide();
      } else {
        $scope.timelineDatePicker.show();
      }
    }
    event.stopPropagation();
    event.preventDefault();
  };
  $scope.moveNextDate = function (isPrev) {
    if ($scope.isToday && !isPrev) {
      return;
    }
    if ($scope.selectDate) {
      if (isPrev) {
        $scope.selectDate.setDate($scope.selectDate.getDate() - 1);
      } else {
        $scope.selectDate.setDate($scope.selectDate.getDate() + 1);
      }
      $scope.timelineDatePicker.setDate($scope.selectDate);
    }
  };
  function initCalendar() {
    $scope.setDate(new Date());
    var minDate = new Date();
    minDate.setDate(minDate.getDate() - 30);
    $scope.timelineDatePicker = new Pikaday({
      field: document.getElementById("timelineDate"),
      container: document.getElementById("calendarContainer"),
      format: $translate.instant("CLIP_CREATE_CLIP_DATE_FORMAT"),
      minDate: minDate,
      maxDate: $scope.selectDate,
      defaultDate: $scope.selectDate,
      position: "bottom right",
      onSelect: function onSelect(date) {
        $scope.setDate(date);
        $scope.$parent.$broadcast("fetchPools");
      }
    });
  }
  $scope.$on("$destroy", function () {
    $("#group_name_editor").off("keyup", editKeyupHandler);
    if (toastTimeout) {
      $timeout.cancel(toastTimeout);
      toastTimeout = null;
    }
    if (dragNotiTimeout) {
      $timeout.cancel(dragNotiTimeout);
      dragNotiTimeout = null;
    }
    if ($scope.timelineDatePicker) {
      $scope.timelineDatePicker.destroy();
    }
    if (grpSearchObj) {
      grpSearchObj.destroy();
      grpSearchObj = null;
    }
    $scope.dragGhostEl.detach();
  });
  $scope.initValues = function () {
    $scope.searchStr = "";
    $scope.selectedSearchResult = null;
    if (grpSearchObj) {
      grpSearchObj.value = "";
    }
    $scope.searchResult = [];
    $scope.showDragNoti = false;
    $scope.notiMsg = "";
    if ($scope.notiTimeout) {
      $timeout.cancel($scope.notiTimeout);
    }
  };
  $scope.selectSearchResult = function (result) {
    $scope.$parent.$broadcast("selectSearchResult", result);
    $scope.searchStr = "";
    grpSearchObj.value = "";
    $scope.searchResult = [];
    $scope.selectedSearchResult = result;
  };
  $scope.selectGroupPeople = function (person) {
    $scope.selectedSearchResult = null;
    if ($scope.$parent.groupEditMode === $scope.$parent.GROUP_EDIT_MODE.PERSON_LIST) {
      person.isChecked = !person.isChecked;
      if ($scope.$parent.selectedGroup && $scope.$parent.selectedGroup.persons) {
        $scope.groupSelectPeoplList = $scope.$parent.selectedGroup.persons.filter(function (item) {
          return item.isChecked;
        });
      }
    } else {
      $scope.$parent.$broadcast("showAiFaceSetPeopleDlg", {
        id: person.id,
        isEdit: true
      });
    }
  };
  function groupSearchHandler(event) {
    $scope.searchStr = event.value;
    if ($scope.$parent.selectTab === "group") {
      $scope.searchResult = [];
      $scope.showSearchResult = !!$scope.searchStr;
      if (event.value) {
        var lowerValue = event.value.toLowerCase();
        var allGroups = $scope.$parent.groups.concat($scope.$parent.sysGroups);
        allGroups.forEach(function (group) {
          if (group.name.toLowerCase().indexOf(lowerValue) !== -1) {
            $scope.searchResult.push({
              id: group.id,
              name: group.name
            });
          }
          if (group.persons) {
            group.persons.forEach(function (person) {
              if (person.name.toLowerCase().indexOf(lowerValue) !== -1) {
                $scope.searchResult.push({
                  id: group.id,
                  name: group.name,
                  person: {
                    id: person.id,
                    name: person.name,
                    masterImageUrl: person.masterImageUrl
                  }
                });
              }
            });
          }
        });
      }
    }
    $scope.$apply();
  }
  var grpSearchObj = tCam.search("search_grp");
  if (grpSearchObj) {
    grpSearchObj.on("focused", function (evt) {
      if ($scope.searchStr) {
        $scope.showSearchResult = true;
        $scope.$apply();
      }
    });
    grpSearchObj.on("changed", groupSearchHandler);
    grpSearchObj.placeholder = $translate.instant("9rRqk7Vo_02319");
    grpSearchObj.boxStyle = {
      width: "100%",
      height: "48px",
      border: "1px solid #f5f5f5",
      borderRadius: "6px",
      color: "#999999",
      background: "#f5f5f5",
      textAlign: "left"
    };
    grpSearchObj.design = "search";
  }
  $scope.dragGhostEls = null;
  $scope.dragGhostImgEls = [];
  function buildDragGhost() {
    $scope.dragGhostEl = $("<div>");
    $scope.dragGhostEl.addClass("drag_ghost_wrap");
    document.body.appendChild($scope.dragGhostEl[0]);
  }
  function initComp() {
    $scope.$parent.setContentChildScope($scope);
    $scope.$parent.selectTab = $stateParams.tab === "group" ? "group" : "man";
    $scope.$parent.selectedUserId = $stateParams.user ? $stateParams.user : null;
    initCalendar();
    buildDragGhost();
  }
  $scope.sendAIRegistURL = function () {
    $http({
      method: "POST",
      url: $scope.wasUrlForRequest + "/json/biz/ai/face/add_request",
      data: {
        userId: $rootScope.me.userId,
        name: $scope.request_user.name,
        sms: $scope.request_user.info
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
      }
    }).success(function (response) {
      $scope.request_user.name = "";
      $scope.request_user.info = "";
      $scope.getAIRegistList();
      $scope.showNotiMsg("AI 얼굴 등록 요청을 보냈습니다.");
    })["finally"](function () {
      void 0;
    });
    return true;
  };
  $scope.getAIRegistList = function () {
    $http({
      method: "POST",
      url: $scope.wasUrlForRequest + "/json/biz/ai/face/get_request",
      data: {
        userId: $rootScope.me.userId
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
      }
    }).success(function (response) {
      $scope.count_request_ing = 0;
      $scope.count_request_res = 0;
      response.list.forEach(function (item) {
        if (item.status != 3 || item.picUrl === undefined) {
          $scope.count_request_ing++;
        } else {
          $scope.count_request_res++;
        }
      });
      $scope.request_user_list = response.list;
    })["finally"](function () {
      void 0;
    });
    return true;
  };
  $scope.resendAIRegistRequest = function () {
    if ($scope.resentReasonSelected.code == "0") {
      return false;
    }
    $http({
      method: "POST",
      url: $scope.wasUrlForRequest + "/json/biz/ai/face/resend_request",
      data: {
        userId: $rootScope.me.userId,
        requestId: $scope.selected_user.id,
        reason: $scope.resentReasonSelected.code
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
      }
    }).success(function (response) {
      $scope.getAIRegistList();
      $scope.showNotiMsg("재요청 메세지를 보냈습니다.");
    })["finally"](function () {
      void 0;
    });
    return true;
  };
  $scope.delRequest = function (user) {
    $http({
      method: "POST",
      url: $scope.wasUrlForRequest + "/json/biz/ai/face/del_request",
      data: {
        userId: $rootScope.me.userId,
        requestId: user.id
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
      }
    }).success(function (response) {
      $scope.getAIRegistList();
    })["finally"](function () {
      void 0;
    });
    return true;
  };
  $scope.registRequest = function (user) {
    $http({
      method: "POST",
      url: $scope.wasUrlForRequest + "/json/biz/ai/face/regist_request",
      data: {
        userId: $rootScope.me.userId,
        requestId: user.id
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
      }
    }).success(function (response) {
      $scope.getAIRegistList();
      $scope.showNotiMsg("등록이 완료되었습니다. 완료된 요청은 목록에서 사라집니다.");
      $rootScope.$broadcast("aifacePeopleUpdate", null);
    })["finally"](function () {
      void 0;
    });
    return true;
  };
  $scope.managerFileOpen = function () {
    $("#faceFileLoader").unbind("change");
    $("#faceFileLoader").bind("change", function (e) {
      $scope.managerFileView(e.target.files[0]);
      e.preventDefault();
    });
    $("#faceFileLoader").click();
  };
  $scope.viewRegistManagerFile = function () {
    $scope.managerPicStep = 2;
  };
  $scope.resetManagerFile = function () {
    $scope.managerPicStep = 0;
  };
  $scope.managerRegist = function () {
    $http({
      method: "POST",
      url: $scope.wasUrlForRequest + "/json/biz/ai/face/regist_manager",
      data: {
        userId: $rootScope.me.userId,
        name: $scope.request_user_manager.name,
        pic: $scope.face_data
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
      }
    }).success(function (response) {
      $scope.resetManagerFile();
      $scope.showNotiMsg("등록이 완료되었습니다. 인물 목록을 확인해 주세요.");
      $rootScope.$broadcast("aifacePeopleUpdate", null);
    })["finally"](function () {
      void 0;
    });
    return true;
  };
  $scope.initPicArea = function () {
    $("#PicArea").unbind("dragover");
    $("#PicArea").unbind("drop");
    $("#PicArea").bind("dragover", function (e) {
      e.preventDefault();
    });
    $("#PicArea").bind("drop", function (e) {
      $scope.managerFileView(e.originalEvent.dataTransfer.files[0]);
      e.preventDefault();
    });
  };
  $scope.managerFileView = function (file) {
    if (file.type.indexOf("image") !== -1) {
      var img = new Image();
      $scope.image_canvas = document.getElementById("image_snap_canvas");
      img.onload = function () {
        var maxWH = 1280;
        var rateWH = 1.0;
        if (img.width > img.height) {
          if (img.width > maxWH) {
            rateWH = maxWH / img.width;
          }
        } else {
          if (img.height > maxWH) {
            rateWH = maxWH / img.height;
          }
        }
        $scope.image_canvas.width = img.width * rateWH;
        $scope.image_canvas.height = img.height * rateWH;
        $scope.image_canvas.getContext("2d").drawImage(img, 0, 0, img.width, img.height, 0, 0, $scope.image_canvas.width, $scope.image_canvas.height);
        $scope.snapshot_data = $scope.image_canvas.toDataURL("image/jpeg");
        $http({
          method: "POST",
          url: $scope.wasUrlForRequest + "/json/biz/ai/face/detect",
          data: {
            userId: $rootScope.me.userId,
            pic: $scope.snapshot_data
          },
          headers: {
            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
          }
        }).success(function (response) {
          void 0;
          var face_left = $scope.image_canvas.width * response.left;
          var face_top = $scope.image_canvas.height * response.top;
          var face_width = $scope.image_canvas.width * response.width;
          var face_height = $scope.image_canvas.height * response.height;
          var face_confidence = response.confidence;
          var canvas_face = document.getElementById("face_canvas");
          var image_canvas_fit = document.getElementById("image_snap_canvas_fit");
          var width20p = face_width;
          var height20p = face_height;
          canvas_face.width = face_width + width20p;
          canvas_face.height = face_height + height20p;
          canvas_face.getContext("2d").drawImage($scope.image_canvas, face_left - width20p / 2, face_top - height20p / 2, canvas_face.width, canvas_face.height, 0, 0, canvas_face.width, canvas_face.height);
          $scope.face_data = canvas_face.toDataURL("image/jpeg");
          image_canvas_fit.width = $scope.image_canvas.width * 360 / $scope.image_canvas.height;
          image_canvas_fit.height = 360;
          var ctx = image_canvas_fit.getContext("2d");
          ctx.drawImage($scope.image_canvas, 0, 0, $scope.image_canvas.width, $scope.image_canvas.height, 0, 0, $scope.image_canvas.width * 360 / $scope.image_canvas.height, 360);
          ctx.globalAlpha = 0.8;
          ctx.fillStyle = "#000";
          ctx.fillRect(0, 0, image_canvas_fit.width, image_canvas_fit.height);
          ctx.globalAlpha = 1.0;
          ctx.drawImage($scope.image_canvas, face_left - 30, face_top - 30, face_width + 60, face_height + 60, (face_left - 30) * (image_canvas_fit.width / $scope.image_canvas.width), (face_top - 30) * (image_canvas_fit.height / $scope.image_canvas.height), (face_width + 60) * (image_canvas_fit.width / $scope.image_canvas.width), (face_height + 60) * (image_canvas_fit.height / $scope.image_canvas.height));
          $scope.imageManagerSelected = image_canvas_fit.toDataURL("image/jpeg");
          $scope.managerPicStep = 1;
        })["finally"](function () {
          void 0;
        });
      };
      img.src = URL.createObjectURL(file);
    } else {
      void 0;
    }
  };
  $scope.getRequestImageURL = function (user) {
    if (user.picUrl === undefined || user.picUrl == "") {
      return "/resources/im/pic_none.png";
    }
    return "https://dev-biz.toastcam.com/" + user.picUrl;
  };

  // 팝업
  $scope.layer_show = function (name, user) {
    if (name == "request_layer") {
      var is_email = true;
      if ($scope.request_user.name == "" || $scope.request_user.info == "") {
        $scope.showNotiMsg("이름과 연락처를 입력해 주세요.");
        return;
      }
      if ($scope.emailFormat.test($scope.request_user.info)) {
        //email
      } else {
        var mobile_phone_tmp = $scope.request_user.info;
        mobile_phone_tmp = mobile_phone_tmp.replace(/-/g, "");
        mobile_phone_tmp = mobile_phone_tmp.replace(/(\s*)/g, "");
        $scope.request_user.info = mobile_phone_tmp;
        if ($scope.request_user.info.length == 11 && $scope.hpFormat.test($scope.request_user.info)) {
          is_email = false;
        } else {
          $scope.showNotiMsg("올바른 연락처를 입력해 주세요.");
          return;
        }
      }
      var already_regist = false;
      $scope.request_user_list.forEach(function (item) {
        var user1 = $scope.request_user.info.toString();
        var user2 = item.info.toString();
        if (is_email == false) {
          user2 = user2.replace(/-/g, "");
          user2 = user2.replace(/(\s*)/g, "");
        }
        var compare = user1.localeCompare(user2, undefined, {
          sensitivity: "base"
        }) === 0;
        if (compare == true) {
          already_regist = true;
        }
      });
      if (already_regist == true) {
        $scope.showNotiMsg("이미 요청을 전송한 사용자 입니다.");
        return;
      }
    }
    document.body.classList.add;
    document.body.classList.add("fixed");
    $("#layer_wrapper").show();
    $("." + name).show();
    $("#layer_wrapper > div").not($("." + name)).hide();
    //return false;
    $scope.selected_user = user;
    if (name == "request_layer") {} else if (name == "re-request_layer") {}
  };
  $scope.layer_hide = function (name) {
    $("#layer_wrapper > div").not($("." + name)).hide();
    $("#layer_wrapper").hide();
    $("body").removeClass("fixed");
    //return false;

    if (name == "request_layer") {}
  };
  $scope.ai_tab_select = function (seli, name) {
    $(".tab_nav > li").not($("." + name)).removeClass("on");
    $(".tab_nav > li").addClass(function (index, currentClass) {
      if (index == seli) {
        if (seli == 1) {
          $scope.managerPicStep = 0;
        } else if (seli == 2) {
          $scope.getAIRegistList();
        }
        return "on";
      }
      return "";
    });
    $("." + name).show();
    var ttt = $(".clip_container");
    $(".clip_container").not($("." + name)).hide();
  };
  initComp();
}]);
"use strict";

app.controller("AiFaceDebugCtrl", ["$scope", "$rootScope", "$state", "$compile", "$translate", "$interval", "$timeout", "AiFace", function ($scope, $rootScope, $state, $compile, $translate, $interval, $timeout, AiFace) {
  $scope.authAccounts = [];
  $scope.logs = [];
  $scope.selectedAccount = null;
  $scope.isShowAccList = false;
  $scope.isLoading = false;
  $scope.selectDate = null;
  var ajaxCall = null;
  function getDateString(timestamp) {
    var dateObj;
    if (timestamp) {
      dateObj = new Date(parseInt(timestamp, 10));
    } else {
      dateObj = new Date();
    }
    var dd = dateObj.getDate();
    var mm = dateObj.getMonth() + 1;
    var yyyy = dateObj.getFullYear();
    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }
    return "" + yyyy + mm + dd;
  }
  function buildAuthAccounts(me, recieveAccounts) {
    $scope.authAccounts = [];
    $scope.authAccounts.push({
      userId: me.userId,
      account: me.paycoEmail ? me.paycoEmail : me.paycoMobile ? me.paycoMobile : me.email,
      isOwner: true
    });
    if (recieveAccounts && recieveAccounts.length) {
      $scope.authAccounts = $scope.authAccounts.concat(recieveAccounts);
    }
    $scope.selectAccount(me.userId);
  }
  function fetchRecievedAccounts(userId) {
    AiFace.recievedAccounts({
      userId: userId
    }).$promise.then(function (res) {
      if (res.code === "ok") {
        buildAuthAccounts($rootScope.me, res.accounts);
      }
    }, function (err) {});
  }
  function fetchHistory(userId, curDateStr) {
    if (ajaxCall) {
      ajaxCall.abort();
    }
    $scope.isLoading = true;
    ajaxCall = $.ajax({
      url: "/json/biz/ai/face/user/" + userId + "/detect/debug",
      type: "get",
      data: {
        date: curDateStr
      },
      success: function success(res) {
        var resObj = JSON.parse(res);
        $scope.logs = resObj.detectDebugs;
        $scope.$apply();
        $timeout(function () {
          $(".ai_lazy.person").load(function () {
            var width = this.width,
              height = this.height;
            if (this.width > 1) {
              this.width = 100;
              this.height = 100;
              var wInfoEl = this.parentElement.querySelector(".w_info");
              var hInfoEl = this.parentElement.querySelector(".h_info");
              if (wInfoEl) {
                wInfoEl.innerHTML = "w: " + width;
              }
              if (hInfoEl) {
                hInfoEl.innerHTML = "h: " + height;
              }
            }
          });
          $(".ai_lazy").Lazy({
            scrollDirection: "vertical",
            visibleOnly: true
          });
          $(window).scrollTop(document.documentElement.scrollTop + 32);
        }, 100);
        $scope.isLoading = false;
      },
      error: function error(err) {
        $scope.isLoading = false;
      }
    });
  }
  function isToday(date) {
    var today = new Date();
    return date.getDate() === today.getDate() && date.getMonth() === today.getMonth() && date.getFullYear() === today.getFullYear();
  }
  $scope.selectModel = "";
  $scope.selectOptions = [{
    value: "reg",
    text: "최신순"
  }, {
    value: "cam",
    text: "카메라ID순"
  }];
  $scope.orderingByType = function (list, type) {
    if (!list || !list.length) {
      return;
    }
    if (type === "reg") {
      list.sort(function (a, b) {
        return a.regDate > b.regDate ? -1 : a.regDate < b.regDate ? 1 : 0;
      });
    } else if (type === "cam") {
      list.sort(function (a, b) {
        var aLabel, bLabel;
        aLabel = a.cameraId.toLowerCase();
        bLabel = b.cameraId.toLowerCase();
        return aLabel < bLabel ? -1 : aLabel > bLabel ? 1 : 0;
      });
    }
  };
  $scope.selectAccount = function (userId) {
    var i,
      len = $scope.authAccounts.length;
    for (i = 0; i < len; i += 1) {
      if ($scope.authAccounts[i].userId === userId) {
        $scope.selectedAccount = $scope.authAccounts[i];
        fetchHistory($scope.selectedAccount.userId, getDateString($scope.selectDate.valueOf()));
        break;
      }
    }
  };
  $scope.moveNextDate = function (isPrev) {
    if ($scope.selectDate) {
      if (isPrev) {
        $scope.selectDate.setDate($scope.selectDate.getDate() - 1);
      } else {
        if (isToday($scope.selectDate)) {
          return;
        }
        $scope.selectDate.setDate($scope.selectDate.getDate() + 1);
      }
    }
    fetchHistory($scope.selectedAccount.userId, getDateString($scope.selectDate.valueOf()));
  };
  $scope.$on("$destroy", function () {
    if (ajaxCall) {
      ajaxCall.abort();
    }
  });
  if (!$rootScope.me) {
    $state.go("main");
  } else {
    $scope.selectDate = new Date();
    fetchRecievedAccounts($rootScope.me.userId);
  }
}]);
"use strict";

app.controller('AiFaceEventCtrl', ['$scope', '$stateParams', '$rootScope', '$document', '$timeout', '$location', '$translate', '$q', '$state', 'AiFace', 'Shop', function ($scope, $stateParams, $rootScope, $document, $timeout, $location, $translate, $q, $state, AiFace, Shop) {
  $scope.isLoadingEvent = false;
  $scope.isShowAiFaceEventFilterDialog = false;
  $scope.isToday = false;
  $scope.loadTimestamp = -1;
  $scope.aiCameras = [];
  $scope.eventListByHour = [];
  $scope.selectDate = null;
  $scope.selectedEventId = $stateParams.eventId;
  $scope.eventLength = 0;
  $scope.shopObject = null;
  var curDateStr = "";
  function buildEventGroups(eventGroups) {
    $scope.eventListByHour = [];
    $scope.eventLength = 0;
    if (eventGroups && eventGroups.length) {
      eventGroups.forEach(function (eventGroup) {
        var hour = new Date(eventGroup.timestamp).getHours();
        var time = hour < 10 ? '0' + hour : hour;
        var nextTime = hour + 1;
        nextTime = nextTime < 10 ? '0' + nextTime : nextTime;
        $scope.eventLength += eventGroup.eventCount;
        $scope.eventListByHour.push({
          hour: hour,
          timestamp: eventGroup.timestamp,
          time: time + ':00' + '~' + nextTime + ':00',
          events: []
        });
      });
    }
    $scope.eventListByHour.reverse();
    $scope.firstShowTimeIndex = 0;
  }
  function updateHourEvents(timestamp, events) {
    var i,
      len = $scope.eventListByHour.length,
      eventByHour = null;
    for (i = 0; i < len; i += 1) {
      if ($scope.eventListByHour[i].timestamp === timestamp) {
        eventByHour = $scope.eventListByHour[i];
        break;
      }
    }
    if (eventByHour) {
      eventByHour.events = events;
    }
  }
  $scope.filterChecked = false;
  $scope.toggleEventListBtn = function (e, timestamp) {
    var $parent = $(e.target).parent();
    if (!($parent[0] && $parent[0].localName == 'li')) {
      $parent = $parent.parent();
    }
    if ($parent[0] && $parent[0].localName == 'li') {
      if ($parent.hasClass('is_open')) {
        $parent.removeClass('is_open');
        updateHourEvents(timestamp, []);
      } else {
        $parent.addClass('is_open');
        var filterIds = [];
        $scope.aiCameras.forEach(function (item) {
          if (item.isChecked) {
            filterIds.push(item.deviceId);
          }
        });
        fetchEventsByHourly(timestamp, filterIds);
      }
    }
  };
  $scope.showPeopleEvtPlayer = function (param) {
    $scope.isShowAiFaceSetPeopleDialog = false;
    $scope.eventInfo = param.eventInfo;
    $scope.person = param.person;
    $scope.isShared = $stateParams.shared === true || $stateParams.shared === "true";
    $scope.isShowAiFacePeopleEventPlayDialog = true;
  };
  $scope.playEvent = function (event) {
    $scope.eventInfo = event;
    $scope.isShared = $stateParams.shared === true || $stateParams.shared === "true";
    $scope.isShowAiFaceEventPlayDialog = true;
    /*
    if (event.deviceId) {
        var isShared = ($stateParams.shared === true || $stateParams.shared === "true");
        $state.go('main.cameraDetail', {
            cameraId: event.deviceId,
            type: isShared ? 'sharedshop' : 'shop',
            id: $stateParams.shopId,
            time: event.detectDate - 4000,
            shared: isShared,
            eventId: event.eventId
        });
    }
     */
  };
  $scope.setDate = function (date) {
    $scope.selectDate = date;
    $scope.isToday = checkIsToday($scope.selectDate);
    curDateStr = getDateString($scope.selectDate.valueOf());
    $state.go('main.dashboard.aifaceEvent', {
      regDate: $scope.selectDate.valueOf()
    }, {
      reload: false,
      inherit: true,
      notify: false
    });
  };
  function checkIsToday(graphDate) {
    if (!graphDate) {
      return true;
    }
    var today = new Date();
    if (today <= graphDate || today.getFullYear() === graphDate.getFullYear() && today.getMonth() === graphDate.getMonth() && today.getDate() === graphDate.getDate()) {
      return true;
    } else {
      return false;
    }
  }
  function getEvenstWithDate(selectDate, filterIds) {
    if (filterIds && filterIds.length) {
      $scope.filterChecked = true;
    } else {
      $scope.filterChecked = false;
    }
    fetchEventGroups(selectDate, filterIds);
  }
  function getDateString(timestamp) {
    var dateObj;
    if (timestamp) {
      dateObj = new Date(parseInt(timestamp, 10));
    } else {
      dateObj = new Date();
    }
    var dd = dateObj.getDate();
    var mm = dateObj.getMonth() + 1;
    var yyyy = dateObj.getFullYear();
    if (dd < 10) {
      dd = '0' + dd;
    }
    if (mm < 10) {
      mm = '0' + mm;
    }
    return '' + yyyy + mm + dd;
  }
  $scope.toggleTimelineCalendar = function (event) {
    if ($scope.timelineDatePicker) {
      if ($scope.timelineDatePicker.isVisible()) {
        $scope.timelineDatePicker.hide();
      } else {
        $scope.timelineDatePicker.show();
      }
    }
    event.stopPropagation();
    event.preventDefault();
  };
  $scope.moveNextDate = function (isPrev) {
    if ($scope.isToday && !isPrev) {
      return;
    }
    $scope.selectedEventId = null;
    if ($scope.selectDate) {
      if (isPrev) {
        $scope.selectDate.setDate($scope.selectDate.getDate() - 1);
      } else {
        $scope.selectDate.setDate($scope.selectDate.getDate() + 1);
      }
      $scope.timelineDatePicker.setDate($scope.selectDate);
    }
  };
  function initCalendar() {
    var dateObj;
    if ($stateParams.regDate) {
      dateObj = new Date(parseInt($stateParams.regDate, 10));
    } else {
      dateObj = new Date();
    }
    $scope.setDate(dateObj);
    $scope.timelineDatePicker = new Pikaday({
      field: document.getElementById('timelineDate'),
      container: document.getElementById('calendarContainer'),
      format: $translate.instant('CLIP_CREATE_CLIP_DATE_FORMAT'),
      //minDate: minDate.toDate(),
      maxDate: new Date(),
      defaultDate: dateObj,
      position: 'bottom right',
      onSelect: function onSelect(date) {
        $scope.eventListByHour = [];
        $scope.selectedEventId = null;
        $scope.setDate(date);
        var filterIds = [];
        $scope.aiCameras.forEach(function (item) {
          if (item.isChecked) {
            filterIds.push(item.deviceId);
          }
        });
        getEvenstWithDate($scope.selectDate, filterIds);
      }
    });
  }
  $scope.showAiFaceSetPeopleDlg = function (detectPerson, isEdit, event) {
    $scope.selectPersonId = detectPerson.id;
    $scope.isPersonEditMode = isEdit;
    $scope.isShowAiFaceSetPeopleDialog = true;
    $scope.selectedAccount = {
      userId: detectPerson.userId
    };
    event.preventDefault();
    event.stopPropagation();
  };
  $scope.clickAllChecker = function (event) {
    $scope.allChecked = !$scope.allChecked;
    $scope.aiCameras.forEach(function (item) {
      item.isChecked = $scope.allChecked;
    });
    $scope.confirmEventFilterSetting();
    event.preventDefault();
    event.stopPropagation();
  };
  $scope.clickCamera = function (camera, event) {
    camera.isChecked = !camera.isChecked;
    var notAllChecked = $scope.aiCameras.some(function (cam) {
      return !cam.isChecked;
    });
    $scope.allChecked = !notAllChecked;
    $scope.confirmEventFilterSetting();
    event.preventDefault();
    event.stopPropagation();
  };
  $scope.clickFilter = function () {
    $scope.showFilter = !$scope.showFilter;
  };
  $scope.confirmEventFilterSetting = function () {
    var filterIds = [];
    $scope.aiCameras.forEach(function (item) {
      if (item.isChecked) {
        filterIds.push(item.deviceId);
      }
    });
    getEvenstWithDate($scope.selectDate, filterIds);
  };
  $scope.$on('filterConfirm', function (event, filterIds) {
    getEvenstWithDate($scope.selectDate, filterIds);
  });
  $scope.$on('showPeopleEvtPlayerDlg', function (event, param) {
    $scope.showPeopleEvtPlayer(param);
  });
  $scope.$on('$destroy', function () {
    $('body').removeClass('blockScroll');
    $('body').off('click', bodyClickCb);
    if ($scope.timelineDatePicker) $scope.timelineDatePicker.destroy();
  });
  function fetchCameras() {
    Shop.dashboardShopV4({
      shopId: $stateParams.shopId
    }).$promise.then(function (res) {
      var filterIds = [];
      if (res.shop && res.shop.controllerList) {
        $scope.shopObject = res.shop;
        res.shop.controllerList.forEach(function (item) {
          if (item.cameraInfo && item.cameraInfo.aiType >= 2) {
            //item.isChecked = true;
            $scope.aiCameras.push(item);
            //filterIds.push(item.deviceId);
          }
        });
        var notAllChecked = $scope.aiCameras.some(function (cam) {
          return !cam.isChecked;
        });
        $scope.allChecked = !notAllChecked;
      } else {
        $scope.shopObject = null;
      }
      getEvenstWithDate($scope.selectDate, filterIds);
    }, function (err) {});
  }
  function fetchEventGroups(selectDate, filterIds) {
    var filterIdsStr = '';
    filterIds.forEach(function (id) {
      filterIdsStr += filterIdsStr ? ',' + id : id;
    });
    $scope.isLoadingEvent = true;
    AiFace.eventGroups({
      shopId: $stateParams.shopId,
      date: selectDate.valueOf(),
      filterIds: filterIdsStr
    }).$promise.then(function (res) {
      $scope.isLoadingEvent = false;
      if (res.code === 'ok') {
        buildEventGroups(res.eventGroups);
        if ($scope.eventListByHour.length) {
          fetchEventsByHourly($scope.eventListByHour[0].timestamp, filterIds);
        }
      } else {
        $scope.eventListByHour = [];
      }
    }, function (err) {
      $scope.isLoadingEvent = false;
    });
  }
  function fetchEventsByHourly(timestamp, filterIds) {
    var filterIdsStr = '';
    filterIds.forEach(function (id) {
      filterIdsStr += filterIdsStr ? ',' + id : id;
    });
    $scope.loadTimestamp = timestamp;
    AiFace.eventsByHourly({
      shopId: $stateParams.shopId,
      date: timestamp,
      filterIds: filterIdsStr
    }).$promise.then(function (res) {
      $scope.loadTimestamp = -1;
      if (res.code === 'ok') {
        $scope.hasConfigPermission = res.hasConfigPermission;
        updateHourEvents(timestamp, res.events);
      }
    }, function (err) {
      $scope.loadTimestamp = -1;
    });
  }
  function bodyClickCb(event) {
    if ($scope.showFilter && event.target.className.indexOf('clickable') === -1) {
      $scope.showFilter = false;
      $scope.$apply();
    }
  }
  function initPage() {
    initCalendar();
    fetchCameras();
    $('body').on('click', bodyClickCb);
  }
  initPage();
}]);
"use strict";

app.controller('AiFacePeopleEventCtrl', ['$scope', '$stateParams', '$rootScope', '$document', '$timeout', '$location', '$translate', '$q', '$state', 'AiFace', 'Shop', function ($scope, $stateParams, $rootScope, $document, $timeout, $location, $translate, $q, $state, AiFace, Shop) {
  $scope.$on('$destroy', function () {
    $(window).off('resize', resizeCb);
    if ($scope.timelineDatePicker) $scope.timelineDatePicker.destroy();
    $('.dashboard_inrs').css('background', 'none');
  });
  $scope.$on('showPeopleEvtPlayerDlg', function (event, param) {
    $scope.showPeopleEvtPlayer(param);
  });
  $scope.shopObject = null;
  $scope.timelineDatePicker = null;
  $scope.isLoadingEvent = false;
  $scope.selectDate = null;
  $scope.startDate = null;
  $scope.endDate = null;
  $scope.eventsByPeople = {};
  $scope.peopleList = [];
  $scope.hideTimeline = false;
  $scope.isToday = false;
  $scope.hasConfigPermission = false;
  $scope.currentTime = moment().format("HH:mm");
  var resizeTimeout = null;
  $(window).on('resize', resizeCb);
  function resizeCb() {
    if (resizeTimeout) {
      clearTimeout(resizeTimeout);
    }
    resizeTimeout = setTimeout(function () {
      $scope.hideTimeline = true;
      $scope.$apply();
      $scope.hideTimeline = false;
      $scope.$apply();
    }, 400);
  }
  function getCameraLabel(cameraId) {
    var labelName = '';
    if ($scope.shopObject && $scope.shopObject.controllerList) {
      $scope.shopObject.controllerList.some(function (controller) {
        if (controller.deviceType === 'CAMERA' && controller.cameraInfo.id === cameraId) {
          labelName = controller.cameraInfo.labelName;
          return true;
        }
        return false;
      });
    }
    return labelName;
  }
  function getDateRange(timestamp) {
    var startDate = new Date(timestamp),
      endDate = new Date(timestamp);
    startDate.setHours(0);
    startDate.setMinutes(0);
    startDate.setSeconds(0);
    endDate.setHours(23);
    endDate.setMinutes(59);
    endDate.setSeconds(59);
    return {
      startDate: startDate,
      endDate: endDate
    };
  }
  function groupEvtByPeople(events) {
    var lastDetectDateByPeople = {};
    var camLabelMap = {};
    $scope.eventsByPeople = {};
    if (!events && !events.length) {
      return;
    }
    events.sort(function (a, b) {
      return a.detectDate < b.detectDate ? -1 : a.detectDate > b.detectDate ? 1 : 0;
    });
    events.forEach(function (evt) {
      if (!camLabelMap[evt.deviceId]) {
        camLabelMap[evt.deviceId] = getCameraLabel(evt.deviceId);
      }
      if ($scope.eventsByPeople[evt.detectPerson.id]) {
        if (lastDetectDateByPeople[evt.detectPerson.id] + 40 * 60 * 1000 > evt.detectDate) {
          evt.detectTime = ' ';
        }
        lastDetectDateByPeople[evt.detectPerson.id] = evt.detectDate;
        $scope.eventsByPeople[evt.detectPerson.id].events.push({
          detectDate: evt.detectDate,
          detectTime: evt.detectTime,
          deviceId: evt.deviceId,
          deviceName: camLabelMap[evt.deviceId],
          eventId: evt.eventId
        });
      } else {
        $scope.eventsByPeople[evt.detectPerson.id] = {
          events: [{
            detectDate: evt.detectDate,
            detectTime: evt.detectTime,
            deviceId: evt.deviceId,
            deviceName: camLabelMap[evt.deviceId],
            eventId: evt.eventId
          }],
          people: evt.detectPerson
        };
        lastDetectDateByPeople[evt.detectPerson.id] = evt.detectDate;
      }
    });
  }
  function updatePeopleList() {
    $scope.peopleList = [];
    var key;
    for (key in $scope.eventsByPeople) {
      $scope.peopleList.push($scope.eventsByPeople[key].people);
    }
    $scope.peopleList.sort(function (a, b) {
      var aLabel, bLabel;
      aLabel = a.name.toLowerCase();
      bLabel = b.name.toLowerCase();
      return aLabel < bLabel ? -1 : aLabel > bLabel ? 1 : 0;
    });
  }
  function fetchAiEvents() {
    if (!$scope.startDate || !$scope.endDate) {
      return;
    }
    $scope.isLoadingEvent = true;
    $scope.peopleList = [];
    $scope.eventsByPeople = {};
    Shop.dashboardShopV4({
      shopId: $stateParams.shopId
    }).$promise.then(function (res) {
      $scope.shopObject = res.shop;
      AiFace.eventsByRange({
        shopId: $stateParams.shopId,
        startDate: $scope.startDate.valueOf(),
        endDate: $scope.endDate.valueOf()
      }).$promise.then(function (res) {
        $scope.isLoadingEvent = false;
        if (res.code === 'ok') {
          $scope.hasConfigPermission = res.hasConfigPermission;
          groupEvtByPeople(res.events);
          updatePeopleList();
        }
        $scope.currentTime = moment().format("HH:mm");
        $scope.currentTimedotArea();
      }, function (err) {
        $scope.isLoadingEvent = false;
      });
    }, function (err) {
      $scope.isLoadingEvent = false;
    });
  }
  function checkIsToday(graphDate) {
    if (!graphDate) {
      return true;
    }
    var today = new Date();
    if (today <= graphDate || today.getFullYear() === graphDate.getFullYear() && today.getMonth() === graphDate.getMonth() && today.getDate() === graphDate.getDate()) {
      return true;
    } else {
      return false;
    }
  }
  $scope.showPeopleEvtPlayer = function (param) {
    $scope.isShowAiFaceSetPeopleDialog = false;
    $scope.eventInfo = param.eventInfo;
    $scope.person = param.person;
    $scope.isShared = !!$scope.shopObject.shareId;
    $scope.isShowAiFacePeopleEventPlayDialog = true;
  };
  $scope.playAiEvent = function (event) {
    $scope.eventInfo = event;
    $scope.isShared = !!$scope.shopObject.shareId;
    $scope.isShowAiFaceEventPlayDialog = true;
    $scope.$apply();
  };
  $scope.goToday = function () {
    if ($scope.isToday) {
      return;
    }
    $scope.selectDate = new Date();
    $scope.timelineDatePicker.setDate($scope.selectDate);
  };
  $scope.currentTimedotArea = function () {
    $timeout(function () {
      var currentTimedotArea = $(".currentTimeDot").parent()[0];
      if (currentTimedotArea) {
        $scope.divX = $(currentTimedotArea).offset().left;
        $scope.divY = $(currentTimedotArea).offset().top;
        $(".dotted_time").css("left", $scope.divX);
        $(".dotted_time").css("top", $scope.divY);
      }
    });
  };
  $scope.toggleTimelineCalendar = function (event) {
    if ($scope.timelineDatePicker) {
      if ($scope.timelineDatePicker.isVisible()) {
        $scope.timelineDatePicker.hide();
      } else {
        $scope.timelineDatePicker.show();
      }
    }
    event.stopPropagation();
    event.preventDefault();
  };
  $scope.moveNextDate = function (isPrev) {
    if ($scope.isToday && !isPrev) {
      return;
    }
    if ($scope.selectDate) {
      if (isPrev) {
        $scope.selectDate.setDate($scope.selectDate.getDate() - 1);
      } else {
        $scope.selectDate.setDate($scope.selectDate.getDate() + 1);
      }
      $scope.timelineDatePicker.setDate($scope.selectDate);
    }
  };
  $scope.setDate = function (date) {
    $scope.selectDate = date;
    $scope.isToday = checkIsToday($scope.selectDate);
    var dateRange = getDateRange($scope.selectDate.valueOf());
    $scope.startDate = dateRange.startDate;
    $scope.endDate = dateRange.endDate;
  };
  function initCalendar(dateObj) {
    $scope.setDate(dateObj);
    $scope.timelineDatePicker = new Pikaday({
      field: document.getElementById('timelineDate'),
      container: document.getElementById('calendarContainer'),
      format: $translate.instant('CLIP_CREATE_CLIP_DATE_FORMAT'),
      //minDate: minDate.toDate(),
      maxDate: new Date(),
      defaultDate: dateObj,
      position: 'bottom right',
      onSelect: function onSelect(date) {
        $scope.setDate(date);
        fetchAiEvents();
      }
    });
  }
  $scope.showAiFaceSetPeopleDlg = function (person, event) {
    $scope.selectPersonId = person.id;
    $scope.isShowAiFaceSetPeopleDialog = true;
    $scope.selectedAccount = {
      userId: person.userId
    };
    event.preventDefault();
    event.stopPropagation();
  };
  function initPage() {
    var dateObj = new Date();
    initCalendar(dateObj);
    fetchAiEvents();
    $('.dashboard_inrs').css('background', 'white');
  }
  initPage();
}]);
"use strict";

app.controller("AiFaceSetCtrl", ["$scope", "$rootScope", "$state", "$compile", "$translate", "$stateParams", "$timeout", "AiFace", "Utils", function ($scope, $rootScope, $state, $compile, $translate, $stateParams, $timeout, AiFace, Utils) {
  $scope.listChild = null;
  $scope.contentChild = null;
  $scope.isShowAiFaceSetDialog = false;
  $scope.isShowAiFaceGroupDialog = false;
  $scope.isShowAiFaceAddPhotoDialog = false;
  $scope.isShowAiFaceRegistDialog = false;
  $scope.isShowAccList = false;
  $scope.selectTab = $stateParams.tab === "group" ? "group" : "man";
  $scope.selectedAccount = null;
  $scope.selectedUserId = null;
  $scope.selectedGroup = null;
  $scope.nextPoolToken = null;
  $scope.sysGroups = [];
  $scope.selectPersonId = null;
  $scope.authAccounts = [];
  $scope.groups = [];
  $scope.peopleList = [];
  $scope.poolList = [];
  $scope.isLoadGroup = false;
  $scope.isLoadedGroup = false;
  $scope.isLoadPeople = false;
  $scope.isLoadPool = false;
  $scope.isLoadMorePool = false;
  $scope.addingPoolId = null;
  $scope.browserCountry = $("html").attr("lang");
  $scope.POOL_SHOW_MODE = {
    NORMAL: "1",
    EDIT: "2",
    SELECT: "3"
  };
  $scope.ORDER_TYPE_ENUM = {
    REG_ASC: "1",
    REG_DESC: "2",
    NAME_ASC: "3",
    NAME_DESC: "4"
  };
  $scope.STORAGE_KEY = {
    MAN_ORDER: "MAN_ORDERING",
    GRP_ORDER: "GRP_ORDERING",
    CLOSE_DRAG_NOTI: "CLOSE_DRAG_NOTI"
  };
  $scope.GROUP_EDIT_MODE = {
    NORMAL: "1",
    GROUP_LIST: "2",
    PERSON_LIST: "3",
    GROUP_NAME: "4"
  };
  $scope.PEOPLE_EDIT_MODE = {
    NORMAL: "1",
    EDIT: "2"
  };
  $scope.groupEditMode = $scope.GROUP_EDIT_MODE.NORMAL;
  $scope.peopleEditMode = $scope.PEOPLE_EDIT_MODE.NORMAL;
  $scope.selectedOrderType = getOrderTypeFromLocalStorage("group");
  $scope.selectedPeopleOrderType = getOrderTypeFromLocalStorage("man");
  var poolFetchCount = 120;
  var poolFetchScrollPos = 55;
  var throttleTime = 300;
  function buildAuthAccounts(recieveAccounts) {
    $scope.authAccounts = [];
    if (recieveAccounts && recieveAccounts.length) {
      $scope.authAccounts = recieveAccounts;
    }
  }
  function fetchRecievedAccounts(userId) {
    AiFace.accounts().$promise.then(function (res) {
      if (res.code === "ok") {
        buildAuthAccounts(res.accounts);
      }
      if ($scope.selectedUserId) {
        var idExist = false;
        idExist = $scope.authAccounts.some(function (account) {
          return account.userId === $scope.selectedUserId;
        });
        $scope.selectAccount(idExist ? $scope.selectedUserId : $scope.authAccounts[0].userId);
      } else {
        $scope.selectAccount($scope.authAccounts[0].userId);
      }
    }, function (err) {
      $scope.selectAccount($scope.authAccounts[0].userId);
    });
  }
  function strIncludeSomeCheck(targetStr, checkArr) {
    if (!checkArr || !checkArr.length) {
      return false;
    }
    return checkArr.some(function (checkStr) {
      return targetStr.indexOf(checkStr) !== -1;
    });
  }
  function globalClickCallback(event) {
    var needRedraw = false;
    if ($scope.groupEditMode === $scope.GROUP_EDIT_MODE.GROUP_NAME) {
      if (event.target.id.indexOf("group_name_editor") === -1) {
        $scope.saveGroupName($scope.contentChild.groupEditName);
      }
    } else {
      if (!strIncludeSomeCheck(event.target.className, ["drops_element", "drop_btn"])) {
        needRedraw = $scope.listChild.closeEditMenu();
      }
    }
    if ($scope.contentChild.showSearchResult && event.target.type !== "search") {
      $scope.contentChild.showSearchResult = false;
      needRedraw = true;
    }
    if ($scope.contentChild.showFilterCams && !strIncludeSomeCheck(event.target.className, ["selector", "filter_btn_text", "triangle_down", "ai-filter-img"])) {
      $scope.contentChild.showFilterCams = false;
      needRedraw = true;
    }
    if ($scope.contentChild.showPoolOption && !strIncludeSomeCheck(event.target.className, ["selector", "filter_btn_text", "triangle_down", "ai-filter-img"])) {
      $scope.contentChild.showPoolOption = false;
      needRedraw = true;
    }
    if ($scope.contentChild.isShowFaceAddOptions && !strIncludeSomeCheck(event.target.className, ["ad_btn_img", "ad_text", "ai_pool_add_btn"])) {
      $scope.contentChild.isShowFaceAddOptions = false;
      needRedraw = true;
    }
    if ($scope.isShowAccList && !strIncludeSomeCheck(event.target.className, ["acc_lst_click", "triangle_down", "acc_img_share"])) {
      $scope.isShowAccList = false;
      needRedraw = true;
    }
    if (needRedraw) {
      $scope.$apply();
    }
  }
  $scope.$on("setGroupEditMode", function (event, mode) {
    $scope.setGroupEditMode(mode);
  });
  $scope.$on("setPeopleEditMode", function (event, mode) {
    $scope.setPeopleEditMode(mode);
  });
  $scope.$on("deletePeoples", function (event, peopleSelectList) {
    $scope.deletePeoples(peopleSelectList);
  });
  $scope.$on("deleteGroups", function (event, groupSelectList) {
    $scope.deleteGroups(groupSelectList);
  });
  $scope.$on("updateGroup", function (event, updateParam) {
    $scope.updateGroup(updateParam);
  });
  $scope.$on("deletePools", function (event, deleteParam) {
    $scope.deletePools(deleteParam);
  });
  $scope.$on("fetchPools", function (event) {
    $scope.fetchPools();
  });
  $scope.$on("groupOrderChange", function (event, type) {
    $scope.groupOrderChange(type);
  });
  $scope.$on("peopleOrderChange", function (event, type) {
    $scope.peopleOrderChange(type);
  });
  $scope.$on("selectSearchResult", function (event, result) {
    $scope.selectSearchResult(result);
  });
  $scope.$on("showAiFaceSetPeopleDlg", function (event, param) {
    $scope.showAiFaceSetPeopleDlg(param.id, param.isEdit);
  });
  $scope.$on("showAiFaceGroupDlg", function (event) {
    $scope.showAiFaceGroupDlg();
  });
  $scope.$on("showAiFaceAddPeopleDlg", function (event) {
    $scope.showAiFaceAddPeopleDlg();
  });
  $scope.$on("showAiFaceAddPhotoDlg", function (event) {
    $scope.showAiFaceAddPhotoDlg();
  });
  $scope.$on("showAiFaceRegistDlg", function (event) {
    $scope.showAiFaceRegistDlg();
  });
  $scope.$on("showPeopleEvtPlayerDlg", function (event, param) {
    $scope.showPeopleEvtPlayer(param);
  });
  $scope.$on("selectGroup", function (event, group) {
    $scope.selectGroup(group);
  });
  $scope.groupOrderChange = function (type) {
    $scope.orderingByType($scope.groups, type);
    $scope.selectedOrderType = type;
    setOrderTypeFromLocalStorage("group", $scope.selectedOrderType);
  };
  $scope.peopleOrderChange = function (type) {
    $scope.orderingByType($scope.peopleList, type);
    $scope.selectedPeopleOrderType = type;
    setOrderTypeFromLocalStorage("man", $scope.selectedPeopleOrderType);
  };
  $scope.setGroupEditMode = function (mode) {
    $scope.contentChild.setGroupEditMode(mode);
    $scope.listChild.setGroupEditMode(mode);
    if (mode === $scope.GROUP_EDIT_MODE.PERSON_LIST) {
      if ($scope.selectedGroup && $scope.selectedGroup.persons) {
        $scope.selectedGroup.persons.forEach(function (item) {
          item.isChecked = false;
        });
      }
    } else if (mode === $scope.GROUP_EDIT_MODE.GROUP_LIST) {
      if ($scope.groups) {
        $scope.groups.forEach(function (item) {
          item.isChecked = false;
        });
      }
    }
    $scope.groupEditMode = mode;
  };
  $scope.updateGroup = function (updateParam) {
    AiFace.updateGroup({
      userId: $scope.selectedAccount.userId,
      groupId: $scope.selectedGroup.id
    }, updateParam).$promise.then(function (res) {
      if (res.code === "ok") {
        $scope.contentChild.showNotiMsg($translate.instant("9rRqk7Vo_02417"));
        if (updateParam.deleteIds) {
          $scope.contentChild.groupSelectPeoplList = [];
        }
        $scope.setGroupEditMode($scope.GROUP_EDIT_MODE.NORMAL);
        $scope.fetchGroups($scope.selectedAccount.userId);
      }
    }, function (err) {
      $rootScope.createConfirm({
        title: $translate.instant("ACCESS_NET_FAIL"),
        description: $translate.instant("ACCESS_NET_FAIL_DESC"),
        btnCount: 1
      });
    });
  };
  $scope.$on("saveGroupName", function (event, groupEditName) {
    $scope.saveGroupName(groupEditName);
  });
  $scope.saveGroupName = function (groupEditName) {
    if (!groupEditName) {
      $scope.setGroupEditMode($scope.GROUP_EDIT_MODE.NORMAL);
      $scope.$apply();
      return;
    }
    AiFace.updateGroup({
      userId: $scope.selectedAccount.userId,
      groupId: $scope.selectedGroup.id
    }, {
      name: groupEditName
    }).$promise.then(function (res) {
      $scope.selectedGroup.name = groupEditName;
      $scope.setGroupEditMode($scope.GROUP_EDIT_MODE.NORMAL);
    }, function (err) {
      $rootScope.createConfirm({
        title: $translate.instant("ACCESS_NET_FAIL"),
        description: $translate.instant("ACCESS_NET_FAIL_DESC"),
        btnCount: 1
      });
    });
  };
  $scope.setPeopleEditMode = function (mode) {
    if ($scope.peopleList) {
      $scope.peopleList.forEach(function (item) {
        item.isChecked = false;
      });
      $scope.listChild.peopleSelectList = [];
    }
    $scope.peopleEditMode = mode;
  };
  $scope.deletePeoples = function (peopleSelectList) {
    var peopleIds = [];
    peopleSelectList.forEach(function (item) {
      peopleIds.push(item.id);
    });
    AiFace.deletePeople({
      userId: $scope.selectedAccount.userId,
      personIds: peopleIds
    }).$promise.then(function (res) {
      if (res.code === "ok") {
        $scope.listChild.showNotiMsg($translate.instant("9rRqk7Vo_02416"));
        $scope.setPeopleEditMode($scope.PEOPLE_EDIT_MODE.NORMAL);
        $scope.fetchPeoples($scope.selectedAccount.userId);
        $scope.fetchPools();
      }
    }, function (err) {});
  };
  $scope.deleteGroups = function (groupSelectList) {
    var groupIds = "";
    groupSelectList.forEach(function (item) {
      if (groupIds) {
        groupIds += "," + item.id;
      } else {
        groupIds += item.id;
      }
    });
    $.ajax({
      url: "/json/biz/ai/face/user/" + $scope.selectedAccount.userId + "/groups?groupIds=" + groupIds,
      type: "DELETE",
      success: function success(dataStr) {
        var data = JSON.parse(dataStr);
        if (data.code === "ok") {
          $scope.listChild.showNotiMsg($translate.instant("9rRqk7Vo_02416"));
          $scope.setGroupEditMode($scope.GROUP_EDIT_MODE.NORMAL);
          $scope.fetchGroups($scope.selectedAccount.userId);
        }
      },
      error: function error(e) {}
    });
  };
  $scope.deletePools = function (param) {
    var poolIds = "";
    param.poolSelectList.forEach(function (item) {
      if (poolIds) {
        poolIds += "," + item.id;
      } else {
        poolIds += item.id;
      }
    });
    $.ajax({
      url: "/json/biz/ai/face/user/" + $scope.selectedAccount.userId + "/pool?poolIds=" + poolIds,
      type: "DELETE",
      success: function success(dataStr) {
        $scope.fetchPools();
        $scope.setPoolMode($scope.POOL_SHOW_MODE.NORMAL);
      },
      error: function error(e) {}
    });
  };
  $scope.setPoolMode = function (mode) {
    $scope.contentChild.setPoolMode(mode);
  };
  $scope.fetchAiCameras = function (userId) {
    AiFace.aiCamera({
      userId: userId
    }).$promise.then(function (res) {
      $scope.contentChild.selectedFilterIdx = null;
      $scope.aiCameras = res.cameras;
    }, function (err) {});
  };
  function orderGroupPersonsByName(group) {
    if (!group || !group.persons) {
      return;
    }
    group.persons.sort(function (a, b) {
      var aLabel, bLabel;
      aLabel = a.name.toLowerCase();
      bLabel = b.name.toLowerCase();
      return aLabel < bLabel ? -1 : aLabel > bLabel ? 1 : 0;
    });
  }
  function footerShowControl(isShow) {
    var $footer = $("#toastFooter");
    if (!$footer.length) {
      return;
    }
    if (!isShow && $scope.nextPoolToken) {
      $footer.hide();
    } else {
      $footer.show();
    }
  }
  function checkSelectPool(poolList) {
    if (!$scope.contentChild.poolSelectList.length) {
      return;
    }
    var poolSelectsCopy = $scope.contentChild.poolSelectList.filter(function (select) {
      return select.id;
    });
    poolList.forEach(function (pool) {
      var i,
        len = poolSelectsCopy.length;
      for (i = 0; i < len; i += 1) {
        if (poolSelectsCopy[i].id === pool.id) {
          pool.isChecked = true;
          poolSelectsCopy.splice(i, 1);
          break;
        }
      }
    });
  }
  $scope.fetchPools = function () {
    if ($scope.selectTab !== "man") {
      return;
    }
    $scope.poolList = [];
    var selDate = $scope.contentChild.getCurSelectDate() ? $scope.contentChild.getCurSelectDate() : new Date();
    var params = {
      userId: $scope.selectedAccount.userId,
      date: selDate.valueOf(),
      maxResults: poolFetchCount
    };
    if ($scope.aiCameras && $scope.contentChild.selectedFilterIdx !== null) {
      params.filterIds = $scope.aiCameras[$scope.contentChild.selectedFilterIdx].id;
    }
    $scope.isLoadPool = true;
    void 0;
    AiFace.faces(params).$promise.then(function (res) {
      $(window).scrollTop(0);
      $scope.isLoadPool = false;
      $scope.nextPoolToken = res.nextToken;
      if (res.faces) {
        checkSelectPool(res.faces);
      }
      $scope.poolList = res.faces ? res.faces : [];
      footerShowControl();
    }, function (err) {
      $scope.isLoadPool = false;
    });
  };
  $scope.fetchMorePools = function () {
    if (!$scope.nextPoolToken || $scope.selectTab !== "man") {
      return;
    }
    var selDate = $scope.contentChild.getCurSelectDate() ? $scope.contentChild.getCurSelectDate() : new Date();
    var params = {
      userId: $scope.selectedAccount.userId,
      date: selDate.valueOf(),
      pageToken: $scope.nextPoolToken,
      maxResults: poolFetchCount
    };
    if ($scope.aiCameras && $scope.contentChild.selectedFilterIdx !== null) {
      params.filterIds = $scope.aiCameras[$scope.contentChild.selectedFilterIdx].id;
    }
    $scope.isLoadMorePool = true;
    void 0;
    AiFace.faces(params).$promise.then(function (res) {
      $scope.isLoadMorePool = false;
      $scope.nextPoolToken = res.nextToken;
      checkSelectPool(res.faces);
      $scope.poolList = $scope.poolList.concat(res.faces);
      footerShowControl();
    }, function (err) {
      $scope.isLoadMorePool = false;
    });
  };
  var throttleFunc = new Utils.throttling().throttle(function (event) {
    if ($scope.poolList && $scope.poolList.length >= poolFetchCount) {
      var currentPercentage = $(window).scrollTop() / ($(document).outerHeight() - $(window).height()) * 100;
      void 0;
      if (currentPercentage > poolFetchScrollPos && !$scope.isLoadMorePool) {
        $scope.fetchMorePools();
      }
    }
  }, throttleTime);
  $(window).on("scroll", throttleFunc);
  $scope.fetchPeoples = function (userId) {
    $scope.contentChild.setPoolMode($scope.contentChild.POOL_SHOW_MODE.NORMAL);
    $scope.isLoadPeople = true;
    AiFace.persons({
      userId: userId
    }).$promise.then(function (res) {
      $scope.isLoadPeople = false;
      $scope.peopleList = res.persons;
      $scope.orderingByType($scope.peopleList, $scope.selectedPeopleOrderType);
    }, function (err) {
      $scope.isLoadPeople = false;
    });
  };
  $scope.fetchGroups = function (userId, selectGroupId) {
    $scope.isLoadGroup = true;
    AiFace.groups({
      userId: userId
    }).$promise.then(function (res) {
      $timeout(function () {
        $scope.isLoadGroup = false;
        $scope.isLoadedGroup = true;
      }, 100);
      var personMap = {};
      $scope.groups = [];
      $scope.sysGroups = [];
      if (res.groups) {
        res.groups.forEach(function (group) {
          if (group.groupType === "custom") {
            $scope.groups.push(group);
          } else {
            $scope.sysGroups.push(group);
          }
        });
      }
      $scope.orderingByType($scope.groups, $scope.selectedOrderType);
      if (res.noGroupPersonIds && res.noGroupPersonIds.length) {
        $scope.sysGroups.push({
          id: "",
          name: $translate.instant("9rRqk7Vo_02314"),
          regDate: 0,
          persons: [],
          personIds: res.noGroupPersonIds
        });
      }
      if (res.persons) {
        res.persons.forEach(function (person) {
          personMap[person.id] = person;
        });
      }
      $scope.groups.forEach(function (group) {
        group.persons = [];
        group.personIds.forEach(function (pId) {
          group.persons.push(personMap[pId]);
        });
      });
      $scope.sysGroups.forEach(function (group) {
        group.persons = [];
        group.personIds.forEach(function (pId) {
          group.persons.push(personMap[pId]);
        });
      });
      var selGroupId = selectGroupId || ($scope.selectedGroup ? $scope.selectedGroup.id : null);
      if (selGroupId) {
        var i, len;
        for (i = 0, len = $scope.groups.length; i < len; i += 1) {
          if ($scope.groups[i].id === selGroupId) {
            $scope.selectedGroup = $scope.groups[i];
            orderGroupPersonsByName($scope.selectedGroup);
            return;
          }
        }
        for (i = 0, len = $scope.sysGroups.length; i < len; i += 1) {
          if ($scope.sysGroups[i].id === selGroupId) {
            $scope.selectedGroup = $scope.sysGroups[i];
            orderGroupPersonsByName($scope.selectedGroup);
            return;
          }
        }
      }
      $scope.selectedGroup = $scope.groups.length ? $scope.groups[0] : $scope.sysGroups[0];
      orderGroupPersonsByName($scope.selectedGroup);
    }, function (err) {
      $timeout(function () {
        $scope.isLoadGroup = false;
        $scope.isLoadedGroup = true;
      }, 100);
    });
  };
  $scope.changeTab = function (tab) {
    $state.go("main.aiface.content", {
      tab: tab
    }, {
      reload: false,
      inherit: true,
      notify: false
    });
    $scope.isLoadedGroup = false;
    $scope.selectTab = tab;
    $scope.contentChild.initValues();
    $scope.listChild.initValues();
    footerShowControl(true);
    $scope.peopleList = [];
    $scope.poolList = [];
    $scope.groups = [];
    $scope.selectedGroup = null;
    if (tab === "man") {
      $scope.setPoolMode($scope.POOL_SHOW_MODE.NORMAL);
      $scope.fetchPeoples($scope.selectedAccount.userId);
      $scope.fetchPools();
      $scope.fetchGroups($scope.selectedAccount.userId);
    } else {
      $scope.fetchGroups($scope.selectedAccount.userId);
      $scope.setGroupEditMode($scope.GROUP_EDIT_MODE.NORMAL);
    }
  };
  $scope.orderingByType = function (list, type) {
    if (!list || !list.length) {
      return;
    }
    if (type === $scope.ORDER_TYPE_ENUM.REG_ASC) {
      list.sort(function (a, b) {
        return a.regDate > b.regDate ? -1 : a.regDate < b.regDate ? 1 : 0;
      });
    } else if (type === $scope.ORDER_TYPE_ENUM.REG_DESC) {
      list.sort(function (a, b) {
        return a.regDate < b.regDate ? -1 : a.regDate > b.regDate ? 1 : 0;
      });
    } else if (type === $scope.ORDER_TYPE_ENUM.NAME_ASC) {
      list.sort(function (a, b) {
        var aLabel, bLabel;
        aLabel = a.name.toLowerCase();
        bLabel = b.name.toLowerCase();
        return aLabel < bLabel ? -1 : aLabel > bLabel ? 1 : 0;
      });
    } else if (type === $scope.ORDER_TYPE_ENUM.NAME_DESC) {
      list.sort(function (a, b) {
        var aLabel, bLabel;
        aLabel = a.name.toLowerCase();
        bLabel = b.name.toLowerCase();
        return aLabel > bLabel ? -1 : aLabel < bLabel ? 1 : 0;
      });
    } else {
      list.sort(function (a, b) {
        return a.regDate > b.regDate ? -1 : a.regDate < b.regDate ? 1 : 0;
      });
    }
  };
  $scope.selectSearchResult = function (result) {
    var i, len;
    len = $scope.groups.length;
    for (i = 0; i < len; i += 1) {
      if ($scope.groups[i].id === result.id) {
        $scope.selectedGroup = $scope.groups[i];
        orderGroupPersonsByName($scope.selectedGroup);
        return;
      }
    }
    len = $scope.sysGroups.length;
    for (i = 0; i < len; i += 1) {
      if ($scope.sysGroups[i].id === result.id) {
        $scope.selectedGroup = $scope.sysGroups[i];
        orderGroupPersonsByName($scope.selectedGroup);
        return;
      }
    }
  };
  $scope.selectGroup = function (group) {
    $scope.contentChild.selectedSearchResult = null;
    if ($scope.groupEditMode !== $scope.GROUP_EDIT_MODE.GROUP_LIST) {
      if (group) {
        $scope.selectedGroup = group;
        orderGroupPersonsByName($scope.selectedGroup);
      } else {
        $scope.sysGroups.some(function (sysgrp) {
          if (!sysgrp.id) {
            $scope.selectedGroup = sysgrp;
            orderGroupPersonsByName($scope.selectedGroup);
          }
          return !sysgrp.id;
        });
      }
    }
  };
  $scope.selectAccount = function (userId) {
    if ($scope.selectedAccount) {
      $state.go("main.aiface.content", {
        tab: $scope.selectTab,
        user: userId
      }, {
        reload: false,
        inherit: true,
        notify: false
      });
    }
    $scope.setPoolMode($scope.POOL_SHOW_MODE.NORMAL);
    $timeout(function () {
      var i,
        len = $scope.authAccounts.length;
      for (i = 0; i < len; i += 1) {
        if ($scope.authAccounts[i].userId === userId) {
          $scope.selectedAccount = $scope.authAccounts[i];
          break;
        }
      }
      $scope.selectedGroup = null;
      if (!$scope.contentChild.selectDate) {
        $scope.contentChild.setDate(new Date());
      }
      $scope.contentChild.selectedFilterIdx = null;
      $scope.fetchGroups(userId);
      $scope.fetchAiCameras(userId);
      $scope.fetchPools();
      $scope.fetchPeoples(userId);
    }, 100);
  };
  $scope.toggleAiFaceSetDlg = function () {
    $scope.isShowAiFaceSetDialog = !$scope.isShowAiFaceSetDialog;
  };
  $scope.showAiFaceGroupDlg = function () {
    $scope.isShowAiFaceGroupDialog = true;
  };
  $scope.showAiFaceAddPeopleDlg = function () {
    $scope.isShowAiFaceAddPeopleDialog = true;
  };
  $scope.showAiFaceSetPeopleDlg = function (id, isEdit) {
    $scope.selectPersonId = id;
    $scope.isPersonEditMode = isEdit;
    $scope.isShowAiFaceSetPeopleDialog = true;
  };
  $scope.showAiFaceAddPhotoDlg = function () {
    $scope.poolSelectList = $scope.contentChild.poolSelectList;
    $scope.isShowAiFaceAddPhotoDialog = true;
  };
  $scope.showAiFaceRegistDlg = function () {
    $scope.poolSelectList = $scope.contentChild.poolSelectList;
    $scope.isShowAiFaceRegistDialog = true;
  };
  $scope.showAiCamModeSetDlg = function () {
    $scope.isShowAiFaceSetDialog = false;
    $scope.isShowAiCamModeSetDialog = true;
  };
  $scope.hideAiCamModeSetDlg = function () {
    $scope.isShowAiFaceSetDialog = true;
    $scope.isShowAiCamModeSetDialog = false;
    $scope.fetchAiCameras($scope.selectedAccount.userId);
  };
  $scope.showAiServRegDlg = function () {
    $scope.isShowAiFaceSetDialog = false;
    $scope.isShowAiFaceServiceRegDialog = true;
  };
  $scope.hideAiServRegDlg = function () {
    $scope.isShowAiFaceSetDialog = true;
    $scope.isShowAiFaceServiceRegDialog = false;
  };
  $scope.showPeopleEvtPlayer = function (param) {
    $scope.isShowAiFaceSetPeopleDialog = false;
    $scope.eventInfo = param.eventInfo;
    $scope.person = param.person;
    $scope.isShared = !!$scope.selectedAccount.isShared;
    $scope.isShowAiFacePeopleEventPlayDialog = true;
  };
  function getOrderTypeFromLocalStorage(subject) {
    var clientUid = "";
    if ($rootScope.me && $rootScope.me.uid) {
      clientUid = $rootScope.me.uid;
    }
    var itemKey = (subject === "man" ? $scope.STORAGE_KEY.MAN_ORDER : $scope.STORAGE_KEY.GRP_ORDER) + clientUid,
      orderData = localStorage.getItem(itemKey);
    if (orderData) {
      return orderData;
    } else {
      return $scope.ORDER_TYPE_ENUM.NAME_ASC;
    }
  }
  function setOrderTypeFromLocalStorage(subject, type) {
    var clientUid = "";
    if ($rootScope.me && $rootScope.me.uid) {
      clientUid = $rootScope.me.uid;
    }
    var itemKey = (subject === "man" ? $scope.STORAGE_KEY.MAN_ORDER : $scope.STORAGE_KEY.GRP_ORDER) + clientUid;
    localStorage.setItem(itemKey, type);
  }
  $scope.$on("aifacePeopleUpdate", function () {
    $scope.fetchPeoples($scope.selectedAccount.userId);
    $scope.fetchGroups($scope.selectedAccount.userId);
  });
  $scope.$on("aifaceGroupUpdate", function () {
    $scope.fetchGroups($scope.selectedAccount.userId);
  });
  $scope.$on("aifaceGroupAdd", function (event, groupId) {
    $scope.fetchGroups($scope.selectedAccount.userId, groupId);
  });
  $scope.$on("showAiCamModeSetDlg", function () {
    $scope.showAiCamModeSetDlg();
  });
  $scope.$on("hideAiCamModeSetDlg", function () {
    $scope.hideAiCamModeSetDlg();
  });
  $scope.$on("showAiServRegDlg", function () {
    $scope.showAiServRegDlg();
  });
  $scope.$on("hideAiServRegDlg", function () {
    $scope.hideAiServRegDlg();
  });
  $scope.$on("$destroy", function () {
    $("body").off("click", globalClickCallback);
    $("body").removeClass("blockScroll");
    $(window).off("scroll", throttleFunc);
    footerShowControl(true);
    window.aiPoolAllowDrop = null;
    window.aiPoolLeaveDrop = null;
    window.aiPoolDragStart = null;
    window.aiPoolDragEnd = null;
    window.aiPoolDrop = null;
  });
  $scope.setListChildScope = function (scope) {
    $scope.listChild = scope;
  };
  $scope.setContentChildScope = function (scope) {
    $scope.contentChild = scope;
  };

  /***** Drag & Drop Start *******/
  window.aiPoolAllowDrop = function (ev) {
    if (ev.currentTarget.className.indexOf("dropped") === -1) {
      ev.currentTarget.className = "ai_man_item dropped";
      $scope.$apply();
    }
    ev.preventDefault();
  };
  window.aiPoolLeaveDrop = function (ev) {
    if (ev.currentTarget.className.indexOf("dropped") !== -1) {
      ev.currentTarget.className = "ai_man_item";
      $scope.$apply();
    }
    ev.preventDefault();
  };
  function imgLayer(imgList, topImgIdx) {
    var imgLength = imgList.length,
      layerPos = imgList.length,
      movePxUnit = 5;
    imgList[topImgIdx].css("zIndex", layerPos);
    imgList[topImgIdx].css("left", 0);
    imgList[topImgIdx].css("top", 0);
    layerPos -= 1;
    imgList.forEach(function (img) {
      if (img === imgList[topImgIdx]) {
        return;
      }
      img.css("zIndex", layerPos);
      img.css("top", (imgLength - layerPos) * movePxUnit + "px");
      img.css("left", (imgLength - layerPos) * movePxUnit + "px");
      layerPos -= 1;
    });
  }
  window.aiPoolDragStart = function (ev) {
    var poolId = ev.currentTarget.getAttribute("data-id");
    if (!$scope.contentChild.poolSelectList.length) {
      var findItem = null;
      $scope.poolList.some(function (item) {
        if (item.id === poolId) {
          findItem = item;
        }
        return item.id === poolId;
      });
      if (findItem && !findItem.registed) {
        $scope.contentChild.selectPoolItem(findItem);
        $scope.$apply();
      } else {
        ev.preventDefault();
        return false;
      }
    } else {
      var isSelectItem = $scope.contentChild.poolSelectList.some(function (select) {
        return select.id === poolId;
      });
      if (!isSelectItem) {
        ev.preventDefault();
        return false;
      }
      var i,
        len = $scope.contentChild.dragGhostImgEls.length;
      if (len) {
        for (i = 0; i < len; i += 1) {
          if ($scope.contentChild.dragGhostImgEls[i].poolId === poolId) {
            break;
          }
        }
        imgLayer($scope.contentChild.dragGhostImgEls, i);
        ev.dataTransfer.setDragImage($scope.contentChild.dragGhostEl[0], 0, 0);
      }
    }
  };
  window.aiPoolDragEnd = function (ev) {};
  window.aiPoolDrop = function (ev) {
    var personId = ev.currentTarget.getAttribute("data-id");
    if (ev.currentTarget.className.indexOf("dropped") !== -1) {
      ev.currentTarget.className = "ai_man_item";
    }
    if ($scope.contentChild.poolSelectList.length && personId) {
      var addPoolIds = [];
      $scope.contentChild.poolSelectList.forEach(function (item) {
        addPoolIds.push(item.id);
      });
      $scope.addingPoolId = personId;
      AiFace.updatePeople({
        userId: $scope.selectedAccount.userId
      }, {
        personId: personId,
        addPoolIds: addPoolIds
      }).$promise.then(function (res) {
        $scope.addingPoolId = null;
        if (res.code === "ok") {
          $scope.contentChild.poolSelectList.forEach(function (item) {
            item.registed = true;
          });
          $scope.setPoolMode($scope.POOL_SHOW_MODE.NORMAL);
          $rootScope.createConfirm({
            title: $translate.instant("9rRqk7Vo_02315"),
            description: $translate.instant("9rRqk7Vo_02316"),
            btnCount: 1
          });
        } else {
          $rootScope.createConfirm({
            title: $translate.instant("9rRqk7Vo_02315"),
            description: $translate.instant("9rRqk7Vo_02317"),
            btnCount: 1
          });
        }
      }, function (err) {
        $scope.addingPoolId = null;
        $rootScope.createConfirm({
          title: $translate.instant("ACCESS_NET_FAIL"),
          description: $translate.instant("ACCESS_NET_FAIL_DESC"),
          btnCount: 1
        });
      });
    }
    ev.preventDefault();
  };
  /***** Drag & Drop End *******/

  function initPage() {
    $("body").on("click", globalClickCallback);
    //$scope.selectAccount($rootScope.me.userId);
    fetchRecievedAccounts($rootScope.me.userId);
    var $cont = $("#dlg_container");
    $cont.append($compile("<ai-face-set-dialog></ai-face-set-dialog>")($scope));
    $cont.append($compile("<ai-face-set-people-dialog></ai-face-set-people-dialog>")($scope));
    $cont.append($compile("<ai-face-group-dialog></ai-face-group-dialog>")($scope));
    $cont.append($compile("<ai-face-add-photo-dialog></ai-face-add-photo-dialog>")($scope));
    $cont.append($compile("<ai-face-add-people-dialog></ai-face-add-people-dialog>")($scope));
    $cont.append($compile("<ai-face-regist-dialog></ai-face-regist-dialog>")($scope));
    $cont.append($compile("<ai-cam-mode-set-dialog></ai-cam-mode-set-dialog>")($scope));
    $cont.append($compile("<ai-face-service-reg-dialog></ai-face-service-reg-dialog>")($scope));
    $cont.append($compile("<ai-face-people-event-play-dialog></ai-face-people-event-play-dialog>")($scope));
    $timeout(function () {
      $scope.isDlgLoaded = true;
    }, 800);
  }
  setTimeout(function () {
    if (!$rootScope.me) {
      $.ajax({
        type: "GET",
        url: "/json/biz/v2/users/me",
        success: function success(dateStr) {
          var data = JSON.parse(dateStr);
          if (data.code == "ok" || data.code == "nok" && data.errorCode == "-2") {
            $rootScope.me = data;
            initPage();
          } else {
            $state.go("main");
          }
        },
        error: function error(e) {
          $state.go("main");
        }
      });
    } else {
      initPage();
    }
  }, 0);
}]);
"use strict";

app.controller('AiFaceSetListCtrl', ['$scope', 'Camera', 'User', 'AiFace', '$state', '$rootScope', '$translate', '$timeout', '$interval', function ($scope, Camera, User, AiFace, $state, $rootScope, $translate, $timeout, $interval) {
  $scope.groupSelectList = [];
  $scope.peopleSelectList = [];
  $scope.searchStr = '';
  $scope.isPersonEditMode = false;
  $scope.showGroupsEdit = false;
  $scope.showPeopleEdit = false;
  $scope.changeGroupEditMode = function (mode) {
    $scope.$parent.$broadcast('setGroupEditMode', mode);
  };
  $scope.setGroupEditMode = function (mode) {
    if (mode === $scope.$parent.GROUP_EDIT_MODE.GROUP_LIST) {
      if ($scope.$parent.groups) {
        $scope.groupSelectList = [];
      }
    }
  };
  function dropdownHandler(event) {
    if ($scope.showGroupsEdit) {
      $scope.showGroupsEdit = false;
      $scope.$apply();
    }
  }
  function peopleDropdownHandler(event) {
    if ($scope.showPeopleEdit) {
      $scope.showPeopleEdit = false;
      $scope.$apply();
    }
  }
  function activePeopleDropdown(isActive) {
    if (orderPeopleDropObj) {
      orderPeopleDropObj.active = isActive;
    }
  }
  function activePeopleSearch(isActive) {
    if (peopleSearchObj) {
      peopleSearchObj.active = isActive;
    }
  }
  var orderDropObj = tCam.dropdown('aiface_order_dropdown');
  if (orderDropObj) {
    orderDropObj.on('changed', dropdownHandler);
    orderDropObj.dropElementId = 'aiface_order_list';
    orderDropObj.dropPosition = 'left';
  }
  var orderPeopleDropObj = tCam.dropdown('aiface_people_order_dropdown');
  if (orderPeopleDropObj) {
    orderPeopleDropObj.on('changed', peopleDropdownHandler);
    orderPeopleDropObj.dropElementId = 'aiface_people_order_list';
    orderPeopleDropObj.dropPosition = 'left';
  }
  var peopleSearchObj = tCam.search('search_people');
  if (peopleSearchObj) {
    peopleSearchObj.on('changed', peopleSearchHandler);
    peopleSearchObj.placeholder = $translate.instant('9rRqk7Vo_02399');
    peopleSearchObj.boxStyle = {
      width: '228px',
      height: '44px',
      border: '1px solid #f5f5f5',
      borderRadius: '6px',
      backgroundColor: '#f5f5f5',
      marginTop: '16px'
    };
    peopleSearchObj.design = 'search';
  }
  function peopleSearchHandler(event) {
    $scope.searchStr = event.value;
    $scope.$apply();
  }
  $scope.showNotiMsg = function (msg) {
    $scope.notiMsg = msg;
    $('#aiface_lnb_noti').fadeIn(500);
    if ($scope.notiTimeout) {
      $timeout.cancel($scope.notiTimeout);
    }
    $scope.notiTimeout = $timeout(function () {
      $('#aiface_lnb_noti').fadeOut(500, function () {
        $scope.notiMsg = '';
      });
    }, 2000);
  };
  $scope.closeEditMenu = function () {
    var needRedraw = false;
    if (orderDropObj) {
      orderDropObj.value = false;
    }
    if (orderPeopleDropObj) {
      orderPeopleDropObj.value = false;
    }
    if ($scope.showGroupsEdit || $scope.showPeopleEdit) {
      $scope.showGroupsEdit = false;
      $scope.showPeopleEdit = false;
      needRedraw = true;
    }
    return needRedraw;
  };
  $scope.checkIsPeopleShow = function (people) {
    if (!$scope.searchStr) {
      return true;
    }
    var lowerName = people.name ? people.name.toLowerCase() : '';
    var lowerSearch = $scope.searchStr ? $scope.searchStr.toLowerCase() : '';
    if (lowerName && lowerName.indexOf(lowerSearch) !== -1) {
      return true;
    }
    return false;
  };
  $scope.showPeopleDeleteConfirm = function () {
    $rootScope.createConfirm({
      title: $translate.instant('9rRqk7Vo_02335'),
      description: $translate.instant('9rRqk7Vo_02336'),
      handler: function handler() {
        $scope.$parent.$broadcast('deletePeoples', $scope.peopleSelectList);
      }
    });
  };
  $scope.showGroupDeleteConfirm = function () {
    $rootScope.createConfirm({
      description: $translate.instant('9rRqk7Vo_02318'),
      handler: function handler() {
        $scope.$parent.$broadcast('deleteGroups', $scope.groupSelectList);
      }
    });
  };
  $scope.clickGroupOrderChange = function (type) {
    $scope.$parent.$broadcast('groupOrderChange', type);
    if (orderDropObj) {
      orderDropObj.value = false;
    }
  };
  $scope.clickPeopleOrderChange = function (type) {
    if (!$scope.$parent.peopleList.length) {
      return;
    }
    $scope.$parent.$broadcast('peopleOrderChange', type);
    if (orderPeopleDropObj) {
      orderPeopleDropObj.value = false;
    }
  };
  $scope.clickGroupEdit = function () {
    $scope.showGroupsEdit = !$scope.showGroupsEdit;
    if (orderDropObj) {
      orderDropObj.value = false;
    }
  };
  $scope.clickPeopleEdit = function () {
    if (!$scope.$parent.peopleList.length) {
      return;
    }
    $scope.showPeopleEdit = !$scope.showPeopleEdit;
    if (orderPeopleDropObj) {
      orderPeopleDropObj.value = false;
    }
  };
  $scope.peopleEditModeChange = function (mode) {
    $scope.$parent.$broadcast('setPeopleEditMode', mode);
  };
  $scope.clickPeople = function (people) {
    if ($scope.$parent.peopleEditMode === $scope.$parent.PEOPLE_EDIT_MODE.NORMAL) {
      $scope.$parent.$broadcast('showAiFaceSetPeopleDlg', {
        id: people.id,
        isEdit: true
      });
    } else {
      people.isChecked = !people.isChecked;
      $scope.peopleSelectList = [];
      $scope.$parent.peopleList.forEach(function (item) {
        if (item.isChecked) {
          $scope.peopleSelectList.push(item);
        }
      });
    }
  };
  $scope.selectGroup = function (group) {
    $scope.$parent.$broadcast('selectGroup', group);
    if ($scope.$parent.groupEditMode === $scope.$parent.GROUP_EDIT_MODE.GROUP_LIST) {
      if (group) {
        group.isChecked = !group.isChecked;
        if ($scope.$parent.groups) {
          $scope.groupSelectList = $scope.$parent.groups.filter(function (item) {
            return item.isChecked;
          });
        }
      }
    }
  };
  $scope.showAiFaceGroupDlg = function () {
    $scope.$parent.$broadcast('showAiFaceGroupDlg');
  };
  $scope.$on('$destroy', function () {
    if (orderDropObj) {
      orderDropObj.destroy();
      orderDropObj = null;
    }
    if (orderPeopleDropObj) {
      orderPeopleDropObj.destroy();
      orderPeopleDropObj = null;
    }
    if (peopleSearchObj) {
      peopleSearchObj.destroy();
      peopleSearchObj = null;
    }
    if ($scope.notiTimeout) {
      $timeout.cancel($scope.notiTimeout);
    }
  });
  $scope.$parent.$watch('peopleList', function (newValue, oldValue) {
    if (newValue) {
      activePeopleDropdown(!!newValue.length);
      //activePeopleSearch(!!newValue.length);
    }
  });
  $scope.initValues = function () {
    $scope.notiMsg = '';
    if ($scope.notiTimeout) {
      $timeout.cancel($scope.notiTimeout);
    }
  };
  function initComp() {
    $scope.$parent.setListChildScope($scope);
  }
  initComp();
}]);
"use strict";

var _excluded = ["id"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var checkFilters = new Map();
var zonesLength = 0;
var zoomZoneBottom = 149;
var zoomZoneRight = 580;
var errCnt = 0;
var offLayer = false;
app.controller("CameraViewCtrl2", ["$scope", "$rootScope", "$stateParams", "$state", "$interval", "Camera", "Share", "User", "CameraConfig", "CameraNotifyConfig", "ZoneUpdate", "AudioChat", "$translate", "$timeout", "$sce", "$q", "$window", "Market", "Shop", "CameraGroup", "Utils", function ($scope, $rootScope, $stateParams, $state, $interval, Camera, Share, User, CameraConfig, CameraNotifyConfig, ZoneUpdate, AudioChat, $translate, $timeout, $sce, $q, $window, Market, Shop, CameraGroup, Utils) {
  showPage();
  $scope.moveCameraListCount = 10;
  $scope.cameraName = "";
  $scope.timelineData = "";
  $scope.timelineEle = "";
  $scope.tzCode = "";
  $scope.eventListCheckFlag = false;
  $scope.pressedEventListTimeButtonFlag = false;
  $scope.isAudioChat = false;
  $scope.isScreenShot = false;
  $scope.showSelectColor = false;
  $scope.shareStatus = true;
  $scope.isAddShare = false;
  $scope.isRemoveShare = false;
  $scope.isPromotionCheck = false;
  $scope.isShowCamCloudInfo = false;
  $scope.isShowCreateClip = false;
  $scope.volumeList = [];
  $scope.volumeIdx = 0;
  $scope.timelineDataLastDate = 0;
  $scope.eventListDateIndex = 0;
  $scope.liveReplayCheck = 0;
  $scope.serviceDay = 0;
  $scope.cloudEnd = 0;
  $scope.cloudStart = 0;
  $scope.cloudTime = 0;
  $scope.currentTimeNow = {
    time: Date.now()
  };
  $scope.getContextPath = Utils.getContextPath();
  $scope.colorArray = ["#ff7900", "#3ea1d4", "#a4c800", "#efd600", "#767dff", "#ca7af0", "#ff76bd", "#18b57b", "#929292"]; //주황(ID:1),파랑(ID:2),연두(ID:3),노랑(ID:4),진한보라(ID:5),보라(ID:6),핑크(ID:7),녹색(사운드, ID:0),회색(기타, ID:8)
  $scope.colorArrayName = ["org", "sky", "grn", "yel", "blpp", "ppl", "pink"];
  $scope.listViewMaxCnt = 7;
  $scope.listViewFirstIdx = 0;
  $scope.listViewItems = [];
  $scope.isHideCloudOut = $rootScope.hideCloudOutMap ? $rootScope.hideCloudOutMap[$stateParams.cameraId] : false;
  $scope.aiGraphMode = "min";
  $scope.hasMenuSettingBadge = false;
  $scope.cameraId = $stateParams.cameraId;
  $scope.playerObj = null;
  $scope.playControl = null;
  var face_zone = "";
  var guideDlg = null;
  var camListObj = null;
  var timelineHideTimer;
  var colorArray = ["org", "sky", "grn", "yel", "blpp", "ppl", "pink"];
  var callEvtList;
  var vPlayerTipDlg = null;
  var tipDlgKey = "toastcam-player-tip-show";
  var controlHideTimeout = null;
  var focusTimeout = null;
  var restrictCheckSecond = 0;
  var restrictCheckId = null;
  var PUSH_UNSUPPORTED_RECORD_TYPE = /live/i;
  var PUSH_SUPPORT_RECORD_TYPES_STATUS = {
    LOADING: "LOADING",
    Y: "Y",
    N: "N"
  };
  var ai_camera_type = "";
  $scope.isBrowserNotSupport = !Utils.getIsHlsSupport();

  // ! 서비스 만료일
  $scope.saveEndDateText = "";
  $scope.saveEndDate = 0;
  $scope.disaplySaveEndDate = "";
  $scope.displaySaveEndDateTimeout = 0;

  // ! 동영상 삭제 요청일
  $scope.hasLastAgingDate = false;
  $scope.lastAgingDate = 0;
  $scope.displayLastAgingDate = "";
  $scope.isAgingDone = false;
  $scope.isShowAgingConfirmLayer = false;
  var CAM_DETAIL_SENSOR_FILTER = "CAM_DETAIL_SENSOR_FILTER_" + $stateParams.cameraId;
  var CAM_DETAIL_INOUT_FILTER = "CAM_DETAIL_INOUT_FILTER_" + $stateParams.cameraId;
  var SENSOR_STORAGE_KEY = "SENSOR_STORAGE";
  $scope.sensorZoneTranslate = {
    SENSOR_TEMP: $translate.instant("STR_TEMP_SENSOR"),
    SENSOR_HUMID: $translate.instant("STR_HUMID_SENSOR"),
    SENSOR_MOTION: $translate.instant("STR_MOVE_SENSOR"),
    SENSOR_MAGNETIC: $translate.instant("STR_DOOR_SENSOR"),
    DOORLOCK_EVENT: $translate.instant("STR_MAIN_BIZ_44"),
    SENSOR_SMOKE: $translate.instant("STR_SMOKE_SENSOR"),
    SENSOR_GAS: $translate.instant("STR_GAS_SENSOR"),
    SENSOR_PLUG: $translate.instant("STR_PLUG_SENSOR")
  };
  $scope.inoutFilter = true;
  $scope.sensorZones = [];
  $scope.tempSensorZones = [];
  $scope.motionZones = [];
  $scope.tempMotionZones = [];
  var TIME_DELIMTER = {
    MINUTE: 1000 * 60,
    HOUR: 1000 * 60 * 60,
    DAY: 1000 * 60 * 60 * 24
  };
  var TIME_MESSAGES = {
    MINUTE: $translate.instant("5mw2slvk_02264"),
    // {MM}분
    HOUR: $translate.instant("5mw2slvk_02263"),
    // {HH}시
    DAY: $translate.instant("5mw2slvk_02262") // {DD}일
  };
  $scope.setDisplaySaveEndDate = function () {
    var diff = +new Date($scope.saveEndDate) - +new Date();
    var minute = Math.floor(diff / TIME_DELIMTER.MINUTE);
    var hour = Math.floor(diff / TIME_DELIMTER.HOUR);
    var day = Math.floor(diff / TIME_DELIMTER.DAY);
    var display = [];
    if (day) {
      display.push(TIME_MESSAGES.DAY.replace("{DD}", day)); // {DD}일
    }
    if (hour) {
      hour = hour > 24 ? hour % 24 : hour;
      display.push(TIME_MESSAGES.HOUR.replace("{HH}", hour)); // {HH}시
    }
    if (minute) {
      minute = minute > 60 ? minute % 60 : minute;
      display.push(TIME_MESSAGES.MINUTE.replace("{MM}", minute)); // {MM}분
    }
    $scope.disaplySaveEndDate = display.join(" ");
    $scope.displaySaveEndDateTimeout = $timeout(function () {
      $scope.setDisplaySaveEndDate();
    }, 1000 * 1);
  };

  // ! 푸시 설정 미지원 여부
  $scope.pushSupportRecordTypeStatus = PUSH_SUPPORT_RECORD_TYPES_STATUS.LOADING;
  function getPushSupportRecordTypeStatus(recordType) {
    return PUSH_UNSUPPORTED_RECORD_TYPE.test(recordType) ? PUSH_SUPPORT_RECORD_TYPES_STATUS.N : PUSH_SUPPORT_RECORD_TYPES_STATUS.Y;
  }
  function getPlayLimitSetting() {
    return localStorage.getItem("biz-play-limit-" + $rootScope.me.userId);
  }

  // ! 펌웨어 업데이트 팝업 - 설정값 조회
  function getCameraFirmwareSetting() {
    return localStorage.getItem("biz-camera-firmware-update-" + $rootScope.me.userId);
  }
  function userInteractionCb() {
    restrictCheckSecond = 0;
    return true;
  }
  $(document).on("mousemove", userInteractionCb);
  $(document).on("keydown", userInteractionCb);
  function startPlayLimitInterval() {
    if ($state.current.name !== "main.cameraDetail") {
      return;
    }
    if (!$scope.shareStatus && getPlayLimitSetting() === "false" && Utils.isCloudExpired($scope.currentCamera) === false) {
      return;
    }
    if (restrictCheckId) {
      $interval.cancel(restrictCheckId);
    }
    restrictCheckId = $interval(function () {
      restrictCheckSecond += 1;
      if (restrictCheckSecond === 60 * 15) {
        $scope.pauseBtn();
        $rootScope.createConfirm({
          title: $translate.instant("9rRqk7Vo_02115"),
          description: $translate.instant("9rRqk7Vo_02114"),
          btnCount: 1,
          noCloseBtn: true,
          handler: function handler() {
            if ($scope.playerObj) {
              $scope.playerObj.togglePlay();
            }
          }
        });
      }
    }, 1000);
  }
  $scope.setPlayControlShow = function () {
    $scope.isShowPlayControl = true;
    if (controlHideTimeout) {
      $timeout.cancel(controlHideTimeout);
    }
    controlHideTimeout = $timeout(function () {
      if ($(".dimmed:visible").length || $(".v_modal_dialog").length || $scope.isFullScreen && ($("#controlNdTimeLine").is(":hover") || $(".cam_label").is(":hover")) || !$scope.isFullScreen && ($(".cam_ctrl").is(":hover") || $(".cam_label").is(":hover") || $(".play_tips_icon").is(":hover"))) {
        $scope.setPlayControlShow();
      } else {
        $scope.isShowPlayControl = false;
      }
    }, 4000);
  };
  $scope.setPlayControlHide = function () {
    if (Utils.isIE()) {
      return;
    }
    if ($(".dimmed:visible").length || $(".v_modal_dialog").length || $scope.isFullScreen && ($("#controlNdTimeLine").is(":hover") || $(".cam_label").is(":hover") || ($(".thum_full_area").length ? $(".thum_full_area").is(":hover") : false) || $("#play_indicator").is(":hover")) || !$scope.isFullScreen && ($(".cam_ctrl").is(":hover") || $(".cam_label").is(":hover") || $("#play_indicator").is(":hover") || $(".play_tips_icon").is(":hover"))) {
      return;
    } else {
      if (controlHideTimeout) {
        $timeout.cancel(controlHideTimeout);
      }
      $scope.isShowPlayControl = false;
    }
  };
  setTimeout(function () {
    $(".cam_ctrl").hover(function () {
      $scope.setPlayControlShow();
      $scope.$apply();
    }, function () {
      $scope.setPlayControlHide();
      $scope.$apply();
    });
    $(".cam_label").hover(function () {}, function () {
      $scope.setPlayControlHide();
      $scope.$apply();
    });
  }, 100);
  $scope.setPlayControlShow();
  if ($stateParams.id && ($stateParams.type === "shop" || $stateParams.type === "sharedshop")) {
    $rootScope.cameraShopId = $stateParams.id;
  } else if ($stateParams.shopId) {
    $rootScope.cameraShopId = $stateParams.shopId;
  } else {
    $rootScope.cameraShopId = "";
  }

  /**** AI Shop Start ****/
  $scope.aiCountSummary = null;
  $scope.showAiGraph = true;
  var aiInfoReqInterval = null;
  var makeAICamGraph = function makeAICamGraph(chartData) {
    var color = "#4a96e6",
      $aiGraphEl = $("#cam_detail_graph");
    if (!$aiGraphEl.length) {
      return;
    }
    $aiGraphEl.html("");
    var chartWidth = $aiGraphEl.width();
    // data 설정
    var data = {};
    if (chartData) {
      if (chartData.data) {
        chartData.data = chartData.data.map(function (data) {
          return data ? Math.ceil(data) : null;
        });
      }
      data.categories = chartData.xAxis.items;
      data.series = [{
        name: $translate.instant("9rRqk7Vo_01942"),
        data: chartData.data,
        color: color
      }];
      // option 설정
      var options = {};
      options["theme"] = "newTheme";
      options["chart"] = {
        width: chartWidth,
        height: 400,
        title: "",
        format: "1,000"
      };
      options["yAxis"] = {
        title: "(" + $translate.instant("MAN_COUNT") + ")",
        min: chartData.yAxis.min,
        max: chartData.yAxis.max
      };
      options["tooltip"] = {
        suffix: $translate.instant("MAN_COUNT")
      };
      options["xAxis"] = {
        title: "(" + $translate.instant("HOUR_COUNT") + ")"
      };
      options["series"] = {
        hasDot: false,
        hasSelection: true
      };
      options["legend"] = {
        visible: false
      };
      options["chartExportMenu"] = {
        visible: false
      };
      var theme = {
        series: {
          colors: [color]
        }
      };
      tui.chart.registerTheme("newTheme", theme);
      tui.chart.columnChart(document.getElementById("cam_detail_graph"), data, options);
      $("#cam_detail_graph").children(".tui-chart").css("margin", "auto");
      $("#cam_detail_graph" + " .tui-chart-series-custom-event-area").hide();
    }
  };
  var makeAICamLineGraph = function makeAICamLineGraph(chartData) {
    var format,
      yTitle,
      elementId = "cam_detail_graph",
      container = document.getElementById(elementId);
    var chartWidth = $("#cam_detail_graph").width();
    if (container) {
      while (container.firstChild) {
        container.removeChild(container.firstChild);
      }
    }
    if (!chartData) {
      return;
    }
    yTitle = "(" + $translate.instant("MAN_COUNT") + ")";
    format = "0";
    var data = {
      categories: chartData.xAxis.items,
      series: [{
        name: $translate.instant("9rRqk7Vo_01942"),
        data: chartData.data
      }]
    };
    var options = {
      chart: {
        width: chartWidth,
        height: 400,
        format: format
      },
      yAxis: {
        title: yTitle,
        max: chartData.yAxis.max,
        min: chartData.yAxis.min
      },
      xAxis: {
        title: "(" + $translate.instant("HOUR") + ")"
      },
      series: {
        showDot: true,
        zoomable: false
      },
      tooltip: {
        suffix: $translate.instant("MAN_COUNT")
      },
      legend: {
        visible: false
      },
      chartExportMenu: {
        visible: false
      }
    };
    var theme = {
      series: {
        colors: ["#4b96e6"]
      }
    };
    tui.chart.registerTheme("theme", theme);
    options.theme = "theme";
    tui.chart.lineChart(container, data, options);
  };
  var graphDate = new Date();
  var graphDateFormat = function graphDateFormat(date, format) {
    var md = moment(date);
    return md.locale(Utils.getBrowserLanguage()).format(format);
  };
  var checkIsToday = function checkIsToday(graphDate) {
    if (!graphDate) {
      return true;
    }
    var today = new Date();
    if (today <= graphDate || today.getFullYear() === graphDate.getFullYear() && today.getMonth() === graphDate.getMonth() && today.getDate() === graphDate.getDate()) {
      return true;
    } else {
      return false;
    }
  };
  $scope.setGraphTimeUnit = function (unit) {
    if (unit === 10) {
      if ($scope.aiGraphMode === "min") {
        return;
      }
      $scope.aiGraphMode = "min";
    } else {
      if ($scope.aiGraphMode === "hour") {
        return;
      }
      $scope.aiGraphMode = "hour";
    }
    requestCamAiGraph(true);
  };
  var redrawGraph = true,
    aiStatList = null;
  function checkAIPeopleCountDataSame(prevData, newData) {
    var i,
      len,
      isSame = true;
    if (prevData.data.length === newData.data.length) {
      for (i = 0, len = newData.data.length; i < len; i += 1) {
        if (prevData.data[i] !== newData.data[i]) {
          isSame = false;
          break;
        }
      }
    } else {
      isSame = false;
    }
    return isSame;
  }
  var requestCamAiGraph = function requestCamAiGraph(forceRedraw) {
    var dateInfo = graphDate ? graphDate : new Date();
    $scope.periodStr = graphDateFormat(dateInfo, "YY.MM.DD (ddd)");
    $scope.isToday = checkIsToday(dateInfo);
    if ($scope.aiGraphMode === "min") {
      Camera.getAiChartByMin({
        cameraId: $stateParams.cameraId,
        dayToTime: dateInfo.valueOf(),
        interval: 5,
        scale: "IN_HOUR",
        fields: "aiCountSummary,peopleArea,aiThumbnailPath"
      }).$promise.then(function (res) {
        if (res.peopleArea) {
          redrawGraph = aiStatList ? !checkAIPeopleCountDataSame(aiStatList, res.peopleArea) : true;
          if (redrawGraph || forceRedraw) {
            makeAICamLineGraph(res.peopleArea);
          }
          aiStatList = res.peopleArea;
        }
        $scope.aiCountSummary = res.aiCountSummary ? res.aiCountSummary : null;
        $scope.aiThumbnailPath = res.aiThumbnailPath ? location.protocol + "//" + res.aiThumbnailPath : "/resources/img/img_camera_fail.svg";
      }, function (err) {});
    } else {
      Camera.getAiChartByMin({
        cameraId: $stateParams.cameraId,
        dayToTime: dateInfo.valueOf(),
        interval: 60,
        fields: "aiCountSummary,peopleArea,aiThumbnailPath"
      }).$promise.then(function (res) {
        if (res.peopleArea) {
          makeAICamGraph(res.peopleArea);
        }
        $scope.aiCountSummary = res.aiCountSummary ? res.aiCountSummary : null;
        $scope.aiThumbnailPath = res.aiThumbnailPath ? location.protocol + "//" + res.aiThumbnailPath : "/resources/img/img_camera_fail.svg";
      }, function (err) {});
    }
  };
  $scope.requestCamAiGraph = function () {
    graphDate = $scope.playControl.getData("currentTime");
    requestCamAiGraph(true);
  };
  var makeAiInfoReqInterval = function makeAiInfoReqInterval() {
    if (aiInfoReqInterval) {
      $interval.cancel(aiInfoReqInterval);
    }
    aiInfoReqInterval = $interval(function () {
      if (!$scope.playControl) {
        return;
      }
      graphDate = $scope.playControl.getData("currentTime");
      if (graphDate) {
        requestCamAiGraph();
      }
    }, 10 * 1000);
  };
  $scope.toggleAiTableZones = function () {
    if ($scope.isZoomed) {
      return;
    }
    $scope.showAiTableZones = !$scope.showAiTableZones;
    if ($scope.showAiTableZones && $scope.playControl && $("#player").length) {
      Camera.getAlarmZoneByType({
        cameraId: $stateParams.cameraId,
        zoneType: "TABLE_ZONE"
      }, function (res) {
        if (res.zones.length) {
          $("#ai-zone-area").css("width", $("#player").width() + "px");
          $("#ai-zone-area").css("height", $("#player").height() + "px");
          $scope.aiTableZones = res.zones;
          if (!$scope.aiZonearea) {
            $scope.aiZonearea = new AiZoneArea("ai-zone-area");
          } else {
            $scope.aiZonearea.setCanvasSize($("#player").width(), $("#player").height());
          }
          $scope.aiZonearea.setZonesData($scope.aiTableZones); //coordinate, color, index
        }
      });
    }
  };
  $scope.toggleAiPeopleZones = function () {
    if ($scope.isZoomed) {
      return;
    }
    $scope.showAiPeopleZones = !$scope.showAiPeopleZones;
    if ($scope.showAiPeopleZones && $scope.playControl && $("#player").length) {
      Camera.getAlarmZoneByType({
        cameraId: $stateParams.cameraId,
        zoneType: "PEOPLE_COUNT_ZONE"
      }, function (res) {
        if (res.zones.length) {
          $("#ai-people-zone-area").css("width", $("#player").width() + "px");
          $("#ai-people-zone-area").css("height", $("#player").height() + "px");
          $scope.aiPeopleZones = res.zones;
          if (!$scope.aiPeopleZonearea) {
            $scope.aiPeopleZonearea = new AiZoneArea("ai-people-zone-area");
          } else {
            $scope.aiPeopleZonearea.setCanvasSize($("#player").width(), $("#player").height());
          }
          $scope.aiPeopleZonearea.setZonesData($scope.aiPeopleZones); //coordinate, color, index
        }
      });
    }
  };
  $scope.goAiSetPage = function () {
    var shopId = $stateParams.type === "shop" || $stateParams.type === "sharedshop" || $stateParams.shopId ? $stateParams.shopId || $stateParams.id : null;
    if (shopId) {
      $state.go("main.dashboard.aishop", {
        shopId: shopId
      });
    }
  };

  /****** Ai Shop End ******/

  $scope.tipDlgId = "vue-player-tip-dlg-wrapper";
  $scope.showPlayerTipDlg = function () {
    if (vPlayerTipDlg) {
      vPlayerTipDlg.destroy();
      vPlayerTipDlg = null;
    }
    vPlayerTipDlg = tCam.playerTipDialog({
      elId: $scope.tipDlgId,
      dlgStyle: {
        position: "absolute",
        top: "120px",
        left: $("#content_detail").offset().left + ($("#player").width() - 500) / 2 + "px",
        width: "500px",
        height: "540px",
        padding: "24px",
        boxSizing: "border-box",
        overflow: "auto"
      },
      txtMap: {
        title: $translate.instant("9rRqk7Vo_01938"),
        guideKeyFb: $translate.instant("9rRqk7Vo_01940"),
        guideKeySpace: $translate.instant("9rRqk7Vo_01941"),
        confirm: $translate.instant("BUTTON_CONFIRM")
      },
      eventHandler: function eventHandler() {
        localStorage.setItem(tipDlgKey, "true");
      }
    });
  };
  if (!localStorage.getItem(tipDlgKey)) {
    $scope.showPlayerTipDlg();
  }
  function playerEventHandler(event, data) {
    switch (event) {
      case "zoomLevelChanged":
        $scope.isZoomed = data > 1;
        if (data > 1) {
          $scope.showAiTableZones = false;
          $scope.showAiPeopleZones = false;
          $scope.$apply();
        }
        break;
      case "resizeTimline":
        errCnt = 0;
        var playerWidth = $("#player").width(),
          playerHeight = $("#player").height();
        if ($scope.zonearea) {
          $scope.zonearea.setCanvasSize(playerWidth, playerHeight, $scope.motionZones, $scope.selectedZones);
        }
        if ($scope.aiZonearea) {
          $scope.aiZonearea.setCanvasSize(playerWidth, playerHeight);
        }
        if ($scope.aiPeopleZonearea) {
          $scope.aiPeopleZonearea.setCanvasSize(playerWidth, playerHeight);
        }
        if ($scope.ptzArea) {
          $scope.ptzArea.setCanvasSize(playerWidth, playerHeight);
        }
        $(".eventListArea").css("height", $("#eventList_list").height() - 50);
        if ($scope.currentCamera.isAiSupport && $scope.usePeopleCount && !$scope.isExpiredCloud()) {
          graphDate = $scope.playControl.getData("currentTime");
          requestCamAiGraph(true);
          $("#ai_graph_wrap").css("width", playerWidth);
        }
        break;
      case "isShowMikeChanged":
        $scope.isShowMike = data;
        break;
      case "shareEnd":
        break;
      case "clickedCVRArea":
        $scope.goEventListWithSelectedTime(data);
        break;
      case "isClickTimelineShowChanged":
        isClickTimelineShow = data;
        break;
      case "getAlarmZones":
        if (getAlarmZones) {
          getAlarmZones().then(function () {
            if ($scope.playControl) {
              $scope.playControl.timeline.getTimeline();
            }
          });
        }
        if ($scope.currentCamera.isAiSupport && $scope.usePeopleCount && !$scope.isExpiredCloud()) {
          if ($scope.playControl) {
            if ($scope.aiReqTimeout) {
              $timeout.cancel($scope.aiReqTimeout);
            }
            $scope.aiReqTimeout = $timeout(function () {
              graphDate = $scope.playControl.getData("currentTime");
              requestCamAiGraph(true);
            }, 1000);
          }
        }
        break;
      case "changedSelectedZone":
        if (changedSelectedZone) {
          changedSelectedZone();
        }
        break;
      case "loadingAlert":
        showAlert($translate.instant("DATA_LOADING_SUBJECT"), $translate.instant("DATA_LOADING_CONTENT"));
        break;
      case "fullScreenAlertChanged":
        $scope.fullScreenAlert = data;
        break;
      case "isFullScreenChanged":
        $scope.isAddShowGalleryClass = false;
        $scope.isShowCameraSetting = false;
        $scope.isShowCreateClip = false;
        $scope.isFullScreen = data;
        if (!$scope.isFullScreen) {
          setTimeout(function () {
            if ($scope.aiZonearea) {
              $scope.aiZonearea.setCanvasSize($("#player").width(), $("#player").height());
            }
            if ($scope.aiPeopleZonearea) {
              $scope.aiPeopleZonearea.setCanvasSize($("#player").width(), $("#player").height());
            }
          }, 500);
        }
        $scope.$apply();
        break;
      case "timelineVisibleChanged":
        $scope.timelineVisible = data;
        break;
      case "noPrevEvent":
        showAlert($translate.instant("CAMERA_EVENT_MOVE"), $translate.instant("CAMERA_NO_PREV_EVENT"));
        break;
      case "noNextEvent":
        showAlert($translate.instant("CAMERA_EVENT_MOVE"), $translate.instant("CAMERA_NO_NEXT_EVENT"));
        break;
      case "eventsChanged":
        $scope.events = data;
        break;
      case "timelineHideTimerStop":
        $timeout.cancel(timelineHideTimer);
        break;
      case "loadingDataAlert":
        $scope.loadingDataAlert();
        break;
      case "timeInputError":
        if (data === "time") {
          showAlert($translate.instant("CAMERA_INPUT_ERROR"), $translate.instant("CAMERA_ENTER_TIME"));
        } else if (data === "minute") {
          showAlert($translate.instant("CAMERA_INPUT_ERROR"), $translate.instant("CAMERA_ENTER_MINUTE"));
        } else if (data === "second") {
          showAlert($translate.instant("CAMERA_INPUT_ERROR"), $translate.instant("CAMERA_ENTER_SECOND"));
        }
        break;
      case "isIncorrectPlayPasswordChanged":
        $scope.isIncorrectPlayPassword = data;
        $scope.$apply();
        break;
      case "indicatorHoverIn":
        $scope.setPlayControlShow();
        $scope.$apply();
        break;
      case "indicatorHoverOut":
        $scope.setPlayControlHide();
        $scope.$apply();
        break;
    }
  }
  $scope.shareStatus = $stateParams.shared === true || $stateParams.shared === "true";
  $scope.initCameraListView = function () {
    var halfMoveCnt,
      showCameraNum,
      padding = 30,
      wrapWidth = 0,
      titleWidth,
      camListPadding = 28,
      camListWidth,
      camWidth = 92;
    if ($(window).width() < 1550) {
      $scope.moveCameraListCount = 5;
    } else if (1900 >= $(window).width() && $(window).width() >= 1550) {
      $scope.moveCameraListCount = 7;
    } else {
      $scope.moveCameraListCount = 10;
    }
    if ($scope.cameraList && $scope.cameraList.length) {
      if ($scope.moveCameraListCount === 5 || $scope.moveCameraListCount === 7 || $scope.moveCameraListCount === 10) {
        halfMoveCnt = $scope.moveCameraListCount - 0.5;
      } else {
        halfMoveCnt = $scope.moveCameraListCount;
      }
      showCameraNum = $scope.cameraList.length > $scope.moveCameraListCount ? halfMoveCnt : $scope.cameraList.length;
    } else {
      showCameraNum = 0;
    }
    $timeout(function () {
      var $playArea = $("#player_area"),
        $camTitle = $("#camera_title");
      if ($playArea.length) {
        wrapWidth = parseInt($playArea.css("width").replace("px", ""), 10);
      }
      camListWidth = camListPadding + showCameraNum * camWidth;
      titleWidth = wrapWidth - camListWidth - padding;
      if ($camTitle.length) {
        $camTitle.css("max-width", titleWidth + "px");
      }
    }, 0);
  };
  $(window).resize(resizeHandler);
  function resizeHandler() {
    $scope.initCameraListView();
    if ($("#remoteVideosContainer").children("video").length) {
      $("#remoteVideosContainer").children("video").css("height", $("#remoteVideosContainer").height() - $("#timeline_table").height());
    }
    $timeout(function () {
      $scope.$apply();
    });
  }
  $scope.camera = {
    id: $stateParams.cameraId
  };
  var showAlert = function showAlert(title, message) {
    $(".display_show").css("display", "");
    $scope.showAlert = true;
    $scope.alertTitle = title;
    $scope.alertMessage = message;
  };
  $scope.hideAlert = function () {
    $scope.showAlert = false;
  };
  $scope.isExpiredCloud = function () {
    if ($scope.currentCamera) {
      return Utils.isCloudExpired($scope.currentCamera);
    } else {
      return false;
    }
  };
  $scope.showClipDlg = function () {
    $scope.isShowCreateClip = !$scope.isShowCreateClip;
  };
  $scope.$watch("[isShowCameraSetting, isShowCamCloudInfo]", function (newValue, oldValue) {
    var isDlgOpen = false;
    if (newValue && newValue.length) {
      newValue.forEach(function (item) {
        if (item) {
          isDlgOpen = true;
        }
      });
      if (isDlgOpen) {
        document.body.classList.add("blockScroll");
      } else {
        $("body").removeClass("blockScroll");
      }
    } else {
      $("body").removeClass("blockScroll");
    }
  });

  // $interval cancel
  $scope.$on("$destroy", function () {
    $("body").removeClass("blockScroll");
    $("body").off("click", editZoneNameSaveClickFn);
    $(window).off("resize", resizeHandler);
    if ($scope.playerObj) {
      $scope.playerObj.destroy();
      // $scope.playerObj = null;
      $scope.playerObj = null;
    }
    if (camListObj) {
      camListObj.destroy();
      camListObj = null;
    }
    restrictCheckSecond = 0;
    $(document).off("mousemove", userInteractionCb);
    $(document).off("keydown", userInteractionCb);
    $interval.cancel(restrictCheckId);
    $interval.cancel(aiInfoReqInterval);
    $scope.playControl = null;
    $(document).off("keydown");
    $interval.cancel($scope.reloadTimer); // CVR Fetch
    $interval.cancel($scope.eventlistTimer); // 이벤트 목록 썸네일 반복
    $interval.cancel(callEvtList); //이벤트 리스트 주기적으로 호출 및 업데이트
    $("#view_timeline_area").unbind();
    if (vPlayerTipDlg) {
      vPlayerTipDlg.destroy();
      vPlayerTipDlg = null;
    }
    if (controlHideTimeout) {
      $timeout.cancel(controlHideTimeout);
      controlHideTimeout = null;
    }
    if (focusTimeout) {
      $timeout.cancel(focusTimeout);
      focusTimeout = null;
    }
    if ($scope.aiReqTimeout) {
      $timeout.cancel($scope.aiReqTimeout);
    }
    if ($scope.aiZonearea) {
      $scope.aiZonearea.destroy();
      $scope.aiZonearea = null;
    }
    if ($scope.aiPeopleZonearea) {
      $scope.aiPeopleZonearea.destroy();
      $scope.aiPeopleZonearea = null;
    }
    destroyPtzArea();
    timelineHideTimer = null;
    colorArray = null;
    showAlert = null;
    callEvtList = null;
    loadCurrentCamera = null;
    ptzCursorDrag = null;
    isFullScreen = null;
    isFullscreenActiveArea = null;
    confirmFromToastMarket = null;
    eventListDate = null;
    eventGroupTmp = null;
    eventListFormatted = null;
    dateWithDateIndex = null;
    timeRangeWithEventIndexes = null;
    changedSelectedZone = null;
    setTimelineTimeMoment = null;
    $window.confirmPaycoPasswordCallback = null;
    getAlarmZones = null;
    saveFilter = null;
  });

  // 1분 주기로 이벤트 리스트 로딩
  callEvtList = $interval(function () {
    if ($scope.currentCamera.saveEndDate < new Date().valueOf()) {
      $interval.cancel(callEvtList);
      return;
    }
    var nowTimeCheck = new Date();
    var getTimeMin = nowTimeCheck.getMinutes();
    if (getTimeMin == 0) {
      getTimeMin = 60;
    }
    var nowHours = new Date().getHours();
    var selectedDate = dateWithDateIndex(0);
    var refleshEvtList = 0;
    var topEvtList = $("#btn_time_" + nowHours + "_" + selectedDate).children("button").children("span").html();
    if (parseInt(topEvtList) > 0) {
      refleshEvtList = 60;
      if ($("#btn_time_" + nowHours + "_" + selectedDate).css("display") == "none" && $scope.eventListDateIndex == 0) {
        refleshEvtList = 1;
      }
    } else {
      refleshEvtList = 2;
    }
    $scope.updateEventListDate(0);
    if (getTimeMin % refleshEvtList == 0) {
      if ($scope.selectedEventDateIndex == 0) {
        $scope.pressedEventListDateButton(0);
        if ($scope.pressedEventListTimeButtonFlag) {
          setTimeout(function () {
            $scope.pressedEventListTimeButton(pEventButtonIdx, pEventButtonDate, 1);
          }, 1000);
        }
      }
    }
  }, 60000);
  $scope.currentTab = "event";
  $scope.viewPageTop = function () {
    setTimeout(function () {
      if ($("html").attr("lang") == "en") {
        for (var i = 0; i < $(".en_en_en").length; i++) {
          $(".en_en_en").eq(i).attr("class", $(".en_en_en").eq(i).attr("class").replace("_en_en_en", "_en"));
        }
        $(".cam_info_bg_en_en_en").addClass("cam_info_bg_en");
        $(".cam_info_bg_en_en_en").removeClass("cam_info_bg");
      } else {
        $(".cam_info_bg").removeClass("cam_info_bg_en_en_en");
      }
      $(".en_en_en").removeClass("en_en_en");
      var trident = navigator.userAgent.match(/Trident\/(\d)/i);
      if (trident != null) {
        document.documentElement.scrollTop = 32;
      } else {
        $(window).scrollTop(32);
      }
    }, 500);
  };
  $scope.viewPageTop();
  $scope.goDetail = function (id) {
    var trident = navigator.userAgent.match(/Trident\/(\d)/i);
    if (trident != null) {
      document.documentElement.scrollTop = 0;
    } else {
      $("body").scrollTop(0);
    }
    $state.go("main.cameraDetail", {
      cameraId: id
    }, {
      reload: true,
      inherit: true,
      notify: true
    });
  };
  $scope.pauseBtn = function () {
    if ($scope.playControl) {
      $scope.playControl.playInfoBar.pauseBtn();
      $scope.isPlaying = $scope.playControl.getData("isPlaying");
    }
  };

  //로컬스토리지에서 sensor 데이터 받아오는 메소드
  function getSensorFilterFromLocalStorage() {
    var zoneItem,
      jsonKey,
      eventFilterData = localStorage.getItem(CAM_DETAIL_SENSOR_FILTER);
    if (eventFilterData) {
      var eventFilterJSON = JSON.parse(eventFilterData);
      for (jsonKey in eventFilterJSON) {
        if (eventFilterJSON[jsonKey]) {
          if (jsonKey.includes(SENSOR_STORAGE_KEY)) {
            zoneItem = _.find($scope.sensorZones, ["id", jsonKey.replace(SENSOR_STORAGE_KEY, "")]);
          } else {
            zoneItem = _.find($scope.motionZones, ["id", jsonKey]);
          }
          if (zoneItem) {
            zoneItem.filterMark = eventFilterJSON[jsonKey];
          }
        }
      }
    }
    $scope.playerObj.setData("sensorZones", $scope.sensorZones);
    $scope.playerObj.setData("motionZones", $scope.motionZones);
  }

  // ! 녹화 영상 초기화
  $scope.showAgingLayer = function () {
    $scope.isShowCamCloudInfo = false;
    $scope.isShowAgingLayer = true;
  };
  $scope.hideAgingLayer = function () {
    $scope.isShowAgingLayer = false;
  };
  $scope.agingBackStep = function () {
    $scope.hideAgingLayer();
    $scope.isShowCamCloudInfo = true;
  };

  // ! 삭제 확인 컨펌
  $scope.showAgingConfirmLayer = function () {
    $scope.isShowAgingConfirmLayer = true;
  };
  $scope.hideAginConfirmlayer = function () {
    $scope.isShowAgingConfirmLayer = false;
  };
  $scope.confirmAging = function () {
    // ! 두번째 파라미터에 {} 를 넘겨야, url :cameraId 에 cameraId 가 치환됨
    Camera.requestCameraAging({
      cameraId: $stateParams.cameraId
    }, {}, function () {
      $scope.hideAginConfirmlayer();

      // ! 삭제 요청 후, 정보 갱신 처리
      $scope.showCamCloudInfo(true, function () {
        $scope.showAgingLayer();
        if ($scope.playerObj) {
          // ! 영상 타임라인 업데이트를 위함
          $scope.playerObj.requestPlay();

          // ! 이벤트 리스트 업데이트
          $scope.nextEventList(1);
          $("#evnetListDate_0").show();
        }
      });
    }, function () {
      $rootScope.createConfirm({
        title: $translate.instant("ACCESS_NET_FAIL"),
        description: $translate.instant("ACCESS_NET_FAIL_DESC"),
        btnCount: 1
      });
      $scope.hideAginConfirmlayer();
    });
  };
  $scope.showCamCloudInfo = function (isShow, callBack) {
    if (isShow) {
      // ! 카메라 정보 조회
      Camera.getCamera({
        cameraId: $stateParams.cameraId
      }, function (data) {
        $scope.hasLastAgingDate = !!data.lastAgingDate && data.lastAgingDate !== -100;
        $scope.lastAgingDate = $scope.hasLastAgingDate ? data.lastAgingDate : "";
        $scope.displayLastAgingDate = moment(new Date($scope.lastAgingDate)).format("YYYY.MM.DD. HH:mm");
        // ! agingDate 없거나 <= 0 완료 , agingDate > 0 미완료
        $scope.isAgingDone = (data.agingDate || 0) <= 0;
        if (callBack && typeof callBack === "function") {
          callBack();
        }
      });

      // ! 카메라 - 서비스 만료일 조회
      Camera.saveEndDateInfo({
        cameraId: $stateParams.cameraId
      }, function (data) {
        $scope.saveEndDateText = data.saveEndDateText;
        $scope.saveEndDate = data.saveEndDate;
        $scope.isShowCamCloudInfo = isShow;
        $scope.isShowCameraSetting = false;
        $timeout.cancel($scope.displaySaveEndDateTimeout);
        $scope.setDisplaySaveEndDate();
        if (callBack && typeof callBack === "function") {
          callBack();
        }
      });
    } else {
      $scope.isShowCamCloudInfo = isShow;
    }
  };
  $scope.backToCamSetting = function () {
    $scope.showCamCloudInfo(false);
    $scope.isShowCameraSetting = true;
  };
  $scope.goToInqueryPage = function () {
    $state.go("main.help.inquiry", {
      type: "cam_cancel"
    });
  };
  function getInoutFilterFromLocalStorage() {
    var filterData = localStorage.getItem(CAM_DETAIL_INOUT_FILTER);
    $scope.inoutFilter = filterData !== "false";
    $scope.playerObj.setData("inoutFilter", $scope.inoutFilter);
  }
  function setSensorFilterToLocalStorage() {
    var sensorZoneStorageList = $scope.sensorZones.map(function (obj) {
      return _objectSpread(_objectSpread({}, obj), {}, {
        id: "".concat(SENSOR_STORAGE_KEY, "_").concat(obj.id)
      });
    });
    var eventFilterList = sensorZoneStorageList.concat($scope.motionZones);
    var eventFilterJSON = eventFilterList.reduce(function (acc, sensorZone) {
      acc[sensorZone.id] = sensorZone.filterMark;
      return acc;
    }, {});
    localStorage.setItem(CAM_DETAIL_SENSOR_FILTER, JSON.stringify(eventFilterJSON));
  }
  function setInoutFilterToLocalStorage() {
    localStorage.setItem(CAM_DETAIL_INOUT_FILTER, $scope.inoutFilter ? "true" : "false");
  }
  $scope.reloadCameraDetail = function (check) {
    $scope.playControl.errorStatusLayer.cameraStatusAllOff();
    $scope.playerObj.setData("playBtnStatus", $scope.plyBtnStatus);
    if (!$scope.shareStatus) {
      Camera.get({
        id: $stateParams.cameraId
      }, function (res) {
        $scope.currentCamera = res;
        if ($scope.playerObj) {
          $scope.playerObj.setData("cameraData", $scope.currentCamera);
        }
        $scope.livePlayDataSet(check);
      });
    } else {
      Share.get({
        id: $stateParams.cameraId
      }, function (res) {
        $scope.currentCamera = res;
        if ($scope.playerObj) {
          $scope.playerObj.setData("cameraData", $scope.currentCamera);
        }
        $scope.livePlayDataSet(check);
      });
    }
  };
  $scope.livePlayDataSet = function (check) {
    var callAPIFn = !$scope.shareStatus ? CameraConfig.get : CameraConfig.getSharedConfig;
    callAPIFn({
      id: $stateParams.cameraId
    }, function (data) {
      angular.extend($scope.config, data);
      $scope.config.tzCode = $scope.tzCode;
      $scope.livePlayConfigDataSet(check);
      if (data && data.cameraSchedule) {
        $scope.scheduleOn = data.cameraSchedule.scheduleOn;
      }
      if ($scope.playerObj) {
        $scope.playerObj.setData("cameraConfig", $scope.config);
      }
    });
  };
  $scope.cameraStatusChange = function (status) {
    $scope.playControl.errorStatusLayer.cameraStatusChange(status);
  };
  $scope.livePlayConfigDataSet = function (check) {
    var cameraStatus = true;
    var cameraStatusNum = 0;
    if ($scope.config.streamStatus == "off") {
      cameraStatusNum = 1;
      setTimeout(function () {
        $scope.pauseBtn();
        $scope.timeline.updateCursor(new Date().valueOf());
      }, 500);
    } else {
      if ($scope.currentCamera.controlStatus === "CS" || $scope.currentCamera.controlStatus === "on") {
        if ($scope.currentCamera.recordType != "event") {
          if ($scope.currentCamera.streamStatus == "off" && check != "NetStream.Play.Stop") {
            cameraStatusNum = 2;
            cameraStatus = false;
            setTimeout(function () {
              $scope.pauseBtn();
              $scope.timeline.updateCursor(new Date().valueOf());
            }, 500);
          } else {
            cameraStatusNum = 0;
            cameraStatus = true;
          }
        }
      } else if ($scope.currentCamera.controlStatus === "CE" || $scope.currentCamera.controlStatus === "off") {
        if ($scope.currentCamera.streamStatus == "off") {
          cameraStatusNum = 4;
          cameraStatus = false;
          setTimeout(function () {
            $scope.pauseBtn();
            $scope.timeline.updateCursor(new Date().valueOf());
          }, 500);
        } else {
          cameraStatusNum = 0;
          cameraStatus = true;
        }
      }
    }
    $scope.cameraStatusChange(cameraStatusNum);
    if (check == "NetStream.Play.Stop" || check == "changeRec") {
      $scope.liveReplayCheck++;
      if (check == "changeRec") {
        setTimeout(function () {
          if ($scope.liveReplayCheck < 20 && cameraStatus == false) {
            $scope.reloadCameraDetail();
          } else {
            cameraStatus = true;
            $scope.liveReplayCheck = 0;
            $scope.isPlaying = true;
            if ($scope.playerObj) {
              $scope.playerObj.setData("isPlaying", true);
            }
            $scope.startLiveTimer();
          }
        }, 5000);
      }
    }
    if ($scope.config.cameraSchedule != undefined) {
      $scope.config.parsedStartAt = Utils.configDateSeparate($scope.config.cameraSchedule.startAt);
      $scope.config.parsedStopAt = Utils.configDateSeparate($scope.config.cameraSchedule.stopAt);
      $scope.config.repeatOn = Utils.configRepeatOnSeparate($scope.config.cameraSchedule.repeatOn);
      $scope.playerObj.setData("cameraConfig", $scope.config);
    }
  };
  var userIdLoading = 0;
  $scope.cameraUpagradeAlert = false;
  $scope.eventListDate = [];
  $scope.moveToHome = function () {
    $state.go("main");
  };
  var loadCurrentCamera = function loadCurrentCamera() {
    var deferred = $q.defer();
    $(".display_show").css("display", "");
    $scope.pushSupportRecordTypeStatus = PUSH_SUPPORT_RECORD_TYPES_STATUS.LOADING;
    if (!$scope.shareStatus) {
      Camera.get({
        id: $stateParams.cameraId
      }, function (res) {
        $scope.currentCamera = res;
        if ($scope.playerObj) {
          $scope.playerObj.setData("cameraData", $scope.currentCamera);
          $scope.currentCameraDataSet();
        }
        $scope.pushSupportRecordTypeStatus = getPushSupportRecordTypeStatus(res.recordType);
        startPlayLimitInterval();
        deferred.resolve();
      }, function (error) {
        deferred.reject();
      });
    } else {
      if ($stateParams.type === "sharedshop" && typeof $stateParams.id !== "undefined") {
        Share.get({
          id: $stateParams.cameraId
        }, function (res) {
          $scope.currentCamera = res;
          if ($scope.playerObj) {
            $scope.playerObj.setData("cameraData", $scope.currentCamera);
            $scope.currentCameraDataSet();
          }
          $scope.pushSupportRecordTypeStatus = getPushSupportRecordTypeStatus(res.recordType);
          startPlayLimitInterval();
          deferred.resolve();
        }, function (error) {
          deferred.reject();
        });
      } else {
        Share.get({
          id: $stateParams.cameraId
        }, function (res) {
          $scope.currentCamera = res;
          if ($stateParams.type === "sharedgroup") {
            if ($scope.currentCamera.hasConfigPermission === true) {
              $scope.camConfigPermision = true;
            }
          }
          if ($scope.playerObj) {
            $scope.playerObj.setData("cameraData", $scope.currentCamera);
            $scope.currentCameraDataSet();
          }
          $scope.pushSupportRecordTypeStatus = getPushSupportRecordTypeStatus(res.recordType);
          startPlayLimitInterval();
          deferred.resolve();
        }, function (error) {
          deferred.reject();
        });
      }
    }
    return deferred.promise;
  };
  $scope.cameraStatusSet = function (clickStatus) {
    if ($scope.currentCamera) {
      if ($scope.shareStatus && !$scope.currentCamera.hasConfigPermission) {
        $scope.configStatus = "share";
      }
    }
    if ($scope.playerObj && $scope.playControl.getData("isLive") == true) {
      var cameraStatusNum = 0;
      if ($scope.config.streamStatus == "off") {
        cameraStatusNum = 1;
      } else {
        if ($scope.currentCamera) {
          if ($scope.currentCamera.controlStatus === "CS" || $scope.currentCamera.controlStatus === "on") {
            if ($scope.currentCamera.recordType != "event") {
              if ($scope.currentCamera.streamStatus == "off" && clickStatus != "setting") {
                if (Utils.isCloudExpired($scope.currentCamera)) {
                  cameraStatusNum = 0;
                } else {
                  cameraStatusNum = 2;
                }
              }
            }
          } else if ($scope.currentCamera.controlStatus === "CE" || $scope.currentCamera.controlStatus === "off") {
            if ($scope.currentCamera.streamStatus == "off") {
              cameraStatusNum = 4;
            } else {
              cameraStatusNum = 3;
            }
          }
        }
      }
      $scope.cameraStatusChange(cameraStatusNum);
    }
  };
  $scope.cameraChangeFlag = false;

  // 현재 화면에 호출된 카메라의 데이터 설정
  $scope.currentCameraDataSet = function () {
    $scope.getShareCamerasList();
    $scope.shareView = true;
    if ($scope.playerObj) {
      $scope.playControl = $scope.playerObj.control;
      $scope.timeline = $scope.playControl.timeline;
      $scope.player = $scope.playControl.player;
    }
    $("#timebar_area").children("svg").width() / 2 - 75;
    setTimeout(function () {
      $("#timelinedesc").fadeIn(2000, function () {
        $("#timelinedesc").fadeOut(1000);
      });
    }, 500);
    $scope.cameraUpagradeAlert = false;
    $scope.hasMenuSettingBadge = false;
    //블랙아웃
    if ($scope.currentCamera.code == "nok") {
      $scope.isNoCamera = true;
      return;
    }
    $scope.cameraName = $scope.currentCamera.labelName;
    if ($scope.currentCamera.mediaStreamURL != "" || $scope.currentCamera.mediaStreamURL != null) {
      if ($scope.cameraChangeFlag && $scope.playControl.getData("isLive") == false) {
        $scope.clickedCVRArea($scope.playControl.getData("currentTime"));
      }
      if ($scope.currentCamera.needUpgrade == "YES" && $scope.currentCamera.controlStatus == "on") {
        if (!$scope.shareStatus) {
          var firmwareSetting = getCameraFirmwareSetting();
          if (!firmwareSetting || firmwareSetting === "true") {
            $scope.cameraUpagradeAlert = true;
          } else {
            $scope.cameraUpagradeAlert = false;
          }
          $scope.hasMenuSettingBadge = true;
        }
      }
    } else {
      $scope.isNetwork = true;
    }
    if ($scope.currentCamera.saveEndDate < new Date().valueOf()) {
      $("#timelinedesc").remove();
      $scope.cloud_out = true;
    } else {
      $scope.cloud_out = false;
      if ($scope.getCookie("service_end") == "service_end") {} else {
        var today = new Date();
        var betweenDay = parseInt(($scope.currentCamera.saveEndDate - today.getTime()) / 1000 / 60 / 60 / 24);
        if (betweenDay <= 7) {
          $scope.cloudEnd = betweenDay;
          $scope.showServiceEnd = true;
          if (betweenDay === 0) {
            $scope.cloudTime = parseInt(($scope.currentCamera.saveEndDate - today.getTime()) / 1000 / 60 / 60);
          }
        }
      }
    }
    if ($scope.currentCamera.isPromotion == 1) {
      if ($scope.currentCamera.saveEndDate > new Date().valueOf()) {
        $scope.isPromotionCheck = true;
      } else {
        $scope.isPromotionCheck = false;
        $scope.cloud_out = true;
        $("#timelinedesc").remove();
      }
    } else {
      $scope.isPromotionCheck = false;
    }
    if (Utils.isTurnOffCamera($scope.currentCamera)) {
      if ($scope.currentCamera.streamStatus !== "off") {
        Camera.isLastRecord({
          id: $stateParams.cameraId
        }, function (data) {
          if ($scope.playControl) {
            $scope.playControl.errorStatusLayer.currentCameraIsLastRecordDataSet(data);
          }
        });
      }
      $scope.isPlaying = false;
      $scope.isShowMike = false;
    } else {
      $scope.isPlaying = true;
    }
    $scope.playerObj.setData("isPlaying", $scope.isPlaying);
    $scope.controlsReady = true;
    if (!$scope.isExpiredCloud()) {
      if ($scope.currentCamera.recorderType === "nvr") {
        var now = moment();
        var regDate = moment($scope.currentCamera.regDate);
        $scope.serviceDay = now.diff(regDate, "days") + 1;
      } else {
        $scope.serviceDay = parseInt($scope.currentCamera.serviceType);
      }
      if ($scope.serviceDay <= 7 && $scope.serviceDay >= 1) {
        setTimeout(function () {
          $("#view_timeline_date").find("button").css("padding", "0 12px");
        }, 500);
      } else if ($scope.serviceDay >= 8) {
        setTimeout(function () {
          $("#view_timeline_date").find("button").css("padding", "");
        }, 500);
        var month = parseInt(new Date($scope.currentCamera.regDate).getMonth() + 1);
        if (month < 10) {
          month = "0" + month;
        }
      } else {
        $scope.cloud_out = true;
        $("#timelinedesc").remove();
      }
    } else {
      $scope.cloud_out = true;
      $scope.serviceDay = 0;
    }
    $scope.playerObj.setData("serviceDay", $scope.serviceDay);
    if ($scope.cloud_out) {
      $scope.cloudStart = 0;
    } else {
      $scope.cloudStart = new Date().getTime() - $scope.serviceDay * 24 * 60 * 60 * 1000;
    }
    var eventListDateDate = eventListDate();
    for (var i = 0; i < eventListDateDate.length; i++) {
      var dateObject = {};
      dateObject.date = eventListDateDate[i].date;
      dateObject.year = eventListDateDate[i].date ? eventListDateDate[i].date.slice(0, 4) : "0000";
      dateObject.day = eventListDateDate[i].day;
      var dateO = eventListDateDate[i].day.split(" ");
      dateObject.month = dateObject.date.substring(4, 6);
      dateObject.dates = dateObject.date.substring(6, 8);
      var dayCheck = new Date(dateObject.date.substring(0, 4) + "-" + dateObject.date.substring(4, 6) + "-" + dateObject.date.substring(6, 8)).getDay();
      dateObject.days = dayCheck;
      dateObject.today = dateO[3] ? dateO[3].replace(/\)|\(/g, "") : "";
      $scope.eventListDate.push(dateObject);
    }
    $(".cvr").empty();
    $scope.cameraStatusSet();
    $scope.me = User.me(function () {
      if (userIdLoading == 0) {
        userIdLoading++;
      }
    });
    $scope.selectedZones = [];
    $scope.selectedAllZones = [];
    $scope.zones = [];
    if ($scope.currentCamera.saveEndDate >= new Date().valueOf()) {
      if ($scope.eventListCheckFlag === false) {
        setTimeout(function () {
          $scope.pressedEventListDateButton(0);
        }, 10);
        $scope.eventListCheckFlag = true;
      }
      if ($scope.selectedEventDateIndex == 0) {
        $scope.pressedEventListDateButton(0);
        if ($scope.pressedEventListTimeButtonFlag) {
          setTimeout(function () {
            $scope.pressedEventListTimeButton(pEventButtonIdx, pEventButtonDate, 1);
          }, 1500);
        }
      }
    } else {
      $scope.cloudServiceEnd = true;
    }
  };
  $scope.showServiceEndClose = function () {
    if ($("#cloud_out_service").is(":checked") == true) {
      $scope.setCookie("service_end", "service_end", 1);
    }
    $scope.showServiceEnd = false;
  };
  $scope.hideCloudOut = function () {
    if (!$rootScope.hideCloudOutMap) {
      $rootScope.hideCloudOutMap = {};
    }
    $rootScope.hideCloudOutMap[$stateParams.cameraId] = true;
    $scope.isHideCloudOut = true;
  };
  $scope.setupDomain = function (domain) {
    $scope.timeline.setupDomain(domain);
  };
  $scope.reloadTimer = $interval(function () {
    var currentDomain = $scope.timeline ? $scope.timeline.getData("currentDomain") : null;
    if (!currentDomain) {
      return;
    }
    if ($scope.serviceDay != 0) {
      if (currentDomain[1] > Date.now() || currentDomain[0] < $scope.playControl.timeline.getData("serviceDateTime")) {
        $scope.setupDomain([currentDomain[0], currentDomain[1]]);
      }
    }
  }, 10000);
  $scope.loadingDataAlert = function () {
    if (isFullScreen()) {
      $scope.fullScreenAlert = true;
      return;
    }
    showAlert($translate.instant("CAMERA_TIMELINE_LOADING_SUBJECT"), $translate.instant("CAMERA_TIMELINE_LOADING_CONTENT"));
  };
  $scope.formattedInternalDate = function (date) {
    var md,
      tz = $scope.timeline ? $scope.timeline.getData("timezone") : "";
    md = tz ? moment(new Date(date)).tz(tz) : moment(new Date(date));
    return md.format("YYYYMMDD");
  };
  $scope.selectCamera = function (id) {
    $state.go("main.cameraDetail", {
      cameraId: id
    });
  };
  $scope.goCameraList = function () {
    $window.history.back();
  };
  $scope.stopTimer = function () {
    $scope.playControl.playTimer.stopTimer();
  };
  $scope.startLiveTimer = function () {
    $scope.playControl.playTimer.startLiveTimer($scope.playControl.timeline);
  };
  $scope.clickedCVRArea = function (time, status) {
    $scope.playControl.timeline.clickedCVRArea(time, status);
  };
  $scope.goCvr = function (time, status) {
    $scope.timeline.requestPlay(time, status);
  };
  $scope.isTurnOffCamera = function () {
    return Utils.isTurnOffCamera($scope.currentCamera);
  };
  $scope.goShopDashboard = function () {
    if ($scope.shopObj) {
      $state.go("main.dashboard.shop", {
        shop: JSON.stringify({
          shopId: $scope.shopObj.shopId,
          myShop: !$scope.shopObj.shareId,
          posExists: $scope.shopObj.posIdList && $scope.shopObj.posIdList.length || $scope.shopObj.posId
        })
      });
    }
  };
  $scope.goGroup = function () {
    if ($scope.groupObj) {
      var params = {
        groupId: $scope.groupObj.groupId
      };
      if ($scope.groupObj.shareId) {
        params.shareId = $scope.groupObj.shareId;
      }
      $state.go("main.cameraGroup.group", params);
    }
  };
  var ptzSppedDrag = 139.2;
  var ptzSpeed = 7.4;
  var ptzCursorDrag = d3.behavior.drag().on("drag", function (e) {
    if (ptzSppedDrag == 0) {
      ptzSppedDrag = parseInt($("#ptz_cursor_length").css("width"));
    }
    ptzSppedDrag = Math.max(0, Math.min(ptzSppedDrag + d3.event.dx, 174));
    var widthX = ptzSppedDrag * 100 / 174;

    // 스타일 업데이트
    $("#ptz_cursor_length").css("width", "".concat(widthX, "%"));

    // 속도 계산
    ptzSpeed = Math.max(1.0, Math.min(widthX / 11.11, 9.0));
  });

  // fullscreen

  var isFullScreen = function isFullScreen() {
    return !!(document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement);
  };
  var isFullscreenActiveArea = function isFullscreenActiveArea() {
    var x = d3.event.pageX;
    var y = d3.event.pageY;
    return x <= 50 || y >= screen.height - 110;
  };
  d3.select("#player").on("mousemove", function () {
    if ($scope.isFullScreen) {
      if (isFullscreenActiveArea()) {
        if ($scope.playControl) {
          $scope.playControl.fullscreenBtn.stopFullscreenTimer();
        }
        $scope.timelineVisible = true;
      } else {
        if ($scope.timelineVisible && $scope.playControl) {
          $scope.playControl.fullscreenBtn.startFullscreenTimer();
        }
      }
    }
  });

  // Camera Setting
  $scope.config = {};
  $scope.loadCameraSetting = function (callback, clickStatus) {
    var apiCallFn = !$scope.shareStatus ? CameraConfig.get : CameraConfig.getSharedConfig;
    apiCallFn({
      id: $stateParams.cameraId
    }, function (data) {
      angular.extend($scope.config, data);
      if (data && data.cameraSchedule) {
        $scope.scheduleOn = data.cameraSchedule.scheduleOn;
      }
      if ($scope.config.resolution) {
        $scope.config.resolution = $scope.config.resolution.toUpperCase();
      }
      $("#cameraNameView").html($scope.config.name);
      $scope.cameraStatusSet(clickStatus);
      if ($scope.config.cameraSchedule != undefined) {
        $scope.config.parsedStartAt = Utils.configDateSeparate($scope.config.cameraSchedule.startAt);
        $scope.config.parsedStopAt = Utils.configDateSeparate($scope.config.cameraSchedule.stopAt);
        $scope.config.repeatOn = Utils.configRepeatOnSeparate($scope.config.cameraSchedule.repeatOn);
      }
      if ($scope.config.timezone != undefined) {
        $scope.config.tzCode = $scope.config.timezone.split(",")[0];
        $scope.tzCode = $scope.config.tzCode;
        $scope.config.tzDisplayName = $scope.config.timezone.split(",")[1] + $scope.config.timezone.split(",")[3];
      }
      $scope.micVolume = $scope.config.micVolume;
      $scope.volumeList = [];
      for (var i = 0; i < 31; i++) {
        if (i == 0) {
          $scope.volumeList.push(1);
        } else {
          $scope.volumeList.push(Math.ceil(i * 3.4));
        }
      }
      $scope.volumeIdx = $scope.config.micVolume;
      $("#settingSoundbar").css("width", $scope.volumeList[$scope.volumeIdx]);
      $("#settingSoundbar_full").css("width", $scope.volumeList[$scope.volumeIdx]);
      if ($scope.config.usageRate > 100) {
        $scope.config.usageRate = 100;
      }
      if ($scope.playerObj) {
        $scope.playerObj.setData("cameraConfig", $scope.config);
      }
      if (typeof callback === "function") {
        callback();
      }
    }, function (err) {
      // error
      $state.go("main", {}, {
        reload: true
      });
    });
  };
  $scope.loadCameraSetting(function () {
    loadCurrentCamera().then(function () {
      if ($state.current.name !== "main.cameraDetail") {
        return;
      }
      $scope.usePeopleCount = $scope.config.cameraAIConfig && $scope.config.cameraAIConfig.aiTypeCode === 1;
      $scope.isMuted = true;
      if ($scope.currentCamera.serviceType == "0d" && $scope.currentCamera.recordType == "na" && $scope.currentCamera.recorderType == "cvr") {
        $scope.currentCamera.streamStatus = "off";
        $scope.currentCamera.controlStatus = "off";
      }
      $scope.playerObj = new tCam.player({
        elementIdMap: {
          root: "camdtl_wrap"
        },
        shopId: $rootScope.cameraShopId,
        isShared: $scope.shareStatus,
        category: "b2b",
        playerType: "hls",
        mute: $scope.isMuted,
        cameraData: $scope.currentCamera,
        cameraConfig: $scope.config,
        playEventCb: playerEventHandler,
        country: $rootScope.me.country,
        playTime: $stateParams.time && $scope.currentCamera.cloud ? parseInt($stateParams.time) : 0
      });
      if ($scope.currentCamera.serviceType == "0d" && $scope.currentCamera.recordType == "na" && $scope.currentCamera.recorderType == "cvr") {
        $("#error_status_wrap").css("display", "none");
      }
      if ($scope.currentCamera.isAiSupport && $scope.usePeopleCount && !$scope.isExpiredCloud()) {
        requestCamAiGraph(true);
        makeAiInfoReqInterval();
        $("#ai_graph_wrap").css("width", $("#player").width());
      }
      $scope.currentCameraDataSet();
      $scope.cameraStatusSet();
      getSensorFilterFromLocalStorage();
      getInoutFilterFromLocalStorage();
      loadCameraList();
      d3.select("#ptzCursor").call(ptzCursorDrag);
      $timeout(function () {
        $("#cvr_play_manager_wrap input").attr("autocomplete", "new-password");
      }, 100);
    });
  });
  function keydownHandler(event) {
    if ($(".dimmed:visible").length || $scope.isShowPtzControl) {
      return true;
    }
    if (event.which === 39) {
      //right
      if (!$scope.cloud_out) {
        $scope.playerObj.jumpToCvrWithSeconds(10);
      }
      return false;
    } else if (event.which === 37) {
      //left
      if (!$scope.cloud_out) {
        $scope.playerObj.jumpToCvrWithSeconds(-10);
      }
      return false;
    } else if (event.which === 32) {
      //space
      $scope.playerObj.togglePlay();
      return false;
    }
  }
  $(document).on("keydown", keydownHandler);
  $scope.configStatus = "basic";
  $scope.showEventFilterSettingLayer = function (isShow) {
    if ($scope.currentCamera.serviceType == "0d" && $scope.currentCamera.recordType == "na" && $scope.currentCamera.recorderType == "cvr") {
      return;
    }
    if (isShow) {
      var _ref, _ref$find;
      $scope.tempMotionZones = $scope.motionZones ? JSON.parse(JSON.stringify($scope.motionZones)) : [];
      $scope.tempInoutFilter = $scope.inoutFilter;
      $scope.tempSoundFilter = ((_ref = _) === null || _ref === void 0 ? void 0 : (_ref$find = _ref.find($scope.eventZones, ["id", "0"])) === null || _ref$find === void 0 ? void 0 : _ref$find.filterMark) === "on";
      var allSensorZonesActive = $scope.tempSensorZones.every(function (_ref2) {
        var filterMark = _ref2.filterMark;
        return filterMark === "on";
      });
      $scope.allMotionCheck = !_.includes(_.map($scope.tempMotionZones, "filterMark"), "off") && $scope.tempInoutFilter && allSensorZonesActive && (!$scope.soundZone || !!$scope.tempSoundFilter);
    }
    $scope.isShowEventFilterSettingLayer = isShow;
  };
  $scope.confirmEventFilterCheck = function () {
    $scope.sensorZones = JSON.parse(JSON.stringify($scope.tempSensorZones));
    setSensorFilterToLocalStorage();
    $scope.motionZones = JSON.parse(JSON.stringify($scope.tempMotionZones));
    $scope.inoutFilter = $scope.tempInoutFilter;
    if (_.find($scope.eventZones, ["id", "0"])) {
      _.find($scope.eventZones, ["id", "0"]).filterMark = $scope.tempSoundFilter ? "on" : "off";
    }
    if ($scope.playerObj) {
      $scope.playerObj.setData("sensorZones", $scope.sensorZones);
      $scope.playerObj.setData("motionZones", $scope.motionZones);
      $scope.playerObj.setData("inoutFilter", $scope.inoutFilter);
    }
    setInoutFilterToLocalStorage();
    $scope.isShowEventFilterSettingLayer = false;
    //공유 카메라가 아닌 경우 필터 저장
    if (!$scope.shareStatus) {
      saveFilter();
    }
    $scope.playerObj.redrawEvents($scope.events); //타임라인 이벤트 그리기
  };
  $scope.clickedCameraSettingButton = function (shareCheck) {
    if (!$scope.currentCamera.hasConfigPermission) {
      showAlert($translate.instant("SHARE_ED_CAMERA"), $translate.instant("SHARE_ED_CAMERA_IS_NO"));
      return;
    }

    // ! 카메라 설정 버튼을 누를때 설정값을 다시 불러와서 Streaming서버 상태값을 최신으로 갱신하도록 개선
    if (!$scope.shareStatus) {
      Camera.get({
        id: $stateParams.cameraId
      }, function (res) {
        $scope.currentCamera = res;
        $scope.shareAddModel = {
          shareOptions: ["1", "0"]
        };
        $scope.isShowCameraSetting = !$scope.isShowCameraSetting;
        $scope.loadCameraSetting("", "setting");
        if ($scope.shareStatus && !$scope.currentCamera.hasConfigPermission) {
          $scope.configStatus = "share";
          if ($scope.shareStatus) {
            $scope.getShareConfig();
          }
        } else {
          if (shareCheck == "share") {
            $scope.configStatus = "share";
          } else {
            $scope.configStatus = "basic";
            // 라이브 상품이 아닌경우
            if (!$scope.isExpiredCloud()) {
              confirmFromToastMarket(); // 마켓판매 상품인지 확인 후 카메라 제거 or 서비스 해지 버튼 노출
            }
          }
        }
      });
    } else {
      Share.get({
        id: $stateParams.cameraId
      }, function (res) {
        $scope.currentCamera = res;
        $scope.shareAddModel = {
          shareOptions: ["1", "0"]
        };
        $scope.isShowCameraSetting = !$scope.isShowCameraSetting;
        $scope.loadCameraSetting("", "setting");
        if ($scope.shareStatus && !$scope.currentCamera.hasConfigPermission) {
          $scope.configStatus = "share";
          if ($scope.shareStatus) {
            $scope.getShareConfig();
          }
        } else {
          if (shareCheck == "share") {
            $scope.configStatus = "share";
          } else {
            $scope.configStatus = "basic";
            // 라이브 상품이 아닌경우
            if (!$scope.isExpiredCloud()) {
              confirmFromToastMarket(); // 마켓판매 상품인지 확인 후 카메라 제거 or 서비스 해지 버튼 노출
            }
          }
        }
      });
    }
  };
  $scope.clickedCameraShareButton = function () {
    $scope.configStatus = "share";
    $scope.clickedCameraSettingButton("share");
  };
  $scope.getShareConfig = function () {
    $scope.shareConfig = Share.shareConfig({
      cameraId: $stateParams.cameraId
    });
  };

  // 마켓 판매 상품인지 확인
  $scope.isFromToastMarket = false;
  var confirmFromToastMarket = function confirmFromToastMarket() {
    Market.get({
      cameraId: $scope.currentCamera.id
    }, function (data) {
      $scope.isFromToastMarket = data.isFromToastMarket;
    }, function (err) {
      showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
    });
  };
  $scope.shareDisable = function () {
    if ($scope.shareStatus && !$scope.currentCamera.hasConfigPermission) {
      if ($stateParams.type === "sharedgroup") {
        showAlert($translate.instant("SHARE_ED_CAMERA"), $translate.instant("STR_NO_CAMERA_SET_AUTH"));
      } else {
        showAlert($translate.instant("SHARE_ED_CAMERA"), $translate.instant("SHARE_ED_CAMERA_IS_NO"));
      }
      return true;
    } else {
      return false;
    }
  };
  $scope.getCameraConfig = function () {
    var apiCallFn = !$scope.shareStatus ? CameraConfig.get : CameraConfig.getSharedConfig;
    apiCallFn({
      id: $stateParams.cameraId
    }, function (data) {
      angular.extend($scope.config, data);
      $scope.config.tzCode = $scope.config.timezone.split(",")[0];
      $scope.tzCode = $scope.config.tzCode;
      if (data && data.cameraSchedule) {
        $scope.scheduleOn = data.cameraSchedule.scheduleOn;
      }
      if ($scope.playerObj) {
        $scope.playerObj.setData("cameraConfig", $scope.config);
      }
    });
  };

  // 귀가시 녹화꺼짐 설정
  $scope.changeRecStopInHome = function (status) {
    CameraConfig.update({
      id: $stateParams.cameraId
    }, {
      recStopInHome: status
    }, function (data) {
      if (data.code == "ok") {
        $scope.config.recStopInHome = status;
      } else {
        showAlert($translate.instant("FAIL"), $translate.instant("ACCESS_SET_FAIL"));
      }
    }, function (err) {
      showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
    });
  };
  $scope.requestLivePlay = function () {
    if (!$scope.playerObj || !$scope.playControl) {
      return;
    }
    if ($scope.playControl.getData("isLive") == false) {
      $scope.playerObj.requestPlay();
    }
  };
  $scope.setCameraData = function (data) {
    $scope.currentCamera = data;
    if ($scope.playerObj) {
      $scope.playerObj.setData("cameraData", $scope.currentCamera);
    }
  };
  $scope.updateCameraErrorStatus = function (status) {
    if (!$scope.playControl) {
      return;
    }

    // ! 줌 초기화 처리
    if ($scope.playControl.isLive && $scope.playControl.zoomArea) {
      $scope.playControl.zoomArea.changeZoom(1);
    }
    if (status === "recoff") {
      $scope.playControl.errorStatusLayer.cameraRecOff();
      if ($scope.playControl.isPlaying) {
        // ! player 일시정지 처리
        $scope.playControl.playIndicator.showIndicator("pause");
        $scope.playControl.playInfoBar.pauseBtn();
      }
    } else {
      $scope.playControl.errorStatusLayer.cameraStatusAllOff();
      if (!$scope.playControl.isPlaying) {
        // ! player 재생 처리
        $scope.playControl.playIndicator.showIndicator("play");
        $scope.playControl.playInfoBar.playBtn();
      }
    }
  };
  $scope.cameraUpgrade = function (obj) {
    if (event.preventDefault) {
      event.preventDefault();
    } else {
      event.returnValue = false;
    }

    // ! silence - 펌웨어 업데이트시, 카메라 기기 음성 안내 여부( false: 음성 안내 )
    Camera.upgradeCamera({
      cameraId: $scope.currentCamera.id,
      silence: false
    }, function (data) {
      $scope.cameraUpagradeAlert = false;
      $scope.isUpgrading = true;
      $scope.isShowCameraSetting = false;
      $scope.hasMenuSettingBadge = false;
    });
  };
  $scope.hideRemoveCameraAlert = function () {
    $scope.showRemoveCameraAlert = false;
  };
  $scope.removeCameraConfirm = function () {
    Camera.remove({
      id: $stateParams.cameraId
    }, function (res) {
      if (res.code === "ok") {
        if ($stateParams.type === "shop" || $stateParams.type === "sharedshop") {
          $state.go("main.dashboard.shop");
        } else {
          $state.go("main.cameraGroup.group");
        }
      } else {
        showAlert($translate.instant("CAMERA_SETTING_REMOVE_CAMERA"), res.msg ? res.msg : $translate.instant("ACCESS_FAIL"));
      }
    });
  };
  $scope.changeNotifyOn = function (notifyOn) {
    $scope.notify.notifyOn = notifyOn;
    CameraNotifyConfig.update({
      id: $stateParams.cameraId
    }, {
      notifyOn: notifyOn
    });
  };
  $scope.changeEventType = function () {
    var eventType = Utils.notifyEventTypeJoin($scope.notify.eventType);
    CameraNotifyConfig.update({
      id: $stateParams.cameraId
    }, {
      notifyEventType: eventType
    });
  };
  $scope.changeNotifyScheduleOn = function (scheduleOn) {
    $scope.notify.notifySchedule.scheduleOn = scheduleOn;
    if (scheduleOn == "off") {
      $scope.notify.repeatOn.SUN = false;
      $scope.notify.repeatOn.MON = false;
      $scope.notify.repeatOn.TUE = false;
      $scope.notify.repeatOn.WED = false;
      $scope.notify.repeatOn.THU = false;
      $scope.notify.repeatOn.FRI = false;
      $scope.notify.repeatOn.SAT = false;
      $("input[name=notifyDays]").attr("disabled", true);
      $("#notifyStartHour").attr("disabled", true);
      $("#notifyStartMin").attr("disabled", true);
      $("#notifyEndHour").attr("disabled", true);
      $("#notifyEndMin").attr("disabled", true);
      $("#notifyStartHour").css("opacity", "0.2");
      $("#notifyStartMin").css("opacity", "0.2");
      $("#notifyEndHour").css("opacity", "0.2");
      $("#notifyEndMin").css("opacity", "0.2");
      $("input[name=notifyDays]").parent("span").css("opacity", "0.2");
    } else {
      $("input[name=notifyDays]").removeAttr("disabled");
      $("#notifyStartHour").removeAttr("disabled");
      $("#notifyStartMin").removeAttr("disabled");
      $("#notifyEndHour").removeAttr("disabled");
      $("#notifyEndMin").removeAttr("disabled");
      $("#notifyStartHour").css("opacity", "");
      $("#notifyStartMin").css("opacity", "");
      $("#notifyEndHour").css("opacity", "");
      $("#notifyEndMin").css("opacity", "");
      $("input[name=notifyDays]").parent("span").css("opacity", "");
    }
  };
  $scope.changeAlertUpdate = function () {
    var scheduleOn = $scope.notify.notifySchedule.scheduleOn;
    var startAt = Utils.configDateJoin($scope.notify.parsedStartAt);
    var stopAt = Utils.configDateJoin($scope.notify.parsedStopAt);
    var repeatOn = Utils.configRepeatOnJoin($scope.notify.repeatOn);
    CameraNotifyConfig.update({
      id: $stateParams.cameraId
    }, _defineProperty(_defineProperty({
      scheduleOn: scheduleOn,
      stopAt: stopAt
    }, "stopAt", stopAt), "repeatOn", repeatOn), function (data) {
      if (data.code == "ok") {
        showAlert($translate.instant("ALARM_SETTING_SAVE_SUBECT"), $translate.instant("ALARM_SETTING_SAVE_CONTENT"));
      }
    });
  };
  $scope.pressedMuteButton = function (value) {
    if ($scope.currentCamera.isAudioSupport != 1) {
      showAlert($translate.instant("NOT_SUPPORT"), $translate.instant("NOT_SUPPORT_FUNCTION"));
      return;
    }
    if (typeof value === "boolean") {
      $scope.isMuted = value;
    } else {
      $scope.isMuted = !$scope.isMuted;
    }
    if ($scope.player) {
      $scope.player.mute($scope.isMuted);
    }
  };
  $scope.changeAlerCancle = function () {
    $scope.loadNotifyConfig();
  };
  var cc = 0;
  $scope.setCurrentTab = function (tabName, status) {
    $("body").off("click", editZoneNameSaveClickFn);
    if (tabName == "zone") {
      if ($scope.currentCamera.serviceType == "0d" && $scope.currentCamera.recordType == "na" && $scope.currentCamera.recorderType == "cvr") {
        return;
      }
    }
    if ($scope.playControl.getData("screenloading") == 0) {
      if ($scope.currentCamera.recorderType !== "recorder") {
        showAlert($translate.instant("DATA_LOADING_SUBJECT"), $translate.instant("DATA_LOADING_CONTENT"));
        return;
      }
    }
    if (tabName == "zone") {
      if (!$scope.currentCamera.hasConfigPermission) {
        showAlert($translate.instant("SHARE_ED_CAMERA"), $translate.instant("SHARE_ED_CAMERA_IS_NO"));
        return;
      }
      if ($scope.currentCamera.recorderType === "recorder") {
        showAlert("DVR에 연결된 카메라", "DVR에 연결된 카메라에서는 움직임 감지 영역을 설정할 수 없습니다.");
        return;
      } else if ($scope.currentCamera.recorderType === "gateway") {
        showAlert($translate.instant("STR_GATEWAY_CON_CAM"), $translate.instant("STR_GATEWAY_NOT_CONTROL_ZONE"));
        return;
      }
    }
    $scope.currentTab = tabName;
    if (tabName == "zone") {
      $("#eventList_list").hide();
      if ($scope.playControl.zoomArea) {
        $scope.playControl.zoomArea.changeZoom(1);
      }
      $("#pause_btn").removeClass("pause");
      $("#play_btn").removeClass("play");
      $("#golive_btn").removeClass("golive");
      $("#pause_btn").addClass("pause_disabled");
      $("#play_btn").addClass("play_disabled");
      $("#golive_btn").addClass("golive_disabled");
      $("#cam_info").css("z-index", 1);
      $("#timelinedesc").css("top", "44px");
      if ($scope.playControl.getData("showCameraOffLayer") == true) {
        $("#cameraOffLayerIn").hide();
      }
      $scope.showSelectColor = false;
      var canvas = document.getElementById("zone-area");
      canvas.width = $("#player").width();
      canvas.height = $("#player").height();
      $scope.showZoneSetting();
      $("#view_cam_ctrl").children("div").hide();
      var c = $scope.getCookie("alarm_set_no");
      if (c == "alarm_set_no") {
        $("#alarm_set").remove();
      }
      $("#view_cam_ctrl").css("visibility", "hidden");
      if (status != "edit") {
        getAlarmZones();
      }
      $scope.showPtzControl(false);
      if (cc === 0) {
        cc = cc + 1;
      }
    } else {
      $(".alrm_lst").children("li").removeClass("open");
      $scope.currentEditingZoneId = -1;
      $("#eventList_list").show();
      $("#pause_btn").addClass("pause");
      $("#play_btn").addClass("play");
      $("#golive_btn").addClass("golive");
      $("#pause_btn").removeClass("pause_disabled");
      $("#play_btn").removeClass("play_disabled");
      $("#golive_btn").removeClass("golive_disabled");
      $("#cam_info").css("z-index", "");
      $("#timelinedesc").css("top", "50px");
      if ($scope.playControl.getData("showCameraOffLayer") == true) {
        $("#cameraOffLayerIn").show();
      }
      $scope.hideZoneSetting();
      $scope.pressedEventListDateButton($scope.selectedEventDateIndex);
      $("#view_cam_ctrl").children("div").show();
      $("#view_cam_ctrl").css("visibility", "visible");
    }
    $scope.initFlags();
  };

  // Event List

  var eventListDate = function eventListDate() {
    var dates = [];
    var now = Date.now();
    for (var i = 0; i <= $scope.serviceDay; i++) {
      var past = now - i * 24 * 60 * 60 * 1000;
      var date = {
        date: $scope.formattedInternalDate(new Date(past))
      };
      date.day = moment(new Date(past)).locale(Utils.getBrowserLanguage()).format($translate.instant("EVENT_LIST_DATE_FORMAT"));
      if (i === 0) {
        date.day += " (" + $translate.instant("EVENT_LIST_DATE_TODAY") + ")";
      }
      dates.push(date);
    }
    return dates;
  };
  $scope.eventlists = {};
  $scope.eventlistDates = Array.from({
    length: 30
  }, function () {
    return {};
  });
  $scope.eventThumbnails = {};
  $scope.eventDetectType = ["motion", "audio", "access"];
  $scope.checkboxAudioEvent = true;
  $scope.eventFilter = {};
  $scope.eventFilter.accessCheck = true;
  $scope.eventIncludeDetectType = function (detectType) {
    if (!$scope.serviceDay) {
      return;
    }
    if (detectType == "motion") {
      if ($("#f_move").is(":checked") == true) {
        for (var i = 0; i < $scope.selectedAllZones.length; i++) {
          if ($scope.selectedAllZones[i] != 0) {
            $scope.selectedZones.push($scope.selectedAllZones[i]);
            $scope.hideZones = [];
            checkFilters.put($scope.selectedAllZones[i], $scope.selectedAllZones[i]);
          }
        }
        $scope.eventDetectType.push("motion");
        $("#zone8").prop("checked", true);

        //show
        for (var _i = 1; _i <= 8; _i++) {
          $(".nntion.color_" + _i).show();
        }
      } else {
        $scope.selectedZones = [];
        if ($("#f_sound").is(":checked") == true) {
          $scope.selectedZones.splice(0, $scope.selectedZones.length);
          $scope.selectedZones.push("0");
        }
        for (var _i2 = 0; _i2 < $scope.selectedAllZones.length; _i2++) {
          if ($scope.selectedAllZones[_i2] != 0) {
            $scope.hideZones.push($scope.selectedAllZones[_i2]);
            checkFilters.remove($scope.selectedAllZones[_i2]);
          }
        }
        var motionIdx = $scope.eventDetectType.indexOf("motion");
        $scope.eventDetectType.splice(motionIdx, 1);
        $("#zone8").prop("checked", false);
        //hide
        for (var _i3 = 1; _i3 <= 8; _i3++) {
          $(".nntion.color_" + _i3).hide();
        }
      }
    } else if (detectType == "audio") {
      if ($scope.checkboxAudioEvent) {
        $scope.hideZones.splice($scope.hideZones.indexOf("0"), 1);
        $scope.selectedZones.push("0");
        $scope.eventDetectType.push("audio");
        $(".nntion.color_0").show();
      } else {
        $scope.selectedZones.splice($scope.selectedZones.indexOf("0"), 1);
        $scope.hideZones.push("0");
        var audioIdx = $scope.eventDetectType.indexOf("audio");
        $scope.eventDetectType.splice(audioIdx, 1);
        $(".nntion.color_0").hide();
      }
    } else if (detectType === "access") {
      if ($scope.eventFilter.accessCheck) {
        $scope.hideZones.splice($scope.hideZones.indexOf("9"), 1);
        $scope.selectedZones.push("9");
        $scope.eventDetectType.push("access");
      } else {
        $scope.selectedZones.splice($scope.selectedZones.indexOf("9"), 1);
        $scope.hideZones.push("9");
        var accessIndex = $scope.eventDetectType.indexOf("access");
        $scope.eventDetectType.splice(accessIndex, 1);
      }
    }
    changedSelectedZone(detectType);
    $scope.eventListChnage();
  };
  var eventGroupTmp = [];

  // 이벤트 리스트 날짜 이동 처리
  $scope.pressedEventListDateButton = function (index) {
    $scope.showSelectColor = false;
    $scope.selectedEventDateIndex = index;
    if (index !== undefined && $scope.eventlists[index.toString()] === undefined) {
      $scope.eventlists[index.toString()] = {};
    }
    var selectedDate = dateWithDateIndex(index);
    if (!$scope.shareStatus) {
      if ($stateParams.type === "shop" || $stateParams.type === "sharedshop" || $stateParams.shopId) {
        var shopId = $stateParams.shopId || $stateParams.id;
        $scope.eventlistDates[index] = Camera.eventDaily({
          id: $scope.currentCamera.id,
          shopId: shopId,
          date: selectedDate
        }, function (data) {
          $scope.pressEventDailyDataSet(data, index);
        }, function (err) {
          setTimeout(function () {
            if (errCnt === 0) {
              errCnt++;
            }
          }, 150);
        });
      } else {
        $scope.eventlistDates[index] = Camera.eventDaily({
          id: $scope.currentCamera.id,
          date: selectedDate
        }, function (data) {
          $scope.pressEventDailyDataSet(data, index);
        }, function (err) {
          setTimeout(function () {
            if (errCnt === 0) {
              errCnt++;
            }
          }, 150);
        });
      }
    } else {
      if ($stateParams.type === "shop" || $stateParams.type === "sharedshop" || $stateParams.shopId) {
        var _shopId = $stateParams.shopId || $stateParams.id;
        $scope.eventlistDates[index] = Share.eventDaily({
          id: $stateParams.cameraId,
          shopId: _shopId,
          date: selectedDate
        }, function (data) {
          $scope.pressEventDailyDataSet(data, index);
        }, function (err) {
          setTimeout(function () {
            if (errCnt == 0) {
              $scope.goDetail($scope.currentCamera.id);
              errCnt++;
            } else {
              setTimeout(function () {
                location.reload();
              }, 150);
            }
          }, 150);
        });
      } else {
        $scope.eventlistDates[index] = Share.eventDaily({
          id: $stateParams.cameraId,
          date: selectedDate
        }, function (data) {
          $scope.pressEventDailyDataSet(data, index);
        }, function (err) {
          setTimeout(function () {
            if (errCnt == 0) {
              $scope.goDetail($scope.currentCamera.id);
              errCnt++;
            } else {
              setTimeout(function () {
                location.reload();
              }, 150);
            }
          }, 150);
        });
      }
    }
  };

  // 이벤트 리스트 날짜 이동시 이벤트 리스트 목록에 출력하는 화면 생성
  $scope.pressEventDailyDataSet = function (data, index) {
    var i, len, time;
    $scope.allEventCount = calcAllEventCount(data);
    eventGroupTmp = [];
    for (i in data.eventsGroup) {
      var hourText = $translate.instant("HOUR_COUNT");
      if ($("html").attr("lang") == "en") {
        hourText = " hour";
      }
      data.eventsGroup[i].startDate = moment(data.eventsGroup[i].start).format("HH") + hourText;
      data.eventsGroup[i].endDate = moment(data.eventsGroup[i].end).format("HH") + hourText;
    }
    for (i = data.eventsGroup.length - 1; i >= 0; i--) {
      eventGroupTmp.push(data.eventsGroup[i]);
    }
    $scope.eventlistDates[index] = eventGroupTmp;
    $(".eventListArea").css("height", $("#eventList_list").height() - 50);
    setTimeout(function () {
      eventListHeightCheckSize = 0;
      var nowHours = new Date().getHours();
      if ($scope.eventListDate[index]) {
        for (i = 0; i < 24; i++) {
          var motionCnt = $("#btn_time_" + i + "_" + $scope.eventListDate[index].date).children("button").children("span").html();
          if (motionCnt != "") {
            $("#btn_time_" + i + "_" + $scope.eventListDate[index].date).show();
            eventListHeightCheckSize++;
          }
        }
        if ($stateParams.time) {
          if (!$scope.selectedEventTime || findingEventTimeFlag) {
            len = $scope.eventlistDates[index].length;
            time = parseInt($stateParams.time, 10);
            for (i = 0; i < len; i += 1) {
              if ($scope.eventlistDates[index][i]) {
                if (time >= $scope.eventlistDates[index][i].start && time <= $scope.eventlistDates[index][i].end) {
                  $scope.pressedEventListTimeButton($scope.eventlistDates[index][i].index, $scope.eventListDate[index].date, $scope.eventDatesCount($scope.eventlistDates[index][i].audioCount, $scope.eventlistDates[index][i].motionCount, $scope.eventlistDates[index][i].accessCount, $scope.eventlistDates[index][i].sensorCount, $scope.eventlistDates[index][i].zoneCount, $scope.eventlistDates[index][i].sensorCountMap));
                  findingEventTimeFlag = false;
                  break;
                }
              }
            }
          }
        }
      }
    }, 150);
  };
  $scope.checkTimeInclude = function (eventTime, startTime, endTime) {
    var parsedTime = parseInt(eventTime, 10);
    if (parsedTime >= parseInt(startTime, 10) && parsedTime <= parseInt(endTime, 10)) {
      return true;
    } else {
      return false;
    }
  };

  // 이벤트 리스트 목록 호출
  $scope.updateEventListDate = function () {
    if ($scope.eventListDateIndex == 0) {
      $scope.selectedEventDateIndex = 0;
      var shopId,
        selectedDate = dateWithDateIndex(0);
      if (!$scope.shareStatus) {
        if ($stateParams.type === "shop" || $stateParams.type === "sharedshop" || $stateParams.shopId) {
          shopId = $stateParams.shopId || $stateParams.id;
          Camera.eventDaily({
            id: $scope.currentCamera.id,
            shopId: shopId,
            date: selectedDate
          }, function (data) {
            $scope.updateEventListEventDailyDataSet(data);
          });
        } else {
          Camera.eventDaily({
            id: $scope.currentCamera.id,
            date: selectedDate
          }, function (data) {
            $scope.updateEventListEventDailyDataSet(data);
          });
        }
      } else {
        if ($stateParams.type === "shop" || $stateParams.type === "sharedshop" || $stateParams.shopId) {
          shopId = $stateParams.shopId || $stateParams.id;
          Share.eventDaily({
            id: $stateParams.cameraId,
            shopId: shopId,
            date: selectedDate
          }, function (data) {
            $scope.updateEventListEventDailyDataSet(data);
          });
        } else {
          Share.eventDaily({
            id: $stateParams.cameraId,
            date: selectedDate
          }, function (data) {
            $scope.updateEventListEventDailyDataSet(data);
          });
        }
      }
    }
  };
  function calcAllEventCount(data) {
    var key,
      i,
      len,
      count = 0;
    if (data && data.eventsGroup && data.eventsGroup.length) {
      for (i = 0, len = data.eventsGroup.length; i < len; i += 1) {
        if (data.eventsGroup[i]) {
          count += data.eventsGroup[i].accessCount;
          count += data.eventsGroup[i].audioCount;
          count += data.eventsGroup[i].motionCount;
          count += data.eventsGroup[i].sensorCount;
          for (key in data.eventsGroup[i].zoneCount) {
            if (data.eventsGroup[i].zoneCount[key]) {
              count += data.eventsGroup[i].zoneCount[key];
            }
          }
        }
      }
    }
    return count;
  }
  $scope.updateEventListEventDailyDataSet = function (data) {
    $scope.allEventCount = calcAllEventCount(data);
    var nowHours = new Date().getHours();
    var selectedDate = dateWithDateIndex(0);
    if (data.eventsGroup[nowHours].audioCount == undefined) {}
    if ($scope.eventlistDates[0][23 - nowHours] == undefined) {
      return;
    }
    if (data.eventsGroup[nowHours].audioCount != undefined) {
      $scope.eventlistDates[0][23 - nowHours].audioCount = data.eventsGroup[nowHours].audioCount;
    }
    $scope.eventlistDates[0][23 - nowHours].motionCount = data.eventsGroup[nowHours].motionCount;
  };
  $scope.ImageExist = function (url) {
    var img = new Image();
    img.src = url;
    if (img.height == 0) {
      return false;
    } else {
      return true;
    }
  };
  $scope.indexOf = function (target, param) {
    if (!target || !param) {
      return -1;
    }
    return target.indexOf(param);
  };
  var eventListHeightCheckSize = 0;
  var tempIndexCheck = 0;
  var pEventButtonIdx = 0;
  var pEventButtonDate = 0;
  var openEventListflag = false; // 시간대별 이벤트 목록 호출 중복 클릭 방지

  // 시간대별 이벤트 리스트 목록 호출
  $scope.pressedEventListTimeButton = function (index, date, count) {
    if (openEventListflag == true) {
      return;
    }
    openEventListflag = true;
    $("#btn_time_" + index + "_" + date).children("ul").hide();
    if ($("#btn_time_" + index + "_" + date).attr("class") == undefined) {
      openEventListflag = false;
      return;
    }
    if (tempIndexCheck == index && $("#btn_time_" + index + "_" + date).attr("class").indexOf("open") == -1) {
      $scope.pressedEventListTimeButtonFlag = false;
      $("#btn_time_" + index + "_" + date).addClass("open");
    }
    $(".event_list_li_level_2.open").children("ul").children().empty();
    $(".pos_rgt").css("color", "#999999");
    $(".event_list_li_level_2").removeClass("open").children("button").css("color", "#333333");
    if (tempIndexCheck != index) {
      $scope.pressedEventListTimeButtonFlag = false;
    }
    if (count <= 0) {
      openEventListflag = false;
      return;
    }
    if ($scope.pressedEventListTimeButtonFlag == false) {
      pEventButtonIdx = index;
      pEventButtonDate = date;
      tempIndexCheck = index;
      $("#btn_time_" + index + "_" + date).addClass("open");
      if ($scope.selectedEventTimeIndex === index) {
        $scope.selectedEventTimeIndex = -1;
      } else {
        $scope.selectedEventTimeIndex = index;
      }
      var timeRange = timeRangeWithEventIndexes($scope.selectedEventDateIndex, index);
      eventTimeRange = timeRange;
      var scale = "1h";
      if ($scope.currentCamera.recordType == "event") {
        scale = "10m";
      }
      var params;
      if ($stateParams.type === "shop" || $stateParams.type === "sharedshop" || $stateParams.shopId) {
        var shopId = $stateParams.shopId || $stateParams.id;
        params = {
          id: $scope.currentCamera.id,
          scale: scale,
          shopId: shopId,
          start: timeRange[0],
          end: timeRange[1],
          mode: "desc"
        };
      } else {
        params = {
          id: $scope.currentCamera.id,
          scale: scale,
          start: timeRange[0],
          end: timeRange[1],
          mode: "desc"
        };
      }
      Camera.eventGroup(params, function (data) {
        $("#btn_time_" + index + "_" + date).children("button").css("color", "#4a95eb").children("span").css("color", "#4a95eb");
        if (data.events == undefined) {
          $(".depth2").hide();
          openEventListflag = false;
          return;
        }
        if (data.events.length == 0) {
          $(".depth2").hide();
          openEventListflag = false;
          return;
        }
        var eventThumbnails = {};
        var allEventZones = _.map(_.filter(_.concat($scope.eventZones, $scope.motionZones), ["filterMark", "on"]), "id");
        if ($scope.inoutFilter) {
          allEventZones = _.concat(allEventZones, ["ACCESS_ENTER", "ACCESS_EXIT"]);
        }
        $scope.sensorZones.forEach(function (sensorZone) {
          if (sensorZone.filterMark === "on") {
            allEventZones.push(sensorZone.id);
          }
        });
        for (var i in data.events) {
          var _event = data.events[i];
          _event.timeRange = eventListFormatted(_event);
          _event.durationString = Utils.durationStringFromTwoTime(_event.playStartTime || _event.startTime, _event.playEndTime || _event.endTime);
          var remain = data.events.length;
          var httpUrl = location.origin;
          if (httpUrl == undefined) {
            httpUrl = location.protocol + "//" + location.hostname;
          }
          var imagePath = location.protocol + "//" + _event.filePath;
          $(".event_img").hide();
          eventThumbnails[i] = {
            style: {
              "background-image": "url(" + imagePath + "), url(/resources/img/img_camera_fail.svg)",
              "background-size": "cover",
              "background-position": "center"
            },
            index: 10,
            imagePath: imagePath
          };
          $scope.eventThumbnails[i] = eventThumbnails[i];
          remain -= 1;
          if (remain.toString() === i) {}
          var dataList = [];
          var _loop = function _loop() {
            var dataObj = {};
            var zoneIdxs = data.events[k].zoneUidxs.split(",");
            var zoneDetails = data.events[k].zoneDetails;
            var html = "";
            var _loop2 = function _loop2(j) {
              var indexNum = parseInt(_.get(_.find($scope.motionZones, function (o) {
                return o.uid === zoneIdxs[j] && o.id !== "9";
              }), "id"));
              if (isNaN(indexNum)) {
                indexNum = parseInt(_.get(_.find($scope.eventZones, ["id", zoneIdxs[j]]), "id"));
              }
              if (zoneIdxs[j] == 0) {
                indexNum = 0;
              } else if (zoneIdxs[j] === -1 || zoneDetails[j] !== undefined && zoneDetails[j].zoneIdx === "9") {
                indexNum = 9;
              } else if (zoneIdxs[j] === "ACCESS_ENTER" || zoneIdxs[j] === "ACCESS_EXIT" || zoneIdxs[j] === "SENSOR_TEMP" || zoneIdxs[j] === "SENSOR_HUMID" || zoneIdxs[j] === "SENSOR_MOTION" || zoneIdxs[j] === "SENSOR_GAS" || zoneIdxs[j] === "SENSOR_SMOKE" || zoneIdxs[j] === "SENSOR_PLUG" || zoneIdxs[j] === "SENSOR_MAGNETIC" || zoneIdxs[j] === "DOORLOCK_EVENT") {
                indexNum = zoneIdxs[j];
              }
              if (indexNum !== 10000 && indexNum !== 20000 && allEventZones.indexOf(indexNum.toString()) > -1) {
                switch (indexNum) {
                  case 0:
                    html += '<img src="/resources/img/ic-event-cam-sound.svg">';
                    break;
                  case 1:
                    html += '<img src="/resources/img/ic-event-s-zone-1.png">';
                    break;
                  case 2:
                    html += '<img src="/resources/img/ic-event-s-zone-2.png">';
                    break;
                  case 3:
                    html += '<img src="/resources/img/ic-event-s-zone-3.png">';
                    break;
                  case 4:
                    html += '<img src="/resources/img/ic-event-s-zone-4.png">';
                    break;
                  case 5:
                    html += '<img src="/resources/im/ic_area_color05_N.png">';
                    break;
                  case 6:
                    html += '<img src="/resources/im/ic_area_color06_N.png">';
                    break;
                  case 7:
                    html += '<img src="/resources/im/ic_area_color07_N.png">';
                    break;
                  case "ACCESS_ENTER":
                    html += '<img src="/resources/img/ic-event-in.png">';
                    break;
                  case "ACCESS_EXIT":
                    html += '<img src="/resources/img/ic-event-out.png">';
                    break;
                  case "SENSOR_TEMP":
                    html += '<img src="/resources/img/ic-sensor-s-temp.png">';
                    break;
                  case "SENSOR_HUMID":
                    html += '<img src="/resources/img/ic-sensor-s-hum.png">';
                    break;
                  case "SENSOR_MOTION":
                    html += '<img src="/resources/img/ic-sensor-s-motion.png">';
                    break;
                  case "SENSOR_GAS":
                    var gasStatus = _.get(_.find(zoneDetails, ["zoneIdx", "SENSOR_GAS"]), "status");
                    if (gasStatus && gasStatus.indexOf("DETECT") != -1) {
                      html += '<img src="/resources/img/ic-sensor-s-gas.png">';
                    } else {
                      html += '<img src="/resources/img/ic-sensor-s-gas-sensing.png">';
                    }
                    break;
                  case "SENSOR_SMOKE":
                    var smokeStatus = _.get(_.find(zoneDetails, ["zoneIdx", "SENSOR_SMOKE"]), "status");
                    if (smokeStatus && smokeStatus.indexOf("DETECT") != -1) {
                      html += '<img src="/resources/img/ic-sensor-s-smoke.png">';
                    } else {
                      html += '<img src="/resources/img/ic-sensor-s-smoke-sensing.png">';
                    }
                    break;
                  case "SENSOR_PLUG":
                    html += '<img src="/resources/img/ic-sensor-s-plug.png">';
                    break;
                  case "SENSOR_MAGNETIC":
                    html += '<img src="/resources/img/ic-sensor-s-door-close.png">';
                    break;
                  case "DOORLOCK_EVENT":
                    html += '<img src="/resources/img/ic-sensor-s-door-lock.png">';
                    break;
                  default:
                    html += '<img src="/resources/img/ic-event-s-delete-zone.png"';
                    break;
                }
              }
            };
            for (var j = 0; j < zoneIdxs.length; j++) {
              _loop2(j);
            }
            if (html) {
              dataObj.zoneIdxList = html;
              dataObj.id = data.events[k].id;
              dataObj.startTime = data.events[k].startTime;
              dataObj.playStartTime = data.events[k].playStartTime;
              dataObj.endTime = data.events[k].endTime;
              dataObj.playEndTime = data.events[k].playEndTime;
              dataObj.startTimeStr = moment(parseInt(data.events[k].playStartTime || data.events[k].startTime)).format("HH:mm:ss");
              dataObj.endTimeStr = moment(parseInt(data.events[k].playEndTime || data.events[k].endTime)).format("HH:mm:ss");
              dataObj.num = i;
              dataObj.timeRange = data.events[k].timeRange;
              dataObj.durationString = data.events[k].durationString;
              dataObj.zoneDetails = data.events[k].zoneDetails;
              dataObj.zoneUidxs = data.events[k].zoneUidxs;
              dataList.push(dataObj);
            }
          };
          for (var k = 0; k < data.events.length; k++) {
            _loop();
          }
        }
        $scope.eventlists[$scope.selectedEventDateIndex.toString()][index.toString()] = dataList;
        $("#btn_time_" + index + "_" + date).children("ul").show();
        var evtLiCheckCnt = 0;
        setTimeout(function () {
          for (var _i4 = index + 1; _i4 < 24; _i4++) {
            var evtLiCheck = $("#btn_time_" + _i4 + "_" + date).children("button").children("span").html();
            if (evtLiCheck != "") {
              evtLiCheckCnt++;
            }
          }
          var moveTo = 51 * evtLiCheckCnt;
          $(".eventListArea").scrollTop(moveTo);
          openEventListflag = false;
          $("#btn_time_" + index + "_" + date).addClass("open");
          setTimeout(function () {
            var $focused = $(".focused_event");
            if ($focused.length) {
              $focused[0].scrollIntoView(false);
            }
          }, 100);
        }, 200);
      }, function (err) {
        openEventListflag = false;
      });
      $scope.pressedEventListTimeButtonFlag = true;
    } else {
      $interval.cancel($scope.eventlistTimer);
      openEventListflag = false;
    }
  };
  $scope.renderHtml = function (html_code) {
    return $sce.trustAsHtml(html_code);
  };

  /**
   * 이벤트 리스트의 시간대별 필터링 된 존 카운트
   * @param  {String} audio     소리 존 카운트
   * @param  {String} motion    가족출입 존 카운트
   * @param  {String} access    가족출입 존 카운트
   * @param  {Object} zoneCountObj 모션존별 카운트
   * @return {String} sumCount	존 카운트 합계
   */
  $scope.eventDatesCount = function (audio, motion, access, sensor, zoneCountObj, sensorCountObj, index) {
    var _$scope$soundZone;
    var sumZoneCount = 0;
    var checkedMotionIds = _.map(_.filter($scope.motionZones, function (o) {
      return o.filterMark === "on" && o.id !== "9";
    }), "uid");
    var isCheckedDeleteZoneId = _.get(_.find($scope.motionZones, ["id", "9"]), "filterMark") === "on" ? true : false;
    /**
     * 삭제된 이벤트 필터를 체크 했을 경우 상젝
     */
    if (isCheckedDeleteZoneId) {
      var allEventZoneIds = _.concat(_.map($scope.eventZones, "id"), _.map(_.filter($scope.motionZones, function (o) {
        return o.id !== "9";
      }), "uid")); // 체크여부와 상관없이 모든 zonedId
      var deletedZoneIds = _.difference(_.keys(zoneCountObj), allEventZoneIds);
      checkedMotionIds = _.concat(checkedMotionIds, deletedZoneIds);
    }
    var motionsCount = _.sum(_.values(_.pick(zoneCountObj, checkedMotionIds)));
    audio = ((_$scope$soundZone = $scope.soundZone) === null || _$scope$soundZone === void 0 ? void 0 : _$scope$soundZone.filterMark) === "on" ? audio : 0;
    access = $scope.inoutFilter ? access : 0;
    var sensorSum = 0;
    if (sensorCountObj) {
      $scope.sensorZones.forEach(function (sensorZone) {
        if (sensorZone.filterMark === "on" && sensorCountObj[sensorZone.id]) {
          sensorSum += sensorCountObj[sensorZone.id];
        }
      });
    } else {
      var allSensorZonesDeactive = true,
        i,
        len = $scope.sensorZones.length;
      for (i = 0; i < len; i += 1) {
        if ($scope.sensorZones[i].filterMark === "on") {
          allSensorZonesDeactive = false;
        }
      }
      sensorSum = allSensorZonesDeactive ? 0 : sensor;
    }
    sumZoneCount = audio + access + sensorSum + motionsCount;
    if (sumZoneCount == 0) {
      return "";
    }
    return sumZoneCount;
  };
  $scope.selecEventId = "";
  $scope.pressedEventItem = function (data) {
    if ($stateParams.time) {
      if ($scope.selectedEventTime) {
        $scope.selectedEventTime = -1;
      }
    }
    $scope.selecEventId = data.id;
    $scope.playControl.playTimer.stopTimer();
    var targetTime = parseInt(data.playStartTime || data.startTime);
    event.cancelBubble = true; // for IE
    if (event.stopPropagation) {
      event.stopPropagation();
    }
    var cvrSecureManager = isFullScreen() ? $scope.playControl.cvrPlaySecureManagerFull : $scope.playControl.cvrPlaySecureManager;
    cvrSecureManager.checkCVRSeucre(function (isSecureMode) {
      if (isSecureMode) {
        cvrSecureManager.setCVRSecureCallback(function () {
          $scope.goCvr(targetTime, "f");
          $scope.showPtzControl(false);
        });
      } else {
        $scope.goCvr(targetTime, "f");
        $scope.showPtzControl(false);
      }
    });
  };
  var eventListFormatted = function eventListFormatted(event) {
    var tz = $scope.timeline.getData("timezone");
    var start = moment(parseInt(event.startTime)).tz(tz).format("HH:mm:ss");
    var end = moment(parseInt(event.endTime)).tz(tz).format("HH:mm:ss");
    return $sce.trustAsHtml(start + "-" + end);
  };

  // 이벤트 리스트에 표기하는 날짜 문자열 반환
  var dateWithDateIndex = function dateWithDateIndex(dateIndex) {
    var now = moment().tz($scope.timeline.getData("timezone"));
    var dateString = "";
    if (now == undefined) {
      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1; //January is 0!

      var yyyy = today.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }
      var _dateString = yyyy + "" + mm + "" + dd;
    } else {
      dateString = now.subtract(dateIndex, "days").format("YYYYMMDD");
    }
    return dateString;
  };
  var timeRangeWithEventIndexes = function timeRangeWithEventIndexes(dateIndex, timeIndex) {
    var dateFormat = "YYYYMMDDHHmmss";
    var tz = $scope.timeline.getData("timezone");
    var now = moment().tz(tz);
    var dateString = now.subtract(dateIndex, "days").format("YYYYMMDD");
    var startHourString = timeIndex.toString();
    if (timeIndex < 10) startHourString = "0" + timeIndex;
    var endHourString = (timeIndex + 1).toString();
    if (timeIndex + 1 < 10) endHourString = "0" + (timeIndex + 1);
    var startDateTimeString = dateString + startHourString + "0001";
    var endDateTimeString = dateString + endHourString + "0000";
    var start = moment(startDateTimeString, dateFormat).tz(tz);
    var end = moment(endDateTimeString, dateFormat).tz(tz);
    return [start.valueOf(), end.valueOf()];
  };

  // 이벤트 목록에서 알림존별 체크박스 click event
  $scope.checkboxAllMotionEvent = true;
  $scope.toggleClickZoneEvent = function (id) {
    if (parseInt(id) <= 8) {
      var flag = "";
      var index = $scope.selectedZones.indexOf(id);
      if (index > -1) {
        $scope.selectedZones.splice(index, 1);
        $scope.hideZones.push(id);
        checkFilters.remove(id);
        flag = "remove";
        $(".nntion.color_" + id).hide(); // 시간대별 이벤트 상세 목록 해당존의 동그라미 숨김
      } else {
        $scope.selectedZones.push(id);
        $scope.hideZones.splice($scope.hideZones.indexOf(id), 1);
        checkFilters.put(id, id);
        flag = "add";
        $(".nntion.color_" + id).show(); // 시간대별 이벤트 상세 목록 해당존의 동그라미 표시
      }
    }
    if ($scope.selectedZones.length < 2 && $scope.selectedZones.indexOf("0") > -1 || $scope.selectedZones.length < 1 && $scope.selectedZones.indexOf("0") == -1) {
      $scope.checkboxAllMotionEvent = false;
    } else {
      $scope.checkboxAllMotionEvent = true;
    }
    changedSelectedZone();
    $scope.eventListChnage();
  };

  // 시간대별 상세 이벤트 목록의 존 체크 여부에 따른 이벤트 표시 여부
  $scope.eventListChnage = function () {
    var buttonCnt = 0;
    for (var i = 0; i < $(".eventLists_li").length; i++) {
      var hideCnt = 0;
      buttonCnt = $(".eventLists_li").eq(i).closest("span").children(".color_zone_area").children("img").length;
      beaconCnt = $(".eventLists_li").eq(i).siblings(".beacon_list_area").find(".beacon_list").length;
      for (var j = 0; j < buttonCnt; j++) {
        var idx2 = $(".eventLists_li").eq(i).closest("span").children(".color_zone_area").children("img").eq(j).css("display").indexOf("none");
        if (idx2 == 0) {
          hideCnt++;
        }
      }
      if (hideCnt == buttonCnt + beaconCnt) {
        $(".eventLists_li").eq(i).parent().parent().hide();
      } else {
        $(".eventLists_li").eq(i).parent().parent().show();
      }
    }
  };

  // 알림존 설정 메뉴에서 알림존별 체크박스 click event
  $scope.toggleClickZone = function (id) {
    var flag = "";
    var index = $scope.selectedZones.indexOf(id);
    if (index > -1) {
      $scope.selectedZones.splice(index, 1);
      $scope.hideZones.push(id);
      checkFilters.remove(id);
      flag = "remove";
    } else {
      $scope.selectedZones.push(id);
      $scope.hideZones.splice(index, 1);
      checkFilters.put(id, id);
      flag = "add";
    }
    changedSelectedZone();
    $scope.setCurrentTab("zone", "edit");
  };

  // 이벤트 목록 및 알림존 설정에서 존별 체크여부 확인
  $scope.isSelectedZone = function (id) {
    if ($scope.selectedZones.indexOf(id) > -1) {
      return true;
    }
    return false;
  };
  function ptzAreaEventHandler(event) {
    var ptzCommandAPI;
    if (event.type === "zoomin") {
      ptzCommandAPI = Camera.ptzZoomIn;
    } else {
      ptzCommandAPI = Camera.ptzZoomOut;
    }
    ptzCommandAPI({
      cameraId: $stateParams.cameraId
    }, {
      centerPointX: event.rectCenterX,
      centerPointY: event.rectCenterY,
      lengthX: event.rectWidth,
      lengthY: event.rectHeight,
      width: event.canvasWidth,
      height: event.canvasHeight
    });
  }
  function destroyPtzArea() {
    if ($scope.ptzArea) {
      $scope.ptzArea.destroy();
      delete $scope.ptzArea;
    }
  }
  function showPtzArea() {
    $scope.ptzAreaVisible = true;
    destroyPtzArea();
    $scope.ptzArea = new ptzArea("ptz-area", ptzAreaEventHandler);
    $scope.ptzArea.setCanvasSize($("#player").width(), $("#player").height());
  }
  var create_zone = "zone-area";
  // Zone
  $scope.zoneAreaColorSet = ["#d90101", "#ff7900", "#3ea1d4", "#a4c800", "#efd600", "#767dff", "#ca74f0", "#ff76bd"];
  $scope.showZoneSetting = function () {
    $scope.zoneSettingVisible = true;
    if ($scope.currentCamera.aiType == 4) {
      $("div[name='zone-area-div']").css("display", "block");
      $("canvas[name='zone-area-canvas']").remove();
      create_zone = "zone-area";
      face_zone = "FACE_ZONE";
    } else {
      create_zone = "zone-area";
      $("div[name='zone-area-div']").remove();
      face_zone = "TABLE_ZONE";
    }
    if ($scope.zonearea == undefined || $scope.zonearea == null) {
      //if (true) {
      if ($scope.currentCamera.aiType !== 4) {
        $scope.zonearea = new ZoneArea(create_zone);
        $scope.zonearea.delegate = $scope;
        $scope.zonearea.setZonesData($scope.motionZones);
        $scope.zonearea.setSelectedZones($scope.selectedZones);
      } else {
        $scope.zonearea = new AifaceZoneArea(create_zone, $scope.currentCamera.aiType);
        var arr = [];
        $.each($scope.motionZones, function (i, zone) {
          if (zone.id != 9) {
            arr.push(zone);
          }
        });
        $scope.zonearea.setZonesData(arr);
        $scope.zonearea.setEventHandler(aiZoneEventHandler);
      }
      $scope.zonearea.setCanvasSize($("#player").width(), $("#player").height(), $scope.motionZones, $scope.selectedZones);
    } else {
      $scope.zonearea.setCanvasSize($("#player").width(), $("#player").height(), $scope.motionZones, $scope.selectedZones);
    }
  };
  $scope.hideZoneSetting = function () {
    $scope.zoneSettingVisible = false;
    //$scope.zonearea = null;
  };
  $scope.hideZones = [];

  // 타임라인 이벤트존 영역 보여주기 숨김
  var changedSelectedZone = function changedSelectedZone(detectType) {
    for (var i = 0; i < $scope.hideZones.length; i++) {
      $(".event-bar.motion.num" + $scope.hideZones[i]).hide();
    }
    if ($scope.selectedZones != undefined) {
      for (var _i5 = 0; _i5 < $scope.selectedZones.length; _i5++) {
        $(".event-bar.motion.num" + $scope.selectedZones[_i5]).show();
      }
    }
    if (detectType == "motion") {
      if ($("#f_move").is(":checked") == true) {
        $(".event-bar.motion.numnull").show();
        $(".event-bar.motion.num8").show();
      } else {
        $(".event-bar.motion.numnull").hide();
        $(".event-bar.motion.num8").hide();
      }
    } else if (detectType == "audio") {
      if ($("#f_sound").prop("checked") == true) {
        $(".event-bar.motion.num0").show();
      } else {
        $(".event-bar.motion.num0").hide();
      }
    } else if (detectType == "access") {
      if ($scope.eventFilter.accessCheck == true) {
        $(".accessIcons").show();
        $(".beacon_list").show();
        $(".event-bar.motion.num9").show();
      } else {
        $(".accessIcons").hide();
        $(".beacon_list").hide();
        $(".event-bar.motion.num9").hide();
      }
    } else if (detectType == undefined) {
      if ($("#zone8").prop("checked") == true) {
        $(".event-bar.motion.numnull").show();
        $(".event-bar.motion.num8").show();
      } else {
        $(".event-bar.motion.numnull").hide();
        $(".event-bar.motion.num8").hide();
      }
    }
    setTimeout(function () {
      for (var _i6 = 0; _i6 < $(".image_event_thum").length; _i6++) {
        if ($(".image_event_thum").eq(_i6).parent().css("background-image") != "none") {
          $("#image_event_thum_" + _i6).remove();
        }
      }
    }, 1000);
  };
  function editZoneNameSaveClickFn(event) {
    if ($scope.currentEditingZone && $scope.currentEditingZoneId && $scope.currentEditingZoneId != -1) {
      if (event.target.id.indexOf("tx_z") == -1 && event.target.id.indexOf("tx_t") == -1) {
        $scope.saveEditZone($scope.currentEditingZone);
      }
    }
  }
  $scope.showEditZone = function (zone) {
    if ($scope.currentEditingZone && $scope.currentEditingZoneId && $scope.currentEditingZoneId != -1) {
      if ($scope.currentEditingZone.labelName.length > 25) {
        showAlert($translate.instant("ZONE_NAME_ERR_SUBJECT"), $translate.instant("ZONE_NAME_ERR_CONTENT1") + "<br>" + $translate.instant("ZONE_NAME_ERR_CONTENT2"));
      } else {
        ZoneUpdate.update({
          id: $scope.currentCamera.id,
          zoneIndex: $scope.currentEditingZone.id
        }, {
          labelName: $scope.currentEditingZone.labelName,
          status: $scope.currentEditingZone.status,
          coordinate: $scope.currentEditingZone.coordinate
        }, function (data) {});
      }
    }
    $(".alrm_lst").children("li").removeClass("open");
    $("#alrm_zone_li_" + zone.id).addClass("open");
    $scope.currentEditingZone = zone;
    $scope.currentEditingZoneId = zone.id;
    $("body").on("click", editZoneNameSaveClickFn);
  };
  $scope.cancelEditZone = function (zone) {
    $("#alrm_zone_li_" + zone.id).removeClass("open");
    $scope.currentEditingZoneId = 0;
    $("body").off("click", editZoneNameSaveClickFn);
    $scope.setCurrentTab("zone");
  };
  $scope.saveEditZone = function (zone) {
    if ($scope.currentEditingZone.labelName.length > 25) {
      showAlert($translate.instant("ZONE_NAME_ERR_SUBJECT"), $translate.instant("ZONE_NAME_ERR_CONTENT1") + "<br>" + $translate.instant("ZONE_NAME_ERR_CONTENT2"));
      return;
    }
    $("body").off("click", editZoneNameSaveClickFn);
    zone.labelName = $("#tx_z" + zone.id.toString()).val();
    zone.color = $scope.currentEditingZone.color;
    $scope.currentEditingZoneId = 0;
    updateZoneData = zone;
    $scope.updateZone("rename");
  };
  $scope.createNewZone = function () {
    for (var i = 0; i < $scope.motionZones.length; i++) {
      if ($scope.motionZones[i]) {
        $("#alrm_zone_li_" + $scope.motionZones[i].id).removeClass("open");
      }
    }
    $scope.currentEditingZoneId = 0;
    $("body").off("click", editZoneNameSaveClickFn);
    $scope.setCurrentTab("zone");
    Camera.createZone({
      id: $scope.currentCamera.id
    }, {}, function (zoneData) {
      if (zoneData.zone != undefined) {
        $scope.motionZones.push(zoneData.zone);
        if ($scope.currentCamera.aiType === 4) {
          var arr = [];
          $.each($scope.motionZones, function (i, zone) {
            if (zone.id != 9) {
              arr.push(zone);
            }
          });
          $scope.zonearea.setZonesData(arr);
        } else {
          $scope.zonearea.setZonesData($scope.motionZones);
        }
        var cnt = 0;
        $scope.setCurrentTab("zone");
      } else {
        var msg;
        if ($("html").attr("lang") == "ja") {
          msg = $translate.instant("ZONE_MAKE_ERR_CONTENT");
        } else {
          msg = zoneData.msg ? zoneData.msg : $translate.instant("ZONE_MAKE_ERR_CONTENT");
        }
        showAlert($translate.instant("ZONE_MAKE_ERR_SUBJECT"), msg);
      }
    }, function (err) {});
  };
  var notiTimeout = null;
  var aiZoneEventHandler = function aiZoneEventHandler(event) {
    if ($scope.currentCamera.aiType == 4) {
      if (ai_camera_type == null || ai_camera_type == "") {
        return;
      }
    }
    if (event.name === "remove") {
      $scope.removeZone(event.zone);
    } else if (event.name === "add") {
      $scope.addZone(event.zone);
      var loitering_length = $("[name=ul_" + "1" + "]").find("li").length;
      var intrusion_length = $("[name=ul_" + "2" + "]").find("li").length;
      $scope.zonearea.setZoneType(null, loitering_length, intrusion_length);
    } else if (event.name === "modify") {
      $scope.modifyZone(event.zone);
    } else if (event.name === "drawing_change") {
      $scope.isDrawing = event.drawing;
      $scope.$apply();
    } else if (event.name === "full") {
      if (!$scope.modifyMode) {
        notiDelete();
        $scope.notiMsg = $filter("stringFormat")($translate.instant("5mw2slvk_02136"), 4);
        notiTimeout = $timeout(function () {
          $scope.notiMsg = "";
        }, 3000);
        $scope.$apply();
      }
    }
  };
  $scope.removeZone = function (zone) {
    Camera.removeAlarmZone({
      cameraId: $stateParams.cameraId,
      zoneType: face_zone,
      zoneIndex: zone.zoneIndex
    }, function (res) {
      updateZones();
    });
  };
  function notiDelete() {
    if (notiTimeout) {
      $timeout.cancel(notiTimeout);
      notiTimeout = null;
    }
    $scope.notiMsg = "";
  }
  $scope.addZone = function (zone) {
    var type = "";
    var labelName = "";
    var color = ai_camera_type == "2" ? "FF7900" : "#59A1D6";
    if (ai_camera_type == "2") {
      type = "ABNORMAL_INTRUSION_ZONE";
      labelName = "";
    } else {
      type = "ABNORMAL_LOITERING_ZONE";
      labelName = "";
    }
    Camera.setAlarmZones({
      cameraId: $stateParams.cameraId,
      zoneType: type,
      labelName: labelName
    }, {
      color: color,
      coordinate: zone.coordinate
    }, function (res) {
      $scope.setCurrentTab("zone");
    });
  };
  $scope.modifyZone = function (zone) {
    var type = "";
    if (ai_camera_type == "2") {
      type = "ABNORMAL_INTRUSION_ZONE";
    } else {
      type = "ABNORMAL_LOITERING_ZONE";
    }
    Camera.modifyAlarmZone({
      cameraId: $stateParams.cameraId,
      zoneType: type,
      zoneIndex: zone.zoneIndex
    }, {
      coordinate: zone.coordinate
    }, function (res) {
      updateZones();
    });
  };
  var guideShowChecked = false;
  var clientUid = "";
  if ($rootScope.me && $rootScope.me.uid) {
    clientUid = $rootScope.me.uid;
  }
  function updateZones() {
    Camera.getAlarmZoneByType({
      cameraId: $stateParams.cameraId,
      zoneType: face_zone
    }, function (res) {
      if (!res.zones.length) {
        $scope.zonearea.setZonesData(null);
        $scope.hasZone = false;
        if (!guideShowChecked) {
          if (!(localStorage && localStorage.getItem && localStorage.getItem(noMakeKeyPrefix + clientUid))) {
            showMakeGuideDlg();
          }
        }
      } else {
        $scope.hasZone = true;
        $scope.zonearea.setZonesData(res.zones, $scope.modifyMode);
      }
      guideShowChecked = true;
    });
  }
  var noMakeKeyPrefix = "no-ai-guide-make-show-";
  function showMakeGuideDlg() {
    if ($rootScope.isSetAiZone) {
      return;
    }
    if (guideDlg) {
      guideDlg.destroy();
    }
    guideDlg = tCam.aizoneGuideDialog({
      elId: "wrap",
      dlgStyle: {
        width: "452px",
        height: "367px",
        borderRadius: "12px",
        boxSizing: "border-box",
        overflow: "hidden"
      },
      txtMap: {
        noshow: $translate.instant("BUTTON_DO_NOT_SHOW"),
        confirm: $translate.instant("BUTTON_CONFIRM")
      },
      swipeInfos: [{
        imgUrl: "/resources/img/img-zone-create-guide.jpg",
        description: $translate.instant("9rRqk7Vo_02186")
      }, {
        imgUrl: "/resources/img/img-zone-delete-guide.jpg",
        description: $translate.instant("9rRqk7Vo_02187")
      }],
      noCloseBtn: true,
      eventHandler: function eventHandler(event) {
        if (event.event === "noshow") {
          if (localStorage && localStorage.setItem) {
            localStorage.setItem(noMakeKeyPrefix + clientUid, true);
          }
        }
        guideDlg.destroy();
        guideDlg = null;
      }
    });
  }
  $scope.modifyMode = false;
  $scope.hasZone = false;
  $scope.isDrawing = false;
  $scope.createNewAiZone = function (type) {
    var area = document.getElementById(create_zone);
    var loitering_length = $("[name=ul_" + "1" + "]").find("li").length;
    var intrusion_length = $("[name=ul_" + "2" + "]").find("li").length;
    if (type === "1") {
      if (loitering_length >= 3) {
        var mainZoneType = "loitering";
        if (!$scope.zonearea) {
          $scope.zonearea = new AifaceZoneArea(create_zone);
          $scope.zonearea.setEventHandler(aiZoneEventHandler);
          $scope.zonearea.setZoneType(mainZoneType, loitering_length, intrusion_length);
        } else {
          $scope.zonearea.setZoneType(mainZoneType, loitering_length, intrusion_length);
        }
      } else {
        showAlert($translate.instant("STR_DETECT_MSG17"));
        ai_camera_type = "1";
        $scope.zoneVisible = true;
        var _area = document.getElementById(create_zone);
        var playerWidth = $("#player").width(),
          playerHeight = $("#player").height();
        _area.style.width = playerWidth + "px";
        _area.style.height = playerHeight + "px";
        var _mainZoneType = "loitering";
        if (!$scope.zonearea) {
          $scope.zonearea = new AifaceZoneArea(create_zone);
          $scope.zonearea.setEventHandler(aiZoneEventHandler);
          $scope.zonearea.setZoneType(_mainZoneType, loitering_length, intrusion_length);
        } else {
          $scope.zonearea.setZoneType(_mainZoneType, loitering_length, intrusion_length);
        }
      }
    } else if (type === "2") {
      if (intrusion_length >= 3) {
        var _mainZoneType2 = "intrusion";
        if (!$scope.zonearea) {
          $scope.zonearea = new AifaceZoneArea(create_zone);
          $scope.zonearea.setEventHandler(aiZoneEventHandler);
          $scope.zonearea.setZoneType(_mainZoneType2, loitering_length, intrusion_length);
        } else {
          $scope.zonearea.setZoneType(_mainZoneType2, loitering_length, intrusion_length);
        }
      } else {
        showAlert($translate.instant("STR_DETECT_MSG18"));
        ai_camera_type = "2";
        $scope.zoneVisible = true;
        var _area2 = document.getElementById(create_zone);
        var _playerWidth = $("#player").width(),
          _playerHeight = $("#player").height();
        _area2.style.width = _playerWidth + "px";
        _area2.style.height = _playerHeight + "px";
        var _mainZoneType3 = "intrusion";
        if (!$scope.zonearea) {
          $scope.zonearea = new AifaceZoneArea(create_zone);
          $scope.zonearea.setEventHandler(aiZoneEventHandler);
          $scope.zonearea.setZoneType(_mainZoneType3, loitering_length, intrusion_length);
        } else {
          $scope.zonearea.setZoneType(_mainZoneType3, loitering_length, intrusion_length);
        }
      }
    }
    for (var i = 0; i < $scope.motionZones.length; i++) {
      if ($scope.motionZones[i]) {
        $("#alrm_zone_li_" + $scope.motionZones[i].id).removeClass("open");
      }
    }
    $scope.currentEditingZoneId = 0;
    $("body").off("click", editZoneNameSaveClickFn);
    $scope.setCurrentTab("zone");
  };
  $scope.deleteZone = function (zone) {
    Camera.deleteZone({
      id: $scope.currentCamera.id,
      zoneIndex: zone.id
    }, function (data) {
      if (data.code === "ok") {
        for (var i = 0; i < $scope.motionZones.length; i++) {
          if ($scope.motionZones[i].id == zone.id) {
            $scope.motionZones.splice(i, 1);
          }
        }
        $scope.currentEditingZoneId = 0;
        $("body").off("click", editZoneNameSaveClickFn);
        if ($scope.currentCamera.aiType === 4) {
          var arr = [];
          $.each($scope.motionZones, function (i, zone) {
            if (zone.id != 9) {
              arr.push(zone);
            }
          });
          $scope.zonearea.setZonesData(arr);
        } else {
          $scope.zonearea.setZonesData($scope.motionZones);
        }
        $scope.setCurrentTab("zone");
      }
    });
  };
  var updateZoneData = {};
  $scope.toogleZoneAlarm = function (zone) {
    if (zone.status === "on") {
      zone.status = "off";
    } else {
      zone.status = "on";
    }
    updateZoneData = zone;
    $scope.updateZone("update");
  };
  $scope.movedZone = function (zoneId, data) {
    for (var i in $scope.motionZones) {
      var current = $scope.motionZones[i];
      if (current.id === zoneId) {
        current.coordinate = data;
        current.status = "on";
        updateZoneData = current;
        $scope.updateZone("update");
        break;
      }
    }
  };
  $scope.updateZone = function (flag) {
    if ($scope.currentCamera.aiType === 4) {
      var type = "";
      if ($scope.currentEditingZone.type == "intrusion") {
        type = "ABNORMAL_INTRUSION_ZONE";
      } else {
        type = "ABNORMAL_LOITERING_ZONE";
      }
      ZoneUpdate.update({
        id: $scope.currentCamera.id,
        zoneIndex: updateZoneData.id,
        zoneType: type
      }, {
        labelName: updateZoneData.labelName,
        status: updateZoneData.status,
        coordinate: updateZoneData.coordinate
      }, function (data) {
        if (flag === "rename") {
          $(".alrm_lst").children("li").removeClass("open");
          $scope.setCurrentTab("zone");
        }
        updateZoneData = {};
      });
    } else {
      ZoneUpdate.update({
        id: $scope.currentCamera.id,
        zoneIndex: updateZoneData.id
      }, {
        labelName: updateZoneData.labelName,
        status: updateZoneData.status,
        coordinate: updateZoneData.coordinate
      }, function (data) {
        if (flag === "rename") {
          $(".alrm_lst").children("li").removeClass("open");
          $scope.setCurrentTab("zone");
        }
        updateZoneData = {};
      });
    }
  };
  $scope.timelineDate = {};
  var setTimelineTimeMoment = function setTimelineTimeMoment(m) {
    $scope.timelineDate.time = m.format("HH : mm : ss");
    var token = $scope.timelineDate.time.split(" : ");
    if (token[0] == "Invalid date") {
      token[0] = "00";
      token[1] = "00";
      token[2] = "00";
    }
    $scope.timelineDate.hour = token[0];
    $scope.timelineDate.minute = token[1];
    $scope.timelineDate.second = token[2];
  };

  //공유
  $scope.shareCnt = 0;
  $scope.getShareCamerasList = function () {
    Share.getMySharedList({
      id: $scope.currentCamera.id
    }, function (data) {
      $scope.shareCameras = $scope.cameraDataSet(data);
      $scope.shareCnt = data.length;
    }, function (err) {
      $scope.errCameras = true;
    });
  };
  $scope.shareEnd = function () {
    Share.get({
      id: $stateParams.cameraId
    }, function (res) {}, function (err) {
      if (err.status === 401) {
        $scope.shareEndCheckErr();
      }
    });
  };
  $scope.shareEndCheckErr = function () {
    if ($scope.player) {
      $scope.player.stop();
    }
    $interval.cancel($scope.reloadTimer);
    $scope.playControl.playTimer.stopTimer();
    $interval.cancel($scope.eventlistTimer);
    $interval.cancel(callEvtList);
    $scope.isNoShared = true;
    return false;
  };
  $scope.$on("showAlert", function (event, data) {
    showAlert(data.title, data.msg);
  });

  //audio chat event
  $scope.$on(AudioChat.EVENT_STREAM_CONNECTED, function (event, data) {});
  $scope.$on(AudioChat.EVENT_STREAM_DISCONNECTED, function (event, data) {
    AudioChat.audioChatStop($stateParams.cameraId);
  });
  $scope.goToAudioChatPage = function () {
    $scope.isMiceSet = false;
    $state.go("main.cameraAudioChat", {
      cameraId: $stateParams.cameraId
    });
  };
  $scope.pressedUseMikeButton = function () {
    Camera.get({
      id: $stateParams.cameraId
    }, function (data) {
      if (data && data.controlStatus === "on" && $scope.config.streamStatus === "on") {
        if ($rootScope.isJp) {
          if ($scope.config.mic === "on") {
            $state.go("main.cameraAudioChat", {
              cameraId: $stateParams.cameraId
            });
          } else {
            $scope.isMiceSet = true;
          }
        } else {
          $state.go("main.cameraAudioChat", {
            cameraId: $stateParams.cameraId
          });
        }
      } else {
        showAlert($translate.instant("CLICK_MIKE_ALERT_SUBEJCT"), $translate.instant("CAMERA_OFF_NO_FUNCTION"));
      }
    }, function () {
      showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
    });
  };
  $scope.cameraDataSet = function (data) {
    for (var i = 0; i < data.length; i++) {
      if (location.port != "") {
        data[i].thumbnailPath = location.protocol + "//" + data[i].thumbnailPath.replace(".com/", ".com:" + location.port + "/");
      } else {
        data[i].thumbnailPath = location.protocol + "//" + data[i].thumbnailPath;
      }
      if (data[i].streamStatus === "off" && data[i].controlStatus === "CS") {
        data[i].streamStatus = data[i].streamStatus === "on";
      }
      data[i].cameraViewState = 0;
      if (data[i].streamStatusConfig == "off") {
        data[i].cameraViewState = 1;
      } else {
        if (data[i].controlStatus == "on") {
          if (data[i].recordType != "event") {
            if (data[i].streamStatus == "off") {
              data[i].cameraViewState = 2;
            }
          }
        } else {
          if (data[i].streamStatus == "on") {
            data[i].cameraViewState = 3;
          } else {
            data[i].cameraViewState = 4;
          }
        }
      }
      data[i].number = i;
    }
    return data;
  };
  var findingEventTimeFlag = false,
    eventTimeRange = null;
  $scope.goEventListWithSelectedTime = function (time) {
    var i, len, fulldate, msDate;
    if ($stateParams.eventId && !$scope.selecEventId) {
      $scope.focusEventId = $stateParams.eventId;
      if ($stateParams.time) {
        $scope.selectedEventTime = $stateParams.time;
      }
      if (focusTimeout) {
        $timeout.cancel(focusTimeout);
      }
      focusTimeout = $timeout(function () {
        $(".focused_event").addClass("fadeout");
        $timeout(function () {
          $scope.selectedEventTime = -1;
          $scope.focusEventId = "";
        }, 1000);
      }, 4000);
    } else {
      $scope.selectedEventTime = -1;
      $scope.focusEventId = "";
    }
    if (!time || isFullScreen()) {
      return;
    }
    msDate = time.valueOf();
    if (eventTimeRange) {
      if (msDate >= eventTimeRange[0] && msDate <= eventTimeRange[1]) {
        if ($(".event_list_li_level_2.open").length) {
          return;
        }
      }
    }
    $stateParams.time = msDate;
    var addZero = function addZero(num) {
      if (num < 10) {
        return "0" + num;
      } else {
        return num;
      }
    };
    fulldate = "" + time.getFullYear() + addZero(time.getMonth() + 1) + addZero(time.getDate());
    for (i = 0, len = $scope.eventListDate.length; i < len; i += 1) {
      if (fulldate === $scope.eventListDate[i].date) {
        $(".evnetListDate").hide();
        $scope.eventListDateIndex = i;
        findingEventTimeFlag = true;
        $scope.pressedEventListDateButton($scope.eventListDateIndex);
        $scope.initFlags();
        $("#evnetListDate_" + $scope.eventListDateIndex).show();
        break;
      }
    }
  };

  // 이전 이벤트 리스트 목록
  $scope.prevEventList = function (idx) {
    $(".evnetListDate").hide(); //

    $scope.eventListDateIndex++;
    var idxNum = parseInt(idx) + 1;
    if ($scope.eventListDateIndex >= $scope.eventListDate.length) {
      $scope.eventListDateIndex = $scope.eventListDate.length - 1;
      idxNum--;
    }
    $scope.pressedEventListDateButton($scope.eventListDateIndex);
    $scope.initFlags();
    $("#evnetListDate_" + idxNum).show();
  };

  // 다음 이벤트 리스트 목록
  $scope.nextEventList = function (idx) {
    if (idx == 0) {
      return;
    }
    $(".evnetListDate").hide();
    $scope.eventListDateIndex--;
    if ($scope.eventListDateIndex < 0) {
      $scope.eventListDateIndex = 0;
      return;
    }
    $scope.pressedEventListDateButton($scope.eventListDateIndex);
    $scope.initFlags();
    var idxNum = parseInt(idx) - 1;
    $("#evnetListDate_" + idxNum).show();
  };
  $scope.initFlags = function () {
    tempIndexCheck = 0;
    $scope.pressedEventListTimeButtonFlag = false;
  };
  $scope.goCameraManager = function () {
    location.href = "/#/settings/product";
  };
  $scope.alarmSetHide = function () {
    if ($("#alarm_set_no").is(":checked") == true) {
      $scope.setCookie("alarm_set_no", "alarm_set_no");
    }
    $("#alarm_set").remove();
  };
  $scope.cameraManage = function () {
    location.href = "/#/settings/product";
  };
  $scope.setCookie = function (cName, cValue, expireDate) {
    var expire = new Date();
    if (expireDate == "" || expireDate == undefined) {
      expire.setDate(expire.getDate() + 7);
    } else {
      expire.setDate(expire.getDate() + expireDate);
    }
    cookies = cName + "=" + escape(cValue) + "; path=/ "; //쿠키 저장
    cookies += ";expires=" + expire.toGMTString() + ";";
    document.cookie = cookies;
  };
  $scope.getCookie = function (cName) {
    cName = cName + "=";
    var cookieData = document.cookie;
    var start = cookieData.indexOf(cName);
    var cValue = "";
    if (start != -1) {
      start += cName.length;
      var end = cookieData.indexOf(";", start);
      if (end == -1) end = cookieData.length;
      cValue = cookieData.substring(start, end);
    }
    return unescape(cValue);
  };
  $scope.logout = function () {
    User.logout(function (data) {
      logoutSuccess();
    });
  };
  $scope.showCvrSecureAgain = function () {
    var cvrPlayManager = isFullScreen() ? $scope.playControl.cvrPlaySecureManagerFull : $scope.playControl.cvrPlaySecureManager;
    cvrPlayManager.securePassword = "";
    $scope.isIncorrectPlayPassword = !$scope.isIncorrectPlayPassword;
    cvrPlayManager.isShowCVRPlayPasswordConfirm = true;
  };
  $scope.confirm = {};
  $scope.checkPassword = function () {
    var params = {
      securePassword: $scope.confirm.securePassword
    };
    CameraConfig.confirmSecure({
      id: $stateParams.cameraId
    }, params, function (data) {
      if (data.code == "ok") {
        $scope.cvrPasswordSuccess();
      } else {
        $scope.isIncorrectPassword = !$scope.isIncorrectPassword;
      }
    }, function (err) {
      location.href = "/error";
    });
  };
  $scope.changeSecureMode = function () {
    var callbackFunc = function callbackFunc() {
      var params = {
        secureMode: $scope.config.secureMode
      };
      CameraConfig.toggleSecure({
        id: $stateParams.cameraId
      }, params, function (data) {
        if (data.code == "ok") {
          if ($scope.config.secureMode == "on") {
            var passCVRSecure = sessionStorage.getItem("passCVRSecureCameraIds");
            if (passCVRSecure == null || passCVRSecure == "undefined" || passCVRSecure.indexOf($stateParams.cameraId) > -1) {
              sessionStorage.setItem("passCVRSecureCameraIds", $stateParams.cameraId);
            } else {
              sessionStorage.setItem("passCVRSecureCameraIds", passCVRSecure + "," + $stateParams.cameraId);
            }
          }
          $scope.getCameraConfig();
          showAlert($translate.instant("CAMERA_SECURITY_UP"), $translate.instant("CAMERA_CONFIRMED"));
        } else {
          showAlert($translate.instant("CAMERA_SECURITY_UP"), $translate.instant("ACCESS_FAIL"));
        }
      }, function (err) {
        location.href = "/error";
      });
    };
    if ($scope.config.secureMode == "on" && $scope.config.securePassword == "") {
      $scope.isShowCVRSecureModeInfo = !$scope.isShowCVRSecureModeInfo;
    } else if ($scope.config.secureMode == "on" && $scope.config.securePassword != "") {
      $scope.confirm.securePassword = "";
      $scope.isShowCVRPasswordConfirm = !$scope.isShowCVRPasswordConfirm;
      $scope.cvrPasswordSuccess = callbackFunc;
    } else {
      $scope.isShowSecureOffMessage = !$scope.isShowSecureOffMessage;
      $scope.cvrPasswordSuccess = callbackFunc;
    }
  };
  $scope.pressedShowSecureModeButton = function () {
    var secureMode = "";
    var callbackFunc = function callbackFunc() {
      var params = {
        secureMode: secureMode
      };
      CameraConfig.toggleSecure({
        id: $stateParams.cameraId
      }, params, function (data) {
        if (data.code == "ok") {
          $scope.getCameraConfig();
          showAlert($translate.instant("CAMERA_SECURITY_UP"), $translate.instant("CAMERA_CONFIRMED"));
        } else {
          showAlert($translate.instant("CAMERA_SECURITY_UP"), $translate.instant("ACCESS_FAIL"));
        }
      }, function (err) {
        location.href = "/error";
      });
    };
    if ($scope.config.secureMode == "off" && $scope.config.securePassword == "") {
      $scope.isShowCVRSecureModeInfo = !$scope.isShowCVRSecureModeInfo;
    } else if ($scope.config.secureMode == "on" && $scope.config.securePassword != "") {
      $scope.isShowSecureOffMessage = !$scope.isShowSecureOffMessage;
      secureMode = "off";
      $scope.cvrPasswordSuccess = callbackFunc;
    } else {
      $scope.isShowSecureOnMessage = !$scope.isShowSecureOnMessage;
      secureMode = "on";
      $scope.cvrPasswordSuccess = callbackFunc;
    }
  };
  $scope.resetCVRPassword = function () {
    var treatmentUrl = document.URL;
    var loginUrl = paycoUrl + "login.nhn";
    var confirmUrl = paycoUrl + "auth/confirmPwd.nhn";
    var httpUrl = location.origin;
    if (httpUrl == undefined) {
      httpUrl = location.protocol + "//" + location.hostname;
    }
    if ($rootScope.isJp) {
      var url = "/checkpw?nextUrl=resetCVRPassword";
      window.open(url, $translate.instant("CAMERA_PASSWORD_INIT"), "scrollbars=yes,toolbar=no,resizable=yes,width=420,height=538,left=600,top=200");
    } else {
      var _url = "/#/passwordConfirm";
      openInfoWin(_url, "popup", 470, 280, "no"); // window.open
    }
  };
  $window.confirmPaycoPasswordCallback = function () {
    CameraConfig.deleteSecurePassword({
      id: $stateParams.cameraId
    }, function (data) {
      if (data.code == "ok") {
        $scope.isIncorrectPassword = false;
        $scope.isIncorrectPlayPassword = false;
        $scope.getCameraConfig();
        showAlert($translate.instant("CAMERA_SECURITY_UP"), $translate.instant("CAMERA_CONFIRMED"));
      } else {
        showAlert($translate.instant("CAMERA_SECURITY_UP"), $translate.instant("ACCESS_FAIL"));
      }
    }, function (error) {
      location.href = "/error";
    });
  };
  $scope.regForm = {
    securePassword: "",
    securePasswordConfirm: ""
  };
  $scope.regSecurePassword = function () {
    var validRgEx = /^[A-Za-z0-9+]{4,8}$/;
    if ($scope.regForm.securePassword.length == 0) {
      showAlert($translate.instant("CAMERA_SECURITY_UP"), $translate.instant("CAMERA_ENTER_PASSWORD"));
      return;
    }
    if (!validRgEx.test($scope.regForm.securePassword)) {
      showAlert($translate.instant("CAMERA_SECURITY_UP"), $translate.instant("CAMERA_4_TO_8_INPUT"));
      return;
    }
    if ($scope.regForm.securePassword != $scope.regForm.securePasswordConfirm) {
      showAlert($translate.instant("CAMERA_SECURITY_UP"), $translate.instant("CAMERA_PASSWORD_NOT_SAME"));
      return;
    }
    var params = {
      securePassword: $scope.regForm.securePassword
    };
    CameraConfig.regSecurePassword({
      id: $stateParams.cameraId
    }, params, function (data) {
      if (data.code == "ok") {
        $scope.getCameraConfig();
        $scope.isShowCVRPasswordInput = false;
        $scope.isShowCVRPasswordChange = false;
        var passCVRSecure = sessionStorage.getItem("passCVRSecureCameraIds");
        if (passCVRSecure == null || passCVRSecure == "undefined" || passCVRSecure.indexOf($stateParams.cameraId) > -1) {
          sessionStorage.setItem("passCVRSecureCameraIds", $stateParams.cameraId);
        } else {
          sessionStorage.setItem("passCVRSecureCameraIds", passCVRSecure + "," + $stateParams.cameraId);
        }
        showAlert($translate.instant("CAMERA_SECURITY_UP"), $translate.instant("CAMERA_CONFIRMED"));
      } else {
        showAlert($translate.instant("CAMERA_SECURITY_UP"), $translate.instant("ACCESS_FAIL"));
      }
    }, function (error) {
      location.href = "/error";
    });
  };
  $scope.changeSecurePassword = function () {
    $scope.confirm.securePassword = "";
    $scope.isShowCVRPasswordConfirm = !$scope.isShowCVRPasswordConfirm;
    $scope.cvrPasswordSuccess = function () {
      $scope.regForm.securePassword = "";
      $scope.regForm.securePasswordConfirm = "";
      $scope.isShowCVRPasswordChange = !$scope.isShowCVRPasswordChange;
    };
  };
  $scope.cancelCVRPlay = function () {
    if ($scope.playControl.getData("isLive")) {
      $scope.timeline.setData("cursorOn", false);
      $scope.playerObj.requestPlay();
      if ($scope.currentTab == "zone") {
        setTimeout(function () {
          $scope.setCurrentTab("zone");
        }, 1500);
      }
    }
  };

  // 알림설정 저장 확인 팝업 open
  $scope.showSaveAlarmSettingConfirmLayer = function () {
    var isCheckedDays = _.includes($scope.notify.repeatOn, false); // 일반 알림은 값 반전
    if (!isCheckedDays && $scope.notify.alarmOn === "on" && $scope.notify.alarmAlways === "off") {
      showAlert($translate.instant("ACCESS_ALARM_SET"), $translate.instant("ACCESS_ALARM_SET_DESC"));
      return;
    }
    var isCheckedPrimeDays = _.includes($scope.notify.primeRepeatOn, true);
    if (!isCheckedPrimeDays && $scope.notify.primeScheduleOn === "on") {
      showAlert($translate.instant("ACCESS_ALARM_SET"), $translate.instant("CAMERA_GUARD_SET_SELECT"));
      return;
    }
    $scope.isShowSaveAlarmSettingConfirmLayer = true;
  };

  // 알림설정 저장 확인 팝업 close
  $scope.hideSaveAlarmSettingConfirmLayer = function () {
    $scope.isShowSaveAlarmSettingConfirmLayer = false;
  };

  // 알림설정 저장
  $scope.saveAlarmSetting = function () {
    var params = angular.copy($scope.notify);
    params.notifyEventType = Utils.notifyEventTypeJoin(params.notifyEventType);
    params.startAt = Utils.configDateJoin(params.startAt);
    params.stopAt = Utils.configDateJoin(params.stopAt);
    params.repeatOn = Utils.configRepeatOnJoin(params.repeatOn);
    params.primeStartAt = Utils.configDateJoin(params.primeStartAt);
    params.primeStopAt = Utils.configDateJoin(params.primeStopAt);
    params.primeRepeatOn = Utils.configRepeatOnJoin(params.primeRepeatOn);
    CameraNotifyConfig.update({
      cameraId: $stateParams.cameraId
    }, params, function (data) {
      if (data.code === "ok") {
        showAlert($translate.instant("STR_ALARM_SET_SHOW"), $translate.instant("STR_MORE_DETAIL_SET"));
        $scope.isShowSaveAlarmSettingConfirmLayer = false;
      } else {
        showAlert($translate.instant("FAIL"), $translate.instant("ACCESS_SET_FAIL"));
      }
    }, function (err) {
      showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
    });
  };

  // 풀스크린 상태이고 타임라인 숨김상태일 때 마우스오버 이벤트 함수
  $scope.showTimeline = function () {
    if (isFullScreen()) {
      $scope.playControl.playInfoBar.setData("isToggleOn", true);
      $scope.isShowControlArea = false;
      isClickTimelineShow = false;
      $timeout.cancel(timelineHideTimer);
    }
  };

  // 풀스크린 적용시 타임라인 컨트롤바에서 mouseleave 이벤트 발생시 5초후 타임라인 숨김 처리
  $scope.hideTimeline = function () {
    if (isFullScreen() && !isClickTimelineShow) {
      timelineHideTimer = $timeout(function () {
        $scope.isShowControlArea = true; // fullscreen 타임라인 숨김인 경우 mouseover 영역 표시
        $scope.isShowTimelineCalendar = false;
        if ($scope.playControl) {
          $scope.playControl.playInfoBar.setData("isToggleOn", false);
        }
      }, 5000);
    }
  };

  // 풀스크린 상태이고 타임라인에 마우스오버 상태인 경우 타임라인 숨김 timeout을 취소
  $scope.cancelTimelineHide = function () {
    if (isFullScreen()) {
      $timeout.cancel(timelineHideTimer);
    }
  };
  var isClickTimelineShow = false; //클릭 이벤트로 타임라인 표시할 경우 timeout 적용되지 않도록하기 위한 flag

  // 토스트 마켓 상품 상세 페이지 이동
  $scope.goMaket = function () {
    $window.location.href = $rootScope.ENV_VARS.marketUrl + "/product/CAM/" + $rootScope.ENV_VARS.marketDealNo + "?itemSerial=" + $scope.currentCamera.id;
  };

  // ! toast message
  $scope.purchaseGuide = {
    hasToast: false,
    message: "",
    timeout: 0
  };
  $scope.showToastPurchaseGuideMessage = function (message) {
    $scope.purchaseGuide.message = message;
    $scope.purchaseGuide.hasToast = true;
    if ($scope.purchaseGuide.timeout) {
      $timeout.cancel($scope.purchaseGuide.timeout);
    }
    $scope.purchaseGuide.timeout = $timeout(function () {
      $scope.purchaseGuide.hasToast = false;
      $scope.purchaseGuide.message = "";
    }, 1000 * 3);
  };

  // 구매 확인 레이어 팝업 호출
  $scope.showPurchaseConfirmLayer = function () {
    // ie에서 풀스크린상태일 경우 레이어 팝업이 보이지 않는 문제로.. 풀스크린 해제
    if ($rootScope.isJp) {
      $state.go("main.help.customerCenter");
    } else {
      $state.go("main.help.inquiry", {
        type: "cam_buy"
      });
    }
  };

  // 구매 확인 레이어 팝업 닫기
  $scope.hidePurchageConfirmLayer = function () {
    $scope.isShowPurchaseConfirmLayer = false;
  };

  // 서비스 해지 확인 레이어 팝업 호출
  $scope.showRefundConfirmLayer = function () {
    $scope.isShowRefundConfirmLayer = true;
  };

  // 서비스 해지 확인 레이어 팝업 닫기
  $scope.hideRefundConfirmLayer = function () {
    $scope.isShowRefundConfirmLayer = false;
  };

  // 토스트마켓 서비스 해지 페이지 이동
  $scope.goMarketRefund = function () {
    $window.location.href = $rootScope.ENV_VARS.marketUrl + "/usage";
  };

  // 카메라 off 확인 레이어 팝업 닫기
  $scope.hideCameraOffConfirmLayer = function () {
    $scope.isShowCameraOffConfirmLayer = false;
  };

  // 카메라 on 확인 레이어 팝업 닫기
  $scope.hideCameraOnConfirmLayer = function () {
    $scope.isShowCameraOnConfirmLayer = false;
  };

  // 카메라 on / off 확인 레이어 팝업 열기
  $scope.showCameraOnOffConfirmLayer = function () {
    if (!$scope.currentCamera.hasConfigPermission) {
      showAlert($translate.instant("SHARE_ED_CAMERA"), $translate.instant("SHARE_ED_CAMERA_IS_NO"));
      return;
    }
    if ($scope.config.streamStatus == "off") {
      $scope.isShowCameraOnConfirmLayer = true;
      $scope.isShowCameraOffConfirmLayer = false;
    } else {
      $scope.isShowCameraOffConfirmLayer = true;
      $scope.isShowCameraOnConfirmLayer = false;
    }
  };
  var motionArray_1 = [];
  var motionArray_2 = [];
  var motionArray_3 = [];
  /**
   * 이벤트 존 ajax 호출 및 필터 on / off 셋팅
   * @return {Promise}
   */
  var getAlarmZones = function getAlarmZones() {
    var deferred = $q.defer();
    var paramType = $stateParams.type;
    var paramId = $stateParams.id;
    var requestParam = {
      id: $stateParams.cameraId
    };
    if ((paramType === "shop" || paramType === "sharedshop") && paramId) {
      requestParam.shopId = paramId;
    }
    var fetchZones = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res, isAiType4, processZones, isAllSensorZonesActive, filteredSensorZoneList;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return new Promise(function (resolve, reject) {
                Camera.zones(requestParam, resolve, reject);
              });
            case 3:
              res = _context.sent;
              isAiType4 = $scope.currentCamera.aiType === 4; // 공통 데이터 처리 함수
              processZones = function processZones(zones) {
                if (isAiType4) {
                  // AI 타입이 4일 경우 추가 분류
                  motionArray_1 = [];
                  motionArray_2 = [];
                  motionArray_3 = [];
                  zones.forEach(function (zone) {
                    if (zone.id !== 9) {
                      if (zone.type === "loitering") {
                        motionArray_1.push(zone);
                      } else if (zone.type === "intrusion") {
                        motionArray_2.push(zone);
                      }
                      motionArray_3.push(zone);
                    }
                  });
                  $scope.motionZones_1 = motionArray_1;
                  $scope.motionZones_2 = motionArray_2;
                }
                $scope.motionZones = zones;
              }; // 센서 활성화 상태 계산
              isAllSensorZonesActive = function isAllSensorZonesActive() {
                return $scope.sensorZones.every(function (_ref4) {
                  var filterMark = _ref4.filterMark;
                  return filterMark === "on";
                });
              }; // 이벤트와 센서 처리
              $scope.eventZones = res.eventZones;

              // NOTE: 소리의 경우 하드코딩되어있기 때문에 의도적으로 제외
              filteredSensorZoneList = res.eventZones.filter(function (_ref5) {
                var id = _ref5.id,
                  labelName = _ref5.labelName;
                var isSoundEvent = id === "0" && labelName === "소리";
                return !isSoundEvent;
              });
              $scope.tempSensorZones = filteredSensorZoneList;
              $scope.sensorZones = filteredSensorZoneList;
              processZones(res.zones);
              if ($scope.playerObj) {
                $scope.playerObj.setData("eventZones", $scope.eventZones);
                $scope.playerObj.setData("motionZones", $scope.motionZones);
              }
              $scope.allMotionCheck = $scope.motionZones.every(function (zone) {
                return zone.filterMark === "on";
              }) && $scope.inoutFilter && isAllSensorZonesActive() && (!$scope.soundZone || !!$scope.tempSoundFilter);
              $scope.soundZone = $scope.eventZones.find(function (zone) {
                return zone.id === "0";
              });
              $scope.accessZone = $scope.eventZones.find(function (zone) {
                return zone.id === "10000";
              });
              deferred.resolve();
              _context.next = 23;
              break;
            case 19:
              _context.prev = 19;
              _context.t0 = _context["catch"](0);
              void 0;
              deferred.reject(_context.t0);
            case 23:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 19]]);
      }));
      return function fetchZones() {
        return _ref3.apply(this, arguments);
      };
    }();

    // 비동기 함수 호출
    fetchZones();
    return deferred.promise;
  };

  // motion 알림 존 별 css 클래스명
  $scope.getMotionZoneClassName = function (zoneId) {
    //  FIXME: 최대 4개까지 인것으로 파악됨.
    var motionZoneClassName = {
      1: "org",
      2: "sky",
      3: "grn",
      4: "yel",
      5: "blpp",
      6: "ppl",
      7: "pink",
      9: "gray"
    };
    return motionZoneClassName[zoneId];
  };

  // sensor 알림 존 별 css 클래스명
  $scope.getSensorZoneClassName = function (zoneId) {
    var sensorZoneClassName = {
      SENSOR_TEMP: "temp",
      SENSOR_HUMID: "humid",
      SENSOR_MOTION: "motion",
      SENSOR_MAGNETIC: "door",
      DOORLOCK_EVENT: "doorlock",
      SENSOR_SMOKE: "smoke",
      SENSOR_GAS: "gas",
      SENSOR_PLUG: "plug"
    };
    return sensorZoneClassName[zoneId];
  };
  $scope.toggleEventFilter = function (eventId, filterMark) {
    // 모든 움직임 필터 선택여부에 따른 전체 선택 체크박스 체크 처리
    var tmpEventZoneList = $scope.tempSensorZones;
    $scope.tempSensorZones = tmpEventZoneList.map(function (_ref6) {
      var id = _ref6.id,
        rest = _objectWithoutProperties(_ref6, _excluded);
      if (id === eventId) {
        return _objectSpread(_objectSpread({}, rest), {}, {
          id: id,
          filterMark: filterMark
        });
      }
      return _objectSpread({
        id: id
      }, rest);
    });
    var allSensorZonesActive = $scope.tempSensorZones.every(function (_ref7) {
      var filterMark = _ref7.filterMark;
      return filterMark === "on";
    });
    $scope.allMotionCheck = !_.includes(_.map($scope.tempMotionZones, "filterMark"), "off") && $scope.tempInoutFilter && allSensorZonesActive && (!$scope.soundZone || !!$scope.tempSoundFilter);
  };
  $scope.toggleInoutFilter = function () {
    var allSensorZonesActive = allSensorZonesActive.every(function (_ref8) {
      var filterMark = _ref8.filterMark;
      return filterMark === "on";
    });
    $scope.allMotionCheck = !_.includes(_.map($scope.tempMotionZones, "filterMark"), "off") && $scope.tempInoutFilter && allSensorZonesActive;
  };

  /**
   * 움직임 필터 전체 선택 check toggle 함수
   */
  $scope.toggleAllMotionFilter = function () {
    if ($scope.allMotionCheck) {
      $scope.tempMotionZones.forEach(function (obj) {
        obj.filterMark = "on";
      });
      $scope.tempInoutFilter = true;
      $scope.tempSoundFilter = true;
      $scope.tempSensorZones.forEach(function (obj) {
        obj.filterMark = "on";
      });
    } else {
      $scope.tempMotionZones.forEach(function (obj) {
        obj.filterMark = "off";
      });
      $scope.tempInoutFilter = false;
      $scope.tempSoundFilter = false;
      $scope.tempSensorZones.forEach(function (obj) {
        obj.filterMark = "off";
      });
    }
  };

  /**
   * 공유받은 카메라가 아닌 경우 이벤트 필터 저장 ajax 호출 처리 및
   * 타임라인 이벤트 그리기, 이벤트 리스트 필터링 및 섬네일 필터링 함수 호출
   */
  var saveFilter = function saveFilter() {
    //FIXME: motionZones의 id와 eventZones의 아이디가 겹칠것이 우려됨. 특히 4번
    var zoneData = _.concat($scope.eventZones, $scope.motionZones);
    var params = {
      zoneIndex: _.map(zoneData, "id").join(","),
      filterMark: _.map(zoneData, "filterMark").join(",")
    };
    Camera.updateAlarmZonesFiltersOnOff({
      cameraId: $scope.currentCamera.id
    }, params, function (res) {
      // success
    }, function (err) {
      showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
    });
  };

  /**
   * 이벤트 리스트 목록의 상세 모션별 아이콘
   * @param {Number} zoneId
   * @return {Bolean} check 여부
   */
  // FIXME: 삭제 예상
  $scope.showEventIcons = function (zoneId) {
    var allEventZones = _.map(_.filter(_.concat($scope.eventZones, $scope.motionZones), ["filterMark", "on"]), "id");
    if ($scope.inoutFilter) {
      allEventZones = _.concat(allEventZones, ["ACCESS_ENTER", "ACCESS_EXIT"]);
    }
    var i,
      len = $scope.sensorZones.length;
    for (i = 0; i < len; i += 1) {
      if ($scope.sensorZones[i].filterMark === "on") {
        allEventZones.push($scope.sensorZones[i].id);
      }
    }
    if (zoneId != undefined) {
      return allEventZones.indexOf(zoneId.toString()) > -1;
    }
  };

  /**
   * 이벤트 목록의  썸네일 중 필터체크 된 이벤트가 없을 경우 썸네일 숨김
   * @param  {[type]} eventData [description]
   * @return {[type]}           [description]
   */
  $scope.isShowEventThumbnail = function (eventData) {
    var allFilteredZoneIds = $scope.getAllFilteredZonesIds(eventData.zoneUidxs.split(","));
    return _.intersection(eventData.zoneUidxs.split(","), allFilteredZoneIds).length > 0;
  };

  /**
   * 비교할 zone data로 삭제된 이벤트를 포함
   * @param  {Array} zoneData
   * @return {Array} allFilteredZoneIdsArr 체크 처리된 zone id array. 모션존은 uid
   */
  $scope.getAllFilteredZonesIds = function (zoneData) {
    // 현재 이벤트 data의 zoneIdxs중 check 된 zoneIndex 여부 확인
    var filteredEventZoneIdsArr = _.map(_.filter($scope.eventZones, ["filterMark", "on"]), "id");
    var filteredMotionZoneIdsArr = _.map(_.filter($scope.motionZones, function (o) {
      return o.filterMark === "on" && o.id !== "9";
    }), "uid");
    var allFilteredZoneIdsArr = _.concat(filteredEventZoneIdsArr, filteredMotionZoneIdsArr); // 체크 처리된 모든 zoneId
    var isCheckedDeleteZoneId = _.get(_.find($scope.motionZones, ["id", "9"]), "filterMark") === "on" ? true : false;

    // 삭제된 이벤트가 체크된 경우 이벤트에서 alarmzone으로 설정된 zoneId가 아닌 zoneId 모두를 추출.
    if (isCheckedDeleteZoneId) {
      var allZoneIdsArr = _.concat(_.map($scope.eventZones, "id"), _.map(_.filter($scope.motionZones, function (o) {
        return o.id !== "9";
      }), "uid"));
      var deletedZoneIdsArr = _.difference(zoneData, allZoneIdsArr); // 0, 10000, 20000, motion zoneId를 제외한 존 데이터는 삭제된 이벤트 zone id
      allFilteredZoneIdsArr = _.concat(allFilteredZoneIdsArr, _.map(_.filter(deletedZoneIdsArr, function (o) {
        return o !== "ACCESS_ENTER" && o !== "ACCESS_EXIT" && o !== "SENSOR_TEMP" && o !== "SENSOR_HUMID" && o !== "SENSOR_MOTION" && o !== "SENSOR_MAGNETIC" && o !== "SENSOR_SMOKE" && o !== "SENSOR_GAS" && o !== "SENSOR_PLUG" && o !== "DOORLOCK_EVENT";
      })));
    }
    if ($scope.inoutFilter) {
      allFilteredZoneIdsArr = _.concat(allFilteredZoneIdsArr, ["ACCESS_ENTER", "ACCESS_EXIT"]);
    }
    $scope.sensorZones.forEach(function (sensorZone) {
      if (sensorZone.filterMark === "on") {
        allFilteredZoneIdsArr.push(sensorZone.id);
      }
    });
    return allFilteredZoneIdsArr;
  };
  function loadCameraList() {
    if (typeof $stateParams.type !== "undefined") {
      $scope.viewtype = $stateParams.type;
      var promiseCameras = null;
      if ($stateParams.type === "camera") {
        promiseCameras = Camera.getMyCameras().$promise;
      } else if ($stateParams.type === "shop" && typeof $stateParams.id !== "undefined") {
        promiseCameras = Shop.getShopV2({
          shopId: $stateParams.id
        }).$promise;
      } else if ($stateParams.type === "group" && typeof $stateParams.id !== "undefined") {
        promiseCameras = CameraGroup.getGroupDetail({
          groupId: $stateParams.id
        }).$promise;
      } else if ($stateParams.type === "sharedgroup" && typeof $stateParams.id !== "undefined") {
        promiseCameras = CameraGroup.getSharedGroupDetail({
          groupId: $stateParams.id
        }).$promise;
      } else if ($stateParams.type === "sharedshop" && typeof $stateParams.id !== "undefined") {
        promiseCameras = Shop.getSharedShopV2({
          shopId: $stateParams.id
        }).$promise;
      }
      if (!promiseCameras) {
        return;
      }
      promiseCameras.then(function (res) {
        if (res.controllerList) {
          $.each(res.controllerList, function (i, node) {
            if (node !== undefined) {
              var camera = node.cameraInfo;
              if (node.deviceType == "CAMERA") {
                var serviceType = camera.serviceType;
                var recordType = camera.recordType;
                var recorderType = camera.recorderType;
                if (serviceType == "0d" && recordType == "na" && recorderType == "cvr") {
                  camera.thumbnailPath = location.hostname + "/resources/img/img_camera_blackout.png";
                  camera.addServiceType = "black";
                } else if (recorderType == "0d" && recordType == "live" && recorderType == "cvr") {
                  //live
                  camera.addServiceType = "live";
                } else if (recorderType != "0d" && recordType == "event" && recorderType == "cvr") {
                  //event
                  camera.addServiceType = "event";
                } else if (recorderType != "0d" && recordType == "24h" && recorderType == "cvr") {
                  //24h
                  camera.addServiceType = "24h";
                } else {
                  camera.addServiceType = "else";
                }
              } else {
                if (camera !== undefined) {
                  camera.addServiceType = "else";
                }
              }
            }
          });
        }
        if ($stateParams.type === "shop" || $stateParams.type === "sharedshop") {
          $scope.cameraList = _.map(_.filter(res.controllerList, ["deviceType", "CAMERA"]), "cameraInfo");
        } else {
          $.each(res.cameras, function (i, node) {
            var camera = node;
            var serviceType = camera.serviceType;
            var recordType = camera.recordType;
            var recorderType = camera.recorderType;
            if (serviceType == "0d" && recordType == "na" && recorderType == "cvr") {
              camera.thumbnailPath = location.hostname + "/resources/img/img_camera_blackout.png";
              camera.addServiceType = "black";
            } else if (recorderType == "0d" && recordType == "live" && recorderType == "cvr") {
              //live
              camera.addServiceType = "live";
            } else if (recorderType != "0d" && recordType == "event" && recorderType == "cvr") {
              //event
              camera.addServiceType = "event";
            } else if (recorderType != "0d" && recordType == "24h" && recorderType == "cvr") {
              //24h
              camera.addServiceType = "24h";
            } else {
              camera.addServiceType = "else";
            }
          });
          $scope.cameraList = res.cameras;
        }
        $scope.cameraList.forEach(function (camera) {
          if (camera.thumbnailPath) {
            camera.thumbnailPath = $scope.protocol + camera.thumbnailPath;
          }
        });
        if (camListObj) {
          camListObj.destroy();
        }
        camListObj = tCam.camlist({
          elId: "camera_list_wrap",
          list: $scope.cameraList,
          focusId: $scope.currentCamera.id,
          eventHandler: function eventHandler(event) {
            $scope.changeCamera(event.value.id, event.value.recorderType);
          }
        });
        if ($scope.currentCamera.serviceType == "0d" && $scope.currentCamera.recordType == "na" && $scope.currentCamera.recorderType == "cvr") {
          $.each($(".player_cam.player_off_black"), function (i, node) {
            var display = $(node).css("display");
            if (display != "none") {
              $(node).find(".n_area").css("display", "none");
            }
          });
          $("#error_status_wrap").css("display", "block");
        } else if ($scope.currentCamera.serviceType == "0d" && $scope.currentCamera.recordType == "live" && $scope.currentCamera.recorderType == "cvr") {
          $("#error_status_wrap").css("display", "block");
        }
        makeCameraListViewItems();
        $scope.initCameraListView();
        if ($stateParams.type === "shop" || $stateParams.type === "sharedshop") {
          $scope.shopObj = res;
        } else if ($stateParams.type === "group" || $stateParams.type === "sharedgroup") {
          $scope.groupObj = res;
        }
        moveCameraListToCurCam();
      }, function (err) {});
    } else {
      $scope.viewtype = "";
    }
  }
  function moveCameraListToCurCam() {
    function hasCurCamera(list) {
      var i,
        len = list.length;
      for (i = 0; i < len; i += 1) {
        if (list[i].id === $scope.currentCamera.id) {
          return true;
        }
      }
      return false;
    }
    var loopCount = Math.ceil($scope.cameraList.length / $scope.listViewMaxCnt) - 1;
    for (var i = 0; i < loopCount; i += 1) {
      if (hasCurCamera($scope.listViewItems)) {
        return;
      }
      $scope.moveCameraList(1);
    }
  }
  function makeCameraListViewItems() {
    var i, len;
    $scope.listViewItems = [];
    for (i = $scope.listViewFirstIdx, len = $scope.listViewFirstIdx + $scope.listViewMaxCnt; i < len; i += 1) {
      if ($scope.cameraList[i]) {
        $scope.listViewItems.push($scope.cameraList[i]);
      }
    }
  }
  $scope.moveCameraList = function (step) {
    if (step > 0) {
      if ($scope.cameraList.length > $scope.listViewMaxCnt && $scope.listViewFirstIdx + $scope.listViewItems.length < $scope.cameraList.length) {
        $scope.listViewFirstIdx += $scope.listViewMaxCnt;
        makeCameraListViewItems();
      }
    } else {
      if ($scope.cameraList.length > $scope.listViewMaxCnt && $scope.listViewFirstIdx > 0) {
        $scope.listViewFirstIdx -= $scope.listViewMaxCnt;
        makeCameraListViewItems();
      }
    }
  };

  /**
   * 카메라 변경
   * @param {String} cameraId
   * @param {String} recorderType
   */
  $scope.changeCamera = function (cameraId, recorderType) {
    if ($scope.currentCamera.id === cameraId) return;
    if (restrictCheckId) {
      $interval.cancel(restrictCheckId);
    }
    if (camListObj) {
      if (camListObj.focusId !== cameraId) {
        camListObj.focusId = cameraId;
      }
    }
    $scope.showPtzControl(false);
    $stateParams.cameraId = cameraId;
    $scope.cameraId = cameraId;
    if (($stateParams.type === "sharedshop" || $stateParams.type === "sharedgroup") && typeof $stateParams.id !== "undefined") {
      $("#player").show();
      $("#remote_stream").hide();
      $("#connectIframe").attr("src", "");
      $state.go("main.cameraDetail", {
        cameraId: cameraId,
        type: $stateParams.type,
        id: $stateParams.id,
        shared: true
      }, {
        notify: false
      });
      $scope.setCurrentTab("event");
      changeData($scope.currentCamera.isAiSupport && $scope.usePeopleCount);
    } else {
      $("#player").show();
      $("#remote_stream").hide();
      $("#connectIframe").attr("src", "");
      $state.go("main.cameraDetail", {
        cameraId: cameraId,
        type: $stateParams.type,
        id: $stateParams.id
      }, {
        notify: false
      });
      $scope.setCurrentTab("event");
      changeData($scope.currentCamera.isAiSupport && $scope.usePeopleCount);
    }
    $scope.cameraChangeFlag = true;
  };

  /**
   * 카메라 변경 데이터 처리
   */
  function changeData(prevCamAISupport) {
    var currentTime = $scope.playControl.getData("isLive") == true ? 0 : $scope.playControl.getData("currentTime").getTime();
    if (prevCamAISupport) {
      $interval.cancel(aiInfoReqInterval);
      $scope.aiCountSummary = null;
      $scope.aiThumbnailPath = null;
      $scope.showAiGraph = true;
      var generateXAxisItems = function generateXAxisItems() {
        return Array.from({
          length: 24
        }, function (_, i) {
          return i % 2 === 0 ? i.toString() : "";
        });
      };

      // Helper 함수: AI Zone 정리
      var destroyZone = function destroyZone(zone) {
        if (zone) {
          zone.destroy();
          return null;
        }
        return zone;
      };
      makeAICamLineGraph({
        data: Array(23).fill(null),
        //
        xAxis: {
          items: generateXAxisItems()
        },
        yAxis: {
          min: 0,
          max: 10
        }
      });
      $scope.aiTableZones = null;
      $scope.aiZonearea = destroyZone($scope.aiZonearea); // 중복 제거
      $scope.aiPeopleZonearea = destroyZone($scope.aiPeopleZonearea); // 중복 제거
    }
    $("#zoom_cursor_length").css("width", 0);
    $scope.loadCameraSetting(function () {
      loadCurrentCamera().then(function () {
        if ($scope.playerObj) {
          $scope.playerObj.reloadPlayer();
        }
        $scope.usePeopleCount = $scope.config.cameraAIConfig && $scope.config.cameraAIConfig.aiTypeCode === 1;
        if ($scope.currentCamera.isAiSupport && $scope.usePeopleCount && !$scope.isExpiredCloud()) {
          requestCamAiGraph(true);
          makeAiInfoReqInterval();
          $("#ai_graph_wrap").css("width", $("#player").width());
        }
        $scope.currentCameraDataSet();
        $scope.cameraStatusSet();
        getSensorFilterFromLocalStorage();
        getInoutFilterFromLocalStorage();
        if (!currentTime || $scope.currentCamera.recordType === "live") {
          setTimeout(function () {
            $scope.timeline.setData("cursorOn", false);
            $scope.playerObj.requestPlay();
          }, 1000);
        }
      });
    });
  }

  /**
   * 전체 화면 모드 카메라 썸네일 목록 영영 토글 처리
   */
  $scope.toggleCameraGallery = function () {
    $scope.isAddShowGalleryClass = !$scope.isAddShowGalleryClass;
  };

  /**
   * NVR 카메라 이름 변경 레이어 호출
   */
  $scope.showNVRCameraSetting = function () {
    var apiCallFn = !$scope.shareStatus ? CameraConfig.get : CameraConfig.getSharedConfig;
    apiCallFn({
      id: $scope.currentCamera.id
    }, function (res) {
      $scope.config = res;
      $scope.isShowNVRCameraSetting = true;
    }, function (err) {
      showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
    });
  };

  /**
   * NVR 카메라 이름 변경 레이어 닫기
   */
  $scope.hideNVRCameraSetting = function () {
    $scope.isShowNVRCameraSetting = false;
  };
  $scope.showCVRSecureModeInfoLayer = function () {
    $scope.isShowCVRSecureModeInfo = true;
  };
  $scope.initCameraListView();
  $scope.showPtzControl = function (isShow) {
    if (isShow && (!$scope.currentCamera || $scope.currentCamera.controlStatus != "on" || $scope.isFullScreen)) {
      return;
    }
    $scope.isShowPtzControl = isShow;
    if (isShow) {
      showPtzArea();
      $scope.requestLivePlay();
    } else {
      $scope.ptzAreaVisible = false;
      destroyPtzArea();
    }
    if ($scope.playControl && !$scope.playControl.getData("isPlaying")) {
      $scope.playControl.playInfoBar.playBtn();
    }
    if ($scope.playerObj) {
      $scope.playerObj.setData("ptzControlMode", isShow);
    }
  };
  $scope.PTZ_CMD = {
    UP: "0x0402",
    DOWN: "0x0404",
    RIGHT: "0x0502",
    LEFT: "0x0504",
    UP_LEFT: "0x0702",
    DOWN_LEFT: "0x0704",
    UP_RIGHT: "0x0802",
    DOWN_RIGHT: "0x0804",
    STOP: "0x0901",
    ZOOM_IN: "0x0302",
    STOP_ZOOM_IN: "0x0301",
    ZOOM_OUT: "0x0304",
    STOP_ZOOM_OUT: "0x0303"
  };
  $scope.ptzMove = function (ptzCmd) {
    var speed = Math.round(ptzSpeed);
    if (ptzCmd === $scope.PTZ_CMD.STOP || ptzCmd === $scope.PTZ_CMD.STOP_ZOOM_IN || ptzCmd === $scope.PTZ_CMD.STOP_ZOOM_OUT) {
      speed = 0;
    }
    Camera.ptzControl({
      cameraId: $stateParams.cameraId
    }, {
      ptzCmd: ptzCmd,
      para1: speed,
      para2: speed,
      para3: 0
    }, function (data) {});
  };
  if ($rootScope.previousState === "main.cameraAudioChat") {
    $timeout(function () {
      showAlert($translate.instant("AUDIOCHAT_EXIT"), $translate.instant("AUDIOCHAT_STOP_FROM"));
    }, 500);
  }
  $timeout(function () {
    $scope.isLoadOff = true;
  }, 500);
}]);
"use strict";

app.controller("AiZoneSetCtrl", ["$scope", "$rootScope", "$stateParams", "$state", "Camera", "User", "CameraConfig", "$translate", "$timeout", "$q", "$window", "Shop", "Utils", function ($scope, $rootScope, $stateParams, $state, Camera, User, CameraConfig, $translate, $timeout, $q, $window, Shop, Utils) {
  var _$rootScope$me;
  showPage();
  $scope.cameraName = "";
  $scope.tzCode = "";
  $scope.volumeIdx = 0;
  $scope.liveReplayCheck = 0;
  $scope.serviceDay = 0;
  $scope.modifyMode = false;
  $scope.hasZone = false;
  $scope.isDrawing = false;
  var guideShowChecked = false;
  var playerObj = null;
  var camListObj = null;
  var guideDlg = null;
  var playControl = null;
  var noMakeKeyPrefix = "no-ai-guide-make-show-";
  var noGuideKeyPrefix = "no-ai-guide-show-";
  var clientUid = ($rootScope === null || $rootScope === void 0 ? void 0 : (_$rootScope$me = $rootScope.me) === null || _$rootScope$me === void 0 ? void 0 : _$rootScope$me.uid) || "";
  $scope.countryDomain = $rootScope.countryDomain || "ko";
  if ($stateParams.id && $stateParams.type === "shop") {
    $rootScope.cameraShopId = $stateParams.id;
  } else if ($stateParams.shopId) {
    $rootScope.cameraShopId = $stateParams.shopId;
  } else {
    $rootScope.cameraShopId = "";
  }

  /**** AI Shop Start ****/
  $scope.peopleZoneMode = $stateParams.peopleZone == "true";
  $scope.seatZoneMode = $stateParams.seatZone == "true";
  var zoneType = $scope.peopleZoneMode ? "PEOPLE_COUNT_ZONE" : "TABLE_ZONE";
  $scope.goAiShopPage = function () {
    var navigateToAiShop = function navigateToAiShop() {
      $state.go("main.dashboard.aishop", {
        shopId: $stateParams.id
      });
    };
    if ($scope.peopleZonearea.getIsDrawing()) {
      showNotCompleteConfirm(true, navigateToAiShop);
    } else {
      navigateToAiShop();
    }
  };
  $scope.aiZoneTimeStr = "";
  $scope.aiZoneVisible = true;
  var initAiZoneData = function initAiZoneData() {
    $scope.aiZoneTimeStr = "";
    $scope.aiZones = null;
    $scope.aiZoneVisible = true;
    $scope.people_count = 0;
  };
  var aiZoneEventHandler = function aiZoneEventHandler(event) {
    var eventHandlers = {
      remove: function remove() {
        return $scope.removeZone(event.zone);
      },
      add: function add() {
        return $scope.addZone(event.zone);
      },
      modify: function modify() {
        return $scope.modifyZone(event.zone);
      },
      drawing_change: function drawing_change() {
        $scope.isDrawing = event.drawing;
        $scope.$apply();
      },
      full: function full() {
        if (!$scope.modifyMode) {
          var title = $translate.instant($scope.peopleZoneMode ? "9rRqk7Vo_01883" : "9rRqk7Vo_01884");
          var message = $translate.instant($scope.peopleZoneMode ? "9rRqk7Vo_02188" : "9rRqk7Vo_02189");
          showAlert(title, message);
          $scope.$apply();
        }
      }
    };
    if (eventHandlers[event.name]) {
      eventHandlers[event.name]();
    }
  };
  var showPeopleZones = function showPeopleZones() {
    $scope.peopleZoneVisible = true;
    var area = document.getElementById("people-zone-area");
    var playerWidth = $("#player").width(),
      playerHeight = $("#player").height();
    area.style.width = playerWidth + "px";
    area.style.height = playerHeight + "px";
    if (!$scope.peopleZonearea) {
      $scope.peopleZonearea = new PeopleZoneArea("people-zone-area", $scope.seatZoneMode ? "seat" : "people");
      $scope.peopleZonearea.setEventHandler(aiZoneEventHandler);
    }
    updateZones();
  };
  var deletePeopleZones = function deletePeopleZones() {
    $scope.peopleZoneVisible = false;
    $("#people-zone-area").empty();
    $scope.peopleZonearea = null;
  };
  if ($scope.peopleZoneMode || $scope.seatZoneMode) {
    setTimeout(function () {
      showPeopleZones();
    }, 1000);
  }
  function showNotCompleteConfirm(isOut, callback) {
    $rootScope.createConfirm({
      title: $translate.instant("ACCESS_ALARM"),
      description: $translate.instant("9rRqk7Vo_02246"),
      cancelTxt: isOut ? $translate.instant("9rRqk7Vo_01895") : $translate.instant("BUTTON_CANCEL"),
      confTxt: $translate.instant("BUTTON_SAVE"),
      handler: function handler() {
        $scope.peopleZonearea.closePolygon();
        if (callback) {
          callback();
        }
      },
      cancelHandler: function cancelHandler() {
        if (callback) {
          callback();
        }
      }
    });
  }
  function updateZones() {
    Camera.getAlarmZoneByType({
      cameraId: $stateParams.cameraId,
      zoneType: zoneType
    }, function (res) {
      if (!res.zones.length) {
        $scope.peopleZonearea.setZonesData(null);
        $scope.hasZone = false;
        if (!guideShowChecked) {
          if (!(localStorage && localStorage.getItem && localStorage.getItem(noMakeKeyPrefix + clientUid))) {
            showMakeGuideDlg();
          }
        }
      } else {
        $scope.hasZone = true;
        $scope.peopleZonearea.setZonesData(res.zones, $scope.modifyMode);
      }
      guideShowChecked = true;
    });
  }
  function showMakeGuideDlg() {
    if ($rootScope.isSetAiZone) {
      return;
    }
    if (guideDlg) {
      guideDlg.destroy();
    }
    guideDlg = tCam.aizoneGuideDialog({
      elId: "wrap",
      dlgStyle: {
        width: "452px",
        height: "367px",
        borderRadius: "12px",
        boxSizing: "border-box",
        overflow: "hidden"
      },
      txtMap: {
        noshow: $translate.instant("BUTTON_DO_NOT_SHOW"),
        confirm: $translate.instant("BUTTON_CONFIRM")
      },
      swipeInfos: [{
        imgUrl: "/resources/img/img-zone-create-guide.jpg",
        description: $translate.instant("9rRqk7Vo_02186")
      }, {
        imgUrl: "/resources/img/img-zone-delete-guide.jpg",
        description: $translate.instant("9rRqk7Vo_02187")
      }],
      noCloseBtn: true,
      eventHandler: function eventHandler(event) {
        if (event.event === "noshow") {
          if (localStorage && localStorage.setItem) {
            localStorage.setItem(noMakeKeyPrefix + clientUid, true);
          }
        }
        guideDlg.destroy();
        guideDlg = null;
      }
    });
  }
  function showModifyGuideDlg() {
    if ($rootScope.isSetAiZone) {
      return;
    }
    if (guideDlg) {
      guideDlg.destroy();
    }
    guideDlg = tCam.aizoneGuideDialog({
      elId: "wrap",
      dlgStyle: {
        width: "452px",
        height: "367px",
        borderRadius: "12px",
        boxSizing: "border-box",
        overflow: "hidden"
      },
      txtMap: {
        noshow: $translate.instant("BUTTON_DO_NOT_SHOW"),
        confirm: $translate.instant("BUTTON_CONFIRM")
      },
      swipeInfos: [{
        imgUrl: "/resources/img/img-zone-modify-guide-1.jpg",
        description: $translate.instant("9rRqk7Vo_02181")
      }, {
        imgUrl: "/resources/img/img-zone-modify-guide-2.jpg",
        description: $translate.instant("9rRqk7Vo_02242")
      }],
      noCloseBtn: true,
      eventHandler: function eventHandler(event) {
        if (event.event === "noshow") {
          if (localStorage && localStorage.setItem) {
            localStorage.setItem(noGuideKeyPrefix + clientUid, true);
          }
        }
        guideDlg.destroy();
        guideDlg = null;
      }
    });
  }
  $scope.toggleModifyMode = function () {
    if (!$scope.hasZone) {
      return;
    }
    $scope.modifyMode = !$scope.modifyMode;
    $scope.peopleZonearea.resetDrawing();
    $scope.peopleZonearea.setZonesData($scope.peopleZonearea.getZonesData(), $scope.modifyMode);
    if ($scope.modifyMode) {
      if (!(localStorage && localStorage.getItem && localStorage.getItem(noGuideKeyPrefix + clientUid))) {
        showModifyGuideDlg();
      }
    }
  };
  $scope.removeZone = function (zone) {
    Camera.removeAlarmZone({
      cameraId: $stateParams.cameraId,
      zoneType: zoneType,
      zoneIndex: zone.zoneIndex
    }, function (res) {
      updateZones();
    });
  };
  $scope.addZone = function (zone) {
    Camera.setAlarmZones({
      cameraId: $stateParams.cameraId,
      zoneType: zoneType
    }, {
      color: zone.color,
      coordinate: zone.coordinate
    }, function (res) {
      updateZones();
    });
  };
  $scope.modifyZone = function (zone) {
    Camera.modifyAlarmZone({
      cameraId: $stateParams.cameraId,
      zoneType: zoneType,
      zoneIndex: zone.zoneIndex
    }, {
      coordinate: zone.coordinate
    }, function (res) {
      updateZones();
    });
  };
  /****** Ai Shop End ******/

  function playerEventHandler(event, data) {}
  $(window).resize(resizeHandler);
  function resizeHandler() {
    if ($("#remoteVideosContainer").children("video").length) {
      $("#remoteVideosContainer").children("video").css("height", $("#remoteVideosContainer").height() - $("#timeline_table").height());
    }
    var playerWidth = $("#player").css("width"),
      playerHeight = $("#player").css("height");
    $("#people-zone-area").css("width", playerWidth);
    $("#people-zone-area").css("height", playerHeight);
    if ($scope.peopleZonearea) {
      $scope.peopleZonearea.setCanvasSize($("#player").css("width"), $("#player").css("height"));
    }
    $timeout(function () {
      $scope.$apply();
    });
  }
  $scope.camera = {
    id: $stateParams.cameraId
  };
  var showAlert = function showAlert(title, message) {
    $(".display_show").css("display", "");
    $scope.showAlert = true;
    $scope.alertTitle = title;
    $scope.alertMessage = message;
  };
  $scope.hideAlert = function () {
    $scope.showAlert = false;
  };
  $scope.isExpiredCloud = function () {
    if ($scope.currentCamera) {
      return Utils.isCloudExpired($scope.currentCamera);
    } else {
      return false;
    }
  };
  $scope.$on("$destroy", function () {
    if (playerObj) {
      playerObj.destroy();
      playerObj = null;
    }
    if (camListObj) {
      camListObj.destroy();
      camListObj = null;
    }
    if (guideDlg) {
      guideDlg.destroy();
      guideDlg = null;
    }
    $(window).off("resize", resizeHandler);
    playControl = null;
    showAlert = null;
    loadCurrentCamera = null;
  });
  $scope.reloadCameraDetail = function () {
    playControl.errorStatusLayer.cameraStatusAllOff();
    playerObj.setData("playBtnStatus", $scope.plyBtnStatus);
    Camera.get({
      id: $stateParams.cameraId
    }, function (res) {
      $scope.currentCamera = res;
      if (playerObj) {
        playerObj.setData("cameraData", $scope.currentCamera);
      }
      $scope.livePlayDataSet();
    });
  };
  $scope.livePlayDataSet = function () {
    $scope.livePlayStart();
    CameraConfig.get({
      id: $stateParams.cameraId
    }, function (data) {
      angular.extend($scope.config, data);
      $scope.config.tzCode = $scope.tzCode;
      $scope.livePlayConfigDataSet();
      if (playerObj) {
        playerObj.setData("cameraConfig", $scope.config);
      }
    });
  };
  $scope.cameraStatusChange = function (status) {
    playControl.errorStatusLayer.cameraStatusChange(status);
  };
  $scope.livePlayConfigDataSet = function () {
    var cameraStatus = true;
    var cameraStatusNum = 0;
    if ($scope.config.streamStatus == "off") {
      cameraStatusNum = 1;
      setTimeout(function () {
        $scope.pauseBtn();
        $scope.timeline.updateCursor(new Date().valueOf());
      }, 500);
    } else {
      if ($scope.currentCamera.controlStatus === "CS" || $scope.currentCamera.controlStatus === "on") {
        if ($scope.currentCamera.recordType != "event") {
          if ($scope.currentCamera.streamStatus == "off") {
            cameraStatusNum = 2;
            cameraStatus = false;
            setTimeout(function () {
              $scope.pauseBtn();
              $scope.timeline.updateCursor(new Date().valueOf());
            }, 500);
          } else {
            cameraStatusNum = 0;
            cameraStatus = true;
          }
        }
      } else if ($scope.currentCamera.controlStatus === "CE" || $scope.currentCamera.controlStatus === "off") {
        if ($scope.currentCamera.streamStatus == "off") {
          cameraStatusNum = 4;
          cameraStatus = false;
          setTimeout(function () {
            $scope.pauseBtn();
            $scope.timeline.updateCursor(new Date().valueOf());
          }, 500);
        } else {
          cameraStatusNum = 0;
          cameraStatus = true;
        }
      }
    }
    $scope.cameraStatusChange(cameraStatusNum);
  };
  $scope.livePlayStart = function () {
    if ($scope.config.streamStatus != "off") {
      playControl.player.play();
    }
  };
  var userIdLoading = 0;
  $scope.cameraUpagradeAlert = false;
  var loadCurrentCamera = function loadCurrentCamera() {
    var deferred = $q.defer();
    $(".display_show").css("display", "");
    Camera.get({
      id: $stateParams.cameraId
    }, function (res) {
      $scope.currentCamera = res;
      if (playerObj) {
        playerObj.setData("cameraData", $scope.currentCamera);
        $scope.currentCameraDataSet();
      }
      deferred.resolve();
    }, function (error) {
      deferred.reject();
    });
    return deferred.promise;
  };
  $scope.cameraStatusSet = function (clickStatus) {
    if (playerObj && playControl.getData("isLive") == true) {
      var cameraStatusNum = 0;
      if ($scope.config.streamStatus == "off") {
        cameraStatusNum = 1;
      } else {
        if ($scope.currentCamera) {
          if ($scope.currentCamera.controlStatus === "CS" || $scope.currentCamera.controlStatus === "on") {
            if ($scope.currentCamera.recordType != "event") {
              if ($scope.currentCamera.streamStatus == "off" && clickStatus != "setting") {
                if (Utils.isCloudExpired($scope.currentCamera)) {
                  cameraStatusNum = 0;
                } else {
                  cameraStatusNum = 2;
                }
              }
            }
          } else if ($scope.currentCamera.controlStatus === "CE" || $scope.currentCamera.controlStatus === "off") {
            if ($scope.currentCamera.streamStatus == "off") {
              cameraStatusNum = 4;
            } else {
              cameraStatusNum = 3;
            }
          }
        }
      }
      $scope.cameraStatusChange(cameraStatusNum);
    }
  };

  // 현재 화면에 호출된 카메라의 데이터 설정
  $scope.currentCameraDataSet = function () {
    if (playerObj) {
      playControl = playerObj.control;
      $scope.timeline = playControl.timeline;
      $scope.player = playControl.player;
    }
    $("#timebar_area").children("svg").width() / 2 - 75;
    setTimeout(function () {
      $("#timelinedesc").fadeIn(2000, function () {
        $("#timelinedesc").fadeOut(1000);
      });
    }, 500);
    if ($scope.currentCamera.code == "nok") {
      $scope.isNoCamera = true;
      return;
    }
    $scope.cameraName = $scope.currentCamera.labelName;
    if (Utils.isTurnOffCamera($scope.currentCamera)) {
      if ($scope.currentCamera.streamStatus !== "off") {
        Camera.isLastRecord({
          id: $stateParams.cameraId
        }, function (data) {
          if (playControl) {
            playControl.errorStatusLayer.currentCameraIsLastRecordDataSet(data);
          }
        });
      }
      $scope.isPlaying = false;
    } else {
      $scope.isPlaying = true;
    }
    playerObj.setData("isPlaying", $scope.isPlaying);
    if ($scope.currentCamera.streamStatus == "off" || $scope.currentCamera.controlStatus === "CE") {
      cameraOffCheck = setTimeout(function () {
        Camera.isLastRecord({
          id: $stateParams.cameraId
        }, function (data) {
          if (playControl) {
            playControl.errorStatusLayer.currentCameraIsLastRecordDataSet(data);
          }
        });
      }, 1050);
    }
    if (!$scope.isExpiredCloud()) {
      if ($scope.currentCamera.recorderType === "nvr") {
        var now = moment();
        var regDate = moment($scope.currentCamera.regDate);
        $scope.serviceDay = now.diff(regDate, "days") + 1;
      } else {
        $scope.serviceDay = parseInt($scope.currentCamera.serviceType);
      }
    } else {
      $scope.serviceDay = 0;
    }
    playerObj.setData("serviceDay", $scope.serviceDay);
    $scope.cameraStatusSet();
    $scope.me = User.me(function () {
      if (userIdLoading == 0) {
        userIdLoading++;
      }
    });
  };
  $scope.formattedInternalDate = function (date) {
    var md,
      tz = $scope.timeline ? $scope.timeline.getData("timezone") : "";
    if (tz) {
      md = moment(new Date(date)).tz(tz);
    } else {
      md = moment(new Date(date));
    }
    return md.format("YYYYMMDD");
  };
  $scope.selectCamera = function (id) {
    $state.go("main.cameraDetail", {
      cameraId: id
    });
  };
  $scope.goCameraList = function () {
    $window.history.back();
    // $state.go('main.cameras');
  };
  $scope.stopTimer = function () {
    playControl.playTimer.stopTimer();
  };
  $scope.startLiveTimer = function () {
    playControl.playTimer.startLiveTimer(playControl.timeline);
  };
  $scope.goCvr = function (time, status) {
    $scope.timeline.requestPlay(time, status);
  };
  $scope.isTurnOffCamera = function () {
    return Utils.isTurnOffCamera($scope.currentCamera);
  };

  // Camera Setting
  $scope.config = {};
  $scope.loadCameraSetting = function (callback, clickStatus) {
    CameraConfig.get({
      id: $stateParams.cameraId
    }, function (data) {
      angular.extend($scope.config, data);
      if ($scope.config.resolution) {
        $scope.config.resolution = $scope.config.resolution.toUpperCase();
      }
      $("#cameraNameView").html($scope.config.name);
      $scope.cameraStatusSet(clickStatus);
      if ($scope.config.cameraSchedule != undefined) {
        $scope.config.parsedStartAt = Utils.configDateSeparate($scope.config.cameraSchedule.startAt);
        $scope.config.parsedStopAt = Utils.configDateSeparate($scope.config.cameraSchedule.stopAt);
        $scope.config.repeatOn = Utils.configRepeatOnSeparate($scope.config.cameraSchedule.repeatOn);
      }
      if ($scope.config.timezone != undefined) {
        $scope.config.tzCode = $scope.config.timezone.split(",")[0];
        $scope.tzCode = $scope.config.tzCode;
        $scope.config.tzDisplayName = $scope.config.timezone.split(",")[1] + $scope.config.timezone.split(",")[3];
      }
      if ($scope.config.usageRate > 100) {
        $scope.config.usageRate = 100;
      }
      if (playerObj) {
        playerObj.setData("cameraConfig", $scope.config);
      }
      if (typeof callback === "function") {
        callback();
      }
    }, function (err) {
      // error
      $state.go("main", {}, {
        reload: true
      });
    });
  };
  $scope.loadCameraSetting(function () {
    loadCurrentCamera().then(function () {
      playerObj = new tCam.player({
        elementIdMap: {
          root: "camdtl_wrap"
        },
        shopId: $rootScope.cameraShopId,
        isShared: false,
        category: "b2b",
        playerType: "hls",
        country: $rootScope.me.country,
        cameraData: $scope.currentCamera,
        cameraConfig: $scope.config,
        playEventCb: playerEventHandler,
        playTime: 0,
        mute: true
      });
      $scope.currentCameraDataSet();
      $scope.cameraStatusSet();
      loadCameraList();
    });
  });
  $scope.getCameraConfig = function () {
    CameraConfig.get({
      id: $stateParams.cameraId
    }, function (data) {
      angular.extend($scope.config, data);
      $scope.config.tzCode = $scope.config.timezone.split(",")[0];
      $scope.tzCode = $scope.config.tzCode;
      if (playerObj) {
        playerObj.setData("cameraConfig", $scope.config);
      }
    });
  };
  $scope.requestLivePlay = function () {
    if (!playerObj || !playControl) {
      return;
    }
    if (playControl.getData("isLive") == false) {
      playerObj.requestPlay();
    }
  };
  $scope.setCameraData = function (data) {
    $scope.currentCamera = data;
    if (playerObj) {
      playerObj.setData("cameraData", $scope.currentCamera);
    }
  };
  $scope.updateCameraErrorStatus = function (status) {
    if (!playControl) {
      return;
    }
    if (status === "recoff") {
      playControl.errorStatusLayer.cameraRecOff();
    } else {
      playControl.errorStatusLayer.cameraStatusAllOff();
    }
  };
  $scope.hideRemoveCameraAlert = function () {
    $scope.showRemoveCameraAlert = false;
  };
  $scope.ImageExist = function (url) {
    var img = new Image();
    img.src = url;
    if (img.height == 0) {
      return false;
    } else {
      return true;
    }
  };
  $scope.$on("showAlert", function (event, data) {
    showAlert(data.title, data.msg);
  });
  $scope.cameraDataSet = function (data) {
    for (var i = 0; i < data.length; i++) {
      if (location.port != "") {
        data[i].thumbnailPath = location.protocol + "//" + data[i].thumbnailPath.replace(".com/", ".com:" + location.port + "/");
      } else {
        data[i].thumbnailPath = location.protocol + "//" + data[i].thumbnailPath;
      }
      if (data[i].streamStatus === "off" && data[i].controlStatus === "CS") {
        data[i].streamStatus = data[i].streamStatus === "on";
      }
      data[i].cameraViewState = 0;
      if (data[i].streamStatusConfig == "off") {
        data[i].cameraViewState = 1;
      } else {
        if (data[i].controlStatus == "on") {
          if (data[i].recordType != "event") {
            if (data[i].streamStatus == "off") {
              data[i].cameraViewState = 2;
            }
          }
        } else {
          if (data[i].streamStatus == "on") {
            data[i].cameraViewState = 3;
          } else {
            data[i].cameraViewState = 4;
          }
        }
      }
      data[i].number = i;
    }
    return data;
  };
  function findIsAiCamera(cameraId, aiList) {
    return aiList.some(function (aiCam) {
      return cameraId === aiCam.id;
    });
  }
  function loadCameraList() {
    if (typeof $stateParams.type !== "undefined") {
      $scope.viewtype = $stateParams.type;
      var promiseCameras = null;
      if ($stateParams.type === "shop" && typeof $stateParams.id !== "undefined") {
        promiseCameras = Shop.dashboardShopV4({
          shopId: $stateParams.id
        }).$promise;
      }
      promiseCameras.then(function (res) {
        $scope.cameraList = [];
        var aiList = [];
        if (res.ai) {
          aiList = res.ai.summariesByCamera;
        }
        res.shop.controllerList.forEach(function (controller) {
          if (controller.deviceType === "CAMERA" && controller.cameraInfo && controller.cameraInfo.aiType === 1) {
            controller.cameraInfo.thumbnailPath = $scope.protocol + controller.cameraInfo.thumbnailPath;
            $scope.cameraList.push(controller.cameraInfo);
          }
        });
        if (camListObj) {
          camListObj.destroy();
        }
        camListObj = tCam.camlist({
          elId: "camera_list_wrap",
          list: $scope.cameraList,
          focusId: $scope.currentCamera.id,
          eventHandler: function eventHandler(event) {
            if ($stateParams.cameraId === event.value.id) {
              return;
            }
            if ($scope.peopleZonearea.getIsDrawing()) {
              showNotCompleteConfirm(false, function () {
                $scope.changeCamera(event.value.id, event.value.recorderType);
              });
            } else {
              $scope.changeCamera(event.value.id, event.value.recorderType);
            }
          }
        });
      }, function (err) {
        showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
      });
    } else {
      $scope.viewtype = "";
    }
  }

  /**
   * 카메라 변경
   * @param {String} cameraId
   * @param {String} recorderType
   */
  $scope.changeCamera = function (cameraId, recorderType) {
    if ($scope.currentCamera.id === cameraId) return;
    if (camListObj) {
      if (camListObj.focusId !== cameraId) {
        camListObj.focusId = cameraId;
      }
    }
    $("#player").show();
    $("#remote_stream").hide();
    $("#connectIframe").attr("src", "");
    $state.go("main.aiZoneSet", {
      cameraId: cameraId,
      type: $stateParams.type,
      id: $stateParams.id
    }, {
      notify: false
    });
    $stateParams.cameraId = cameraId;
    changeData();
  };

  /**
   * 카메라 변경 데이터 처리
   */
  function changeData() {
    initAiZoneData();
    $scope.loadCameraSetting(function () {
      loadCurrentCamera().then(function () {
        if (playerObj) {
          playerObj.reloadPlayer();
        }
        $scope.currentCameraDataSet();
        $scope.cameraStatusSet();
        if (playControl && playControl.timeline) {
          playControl.timeline.clickedCVRArea(null);
        }
        if (deletePeopleZones) {
          deletePeopleZones();
        }
        if (showPeopleZones) {
          setTimeout(function () {
            showPeopleZones();
          }, 100);
        }
      });
    });
  }
  $timeout(function () {
    $scope.isLoadOff = true;
  }, 500);
}]);
"use strict";

var AiZoneArea = function AiZoneArea(id) {
  this.elId = id;
  this.canvas = document.getElementById(id);
  this.aiZoneWidth = parseInt(this.canvas.style.width);
  this.aiZoneHeight = parseInt(this.canvas.style.height);
  this.svg = d3.select(this.canvas).append('svg').attr('width', '100%').attr('height', '100%').attr('class', 'zone_set_svg');
  this.startPoint = null;
  this.handler = null;
  this.points = [];
  this.polyG = null;
  this.zones = [];
  this.currentColor = null;
  this.init();
};
AiZoneArea.prototype.destroy = function () {
  $(this.canvas).empty();
};
AiZoneArea.prototype.setEventHandler = function (handler) {
  this.handler = handler;
};
AiZoneArea.prototype.makeZoneId = function () {
  var text = "";
  var possible = "0123456789";
  for (var i = 0; i < 13; i++) text += possible.charAt(Math.floor(Math.random() * possible.length));
  return text;
};
AiZoneArea.prototype.draw = function () {
  var i, len;
  $("#" + this.elId + " .zone_set_svg").empty();
  for (i in this.zones) {
    var zone = this.zones[i];
    zone.draw(this.svg);
  }
  if (this.points && this.points.length && this.currentColor) {
    if (d3.select('g.drawPloy').empty()) {
      this.polyG = this.svg.append('g').attr('class', 'drawPoly');
    }
    this.polyG.select('polyline').remove();
    var polyline = this.polyG.append('polyline').attr('points', this.points).style('fill', 'none').attr('stroke', this.currentColor).attr('stroke-width', '2px');
    len = this.points.length;
    for (i = 0; i < len; i += 1) {
      this.polyG.append('circle').attr('cx', this.points[i][0]).attr('cy', this.points[i][1]).attr('r', 6).attr('fill', this.currentColor).attr('is-handle', 'true').style({
        cursor: 'pointer'
      });
    }
  }
};
AiZoneArea.prototype.getZonesData = function () {
  var i,
    len,
    arr = [];
  len = this.zones.length;
  for (i = 0; i < len; i += 1) {
    arr.push({
      coordinate: this.serverDataFromCoordinate(this.zones[i].paths),
      color: this.zones[i].color,
      id: '' + this.zones[i].id,
      uid: '' + this.zones[i].uid,
      zoneIndex: '' + this.zones[i].zoneIndex,
      labelName: this.zones[i].labelName,
      status: 'on',
      filterMark: 'on'
    });
  }
  return arr;
};
AiZoneArea.prototype.setZonesData = function (data) {
  var zones = [];
  for (var i in data) {
    var zoneData = data[i];
    var coordinate = zoneData.coordinate;
    if (coordinate !== undefined) {
      var coordinates = this.coordinateFromServerData(coordinate);
      var zone = AiZone.newZone(zoneData.id, zoneData.uid, zoneData.zoneIndex, coordinates, zoneData.color, zoneData.label);
      zones.push(zone);
    }
  }
  this.zones = zones;
  this.draw();
};
AiZoneArea.prototype.setCanvasSize = function (width, height) {
  var serverData = this.getZonesData();
  var widthInt = parseInt(width);
  var heightInt = parseInt(height);
  this.canvas.style.width = widthInt + 'px';
  this.canvas.style.height = heightInt + 'px';
  this.aiZoneWidth = widthInt;
  this.aiZoneHeight = heightInt;
  this.setZonesData(serverData);
};
AiZoneArea.prototype.init = function () {};
AiZoneArea.prototype.coordinateFromServerData = function (data) {
  var i,
    len,
    that = this,
    arr = [],
    cacheArr = [];
  var parsed = data.split(',').map(function (i) {
    return parseInt(i);
  });
  len = parsed.length;
  for (i = 0; i < len; i += 1) {
    if (i % 2 === 1) {
      cacheArr.push(this.aiZoneHeight * parsed[i] / 1000);
    } else {
      cacheArr.push(this.aiZoneWidth * parsed[i] / 1000);
    }
    if (cacheArr.length === 2) {
      arr.push(cacheArr);
      cacheArr = [];
    }
  }
  return arr;
};
AiZoneArea.prototype.serverDataFromCoordinate = function (data) {
  var i,
    len,
    tempArr = [],
    arr = [];
  if (!data) {
    return '';
  }
  len = data.length;
  for (i = 0; i < len; i += 1) {
    tempArr = tempArr.concat(data[i]);
  }
  len = tempArr.length;
  for (i = 0; i < len; i += 1) {
    if (i % 2 === 1) {
      arr.push(parseInt(1000 * tempArr[i] / this.aiZoneHeight));
    } else {
      arr.push(parseInt(1000 * tempArr[i] / this.aiZoneWidth));
    }
  }
  return arr.join(',');
};
var AiZone = function AiZone(id, uid, zoneIndex, paths, color, label) {
  this.id = id;
  this.uid = uid;
  this.zoneIndex = zoneIndex;
  this.paths = paths;
  this.color = color;
  this.labelName = label;
};
AiZone.newZone = function (id, uid, zoneIndex, datas, color, label) {
  return new AiZone(id, uid, zoneIndex, datas, color, label);
};
AiZone.prototype.createPath = function (svg) {
  var that = this;
  var g = svg.append('g').attr('class', 'poly_wrap_' + that.zoneIndex);
  var polygon = g.append('polygon').attr('points', that.paths).attr("stroke", "black").text(function (d) {
    return that.zoneIndex;
  }).style('fill', that.color).style('opacity', 0.5);
  var polyline = g.append('polyline').attr('points', that.paths.concat([that.paths[0]])).style('fill', 'none').attr('stroke', that.color).attr('stroke-width', '2px');
};
AiZone.prototype.draw = function (svg) {
  this.svg = svg;
  this.createPath(svg);
};
AiZone.prototype.coordinate = function () {
  var x = parseInt(this.paths[0][0]);
  var y = parseInt(this.paths[0][1]);
  var width = parseInt(this.paths[1][0] - x);
  var height = parseInt(this.paths[3][1] - y);
  return [x, y, width, height];
};
"use strict";

app.controller("AifaceZoneSetCtrl", ["$scope", "$rootScope", "$stateParams", "$state", "$filter", "Camera", "CameraConfig", "$translate", "$timeout", "$q", "$window", "Utils", function ($scope, $rootScope, $stateParams, $state, $filter, Camera, CameraConfig, $translate, $timeout, $q, $window, Utils) {
  showPage();
  $scope.cameraName = "";
  $scope.tzCode = "";
  $scope.liveReplayCheck = 0;
  $scope.modifyMode = false;
  $scope.hasZone = false;
  $scope.isDrawing = false;
  $scope.cameraList = [];
  var noMakeKeyPrefix = "no-ai-guide-make-show-";
  var noGuideKeyPrefix = "no-ai-guide-show-";
  var guideShowChecked = false;
  var playerObj = null;
  var camListObj = null;
  var guideDlg = null;
  var playControl = null;
  var cameraOffCheck = 0;
  var notiTimeout = null;
  var clientUid = "";
  if ($rootScope.me && $rootScope.me.uid) {
    clientUid = $rootScope.me.uid;
  }
  $scope.countryDomain = $rootScope.countryDomain;
  if (!$scope.countryDomain) {
    $scope.countryDomain = "ko";
  }
  var zoneType = "FACE_ZONE";
  $scope.goAiFacePage = function () {
    if ($scope.zoneArea.getIsDrawing()) {
      showNotCompleteConfirm(true, function () {
        $state.go("main.aiface.content", {});
      });
    } else {
      $state.go("main.aiface.content", {});
    }
  };
  $scope.aiZoneTimeStr = "";
  $scope.aiZoneVisible = true;
  var initAiZoneData = function initAiZoneData() {
    $scope.aiZoneTimeStr = "";
    $scope.aiZones = null;
    $scope.aiZoneVisible = true;
  };
  var aiZoneEventHandler = function aiZoneEventHandler(event) {
    if (event.name === "remove") {
      $scope.removeZone(event.zone);
    } else if (event.name === "add") {
      $scope.addZone(event.zone);
    } else if (event.name === "modify") {
      $scope.modifyZone(event.zone);
    } else if (event.name === "drawing_change") {
      $scope.isDrawing = event.drawing;
      $scope.$apply();
    } else if (event.name === "full") {
      if (!$scope.modifyMode) {
        notiDelete();
        $scope.notiMsg = $filter("stringFormat")($translate.instant("5mw2slvk_02136"), 4);
        notiTimeout = $timeout(function () {
          $scope.notiMsg = "";
        }, 3000);
        $scope.$apply();
      }
    }
  };
  var showZones = function showZones() {
    $scope.zoneVisible = true;
    var area = document.getElementById("zone-area");
    var playerWidth = $("#player").width(),
      playerHeight = $("#player").height();
    area.style.width = playerWidth + "px";
    area.style.height = playerHeight + "px";
    if (!$scope.zoneArea) {
      $scope.zoneArea = new AifaceZoneArea("zone-area");
      $scope.zoneArea.setEventHandler(aiZoneEventHandler);
    }
    updateZones();
  };
  var deleteZones = function deleteZones() {
    $scope.zoneVisible = false;
    $("#zone-area").empty();
    $scope.zoneArea = null;
  };
  setTimeout(function () {
    showZones();
  }, 1000);
  function notiDelete() {
    if (notiTimeout) {
      $timeout.cancel(notiTimeout);
      notiTimeout = null;
    }
    $scope.notiMsg = "";
  }
  function showNotCompleteConfirm(isOut, callback) {
    $rootScope.createConfirm({
      title: $translate.instant("ACCESS_ALARM"),
      description: $translate.instant("9rRqk7Vo_02246"),
      cancelTxt: isOut ? $translate.instant("9rRqk7Vo_01895") : $translate.instant("BUTTON_CANCEL"),
      confTxt: $translate.instant("BUTTON_SAVE"),
      handler: function handler() {
        $scope.zoneArea.closePolygon();
        if (callback) {
          callback();
        }
      },
      cancelHandler: function cancelHandler() {
        if (callback) {
          callback();
        }
      }
    });
  }
  function updateZones() {
    Camera.getAlarmZoneByType({
      cameraId: $stateParams.cameraId,
      zoneType: zoneType
    }, function (res) {
      if (!res.zones.length) {
        $scope.zoneArea.setZonesData(null);
        $scope.hasZone = false;
        if (!guideShowChecked) {
          if (!(localStorage && localStorage.getItem && localStorage.getItem(noMakeKeyPrefix + clientUid))) {
            showMakeGuideDlg();
          }
        }
      } else {
        $scope.hasZone = true;
        $scope.zoneArea.setZonesData(res.zones, $scope.modifyMode);
      }
      guideShowChecked = true;
    });
  }
  function showMakeGuideDlg() {
    if ($rootScope.isSetAiZone) {
      return;
    }
    if (guideDlg) {
      guideDlg.destroy();
    }
    guideDlg = tCam.aizoneGuideDialog({
      elId: "wrap",
      dlgStyle: {
        width: "452px",
        height: "367px",
        borderRadius: "12px",
        boxSizing: "border-box",
        overflow: "hidden"
      },
      txtMap: {
        noshow: $translate.instant("BUTTON_DO_NOT_SHOW"),
        confirm: $translate.instant("BUTTON_CONFIRM")
      },
      swipeInfos: [{
        imgUrl: "/resources/img/img-zone-create-guide.jpg",
        description: $translate.instant("9rRqk7Vo_02186")
      }, {
        imgUrl: "/resources/img/img-zone-delete-guide.jpg",
        description: $translate.instant("9rRqk7Vo_02187")
      }],
      noCloseBtn: true,
      eventHandler: function eventHandler(event) {
        if (event.event === "noshow") {
          if (localStorage && localStorage.setItem) {
            localStorage.setItem(noMakeKeyPrefix + clientUid, true);
          }
        }
        guideDlg.destroy();
        guideDlg = null;
      }
    });
  }
  function showModifyGuideDlg() {
    if ($rootScope.isSetAiZone) {
      return;
    }
    if (guideDlg) {
      guideDlg.destroy();
    }
    guideDlg = tCam.aizoneGuideDialog({
      elId: "wrap",
      dlgStyle: {
        width: "452px",
        height: "367px",
        borderRadius: "12px",
        boxSizing: "border-box",
        overflow: "hidden"
      },
      txtMap: {
        noshow: $translate.instant("BUTTON_DO_NOT_SHOW"),
        confirm: $translate.instant("BUTTON_CONFIRM")
      },
      swipeInfos: [{
        imgUrl: "/resources/img/img-zone-modify-guide-1.jpg",
        description: $translate.instant("9rRqk7Vo_02181")
      }, {
        imgUrl: "/resources/img/img-zone-modify-guide-2.jpg",
        description: $translate.instant("9rRqk7Vo_02242")
      }],
      noCloseBtn: true,
      eventHandler: function eventHandler(event) {
        if (event.event === "noshow") {
          if (localStorage && localStorage.setItem) {
            localStorage.setItem(noGuideKeyPrefix + clientUid, true);
          }
        }
        guideDlg.destroy();
        guideDlg = null;
      }
    });
  }
  $scope.toggleModifyMode = function () {
    if (!$scope.hasZone) {
      return;
    }
    notiDelete();
    $scope.modifyMode = !$scope.modifyMode;
    $scope.zoneArea.resetDrawing();
    $scope.zoneArea.setZonesData($scope.zoneArea.getZonesData(), $scope.modifyMode);
    if ($scope.modifyMode) {
      if (!(localStorage && localStorage.getItem && localStorage.getItem(noGuideKeyPrefix + clientUid))) {
        showModifyGuideDlg();
      }
    }
  };
  $scope.removeZone = function (zone) {
    Camera.removeAlarmZone({
      cameraId: $stateParams.cameraId,
      zoneType: zoneType,
      zoneIndex: zone.zoneIndex
    }, function (res) {
      updateZones();
    });
  };
  $scope.addZone = function (zone) {
    Camera.setAlarmZones({
      cameraId: $stateParams.cameraId,
      zoneType: zoneType
    }, {
      color: zone.color,
      coordinate: zone.coordinate
    }, function (res) {
      updateZones();
    });
  };
  $scope.modifyZone = function (zone) {
    Camera.modifyAlarmZone({
      cameraId: $stateParams.cameraId,
      zoneType: zoneType,
      zoneIndex: zone.zoneIndex
    }, {
      coordinate: zone.coordinate
    }, function (res) {
      updateZones();
    });
  };
  function playerEventHandler(event, data) {}
  $(window).resize(resizeHandler);
  function resizeHandler() {
    if ($("#remoteVideosContainer").children("video").length) {
      $("#remoteVideosContainer").children("video").css("height", $("#remoteVideosContainer").height() - $("#timeline_table").height());
    }
    var playerWidth = $("#player").css("width"),
      playerHeight = $("#player").css("height");
    $("#zone-area").css("width", playerWidth);
    $("#zone-area").css("height", playerHeight);
    if ($scope.zoneArea) {
      $scope.zoneArea.setCanvasSize($("#player").css("width"), $("#player").css("height"));
    }
    $timeout(function () {
      $scope.$apply();
    });
  }
  $scope.camera = {
    id: $stateParams.cameraId
  };
  var showAlert = function showAlert(title, message) {
    $(".display_show").css("display", "");
    $scope.showAlert = true;
    $scope.alertTitle = title;
    $scope.alertMessage = message;
  };
  $scope.hideAlert = function () {
    $scope.showAlert = false;
  };
  $scope.isExpiredCloud = function () {
    if ($scope.currentCamera) {
      return Utils.isCloudExpired($scope.currentCamera);
    } else {
      return false;
    }
  };
  $scope.$on("$destroy", function () {
    if (playerObj) {
      playerObj.destroy();
      playerObj = null;
    }
    if (camListObj) {
      camListObj.destroy();
      camListObj = null;
    }
    if (guideDlg) {
      guideDlg.destroy();
      guideDlg = null;
    }
    notiDelete();
    $(window).off("resize", resizeHandler);
    playControl = null;
    showAlert = null;
    loadCurrentCamera = null;
  });
  $scope.reloadCameraDetail = function () {
    playControl.errorStatusLayer.cameraStatusAllOff();
    playerObj.setData("playBtnStatus", $scope.plyBtnStatus);
    Camera.get({
      id: $stateParams.cameraId
    }, function (res) {
      $scope.currentCamera = res;
      if (playerObj) {
        playerObj.setData("cameraData", $scope.currentCamera);
      }
      $scope.livePlayDataSet();
    });
  };
  $scope.livePlayDataSet = function () {
    $scope.livePlayStart();
    CameraConfig.get({
      id: $stateParams.cameraId
    }, function (data) {
      angular.extend($scope.config, data);
      $scope.config.tzCode = $scope.tzCode;
      $scope.livePlayConfigDataSet();
      if (playerObj) {
        playerObj.setData("cameraConfig", $scope.config);
      }
    });
  };
  $scope.cameraStatusChange = function (status) {
    playControl.errorStatusLayer.cameraStatusChange(status);
  };
  $scope.livePlayConfigDataSet = function () {
    var cameraStatus = true;
    var cameraStatusNum = 0;
    if ($scope.config.streamStatus == "off") {
      cameraStatusNum = 1;
      setTimeout(function () {
        $scope.pauseBtn();
        $scope.timeline.updateCursor(new Date().valueOf());
      }, 500);
    } else {
      if ($scope.currentCamera.controlStatus === "CS" || $scope.currentCamera.controlStatus === "on") {
        if ($scope.currentCamera.recordType != "event") {
          if ($scope.currentCamera.streamStatus == "off") {
            cameraStatusNum = 2;
            cameraStatus = false;
            setTimeout(function () {
              $scope.pauseBtn();
              $scope.timeline.updateCursor(new Date().valueOf());
            }, 500);
          } else {
            cameraStatusNum = 0;
            cameraStatus = true;
          }
        }
      } else if ($scope.currentCamera.controlStatus === "CE" || $scope.currentCamera.controlStatus === "off") {
        if ($scope.currentCamera.streamStatus == "off") {
          cameraStatusNum = 4;
          cameraStatus = false;
          setTimeout(function () {
            $scope.pauseBtn();
            $scope.timeline.updateCursor(new Date().valueOf());
          }, 500);
        } else {
          cameraStatusNum = 0;
          cameraStatus = true;
        }
      }
    }
    $scope.cameraStatusChange(cameraStatusNum);
  };
  $scope.livePlayStart = function () {
    if ($scope.config.streamStatus != "off") {
      playControl.player.play();
    }
  };
  $scope.cameraUpagradeAlert = false;
  var loadCurrentCamera = function loadCurrentCamera() {
    var deferred = $q.defer();
    $(".display_show").css("display", "");
    Camera.get({
      id: $stateParams.cameraId
    }, function (res) {
      $scope.currentCamera = res;
      if (playerObj) {
        playerObj.setData("cameraData", $scope.currentCamera);
        $scope.currentCameraDataSet();
      }
      deferred.resolve();
    }, function (error) {
      deferred.reject();
    });
    return deferred.promise;
  };
  $scope.cameraStatusSet = function (clickStatus) {
    if (playerObj && playControl.getData("isLive") == true) {
      var cameraStatusNum = 0;
      if ($scope.config.streamStatus == "off") {
        cameraStatusNum = 1;
      } else {
        if ($scope.currentCamera) {
          if ($scope.currentCamera.controlStatus === "CS" || $scope.currentCamera.controlStatus === "on") {
            if ($scope.currentCamera.recordType != "event") {
              if ($scope.currentCamera.streamStatus == "off" && clickStatus != "setting") {
                if (Utils.isCloudExpired($scope.currentCamera)) {
                  cameraStatusNum = 0;
                } else {
                  cameraStatusNum = 2;
                }
              }
            }
          } else if ($scope.currentCamera.controlStatus === "CE" || $scope.currentCamera.controlStatus === "off") {
            if ($scope.currentCamera.streamStatus == "off") {
              cameraStatusNum = 4;
            } else {
              cameraStatusNum = 3;
            }
          }
        }
      }
      $scope.cameraStatusChange(cameraStatusNum);
    }
  };

  // 현재 화면에 호출된 카메라의 데이터 설정
  $scope.currentCameraDataSet = function () {
    if (playerObj) {
      playControl = playerObj.control;
      $scope.timeline = playControl.timeline;
      $scope.player = playControl.player;
    }
    $("#timebar_area").children("svg").width() / 2 - 75;
    setTimeout(function () {
      $("#timelinedesc").fadeIn(2000, function () {
        $("#timelinedesc").fadeOut(1000);
      });
    }, 500);
    if ($scope.currentCamera.code == "nok") {
      $scope.isNoCamera = true;
      return;
    }
    $scope.cameraName = $scope.currentCamera.labelName;
    if (Utils.isTurnOffCamera($scope.currentCamera)) {
      if ($scope.currentCamera.streamStatus !== "off") {
        Camera.isLastRecord({
          id: $stateParams.cameraId
        }, function (data) {
          if (playControl) {
            playControl.errorStatusLayer.currentCameraIsLastRecordDataSet(data);
          }
        });
      }
      $scope.isPlaying = false;
    } else {
      $scope.isPlaying = true;
    }
    playerObj.setData("isPlaying", $scope.isPlaying);
    if ($scope.currentCamera.streamStatus == "off" || $scope.currentCamera.controlStatus === "CE") {
      cameraOffCheck = setTimeout(function () {
        Camera.isLastRecord({
          id: $stateParams.cameraId
        }, function (data) {
          if (playControl) {
            playControl.errorStatusLayer.currentCameraIsLastRecordDataSet(data);
          }
        });
      }, 1050);
    }
    playerObj.setData("serviceDay", 0);
    $scope.cameraStatusSet();
  };
  $scope.formattedInternalDate = function (date) {
    var md,
      tz = $scope.timeline ? $scope.timeline.getData("timezone") : "";
    if (tz) {
      md = moment(new Date(date)).tz(tz);
    } else {
      md = moment(new Date(date));
    }
    return md.format("YYYYMMDD");
  };
  $scope.selectCamera = function (id) {
    $state.go("main.cameraDetail", {
      cameraId: id
    });
  };
  $scope.goCameraList = function () {
    $window.history.back();
    // $state.go('main.cameras');
  };
  $scope.stopTimer = function () {
    playControl.playTimer.stopTimer();
  };
  $scope.startLiveTimer = function () {
    playControl.playTimer.startLiveTimer(playControl.timeline);
  };
  $scope.goCvr = function (time, status) {
    $scope.timeline.requestPlay(time, status);
  };
  $scope.isTurnOffCamera = function () {
    return Utils.isTurnOffCamera($scope.currentCamera);
  };

  // Camera Setting
  $scope.config = {};
  $scope.loadCameraSetting = function (callback, clickStatus) {
    CameraConfig.get({
      id: $stateParams.cameraId
    }, function (data) {
      angular.extend($scope.config, data);
      if ($scope.config.resolution) {
        $scope.config.resolution = $scope.config.resolution.toUpperCase();
      }
      $("#cameraNameView").html($scope.config.name);
      $scope.cameraStatusSet(clickStatus);
      if ($scope.config.cameraSchedule != undefined) {
        $scope.config.parsedStartAt = Utils.configDateSeparate($scope.config.cameraSchedule.startAt);
        $scope.config.parsedStopAt = Utils.configDateSeparate($scope.config.cameraSchedule.stopAt);
        $scope.config.repeatOn = Utils.configRepeatOnSeparate($scope.config.cameraSchedule.repeatOn);
      }
      if ($scope.config.timezone != undefined) {
        $scope.config.tzCode = $scope.config.timezone.split(",")[0];
        $scope.tzCode = $scope.config.tzCode;
        $scope.config.tzDisplayName = $scope.config.timezone.split(",")[1] + $scope.config.timezone.split(",")[3];
      }
      if ($scope.config.usageRate > 100) {
        $scope.config.usageRate = 100;
      }
      if (playerObj) {
        playerObj.setData("cameraConfig", $scope.config);
      }
      if (typeof callback === "function") {
        callback();
      }
    }, function (err) {
      // error
      $state.go("main", {}, {
        reload: true
      });
    });
  };
  $scope.loadCameraSetting(function () {
    loadCurrentCamera().then(function () {
      playerObj = new tCam.player({
        elementIdMap: {
          root: "camdtl_wrap"
        },
        isShared: false,
        category: "b2b",
        playerType: "hls",
        country: $rootScope.me.country,
        cameraData: $scope.currentCamera,
        cameraConfig: $scope.config,
        playEventCb: playerEventHandler,
        playTime: 0,
        mute: true
      });
      $scope.currentCameraDataSet();
      $scope.cameraStatusSet();
      loadCameraList();
    });
  });
  $scope.getCameraConfig = function () {
    CameraConfig.get({
      id: $stateParams.cameraId
    }, function (data) {
      angular.extend($scope.config, data);
      $scope.config.tzCode = $scope.config.timezone.split(",")[0];
      $scope.tzCode = $scope.config.tzCode;
      if (playerObj) {
        playerObj.setData("cameraConfig", $scope.config);
      }
    });
  };
  $scope.requestLivePlay = function () {
    if (!playerObj || !playControl) {
      return;
    }
    if (playControl.getData("isLive") == false) {
      playerObj.requestPlay();
    }
  };
  $scope.setCameraData = function (data) {
    $scope.currentCamera = data;
    if (playerObj) {
      playerObj.setData("cameraData", $scope.currentCamera);
    }
  };
  $scope.updateCameraErrorStatus = function (status) {
    if (!playControl) {
      return;
    }
    if (status === "recoff") {
      playControl.errorStatusLayer.cameraRecOff();
    } else {
      playControl.errorStatusLayer.cameraStatusAllOff();
    }
  };
  $scope.hideRemoveCameraAlert = function () {
    $scope.showRemoveCameraAlert = false;
  };
  $scope.ImageExist = function (url) {
    var img = new Image();
    img.src = url;
    if (img.height == 0) {
      return false;
    } else {
      return true;
    }
  };
  $scope.$on("showAlert", function (event, data) {
    showAlert(data.title, data.msg);
  });
  $scope.cameraDataSet = function (data) {
    for (var i = 0; i < data.length; i++) {
      if (location.port != "") {
        data[i].thumbnailPath = location.protocol + "//" + data[i].thumbnailPath.replace(".com/", ".com:" + location.port + "/");
      } else {
        data[i].thumbnailPath = location.protocol + "//" + data[i].thumbnailPath;
      }
      if (data[i].streamStatus === "off" && data[i].controlStatus === "CS") {
        data[i].streamStatus = data[i].streamStatus === "on";
      }
      data[i].cameraViewState = 0;
      if (data[i].streamStatusConfig == "off") {
        data[i].cameraViewState = 1;
      } else {
        if (data[i].controlStatus == "on") {
          if (data[i].recordType != "event") {
            if (data[i].streamStatus == "off") {
              data[i].cameraViewState = 2;
            }
          }
        } else {
          if (data[i].streamStatus == "on") {
            data[i].cameraViewState = 3;
          } else {
            data[i].cameraViewState = 4;
          }
        }
      }
      data[i].number = i;
    }
    return data;
  };
  function loadCameraList() {
    var promiseCameras = Camera.getListV3().$promise;
    promiseCameras.then(function (res) {
      $scope.cameraList = [];
      if (res.cameras) {
        res.cameras.forEach(function (camObj) {
          if (camObj.camera.isAiSupport === 1 && camObj.camera.aiType === 2) {
            camObj.camera.thumbnailPath = "https://" + camObj.camera.thumbnailPath;
            $scope.cameraList.push(camObj.camera);
          }
        });
      }
      if (camListObj) {
        camListObj.destroy();
      }
      camListObj = tCam.camlist({
        elId: "camera_list_wrap",
        list: $scope.cameraList,
        focusId: $scope.currentCamera.id,
        eventHandler: function eventHandler(event) {
          if ($stateParams.cameraId === event.value.id) {
            return;
          }
          if ($scope.zoneArea.getIsDrawing()) {
            showNotCompleteConfirm(false, function () {
              $scope.changeCamera(event.value.id);
            });
          } else {
            $scope.changeCamera(event.value.id);
          }
        }
      });
    }, function (err) {
      showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
    });
  }
  $scope.changeCamera = function (cameraId) {
    if ($scope.currentCamera.id === cameraId) return;
    notiDelete();
    if (camListObj) {
      if (camListObj.focusId !== cameraId) {
        camListObj.focusId = cameraId;
      }
    }
    $("#player").show();
    $("#remote_stream").hide();
    $("#connectIframe").attr("src", "");
    $state.go("main.aifaceZoneSet", {
      cameraId: cameraId
    }, {
      notify: false
    });
    $stateParams.cameraId = cameraId;
    changeData();
  };

  /**
   * 카메라 변경 데이터 처리
   */
  function changeData() {
    initAiZoneData();
    $scope.loadCameraSetting(function () {
      loadCurrentCamera().then(function () {
        if (playerObj) {
          playerObj.reloadPlayer();
        }
        $scope.currentCameraDataSet();
        $scope.cameraStatusSet();
        if (playControl && playControl.timeline) {
          playControl.timeline.clickedCVRArea(null);
        }
        if (deleteZones) {
          deleteZones();
        }
        if (showZones) {
          setTimeout(function () {
            showZones();
          }, 100);
        }
      });
    });
  }
  $timeout(function () {
    $scope.isLoadOff = true;
  }, 500);
}]);
"use strict";

var drawing = false,
  dragging = false,
  zoneWidth,
  zoneHeight;
var AifaceZoneArea = function AifaceZoneArea(id) {
  this.canvas = document.getElementById(id);
  zoneWidth = parseInt(this.canvas.style.width);
  zoneHeight = parseInt(this.canvas.style.height);
  this.svg = d3.select(this.canvas).append('svg').attr('width', '100%').attr('height', '100%').attr('class', 'zone_set_svg');
  dragging = false;
  drawing = false;
  this.startPoint = null;
  this.handler = null;
  this.points = [];
  this.polyG = null;
  this.zones = [];
  this.currentColor = null;
  this.init();
};
AifaceZoneArea.prototype.setEventHandler = function (handler) {
  this.handler = handler;
};
AifaceZoneArea.prototype.getIsDrawing = function () {
  return drawing;
};
AifaceZoneArea.prototype.makeZoneId = function () {
  var text = "";
  var possible = "0123456789";
  for (var i = 0; i < 13; i++) text += possible.charAt(Math.floor(Math.random() * possible.length));
  return text;
};
AifaceZoneArea.prototype.draw = function () {
  var i, len;
  $(".zone_set_svg").empty();
  for (i in this.zones) {
    var zone = this.zones[i];
    zone.draw(this.svg);
  }
  if (this.points && this.points.length && this.currentColor) {
    if (d3.select('g.drawPloy').empty()) {
      this.polyG = this.svg.append('g').attr('class', 'drawPoly');
    }
    this.polyG.select('polyline').remove();
    var polyline = this.polyG.append('polyline').attr('points', this.points).style('fill', 'none').attr('stroke', this.currentColor).attr('stroke-width', '2px');
    len = this.points.length;
    for (i = 0; i < len; i += 1) {
      this.polyG.append('circle').attr('cx', this.points[i][0]).attr('cy', this.points[i][1]).attr('r', 6).attr('fill', this.currentColor).attr('is-handle', 'true').style({
        cursor: 'pointer'
      });
    }
  }
};
AifaceZoneArea.prototype.getZonesData = function () {
  var i,
    len,
    arr = [];
  len = this.zones.length;
  for (i = 0; i < len; i += 1) {
    arr.push({
      coordinate: this.serverDataFromCoordinate(this.zones[i].paths),
      color: this.zones[i].color,
      id: '' + this.zones[i].id,
      uid: '' + this.zones[i].uid,
      zoneIndex: '' + this.zones[i].zoneIndex,
      labelName: this.zones[i].labelName,
      status: 'on',
      filterMark: 'on'
    });
  }
  return arr;
};
AifaceZoneArea.prototype.modifyHandler = function (event) {
  if (this.handler) {
    this.handler({
      name: 'modify',
      zone: {
        coordinate: this.serverDataFromCoordinate(event.paths),
        zoneIndex: event.zoneIndex
      }
    });
  }
};
AifaceZoneArea.prototype.setZonesData = function (data, modifyMode) {
  var zones = [];
  this.modifyMode = modifyMode;
  for (var i in data) {
    var zoneData = data[i];
    var coordinate = zoneData.coordinate;
    if (coordinate !== undefined) {
      var coordinates = this.coordinateFromServerData(coordinate);
      var zone = AifaceZone.newZone(zoneData.id, zoneData.uid, zoneData.zoneIndex, coordinates, zoneData.color, zoneData.label, modifyMode, this.modifyHandler.bind(this));
      zones.push(zone);
    }
  }
  this.zones = zones;
  this.draw();
};
AifaceZoneArea.prototype.setCanvasSize = function (width, height) {
  var serverData = this.getZonesData();
  this.canvas.width = zoneWidth = parseInt(width);
  this.canvas.height = zoneHeight = parseInt(height);
  this.setZonesData(serverData, this.modifyMode);
};
AifaceZoneArea.prototype.resetDrawing = function () {
  this.currentColor = null;
  this.points = [];
};
AifaceZoneArea.prototype.removeZone = function (zoneIndex) {
  var i,
    len = this.zones.length;
  for (i = 0; i < len; i += 1) {
    if (this.zones && this.zones[i].zoneIndex == zoneIndex) {
      this.zones.splice(i, 1);
      this.draw();
      break;
    }
  }
  if (this.handler) {
    this.handler({
      name: 'remove',
      zone: {
        zoneIndex: zoneIndex
      }
    });
  }
};
AifaceZoneArea.prototype.init = function () {
  var that = this;
  d3.select(that.canvas).on('mouseup', function () {
    if (dragging || that.modifyMode) {
      return;
    }
    if (d3.event.target.hasAttribute('area_delete_btn')) {
      that.removeZone(d3.event.target.getAttribute('zoned_index'));
      return;
    }
    if (that.zones.length >= 4) {
      if (that.handler) {
        that.handler({
          name: 'full'
        });
      }
      return;
    }
    if (!that.currentColor) {
      that.currentColor = that.getColor();
    }
    drawing = true;
    if (that.handler) {
      that.handler({
        name: 'drawing_change',
        drawing: drawing
      });
    }
    that.startPoint = [d3.mouse(this)[0], d3.mouse(this)[1]];
    if (d3.select('g.drawPloy').empty()) {
      that.polyG = that.svg.append('g').attr('class', 'drawPoly');
    }
    if (d3.event.target.hasAttribute('is-handle')) {
      that.closePolygon();
      return;
    }
    that.points.push(d3.mouse(this));
    that.polyG.select('polyline').remove();
    var polyline = that.polyG.append('polyline').attr('points', that.points).style('fill', 'none').attr('stroke', that.currentColor).attr('stroke-width', '2px');
    var i,
      len = that.points.length;
    for (i = 0; i < len; i += 1) {
      that.polyG.append('circle').attr('cx', that.points[i][0]).attr('cy', that.points[i][1]).attr('r', 6).attr('fill', that.currentColor).attr('is-handle', 'true').style({
        cursor: 'pointer'
      });
    }
    if (that.points.length >= 16) {
      that.closePolygon();
    }
  });
  d3.select(this.canvas).on('mousedown', function () {});
};
AifaceZoneArea.prototype.getEmptyZoneId = function () {
  var i,
    len = this.zones.length,
    zoneId = this.zones.length + 1;
  for (i = 0; i < len; i += 1) {
    if (this.zones[i].id == zoneId) {
      zoneId += 1;
    }
  }
  return zoneId;
};
AifaceZoneArea.prototype.closePolygon = function () {
  var that = this;
  $('.drawPoly').remove();
  if (!that.points || that.points.length <= 2) {
    that.currentColor = null;
    that.points = [];
    drawing = false;
    if (this.handler) {
      this.handler({
        name: 'drawing_change',
        drawing: drawing
      });
    }
    return;
  }
  var newZone = AifaceZone.newZone('', '', '', that.points, that.currentColor, '', this.modifyMode, this.modifyHandler.bind(this));
  newZone.draw(this.svg);
  that.zones.push(newZone);
  that.currentColor = null;
  that.points = [];
  drawing = false;
  if (this.handler) {
    this.handler({
      name: 'drawing_change',
      drawing: drawing
    });
    this.handler({
      name: 'add',
      zone: {
        coordinate: this.serverDataFromCoordinate(newZone.paths),
        color: newZone.color
      }
    });
  }
};
AifaceZoneArea.prototype.getColor = function () {
  var minUseCount = -1,
    useColorMap = {},
    minUsedColors = [];
  this.zones.forEach(function (zone) {
    var upperColor = zone.color.toUpperCase();
    if (useColorMap[upperColor]) {
      useColorMap[upperColor] += 1;
    } else {
      useColorMap[upperColor] = 1;
    }
  });
  var colorArr = [{
    color: '#FF7900',
    useCount: 0
  }, {
    color: '#59A1D6',
    useCount: 0
  }, {
    color: '#EFD600',
    useCount: 0
  }, {
    color: '#91C90C',
    useCount: 0
  }];
  colorArr.forEach(function (colorObj) {
    colorObj.useCount = useColorMap[colorObj.color] ? useColorMap[colorObj.color] : 0;
    if (minUseCount === -1) {
      minUseCount = colorObj.useCount;
      minUsedColors.push(colorObj.color);
    } else {
      if (minUseCount === colorObj.useCount) {
        minUsedColors.push(colorObj.color);
      } else if (minUseCount > colorObj.useCount) {
        minUseCount = colorObj.useCount;
        minUsedColors = [];
        minUsedColors.push(colorObj.color);
      }
    }
  });
  return minUsedColors[0];
};
AifaceZoneArea.prototype.coordinateFromServerData = function (data) {
  var i,
    len,
    that = this,
    arr = [],
    cacheArr = [];
  var parsed = data.split(',').map(function (i) {
    return parseInt(i);
  });
  len = parsed.length;
  for (i = 0; i < len; i += 1) {
    if (i % 2 === 1) {
      cacheArr.push(zoneHeight * parsed[i] / 1000);
    } else {
      cacheArr.push(zoneWidth * parsed[i] / 1000);
    }
    if (cacheArr.length === 2) {
      arr.push(cacheArr);
      cacheArr = [];
    }
  }
  return arr;
};
AifaceZoneArea.prototype.serverDataFromCoordinate = function (data) {
  var i,
    len,
    tempArr = [],
    arr = [];
  if (!data) {
    return '';
  }
  len = data.length;
  for (i = 0; i < len; i += 1) {
    tempArr = tempArr.concat(data[i]);
  }
  len = tempArr.length;
  for (i = 0; i < len; i += 1) {
    if (i % 2 === 1) {
      arr.push(parseInt(1000 * tempArr[i] / zoneHeight));
    } else {
      arr.push(parseInt(1000 * tempArr[i] / zoneWidth));
    }
  }
  return arr.join(',');
};
var AifaceZone = function AifaceZone(id, uid, zoneIndex, paths, color, label, modifyMode, modifyCallback) {
  this.id = id;
  this.uid = uid;
  this.zoneIndex = zoneIndex;
  this.paths = paths;
  this.color = color;
  this.labelName = label;
  this.modifyMode = modifyMode;
  if (this.modifyMode) {
    this.modifyCallback = modifyCallback;
  }
  this.dragger = d3.behavior.drag().on('drag', this.handleDrag).on('dragend', this.handleDragEnd.bind(this));
  this.polyDragger = d3.behavior.drag().on('drag', this.handlePolyDrag).on('dragend', this.handlePolyDragEnd.bind(this));
};
AifaceZone.newZone = function (id, uid, zoneIndex, datas, color, label, modifyMode, modifyCallback) {
  //[123, 34, 45, 33], id, color
  return new AifaceZone(id, uid, zoneIndex, datas, color, label, modifyMode, modifyCallback);
};
AifaceZone.prototype.handlePolyDrag = function () {
  if (drawing) return;
  var i,
    len,
    newPoints = [],
    circle,
    circleX,
    circleY;
  dragging = true;
  var poly = d3.select(this.parentNode).select('polygon');
  var polyline = d3.select(this.parentNode).select('polyline');
  var circles = d3.select(this.parentNode).selectAll('circle');
  for (i = 0, len = circles[0].length; i < len; i++) {
    circle = d3.select(circles[0][i]);
    circleX = parseInt(circle.attr('cx')) + d3.event.dx;
    circleY = parseInt(circle.attr('cy')) + d3.event.dy;
    if (circleX <= 0 || circleX >= zoneWidth || circleY <= 0 || circleY >= zoneHeight) {
      return;
    }
  }
  for (i = 0, len = circles[0].length; i < len; i++) {
    circle = d3.select(circles[0][i]);
    circle.attr('cx', parseInt(circle.attr('cx')) + d3.event.dx).attr('cy', parseInt(circle.attr('cy')) + d3.event.dy);
    newPoints.push([circle.attr('cx'), circle.attr('cy')]);
  }
  poly.attr('points', newPoints);
  polyline.attr('points', newPoints.concat([newPoints[0]]));
};
AifaceZone.prototype.handlePolyDragEnd = function () {
  dragging = false;
  var circles = d3.select('.poly_wrap_' + this.zoneIndex).selectAll('circle');
  for (var i = 0; i < circles[0].length; i++) {
    if ('circle_' + i === circles[0][i].className.baseVal) {
      this.paths[i][0] = circles[0][i].cx.baseVal.value;
      this.paths[i][1] = circles[0][i].cy.baseVal.value;
    }
  }
  $('.poly_wrap_' + this.zoneIndex).remove();
  if (this.svg) {
    this.createPath(this.svg);
  }
  if (this.modifyCallback) {
    this.modifyCallback({
      event: 'modify',
      paths: this.paths,
      zoneIndex: this.zoneIndex
    });
  }
};
AifaceZone.prototype.handleDragEnd = function () {
  dragging = false;
  var i,
    len = this.paths.length;
  for (i = 0; i < len; i += 1) {
    if (d3.event.sourceEvent.target.cx && d3.event.sourceEvent.target.cy) {
      if ('circle_' + i === d3.event.sourceEvent.target.className.baseVal) {
        this.paths[i][0] = parseInt(d3.event.sourceEvent.target.cx.baseVal.value);
        this.paths[i][1] = parseInt(d3.event.sourceEvent.target.cy.baseVal.value);
        break;
      }
    }
  }
  $('.poly_wrap_' + this.zoneIndex).remove();
  if (this.svg) {
    this.createPath(this.svg);
  }
  if (this.modifyCallback) {
    this.modifyCallback({
      event: 'modify',
      paths: this.paths,
      zoneIndex: this.zoneIndex
    });
  }
};
AifaceZone.prototype.handleDrag = function () {
  if (drawing) {
    return;
  }
  if (d3.event.x <= 0 || d3.event.x >= zoneWidth || d3.event.y <= 0 || d3.event.y >= zoneHeight) {
    return;
  }
  var dragCircle = d3.select(this),
    newPoints = [],
    circle;
  dragging = true;
  var poly = d3.select(this.parentNode).select('polygon');
  var polyline = d3.select(this.parentNode).select('polyline');
  var circles = d3.select(this.parentNode).selectAll('circle');
  dragCircle.attr('cx', d3.event.x).attr('cy', d3.event.y);
  for (var i = 0; i < circles[0].length; i++) {
    circle = d3.select(circles[0][i]);
    newPoints.push([circle.attr('cx'), circle.attr('cy')]);
  }
  poly.attr('points', newPoints);
  polyline.attr('points', newPoints.concat([newPoints[0]]));
};
AifaceZone.prototype.createPath = function (svg) {
  var that = this;
  var g = svg.append('g').attr('class', 'poly_wrap_' + that.zoneIndex);
  var polygon = g.append('polygon').attr('points', that.paths).attr("stroke", "black").text(function (d) {
    return that.zoneIndex;
  }).style('fill', that.color).style('opacity', 0.5);
  if (that.modifyMode) {
    polygon.call(that.polyDragger);
  }
  var polyline = g.append('polyline').attr('points', that.paths.concat([that.paths[0]])).style('fill', 'none').attr('stroke', that.color).attr('stroke-width', '2px');
  if (that.modifyMode) {
    polyline.call(that.polyDragger);
  }
  var i,
    len = that.paths.length;
  for (i = 0; i < len; i += 1) {
    if (that.modifyMode) {
      var circle = g.selectAll('circles').data([that.paths[i]]).enter().append('circle').attr('cx', that.paths[i][0]).attr('cy', that.paths[i][1]).attr('r', 6).attr('fill', that.color).attr('stroke', that.color).attr('is-handle', 'true').attr({
        cursor: 'move'
      }).attr('class', 'circle_' + i).call(that.dragger);
    }
    if (i === 0 && !that.modifyMode) {
      g.append('svg:image').attr({
        x: that.paths[i][0] - 14,
        y: that.paths[i][1] - 14,
        width: 28,
        height: 28,
        "class": function _class(d) {
          return "area_delete_btn";
        }
      }).attr("xlink:href", function (d) {
        return "/resources/img/btn-zone-delete.svg";
      }).attr('area_delete_btn', 'true').attr('zoned_index', that.zoneIndex);
    }
  }
};
AifaceZone.prototype.draw = function (svg) {
  this.svg = svg;
  this.createPath(svg);
};
AifaceZone.prototype.coordinate = function () {
  var x = parseInt(this.paths[0][0]);
  var y = parseInt(this.paths[0][1]);
  var width = parseInt(this.paths[1][0] - x);
  var height = parseInt(this.paths[3][1] - y);
  return [x, y, width, height];
};
"use strict";

app.controller("AudioChat", ["$scope", "$rootScope", "$translate", "$q", "$timeout", "$stateParams", "$window", "Camera", "AudioChat", "Utils", function ($scope, $rootScope, $translate, $q, $timeout, $stateParams, $window, Camera, AudioChat, Utils) {
  var audioChatTime = 0;
  var intervalId = null;
  var chatTimeIntervalId = null;
  var connectionTime = 0;
  var AUDIO_CHAT_STATUS = {
    CONNECTING: "connecting",
    FAIL: "fail",
    ONGOING: "ongoing"
  };
  var playerObj = null;
  $scope.showUpperAlertMsg = false;
  $scope.labelName = "";
  $scope.isMute = false;
  $scope.isShowVideo = true;
  $scope.notSupportAudioChat = false;
  $scope.upperAlertMsg = "";
  $scope.connectingStr = $translate.instant("AUDIOCHAT_CONNECTING") + "...";
  $scope.audioChatTime = "00:00";
  $scope.audioChatStatus = AUDIO_CHAT_STATUS.CONNECTING;
  if ($rootScope.me && $rootScope.me.country === "JP") {
    $("#connectIframe").attr("src", controlServerJpUrl + "/rtcapp.html");
  } else {
    $("#connectIframe").attr("src", controlServerUrl + "/rtcapp.html");
  }
  $scope.$on("$destroy", function () {
    if (playerObj) {
      playerObj.destroy();
      playerObj = null;
    }
    if (intervalId) {
      clearInterval(intervalId);
    }
    if (chatTimeIntervalId) {
      clearInterval(chatTimeIntervalId);
    }
    AudioChat.audioChatStop($stateParams.cameraId);
  });
  var audioChatTimer = function audioChatTimer() {
    var minutes = 0,
      seconds = 0,
      secondStr;
    audioChatTime += 1;
    seconds = audioChatTime % 60;
    minutes = parseInt(audioChatTime / 60, 10);
    if (seconds < 10) {
      secondStr = "0" + seconds;
    } else {
      secondStr = "" + seconds;
    }
    if (minutes < 10) {
      minutes = "0" + minutes;
    } else {
      minutes = "" + minutes;
    }
    $scope.audioChatTime = minutes + ":" + secondStr;
    $scope.$apply();
  };
  var showAlert = function showAlert(title, message) {
    $scope.showAlert = true;
    $scope.alertTitle = title;
    $scope.alertMessage = message;
  };
  $scope.hideAlert = function () {
    $scope.showAlert = false;
  };

  //audio chat event
  $scope.$on(AudioChat.EVENT_STREAM_CONNECTED, function (event, data) {
    $scope.audioChatStatus = AUDIO_CHAT_STATUS.ONGOING;
    $scope.showUpperAlertMsg = false;
    $(".audiochat_center_txt3").hide();
    $(".audiochat_center_txt1").show();
    if (intervalId) {
      clearInterval(intervalId);
    }
    if (chatTimeIntervalId) {
      clearInterval(chatTimeIntervalId);
    }
    audioChatTime = 0;
    chatTimeIntervalId = setInterval(audioChatTimer, 1000);
  });
  $scope.$on(AudioChat.EVENT_STREAM_DISCONNECTED, function (event, data) {
    $scope.audioChatStatus = AUDIO_CHAT_STATUS.FAIL;
    if (intervalId) {
      clearInterval(intervalId);
    }
    if (chatTimeIntervalId) {
      clearInterval(chatTimeIntervalId);
    }
    AudioChat.audioChatStop($stateParams.cameraId);
    if (data.code == -3) {
      $scope.showUpperAlertMsg = true;
      $scope.upperAlertMsg = $translate.instant("AUDIOCHAT_ALREADY");
      showAlert($translate.instant("AUDIOCHAT_CON_FAIL"), $translate.instant("AUDIOCHAT_ALREADY") + "<br>" + $translate.instant("AUDIOCHAT_LATER"));
    } else if (data.code == -1) {
      showAlert($translate.instant("AUDIOCHAT_CON_FAIL"), $translate.instant("AUDIOCHAT_CONFIRM_CAM"));
    } else if (data.code == -2) {
      showAlert($translate.instant("AUDIOCHAT_CON_FAIL"), $translate.instant("AUDIOCHAT_CONFIRM_CAM"));
    } else if (data.code == -5) {
      $scope.showUpperAlertMsg = true;
      $scope.upperAlertMsg = $translate.instant("AUDIOCHAT_MICE_OFF");
      showAlert($translate.instant("MIC_OFF"), $translate.instant("AUDIOCHAT_MICE_OFF"));
    } else if (data.code == -6) {
      showAlert($translate.instant("AUDIOCHAT_CON_FAIL"), $translate.instant("AUDIOCHAT_CONFIRM_CAM"));
    } else if (data.code == "disconnect") {
      showAlert($translate.instant("AUDIOCHAT_CON_DISCON"), $translate.instant("AUDIOCHAT_CONFIRM_CAM"));
    } else if (data.code == "nomike") {
      showAlert($translate.instant("AUDIOCHAT_CON_FAIL"), $translate.instant("AUDIOCHAT_NO_MIKE"));
    }
    $(".audiochat_center_txt1").hide();
    $(".audiochat_center_txt3").show();
    if (data.code == "disconnect") {
      $scope.connectingStr = $translate.instant("AUDIOCHAT_CON_DISCON");
    } else {
      $scope.connectingStr = $translate.instant("AUDIOCHAT_CON_FAIL");
    }
    $scope.$apply();
  });
  $scope.audioChatStart = function () {
    $scope.audioChatStatus = AUDIO_CHAT_STATUS.CONNECTING;
    AudioChat.audioChatStart($stateParams.cameraId);
    if (intervalId) {
      clearInterval(intervalId);
    }
    if (chatTimeIntervalId) {
      clearInterval(chatTimeIntervalId);
    }
    $scope.connectingStr = $translate.instant("AUDIOCHAT_CONNECTING");
    connectionTime = 0;
    intervalId = setInterval(function () {
      if ($scope.connectingStr === $translate.instant("AUDIOCHAT_CONNECTING") + "...") {
        $scope.connectingStr = $translate.instant("AUDIOCHAT_CONNECTING");
      } else {
        $scope.connectingStr = $scope.connectingStr + ".";
      }
      $scope.$apply();
      connectionTime += 1;
      if (connectionTime > 10) {
        if (intervalId) {
          clearInterval(intervalId);
        }
        $scope.audioChatStatus = AUDIO_CHAT_STATUS.FAIL;
        AudioChat.audioChatStop($stateParams.cameraId);
        $(".audiochat_center_txt1").hide();
        $(".audiochat_center_txt3").show();
        $scope.connectingStr = $translate.instant("AUDIOCHAT_CON_FAIL");
        $scope.$apply();
      }
    }, 1000);
  };
  $scope.audioChatStop = function () {
    if (intervalId) {
      clearInterval(intervalId);
    }
    if (chatTimeIntervalId) {
      clearInterval(chatTimeIntervalId);
    }
    audioChatTime = 0;
    AudioChat.audioChatStop($stateParams.cameraId);
    $window.history.back();
  };
  $scope.retryAudioChat = function () {
    AudioChat.audioChatStop($stateParams.cameraId);
    $scope.audioChatStart();
  };
  $scope.livePlayStart = function (mediaUrl) {
    var tokenPromise = {};
    tokenPromise = Camera.getToken({
      id: $stateParams.cameraId
    }).$promise;
    $q.all([tokenPromise]).then(function (data) {
      $scope.token = data[0];
      $timeout(function () {
        $scope.player.control.setPath(mediaUrl, $scope.currentCamera.id + "?token=" + $scope.token.token);
      }, 1000);
    });
  };
  $scope.chromeDownload = function () {
    window.open("https://www.google.com/chrome/browser/desktop/index.html", "popup", "width=800px,height=600px");
  };
  $scope.currentCamera = Camera.get({
    id: $stateParams.cameraId
  }, function () {
    //$scope.player.control.play();
    $timeout(function () {
      var _$rootScope$me;
      $scope.labelName = $scope.currentCamera.labelName;
      playerObj = new tCam.player({
        elementIdMap: {
          root: "playerAudioChat"
        },
        shopId: $rootScope.cameraShopId,
        isShared: false,
        category: "b2b",
        playerType: "hls",
        mute: true,
        cameraData: $scope.currentCamera,
        country: $rootScope === null || $rootScope === void 0 ? void 0 : (_$rootScope$me = $rootScope.me) === null || _$rootScope$me === void 0 ? void 0 : _$rootScope$me.country,
        cameraConfig: {
          streamStatus: "on",
          controlStatus: "on",
          timezone: "268,아시아/서울,Asia/Seoul,+09:00"
        },
        playEventCb: function playEventCb(e) {},
        playTime: 0
      });
      if (Utils.isIE() || Utils.isSafari() && navigator.userAgent.indexOf("Version/11") == -1) {
        $(".audiochat_center_txt3").hide();
        $scope.notSupportAudioChat = true;
      } else {
        $scope.notSupportAudioChat = false;
        $scope.audioChatStart();
      }
    }, 1000);
  });
}]);
"use strict";

app.controller("CameraListCtrl", ["$scope", "Camera", "$state", "$translate", "Shop", "$location", "NgUtils", "Utils", function ($scope, Camera, $state, $translate, Shop, $location, NgUtils, Utils) {
  showPage2();
  var shopList = [];
  $scope.location = $location;
  $scope.shareList = false;
  $scope.isLoadCams = false;
  $scope.totalCount = 0;
  $scope.searchFlag = false;
  $scope.myCameraSharePopup = false;
  $scope.isCameraSettingOpen = false;
  $scope.currentCamera = {};
  $scope.isCameraSettingLoading = false;
  $scope.getContextPath = Utils.getContextPath();
  $scope.pagingUtil = NgUtils.pagingUtil();
  $(window).scroll(function () {
    if (navigator.userAgent.indexOf("MSIE") !== -1 || navigator.appVersion.indexOf("Trident/") > 0) {
      $("#myCameraSharePopup").css("top", parseInt(document.documentElement.scrollTop + 200));
      $("#showShareRemoveCameraAlert").css("top", parseInt(document.documentElement.scrollTop + 200));
      $("#showShareAddCameraAlert").css("top", parseInt(document.documentElement.scrollTop + 200));
    } else {
      $("#myCameraSharePopup").css("top", parseInt(window.scrollY + 200));
      $("#showShareRemoveCameraAlert").css("top", parseInt(window.scrollY + 200));
      $("#showShareAddCameraAlert").css("top", parseInt(window.scrollY + 200));
    }
  });
  $("body").scrollTop(0);
  Shop.dashboardShops().$promise.then(function (res) {
    shopList = res.shops && res.shops.length ? res.shops : [];
  });
  var showAlert = function showAlert(title, message) {
    $scope.showAlert = true;
    $scope.alertTitle = title;
    $scope.alertMessage = message;
  };
  $scope.searchParam = Object.assign({
    keyword: "",
    pageNumber: "1",
    count: "16",
    sortKey: "labelName",
    sortOrder: "asc",
    searchType: "1"
  }, $scope.sorting);
  $scope.filterOptionClick = function ($event, param) {
    var divTag = document.getElementsByClassName("selectBox_Camera")[0];
    var buttonTag = divTag.getElementsByTagName("button")[0];
    buttonTag.textContent = $event.target.textContent;
    $scope.ulTagController();
    $scope.changeSorting(param);
  };
  $scope.ulTagController = function (flag) {
    var divTag = document.getElementsByClassName("selectBox_Camera")[0];

    // 변수없음
    if (flag == undefined) {
      divTag.classList.toggle("active");
    }
    if (flag == true || flag == false) {
      if (flag == true) {
        divTag.classList.add("active");
      } else {
        divTag.classList.remove("active");
      }
    }
  };
  $scope.changeSorting = function (param) {
    var searchType = {
      1: ["labelName", "asc"],
      2: ["labelName", "desc"],
      3: ["firstConnectDate", "desc"],
      4: ["firstConnectDate", "asc"]
    };
    var type = param || $scope.searchParam.searchType;
    var typeArr = searchType[type];
    var sortKey = typeArr[0];
    var sortOrder = typeArr[1];
    $scope.searchParam = Object.assign($scope.searchParam, {
      sortKey: sortKey,
      sortOrder: sortOrder
    });
    $scope.search();
  };
  $scope.keydownEvent = function ($event) {
    if ($event.key == "\\") {
      $event.preventDefault();
      return false;
    }
    if ($event.key == "Enter") {
      $scope.pagingUtil.init();
      $scope.search({
        event: true,
        totalCount: true
      });
    }
  };
  $scope.clickInput = function (event) {
    var inputTagOffsetHeight = event.target.offsetHeight;
    var inputTagOffsetWidth = event.target.offsetWidth;
    var clickEventOffsetHeight = event.offsetY;
    var clickEventOffsetWidth = event.offsetX;
    var paddingRight = Number(document.defaultView.getComputedStyle(event.target).getPropertyValue("padding-right").replace("px", ""));
    var innerY = 5 <= clickEventOffsetHeight && clickEventOffsetHeight <= inputTagOffsetHeight - 5;
    var innerX = inputTagOffsetWidth - paddingRight <= clickEventOffsetWidth && clickEventOffsetWidth <= inputTagOffsetWidth;
    if (innerX && innerY) {
      $scope.pagingUtil.init();
      $scope.search({
        event: true,
        totalCount: true
      });
    }
  };
  $scope.search = function (searchOption) {
    $scope.searchParam.pageNumber = $scope.pagingUtil.pageNumber();
    if (searchOption && searchOption.totalCount !== undefined) {
      $scope.searchParam.totalCount = searchOption.totalCount;
    }
    $scope.isLoadCams = false;
    $scope.getCameraList($scope.searchParam);
    if (searchOption && searchOption.event) {
      $scope.searchFlag = searchOption.event;
    }
  };
  $scope.getCameraList = function (searchParam) {
    $(".display_show").css("display", "");
    $scope.isLoadCams = true;
    Camera.getListV4(searchParam, function (data) {
      if (data.totalCount !== undefined) {
        $scope.pagingUtil.setTotalCount(data.totalCount);
        $scope.totalCount = data.totalCount;
      }
      $scope.pagingUtil.setCallBackFunc(function () {
        return $scope.search({
          totalCount: true
        });
      });
      $.each(data.cameras, function (i, node) {
        var camera = node.camera;
        var serviceType = camera.serviceType;
        var recordType = camera.recordType;
        var recorderType = camera.recorderType;
        if (serviceType == "0d" && recordType == "na" && recorderType == "cvr") {
          camera.thumbnailPath = location.hostname + "/resources/img/img_camera_blackout.svg";
          camera.addServiceType = "black";
        } else if (recorderType == "0d" && recordType == "live" && recorderType == "cvr") {
          //live
          camera.addServiceType = "live";
        } else if (recorderType != "0d" && recordType == "event" && recorderType == "cvr") {
          //event
          camera.addServiceType = "event";
        } else if (recorderType != "0d" && recordType == "24h" && recorderType == "cvr") {
          //24h
          camera.addServiceType = "24h";
        } else {
          camera.addServiceType = "else";
        }
      });
      $scope.cameras = data.cameras ? $scope.cameraDataSet(data.cameras) : [];
      $scope.isLoadCams = false;
      setTimeout(function () {
        $(".all_cam_lazy").Lazy({
          scrollDirection: "vertical",
          visibleOnly: true,
          onError: function onError(element) {
            element.attr("src", "/resources/img/img_camera_fail.svg");
          }
        });
      }, 100);
    }, function (err) {
      $scope.isLoadCams = false;
      showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
    });
  };
  function toggleToBodyEvent($event) {
    var divTag = document.getElementsByClassName("selectBox_Camera")[0];
    var buttonTag = divTag.getElementsByTagName("button")[0];
    if (buttonTag !== $event.target) {
      $scope.ulTagController(false);
    }
  }

  // 다른곳 클릭했을때 토글이벤트 작동
  document.getElementsByTagName("body")[0].addEventListener("click", toggleToBodyEvent);

  // 페이지 이동 전 이벤트 해제
  $scope.$on("$destroy", function () {
    document.getElementsByTagName("body")[0].removeEventListener("click", toggleToBodyEvent);
  });
  $scope.cameras = [];
  $scope.shareCameras = [];
  $scope.shareMyCameras = [];
  $scope.cameraDataSet = function (data) {
    for (var i = 0; i < data.length; i++) {
      if (data[i].camera) {
        //#2016-09-02 NVR 카메라 thumbname인 경우 무조건 http로 설정한다.
        if (data[i].camera.recorderType == "nvr") {
          data[i].camera.thumbnailPath = "http://" + data[i].camera.thumbnailPath;
        } else {
          if (location.port != "") {
            data[i].camera.thumbnailPath = location.protocol + "//" + data[i].camera.thumbnailPath.replace(".com/", ".com:" + location.port + "/");
          } else {
            data[i].camera.thumbnailPath = location.protocol + "//" + data[i].camera.thumbnailPath;
          }
        }
        if (data[i].camera.streamStatus === "off" && data[i].camera.controlStatus === "CS") {
          data[i].camera.streamStatus = data[i].camera.streamStatus === "on";
        }
        data[i].camera.cameraViewState = 0;
        data[i].camera.cameraOff = "";
        if (data[i].camera.streamStatusConfig == "off") {
          data[i].camera.cameraViewState = 1;
          data[i].camera.cameraOff = "off";
        } else {
          if (data[i].camera.recordType != "event") {
            if (data[i].camera.controlStatus == "on") {
              if (data[i].camera.streamStatus == "off" && !Utils.isCloudExpired(data[i].camera)) {
                data[i].camera.cameraViewState = 2;
                data[i].camera.cameraOff = "off";
              } else if (data[i].camera.streamStatus == null) {
                data[i].camera.cameraViewState = 4;
                data[i].camera.cameraOff = "off";
              }
            } else {
              data[i].camera.cameraViewState = 4;
              data[i].camera.cameraOff = "off";
            }
          }
        }
      }
    }
    return data;
  };
  $scope.getCameraList($scope.searchParam);
  function findShopId(cameraId) {
    var i, j, shopLen, camLen;
    for (i = 0, shopLen = shopList.length; i < shopLen; i += 1) {
      for (j = 0, camLen = shopList[i].cameraIds.length; j < camLen; j += 1) {
        if (cameraId === shopList[i].cameraIds[j]) {
          return shopList[i].shopId;
        }
      }
    }
    return "";
  }
  $scope.goDetail = function (id) {
    var trident = navigator.userAgent.match(/Trident\/(\d)/i);
    if (trident != null) {
      document.documentElement.scrollTop = 0;
    } else {
      $("body").scrollTop(0);
    }
    $("#wrap").hide();
    var shopId = findShopId(id);
    $state.go("main.cameraDetail", {
      cameraId: id,
      type: "camera",
      shopId: shopId
    });
  };
  $scope.goShare = function (cameraId, groupId) {
    var trident = navigator.userAgent.match(/Trident\/(\d)/i);
    if (trident != null) {
      document.documentElement.scrollTop = 0;
    } else {
      $("body").scrollTop(0);
    }
    $state.go("main.cameraDetail", {
      cameraId: cameraId,
      id: groupId,
      type: "sharedgroup",
      shared: true
    });
  };
  $scope.settingOpenCallback = function (_ref) {
    var isOpen = _ref.isOpen,
      cameraData = _ref.cameraData,
      isShared = _ref.isShared;
    $scope.$apply(function () {
      $scope.isCameraSettingOpen = isOpen;
      $scope.currentCamera = cameraData;
      angular.extend($scope.currentCamera, {
        isShared: isShared
      });
    });
  };
  var showAlert = function showAlert(title, message) {
    $(".display_show").css("display", "");
    $scope.showAlert = true;
    $scope.alertTitle = title;
    $scope.alertMessage = message;
  };
}]);
"use strict";

var drawing = false,
  dragging = false,
  peopleZoneWidth,
  peopleZoneHeight;
var PeopleZoneArea = function PeopleZoneArea(id, mode) {
  this.canvas = document.getElementById(id);
  peopleZoneWidth = parseInt(this.canvas.style.width);
  peopleZoneHeight = parseInt(this.canvas.style.height);
  this.svg = d3.select(this.canvas).append('svg').attr('width', '100%').attr('height', '100%').attr('class', 'zone_set_svg');
  dragging = false;
  drawing = false;
  this.startPoint = null;
  this.mode = mode;
  this.handler = null;
  this.points = [];
  this.polyG = null;
  this.zones = [];
  this.currentColor = null;
  this.init();
};
PeopleZoneArea.prototype.setEventHandler = function (handler) {
  this.handler = handler;
};
PeopleZoneArea.prototype.getIsDrawing = function () {
  return drawing;
};
PeopleZoneArea.prototype.makeZoneId = function () {
  var text = "";
  var possible = "0123456789";
  for (var i = 0; i < 13; i++) text += possible.charAt(Math.floor(Math.random() * possible.length));
  return text;
};
PeopleZoneArea.prototype.draw = function () {
  var i, len;
  $(".zone_set_svg").empty();
  for (i in this.zones) {
    var zone = this.zones[i];
    zone.draw(this.svg);
  }
  if (this.points && this.points.length && this.currentColor) {
    if (d3.select('g.drawPloy').empty()) {
      this.polyG = this.svg.append('g').attr('class', 'drawPoly');
    }
    this.polyG.select('polyline').remove();
    var polyline = this.polyG.append('polyline').attr('points', this.points).style('fill', 'none').attr('stroke', this.currentColor).attr('stroke-width', '2px');
    len = this.points.length;
    for (i = 0; i < len; i += 1) {
      this.polyG.append('circle').attr('cx', this.points[i][0]).attr('cy', this.points[i][1]).attr('r', 6).attr('fill', this.currentColor).attr('is-handle', 'true').style({
        cursor: 'pointer'
      });
    }
  }
};
PeopleZoneArea.prototype.getZonesData = function () {
  var i,
    len,
    arr = [];
  len = this.zones.length;
  for (i = 0; i < len; i += 1) {
    arr.push({
      coordinate: this.serverDataFromCoordinate(this.zones[i].paths),
      color: this.zones[i].color,
      id: '' + this.zones[i].id,
      uid: '' + this.zones[i].uid,
      zoneIndex: '' + this.zones[i].zoneIndex,
      labelName: this.zones[i].labelName,
      status: 'on',
      filterMark: 'on'
    });
  }
  return arr;
};
PeopleZoneArea.prototype.modifyHandler = function (event) {
  if (this.handler) {
    this.handler({
      name: 'modify',
      zone: {
        coordinate: this.serverDataFromCoordinate(event.paths),
        zoneIndex: event.zoneIndex
      }
    });
  }
};
PeopleZoneArea.prototype.setZonesData = function (data, modifyMode) {
  var zones = [];
  this.modifyMode = modifyMode;
  for (var i in data) {
    var zoneData = data[i];
    var coordinate = zoneData.coordinate;
    if (coordinate !== undefined) {
      var coordinates = this.coordinateFromServerData(coordinate);
      var zone = PeopleZone.newZone(zoneData.id, zoneData.uid, zoneData.zoneIndex, coordinates, zoneData.color, zoneData.label, modifyMode, this.modifyHandler.bind(this), this.mode === 'seat');
      zones.push(zone);
    }
  }
  this.zones = zones;
  this.draw();
};
PeopleZoneArea.prototype.setCanvasSize = function (width, height) {
  var serverData = this.getZonesData();
  this.canvas.width = peopleZoneWidth = parseInt(width);
  this.canvas.height = peopleZoneHeight = parseInt(height);
  this.setZonesData(serverData, this.modifyMode);
};
PeopleZoneArea.prototype.resetDrawing = function () {
  this.currentColor = null;
  this.points = [];
};
PeopleZoneArea.prototype.removeZone = function (zoneIndex) {
  var i,
    len = this.zones.length;
  for (i = 0; i < len; i += 1) {
    if (this.zones && this.zones[i].zoneIndex == zoneIndex) {
      this.zones.splice(i, 1);
      this.draw();
      break;
    }
  }
  if (this.handler) {
    this.handler({
      name: 'remove',
      zone: {
        zoneIndex: zoneIndex
      }
    });
  }
};
PeopleZoneArea.prototype.init = function () {
  var that = this;
  d3.select(that.canvas).on('mouseup', function () {
    if (dragging || that.modifyMode) {
      return;
    }
    if (d3.event.target.hasAttribute('area_delete_btn')) {
      that.removeZone(d3.event.target.getAttribute('zoned_index'));
      return;
    }
    if (that.mode === 'people') {
      if (that.zones.length >= 4) {
        if (that.handler) {
          that.handler({
            name: 'full'
          });
        }
        return;
      }
    } else if (that.mode === 'seat') {
      if (that.zones.length >= 16) {
        if (that.handler) {
          that.handler({
            name: 'full'
          });
        }
        return;
      }
    }
    if (!that.currentColor) {
      that.currentColor = that.mode === 'seat' ? '#8013ca' : that.getColor();
    }
    drawing = true;
    if (that.handler) {
      that.handler({
        name: 'drawing_change',
        drawing: drawing
      });
    }
    that.startPoint = [d3.mouse(this)[0], d3.mouse(this)[1]];
    if (d3.select('g.drawPloy').empty()) {
      that.polyG = that.svg.append('g').attr('class', 'drawPoly');
    }
    if (d3.event.target.hasAttribute('is-handle')) {
      that.closePolygon();
      return;
    }
    that.points.push(d3.mouse(this));
    that.polyG.select('polyline').remove();
    var polyline = that.polyG.append('polyline').attr('points', that.points).style('fill', 'none').attr('stroke', that.currentColor).attr('stroke-width', '2px');
    var i,
      len = that.points.length;
    for (i = 0; i < len; i += 1) {
      that.polyG.append('circle').attr('cx', that.points[i][0]).attr('cy', that.points[i][1]).attr('r', 6).attr('fill', that.currentColor).attr('is-handle', 'true').style({
        cursor: 'pointer'
      });
    }
    if (that.points.length >= 16) {
      that.closePolygon();
    }
  });
  d3.select(this.canvas).on('mousedown', function () {});
};
PeopleZoneArea.prototype.getEmptyZoneId = function () {
  var i,
    len = this.zones.length,
    zoneId = this.zones.length + 1;
  for (i = 0; i < len; i += 1) {
    if (this.zones[i].id == zoneId) {
      zoneId += 1;
    }
  }
  return zoneId;
};
PeopleZoneArea.prototype.closePolygon = function () {
  var that = this;
  $('.drawPoly').remove();
  if (!that.points || that.points.length <= 2) {
    that.currentColor = null;
    that.points = [];
    drawing = false;
    if (this.handler) {
      this.handler({
        name: 'drawing_change',
        drawing: drawing
      });
    }
    return;
  }
  var newZone = PeopleZone.newZone('', '', '', that.points, that.currentColor, '', this.modifyMode, this.modifyHandler.bind(this), this.mode === 'seat');
  newZone.draw(this.svg);
  that.zones.push(newZone);
  that.currentColor = null;
  that.points = [];
  drawing = false;
  if (this.handler) {
    this.handler({
      name: 'drawing_change',
      drawing: drawing
    });
    this.handler({
      name: 'add',
      zone: {
        coordinate: this.serverDataFromCoordinate(newZone.paths),
        color: newZone.color
      }
    });
  }
};
PeopleZoneArea.prototype.getColor = function () {
  var minUseCount = -1,
    useColorMap = {},
    minUsedColors = [];
  this.zones.forEach(function (zone) {
    var upperColor = zone.color.toUpperCase();
    if (useColorMap[upperColor]) {
      useColorMap[upperColor] += 1;
    } else {
      useColorMap[upperColor] = 1;
    }
  });
  var colorArr = [{
    color: '#FF7900',
    useCount: 0
  }, {
    color: '#59A1D6',
    useCount: 0
  }, {
    color: '#EFD600',
    useCount: 0
  }, {
    color: '#91C90C',
    useCount: 0
  }];
  colorArr.forEach(function (colorObj) {
    colorObj.useCount = useColorMap[colorObj.color] ? useColorMap[colorObj.color] : 0;
    if (minUseCount === -1) {
      minUseCount = colorObj.useCount;
      minUsedColors.push(colorObj.color);
    } else {
      if (minUseCount === colorObj.useCount) {
        minUsedColors.push(colorObj.color);
      } else if (minUseCount > colorObj.useCount) {
        minUseCount = colorObj.useCount;
        minUsedColors = [];
        minUsedColors.push(colorObj.color);
      }
    }
  });
  return minUsedColors[0];
};
PeopleZoneArea.prototype.coordinateFromServerData = function (data) {
  var i,
    len,
    that = this,
    arr = [],
    cacheArr = [];
  var parsed = data.split(',').map(function (i) {
    return parseInt(i);
  });
  len = parsed.length;
  for (i = 0; i < len; i += 1) {
    if (i % 2 === 1) {
      cacheArr.push(peopleZoneHeight * parsed[i] / 1000);
    } else {
      cacheArr.push(peopleZoneWidth * parsed[i] / 1000);
    }
    if (cacheArr.length === 2) {
      arr.push(cacheArr);
      cacheArr = [];
    }
  }
  return arr;
};
PeopleZoneArea.prototype.serverDataFromCoordinate = function (data) {
  var i,
    len,
    tempArr = [],
    arr = [];
  if (!data) {
    return '';
  }
  len = data.length;
  for (i = 0; i < len; i += 1) {
    tempArr = tempArr.concat(data[i]);
  }
  len = tempArr.length;
  for (i = 0; i < len; i += 1) {
    if (i % 2 === 1) {
      arr.push(parseInt(1000 * tempArr[i] / peopleZoneHeight));
    } else {
      arr.push(parseInt(1000 * tempArr[i] / peopleZoneWidth));
    }
  }
  return arr.join(',');
};
var PeopleZone = function PeopleZone(id, uid, zoneIndex, paths, color, label, modifyMode, modifyCallback, drawIdx) {
  this.id = id;
  this.uid = uid;
  this.zoneIndex = zoneIndex;
  this.paths = paths;
  this.color = color;
  this.labelName = label;
  this.modifyMode = modifyMode;
  this.drawIdx = drawIdx;
  if (this.modifyMode) {
    this.modifyCallback = modifyCallback;
  }
  this.dragger = d3.behavior.drag().on('drag', this.handleDrag).on('dragend', this.handleDragEnd.bind(this));
  this.polyDragger = d3.behavior.drag().on('drag', this.handlePolyDrag).on('dragend', this.handlePolyDragEnd.bind(this));
};
PeopleZone.newZone = function (id, uid, zoneIndex, datas, color, label, modifyMode, modifyCallback, drawIdx) {
  //[123, 34, 45, 33], id, color
  return new PeopleZone(id, uid, zoneIndex, datas, color, label, modifyMode, modifyCallback, drawIdx);
};
PeopleZone.prototype.handlePolyDrag = function () {
  if (drawing) return;
  var i,
    len,
    newPoints = [],
    circle,
    circleX,
    circleY;
  dragging = true;
  var poly = d3.select(this.parentNode).select('polygon');
  var polyline = d3.select(this.parentNode).select('polyline');
  var circles = d3.select(this.parentNode).selectAll('circle');
  for (i = 0, len = circles[0].length; i < len; i++) {
    circle = d3.select(circles[0][i]);
    circleX = parseInt(circle.attr('cx')) + d3.event.dx;
    circleY = parseInt(circle.attr('cy')) + d3.event.dy;
    if (circleX <= 0 || circleX >= peopleZoneWidth || circleY <= 0 || circleY >= peopleZoneHeight) {
      return;
    }
  }
  for (i = 0, len = circles[0].length; i < len; i++) {
    circle = d3.select(circles[0][i]);
    circle.attr('cx', parseInt(circle.attr('cx')) + d3.event.dx).attr('cy', parseInt(circle.attr('cy')) + d3.event.dy);
    newPoints.push([circle.attr('cx'), circle.attr('cy')]);
  }
  poly.attr('points', newPoints);
  polyline.attr('points', newPoints.concat([newPoints[0]]));
};
PeopleZone.prototype.handlePolyDragEnd = function () {
  dragging = false;
  var circles = d3.select('.poly_wrap_' + this.zoneIndex).selectAll('circle');
  for (var i = 0; i < circles[0].length; i++) {
    if ('circle_' + i === circles[0][i].className.baseVal) {
      this.paths[i][0] = circles[0][i].cx.baseVal.value;
      this.paths[i][1] = circles[0][i].cy.baseVal.value;
    }
  }
  $('.poly_wrap_' + this.zoneIndex).remove();
  if (this.svg) {
    this.createPath(this.svg);
  }
  if (this.modifyCallback) {
    this.modifyCallback({
      event: 'modify',
      paths: this.paths,
      zoneIndex: this.zoneIndex
    });
  }
};
PeopleZone.prototype.handleDragEnd = function () {
  dragging = false;
  var i,
    len = this.paths.length;
  for (i = 0; i < len; i += 1) {
    if (d3.event.sourceEvent.target.cx && d3.event.sourceEvent.target.cy) {
      if ('circle_' + i === d3.event.sourceEvent.target.className.baseVal) {
        this.paths[i][0] = parseInt(d3.event.sourceEvent.target.cx.baseVal.value);
        this.paths[i][1] = parseInt(d3.event.sourceEvent.target.cy.baseVal.value);
        break;
      }
    }
  }
  $('.poly_wrap_' + this.zoneIndex).remove();
  if (this.svg) {
    this.createPath(this.svg);
  }
  if (this.modifyCallback) {
    this.modifyCallback({
      event: 'modify',
      paths: this.paths,
      zoneIndex: this.zoneIndex
    });
  }
};
PeopleZone.prototype.handleDrag = function () {
  if (drawing) {
    return;
  }
  if (d3.event.x <= 0 || d3.event.x >= peopleZoneWidth || d3.event.y <= 0 || d3.event.y >= peopleZoneHeight) {
    return;
  }
  var dragCircle = d3.select(this),
    newPoints = [],
    circle;
  dragging = true;
  var poly = d3.select(this.parentNode).select('polygon');
  var polyline = d3.select(this.parentNode).select('polyline');
  var circles = d3.select(this.parentNode).selectAll('circle');
  dragCircle.attr('cx', d3.event.x).attr('cy', d3.event.y);
  for (var i = 0; i < circles[0].length; i++) {
    circle = d3.select(circles[0][i]);
    newPoints.push([circle.attr('cx'), circle.attr('cy')]);
  }
  poly.attr('points', newPoints);
  polyline.attr('points', newPoints.concat([newPoints[0]]));
};
PeopleZone.prototype.createPath = function (svg) {
  var that = this;
  var g = svg.append('g').attr('class', 'poly_wrap_' + that.zoneIndex);
  var polygon = g.append('polygon').attr('points', that.paths).attr("stroke", "black").text(function (d) {
    return that.zoneIndex;
  }).style('fill', that.color).style('opacity', 0.5);
  if (that.modifyMode) {
    polygon.call(that.polyDragger);
  }
  var polyline = g.append('polyline').attr('points', that.paths.concat([that.paths[0]])).style('fill', 'none').attr('stroke', that.color).attr('stroke-width', '2px');
  if (that.modifyMode) {
    polyline.call(that.polyDragger);
  }
  var i,
    len = that.paths.length;
  for (i = 0; i < len; i += 1) {
    if (that.modifyMode) {
      var circle = g.selectAll('circles').data([that.paths[i]]).enter().append('circle').attr('cx', that.paths[i][0]).attr('cy', that.paths[i][1]).attr('r', 6).attr('fill', that.color).attr('stroke', that.color).attr('is-handle', 'true').attr({
        cursor: 'move'
      }).attr('class', 'circle_' + i).call(that.dragger);
    }
    if (i === 0 && !that.modifyMode) {
      g.append('svg:image').attr({
        x: that.paths[i][0] - 14,
        y: that.paths[i][1] - 14,
        width: 28,
        height: 28,
        "class": function _class(d) {
          return "area_delete_btn";
        }
      }).attr("xlink:href", function (d) {
        return "/resources/img/btn-zone-delete.svg";
      }).attr('area_delete_btn', 'true').attr('zoned_index', that.zoneIndex);
    }
  }
  if (that.drawIdx && !that.modifyMode) {
    var centeroid = function centeroid(polygon) {
      var i = -1,
        n = polygon.length,
        x = 0,
        y = 0,
        a,
        b = polygon[n - 1],
        c,
        k = 0;
      while (++i < n) {
        a = b;
        b = polygon[i];
        k += c = a[0] * b[1] - b[0] * a[1];
        x += (a[0] + b[0]) * c;
        y += (a[1] + b[1]) * c;
      }
      return k *= 3, [x / k, y / k];
    };
    var polyCenter = centeroid(that.paths);
    g.append("rect").attr('fill', 'rgba(28, 255, 190, 0.9)').attr("x", polyCenter[0] - 14).attr("y", polyCenter[1] - 14).attr("width", 28).attr("height", 28);
    g.append("text").attr("x", polyCenter[0]).attr("y", polyCenter[1] + 4).style("font-size", 12).attr("fill", "black").attr("stroke", "#000000").attr('text-anchor', 'middle').text(that.zoneIndex);
  }
};
PeopleZone.prototype.draw = function (svg) {
  this.svg = svg;
  this.createPath(svg);
};
PeopleZone.prototype.coordinate = function () {
  var x = parseInt(this.paths[0][0]);
  var y = parseInt(this.paths[0][1]);
  var width = parseInt(this.paths[1][0] - x);
  var height = parseInt(this.paths[3][1] - y);
  return [x, y, width, height];
};
"use strict";

var ptzArea = function ptzArea(id, eventHandler) {
  this.canvas = document.getElementById(id);
  this.ctx = this.canvas.getContext('2d');
  this.width;
  this.height;
  this.rect = {};
  this.drag = false;
  this.eventHandler = eventHandler;
  this.mouseDownCb = null;
  this.mouseUpCb = null;
  this.mouseMoveCb = null;
  this.init();
};
ptzArea.prototype.destroy = function () {
  this.canvas.removeEventListener('mousedown', this.mouseDownCb, false);
  this.canvas.removeEventListener('mouseup', this.mouseUpCb, false);
  this.canvas.removeEventListener('mousemove', this.mouseMoveCb, false);
  this.canvas = null;
  this.ctx = null;
  this.eventHandler = null;
  this.mouseDownCb = null;
  this.mouseUpCb = null;
  this.mouseMoveCb = null;
};
ptzArea.prototype.init = function () {
  this.mouseDownCb = this.mouseDown.bind(this);
  this.mouseUpCb = this.mouseUp.bind(this);
  this.mouseMoveCb = this.mouseMove.bind(this);
  this.canvas.addEventListener('mousedown', this.mouseDownCb, false);
  this.canvas.addEventListener('mouseup', this.mouseUpCb, false);
  this.canvas.addEventListener('mousemove', this.mouseMoveCb, false);
};
ptzArea.prototype.setCanvasSize = function (width, height) {
  this.canvas.width = width;
  this.canvas.height = height;
};
ptzArea.prototype.mouseDown = function (e) {
  this.rect = {};
  this.rect.startX = e.offsetX;
  this.rect.startY = e.offsetY;
  this.drag = true;
};
ptzArea.prototype.mouseUp = function () {
  this.drag = false;
  var type, rectCenterX, rectCenterY, rectWidth, rectHeight;
  if (!this.rect.w || !this.rect.h) {
    //click
    type = 'click';
    rectCenterX = this.rect.startX;
    rectCenterY = this.rect.startY;
    rectWidth = 0;
    rectHeight = 0;
  } else if (this.rect.w < 0 && this.rect.h < 0) {
    //zoom out
    type = 'zoomout';
    rectCenterX = this.rect.startX + Math.round(this.rect.w / 2);
    rectCenterY = this.rect.startY + Math.round(this.rect.h / 2);
    rectWidth = Math.abs(this.rect.w);
    rectHeight = Math.abs(this.rect.h);
  } else {
    //zoom in
    type = 'zoomin';
    rectCenterX = this.rect.startX + Math.round(this.rect.w / 2);
    rectCenterY = this.rect.startY + Math.round(this.rect.h / 2);
    rectWidth = this.rect.w;
    rectHeight = this.rect.h;
  }
  if (this.eventHandler) {
    this.eventHandler({
      type: type,
      rectCenterX: rectCenterX,
      rectCenterY: rectCenterY,
      rectWidth: rectWidth,
      rectHeight: rectHeight,
      canvasWidth: this.canvas.width,
      canvasHeight: this.canvas.height
    });
  }
  this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
};
ptzArea.prototype.mouseMove = function (e) {
  if (this.drag) {
    this.rect.w = e.offsetX - this.rect.startX;
    this.rect.h = e.offsetY - this.rect.startY;
    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    this.draw();
  }
};
ptzArea.prototype.draw = function () {
  this.ctx.setLineDash([6]);
  this.ctx.strokeStyle = '#d8d8d8';
  this.ctx.lineWidth = 2;
  this.ctx.strokeRect(this.rect.startX, this.rect.startY, this.rect.w, this.rect.h);
};
"use strict";

var ZoneArea = function ZoneArea(id) {
  this.canvas = document.getElementById(id);
  this.ctx = this.canvas.getContext('2d');
  this.width = this.canvas.width;
  this.height = this.canvas.height;
  this.drag = false;
  this.zones = [];
  this.downLocation;
  this.lastMouseMoveLocation;
  this.selectedZone = "";
  this.currentGrab;
  this.dragMode = "";
  this.init();
};
ZoneArea.prototype.setCanvasSize = function (width, height, zones, selectZones) {
  this.width = width;
  this.height = height;
  this.canvas.width = width;
  this.canvas.height = height;
  this.setZonesData(zones);
  this.setSelectedZones(selectZones);
};
ZoneArea.prototype.init = function () {
  var that = this;
  d3.select(this.canvas).on('mousedown', function () {
    if (event.preventDefault) {
      event.preventDefault();
    } else {
      event.returnValue = false;
    }
    that.drag = true;
    var location = d3.mouse(this);
    that.lastMouseMoveLocation = location;
    that.downLocation = location;
    var selectedZoneId = that.zonePointId(location[0], location[1]);
    if (selectedZoneId !== "") {
      that.dragMode = "move";
    } else {
      that.dragMode = "";
    }
    // Grab 손잡이를 클릭하면, Move 보다 Grab이 우선적으로 작동
    if (that.isGrabPoint(location[0], location[1])) {
      that.currentGrab = that.grabPointIndex(location[0], location[1]);
      selectedZoneId = that.selectedZone;
      that.dragMode = "grab";
    }
    // selected zone의 grab을 그린다.
    if (selectedZoneId !== "") {
      that.selectedZone = selectedZoneId;
      that.draw();
    }
  });
  d3.select(this.canvas).on('mouseup', function () {
    if (event.preventDefault) {
      event.preventDefault();
    } else {
      event.returnValue = false;
    }
    that.drag = false;
    that.canvas.style.cursor = "default";
    var zone = that.zoneWithId(that.selectedZone);
    zone.healPoint(this.width, this.height);
    that.draw();
    if (that.delegate !== undefined && typeof that.delegate.movedZone === 'function') {
      var serverData = that.serverDataFromCoordinate(zone.coordinate());
      that.delegate.movedZone(zone.id, serverData);
    }
  });
  d3.select(this.canvas).on('mousemove', function (e) {
    //$("#cam_info").css("z-index",1);
    if (event.preventDefault) {
      event.preventDefault();
    } else {
      event.returnValue = false;
    }
    var location = d3.mouse(this);
    if (that.isGrabPoint(location[0], location[1])) {
      that.canvas.style.cursor = "crosshair";
    } else if (that.zonePointId(location[0], location[1]) !== "") {
      that.canvas.style.cursor = "move";
    } else {
      that.canvas.style.cursor = "default";
    }
    ;
    if (that.drag) {
      var zone = that.zoneWithId(that.selectedZone);
      if (that.dragMode === "grab") {
        zone.grab(that.currentGrab, location[0], location[1]);
      } else if (that.dragMode === "move") {
        var dx = location[0] - that.lastMouseMoveLocation[0];
        var dy = location[1] - that.lastMouseMoveLocation[1];
        zone.move(dx, dy);
      }
      that.draw();
    }
    that.lastMouseMoveLocation = location;
  });
  d3.select(this.canvas).on('mouseleave', function (e) {
    //	$("#cam_info").css("z-index","");
  });
};
ZoneArea.prototype.isGrabPoint = function (x, y) {
  var grabIndex = this.grabPointIndex(x, y);
  if (grabIndex >= 0 && grabIndex <= 7) {
    return true;
  }
  return false;
};
ZoneArea.prototype.zonePointId = function (x, y) {
  for (var i = this.zones.length - 1; i >= 0; i--) {
    var zone = this.zones[i];
    zone.createPath(this.ctx);
    if (this.ctx.isPointInPath(x, y)) {
      return zone.id;
    }
  }
  return "";
};
ZoneArea.prototype.currentZone = function () {
  if (this.selectZone !== "") {
    return this.zoneWithId(this.selectedZone);
  }
  return undefined;
};
ZoneArea.prototype.grabPointIndex = function (x, y) {
  if (this.currentZone() === undefined) {
    return 99;
  }

  // 두 점 사이의 거리가 6 이하이면
  for (var i in this.currentZone().paths) {
    var path = this.currentZone().paths[i];
    var distance = Math.sqrt(Math.pow(path[0] - x, 2) + Math.pow(path[1] - y, 2));
    if (distance <= 6) {
      return parseInt(i);
    }
  }
};
ZoneArea.prototype.draw = function () {
  this.ctx.clearRect(0, 0, this.width, this.height);
  for (var i in this.zones) {
    var zone = this.zones[i];
    if (this.selectedZone !== zone.id) {
      zone.draw(this.ctx);
    }
  }
  if (this.selectedZone !== "") {
    var selectedZone = this.zoneWithId(this.selectedZone);
    if (selectedZone != undefined) {
      selectedZone.draw(this.ctx);
      selectedZone.drawGrab(this.ctx);
    }
  }
};
ZoneArea.prototype.addZone = function () {
  var centerX = this.width / 2;
  var centerY = this.height / 2;
  var halfWidth = 50;
  var newZone = Zone.newZone([centerX - halfWidth, centerY - halfWidth], [centerX + halfWidth, centerY + halfWidth]);
  this.selectedZone = newZone.id;
  this.zones.push(newZone);
  this.draw();
};
ZoneArea.prototype.zoneWithId = function (id) {
  for (var i in this.zones) {
    var zone = this.zones[i];
    if (zone.id === id) {
      return zone;
    }
  }
};
ZoneArea.prototype.setZonesData = function (data) {
  var zones = [];
  for (var i in data) {
    if (data[i].id !== '9') {
      var zoneData = data[i];
      var coordinate = zoneData.coordinate;
      if (coordinate !== undefined) {
        var coordinates = this.coordinateFromServerData(coordinate);
        var zone = Zone.newZone(coordinates[0], coordinates[1], coordinates[2], coordinates[3], zoneData.id, zoneData.color);
        zones.push(zone);
      }
    }
  }
  this.zones = zones;
  this.draw();
};
ZoneArea.prototype.setSelectedZones = function (selectedZones) {
  // this.selectedZones = selectedZones;
  // this.zones.forEach(function (zone) {
  // 	if (selectedZones.indexOf(zone.id) === -1) {
  // 		zone.hidden = true;
  // 	} else {
  // 		zone.hidden = false;
  // 	}
  // });
  this.draw();
};
ZoneArea.prototype.coordinateFromServerData = function (data) {
  // [x, y, width, height]
  var parsed = data.split(',').map(function (i) {
    return parseInt(i);
  });

  // 카메라 영역인 1000x1000 에서 canvas Size 비율로 보정한다.
  var x = this.width * parsed[0] / 1000;
  var y = this.height * parsed[1] / 1000;
  var width = this.width * parsed[2] / 1000;
  var height = this.height * parsed[3] / 1000;
  return [x, y, width, height];
};
ZoneArea.prototype.serverDataFromCoordinate = function (data) {
  var x = parseInt(1000 * data[0] / this.width);
  var y = parseInt(1000 * data[1] / this.height);
  var width = parseInt(1000 * data[2] / this.width);
  var height = parseInt(1000 * data[3] / this.height);
  return [x, y, width, height].join(',');
};
var Zone = function Zone(id, paths, color) {
  this.id = id;
  this.paths = paths;
  this.color = color;
  this.hidden = false;
};
Zone.createPaths = function (x, y, width, height) {
  var paths = [];
  paths.push([x, y]);
  paths.push([x + width, y]);
  paths.push([x + width, y + height]);
  paths.push([x, y + height]);
  return paths;
};
Zone.newZone = function (x, y, width, height, id, color) {
  var newPaths = Zone.createPaths(x, y, width, height);
  return new Zone(id, newPaths, color);
};
Zone.prototype.move = function (dx, dy) {
  var newPath = [];
  this.paths.forEach(function (path) {
    newPath.push([path[0] + dx, path[1] + dy]);
  });
  this.paths = newPath;
};
Zone.prototype.createPath = function (context) {
  context.beginPath();
  for (var i in this.paths) {
    if (i === 0) {
      context.moveTo(this.paths[i][0], this.paths[i][1]);
    } else {
      context.lineTo(this.paths[i][0], this.paths[i][1]);
    }
  }
  context.closePath();
};
Zone.prototype.grab = function (index, x, y) {
  // 좌측 상단부터 시계방향으로 그려진다.
  this.paths[index] = [x, y];

  // 다각형일때에는 아래의 코드를 삭제..
  if (index === 0) {
    this.paths[3][0] = x;
    this.paths[1][1] = y;
  } else if (index === 1) {
    this.paths[0][1] = y;
    this.paths[2][0] = x;
  } else if (index === 2) {
    this.paths[1][0] = x;
    this.paths[3][1] = y;
  } else if (index === 3) {
    this.paths[2][1] = y;
    this.paths[0][0] = x;
  }
};
Zone.prototype.draw = function (context) {
  if (this.hidden) return;
  this.createPath(context);
  context.globalAlpha = 1;
  context.fillStyle = this.color;
  context.fill();
  context.globalCompositeOperation = 'xor';
  context.fill();
  context.globalCompositeOperation = 'xor';
  context.globalAlpha = 0.3;
  context.fill();
  context.globalAlpha = 1;
  context.lineWidth = 3;
  context.strokeStyle = this.color;
  context.stroke();
};
Zone.prototype.drawGrab = function (context) {
  if (this.hidden) return;
  context.globalCompositeOperation = 'source-over';
  context.globalAlpha = 1;
  context.fillStyle = this.color;
  for (var i = 0; i < this.paths.length; i++) {
    var path = this.paths[i];
    context.beginPath();
    context.arc(path[0], path[1], 6, 0, Math.PI * 2, false);
    context.fill();
  }
};
Zone.prototype.healPoint = function (width, height) {
  // 2px: line width 보정
  for (var i in this.paths) {
    var path = this.paths[i];
    if (path[0] < 2) {
      path[0] = 2;
    } else if (path[0] > width - 2) {
      path[0] = width - 2;
    }
    if (path[1] < 2) {
      path[1] = 2;
    } else if (path[1] > height - 2) {
      path[1] = height - 2;
    }
  }
};
Zone.prototype.coordinate = function () {
  var x = parseInt(this.paths[0][0]);
  var y = parseInt(this.paths[0][1]);
  var width = parseInt(this.paths[1][0] - x);
  var height = parseInt(this.paths[3][1] - y);
  return [x, y, width, height];
};
"use strict";

app.controller('AllGroupCtrl', ['$scope', '$state', 'CameraGroup', function ($scope, $state, CameraGroup) {
  $scope.groups = [];
  // B2B 화면 초기 데이터 셋팅
  var getCameraGroup = function getCameraGroup() {
    CameraGroup.query(function (res) {
      $scope.groups = res;
    }, function (err) {});
  };
  getCameraGroup();

  /**
   * 카메라 상세 페이지로 이동
   * @param  {String} cameraId
   * @param  {String} recorderType
   */
  $scope.goDetail = function (cameraId, recorderType, groupId) {
    $state.go('main.cameraDetail', {
      cameraId: cameraId,
      type: 'group',
      id: groupId
    });
  };
}]);
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
app.controller("CameraGroupCtrl", ["$scope", "$location", "$q", "$state", "$translate", "$timeout", "$sessionStorage", "CameraGroup", "Camera", "Shop", "NgUtils", function ($scope, $location, $q, $state, $translate, $timeout, $sessionStorage, CameraGroup, Camera, Shop, NgUtils) {
  $scope.protocol = $location.protocol() + "://"; // thumbnail location protocol
  $scope.groups = [];
  $scope.searchCamMap = null;
  $scope.searchKeyword = "";
  $scope.loadGroup = false;
  $scope.loadCams = false;
  $scope.currentGroupId = "";
  $scope.shopList = [];
  var myGroupLength = 0;
  // B2B 화면 초기 데이터 셋팅
  var getCameraGroup = function getCameraGroup() {
    var defered = $q.defer();
    var getGroupPromise = CameraGroup.query().$promise;
    var getSharedGroupPromise = CameraGroup.getSharedGroups().$promise;
    $scope.loadGroup = true;
    $q.all([getGroupPromise, getSharedGroupPromise]).then(function (res) {
      var _res = _slicedToArray(res, 2),
        myGroups = _res[0],
        sharedGroups = _res[1];
      var myGroupLength = myGroups.length;
      sharedGroups.forEach(function (groupObj) {
        if (groupObj) {
          if (groupObj.hasOwnProperty("subgroups")) {
            groupObj["subGroups"] = groupObj["subgroups"];
            delete groupObj["subgroups"];
          }
          if (groupObj.shareId && groupObj.subGroups) {
            groupObj.subGroups.forEach(function (subGroup) {
              subGroup["shareId"] = groupObj.shareId;
            });
          }
        }
      });
      $scope.groups = myGroups.concat(sharedGroups);
      $scope.loadGroup = false;
      defered.resolve();
    }, function (err) {
      $scope.loadGroup = false;
      $scope.$root.createSessionDlg();
    });
    return defered.promise;
  };
  getCameraGroup();
  Shop.dashboardShops().$promise.then(function (res) {
    return $scope.shopList = res.shops && res.shops.length ? res.shops : [];
  });
  var mappingCameraArray = function mappingCameraArray(data) {
    data.cameras.filter(function (object) {
      return object.camera;
    }.map(function (object) {
      return object.camera;
    }));
  };
  var getCameraInfo = function getCameraInfo(cameraId) {
    if (!$scope.allCameras) {
      return null;
    }
    var i,
      len = $scope.allCameras.length;
    for (i = 0; i < len; i += 1) {
      if ($scope.allCameras[i].id === cameraId) {
        return {
          controlStatus: $scope.allCameras[i].controlStatus,
          recordType: $scope.allCameras[i].recordType,
          streamStatusConfig: $scope.allCameras[i].streamStatusConfig,
          streamStatus: $scope.allCameras[i].streamStatus,
          serviceType: $scope.allCameras[i].serviceType,
          recorderType: $scope.allCameras[i].recorderType
        };
      }
    }
    return null;
  };
  var makeSubGroupEditCamList = function makeSubGroupEditCamList(upperCameras, groupCameras) {
    var addCameras;
    addCameras = groupCameras.filter(function (camera) {
      var found = false;
      found = upperCameras.some(function (upperCam) {
        return upperCam.id === camera.id;
      });
      return !found;
    });
    return upperCameras.concat(addCameras);
  };
  var getFirstGroupAfterDelete = function getFirstGroupAfterDelete(groups, deleteId) {
    var i,
      len = groups.length;
    for (i = 0; i < len; i += 1) {
      if (groups[i].groupId && groups[i].groupId !== deleteId) {
        return groups[i];
      }
    }
    return null;
  };
  function subGroupOpen(groupId) {
    if (typeof $sessionStorage.openGroups === "undefined") {
      $sessionStorage.openGroups = {};
    }
    _.set($sessionStorage.openGroups, groupId, true);
  }
  $scope.findShopId = function (cameraId) {
    var i, j, shopLen, camLen;
    for (i = 0, shopLen = $scope.shopList.length; i < shopLen; i += 1) {
      for (j = 0, camLen = $scope.shopList[i].cameraIds.length; j < camLen; j += 1) {
        if (cameraId === $scope.shopList[i].cameraIds[j]) {
          return $scope.shopList[i].shopId;
        }
      }
    }
    return "";
  };
  var defaultGroupName = "";
  $scope.keydownEvent = function ($event) {
    if ($event.key == "\\") {
      $event.preventDefault();
      return false;
    }
    if ($event.key == "Enter" && $event.isComposing === false) {
      $scope.searchCameraList();
    }
  };
  $scope.searchCameraList = function () {
    $scope.popupGroupCameraList.splice(0, $scope.popupGroupCameraList.length);
    $scope.pagingUtil.setPage(1);
    var groupType = $scope.groupConfig.groupType;
    var callGroupId = groupType === "group" ? null : $scope.groupConfig.upperGroupId;
    $scope.searchParentGroupCameraData($scope.makeParam(callGroupId, false), function (data) {
      $scope.settingCameraList(data);
    });
  };

  // 추가/ 수정팝업 체크박스 클릭 시 이벤트
  $scope.checkboxClick = function (cameraid) {
    var index = $scope.groupCameraIds.indexOf(cameraid);
    if (index >= 0) {
      $scope.groupCameraIds.splice(index, 1);
    } else {
      $scope.groupCameraIds.push(cameraid);
    }
  };
  $scope.makeDefaultGroupName = function () {
    var groupType = $scope.groupConfig.groupType;
    var defaultGroupName;
    if (groupType === "group") {
      defaultGroupName = $translate.instant("CAMERA_GROUP") + (myGroupLength + 1);
    } else {
      defaultGroupName = $translate.instant("CAMERA_LOWER_GROUP");
      var subGroups = [],
        targetGroup = _.find($scope.groups, {
          groupId: $scope.groupConfig.upperGroupId
        });
      if (targetGroup) {
        subGroups = targetGroup.subGroups || targetGroup.subgroups || [];
      }
      defaultGroupName = defaultGroupName + (subGroups.length + 1);
    }
    return defaultGroupName;
  };

  /**
   * 그룹 추가/수정 팝업 open
   * @param {String} type group or subGroup
   * @param {String} groupId
   */
  $scope.showGroupConfigDialog = function (groupType, groupId, upperGroupId, shareId) {
    $scope.groupCameraIds = [];
    $scope.popupGroupCameraList.splice(0, $scope.popupGroupCameraList.length);
    $scope.pagingUtil = NgUtils.pagingUtil();
    $scope.pagingUtil.init();
    $scope.popupSearchData = {
      keyword: "",
      updateCameraArray: []
    };
    $scope.groupConfig = {};
    $scope.groupConfig.paging = 0;
    $scope.groupConfig.isEdit = typeof groupId !== "undefined" ? true : false;
    $scope.groupConfig.groupType = groupType;
    $scope.groupConfig.groupId = groupId;
    $scope.groupConfig.upperGroupId = upperGroupId;
    $scope.groupConfig.shareId = shareId;
    $scope.isShowGroupConfigDialog = true;
    $scope.loadCams = true;
    $scope.groupConfig.groupName = $scope.makeDefaultGroupName();
    var myGroupSearchParam = {
      groupId: groupId,
      count: 16,
      pageNumber: 1,
      sortOrder: "firstConnectDate",
      sortKey: "desc"
    };
    var callGroupId = groupType === "group" ? null : $scope.groupConfig.upperGroupId;
    var parentGroupSearchParam = $scope.makeParam(callGroupId, true);
    var getParentCameraListSetting = function getParentCameraListSetting() {
      // paging function 설정
      $scope.pagingUtil.setCallBackFunc(function () {
        $scope.searchParentGroupCameraData($scope.makeParam(callGroupId, false), function (data) {
          $scope.settingCameraList(data);
        });
      });

      // 기본 cameraList 조회
      $scope.searchParentGroupCameraData(parentGroupSearchParam, function (data) {
        $scope.settingCameraList(data);
      });
    };
    if ($scope.groupConfig.isEdit) {
      // getCameraGroup
      var myGroupFunc = shareId ? CameraGroup.getSharedGroupDetailV2 : CameraGroup.getGroupDetailV2;
      $scope.searchMyGroupCameraData(myGroupSearchParam, function (data) {
        if ($scope.groupConfig.isEdit) $scope.groupConfig.groupName = data.groupName;
        $scope.groupCameraIds = data.cameraIds;
        getParentCameraListSetting();
      });
    } else {
      getParentCameraListSetting();
    }
  };
  $scope.getCallFunc = function () {
    var groupType = $scope.groupConfig.groupType;
    var shareId = $scope.groupConfig.shareId;
    var callFunc;
    //상위 그룹이라면
    if (groupType === "group") callFunc = Camera.getListV4;else if (shareId) {
      // 하위그룹 groupType === 'subGroup'
      callFunc = CameraGroup.getSharedGroupDetailV2; // 하위 & 공유 그룹
    } else {
      callFunc = CameraGroup.getGroupDetailV2; // 하위 그룹
    }
    return callFunc;
  };

  // 팝업의 카메라 리스트
  $scope.popupGroupCameraList = [];
  $scope.makeParam = function (groupId, totalCountFlag) {
    var param = Object.assign({}, $scope.popupSearchData);
    if (totalCountFlag !== undefined) param.totalCount = totalCountFlag;
    param.pageNumber = $scope.pagingUtil.pageNumber();
    param.count = 16;
    param.groupId = groupId;
    return param;
  };
  $scope.searchMyGroupCameraData = function (param, callbackFunc) {
    var shareId = $scope.groupConfig.shareId;
    var myGroupFunc = shareId ? CameraGroup.getSharedGroupDetailV2 : CameraGroup.getGroupDetailV2;
    myGroupFunc(param, function (data) {
      return callbackFunc(data);
    });
  };
  $scope.searchParentGroupCameraData = function (param, callbackFunc) {
    var groupType = $scope.groupConfig.groupType;
    var shareId = $scope.groupConfig.shareId;
    var callFunc;
    //상위 그룹이라면
    if (groupType === "group") callFunc = Camera.getListV4;else if (shareId) {
      // 하위그룹 groupType === 'subGroup'
      callFunc = CameraGroup.getSharedGroupDetailV2; // 하위 & 공유 그룹
    } else {
      callFunc = CameraGroup.getGroupDetailV2; // 하위 그룹
    }
    callFunc(param, function (data) {
      return callbackFunc(data);
    });
  };
  $scope.totalCount = 0;
  $scope.settingCameraList = function (data) {
    var callFunc = $scope.getCallFunc();
    if (data.totalCount) {
      $scope.pagingUtil.setTotalCount(data.totalCount);
      $scope.totalCount = data.totalCount;
    }
    var filterCameraList;
    if (callFunc == Camera.getListV4) {
      filterCameraList = data.cameras.map(function (cameraData) {
        return cameraData.camera;
      });
    } else {
      filterCameraList = data.cameras;
    }
    $scope.popupGroupCameraList = $scope.popupGroupCameraList.concat(filterCameraList);
    if ($scope.groupConfig.isEdit) {
      angular.forEach(filterCameraList, function (value, key) {
        if ($scope.groupCameraIds.indexOf(value.id) > -1) value.isChecked = true;
      });
    }
    $timeout(function () {
      $(".g_add_lazy").Lazy({
        appendScroll: $("#add_cam_list_wrap"),
        visibleOnly: true,
        onError: function onError(element) {
          element.attr("src", "/resources/img/img_camera_fail.svg");
        }
      });
    }, 100);
    $scope.loadCams = false;
  };
  $scope.settingCameras = function (res) {
    if ($scope.groupConfig.isEdit) {
      if (res[1]) {
        angular.extend($scope.groupConfig, res[1]);
      }
    } else {
      if (groupType === "group") {
        defaultGroupName = $translate.instant("CAMERA_GROUP") + (myGroupLength + 1);
      } else {
        defaultGroupName = $translate.instant("CAMERA_LOWER_GROUP");
        var subGroups = [],
          targetGroup = _.find($scope.groups, {
            groupId: $scope.groupConfig.upperGroupId
          });
        if (targetGroup) {
          subGroups = targetGroup.subGroups || targetGroup.subgroups || [];
        }
        defaultGroupName = defaultGroupName + (subGroups.length + 1);
      }
      $scope.groupConfig.groupName = defaultGroupName;
    }
    if (groupType === "subGroup") {
      if ($scope.groupConfig.isEdit) {
        $scope.groupConfig.cameras = makeSubGroupEditCamList(res[0] && res[0].cameras ? res[0].cameras : [], res[1] && res[1].cameras ? res[1].cameras : []);
      } else {
        $scope.groupConfig.cameras = res[0] && res[0].cameras ? res[0].cameras : [];
      }
    } else {
      $scope.groupConfig.cameras = res[0];
    }
    angular.forEach($scope.groupConfig.cameras, function (value, key) {
      var info = getCameraInfo(value.id);
      if (info) {
        value.controlStatus = info.controlStatus;
        value.recordType = info.recordType;
        value.streamStatusConfig = info.streamStatusConfig;
        value.streamStatus = info.streamStatus;
        value.serviceType = info.serviceType;
        value.recorderType = info.recorderType;
      }
    });
    if ($scope.groupConfig.isEdit) {
      angular.forEach(cameraList, function (value, key) {
        angular.forEach(res[1].cameras, function (value1, key1) {
          if (value.id === value1.id) {
            value.isChecked = true;
          }
        });
      });
      defaultGroupName = $scope.groupConfig.groupName;
    }
    $timeout(function () {
      $(".g_add_lazy").Lazy({
        appendScroll: $("#add_cam_list_wrap"),
        visibleOnly: true,
        onError: function onError(element) {
          element.attr("src", "/resources/img/img_camera_fail.svg");
        }
      });
    }, 100);
    $scope.loadCams = false;
  };

  /**
   * 그룹 추가/수정 팝업 close
   */
  $scope.hideGroupConfigDialog = function () {
    $scope.isShowGroupConfigDialog = false;
  };

  /**
   * 그룹 저장 확인 팝업 open
   */
  $scope.showGroupConfigSaveConfirm = function () {
    $scope.isShowGroupConfigSaveConfirm = true;
  };

  /**
   * 그룹 저장 확인 팝업 close
   */
  $scope.hideGroupConfigSaveConfirm = function () {
    $scope.isShowGroupConfigSaveConfirm = false;
  };

  /**
   * 그룹 저장 처리
   */
  $scope.saveGroup = function () {
    var title = ($scope.groupConfig.groupType === "group" ? $translate.instant("CAMERA_UPPER_GROUP") : $translate.instant("CAMERA_LOWER_GROUP")) + ($scope.groupConfig.isEdit ? $translate.instant("SETTING") : $translate.instant("SHARE_ADD"));
    var params = {
      groupName: $scope.groupConfig.groupName === "" ? defaultGroupName : $scope.groupConfig.groupName,
      cameraIds: $scope.groupCameraIds.join(",") //_.chain($scope.groupConfig.cameras).filter('isChecked').map('id').value().join(',')
    };
    if ($scope.groupConfig.isEdit) {
      CameraGroup.updateGroup({
        groupId: $scope.groupConfig.groupId
      }, params, function (res) {
        if (res.code === "ok") {
          $state.reload();
        }
      }, function (err) {});
    } else {
      if ($scope.groupConfig.groupType == "group") {
        CameraGroup.addGroup(params, function (res) {
          if (res.code === "ok") {
            $scope.hideGroupConfigDialog();
            getCameraGroup();
            if (res.groupId) {
              $state.go("main.cameraGroup.group", {
                groupId: res.groupId,
                shareId: ""
              });
            } else {
              $state.reload();
            }
          }
        }, function (err) {});
      } else {
        CameraGroup.addSubGroup({
          groupId: $scope.groupConfig.upperGroupId
        }, params, function (res) {
          if (res.code === "ok") {
            $scope.hideGroupConfigDialog();
            getCameraGroup();
            subGroupOpen($scope.groupConfig.upperGroupId);
            if (res.groupId) {
              $state.go("main.cameraGroup.group", {
                groupId: res.groupId
              });
            } else {
              $state.reload();
            }
          }
        }, function (err) {
          showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
        });
      }
    }
  };

  /**
   * 그룹 삭제 확인 팝업 open
   */
  $scope.showGroupConfigDeleteConfirm = function () {
    $scope.isShowGroupConfigDeleteConfirm = true;
  };

  /**
   * 그룹 삭제 확인 팝업 close
   */
  $scope.hideGroupConfigDeleteConfirm = function () {
    $scope.isShowGroupConfigDeleteConfirm = false;
  };

  /**
   * 그룹 삭제 처리
   */
  $scope.deleteGroup = function () {
    CameraGroup.deleteGroup({
      groupId: $scope.groupConfig.groupId
    }, function (res) {
      if (res.code === "ok") {
        var firstGroup;
        $scope.searchCamMap = null;
        $scope.searchKeyword = "";
        $scope.hideGroupConfigDialog();
        $scope.hideGroupConfigDeleteConfirm();
        firstGroup = getFirstGroupAfterDelete($scope.groups, $scope.groupConfig.groupId);
        getCameraGroup().then(function (res) {
          if ($scope.groups.length < 1) {
            $state.go("main.cameraGroup.group", {
              groupId: "",
              shareId: ""
            });
          } else {
            var groupId = $state.params.groupId;
            if (groupId) {
              if (firstGroup) {
                $state.go("main.cameraGroup.group", {
                  groupId: firstGroup.groupId,
                  shareId: firstGroup.shareId ? firstGroup.shareId : ""
                });
              } else {
                $state.go("main.cameraGroup.group", {
                  groupId: "",
                  shareId: ""
                });
              }
            } else {
              $state.reload();
            }
          }
        });
      }
    }, function (err) {
      showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
    });
  };
}]);
"use strict";

app.controller("GroupCtrl", ["$scope", "$state", "$translate", "$interval", "CameraGroup", "NgUtils", "$anchorScroll", "Utils", function ($scope, $state, $translate, $interval, CameraGroup, NgUtils, $anchorScroll, Utils) {
  $scope.currentCamera = {};
  $scope.isCameraSettingOpen = false;
  $scope.pagingUtil = NgUtils.pagingUtil();
  $scope.groupLoading = false;
  $scope.pagingUtil.setCallBackFunc(function () {
    var groupId = $state.params.groupId;
    if ($state.params.shareId) {
      getSharedGroupDetail(groupId);
    } else {
      getGroupDetail(groupId);
    }
    $anchorScroll(); // 스크롤 탑
  });
  var updateThumbIntervalId = null;
  var keyList = [];
  var todayKey = getTodayKey();
  (function () {
    var navigateToGroup = function navigateToGroup(group) {
      $state.go("main.cameraGroup.group", {
        groupId: group.groupId,
        shareId: group.shareId
      });
    };
    var handleGroupWatch = function handleGroupWatch(newValue) {
      $scope.allShoplist = newValue;
      if ($scope.allShoplist && $scope.allShoplist.length) {
        var group = $scope.allShoplist[0];
        navigateToGroup(group);
      }
    };
    var groupId = $state.params.groupId;
    if (groupId === "") {
      if ($scope.allShoplist && $scope.allShoplist.length) {
        var group = $scope.allShoplist[0];
        navigateToGroup(group);
      } else {
        $scope.$parent.$watch("groups", handleGroupWatch);
        $scope.$parent.currentGroupId = "";
      }
    } else {
      if ($state.params.shareId) {
        getSharedGroupDetail(groupId);
      } else {
        getGroupDetail(groupId);
      }
    }
  })();
  function getTodayKey() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1;
    var yyyy = today.getFullYear();
    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }
    return "" + yyyy + mm + dd;
  }
  function showAlert(title, message) {
    $(".display_show").css("display", "");
    $scope.showAlert = true;
    $scope.alertTitle = title;
    $scope.alertMessage = message;
  }
  var searchType = {
    1: ["labelName", "asc"],
    2: ["labelName", "desc"],
    3: ["firstConnectDate", "desc"],
    4: ["firstConnectDate", "asc"]
  };
  $scope.searchParam = {
    keyword: "",
    pageNumber: "1",
    count: "16",
    sortKey: "firstConnectDate",
    sortOrder: "desc",
    searchType: "1"
  };
  $scope.filterOptionClick = function ($event, param) {
    var divTag = document.getElementsByClassName("selectBox_Camera")[0];
    var buttonTag = divTag.getElementsByTagName("button")[0];
    buttonTag.textContent = $event.target.textContent;
    $scope.ulTagController();
    $scope.changeSorting(param);
  };
  $scope.ulTagController = function (flag) {
    var divTag = document.getElementsByClassName("selectBox_Camera")[0];
    if (typeof flag === "undefined") {
      divTag.classList.toggle("active");
    } else {
      divTag.classList.toggle("active", flag);
    }
  };
  $scope.changeSorting = function (param) {
    var type = param || $scope.searchParam.searchType;
    var typeArr = searchType[type];
    var sortKey = typeArr[0];
    var sortOrder = typeArr[1];
    $scope.searchParam = Object.assign($scope.searchParam, {
      sortKey: sortKey,
      sortOrder: sortOrder
    });
    var groupId = $state.params.groupId;
    if ($state.params.shareId) {
      getSharedGroupDetail(groupId);
    } else {
      getGroupDetail(groupId);
    }
  };

  /**
   * 그룹 상세 데이터 조회
   * @param {String} groupId
   */
  function getGroupDetail(groupId) {
    $scope.groupLoading = true;
    var param = Object.assign($scope.searchParam || {}, {
      groupId: $state.params.groupId,
      pageNumber: $scope.pagingUtil.pageNumber()
    });
    CameraGroup.getGroupDetailV2(param, function (res) {
      $scope.pagingUtil.setTotalCount(res.totalCount);
      $scope.$parent.currentGroupId = groupId;
      $.each(res.cameras, function (i, camera) {
        var serviceType = camera.serviceType;
        var recordType = camera.recordType;
        var recorderType = camera.recorderType;
        if (serviceType == "0d" && recordType == "na" && recorderType == "cvr") {
          camera.thumbnailPath = location.hostname + "/resources/img/img_camera_blackout.svg";
          camera.addServiceType = "black";
        } else if (recorderType == "0d" && recordType == "live" && recorderType == "cvr") {
          //live
          camera.addServiceType = "live";
        } else if (recorderType != "0d" && recordType == "event" && recorderType == "cvr") {
          //event
          camera.addServiceType = "event";
        } else if (recorderType != "0d" && recordType == "24h" && recorderType == "cvr") {
          //24h
          camera.addServiceType = "24h";
        } else {
          camera.addServiceType = "else";
        }
      });
      $scope.currentGroup = res;
      $scope.groupLoading = false;
    }, function (err, status) {
      $scope.$root.createSessionDlg();
      $scope.groupLoading = false;
    });
  }
  function getSharedGroupDetail(groupId) {
    var param = Object.assign($scope.searchParam || {}, {
      groupId: $state.params.groupId,
      pageNumber: $scope.pagingUtil.pageNumber()
    });
    CameraGroup.getSharedGroupDetailV2(param, function (res) {
      if (res) {
        if (res.hasOwnProperty("subgroups")) {
          res["subGroups"] = res["subgroups"];
          delete res["subgroups"];
        }
        res["root"] = $scope.$parent.groups.some(function (group) {
          return res.groupId === group.groupId;
        });
      }
      $scope.pagingUtil.setTotalCount(res.totalCount);
      $scope.$parent.currentGroupId = groupId;
      $scope.currentGroup = res;
    }, function (err, status) {
      $scope.$root.createSessionDlg();
    });
  }
  function makeFullModeCamList() {
    $scope.fullCamWidth = screen.width / 4 - 4;
    $scope.fullCamHeight = screen.height / 4 - 4;
    $scope.fullModeCameras = Array(16).fill({});
    if (!$scope.currentGroup || !$scope.currentGroup.cameras) {
      return;
    }
    $scope.currentGroup.cameras.forEach(function (camera, index) {
      if (index < 16) {
        $scope.fullModeCameras[index] = {
          id: camera.id,
          recorderType: camera.recorderType,
          thumbnailPath: camera.thumbnailPath,
          labelName: camera.labelName
        };
      }
    });
  }
  function updateFullModeCamThumb() {
    if (!$state.params.groupId) {
      return;
    }
    var updateThumb = function updateThumb(cameras) {
      if (!cameras || !$scope.fullModeCameras) {
        return;
      }
      var targetCam;
      for (var i = 0, len = cameras.length; i < len; i += 1) {
        targetCam = _.find($scope.fullModeCameras, {
          id: cameras[i].id
        });
        if (targetCam) {
          targetCam.thumbnailPath = cameras[i].thumbnailPath;
        }
      }
    };
    if ($state.params.shareId) {
      CameraGroup.getSharedGroupDetail({
        groupId: $state.params.groupId
      }, function (res) {
        updateThumb(res.cameras);
      });
    } else {
      CameraGroup.getGroupDetail({
        groupId: $state.params.groupId
      }, function (res) {
        updateThumb(res.cameras);
      });
    }
  }
  $scope.settingOpenCallback = function (_ref) {
    var isOpen = _ref.isOpen,
      cameraData = _ref.cameraData,
      isShared = _ref.isShared;
    $scope.$apply(function () {
      $scope.isCameraSettingOpen = isOpen;
      $scope.currentCamera = cameraData;
      angular.extend($scope.currentCamera, {
        isShared: isShared
      });
    });
  };
  function startUpdateFullModeCamThumb() {
    if (updateThumbIntervalId) {
      $interval.cancel(updateThumbIntervalId);
      updateThumbIntervalId = null;
    }
    updateThumbIntervalId = $interval(updateFullModeCamThumb, 5000);
  }
  function stopUpdateFullModeCamThumb() {
    if (updateThumbIntervalId) {
      $interval.cancel(updateThumbIntervalId);
      updateThumbIntervalId = null;
    }
  }
  function isFullScreen() {
    return !!(document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement);
  }
  function fullscreenHandler() {
    if (isFullScreen()) {} else {
      stopUpdateFullModeCamThumb();
      $scope.fullScreenMode = false;
      $scope.$apply();
    }
  }
  function windowKeyDownListener(event) {
    if (keyList.length < 8) {
      keyList.push(event.key);
      if (keyList[0] == todayKey[0] && keyList[1] == todayKey[1] && keyList[2] == todayKey[2] && keyList[3] == todayKey[3] && keyList[4] == todayKey[4] && keyList[5] == todayKey[5] && keyList[6] == todayKey[6] && keyList[7] == todayKey[7]) {
        $scope.showFullScreenBtn = true;
        $scope.$apply();
      }
    } else {
      keyList = [];
      keyList.push(event.key);
    }
  }
  $scope.countryDomain = $("html").attr("lang");
  $scope.fullScreenMode = false;
  window.addEventListener("keydown", windowKeyDownListener, false);
  document.addEventListener("webkitfullscreenchange", fullscreenHandler, false);
  document.addEventListener("mozfullscreenchange", fullscreenHandler, false);
  document.addEventListener("fullscreenchange", fullscreenHandler, false);
  document.addEventListener("MSFullscreenChange", fullscreenHandler, false);
  $scope.$on("$destroy", function () {
    stopUpdateFullModeCamThumb();
    window.removeEventListener("keydown", windowKeyDownListener, false);
    document.removeEventListener("webkitfullscreenchange", fullscreenHandler, false);
    document.removeEventListener("mozfullscreenchange", fullscreenHandler, false);
    document.removeEventListener("fullscreenchange", fullscreenHandler, false);
    document.removeEventListener("MSFullscreenChange", fullscreenHandler, false);
  });

  /**
   * 그룹 카메라 추가 팝업 open
   */
  $scope.showGroupCameraAddDialog = function () {
    $scope.isShowGroupCameraAddDialog = true;
  };

  /**
   * 그룹 카메라 추가 팝업 close
   */
  $scope.hideGroupCameraAddDialog = function () {
    $scope.isShowGroupCameraAddDialog = false;
  };

  /**
   * 하위 그룹 화면으로 이동
   * @param  {Object} group
   */
  $scope.goSubGroup = function (group, shareId) {
    if (group) {
      $state.go("main.cameraGroup.group", {
        groupId: group.groupId,
        shareId: shareId
      });
    }
  };

  /**
   * 카메라 상세 페이지로 이동
   * @param  {String} cameraId
   * @param  {String} recorderType
   */
  $scope.goDetail = function (cameraId, recorderType) {
    var shopId = $scope.$parent.findShopId(cameraId);
    if ($state.params.shareId) {
      $state.go("main.cameraDetail", {
        cameraId: cameraId,
        type: "sharedgroup",
        id: $scope.$parent.currentGroupId,
        shopId: shopId,
        shared: true
      });
    } else {
      $state.go("main.cameraDetail", {
        cameraId: cameraId,
        type: "group",
        id: $scope.$parent.currentGroupId,
        shopId: shopId
      });
    }
  };

  /**
   * 카메라 순서변경 팝업 open
   */
  $scope.showCameraOrderChangeDialog = function () {
    if ($scope.currentGroup && $scope.currentGroup.cameras) {
      $scope.cameraOrderList = angular.copy($scope.currentGroup.cameras);
    } else {
      $scope.cameraOrderList = [];
    }
    $scope.isShowCameraOrderChangeDialog = true;
  };

  /**
   * 카메라 순서변경 팝업 close
   */
  $scope.hideCameraOrderChangeDialog = function () {
    $scope.isShowCameraOrderChangeDialog = false;
  };

  /**
   * 카메라 순서 변경 Up
   * @param  {Number} step
   */
  $scope.changeOrderUp = function (step) {
    if ($scope.cameraOrderList && $scope.cameraOrderList.length) {
      var tempArray = angular.copy($scope.cameraOrderList);
      if (step === -1) {
        for (var i = 0; i < tempArray.length; i++) {
          if (tempArray[i].isChecked && i + step !== -1 && !$scope.cameraOrderList[i + step].isChecked) {
            $scope.cameraOrderList[i] = $scope.cameraOrderList.splice(i + step, 1, tempArray[i])[0];
          }
        }
      } else {
        var checkedArr = _.remove($scope.cameraOrderList, function (value) {
          return value.isChecked;
        });
        $scope.cameraOrderList = checkedArr.concat($scope.cameraOrderList);
      }
    }
  };

  /**
   * 카메라 순서 변경 Down
   * @param  {Number} step
   */
  $scope.changeOrderDown = function (step) {
    if ($scope.cameraOrderList && $scope.cameraOrderList.length) {
      var tempArray = angular.copy($scope.cameraOrderList);
      for (var i = tempArray.length - 1; 0 <= i; i--) {
        if (step === 1) {
          if (tempArray[i].isChecked && i + step < tempArray.length && !$scope.cameraOrderList[i + step].isChecked) {
            $scope.cameraOrderList[i] = $scope.cameraOrderList.splice(i + step, 1, tempArray[i])[0];
          }
        } else {
          var checkedArr = _.remove($scope.cameraOrderList, function (value) {
            return value.isChecked;
          });
          $scope.cameraOrderList = $scope.cameraOrderList.concat(checkedArr);
        }
      }
    }
  };

  /**
   * 카메라 순서 변경 저장
   */
  $scope.saveCameraOrderChange = function () {
    var groupId = $state.params.groupId;
    if ($scope.cameraOrderList && $scope.cameraOrderList.length) {
      CameraGroup.orderChange({
        groupId: groupId
      }, {
        cameraIds: _.map($scope.cameraOrderList, "id").join(",")
      }, function (res) {
        $scope.hideCameraOrderChangeDialog();
        if ($state.params.shareId) {
          getSharedGroupDetail(groupId);
        } else {
          getGroupDetail(groupId);
        }
      }, function (err) {
        showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
      });
    } else {
      $scope.hideCameraOrderChangeDialog();
    }
  };

  /**
   * 그룹 공유
   */
  $scope.showGroupShareDialog = function (isShow) {
    $scope.isShowGroupShareDialog = isShow;
  };

  /**
   * 전체 화면
   */
  $scope.enterFullScreen = function () {
    if (Utils.isIE()) {
      var ua = navigator.userAgent;
      var re = new RegExp("MSIE ([0-9]{1,}[.0-9]{0,})");
      var match = re.exec(ua);
      var rv = match ? parseFloat(match[1]) : 0;
      if (rv !== 0 && rv <= 10) {
        showAlert($translate.instant("EXPLORE_UNDER10_SUBJECT"), "".concat($translate.instant("EXPLORE_UNDER10_CONTENT1"), "<br>\n            ").concat($translate.instant("EXPLORE_UNDER10_CONTENT2"), "<br>\n            ").concat($translate.instant("EXPLORE_UNDER10_CONTENT3")));
        return;
      }
    }
    $scope.fullScreenMode = true;
    var element = document.getElementById("fullscreen");
    var requestFullScreen = element.requestFullscreen || element.mozRequestFullScreen || element.webkitRequestFullscreen || element.msRequestFullscreen;
    if (requestFullScreen) {
      requestFullScreen.call(element);
    }
    if (document.getElementById("footer")) document.getElementById("footer").style.display = "none";
    if (document.getElementById("header")) document.getElementById("header").style.display = "none";
    makeFullModeCamList();
    startUpdateFullModeCamThumb();
  };
}]);
"use strict";

app.controller("GroupLnbCtrl", ["$scope", "$rootScope", "$state", "$translate", "$timeout", "$stateParams", "$sessionStorage", "Utils", function ($scope, $rootScope, $state, $translate, $timeout, $stateParams, $sessionStorage, Utils) {
  $scope.state = $state;
  $scope.stateParams = $stateParams;
  $scope.searchSelectedGroupId = "";
  $scope.storage = $sessionStorage;
  $scope.countryDomain = $("html").attr("lang");
  $scope.selectedOrderType = "";
  $scope.ORDER_TYPE_ENUM = {
    REG_ASC: "1",
    REG_DESC: "2",
    NAME_ASC: "3",
    NAME_DESC: "4"
  };
  var searchObj = null;
  var orderDropObj = null;
  function buildSearchCameraMap(groups, keyword) {
    var lowerKeyword = keyword.toLowerCase(),
      searchCamMap = {};
    var searchCamera = function searchCamera(cameras, group, upperGroup) {
      cameras.forEach(function (camera) {
        if (searchCamMap[camera.id]) {
          searchCamMap[camera.id].groups.push({
            id: group.groupId,
            name: upperGroup ? upperGroup.groupName + " > " + group.groupName : group.groupName,
            shareId: upperGroup ? upperGroup.shareId : group.shareId,
            upperId: upperGroup ? upperGroup.groupId : "",
            subgroupPermission: group.subgroupPermission,
            groupPermission: group.groupPermission
          });
        } else {
          if (camera.labelName.toLowerCase().indexOf(lowerKeyword) != -1 || camera.serialNo.toLowerCase().indexOf(lowerKeyword) != -1) {
            searchCamMap[camera.id] = {
              name: camera.labelName,
              serial: camera.serialNo,
              thumbnail: camera.thumbnailPath,
              groups: [{
                id: group.groupId,
                name: upperGroup ? upperGroup.groupName + " > " + group.groupName : group.groupName,
                shareId: upperGroup ? upperGroup.shareId : group.shareId,
                upperId: upperGroup ? upperGroup.groupId : "",
                subgroupPermission: group.subgroupPermission,
                groupPermission: group.groupPermission
              }]
            };
          }
        }
      });
    };
    groups.forEach(function (group) {
      searchCamera(group.cameras, group);
      if (group.subGroups) {
        group.subGroups.forEach(function (subgroup) {
          searchCamera(subgroup.cameras, subgroup, group);
        });
      }
    });
    return Object.keys(searchCamMap).length ? searchCamMap : null;
  }
  function globalClickCallback(event) {
    if (event.target.className.indexOf("drops_element") === -1 && event.target.className.indexOf("drop_btn") === -1) {
      if (orderDropObj) {
        orderDropObj.value = false;
      }
    }
  }
  function searchHandler(event) {
    if ($scope.$parent.searchKeyword != event.value) {
      $scope.$parent.searchKeyword = event.value;
      if ($scope.$parent.searchKeyword) {
        $scope.$parent.searchCamMap = buildSearchCameraMap(JSON.parse(JSON.stringify($scope.$parent.groups)), $scope.$parent.searchKeyword);
      }
      $scope.$apply();
      $timeout(function () {
        $(".g_list_lazy").Lazy({
          appendScroll: $(".group_list_scroll"),
          visibleOnly: true,
          onError: function onError(element) {
            element.attr("src", "/resources/img/img_camera_fail.svg");
          }
        });
      }, 0);
    }
  }
  function dropdownHandler(event) {}
  searchObj = tCam.search("search_group");
  searchObj.on("changed", searchHandler);
  searchObj.placeholder = $translate.instant("9rRqk7Vo_02163");
  searchObj.design = "search";
  searchObj.boxStyle = {
    width: "228px",
    height: "44px",
    border: "1px solid #f5f5f5",
    borderRadius: "6px",
    backgroundColor: "#f5f5f5",
    marginTop: "16px"
  };
  searchObj.value = "";
  orderDropObj = tCam.dropdown("group_order_dropdown");
  orderDropObj.on("changed", dropdownHandler);
  orderDropObj.dropElementId = "group_order_list";
  orderDropObj.dropPosition = "left";
  $scope.$on("$destroy", function () {
    $("body").off("click", globalClickCallback);
    if (searchObj) {
      searchObj.destroy();
      searchObj = null;
    }
    if (orderDropObj) {
      orderDropObj.destroy();
      orderDropObj = null;
    }
  });
  $scope.selectedOrderType = getOrderTypeFromLocalStorage();
  $scope.showShopSearchInput = function (isShow) {
    if (!$scope.$parent.groups || !$scope.$parent.groups.length) {
      return;
    }
    $scope.$parent.searchCamMap = null;
    $scope.$parent.searchKeyword = "";
    if (isShow && searchObj) {
      searchObj.value = "";
      setTimeout(function () {
        searchObj.setFocus();
      }, 0);
    }
    if (orderDropObj) {
      orderDropObj.value = false;
    }
  };

  /* GROUP ORDERING */
  function getOrderTypeFromLocalStorage() {
    var clientUid = "";
    if ($rootScope.me && $rootScope.me.uid) {
      clientUid = $rootScope.me.uid;
    }
    var itemKey = "GROUP_ORDERING_" + clientUid,
      orderData = localStorage.getItem(itemKey);
    if (orderData) {
      return orderData;
    } else {
      return $scope.ORDER_TYPE_ENUM.REG_ASC;
    }
  }
  function setOrderTypeFromLocalStorage(type) {
    var clientUid = "";
    if ($rootScope.me && $rootScope.me.uid) {
      clientUid = $rootScope.me.uid;
    }
    var itemKey = "GROUP_ORDERING_" + clientUid;
    localStorage.setItem(itemKey, type);
  }
  $scope.goCameraView = function (cameraId, camera) {
    var shopId = $scope.$parent.findShopId(cameraId);
    var group = (camera.groups || [])[0];
    if (group && group.shareId) {
      $state.go("main.cameraDetail", {
        cameraId: cameraId,
        type: "sharedgroup",
        id: group.id,
        shopId: shopId,
        shared: true
      });
    } else {
      $state.go("main.cameraDetail", {
        cameraId: cameraId,
        type: "group",
        id: group.id,
        shopId: shopId
      });
    }
  };
  $scope.groupOrderingByType = function (groupList, type) {
    $scope.selectedOrderType = type;
    setOrderTypeFromLocalStorage($scope.selectedOrderType);
    if (orderDropObj) {
      orderDropObj.value = false;
    }
    if (!groupList || !groupList.length) {
      return;
    }
    if (type === $scope.ORDER_TYPE_ENUM.REG_ASC) {
      groupList.sort(function (a, b) {
        if (!!a.shareId === !!b.shareId) {
          var aLabel, bLabel;
          aLabel = a.groupName.toLowerCase();
          bLabel = b.groupName.toLowerCase();
          return aLabel < bLabel ? -1 : aLabel > bLabel ? 1 : 0;
        } else {
          return !!a.shareId ? 1 : -1;
        }
      });
    } else if (type === $scope.ORDER_TYPE_ENUM.REG_DESC) {
      groupList.sort(function (a, b) {
        if (!!a.shareId === !!b.shareId) {
          var aLabel, bLabel;
          aLabel = a.groupName.toLowerCase();
          bLabel = b.groupName.toLowerCase();
          return aLabel > bLabel ? -1 : aLabel < bLabel ? 1 : 0;
        } else {
          return !!a.shareId ? 1 : -1;
        }
      });
    } else if (type === $scope.ORDER_TYPE_ENUM.NAME_ASC) {
      groupList.sort(function (a, b) {
        if (!!a.shareId === !!b.shareId) {
          return a.regDate > b.regDate ? -1 : a.regDate < b.regDate ? 1 : 0;
        } else {
          return !!a.shareId ? 1 : -1;
        }
      });
    } else if (type === $scope.ORDER_TYPE_ENUM.NAME_DESC) {
      groupList.sort(function (a, b) {
        if (!!a.shareId === !!b.shareId) {
          return a.regDate < b.regDate ? -1 : a.regDate > b.regDate ? 1 : 0;
        } else {
          return !!a.shareId ? 1 : -1;
        }
      });
    } else {
      groupList.sort(function (a, b) {
        if (!!a.shareId === !!b.shareId) {
          return a.regDate > b.regDate ? -1 : a.regDate < b.regDate ? 1 : 0;
        } else {
          return !!a.shareId ? 1 : -1;
        }
      });
    }
  };
  $scope.selectGroup = function (group) {
    $scope.showShopSearchInput(false);
    $scope.searchSelectedGroupId = group.id;
    if (typeof $scope.storage.openGroups === "undefined") {
      $scope.storage.openGroups = {};
    }
    _.set($scope.storage.openGroups, group.upperId ? group.upperId : group.id, true);
    $state.go("main.cameraGroup.group", {
      groupId: group.id,
      shareId: group.shareId
    });
    setTimeout(function () {
      var $selected = $("#all_group_list .isSearchSelect");
      if ($selected.length) {
        $("#all_group_list .isSearchSelect")[0].scrollIntoView();
      }
    }, 500);
  };

  /**
   * 하위 그룹 토글 및 그룹 상세 호출
   * @param  {Object} group
   */
  $scope.toggleSubGroup = function (group) {
    $scope.$parent.currentGroupId = group.groupId;
    $scope.searchSelectedGroupId = "";
    $scope.$parent.searchKeyword = "";
    searchObj.value = "";
    if (typeof $scope.storage.openGroups === "undefined") {
      $scope.storage.openGroups = {};
    }
    _.set($scope.storage.openGroups, group.groupId, true);
    $state.go("main.cameraGroup.group", {
      groupId: group.groupId,
      shareId: group.shareId
    }, {
      reload: "main.cameraGroup.group"
    });
  };
  $scope.toggleSubGroupOpen = function (groupId, event) {
    if (typeof $scope.storage.openGroups === "undefined") {
      $scope.storage.openGroups = {};
    }
    if (_.get($scope.storage.openGroups, groupId)) {
      _.set($scope.storage.openGroups, groupId, false);
    } else {
      _.set($scope.storage.openGroups, groupId, true);
    }
    event.stopPropagation();
  };
  $scope.parentGroupOpen = function (groupId) {
    _.set($scope.storage.openGroups, groupId, true);
  };
  $scope.initSubGroupOpen = function (groupId) {
    var parentId = $("#" + groupId).attr("name");
    if (parentId) {
      $scope.parentGroupOpen(parentId);
    }
  };
  $scope.goAllCameras = function () {
    $state.go("main.cameraGroup.cameras");
  };

  /**
   * 그룹 상세 화면으로 이동
   * @param  {Object} group
   */
  $scope.goGroup = function (group) {
    $scope.$parent.currentGroupId = group.groupId;
    $scope.searchSelectedGroupId = "";
    $scope.$parent.searchKeyword = "";
    searchObj.value = "";
    $state.go("main.cameraGroup.group", {
      groupId: group.groupId,
      shareId: group.shareId
    }, {
      reload: "main.cameraGroup.group"
    });
  };

  /**
   * 하위 그룹 open 확인
   * @return {[type]} [description]
   */
  $scope.openGroup = function (groupId) {
    return _.get($scope.storage.openGroups, groupId);
  };
  $scope.$parent.$watch("groups", function (newValue, oldValue) {
    if (newValue && $scope.selectedOrderType) {
      $scope.groupOrderingByType(newValue, $scope.selectedOrderType);
    }
    if (orderDropObj) {
      if (!newValue || !newValue.length) {
        orderDropObj.active = false;
      } else {
        orderDropObj.active = true;
      }
    }
  });
  $("body").on("click", globalClickCallback);
  (function () {
    var groupId = $state.params.groupId;
    if (groupId != "") {
      $scope.parentGroupOpen(groupId);
    }
    $timeout(function () {
      if (Utils.isChrome() || Utils.isOpera()) {
        $("#snb_b2b").css("paddingBottom", "200px");
        $("#group_inr").css("paddingBottom", 0);
      }
    }, 0);
  })();
}]);
"use strict";

app.controller('CameraGuideAccess', ['$scope', function ($scope) {
  var lang = $("html").attr("lang");
  if (lang === "ja") {} else {}
}]);
"use strict";

app.controller('CameraGuideShop', ['$scope', function ($scope) {
  var lang = $("html").attr("lang");
  if (lang === "ja") {} else {}
}]);
"use strict";

app.controller('CameraGuideWifi', ['$scope', function ($scope) {
  var lang = $("html").attr("lang");
  if (lang === "ja") {} else {}
}]);
"use strict";

app.controller('GuideMenuCtrl', ['$scope', '$state', function ($scope, $state) {
  $scope.currentStateName = $state.current.name;
  var lang = $("html").attr("lang");
  if (lang === "ja") {
    $scope.isShowCS = false;
  } else {
    $scope.isShowCS = true;
  }
}]);
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
app.controller("ClipListCtrl", ["$scope", "$rootScope", "User", "Clip", "$translate", "$timeout", "$window", "$q", "Utils", "$location", function ($scope, $rootScope, User, Clip, $translate, $timeout, $window, $q, Utils, $location) {
  showPage2();
  var DEFAULT_CLIP_SIZE = 4;
  var DEFAULT_CAMERA_CLIP_COUNT = 5;
  var initQueryType = $location.search().type;
  if (initQueryType !== "date" && initQueryType !== "cameraid") {
    $location.search("type", null);
  }
  $scope.selectTab = initQueryType;
  $scope.showClipNameListFlag = false;
  $scope.clipNameList = [];
  $scope.isLoadCams = false;
  $scope.isLoadingExtraClip = false;
  $scope.isLoadingCameraClip = false;
  $scope.isLastCameraClip = false;
  $scope.cameraClipObserver = null;
  $scope.currentRequest = null;
  $scope.searchParam = {
    keyword: "",
    clipSelectMonth: new Date()
  };
  $scope.browserLanguage = Utils.getBrowserLanguage();
  $scope.validator = function () {
    return !!$scope.searchParam.keyword;
  };
  $scope.setClipSelectMonth = function (date) {
    $scope.searchParam.clipSelectMonth = date;
    $scope.timelineDatePicker.dates[0] = date.getTime();
    $scope.timelineDatePicker.refresh();
  };
  $scope.equalDate = function (dateA, dateB) {
    var prev = dateA.getYear() + "" + dateA.getMonth();
    var next = dateB.getYear() + "" + dateB.getMonth();
    return prev === next;
  };
  $scope.onSelected = function (data) {
    if (!$scope.equalDate($scope.searchParam.clipSelectMonth, data.detail.date)) {
      $scope.setClipSelectMonth(data.detail.date);
      $scope.$apply();
      $scope.loadClipList();
    }
  };
  $scope.moveMonth = function (number) {
    var newDate = moment($scope.searchParam.clipSelectMonth).add(number, "M").toDate();
    $scope.setClipSelectMonth(newDate);
    $scope.timelineDatePicker.update();
    $scope.loadClipList();
  };
  $scope.visibleNextMonth = function () {
    return new Date() > moment($scope.timelineDatePicker.picker.viewDate).day(1).add(1, "M").add(-1, "d").format("x");
  };
  var initCalendar = function initCalendar() {
    var inputMonthpicker = document.getElementById("monthpicker");
    var nowMonthLastDay = moment().day(1).add(1, "M").add(-1, "d").format("x");
    $scope.timelineDatePicker = new Datepicker(inputMonthpicker, {
      startView: 1,
      // month
      pickLevel: 1,
      // month
      language: window.navigator.language,
      prevArrow: "",
      nextArrow: "",
      autohide: true,
      maxDate: nowMonthLastDay // 오늘 기준 다음 달 이후 날짜 선택 금지
    });
    inputMonthpicker.addEventListener("changeMonth", function (e) {
      $scope.onSelected(e);
    });
  };
  initCalendar();
  var getMediaUrl = function getMediaUrl(clip) {
    var _clip$origin;
    if (clip !== null && clip !== void 0 && (_clip$origin = clip.origin) !== null && _clip$origin !== void 0 && _clip$origin.filePath) {
      var filePath = clip.origin.filePath;
      var port = location.port ? ":".concat(location.port) : "";
      return "".concat(location.protocol, "//").concat(filePath.replace(".com/", ".com".concat(port, "/")));
    }
    return $scope.mediaUrl;
  };
  var getThumbnailPath = function getThumbnailPath(d) {
    if (parseInt(d.status) === 4 || parseInt(d.status) === 5) {
      if (location.port !== "") {
        return location.protocol + "//" + d.thumbnailPath.replace(".com/", ".com:" + location.port + "/");
      } else {
        return location.protocol + "//" + d.thumbnailPath;
      }
    } else if (parseInt(d.status) >= 0 && parseInt(d.status) <= 2) {
      return $translate.instant("CLIPS_NOW_CREATING_IMG");
    } else if (parseInt(d.status) === 3) {
      return $translate.instant("CLIPS_NOW_CREATING_FAIL_IMG");
    }
  };
  var getVideoUrl = function getVideoUrl(d) {
    if (location.port !== "") {
      return location.protocol + "//" + d.filePath.replace(".com/", ".com:" + location.port + "/");
    } else {
      return location.protocol + "//" + d.filePath;
    }
  };
  $scope.downloadClip = function (clip) {
    var _clip$origin2, _clip$origin3;
    var clipStatus = (clip === null || clip === void 0 ? void 0 : (_clip$origin2 = clip.origin) === null || _clip$origin2 === void 0 ? void 0 : _clip$origin2.status) !== undefined ? clip.origin.status : $scope.currentClip.status;
    var clipName = (clip === null || clip === void 0 ? void 0 : (_clip$origin3 = clip.origin) === null || _clip$origin3 === void 0 ? void 0 : _clip$origin3.labelName) !== undefined ? clip.origin.labelName : $scope.clipName;
    var mediaUrl = getMediaUrl(clip);
    if (clipStatus != "4" && clipStatus != "5") {
      showAlert($translate.instant("BUTTON_DOWNLOAD"), $translate.instant("CAMERA_CLIP_DOWNLOAD_POSSIBLE"));
      return;
    }
    if ($rootScope.me && $rootScope.me.country === "JP") {
      if (mediaUrl.indexOf("?") === -1) {
        $window.location.href = mediaUrl + "?" + encodeURIComponent(clipName);
      } else {
        $window.location.href = mediaUrl + "&" + encodeURIComponent(clipName);
      }
    } else {
      $window.location.href = (typeof mediaUrl === "string" ? mediaUrl.split("?")[0] : "") + "?" + encodeURIComponent(clipName);
    }
  };
  $scope.getContextPath = Utils.getContextPath();
  $scope.toggleTimelineCalendar = function ($event) {
    if ($scope.timelineDatePicker) {
      $scope.timelineDatePicker.active ? $scope.timelineDatePicker.hide() : $scope.timelineDatePicker.show();
    }
    $event.preventDefault();
  };
  $scope.me = User.me(function () {
    $scope.isLogin = true;
  });
  var showAlert = function showAlert(title, message) {
    $scope.showAlert = true;
    $scope.alertTitle = title;
    $scope.alertMessage = message;
  };
  var clipPlayer = null;
  var oldScorll = 0;
  $scope.$on("$destroy", function () {
    if (clipPlayer) {
      clipPlayer.destroy();
      clipPlayer = null;
    }
    if ($scope.timelineDatePicker) $scope.timelineDatePicker.destroy();
  });
  var makeParam = function makeParam(type) {
    var param = {};
    if (type === "date") {
      param.group = type;
      var nowDate = $scope.searchParam.clipSelectMonth;
      var startDate = new Date(nowDate.getFullYear(), nowDate.getMonth(), 1).getTime();
      var endDate = new Date(new Date(nowDate.getFullYear(), nowDate.getMonth() + 1, 1) - 1).getTime();
      param.start = startDate;
      param.end = endDate;
    } else {
      param.keyword = $scope.searchParam.keyword;
      param.groupedClipSize = DEFAULT_CLIP_SIZE;
      param.size = DEFAULT_CAMERA_CLIP_COUNT;
    }
    return param;
  };
  $scope.changeEvent = function () {
    if (!$scope.searchParam.keyword) {
      $scope.clipNameList.splice(0, $scope.clipNameList.length);
      return;
    }
  };
  $scope.clickButtonEvent = function ($event) {
    if (!$scope.validator()) {
      showAlert("", $translate.instant("PLEASE_SEARCH_PARAMETER"));
      return false;
    }
    $scope.loadClipList();
    $event.preventDefault();
  };
  $scope.keydownEvent = function ($event) {
    if (!$event.key) {
      $event.preventDefault();
      return false;
    }
    if ($event.key === "\\") {
      $event.preventDefault();
      return false;
    }
    if ($event.key === "Enter") {
      if (!$scope.validator()) {
        showAlert("", $translate.instant("PLEASE_SEARCH_PARAMETER"));
        return false;
      }
      $scope.loadClipList();
      $event.preventDefault();
      return;
    }
    var prevValue = $scope.searchParam.keyword;
    $timeout(function () {
      var currValue = $scope.searchParam.keyword;
      if (currValue && prevValue !== currValue) {
        $scope.loadClipNameList();
      }
    }, 0);
  };
  $scope.loadClipNameList = function () {
    var param = makeParam($scope.selectTab);
    param.limitSize = 10;
    Clip.getClipCameraListV2(param, function (data) {
      $scope.clipNameList.splice(0);
      $scope.clipNameList = $scope.clipNameList.concat(data.cameras);
      if ($scope.clipNameList.length !== 0) {
        $timeout(function () {
          $scope.$apply();
          $scope.showClipNameListFlag = true;
        }, 0);
      }
    });
  };
  $scope.clickClipName = function (clipName) {
    $scope.searchParam.keyword = clipName;
    $scope.loadClipList();
  };
  $scope.loadClipList = function () {
    $scope.isLoadCams = false;
    $scope.cliplistShow = true;
    $scope.showClipNameListFlag = false;
    if ($scope.selectTab === undefined) {
      $scope.selectTab = "date";
    }
    var param = makeParam($scope.selectTab);
    if ($scope.selectTab === "date") {
      var promise1 = Clip.getClipListV2(param).$promise;
      promise1.then(function (data) {
        processClipsData(data.clips);
        $scope.isLoadCams = true;
      }, function (err) {
        $scope.$root.createSessionDlg();
      });
    } else {
      var _promise = Clip.getClipListByCamera(param).$promise;
      if ($scope.isLoadingCameraClip) {
        $scope.isLoadingCameraClip = false;
      }
      $scope.isLoadingCameraClip = true;
      _promise.then(function (data) {
        var result = data.data;
        if (!result.content.length) {
          showAlert("", $translate.instant("STR_NO_SEARCH_RESULT"));
        }
        processClipsData(result.content);
        $scope.isLastCameraClip = result.last;
        $scope.isLoadCams = true;
        $scope.isLoadingCameraClip = false;
        watchClipListUpdate();
      }, function (err) {
        $scope.$root.createSessionDlg();
      });
    }
  };
  var formattingClip = function formattingClip(clip, clipGroup) {
    var formattedClips = {};
    if (clipGroup !== "cameraId" && clipGroup !== "shop" && clipGroup !== "date") {
      return {};
    }
    if (clipGroup === "cameraId" || clipGroup === "shop") {
      formattedClips.title = clip.label || clip.labelName;
      formattedClips.sizeOfItems = clip.sizeOfItems;
      formattedClips.cameraId = clip.cameraId;
    } else {
      var m = moment(clip.date);
      formattedClips.title = m.locale(Utils.getBrowserLanguage()).format("YYYY.MM.DD dddd");
    }
    if (clip.group === "cameraId" && clip.shareType != 0) {
      formattedClips.sharedCam = true;
    }
    if (clip.isShared !== undefined) {
      formattedClips.isShared = clip.isShared;
    }
    formattedClips.hasExtraClip = clip.items.length > 4;
    formattedClips.extraClipIsLoading = false;
    return formattedClips;
  };
  var formattingClipItem = function formattingClipItem(clipItem) {
    var formattedClip = {};
    formattedClip.origin = clipItem;
    var startMoment = moment(new Date(clipItem.start));
    formattedClip.formattedStart = startMoment.format("HH:mm:ss");
    formattedClip.formattedStartDate = startMoment.format("YYYY.MM.DD");
    var endMoment = moment(new Date(clipItem.end));
    formattedClip.formattedEnd = endMoment.format("HH:mm:ss");
    formattedClip.formattedEndDate = endMoment.format("YYYY.MM.DD");
    var makeMoment = moment(new Date(clipItem.regDate));
    formattedClip.formattedMakeDate = makeMoment.locale(Utils.getBrowserLanguage()).format("YYYY.MM.DD (ddd) HH:mm:ss");
    formattedClip.duration = $scope.timeCalcul(clipItem.outputDuration);
    formattedClip.targetDuration = Utils.durationStringFromTwoTime(0, clipItem.targetDuration * 1000);
    formattedClip.status = clipItem.status;
    formattedClip.thumbnailPath = getThumbnailPath(clipItem);
    if (Date.now() - clipItem.start <= 24 * 60 * 60 * 1000) {
      formattedClip.isNew = true;
    }
    return formattedClip;
  };
  var addCameraExtraClipList = function addCameraExtraClipList(detailClipList) {
    var targetCameraId = detailClipList[0].cameraId;
    var formattedDetailClipList = detailClipList.map(function (clip) {
      return formattingClipItem(clip);
    });
    var newClipList = $scope.clipsArray.map(function (clip) {
      if (clip.cameraId === targetCameraId) {
        var deepCopiedClip = JSON.parse(JSON.stringify(clip));
        deepCopiedClip.items = deepCopiedClip.items.concat(formattedDetailClipList);
        return deepCopiedClip;
      }
      return clip;
    });
    $scope.$apply(function () {
      $scope.clipsArray = newClipList;
    });
  };
  function updateCameraClipList(clipList, isLast) {
    if (!clipList.length) {
      $timeout(function () {
        $scope.isLoadingCameraClip = false;
        $scope.isLastCameraClip = isLast;
      });
      return;
    }
    $scope.isLoadingCameraClip = true;
    var tempClipsArray = $scope.clipsArray;
    var formattedList = clipList.map(function (clips, i) {
      var formattedClips = formattingClip(clips, clips.group);
      formattedClips.items = clips.items.map(function (d, j) {
        var formattedClipItem = formattingClipItem(d);
        return formattedClipItem;
      });
      return formattedClips;
    });
    $scope.clipsArray = [].concat(_toConsumableArray(tempClipsArray), _toConsumableArray(formattedList));
    $timeout(function () {
      $scope.isLastCameraClip = isLast;
      $scope.isLoadingCameraClip = false;
    });
  }
  var processClipsData = function processClipsData(data) {
    $scope.cliplistShow = !!data.length;
    $scope.clipsArray = data.map(function (clips, i) {
      var formattedClips = formattingClip(clips, clips.group);
      formattedClips.items = clips.items.map(function (d, j) {
        var formattedClipItem = formattingClipItem(d);
        return formattedClipItem;
      });
      return formattedClips;
    });

    // Lazy 로딩 최적화
    $timeout(function () {
      $(".lazy").Lazy({
        scrollDirection: "vertical",
        visibleOnly: true
      });

      // 클립 ID 존재 시 자동 재생
      var clipId = Utils.getParameters("clipId");
      if (clipId !== undefined) {
        $scope.clipDetail = true;
        $scope.playOpen(clipId);
      }
    }, 0);
  };
  $scope.loadCameraExtraClip = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(cameraId, lastClipId) {
      var targetClip, res;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            targetClip = $scope.clipsArray.find(function (item) {
              return item.cameraId === cameraId;
            });
            if (!targetClip.extraClipIsLoading) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return");
          case 3:
            if (targetClip) {
              targetClip.extraClipIsLoading = true;
              $timeout();
            }
            $scope.isLoadingExtraClip = true;
            _context.next = 7;
            return new Promise(function (resolve, reject) {
              Clip.getCameraClipList({
                cameraId: cameraId,
                lastId: lastClipId
              }, resolve, reject);
            });
          case 7:
            res = _context.sent;
            $timeout(function () {
              targetClip.extraClipIsLoading = false;
              addCameraExtraClipList(res.data.content);
            }, 500);
          case 9:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
  $scope.getInfiniteCameraClip = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(lastCameraId) {
      var param, res;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!$scope.isLoadingCameraClip) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return");
          case 2:
            $scope.isLoadingCameraClip = true;
            param = makeParam($scope.selectTab);
            if (lastCameraId) param.lastId = lastCameraId;
            _context2.next = 7;
            return new Promise(function (resolve, reject) {
              Clip.getClipListByCamera(param, resolve, reject);
            });
          case 7:
            res = _context2.sent;
            $timeout(function () {
              var _res$data;
              $scope.isLoadingCameraClip = false;
              updateCameraClipList(res.data.content, (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.last);
            }, 500);
          case 9:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x3) {
      return _ref2.apply(this, arguments);
    };
  }();
  function watchClipListUpdate() {
    function observeChanges() {
      var targetNode = document.getElementById("cameraIdClipList");
      if (!targetNode) {
        void 0;
        setTimeout(observeChanges, 100); // 100ms 후 다시 실행
        return;
      }
      var observer = new MutationObserver(function () {
        if ($scope.clipsArray && $scope.clipsArray.length > 0) {
          observer.disconnect();
          initInfiniteScroll();
        }
      });
      observer.observe(targetNode, {
        childList: true,
        subtree: true
      });
    }
    observeChanges(); // 최초 실행
  }
  function initInfiniteScroll() {
    function setupObserver() {
      var observerTarget = document.getElementById("cameraIdClipObserver");
      if (!observerTarget) {
        setTimeout(setupObserver, 100);
        return;
      }
      if ($scope.cameraClipObserver) {
        $scope.cameraClipObserver.disconnect();
      }
      var observer = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting && !$scope.isLoadingCameraClip) {
          var lastCameraId = $scope.clipsArray.length ? $scope.clipsArray[$scope.clipsArray.length - 1].cameraId : null;
          $scope.getInfiniteCameraClip(lastCameraId);
        }
      });
      observer.observe(observerTarget);
      $scope.cameraClipObserver = observer;
    }
    $timeout(function () {
      setupObserver();
    }, 0);
  }
  $scope.$watch("selectTab", function (newValue, oldValue) {
    $scope.loadClipList();
    if (newValue === "cameraid") {
      watchClipListUpdate();
    }
  });
  $scope.changeListOrder = function (order) {
    var queryType = order === "date" ? null : order;
    $location.search("type", queryType);
    $scope.selectTab = order;
    if (!$scope.isSearch()) {
      $scope.cliplistShow = false;
      $scope.clipsArray.splice(0, $scope.clipsArray.length);
      return;
    }
    $scope.loadClipList();
  };
  $scope.isSearch = function () {
    if ($scope.selectTab === "cameraid" && $scope.searchParam.keyword && !$scope.cliplistShow) return false;
    return true;
  };
  $scope.showClipDetail = function (clip) {
    $scope.playOpen(clip.origin.clipId);
  };
  $scope.playOpen = function (clipId) {
    // 이전 요청이 있다면 취소
    if ($scope.currentRequest && $scope.currentRequest.$cancelRequest) {
      $scope.currentRequest.$cancelRequest();
    }

    // 즉시 UI 초기화 (이전 클립 정보 제거)
    $scope.currentClip = {};
    $scope.clipDetail = false;

    // 새로운 요청 시작
    $scope.currentRequest = Clip.get({
      id: clipId
    }, function (d) {
      $(".display_show").css("display", "");
      // 요청이 완료되었으므로 currentRequest 초기화
      $scope.currentRequest = null;
      oldScorll = $(document).scrollTop();
      $scope.currentClip.origin = d;
      $scope.currentClip.clipName = d.labelName;
      $scope.currentClip.regDate = d.regDate;
      $scope.currentClip.duration = $scope.timeCalcul(d.outputDuration);
      $scope.currentClip.targetDuration = Utils.durationStringFromTwoTime(0, d.targetDuration * 1000);
      $scope.currentClip.status = d.status;
      $scope.currentClip.hasClipPermission = d.hasClipPermission;
      $scope.currentClip.thumbnailPath = getThumbnailPath(d);
      if (Date.now() - d.start <= 24 * 60 * 60 * 1000) {
        $scope.currentClip.isNew = true;
      }
      $scope.clipName = d.labelName;
      var videoUrl = getVideoUrl(d);
      $scope.mediaUrl = videoUrl;
      $scope.currentClip.shared = d.shared;
      $scope.clipDetail = true;
      createClipPlayer();
    }, function (error) {
      // 에러 처리 (요청이 취소된 경우 포함)
      $scope.currentRequest = null;
      void 0;
    });
  };
  var createClipPlayer = function createClipPlayer() {
    // 플레이어 생성 전에 한번 더 체크
    if (!$scope.currentClip.origin) {
      return;
    }
    var clipElId = "clip_player";

    // 기존 플레이어 정리
    if (clipPlayer) {
      clipPlayer.destroy && clipPlayer.destroy();
    }
    clipPlayer = tCam.clipplayer({
      elId: clipElId,
      videoUrl: $scope.mediaUrl,
      durationStr: $scope.currentClip.duration,
      clipStatus: $scope.currentClip.origin.status,
      thumbnailPath: $scope.currentClip.origin.thumbnailPath,
      startTime: $scope.currentClip.origin.start,
      endTime: $scope.currentClip.origin.end
    });
  };
  $scope.hideClipDetail = function () {
    if (location.hash.indexOf("clipId") !== -1) {
      location.href = "/#/clips";
    }
    $scope.isEditingClip = false;
    $scope.clipDetail = false;
    $scope.currentClip = undefined;
    if (clipPlayer) {
      clipPlayer.destroy();
      clipPlayer = null;
    }
  };
  $scope.cancelEditClip = function () {
    $scope.isEditingClip = false;
  };
  $scope.deleteClipConfirm = function (clip) {
    $scope.clipDel = true;
    if (!$scope.currentClip && clip) {
      $scope.currentClip = clip;
    }
    $("#clipDel").css("top", oldScorll + 350);
  };
  $scope.deleteClip = function () {
    var _$scope$currentClip, _$scope$currentClip$o, _$scope$currentClip2;
    var clipId = ((_$scope$currentClip = $scope.currentClip) === null || _$scope$currentClip === void 0 ? void 0 : (_$scope$currentClip$o = _$scope$currentClip.origin) === null || _$scope$currentClip$o === void 0 ? void 0 : _$scope$currentClip$o.clipId) || ((_$scope$currentClip2 = $scope.currentClip) === null || _$scope$currentClip2 === void 0 ? void 0 : _$scope$currentClip2.clipId);
    Clip["delete"]({
      id: clipId
    }, function () {
      $scope.clipDetail = false;
      $scope.clipDel = false;
      if (clipPlayer) {
        clipPlayer.destroy();
        clipPlayer = null;
      }
      $scope.loadClipList();
    });
  };
  $scope.submittedClipName = function () {
    if ($scope.clipName.length > 30) {
      $scope.nameLengthOver = true;
      $("#nameLengthOver").css("top", $(document).scrollTop() + 200);
      return;
    }
    $scope.clipName = $("#clipName").val();
    $scope.currentClip.origin.labelName = $scope.clipName;
    Clip.update({
      id: $scope.currentClip.origin.clipId
    }, {
      labelName: $scope.clipName
    }, function () {
      $scope.cancelEditClip();
      $scope.loadClipList();
    });
  };
  $scope.handleImageError = function (imgElement) {
    imgElement.src = "/resources/img/img_camera_fail.svg";
    $scope.$apply();
  };
  $scope.timeCalcul = function (timeSec) {
    var absTimeSec = Math.abs(timeSec);
    var min = parseInt(absTimeSec / 60);
    var sec = parseInt(absTimeSec % 60);
    return min + ":" + (sec < 10 ? "0" : "") + (absTimeSec < 0 ? 1 : sec);
  };
  $scope.logout = function () {
    User.logout(function () {
      logoutSuccess();
    });
  };
  $scope.$watch("clipDel", function (newValue) {
    if (!newValue && !$scope.clipDetail) {
      $scope.currentClip = undefined;
    }
  });
}]);
"use strict";

var appConfig = {
  useJPLogin: true,
  useGeofence: true,
  useCameraGuide: true,
  sensorDisableUI: true,
  newFlow: false
};
"use strict";

app.controller("FooterCtrl", ["$location", "$rootScope", "$translate", "$scope", "$state", "$document", function ($location, $rootScope, $translate, $scope, $state, $document) {
  var lang = "ko_KR";
  var getLang = $("html").attr("lang");
  if (getLang == "ko") {
    lang = "ko_KR";
  } else if (getLang == "ja") {
    lang = "ja_JP";
  }
  if (window.location.pathname && (window.location.pathname.indexOf("/ja/") != -1 || window.location.pathname.indexOf("/jp/") != -1)) {
    lang = "ja_JP";
  }
  if (navigator.userAgent.indexOf("Googlebot") != -1 || navigator.userAgent.indexOf("GoogleBot") != -1 || navigator.userAgent.indexOf("googlebot") != -1) {
    lang = "en_US";
  }

  //Change SAVAWAY Logo & link

  $scope.termsPopUp = function () {
    var termsUrl = $state.href(lang === "ja_JP" ? "termsJP" : "terms");
    window.open(termsUrl, "", "scrollbars=yes,toolbar=no,resizable=yes,width=600,height=720,left=600,top=200");
  };
  var toggleLayer = function toggleLayer(params) {
    var closestByClass = function closestByClass(el, fn) {
      return el && (fn(el) ? el : closestByClass(el.parentNode, fn));
    };
    var trimString = function trimString(str) {
      return str !== "" ? str.trim() : str;
    };
    var targetEl = closestByClass(params.el, function (el) {
      return el.className.indexOf("layer") > -1;
    });
    var curCN = trimString(targetEl.className);
    var hasClass = curCN.indexOf(params.className) > -1;
    var layerEls = document.querySelectorAll(".layer");
    layerEls.forEach(function (layerEl) {
      if (layerEl !== targetEl) {
        layerEl.className = trimString(layerEl.className.replace(params.className, ""));
      }
    });
    targetEl.className = hasClass || params.off ? trimString(curCN.replace(params.className, "")) : "".concat(curCN, " ").concat(params.className);
  };
  $scope.toggleMenu = function (event) {
    event.cancelBubble = true;
    toggleLayer({
      el: event.currentTarget,
      className: "on",
      off: false
    });
    return false;
  };
  $scope.hideMenu = function (event) {
    var targetElement = document.querySelector(".sel_brand.layer.on");
    if (targetElement && !targetElement.contains(event.target)) {
      targetElement.classList.remove("on");
    }
  };
  function makeLastItemBar() {
    var $lastLi = $(".lst_footer li:last-child");
    var $span = $(document.createElement("span"));
    $span.addClass("bar");
    $lastLi.append($span);
  }

  //TODO: 앵귤러 라우트 추가 필요
  $scope.guaranteePopUp = function () {
    window.open("guaranteejp", "guaranteejp", "scrollbars=yes,toolbar=no,resizable=yes,width=600,height=600");
  };

  //TODO: 앵귤러 라우트 추가 필요
  $scope.privateTermsPopUp = function () {
    var privateTermsUrl = lang === "ja_JP" ? "privateTermsJP" : "privateTerms";
    window.open(privateTermsUrl, "privateTerms", "scrollbars=yes,toolbar=no,resizable=yes,width=600,height=600");
  };
  function makeGuaranteeItem() {
    var $li = $(document.createElement("li"));
    var positionTitle = "取扱・保証";
    $li.html("<a href='#' class='N=a:ftr.notice'>" + positionTitle + "</a>");
    $li.click(function (event) {
      window.open("/guaranteejp?" + window.buildTime, "guaranteejp", "scrollbars=yes,toolbar=no,resizable=yes,width=600,height=600");
      return false;
    });
    if ($footer) {
      $footer.append($li);
    }
  }
  function makePositionTermsItem(lang, $footer) {
    var $li = $(document.createElement("li"));
    var positionTitle = lang == "ja_JP" ? "位置情報サービス利用規約" : "위치 기반 서비스 이용약관";
    var positionUrl = lang == "ja_JP" ? "positionTermsJP" : "positionTerms";
    $li.html("<a href='#' style='color:#ffffff;' class='N=a:ftr.notice'>" + positionTitle + "</a>");
    $li.click(function (event) {
      window.open("/#/" + positionUrl, positionUrl, "scrollbars=yes,toolbar=no,resizable=yes,width=600,height=720");
      return false;
    });
    if ($footer) {
      $footer.append($li);
    }
  }
  function makePrivateTerms() {
    var $li = $(document.createElement("li"));
    var privateTitle = lang == "ja_JP" ? "個人情報保護方針" : "개인정보처리방침";
    var isLocalEnv = /(local-bizcam\.toastcam\.com)/.test(window.location.href || "");
    $li.html("<a href='#' style='color:#ffffff;' class='N=a:ftr.notice'>" + privateTitle + "</a>");
    $li.click(function (event) {
      if (lang == "ja_JP") {
        if (isLocalEnv) {
          window.open("/dist/privateTermsJP", "terms", "scrollbars=yes,toolbar=no,resizable=yes,width=600,height=720");
        } else {
          window.open("/privateTermsJP", "terms", "scrollbars=yes,toolbar=no,resizable=yes,width=600,height=720");
        }
      } else {
        if (isLocalEnv) {
          window.open("/dist/privateTerms", "terms", "scrollbars=yes,toolbar=no,resizable=yes,width=600,height=720");
        } else {
          window.open("/privateTerms", "terms", "scrollbars=yes,toolbar=no,resizable=yes,width=600,height=720");
        }
      }
      return false;
    });
    if ($footer) {
      $footer.append($li);
    }
  }

  //Add Position Terms Menu
  var $footer = $(".lst_footer");
  var subLocation = "installGuide, cameraGuide, help, settings, cameraGroup, dashboard, aiface, manage";
  var location = $location.path();
  $document.on("click", function (event) {
    $scope.$apply(function () {
      $scope.hideMenu(event);
    });
  });

  // 컨트롤러가 파괴될 때 이벤트 리스너 제거
  $scope.$on("$destroy", function () {
    $document.off("click");
  });
}]);
"use strict";

app.controller("gatewayAnalogCtrl", ["$scope", function ($scope) {
  var isScrolling = false;

  // 초기 스타일 설정
  $("body").css("min-width", 0);
  $(".cont_min").css({
    "min-height": "0px",
    "background-color": "white"
  });
  $scope.viewStep = 1;
  $scope.newFlow = appConfig.newFlow;
  var scrollPositions = [0, 330, 800];
  $("#contents_wrap").scroll(function () {
    if (!isScrolling) {
      var $contentWrap = $("#contents_wrap"),
        scrollTop = $contentWrap.scrollTop(),
        height = $contentWrap.height();
      if (scrollTop < 100 && $scope.viewStep !== 1) {
        updateViewStep(1);
      } else if (scrollTop >= 330 && scrollTop < height - 50 && $scope.viewStep !== 2) {
        updateViewStep(2);
      } else if (scrollTop > height + 10 && $scope.viewStep !== 3) {
        updateViewStep(3);
      }
    }
  });
  function updateViewStep(step) {
    $scope.viewStep = step;
    $scope.$apply();
  }
  $scope.selectStep = function (step) {
    if (step >= 1 && step <= 3) {
      isScrolling = true;
      $("#contents_wrap").animate({
        scrollTop: scrollPositions[step - 1]
      }, 300, function () {
        isScrolling = false;
        updateViewStep(step);
      });
    }
  };
  function downloadFile(url) {
    window.open(url, "_blank");
  }
  $scope.downloadGatewayAnalogManual = function () {
    var lang = $("html").attr("lang");
    var url = lang === "ja" ? "https://bizcam.toast.com/CF/gateway_install_analog_jp.pdf" : "https://bizcam.toast.com/CF/gateway_install_analog_kr.pdf";
    downloadFile(url);
  };
  $scope.downloadGatewayAnalogInstaller = function () {
    downloadFile("https://bizcam.toast.com/CF/TCGW_Manager.zip");
  };
}]);
"use strict";

app.controller("gatewayCtrl", ["$rootScope", "$scope", function ($rootScope, $scope) {
  var isScrolling = false;

  // 초기 스타일 설정
  $("body").css("min-width", 0);
  $(".cont_min").css({
    "min-height": "0px",
    "background-color": "white"
  });
  $scope.viewStep = 1;
  $scope.newFlow = appConfig.newFlow;
  var scrollPositions = [0, 330, 800];
  $("#contents_wrap").scroll(function () {
    if (!isScrolling) {
      var $contentWrap = $("#contents_wrap"),
        scrollTop = $contentWrap.scrollTop(),
        height = $contentWrap.height();
      if (scrollTop < 100 && $scope.viewStep !== 1) {
        updateViewStep(1);
      } else if (scrollTop >= 330 && scrollTop < height - 50 && $scope.viewStep !== 2) {
        updateViewStep(2);
      } else if (scrollTop > height + 10 && $scope.viewStep !== 3) {
        updateViewStep(3);
      }
    }
  });
  function updateViewStep(step) {
    $scope.viewStep = step;
    $scope.$apply();
  }
  $scope.selectStep = function (step) {
    if (step >= 1 && step <= 3) {
      isScrolling = true;
      $("#contents_wrap").animate({
        scrollTop: scrollPositions[step - 1]
      }, 300, function () {
        isScrolling = false;
        updateViewStep(step);
      });
    }
  };
  function downloadFile(url) {
    window.open(url, "_blank");
  }
  $scope.downloadGatewayManual = function () {
    var lang = $("html").attr("lang");
    var url = lang === "ja" ? "https://bizcam.toast.com/CF/gateway_install_ip_jp.pdf" : "https://bizcam.toast.com/CF/gateway_install_ip_kr.pdf";
    downloadFile(url);
  };
  $scope.downloadGatewayInstaller = function () {
    downloadFile($rootScope.ENV_VARS.gwInstallerUrl);
  };
  $scope.downloadGatewayPrevInstall = function () {
    var lang = $("html").attr("lang");
    var url = lang === "ja" ? "https://bizcam.toast.com/CF/gateway_prev_install_jp.pdf" : "https://bizcam.toast.com/CF/gateway_prev_install_kr.pdf";
    downloadFile(url);
  };
}]);
"use strict";

var ci = "";
var at = "";
var urlStatus = "";
var menuOpen = function menuOpen(menuOpenFlag) {
  if (menuOpenFlag) {
    $("#wrap").addClass("navon");
  } else {
    $("#wrap").removeClass("navon");
  }
};
var logoutSuccess = function logoutSuccess() {
  sessionStorage.removeItem("passCVRSecureCameraIds");
  location.href = "/";
};
var openUserMenu = function openUserMenu(userMenuFlag) {
  if ($("html").attr("lang") == "en") {
    $("#gnb_bx_layer").removeClass("gnb_bx_layer_en_en_en");
    $("#gnb_bx_layer").addClass("gnb5_bx_layer_en");
  }
  if (userMenuFlag) {
    $("#topUserMenu").addClass("clicked");
    $("#gnb_bx_layer").show();
    if (event.preventDefault) {
      event.preventDefault();
    } else {
      event.returnValue = false;
    }
    event.cancelBubble = true; // for IE
    if (event.stopPropagation) {
      event.stopPropagation();
    }
  } else {
    $("#topUserMenu").removeClass("clicked");
    $("#gnb_bx_layer").hide();
  }
};
var openInfo = function openInfo() {
  window.open("http://www.ftc.go.kr/info/bizinfo/communicationViewPopup.jsp?wrkr_no=1448115549", "communicationViewPopup", "width=750,height=700");
};
var removeLi = function removeLi() {
  $("#loginLi").remove();
};
var goCameras = function goCameras() {
  location.href = "/#/cameras";
};
$("#wrap").click(function (e) {
  $("#topUserMenu").removeClass("clicked");
});
var openTerms = function openTerms() {
  $("#showTemrs").show();
  $("#termsDim").show();
  $("body").scrollTop(50);
};
var cloasTemrs = function cloasTemrs() {
  $("#showTemrs").hide();
  $("#termsDim").hide();
};
var showPage = function showPage() {
  if (navigator.userAgent.indexOf("MSIE") !== -1 || navigator.appVersion.indexOf("Trident/") > 0) {
    setTimeout(function () {
      $("html").hide();
      $("html").show();
    }, 250);
  }
};
var showPage2 = function showPage2() {
  if (navigator.userAgent.indexOf("MSIE") !== -1 || navigator.appVersion.indexOf("Trident/") > 0) {
    $("html").hide();
    setTimeout(function () {
      $("html").show();
    }, 400);
  }
};
var fam_open = false;
var fam = function fam() {
  if (fam_open == false) {
    fam_open = true;
    $("#footer_fam_pa").removeClass("date_lst_sel_fm");
    $("#footer_fam_pa").addClass("date_lst_sel_fm_open");
    $("#footer_fam").show();
  } else {
    fam_open = false;
    $("#footer_fam_pa").removeClass("date_lst_sel_fm_open");
    $("#footer_fam_pa").addClass("date_lst_sel_fm");
    $("#footer_fam").hide();
  }
};
var imgError = function imgError() {
  return "/resources/im/@thumb/thmb_none.jpg";
};
var loginWithPayco = function loginWithPayco() {
  removeCookie("TOASTCAM_CHK");
  removeCookie("TOASTCAM_SES");
  removeCookie("toastcam");
  var httpUrl = location.origin;
  if (httpUrl == undefined) {
    httpUrl = location.protocol + "//" + location.hostname;
  }
  var lang = "";
  if ($("html").attr("lang") == "en") {
    lang = "en_US";
  } else if ($("html").attr("lang") == "ko") {
    lang = "ko_KR";
  } else if ($("html").attr("lang") == "ja") {
    lang = "ja_JP";
  }
  var url = paycoUrl + "oauth2.0/authorize?&termsYN=N&response_type=code&redirect_uri=" + encodeURIComponent(toastAuthUrl + "/authorize?client_id=" + clientId + "&serviceCallbackUrl=" + httpUrl + "/json/biz/payco/logIn?next_uri=" + encodeURIComponent(httpUrl + "/#/lproc")) + "&serviceProviderCode=BIZCAM&state=1&client_id=" + clientId + "&userLocale=" + lang;
  var winHeight = document.body.clientHeight; // 현재창의 높이
  var winWidth = document.body.clientWidth; // 현재창의 너비
  var winX = window.screenLeft; // 현재창의 x좌표
  var winY = window.screenTop; // 현재창의 y좌표

  var popX = winX + (winWidth - 630) / 2;
  var popY = winY + (winHeight - 560) / 2;
  var lp = window.open(url, "PaycoLoginPopup", "left=" + popX + ",top=" + popY + ",width=630,height=560,scrollbars=yes");
  lp.focus();
};
var signupWitPayco = function signupWitPayco() {
  removeCookie("TOASTCAM_CHK");
  removeCookie("TOASTCAM_SES");
  removeCookie("toastcam");
  var httpUrl = location.origin;
  if (httpUrl == undefined) {
    httpUrl = location.protocol + "//" + location.hostname;
  }
  var lang = "";
  if ($("html").attr("lang") == "en") {
    lang = "en_US";
  } else if ($("html").attr("lang") == "ko") {
    lang = "ko_KR";
  } else if ($("html").attr("lang") == "ja") {
    lang = "ja_JP";
  }
  var url = paycoUrl + "join.nhn?serviceProviderCode=BIZCAM&svcType=APP&migrationCode=&smsAuthInfoYn=&client_id=" + ci + "&nextURL=&response_type=code&redirect_uri=" + encodeURIComponent(httpUrl + "/oauth2.0/appCallback?next_uri=" + httpUrl + "/lproc/?deviceType=web") + "&userLocale=" + lang;
  openInfoWin(url, "myinfoPopup", 630, 547);
};
var openUpdateUserInfo = function openUpdateUserInfo() {
  var httpUrl = location.origin;
  if (httpUrl == undefined) {
    httpUrl = [location.protocol, "//", location.hostname, "/#/lproc?from=myInfoChangePwd.nhn"].join("");
  } else {
    httpUrl = httpUrl + "/#/lproc?from=myInfoChangePwd.nhn";
  }
  var myInfoChangePwdUrl = [paycoUrl, "myInfoChangePwd.nhn", "?popUp=true",
  // ! lproc 에서 최종 프로세스 처리
  "&retUrl=" + encodeURIComponent(httpUrl), "&serviceProviderCode=BIZCAM", "&svcType=WEB"].join("");
  openInfoWin(myInfoChangePwdUrl, "myinfoPopup", 630, 547); // window.open
};
var openChangeEmailPassword = function openChangeEmailPassword() {
  var httpUrl = location.origin;
  var lang = "";
  if ($("html").attr("lang") == "en") {
    lang = "en_US";
  } else if ($("html").attr("lang") == "ko") {
    lang = "ko_KR";
  } else if ($("html").attr("lang") == "ja") {
    lang = "ja_JP";
  }
  if (httpUrl == undefined) {
    httpUrl = [location.protocol, "//", location.hostname, "/myInfo?lang=", lang].join("");
  } else {
    httpUrl = httpUrl + "/myInfo?lang=" + lang;
  }
  openInfoWin(httpUrl, "myinfoPopup", 630, 547); // window.open
};
var openServiceUseTerms = function openServiceUseTerms() {
  var nextURL = memberUrl + "personalInfoUsageDetail";
  var url = memberUrl + "bridge&client_id=" + ci + "&access_token=" + encodeURIComponent(at) + "&serviceProviderCode=BIZCAM&nextUrl=" + encodeURIComponent(nextURL);
  openInfoWin(url, "serviceTerms", 630, 547); // window.open
};
var openInfoWin = function openInfoWin(sURL, sWindowName, w, h, sScroll, reSize, status) {
  var x = (screen.width - w) / 2;
  var y = (screen.height - h) / 2;
  if (sScroll == null) sScroll = "no";
  if (screen.width == 800 && screen.height == 600) sScroll = "yes"; // 해상도 800*600일 때 스크롤 생기도록 함
  var sOption = "";
  sOption = sOption + "toolbar=no, channelmode=no, location=no, directories=no, menubar=no";
  sOption = sOption + ", scrollbars=" + sScroll + ", resizable=" + reSize + ", status=" + status + ", left=" + x + ", top=" + y + ", width=" + w + ", height=" + h;
  var win = window.open(sURL, sWindowName, sOption);
  try {
    win.focus();
  } catch (e) {}
  return win;
};
var removeCookie = function removeCookie(sKey) {
  sPath = "/";
  document.cookie = encodeURIComponent(sKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT" + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "");
};
var sDomain = ".toastcam.com";
var callEvtList = 0;
var calluevtList = 0;
var loginWithStore = function loginWithStore() {
  $.ajax({
    type: "POST",
    url: "/json/login/store",
    dataType: "json",
    success: function success(data) {
      if (data.code == "ok") {
        location.href = "/#/store";
      }
    },
    error: function error(e) {
      location.href = "/error";
    }
  });
};
var loginWithPaycoNStore = function loginWithPaycoNStore() {
  removeCookie("TOASTCAM_CHK");
  removeCookie("TOASTCAM_SES");
  removeCookie("toastcam");
  var httpUrl = location.origin;
  if (httpUrl == undefined) {
    httpUrl = location.protocol + "//" + location.hostname;
  }
  var lang = "";
  if ($("html").attr("lang") == "en") {
    lang = "en_US";
  } else if ($("html").attr("lang") == "ko") {
    lang = "ko_KR";
  } else if ($("html").attr("lang") == "ja") {
    lang = "ja_JP";
  }
  if (location.hash.indexOf("installKey") == -1) {
    var url = paycoUrl + "oauth2.0/authorize?&termsYN=Y&response_type=code&redirect_uri=" + encodeURIComponent(httpUrl + "/oauth2.0/appCallback?next_uri=" + httpUrl + "/lproc/?deviceType=web&storeLogin=Y") + "&serviceProviderCode=BIZCAM&state=1&client_id=" + clientId + "&userLocale=" + lang;
  } else {
    var url = paycoUrl + "oauth2.0/authorize?&termsYN=Y&response_type=code&redirect_uri=" + encodeURIComponent(httpUrl + "/oauth2.0/appCallback?next_uri=" + httpUrl + "/lproc/?" + location.hash.substring(location.hash.indexOf("installKey"))) + "&serviceProviderCode=BIZCAM&state=1&client_id=" + clientId + "&userLocale=" + lang;
  }
  var winHeight = document.body.clientHeight; // 현재창의 높이
  var winWidth = document.body.clientWidth; // 현재창의 너비
  var winX = window.screenLeft; // 현재창의 x좌표
  var winY = window.screenTop; // 현재창의 y좌표

  var popX = winX + (winWidth - 630) / 2;
  var popY = winY + (winHeight - 560) / 2;
  var lp = window.open(url, "PaycoLoginPopup", "left=" + popX + ",top=" + popY + ",width=630,height=560,scrollbars=yes");
  lp.focus();
};
var showToastCamServiceRequestLayer = function showToastCamServiceRequestLayer() {
  $("#request_companyName").val("");
  $("#request_tel1").val("010");
  $("#request_tel2").val("");
  $("#request_tel3").val("");
  $("#request_email").val("");
  $("#request_address").val("");
  $("#request_content").val("");
  $("#showToastCamServiceRequestLayerBack").css("display", "block");
  $("#showToastCamServiceRequestLayer").css("display", "block");
};
var closeToastCamServiceRequestLayer = function closeToastCamServiceRequestLayer() {
  $("#showToastCamServiceRequestLayerBack").css("display", "none");
  $("#showToastCamServiceRequestLayer").css("display", "none");
};
var serviceRequestSummit = function serviceRequestSummit() {
  var title = "사용신청";
  if ($("#request_companyName").val().trim() === "") {
    showAlertPop(title, "신청인(회사명)을 입력해주세요.");
    return;
  }
  var telNum = $("#request_tel1").val() + "-" + $("#request_tel2").val() + "-" + $("#request_tel3").val();
  if ($("#request_tel2").val().trim() === "" || $("#request_tel3").val().trim() === "") {
    showAlertPop(title, "휴대폰 번호를 입력해주세요.");
    return;
  } else {
    if (!/^[0-9]*$/.test($("#request_tel2").val() + $("#request_tel3").val())) {
      showAlertPop(title, "숫자만 입력가능합니다.");
      return;
    } else if (!/^\d{3}-\d{3,4}-\d{4}$/.test(telNum)) {
      showAlertPop(title, "전화번호 형식에 맞지 않습니다.");
      return;
    }
  }
  if ($("#request_email").val().trim() === "") {
    showAlertPop(title, "이메일을 입력해주세요.");
    return;
  } else {
    var emailRegExp = /^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i;
    if (!emailRegExp.test($("#request_email").val())) {
      showAlertPop(title, "이메일 형식에 맞지 않습니다.");
      return;
    }
  }
  if ($("#request_address").val().trim() === "") {
    showAlertPop(title, "설치장소를 입력해주세요.");
    return;
  }
  if ($("#request_content").val().trim() === "") {
    showAlertPop(title, "신청내용을 입력해주세요.");
    return;
  }
  var requestParam = {
    companyName: $("#request_companyName").val(),
    mobile: telNum,
    email: $("#request_email").val(),
    location: $("#request_address").val(),
    message: $("#request_content").val()
  };
  $.ajax({
    type: "POST",
    url: "/json/biz/camera/request",
    dataType: "json",
    data: requestParam,
    success: function success(data) {
      if (data.code === "ok") {
        showAlertPop(title, "사용 신청이 성공적으로 전송");
        $("#showToastCamServiceRequestLayerBack").css("display", "none");
        $("#showToastCamServiceRequestLayer").css("display", "none");
      } else {
        showAlertPop(title, "사용 신청에 실패하였습니다.");
      }
    },
    error: function error(e) {
      showAlertPop("통신장애", "서버와 통신중 장애가 발생하였습니다. <br>잠시 후 다시 시도해주세요.");
    }
  });
};
var showAlertPop = function showAlertPop(title, message) {
  $("#showAlertPop").css("display", "block");
  $("#popTitle").html(title);
  $("#popBody").html(message);
};
var hideAlertPop = function hideAlertPop() {
  $("#showAlertPop").css("display", "none");
};
var clickLanguageHandler = function clickLanguageHandler(event) {
  var getLang = event.target.getAttribute("code");
  if (getLang.indexOf("_") > 0) {
    getLang = getLang.split("_")[0];
  }
  document.documentElement.setAttribute("lang", getLang);
  window.location.reload();
};
function loginJpCallBack(code, nextUrl) {
  if (nextUrl) {
    window.href = nextUrl;
  } else {
    location.href = "/#/index";
  }
}
var isIE = /*@cc_on!@*/false || !!document.documentMode;
if (isIE) {
  window.onload = function () {
    var titleEl = document.title;
    var docEl = document.documentElement;
    if (docEl && docEl.addEventListener) {
      docEl.addEventListener("DOMSubtreeModified", function (evt) {
        var newTitle = document.title;
        if (newTitle != titleEl) {
          document.title = titleEl;
        }
      }, false);
    } else {
      document.onpropertychange = function () {
        if (window.event.propertyName == "title") {
          document.title = titleEl;
        }
      };
    }
  };
}
"use strict";

app.controller("HeaderCtrl", ["$scope", "$state", "User", "Acount", "$q", "$translate", "$rootScope", "$timeout", "NoticePopup", "Monitor", "AiFace", "Utils", "$document", "$window", function ($scope, $state, User, Acount, $q, $translate, $rootScope, $timeout, NoticePopup, Monitor, AiFace, Utils, $document, $window) {
  $scope.state = $state;
  $scope.isUseJPLogin = appConfig.useJPLogin;
  $scope.isUseCameraGuide = appConfig.useCameraGuide;
  $scope.useAiPeopleCount;
  $scope.useAiFaceDetect;
  $scope.ENV_VARS = $rootScope.ENV_VARS;
  $scope.isShowTopMenu = false;
  $scope.isPaycoLogin = false;
  var lang = getLanguage();
  $scope.isShowOnlineMenu = lang !== "ja_JP";
  $scope.useExtraService = Utils.getCookie("useExtraService") === "true";

  // ! toast message
  $scope.toast = {
    hasToast: false,
    message: "",
    timeout: 0
  };
  function getLanguage() {
    var langMap = {
      ko: "ko_KR",
      ja: "ja_JP"
    };
    var lang = langMap[$("html").attr("lang")] || "ko_KR";
    if (window.location.pathname.includes("/ja/") || window.location.pathname.includes("/jp/")) {
      lang = "ja_JP";
    }
    if (navigator.userAgent.toLowerCase().includes("googlebot")) {
      lang = "en_US";
    }
    return lang;
  }
  function handleScroll() {
    var $toastGnb = $("#toastGnb");
    var st = window.pageYOffset || document.documentElement.scrollTop;
    if (st > 300 && st > $scope.lastScrollTop + 10) {
      $toastGnb.addClass("scroll_down").removeClass("scroll_up");
    } else if (st < 580 && st + 10 < $scope.lastScrollTop) {
      $toastGnb.addClass("scroll_up").removeClass("scroll_down");
    }
    $scope.lastScrollTop = st <= 0 ? 0 : st;
    var scrollTop = navigator.userAgent.toLowerCase().indexOf("rv") != -1 || navigator.userAgent.toLowerCase().indexOf("msie") != -1 ? document.documentElement.scrollTop : window.scrollY;
    $toastGnb.toggleClass("scroll_move", scrollTop >= 5);
  }
  function openWindow(url, title, width, height) {
    var translatedTitle = $translate.instant(title);
    var newWindow = window.open(url, translatedTitle, "scrollbars=yes,toolbar=no,resizable=yes,width=".concat(width, ",height=").concat(height, ",left=600,top=200"));
    return newWindow;
  }
  if ($rootScope.isMain) {
    window.addEventListener("scroll", handleScroll);
  } else {
    window.removeEventListener("scroll", handleScroll);
  }
  $rootScope.$on("$stateChangeSuccess", function (event, toState) {
    if ($rootScope.isMain) {
      window.addEventListener("scroll", handleScroll);
    } else {
      window.removeEventListener("scroll", handleScroll);
    }
  });
  $scope.showAlertPop = function (title, message) {
    document.getElementById("showAlertPop").style.display = "block";
    document.getElementById("popTitle").innerHTML = title;
    document.getElementById("popBody").innerHTML = message;
  };
  $scope.hideAlertPop = function () {
    document.getElementById("showAlertPop").style.display = "none";
  };
  function checkAiFaceRecvAccounts() {
    var deferred = $q.defer();
    AiFace.recievedAccounts().$promise.then(function (res) {
      if (res.code === "ok" && res.accounts && res.accounts.length) {
        deferred.resolve();
      } else {
        deferred.reject();
      }
    }, function (err) {
      deferred.reject();
    });
    return deferred.promise;
  }
  $scope.$on("showAiFaceRegDlg", function () {
    if ($rootScope.me) {
      $scope.isShowAiFaceServiceRegDialog = true;
      $scope.selectedAccount = {
        userId: $rootScope.me.userId
      };
    }
  });
  $scope.clickMenu = function (state) {
    var reloadState = "";
    switch (state) {
      case "main.dashboard.shop":
        reloadState = "main.dashboard";
        break;
      case "main.cameraGroup.group":
        reloadState = "main.cameraGroup";
        break;
      case "main.aiface.content":
        if ($rootScope.me.useAiFaceDetect) {
          reloadState = state;
        } else {
          checkAiFaceRecvAccounts().then(function () {
            reloadState = state;
            $state.go(state, {}, {
              reload: reloadState,
              inherit: true,
              notify: true
            });
          }, function () {
            if ($rootScope.me) {
              $scope.isShowAiFaceServiceRegDialog = true;
              $scope.selectedAccount = {
                userId: $rootScope.me.userId
              };
            }
          });
          return;
        }
        break;
      default:
        reloadState = state;
        break;
    }
    $state.go(state, {}, {
      reload: reloadState,
      inherit: true,
      notify: true
    });
  };
  User.me().$promise.then(function (data) {
    $scope.useAiPeopleCount = data.useAiPeopleCount;
    $scope.useAiFaceDetect = data.useAiFaceDetect;
    $scope.country = data.country === "JP" ? "ja" : "ko";
    if (data.code === "ok" || data.code === "nok" && data.errorCode === "-2") {
      $scope.isShowTopMenu = true;
      $scope.isLogin = true;
    } else {
      $scope.isShowTopMenu = false;
    }
    $scope.isPaycoLogin = (data === null || data === void 0 ? void 0 : data.accountType) === "3";
  }, function (err) {
    void 0;
  });
  $scope.logoutSuccess = function () {
    Acount.logout({}, function (data) {
      location.href = "/";
      if (lang == "ja_JP" && $scope.isUseJPLogin && $scope.isLogin) {
        $scope.toggleLayer({
          el: $("#toggle_menu")[0],
          className: "on",
          off: false
        });
      }
    }, function (err) {
      location.href = "/";
    });
  };

  // 공지사항 그만보기 체크
  $scope.checkPopupNoticeNoMore = function (notice) {
    var key = "CAM_NOTICE_POPUP_NO_MORE-" + notice.seq;
    var noticeNoMoreDate = localStorage.getItem(key);
    if (noticeNoMoreDate === null) {
      return false;
    }
    return moment(Number(noticeNoMoreDate)).startOf("day").isSame(moment().startOf("day"));
  };
  var boardTypeVal = lang == "ja_JP" ? "bizcam_ja" : "bizcam";
  // 공지사항 팝업
  $scope.popupNotice = function () {
    NoticePopup.get({
      boardType: boardTypeVal
    }).$promise.then(function (data) {
      if (typeof data.seq === "undefined" || $scope.checkPopupNoticeNoMore(data)) {
        return false;
      }
      window.open("/#/noticePopup", "noticePopup", "scrollbars=yes,toolbar=no,resizable=yes,width=600,height=500,left=100,top=100");
    }, function (err) {});
  };
  $scope.popupNotice();
  $scope.goMyInfo = function (e) {
    e && e.preventDefault();
    var isPaycoUser = $rootScope.me.accountType === "3";
    var retUrl = encodeURIComponent("".concat($window.location.protocol, "//").concat($window.location.host, "/lproc?from=myInfoChangePwd.nhn"));
    var paycoMyInfoQuery = new URLSearchParams({
      popUp: true,
      retUrl: retUrl
    });
    var paycoMyInfoUrl = "".concat($rootScope.ENV_VARS.paycoBaseUrl, "/myInfoChangePwd.nhn?").concat(paycoMyInfoQuery);
    if (isPaycoUser) {
      openWindow(paycoMyInfoUrl, "myinfoPopup", 630, 547);
      return;
    }
    var myInfoUrl = $state.href("myInfo", {
      lang: lang
    }, {
      absolute: true
    });
    var myInfoWindow = openWindow(myInfoUrl, "5mw2slvk_02181", 630, 547);
    myInfoWindow.onload = function () {
      myInfoWindow.document.body.style.minWidth = "100%";
    };
  };
  $scope.goServiceManage = function () {
    $state.go("main.settings.product");
    if (lang == "ja_JP" && $scope.isUseJPLogin && $scope.isLogin) {
      $scope.toggleLayer({
        el: $("#toggle_menu")[0],
        className: "on",
        off: false
      });
    }
  };
  $scope.goAccess = function () {
    var shopId = $rootScope.cameraShopId;
    var stateName = $state.current || "";
    if (shopId && stateName === "main.cameraDetail") {
      $state.go("main.access", {
        shopId: shopId
      });
    } else {
      $state.go("main.accessall");
    }
  };
  $scope.showToastMessage = function (message) {
    $scope.toast.message = message;
    $scope.toast.hasToast = true;
    if ($scope.toast.timeout) {
      $timeout.cancel($scope.toast.timeout);
    }
    $scope.toast.timeout = $timeout(function () {
      $scope.toast.hasToast = false;
      $scope.toast.message = "";
    }, 1000 * 3);
  };
  $scope.goCustomService = function () {
    $state.go($rootScope.isJPLogin ? "main.help.customerCenter" : "main.help.faq");
  };
  $scope.goManuals = function () {
    location.href = "/#/manuals";
  };
  $scope.goMain = function () {
    window.monitorDemoState = null;
    window.gatewayDemoState = null;
    if ($state.current && $state.current.name === "main") {
      window.scrollTo(0, 0);
    }
    $state.go("main");
  };
  $scope.gotoShowcase = function () {
    location.href = "/showcase";
  };
  $scope.gotoPartner = function () {
    location.href = "/partner";
  };
  $scope.toggleLayer = function (params) {
    var closestByClass = function closestByClass(el, fn) {
      return el && (fn(el) ? el : closestByClass(el.parentNode, fn));
    };
    var trimString = function trimString(str) {
      return str !== "" ? str.trim() : str;
    };
    var targetEl = closestByClass(params.el, function (el) {
      return el.className.indexOf("layer") > -1;
    });
    var curCN = trimString(targetEl.className);
    var hasClass = curCN.indexOf(params.className) > -1;
    var layerEls = document.querySelectorAll(".layer");
    layerEls.forEach(function (layerEl) {
      if (layerEl !== targetEl) {
        layerEl.className = trimString(layerEl.className.replace(params.className, ""));
      }
    });
    targetEl.className = hasClass || params.off ? trimString(curCN.replace(params.className, "")) : "".concat(curCN, " ").concat(params.className);
  };
  $scope.hideMenu = function (event) {
    var targetElement = document.querySelector(".signup.layer.on");
    if (targetElement && !targetElement.contains(event.target)) {
      targetElement.classList.remove("on");
    }
  };
  $scope.toggleMenu = function (event) {
    event.cancelBubble = true;
    $scope.toggleLayer({
      el: event.currentTarget,
      className: "on",
      off: false
    });
    return false;
  };
  $scope.goMonitor = function () {
    var blockScrollClass = "blockScroll";
    var cloudMonitorMessage = $translate.instant("STR_CLOUD_MONITOR");
    $scope.isLoading = true;
    document.body.classList.add(blockScrollClass);
    function handleMonitorError(message) {
      $scope.isLoading = false;
      document.body.classList.remove(blockScrollClass);
      $scope.showAlertPop(cloudMonitorMessage, message);
    }
    function handleMonitorSuccess(data) {
      $scope.isLoading = false;
      $("body").removeClass(blockScrollClass);
      if (data.code !== "ok") {
        handleMonitorError(data.msg);
        return;
      }
      $rootScope.monitorConfigData = data;
      if (!$rootScope.me.cloudMonitorUser) {
        var message = $rootScope.monitorConfigData.isCloudMonitorUser ? $translate.instant("STR_NO_MONITOR_CAMERAS") : $translate.instant("STR_NEED_SERVICE");
        $scope.showMonitorConfirm(message, $translate.instant("STR_CLOUD_MON_DEMO_GO_DESC"));
        return;
      }
      var browserVersion = Utils.getBrowserVersion();
      if (browserVersion.name === "Chrome") {
        $state.go("main.monitors", {
          demo: "nok"
        }, {
          reload: true
        });
      } else {
        $scope.showAlertPop(cloudMonitorMessage, $translate.instant("STR_USE_CHROME"));
      }
    }
    Monitor.api.getInfo({}, handleMonitorSuccess, function () {
      return handleMonitorError($translate.instant("ACCESS_NET_FAIL_DESC"));
    });
  };
  $scope.showMonitorConfirm = function (title, desc) {
    $scope.monitorPopTitle = title;
    $scope.monitorPopDesc = desc;
    $scope.isShowMonitorConfirm = true;
  };
  $scope.goToMonitorDemo = function () {
    var browserVersion = Utils.getBrowserVersion();
    if (browserVersion.name === "Chrome") {
      $state.go("main.monitors", {
        demo: "ok"
      }, {
        reload: true
      });
    } else {
      $scope.showAlertPop($translate.instant("STR_CLOUD_MONITOR"), $translate.instant("STR_USE_CHROME"));
    }
  };
  $document.on("click", function (event) {
    $scope.$apply(function () {
      $scope.hideMenu(event);
    });
  });

  // 컨트롤러가 파괴될 때 이벤트 리스너 제거
  $scope.$on("$destroy", function () {
    $document.off("click");
  });
}]);
app.controller("HeaderMobileCtrl", ["$scope", function ($scope) {
  $scope.isShow = $("html").attr("lang") !== "ja";
  $scope.app_open = function () {
    var openAt = new Date(),
      uagentLow = navigator.userAgent.toLocaleLowerCase(),
      chrome25;
    $("body").append("<iframe id='____toastcamlink____'></iframe>");
    $("#____toastcamlink____").hide();
    setTimeout(function () {
      if (new Date() - openAt < 4000 && isAndroid()) {
        $("#____toastcamlink____").attr("src", "market://details?id=com.nhnent.toastcam");
      }
    }, 1000);
    if (isAndroid()) {
      chrome25 = uagentLow.includes("chrome") && parseInt(navigator.appVersion.match(/Chrome\/(\d+)\./)[1], 10) > 25;
      var kitkatWebview = uagentLow.includes("naver") || uagentLow.includes("daum");
      if (chrome25 && !kitkatWebview) {
        document.location.href = "intent://toastcam?param=value#Intent;scheme=toast;package=com.nhnent.toastcam;end";
      } else {
        $("#____toastcamlink____").attr("src", "toast://toastcam");
      }
    } else if (isIphone()) {
      location.href = "https://itunes.apple.com/us/app/toseuteukaem/id1048514287?mt=8";
    }
    $("#____toastcamlink____").remove();
  };
  function isAndroid() {
    return uagentLow.includes("android");
  }
  function isIphone() {
    return uagentLow.includes("iphone");
  }

  // 페이지 최상단으로 이동
  $scope.scrollTop = function () {
    window.scrollTo(0, 0);
  };
  $scope.cellPhone = function (tel) {
    location.href = "tel:" + tel;
  };
}]);
"use strict";

var TCC;
var webrtcDetectedBrowser = null;
var webrtcDetectedVersion = null;
var reattachMediaStream;
var cookies;
var getUserMedia;
(function () {
  var selectLanguage = function selectLanguage() {
    var ua = navigator.userAgent;
    if (ua.indexOf("MSIE 10.0") != -1) {
      if (navigator.userLanguage.indexOf("ko") != -1) {
        $("html").attr("lang", "ko");
      } else {
        $("html").attr("lang", "ko");
      }
    } else {
      if (navigator.language.indexOf("ko") != -1) {
        $("html").attr("lang", "ko");
      } else {
        $("html").attr("lang", "ko");
      }
    }
  };
  if (navigator.userAgent.indexOf("MSIE") !== -1 || navigator.appVersion.indexOf("Trident/") > 0) {
    var rv = 0;
    var ua = navigator.userAgent;
    var re = new RegExp("MSIE ([0-9]{1,}[.0-9]{0,})");
    if (re.exec(ua) != null) rv = parseFloat(RegExp.$1);
    if (rv != 0 && rv <= 8) {
      void 0;
    } else {
      selectLanguage();
    }
  } else {
    selectLanguage();
  }
  function browserCheck() {
    var userAgent = navigator.userAgent,
      match = userAgent.match(/(opera|chrome|crios|safari|ucbrowser|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [],
      result = {},
      tem;
    try {
      if (/trident/i.test(match[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(userAgent) || [];
        result.name = "Internet Explorer";
      } else if (match[1] === "Chrome") {
        tem = userAgent.match(/\b(OPR|Edge)\/(\d+)/);
        if (tem && tem[1]) {
          result.name = tem[0].indexOf("Edge") === 0 ? "Edge" : "Opera";
        }
      }
      if (!result.name) {
        tem = userAgent.match(/version\/(\d+)/i); // iOS support
        result.name = match[0].replace(/\/.*/, "");
        if (result.name.indexOf("MSIE") === 0) {
          result.name = "Internet Explorer";
        }
        if (userAgent.match("CriOS")) {
          result.name = "Chrome";
        }
      }
      if (tem && tem.length) {
        match[match.length - 1] = tem[tem.length - 1];
      }
      result.version = Number(match[match.length - 1]);
    } catch (e) {
      result.name = "unknown";
      result.version = 0;
    }
    return result;
  }
  var browserInfo = browserCheck();
  if (navigator.mozGetUserMedia) {
    webrtcDetectedBrowser = "firefox";
    webrtcDetectedVersion = parseInt(navigator.userAgent.match(/Firefox\/([0-9]+)\./)[1], 10);
    // The RTCPeerConnection object.
    if (!window.RTCPeerConnection) {
      RTCPeerConnection = function RTCPeerConnection(pcConfig, pcConstraints) {
        return new mozRTCPeerConnection(pcConfig, pcConstraints);
      };
    }

    // The RTCSessionDescription object.
    if (!window.RTCSessionDescription) {
      window.RTCSessionDescription = mozRTCSessionDescription;
    }

    // The RTCIceCandidate object.
    if (!window.RTCIceCandidate) {
      window.RTCIceCandidate = mozRTCIceCandidate;
    }

    // getUserMedia shim (only difference is the prefix).
    // Code from Adam Barth.
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      getUserMedia = navigator.mediaDevices.getUserMedia.bind(navigator.mediaDevices);
      navigator.getUserMedia = getUserMedia;
    }

    // Attach a media stream to an element.
    var attachMediaStream = function attachMediaStream(element, stream) {
      if (typeof element.srcObject !== "undefined") {
        element.srcObject = stream;
      } else if (typeof element.mozSrcObject !== "undefined") {
        element.mozSrcObject = stream;
      } else if (typeof element.src !== "undefined") {
        element.src = URL.createObjectURL(stream);
      } else {
        void 0;
      }
    };
    reattachMediaStream = function reattachMediaStream(to, from) {
      void 0;
      to.src = from.src;
    };
  } else if (navigator.webkitGetUserMedia) {
    void 0;
    webrtcDetectedBrowser = "chrome";
    // Temporary fix until crbug/374263 is fixed.
    // Setting Chrome version to 999, if version is unavailable.
    var result = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
    if (result !== null) {
      webrtcDetectedVersion = parseInt(result[2], 10);
    } else {
      webrtcDetectedVersion = 999;
    }

    // The RTCPeerConnection object.
    RTCPeerConnection = function RTCPeerConnection(pcConfig, pcConstraints) {
      return new webkitRTCPeerConnection(pcConfig, pcConstraints);
    };

    // Get UserMedia (only difference is the prefix).
    // Code from Adam Barth.
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      getUserMedia = navigator.mediaDevices.getUserMedia.bind(navigator.mediaDevices);
      navigator.getUserMedia = getUserMedia;
    } else {
      getUserMedia = navigator.webkitGetUserMedia.bind(navigator);
      navigator.getUserMedia = getUserMedia;
    }

    // Attach a media stream to an element.
    attachMediaStream = function attachMediaStream(element, stream) {
      if (typeof element.srcObject !== "undefined") {
        element.srcObject = stream;
      } else if (typeof element.mozSrcObject !== "undefined") {
        element.mozSrcObject = stream;
      } else if (typeof element.src !== "undefined") {
        element.src = URL.createObjectURL(stream);
      } else {
        void 0;
      }
    };
    reattachMediaStream = function reattachMediaStream(to, from) {
      to.src = from.src;
    };
  } else if (navigator.userAgent.indexOf("Safari") != -1 && navigator.userAgent.indexOf("Version/11") != -1) {
    void 0;
    safariRTCPeerConnection = RTCPeerConnection;
    webrtcDetectedBrowser = "safari";
    // Temporary fix until crbug/374263 is fixed.
    // Setting Chrome version to 999, if version is unavailable.
    var result = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
    if (result !== null) {
      webrtcDetectedVersion = parseInt(result[2], 10);
    } else {
      webrtcDetectedVersion = 999;
    }

    // The RTCPeerConnection object.
    RTCPeerConnection = function RTCPeerConnection(pcConfig, pcConstraints) {
      return new safariRTCPeerConnection(pcConfig, pcConstraints);
    };
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      getUserMedia = navigator.mediaDevices.getUserMedia.bind(navigator.mediaDevices);
      navigator.getUserMedia = getUserMedia;
    } else {
      getUserMedia = navigator.getUserMedia.bind(navigator);
      navigator.getUserMedia = getUserMedia;
    }

    // Attach a media stream to an element.
    attachMediaStream = function attachMediaStream(element, stream) {
      if (typeof element.srcObject !== "undefined") {
        element.srcObject = stream;
      } else if (typeof element.mozSrcObject !== "undefined") {
        element.mozSrcObject = stream;
      } else if (typeof element.src !== "undefined") {
        element.src = URL.createObjectURL(stream);
      } else {
        void 0;
      }
    };
    reattachMediaStream = function reattachMediaStream(to, from) {
      to.src = from.src;
    };
  } else if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
    webrtcDetectedBrowser = "safari";
    var result = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
    if (result !== null) {
      webrtcDetectedVersion = parseInt(result[2], 10);
    } else {
      webrtcDetectedVersion = 999;
    }

    // getUserMedia shim (only difference is the prefix).
    // Code from Adam Barth.
    getUserMedia = navigator.mediaDevices.getUserMedia.bind(navigator.mediaDevices);
    navigator.getUserMedia = getUserMedia;

    // Attach a media stream to an element.
    attachMediaStream = function attachMediaStream(element, stream) {
      if (typeof element.srcObject !== "undefined") {
        element.srcObject = stream;
      } else if (typeof element.mozSrcObject !== "undefined") {
        element.mozSrcObject = stream;
      } else if (typeof element.src !== "undefined") {
        element.src = URL.createObjectURL(stream);
      } else {
        void 0;
      }
    };
    reattachMediaStream = function reattachMediaStream(to, from) {
      void 0;
      to.src = from.src;
    };
  } else if (browserInfo.name !== "Internet Explorer" && browserInfo.name !== "Edge") {
    if (browserInfo.name === "Safari" && browserInfo.version < 11) {
      return;
    }
    webrtcDetectedBrowser = "chrome";
    // Temporary fix until crbug/374263 is fixed.
    // Setting Chrome version to 999, if version is unavailable.
    var result = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
    if (result !== null) {
      webrtcDetectedVersion = parseInt(result[2], 10);
    } else {
      webrtcDetectedVersion = 999;
    }

    // The RTCPeerConnection object.
    RTCPeerConnection = function RTCPeerConnection(pcConfig, pcConstraints) {
      return new webkitRTCPeerConnection(pcConfig, pcConstraints);
    };

    // Get UserMedia (only difference is the prefix).
    // Code from Adam Barth.
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      getUserMedia = navigator.mediaDevices.getUserMedia.bind(navigator.mediaDevices);
      navigator.getUserMedia = getUserMedia;
    } else if (navigator.webkitGetUserMedia) {
      getUserMedia = navigator.webkitGetUserMedia.bind(navigator);
      navigator.getUserMedia = getUserMedia;
    }

    // Attach a media stream to an element.
    attachMediaStream = function attachMediaStream(element, stream) {
      if (typeof element.srcObject !== "undefined") {
        element.srcObject = stream;
      } else if (typeof element.mozSrcObject !== "undefined") {
        element.mozSrcObject = stream;
      } else if (typeof element.src !== "undefined") {
        element.src = URL.createObjectURL(stream);
      } else {
        void 0;
      }
    };
    reattachMediaStream = function reattachMediaStream(to, from) {
      to.src = from.src;
    };
  }
})();
"use strict";

// TODO: 삭제될 파일 ! 구버전 main controller

app.controller("IndexCtrl2", ["$scope", "$rootScope", "$state", "$timeout", "$translate", "Service", "$interval", "$stateParams", "$sce", "User", "Utils", function ($scope, $rootScope, $state, $timeout, $translate, Service, $interval, $stateParams, $sce, User, Utils) {
  $scope.rotation = {};
  $scope.isShowToastCamServiceRequestLayer = false;
  $scope.productRotationIndex = 0;
  $scope.sunOnOff = true;
  $scope.biz_show = true;
  $scope.device_show = false;
  $scope.v3_show = false;
  $scope.ai_show = false;
  $scope.aiplus_spec = true;
  $scope.lte_show = false;
  $scope.monitor_show = false;
  $scope.isZWaveDescShow = false;
  $scope.slideLeft = 0;
  $scope.bizSlideLeft = 0;
  $scope.camColor = "black";
  $scope.isLogin = false;
  $scope.isTop = true;
  $scope.selectSensorIdx = 0;
  $scope.selectedAiTabIdx = 0;
  $scope.isFaceSectReplayShow = false;
  $scope.isFaceSectPlay = false;
  $scope.isMonitorSectPlay = false;
  var prevSector = null;
  var vContentPlayDlg = null;
  var slideImageInterval = null;
  var nightImageMoveFlag = true;
  var mySwiper;
  var didSwiper;
  var elNightViewMode, elNightViewModeBtnList;
  var lang = $("html").attr("lang");
  var productRotationInterval = $interval(function () {
    if ($scope.biz_show === true) {
      productRotate();
    }
  }, 5000);
  $scope.languageSet = lang;
  $scope.isShowPriceRequest = lang !== "ja";
  User.me().$promise.then(function (data) {
    $scope.isLogin = Boolean(data.code === "ok" || data.code === "nok" && data.errorCode === "-2");
  }, function (err) {
    $scope.isLogin = false;
  });
  setWindowScrollEvent(true);
  $scope.$on("$destroy", function () {
    $("#product_wrap .inner").off("mouseover mouseleave");
    setWindowScrollEvent(false);
    setSlideInterval(false);
    setDidSwiper(false);
    if (productRotationInterval) {
      $interval.cancel(productRotationInterval);
      productRotationInterval = null;
    }
    if (mySwiper) {
      mySwiper.destroy();
      mySwiper = null;
    }
    if (vContentPlayDlg) {
      vContentPlayDlg.destroy();
      vContentPlayDlg = null;
    }
  });
  $timeout(setProductTabMouseOverEvent, 1000);
  if ((!$stateParams.sector || $stateParams.sector === "dev" || $stateParams.sector === "biz") && $rootScope.lastType) {
    $timeout(function () {
      if ($stateParams.sector === "dev" && $rootScope.lastType === "v3") {
        if (Utils.isSafari()) {
          $("body").scrollTop($(".spec_v3").offset().top - 300);
        } else {
          $("html").scrollTop($(".spec_v3").offset().top - 300);
        }
      } else if ($stateParams.sector === "dev" && $rootScope.lastType === "lte") {
        if (Utils.isSafari()) {
          $("body").scrollTop($(".spec_lte").offset().top - 300);
        } else {
          $("html").scrollTop($(".spec_lte").offset().top - 300);
        }
      } else if ($stateParams.sector === "dev" && $rootScope.lastType === "ai") {
        if (Utils.isSafari()) {
          $("body").scrollTop($(".spec_ai").offset().top - 300);
        } else {
          $("html").scrollTop($(".spec_ai").offset().top - 300);
        }
      } else if ($stateParams.sector === "dev" && $rootScope.lastType === "monitor") {
        setTranslateMap();
        if (Utils.isSafari()) {
          $("body").scrollTop($(".iothub_info").offset().top + 100);
        } else {
          $("html").scrollTop($(".iothub_info").offset().top + 100);
        }
      } else if ((!$stateParams.sector || $stateParams.sector === "biz") && $rootScope.lastType === "bizai") {
        if (Utils.isSafari()) {
          $("body").scrollTop($(".biz_ai_cont").offset().top + 100);
        } else {
          $("html").scrollTop($(".biz_ai_cont").offset().top + 100);
        }
      }
      $rootScope.lastType = "";
    }, 100);
  } else if (window.gatewayDemoState && window.gatewayDemoState.state === "out") {
    window.gatewayDemoState = null;
    $timeout(function () {
      if (Utils.isSafari()) {
        $("body").scrollTop($(".biz_sec12").offset().top + 300);
      } else {
        $("html").scrollTop($(".biz_sec12").offset().top + 300);
      }
    }, 100);
  } else if (window.monitorDemoState && window.monitorDemoState.state === "out") {
    window.monitorDemoState = null;
    $timeout(function () {
      if (Utils.isSafari()) {
        $("body").scrollTop($(".biz_sec13").offset().top + 200);
      } else {
        $("html").scrollTop($(".biz_sec13").offset().top + 200);
      }
    }, 100);
  } else {
    window.gatewayDemoState = null;
    window.monitorDemoState = null;
  }
  function setProductTabMouseOverEvent() {
    var $productTab = $("#product_wrap .inner");
    if ($productTab.length) {
      $productTab.on("mouseover", function (e) {
        if (productRotationInterval) {
          $interval.cancel(productRotationInterval);
          productRotationInterval = null;
        }
      });
      $productTab.on("mouseleave", function (e) {
        if ($scope.biz_show === true) {
          if (productRotationInterval) {
            $interval.cancel(productRotationInterval);
          }
          productRotationInterval = $interval(productRotate, 5000);
        }
      });
    }
  }
  $scope.selectAiTab = function (idx) {
    $scope.isFaceSectReplayShow = false;
    $scope.selectedAiTabIdx = idx;
    if (idx === 0) {
      initFaceSectVideo();
      $scope.playFaceSectVideo();
    } else if (idx === 2) {
      $scope.playMonitorSectVideo();
    }
    $(".selected_cont").fadeOut(300, function () {
      $(this).removeClass("selected_cont");
      $(".selcted_ai_cont").addClass("selected_cont");
      $(".selcted_ai_cont").fadeIn(300);
    });
  };
  function initFaceSectVideo() {
    var faceSectVideo = $("#faceSectVideo");
    if (faceSectVideo.length) {
      faceSectVideo.on("ended", function () {
        $scope.isFaceSectReplayShow = true;
        $scope.$apply();
      });
    }
    $scope.isFaceSectReplayShow = false;
  }
  $scope.playFaceSectVideo = function () {
    var faceSectVideo = $("#faceSectVideo");
    if (faceSectVideo.length && faceSectVideo[0]) {
      faceSectVideo[0].currentTime = 0;
      if (faceSectVideo[0].play) {
        faceSectVideo[0].play();
      }
      $scope.isFaceSectPlay = true;
      $scope.isFaceSectReplayShow = false;
    }
  };
  $scope.playMonitorSectVideo = function () {
    var monitorSectVideo = $("#monitorSectVideo");
    if (monitorSectVideo.length && monitorSectVideo[0]) {
      monitorSectVideo[0].currentTime = 0;
      if (monitorSectVideo[0].play) {
        monitorSectVideo[0].play();
      }
      $scope.isMonitorSectPlay = true;
    }
  };
  function setAiTabInfos() {
    $scope.aiTabInfos = [{
      description: $translate.instant("9rRqk7Vo_02431")
    }, {
      description: $translate.instant("9rRqk7Vo_02433")
    }, {
      description: $translate.instant("9rRqk7Vo_02434")
    }];
  }
  $scope.goTop = function () {
    $("html").animate({
      scrollTop: 0
    }, 200);
  };
  function setWindowScrollEvent(isOn) {
    if (isOn) {
      $(window).on("scroll", function () {
        var scrollTop = $(window).scrollTop();
        if (scrollTop > 0) {
          if ($scope.isTop) {
            $scope.isTop = false;
            $scope.$apply();
          }
        } else {
          if (!$scope.isTop) {
            $scope.isTop = true;
            $scope.$apply();
          }
        }
        if (scrollTop > 710) {
          if (!$scope.isStickyTab) {
            $scope.isStickyTab = true;
            $scope.$apply();
          }
        } else {
          if ($scope.isStickyTab) {
            $scope.isStickyTab = false;
            $scope.$apply();
          }
        }
        if ($scope.v3_show === true) {
          if (nightImageMoveFlag) {
            var $nightView = $("#night_view_mode");
            if ($nightView.length && $nightView.offset()) {
              if (scrollTop >= Math.ceil($nightView.offset().top - 300)) {
                nightImageMoveFlag = false;
                $scope.selectNightViewMode(2);
                $timeout(function () {
                  $scope.selectNightViewMode(3);
                }, 700);
              }
            }
          }
        } else if ($scope.biz_show === true) {
          if ($scope.selectedAiTabIdx === 0 && !$scope.isFaceSectPlay) {
            var $faceSectVideo = $("#faceSectVideo");
            if ($faceSectVideo.length) {
              var vOffset = $faceSectVideo.offset();
              if (scrollTop >= Math.ceil(vOffset.top - 750)) {
                $scope.playFaceSectVideo();
              }
            }
          }
        }
      });
    } else {
      $(window).off("scroll");
    }
  }
  function setSlideInterval(isOn) {
    if (slideImageInterval) {
      $interval.cancel(slideImageInterval);
    }
    if (isOn) {
      slideImageInterval = $interval(function () {
        var $slider = $("#intro_slider"),
          $parent;
        var parentWidth = 1280;
        $parent = $slider.parent() ? $slider.parent()[0] : null;
        if ($parent && $parent.offsetWidth) {
          parentWidth = $parent.offsetWidth;
        }
        if ($slider.length) {
          if ($scope.slideLeft > -(parentWidth * 2)) {
            if ($scope.slideLeft <= 0 && $scope.slideLeft > -parentWidth) {
              $scope.slideLeft = -parentWidth;
            } else {
              $scope.slideLeft = -(parentWidth * 2);
            }
            $slider.animate({
              left: $scope.slideLeft + "px"
            }, 700);
          } else {
            $scope.slideLeft = 0;
            $slider.animate({
              left: "0px"
            }, 700);
          }
        }
      }, 4000);
    }
  }
  function setDidSwiper(isOn) {
    if (isOn) {
      didSwiper = new Swiper(".swiper-container.did-swiper", {
        // Optional parameters
        //direction: 'vertical',
        direction: "horizontal",
        loop: true,
        // autoplay
        autoplay: 5000,
        autoplayDisableOnInteraction: false
        // And if we need scrollbar
        //scrollbar: '.swiper-scrollbar',
      });
    } else {
      if (didSwiper && didSwiper.destroy) {
        didSwiper.destroy();
        didSwiper = null;
      }
    }
  }
  function productRotate() {
    $scope.productRotationIndex = $scope.productRotationIndex >= 4 ? 0 : $scope.productRotationIndex + 1;
    var elProductWrap = document.getElementById("product_wrap"),
      elClassName = "intro_sec biz_sec9 is_align_right";
    if (0 <= $scope.productRotationIndex <= 4) {
      elClassName += " biz_product0".concat($scope.productRotationIndex + 1);
    }
    if (elProductWrap) {
      elProductWrap.className = elClassName;
    }
  }
  $scope.selectSensor = function (idx) {
    $scope.selectSensorIdx = idx;
    switch (idx) {
      case 0:
        $scope.selectSensorDesc = $translate.instant("9rRqk7Vo_02044");
        break;
      case 1:
        $scope.selectSensorDesc = $translate.instant("9rRqk7Vo_02045");
        break;
      case 2:
        $scope.selectSensorDesc = $translate.instant("9rRqk7Vo_02046");
        break;
      case 3:
        $scope.selectSensorDesc = $translate.instant("9rRqk7Vo_02047");
        break;
      case 4:
        $scope.selectSensorDesc = $translate.instant("9rRqk7Vo_02048");
        break;
      case 5:
        $scope.selectSensorDesc = $translate.instant("9rRqk7Vo_02049");
        break;
      default:
        $scope.selectSensorDesc = $translate.instant("9rRqk7Vo_02044");
        break;
    }
  };
  $scope.selectProductTab = function (index) {
    if (productRotationInterval) {
      $interval.cancel(productRotationInterval);
    }
    $scope.productRotationIndex = index;
    var elProductWrap = document.getElementById("product_wrap"),
      elClassName = "intro_sec biz_sec9 is_align_right";
    if (0 <= $scope.productRotationIndex <= 4) {
      elClassName += " biz_product0".concat($scope.productRotationIndex + 1);
    }
    if (elProductWrap) {
      elProductWrap.className = elClassName;
    }
  };
  $scope.showToastCamServiceRequestLayer = function () {
    $scope.request = {
      companyName: "",
      tel1: "010",
      tel2: "",
      tel3: "",
      email: "",
      address: "",
      content: ""
    };
    $scope.isShowToastCamServiceRequestLayer = true;
  };
  $scope.closeToastCamServiceRequestLayer = function () {
    $scope.isShowToastCamServiceRequestLayer = false;
  };
  $scope.serviceRequestSummit = function () {
    var title = $translate.instant("USER_REQUEST");
    if ($scope.request.companyName.trim() === "") {
      showAlert(title, $translate.instant("USER_NAME_INPUT"));
      return;
    }
    var telNum = "".concat($scope.request.tel1, "-").concat($scope.request.tel2, "-").concat($scope.request.tel3);
    if ($scope.request.tel2.trim() === "" || $scope.request.tel3.trim() === "") {
      showAlert(title, $translate.instant("USER_NUMBER_INPUT"));
      return;
    } else {
      if (!/^[0-9]*$/.test($scope.request.tel2 + $scope.request.tel3)) {
        showAlert(title, $translate.instant("USER_ONLY_NUMBER_INPUT"));
        return;
      } else if (!/^\d{3}-\d{3,4}-\d{4}$/.test(telNum)) {
        showAlert(title, $translate.instant("USER_NOT_PHONE_NUMBER"));
        return;
      }
    }
    if ($scope.request.email.trim() === "") {
      showAlert(title, $translate.instant("USER_MAIL_ADDRESS_INPUT"));
      return;
    } else {
      var emailRegExp = /^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i;
      if (!emailRegExp.test($scope.request.email)) {
        showAlert(title, $translate.instant("USER_NOT_MAIL_ADDRESS"));
        return;
      }
    }
    if ($scope.request.address.trim() === "") {
      showAlert(title, $translate.instant("USER_LOCATION_INPUT"));
      return;
    }
    if ($scope.request.content.trim() === "") {
      showAlert(title, $translate.instant("USER_COMMENT_INPUT"));
      return;
    }
    var requestParam = {
      companyName: $scope.request.companyName,
      mobile: telNum,
      email: $scope.request.email,
      location: $scope.request.address,
      message: $scope.request.content
    };
    Service.serviceRequest(requestParam, function (res) {
      if (res.code === "ok") {
        showAlert(title, $translate.instant("USER_REQUEST_SUCCESS"));
        $scope.isShowToastCamServiceRequestLayer = false;
      } else {
        showAlert(title, $translate.instant("USER_REQUEST_FAIL"));
      }
    }, function (err) {
      showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
    });
  };

  // 상단 swiper 초기화
  $scope.initSwiper = function () {
    mySwiper = new Swiper(".swiper-container.tit-swiper", {
      // Optional parameters
      //direction: 'vertical',
      direction: "horizontal",
      loop: true,
      // autoplay
      autoplay: 5000,
      autoplayDisableOnInteraction: false,
      pagination: ".swiper-pagination",
      paginationClickable: true
      // And if we need scrollbar
      //scrollbar: '.swiper-scrollbar'
    });
    mySwiper.on("transitionEnd", function () {
      switch (mySwiper.activeIndex) {
        case 1:
        case 5:
          $("#toastcam_menu").removeClass("white_bg");
          break;
        case 2:
          $("#toastcam_menu").removeClass("white_bg");
          break;
        case 0:
        case 3:
        case 4:
          $("#toastcam_menu").addClass("white_bg");
          break;
        default:
          break;
      }
    });
  };
  function setTranslateMap() {
    $scope.selectSensorDesc = $translate.instant("9rRqk7Vo_02044");
    if ($scope.deviceMap) {
      return;
    }
    $scope.deviceMap = {
      cloudIp1: [{
        name: "V4 / V4 LTE",
        desc: $sce.trustAsHtml($translate.instant("9rRqk7Vo_02299") + ", " + $translate.instant("9rRqk7Vo_02300") + "<br>" + '<span style="font-size:13px;">Wi-Fi, Z-wave, BLE, Ethernet, LTE(' + $translate.instant("9rRqk7Vo_02028") + ")</span><br>" + $translate.instant("TOAST_HELP_47") + ", " + $translate.instant("VIDEO_DEGREE") + "135°"),
        img: "/resources/img/img-lineup-camera-lte.png"
      }, {
        name: "V4 AI / AI+",
        desc: $translate.instant("9rRqk7Vo_02301") + "<br>" + $translate.instant("9rRqk7Vo_02302") + "<br>" + $translate.instant("9rRqk7Vo_02303"),
        img: "/resources/img/img-lineup-camera-v-4.png"
      }, {
        name: "V3 Pro",
        desc: $sce.trustAsHtml($translate.instant("9rRqk7Vo_02299") + ", " + $translate.instant("9rRqk7Vo_02300") + "<br>" + '<span style="font-size:15px;">Wi-Fi, Z-wave, BLE, Ethernet</span><br>' + $translate.instant("TOAST_HELP_47") + ", " + $translate.instant("VIDEO_DEGREE") + "135°"),
        img: "/resources/img/img-lineup-camera-v-3-pro.png"
      }, {
        name: "V3 Lite",
        desc: $sce.trustAsHtml($translate.instant("9rRqk7Vo_02300") + "<br>" + '<span style="font-size:15px;">Wi-Fi, BLE, Ethernet</span><br>' + $translate.instant("TOAST_HELP_47") + ", " + $translate.instant("VIDEO_DEGREE") + "135°"),
        img: "/resources/img/img-lineup-camera-v-3-lite.png"
      }],
      cloudIp2: [{
        name: "V2",
        desc: $translate.instant("9rRqk7Vo_02304") + "<br>Wi-Fi, BLE<br>" + $translate.instant("TOAST_HELP_47") + ", " + $translate.instant("VIDEO_DEGREE") + "135°",
        img: "/resources/img/img-lineup-camera-v-2.png"
      }, {
        name: $translate.instant("TOAST_CAM") + " Standard",
        desc: $translate.instant("9rRqk7Vo_02304") + "<br>" + $translate.instant("9rRqk7Vo_02305"),
        img: "/resources/img/img-lineup-camera-v-3-standard.png"
      }, {
        name: $translate.instant("TOAST_CAM") + " Bullet",
        desc: $translate.instant("9rRqk7Vo_02306") + ", " + $translate.instant("9rRqk7Vo_02300") + "<br>" + $translate.instant("TOAST_HELP_47") + ", " + $translate.instant("VIDEO_DEGREE") + "81°",
        img: "/resources/img/img-lineup-camera-bullet.png"
      }, {
        name: $translate.instant("TOAST_CAM") + " Dome",
        desc: $translate.instant("9rRqk7Vo_02306") + ", " + $translate.instant("9rRqk7Vo_02300") + "<br>" + $translate.instant("TOAST_HELP_47") + ", " + $translate.instant("VIDEO_DEGREE") + "81°",
        img: "/resources/img/img-lineup-camera-dome.png"
      }],
      iothub: [{
        name: $translate.instant("9rRqk7Vo_02135"),
        desc: $translate.instant("9rRqk7Vo_02103"),
        desc2: $translate.instant("9rRqk7Vo_02442"),
        img: "/resources/img/img-lineup-io-t-hub1.png"
      }],
      analog: [{
        name: $translate.instant("9rRqk7Vo_02107") + " Bullet",
        desc: $translate.instant("TOAST_HELP_197") + "<br>" + $translate.instant("TOAST_HELP_47") + "<br>" + $translate.instant("9rRqk7Vo_02094"),
        img: "/resources/img/img-lineup-camera-cms.png"
      }, {
        name: $translate.instant("9rRqk7Vo_02107") + " Dome",
        desc: $translate.instant("9rRqk7Vo_02103") + "<br>" + $translate.instant("TOAST_HELP_47") + "<br>" + $translate.instant("9rRqk7Vo_02094"),
        img: "/resources/img/img-lineup-camera-cmsm.png"
      }],
      dvr: [{
        name: "DVR",
        desc: $translate.instant("9rRqk7Vo_02104") + "<br>" + $translate.instant("9rRqk7Vo_02105") + "<br>&nbsp;",
        img: "/resources/img/img-lineup-dvr.png"
      }],
      doorlock: [{
        name: $translate.instant("9rRqk7Vo_02095"),
        desc: "Z-wave, BLE<br>" + $translate.instant("9rRqk7Vo_02096") + "<br>" + $translate.instant("9rRqk7Vo_02097"),
        img: "/resources/img/img-lineup-doorlock-kr.png"
      }, {
        name: $translate.instant("9rRqk7Vo_02098"),
        desc: "Z-Wave, BLE<br>" + $translate.instant("9rRqk7Vo_02099") + "<br>" + $translate.instant("9rRqk7Vo_02100") + "<br>" + $translate.instant("9rRqk7Vo_02101"),
        img: "/resources/img/img-lineup-doorlock-jp.png"
      }],
      monitoring: [{
        name: "Gateway-IP",
        desc: $translate.instant("9rRqk7Vo_02082") + "<br>" + $translate.instant("9rRqk7Vo_02083") + "<br>" + $translate.instant("9rRqk7Vo_02084"),
        img: "/resources/img/img-lineup-gateway-ip.png"
      }, {
        name: "Gateway-Analog",
        desc: $translate.instant("5mw2slvk_02281") + "<br>" + $translate.instant("9rRqk7Vo_02084") + "<br>&nbsp;",
        img: "/resources/img/img-lineup-dvr.png"
      }],
      did: [{
        name: "DID",
        desc: $translate.instant("9rRqk7Vo_02085") + "<br>" + $translate.instant("9rRqk7Vo_02086") + "<br>" + $translate.instant("9rRqk7Vo_02087"),
        img: "/resources/img/img-lineup-did.png"
      }],
      edge: [{
        name: "Edge Monitoring",
        desc: $translate.instant("9rRqk7Vo_02106") + "<br>" + $translate.instant("9rRqk7Vo_02083") + "<br>" + $translate.instant("9rRqk7Vo_02084"),
        img: "/resources/img/img-lineup-edge-monitoring.png"
      }],
      iot: [{
        name: $translate.instant("STR_MOVE_SENSOR"),
        img: "/resources/img/img-device-sensor-motion.png"
      }, {
        name: $translate.instant("STR_DOOR_SENSOR"),
        img: "/resources/img/img-device-sensor-door.png"
      }, {
        name: $translate.instant("STR_SMOKE_SENSOR"),
        img: "/resources/img/img-device-sensor-smoke.png"
      }, {
        name: $translate.instant("STR_GAS_SENSOR"),
        img: "/resources/img/img-device-sensor-gas.png"
      }, {
        name: $translate.instant("STR_TEMP_HUMID_SENSOR"),
        img: "/resources/img/img-device-sensor-hum1.png"
      }, {
        name: $translate.instant("STR_PLUG_SENSOR"),
        img: "/resources/img/img-device-sensor-plug1.png"
      }],
      accessory: [{
        name: $translate.instant("9rRqk7Vo_02102"),
        desc: $translate.instant("9rRqk7Vo_02088") + "<br>" + $translate.instant("9rRqk7Vo_02089"),
        img: "/resources/img/img-device-network-box1.png"
      }, {
        name: "PoE",
        desc: $translate.instant("9rRqk7Vo_02088") + "<br>" + $translate.instant("9rRqk7Vo_02089") + "<br>" + $translate.instant("9rRqk7Vo_02090"),
        img: "/resources/img/img-device-poe1.png"
      }]
    };
  }
  $timeout(function () {
    if (Utils.getBrowserVersion().name === "Chrome") {
      $(".sticky_tab").css("width", "100vw");
    }
    $scope.initSwiper();
    setDidSwiper(true);
    initFaceSectVideo();
    setTranslateMap();
    setAiTabInfos();
    $scope.aiTxt = $sce.trustAsHtml($translate.instant("9rRqk7Vo_02297"));
    $scope.aipTxt = $sce.trustAsHtml($translate.instant("9rRqk7Vo_02298"));
    $(".lazy").Lazy({
      scrollDirection: "vertical"
    });
  }, 1000);
  var showAlert = function showAlert(title, message) {
    $(".display_show").css("display", "");
    $scope.showAlert = true;
    $scope.alertTitle = title;
    $scope.alertMessage = message;
  };
  $scope.showArtiseeLayer = function () {
    $scope.isShowArtiseeLayer = true;
  };
  $scope.closeArtiseeLayer = function () {
    $scope.isShowArtiseeLayer = false;
  };
  $scope.showOudtdoorStoryLayer = function () {
    $scope.isShowOudtdoorStoryLayer = true;
  };
  $scope.closeOudtdoorStoryLayer = function () {
    $scope.isShowOudtdoorStoryLayer = false;
  };
  $scope.showKglogisLayer = function () {
    $scope.isShowKglogisLayer = true;
  };
  $scope.closeKglogisLayer = function () {
    $scope.isShowKglogisLayer = false;
  };
  $scope.show60ChickenLayer = function () {
    $scope.isShow60ChickenLayer = true;
  };
  $scope.close60ChickenLayer = function () {
    $scope.isShow60ChickenLayer = false;
  };
  $scope.show09CleanLayer = function () {
    $scope.isShow09CleanLayer = true;
  };
  $scope.close09CleanLayer = function () {
    $scope.isShow09CleanLayer = false;
  };
  $scope.prevProduct = function () {
    if ($scope.productRotationIndex <= 0) {
      $scope.productRotationIndex = 4;
    } else {
      $scope.productRotationIndex -= 1;
    }
    $scope.selectProductTab($scope.productRotationIndex);
  };
  $scope.nextProduct = function () {
    if ($scope.productRotationIndex >= 4) {
      $scope.productRotationIndex = 0;
    } else {
      $scope.productRotationIndex += 1;
    }
    $scope.selectProductTab($scope.productRotationIndex);
  };
  function makeAiGraph() {
    var i,
      len,
      datas = [{
        height: 231,
        time: 10,
        color: "#4a96e6"
      }, {
        height: 189,
        color: "#4a96e6"
      }, {
        height: 231,
        time: 12,
        color: "#4a96e6"
      }, {
        height: 115,
        color: "#4a96e6"
      }, {
        height: 313,
        time: 14,
        color: "#e94155",
        max: true
      }, {
        height: 164,
        color: "#4a96e6"
      }, {
        height: 58,
        time: 16,
        color: "#4a96e6"
      }];
    $(".ai_graph_wrap").empty();
    len = datas.length;
    for (i = 0; i < len; i += 1) {
      $("<div/>", {
        "class": "ai_graph_bar" + (datas[i].max ? " max_graph" : ""),
        css: {
          width: "32px",
          height: datas[i].height + "px",
          background: datas[i].color
        },
        html: "<p>" + (datas[i].time ? datas[i].time + (lang === "ja" ? "時" : "시") : "") + "</p>"
      }).appendTo(".ai_graph_wrap");
    }
    $("<div/>", {
      "class": "ai_graph_bar_dummy",
      css: {
        width: "1px",
        height: "313px",
        background: "#fff",
        opacity: 0
      }
    }).appendTo(".ai_graph_wrap");
  }
  function initState() {
    $scope.slideLeft = 0;
    $scope.bizSlideLeft = 0;
    var $slider = $("#intro_slider");
    if ($slider.length) {
      $slider.css("left", "0px");
    }
    var $bizSlider = $("#biz_intro_slider");
    if ($bizSlider.length) {
      $bizSlider.css("left", "0px");
    }
    if (productRotationInterval) {
      $interval.cancel(productRotationInterval);
      productRotationInterval = null;
    }
    $scope.hoverZwave = false;
    setDidSwiper(false);
    setSlideInterval(false);
    $("#product_wrap .inner").off("mouseover mouseleave");
  }
  $scope.changePage = function (type, subType, lastType) {
    prevSector = $state.params.sector;
    $state.go("main", {
      sector: type
    }, {
      notify: false
    });
    $rootScope.lastType = lastType ? lastType : "";
    if (type === "ai") {
      $scope.gotoAi();
    } else if (type === "v3") {
      $scope.gotoV3();
    } else if (type === "dev") {
      $scope.gotoDevice();
    } else if (type === "lte") {
      $scope.gotoLte();
    } else if (type === "monitor") {
      $scope.goMonitor(subType);
    } else {
      $scope.gotoBiz();
    }
  };
  $scope.goPrevPage = function () {
    if (prevSector === "dev") {
      $state.go("main", {
        sector: "dev"
      }, {
        notify: false
      });
      $scope.gotoDevice();
      if ($state.params.sector === "monitor") {
        setTimeout(function () {
          window.scrollTo(0, 6000);
        }, 100);
      }
    } else {
      $state.go("main", {
        sector: "biz"
      }, {
        notify: false
      });
      $scope.gotoBiz();
      if ($state.params.sector === "ai") {
        setTimeout(function () {
          window.scrollTo(0, 2600);
        }, 100);
      }
    }
  };
  $scope.goMonitor = function (subType) {
    if ($scope.monitor_show !== true) {
      $scope.biz_show = false;
      $scope.device_show = false;
      $scope.v3_show = false;
      $scope.lte_show = false;
      $scope.ai_show = false;
      $scope.monitor_show = true;
      initState();
      if (subType && subType.indexOf("Gateway-IP") !== -1) {
        window.scrollTo(0, 650);
      } else if (subType && subType.indexOf("Gateway-Analog") !== -1) {
        window.scrollTo(0, 1865);
      } else if (subType && subType.indexOf("Edge") !== -1) {
        window.scrollTo(0, 2940);
      } else if (subType && subType.indexOf("iothub") !== -1) {
        window.scrollTo(0, 4035);
      } else {
        window.scrollTo(0, 650);
      }
      $timeout(function () {
        makeAiGraph();
        $(".lazy").Lazy({
          scrollDirection: "vertical"
        });
      }, 500);
    }
  };
  $scope.gotoLte = function () {
    if ($scope.lte_show !== true) {
      $scope.biz_show = false;
      $scope.device_show = false;
      $scope.v3_show = false;
      $scope.ai_show = false;
      $scope.monitor_show = false;
      $scope.lte_show = true;
      initState();
      window.scrollTo(0, 650);
      $timeout(function () {
        $(".lazy").Lazy({
          scrollDirection: "vertical"
        });
      }, 500);
    }
  };
  $scope.gotoAi = function () {
    if ($scope.ai_show !== true) {
      $scope.biz_show = false;
      $scope.device_show = false;
      $scope.v3_show = false;
      $scope.lte_show = false;
      $scope.monitor_show = false;
      $scope.ai_show = true;
      $scope.aiplus_spec = true;
      initState();
      window.scrollTo(0, 650);
      $timeout(function () {
        makeAiGraph();
        $(".lazy").Lazy({
          scrollDirection: "vertical"
        });
      }, 500);
    }
  };
  $scope.gotoV3 = function () {
    if ($scope.v3_show !== true) {
      $scope.biz_show = false;
      $scope.device_show = false;
      $scope.ai_show = false;
      $scope.lte_show = false;
      $scope.monitor_show = false;
      $scope.v3_show = true;
      nightImageMoveFlag = true;
      initState();
      window.scrollTo(0, 650);
      $timeout(function () {
        elNightViewMode = document.getElementById("night_view_mode");
        if (elNightViewMode) {
          elNightViewModeBtnList = elNightViewMode.querySelectorAll(".feat_btn");
        }
        $("#rotate_camera").reel({
          images: "/resources/img/black_s_000##.jpg|00..36"
        });
        setSlideInterval(true);
        $(".lazy").Lazy({
          scrollDirection: "vertical"
        });
      }, 500);
    }
  };
  $scope.gotoDevice = function () {
    $scope.aiTxt = $sce.trustAsHtml($translate.instant("9rRqk7Vo_02297"));
    $scope.aipTxt = $sce.trustAsHtml($translate.instant("9rRqk7Vo_02298"));
    if ($scope.device_show !== true) {
      $scope.device_show = true;
      $scope.v3_show = false;
      $scope.ai_show = false;
      $scope.lte_show = false;
      $scope.monitor_show = false;
      $scope.biz_show = false;
      initState();
      $timeout(function () {
        $(".lazy").Lazy({
          scrollDirection: "vertical"
        });
        $(".zwave_desc span").hover(function () {
          $scope.hoverZwave = true;
          $scope.$apply();
        }, function () {
          $scope.hoverZwave = false;
          $scope.$apply();
        });
      }, 500);
    }
  };
  $scope.gotoBiz = function () {
    if ($scope.biz_show !== true) {
      $scope.device_show = false;
      $scope.v3_show = false;
      $scope.ai_show = false;
      $scope.lte_show = false;
      $scope.monitor_show = false;
      $scope.biz_show = true;
      $scope.selectedAiTabIdx = 0;
      $scope.isFaceSectReplayShow = false;
      $scope.isFaceSectPlay = false;
      $scope.isMonitorSectPlay = false;
      initState();
      //window.scrollTo(0, 600);
      $timeout(function () {
        setProductTabMouseOverEvent();
        if (productRotationInterval) {
          $interval.cancel(productRotationInterval);
        }
        productRotationInterval = $interval(productRotate, 5000);
        setDidSwiper(true);
        $(".lazy").Lazy({
          scrollDirection: "vertical"
        });
        initFaceSectVideo();
      }, 500);
    }
  };
  $scope.selectNightViewMode = function (modeStep) {
    if (elNightViewMode) {
      if (modeStep === 1) {
        elNightViewMode.className = "intro_sec is_align_left sec_v3_3 is_step1";
        if (elNightViewModeBtnList && elNightViewModeBtnList.length >= 3) {
          elNightViewModeBtnList[0].className = "feat_btn feat_btn_night1 is_selected";
          elNightViewModeBtnList[1].className = "feat_btn feat_btn_night2";
          elNightViewModeBtnList[2].className = "feat_btn feat_btn_night3";
        }
      } else if (modeStep === 2) {
        elNightViewMode.className = "intro_sec is_align_left sec_v3_3 is_step2";
        if (elNightViewModeBtnList && elNightViewModeBtnList.length >= 3) {
          elNightViewModeBtnList[0].className = "feat_btn feat_btn_night1";
          elNightViewModeBtnList[1].className = "feat_btn feat_btn_night2 is_selected";
          elNightViewModeBtnList[2].className = "feat_btn feat_btn_night3";
        }
      } else if (modeStep === 3) {
        elNightViewMode.className = "intro_sec is_align_left sec_v3_3 is_step3";
        if (elNightViewModeBtnList && elNightViewModeBtnList.length >= 3) {
          elNightViewModeBtnList[0].className = "feat_btn feat_btn_night1";
          elNightViewModeBtnList[1].className = "feat_btn feat_btn_night2";
          elNightViewModeBtnList[2].className = "feat_btn feat_btn_night3 is_selected";
        }
      }
    }
  };
  $scope.slidePrevImg = function () {
    setSlideInterval(false);
    var $slider = $("#intro_slider"),
      $parent;
    var parentWidth = 1280;
    $parent = $slider.parent() ? $slider.parent()[0] : null;
    if ($parent && $parent.offsetWidth) {
      parentWidth = $parent.offsetWidth;
    }
    if ($slider.length) {
      if ($scope.slideLeft < 0) {
        if ($scope.slideLeft >= -parentWidth) {
          $scope.slideLeft = 0;
        } else {
          $scope.slideLeft = -parentWidth;
        }
        $slider.animate({
          left: $scope.slideLeft + "px"
        }, 700);
      }
    }
  };
  $scope.slideNextImg = function () {
    setSlideInterval(false);
    var $slider = $("#intro_slider"),
      $parent;
    var parentWidth = 1280;
    $parent = $slider.parent() ? $slider.parent()[0] : null;
    if ($parent && $parent.offsetWidth) {
      parentWidth = $parent.offsetWidth;
    }
    if ($slider.length) {
      if ($scope.slideLeft > -(parentWidth * 2)) {
        if ($scope.slideLeft > -parentWidth) {
          $scope.slideLeft = -parentWidth;
        } else {
          $scope.slideLeft = -(parentWidth * 2);
        }
        $slider.animate({
          left: $scope.slideLeft + "px"
        }, 700);
      }
    }
  };
  $scope.slideBizPrevImg = function () {
    var $slider = $("#biz_intro_slider"),
      $parent;
    var parentWidth = 1280;
    $parent = $slider.parent() ? $slider.parent()[0] : null;
    if ($parent && $parent.offsetWidth) {
      parentWidth = $parent.offsetWidth;
    }
    if ($slider.length) {
      if ($scope.bizSlideLeft < 0) {
        if ($scope.bizSlideLeft >= -parentWidth) {
          $scope.bizSlideLeft = 0;
        } else {
          $scope.bizSlideLeft = -parentWidth;
        }
        $slider.animate({
          left: $scope.bizSlideLeft + "px"
        }, 700);
      }
    }
  };
  $scope.slideBizNextImg = function () {
    var $slider = $("#biz_intro_slider"),
      $parent;
    var parentWidth = 1280;
    $parent = $slider.parent() ? $slider.parent()[0] : null;
    if ($parent && $parent.offsetWidth) {
      parentWidth = $parent.offsetWidth;
    }
    if ($slider.length) {
      if ($scope.bizSlideLeft > -(parentWidth * 2)) {
        if ($scope.bizSlideLeft > -parentWidth) {
          $scope.bizSlideLeft = -parentWidth;
        } else {
          $scope.bizSlideLeft = -(parentWidth * 2);
        }
        $slider.animate({
          left: $scope.bizSlideLeft + "px"
        }, 700);
      }
    }
  };
  $scope.changeCamColor = function (color) {
    if ($scope.camColor !== color) {
      var $rotateCamera = $("#rotate_camera");
      $scope.camColor = color;
      if ($rotateCamera.length) {
        $rotateCamera.reel({
          images: "/resources/img/" + $scope.camColor + "_s_000##.jpg|00..36"
        });
        $rotateCamera[0].currentSrc = "/resources/img/" + $scope.camColor + "_s_00000.jpg";
      }
    }
  };
  $scope.videoDlgId = "vue-video-dlg-wrapper";
  $scope.showEnterMovie = function (width, height, webmUrl, mp4Url) {
    if (vContentPlayDlg) {
      vContentPlayDlg.destroy();
      vContentPlayDlg = null;
    }
    vContentPlayDlg = tCam.videoPlayDialog({
      elId: $scope.videoDlgId,
      dlgStyle: {
        width: width + "px",
        height: height + "px",
        padding: "60px",
        boxSizing: "border-box",
        overflow: "auto"
      },
      webmUrl: webmUrl,
      mp4Url: mp4Url
    });
  };
  $scope.downloadDidManual = function () {
    if (lang === "ja") {
      window.open("https://bizcam.toast.com/CF/DID_manual_jp.pdf", "_blank");
    } else {
      window.open("https://bizcam.toast.com/CF/DID_manual_kr.pdf", "_blank");
    }
  };
  $scope.downloadGatewayManual = function (type) {
    switch (type) {
      case "analog":
        if (Utils.isSafari()) {
          window.open("/#/gatewayAnalogGuide", "Cloud Gateway-Analog", "scrollbars=no, toolbar=no, resizable=no, width=605, height=640,left=600,top=200");
        } else {
          window.open("/#/gatewayAnalogGuide", "Cloud Gateway-Analog", "scrollbars=no, toolbar=no, resizable=no, width=605, height=625,left=600,top=200");
        }
        break;
      case "ip":
      default:
        if (Utils.isSafari()) {
          window.open("/#/gatewayIpGuide", "Cloud Gateway-IP", "scrollbars=no, toolbar=no, resizable=no, width=605, height=640,left=600,top=200");
        } else {
          window.open("/#/gatewayIpGuide", "Cloud Gateway-IP", "scrollbars=no, toolbar=no, resizable=no, width=605, height=625,left=600,top=200");
        }
        break;
    }
  };
  $scope.goGatewayDemo = function () {
    window.gatewayDemoState = {
      from: "main",
      state: "in"
    };
    $state.go("main.demoGateway");
  };
  $scope.gotoMonitorDemo = function () {
    if ($scope.isLogin) {
      if (Utils.isChrome()) {
        window.monitorDemoState = {
          from: "main",
          state: "in"
        };
        $state.go("main.monitors", {
          demo: "ok"
        });
      } else {
        showAlert($translate.instant("STR_CLOUD_MONITOR"), $translate.instant("STR_USE_CHROME"));
      }
    } else {
      $scope.showEnterMovie(1180, 770, "", $scope.languageSet === "ja" ? "https://bizcam.toast.com/CF/cloud_monitor_demo_jp.mp4" : "https://bizcam.toast.com/CF/cloud_monitor_demo_kr.mp4");
    }
  };
  $scope.downloadMonitorManual = function () {
    if (lang === "ja") {
      window.open("https://bizcam.toast.com/CF/cloud_monitor_manual_jp.pdf", "_blank");
    } else {
      window.open("https://bizcam.toast.com/CF/cloud_monitor_manual_ko.pdf", "_blank");
    }
  };
  if ($stateParams.sector === "ai") {
    $scope.gotoAi();
  } else if ($stateParams.sector === "v3") {
    $scope.gotoV3();
  } else if ($stateParams.sector === "dev") {
    $scope.gotoDevice();
  } else if ($stateParams.sector === "lte") {
    $scope.gotoLte();
  } else if ($stateParams.sector === "monitor") {
    $scope.goMonitor();
  } else {
    $scope.gotoBiz();
  }
  if ($rootScope.previousState === "main" && !$rootScope.lastType) {
    $timeout(function () {
      window.scrollTo(0, 0);
    }, 500);
  }
}]);
app.controller("IndexMobileCtrl2", ["$scope", "$interval", "$translate", "Service", function ($scope, $interval, $translate, Service) {
  var lang = $("html").attr("lang");
  if (lang === "ja") {
    $scope.isShowPriceRequest = false;
  } else {
    $scope.isShowPriceRequest = true;
  }
  $scope.getContextPath = Utils.getContextPath();
  $scope.goPlayStore = function () {
    setTimeout(function () {
      location.href = "market://details?id=com.nhnent.toastcam";
    }, 500);
  };
  $scope.goAppStore = function () {
    setTimeout(function () {
      location.href = "https://itunes.apple.com/kr/app/toseuteukaem/id1048514287?mt=8";
    }, 500);
  };
  $("#mobileViewSizeCheck").attr("content", "user-scalable=0");
  $scope.app_open = function () {
    var openAt = new Date(),
      uagentLow = navigator.userAgent.toLocaleLowerCase(),
      chrome25,
      kitkatWebview;
    $("body").append("<iframe id='____toastcamlink____'></iframe>");
    $("#____toastcamlink____").hide();
    setTimeout(function () {
      if (new Date() - openAt < 4000) {
        if (uagentLow.search("android") > -1) {
          $("#____toastcamlink____").attr("src", "market://details?id=com.nhnent.toastcam");
        }
      }
    }, 1000);
    if (uagentLow.search("android") > -1) {
      chrome25 = uagentLow.search("chrome") > -1 && navigator.appVersion.match(/Chrome\/\d+.\d+/)[0].split("/")[1] > 25;
      kitkatWebview = uagentLow.indexOf("naver") != -1 || uagentLow.indexOf("daum") != -1;
      if (chrome25 && !kitkatWebview) {
        document.location.href = "intent://toastcam?param=value#Intent;scheme=toast;package=com.nhnent.toastcam;end";
      } else {
        $("#____toastcamlink____").attr("src", "toast://toastcam");
      }
    }
    $("#____toastcamlink____").remove();
  };

  // 카메라 안내영역 인덱스
  $scope.cameraInfoIndex = 0;
  var imageFlag = true;
  var rotatioCameraImage;
  $(window).scroll(function () {
    if ($(this).scrollTop() >= Math.ceil($("#cameraImageRotation").offset().top - 300) && imageFlag) {
      imageFlag = false;
      $scope.rotatioCameraImage();
    }
    if (Math.ceil($("#cameraImageRotation").offset().top - 1000) > $(this).scrollTop() && !imageFlag) {
      $interval.cancel(rotatioCameraImage);
      imageFlag = true;
      $scope.cameraInfoIndex = 0;
    }
  });
  $scope.rotatioCameraImage = function () {
    rotatioCameraImage = $interval(function () {
      $scope.cameraInfoIndex = $scope.cameraInfoIndex < 5 ? ++$scope.cameraInfoIndex : 0;
    }, 3000);
  };

  // 카메라 안내영역 변경 처리
  $scope.changeCameraInfo = function (index) {
    $scope.cameraInfoIndex = index;
  };

  // 가입상담 신청 폼 초기화
  $scope.initRequestForm = function () {
    $scope.request = {
      companyName: "",
      tel1: "010",
      tel2: "",
      tel3: "",
      email: "",
      address: "",
      content: ""
    };
  };
  $scope.initRequestForm();

  // 가입상담 신청 처리
  $scope.serviceRequestSummit = function () {
    var title = $translate.instant("USER_REQUEST");
    if ($scope.request.companyName.trim() === "") {
      $scope.showAlert(title, $translate.instant("USER_NAME_INPUT"));
      return;
    }
    var telNum = $scope.request.tel1 + "-" + $scope.request.tel2 + "-" + $scope.request.tel3;
    if ($scope.request.tel2.trim() === "" || $scope.request.tel3.trim() === "") {
      $scope.showAlert(title, $translate.instant("USER_NUMBER_INPUT"));
      return;
    } else {
      if (!/^[0-9]*$/.test($scope.request.tel2 + $scope.request.tel3)) {
        $scope.showAlert(title, $translate.instant("USER_ONLY_NUMBER_INPUT"));
        return;
      } else if (!/^\d{3}-\d{3,4}-\d{4}$/.test(telNum)) {
        $scope.showAlert(title, $translate.instant("USER_NOT_PHONE_NUMBER"));
        return;
      }
    }
    if ($scope.request.email.trim() === "") {
      $scope.showAlert(title, $translate.instant("USER_MAIL_ADDRESS_INPUT"));
      return;
    } else {
      var emailRegExp = /^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i;
      if (!emailRegExp.test($scope.request.email)) {
        $scope.showAlert(title, $translate.instant("USER_NOT_MAIL_ADDRESS"));
        return;
      }
    }
    if ($scope.request.address.trim() === "") {
      $scope.showAlert(title, $translate.instant("USER_LOCATION_INPUT"));
      return;
    }
    if ($scope.request.content.trim() === "") {
      $scope.showAlert(title, $translate.instant("USER_COMMENT_INPUT"));
      return;
    }
    var requestParam = {
      companyName: $scope.request.companyName,
      mobile: telNum,
      email: $scope.request.email,
      location: $scope.request.address,
      message: $scope.request.content
    };
    $scope.isLoadingComplete = false;
    Service.serviceRequest(requestParam, function (res) {
      if (res.code === "ok") {
        $scope.showAlert(title, $translate.instant("USER_REQUEST_SUCCESS"));
        $scope.initRequestForm();
      } else {
        $scope.showAlert(title, $translate.instant("USER_REQUEST_FAIL"));
      }
    }, function (err) {
      $scope.showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
    });
  };
  $scope.showAlert = function (title, message) {
    $scope.isServiceRequestAlert = true;
    $scope.alertTitle = title;
    $scope.alertMessage = message;
  };
  $scope.hideAlert = function () {
    $scope.isServiceRequestAlert = false;
  };
}]);
app.controller("PasswordConfirmCtrl", ["$scope", "User", "$sce", "$window", function ($scope, User, $sce, $window) {
  $("body").css("min-width", 0);
  $scope.me = User.me(function () {
    $scope.isLogin = true;
  });
  var loginUrl = paycoUrl + "login.nhn";
  var confirmUrl = paycoUrl + "auth/confirmPwd.nhn";
  var httpUrl = location.origin;
  if (httpUrl == undefined) {
    httpUrl = location.protocol + "//" + location.hostname;
  }
  void 0;
  var ci = opener.ci;
  var at = opener.at;
  var url = loginUrl + "?m=bridge&client_id=" + ci + "&access_token=" + encodeURIComponent(at) + "&nextUrl=" + encodeURIComponent(confirmUrl + "?serviceProviderCode=BIZCAM&reason=CONFIRM_PWD&treatmentUrl=" + httpUrl + "/cproc?deviceType=web&userLocale=ko_KR");
  $scope.iframeUrl = $sce.trustAsResourceUrl(url);
  $window.confirmPasswordCallback = function () {
    self.close();
    opener.confirmPaycoPasswordCallback();
  };
}]);
"use strict";

app.config(function ($translateProvider) {
  var supportedLanguages = ["en", "ko", "ja"];
  $translateProvider.registerAvailableLanguageKeys(supportedLanguages, {
    en_US: "en",
    ko_KR: "ko",
    ja_JP: "ja"
  }).determinePreferredLanguage();
  var getLang = navigator.language || navigator.userLanguage;
  if (getLang.indexOf("-") > 0) {
    getLang = getLang.split("-")[0];
  }
  if (navigator.userAgent.indexOf("Googlebot") != -1 || navigator.userAgent.indexOf("GoogleBot") != -1 || navigator.userAgent.indexOf("googlebot") != -1) {
    $translateProvider.preferredLanguage("en");
  } else if (location.pathname && (location.pathname.indexOf("/ja/") != -1 || location.pathname.indexOf("/jp/") != -1)) {
    $translateProvider.preferredLanguage("ja");
  } else {
    if (getLang) {
      if (getLang !== "ko" && getLang !== "ja") {
        getLang = "ko";
      }
      $translateProvider.preferredLanguage(getLang);
    }
  }
  $translateProvider.useLoaderCache(false);
  $translateProvider.useStaticFilesLoader({
    prefix: "/resources/languages/locale-",
    suffix: ".json" + "?t=" + window.buildTime
  });
});
"use strict";

app.controller("NoticePopupCtrl", ["$scope", "NoticePopup", "$sce", "Utils", function ($scope, NoticePopup, $sce, Utils) {
  $scope.notice = {};
  $("body").css("minWidth", 0);
  // 공지사항 조회
  $scope.popupNotice = function () {
    var lang = Utils.getBrowserLanguage();
    var boardTypeVal = lang === "ja_JP" ? "bizcam_ja" : "bizcam";
    NoticePopup.get({
      boardType: boardTypeVal
    }).$promise.then(function (data) {
      if (typeof data.seq === "undefined") {
        return false;
      }
      $scope.notice = data;
      if ($scope.checkPopupNoticeNoMore(data)) {
        return false;
      }
      $scope.notice = data;
      $scope.formattedRegDate = moment(data.regDate).format("YYYY-MM-DD");
    }, function (err) {});
  };
  $scope.renderHtml = function (html_code) {
    return $sce.trustAsHtml(html_code);
  };

  // 공지사항 그만보기 체크
  $scope.checkPopupNoticeNoMore = function (notice) {
    void 0;
    var key = "CAM_NOTICE_POPUP_NO_MORE-" + notice.seq;
    var noticeNoMoreDate = localStorage.getItem(key);
    if (noticeNoMoreDate === null) {
      return false;
    }
    return moment(Number(noticeNoMoreDate)).startOf().isSame(moment().startOf());
  };

  // 공지사항 그만보기 클릭
  $scope.clickPopupNoticeNoMore = function () {
    var key = "CAM_NOTICE_POPUP_NO_MORE-" + $scope.notice.seq;
    localStorage.setItem(key, moment().valueOf());
    window.close();
  };

  // 초기화
  $scope.init = function () {
    $scope.popupNotice();
  };
  $scope.init();
}]);
"use strict";

app.controller('PartnerSignupCtrl', ['$scope', '$state', '$translate', '$location', '$timeout', function ($scope, $state, $translate, $location, $timeout) {
  // 공지사항 그만보기 체크
  $scope.noMoreOpt = false;
  $scope.goSignup = function () {
    opener.location = "/#/help/inquiry?type=biz_support_guest";
    window.close();
  };
  $scope.closePopup = function () {
    if ($scope.noMoreOpt) {
      var key = 'PARTNER_NOTICE_POPUP_NO_MORE';
      localStorage.setItem(key, new Date().valueOf());
    }
    window.close();
  };
}]);
"use strict";

app.controller("positionTerms", ["$scope", function ($scope) {
  $scope.termsVersion = ["v3", "v4", "v5", "v6", "v7", "v8"];
  $scope.termsIdx = $scope.termsVersion.length - 1;
  $scope.goPrev = function () {
    $scope.termsIdx -= 1;
    if ($scope.termsIdx < 0) {
      $scope.termsIdx = 0;
    }
    $("body").scrollTop(0);
    $("html").scrollTop(0);
  };
  $scope.goLast = function () {
    $scope.termsIdx = $scope.termsVersion.length - 1;
    $("body").scrollTop(0);
    $("html").scrollTop(0);
  };
  $scope.contentMap = {
    v8: '<p align="center" class="position-terms-title">\n' + "    <strong> 토스트캠 위치기반서비스 이용약관</strong>\n" + "</p>\n" + '<p align="left">\n' + "    <strong>제1장 총칙</strong>\n" + "</p>\n" + '<p align="left">\n' + "    <strong>제 1조 (목적)</strong>\n" + "</p>\n" + '<p align="left">\n' + "    본 약관은 회원(서비스 이용약관에 동의한 자를 말합니다. 이하 “회원”이라고 합니다.)이 엔에이치엔 주식회사(이하 “회사”라고\n" + "    합니다.)가 제공하는 위치기반서비스(이하 “서비스”라고 합니다)를 이용함에 있어 회사와 회원의 권리·의무 및 책임사항을 규정함을\n" + "    목적으로 합니다.\n" + "</p>\n" + '<p align="left">\n' + "    <strong>제 2 조 (이용약관의 효력 및 변경)</strong>\n" + "</p>\n" + '<p align="left">\n' + "    ①본 약관은 서비스를 신청한 고객 또는 개인위치정보주체가 본 약관에 동의하고 회사가 정한 소정의 절차에 따라 서비스의 이용자로\n" + "    등록함으로써 효력이 발생합니다.\n" + "</p>\n" + '<p align="left">\n' + '    ②회원이 온라인에서 본 약관의 "동의하기" 버튼을 클릭하였을 경우 본 약관의 내용을 모두 읽고 이를 충분히 이해하였으며, 그 적용에\n' + "    동의한 것으로 봅니다.\n" + "</p>\n" + '<p align="left">\n' + "    ③회사는 위치정보의 보호 및 이용 등에 관한 법률, 콘텐츠산업 진흥법, 전자상거래 등에서의 소비자보호에 관한 법률, 소비자기본법 약관의\n" + "    규제에 관한 법률 등 관련법령을 위배하지 않는 범위에서 본 약관을 개정할 수 있습니다.\n" + "</p>\n" + '<p align="left">\n' + "    ④회사가 약관을 개정할 경우에는 기존약관과 개정약관 및 개정약관의 적용일자와 개정사유를 명시하여 기존 약관과 함께 그 적용일자 7일\n" + "    전부터 적용일 이후 상당한 기간 동안 공지만을 하고, 개정 내용이 회원에게 불리한 경우에는 그 적용일자 30일 전부터 적용일 이후\n" + "    상당한 기간 동안 각각 이를 서비스 홈페이지에 게시하거나 회원에게 전자적 형태(전자우편, SMS 등)로 약관 개정 사실을 발송하여\n" + "    고지합니다.\n" + "</p>\n" + '<p align="left">\n' + "    ⑤회사가 전항에 따라 회원에게 통지하면서 공지 또는 공지∙고지일로부터 개정약관 시행일 7일 후까지 거부 의사를 표시하지 아니하면\n" + "    이용약관에 승인한 것으로 봅니다. 회원이 개정약관에 동의하지 않을 경우 회원은 이용계약을 해지할 수 있습니다.\n" + "</p>\n" + '<p align="left">\n' + "    <strong>제 3 조 (관계법령의 적용)</strong>\n" + "</p>\n" + '<p align="left">\n' + "    본 약관은 신의성실의 원칙에 따라 공정하게 적용하며, 본 약관에 명시되지 아니한 사항에 대하여는 관계법령 또는 상관례에 따릅니다.\n" + "</p>\n" + '<p align="left">\n' + "    <strong>제 4 조 (서비스의 내용)</strong>\n" + "</p>\n" + '<p align="left">\n' + "    회사는 직접 위치정보를 수집하거나 위치정보사업자로부터 위치정보를 전달받아 아래와 같은 위치기반서비스를 제공합니다.\n" + "</p>\n" + '<p align="left">\n' + "    1. 운동경로 트래킹 서비스: 운동경로를 추적해 운동과정을 기록하고 분석한 데이터를 제공합니다.\n" + "</p>\n" + '<p align="left">\n' + "    2. Geo Tagging 서비스: 게시물 등록 시점의 개인위치정보주체의 위치정보를 게시물과 함께 저장합니다.\n" + "</p>\n" + '<p align="left">\n' + "    3. 현재 위치를 활용한 검색결과 제공 서비스: 정보 검색 요청 시 개인위치정보주체의 현 위치를 이용한 검색결과 및 주변결과(지역정보,\n" + "    주변업체 및 쿠폰정보, 할인정보 등)를 제시합니다.\n" + "</p>\n" + '<p align="left">\n' + "    4. 친구 위치 찾기 및 친구맺기: 함께 서비스 이용 중인 친구의 위치를 찾아주거나 친구를 추천하여 줍니다.\n" + "</p>\n" + '<p align="left">\n' + "    5. 연락처 교환하기: 현재 위치를 활용하여 친구와 연락처를 교환할 수 있습니다.\n" + "</p>\n" + '<p align="left">\n' + "    6. 특정 범위 내 사용자 위치 확인 서비스: 특정 위치와 사용자의 현 위치정보를 비교하여 설정한 범위 내에 사용자가 있는지 확인하여\n" + "    출입, 근태 등의 관리를 할 수 있습니다.\n" + "</p>\n" + '<p align="left">\n' + "    7. 이용자 맞춤형 서비스: 인구통계학적 특성에 따른 서비스 제공, 접속빈도 분석, 기능개선, 서비스 이용에 대한 통계, 서비스 분석\n" + "    및 통계에 따른 이용자 관심 등에 기반한 신규 서비스(개인 맞춤형 상품 추천 서비스 등 포함)를 제공하기 위하여 이용자의 개인위치정보를\n" + "    이용합니다.\n" + "</p>\n" + '<p align="left">\n' + "    <strong>제 5 조 (서비스 이용요금)</strong>\n" + "</p>\n" + '<p align="left">\n' + "    ①회사가 제공하는 서비스는 기본적으로 무료입니다. 단, 별도의 유료 서비스의 경우 해당 서비스에 명시된 요금을 지불하여야 사용\n" + "    가능합니다.\n" + "</p>\n" + '<p align="left">\n' + "    ②회사는 유료 서비스 이용요금을 회사와 계약한 전자지불업체에서 정한 방법에 의하거나 회사가 정한 청구서에 합산하여 청구할 수 있습니다.\n" + "</p>\n" + '<p align="left">\n' + "    ③유료서비스 이용을 통하여 결제된 대금에 대한 취소 및 환불은 회사의 결제 이용약관 등 관계법에 따릅니다.\n" + "</p>\n" + '<p align="left">\n' + "    ④회원의 개인정보도용 및 결제사기로 인한 환불요청 또는 결제자의 개인정보 요구는 법률이 정한 경우 외에는 거절될 수 있습니다.\n" + "</p>\n" + '<p align="left">\n' + "    ⑤무선 서비스 이용 시 발생하는 데이터 통신료는 별도이며 가입한 각 이동통신사의 정책에 따릅니다.\n" + "</p>\n" + '<p align="left">\n' + "    ⑥MMS 등으로 게시물을 등록할 경우 발생하는 요금은 이동통신사의 정책에 따릅니다.\n" + "</p>\n" + '<p align="left">\n' + "    <strong>제 6 조 (서비스내용변경 통지 등)</strong>\n" + "</p>\n" + '<p align="left">\n' + "    ①회사가 서비스 내용을 변경하거나 종료하는 경우 회사는 회원의 등록된 전자우편 주소 또는 통신 단말장치 등을 통하여 서비스 내용의 변경\n" + "    사항 또는 종료를 통지할 수 있습니다.\n" + "</p>\n" + '<p align="left">\n' + "    ②제①항의 경우 불특정 다수인을 상대로 통지를 함에 있어서는 웹사이트 등 기타 회사의 공지사항을 통하여 회원들에게 통지할 수 있습니다.\n" + "</p>\n" + '<p align="left">\n' + "    <strong>제 7 조 (서비스이용의 제한 및 중지)</strong>\n" + "</p>\n" + '<p align="left">\n' + "    ①회사는 아래 각 호의 1에 해당하는 사유가 발생한 경우에는 회원의 서비스 이용을 제한하거나 중지시킬 수 있습니다.\n" + "</p>\n" + '<p align="left">\n' + "    1. 회원이 회사 서비스의 운영을 고의 또는 중과실로 방해하는 경우\n" + "</p>\n" + '<p align="left">\n' + "    2. 서비스용 설비 점검, 보수 또는 공사로 인하여 부득이한 경우\n" + "</p>\n" + '<p align="left">\n' + "    3. 전기통신사업법에 규정된 기간통신사업자가 전기통신 서비스를 중지했을 경우\n" + "</p>\n" + '<p align="left">\n' + "    4. 국가비상사태, 서비스 설비의 장애 또는 서비스 이용의 폭주 등으로 서비스 이용에 지장이 있는 때\n" + "</p>\n" + '<p align="left">\n' + "    5. 기타 중대한 사유로 인하여 회사가 서비스 제공을 지속하는 것이 부적당하다고 인정하는 경우\n" + "</p>\n" + '<p align="left">\n' + "    ②회사는 전항의 규정에 의하여 서비스의 이용을 제한하거나 중지한 때에는 그 사유 및 제한기간 등을 회원에게 알려야 합니다.\n" + "</p>\n" + '<p align="left">\n' + "    <strong>제 8 조 (개인위치정보의 이용 또는 제공)</strong>\n" + "</p>\n" + '<p align="left">\n' + "    ①회사는 개인위치정보를 이용하여 서비스를 제공하고자 하는 경우에는 미리 이용약관에 명시한 후 개인위치정보주체의 동의를 얻어야 합니다.\n" + "</p>\n" + '<p align="left">\n' + "    ②회원 및 법정대리인의 권리와 그 행사방법은 제소 당시의 이용자의 주소에 의하며, 주소가 없는 경우에는 거소를 관할하는 지방법원의\n" + "    전속관할로 합니다. 다만, 제소 당시 이용자의 주소 또는 거소가 분명하지 않거나 외국 거주자의 경우에는 민사소송법상의 관할법원에\n" + "    제기합니다.\n" + "</p>\n" + '<p align="left">\n' + "    ③회사는 타사업자 또는 이용 고객과의 요금정산 및 민원처리를 위해 위치정보 이용·제공·사실 확인자료를 자동 기록·보존하며, 해당 자료는\n" + "    6개월 이상 보관합니다.\n" + "</p>\n" + '<p align="left">\n' + "    ④회사는 개인위치정보주체의 동의 없이 개인위치정보를 제3자에게 제공하지 아니하며, 제3자에게 개인위치정보를 제공하는 경우에는 제공\n" + "    받는자 및 제공목적을 사전에 개인위치정보주체에게 고지하고 동의를 받습니다.\n" + "</p>\n" + '<p align="left">\n' + "    ⑤회사는 개인위치정보를 회원이 지정하는 제3자에게 제공하는 경우에는 개인위치정보를 수집한 당해 통신 단말장치로 매회 회원에게 제공받는\n" + "    자, 제공일시 및 제공목적을 즉시 통보합니다. 단, 아래 각 호의 1에 해당하는 경우에는 회원이 미리 특정하여 지정한 통신 단말장치\n" + "    또는 전자우편주소로 통보합니다.\n" + "</p>\n" + '<p align="left">\n' + "    1. 개인위치정보를 수집한 당해 통신단말장치가 문자, 음성 또는 영상의 수신기능을 갖추지 아니한 경우\n" + "</p>\n" + '<p align="left">\n' + "    2. 개인위치정보주체가 개인위치정보를 수집한 해당 통신단말장치 외의 통신단말장치 또는 전자우편주소 등으로 통보할 것을 미리 요청한 경우\n" + "</p>\n" + '<p align="left">\n' + "    <strong>제 9 조 (개인위치정보주체의 권리)</strong>\n" + "</p>\n" + '<p align="left">\n' + "    ①회원은 회사에 대하여 언제든지 개인위치정보를 이용한 위치기반서비스 제공 및 개인위치정보의 제3자 제공에 대한 동의의 전부 또는 일부를\n" + "    철회할 수 있습니다. 이 경우 회사는 수집한 개인위치정보 및 위치정보 이용, 제공사실 확인자료를 파기합니다.\n" + "</p>\n" + '<p align="left">\n' + "    ②회원은 회사에 대하여 언제든지 개인위치정보의 수집, 이용 또는 제공의 일시적인 중지를 요구할 수 있으며, 회사는 이를 거절할 수 없고\n" + "    이를 위한 기술적 수단을 갖추고 있습니다.\n" + "</p>\n" + '<p align="left">\n' + "    ③회원은 회사에 대하여 아래 각 호의 자료에 대한 열람 또는 고지를 요구할 수 있고, 당해 자료에 오류가 있는 경우에는 그 정정을\n" + "    요구할 수 있습니다. 이 경우 회사는 정당한 사유 없이 회원의 요구를 거절할 수 없습니다.\n" + "</p>\n" + '<p align="left">\n' + "    1. 본인에 대한 위치정보 수집, 이용, 제공사실 확인자료\n" + "</p>\n" + '<p align="left">\n' + "    2. 본인의 개인위치정보가 위치정보의 보호 및 이용 등에 관한 법률 또는 다른 법률 규정에 의하여 제3자에게 제공된 이유 및 내용\n" + "</p>\n" + '<p align="left">\n' + "    ④회원은 제1항 내지 제3항의 권리행사를 위해 회사의 소정의 절차를 통해 요구할 수 있습니다.\n" + "</p>\n" + '<p align="left">\n' + "    <strong>제 10 조 (법정대리인의 권리)</strong>\n" + "</p>\n" + '<p align="left">\n' + "    ①회사는 14세 미만의 회원에 대해서는 개인위치정보를 이용한 위치기반서비스 제공 및 개인위치정보의 제3자 제공에 대한 동의를 당해\n" + "    회원과 당해 회원의 법정대리인으로부터 동의를 받아야 합니다. 이 경우 법정대리인은 제9조에 의한 회원의 권리를 모두 가집니다.\n" + "</p>\n" + '<p align="left">\n' + "    ②회사는 14세 미만의 아동의 개인위치정보 또는 위치정보 이용․제공사실 확인자료를 이용약관에 명시 또는 고지한 범위를 넘어 이용하거나\n" + "    제3자에게 제공하고자 하는 경우에는 14세미만의 아동과 그 법정대리인의 동의를 받아야 합니다. 단, 아래의 경우는 제외합니다.\n" + "</p>\n" + '<p align="left">\n' + "    1. 위치정보 및 위치기반서비스 제공에 따른 요금정산을 위하여 위치정보 이용, 제공사실 확인자료가 필요한 경우\n" + "</p>\n" + '<p align="left">\n' + "    2. 통계작성, 학술연구 또는 시장조사를 위하여 특정 개인을 알아볼 수 없는 형태로 가공하여 제공하는 경우\n" + "</p>\n" + '<p align="left">\n' + "    <strong>제 11 조 (8세 이하의 아동 등의 보호의무자의 권리)</strong>\n" + "</p>\n" + '<p align="left">\n' + "    ①회사는 아래의 경우에 해당하는 자(이하 “8세 이하의 아동”등이라 한다)의 보호의무자가 8세 이하의 아동 등의 생명 또는 신체보호를\n" + "    위하여 개인위치정보의 이용 또는 제공에 동의하는 경우에는 본인의 동의가 있는 것으로 봅니다.\n" + "</p>\n" + '<p align="left">\n' + "    1. 8세 이하의 아동\n" + "</p>\n" + '<p align="left">\n' + "    2. 피성년후견인\n" + "</p>\n" + '<p align="left">\n' + "    3. 장애인복지법제2조제2항제2호의 규정에 의한 정신적 장애를 가진 자로서 장애인고용촉진및직업재활법 제2조제2호의 규정에 의한\n" + "    중증장애인에 해당하는 자(장애인복지법 제32조의 규정에 의하여 장애인등록을 한 자에 한한다)\n" + "</p>\n" + '<p align="left">\n' + "    ②8세 이하의 아동 등의 생명 또는 신체의 보호를 위하여 개인위치정보의 이용 또는 제공에 동의를 하고자 하는 보호의무자는 서면동의서에\n" + "    보호의무자임을 증명하는 서면을 첨부하여 회사에 제출하여야 합니다.\n" + "</p>\n" + '<p align="left">\n' + "    ③보호의무자는 8세 이하의 아동 등의 개인위치정보 이용 또는 제공에 동의하는 경우 개인위치정보주체 권리의 전부를 행사할 수 있습니다.\n" + "</p>\n" + '<p align="left">\n' + "    <strong>제 12 조 (위치정보관리책임자의 지정)</strong>\n" + "</p>\n" + '<p align="left">\n' + "    ①회사는 위치정보를 적절히 관리·보호하고 개인위치정보주체의 불만을 원활히 처리할 수 있도록 실질적인 책임을 질 수 있는 지위에 있는\n" + "    자를 위치정보관리책임자로 지정해 운영합니다.\n" + "</p>\n" + '<p align="left">\n' + "    ②위치정보관리책임자는 위치기반서비스를 제공하는 부서의 부서장으로서 구체적인 사항은 본 약관의 부칙에 따릅니다.\n" + "</p>\n" + '<p align="left">\n' + "    <strong>제 13 조 (개인위치정보의 보유목적 및 이용기간)</strong>\n" + "</p>\n" + '<p align="left">\n' + "    ①회사는 제4조에 명시된 위치기반서비스를 제공하기 위한 목적으로 개인위치정보를 보유 및\n" + "    이용합니다.\n" + "</p>\n" + '<p align="left">\n' + "    ②회사는 위치정보 이용·제공사실 확인자료 외의 개인위치정보는 이용·제공 목적 달성 시 까지\n" + "    보유합니다.\n" + "</p>\n" + '<p align="left">\n' + "    <strong>제 14 조 (손해배상)</strong>\n" + "</p>\n" + '<p align="left">\n' + "    ①회사가 위치정보의 보호 및 이용 등에 관한 법률 제15조 내지 제26조의 규정을 위반한 행위로 회원에게 손해가 발생한 경우 회원은\n" + "    회사에 대하여 손해배상 청구를 할 수 있습니다. 이 경우 회사는 고의, 과실이 없음을 입증하지 못하는 경우 책임을 면할 수 없습니다.\n" + "</p>\n" + '<p align="left">\n' + "    ②회원이 본 약관의 규정을 위반하여 회사에 손해가 발생한 경우 회사는 회원에 대하여 손해배상을 청구할 수 있습니다. 이 경우 회원은\n" + "    고의, 과실이 없음을 입증하지 못하는 경우 책임을 면할 수 없습니다.\n" + "</p>\n" + '<p align="left">\n' + "    <strong>제 15 조 (면책)</strong>\n" + "</p>\n" + '<p align="left">\n' + "    ①회사는 다음 각 호의 경우로 서비스를 제공할 수 없는 경우 이로 인하여 회원에게 발생한 손해에 대해서는 책임을 부담하지 않습니다.\n" + "</p>\n" + '<p align="left">\n' + "    1. 천재지변 또는 이에 준하는 불가항력의 상태가 있는 경우\n" + "</p>\n" + '<p align="left">\n' + "    2. 서비스 제공을 위하여 회사와 서비스 제휴계약을 체결한 제3자의 고의적인 서비스 방해가 있는 경우\n" + "</p>\n" + '<p align="left">\n' + "    3. 회원의 귀책사유로 서비스 이용에 장애가 있는 경우\n" + "</p>\n" + '<p align="left">\n' + "    4. 제1호 내지 제3호를 제외한 기타 회사의 고의∙과실이 없는 사유로 인한 경우\n" + "</p>\n" + '<p align="left">\n' + "    ②회사는 서비스 및 서비스에 게재된 정보, 자료, 사실의 신뢰도, 정확성 등에 대해서는 보증을 하지 않으며 이로 인해 발생한 회원의\n" + "    손해에 대하여는 책임을 부담하지 아니합니다.\n" + "</p>\n" + '<p align="left">\n' + "    <strong>제 16 조 (규정의 준용)</strong>\n" + "</p>\n" + '<p align="left">\n' + "    ①본 약관은 대한민국법령에 의하여 규정되고 이행됩니다.\n" + "</p>\n" + '<p align="left">\n' + "    ②본 약관에 규정되지 않은 사항에 대해서는 관련법령 및 상관습에 의합니다.\n" + "</p>\n" + '<p align="left">\n' + "    <strong>제 17 조 (분쟁의 조정 및 기타)</strong>\n" + "</p>\n" + '<p align="left">\n' + "    ①회사는 위치정보와 관련된 분쟁에 대해 당사자간 협의가 이루어지지 아니하거나 협의를 할 수 없는 경우에는 위치정보의 보호 및 이용 등에\n" + "    관한 법률 제28조 규정에 의한 방송통신위원회에 재정을 신청할 수 있습니다.\n" + "</p>\n" + '<p align="left">\n' + "    ②회사 또는 고객은 위치정보와 관련된 분쟁에 대해 당사자간 협의가 이루어지지 아니하거나 협의를 할 수 없는 경우에는 개인정보보호법\n" + "    제40조의 규정에 의한 개인정보분쟁조정위원회에 조정을 신청할 수 있습니다.\n" + "</p>\n" + '<p align="left">\n' + "    <strong>제 18 조 (회사의 연락처)</strong>\n" + "</p>\n" + '<p align="left">\n' + "    회사의 상호 및 주소 등은 다음과 같습니다.\n" + "</p>\n" + '<p align="left">\n' + "    1. 상 호 : 엔에이치엔 주식회사\n" + "</p>\n" + '<p align="left">\n' + "    2. 대 표 자 : 정 우 진\n" + "</p>\n" + '<p align="left">\n' + "    3. 주 소 : 경기도 성남시 분당구 삼평동 629 플레이뮤지엄\n" + "</p>\n" + '<p align="left">\n' + "    4. 대표전화 : 1544-6859\n" + "</p>\n" + '<p align="left">\n' + "    <strong>부칙</strong>\n" + "</p>\n" + '<p align="left">\n' + "    제1조 (시행일) 이 약관은 2022년 6월 30일부터 시행합니다.\n" + "</p>\n" + '<p align="left">\n' + "    제2조 위치정보관리책임자는 2018년 6월을 기준으로 다음과 같이 지정합니다.\n" + "</p>\n" + '<p align="left">\n' + "    1. 소 속 : 법무정책그룹\n" + "</p>\n" + '<p align="left">\n' + "    2. 직 위 : 그룹장\n" + "</p>\n" + '<p align="left">\n' + "    3. 성 명 : 황선영\n" + "</p>\n" + '<p align="left">\n' + "    4. 연락처 : 1544-6859\n" + "</p>\n",
    v7: '<p align="center" class="position-terms-title">\n' + "    <strong>위치기반서비스 이용약관</strong>\n" + "</p>\n" + '<p align="left">\n' + "    <strong>제1장 총칙</strong>\n" + "</p>\n" + '<p align="left">\n' + "    <strong>제 1조 (목적)</strong>\n" + "</p>\n" + '<p align="left">\n' + "    본 약관은 회원(서비스 이용약관에 동의한 자를 말합니다. 이하 “회원”이라고 합니다.)이 엔에이치엔 주식회사(이하 “회사”라고\n" + "    합니다.)가 제공하는 위치기반서비스(이하 “서비스”라고 합니다)를 이용함에 있어 회사와 회원의 권리·의무 및 책임사항을 규정함을\n" + "    목적으로 합니다.\n" + "</p>\n" + '<p align="left">\n' + "    <strong>제 2 조 (이용약관의 효력 및 변경)</strong>\n" + "</p>\n" + '<p align="left">\n' + "    ①본 약관은 서비스를 신청한 고객 또는 개인위치정보주체가 본 약관에 동의하고 회사가 정한 소정의 절차에 따라 서비스의 이용자로\n" + "    등록함으로써 효력이 발생합니다.\n" + "</p>\n" + '<p align="left">\n' + '    ②회원이 온라인에서 본 약관의 "동의하기" 버튼을 클릭하였을 경우 본 약관의 내용을 모두 읽고 이를 충분히 이해하였으며, 그 적용에\n' + "    동의한 것으로 봅니다.\n" + "</p>\n" + '<p align="left">\n' + "    ③회사는 위치정보의 보호 및 이용 등에 관한 법률, 콘텐츠산업 진흥법, 전자상거래 등에서의 소비자보호에 관한 법률, 소비자기본법 약관의\n" + "    규제에 관한 법률 등 관련법령을 위배하지 않는 범위에서 본 약관을 개정할 수 있습니다.\n" + "</p>\n" + '<p align="left">\n' + "    ④회사가 약관을 개정할 경우에는 기존약관과 개정약관 및 개정약관의 적용일자와 개정사유를 명시하여 기존 약관과 함께 그 적용일자 7일\n" + "    전부터 적용일 이후 상당한 기간 동안 공지만을 하고, 개정 내용이 회원에게 불리한 경우에는 그 적용일자 30일 전부터 적용일 이후\n" + "    상당한 기간 동안 각각 이를 서비스 홈페이지에 게시하거나 회원에게 전자적 형태(전자우편, SMS 등)로 약관 개정 사실을 발송하여\n" + "    고지합니다.\n" + "</p>\n" + '<p align="left">\n' + "    ⑤회사가 전항에 따라 회원에게 통지하면서 공지 또는 공지∙고지일로부터 개정약관 시행일 7일 후까지 거부 의사를 표시하지 아니하면\n" + "    이용약관에 승인한 것으로 봅니다. 회원이 개정약관에 동의하지 않을 경우 회원은 이용계약을 해지할 수 있습니다.\n" + "</p>\n" + '<p align="left">\n' + "    <strong>제 3 조 (관계법령의 적용)</strong>\n" + "</p>\n" + '<p align="left">\n' + "    본 약관은 신의성실의 원칙에 따라 공정하게 적용하며, 본 약관에 명시되지 아니한 사항에 대하여는 관계법령 또는 상관례에 따릅니다.\n" + "</p>\n" + '<p align="left">\n' + "    <strong>제 4 조 (서비스의 내용)</strong>\n" + "</p>\n" + '<p align="left">\n' + "    회사는 직접 위치정보를 수집하거나 위치정보사업자로부터 위치정보를 전달받아 아래와 같은 위치기반서비스를 제공합니다.\n" + "</p>\n" + '<p align="left">\n' + "    1. 운동경로 트래킹 서비스: 운동경로를 추적해 운동과정을 기록하고 분석한 데이터를 제공합니다.\n" + "</p>\n" + '<p align="left">\n' + "    2. Geo Tagging 서비스: 게시물 등록 시점의 개인위치정보주체의 위치정보를 게시물과 함께 저장합니다.\n" + "</p>\n" + '<p align="left">\n' + "    3. 현재 위치를 활용한 검색결과 제공 서비스: 정보 검색 요청 시 개인위치정보주체의 현 위치를 이용한 검색결과 및 주변결과(지역정보,\n" + "    주변업체 및 쿠폰정보, 할인정보 등)를 제시합니다.\n" + "</p>\n" + '<p align="left">\n' + "    4. 친구 위치 찾기 및 친구맺기: 함께 서비스 이용 중인 친구의 위치를 찾아주거나 친구를 추천하여 줍니다.\n" + "</p>\n" + '<p align="left">\n' + "    5. 연락처 교환하기: 현재 위치를 활용하여 친구와 연락처를 교환할 수 있습니다.\n" + "</p>\n" + '<p align="left">\n' + "    6. 특정 범위 내 사용자 위치 확인 서비스: 특정 위치와 사용자의 현 위치정보를 비교하여 설정한 범위 내에 사용자가 있는지 확인하여\n" + "    출입, 근태 등의 관리를 할 수 있습니다.\n" + "</p>\n" + '<p align="left">\n' + "    7. 이용자 맞춤형 서비스: 인구통계학적 특성에 따른 서비스 제공, 접속빈도 분석, 기능개선, 서비스 이용에 대한 통계, 서비스 분석\n" + "    및 통계에 따른 이용자 관심 등에 기반한 신규 서비스(개인 맞춤형 상품 추천 서비스 등 포함)를 제공하기 위하여 이용자의 개인위치정보를\n" + "    이용합니다.\n" + "</p>\n" + '<p align="left">\n' + "    <strong>제 5 조 (서비스 이용요금)</strong>\n" + "</p>\n" + '<p align="left">\n' + "    ①회사가 제공하는 서비스는 기본적으로 무료입니다. 단, 별도의 유료 서비스의 경우 해당 서비스에 명시된 요금을 지불하여야 사용\n" + "    가능합니다.\n" + "</p>\n" + '<p align="left">\n' + "    ②회사는 유료 서비스 이용요금을 회사와 계약한 전자지불업체에서 정한 방법에 의하거나 회사가 정한 청구서에 합산하여 청구할 수 있습니다.\n" + "</p>\n" + '<p align="left">\n' + "    ③유료서비스 이용을 통하여 결제된 대금에 대한 취소 및 환불은 회사의 결제 이용약관 등 관계법에 따릅니다.\n" + "</p>\n" + '<p align="left">\n' + "    ④회원의 개인정보도용 및 결제사기로 인한 환불요청 또는 결제자의 개인정보 요구는 법률이 정한 경우 외에는 거절될 수 있습니다.\n" + "</p>\n" + '<p align="left">\n' + "    ⑤무선 서비스 이용 시 발생하는 데이터 통신료는 별도이며 가입한 각 이동통신사의 정책에 따릅니다.\n" + "</p>\n" + '<p align="left">\n' + "    ⑥MMS 등으로 게시물을 등록할 경우 발생하는 요금은 이동통신사의 정책에 따릅니다.\n" + "</p>\n" + '<p align="left">\n' + "    <strong>제 6 조 (서비스내용변경 통지 등)</strong>\n" + "</p>\n" + '<p align="left">\n' + "    ①회사가 서비스 내용을 변경하거나 종료하는 경우 회사는 회원의 등록된 전자우편 주소 또는 통신 단말장치 등을 통하여 서비스 내용의 변경\n" + "    사항 또는 종료를 통지할 수 있습니다.\n" + "</p>\n" + '<p align="left">\n' + "    ②제①항의 경우 불특정 다수인을 상대로 통지를 함에 있어서는 웹사이트 등 기타 회사의 공지사항을 통하여 회원들에게 통지할 수 있습니다.\n" + "</p>\n" + '<p align="left">\n' + "    <strong>제 7 조 (서비스이용의 제한 및 중지)</strong>\n" + "</p>\n" + '<p align="left">\n' + "    ①회사는 아래 각 호의 1에 해당하는 사유가 발생한 경우에는 회원의 서비스 이용을 제한하거나 중지시킬 수 있습니다.\n" + "</p>\n" + '<p align="left">\n' + "    1. 회원이 회사 서비스의 운영을 고의 또는 중과실로 방해하는 경우\n" + "</p>\n" + '<p align="left">\n' + "    2. 서비스용 설비 점검, 보수 또는 공사로 인하여 부득이한 경우\n" + "</p>\n" + '<p align="left">\n' + "    3. 전기통신사업법에 규정된 기간통신사업자가 전기통신 서비스를 중지했을 경우\n" + "</p>\n" + '<p align="left">\n' + "    4. 국가비상사태, 서비스 설비의 장애 또는 서비스 이용의 폭주 등으로 서비스 이용에 지장이 있는 때\n" + "</p>\n" + '<p align="left">\n' + "    5. 기타 중대한 사유로 인하여 회사가 서비스 제공을 지속하는 것이 부적당하다고 인정하는 경우\n" + "</p>\n" + '<p align="left">\n' + "    ②회사는 전항의 규정에 의하여 서비스의 이용을 제한하거나 중지한 때에는 그 사유 및 제한기간 등을 회원에게 알려야 합니다.\n" + "</p>\n" + '<p align="left">\n' + "    <strong>제 8 조 (개인위치정보의 이용 또는 제공)</strong>\n" + "</p>\n" + '<p align="left">\n' + "    ①회사는 개인위치정보를 이용하여 서비스를 제공하고자 하는 경우에는 미리 이용약관에 명시한 후 개인위치정보주체의 동의를 얻어야 합니다.\n" + "</p>\n" + '<p align="left">\n' + "    ②회원 및 법정대리인의 권리와 그 행사방법은 제소 당시의 이용자의 주소에 의하며, 주소가 없는 경우에는 거소를 관할하는 지방법원의\n" + "    전속관할로 합니다. 다만, 제소 당시 이용자의 주소 또는 거소가 분명하지 않거나 외국 거주자의 경우에는 민사소송법상의 관할법원에\n" + "    제기합니다.\n" + "</p>\n" + '<p align="left">\n' + "    ③회사는 타사업자 또는 이용 고객과의 요금정산 및 민원처리를 위해 위치정보 이용·제공·사실 확인자료를 자동 기록·보존하며, 해당 자료는\n" + "    6개월 이상 보관합니다.\n" + "</p>\n" + '<p align="left">\n' + "    ④회사는 개인위치정보주체의 동의 없이 개인위치정보를 제3자에게 제공하지 아니하며, 제3자에게 개인위치정보를 제공하는 경우에는 제공\n" + "    받는자 및 제공목적을 사전에 개인위치정보주체에게 고지하고 동의를 받습니다.\n" + "</p>\n" + '<p align="left">\n' + "    ⑤회사는 개인위치정보를 회원이 지정하는 제3자에게 제공하는 경우에는 개인위치정보를 수집한 당해 통신 단말장치로 매회 회원에게 제공받는\n" + "    자, 제공일시 및 제공목적을 즉시 통보합니다. 단, 아래 각 호의 1에 해당하는 경우에는 회원이 미리 특정하여 지정한 통신 단말장치\n" + "    또는 전자우편주소로 통보합니다.\n" + "</p>\n" + '<p align="left">\n' + "    1. 개인위치정보를 수집한 당해 통신단말장치가 문자, 음성 또는 영상의 수신기능을 갖추지 아니한 경우\n" + "</p>\n" + '<p align="left">\n' + "    2. 개인위치정보주체가 개인위치정보를 수집한 해당 통신단말장치 외의 통신단말장치 또는 전자우편주소 등으로 통보할 것을 미리 요청한 경우\n" + "</p>\n" + '<p align="left">\n' + "    <strong>제 9 조 (개인위치정보주체의 권리)</strong>\n" + "</p>\n" + '<p align="left">\n' + "    ①회원은 회사에 대하여 언제든지 개인위치정보를 이용한 위치기반서비스 제공 및 개인위치정보의 제3자 제공에 대한 동의의 전부 또는 일부를\n" + "    철회할 수 있습니다. 이 경우 회사는 수집한 개인위치정보 및 위치정보 이용, 제공사실 확인자료를 파기합니다.\n" + "</p>\n" + '<p align="left">\n' + "    ②회원은 회사에 대하여 언제든지 개인위치정보의 수집, 이용 또는 제공의 일시적인 중지를 요구할 수 있으며, 회사는 이를 거절할 수 없고\n" + "    이를 위한 기술적 수단을 갖추고 있습니다.\n" + "</p>\n" + '<p align="left">\n' + "    ③회원은 회사에 대하여 아래 각 호의 자료에 대한 열람 또는 고지를 요구할 수 있고, 당해 자료에 오류가 있는 경우에는 그 정정을\n" + "    요구할 수 있습니다. 이 경우 회사는 정당한 사유 없이 회원의 요구를 거절할 수 없습니다.\n" + "</p>\n" + '<p align="left">\n' + "    1. 본인에 대한 위치정보 수집, 이용, 제공사실 확인자료\n" + "</p>\n" + '<p align="left">\n' + "    2. 본인의 개인위치정보가 위치정보의 보호 및 이용 등에 관한 법률 또는 다른 법률 규정에 의하여 제3자에게 제공된 이유 및 내용\n" + "</p>\n" + '<p align="left">\n' + "    ④회원은 제1항 내지 제3항의 권리행사를 위해 회사의 소정의 절차를 통해 요구할 수 있습니다.\n" + "</p>\n" + '<p align="left">\n' + "    <strong>제 10 조 (법정대리인의 권리)</strong>\n" + "</p>\n" + '<p align="left">\n' + "    ①회사는 14세 미만의 회원에 대해서는 개인위치정보를 이용한 위치기반서비스 제공 및 개인위치정보의 제3자 제공에 대한 동의를 당해\n" + "    회원과 당해 회원의 법정대리인으로부터 동의를 받아야 합니다. 이 경우 법정대리인은 제9조에 의한 회원의 권리를 모두 가집니다.\n" + "</p>\n" + '<p align="left">\n' + "    ②회사는 14세 미만의 아동의 개인위치정보 또는 위치정보 이용․제공사실 확인자료를 이용약관에 명시 또는 고지한 범위를 넘어 이용하거나\n" + "    제3자에게 제공하고자 하는 경우에는 14세미만의 아동과 그 법정대리인의 동의를 받아야 합니다. 단, 아래의 경우는 제외합니다.\n" + "</p>\n" + '<p align="left">\n' + "    1. 위치정보 및 위치기반서비스 제공에 따른 요금정산을 위하여 위치정보 이용, 제공사실 확인자료가 필요한 경우\n" + "</p>\n" + '<p align="left">\n' + "    2. 통계작성, 학술연구 또는 시장조사를 위하여 특정 개인을 알아볼 수 없는 형태로 가공하여 제공하는 경우\n" + "</p>\n" + '<p align="left">\n' + "    <strong>제 11 조 (8세 이하의 아동 등의 보호의무자의 권리)</strong>\n" + "</p>\n" + '<p align="left">\n' + "    ①회사는 아래의 경우에 해당하는 자(이하 “8세 이하의 아동”등이라 한다)의 보호의무자가 8세 이하의 아동 등의 생명 또는 신체보호를\n" + "    위하여 개인위치정보의 이용 또는 제공에 동의하는 경우에는 본인의 동의가 있는 것으로 봅니다.\n" + "</p>\n" + '<p align="left">\n' + "    1. 8세 이하의 아동\n" + "</p>\n" + '<p align="left">\n' + "    2. 금치산자\n" + "</p>\n" + '<p align="left">\n' + "    3. 장애인복지법제2조제2항제2호의 규정에 의한 정신적 장애를 가진 자로서 장애인고용촉진및직업재활법 제2조제2호의 규정에 의한\n" + "    중증장애인에 해당하는 자(장애인복지법 제32조의 규정에 의하여 장애인등록을 한 자에 한한다)\n" + "</p>\n" + '<p align="left">\n' + "    ②8세 이하의 아동 등의 생명 또는 신체의 보호를 위하여 개인위치정보의 이용 또는 제공에 동의를 하고자 하는 보호의무자는 서면동의서에\n" + "    보호의무자임을 증명하는 서면을 첨부하여 회사에 제출하여야 합니다.\n" + "</p>\n" + '<p align="left">\n' + "    ③보호의무자는 8세 이하의 아동 등의 개인위치정보 이용 또는 제공에 동의하는 경우 개인위치정보주체 권리의 전부를 행사할 수 있습니다.\n" + "</p>\n" + '<p align="left">\n' + "    <strong>제 12 조 (위치정보관리책임자의 지정)</strong>\n" + "</p>\n" + '<p align="left">\n' + "    ①회사는 위치정보를 적절히 관리·보호하고 개인위치정보주체의 불만을 원활히 처리할 수 있도록 실질적인 책임을 질 수 있는 지위에 있는\n" + "    자를 위치정보관리책임자로 지정해 운영합니다.\n" + "</p>\n" + '<p align="left">\n' + "    ②위치정보관리책임자는 위치기반서비스를 제공하는 부서의 부서장으로서 구체적인 사항은 본 약관의 부칙에 따릅니다.\n" + "</p>\n" + '<p align="left">\n' + "    <strong>제 13 조 (손해배상)</strong>\n" + "</p>\n" + '<p align="left">\n' + "    ①회사가 위치정보의 보호 및 이용 등에 관한 법률 제15조 내지 제26조의 규정을 위반한 행위로 회원에게 손해가 발생한 경우 회원은\n" + "    회사에 대하여 손해배상 청구를 할 수 있습니다. 이 경우 회사는 고의, 과실이 없음을 입증하지 못하는 경우 책임을 면할 수 없습니다.\n" + "</p>\n" + '<p align="left">\n' + "    ②회원이 본 약관의 규정을 위반하여 회사에 손해가 발생한 경우 회사는 회원에 대하여 손해배상을 청구할 수 있습니다. 이 경우 회원은\n" + "    고의, 과실이 없음을 입증하지 못하는 경우 책임을 면할 수 없습니다.\n" + "</p>\n" + '<p align="left">\n' + "    <strong>제 14 조 (면책)</strong>\n" + "</p>\n" + '<p align="left">\n' + "    ①회사는 다음 각 호의 경우로 서비스를 제공할 수 없는 경우 이로 인하여 회원에게 발생한 손해에 대해서는 책임을 부담하지 않습니다.\n" + "</p>\n" + '<p align="left">\n' + "    1. 천재지변 또는 이에 준하는 불가항력의 상태가 있는 경우\n" + "</p>\n" + '<p align="left">\n' + "    2. 서비스 제공을 위하여 회사와 서비스 제휴계약을 체결한 제3자의 고의적인 서비스 방해가 있는 경우\n" + "</p>\n" + '<p align="left">\n' + "    3. 회원의 귀책사유로 서비스 이용에 장애가 있는 경우\n" + "</p>\n" + '<p align="left">\n' + "    4. 제1호 내지 제3호를 제외한 기타 회사의 고의∙과실이 없는 사유로 인한 경우\n" + "</p>\n" + '<p align="left">\n' + "    ②회사는 서비스 및 서비스에 게재된 정보, 자료, 사실의 신뢰도, 정확성 등에 대해서는 보증을 하지 않으며 이로 인해 발생한 회원의\n" + "    손해에 대하여는 책임을 부담하지 아니합니다.\n" + "</p>\n" + '<p align="left">\n' + "    <strong>제 15 조 (규정의 준용)</strong>\n" + "</p>\n" + '<p align="left">\n' + "    ①본 약관은 대한민국법령에 의하여 규정되고 이행됩니다.\n" + "</p>\n" + '<p align="left">\n' + "    ②본 약관에 규정되지 않은 사항에 대해서는 관련법령 및 상관습에 의합니다.\n" + "</p>\n" + '<p align="left">\n' + "    <strong>제 16 조 (분쟁의 조정 및 기타)</strong>\n" + "</p>\n" + '<p align="left">\n' + "    ①회사는 위치정보와 관련된 분쟁에 대해 당사자간 협의가 이루어지지 아니하거나 협의를 할 수 없는 경우에는 위치정보의 보호 및 이용 등에\n" + "    관한 법률 제28조 규정에 의한 방송통신위원회에 재정을 신청할 수 있습니다.\n" + "</p>\n" + '<p align="left">\n' + "    ②회사 또는 고객은 위치정보와 관련된 분쟁에 대해 당사자간 협의가 이루어지지 아니하거나 협의를 할 수 없는 경우에는 개인정보보호법\n" + "    제40조의 규정에 의한 개인정보분쟁조정위원회에 조정을 신청할 수 있습니다.\n" + "</p>\n" + '<p align="left">\n' + "    <strong>제 17 조 (회사의 연락처)</strong>\n" + "</p>\n" + '<p align="left">\n' + "    회사의 상호 및 주소 등은 다음과 같습니다.\n" + "</p>\n" + '<p align="left">\n' + "    1. 상 호 : 엔에이치엔 주식회사\n" + "</p>\n" + '<p align="left">\n' + "    2. 대 표 자 : 정 우 진\n" + "</p>\n" + '<p align="left">\n' + "    3. 주 소 : 경기도 성남시 분당구 삼평동 629 플레이뮤지엄\n" + "</p>\n" + '<p align="left">\n' + "    4. 대표전화 : 1544-6859\n" + "</p>\n" + '<p align="left">\n' + "    <strong>부칙</strong>\n" + "</p>\n" + '<p align="left">\n' + "    제1조 (시행일) 이 약관은 2019년 4월 6일부터 시행합니다.\n" + "</p>\n" + '<p align="left">\n' + "    제2조 위치정보관리책임자는 2018년 6월을 기준으로 다음과 같이 지정합니다.\n" + "</p>\n" + '<p align="left">\n' + "    1. 소 속 : 법무정책그룹\n" + "</p>\n" + '<p align="left">\n' + "    2. 직 위 : 그룹장\n" + "</p>\n" + '<p align="left">\n' + "    3. 성 명 : 황선영\n" + "</p>\n" + '<p align="left">\n' + "    4. 연락처 : 1544-6859\n" + "</p>\n",
    v6: '<p align="center" class="position-terms-title">\n' + "    <strong>위치기반서비스 이용약관</strong>\n" + "</p>\n" + "<p>\n" + "    제1장 총 칙\n" + "</p>\n" + "<p>\n" + "    제 1 조 (목적) 본 약관은 회원(서비스 이용약관에 동의한 자를 말합니다. 이하 “회원”이라고 합니다.)이 엔에이치엔엔터테인먼트\n" + "    주식회사(이하 “회사”라고 합니다.)가 제공하는 위치기반서비스(이하 “서비스”라고 합니다)를 이용함에 있어 회사와 회원의 권리·의무 및\n" + "    책임사항을 규정함을 목적으로 합니다.\n" + "</p>\n" + "<p>\n" + "    제 2 조 (이용약관의 효력 및 변경)\n" + "</p>\n" + "<p>\n" + "    ①본 약관은 서비스를 신청한 고객 또는 개인위치정보주체가 본 약관에 동의하고 회사가 정한 소정의 절차에 따라 서비스의 이용자로\n" + "    등록함으로써 효력이 발생합니다.\n" + "</p>\n" + "<p>\n" + '    ②회원이 온라인에서 본 약관의 "동의하기" 버튼을 클릭하였을 경우 본 약관의 내용을 모두 읽고 이를 충분히 이해하였으며, 그 적용에\n' + "    동의한 것으로 봅니다.\n" + "</p>\n" + "<p>\n" + "    ③회사는 위치정보의 보호 및 이용 등에 관한 법률, 콘텐츠산업 진흥법, 전자상거래 등에서의 소비자보호에 관한 법률, 소비자기본법 약관의\n" + "    규제에 관한 법률 등 관련법령을 위배하지 않는 범위에서 본 약관을 개정할 수 있습니다.\n" + "</p>\n" + "<p>\n" + "    ④회사가 약관을 개정할 경우에는 기존약관과 개정약관 및 개정약관의 적용일자와 개정사유를 명시하여 현행약관과 함께 그 적용일자 7일\n" + "    전부터 적용일 이후 상당한 기간 동안 공지만을 하고, 개정 내용이 회원에게 불리한 경우에는 그 적용일자 30일 전부터 적용일 이후\n" + "    상당한 기간 동안 각각 이를 서비스 홈페이지에 게시하거나 회원에게 전자적 형태(전자우편, SMS 등)로 약관 개정 사실을 발송하여\n" + "    고지합니다.\n" + "</p>\n" + "<p>\n" + "    ⑤회사가 전항에 따라 회원에게 통지하면서 공지 또는 공지∙고지일로부터 개정약관 시행일 7일 후까지 거부의사를 표시하지 아니하면\n" + "    이용약관에 승인한 것으로 봅니다. 회원이 개정약관에 동의하지 않을 경우 회원은 이용계약을 해지할 수 있습니다.\n" + "</p>\n" + "<p>\n" + "    제 3 조 (관계법령의 적용) 본 약관은 신의성실의 원칙에 따라 공정하게 적용하며, 본 약관에 명시되지 아니한 사항에 대하여는 관계법령\n" + "    또는 상관례에 따릅니다.\n" + "</p>\n" + "<p>\n" + "    제 4 조 (서비스의 내용) 회사는 직접 위치정보를 수집하거나 위치정보사업자인 이동통신사로부터 위치정보를 전달받아 아래와 같은\n" + "    위치기반서비스를 제공합니다.\n" + "</p>\n" + "<p>\n" + "    1. 운동경로 트래킹 서비스: 운동경로를 추적해 운동과정을 기록하고 분석한 데이터를 제공합니다.\n" + "</p>\n" + "<p>\n" + "    2. Geo Tagging 서비스: 게시물 등록 시점의 개인위치정보주체의 위치정보를 게시물과 함께 저장합니다.\n" + "</p>\n" + "<p>\n" + "    3. 현재 위치를 활용한 검색결과 제공 서비스: 정보 검색 요청 시 개인위치정보주체의 현 위치를 이용한 검색결과 및 주변결과(지역정보,\n" + "    주변업체 및 쿠폰정보, 할인정보 등)를 제시합니다.\n" + "</p>\n" + "<p>\n" + "    4. 친구 위치 찾기 및 친구맺기: 함께 서비스 이용 중인 친구의 위치를 찾아주거나 친구를 추천하여 줍니다.\n" + "</p>\n" + "<p>\n" + "    5. 연락처 교환하기: 현재 위치를 활용하여 친구와 연락처를 교환할 수 있습니다.\n" + "</p>\n" + "<p>\n" + "    6. 특정 범위 내 사용자 위치 확인 서비스: 특정 위치와 사용자의 현 위치정보를 비교하여 설정한 범위 내에 사용자가 있는지 확인하여\n" + "    출입, 근태 등의 관리를 할 수 있습니다.\n" + "</p>\n" + "<p>\n" + "    7. 이용자 맞춤형 서비스: 인구통계학적 특성에 따른 서비스 제공, 접속빈도 분석, 기능개선, 서비스 이용에 대한 통계, 서비스 분석\n" + "    및 통계에 따른 이용자 관심 등에 기반한 신규 서비스(개인 맞춤형 상품 추천 서비스 등 포함)를 제공하기 위하여 이용자의 개인위치정보를\n" + "    이용합니다.\n" + "</p>\n" + "<p>\n" + "    제 5 조 (서비스 이용요금)\n" + "</p>\n" + "<p>\n" + "    ①회사가 제공하는 서비스는 기본적으로 무료입니다. 단, 별도의 유료 서비스의 경우 해당 서비스에 명시된 요금을 지불하여야 사용\n" + "    가능합니다.\n" + "</p>\n" + "<p>\n" + "    ②회사는 유료 서비스 이용요금을 회사와 계약한 전자지불업체에서 정한 방법에 의하거나 회사가 정한 청구서에 합산하여 청구할 수 있습니다.\n" + "</p>\n" + "<p>\n" + "    ③유료서비스 이용을 통하여 결제된 대금에 대한 취소 및 환불은 회사의 결제 이용약관 등 관계법에 따릅니다.\n" + "</p>\n" + "<p>\n" + "    ④회원의 개인정보도용 및 결제사기로 인한 환불요청 또는 결제자의 개인정보 요구는 법률이 정한 경우 외에는 거절될 수 있습니다.\n" + "</p>\n" + "<p>\n" + "    ⑤무선 서비스 이용 시 발생하는 데이터 통신료는 별도이며 가입한 각 이동통신사의 정책에 따릅니다.\n" + "</p>\n" + "<p>\n" + "    ⑥MMS 등으로 게시물을 등록할 경우 발생하는 요금은 이동통신사의 정책에 따릅니다.\n" + "</p>\n" + "<p>\n" + "    제 6 조 (서비스내용변경 통지 등)\n" + "</p>\n" + "<p>\n" + "    ①회사가 서비스 내용을 변경하거나 종료하는 경우 회사는 회원의 등록된 전자우편 주소 또는 통신 단말장치 등을 통하여 서비스 내용의 변경\n" + "    사항 또는 종료를 통지할 수 있습니다.\n" + "</p>\n" + "<p>\n" + "    ②①항의 경우 불특정 다수인을 상대로 통지를 함에 있어서는 웹사이트 등 기타 회사의 공지사항을 통하여 회원들에게 통지할 수 있습니다.\n" + "</p>\n" + "<p>\n" + "    제 7 조 (서비스이용의 제한 및 중지)\n" + "</p>\n" + "<p>\n" + "    ①회사는 아래 각 호의 1에 해당하는 사유가 발생한 경우에는 회원의 서비스 이용을 제한하거나 중지시킬 수 있습니다.\n" + "</p>\n" + "<p>\n" + "    1. 회원이 회사 서비스의 운영을 고의 또는 중과실로 방해하는 경우\n" + "</p>\n" + "<p>\n" + "    2. 서비스용 설비 점검, 보수 또는 공사로 인하여 부득이한 경우\n" + "</p>\n" + "<p>\n" + "    3. 전기통신사업법에 규정된 기간통신사업자가 전기통신 서비스를 중지했을 경우\n" + "</p>\n" + "<p>\n" + "    4. 국가비상사태, 서비스 설비의 장애 또는 서비스 이용의 폭주 등으로 서비스 이용에 지장이 있는 때\n" + "</p>\n" + "<p>\n" + "    5. 기타 중대한 사유로 인하여 회사가 서비스 제공을 지속하는 것이 부적당하다고 인정하는 경우\n" + "</p>\n" + "<p>\n" + "    ②회사는 전항의 규정에 의하여 서비스의 이용을 제한하거나 중지한 때에는 그 사유 및 제한기간 등을 회원에게 알려야 합니다.\n" + "</p>\n" + "<p>\n" + "    제 8 조 (개인위치정보의 이용 또는 제공)\n" + "</p>\n" + "<p>\n" + "    ①회사는 개인위치정보를 이용하여 서비스를 제공하고자 하는 경우에는 미리 이용약관에 명시한 후 개인위치정보주체의 동의를 얻어야 합니다.\n" + "</p>\n" + "<p>\n" + "    ②회원 및 법정대리인의 권리와 그 행사방법은 제소 당시의 이용자의 주소에 의하며, 주소가 없는 경우에는 거소를 관할하는 지방법원의\n" + "    전속관할로 합니다. 다만, 제소 당시 이용자의 주소 또는 거소가 분명하지 않거나 외국 거주자의 경우에는 민사소송법상의 관할법원에\n" + "    제기합니다.\n" + "</p>\n" + "<p>\n" + "    ③회사는 타사업자 또는 이용 고객과의 요금정산 및 민원처리를 위해 위치정보 이용·제공·사실 확인자료를 자동 기록·보존하며, 해당 자료는\n" + "    6개월 이상 보관합니다.\n" + "</p>\n" + "<p>\n" + "    ④회사는 개인위치정보주체의 동의 없이 개인위치정보를 제3자에게 제공하지 아니하며, 제3자 제공 서비스를 제공하는 경우에는 제공 받는자\n" + "    및 제공목적을 사전에 개인위치정보주체에게 고지하고 동의를 받습니다.\n" + "</p>\n" + "<p>\n" + "    ⑤회사는 개인위치정보를 회원이 지정하는 제3자에게 제공하는 경우에는 개인위치정보를 수집한 당해 통신 단말장치로 매회 회원에게 제공받는\n" + "    자, 제공일시 및 제공목적을 즉시 통보합니다. 단, 아래 각 호의 1에 해당하는 경우에는 회원이 미리 특정하여 지정한 통신 단말장치\n" + "    또는 전자우편주소로 통보합니다.\n" + "</p>\n" + "<p>\n" + "    1. 개인위치정보를 수집한 당해 통신단말장치가 문자, 음성 또는 영상의 수신기능을 갖추지 아니한 경우\n" + "</p>\n" + "<p>\n" + "    2. 개인위치정보주체가 개인위치정보를 수집한 해당 통신단말장치 외의 통신단말장치 또는 전자우편주소 등으로 통보할 것을 미리 요청한 경우\n" + "</p>\n" + "<p>\n" + "    제 9 조 (개인위치정보주체의 권리)\n" + "</p>\n" + "<p>\n" + "    ①회원은 회사에 대하여 언제든지 개인위치정보를 이용한 위치기반서비스 제공 및 개인위치정보의 제3자 제공에 대한 동의의 전부 또는 일부를\n" + "    철회할 수 있습니다. 이 경우 회사는 수집한 개인위치정보 및 위치정보 이용, 제공사실 확인자료를 파기합니다.\n" + "</p>\n" + "<p>\n" + "    ②회원은 회사에 대하여 언제든지 개인위치정보의 수집, 이용 또는 제공의 일시적인 중지를 요구할 수 있으며, 회사는 이를 거절할 수 없고\n" + "    이를 위한 기술적 수단을 갖추고 있습니다.\n" + "</p>\n" + "<p>\n" + "    ③회원은 회사에 대하여 아래 각 호의 자료에 대한 열람 또는 고지를 요구할 수 있고, 당해 자료에 오류가 있는 경우에는 그 정정을\n" + "    요구할 수 있습니다. 이 경우 회사는 정당한 사유 없이 회원의 요구를 거절할 수 없습니다.\n" + "</p>\n" + "<p>\n" + "    1. 본인에 대한 위치정보 수집, 이용, 제공사실 확인자료\n" + "</p>\n" + "<p>\n" + "    2. 본인의 개인위치정보가 위치정보의 보호 및 이용 등에 관한 법률 또는 다른 법률 규정에 의하여 제3자에게 제공된 이유 및 내용\n" + "</p>\n" + "<p>\n" + "    ④회원은 제1항 내지 제3항의 권리행사를 위해 회사의 소정의 절차를 통해 요구할 수 있습니다.\n" + "</p>\n" + "<p>\n" + "    제 10 조 (법정대리인의 권리)\n" + "</p>\n" + "<p>\n" + "    ①회사는 14세 미만의 회원에 대해서는 개인위치정보를 이용한 위치기반서비스 제공 및 개인위치정보의 제3자 제공에 대한 동의를 당해\n" + "    회원과 당해 회원의 법정대리인으로부터 동의를 받아야 합니다. 이 경우 법정대리인은 제9조에 의한 회원의 권리를 모두 가집니다.\n" + "</p>\n" + "<p>\n" + "    ②회사는 14세 미만의 아동의 개인위치정보 또는 위치정보 이용․제공사실 확인자료를 이용약관에 명시 또는 고지한 범위를 넘어 이용하거나\n" + "    제3자에게 \\\\제공하고자 하는 경우에는 14세미만의 아동과 그 법정대리인의 동의를 받아야 합니다. 단, 아래의 경우는 제외합니다.\n" + "</p>\n" + "<p>\n" + "    1. 위치정보 및 위치기반서비스 제공에 따른 요금정산을 위하여 위치정보 이용, 제공사실 확인자료가 필요한 경우\n" + "</p>\n" + "<p>\n" + "    2. 통계작성, 학술연구 또는 시장조사를 위하여 특정 개인을 알아볼 수 없는 형태로 가공하여 제공하는 경우\n" + "</p>\n" + "<p>\n" + "    제 11 조 (8세 이하의 아동 등의 보호의무자의 권리)\n" + "</p>\n" + "<p>\n" + "    ①회사는 아래의 경우에 해당하는 자(이하 “8세 이하의 아동”등이라 한다)의 보호의무자가 8세 이하의 아동 등의 생명 또는 신체보호를\n" + "    위하여 개인위치정보의 이용 또는 제공에 동의하는 경우에는 본인의 동의가 있는 것으로 봅니다.\n" + "</p>\n" + "<p>\n" + "    1. 8세 이하의 아동\n" + "</p>\n" + "<p>\n" + "    2. 금치산자\n" + "</p>\n" + "<p>\n" + "    3. 장애인복지법제2조제2항제2호의 규정에 의한 정신적 장애를 가진 자로서 장애인고용촉진및직업재활법 제2조제2호의 규정에 의한\n" + "    중증장애인에 해당하는 자(장애인복지법 제32조의 규정에 의하여 장애인등록을 한 자에 한한다)\n" + "</p>\n" + "<p>\n" + "    ②8세 이하의 아동 등의 생명 또는 신체의 보호를 위하여 개인위치정보의 이용 또는 제공에 동의를 하고자 하는 보호의무자는 서면동의서에\n" + "    보호의무자임을 증명하는 서면을 첨부하여 회사에 제출하여야 합니다.\n" + "</p>\n" + "<p>\n" + "    ③보호의무자는 8세 이하의 아동 등의 개인위치정보 이용 또는 제공에 동의하는 경우 개인위치정보주체 권리의 전부를 행사할 수 있습니다.\n" + "</p>\n" + "<p>\n" + "    제 12 조 (위치정보관리책임자의 지정)\n" + "</p>\n" + "<p>\n" + "    ①회사는 위치정보를 적절히 관리·보호하고 개인위치정보주체의 불만을 원활히 처리할 수 있도록 실질적인 책임을 질 수 있는 지위에 있는\n" + "    자를 위치정보관리책임자로 지정해 운영합니다.\n" + "</p>\n" + "<p>\n" + "    ②위치정보관리책임자는 위치기반서비스를 제공하는 부서의 부서장으로서 구체적인 사항은 본 약관의 부칙에 따릅니다.\n" + "</p>\n" + "<p>\n" + "    제 13 조 (손해배상)\n" + "</p>\n" + "<p>\n" + "    ①회사가 위치정보의 보호 및 이용 등에 관한 법률 제15조 내지 제26조의 규정을 위반한 행위로 회원에게 손해가 발생한 경우 회원은\n" + "    회사에 대하여 손해배상 청구를 할 수 있습니다. 이 경우 회사는 고의, 과실이 없음을 입증하지 못하는 경우 책임을 면할 수 없습니다.\n" + "</p>\n" + "<p>\n" + "    ②회원이 본 약관의 규정을 위반하여 회사에 손해가 발생한 경우 회사는 회원에 대하여 손해배상을 청구할 수 있습니다. 이 경우 회원은\n" + "    고의, 과실이 없음을 입증하지 못하는 경우 책임을 면할 수 없습니다.\n" + "</p>\n" + "<p>\n" + "    제 14 조 (면책)\n" + "</p>\n" + "<p>\n" + "    ①회사는 다음 각 호의 경우로 서비스를 제공할 수 없는 경우 이로 인하여 회원에게 발생한 손해에 대해서는 책임을 부담하지 않습니다.\n" + "</p>\n" + "<p>\n" + "    1. 천재지변 또는 이에 준하는 불가항력의 상태가 있는 경우\n" + "</p>\n" + "<p>\n" + "    2. 서비스 제공을 위하여 회사와 서비스 제휴계약을 체결한 제3자의 고의적인 서비스 방해가 있는 경우\n" + "</p>\n" + "<p>\n" + "    3. 회원의 귀책사유로 서비스 이용에 장애가 있는 경우\n" + "</p>\n" + "<p>\n" + "    4. 제1호 내지 제3호를 제외한 기타 회사의 고의∙과실이 없는 사유로 인한 경우\n" + "</p>\n" + "<p>\n" + "    ②회사는 서비스 및 서비스에 게재된 정보, 자료, 사실의 신뢰도, 정확성 등에 대해서는 보증을 하지 않으며 이로 인해 발생한 회원의\n" + "    손해에 대하여는 책임을 부담하지 아니합니다.\n" + "</p>\n" + "<p>\n" + "    제 15 조 (규정의 준용)\n" + "</p>\n" + "<p>\n" + "    ①본 약관은 대한민국법령에 의하여 규정되고 이행됩니다.\n" + "</p>\n" + "<p>\n" + "    ②본 약관에 규정되지 않은 사항에 대해서는 관련법령 및 상관습에 의합니다.\n" + "</p>\n" + "<p>\n" + "    제 16 조 (분쟁의 조정 및 기타)\n" + "</p>\n" + "<p>\n" + "    ①회사는 위치정보와 관련된 분쟁에 대해 당사자간 협의가 이루어지지 아니하거나 협의를 할 수 없는 경우에는 위치정보의 보호 및 이용 등에\n" + "    관한 법률 제28조 규정에 의한 방송통신위원회에 재정을 신청할 수 있습니다.\n" + "</p>\n" + "<p>\n" + "    ②회사 또는 고객은 위치정보와 관련된 분쟁에 대해 당사자간 협의가 이루어지지 아니하거나 협의를 할 수 없는 경우에는 개인정보보호법\n" + "    제40조의 규정에 의한 개인정보분쟁조정위원회에 조정을 신청할 수 있습니다.\n" + "</p>\n" + "<p>\n" + "    제 17 조 (회사의 연락처) 회사의 상호 및 주소 등은 다음과 같습니다.\n" + "</p>\n" + "<p>\n" + "    1. 상 호 : 엔에이치엔엔터테인먼트 주식회사\n" + "</p>\n" + "<p>\n" + "    2. 대 표 자 : 정 우 진\n" + "</p>\n" + "<p>\n" + "    3. 주 소 : 경기도 성남시 분당구 삼평동 629 플레이뮤지엄\n" + "</p>\n" + "<p>\n" + "    4. 대표전화 : 1544-6859\n" + "</p>\n" + "<p>\n" + "    부 칙\n" + "</p>\n" + "<p>\n" + "    제1조 (시행일) 이 약관은 2018년 8월 31일부터 시행합니다.\n" + "</p>\n" + "<p>\n" + "    제2조 위치정보관리책임자는 2018년 6월을 기준으로 다음과 같이 지정합니다.\n" + "</p>\n" + "<p>\n" + "    1. 소 속 : 법무정책그룹\n" + "</p>\n" + "<p>\n" + "    2. 직 위 : 그룹장\n" + "</p>\n" + "<p>\n" + "    3. 성 명 : 황선영\n" + "</p>\n" + "<p>\n" + "    4. 연 락 처 : 1544-6859\n" + "</p>\n",
    v5: '<p align="center" class="position-terms-title">\n' + "    <strong>위치기반서비스 이용약관</strong>\n" + "</p>\n" + "<p>\n" + "    제1장 총 칙\n" + "</p>\n" + "<p>\n" + "    제 1 조 (목적) 본 약관은 회원(서비스 이용약관에 동의한 자를 말합니다. 이하 “회원”이라고 합니다.)이 엔에이치엔엔터테인먼트\n" + "    주식회사(이하 “회사”라고 합니다.)가 제공하는 위치기반서비스(이하 “서비스”라고 합니다)를 이용함에 있어 회사와 회원의 권리·의무 및\n" + "    책임사항을 규정함을 목적으로 합니다.\n" + "</p>\n" + "<p>\n" + "    제 2 조 (이용약관의 효력 및 변경)\n" + "</p>\n" + "<p>\n" + "    ① 본 약관은 서비스를 신청한 고객 또는 개인위치정보주체가 본 약관에 동의하고 회사가 정한 소정의 절차에 따라 서비스의 이용자로\n" + "    등록함으로써 효력이 발생합니다.\n" + "</p>\n" + "<p>\n" + '    ② 회원이 온라인에서 본 약관의 "동의하기" 버튼\n' + "</p>\n" + "<p>\n" + "    을 클릭하였을 경우 본 약관의 내용을 모두 읽고 이를 충분히 이해하였으며, 그 적용에 동의한 것으로 봅니다.\n" + "</p>\n" + "<p>\n" + "    ③ 회사는 위치정보의 보호 및 이용 등에 관한 법률, 콘텐츠산업 진흥법, 전자상거래 등에서의 소비자보호에 관한 법률, 소비자기본법\n" + "    약관의 규제에 관한 법률 등 관련법령을 위배하지 않는 범위에서 본 약관을 개정할 수 있습니다.\n" + "</p>\n" + "<p>\n" + "    ④ 회사가 약관을 개정할 경우에는 기존약관과 개정약관 및 개정약관의 적용일자와 개정사유를 명시하여 현행약관과 함께 그 적용일자 7일\n" + "    전부터 적용일 이후 상당한 기간 동안 공지만을 하고, 개정 내용이 회원에게 불리한 경우에는 그 적용일자 30일 전부터 적용일 이후\n" + "    상당한 기간 동안 각각 이를 서비스 홈페이지에 게시하거나 회원에게 전자적 형태(전자우편, SMS 등)로 약관 개정 사실을 발송하여\n" + "    고지합니다.\n" + "</p>\n" + "<p>\n" + "    ⑤ 회사가 전항에 따라 회원에게 통지하면서 공지 또는 공지∙고지일로부터 개정약관 시행일 7일 후까지 거부의사를 표시하지 아니하면\n" + "    이용약관에 승인한 것으로 봅니다. 회원이 개정약관에 동의하지 않을 경우 회원은 이용계약을 해지할 수 있습니다.\n" + "</p>\n" + "<p>\n" + "    제 3 조 (관계법령의 적용) 본 약관은 신의성실의 원칙에 따라 공정하게 적용하며, 본 약관에 명시되지 아니한 사항에 대하여는 관계법령\n" + "    또는 상관례에 따릅니다.\n" + "</p>\n" + "<p>\n" + "    제 4 조 (서비스의 내용) 회사는 직접 위치정보를 수집하거나 위치정보사업자인 이동통신사로부터 위치정보를 전달받아 아래와 같은\n" + "    위치기반서비스를 제공합니다.\n" + "</p>\n" + "<p>\n" + "    1. 운동경로 트래킹 서비스: 운동경로를 추적해 운동과정을 기록하고 분석한 데이터를 제공합니다.\n" + "</p>\n" + "<p>\n" + "    2. Geo Tagging 서비스: 게시물 등록 시점의 개인위치정보주체의 위치정보를 게시물과 함께 저장합니다.\n" + "</p>\n" + "<p>\n" + "    3. 현재 위치를 활용한 검색결과 제공 서비스: 정보 검색 요청 시 개인위치정보주체의 현 위치를 이용한 검색결과 및 주변결과(지역정보,\n" + "    주변업체 및 쿠폰정보, 할인정보 등)를 제시합니다.\n" + "</p>\n" + "<p>\n" + "    4. 친구 위치 찾기 및 친구맺기: 함께 서비스 이용 중인 친구의 위치를 찾아주거나 친구를 추천하여 줍니다.\n" + "</p>\n" + "<p>\n" + "    5. 연락처 교환하기: 현재 위치를 활용하여 친구와 연락처를 교환할 수 있습니다.\n" + "</p>\n" + "<p>\n" + "    6. 특정 범위 내 사용자 위치 확인 서비스: 특정 위치와 사용자의 현 위치정보를 비교하여 설정한 범위 내에 사용자가 있는지 확인하여\n" + "    출입, 근태 등의 관리를 할 수 있습니다.\n" + "</p>\n" + "<p>\n" + "    7. 이용자 맞춤형 서비스: 인구통계학적 특성에 따른 서비스 제공, 접속빈도 분석, 기능개선, 서비스 이용에 대한 통계, 서비스 분석\n" + "    및 통계에 따른 이용자 관심 등에 기반한 신규 서비스(개인 맞춤형 상품 추천 서비스 등 포함)를 제공하기 위하여 이용자의 개인위치정보를\n" + "    이용합니다.\n" + "</p>\n" + "<p>\n" + "    제 5 조 (서비스 이용요금)\n" + "</p>\n" + "<p>\n" + "    ① 회사가 제공하는 서비스는 기본적으로 무료입니다. 단, 별도의 유료 서비스의 경우 해당 서비스에 명시된 요금을 지불하여야 사용\n" + "    가능합니다.\n" + "</p>\n" + "<p>\n" + "    ② 회사는 유료 서비스 이용요금을 회사와 계약한 전자지불업체에서 정한 방법에 의하거나 회사가 정한 청구서에 합산하여 청구할 수\n" + "    있습니다.\n" + "</p>\n" + "<p>\n" + "    ③ 유료서비스 이용을 통하여 결제된 대금에 대한 취소 및 환불은 회사의 결제 이용약관 등 관계법에 따릅니다.\n" + "</p>\n" + "<p>\n" + "    ④ 회원의 개인정보도용 및 결제사기로 인한 환불요청 또는 결제자의 개인정보 요구는 법률이 정한 경우 외에는 거절될 수 있습니다.\n" + "</p>\n" + "<p>\n" + "    ⑤ 무선 서비스 이용 시 발생하는 데이터 통신료는 별도이며 가입한 각 이동통신사의 정책에 따릅니다.\n" + "</p>\n" + "<p>\n" + "    ⑥ MMS 등으로 게시물을 등록할 경우 발생하는\n" + "</p>\n" + "<p>\n" + "    요금은 이동통신사의 정책에 따릅니다.\n" + "</p>\n" + "<p>\n" + "    제 6 조 (서비스내용변경 통지 등)\n" + "</p>\n" + "<p>\n" + "    ① 회사가 서비스 내용을 변경하거나 종료하는 경우 회사는 회원의 등록된 전자우편 주소 또는 통신 단말장치 등을 통하여 서비스 내용의\n" + "    변경 사항 또는 종료를 통지할 수 있습니다.\n" + "</p>\n" + "<p>\n" + "    ② ①항의 경우 불특정 다수인을 상대로 통지를 함에 있어서는 웹사이트 등 기타 회사의 공지 사항을 통하여 회원들에게 통지할 수\n" + "    있습니다.\n" + "</p>\n" + "<p>\n" + "    제 7 조 (서비스이용의 제한 및 중지)\n" + "</p>\n" + "<p>\n" + "    ① 회사는 아래 각 호의 1에 해당하는 사유가 발생한 경우에는 회원의 서비스 이용을 제한하거나 중지시킬 수 있습니다.\n" + "</p>\n" + "<p>\n" + "    1. 회원이 회사 서비스의 운영을 고의 또는 중과실로 방해하는 경우\n" + "</p>\n" + "<p>\n" + "    2. 서비스용 설비 점검, 보수 또는 공사로 인하여 부득이한 경우\n" + "</p>\n" + "<p>\n" + "    3. 전기통신사업법에 규정된 기간통신사업자가 전기통신 서비스를 중지했을 경우\n" + "</p>\n" + "<p>\n" + "    4. 국가비상사태, 서비스 설비의 장애 또는 서비스 이용의 폭주 등으로 서비스 이용에 지장이 있는 때\n" + "</p>\n" + "<p>\n" + "    5. 기타 중대한 사유로 인하여 회사가 서비스 제공을 지속하는 것이 부적당하다고 인정하는 경우\n" + "</p>\n" + "<p>\n" + "    ② 회사는 전항의 규정에 의하여 서비스의 이용을 제한하거나 중지한 때에는 그 사유 및 제한기간 등을 회원에게 알려야 합니다.\n" + "</p>\n" + "<p>\n" + "    제 8 조 (개인위치정보의 이용 또는 제공)\n" + "</p>\n" + "<p>\n" + "    ① 회사는 개인위치정보를 이용하여 서비스를 제공하고자 하는 경우에는 미리 이용약관에 명시한 후 개인위치정보주체의 동의를 얻어야 합니다.\n" + "</p>\n" + "<p>\n" + "    ② 회원 및 법정대리인의 권리와 그 행사방법은 제소 당시의 이용자의 주소에 의하며, 주소가 없는 경우에는 거소를 관할하는 지방법원의\n" + "    전속관할로 합니다. 다만, 제소 당시 이용자의 주소 또는 거소가 분명하지 않거나 외국 거주자의 경우에는 민사소송법상의 관할법원에\n" + "    제기합니다.\n" + "</p>\n" + "<p>\n" + "    ③ 회사는 타사업자 또는 이용 고객과의 요금정산 및 민원처리를 위해 위치정보 이용·제공·사실 확인자료를 자동 기록·보존하며, 해당\n" + "    자료는 6개월 이상 보관합니다.\n" + "</p>\n" + "<p>\n" + "    ④ 회사는 개인위치정보주체의 동의 없이 개인위치정보를 제3자에게 제공하지 아니하며, 제3자 제공 서비스를 제공하는 경우에는 제공 받는자\n" + "    및 제공목적을 사전에 개인위치정보주체에게 고지하고 동의를 받습니다.\n" + "</p>\n" + "<p>\n" + "    ⑤ 회사는 개인위치정보를 회원이 지정하는 제3자에게 제공하는 경우에는 개인위치정보를 수집한 당해 통신 단말장치로 매회 회원에게 제공받는\n" + "    자, 제공일시 및 제공목적을 즉시 통보합니다. 단, 아래 각 호의 1에 해당하는 경우에는 회원이 미리 특정하여 지정한 통신 단말장치\n" + "    또는 전자우편주소로 통보합니다.\n" + "</p>\n" + "<p>\n" + "    1. 개인위치정보를 수집한 당해 통신단말장치가 문자, 음성 또는 영상의 수신기능을 갖추지 아니한 경우\n" + "</p>\n" + "<p>\n" + "    2. 개인위치정보주체가 개인위치정보를 수집한 해당 통신단말장치 외의 통신단말장치 또는 전자우편주소 등으로 통보할 것을 미리 요청한 경우\n" + "</p>\n" + "<p>\n" + "    제 9 조 (개인위치정보주체의 권리)\n" + "</p>\n" + "<p>\n" + "    ① 회원은 회사에 대하여 언제든지 개인위치정보를 이용한 위치기반서비스 제공 및 개인위치정보의 제3자 제공에 대한 동의의 전부 또는\n" + "    일부를 철회할 수 있습니다. 이 경우 회사는 수집한 개인위치정보 및 위치정보 이용, 제공사실 확인자료를 파기합니다.\n" + "</p>\n" + "<p>\n" + "    ② 회원은 회사에 대하여 언제든지 개인위치정보의 수집, 이용 또는 제공의 일시적인 중지를 요구할 수 있으며, 회사는 이를 거절할 수\n" + "    없고 이를 위한 기술적 수단을 갖추고 있습니다.\n" + "</p>\n" + "<p>\n" + "    ③ 회원은 회사에 대하여 아래 각 호의 자료에 대한 열람 또는 고지를 요구할 수 있고, 당해 자료에 오류가 있는 경우에는 그 정정을\n" + "    요구할 수 있습니다. 이 경우 회사는 정당한 사유 없이 회원의 요구를 거절할 수 없습니다.\n" + "</p>\n" + "<p>\n" + "    1. 본인에 대한 위치정보 수집, 이용, 제공사실 확인자료\n" + "</p>\n" + "<p>\n" + "    2. 본인의 개인위치정보가 위치정보의 보호 및 이용 등에 관한 법률 또는 다른 법률 규정에 의하여 제3자에게 제공된 이유 및 내용\n" + "</p>\n" + "<p>\n" + "    ④ 회원은 제1항 내지 제3항의 권리행사를 위해 회사의 소정의 절차를 통해 요구할 수 있습니다.\n" + "</p>\n" + "<p>\n" + "    제 10 조 (법정대리인의 권리)\n" + "</p>\n" + "<p>\n" + "    ① 회사는 14세 미만의 회원에 대해서는 개인위치정보를 이용한 위치기반서비스 제공 및 개인위치정보의 제3자 제공에 대한 동의를 당해\n" + "    회원과 당해 회원의 법정대리인으로부터 동의를 받아야 합니다. 이 경우 법정대리인은 제9조에 의한 회원의 권리를 모두 가집니다.\n" + "</p>\n" + "<p>\n" + "    ② 회사는 14세 미만의 아동의 개인위치정보 또는 위치정보 이용․제공사실 확인자료를 이용약관에 명시 또는 고지한 범위를 넘어 이용하거나\n" + "    제3자에게 제공하고자 하는 경우에는 14세미만의 아동과 그 법정대리인의 동의를 받아야 합니다. 단, 아래의 경우는 제외합니다.\n" + "</p>\n" + "<p>\n" + "    1. 위치정보 및 위치기반서비스 제공에 따른 요금정산을 위하여 위치정보 이용, 제공사실 확인자료가 필요한 경우\n" + "</p>\n" + "<p>\n" + "    2. 통계작성, 학술연구 또는 시장조사를 위하여 특정 개인을 알아볼 수 없는 형태로 가공하여 제공하는 경우\n" + "</p>\n" + "<p>\n" + "    제 11 조 (8세 이하의 아동 등의 보호의무자의 권리)\n" + "</p>\n" + "<p>\n" + "    ① 회사는 아래의 경우에 해당하는 자(이하 “8세 이하의 아동”등이라 한다)의 보호의무자가 8세 이하의 아동 등의 생명 또는 신체보호를\n" + "    위하여 개인위치정보의 이용 또는 제공에 동의하는 경우에는 본인의 동의가 있는 것으로 봅니다.\n" + "</p>\n" + "<p>\n" + "    1. 8세 이하의 아동\n" + "</p>\n" + "<p>\n" + "    2. 금치산자\n" + "</p>\n" + "<p>\n" + "    3. 장애인복지법제2조제2항제2호의 규정에 의한 정신적 장애를 가진 자로서 장애인고용촉진및직업재활법 제2조제2호의 규정에 의한\n" + "    중증장애인에 해당하는 자(장애인복지법 제32조의 규정에 의하여 장애인등록을 한 자에 한한다)\n" + "</p>\n" + "<p>\n" + "    ② 8세 이하의 아동 등의 생명 또는 신체의 보호를 위하여 개인위치정보의 이용 또는 제공에 동의를 하고자 하는 보호의무자는 서면동의서에\n" + "    보호의무자임을 증명하는 서면을 첨부하여 회사에 제출하여야 합니다.\n" + "</p>\n" + "<p>\n" + "    ③ 보호의무자는 8세 이하의 아동 등의 개인위치정보 이용 또는 제공에 동의하는 경우 개인위치정보주체 권리의 전부를 행사할 수 있습니다.\n" + "</p>\n" + "<p>\n" + "    제 12 조 (위치정보관리책임자의 지정)\n" + "</p>\n" + "<p>\n" + "    ① 회사는 위치정보를 적절히 관리·보호하고 개인위치정보주체의 불만을 원활히 처리할 수 있도록 실질적인 책임을 질 수 있는 지위에 있는\n" + "    자를 위치정보관리책임자로 지정해 운영합니다.\n" + "</p>\n" + "<p>\n" + "    ② 위치정보관리책임자는 위치기반서비스를 제공하는 부서의 부서장으로서 구체적인 사항은 본 약관의 부칙에 따릅니다.\n" + "</p>\n" + "<p>\n" + "    제 13 조 (손해배상)\n" + "</p>\n" + "<p>\n" + "    ① 회사가 위치정보의 보호 및 이용 등에 관한 법률 제15조 내지 제26조의 규정을 위반한 행위로 회원에게 손해가 발생한 경우 회원은\n" + "    회사에 대하여 손해배상 청구를 할 수 있습니다. 이 경우 회사는 고의, 과실이 없음을 입증하지 못하는 경우 책임을 면할 수 없습니다.\n" + "</p>\n" + "<p>\n" + "    ② 회원이 본 약관의 규정을 위반하여 회사에 손해가 발생한 경우 회사는 회원에 대하여 손해배상을 청구할 수 있습니다. 이 경우 회원은\n" + "    고의, 과실이 없음을 입증하지 못하는 경우 책임을 면할 수 없습니다.\n" + "</p>\n" + "<p>\n" + "    제 14 조 (면책)\n" + "</p>\n" + "<p>\n" + "    ① 회사는 다음 각 호의 경우로 서비스를 제공할 수 없는 경우 이로 인하여 회원에게 발생한 손해에 대해서는 책임을 부담하지 않습니다.\n" + "</p>\n" + "<p>\n" + "    1. 천재지변 또는 이에 준하는 불가항력의 상태가 있는 경우\n" + "</p>\n" + "<p>\n" + "    2. 서비스 제공을 위하여 회사와 서비스 제휴계약을 체결한 제3자의 고의적인 서비스 방해가 있는 경우\n" + "</p>\n" + "<p>\n" + "    3. 회원의 귀책사유로 서비스 이용에 장애가 있는 경우\n" + "</p>\n" + "<p>\n" + "    4. 제1호 내지 제3호를 제외한 기타 회사의 고의∙과실이 없는 사유로 인한 경우\n" + "</p>\n" + "<p>\n" + "    ② 회사는 서비스 및 서비스에 게재된 정보, 자료, 사실의 신뢰도, 정확성 등에 대해서는 보증을 하지 않으며 이로 인해 발생한 회원의\n" + "    손해에 대하여는 책임을 부담하지 아니합니다.\n" + "</p>\n" + "<p>\n" + "    제 15 조 (규정의 준용)\n" + "</p>\n" + "<p>\n" + "    ① 본 약관은 대한민국법령에 의하여 규정되고 이행됩니다.\n" + "</p>\n" + "<p>\n" + "    ② 본 약관에 규정되지 않은 사항에 대해서는 관련법령 및 상관습에 의합니다.\n" + "</p>\n" + "<p>\n" + "    제 16 조 (분쟁의 조정 및 기타)\n" + "</p>\n" + "<p>\n" + "    ① 회사는 위치정보와 관련된 분쟁에 대해 당사자간 협의가 이루어지지 아니하거나 협의를 할 수 없는 경우에는 위치정보의 보호 및 이용\n" + "    등에 관한 법률 제28조 규정에 의한 방송통신위원회에 재정을 신청할 수 있습니다.\n" + "</p>\n" + "<p>\n" + "    ② 회사 또는 고객은 위치정보와 관련된 분쟁에 대해 당사자간 협의가 이루어지지 아니하거나 협의를 할 수 없는 경우에는 개인정보보호법\n" + "    제40조의 규정에 의한 개인정보분쟁조정위원회에 조정을 신청할 수 있습니다.\n" + "</p>\n" + "<p>\n" + "    제 17 조 (회사의 연락처) 회사의 상호 및 주소 등은 다음과 같습니다.\n" + "</p>\n" + "<p>\n" + "    1. 상 호 : 엔에이치엔엔터테인먼트 주식회사\n" + "</p>\n" + "<p>\n" + "    2. 대 표 자 : 정 우 진\n" + "</p>\n" + "<p>\n" + "    3. 주 소 : 경기도 성남시 분당구 삼평동 629 플레이뮤지엄\n" + "</p>\n" + "<p>\n" + "    4. 대표전화 : 1544-6859\n" + "</p>\n" + "<p>\n" + "    부 칙\n" + "</p>\n" + "<p>\n" + "    제1조 (시행일) 이 약관은 2017년 4월 28일부터 시행합니다.\n" + "</p>\n" + "<p>\n" + "    제2조 위치정보관리책임자는 2013년 8월을 기준으로 다음과 같이 지정합니다.\n" + "</p>\n" + "<p>\n" + "    1. 소 속 : 법무정책그룹\n" + "</p>\n" + "<p>\n" + "    2. 직 위 : 그룹장\n" + "</p>\n" + "<p>\n" + "    3. 성 명 : 김현성\n" + "</p>\n" + "<p>\n" + "    4. 연 락 처 : 1544-6859\n" + "</p>\n",
    v4: '<p align="center" class="position-terms-title">\n' + "    <strong>위치기반서비스 이용약관</strong>\n" + "</p>\n" + "<p>\n" + "    제1장 총 칙\n" + "</p>\n" + "<p>\n" + "    제 1 조 (목적) 본 약관은 회원(서비스 이용약관에 동의한 자를 말합니다. 이하 “회원”이라고 합니다.)이 엔에이치엔엔터테인먼트\n" + "    주식회사(이하 “회사”라고 합니다.)가 제공하는 위치기반서비스(이하 “서비스”라고 합니다)를 이용함에 있어 회사와 회원의 권리·의무 및\n" + "    책임사항을 규정함을 목적으로 합니다.\n" + "</p>\n" + "<p>\n" + "    제 2 조 (이용약관의 효력 및 변경)\n" + "</p>\n" + "<p>\n" + "    ① 본 약관은 서비스를 신청한 고객 또는 개인 위치정보주체가 본 약관에 동의하고 회사가 정한 소정의 절차에 따라 서비스의 이용자로\n" + "    등록함으로써 효력이 발생합니다.\n" + "</p>\n" + "<p>\n" + '    ② 회원이 온라인에서 본 약관의 "동의하기" 버튼\n' + "</p>\n" + "<p>\n" + "    을 클릭하였을 경우 본 약관의 내용을 모두 읽고 이를 충분히 이해하였으며, 그 적용에 동의한 것으로 봅니다.\n" + "</p>\n" + "<p>\n" + "    ③ 회사는 위치정보의 보호 및 이용 등에 관한 법률, 콘텐츠산업 진흥법, 전자상거래 등에서의 소비자보호에 관한 법률, 소비자기본법\n" + "    약관의 규제에 관한 법률 등 관련법령을 위배하지 않는 범위에서 본 약관을 개정할 수 있습니다.\n" + "</p>\n" + "<p>\n" + "    ④ 회사가 약관을 개정할 경우에는 기존약관과 개정약관 및 개정약관의 적용일자와 개정사유를 명시하여 현행약관과 함께 그 적용일자 7일\n" + "    전부터 적용일 이후 상당한 기간 동안 공지만을 하고, 개정 내용이 회원에게 불리한 경우에는 그 적용일자 30일 전부터 적용일 이후\n" + "    상당한 기간 동안 각각 이를 서비스 홈페이지에 게시하거나 회원에게 전자적 형태(전자우편, SMS 등)로 약관 개정 사실을 발송하여\n" + "    고지합니다.\n" + "</p>\n" + "<p>\n" + "    ⑤ 회사가 전항에 따라 회원에게 통지하면서 공지 또는 공지∙고지일로부터 개정약관 시행일 7일 후까지 거부의사를 표시하지 아니하면\n" + "    이용약관에 승인한 것으로 봅니다. 회원이 개정약관에 동의하지 않을 경우 회원은 이용계약을 해지할 수 있습니다.\n" + "</p>\n" + "<p>\n" + "    제 3 조 (관계법령의 적용) 본 약관은 신의성실의 원칙에 따라 공정하게 적용하며, 본 약관에 명시되지 아니한 사항에 대하여는 관계법령\n" + "    또는 상관례에 따릅니다.\n" + "</p>\n" + "<p>\n" + "    제 4 조 (서비스의 내용) 회사는 직접 위치정보를 수집하거나 위치정보사업자인 이동통신사로부터 위치정보를 전달받아 아래와 같은\n" + "    위치기반서비스를 제공합니다.\n" + "</p>\n" + "<p>\n" + "    1. 운동경로 트래킹 서비스: 운동경로를 추적해 운동과정을 기록하고 분석한 데이터를 제공합니다.\n" + "</p>\n" + "<p>\n" + "    2. Geo Tagging 서비스: 게시물 등록 시점의 개인위치정보주체의 위치정보를 게시물과 함께 저장합니다.\n" + "</p>\n" + "<p>\n" + "    3. 현재 위치를 활용한 검색결과 제공 서비스: 정보 검색 요청 시 개인위치정보주체의 현 위치를 이용한 검색결과 및 주변결과(지역정보,\n" + "    주변업체 및 쿠폰정보, 할인정보 등)를 제시합니다.\n" + "</p>\n" + "<p>\n" + "    4. 친구 위치 찾기 및 친구맺기: 함께 서비스 이용 중인 친구의 위치를 찾아주거나 친구를 추천하여 줍니다.\n" + "</p>\n" + "<p>\n" + "    5. 연락처 교환하기: 현재 위치를 활용하여 친구와 연락처를 교환할 수 있습니다.\n" + "</p>\n" + "<p>\n" + "    6. 근태관리 서비스: 근무할 매장주소와 사용자의 현 위치정보를 비교하여 설정한 범위내에 사용자가 있는지 확인 후 출근처리 합니다.\n" + "</p>\n" + "<p>\n" + "    7. 이용자 맞춤형 서비스: 인구통계학적 특성에 따른 서비스 제공, 접속빈도 분석, 기능개선, 서비스 이용에 대한 통계, 서비스 분석\n" + "    및 통계에 따른 이용자 관심 등에 기반한 신규 서비스(개인 맞춤형 상품 추천 서비스 등 포함)를 제공하기 위하여 이용자의 개인위치정보를\n" + "    이용합니다.\n" + "</p>\n" + "<p>\n" + "    제 5 조 (서비스 이용요금)\n" + "</p>\n" + "<p>\n" + "    ① 회사가 제공하는 서비스는 기본적으로 무료입니다. 단, 별도의 유료 서비스의 경우 해당 서비스에 명시된 요금을 지불하여야 사용\n" + "    가능합니다.\n" + "</p>\n" + "<p>\n" + "    ② 회사는 유료 서비스 이용요금을 회사와 계약한 전자지불업체에서 정한 방법에 의하거나 회사가 정한 청구서에 합산하여 청구할 수\n" + "    있습니다.\n" + "</p>\n" + "<p>\n" + "    ③ 유료서비스 이용을 통하여 결제된 대금에 대한 취소 및 환불은 회사의 결제 이용약관 등 관계법에 따릅니다.\n" + "</p>\n" + "<p>\n" + "    ④ 회원의 개인정보도용 및 결제사기로 인한 환불요청 또는 결제자의 개인정보 요구는 법률이 정한 경우 외에는 거절될 수 있습니다.\n" + "</p>\n" + "<p>\n" + "    ⑤ 무선 서비스 이용 시 발생하는 데이터 통신료는 별도이며 가입한 각 이동통신사의 정책에 따릅니다.\n" + "</p>\n" + "<p>\n" + "    ⑥ MMS 등으로 게시물을 등록할 경우 발생하는\n" + "</p>\n" + "<p>\n" + "    요금은 이동통신사의 정책에 따릅니다.\n" + "</p>\n" + "<p>\n" + "    제 6 조 (서비스내용변경 통지 등)\n" + "</p>\n" + "<p>\n" + "    ① 회사가 서비스 내용을 변경하거나 종료하는 경우 회사는 회원의 등록된 전자우편 주소 또는 통신 단말장치 등을 통하여 서비스 내용의\n" + "    변경 사항 또는 종료를 통지할 수 있습니다.\n" + "</p>\n" + "<p>\n" + "    ② ①항의 경우 불특정 다수인을 상대로 통지를 함에 있어서는 웹사이트 등 기타 회사의 공지 사항을 통하여 회원들에게 통지할 수\n" + "    있습니다.\n" + "</p>\n" + "<p>\n" + "    제 7 조 (서비스이용의 제한 및 중지)\n" + "</p>\n" + "<p>\n" + "    ① 회사는 아래 각 호의 1에 해당하는 사유가 발생한 경우에는 회원의 서비스 이용을 제한하거나 중지시킬 수 있습니다.\n" + "</p>\n" + "<p>\n" + "    1. 회원이 회사 서비스의 운영을 고의 또는 중과실로 방해하는 경우\n" + "</p>\n" + "<p>\n" + "    2. 서비스용 설비 점검, 보수 또는 공사로 인하여 부득이한 경우\n" + "</p>\n" + "<p>\n" + "    3. 전기통신사업법에 규정된 기간통신사업자가 전기통신 서비스를 중지했을 경우\n" + "</p>\n" + "<p>\n" + "    4. 국가비상사태, 서비스 설비의 장애 또는 서비스 이용의 폭주 등으로 서비스 이용에 지장이 있는 때\n" + "</p>\n" + "<p>\n" + "    5. 기타 중대한 사유로 인하여 회사가 서비스 제공을 지속하는 것이 부적당하다고 인정하는 경우\n" + "</p>\n" + "<p>\n" + "    ② 회사는 전항의 규정에 의하여 서비스의 이용을 제한하거나 중지한 때에는 그 사유 및 제한기간 등을 회원에게 알려야 합니다.\n" + "</p>\n" + "<p>\n" + "    제 8 조 (개인위치정보의 이용 또는 제공)\n" + "</p>\n" + "<p>\n" + "    ① 회사는 개인위치정보를 이용하여 서비스를 제공하고자 하는 경우에는 미리 이용약관에 명시한 후 개인위치정보주체의 동의를 얻어야 합니다.\n" + "</p>\n" + "<p>\n" + "    ② 회원 및 법정대리인의 권리와 그 행사방법은 제소 당시의 이용자의 주소에 의하며, 주소가 없는 경우에는 거소를 관할하는 지방법원의\n" + "    전속관할로 합니다. 다만, 제소 당시 이용자의 주소 또는 거소가 분명하지 않거나 외국 거주자의 경우에는 민사소송법상의 관할법원에\n" + "    제기합니다.\n" + "</p>\n" + "<p>\n" + "    ③ 회사는 타사업자 또는 이용 고객과의 요금정산 및 민원처리를 위해 위치정보 이용·제공·사실 확인자료를 자동 기록·보존하며, 해당\n" + "    자료는 6개월 이상 보관합니다.\n" + "</p>\n" + "<p>\n" + "    ④ 회사는 개인위치정보주체의 동의 없이 개인위치정보를 제3자에게 제공하지 아니하며, 제3자 제공 서비스를 제공하는 경우에는 제공 받는자\n" + "    및 제공목적을 사전에 개인위치정보주체에게 고지하고 동의를 받습니다.\n" + "</p>\n" + "<p>\n" + "    ⑤ 회사는 개인위치정보를 회원이 지정하는 제3자에게 제공하는 경우에는 개인위치정보를 수집한 당해 통신 단말장치로 매회 회원에게 제공받는\n" + "    자, 제공일시 및 제공목적을 즉시 통보합니다. 단, 아래 각 호의 1에 해당하는 경우에는 회원이 미리 특정하여 지정한 통신 단말장치\n" + "    또는 전자우편주소로 통보합니다.\n" + "</p>\n" + "<p>\n" + "    1. 개인위치정보를 수집한 당해 통신단말장치가 문자, 음성 또는 영상의 수신기능을 갖추지 아니한 경우\n" + "</p>\n" + "<p>\n" + "    2. 개인위치정보주체가 개인위치정보를 수집한 해당 통신단말장치 외의 통신단말장치 또는 전자우편주소 등으로 통보할 것을 미리 요청한 경우\n" + "</p>\n" + "<p>\n" + "    제 9 조 (개인위치정보주체의 권리)\n" + "</p>\n" + "<p>\n" + "    ① 회원은 회사에 대하여 언제든지 개인위치정보를 이용한 위치기반서비스 제공 및 개인위치정보의 제3자 제공에 대한 동의의 전부 또는\n" + "    일부를 철회할 수 있습니다. 이 경우 회사는 수집한 개인위치정보 및 위치정보 이용, 제공사실 확인자료를 파기합니다.\n" + "</p>\n" + "<p>\n" + "    ② 회원은 회사에 대하여 언제든지 개인위치정보의 수집, 이용 또는 제공의 일시적인 중지를 요구할 수 있으며, 회사는 이를 거절할 수\n" + "    없고 이를 위한 기술적 수단을 갖추고 있습니다.\n" + "</p>\n" + "<p>\n" + "    ③ 회원은 회사에 대하여 아래 각 호의 자료에 대한 열람 또는 고지를 요구할 수 있고, 당해 자료에 오류가 있는 경우에는 그 정정을\n" + "    요구할 수 있습니다. 이 경우 회사는 정당한 사유 없이 회원의 요구를 거절할 수 없습니다.\n" + "</p>\n" + "<p>\n" + "    1. 본인에 대한 위치정보 수집, 이용, 제공사실 확인자료\n" + "</p>\n" + "<p>\n" + "    2. 본인의 개인위치정보가 위치정보의 보호 및 이용 등에 관한 법률 또는 다른 법률 규정에 의하여 제3자에게 제공된 이유 및 내용\n" + "</p>\n" + "<p>\n" + "    ④ 회원은 제1항 내지 제3항의 권리행사를 위해 회사의 소정의 절차를 통해 요구할 수 있습니다.\n" + "</p>\n" + "<p>\n" + "    제 10 조 (법정대리인의 권리)\n" + "</p>\n" + "<p>\n" + "    ① 회사는 14세 미만의 회원에 대해서는 개인위치정보를 이용한 위치기반서비스 제공 및 개인위치정보의 제3자 제공에 대한 동의를 당해\n" + "    회원과 당해 회원의 법정대리인으로부터 동의를 받아야 합니다. 이 경우 법정대리인은 제9조에 의한 회원의 권리를 모두 가집니다.\n" + "</p>\n" + "<p>\n" + "    ② 회사는 14세 미만의 아동의 개인위치정보 또는 위치정보 이용․제공사실 확인자료를 이용약관에 명시 또는 고지한 범위를 넘어 이용하거나\n" + "    제3자에게 제공하고자 하는 경우에는 14세미만의 아동과 그 법정대리인의 동의를 받아야 합니다. 단, 아래의 경우는 제외합니다.\n" + "</p>\n" + "<p>\n" + "    1. 위치정보 및 위치기반서비스 제공에 따른 요금정산을 위하여 위치정보 이용, 제공사실 확인자료가 필요한 경우\n" + "</p>\n" + "<p>\n" + "    2. 통계작성, 학술연구 또는 시장조사를 위하여 특정 개인을 알아볼 수 없는 형태로 가공하여 제공하는 경우\n" + "</p>\n" + "<p>\n" + "    제 11 조 (8세 이하의 아동 등의 보호의무자의 권리)\n" + "</p>\n" + "<p>\n" + "    ① 회사는 아래의 경우에 해당하는 자(이하 “8세 이하의 아동”등이라 한다)의 보호의무자가 8세 이하의 아동 등의 생명 또는 신체보호를\n" + "    위하여 개인위치정보의 이용 또는 제공에 동의하는 경우에는 본인의 동의가 있는 것으로 봅니다.\n" + "</p>\n" + "<p>\n" + "    1. 8세 이하의 아동\n" + "</p>\n" + "<p>\n" + "    2. 금치산자\n" + "</p>\n" + "<p>\n" + "    3. 장애인복지법제2조제2항제2호의 규정에 의한 정신적 장애를 가진 자로서 장애인고용촉진및직업재활법 제2조제2호의 규정에 의한\n" + "    중증장애인에 해당하는 자(장애인복지법 제32조의 규정에 의하여 장애인등록을 한 자에 한한다)\n" + "</p>\n" + "<p>\n" + "    ② 8세 이하의 아동 등의 생명 또는 신체의 보호를 위하여 개인위치정보의 이용 또는 제공에 동의를 하고자 하는 보호의무자는 서면동의서에\n" + "    보호의무자임을 증명하는 서면을 첨부하여 회사에 제출하여야 합니다.\n" + "</p>\n" + "<p>\n" + "    ③ 보호의무자는 8세 이하의 아동 등의 개인위치정보 이용 또는 제공에 동의하는 경우 개인위치정보주체 권리의 전부를 행사할 수 있습니다.\n" + "</p>\n" + "<p>\n" + "    제 12 조 (위치정보관리책임자의 지정)\n" + "</p>\n" + "<p>\n" + "    ① 회사는 위치정보를 적절히 관리·보호하고 개인위치정보주체의 불만을 원활히 처리할 수 있도록 실질적인 책임을 질 수 있는 지위에 있는\n" + "    자를 위치정보관리책임자로 지정해 운영합니다.\n" + "</p>\n" + "<p>\n" + "    ② 위치정보관리책임자는 위치기반서비스를 제공하는 부서의 부서장으로서 구체적인 사항은 본 약관의 부칙에 따릅니다.\n" + "</p>\n" + "<p>\n" + "    제 13 조 (손해배상)\n" + "</p>\n" + "<p>\n" + "    ① 회사가 위치정보의 보호 및 이용 등에 관한 법률 제15조 내지 제26조의 규정을 위반한 행위로 회원에게 손해가 발생한 경우 회원은\n" + "    회사에 대하여 손해배상 청구를 할 수 있습니다. 이 경우 회사는 고의, 과실이 없음을 입증하지 못하는 경우 책임을 면할 수 없습니다.\n" + "</p>\n" + "<p>\n" + "    ② 회원이 본 약관의 규정을 위반하여 회사에 손해가 발생한 경우 회사는 회원에 대하여 손해배상을 청구할 수 있습니다. 이 경우 회원은\n" + "    고의, 과실이 없음을 입증하지 못하는 경우 책임을 면할 수 없습니다.\n" + "</p>\n" + "<p>\n" + "    제 14 조 (면책)\n" + "</p>\n" + "<p>\n" + "    ① 회사는 다음 각 호의 경우로 서비스를 제공할 수 없는 경우 이로 인하여 회원에게 발생한 손해에 대해서는 책임을 부담하지 않습니다.\n" + "</p>\n" + "<p>\n" + "    1. 천재지변 또는 이에 준하는 불가항력의 상태가 있는 경우\n" + "</p>\n" + "<p>\n" + "    2. 서비스 제공을 위하여 회사와 서비스 제휴계약을 체결한 제3자의 고의적인 서비스 방해가 있는 경우\n" + "</p>\n" + "<p>\n" + "    3. 회원의 귀책사유로 서비스 이용에 장애가 있는 경우\n" + "</p>\n" + "<p>\n" + "    4. 제1호 내지 제3호를 제외한 기타 회사의 고의∙과실이 없는 사유로 인한 경우\n" + "</p>\n" + "<p>\n" + "    ② 회사는 서비스 및 서비스에 게재된 정보, 자료, 사실의 신뢰도, 정확성 등에 대해서는 보증을 하지 않으며 이로 인해 발생한 회원의\n" + "    손해에 대하여는 책임을 부담하지 아니합니다.\n" + "</p>\n" + "<p>\n" + "    제 15 조 (규정의 준용)\n" + "</p>\n" + "<p>\n" + "    ① 본 약관은 대한민국법령에 의하여 규정되고 이행됩니다.\n" + "</p>\n" + "<p>\n" + "    ② 본 약관에 규정되지 않은 사항에 대해서는 관련법령 및 상관습에 의합니다.\n" + "</p>\n" + "<p>\n" + "    제 16 조 (분쟁의 조정 및 기타)\n" + "</p>\n" + "<p>\n" + "    ① 회사는 위치정보와 관련된 분쟁에 대해 당사자간 협의가 이루어지지 아니하거나 협의를 할 수 없는 경우에는 위치정보의 보호 및 이용\n" + "    등에 관한 법률 제28조 규정에 의한 방송통신위원회에 재정을 신청할 수 있습니다.\n" + "</p>\n" + "<p>\n" + "    ② 회사 또는 고객은 위치정보와 관련된 분쟁에 대해 당사자간 협의가 이루어지지 아니하거나 협의를 할 수 없는 경우에는 개인정보보호법\n" + "    제40조의 규정에 의한 개인정보분쟁조정위원회에 조정을 신청할 수 있습니다.\n" + "</p>\n" + "<p>\n" + "    제 17 조 (회사의 연락처) 회사의 상호 및 주소 등은 다음과 같습니다.\n" + "</p>\n" + "<p>\n" + "    1. 상 호 : 엔에이치엔엔터테인먼트 주식회사\n" + "</p>\n" + "<p>\n" + "    2. 대 표 자 : 정 우 진\n" + "</p>\n" + "<p>\n" + "    3. 주 소 : 경기도 성남시 분당구 삼평동 629 플레이뮤지엄\n" + "</p>\n" + "<p>\n" + "    4. 대표전화 : 1544-6859\n" + "</p>\n" + "<p>\n" + "    부 칙\n" + "</p>\n" + "<p>\n" + "    제1조 (시행일) 이 약관은 2017년 3월 3일부터 시행합니다.<strong></strong>\n" + "</p>\n" + "<p>\n" + "    제2조 위치정보관리책임자는 2013년 8월을 기준으로 다음과 같이 지정합니다.\n" + "</p>\n" + "<p>\n" + "    1. 소 속 : 법무정책그룹\n" + "</p>\n" + "<p>\n" + "    2. 직 위 : 그룹장\n" + "</p>\n" + "<p>\n" + "    3. 성 명 : 김현성\n" + "</p>\n" + "<p>\n" + "    4. 연 락 처 : 1544-6859\n" + "</p>\n",
    v3: '<p align="center" class="position-terms-title">\n' + "    <strong>위치기반서비스 이용약관</strong>\n" + "</p>\n" + "<p>\n" + "    제1장 총 칙\n" + "</p>\n" + "<p>\n" + "    제 1 조 (목적) 본 약관은 회원(서비스 이용약관에 동의한 자를 말합니다. 이하 “회원”이라고 합니다.)이 엔에이치엔엔터테인먼트\n" + "    주식회사(이하 “회사”라고 합니다.)가 제공하는 위치기반서비스(이하 “서비스”라고 합니다)를 이용함에 있어 회사와 회원의 권리·의무 및\n" + "    책임사항을 규정함을 목적으로 합니다.\n" + "</p>\n" + "<p>\n" + "    제 2 조 (이용약관의 효력 및 변경)\n" + "</p>\n" + "<p>\n" + "    ①본 약관은 서비스를 신청한 고객 또는 개인위치정보주체가 본 약관에 동의하고 회사가 정한 소정의 절차에 따라 서비스의 이용자로\n" + "    등록함으로써 효력이 발생합니다.\n" + "</p>\n" + "<p>\n" + '    ②회원이 온라인에서 본 약관의 "동의하기" 버튼을 클릭하였을 경우 본 약관의 내용을 모두 읽고 이를 충분히 이해하였으며, 그 적용에\n' + "    동의한 것으로 봅니다.\n" + "</p>\n" + "<p>\n" + "    ③회사는 위치정보의 보호 및 이용 등에 관한 법률, 콘텐츠산업 진흥법, 전자상거래 등에서의 소비자보호에 관한 법률, 소비자기본법 약관의\n" + "    규제에 관한 법률 등 관련법령을 위배하지 않는 범위에서 본 약관을 개정할 수 있습니다.\n" + "</p>\n" + "<p>\n" + "    ④회사가 약관을 개정할 경우에는 기존약관과 개정약관 및 개정약관의 적용일자와 개정사유를 명시하여 현행약관과 함께 그 적용일자 7일\n" + "    전부터 적용일 이후 상당한 기간 동안 공지만을 하고, 개정 내용이 회원에게 불리한 경우에는 그 적용일자 30일 전부터 적용일 이후\n" + "    상당한 기간 동안 각각 이를 서비스 홈페이지에 게시하거나 회원에게 전자적 형태(전자우편, SMS 등)로 약관 개정 사실을 발송하여\n" + "    고지합니다.\n" + "</p>\n" + "<p>\n" + "    ⑤회사가 전항에 따라 회원에게 통지하면서 공지 또는 공지∙고지일로부터 개정약관 시행일 7일 후까지 거부의사를 표시하지 아니하면\n" + "    이용약관에 승인한 것으로 봅니다. 회원이 개정약관에 동의하지 않을 경우 회원은 이용계약을 해지할 수 있습니다.\n" + "</p>\n" + "<p>\n" + "    제 3 조 (관계법령의 적용) 본 약관은 신의성실의 원칙에 따라 공정하게 적용하며, 본 약관에 명시되지 아니한 사항에 대하여는 관계법령\n" + "    또는 상관례에 따릅니다.\n" + "</p>\n" + "<p>\n" + "    제 4 조 (서비스의 내용) 회사는 직접 위치정보를 수집하거나 위치정보사업자인 이동통신사로부터 위치정보를 전달받아 아래와 같은\n" + "    위치기반서비스를 제공합니다.\n" + "</p>\n" + "<p>\n" + "    1. 운동경로 트래킹 서비스: 운동경로를 추적해 운동과정을 기록하고 분석한 데이터를 제공합니다.\n" + "</p>\n" + "<p>\n" + "    2. Geo Tagging 서비스: 게시물 등록 시점의 개인위치정보주체의 위치정보를 게시물과 함께 저장합니다.\n" + "</p>\n" + "<p>\n" + "    3. 현재 위치를 활용한 검색결과 제공 서비스: 정보 검색 요청 시 개인위치정보주체의 현 위치를 이용한 검색결과 및 주변결과(지역정보,\n" + "    주변업체 및 쿠폰정보, 할인정보 등)를 제시합니다.\n" + "</p>\n" + "<p>\n" + "    4. 친구 위치 찾기 및 친구맺기: 함께 서비스 이용 중인 친구의 위치를 찾아주거나 친구를 추천하여 줍니다.\n" + "</p>\n" + "<p>\n" + "    5. 연락처 교환하기: 현재 위치를 활용하여 친구와 연락처를 교환할 수 있습니다.\n" + "</p>\n" + "<p>\n" + "    6. 근태관리 서비스: 근무할 매장주소와 사용자의 현 위치정보를 비교하여 설정한 범위내에 사용자가 있는지 확인 후 출근처리 합니다.\n" + "</p>\n" + "<p>\n" + "    제 5 조 (서비스 이용요금)\n" + "</p>\n" + "<p>\n" + "    ①회사가 제공하는 서비스는 기본적으로 무료입니다. 단, 별도의 유료 서비스의 경우 해당 서비스에 명시된 요금을 지불하여야 사용\n" + "    가능합니다.\n" + "</p>\n" + "<p>\n" + "    ②회사는 유료 서비스 이용요금을 회사와 계약한 전자지불업체에서 정한 방법에 의하거나 회사가 정한 청구서에 합산하여 청구할 수 있습니다.\n" + "</p>\n" + "<p>\n" + "    ③유료서비스 이용을 통하여 결제된 대금에 대한 취소 및 환불은 회사의 결제 이용약관 등 관계법에 따릅니다.\n" + "</p>\n" + "<p>\n" + "    ④회원의 개인정보도용 및 결제사기로 인한 환불요청 또는 결제자의 개인정보 요구는 법률이 정한 경우 외에는 거절될 수 있습니다.\n" + "</p>\n" + "<p>\n" + "    ⑤무선 서비스 이용 시 발생하는 데이터 통신료는 별도이며 가입한 각 이동통신사의 정책에 따릅니다.\n" + "</p>\n" + "<p>\n" + "    ⑥MMS 등으로 게시물을 등록할 경우 발생하는 요금은 이동통신사의 정책에 따릅니다.\n" + "</p>\n" + "<p>\n" + "    제 6 조 (서비스내용변경 통지 등)\n" + "</p>\n" + "<p>\n" + "    ①회사가 서비스 내용을 변경하거나 종료하는 경우 회사는 회원의 등록된 전자우편 주소 또는 통신 단말장치 등을 통하여 서비스 내용의 변경\n" + "    사항 또는 종료를 통지할 수 있습니다.\n" + "</p>\n" + "<p>\n" + "    ②①항의 경우 불특정 다수인을 상대로 통지를 함에 있어서는 웹사이트 등 기타 회사의 공지사항을 통하여 회원들에게 통지할 수 있습니다.\n" + "</p>\n" + "<p>\n" + "    제 7 조 (서비스이용의 제한 및 중지)\n" + "</p>\n" + "<p>\n" + "    ①회사는 아래 각 호의 1에 해당하는 사유가 발생한 경우에는 회원의 서비스 이용을 제한하거나 중지시킬 수 있습니다.\n" + "</p>\n" + "<p>\n" + "    1. 회원이 회사 서비스의 운영을 고의 또는 중과실로 방해하는 경우\n" + "</p>\n" + "<p>\n" + "    2. 서비스용 설비 점검, 보수 또는 공사로 인하여 부득이한 경우\n" + "</p>\n" + "<p>\n" + "    3. 전기통신사업법에 규정된 기간통신사업자가 전기통신 서비스를 중지했을 경우\n" + "</p>\n" + "<p>\n" + "    4. 국가비상사태, 서비스 설비의 장애 또는 서비스 이용의 폭주 등으로 서비스 이용에 지장이 있는 때\n" + "</p>\n" + "<p>\n" + "    5. 기타 중대한 사유로 인하여 회사가 서비스 제공을 지속하는 것이 부적당하다고 인정하는 경우\n" + "</p>\n" + "<p>\n" + "    ②회사는 전항의 규정에 의하여 서비스의 이용을 제한하거나 중지한 때에는 그 사유 및 제한기간 등을 회원에게 알려야 합니다.\n" + "</p>\n" + "<p>\n" + "    제 8 조 (개인위치정보의 이용 또는 제공)\n" + "</p>\n" + "<p>\n" + "    ①회사는 개인위치정보를 이용하여 서비스를 제공하고자 하는 경우에는 미리 이용약관에 명시한 후 개인위치정보주체의 동의를 얻어야 합니다.\n" + "</p>\n" + "<p>\n" + "    ②회원 및 법정대리인의 권리와 그 행사방법은 제소 당시의 이용자의 주소에 의하며, 주소가 없는 경우에는 거소를 관할하는 지방법원의\n" + "    전속관할로 합니다. 다만, 제소 당시 이용자의 주소 또는 거소가 분명하지 않거나 외국 거주자의 경우에는 민사소송법상의 관할법원에\n" + "    제기합니다.\n" + "</p>\n" + "<p>\n" + "    ③회사는 타사업자 또는 이용 고객과의 요금정산 및 민원처리를 위해 위치정보 이용·제공·사실 확인자료를 자동 기록·보존하며, 해당 자료는\n" + "    6개월 이상 보관합니다.\n" + "</p>\n" + "<p>\n" + "    ④회사는 회원이 동의한 범위를 넘어 개인위치정보를 회원이 지정하는 제3자에게 제공하는 경우에는 개인위치정보를 수집한 당해 통신\n" + "    단말장치로 매회 회원에게 제공받는 자, 제공일시 및 제공목적을 즉시 통보합니다. 단, 아래 각 호의 1에 해당하는 경우에는 회원이 미리\n" + "    특정하여 지정한 통신 단말장치 또는 전자우편주소로 통보합니다.\n" + "</p>\n" + "<p>\n" + "    1. 개인위치정보를 수집한 당해 통신단말장치가 문자, 음성 또는 영상의 수신기능을 갖추지 아니한 경우\n" + "</p>\n" + "<p>\n" + "    2. 개인위치정보주체가 개인위치정보를 수집한 해당 통신단말장치 외의 통신단말장치 또는 전자우편주소 등으로 통보할 것을 미리 요청한 경우\n" + "</p>\n" + "<p>\n" + "    제 9 조 (개인위치정보주체의 권리)\n" + "</p>\n" + "<p>\n" + "    ①회원은 회사에 대하여 언제든지 개인위치정보를 이용한 위치기반서비스 제공 및 개인위치정보의 제3자 제공에 대한 동의의 전부 또는 일부를\n" + "    철회할 수 있습니다. 이 경우 회사는 수집한 개인위치정보 및 위치정보 이용, 제공사실 확인자료를 파기합니다.\n" + "</p>\n" + "<p>\n" + "    ②회원은 회사에 대하여 언제든지 개인위치정보의 수집, 이용 또는 제공의 일시적인 중지를 요구할 수 있으며, 회사는 이를 거절할 수 없고\n" + "    이를 위한 기술적 수단을 갖추고 있습니다.\n" + "</p>\n" + "<p>\n" + "    ③회원은 회사에 대하여 아래 각 호의 자료에 대한 열람 또는 고지를 요구할 수 있고, 당해 자료에 오류가 있는 경우에는 그 정정을\n" + "    요구할 수 있습니다. 이 경우 회사는 정당한 사유 없이 회원의 요구를 거절할 수 없습니다.\n" + "</p>\n" + "<p>\n" + "    1. 본인에 대한 위치정보 수집, 이용, 제공사실 확인자료\n" + "</p>\n" + "<p>\n" + "    2. 본인의 개인위치정보가 위치정보의 보호 및 이용 등에 관한 법률 또는 다른 법률 규정에 의하여 제3자에게 제공된 이유 및 내용\n" + "</p>\n" + "<p>\n" + "    ④회원은 제1항 내지 제3항의 권리행사를 위해 회사의 소정의 절차를 통해 요구할 수 있습니다.\n" + "</p>\n" + "<p>\n" + "    제 10 조 (법정대리인의 권리)\n" + "</p>\n" + "<p>\n" + "    ①회사는 14세 미만의 회원에 대해서는 개인위치정보를 이용한 위치기반서비스 제공 및 개인위치정보의 제3자 제공에 대한 동의를 당해\n" + "    회원과 당해 회원의 법정대리인으로부터 동의를 받아야 합니다. 이 경우 법정대리인은 제9조에 의한 회원의 권리를 모두 가집니다.\n" + "</p>\n" + "<p>\n" + "    ②회사는 14세 미만의 아동의 개인위치정보 또는 위치정보 이용․제공사실 확인자료를 이용약관에 명시 또는 고지한 범위를 넘어 이용하거나\n" + "    제3자에게 제공하고자 하는 경우에는 14세미만의 아동과 그 법정대리인의 동의를 받아야 합니다. 단, 아래의 경우는 제외합니다.\n" + "</p>\n" + "<p>\n" + "    1. 위치정보 및 위치기반서비스 제공에 따른 요금정산을 위하여 위치정보 이용, 제공사실 확인자료가 필요한 경우\n" + "</p>\n" + "<p>\n" + "    2. 통계작성, 학술연구 또는 시장조사를 위하여 특정 개인을 알아볼 수 없는 형태로 가공하여 제공하는 경우\n" + "</p>\n" + "<p>\n" + "    제 11 조 (8세 이하의 아동 등의 보호의무자의 권리)\n" + "</p>\n" + "<p>\n" + "    ①회사는 아래의 경우에 해당하는 자(이하 “8세 이하의 아동”등이라 한다)의 보호의무자가 8세 이하의 아동 등의 생명 또는 신체보호를\n" + "    위하여 개인위치정보의 이용 또는 제공에 동의하는 경우에는 본인의 동의가 있는 것으로 봅니다.\n" + "</p>\n" + "<p>\n" + "    1. 8세 이하의 아동\n" + "</p>\n" + "<p>\n" + "    2. 금치산자\n" + "</p>\n" + "<p>\n" + "    3. 장애인복지법제2조제2항제2호의 규정에 의한 정신적 장애를 가진 자로서 장애인고용촉진및직업재활법 제2조제2호의 규정에 의한\n" + "    중증장애인에 해당하는 자(장애인복지법 제32조의 규정에 의하여 장애인등록을 한 자에 한한다)\n" + "</p>\n" + "<p>\n" + "    ②8세 이하의 아동 등의 생명 또는 신체의 보호를 위하여 개인위치정보의 이용 또는 제공에 동의를 하고자 하는 보호의무자는 서면동의서에\n" + "    보호의무자임을 증명하는 서면을 첨부하여 회사에 제출하여야 합니다.\n" + "</p>\n" + "<p>\n" + "    ③보호의무자는 8세 이하의 아동 등의 개인위치정보 이용 또는 제공에 동의하는 경우 개인위치정보주체 권리의 전부를 행사할 수 있습니다.\n" + "</p>\n" + "<p>\n" + "    제 12 조 (위치정보관리책임자의 지정)\n" + "</p>\n" + "<p>\n" + "    ①회사는 위치정보를 적절히 관리·보호하고 개인위치정보주체의 불만을 원활히 처리할 수 있도록 실질적인 책임을 질 수 있는 지위에 있는\n" + "    자를 위치정보관리책임자로 지정해 운영합니다.\n" + "</p>\n" + "<p>\n" + "    ②위치정보관리책임자는 위치기반서비스를 제공하는 부서의 부서장으로서 구체적인 사항은 본 약관의 부칙에 따릅니다.\n" + "</p>\n" + "<p>\n" + "    제 13 조 (손해배상)\n" + "</p>\n" + "<p>\n" + "    ①회사가 위치정보의 보호 및 이용 등에 관한 법률 제15조 내지 제26조의 규정을 위반한 행위로 회원에게 손해가 발생한 경우 회원은\n" + "    회사에 대하여 손해배상 청구를 할 수 있습니다. 이 경우 회사는 고의, 과실이 없음을 입증하지 못하는 경우 책임을 면할 수 없습니다.\n" + "</p>\n" + "<p>\n" + "    ②회원이 본 약관의 규정을 위반하여 회사에 손해가 발생한 경우 회사는 회원에 대하여 손해배상을 청구할 수 있습니다. 이 경우 회원은\n" + "    고의, 과실이 없음을 입증하지 못하는 경우 책임을 면할 수 없습니다.\n" + "</p>\n" + "<p>\n" + "    제 14 조 (면책)\n" + "</p>\n" + "<p>\n" + "    ①회사는 다음 각 호의 경우로 서비스를 제공할 수 없는 경우 이로 인하여 회원에게 발생한 손해에 대해서는 책임을 부담하지 않습니다.\n" + "</p>\n" + "<p>\n" + "    1. 천재지변 또는 이에 준하는 불가항력의 상태가 있는 경우\n" + "</p>\n" + "<p>\n" + "    2. 서비스 제공을 위하여 회사와 서비스 제휴계약을 체결한 제3자의 고의적인 서비스 방해가 있는 경우\n" + "</p>\n" + "<p>\n" + "    3. 회원의 귀책사유로 서비스 이용에 장애가 있는 경우\n" + "</p>\n" + "<p>\n" + "    4. 제1호 내지 제3호를 제외한 기타 회사의 고의∙과실이 없는 사유로 인한 경우\n" + "</p>\n" + "<p>\n" + "    ②회사는 서비스 및 서비스에 게재된 정보, 자료, 사실의 신뢰도, 정확성 등에 대해서는 보증을 하지 않으며 이로 인해 발생한 회원의\n" + "    손해에 대하여는 책임을 부담하지 아니합니다.\n" + "</p>\n" + "<p>\n" + "    제 15 조 (규정의 준용)\n" + "</p>\n" + "<p>\n" + "    ①본 약관은 대한민국법령에 의하여 규정되고 이행됩니다.\n" + "</p>\n" + "<p>\n" + "    ②본 약관에 규정되지 않은 사항에 대해서는 관련법령 및 상관습에 의합니다.\n" + "</p>\n" + "<p>\n" + "    제 16 조 (분쟁의 조정 및 기타)\n" + "</p>\n" + "<p>\n" + "    ①회사는 위치정보와 관련된 분쟁에 대해 당사자간 협의가 이루어지지 아니하거나 협의를 할 수 없는 경우에는 위치정보의 보호 및 이용 등에\n" + "    관한 법률 제28조 규정에 의한 방송통신위원회에 재정을 신청할 수 있습니다.\n" + "</p>\n" + "<p>\n" + "    ②회사 또는 고객은 위치정보와 관련된 분쟁에 대해 당사자간 협의가 이루어지지 아니하거나 협의를 할 수 없는 경우에는 개인정보보호법\n" + "    제40조의 규정에 의한 개인정보분쟁조정위원회에 조정을 신청할 수 있습니다.\n" + "</p>\n" + "<p>\n" + "    제 17 조 (회사의 연락처) 회사의 상호 및 주소 등은 다음과 같습니다.\n" + "</p>\n" + "<p>\n" + "    1. 상 호 : 엔에이치엔엔터테인먼트 주식회사\n" + "</p>\n" + "<p>\n" + "    2. 대 표 자 : 정 우 진\n" + "</p>\n" + "<p>\n" + "    3. 주 소 : 경기도 성남시 분당구 삼평동 629 플레이뮤지엄\n" + "</p>\n" + "<p>\n" + "    4. 대표전화 : 1544-6859\n" + "</p>\n" + "<p>\n" + "    부 칙\n" + "</p>\n" + "<p>\n" + "    제1조 (시행일) 이 약관은 2016년 6월 22일부터 시행한다.\n" + "</p>\n" + "<p>\n" + "    제2조 위치정보관리책임자는 2013년 8월을 기준으로 다음과 같이 지정합니다.\n" + "</p>\n" + "<p>\n" + "    1. 소 속 : 법무정책그룹\n" + "</p>\n" + "<p>\n" + "    2. 직 위 : 그룹장\n" + "</p>\n" + "<p>\n" + "    3. 성 명: 김현성\n" + "</p>\n" + "<p>\n" + "    4. 연락처 : 1544-6859\n" + "</p>\n"
  };
  window.document.title = "위치기반 서비스 이용약관";
  $scope.$on("$destroy", function () {
    window.document.title = "TOASTCAM BIZ";
  });
}]);
"use strict";

(function () {
  var getLang = navigator.language || navigator.userLanguage;
  if (getLang.indexOf("-") > 0) {
    getLang = getLang.split("-")[0];
  }
  if (navigator.userAgent.indexOf("Googlebot") != -1 || navigator.userAgent.indexOf("GoogleBot") != -1 || navigator.userAgent.indexOf("googlebot") != -1) {
    getLang = "en";
  } else if (location.pathname && (location.pathname.indexOf("/ja/") != -1 || location.pathname.indexOf("/jp/") != -1)) {
    getLang = "ja";
  } else {
    if (getLang !== "ko" && getLang !== "ja") {
      getLang = "ko";
    }
  }
  var i18nScript = document.createElement("script");
  var scriptSrc = "/resources/vendor/angular-i18n/angular-locale_" + getLang.toLowerCase() + ".js";
  i18nScript.setAttribute("src", scriptSrc);
  document.head.appendChild(i18nScript);
  document.documentElement.setAttribute("lang", getLang);
})();
"use strict";

app.controller('DemoAccessCtrl', ['$scope', '$state', function ($scope, $state) {
  $scope.imageIndex = 10;
  $scope.accessDate = Date.now();
  $scope.moveDemoShopsPage = function () {
    $state.go('main.demoShops', {});
  };
  var datePicker = new Pikaday({
    field: document.getElementById('accessDate'),
    bound: false,
    container: document.getElementById('datePickerContainer'),
    minDate: moment().add(-10, 'd').toDate(),
    maxDate: new Date(),
    defaultDate: new Date(),
    onSelect: function onSelect(date) {
      $scope.$apply(function () {
        $scope.accessDate = date;
        var diffDay = moment().diff(date, 'day');
        selectDate(10 - diffDay);
      });
      this.hide();
    }
  });
  datePicker.hide();

  /**
   * date picker open
   */
  $scope.toggleDatePicker = function (event) {
    event.stopPropagation();
    if (datePicker.isVisible()) {
      datePicker.hide();
    } else {
      datePicker.show();
    }
  };
  var selectDate = function selectDate(index) {
    $scope.imageIndex = index;
  };
  $scope.changeDate = function (num) {
    var index = $scope.imageIndex + num;
    if (index > 9) {
      $scope.imageIndex = 10;
      $scope.accessDate = Date.now();
    } else {
      $scope.accessDate = moment($scope.accessDate).add(num, 'd').toDate();
      index = $scope.imageIndex + num;
      $scope.imageIndex = index;
    }
  };
  $scope.showDemoDownLoadAlertLayer = function () {
    $scope.isShowDemoDownLoadAlertLayer = true;
  };
  $scope.closeDemoDownLoadAlertLayer = function () {
    $scope.isShowDemoDownLoadAlertLayer = false;
  };
  $scope.showDemoAccessSettingLayer = function () {
    $scope.isShowDemoAccessSettingLayer = true;
  };
  $scope.closeDemoAccessSettingLayer = function () {
    $scope.isShowDemoAccessSettingLayer = false;
  };
  $scope.showDemoAccessAlramLayer = function () {
    $scope.isShowDemoAccessAlramLayer = true;
  };
  $scope.closeDemoAccessAlramLayer = function () {
    $scope.isShowDemoAccessAlramLayer = false;
  };
}]);
"use strict";

app.controller("DemoListCtrl", ["$scope", "Demos", "User", "$state", "Utils", function ($scope, Demos, User, $state, Utils) {
  showPage2();
  $scope.templates = [{
    name: "top_menu.html",
    url: "/templates/common/_top.html"
  }, {
    name: "cameras.html",
    url: "/templates/dem/_demo_cameras.html"
  }, {
    name: "bottom.html",
    url: "/templates/common/_bottom.html"
  }];
  $scope.getContextPath = Utils.getContextPath();
  $scope.clickedTopMenu = function () {
    $scope.isTopMenuLayer = !$scope.isTopMenuLayer;
    menuOpen($scope.isTopMenuLayer);
  };
  $scope.clickedUserMenu = function () {
    $scope.isUserMenuLayer = !$scope.isUserMenuLayer;
    openUserMenu($scope.isUserMenuLayer);
  };
  document.getElementById("wrap").addEventListener("click", function (e) {
    $scope.isUserMenuLayer = false;
    document.getElementById("topUserMenu").classList.remove("clicked");
  });
  $scope.viewPageTop = function () {
    setTimeout(function () {
      var trident = navigator.userAgent.match(/Trident\/(\d)/i);
      if (trident != null) {
        document.documentElement.scrollTop = 0;
      } else {
        $("body").scrollTop(0);
      }
    }, 500);
  };
  $scope.viewPageTop();
  $scope.getDemoCameraList = function () {
    Demos.getDemoList(function (data) {
      for (var i = 0; i < data.length; i++) {
        var camera = data[i];
        //	camera.thumbnailURL = thumbnailURL(camera);
        data[i].thumbnailPath = location.protocol + "//" + data[i].thumbnailPath;
        if (camera.id == "BD00BE") {
          data[i].content = "<strong>피트니스 센터</strong>";
          data[i].content += "<span>이 곳은 실제로 토스트캠을 만들어가는 사람들이 운동하고 있는 휘트니스 센터입니다.<br>";
          data[i].content += "스트레스 해소와 재충전의 공간이지만, 많은 사람들이 함께하기 때문에 언제 어떤 일이 생길지 모르는 법이죠. <br>마음 높고 운동할 수 있도록, 토스트캠이 지켜보고 있습니다.</span>";
        }
        if (camera.id == "BD001A") {
          data[i].content = "<strong>목동</strong>";
          data[i].content += "<span>서울의 서쪽 주거단지인 목동의 1층 아파트 가정집입니다.<br>";
          data[i].content += "아파트라도 1층에 사는 사람들은 보안에 대한 걱정이 많죠. <br>";
          data[i].content += "미관을 해치는 철창을 설치하기도 난감하고, 보안업체를 이용하자니 큰 비용이 부담스럽습니다. <br>";
          data[i].content += "바로 이럴 때 토스트 캠이 필요합니다. 창 밖을 비추며 움직임이 발생할 때마다  알림을 보내주고, 언제 어디서든 스마트폰과 PC를 통해 확인할 수 있는 토스트캠이면,적은 비용으로도 안심입니다.</span>";
        }
        if (camera.id == "BD004F") {
          data[i].content = "<strong>홍대 리믹스랩</strong>";
          data[i].content += "<span>이제는 다양한 국적의 젊은이들이 함께하는 홍대, 그 중에서도 가장 핫플레이스인삼거리에 위치한 바입니다. <br>";
          data[i].content += "보드카 담금주를 필두로 알려지지 않은 다양한 술을 연구, 개발하여 판매하고 있는  일명 비주류 주류연구소 “리믹스 랩”이라는 곳인데요. 훈남 사장님과 상남자 매니저가 함께하는 이곳에서도 보안은 늘 걱정이었습니다.<br>";
          data[i].content += "이제 토스트캠이 리믹스랩을 든든하게 지켜보고 있으니, 오늘 밤 방문하셔서 안심하고 새로운 주류를 마음껏 경험해보시는 건 어떨까요?</span>";
        }
        if (camera.id == "BD00AF") {
          data[i].content = "<strong>NHN 앞마당</strong>";
          data[i].content += "<span>토스트캠의 플랫폼과 클라우드 서비스가 개발되고 있는 NHN 플레이뮤지엄에서 밖을 바라본 전경입니다.<br>";
          data[i].content += "사용자들이 만족할만한 서비스를 만들기 위한 NHN의 노력은 오늘도 계속됩니다.</span>";
        }
        if (camera.id == "BD006C") {
          data[i].content = "<strong>한국뉴욕주립대학교</strong>";
          data[i].content += "<span>한국뉴욕주립대학교는 2013년 3월 송도 글로벌 대학 캠퍼스에 첫 번째로 개교한, 학부와 석박사를 모두 갖춘 국내 최초의 외국대학교입니다. <br>";
          data[i].content += "평화로운 교정을 토스트캠이 비추고 있습니다.</span>";
        }
        if (camera.id == "fn_C0019C1466560095695") {
          data[i].content = "<strong>거제도 아라솔펜션</strong>";
          data[i].content += "<span>아라솔펜션은 거제의 푸른 상록수림을 자랑하는 윤돌섬과 해금강을 한 눈에 볼 수 있는 펜션입니다. <br>";
          data[i].content += "토스트캠을 통해 아름다운 거제의 풍경을 감상하세요.</span>";
        }
        if (camera.id == "fn_C001BF1463636411206") {
          data[i].content = "<strong>동해 소노하임펜션</strong>";
          data[i].content += "<span>소노하임펜션에서는 관동팔경 중 하나인 청간정과 청간해변, 아야진 항구 등 동해의 명소를 한 눈에 볼 수 있습니다. <br>";
          data[i].content += "토스트캠으로 동해의 아름다운 풍경을 감상하세요.</span>";
        }
      }
      $scope.cameras = data;
      setTimeout(function () {
        for (var i = 0; i < data.length; i++) {
          $("#demo_content" + i).append(data[i].content);
        }
      }, 200);
    });
  };
  $scope.goDetail = function (id) {
    $state.go("main.cameraDemoDetail", {
      cameraId: id
    });
  };
  $scope.getDemoCameraList();
  $scope.logout = function () {
    User.logout(function (data) {
      logoutSuccess();
    });
  };
}]);
"use strict";

app.controller('DemoGatewayCtrl', ['$scope', '$location', 'Demos', '$q', '$translate', '$state', function ($scope, $location, Demos, $q, $translate, $state) {
  getDemoCamList();
  function getDemoCamList() {
    Demos.getGatewayDemoList(function (res) {
      for (var i = 0; i < res.length; i++) {
        res[i].thumbnailPath = location.protocol + "//" + res[i].thumbnailPath;
      }
      $scope.camList = res;
    }, function (err) {
      showAlert($translate.instant('ACCESS_NET_FAIL'), $translate.instant('ACCESS_NET_FAIL_DESC'));
    });
  }
  $scope.$on('$destroy', function () {
    if (window.gatewayDemoState && window.gatewayDemoState.from === 'main') {
      window.gatewayDemoState.state = 'out';
    }
  });

  /**
   * Demo 카메라 상세 페이지로 이동
   * @param  {String} cameraId
   * @param  {String} recorderType
   */
  $scope.goDemoDetail = function (cameraId) {
    $state.go('main.cameraDemoDetail', {
      cameraId: cameraId,
      type: 'gateway'
    });
  };
  $scope.movePageBack = function () {
    window.mainScrollToGateway = true;
    $state.go('main');
  };
  var showAlert = function showAlert(title, message) {
    $(".display_show").css("display", "");
    $scope.showAlert = true;
    $scope.alertTitle = title;
    $scope.alertMessage = message;
  };
  $scope.hideAlert = function () {
    $scope.showAlert = false;
  };
}]);
"use strict";

app.controller('DemoShopCtrl', ['$scope', '$location', 'Demos', '$q', '$translate', '$state', function ($scope, $location, Demos, $q, $translate, $state) {
  (function () {
    initDemoShopCtrl();
  })();

  /**
   * Demo 매장 초기 함수
   */
  function initDemoShopCtrl() {
    if ($("html").attr("lang") === "ja") {
      $scope.isShowBtn = false;
    } else {
      $scope.isShowBtn = true;
    }
    getDemoShopList();
  }

  /**
   * Demo 매장 목록
   * @return {Array} $scope.shopList
   */
  function getDemoShopList() {
    Demos.getDemoList(function (res) {
      for (var i = 0; i < res.length; i++) {
        res[i].thumbnailPath = location.protocol + "//" + res[i].thumbnailPath;
      }
      $scope.shopList = res;
    }, function (err) {
      showAlert($translate.instant('ACCESS_NET_FAIL'), $translate.instant('ACCESS_NET_FAIL_DESC'));
    });
  }

  /**
   * Demo 카메라 상세 페이지로 이동
   * @param  {String} cameraId
   * @param  {String} recorderType
   */
  $scope.goDemoDetail = function (cameraId) {
    $state.go('main.cameraDemoDetail', {
      cameraId: cameraId
    });
  };
  $scope.moveDemoAccessPage = function () {
    $state.go('main.demoAccess', {});
  };
  $scope.showDemoShareSettingLayer = function () {
    $scope.isShowDemoShareSettingLayer = true;
  };
  $scope.closeDemoShareSettingLayer = function () {
    $scope.isShowDemoShareSettingLayer = false;
  };
  $scope.showDemoShopSettingLayer = function () {
    $scope.isShowDemoShopSettingLayer = true;
  };
  $scope.closeDemoShopSettingLayer = function () {
    $scope.isShowDemoShopSettingLayer = false;
  };
  var showAlert = function showAlert(title, message) {
    $(".display_show").css("display", "");
    $scope.showAlert = true;
    $scope.alertTitle = title;
    $scope.alertMessage = message;
  };
  $scope.hideAlert = function () {
    $scope.showAlert = false;
  };
}]);
"use strict";

var nowWitdh = 0;
var dragFlag = false;
var dragEndStatus = false;
var dragX = 0;
var draging = 0;
var dragTimeLine = false;
var timelineClick = false;
var timelineColor = ["#18b57b", "#ff7900", "#3ea1d4", "#a4c800", "#efd600", "#767dff", "#ca7af0", "#ff76bd", "#929292", "#ff1e00"]; //초록,주황,파랑,연두,노랑,진한보라,보라,핑크,회색

var thumnailViewFlag = false;
var dragThumCancle = false;
var timelineDrawFlag = true;
var dblClickFlag = false;
var dblClickTime = 0;
var dblClicklive = false;
var demoTimeline = function demoTimeline(width, height, timeRange, $q, $translate) {
  var that = this;
  this.width = width;
  this.height = height;
  this.timeRange = timeRange;
  this.eventData = [];
  this.cvrData = [];
  this.forceDomain = true;
  this.isLoading = false;
  this.$q = $q;
  this.$translate = $translate;
  var currentSvg = d3.select(".timebar .timebar_area svg");
  if (currentSvg !== undefined) {
    currentSvg.remove();
  }
  this.svg = d3.select(".timebar .timebar_area").append("svg").attr("width", width).attr("height", height).attr("class", "no-select");
  this.mainContainer = this.svg.append("g").attr({
    transform: "translate(0, -19)"
  });
  var cvrBgDrag = d3.behavior.drag().on("dragstart", function () {
    changeTimeRangeFlag = true;
    dragThumCancle = true;
    thumnailDraw = false;
  }).on("drag", function () {
    if (timelineDrawFlag == false) {
      return;
    }
    beforeSgid = "";
    $("#time_info_tri").hide();
    $("#showThumbnailListNew").hide();
    removeWidthStop = true;
    draging++;

    //if(draging % 2 == 0){

    dragFlag = true;
    var x = 0;
    if (navigator.userAgent.indexOf("MSIE") !== -1 || navigator.appVersion.indexOf("Trident/") > 0) {
      x = d3.event.dx; // *2.22;
    } else {
      x = d3.event.dx; // *1.91;
    }
    dragX += x;
    if (dragX > 1224) {
      return;
    } else if (dragX < -1225) {
      return;
    }
    that.updateCursor(that.delegate.currentTime);
    $(".motion").attr("transform", "translate(" + dragX + ", 0)");
    $(".audios").attr("transform", "translate(" + dragX + ", 0)");
    $(".cvr").attr("transform", "translate(" + dragX + ", 0)");
    $(".axis").attr("transform", "translate(" + dragX + ", 75)");
    $(".cursor").attr("transform", "translate(" + dragX + ", 0)");
    $(".cvrBG").attr("x", dragX * -1);
    $(".cvrBG2").attr("x", dragX * -1);
    //}
  }).on("dragend", function () {
    //	timelineDrawFlag = false;
    beforeSgid = "";
    if (dragX < -10) {} else if (dragX > 10) {} else {
      dragFlag = false;
    }
    setTimeout(function () {
      dragFlag = false;
      if (timelineClick == false) {
        that.delegate.lineMoveFlag = true;
        dragTimeLine = true;
        dragEndStatus = true;
        that.dragDomain();
        $(".axis").attr("transform", "translate(0, 75)");
        $(".cvr").attr("transform", "translate(0, 0)");
        $(".cursor").attr("transform", "translate(0, 0)");
        $(".cvrBG").attr("x", "0");
        $(".cvrBG2").attr("x", "0");
      }
      timelineClick = false;
    }, 150);
    setTimeout(function () {
      changeTimeRangeFlag = false;
      timelineDrawFlag = true;
    }, 1410);
    dragThumCancle = false;
  });
  this.motionEvents = this.mainContainer.append("g").attr("class", "motions");
  this.audioEvents = this.mainContainer.append("g").attr("class", "audios");
  this.scaleEvents = this.mainContainer.append("g").attr("class", "scales");
  this.mainContainer.append("g").append("rect").attr({
    x: 0,
    y: 25,
    width: this.width,
    height: 48,
    "class": "cvrBG"
  }).call(cvrBgDrag);
  this.mainContainer.append("g").append("rect").attr({
    x: 0,
    y: 70,
    width: this.width,
    height: 48,
    "class": "cvrBG2"
  }).call(cvrBgDrag);
  this.cvrs = this.mainContainer.append("g").attr("class", "cvr");
  this.isDblZooming = false;
  this.previousDblClickTime = 0;
  this.currentDomain = timeRange.currentDomain;
  this.svg.on("dblclick", function () {
    dblClickFlag = true;
    var now = new Date();
    $("#showThumbnailListNew").hide();
    $("#time_info_tri").hide();
    if (now.getTime() - that.previousDblClickTime < 500) return;
    that.previousDblClickTime = now.getTime();
    if (that.isLoading) return;
    var cursorTime = that.delegate.currentTime.getTime();
    if (cursorTime <= that.currentDomain[0] || cursorTime >= that.currentDomain[1]) {
      return;
    }
    var timeRanges = [10, 60, 360, 1440];
    var current = timeRanges.indexOf(that.timeRange);
    if (current === 0) {
      that.isDblZooming = true;
    } else if (current === 3) {
      that.isDblZooming = false;
    }
    var newTimeRange;
    if (that.isDblZooming) {
      newTimeRange = timeRanges[current + 1];
    } else {
      newTimeRange = timeRanges[current - 1];
    }
    that.dblZoomDomain(cursorTime, newTimeRange);
  });
};
demoTimeline.prototype.setBoundDateFormat = function (format) {
  this.boundDateFormat = format;
};
demoTimeline.prototype.setTimezone = function (timezone) {
  if (timezone !== undefined && timezone !== "") {
    var tokens = timezone.split(",");
    this.tz = tokens[2];
  }
};
demoTimeline.bufferDomain = function (minutes) {
  var buffer = 0;
  switch (minutes) {
    case 5:
      buffer = 30000;
      break;
    case 60:
      buffer = 5 * 60 * 1000;
      break;
    case 360:
      buffer = 30 * 60 * 1000;
      break;
    case 1440:
      buffer = 90 * 60 * 1000;
      break;
    default:
      break;
  }
  return buffer;
};
demoTimeline.removeBufferDomain = function (domain, timeRange) {
  var buffer = demoTimeline.bufferDomain(timeRange);
  var originStart = domain[0] + buffer;
  var originEnd = domain[1] - buffer;
  return [originStart, originEnd];
};
demoTimeline.bufferCursorCheckDomain = function (minutes) {
  var buffer = 0;
  switch (minutes) {
    case 5:
      buffer = 5 * 60 * 1000;
      break;
    case 10:
      buffer = 10 * 60 * 1000;
      break;
    case 60:
      buffer = 60 * 60 * 1000 + 150000;
      break;
    case 360:
      buffer = 60 * 60 * 1000 * 6 + 650000;
      break;
    case 1440:
      buffer = 60 * 60 * 1000 * 24 + 650000;
      break;
    default:
      break;
  }
  return buffer;
};
demoTimeline.removeBufferCursorCheckDomain = function (domain, timeRange) {
  var buffer = demoTimeline.bufferCursorCheckDomain(timeRange);
  var originStart = domain[0] + buffer;
  var originEnd = domain[1] - buffer;
  return [originStart, originEnd];
};
demoTimeline.dateDomain = function (minutes, ratio) {
  var now = Date.now();
  if (ratio === undefined) {
    ratio = 0.8;
  }
  var ms = minutes * 60 * 1000;
  var start = now - parseInt(ms * ratio);
  var end = now + parseInt(ms * (1 - ratio));
  return demoTimeline.bufferedDomain([start, end], minutes);
};
demoTimeline.bufferedDomain = function (domain, minutes) {
  var ticks = {
    1: 0.2,
    5: 1,
    10: 2,
    60: 10,
    360: 60,
    1440: 180
  };
  var ms = ticks[minutes] * 60 * 1000;
  var buffer = demoTimeline.bufferDomain(minutes);
  var newStart = Math.ceil(domain[0] / ms) * ms - buffer;
  var newEnd = Math.ceil(domain[1] / ms) * ms + buffer;
  return [newStart, newEnd];
};
demoTimeline.prototype.zoomDomain = function (time, timeRange) {
  thumnailViewFlag = false;
  this.timeRange = timeRange;
  if (this.delegate !== undefined) {
    this.delegate.timeRange = timeRange;
  }
  var range = 1000 * 60 * timeRange;
  var diff = timeRange / 2 * 60 * 1000;
  var start = time - diff - diff * 0.8;
  var end = time + diff - diff * 0.8;
  return this.changeDomain(demoTimeline.bufferedDomain([start - range, end + range], timeRange), 500, time);
};
demoTimeline.prototype.dblZoomDomain = function (time, timeRange) {
  this.timeRange = timeRange;
  if (this.delegate !== undefined) {
    this.delegate.timeRange = timeRange;
  }
  var range = 1000 * 60 * timeRange;
  var diff = timeRange / 2 * 60 * 1000;
  var start = time - diff - diff * 0.8;
  var end = time + diff - diff * 0.8;
  var newDomain = demoTimeline.bufferedDomain([start - range, end + range], timeRange);
  while (time < newDomain[0] || time > newDomain[1]) {
    var ms = timeRange * 60 * 1000;
    if (time < newDomain[0]) {
      newDomain = [newDomain[0] + ms, newDomain[1] + ms];
    }
    if (time > newDomain[1]) {
      newDomain = [newDomain[0] - ms, newDomain[1] - ms];
    }
  }
  if (dblClicklive == false) {
    this.delegate.clickedCVRArea(new Date(dblClickTime));
  } else {
    this.delegate.goLive();
  }
  return this.changeDomain(newDomain);
};
demoTimeline.prototype.moveDomain = function (ratio) {
  var diff = parseInt((this.currentDomain[1] - this.currentDomain[0]) * ratio);
  var start = this.currentDomain[0] + diff;
  var end = this.currentDomain[1] + diff;
  return this.changeDomain([start, end]);
};
demoTimeline.prototype.dragDrawDomain = function (value) {
  dragThumCancle = false;
  var diff = 10000 * value;
  var newDomain = [this.currentDomain[0] - diff, this.currentDomain[1] - diff];
  return this.changeDomain(newDomain);
};
demoTimeline.prototype.prevDomain = function () {
  dragThumCancle = false;
  var diff = this.timeRange * 60 * 1000;
  var newDomain = [this.currentDomain[0] - diff, this.currentDomain[1] - diff];
  return this.changeDomain(newDomain);
};
demoTimeline.prototype.nextDomain = function () {
  dragThumCancle = false;
  var diff = this.timeRange * 60 * 1000;
  var newDomain = [this.currentDomain[0] + diff, this.currentDomain[1] + diff];
  return this.changeDomain(newDomain);
};
demoTimeline.prototype.dragDomain = function () {
  var diff = this.timeRange * 60 * 1000;
  var newDomain = [this.currentDomain[0] + diff, this.currentDomain[1] + diff];
  dragX = 0;
  var range = 0;
  var timelineFix = 0;
  switch (this.timeRange) {
    case 10:
      range = 1800000;
      break;
    case 60:
      range = 11400000;
      timelineFix = 200000;
      break;
    case 360:
      range = 68400000;
      timelineFix = 1200000;
      break;
    case 1440:
      range = 270000000;
      timelineFix = 3600000;
      break;
  }
  var startDo = this.x.invert(parseInt($(".cvrBG").attr("x"))).getTime() - this.timeRange * 60 * 1000 - timelineFix;
  var endDo = startDo + range;
  var newDomain = [startDo, endDo];
  return this.changeDragDomain(newDomain);
};
demoTimeline.prototype.setTimeRange = function (minutes, callback) {
  this.timeRange = parseInt(minutes);
  var x = this.svg.select(".cursor").select("line").attr("x1");
  var cursorTime = this.x.invert(x).getTime();
  return this.zoomDomain(cursorTime, minutes);
};
demoTimeline.prototype.domainCenterTime = function () {
  if (this.currentDomain !== undefined) {
    return (this.currentDomain[0] + this.currentDomain[1]) / 2 + (this.currentDomain[1] - this.currentDomain[0]) / 8;
  }
  return undefined;
};
demoTimeline.prototype.setTimeRangeAtDateString = function (dateString, timeRange) {
  this.timeRange = 1440;
  var format = d3.time.format("%Y%m%d%H%M%S");
  var startDate = format.parse(dateString + "000000");
  var endDate = format.parse(dateString + "240000");
  var range = 1000 * 60 * timeRange;
  var startTime = startDate.getTime();
  var endTime = endDate.getTime();
  var newDomain = demoTimeline.bufferedDomain([startTime - range, endTime + range], this.timeRange);
  return this.changeDomain(newDomain);
};
demoTimeline.prototype.changeDomain = function (domain, duration, time) {
  var $q = this.$q;
  var that = this;
  var deferred = $q.defer();
  this.svg.select(".cursor").classed("hide", true);
  this.currentDomain = domain;
  this.removedBufferDomain = demoTimeline.removeBufferDomain(this.currentDomain, this.timeRange);
  setTimeout(function () {
    if (that.delegate !== undefined && that.delegate.setupDomain !== undefined) {
      that.delegate.setupDomain(that.currentDomain);
    }
  }, 1000);
  var extent;
  if (this.brush !== undefined) {
    extent = this.brush.extent();
  }
  this.x.domain(domain);
  if (this.brush !== undefined && extent !== undefined) {
    this.brush.extent(extent);
    this.brush(d3.select(".brush").transition().duration(500));
  }
  if (duration === undefined) {
    duration = 500;
  }
  if (this.cursorTime >= this.removedBufferDomain[0] && this.cursorTime <= this.removedBufferDomain[1]) {
    this.forceDomain = true;
  } else {
    this.forceDomain = false;
  }
  this.nowAnimating = true;
  this.updateAxis(duration);
  this.updateBar(duration);
  this.updateEvents(duration);
  setTimeout(function () {}, 500);
  this.nowAnimating = false;
  deferred.resolve();
  switch (this.timeRange) {
    case 10:
      range = 600000;
      fixRange = 0;
      break;
    case 60:
      range = 600000 * 6;
      fixRange = 0;
      break;
    case 360:
      range = 600000 * 6 * 6;
      fixRange = 1055000;
      break;
    case 1440:
      range = 600000 * 6 * 6 * 4;
      fixRange = 3120000;
      break;
  }
  if (domain[0] + range <= this.delegate.currentTime.valueOf() && domain[1] - range >= this.delegate.currentTime.valueOf()) {
    if (this.delegate.isPlaying == false) {
      $(".cursor").hide();
      this.svg.select(".cursor").classed("hide", false);
      $(".cursor").fadeIn(500);
    }
  }
  if (clickDateChange == true) {
    clickDateChange = false;
    setTimeout(function () {
      $(".motions").empty();
      $(".audios").empty();
      $(".motions").fadeIn(200);
    }, 280);
  }
  return deferred.promise;
};
demoTimeline.prototype.changeDragDomain = function (domain, duration, time) {
  var $q = this.$q;
  var that = this;
  var deferred = $q.defer();
  this.svg.select(".cursor").classed("hide", true);
  this.currentDomain = domain;
  this.removedBufferDomain = demoTimeline.removeBufferDomain(this.currentDomain, this.timeRange);
  if (this.delegate !== undefined && this.delegate.setupDomain !== undefined) {
    this.delegate.setupDomain(this.currentDomain);
  }
  var extent;
  if (this.brush !== undefined) {
    extent = this.brush.extent();
  }
  this.x.domain(domain);
  if (this.brush !== undefined && extent !== undefined) {
    this.brush.extent(extent);
  }
  if (duration === undefined) {
    duration = 500;
  }
  if (this.cursorTime >= this.removedBufferDomain[0] && this.cursorTime <= this.removedBufferDomain[1]) {
    this.forceDomain = true;
  } else {
    this.forceDomain = false;
  }
  this.nowAnimating = true;
  this.updateAxis(-100, "drag");
  this.updateBar(0);
  this.nowAnimating = false;
  if ($(".cursor").attr("class").indexOf("hide") != -1) {
    that.updateCursor(that.delegate.currentTime);
    this.svg.select(".cursor").classed("hide", false);
  }
  return deferred.promise;
};
demoTimeline.prototype.realAddTimeLine = function (duration, events, time) {
  this.updateBar(duration);
  if (events != undefined) {
    var that = this;
    var $q = this.$q;
    var deferred = $q.defer();
    if (duration === undefined) {
      duration = 0;
    }
    var sortMap = new Map();
    for (var i = events.length - 1; i >= 0; i--) {
      if (events[i].detectType == "audio") {
        return;
      }
      var drawX = 0;
      var drawWidth = 0;
      if (time.startTime >= events[i].startTime) {
        drawX = that.x(time.startTime);
        drawWidth = that.x(events[i].endTime) - that.x(time.startTime);
      }
      if (time.startTime < events[i].startTime) {
        drawX = that.x(events[i].startTime);
        drawWidth = that.x(events[i].endTime) - that.x(events[i].startTime);
      }
      d3.select(".motions").append("rect").transition().duration(duration).attr("class", "tempClass").attr("width", drawWidth).attr("x", drawX).attr("i", events[i].index).attr("y", 27).attr("height", 36).style("fill", events[i].color);
      sortMap.put(i, drawWidth);
    }
  }
};
demoTimeline.prototype.addEventData = function (message) {
  this.eventData.push(message);
  return this.drawEvents();
};
demoTimeline.prototype.addCvrData = function (message) {
  this.cvrData.push(message);
  return this.drawRecordBar();
};
demoTimeline.prototype.draw = function () {
  this.drawAxis();
  this.drawCursor();
  this.drawEvents();
};
demoTimeline.prototype.redrawWithWidth = function (width) {
  if (width == 0) {
    width = nowWitdh;
  }
  this.width = width;
  this.svg.attr({
    width: width
  });
  if (this.axisContainer != undefined) {
    this.axisContainer.remove();
    this.axisContainer = undefined;
    this.drawAxis(this.currentDomain);
    this.cursor.moveToFront();
    this.updateBar(0);
    nowWitdh = width;
  }
};
demoTimeline.prototype.getBigTicks = function () {
  var getBrowserLanguage = function getBrowserLanguage() {
    var langMap = {
      en: "en_US",
      ko: "ko_KR",
      ja: "ja_JP"
    };
    var htmlLang = $("html").attr("lang");
    return langMap[htmlLang] || "en_US";
  };
  var todayWord = this.$translate.instant("EVENT_LIST_DATE_TODAY");
  var that = this;
  var tick = d3.svg.axis().scale(this.x).orient("bottom").tickSize(11, 0).tickPadding(3).tickFormat(function (d, i) {
    var md;
    var formatString = "";
    if (that.tz !== undefined) {
      md = moment(d).tz(that.tz).locale(getBrowserLanguage());
    } else {
      md = moment(d).locale(getBrowserLanguage());
    }
    var dateFormat = that.boundDateFormat;
    if (dateFormat === undefined) {
      dateFormat = "M월 D일 HH:mm";
    }
    var lastItemSets = {
      5: 5,
      10: 30,
      60: 18,
      360: 18,
      1440: 24
    };
    var lastItemIndex = lastItemSets[that.timeRange];
    if (that.timeRange == 10) {
      if (i === 11 || i === 19) {
        var date = new Date();
        var todayCheck = md.year() + "" + md.month() + md.date();
        var todayFlag = date.getFullYear() + "" + date.getMonth() + date.getDate();
        if (todayCheck == todayFlag) {
          return todayWord + " " + md.format("HH:mm");
        } else {
          return md.format(dateFormat);
        }
      }
    } else if (that.timeRange == 60) {
      if (i === 6 || i === 12) {
        var date = new Date();
        var todayCheck = md.year() + "" + md.month() + md.date();
        var todayFlag = date.getFullYear() + "" + date.getMonth() + date.getDate();
        if (todayCheck == todayFlag) {
          return todayWord + " " + md.format("HH:mm");
        } else {
          return md.format(dateFormat);
        }
      }
    } else if (that.timeRange == 360) {
      if (i === 6 || i === 12) {
        var date = new Date();
        var todayCheck = md.year() + "" + md.month() + md.date();
        var todayFlag = date.getFullYear() + "" + date.getMonth() + date.getDate();
        if (todayCheck == todayFlag) {
          return todayWord + " " + md.format("HH:mm");
        } else {
          return md.format(dateFormat);
        }
      }
    } else if (that.timeRange == 1440) {
      if (i === 9 || i === 15) {
        var date = new Date();
        var todayCheck = md.year() + "" + md.month() + md.date();
        var todayFlag = date.getFullYear() + "" + date.getMonth() + date.getDate();
        if (todayCheck == todayFlag) {
          return todayWord + " " + md.format("HH:mm");
        } else {
          return md.format(dateFormat);
        }
      }
    }
    if (i === 0 || i === lastItemIndex) {
      if (i === 1 || i === lastItemIndex - 1) {
        var date = new Date();
        var todayCheck = md.year() + "" + md.month() + md.date();
        var todayFlag = date.getFullYear() + "" + date.getMonth() + date.getDate();
        if (todayCheck == todayFlag) {
          return todayWord + " " + md.format("HH:mm");
        } else {
          return md.format(dateFormat);
        }
      }
    }
    if (that.timeRange > 60) {
      formatString += "HH";
    } else {
      formatString += "HH:mm";
    }
    return md.format(formatString);
  });
  switch (this.timeRange) {
    case 5:
      tick.ticks(d3.time.minutes, 1);
      break;
    case 10:
      tick.ticks(d3.time.minutes, 1);
      break;
    case 60:
      tick.ticks(d3.time.minutes, 10);
      break;
    case 360:
      tick.ticks(d3.time.hours, 1);
      break;
    case 1440:
      tick.ticks(d3.time.hours, 3);
      break;
  }
  return tick;
};
demoTimeline.prototype.getTicks = function () {
  var tick = d3.svg.axis().scale(this.x).orient("bottom").tickSize(10, 0);
  switch (this.timeRange) {
    case 5:
      tick.ticks(d3.time.seconds, 15);
      break;
    case 10:
      tick.ticks(d3.time.seconds, 30);
      break;
    case 60:
      tick.ticks(d3.time.minutes, 5);
      break;
    case 360:
      tick.ticks(d3.time.minutes, 30);
      break;
    case 1440:
      tick.ticks(d3.time.hours, 1);
      break;
  }
  return tick;
};
demoTimeline.prototype.getSmallTicks = function () {
  var tick = d3.svg.axis().scale(this.x).orient("bottom").tickSize(5, 0);
  switch (this.timeRange) {
    case 5:
      tick.ticks(d3.time.seconds, 5);
      break;
    case 10:
      tick.ticks(d3.time.seconds, 5);
      break;
    case 60:
      tick.ticks(d3.time.minutes, 1);
      break;
    case 360:
      tick.ticks(d3.time.minutes, 5);
      break;
    case 1440:
      tick.ticks(d3.time.minutes, 20);
      break;
  }
  return tick;
};
demoTimeline.prototype.getNextDateTicks = function () {
  var tick = d3.svg.axis().scale(this.x).orient("top").tickSize(10, 0).tickFormat(d3.time.format("%m월 %d일"));
  tick.ticks(d3.time.hours, 24);
  return tick;
};
demoTimeline.prototype.drawAxis = function (domain) {
  if (domain === undefined) {
    this.currentDomain = demoTimeline.dateDomain(this.timeRange);
    this.currentDomain[0] = this.currentDomain[0] - 1000 * 60 * 60;
    this.currentDomain[1] = this.currentDomain[1] + 1000 * 60 * 60;
  }
  this.removedBufferDomain = demoTimeline.removeBufferDomain(this.currentDomain, this.timeRange);
  if (this.delegate !== undefined && this.delegate.setupDomain !== undefined) {
    this.delegate.setupDomain(this.currentDomain);
  }
  this.x = d3.time.scale().domain(this.currentDomain).range([-this.width, this.width * 2]);
  if (this.axisContainer === undefined) {
    this.axisContainer = this.mainContainer.append("g").attr("transform", "translate(0, 75)").attr("class", "axis");
  }
  var bigTickAxis = this.axisContainer.append("g").attr("class", "big-tick-axis").call(this.getBigTicks());
  var tickAxis = this.axisContainer.append("g").attr("class", "tick-axis").call(this.getTicks());
  var smallTickAxis = this.axisContainer.append("g").attr("class", "small-tick-axis").call(this.getSmallTicks());
  var cvrBG = this.svg.select(".cvrBG").attr("width", this.width).attr("height", "50px");
  var cvrBG2 = this.svg.select(".cvrBG2").attr("width", this.width).attr("height", "50px").attr("z-index", "999");
  var that = this;
  cvrBG.on("click", function () {
    if (dragFlag == false) {
      dblClicklive = that.delegate.isLive;
      dblClickTime = that.delegate.currentTime.valueOf();
      thumnailDraw = true;
      that.delegate.lineMoveFlag = false;
      dragThumCancle = false;
      timelineClick = true;
      if (new Date().getTime() - that.previousDblClickTime < 500) return; // animating caused by dbl click.
      var mouseLocation = d3.mouse(this);
      var selectedTime = that.x.invert(mouseLocation[0]);
      that.forceDomain = true;
      that.updateCursor(selectedTime);
      if (that.delegate != undefined && typeof that.delegate.clickedCVRArea === "function") {
        that.delegate.clickedCVRArea(selectedTime);
      }
      if (that.delegate.currentTime.getTime() - Date.now() >= 0) {
        // 미래를 선택한 경우
        that.delegate.goLive();
        return;
      }
    }
  }).on("mousemove", function () {
    var mouseLocation = d3.mouse(this);
    var selectedTime = that.x.invert(mouseLocation[0]);
    if (that.delegate != undefined && typeof that.delegate.cvrMouseoverEventsNew === "function") {
      that.delegate.cvrMouseoverEventsNew(mouseLocation[0], selectedTime);
    }
  }).on("mouseout", function () {
    if (that.delegate != undefined && typeof that.delegate.mouseoutEvents === "function") {
      that.delegate.mouseoutEvents();
    }
  });
  cvrBG2.on("mousemove", function () {
    $("#time_info_tri").hide();
    $("#showThumbnailListNew").hide();
  });
};
demoTimeline.prototype.drawCursor = function () {
  var that = this;
  var drag = d3.behavior.drag().on("dragstart", function () {
    if (that.delegate !== undefined && that.delegate.cursorDragStart !== undefined) {
      that.delegate.cursorDragStart();
    }
  }).on("drag", function () {
    var x = d3.event.x;
    that.cursor.selectAll("line").attr({
      x1: x,
      x2: x
    });
    that.cursor.selectAll("cursor").attr({
      x1: x,
      x2: x
    });
    that.cursor.selectAll("circle").attr({
      cx: x
    });
    if (that.delegate !== undefined && that.delegate.cursorDragging !== undefined) {
      var time = that.x.invert(x);
      that.delegate.cursorDragging(time);
    }
  }).on("dragend", function () {
    if (that.delegate !== undefined && that.delegate.cursorDragEnd !== undefined) {
      dragThumCancle = false;
      that.delegate.cursorDragEnd();
    }
  });
  this.cursor = this.mainContainer.append("g").attr("class", "cursor").call(drag);
  var currentX = this.x(Date.now());
  this.cursor.append("line").attr({
    "class": "main",
    x1: currentX,
    x2: currentX,
    y1: 29,
    y2: 74
  });
  this.cursor.append("circle").attr({
    "class": "circle",
    cx: currentX,
    cy: 29,
    r: 5,
    fill: "white"
  });
  $(".circle").attr("stroke", "red");
  $(".circle").attr("stroke-width", "2");
};
var updateCursorState = false;
demoTimeline.prototype.updateCursor = function (time) {
  var deferred = this.$q.defer();
  var now = Date.now();
  if (time !== undefined) {
    now = time.valueOf();
  }
  this.cursorTime = now;
  this.svg.select(".cursor").classed("hide", this.nowAnimationg);
  if (typeof this.x === "function") {
    var currentX = parseInt(this.x(now));
    this.svg.select(".cursor").selectAll("circle").attr({
      cx: currentX
    });
    this.svg.select(".cursor").selectAll("line").attr({
      x1: currentX,
      x2: currentX
    });
    var curosEmptyData = 0;
    deferred.resolve();
    if (this.delegate.timeRange == 60) {
      curosEmptyData = 200000;
    } else if (this.delegate.timeRange == 360) {
      curosEmptyData = 1200000;
    } else if (this.delegate.timeRange == 1440) {
      curosEmptyData = 4800000;
    }
    if (now > this.removedBufferDomain[1] + curosEmptyData) {
      // 커서가 타임라인 우측에 도착했을때
      if (this.forceDomain === true) {
        return this.nextDomain();
      }
      this.svg.select(".cursor").classed("hide", true);
    } else if (now < this.removedBufferDomain[0] - curosEmptyData) {
      // 커서가 타임라인 좌측에 도착했을때
      if (this.forceDomain === true) {
        return this.prevDomain();
      }
      this.svg.select(".cursor").classed("hide", true);
    } else {
      if (this.delagate !== undefined && this.delegate.hideCursorNavigation !== undefined) {
        this.delegate.hideCursorNavigation();
      }
    }
  }
  return deferred.promise;
};
var removeWidth0 = true;
var removeWidth = 0;
var removeWidthStop = true;
demoTimeline.prototype.removeWidthZero = function () {
  removeWidth = setInterval(function () {
    if (removeWidth0 == true && removeWidthStop == false) {
      removeWidth0 = false;
      for (var i = 0; i < $(".cvr").children("rect").length; i++) {
        if (parseInt($(".cvr").children("rect").eq(i).attr("width")) == 0) {
          $(".cvr").children("rect").eq(i).remove();
        }
      }
      for (var i = 0; i < $(".motions").children("rect").length; i++) {
        if (parseInt($(".motions").children("rect").eq(i).attr("width")) == 0) {
          $(".motions").children("rect").eq(i).remove();
        }
      }
      removeWidth0 = true;
    }
  }, 2000);
};
demoTimeline.prototype.drawRecordBar = function () {
  var that = this;
  if (changeTimeRangeClick == true) {
    $(".cvr").empty();
  }
  if (this.cvrData != undefined) {
    var bars = this.cvrs.selectAll(".record-bar").data(this.cvrData).enter().append("rect").attr({
      "class": "record-bar",
      x: function x(d) {
        if (that.x(d.startTime).toString == "NaN") {}
        var thatX = that.x(d.startTime);
        return thatX;
      },
      y: 70,
      width: function width(d) {
        thatEnd = that.x(d.endTime);
        thatStart = that.x(d.startTime);
        var thatWidth = that.x(d.endTime) - that.x(d.startTime);
        if (thatWidth < 0) {
          thatWidth = 0;
        }
        return thatWidth;
      },
      height: 5
    });
  }
};
var zoneId = 0;
var timelineSgidMap = new Map();
var showThumbnail = new Map();
demoTimeline.prototype.drawEvents = function () {
  var that = this;
  var filteredData = [];
  var t = 0;
  zoneId = 0;
  timelineMap = new Map();
  timelineSgidMap = new Map();
  timelineSgidWidthMap = new Map();
  this.eventData.filter(function (d) {
    if (parseInt(d.endTime) <= parseInt(Date.now())) {
      var zons = d.zoneIdxs.split(",");
      timelineSgidMap.put("zone" + zoneId, d.sgid);
      var idx = 0;
      var timelineZoneUid = 0;
      var zoneIdx = 0;
      for (var i = zons.length - 1; i >= 0; i--) {
        var obj = {};
        obj.detectType = "motion";
        obj.id = d.id;
        obj.startTime = d.startTime;
        if (parseInt(d.endTime) == 0) {
          d.endTime = Date.now().toString();
          obj.sgid = "1";
        } else {
          obj.endTime = d.endTime;
          obj.sgid = d.sgid;
        }
        timelineZoneUid = parseInt(zons[i]);
        if (timelineZoneUid.toString() == "NaN") {
          timelineZoneUid = 8;
        }
        if (timelineZoneUid < 0) {
          zoneIdx = 8;
        } else if (timelineZoneUid == 0) zoneIdx = 0;else {
          zoneIdx = timeLineMap.get(timelineZoneUid);
        }
        obj.color = timelineColor[zoneIdx];
        obj.index = zons[i];
        obj.idx = "zone" + zoneId + " num" + zoneIdx + " idx" + i;
        var thatXCheck = that.x(d.startTime);
        var thatWidthCheck = that.x(d.endTime) - that.x(d.startTime);
        if (fullscreenFlag == true) {
          if (thatWidthCheck >= 0) {
            filteredData.push(obj);
          }
        } else {
          if (thatWidthCheck >= 0) {
            filteredData.push(obj);
          }
        }
      }
      zoneId++;
    }
  });
  var motions = this.motionEvents.selectAll(".event-bar").data(filteredData.filter(function (d) {
    return d.endTime !== undefined;
  })).enter().append("rect").attr({
    "class": function _class(d) {
      return ["event-bar", d.detectType, d.idx].join(" ");
    },
    x: function x(d) {
      if (that.x(d.startTime).toString == "NaN") {}
      return that.x(d.startTime);
    },
    y: 40,
    i: function i(d) {
      return d.index;
    },
    fill: function fill(d) {
      if (d.color == null || d.color == "null") {
        return "#929292";
      }
      return d.color;
    },
    width: function width(d) {
      var thatX = that.x(d.startTime);
      var thatWidth = that.x(d.endTime) - that.x(d.startTime);
      timelineSgidWidthMap.put([thatX, thatX + thatWidth], d.sgid);
      return thatWidth;
    },
    height: 28
  });
  var audios = this.audioEvents.selectAll(".event-bar").data(filteredData.filter(function (d) {
    return d.detectType === "audio";
  })).enter().append("rect").attr({
    "class": function _class(d) {
      return "event-bar audio";
    },
    x: function x(d) {
      if (that.x(d.startTime).toString == "NaN") {}
      if (that.x(d.startTime) < 40) {
        return 40;
      }
      return that.x(d.startTime);
    },
    y: 27,
    i: function i(d) {
      return d.index;
    },
    fill: function fill(d) {
      if (d.color == null || d.color == "null") {
        return "#929292";
      }
      return d.color;
    },
    width: function width(d) {
      var thatX = that.x(d.startTime);
      var thatWidth = that.x(d.endTime) - that.x(d.startTime);
      timelineSgidWidthMap.put([thatX, thatX + thatWidth], d.sgid);
      return thatWidth;
    },
    height: 36
  });
  var scales = this.motionEvents.selectAll(".event-bar").data(filteredData.filter(function (d) {
    return d.detectType === "scale";
  })).enter().append("rect").attr({
    "class": function _class(d) {
      return "event-bar " + d.detectType;
    },
    x: function x(d) {
      if (that.x(d.startTime).toString == "NaN") {}
      if (d.count < that.scaleAvg * 0.5) {
        return that.x(d.startTime) + 3;
      } else if (d.count < that.scaleAvg * 0.9) {
        return that.x(d.startTime) + 2.5;
      } else if (d.count >= that.scaleAvg * 0.9 && d.count <= this.scaleAvg * 1.1) {
        return that.x(d.startTime) + 2;
      } else if (d.count > that.scaleAvg * 1.5) {
        return that.x(d.startTime) + 1;
      } else {
        return that.x(d.startTime) + 1.5;
      }
    },
    y: 27,
    width: function width(d) {
      if (d.count < that.scaleAvg * 0.5) {
        return that.x(d.endTime) - that.x(d.startTime) - 6;
      } else if (d.count < that.scaleAvg * 0.9) {
        return that.x(d.endTime) - that.x(d.startTime) - 5;
      } else if (d.count >= that.scaleAvg * 0.9 && d.count <= this.scaleAvg * 1.1) {
        return that.x(d.endTime) - that.x(d.startTime) - 4;
      } else if (d.count > that.scaleAvg * 1.5) {
        return that.x(d.endTime) - that.x(d.startTime) - 2;
      } else {
        return that.x(d.endTime) - that.x(d.startTime) - 3;
      }
    },
    height: 38
  });
  var eventMouseover = function eventMouseover(d) {
    if (that.delegate != undefined && typeof that.delegate.cvrMouseoverEventsNew === "function") {
      that.delegate.cvrMouseoverEventsNew(d, this);
    }
  };
  var eventMouseout = function eventMouseout(d) {
    if (that.delegate != undefined && typeof that.delegate.mouseoutEvents === "function") {
      that.delegate.mouseoutEvents();
    }
  };
  var imageDraw = function imageDraw(d) {};
  var eventClick = function eventClick(d) {
    if (new Date().getTime() - that.previousDblClickTime < 500) return; // animating caused by dbl click.

    var selectedTime = new Date(parseInt(d.startTime));
    that.forceDomain = true;
    if (that.delegate != undefined && typeof that.delegate.clickedCVRArea === "function") {
      that.delegate.clickedCVRArea(selectedTime);
    }
    that.updateCursor(selectedTime);
  };
};
demoTimeline.prototype.updateEvents = function (duration) {
  var that = this;
  var $q = this.$q;
  var deferred = $q.defer();
  if (duration === undefined) {
    duration = 500;
  }
  duration = duration * 2;
  var filteredData = this.eventData.filter(function (d) {
    var checkData = checkFilters.get(d.index);
    if (checkData != undefined) {
      return d.startTime > that.removedBufferDomain[0] && d.endTime < that.removedBufferDomain[1];
    }
  });
  this.svg.selectAll(".event-bar").transition().duration(duration).attr({
    x: function x(d) {
      if (that.x(d.startTime).toString == "NaN") {}
      return that.x(d.startTime);
    },
    y: 40,
    i: function i(d) {
      return d.index;
    },
    fill: function fill(d) {
      if (d.color == null || d.color == "null") {
        return "#929292";
      }
      return d.color;
    },
    width: function width(d) {
      var thatX = that.x(d.startTime);
      var thatWidth = that.x(d.endTime) - that.x(d.startTime);
      timelineSgidWidthMap.put([thatX, thatX + thatWidth], d.sgid);
      return thatWidth;
    },
    height: 28
  }).each("end", function () {
    deferred.resolve();
  });
  return deferred.promise;
};
var recheck = 0;
demoTimeline.prototype.redrawEvents = function (events, avg) {
  if (changeTimeRangeClick == true) {
    var that = this;
    this.scaleAvg = avg;
    this.eventData = events;
    setTimeout(function () {
      $(".motions").empty();
      $(".audios").empty();
      $(".motions").fadeIn(200);
      that.drawEvents();
      changeTimeRangeClick = false;
      thumnailViewFlag = true;
      removeWidthStop = false;
    }, 180);
  } else {
    this.scaleAvg = avg;
    this.eventData = events;
    $(".motions").empty();
    $(".audios").empty();
    this.drawEvents();
    removeWidthStop = false;
    changeTimeRangeClick = false;
    setTimeout(function () {
      $(".motions").fadeIn(200);
    }, 180);
  }
};
demoTimeline.prototype.emptyData = function () {
  this.motionEvents.selectAll("rect").remove();
  this.audioEvents.selectAll("rect").remove();
  this.scaleEvents.selectAll("rect").remove();
  this.cvrs.selectAll(".record-bar").remove();
};
demoTimeline.prototype.updateAxis = function (duration, flag) {
  var $q = this.$q;
  var that = this;
  var deferred = $q.defer();
  if (duration === undefined) {
    duration = 500;
  }
  if (flag == "drag") {
    var bigTickPromise = $q(function (resolve, reject) {
      that.svg.select(".big-tick-axis").transition().duration(duration).call(that.getBigTicks());
    });
    var tickPromise = $q(function (resolve, reject) {
      that.svg.select(".tick-axis").transition().duration(duration).call(that.getTicks()).each("end", function () {
        resolve();
      });
    });
    var smallTickPromise = $q(function (resolve, reject) {
      that.svg.select(".small-tick-axis").transition().duration(duration).call(that.getSmallTicks());
    });
    $q.all([bigTickPromise, tickPromise, smallTickPromise]).then(function () {
      deferred.resolve();
    });
    if (dragEndStatus == true) {
      setTimeout(function () {
        dragThumCancle = false;
      }, 380);
      dragEndStatus = false;
    } else {
      $(".motions").fadeOut(150);
      $(".motions").empty();
      $(".audios").empty();
      setTimeout(function () {
        $(".motions").fadeIn(200);
      }, 380);
      $("#timebar_area").hide();
      setTimeout(function () {
        $("#timebar_area").show();
      }, 90);
    }
    return deferred.promise;
  } else {
    var bigTickPromise = $q(function (resolve, reject) {
      that.svg.select(".big-tick-axis").transition().duration(duration).call(that.getBigTicks());
    });
    var tickPromise = $q(function (resolve, reject) {
      that.svg.select(".tick-axis").transition().duration(duration).call(that.getTicks()).each("end", function () {
        resolve();
      });
    });
    var smallTickPromise = $q(function (resolve, reject) {
      that.svg.select(".small-tick-axis").transition().duration(duration).call(that.getSmallTicks()).each("end", function () {
        resolve();
      });
    });
    $q.all([bigTickPromise, tickPromise, smallTickPromise]).then(function () {
      deferred.resolve();
    });
    return deferred.promise;
  }
};
demoTimeline.prototype.updateBar = function (duration) {
  var that = this;
  var $q = this.$q;
  var deferred = $q.defer();
  if (duration === undefined) {
    duration = 0;
  }
  this.svg.selectAll(".record-bar").transition().duration(duration).attr({
    x: function x(d) {
      if (that.x(d.startTime).toString == "NaN") {}
      var thatX = that.x(d.startTime);
      return thatX;
    },
    width: function width(d) {
      thatEnd = that.x(d.endTime);
      thatStart = that.x(d.startTime);
      thatWidth = thatEnd - thatStart;
      if (thatWidth < 0) {
        thatWidth = 0;
      }
      return thatWidth;
    }
  }).each("end", function () {
    deferred.resolve();
  });
  return deferred.promise;
};
demoTimeline.prototype.resetAxis = function () {
  this.svg.select(".axis").selectAll("g").remove();
  this.drawAxis();
};
demoTimeline.prototype.startBrush = function () {
  var that = this;
  var brushed = function brushed() {};
  var brushend = function brushend() {};
  this.brush = d3.svg.brush().x(this.x).on("brush", brushed);
  var now = Date.now();
  this.brush.extent([now - 100000, now]);
  this.mainContainer.append("g").attr("class", "brush").call(this.brush).selectAll("rect").attr("y", 25).attr("height", 50);
};
demoTimeline.prototype.hideCursor = function () {
  this.svg.select(".cursor").classed("hide", true);
};
demoTimeline.prototype.showCursor = function () {
  this.svg.select(".cursor").classed("hide", false);
};
"use strict";

app.controller("DemoViewCtrl", ["$scope", "$stateParams", "$state", "$interval", "Demos", "$translate", "$timeout", "$q", "Utils", function ($scope, $stateParams, $state, $interval, Demos, $translate, $timeout, $q, Utils) {
  showPage();
  $(".camdtl_wrap").css("padding-right", "0px");
  var playerObj = null;
  var playControl = null;
  var tempIndexCheck = 0;
  var timelineHideTimer;
  var controlHideTimeout = null;
  $scope.setPlayControlShow = function () {
    $scope.isShowPlayControl = true;
    if (controlHideTimeout) {
      $timeout.cancel(controlHideTimeout);
    }
    controlHideTimeout = $timeout(function () {
      if ($(".dimmed:visible").length || $(".v_modal_dialog").length || $scope.isFullScreen && $("#controlNdTimeLine").is(":hover") || !$scope.isFullScreen && $(".cam_ctrl").is(":hover")) {
        $scope.setPlayControlShow();
      } else {
        $scope.isShowPlayControl = false;
      }
    }, 4000);
  };
  $scope.setPlayControlHide = function () {
    if (Utils.isIE()) {
      return;
    }
    if ($(".dimmed:visible").length || $(".v_modal_dialog").length || $scope.isFullScreen && ($("#controlNdTimeLine").is(":hover") || ($(".thum_full_area").length ? $(".thum_full_area").is(":hover") : false) || $("#play_indicator").is(":hover")) || !$scope.isFullScreen && ($(".cam_ctrl").is(":hover") || $("#play_indicator").is(":hover"))) {
      return;
    } else {
      if (controlHideTimeout) {
        $timeout.cancel(controlHideTimeout);
      }
      $scope.isShowPlayControl = false;
    }
  };
  setTimeout(function () {
    $(".cam_ctrl").hover(function () {
      $scope.setPlayControlShow();
      $scope.$apply();
    }, function () {
      $scope.setPlayControlHide();
      $scope.$apply();
    });
    $(".cam_label").hover(function () {}, function () {
      $scope.setPlayControlHide();
      $scope.$apply();
    });
  }, 100);
  $scope.showSelectColor = false;
  $scope.camera = {
    id: $stateParams.cameraId
  };
  var showAlert = function showAlert(title, message) {
    $scope.showAlert = true;
    $scope.alertTitle = title;
    $scope.alertMessage = message;
  };
  $scope.hideAlert = function () {
    $scope.showAlert = false;
  };
  $scope.isExpiredCloud = function () {
    return Utils.isCloudExpired($scope.currentCamera);
  };

  // $interval cancel
  $scope.$on("$destroy", function () {
    if (playerObj) {
      playerObj.destroy();
      playerObj = null;
    }
    if (controlHideTimeout) {
      $timeout.cancel(controlHideTimeout);
      controlHideTimeout = null;
    }
    $interval.cancel($scope.reloadTimer); // CVR Fetch
    $interval.cancel($scope.timer); // Cursor 시간
    $interval.cancel($scope.eventThumbTimer); // 타임라인 마우스 오버시 나타나는 썸네일 반복
    $interval.cancel($scope.eventlistTimer); // 이벤트 목록 썸네일 반복
  });
  function playerEventHandler(event, data) {
    switch (event) {
      case "resizeTimline":
        if ($scope.zonearea !== undefined) {
          $scope.zonearea.setCanvasSize($("#player").width(), $("#player").height(), $scope.zones, $scope.selectedZones);
        }
        break;
      case "isShowMikeChanged":
        $scope.isShowMike = data;
        break;
      case "shareEnd":
        $scope.shareEnd();
        break;
      case "clickedCVRArea":
        //$scope.goEventListWithSelectedTime(data);
        break;
      case "getAlarmZones":
        if (getAlarmZones) {
          getAlarmZones().then(function () {
            if (playControl) {
              playControl.timeline.getTimeline();
            }
          });
        }
        break;
      case "loadingAlert":
        showAlert($translate.instant("DATA_LOADING_SUBJECT"), $translate.instant("DATA_LOADING_CONTENT"));
        break;
      case "fullScreenAlertChanged":
        $scope.fullScreenAlert = data;
        break;
      case "isFullScreenChanged":
        $scope.isAddShowGalleryClass = false;
        $scope.isFullScreen = data;
        $scope.$apply();
        break;
      case "timelineVisibleChanged":
        $scope.timelineVisible = data;
        break;
      case "noPrevEvent":
        showAlert($translate.instant("CAMERA_EVENT_MOVE"), $translate.instant("CAMERA_NO_PREV_EVENT"));
        break;
      case "noNextEvent":
        showAlert($translate.instant("CAMERA_EVENT_MOVE"), $translate.instant("CAMERA_NO_NEXT_EVENT"));
        break;
      case "eventsChanged":
        $scope.events = data;
        break;
      case "timelineHideTimerStop":
        $timeout.cancel(timelineHideTimer);
        break;
      case "loadingDataAlert":
        //$scope.loadingDataAlert();
        break;
      case "timeInputError":
        if (data === "time") {
          showAlert($translate.instant("CAMERA_INPUT_ERROR"), $translate.instant("CAMERA_ENTER_TIME"));
        } else if (data === "minute") {
          showAlert($translate.instant("CAMERA_INPUT_ERROR"), $translate.instant("CAMERA_ENTER_MINUTE"));
        } else if (data === "second") {
          showAlert($translate.instant("CAMERA_INPUT_ERROR"), $translate.instant("CAMERA_ENTER_SECOND"));
        }
        break;
      case "isIncorrectPlayPasswordChanged":
        $scope.isIncorrectPlayPassword = data;
        $scope.$apply();
        break;
      case "zoomDragValChanged":
        zoomDragVal = data;
        break;
      case "indicatorHoverIn":
        $scope.setPlayControlShow();
        $scope.$apply();
        break;
      case "indicatorHoverOut":
        $scope.setPlayControlHide();
        $scope.$apply();
        break;
    }
  }
  $scope.viewPageTop = function () {
    setTimeout(function () {
      var trident = navigator.userAgent.match(/Trident\/(\d)/i);
      if (trident != null) {
        document.documentElement.scrollTop = 50;
      } else {
        $("body").scrollTop(50);
      }
    }, 500);
  };
  $scope.viewPageTop();
  $scope.plyBtnStatus = true;
  $scope.pauseBtn = function () {
    playControl.playInfoBar.pauseBtn();
    $scope.isPlaying = playControl.getData("isPlaying");
  };
  $scope.livePlayStart = function () {
    if ($scope.config.streamStatus != "off") {
      playControl.player.play();
    }
  };
  var userIdLoading = 0;
  $scope.cameraUpagradeAlert = false;
  $scope.eventListDate = [];

  //$scope.cameras = Camera.query();
  var loadCurrentCamera = function loadCurrentCamera() {
    var deferred = $q.defer();
    $scope.currentCamera = Demos.get({
      id: $stateParams.cameraId
    }, function () {
      $("#timelinedesc").fadeOut(4000);
      if ($scope.currentCamera.code == "nok") {
        $scope.isNoCamera = true;
        deferred.reject();
        return;
      }
      $scope.selectedZones = [];
      $scope.selectedAllZones = [];
      $scope.zones = [];
      deferred.resolve();
    });
    return deferred.promise;
  };
  loadCurrentCamera();
  var getAlarmZones = function getAlarmZones() {
    var deferred = $q.defer();
    Demos.zones({
      id: $scope.currentCamera.id
    }, function (res) {
      $scope.eventZones = res.eventZones;
      $scope.motionZones = res.zones;
      if (playerObj) {
        playerObj.setData("eventZones", $scope.eventZones);
        playerObj.setData("motionZones", $scope.motionZones);
      }
      deferred.resolve();
    }, function (err) {
      deferred.reject();
    });
    return deferred.promise;
  };
  $scope.eventSources = [];
  $scope.compareTime = function (time) {
    if ($scope.timelineDataLastDate < time) {
      $scope.timelineDataLastDate = time;
    }
  };
  $scope.setupDomain = function (domain) {
    $scope.timeline.setupDomain(domain);
  };
  $scope.hideCursorNavigation = function () {
    $scope.isCursorLeft = false;
    $scope.isCursorRight = false;
  };
  $scope.currentTime = new Date();
  $scope.reloadTimer = $interval(function () {
    if ($scope.timeline.currentDomain == undefined) {
      return;
    }
    if ($scope.timeline.currentDomain[1] > Date.now()) {
      $scope.setupDomain([$scope.timeline.currentDomain[0], $scope.timeline.currentDomain[1]]);
    }
  }, 10000);
  $scope.formattedInternalDate = function (date) {
    var md;
    if ($scope.timeline.tz !== undefined) {
      md = moment(new Date(date)).tz($scope.timeline.tz);
    } else {
      md = moment(new Date(date));
    }
    return md.format("YYYYMMDD");
  };
  $scope.selectCamera = function (id) {
    $state.go("main.cameraDetail", {
      cameraId: id
    });
  };
  $scope.goCameraList = function () {
    $state.go("main.cameras");
  };
  $scope.toogleCameraSetting = function () {};
  $scope.stopTimer = function () {
    playControl.playTimer.stopTimer();
  };
  $scope.startLiveTimer = function () {
    playControl.playTimer.startLiveTimer(playControl.timeline);
  };
  $scope.clickedCVRArea = function (time, status) {
    playControl.timeline.clickedCVRArea(time, status);
  };
  $scope.goCvr = function (time, status) {
    $scope.timeline.requestPlay(time, status);
  };
  $scope.isTurnOffCamera = function () {
    return Utils.isTurnOffCamera($scope.currentCamera);
  };
  $scope.pressedUseMikeButton = function () {
    showAlert($translate.instant("CLICK_MIKE_ALERT_SUBEJCT"), $translate.instant("CLICK_MIKE_ALERT_CONTENT"));
  };
  var isFullScreen = function isFullScreen() {
    return document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement;
  };
  $scope.isFullScreen = false;
  var isFullscreenActiveArea = function isFullscreenActiveArea() {
    var x = d3.event.pageX;
    var y = d3.event.pageY;
    if (x <= 50 || y >= screen.height - 110) {
      return true;
    }
    return false;
  };
  d3.select("#player").on("mousemove", function () {
    if ($scope.isFullScreen) {
      if (isFullscreenActiveArea()) {
        if (playControl) {
          playControl.fullscreenBtn.stopFullscreenTimer();
        }
        $scope.timelineVisible = true;
      } else {
        if ($scope.timelineVisible && playControl) {
          playControl.fullscreenBtn.startFullscreenTimer();
        }
      }
    }
  });
  $scope.loadCameraSetting = function (callback) {
    //$scope.config.tzCode = 268;
    //$scope.timeline.setTimezone("268,아시아/서울,Asia/Seoul,+09:00");
    if (typeof callback === "function") {
      callback();
    }
  };
  $scope.loadCameraSetting(function () {
    loadCurrentCamera().then(function () {
      playerObj = new tCam.player({
        elementIdMap: {
          root: "camdtl_wrap"
        },
        category: "b2bdemo",
        playerType: "hls",
        cameraData: $scope.currentCamera,
        cameraConfig: {
          streamStatus: "on",
          controlStatus: "on",
          timezone: "268,아시아/서울,Asia/Seoul,+09:00"
        },
        mute: true,
        playEventCb: playerEventHandler,
        playTime: 0,
        isShared: false
      });
      if (playerObj) {
        playControl = playerObj.control;
        $scope.timeline = playControl.timeline;
        $scope.player = playControl.player;
      }
      $(".calendar_btn_wrap").hide();
      $(".range_select_wrap").css("float", "right");
    });
  });
  $scope.moveDemoShopPage = function () {
    if ($stateParams.type === "gateway") {
      $state.go("main.demoGateway");
    } else {
      $state.go("main.demoShops", {});
    }
  };
  $scope.galleryStartIndex = 0;
  $scope.moveCameraListCount = 10;
  /**
   * 갤러리 카메라 목록 좌우 이동
   * @param {Number} step -1 or 1
   */
  $scope.moveList = function (step) {
    if ($scope.galleryStartIndex + step < 0 || $scope.galleryStartIndex + step + $scope.moveCameraListCount > $scope.cameraList.length) {
      return;
    } else {
      $scope.galleryStartIndex = $scope.galleryStartIndex + step;
    }
  };
  /**
   * Demo 매장 목록
   * @return {Array} $scope.shopList
   */
  function getDemoShopList() {
    if ($stateParams.type === "gateway") {
      Demos.getGatewayDemoList(function (res) {
        $scope.cameraList = res;
      }, function (err) {
        showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
      });
    } else {
      Demos.getDemoList(function (res) {
        $scope.cameraList = res;
      }, function (err) {
        showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
      });
    }
  }
  getDemoShopList();
  if ($stateParams.type === "gateway") {
    $scope.mainTitle = "Gateway Demo";
  } else {
    $scope.mainTitle = $translate.instant("PANGYO_TECH") + " " + $translate.instant("EXPERIENCE");
  }
  /**
   * Demo 카메라 상세 페이지로 이동
   * @param  {String} cameraId
   * @param  {String} recorderType
   */
  $scope.goDemoDetail = function (cameraId) {
    $stateParams.cameraId = cameraId;
    $state.go("main.cameraDemoDetail", {
      cameraId: cameraId
    }, {
      reload: true
    });
    //$scope.loadCameraSetting();
  };
}]);
"use strict";

//by Michalis Tzikas & Vasilis Lolos
//07-03-2012
//v1.0
/*
Copyright (C) 2011 by Michalis Tzikas & Vasilis Lolos

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.
*/
(function ($) {
  $.fn.linker = function (options) {
    var defaults = {
      target: 'blank',
      //blank,self,parent,top
      className: '',
      rel: ''
    };
    var options = $.extend(defaults, options);
    target_string = options.target != '' ? 'target="_' + options.target + '"' : '';
    class_string = options.className != '' ? 'class="' + options.className + '"' : '';
    rel_string = options.rel != '' ? 'rel="' + options.rel + '"' : '';
    $(this).each(function () {
      t = $(this).text();
      t = t.replace(/(https\:\/\/|http:\/\/)([www\.]?)([^\s|<]+)/gi, '<a href="$1$2$3" ' + target_string + ' ' + class_string + ' ' + rel_string + '>$1$2$3</a>');
      t = t.replace(/([^https\:\/\/]|[^http:\/\/]|^)(www)\.([^\s|<]+)/gi, '$1<a href="http://$2.$3" ' + target_string + ' ' + class_string + ' ' + rel_string + '>$2.$3</a>');
      t = t.replace(/<([^a]|^\/a])([^<>]+)>/g, "&lt;$1$2&gt;").replace(/&lt;\/a&gt;/g, "</a>").replace(/<(.)>/g, "&lt;$1&gt;").replace(/\n/g, '<br />').replace(/\t/g, '	');
      $(this).html(t);
    });
  };
})(jQuery);
"use strict";

app.controller("HelpCenterCtrl", ["$scope", "User", "Utils", function ($scope, User, Utils) {
  showPage2();
  $scope.nowPage = "pc";
  $scope.templates = [{
    name: "top_menu.html",
    url: "/templates/common/_top.html"
  }, {
    name: "left_menu.html",
    url: "/templates/help/_help_left_menu.html"
  }, {
    name: "help_camera_setting.html",
    url: "/templates/help/_help_camera_setting.html"
  }, {
    name: "bottom.html",
    url: "/templates/common/_bottom.html"
  }];
  $scope.getPath = "help";
  $scope.cameraPage = function (clickid) {
    $scope.nowPage = clickid;

    // 모든 탭의 "on" 클래스를 제거
    var tabList = document.getElementById("camera_setting_tab_list");
    var tabs = tabList.children;
    for (var i = 0; i < tabs.length; i++) {
      tabs[i].classList.remove("on");
    }

    // clickid에 따라 해당 탭에 "on" 클래스 추가
    var tabMapping = {
      pc: "camera_setting_pc",
      phone: "camera_setting_phone",
      led: "camera_setting_led",
      reset: "camera_setting_reset"
    };
    var selectedTabId = tabMapping[clickid];
    if (selectedTabId) {
      document.getElementById(selectedTabId).classList.add("on");
    }
  };
  $scope.clickedTopMenu = function () {
    $scope.isTopMenuLayer = !$scope.isTopMenuLayer;
    menuOpen($scope.isTopMenuLayer);
  };
  $scope.clickedUserMenu = function () {
    $scope.isUserMenuLayer = !$scope.isUserMenuLayer;
    openUserMenu($scope.isUserMenuLayer);
  };
  document.getElementById("wrap").addEventListener("click", function (e) {
    var _document$getElementB, _document$getElementB2;
    $scope.isUserMenuLayer = false;
    (_document$getElementB = document.getElementById("topUserMenu")) === null || _document$getElementB === void 0 ? void 0 : (_document$getElementB2 = _document$getElementB.classList) === null || _document$getElementB2 === void 0 ? void 0 : _document$getElementB2.remove("clicked");
  });
  $scope.logout = function () {
    User.logout(function (data) {
      logoutSuccess();
    });
  };
}]);
app.controller("FaqCtrl", ["$scope", "User", "$sce", "$state", function ($scope, User, $sce, $state) {
  showPage2();
  $scope.getPath = "faq";
  var faqUrl = typeof $state.params.categoryNo === "undefined" ? window.help_faq_url : "".concat(window.help_faq_url, "&categoryNo=").concat($state.params.categoryNo);
  $scope.templates = [];
  var lang = document.documentElement.lang;
  var localeParam = "";
  if (lang === "ja") {
    localeParam = "&_adminLocale=ja";
  } else if (lang !== "ko") {
    localeParam = "&_adminLocale=en";
  }
  $scope.iframeUrl = $sce.trustAsResourceUrl(faqUrl + localeParam);
  $scope.clickedTopMenu = function () {
    $scope.isTopMenuLayer = !$scope.isTopMenuLayer;
    menuOpen($scope.isTopMenuLayer);
  };
  $scope.clickedUserMenu = function () {
    $scope.isUserMenuLayer = !$scope.isUserMenuLayer;
    openUserMenu($scope.isUserMenuLayer);
  };
  document.getElementById("wrap").addEventListener("click", function (e) {
    var _document$getElementB3, _document$getElementB4;
    $scope.isUserMenuLayer = false;
    (_document$getElementB3 = document.getElementById("topUserMenu")) === null || _document$getElementB3 === void 0 ? void 0 : (_document$getElementB4 = _document$getElementB3.classList) === null || _document$getElementB4 === void 0 ? void 0 : _document$getElementB4.remove("clicked");
  });
  $scope.logout = function () {
    User.logout(function (data) {
      logoutSuccess();
    });
  };
  $("[name=faq_tab]").click(function (e) {
    var id = $(this).attr("id");
    var num = id.replace("tab_", "");
    $("[name=faq_tab]").closest("li").removeClass("on");
    $("#" + id).closest("li").addClass("on");
    $("[name=faq_biz]").hide();
    $("[name=faq_biz]:eq(" + (num - 1) + ")").show();
  });
}]);
app.controller("InquiryCtrl", ["$translate", "$window", "$scope", "$rootScope", "User", "$sce", "$stateParams", "$state", "Utils", function ($translate, $window, $scope, $rootScope, User, $sce, $stateParams, $state, Utils) {
  $scope.showAlert = false;
  var showAlert = function showAlert(title, message) {
    void 0;
    $scope.showAlert = true;
    $scope.alertTitle = title;
    $scope.alertMessage = message;
  };
  $scope.hideAlert = function () {
    $scope.showAlert = false;
  };
  var device = "PC";
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test($window.navigator.userAgent)) {
    device = "Mobile";
  }
  showPage2();
  var inquiryUrl;
  if ($("html").attr("lang") == "ko") {
    if ($rootScope.isLogin) {
      inquiryUrl = window.help_inquiry_url;
    } else {
      inquiryUrl = window.help_guest_inquiry_url;
    }
  } else {
    inquiryUrl = window.help_guest_inquiry_url_jp;
  }

  // 이메일 프로바이더 선택
  $("#selectEmail").change(function () {
    void 0;
    $("#selectEmail option:selected").each(function () {
      if ($(this).val() == "1") {
        //직접입력일 경우
        $("#str_email02").val("");
        //값 초기화
        $("#str_email02").attr("disabled", false);
        //활성화
      } else {
        //직접입력이 아닐경우
        $("#str_email02").val($(this).text());
        $scope.params.str_email02 = $(this).text();
        //선택값 입력
        $("#str_email02").attr("disabled", false);
        //비활성화
      }
    });
  });

  // 파일선택시 파일검증
  $("#file").change(function () {
    void 0;
    if ($(this).val() != "") {
      var ext = $(this).val().split(".").pop().toLowerCase();
      void 0;
      if ($.inArray(ext, ["jpg", "jpeg", "png", "gif"]) == -1) {
        void 0;
        $("#fileError").html($translate.instant("jpg, png, gif 파일만 선택해 주세요."));
        $("#fileError").show();
        $(this).val("");
        $("#fileName").val("");
        return;
      }
    }

    // 용량체크
    for (var i = 0; i < this.files.length; i++) {
      var fileSize = this.files[i].size;
      var fSMB = (fileSize / (1024 * 1024)).toFixed(2);
      var maxSize = 1024 * 1024 * 1.4;
      var mSMB = maxSize / (1024 * 1024);
      if (fileSize > maxSize) {
        $("#fileError").html($translate.instant("1.4MB 이내의 파일만 선택해 주세요."));
        $("#fileError").show();
        $(this).val("");
        $("#fileName").val("");
        return;
      }
    }
    $("#fileError").hide();
    $("#fileError").html("");
  });

  // 회부 파일링크 검사
  $("#url").change(function () {
    void 0;
    if (!($(this).val().startsWith("http") || $(this).val().startsWith("https"))) {
      void 0;
      $(this).val("");
      $("#urlError").html($translate.instant("http://나  https://가 포함된 링크를 입력해 주세요."));
      $("#urlError").show();
      return;
    }
    $("#urlError").hide();
    $("#urlError").html("");
  });
  if (device == "Mobile") {
    $scope.templates = [{
      name: "top_menu.html",
      url: "/templates/common/_top_m.html"
    }, {
      name: "help_camera_setting.html",
      url: "/templates/help/_help_inquiry_mobile.html"
    }, {
      name: "bottom.html",
      url: "/templates/common/_bottom_m.html"
    }];
  } else {
    $scope.templates = [{
      name: "top_menu.html",
      url: "/templates/common/_top.html"
    }, {
      name: "help_camera_setting.html",
      url: "/templates/help/_help_inquiry.html"
    }, {
      name: "bottom.html",
      url: "/templates/common/_bottom.html"
    }];
  }
  if ($stateParams.type === "cam_cancel") {
    $scope.iframeUrl = $sce.trustAsResourceUrl(inquiryUrl + "&alias=cam_cancel");
  } else if ($stateParams.type === "cam_buy") {
    $scope.iframeUrl = $sce.trustAsResourceUrl(inquiryUrl + "&alias=cam_buy");
  } else if ($stateParams.type === "biz_support_guest") {
    $scope.iframeUrl = $sce.trustAsResourceUrl(inquiryUrl + "&alias=biz_support_guest");
  } else if ($stateParams.type === "jp_guest") {
    inquiryUrl = window.help_guest_inquiry_url_jp;
    $scope.iframeUrl = $sce.trustAsResourceUrl(inquiryUrl);
  } else if ($stateParams.type === "cam_partner_jp") {
    inquiryUrl = window.help_guest_inquiry_url_jp;
    $scope.iframeUrl = $sce.trustAsResourceUrl(inquiryUrl + "&alias=cam_partner_jp");
  } else {
    $scope.iframeUrl = $sce.trustAsResourceUrl(inquiryUrl);
  }
  $scope.getPath = "inquiry";
  var ua_result = {
    os: Utils.getOs(),
    browser: Utils.getBrowserType()
  };
  $scope.getFileName = function () {
    var fn = $("#file").val();
    var filename = fn.match(/[^\\/]*$/)[0]; // remove C:\fakename
    $("#fileName").val(filename);
    void 0;
  };
  $scope.params = {
    id: $rootScope.me ? $rootScope.me.paycoEmail : "",
    agree: false,
    type: "결제, 청구",
    inqueryType: "구매, 상품 영업문의",
    selectEmail: "1",
    device: device + "/" + ua_result.os + "/" + ua_result.browser
  };
  var verifyEmail = function verifyEmail($email) {
    // 이메일 검증 스크립트 작성
    var emailVal = $email;
    var regExp = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i;
    // 검증에 사용할 정규식 변수 regExp에 저장
    if (emailVal.match(regExp) != null) {
      return true;
    }
    return false;
  };

  // 1:1 문의하기
  $scope.sendInquery = function () {
    if ($scope.params.inqueryType == "" || !$scope.params.inqueryType) {
      showAlert($translate.instant("1:1 문의하기"), $translate.instant("문의유형을 선택하세요."));
      return;
    }
    if ($scope.params.str_email01 == "" || !$scope.params.str_email01 || $scope.params.str_email02 == "" || !$scope.params.str_email02) {
      showAlert($translate.instant("1:1 문의하기"), $translate.instant("이메일을 입력하세요."));
      return;
    }
    var email = $scope.params.str_email01 + "@" + $scope.params.str_email02;
    if (email.length > 100) {
      showAlert($translate.instant("1:1 문의하기"), $translate.instant("이메일은 100자 이내로 작성해 주세요."));
      return;
    }
    if (!verifyEmail(email)) {
      showAlert($translate.instant("1:1 문의하기"), $translate.instant("이메일 형식에 맞게 입력해 주세요."));
      return;
    }
    if ($scope.params.name == "" || !$scope.params.name) {
      showAlert($translate.instant("1:1 문의하기"), $translate.instant("성명을 입력하세요."));
      return;
    }
    if ($scope.params.corpName == "" || !$scope.params.corpName) {
      showAlert($translate.instant("1:1 문의하기"), $translate.instant("회사/단체/매장명을 입력하세요."));
      return;
    }
    if ($scope.params.title == "" || !$scope.params.title) {
      showAlert($translate.instant("1:1 문의하기"), $translate.instant("문의제목을 입력하세요."));
      return;
    }
    if ($scope.params.content == "" || !$scope.params.content) {
      showAlert($translate.instant("1:1 문의하기"), $translate.instant("문의내용을 입력하세요."));
      return;
    }
    if (!$scope.params.agree) {
      showAlert($translate.instant("1:1 문의하기"), $translate.instant("개인정보 수집 및 이용에 대한 안내에 동의해 주세요."));
      return false;
    }
    $scope.params.email = $scope.params.str_email01 + "@" + $scope.params.str_email02;
    var emailTpl = $("#emailTpl").html();
    var data = {
      sender: $scope.params.email,
      title: $scope.params.title,
      content: emailTpl
    };
    function getFormData(object) {
      var formData = new FormData();
      Object.keys(object).forEach(function (key) {
        formData.append(key, object[key]);
      });
      return formData;
    }
    var formData = getFormData(data);
    formData.append("file", $("#file")[0].files[0]);
    $.ajax({
      type: "POST",
      data: formData,
      url: "/json/biz/cs/mail",
      dataType: "json",
      enctype: "multipart/form-data",
      contentType: false,
      processData: false,
      success: function success(data) {
        void 0;
        if (data.code == "ok") {
          if (device == "Mobile") {
            showAlert($translate.instant("1:1 문의하기"), $translate.instant("고객님의 문의가 접수되었습니다. 빠른 시간내에 답변을 드리도록 하겠습니다."));
            $scope.$apply();
            setTimeout(function () {
              location.href = "/#/help/faqM";
            }, 1000);
            return;
          } else {
            location.href = "/#/help/inquiryResult";
          }
        } else {
          showAlert($translate.instant("1:1 문의하기"), $translate.instant(data.msg));
          $scope.$apply();
        }
      },
      error: function error(e) {
        void 0;
        showAlert($translate.instant("1:1 문의하기"), $translate.instant("오류가 발생되었습니다."));
        $scope.$apply();
      }
    });
  };
  $scope.loginCheck = function () {
    setTimeout(function () {
      if ($scope.isLogin == false) {
        $("#showLoginAlert").show();
        $("#showLoginAlertDim").show();
      }
    }, 65);
  };
  $scope.goLogin = function () {
    location.href = "/#/login?url=inquiry";
  };
  $scope.clickedTopMenu = function () {
    $scope.isTopMenuLayer = !$scope.isTopMenuLayer;
    menuOpen($scope.isTopMenuLayer);
  };
  $scope.clickedUserMenu = function () {
    $scope.isUserMenuLayer = !$scope.isUserMenuLayer;
    openUserMenu($scope.isUserMenuLayer);
  };
  document.getElementById("wrap").addEventListener("click", function (e) {
    var _document$getElementB5, _document$getElementB6;
    $scope.isUserMenuLayer = false;
    (_document$getElementB5 = document.getElementById("topUserMenu")) === null || _document$getElementB5 === void 0 ? void 0 : (_document$getElementB6 = _document$getElementB5.classList) === null || _document$getElementB6 === void 0 ? void 0 : _document$getElementB6.remove("clicked");
  });
  $scope.logout = function () {
    User.logout(function (data) {
      logoutSuccess();
    });
  };
}]);
app.controller("QnaCtrl", ["$scope", "User", "$sce", function ($scope, User, $sce) {
  showPage2();
  if ($("html").attr("lang") == "ko") {
    $scope.templates = [{
      name: "top_menu.html",
      url: "/templates/common/_top.html"
    }, {
      name: "left_menu.html",
      url: "/templates/help/_help_left_menu.html"
    }, {
      name: "help_camera_setting.html",
      url: "/templates/help/_help_qna.html"
    }, {
      name: "bottom.html",
      url: "/templates/common/_bottom.html"
    }];
    $scope.iframeUrl = $sce.trustAsResourceUrl(window.help_qna_url);
  } else if ($("html").attr("lang") == "ja") {
    $scope.templates = [];
    $scope.iframeUrl = $sce.trustAsResourceUrl(window.help_qna_url + "&_adminLocale=ja");
  } else {
    $scope.templates = [{
      name: "top_menu.html",
      url: "/templates/common/_top.html"
    }, {
      name: "left_menu.html",
      url: "/templates/help/_help_left_menu.html"
    }, {
      name: "help_camera_setting.html",
      url: "/templates/help/_help_qna.html"
    }, {
      name: "bottom.html",
      url: "/templates/common/_bottom.html"
    }];
    $scope.iframeUrl = $sce.trustAsResourceUrl(window.help_qna_url + "&_adminLocale=en");
  }
  $scope.getPath = "qna";
  $scope.selectLang = function () {
    setTimeout(function () {
      if (document.documentElement.getAttribute("lang") !== "ko") {
        var url = $("#csIframe").attr("src") + "&_adminLocale=en";
        $("#csIframe").attr("src", url);
      }
    }, 500);
  };
  $scope.loginCheck = function () {
    setTimeout(function () {
      if ($scope.isLogin == false) {
        $("#showLoginAlert").show();
        $("#showLoginAlertDim").show();
      }
    }, 65);
  };
  $scope.goLogin = function () {
    location.href = "/#/login?url=qna";
  };
  $scope.clickedTopMenu = function () {
    $scope.isTopMenuLayer = !$scope.isTopMenuLayer;
    menuOpen($scope.isTopMenuLayer);
  };
  $scope.clickedUserMenu = function () {
    $scope.isUserMenuLayer = !$scope.isUserMenuLayer;
    openUserMenu($scope.isUserMenuLayer);
  };
  document.getElementById("wrap").addEventListener("click", function (e) {
    var _document$getElementB7, _document$getElementB8;
    $scope.isUserMenuLayer = false;
    (_document$getElementB7 = document.getElementById("topUserMenu")) === null || _document$getElementB7 === void 0 ? void 0 : (_document$getElementB8 = _document$getElementB7.classList) === null || _document$getElementB8 === void 0 ? void 0 : _document$getElementB8.remove("clicked");
  });
  $scope.logout = function () {
    User.logout(function (data) {
      logoutSuccess();
    });
  };
}]);
app.controller("noticeCtrl", ["$scope", "User", function ($scope, User) {
  showPage2();
  $scope.templates = [{
    name: "top_menu.html",
    url: "/templates/common/_top.html"
  }, {
    name: "left_menu.html",
    url: "/templates/help/_help_left_menu.html"
  }, {
    name: "help_camera_setting.html",
    url: "/templates/help/_help_notice.html"
  }, {
    name: "bottom.html",
    url: "/templates/common/_bottom.html"
  }];
  $scope.getPath = "notice";
  setTimeout(function () {
    $scope.viewContent(1);
  }, 65);
  $scope.clickedTopMenu = function () {
    $scope.isTopMenuLayer = !$scope.isTopMenuLayer;
    menuOpen($scope.isTopMenuLayer);
  };
  $scope.clickedUserMenu = function () {
    $scope.isUserMenuLayer = !$scope.isUserMenuLayer;
    openUserMenu($scope.isUserMenuLayer);
  };
  document.getElementById("wrap").addEventListener("click", function (e) {
    var _document$getElementB9, _document$getElementB10;
    $scope.isUserMenuLayer = false;
    (_document$getElementB9 = document.getElementById("topUserMenu")) === null || _document$getElementB9 === void 0 ? void 0 : (_document$getElementB10 = _document$getElementB9.classList) === null || _document$getElementB10 === void 0 ? void 0 : _document$getElementB10.remove("clicked");
  });
  $scope.logout = function () {
    User.logout(function (data) {
      logoutSuccess();
    });
  };
  $scope.noticeSelectNum = 0;
  var subject = [];
  var content = [];
  var date = [];
  $scope.contentInput1 = function () {
    subject.push("TOASTCAM 정식버전 오픈");
    var d1 = "";
    d1 += "안녕하세요 NHN입니다.\n";
    d1 += "2015년 6월에 베타버전을 선보인 스마트 IP카메라 CCTV 서비스 \n";
    d1 += "“TOASTCAM”의 정식버전이 오픈 되었습니다.\n";
    d1 += "정식버전에서는 아래와 같은 사항들이 적용되었습니다.\n";
    d1 += "\n";
    d1 += "1. 홈페이지가 개편되었습니다.\n";
    d1 += "개편된 홈페이지에서는 이전보다 카메라에 접속하는 속도와, 카메라 상세화면에서 타임라인을 불러오는 속도가 빨라졌으며\n";
    d1 += "새로운 디자인요소들이 추가되어 좀 더 직관적으로 서비스를 이용하실 수 있습니다.\n";
    d1 += "\n";
    d1 += "2. 카메라 공유 기능이 추가되었습니다.\n";
    d1 += "\n";
    d1 += "이제 내 카메라를 가까운 사람들에게 공유해줄 수 있습니다.\n";
    d1 += "내 카메라를 공유해주고 싶은 사람의 PAYCO아이디만 입력하면 내게 등록된 카메라를 바로 공유할 수 있습니다.\n";
    d1 += "( PAYCO에 가입되어 있지 않아도 공유를 받은 연락처로 PAYCO에 가입하면 공유받은 카메라를 바로 확인하실 수 있습니다.\n";
    d1 += "\n";
    d1 += "더 쉽고 편하게, 더 안전하게 믿고 사용할 수 있는 토스트캠이 되도록 항상 노력하겠습니다.\n";
    d1 += "\n";
    d1 += "감사합니다.\n";
    content.push(d1);
    date.push("2015-10-29");
  };
  $scope.getNoticeList = function () {
    $scope.contentInput1();
    $scope.noticeList = [];
    for (var i = 0; i < content.length; i++) {
      var notice = {};
      notice.num = i + 1;
      notice.subject = subject[i];
      notice.content = content[i];
      notice.date = date[i];
      $scope.noticeList.push(notice);
    }
  };
  $scope.getNoticeList();
  var flip = 0;
  $scope.viewContent = function (num) {
    $(".contentDetail").hide();
    $scope.noticeSelectNum = num - 1;
    $("#noticeDetail" + num).empty();
    $("#contentDetail" + num).toggle("slow");
    $("#noticeDetail" + num).append($scope.noticeList[num - 1].content);
    $("#noticeDetail" + num).text();
    $("#noticeDetail" + num).linker();
  };
}]);
app.controller("noticeMobileCtrl", ["$scope", "User", function ($scope, User) {
  $scope.getPath = "noticeMobile";
  setTimeout(function () {
    $("#mobileViewSizeCheck").attr("content", "user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, width=device-width");
  }, 65);
  var isMobileDevice = function isMobileDevice() {
    var phoneArray = new Array("samsung-", "sch-", "shw-", "sph-", "sgh-", "lg-", "canu", "im-", "ev-", "iphone", "nokia", "blackberry", "lgtelecom", "natebrowser", "sonyericsson", "mobile", "android", "ipad");
    for (var i = 0; i < phoneArray.length; i++) {
      if (navigator.userAgent.toLowerCase().indexOf(phoneArray[i]) > -1) {
        return true;
      }
    }
    return false;
  };
  var isTabletDevice = function isTabletDevice() {
    if (!isMobileDevice()) {
      return false;
    }
    // 태블릿검사
    if (navigator.userAgent.toLowerCase().indexOf("ipad") > -1 || navigator.userAgent.toLowerCase().indexOf("android") > -1 && navigator.userAgent.toLowerCase().indexOf("mobile") == -1) {
      return true;
    }
    // 갤럭시 탭만을 위한 리다이렉트. Mobile 이라는 단어가 안들어오게 되면 지우셔도 됨
    var galaxyTabModel = new Array("shw-");
    for (var i = 0; i < galaxyTabModel.length; i++) {
      if (navigator.userAgent.toLowerCase().indexOf(galaxyTabModel[i]) > -1) {
        return true;
      }
    }
    return false;
  };
  setTimeout(function () {
    if (isTabletDevice() == true) {
      $("#mobile_notice_phone").remove();
    } else {
      $("#mobile_notice_tablet").remove();
    }
  }, 1);
  $scope.clickedTopMenu = function () {
    $scope.isTopMenuLayer = !$scope.isTopMenuLayer;
    menuOpen($scope.isTopMenuLayer);
  };
  $scope.clickedUserMenu = function () {
    $scope.isUserMenuLayer = !$scope.isUserMenuLayer;
    openUserMenu($scope.isUserMenuLayer);
  };
  document.getElementById("wrap").addEventListener("click", function (e) {
    var _document$getElementB11, _document$getElementB12;
    $scope.isUserMenuLayer = false;
    (_document$getElementB11 = document.getElementById("topUserMenu")) === null || _document$getElementB11 === void 0 ? void 0 : (_document$getElementB12 = _document$getElementB11.classList) === null || _document$getElementB12 === void 0 ? void 0 : _document$getElementB12.remove("clicked");
  });
  $scope.logout = function () {
    User.logout(function (data) {
      logoutSuccess();
    });
  };
  $scope.noticeSelectNum = 0;
  var subject = [];
  var content = [];
  var date = [];
  $scope.contentInput1 = function () {
    subject.push("TOASTCAM 정식버전 오픈");
    var d1 = "";
    d1 += "안녕하세요 NHN입니다.\n";
    d1 += "2015년 6월에 베타버전을 선보인 스마트 IP카메라 CCTV 서비스 \n";
    d1 += "“TOASTCAM”의 정식버전이 오픈 되었습니다.\n";
    d1 += "정식버전에서는 아래와 같은 사항들이 적용되었습니다.\n";
    d1 += "\n";
    d1 += "1. 홈페이지가 개편되었습니다.\n";
    d1 += "개편된 홈페이지에서는 이전보다 카메라에 접속하는 속도와, 카메라 상세화면에서 타임라인을 불러오는 속도가 빨라졌으며\n";
    d1 += "새로운 디자인요소들이 추가되어 좀 더 직관적으로 서비스를 이용하실 수 있습니다.\n";
    d1 += "\n";
    d1 += "2. 카메라 공유 기능이 추가되었습니다.\n";
    d1 += "\n";
    d1 += "이제 내 카메라를 가까운 사람들에게 공유해줄 수 있습니다.\n";
    d1 += "내 카메라를 공유해주고 싶은 사람의 PAYCO아이디만 입력하면 내게 등록된 카메라를 바로 공유할 수 있습니다.\n";
    d1 += "( PAYCO에 가입되어 있지 않아도 공유를 받은 연락처로 PAYCO에 가입하면 공유받은 카메라를 바로 확인하실 수 있습니다.\n";
    d1 += "\n";
    d1 += "더 쉽고 편하게, 더 안전하게 믿고 사용할 수 있는 토스트캠이 되도록 항상 노력하겠습니다.\n";
    d1 += "\n";
    d1 += "감사합니다.\n";
    content.push(d1);
    date.push("2015-10-29");
  };
  $scope.getNoticeList = function () {
    $scope.contentInput1(0);
    $scope.noticeList = [];
    for (var i = 0; i < content.length; i++) {
      var notice = {};
      notice.num = i + 1;
      notice.subject = subject[i];
      notice.content = content[i];
      notice.date = date[i];
      $scope.noticeList.push(notice);
    }
  };
  $scope.getNoticeList();
  var flip = 0;
  var openNum = 0;
  $scope.viewContent = function (num) {
    if (num != openNum) {
      $("#noticeDetail" + num).empty();
      $("#noticeDetail" + num).append($scope.noticeList[num - 1].content);
      $("#contentDetail" + num).show();
      $("#noticeDetail" + num).show();
      $("#content_detail").show();
      $("#notice_" + num).hide();
      openNum = num;
    } else {
      if ($("#contentDetail" + num).children("td").children("div").eq(2).attr("class").indexOf("day") != -1) {
        $($("#contentDetail" + num).children("td").children("div").eq(3)).toggle("slow", function () {
          $("#contentDetail" + num).hide();
          $("#notice_" + num).show();
        });
      } else {
        $($("#contentDetail" + num).children("td").children("div").eq(2)).toggle("slow", function () {
          $("#contentDetail" + num).hide();
          $("#notice_" + num).show();
        });
      }
      openNum = 0;
    }
  };
}]);
app.controller("HelpMenuCtrl", ["$rootScope", "$translate", "$scope", "User", "$location", "$state", function ($rootScope, $translate, $scope, User, $location, $state) {
  $scope.browserLang = $("html").attr("lang");
  $scope.getPath = $location.path();
  $scope.showAlert = false;
  var showAlert = function showAlert(title, message) {
    $scope.showAlert = true;
    $scope.alertTitle = title;
    $scope.alertMessage = message;
  };
  $scope.hideAlert = function () {
    $scope.showAlert = false;
  };
  $scope.goInquiry = function () {
    $state.go("main.help.inquiry");
  };
}]);
app.controller("ApiCtrl", ["$scope", "User", "$location", function ($scope, User, $location) {}]);
app.controller("CustomerCenterCtrl", ["$scope", "User", "$location", function ($scope, User, $location) {
  $scope.helpLnb = $(".js-help-lnb");
  $scope.name = "";
  $scope.phoneNumber = "";
  $scope.email = "";
  $scope.contactEmail = "";
  $scope.helpLnb.hide();
  $("#content").addClass("customer-center-wrapper");
  User.customerCenterInfo(function (data) {
    if (data) {
      $scope.name = data.name || "";
      $scope.phoneNumber = data.phoneNumber || "";
      $scope.email = data.email || "";
      $scope.contactEmail = data.contactEmail || "";
    }
  });
  $scope.$on("$destroy", function () {
    $scope.helpLnb.show();
    $("#content").removeClass("customer-center-wrapper");
  });
}]);
"use strict";

app.controller('ConnectWifiCtrl', ['$scope', 'Install', 'User', '$state', '$stateParams', '$translate', function ($scope, Install, User, $state, $stateParams, $translate) {
  $scope.currentTab = "connectwifi";

  // $scope.templates = [
  //     { name: 'top_menu.html', url: '/templates/common/_top.html'},
  //     { name: 'install_left_menu.html', url: '/templates/setup/_install_left_menu.html'},
  //     { name: 'main.html', url: '/templates/setup/_wifi_connect.html'},
  //     { name: 'bottom.html', url: '/templates/common/_bottom.html'}
  // ];

  $scope.clickedTopMenu = function () {
    $scope.isTopMenuLayer = !$scope.isTopMenuLayer;
    menuOpen($scope.isTopMenuLayer);
  };
  $scope.clickedUserMenu = function () {
    $scope.isUserMenuLayer = !$scope.isUserMenuLayer;
    openUserMenu($scope.isUserMenuLayer);
  };
  $scope.logout = function () {
    User.logout(function (data) {
      logoutSuccess();
    });
  };
  var showAlert = function showAlert(title, message) {
    $scope.showAlert = true;
    $scope.alertTitle = title;
    $scope.alertMessage = message;
  };
  $scope.hideAlert = function () {
    $scope.showAlert = false;
  };
  if ($stateParams.MAC !== undefined && $stateParams.MAC !== '') {
    $scope.isDirect = false;
    $scope.wifi = Install.getWifiInfo({
      MAC: $stateParams.MAC
    });
    $scope.MAC = $stateParams.MAC;
  } else {
    $scope.isDirect = true;
    $scope.wifi = {};
    $scope.wifi.SEC = 1;
    $scope.showPassword = false;
  }
  $scope.wifiIconWithStrength = function () {
    var strNum = parseInt($scope.wifi.STRENGTH);
    if (strNum === 0) {
      return '/images/icon_WiFi_04.png';
    } else if (strNum <= 25) {
      return '/images/icon_WiFi_03.png';
    } else if (strNum <= 60) {
      return '/images/icon_WiFi_02.png';
    } else if (strNum <= 75) {
      return '/images/icon_WiFi_01.png';
    } else if (strNum <= 100) {
      return '/images/icon_WiFi.png';
    }
  };
  $scope.submit = function () {
    if (event.preventDefault) {
      event.preventDefault();
    } else {
      event.returnValue = false;
    }
    Install.connectwifi({
      SID: $scope.wifi.SID,
      MAC: $scope.MAC,
      PASSWORD: $scope.wifi.PASSWORD,
      SEC: $scope.wifi.SEC
    }, function (data) {
      if (data.code === 'ok') {
        //$state.go('installWifiFinish');/enroll/wififinish
        location.href = "/#/enroll/wififinish?" + location.hash.substring(location.hash.indexOf("installKey"));
      } else {
        showAlert($translate.instant('SETUP_CONN_MSG6'), $translate.instant('SETUP_CONN_MSG7'));
      }
    }, function () {
      showAlert($translate.instant('SETUP_CONN_MSG6'), $translate.instant('SETUP_CONN_MSG7'));
    });
  };
  $scope.directSubmit = function () {
    if ($("#d_wifi_name").val() == "") {
      $scope.showIdAlert = true;
      return;
    }
    if ($("#wifi_sec_method").val() != 1) {
      if ($("#d_wifi_password").val() == "") {
        $scope.showPwdAlert = true;
        return;
      }
    }
    if (event.preventDefault) {
      event.preventDefault();
    } else {
      event.returnValue = false;
    }
    $scope.wifi.SID = $("#d_wifi_name").val();
    $scope.wifi.PASSWORD = $("#d_wifi_password").val();
    $scope.wifi.SEC = $("#wifi_sec_method").val();
    Install.connectwifi({
      SID: $scope.wifi.SID,
      PASSWORD: $scope.wifi.PASSWORD,
      SEC: $scope.wifi.SEC
    }, function (data) {
      if (data.code === 'ok') {
        location.href = "/#/enroll/wififinish?" + location.hash.substring(location.hash.indexOf("installKey"));
      } else {
        showAlert($translate.instant('SETUP_CONN_MSG6'), $translate.instant('SETUP_CONN_MSG7'));
      }
    }, function () {
      showAlert($translate.instant('SETUP_CONN_MSG6'), $translate.instant('SETUP_CONN_MSG7'));
    });
  };
  $scope.changedSEC = function () {
    if (parseInt($scope.wifi.SEC) === 1) {
      $scope.showPassword = false;
      $scope.PASSWORD = '';
    } else {
      $scope.showPassword = true;
    }
  };
}]);
"use strict";

app.controller('FinishWifiCtrl', ['$scope', '$state', 'Install', 'User', '$interval', '$translate', function ($scope, $state, Install, User, $interval, $translate) {
  $scope.currentTab = "completewifi";

  // $scope.templates = [
  //     { name: 'top_menu.html', url: '/templates/common/_top.html'},
  //     { name: 'install_left_menu.html', url: '/templates/setup/_install_left_menu.html'},
  //     { name: 'main.html', url: '/templates/setup/_wifi_finish.html'},
  //     { name: 'bottom.html', url: '/templates/common/_bottom.html'}
  // ];

  $scope.isLoading = true;
  $scope.clickedTopMenu = function () {
    $scope.isTopMenuLayer = !$scope.isTopMenuLayer;
    menuOpen($scope.isTopMenuLayer);
  };
  $scope.clickedUserMenu = function () {
    $scope.isUserMenuLayer = !$scope.isUserMenuLayer;
    openUserMenu($scope.isUserMenuLayer);
  };
  $scope.logout = function () {
    User.logout(function (data) {
      logoutSuccess();
    });
  };
  $scope.$on('$destroy', function () {
    $interval.cancel($scope.checkTimer);
  });
  var checkConnectStatus = function checkConnectStatus() {
    //$scope.installKey = instaillK;
    $scope.installKey = location.hash.substring(location.hash.indexOf("installKey")).replace("installKey=", "");
    Install.connectstatus({
      installKey: $scope.installKey,
      time: new Date().valueOf()
    }, function (data) {
      if (data.code === 'ok') {
        $scope.isLoading = false;
        $interval.cancel($scope.checkTimer);
      } else if (data.code == "error") {
        //이미 처리된 카메라입니다
        $scope.showErrorAlert = true;
        $interval.cancel($scope.checkTimer);
      } else if (data.code == "nok") {
        if (data.errorCode == -1 || data.errorCode == "-1") {
          $interval.cancel($scope.checkTimer);
          $scope.isLoading = false;
          $scope.isError = true;
          showAlert($translate.instant('SETUP_ERROR_TITLE'), $translate.instant('SETUP_ERROR_MSG1_1') + "<br>" + $translate.instant('SETUP_ERROR_MSG1_2'));
        } else if (data.errorCode == -2 || data.errorCode == "-2") {
          $interval.cancel($scope.checkTimer);
          $scope.isLoading = false;
          $scope.isError = true;
          showAlert($translate.instant('SETUP_ERROR_TITLE'), $translate.instant('SETUP_ERROR_MSG2_1') + "<br>" + $translate.instant('SETUP_ERROR_MSG2_2'));
        } else if (data.errorCode == -3 || data.errorCode == "-3") {
          $interval.cancel($scope.checkTimer);
          $scope.isLoading = false;
          $scope.isError = true;
          showAlert($translate.instant('SETUP_ERROR_TITLE'), $translate.instant('SETUP_ERROR_MSG3_1') + "<br>" + $translate.instant('SETUP_ERROR_MSG3_2'));
        } else if (data.errorCode == -4 || data.errorCode == "-4") {
          $interval.cancel($scope.checkTimer);
          $scope.isLoading = false;
          $scope.isError = true;
          showAlert($translate.instant('SETUP_ERROR_TITLE'), $translate.instant('SETUP_ERROR_MSG4_1') + "<br>" + $translate.instant('SETUP_ERROR_MSG4_2'));
        }
      }
    });
  };
  var showAlert = function showAlert(title, message) {
    $(".display_show").css("display", "");
    $scope.showAlert = true;
    $scope.alertTitle = title;
    $scope.alertMessage = message;
  };
  $scope.checkTimer = $interval(checkConnectStatus, 1000);
  $scope.goLogin = function () {
    $state.go('main.login');
  };
  $scope.goCameras = function () {
    $state.go('main.cameras');
  };
}]);
"use strict";

app.controller('InstallMenuCtrl', ['$scope', '$location', function ($scope, $location) {
  $scope.getPath = $location.path();
}]);
"use strict";

var instaillK = "";
app.controller('InstallLoginCtrl', ['$scope', 'Install', 'User', '$state', '$stateParams', '$rootScope', function ($scope, Install, User, $state, $stateParams, $rootScope) {
  $scope.currentTab = "login";
  $scope.isTermsYN = false;
  // $scope.templates = [
  //     { name: 'top_menu.html', url: '/templates/common/_top.html'},
  //     { name: 'install_left_menu.html', url: '/templates/setup/_install_left_menu.html'},
  //     { name: 'main.html', url: '/templates/setup/_login.html'},
  //     { name: 'bottom.html', url: '/templates/common/_bottom.html'}
  // ];
  (function () {
    User.me().$promise.then(function (data) {
      if (data.code == "ok" || data.code == "nok" && data.errorCode == "-2") {
        $rootScope.me = data;
        $rootScope.isLogin = true;
        ci = data.clientId;
        at = data.accessToken;
      } else {
        $rootScope.isLogin = false;
      }
      if ($rootScope.me !== undefined) {
        // 약관동의 여부 확인
        if ($rootScope.me.code == "nok" && $rootScope.me.errorCode == "-2") {
          var httpUrl = location.origin;
          if (httpUrl == undefined) {
            httpUrl = location.protocol + "//" + location.hostname;
          }
          var url = paycoUrl + "login.nhn?m=bridge&client_id=" + ci + "&access_token=" + encodeURIComponent(at) + "&nextUrl=" + encodeURIComponent(paycoUrl + "serviceProvision.nhn?serviceProviderCode=BIZCAM&nextUrl=" + httpUrl + "/oauth2.0/toastcom/appCallback?next_uri=" + httpUrl + "/lproc?" + location.hash.substring(location.hash.indexOf("installKey")));
          // var url = "https://demo-id.payco.com/serviceProvision.nhn?serviceProviderCode=TOASTCAM&nextUrl="+encodeURIComponent(httpUrl+"/oauth2.0/appCallback?next_uri="+httpUrl);
          openInfoWin(url, "popup", 630, 560); // window.open
        } else {
          $scope.isTermsYN = true;
        }
      }
    }, function (err) {
      location.href = "/error";
    });
  })();
  $scope.clickedTopMenu = function () {
    $scope.isTopMenuLayer = !$scope.isTopMenuLayer;
    menuOpen($scope.isTopMenuLayer);
  };
  $scope.clickedUserMenu = function () {
    $scope.isUserMenuLayer = !$scope.isUserMenuLayer;
    openUserMenu($scope.isUserMenuLayer);
  };
  $scope.logout = function () {
    User.logout(function (data) {
      logoutSuccess();
    });
  };
  User.me().$promise.then(function (data) {
    if (data.code == "ok") {
      $rootScope.me = data;
      $rootScope.isLogin = true;
      ci = data.clientId;
      at = data.accessToken;
    } else {
      $rootScope.isLogin = false;
    }
  }, function (err) {});
  $scope.pressedCancle = function () {
    $state.go('main.cameras');
  };
  if ($stateParams.installKey === undefined || !/^[^\s]+$/.test($stateParams.installKey)) {
    if ($rootScope.isLogin) {
      $state.go('main.cameras');
    } else {
      $state.go('main.login');
    }
  }
  ;
  $scope.pressedAddButton = function () {
    instaillK = $stateParams.installKey;
    Install.start({
      installKey: $stateParams.installKey
    }, function (data) {
      if (data.code === 'ok') {
        //$state.go('installWifiSetup');
        location.href = "/#/enroll/wifisetup?" + location.hash.substring(location.hash.indexOf("installKey"));
      }
    });
  };
}]);
"use strict";

app.controller('SetupWifiCtrl', ['$scope', 'Install', 'User', '$interval', '$state', function ($scope, Install, User, $interval, $state) {
  // $scope.templates = [
  //     { name: 'top_menu.html', url: '/templates/common/_top.html'},
  //     { name: 'install_left_menu.html', url: '/templates/setup/_install_left_menu.html'},
  //     { name: 'main.html', url: '/templates/setup/_wifi_setup.html'},
  //     { name: 'bottom.html', url: '/templates/common/_bottom.html'}
  // ];

  $scope.currentTab = "setupwifi";
  $scope.isLoading = 'wait';
  $scope.$on('$destroy', function () {
    $interval.cancel($scope.wifitimer);
  });
  var fetchWifiList = function fetchWifiList() {
    $scope.wifilist = Install.wifilist({
      time: new Date().valueOf()
    }, function (data) {
      if (data.length !== 0) {
        $interval.cancel($scope.wifitimer);
        $scope.isLoading = 'end';
      }
    });
  };
  $scope.logout = function () {
    User.logout(function (data) {
      logoutSuccess();
    });
  };

  //$scope.wifitimer = $interval(fetchWifiList, 3000);

  $scope.autuSearchWifi = function () {
    $scope.isLoading = 'loading';
    $scope.wifitimer = $interval(fetchWifiList, 3000);
  };
  $scope.wifiIconWithStrength = function (strength) {
    var strNum = parseInt(strength);
    if (strNum === 0) {
      return '/images/icon_WiFi_04.png';
    } else if (strNum <= 25) {
      return '/images/icon_WiFi_03.png';
    } else if (strNum <= 60) {
      return '/images/icon_WiFi_02.png';
    } else if (strNum <= 75) {
      return '/images/icon_WiFi_01.png';
    } else if (strNum <= 100) {
      return '/images/icon_WiFi.png';
    }
  };
  $scope.pressedWifiItem = function (wifiItem) {
    location.href = "/#/enroll/wificonnect?MAC=" + wifiItem.MAC + "&" + location.hash.substring(location.hash.indexOf("installKey"));
  };
  $scope.pressedRefresh = function () {
    $scope.isLoading = 'loading';
    $scope.wifitimer = $interval(fetchWifiList, 3000);
  };
  $scope.pressedEnterWifi = function () {
    location.href = "/#/enroll/wificonnect?MAC=&" + location.hash.substring(location.hash.indexOf("installKey"));
  };
}]);
"use strict";

app.controller('ManageDidContentCtrl', ['$scope', '$rootScope', '$stateParams', '$interval', '$timeout', '$state', '$window', '$translate', 'Shop', 'DidFile', function ($scope, $rootScope, $stateParams, $interval, $timeout, $state, $window, $translate, Shop, DidFile) {
  $scope.didName = $stateParams.didName;
  $scope.shopName = $stateParams.shopName;
  $scope.editContType = 'all';
  $scope.isSavable = false;
  var didId = $stateParams.didId ? $stateParams.didId.replace('did:', '') : '';
  var shopId = $stateParams.shopId;
  var dragContId;
  var globalDatePicker = null;
  var currentGlobalCalInfo = {
    isEnd: false
  };
  var contDatePicker = null;
  var currentContCalInfo = {
    id: null,
    isEnd: false
  };
  var splitDatePicker = null;
  var currentSplitCalInfo = {
    isEnd: false
  };
  var regVideoPattern = /^.+\.(mp4|MP4)$/;
  var regImagePattern = /^.+\.(jpg|png|JPG|PNG)$/;
  var initValue = null;
  var VOLUME_KB = 1024;
  var VOLUME_MB = VOLUME_KB * VOLUME_KB;
  var VOLUME_GB = VOLUME_KB * VOLUME_MB;
  // ! 사용량 2.8GB 부터 빨강색 텍스트 처리
  var VOLUME_WARNING_SIZE = VOLUME_GB * 2.8;
  // ! 최대 사용량 2GB
  var MAX_SIZE = 3;
  var MAX_VOLUME_GB = VOLUME_GB * MAX_SIZE;
  $scope.calendarIdMap = {
    splitStartInput: 'splitStartInput',
    splitEndInput: 'splitEndInput',
    splitStartCont: 'splitStartCont',
    splitEndCont: 'splitEndCont',
    globalStartInput: 'globalStartInput',
    globalEndInput: 'globalEndInput',
    globalStartCont: 'globalStartCont',
    globalEndCont: 'globalEndCont',
    contentStartInput: 'contentSInput_',
    contentEndInput: 'contentEInput_',
    contentStartCont: 'contentSCont_',
    contentEndCont: 'contentECont_'
  };
  $scope.contentScheduleMap = {};
  $scope.selectedLayout = 'single'; //'split';
  $scope.contentList = [];
  $scope.serverContentList = [];
  $scope.sizeSumStr = '0MB';
  $scope.contSelectCount = 0;
  $scope.globalStartDate = '';
  $scope.globalStartDateWarning = false;
  $scope.globalEndDate = '';
  $scope.splitStartDate = '';
  $scope.splitEndDate = '';
  $scope.isWarningVolume = false;
  // ! 콘텐츠 사이즈
  $scope.sizeSumBite = 0;
  // ! 서버 콘텐츠 사이즈
  $scope.serverContentSizeSumBite = 0;
  $scope.serverContentMaxSize = VOLUME_GB * 5;
  // ! 최대용량 5GB
  $scope.maxSize = MAX_SIZE;
  // ! toast message
  $scope.toast = {
    hasToast: false,
    message: '',
    timeout: 0
  };
  $scope.isShowContTips = false;
  $scope.isShowVideoTips = false;
  $scope.isShowImgTips = false;
  $scope.isReloadChecked = false;
  $scope.singleModeStartDateWarning = false;
  $('body').css('minWidth', '1640px');
  $('body').addClass('wide_scroll');
  $scope.hasSplitDateGuide = function () {
    return !$scope.splitStartDate || !$scope.splitEndDate;
  };
  $scope.isValidSplitSave = function () {
    return $scope.videoContent && $scope.imgContent && $scope.splitStartDate && $scope.splitEndDate && $scope.checkSettingChanged();
  };
  $scope.changeShowToolTips = function () {
    var hasPerformance = performance && performance.navigation;

    // ! 페이지 새로고침시 미노출
    if (!$scope.isReloadChecked && hasPerformance && performance.navigation.type === PerformanceNavigation.TYPE_RELOAD) {
      $scope.isShowContTips = false;
      $scope.isShowVideoTips = false;
      $scope.isShowImgTips = false;
      $scope.isReloadChecked = true;
      return;
    }
    if ($scope.selectedLayout === 'split') {
      $scope.isShowContTips = false;
      // ! 소뱅 클릭시에만 노출 처리
      // $scope.isShowVideoTips = true;
      $scope.isShowVideoTips = false;
      $scope.isShowImgTips = false;
    } else {
      // ! 소뱅 클릭시에만 노출 처리
      // $scope.isShowContTips = true;
      $scope.isShowContTips = false;
      $scope.isShowVideoTips = false;
      $scope.isShowImgTips = false;
    }
  };
  $scope.showToastMessage = function (message) {
    $scope.toast.message = message;
    $scope.toast.hasToast = true;
    if ($scope.toast.timeout) {
      $timeout.cancel($scope.toast.timeout);
    }
    $scope.toast.timeout = $timeout(function () {
      $scope.toast.hasToast = false;
      $scope.toast.message = '';
    }, 1000 * 3);
  };
  $scope.changeLayout = function (layout) {
    $scope.selectedLayout = layout;
    $scope.sizeSumStr = '0MB';
    $scope.globalStartDate = '';
    $scope.globalEndDate = '';
    $scope.splitStartDate = '';
    $scope.splitEndDate = '';
    $scope.videoContent = null;
    $scope.imgContent = null;
    $scope.contentList = [];
    $scope.isWarningVolume = false;
    $scope.singleModeStartDateWarning = false;

    // ! 초기 진입시 툴팁 노출
    $timeout(function () {
      $scope.changeShowToolTips();
    });
  };
  $scope.selectLayout = function (layout) {
    var isInitEmpy = !initValue.contentList.length;
    var isChanged = $scope.checkSettingChanged(true);
    // ! 이전 설정값이 없는 경우
    if (isInitEmpy && !isChanged) {
      $scope.changeLayout(layout);
      return;
    }
    $rootScope.createConfirm({
      description: $translate.instant('mn1k4t8s_01753'),
      confirmText: $translate.instant('MSG_YES'),
      handler: function handler() {
        $scope.changeLayout(layout);
        $scope.$apply();
      }
    });
  };
  $scope.unsetContent = function (type) {
    if (type === 'video') {
      $scope.videoContent = null;
    } else {
      $scope.imgContent = null;
    }
    updateSizeSum();
  };
  $scope.showContentsDlg = function (type) {
    $scope.editContType = type;
    $scope.isShowDidContentsDialog = true;
  };
  $scope.checkSettingChanged = function (isPassCheckLayout) {
    var i, len, videoCont, imgCont;
    if (!initValue || !initValue.contentList || !initValue.selectedLayout) {
      return false;
    }
    if (!isPassCheckLayout) {
      if (initValue.selectedLayout !== $scope.selectedLayout) {
        return true;
      }
    }
    if (initValue.contentList.length !== $scope.contentList.length) {
      return true;
    }
    if ($scope.selectedLayout === 'split') {
      initValue.contentList.forEach(function (content) {
        if (regVideoPattern.test(content.fileName)) {
          videoCont = content;
        }
        if (regImagePattern.test(content.fileName)) {
          imgCont = content;
        }
      });
      if (!!videoCont !== !!$scope.videoContent || !!imgCont !== !!$scope.imgContent) {
        return true;
      }
      if (videoCont && $scope.videoContent && (videoCont.contentId !== $scope.videoContent.contentId || videoCont.schedule.startAt !== $scope.splitStartDate || videoCont.schedule.stopAt !== $scope.splitEndDate)) {
        return true;
      }
      if (imgCont && $scope.imgContent && (imgCont.contentId !== $scope.imgContent.contentId || imgCont.schedule.startAt !== $scope.splitStartDate || imgCont.schedule.stopAt !== $scope.splitEndDate)) {
        return true;
      }
    } else {
      for (i = 0, len = initValue.contentList.length; i < len; i += 1) {
        if (initValue.contentList[i].contentId !== $scope.contentList[i].contentId || initValue.contentList[i].duration !== $scope.contentList[i].duration || initValue.contentList[i].schedule.startAt !== $scope.contentScheduleMap[$scope.contentList[i].contentId].startAt || initValue.contentList[i].schedule.stopAt !== $scope.contentScheduleMap[$scope.contentList[i].contentId].stopAt) {
          return true;
        }
      }
    }
    return false;
  };
  var originStateGo = $state.go;
  $state.go = function (to, params, options) {
    if ($scope.checkSettingChanged()) {
      $rootScope.createConfirm({
        description: $translate.instant('mn1k4t8s_01750'),
        confirmText: $translate.instant('MSG_YES'),
        handler: function handler() {
          $state.go = originStateGo;
          $state.go(to, params, options);
        }
      });
    } else {
      $state.go = originStateGo;
      $state.go(to, params, options);
    }
  };
  function onBeforeunloadListener() {
    return '사이트에서 나가시겠습니까? 변경사항이 저장되지 않을 수 있습니다.';
  }
  $scope.$watch(function () {
    return $scope.checkSettingChanged();
  }, function () {
    if ($scope.checkSettingChanged()) {
      $(window).on('beforeunload', onBeforeunloadListener);
    } else {
      $(window).off('beforeunload', onBeforeunloadListener);
    }
  });
  $scope.goManageDid = function () {
    if ($scope.checkSettingChanged()) {
      $rootScope.createConfirm({
        description: $translate.instant('mn1k4t8s_01750'),
        confirmText: $translate.instant('MSG_YES'),
        handler: function handler() {
          $window.history.back();
        }
      });
    } else {
      $window.history.back();
    }
    //$state.go('main.manage.did');
  };
  $scope.removeSelectContent = function () {
    $scope.contentList = $scope.contentList.filter(function (cont) {
      return !cont.checked;
    });
    $scope.contSelectCount = 0;
    $scope.isAllChecked = false;
    updateSizeSum();
  };
  $scope.checkAllContents = function () {
    var i, len;
    $scope.isAllChecked = !$scope.isAllChecked;
    for (i = 0, len = $scope.contentList.length; i < len; i += 1) {
      $scope.contentList[i].checked = $scope.isAllChecked;
    }
    $scope.contSelectCount = $scope.isAllChecked ? $scope.contentList.length : 0;
  };
  $scope.checkContent = function (content) {
    content.checked = !content.checked;
    if (content.checked) {
      $scope.contSelectCount += 1;
    } else {
      $scope.contSelectCount -= 1;
    }
    var isSomeNotChecked = $scope.contentList.some(function (cont) {
      return !cont.checked;
    });
    $scope.isAllChecked = !isSomeNotChecked;
  };
  $scope.setConfigAllContents = function () {
    var pTime, updateList;
    if ($scope.globalPlayTime || $scope.globalStartDate && $scope.globalEndDate) {
      if ($scope.contSelectCount) {
        updateList = $scope.contentList.filter(function (cont) {
          return cont.checked;
        });
      } else {
        updateList = $scope.contentList;
      }
      updateList.forEach(function (content) {
        if ($scope.globalPlayTime) {
          pTime = parseInt($scope.globalPlayTime, 10);
          content.duration = pTime;
        }
        if ($scope.globalStartDate && $scope.globalEndDate) {
          content.schedule = {
            startAt: $scope.globalStartDate,
            stopAt: $scope.globalEndDate
          };
          $scope.contentScheduleMap[content.contentId] = {
            startAt: content.schedule.startAt,
            stopAt: content.schedule.stopAt,
            startDateWarning: $scope.globalStartDateWarning
          };
        }
      });
    }
  };
  function checkValidDate(startStr, endStr) {
    if (!startStr || !endStr) {
      return false;
    }
    var startArr = startStr.split('-');
    var endArr = endStr.split('-');
    var startDate = new Date();
    var endDate = new Date();
    startDate.setFullYear(startArr[0]);
    startDate.setMonth(parseInt(startArr[1], 10) - 1);
    startDate.setDate(startArr[2]);
    endDate.setFullYear(endArr[0]);
    endDate.setMonth(parseInt(endArr[1], 10) - 1);
    endDate.setDate(endArr[2]);
    return startDate <= endDate;
  }
  $scope.showSaveDidConfDlg = function () {
    var i, len;
    if ($scope.selectedLayout === 'split') {
      if (!$scope.videoContent || !$scope.imgContent) {
        return;
      }
      if ($scope.videoContent.isLoading || $scope.imgContent.isLoading) {
        $rootScope.createConfirm({
          description: $translate.instant("mn1k4t8s_01752"),
          noCloseBtn: true,
          btnCount: 1
        });
        return;
      }
    } else {
      for (i = 0, len = $scope.contentList.length; i < len; i += 1) {
        if ($scope.contentList[i].isLoading) {
          $rootScope.createConfirm({
            description: $translate.instant("mn1k4t8s_01752"),
            noCloseBtn: true,
            btnCount: 1
          });
          return;
        }
      }
    }
    $scope.saveDidConf();
  };
  $scope.saveDidConf = function () {
    var i, len, contentList;
    if ($scope.selectedLayout === 'split') {
      if (!$scope.videoContent || !$scope.imgContent) {
        return;
      }
      if (!checkValidDate($scope.splitStartDate, $scope.splitEndDate)) {
        $rootScope.createConfirm({
          description: $translate.instant("CLIPS_ERR_DATE_CONTENT"),
          noCloseBtn: true,
          btnCount: 1
        });
        return;
      }
      $scope.videoContent.schedule = {
        startAt: $scope.splitStartDate,
        stopAt: $scope.splitEndDate
      };
      $scope.imgContent.schedule = {
        startAt: $scope.splitStartDate,
        stopAt: $scope.splitEndDate
      };
      contentList = JSON.parse(JSON.stringify([$scope.videoContent, $scope.imgContent]));
    } else {
      contentList = JSON.parse(JSON.stringify($scope.contentList));
    }
    for (i = 0, len = contentList.length; i < len; i += 1) {
      contentList[i] = {
        contentId: contentList[i].contentId,
        userContentId: contentList[i].userContentId,
        duration: parseInt(contentList[i].duration, 10),
        schedule: {
          startAt: $scope.selectedLayout === 'split' ? contentList[i].schedule.startAt : $scope.contentScheduleMap[contentList[i].contentId].startAt,
          stopAt: $scope.selectedLayout === 'split' ? contentList[i].schedule.stopAt : $scope.contentScheduleMap[contentList[i].contentId].stopAt
        }
      };
      if (contentList[i].userContentId) {
        delete contentList[i].contentId;
      } else {
        delete contentList[i].userContentId;
      }
      if (!checkValidDate(contentList[i].schedule.startAt, contentList[i].schedule.stopAt)) {
        $rootScope.createConfirm({
          description: $translate.instant("CLIPS_ERR_DATE_CONTENT"),
          noCloseBtn: true,
          btnCount: 1
        });
        return;
      }
    }
    $.ajax({
      url: '/json/biz/dids/' + didId + '/v2/config',
      type: 'PUT',
      data: JSON.stringify({
        displayMode: $scope.selectedLayout === 'split' ? 1 : 0,
        content: contentList
      }),
      contentType: "application/json; charset=utf-8",
      dataType: "json",
      success: function success(data) {
        if (data.code === 'ok') {
          $scope.contSelectCount = 0;
          $scope.isAllChecked = false;
          fetchDidContents(false, true);
          $rootScope.createConfirm({
            description: $translate.instant("SAVE_COMPLETE"),
            noCloseBtn: true,
            btnCount: 1
          });
        } else {
          $rootScope.createConfirm({
            description: data.msg,
            noCloseBtn: true,
            btnCount: 1
          });
        }
      },
      error: function error() {
        $rootScope.createConfirm({
          title: $translate.instant("ACCESS_NET_FAIL"),
          description: $translate.instant("ACCESS_NET_FAIL_DESC"),
          noCloseBtn: true,
          btnCount: 1
        });
      }
    });
  };
  $scope.toggleAddOptions = function () {
    $scope.isShowAddOptions = !$scope.isShowAddOptions;
  };
  function updateSizeSum() {
    var sumBite = 0;
    if ($scope.selectedLayout === 'split') {
      sumBite = ($scope.videoContent ? $scope.videoContent.fileSize : 0) + ($scope.imgContent ? $scope.imgContent.fileSize : 0);
      if ($scope.videoContent) {
        $scope.videoContent.ellipseStart = ($scope.videoContent.fileName || '').replace(/[^\./]+$/, '');
        $scope.videoContent.ellipseEnd = (($scope.videoContent.fileName || '').match(/[^\./]+$/) || [])[0] || '';
      }
      if ($scope.imgContent) {
        $scope.imgContent.ellipseStart = ($scope.imgContent.fileName || '').replace(/[^\./]+$/, '');
        $scope.imgContent.ellipseEnd = (($scope.imgContent.fileName || '').match(/[^\./]+$/) || [])[0] || '';
      }
    } else {
      sumBite = $scope.contentList.reduce(function (acc, cont) {
        return acc + (cont.fileSize ? cont.fileSize : 0);
      }, 0);
      $scope.contentList.forEach(function (content) {
        content.ellipseStart = (content.fileName || '').replace(/[^\./]+$/, '');
        content.ellipseEnd = ((content.fileName || '').match(/[^\./]+$/) || [])[0] || '';
      });
    }
    if (sumBite >= VOLUME_GB) {
      $scope.sizeSumStr = Number((sumBite / VOLUME_GB).toFixed(3)).toFixed(2) + 'GB';
    } else if (sumBite >= VOLUME_MB) {
      $scope.sizeSumStr = Number((sumBite / VOLUME_MB).toFixed(3)).toFixed(2) + 'MB';
    } else {
      $scope.sizeSumStr = Number((sumBite / VOLUME_KB).toFixed(3)).toFixed(2) + 'KB';
    }
    if (!sumBite) {
      // ! 선택 항목이 없는 경우에 툴팁 노출
      $timeout(function () {
        $scope.changeShowToolTips();
      });
    }
    $scope.sizeSumBite = sumBite;
    $scope.isWarningVolume = sumBite >= VOLUME_WARNING_SIZE;
  }
  function fetchServerContents() {
    if ($rootScope.me && $rootScope.me.userId) {
      DidFile.api.getContents({
        userId: $rootScope.me.userId
      }, function (res) {
        $scope.serverContentList = res.content ? res.content : [];
        $scope.serverContentSizeSumBite = ($scope.serverContentList || []).reduce(function (acc, cont) {
          return acc + (cont.fileSize ? cont.fileSize : 0);
        }, 0);
      }, function (err) {
        $state.go = originStateGo;
        $state.go("main", {}, {
          reload: true
        });
      });
    } else {
      $state.go = originStateGo;
      $state.go("main", {}, {
        reload: true
      });
    }
  }
  $scope.$watch(function () {
    return $rootScope.me;
  }, function () {
    fetchServerContents();
  });
  function sanitizeDateFormat(date) {
    // YYYY-MM-DD
    return new Date(date.toLocaleDateString().replace('/\s./g', '-'));
  }
  function fetchDidContents(noFetchLayout, isInitial) {
    if (!noFetchLayout) {
      $scope.isLoading = true;
    }
    DidFile.api.getDidContents({
      didId: didId
    }, function (res) {
      if (res.code && res.code !== 'ok') {
        $state.go = originStateGo;
        $state.go("main", {}, {
          reload: true
        });
      } else {
        if (!noFetchLayout) {
          $scope.selectedLayout = res.displayMode === 1 ? 'split' : 'single';
          $scope.isLoading = false;
        }
        $scope.contentList = res.content ? res.content : [];
        $scope.videoContent = null;
        $scope.imgContent = null;
        $scope.contentScheduleMap = {};
        $scope.contentList.forEach(function (content) {
          $scope.contentScheduleMap[content.contentId] = {
            startAt: content.schedule.startAt,
            stopAt: content.schedule.stopAt,
            startDateWarning: false
          };
          if (!$scope.videoContent && regVideoPattern.test(content.fileName)) {
            $scope.videoContent = content;
            $scope.splitStartDate = $scope.videoContent.schedule.startAt;
            $scope.splitEndDate = $scope.videoContent.schedule.stopAt;
          }
          if (!$scope.imgContent && regImagePattern.test(content.fileName)) {
            $scope.imgContent = content;
          }
        });
        if (!$scope.splitStartDate || !$scope.splitEndDate) {
          var defaultSchedule = getDefaultSchedule();
          $scope.splitStartDate = defaultSchedule.startAt;
          $scope.splitEndDate = defaultSchedule.stopAt;
        }
        if (isInitial) {
          initValue = {
            selectedLayout: $scope.selectedLayout,
            contentList: JSON.parse(JSON.stringify($scope.contentList))
          };
        }
        fetchServerContents();
        updateSizeSum();
      }
    }, function (err) {
      $rootScope.createConfirm({
        title: $translate.instant("ACCESS_NET_FAIL"),
        description: $translate.instant("ACCESS_NET_FAIL_DESC"),
        noCloseBtn: true,
        btnCount: 1
      });
      if (!noFetchLayout) {
        $scope.isLoading = false;
      }
    });
  }
  function destroySplitCalendar() {
    if (splitDatePicker) {
      splitDatePicker.destroy();
      splitDatePicker = null;
    }
  }
  function buildSplitCalendar(isEnd) {
    var datePrefixId = isEnd ? $scope.calendarIdMap.splitEndInput : $scope.calendarIdMap.splitStartInput;
    var contPrefixId = isEnd ? $scope.calendarIdMap.splitEndCont : $scope.calendarIdMap.splitStartCont;
    var startDate = $scope.splitStartDate && new Date($scope.splitStartDate) || new Date();
    var endDate = $scope.splitEndDate && new Date($scope.splitEndDate);
    var minDate = isEnd ? sanitizeDateFormat(startDate) : sanitizeDateFormat(new Date());
    // ! 시작일의 maxDate 설정 사용시 활용
    // var maxDate = isEnd ? new Date('2099-12-31') : endDate;
    var maxDate = new Date('2099-12-31');
    var defaultDate = isEnd ? endDate : startDate;
    destroySplitCalendar();
    splitDatePicker = new Pikaday({
      field: document.getElementById(datePrefixId),
      container: document.getElementById(contPrefixId),
      format: 'YYYY-MM-DD',
      minDate: minDate,
      maxDate: maxDate,
      defaultDate: defaultDate,
      setDefaultDate: true,
      onDraw: function onDraw() {
        if (isEnd && this.getDate()) {
          var startOverSelectDate = sanitizeDateFormat(startDate).getTime() > sanitizeDateFormat(this.getDate()).getTime();
          $scope.splitStartDateWarning = startOverSelectDate;
          $scope.$apply();
        }
      },
      onSelect: function onSelect(date) {
        var startOverSelectDate = false;
        if (isEnd) {
          startOverSelectDate = sanitizeDateFormat(startDate).getTime() > sanitizeDateFormat(new Date(date)).getTime();
        } else {
          startOverSelectDate = sanitizeDateFormat(new Date(date)).getTime() > sanitizeDateFormat(endDate || maxDate).getTime();
        }
        $scope.splitStartDateWarning = startOverSelectDate;
        $scope.$apply();
      }
    });
    splitDatePicker.show();
  }
  function destroyGlobalCalendar() {
    if (globalDatePicker) {
      globalDatePicker.destroy();
      globalDatePicker = null;
    }
  }
  function buildGlobalCalendar(isEnd) {
    var datePrefixId = isEnd ? $scope.calendarIdMap.globalEndInput : $scope.calendarIdMap.globalStartInput;
    var contPrefixId = isEnd ? $scope.calendarIdMap.globalEndCont : $scope.calendarIdMap.globalStartCont;
    var startDate = $scope.globalStartDate && new Date($scope.globalStartDate) || new Date();
    var endDate = $scope.globalEndDate && new Date($scope.globalEndDate);
    var minDate = isEnd ? sanitizeDateFormat(startDate) : sanitizeDateFormat(new Date());
    // ! 시작일의 maxDate 설정 사용시 활용
    // var maxDate = isEnd ? new Date('2099-12-31') : endDate;
    var maxDate = new Date('2099-12-31');
    var defaultDate = isEnd ? endDate : startDate;
    destroyGlobalCalendar();
    globalDatePicker = new Pikaday({
      field: document.getElementById(datePrefixId),
      container: document.getElementById(contPrefixId),
      format: 'YYYY-MM-DD',
      minDate: minDate,
      maxDate: maxDate,
      defaultDate: defaultDate,
      setDefaultDate: true,
      onDraw: function onDraw() {
        if (isEnd && this.getDate()) {
          var startOverSelectDate = sanitizeDateFormat(startDate).getTime() > sanitizeDateFormat(this.getDate()).getTime();
          $scope.globalStartDateWarning = startOverSelectDate;
          $scope.singleModeStartDateWarning = startOverSelectDate;
          $scope.$apply();
        }
      },
      onSelect: function onSelect(date) {
        var startOverSelectDate = false;
        if (isEnd) {
          startOverSelectDate = sanitizeDateFormat(startDate).getTime() > sanitizeDateFormat(new Date(date)).getTime();
        } else {
          startOverSelectDate = sanitizeDateFormat(new Date(date)).getTime() > sanitizeDateFormat(endDate || maxDate).getTime();
        }
        $scope.globalStartDateWarning = startOverSelectDate;
        $scope.singleModeStartDateWarning = startOverSelectDate;
        $scope.$apply();
      }
    });
    globalDatePicker.show();
  }
  function destroyContCalendar() {
    if (contDatePicker) {
      contDatePicker.destroy();
      contDatePicker = null;
    }
  }
  function buildContCalendar(contentId, isEnd) {
    var datePrefixId = isEnd ? $scope.calendarIdMap.contentEndInput : $scope.calendarIdMap.contentStartInput;
    var contPrefixId = isEnd ? $scope.calendarIdMap.contentEndCont : $scope.calendarIdMap.contentStartCont;
    var schedule = $scope.contentScheduleMap[contentId];
    var startDate = schedule.startAt && new Date(schedule.startAt) || new Date();
    var endDate = schedule.stopAt && new Date(schedule.stopAt) || new Date();
    var minDate = isEnd ? sanitizeDateFormat(startDate) : sanitizeDateFormat(new Date());
    // ! 시작일의 maxDate 설정 사용시 활용
    // var maxDate = isEnd ? new Date('2099-12-31') : endDate;
    var maxDate = new Date('2099-12-31');
    var defaultDate = isEnd ? endDate : startDate;
    destroyContCalendar();
    contDatePicker = new Pikaday({
      field: document.getElementById(datePrefixId + contentId),
      container: document.getElementById(contPrefixId + contentId),
      format: 'YYYY-MM-DD',
      minDate: minDate,
      maxDate: maxDate,
      defaultDate: defaultDate,
      setDefaultDate: true,
      onDraw: function onDraw() {
        if (isEnd && this.getDate()) {
          var startOverSelectDate = sanitizeDateFormat(startDate).getTime() > sanitizeDateFormat(this.getDate()).getTime();
          $scope.contentScheduleMap[contentId].startDateWarning = startOverSelectDate;
          if (startOverSelectDate) {
            $scope.singleModeStartDateWarning = true;
          } else {
            var hasStartDateWarning = false;
            var content;
            for (content in $scope.contentScheduleMap) {
              if (content.startDateWarning) {
                hasStartDateWarning = true;
                break;
              }
            }
            $scope.singleModeStartDateWarning = hasStartDateWarning;
          }
          $scope.$apply();
        }
      },
      onSelect: function onSelect(date) {
        var startOverSelectDate = false;
        if (isEnd) {
          startOverSelectDate = sanitizeDateFormat(startDate).getTime() > sanitizeDateFormat(new Date(date)).getTime();
        } else {
          startOverSelectDate = sanitizeDateFormat(new Date(date)).getTime() > sanitizeDateFormat(endDate || maxDate).getTime();
        }
        $scope.contentScheduleMap[contentId].startDateWarning = startOverSelectDate;
        if (startOverSelectDate) {
          $scope.singleModeStartDateWarning = true;
        } else {
          var hasStartDateWarning = false;
          var content;
          for (content in $scope.contentScheduleMap) {
            if (content.startDateWarning) {
              hasStartDateWarning = true;
              break;
            }
          }
          $scope.singleModeStartDateWarning = hasStartDateWarning;
        }
        $scope.$apply();
      }
    });
    contDatePicker.show();
  }
  $scope.toggleSplitCalendar = function (isEnd, evt) {
    if (currentSplitCalInfo.isEnd === isEnd && splitDatePicker) {
      destroySplitCalendar();
    } else {
      buildSplitCalendar(isEnd);
    }
    currentSplitCalInfo.isEnd = isEnd;
    if (evt) {
      evt.stopPropagation();
    }
  };
  $scope.toggleGlobalCalendar = function (isEnd, evt) {
    if (currentGlobalCalInfo.isEnd === isEnd && globalDatePicker) {
      destroyGlobalCalendar();
    } else {
      buildGlobalCalendar(isEnd);
    }
    currentGlobalCalInfo.isEnd = isEnd;
    if (evt) {
      evt.stopPropagation();
    }
  };
  $scope.toggleContentCalendar = function (contentId, isEnd, evt) {
    if (currentContCalInfo.id === contentId && currentContCalInfo.isEnd === isEnd && contDatePicker) {
      destroyContCalendar();
    } else {
      buildContCalendar(contentId, isEnd);
    }
    currentContCalInfo.id = contentId;
    currentContCalInfo.isEnd = isEnd;
    if (evt) {
      evt.stopPropagation();
    }
  };
  $scope.fileChangeHandler = function () {
    var uploadId = makeMsgId();
    var hasSameFile = false;
    var file, fileName, fileSize;

    // ! 파일 유효성 체크
    if (this.files && this.files[0]) {
      file = this.files[0];
      fileName = unorm.nfc(file.name.replace(/([^\./]+$)/, function ($1) {
        return $1.toLocaleLowerCase();
      }));
      fileSize = file.size;
      hasSameFile = false;

      // ! 용량 제한
      if (fileSize && fileSize > VOLUME_GB * 2) {
        $rootScope.createConfirm({
          description: $translate.instant('mn1k4t8s_01751'),
          confirmText: $translate.instant('mn1k4t8s_01707'),
          noCloseBtn: true,
          btnCount: 1
        });
        this.value = null;
        return $scope.$apply();
      }

      // ! 최대 콘텐츠 보관함 사용 용량
      if ($scope.serverContentSizeSumBite + fileSize > $scope.serverContentMaxSize) {
        // $scope.showToastMessage('콘텐츠 보관함 용량은 최대 5GB까지 업로드 가능합니다.');
        $scope.showToastMessage($translate.instant('mn1k4t8s_01765'));
        this.value = null;
        return $scope.$apply();
      }

      // ! 최대 사용 용량
      if ($scope.sizeSumBite + fileSize > MAX_VOLUME_GB) {
        // $scope.showToastMessage('최대 ' + $scope.maxSize + 'GB까지 업로드 가능합니다');
        $scope.showToastMessage($translate.instant('mn1k4t8s_01761').replace(/\dGB/, $scope.maxSize + 'GB'));
        this.value = null;
        return $scope.$apply();
      }

      // ! 파일명 업로드 불가 특수문자 포함 체크
      var invalidSpecialChar = /[!@#$%^&*(),?":{}|<>]/gi.test(fileName);
      if (invalidSpecialChar) {
        // 파일명에는 ~ 허용가능한 특수문자 안내 문구 노출
        $rootScope.createConfirm({
          title: $translate.instant('mn1k4t8s_01780'),
          description: $translate.instant('mn1k4t8s_01778'),
          confirmText: $translate.instant('mn1k4t8s_01707'),
          noCloseBtn: false,
          btnCount: 1
        });
        this.value = null;
        return $scope.$apply();
      }

      // ! 동일한 파일명 체크
      $scope.serverContentList.forEach(function (content) {
        if (unorm.nfc(content.name) === fileName) {
          hasSameFile = true;
          return;
        }
      });
      $scope.contentList.forEach(function (content) {
        if (unorm.nfc(content.name) === fileName) {
          hasSameFile = true;
          return;
        }
      });
      if (hasSameFile) {
        // $scope.showToastMessage('동일한 이름의 파일이 있습니다. 확인 후 다시 추가해주세요.');
        $scope.showToastMessage($translate.instant('mn1k4t8s_01763'));
        this.value = null;
        return $scope.$apply();
      }
    }
    if (this.id === 'video_upload') {
      if (!this.value || !regVideoPattern.test(this.value)) {
        $rootScope.createConfirm({
          description: $translate.instant('5mw2slvk_02207'),
          noCloseBtn: true,
          btnCount: 1
        });
        this.value = null;
        return $scope.$apply();
      }
      uploadId += this.id;
      $scope.videoContent = {
        fileName: this.value,
        isLoading: true,
        isChecked: false,
        percent: 0,
        uploadId: uploadId
      };
    } else if (this.id === 'img_upload') {
      if (!this.value || !regImagePattern.test(this.value)) {
        $rootScope.createConfirm({
          description: $translate.instant('5mw2slvk_02208'),
          noCloseBtn: true,
          btnCount: 1
        });
        this.value = null;
        return $scope.$apply();
      }
      uploadId += this.id;
      $scope.imgContent = {
        fileName: this.value,
        isLoading: true,
        isChecked: false,
        percent: 0,
        uploadId: uploadId
      };
    } else {
      if (!this.value || !(regVideoPattern.test(this.value) || regImagePattern.test(this.value))) {
        $rootScope.createConfirm({
          description: $translate.instant('5mw2slvk_02206'),
          noCloseBtn: true,
          btnCount: 1
        });
        this.value = null;
        return $scope.$apply();
      }
      $scope.contentList.push({
        fileName: this.value,
        ellipseStart: (this.value || '').replace(/[^\./]+$/, ''),
        ellipseEnd: ((this.value || '').match(/[^\./]+$/) || [])[0] || '',
        isLoading: true,
        isChecked: false,
        percent: 0,
        uploadId: uploadId
      });
    }
    $scope.$apply();
    DidFile.uploadFile(this, uploadId);
  };
  function makeMsgId() {
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for (var i = 0; i < 30; i++) text += possible.charAt(Math.floor(Math.random() * possible.length));
    return text;
  }
  function globalClickCallback(event) {
    var isUpdate = false;
    if ($scope.isShowAddOptions) {
      if (event.target.className.indexOf('did-add-wrap__btn') === -1) {
        $scope.isShowAddOptions = false;
        isUpdate = true;
      }
    }
    if ($scope.isShowVideoOptions) {
      if (event.target.className.indexOf('videolink') === -1) {
        $scope.isShowVideoOptions = false;
        isUpdate = true;
      }
    }
    if ($scope.isShowImgOptions) {
      if (event.target.className.indexOf('imglink') === -1) {
        $scope.isShowImgOptions = false;
        isUpdate = true;
      }
    }
    if ($scope.isShowContOptions) {
      if (event.target.className.indexOf('contopt') === -1) {
        $scope.isShowContOptions = false;
        isUpdate = true;
      }
    }
    if ($scope.isShowContTips) {
      if (event.target.className.indexOf('tiplink') === -1) {
        $scope.isShowContTips = false;
        isUpdate = true;
      }
    }
    if ($scope.isShowVideoTips) {
      if (event.target.className.indexOf('tiplink-video') === -1) {
        $scope.isShowVideoTips = false;
        isUpdate = true;
      }
    }
    if ($scope.isShowImgTips) {
      if (event.target.className.indexOf('tiplink-img') === -1) {
        $scope.isShowImgTips = false;
        isUpdate = true;
      }
    }
    if (isUpdate) {
      $scope.$apply();
    }
  }
  window.didContDragStart = function (ev) {
    dragContId = ev.currentTarget.getAttribute('data-id');
    var i, len, content;
    for (i = 0, len = $scope.contentList.length; i < len; i += 1) {
      if ($scope.contentList[i].contentId === dragContId) {
        content = $scope.contentList[i];
      }
    }
    if (content.isLoading || content.isUploadFail) {
      ev.preventDefault();
      return false;
    }
  };
  window.didContDrop = function (ev) {
    var i, len, dragIdx, targetIdx, tempItem, targetId;
    ev.preventDefault();
    if (!dragContId) {
      return;
    }
    var targetId = ev.currentTarget.getAttribute('data-id');
    var isDraggerHeader = ev.currentTarget.getAttribute('data-dragger-header') === 'Y';
    if (ev.currentTarget.className.indexOf('dropped') !== -1) {
      if (isDraggerHeader) {
        $(ev.currentTarget).removeClass('dropped');
      } else {
        ev.currentTarget.className = 'content-wrap';
      }
    }
    if (!isDraggerHeader) {
      if (!targetId || dragContId === targetId) {
        return;
      }
    }
    for (i = 0, len = $scope.contentList.length; i < len; i += 1) {
      if ($scope.contentList[i].contentId === dragContId) {
        dragIdx = i;
        break;
      }
    }
    if (dragIdx === undefined) {
      return;
    }
    tempItem = $scope.contentList.splice(dragIdx, 1);
    for (i = 0, len = $scope.contentList.length; i < len; i += 1) {
      if ($scope.contentList[i].contentId === targetId) {
        targetIdx = i;
        break;
      }
    }
    if (isDraggerHeader) {
      var updateList = [tempItem[0]];
      $scope.contentList = updateList.concat($scope.contentList);
    } else {
      if (targetIdx !== undefined) {
        $scope.contentList.splice(targetIdx + 1, 0, tempItem[0]);
      }
    }
    $scope.isSavable = true;
    $scope.$apply();
  };
  window.didContAllowDrop = function (ev) {
    var isDraggerHeader = ev.currentTarget.getAttribute('data-dragger-header') === 'Y';
    if (ev.currentTarget.className.indexOf('dropped') === -1) {
      if (isDraggerHeader) {
        $(ev.currentTarget).addClass('dropped');
      } else {
        ev.currentTarget.className = 'content-wrap dropped';
      }
    }
    ev.preventDefault();
  };
  window.didContLeaveDrop = function (ev) {
    var isDraggerHeader = ev.currentTarget.getAttribute('data-dragger-header') === 'Y';
    if (ev.currentTarget.className.indexOf('dropped') !== -1) {
      if (isDraggerHeader) {
        $(ev.currentTarget).removeClass('dropped');
      } else {
        ev.currentTarget.className = 'content-wrap';
      }
    }
    ev.preventDefault();
  };
  $('body').on('click', globalClickCallback);
  if (didId && shopId) {
    fetchDidContents(false, true);
  }
  function getDefaultSchedule() {
    var today = new Date();
    var prevDate = new Date();
    var nextDate = new Date();
    // ! 정책 변경 - 기본 시작일은 당일
    // prevDate.setDate(today.getDate() - 30);
    nextDate.setDate(today.getDate() + 30);
    var py = prevDate.getFullYear();
    var pm = prevDate.getMonth() + 1;
    var pd = prevDate.getDate();
    var ny = nextDate.getFullYear();
    var nm = nextDate.getMonth() + 1;
    var nd = nextDate.getDate();
    return {
      startAt: py + '-' + (pm < 10 ? '0' + pm : pm) + '-' + (pd < 10 ? '0' + pd : pd),
      stopAt: ny + '-' + (nm < 10 ? '0' + nm : nm) + '-' + (nd < 10 ? '0' + nd : nd)
    };
  }

  // ! 서버 콘텐츠 보관함에서 선택 > 완료 클릭 시점
  $scope.$on('saveContents', function (event, data) {
    var contents = data.contents;
    var defaultSchedule = getDefaultSchedule();
    var hasSameFile = false;
    var fileName, fileSize;
    contents.forEach(function (content) {
      content.schedule = {
        startAt: defaultSchedule.startAt,
        stopAt: defaultSchedule.stopAt
      };
      content.duration = 10;
      content.userContentId = content.contentId;
      $scope.contentScheduleMap[content.contentId] = {
        startAt: content.schedule.startAt,
        stopAt: content.schedule.stopAt,
        startDateWarning: false
      };
    });
    if ($scope.editContType === 'video') {
      if (!contents.length || !regVideoPattern.test(contents[0].fileName)) {
        $rootScope.createConfirm({
          description: $translate.instant('5mw2slvk_02207'),
          noCloseBtn: true,
          btnCount: 1
        });
        return;
      }
      $scope.videoContent = contents[0];
    } else if ($scope.editContType === 'img') {
      if (!contents.length || !regImagePattern.test(contents[0].fileName)) {
        $rootScope.createConfirm({
          description: $translate.instant('5mw2slvk_02208'),
          noCloseBtn: true,
          btnCount: 1
        });
        return;
      }
      $scope.imgContent = contents[0];
    } else {
      fileSize = contents.reduce(function (acc, cont) {
        return acc + (cont.fileSize ? cont.fileSize : 0);
      }, 0);

      // ! 최대 사용 용량
      if ($scope.sizeSumBite + fileSize > MAX_VOLUME_GB) {
        // $scope.showToastMessage('최대 ' + $scope.maxSize + 'GB까지 업로드 가능합니다');
        $scope.showToastMessage($translate.instant('mn1k4t8s_01761').replace(/\dGB/, $scope.maxSize + 'GB'));
        return;
      }

      // ! 동일한 파일명 체크
      $scope.serverContentList.forEach(function (content) {
        if (unorm.nfc(content.name) === fileName) {
          hasSameFile = true;
          return;
        }
      });
      $scope.contentList.forEach(function (content) {
        fileName = unorm.nfc(content.name);
        contents.forEach(function (addContent) {
          if (fileName === unorm.nfc(addContent.name)) {
            hasSameFile = true;
            return;
          }
        });
      });
      if (hasSameFile) {
        // $scope.showToastMessage('동일한 이름의 파일이 있습니다. 확인 후 다시 추가해주세요.');
        $scope.showToastMessage($translate.instant('mn1k4t8s_01763'));
        return;
      }
      $scope.contentList = $scope.contentList.concat(contents);
    }
    updateSizeSum();
  });
  $scope.removeUploadFailCont = function (content) {
    var i, len;
    for (i = 0, len = $scope.contentList.length; i < len; i += 1) {
      if ($scope.contentList[i].uploadId === content.uploadId) {
        $scope.contentList.splice(i, 1);
        return;
      }
    }
  };
  $scope.$on('did-file-upload', function (event, data) {
    var i,
      len,
      content = null;
    if (data.uploadId.indexOf('video_upload') !== -1) {
      content = $scope.videoContent;
    } else if (data.uploadId.indexOf('img_upload') !== -1) {
      content = $scope.imgContent;
    } else {
      for (i = 0, len = $scope.contentList.length; i < len; i += 1) {
        if ($scope.contentList[i].uploadId === data.uploadId) {
          content = $scope.contentList[i];
        }
      }
    }
    if (!content) {
      return;
    }
    if (data.type === 'progress') {
      content.percent = data.data;
      $scope.$apply();
    } else if (data.type === 'result') {
      fetchServerContents();
      if (data.result) {
        var defaultSchedule = getDefaultSchedule();
        delete content.isLoading;
        delete content.percent;
        delete content.uploadId;
        content.contentId = data.content.contentId;
        content.fileName = data.content.fileName;
        content.ellipseStart = (content.fileName || '').replace(/[^\./]+$/, '');
        content.ellipseEnd = ((content.fileName || '').match(/[^\./]+$/) || [])[0] || '';
        content.filePath = data.content.filePath;
        content.fileSize = data.content.fileSize;
        content.fileType = data.content.fileType;
        content.schedule = {
          startAt: defaultSchedule.startAt,
          stopAt: defaultSchedule.stopAt
        };
        content.duration = 10;
        content.userContentId = content.contentId;
        $scope.contentScheduleMap[content.contentId] = {
          startAt: defaultSchedule.startAt,
          stopAt: defaultSchedule.stopAt,
          startDateWarning: false
        };
        updateSizeSum();
      } else {
        delete content.isLoading;
        delete content.percent;
        content.isUploadFail = true;
      }
      $scope.$apply();
    }
  });

  // $scope.$on('$stateChangeStart', function(event, toState) {
  // });

  $scope.$on('$destroy', function () {
    $rootScope.destroyConfirm();
    $('body').css('minWidth', '');
    $('body').removeClass('wide_scroll');
    $('body').off('click', globalClickCallback);
    destroySplitCalendar();
    destroyGlobalCalendar();
    destroyContCalendar();
    window.didContDragStart = null;
    window.didContDrop = null;
    window.didContAllowDrop = null;
    window.didContLeaveDrop = null;
    $state.go = originStateGo;
    $(window).off('beforeunload', onBeforeunloadListener);
  });
}]);
"use strict";

app.controller("ManageDidCtrl", ["$scope", "$rootScope", "$interval", "$timeout", "$state", "$translate", "Shop", "DidFile", "User", function ($scope, $rootScope, $interval, $timeout, $state, $translate, Shop, DidFile, User) {
  var myShops = [];
  var sharedShops = [];
  $scope.currentShops = [];
  $scope.selectedTab = "my"; //'shared';
  $scope.isLoading = false;
  $scope.selectedDidId = "";
  $scope.contentsLength = 0;

  // did dtv interface
  $scope.isManage = true;
  $scope.isShared = false;
  $scope.selectDid = null;
  $scope.shopObject = null;
  $scope.isShowDidSetDialog = false;
  $scope.selectTab = function (tab) {
    $scope.selectedTab = tab;
    $scope.currentShops = $scope.selectedTab === "my" ? myShops : sharedShops;
  };
  $scope.setCurrentDid = function (did, shop) {
    $scope.isShared = !shop.isOwner;
    $timeout(function () {
      $scope.selectedDidId = $scope.selectedDidId === did.id ? "" : did.id;
    }, 0);
  };
  $scope.openContentSet = function (did, shop, evt) {
    evt.stopPropagation();
    if (!$rootScope.me || !$rootScope.me.useDid) {
      $rootScope.createConfirm({
        description: $translate.instant("mn1k4t8s_01754"),
        noCloseBtn: true,
        btnCount: 1
      });
      return;
    }
    $scope.selectedDidId = "";
    $state.go("main.manage.didcontents", {
      didId: did.id,
      shopId: shop.shopId,
      didName: did.labelName,
      shopName: shop.shopName
    });
  };
  $scope.openDidDetail = function (did, shop, evt) {
    evt.stopPropagation();
    $scope.selectedDidId = "";
    if (!did || !shop) {
      return;
    }
    $scope.isShared = !shop.isOwner;
    $scope.selectDid = did;
    $scope.shopObject = shop;
    $scope.isShowDidSetDialog = true;
  };
  $scope.showContentsDlg = function () {
    if (!$rootScope.me || !$rootScope.me.useDid) {
      $rootScope.createConfirm({
        description: $translate.instant("mn1k4t8s_01754"),
        noCloseBtn: true,
        btnCount: 1
      });
      return;
    }
    $scope.isContentEdit = true;
    $scope.isShowDidContentsDialog = true;
  };
  function fetchDids() {
    myShops = [];
    sharedShops = [];
    $scope.currentShops = [];
    $scope.isLoading = true;
    Shop.getDids(function (res) {
      if (res.code === "ok" && res.shops) {
        res.shops.forEach(function (shop) {
          if (shop.isOwner) {
            myShops.push(shop);
          } else {
            sharedShops.push(shop);
          }
        });
        $scope.currentShops = myShops;
      }
      $scope.isLoading = false;
    }, function (err) {
      $scope.isLoading = false;
    });
  }
  function fetchDidContents() {
    if (!$rootScope.me) {
      return;
    }
    DidFile.api.getContents({
      userId: $rootScope.me.userId
    }, function (res) {
      $scope.contentsLength = res.content ? res.content.length : 0;
    }, function (err) {});
  }
  function globalClickCallback(event) {
    if ($scope.selectedDidId) {
      if (event.target.className.indexOf("sensor_object") === -1) {
        $scope.selectedDidId = "";
        $scope.$apply();
      }
    }
  }
  fetchDids();
  User.me(function (data) {
    if (data.code === "ok") {
      $rootScope.me = data;
      fetchDidContents();
    }
  });
  $("body").on("click", globalClickCallback);
  $scope.$on("didUpdate", fetchDids);
  $scope.$on("didContentsChanged", function (evt, data) {
    $scope.contentsLength = data ? data : 0;
  });
  $scope.$on("$destroy", function () {
    $("body").off("click", globalClickCallback);
    myShops = [];
    sharedShops = [];
    $scope.currentShops = [];
  });
}]);
"use strict";

app.controller('ManageDoorlockCtrl', ['$scope', '$rootScope', '$interval', '$state', '$translate', 'Doorlock', 'Shop', function ($scope, $rootScope, $interval, $state, $translate, Doorlock, Shop) {
  var myShops = [];
  var sharedShops = [];
  $scope.currentShops = [];
  $scope.selectedTab = 'my'; //'shared';
  $scope.isLoading = false;
  $scope.isLoadShop = false;
  $scope.shopObjectMap = {};
  // sensor dtv interface
  $scope.isManage = true;
  $scope.shopObject = null;
  $scope.isShared = false;
  $scope.selectSensor = null;
  $scope.isShowSensorSetDialog = false;
  $scope.cameraList = [];
  $scope.$on('deviceUpdate', function () {
    fetchSensors(true);
  });
  $scope.selectTab = function (tab) {
    $scope.selectedTab = tab;
    $scope.currentShops = $scope.selectedTab === 'my' ? myShops : sharedShops;
  };
  $scope.selectSensorItem = function (sensor, shop) {
    $scope.selectSensor = sensor;
    $scope.selectSensor.id = $scope.selectSensor.sensorId;
    if ($scope.shopObjectMap[shop.shopId]) {
      showSensorDtv($scope.shopObjectMap[shop.shopId]);
    } else {
      $scope.isLoadShop = true;
      Shop.dashboardShopV4({
        shopId: shop.shopId
      }).$promise.then(function (res) {
        $scope.isLoadShop = false;
        if (res.shop) {
          $scope.shopObjectMap[shop.shopId] = res.shop;
          showSensorDtv(res.shop);
        }
      }, function (err) {
        $scope.isLoadShop = false;
      });
    }
  };
  function showSensorDtv(shop) {
    $scope.cameraList = [];
    $scope.shopObject = shop;
    if ($scope.shopObject) {
      $scope.isShared = !!$scope.shopObject.shareId;
      if ($scope.shopObject.controllerList) {
        $scope.shopObject.controllerList.forEach(function (controller) {
          if (controller.deviceType === 'CAMERA') {
            $scope.cameraList.push(controller.cameraInfo);
          }
        });
      }
    }
    $scope.isShowSensorSetDialog = true;
  }
  function fetchSensors() {
    myShops = [];
    sharedShops = [];
    $scope.currentShops = [];
    $scope.isLoading = true;
    Doorlock.getDoorlocks(function (res) {
      if (res.code === 'ok' && res.shops) {
        res.shops.forEach(function (shop) {
          if (shop.isOwner) {
            myShops.push(shop);
          } else {
            sharedShops.push(shop);
          }
        });
        $scope.currentShops = myShops;
      }
      $scope.isLoading = false;
    }, function (err) {
      $scope.isLoading = false;
    });
  }
  fetchSensors();
  $scope.$on('$destroy', function () {
    myShops = [];
    sharedShops = [];
    $scope.currentShops = [];
  });
}]);
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
app.controller("ManageCtrl", ["$scope", "$rootScope", "User", "$location", ( /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee($scope, $rootScope, User, $location) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}())]);
"use strict";

app.controller("ManageIothubCtrl", ["$scope", "$rootScope", "$interval", "$state", "$translate", "Shop", "Device", function ($scope, $rootScope, $interval, $state, $translate, Shop, Device) {
  var myShops = [];
  var sharedShops = [];
  var selectShop = null;
  $scope.noShops = [];
  $scope.currentShops = [];
  $scope.selectedTab = "my"; //'shared', 'none';
  $scope.isLoading = false;
  $scope.shopObjectMap = {};

  //iothub dtv interface
  $scope.isShared = false;
  $scope.selectIotHubConfig = null;
  $scope.isShowIothubSetDialog = false;
  // sensor dtv interface
  $scope.isManage = false;
  $scope.shopObject = null;
  $scope.selectSensor = null;
  $scope.isShowSensorSetDialog = false;
  $scope.cameraList = [];
  $scope.$on("deviceUpdate", function () {
    fetchIotHubs(true);
  });
  $scope.selectSensorItem = function (sensor, shop) {
    $scope.selectSensor = sensor;
    $scope.selectSensor.id = $scope.selectSensor.sensorId;
    if ($scope.shopObjectMap[shop.shopId]) {
      showSensorDtv($scope.shopObjectMap[shop.shopId]);
    } else {
      $scope.isLoadHub = true;
      Shop.dashboardShopV4({
        shopId: shop.shopId
      }).$promise.then(function (res) {
        $scope.isLoadHub = false;
        if (res.shop) {
          $scope.shopObjectMap[shop.shopId] = res.shop;
          showSensorDtv(res.shop);
        }
      }, function (err) {
        $scope.isLoadHub = false;
      });
    }
  };
  function showSensorDtv(shop) {
    $scope.cameraList = [];
    $scope.shopObject = shop;
    if ($scope.shopObject) {
      $scope.isShared = !!$scope.shopObject.shareId;
      if ($scope.shopObject.controllerList) {
        $scope.shopObject.controllerList.forEach(function (controller) {
          if (controller.deviceType === "CAMERA") {
            $scope.cameraList.push(controller.cameraInfo);
          }
        });
      }
    }
    $scope.isShowIothubSetDialog = false;
    $scope.isShowSensorSetDialog = true;
  }
  $scope.$on("sensorDetail", function (event, sensorId) {
    if ($scope.selectIotHubConfig.sensors) {
      var foundSensor = null;
      $scope.selectIotHubConfig.sensors.some(function (sensor) {
        if (sensor.sensorId === sensorId) {
          foundSensor = sensor;
        }
        return sensor.sensorId === sensorId;
      });
      if (foundSensor) {
        $scope.selectSensorItem(foundSensor, selectShop);
      }
    }
  });
  $scope.selectTab = function (tab) {
    $scope.selectedTab = tab;
    if ($scope.selectedTab === "my") {
      $scope.currentShops = myShops;
    } else if ($scope.selectedTab === "shared") {
      $scope.currentShops = sharedShops;
    } else {
      $scope.currentShops = $scope.noShops;
    }
  };
  $scope.selectDev = function (device, shop) {
    selectShop = shop;
    $scope.isShared = shop.isShared;
    $scope.isLoadHub = true;
    Device.deviceConfig({
      deviceType: "IOTHUB",
      deviceId: device.id
    }, function (res) {
      $scope.isLoadHub = false;
      $scope.selectIotHubConfig = res.config;
      $scope.isShowIothubSetDialog = true;
    }, function (error) {
      $scope.isLoadHub = false;
      showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
    });
  };
  function fetchIotHubs() {
    myShops = [];
    sharedShops = [];
    $scope.noShops = [];
    $scope.currentShops = [];
    $scope.isLoading = true;
    Shop.getIothubs(function (res) {
      if (res.code === "ok" && res.shops) {
        res.shops.forEach(function (shop) {
          if (shop.shopId) {
            if (!shop.isShared) {
              myShops.push(shop);
            } else {
              sharedShops.push(shop);
            }
          } else {
            $scope.noShops.push(shop);
          }
        });
        if ($scope.selectedTab === "my") {
          $scope.currentShops = myShops;
        } else if ($scope.selectedTab === "shared") {
          $scope.currentShops = sharedShops;
        } else {
          $scope.currentShops = $scope.noShops;
        }
      }
      $scope.isLoading = false;
    }, function (err) {
      $scope.isLoading = false;
    });
  }
  fetchIotHubs();
  $scope.$on("$destroy", function () {
    myShops = [];
    sharedShops = [];
    $scope.currentShops = [];
  });
}]);
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
app.controller("ManageMenuCtrl", ["$scope", "$rootScope", "$location", "$state", "$translate", "$q", "AiFace", "DomainUtils", "User", "Utils", ( /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2($scope, $rootScope, $location, $state, $translate, $q, AiFace, DomainUtils, User, Utils) {
    var _$rootScope$extraServ;
    var isExtraServiceInit, fetchExtraService, getManagePath, path, checkAiFaceRecvAccounts;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          checkAiFaceRecvAccounts = function _checkAiFaceRecvAccou() {
            var deferred = $q.defer();
            AiFace.recievedAccounts().$promise.then(function (res) {
              if (res.code === "ok" && res.accounts && res.accounts.length) {
                deferred.resolve();
              } else {
                deferred.reject();
              }
            }, function (err) {
              deferred.reject();
            });
            return deferred.promise;
          };
          $scope.getPath = $location.path();
          $scope.isShowAiFaceServiceRegDialog = false;
          $scope.selectedAccount = null;
          $scope.countryDomain = $rootScope.countryDomain;
          $scope.aiMenuShow = DomainUtils.isAllowedAiDomain();
          $rootScope.$watch("countryDomain", function (newValue) {
            $scope.countryDomain = newValue;
          });
          isExtraServiceInit = ((_$rootScope$extraServ = $rootScope.extraService) === null || _$rootScope$extraServ === void 0 ? void 0 : _$rootScope$extraServ.useIotHub) !== undefined;
          fetchExtraService = /*#__PURE__*/function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
              var data;
              return _regeneratorRuntime().wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    _context.prev = 0;
                    _context.next = 3;
                    return User.extraService().$promise;
                  case 3:
                    data = _context.sent;
                    $rootScope.extraService = data;
                    _context.next = 10;
                    break;
                  case 7:
                    _context.prev = 7;
                    _context.t0 = _context["catch"](0);
                    void 0;
                  case 10:
                  case "end":
                    return _context.stop();
                }
              }, _callee, null, [[0, 7]]);
            }));
            return function fetchExtraService() {
              return _ref2.apply(this, arguments);
            };
          }();
          getManagePath = function getManagePath(extraService) {
            $scope.useExtraService = Utils.getCookie("useExtraService") === "true";
            if (!$scope.useExtraService) return "";
            if ($state.current.name !== "main.manage") {
              return $location.path().split("/").pop();
            }
            var serviceMapping = {
              useIotHub: "iothub",
              useSensor: "sensor",
              useDoorLock: "doorlock",
              useDid: "did"
            };
            return Object.keys(serviceMapping).find(function (key) {
              return extraService[key];
            }) ? serviceMapping[Object.keys(serviceMapping).find(function (key) {
              return extraService[key];
            })] : "";
          };
          if (isExtraServiceInit) {
            _context2.next = 13;
            break;
          }
          _context2.next = 13;
          return fetchExtraService();
        case 13:
          path = !!getManagePath($rootScope.extraService) ? "main.manage.".concat(getManagePath($rootScope.extraService)) : "main.manage";
          $state.go(path, {}, {
            location: "replace"
          });
          $scope.goAiFace = function () {
            $rootScope.createConfirm({
              title: $translate.instant("9rRqk7Vo_02361"),
              description: $translate.instant("9rRqk7Vo_02466"),
              handler: function handler() {
                $state.go("main.aiface.content", {}, {
                  reload: "main.aiface.content",
                  inherit: true,
                  notify: true
                });
              }
            });
          };
          $scope.clickAiFaceMenu = function () {
            if ($rootScope.me.useAiFaceDetect) {
              $scope.goAiFace();
            } else {
              checkAiFaceRecvAccounts().then(function () {
                $scope.goAiFace();
              }, function () {
                if ($rootScope.me) {
                  $scope.selectedAccount = {
                    userId: $rootScope.me.userId
                  };
                  $scope.isShowAiFaceServiceRegDialog = true;
                }
              });
              return;
            }
          };
          $scope.clickMenu = function (state) {
            $state.go(state, {}, {
              reload: state,
              inherit: true,
              notify: true
            });
          };
        case 18:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function (_x, _x2, _x3, _x4, _x5, _x6, _x7, _x8, _x9, _x10) {
    return _ref.apply(this, arguments);
  };
}())]);
"use strict";

app.controller('ManagePosCtrl', ['$scope', '$rootScope', '$interval', '$state', '$translate', '$q', 'Shop', 'PosSummary', 'Pos', function ($scope, $rootScope, $interval, $state, $translate, $q, Shop, PosSummary, Pos) {
  $scope.selectedTab = 'my'; //'shared', 'none';
  $scope.isLoading = false;
  $scope.currentShops = [];
  $scope.fetchTimeStr = '';
  $scope.fetchDateStr = '';
  var myShops = [],
    sharedShops = [];
  var getSummaryReq = null;
  $scope.selectTab = function (tab) {
    $scope.selectedTab = tab;
    if ($scope.selectedTab === 'my') {
      $scope.currentShops = myShops;
    } else if ($scope.selectedTab === 'shared') {
      $scope.currentShops = sharedShops;
    }
  };
  $scope.goPosPage = function (shop) {
    var pageName = 'main.dashboard.pos';
    Pos.getPosInfo({
      shopId: shop.shopId,
      posId: shop.posId
    }, function (data) {
      if (!shop.isOwner) {
        if (shop.posId && shop.posId != "") {
          $rootScope.dashboardCurShopId = shop.shopId;
          $state.go(pageName, {
            shopId: shop.shopId,
            cameraId: data.pos.cameraId,
            posId: shop.posId,
            type: 'sharedshop'
          });
        } else {
          $rootScope.createConfirm({
            title: $translate.instant('SHARE_SHOP'),
            description: $translate.instant('SHARE_SHOP_NO_POS'),
            btnCount: 1
          });
        }
      } else {
        if (shop.posId && shop.posId != "") {
          $rootScope.dashboardCurShopId = shop.shopId;
          $state.go(pageName, {
            shopId: shop.shopId,
            cameraId: data.pos.cameraId,
            posId: shop.posId,
            type: 'shop'
          });
        } else {
          $rootScope.createConfirm({
            description: $translate.instant('SHARE_SHOP_NO_POS'),
            btnCount: 1
          });
        }
      }
    }, function (err) {
      $rootScope.createConfirm({
        description: $translate.instant('9rRqk7Vo_02175'),
        btnCount: 1
      });
    });
  };
  function getTimeStr(dateObj) {
    if (!dateObj) {
      return '';
    }
    var hour = dateObj.getHours();
    var min = dateObj.getMinutes();
    hour = hour < 10 ? '0' + hour : '' + hour;
    min = min < 10 ? '0' + min : '' + min;
    return hour + ':' + min;
  }
  function getDateStr(dateObj) {
    if (!dateObj) {
      return '';
    }
    var month = dateObj.getMonth() + 1;
    var date = dateObj.getDate();
    var day = dateObj.getDay();
    var dayStrIdArr = ['DAY_SUN', 'DAY_MON', 'DAY_TUE', 'DAY_WED', 'DAY_THU', 'DAY_FRI', 'DAY_SAT'];
    month = month < 10 ? '0' + month : '' + month;
    date = date < 10 ? '0' + date : '' + date;
    day = $translate.instant(dayStrIdArr[day]);
    return month + ':' + date + '(' + day + ')';
  }
  function fetchPosSummary() {
    var deferred = $q.defer();
    myShops = [];
    sharedShops = [];
    $scope.isLoading = true;
    getSummaryReq = PosSummary.getPosSummary();
    getSummaryReq.$promise.then(function (res) {
      if (res.shops) {
        var currentDate = new Date();
        $scope.fetchTimeStr = getTimeStr(currentDate);
        $scope.fetchDateStr = getDateStr(currentDate);
        res.shops.forEach(function (shop) {
          if (shop.result === 'on') {
            shop.todayCompareSign = shop.todayCompare.indexOf('+') !== -1 ? 1 : shop.todayCompare.indexOf('-') !== -1 ? -1 : 0;
            shop.todayCompareNum = shop.todayCompare.replace(/[^0-9]/g, "");
          }
          shop.isOwner ? myShops.push(shop) : sharedShops.push(shop);
        });
      }
      getSummaryReq = null;
      $scope.isLoading = false;
      deferred.resolve();
    }, function (err) {
      getSummaryReq = null;
      $scope.isLoading = false;
      deferred.reject();
    });
    return deferred.promise;
  }
  fetchPosSummary().then(function () {
    $scope.selectTab($scope.selectedTab);
  });
  $scope.$on('$destroy', function () {
    if (getSummaryReq) {
      getSummaryReq.$cancelRequest();
    }
  });
}]);
"use strict";

app.controller('ManageSensorCtrl', ['$scope', '$rootScope', '$interval', '$state', '$translate', 'Sensor', 'Shop', function ($scope, $rootScope, $interval, $state, $translate, Sensor, Shop) {
  var myShops = [];
  var sharedShops = [];
  $scope.currentShops = [];
  $scope.selectedTab = 'my'; //'shared';
  $scope.isLoading = false;
  $scope.isLoadShop = false;
  $scope.shopObjectMap = {};
  // sensor dtv interface
  $scope.isManage = true;
  $scope.shopObject = null;
  $scope.isShared = false;
  $scope.selectSensor = null;
  $scope.isShowSensorSetDialog = false;
  $scope.cameraList = [];
  $scope.$on('deviceUpdate', function () {
    fetchSensors(true);
  });
  $scope.selectTab = function (tab) {
    $scope.selectedTab = tab;
    $scope.currentShops = $scope.selectedTab === 'my' ? myShops : sharedShops;
  };
  $scope.selectSensorItem = function (sensor, shop) {
    $scope.selectSensor = sensor;
    $scope.selectSensor.id = $scope.selectSensor.sensorId;
    if ($scope.shopObjectMap[shop.shopId]) {
      showSensorDtv($scope.shopObjectMap[shop.shopId]);
    } else {
      $scope.isLoadShop = true;
      Shop.dashboardShopV4({
        shopId: shop.shopId
      }).$promise.then(function (res) {
        $scope.isLoadShop = false;
        if (res.shop) {
          $scope.shopObjectMap[shop.shopId] = res.shop;
          showSensorDtv(res.shop);
        }
      }, function (err) {
        $scope.isLoadShop = false;
      });
    }
  };
  function showSensorDtv(shop) {
    $scope.cameraList = [];
    $scope.shopObject = shop;
    if ($scope.shopObject) {
      $scope.isShared = !!$scope.shopObject.shareId;
      if ($scope.shopObject.controllerList) {
        $scope.shopObject.controllerList.forEach(function (controller) {
          if (controller.deviceType === 'CAMERA') {
            $scope.cameraList.push(controller.cameraInfo);
          }
        });
      }
    }
    $scope.isShowSensorSetDialog = true;
  }
  function fetchSensors(noLoading) {
    myShops = [];
    sharedShops = [];
    $scope.currentShops = [];
    if (!noLoading) {
      $scope.isLoading = true;
    }
    Sensor.getSensors(function (res) {
      if (res.code === 'ok' && res.shops) {
        res.shops.forEach(function (shop) {
          if (shop.isOwner) {
            myShops.push(shop);
          } else {
            sharedShops.push(shop);
          }
        });
        $scope.currentShops = myShops;
      }
      if (!noLoading) {
        $scope.isLoading = false;
      }
    }, function (err) {
      if (!noLoading) {
        $scope.isLoading = false;
      }
    });
  }
  fetchSensors();
  $scope.$on('$destroy', function () {
    myShops = [];
    sharedShops = [];
    $scope.currentShops = [];
  });
}]);
"use strict";

app.controller('ManageStaffCtrl', ['$scope', '$rootScope', '$interval', '$state', '$translate', 'Shop', 'Access', function ($scope, $rootScope, $interval, $state, $translate, Shop, Access) {
  $scope.selectedTab = 'my'; //'shared', 'none';
  $scope.isLoading = false;
  $scope.currentShops = [];
  $scope.accTargets = [];
  $scope.currentShop = null;
  $scope.selectTab = function (tab) {
    $scope.selectedTab = tab;
    if ($scope.selectedTab === 'my') {
      fetchMyAccess();
    } else if ($scope.selectedTab === 'shared') {
      fetchTargetAccess();
    }
  };
  $scope.goStaffPage = function (shop) {
    if (shop && shop.result === 'on') {
      $rootScope.dashboardCurShopId = shop.shopId;
      $state.go('main.dashboard.staff', {
        shopId: shop.shopId,
        shared: !shop.isOwner
      });
    } else {
      $state.go('main.dashboard.shop', {
        shop: JSON.stringify({
          shopId: shop.shopId,
          myShop: shop.isOwner
        })
      });
    }
  };
  $scope.showStaffRegistDlg = function (shop, evt) {
    $scope.currentShop = shop;
    $scope.isShowStaffRegistDialog = true;
    evt.stopPropagation();
  };
  $scope.deleteTarget = function (target) {
    $rootScope.createConfirm({
      title: $translate.instant('ACCESS_ENROLL_CLEAR'),
      description: $translate.instant('5mw2slvk_02179'),
      handler: function handler() {
        Access.deleteAccessTarget({
          shopId: target.shopId,
          userId: target.userId
        }, function (data) {
          if (data.code === "ok") {
            fetchTargetAccess();
          } else {
            $rootScope.createConfirm({
              title: $translate.instant('ACCOUNT_STORE_ALARM_CLEAR'),
              description: $translate.instant('ACCOUNT_STORE_ALARM_CLEAR_FAIL'),
              btnCount: 1
            });
          }
        }, function (err) {
          $rootScope.createConfirm({
            title: $translate.instant('ACCESS_NET_FAIL'),
            description: $translate.instant('ACCESS_NET_FAIL_DESC'),
            btnCount: 1
          });
        });
      }
    });
  };
  function fetchMyAccess() {
    $scope.isLoading = true;
    Access.getAccessManager(function (res) {
      $scope.currentShops = res.shops ? res.shops : [];
      $scope.currentShops.forEach(function (shop) {
        if (shop.status) {
          if (shop.status.ER && shop.status.ER.length) {
            shop.status.inNames = shop.status.ER.join(', ');
          }
          if (shop.status.ET && shop.status.ET.length) {
            shop.status.outNames = shop.status.ET.join(', ');
          }
        }
      });
      $scope.isLoading = false;
    });
  }
  function fetchTargetAccess() {
    $scope.isLoading = true;
    Access.getAccessTargets(function (res) {
      $scope.accTargets = res.list ? res.list : [];
      $scope.isLoading = false;
    });
  }
  fetchMyAccess();
  $scope.$on('$destroy', function () {});
}]);
"use strict";

app.controller("ManualCtrl", ["$scope", "Utils", function ($scope, Utils) {
  $scope.countryDomain = $("html").attr("lang");
  $scope.downloadGatewayManual = function () {
    if ($scope.countryDomain === "ja") {
      window.open("https://bizcam.toast.com/CF/gateway_install_jp.pdf", "_blank");
    } else {
      window.open("https://bizcam.toast.com/CF/gateway_install_kr.pdf", "_blank");
    }
  };
  $scope.downloadGatewayInstaller = function (type) {
    switch (type) {
      case "analog":
        if (Utils.isSafari()) {
          window.open("/#/gatewayAnalogGuide", "Cloud Gateway-Analog", "scrollbars=no, toolbar=no, resizable=no, width=605, height=640,left=600,top=200");
        } else {
          window.open("/#/gatewayAnalogGuide", "Cloud Gateway-Analog", "scrollbars=no, toolbar=no, resizable=no, width=605, height=625,left=600,top=200");
        }
        break;
      case "ip":
      default:
        if (Utils.isSafari()) {
          window.open("/#/gatewayIpGuide", "Cloud Gateway-IP", "scrollbars=no, toolbar=no, resizable=no, width=605, height=640,left=600,top=200");
        } else {
          window.open("/#/gatewayIpGuide", "Cloud Gateway-IP", "scrollbars=no, toolbar=no, resizable=no, width=605, height=625,left=600,top=200");
        }
        break;
    }
  };
  $scope.showDoorlockManual = function () {
    if ($scope.countryDomain === "ja") {
      window.open("https://bizcam.toast.com/doorlockmanual/ja_house_manual.html", "doorlockManual", "scrollbars=yes,toolbar=no,resizable=yes,width=600,height=720");
    } else {
      window.open("https://bizcam.toast.com/doorlockmanual/ko_shop_manual.html", "doorlockManual", "scrollbars=yes,toolbar=no,resizable=yes,width=600,height=720");
    }
  };
  $scope.downloadMonitorManual = function () {
    if ($scope.countryDomain === "ja") {
      window.open("https://bizcam.toast.com/CF/cloud_monitor_manual_jp_2024.12.02.pdf", "_blank");
    } else {
      window.open("https://bizcam.toast.com/CF/cloud_monitor_manual_ko_2024.12.02.pdf", "_blank");
    }
  };
  $scope.$on("$destroy", function () {});
}]);
"use strict";

app.controller("MonitorDetailCtrl", ["$scope", "$rootScope", "$stateParams", "$state", "$interval", "Camera", "Share", "CameraConfig", "$translate", "$timeout", "$q", "$window", "Utils", function ($scope, $rootScope, $stateParams, $state, $interval, Camera, Share, CameraConfig, $translate, $timeout, $q, $window, Utils) {
  showPage();
  $scope.cameraName = "";
  $scope.countryDomain = window.country;
  var playerObj = null;
  var playControl = null;
  var controlHideTimeout = null;
  var timelineHideTimer = null;

  // 풀스크린 상태이고 타임라인 숨김상태일 때 마우스오버 이벤트 함수
  $scope.showTimeline = function () {
    $scope.isToggleOn = true;
    isClickTimelineShow = false;
    $timeout.cancel(timelineHideTimer);
  };

  // 풀스크린 적용시 타임라인 컨트롤바에서 mouseleave 이벤트 발생시 5초후 타임라인 숨김 처리
  $scope.hideTimeline = function () {
    if (!isClickTimelineShow) {
      timelineHideTimer = $timeout(function () {
        $scope.isShowTimelineCalendar = false;
        $scope.isToggleOn = false;
      }, 5000);
    }
  };

  // 풀스크린 상태이고 타임라인에 마우스오버 상태인 경우 타임라인 숨김 timeout을 취소
  $scope.cancelTimelineHide = function () {
    $timeout.cancel(timelineHideTimer);
  };
  var isClickTimelineShow = false; //클릭 이벤트로 타임라인 표시할 경우 timeout 적용되지 않도록하기 위한 flag
  // 풀스크린 상태일경우 타임라인 토글 이벤트 함수
  $scope.toggleTimeline = function () {
    $scope.isToggleOn = !$scope.isToggleOn;
    if ($scope.isToggleOn) {
      $scope.isShowControlArea = false;
    } else {
      $scope.isShowTimelineCalendar = false;
      $scope.isShowControlArea = true;
    }
    isClickTimelineShow = true;
    $timeout.cancel(timelineHideTimer);
  };
  $scope.isShowPlayControl = true;
  setTimeout(function () {
    $("#toastGnb").hide();
    $("#toastFooter").hide();
  }, 100);
  $scope.camera = {
    id: $stateParams.cameraId
  };
  var showAlert = function showAlert(title, message) {
    $(".display_show").css("display", "");
    $scope.showAlert = true;
    $scope.alertTitle = title;
    $scope.alertMessage = message;
  };
  $scope.hideAlert = function () {
    $scope.showAlert = false;
  };
  $scope.isExpiredCloud = function () {
    return Utils.isCloudExpired($scope.currentCamera);
  };

  // $interval cancel
  $scope.$on("$destroy", function () {
    if (playerObj) {
      playerObj.destroy();
      playerObj = null;
    }
    if (controlHideTimeout) {
      $timeout.cancel(controlHideTimeout);
      controlHideTimeout = null;
    }
    $window.confirmPaycoPasswordCallback = null;
    $timeout.cancel(timelineHideTimer);
    $interval.cancel($scope.reloadTimer); // CVR Fetch
    $interval.cancel($scope.timer); // Cursor 시간
    $interval.cancel($scope.eventThumbTimer); // 타임라인 마우스 오버시 나타나는 썸네일 반복
    $interval.cancel($scope.eventlistTimer); // 이벤트 목록 썸네일 반복
    $("#toastFooter").show();
    $("#toastGnb").show();
  });
  var getAlarmZones = function getAlarmZones() {
    var deferred = $q.defer();
    Camera.zones({
      id: $scope.currentCamera.id
    }, function (res) {
      $scope.eventZones = res.eventZones;
      $scope.motionZones = res.zones;
      if (playerObj) {
        playerObj.setData("eventZones", $scope.eventZones);
        playerObj.setData("motionZones", $scope.motionZones);
      }
      deferred.resolve();
    }, function (err) {
      deferred.reject();
    });
    return deferred.promise;
  };
  function playerEventHandler(event, data) {
    switch (event) {
      case "resizeTimline":
        if ($scope.zonearea !== undefined) {
          $scope.zonearea.setCanvasSize($("#player").width(), $("#player").height(), $scope.zones, $scope.selectedZones);
        }
        break;
      case "isShowMikeChanged":
        $scope.isShowMike = data;
        break;
      case "clickedCVRArea":
        break;
      case "getAlarmZones":
        if (getAlarmZones) {
          getAlarmZones().then(function () {
            if (playControl) {
              playControl.timeline.getTimeline();
            }
          });
        }
        break;
      case "loadingAlert":
        showAlert($translate.instant("DATA_LOADING_SUBJECT"), $translate.instant("DATA_LOADING_CONTENT"));
        break;
      case "fullScreenAlertChanged":
        $scope.fullScreenAlert = data;
        break;
      case "isFullScreenChanged":
        $scope.isAddShowGalleryClass = false;
        $scope.isFullScreen = data;
        $scope.$apply();
        break;
      case "timelineVisibleChanged":
        $scope.timelineVisible = data;
        break;
      case "noPrevEvent":
        showAlert($translate.instant("CAMERA_EVENT_MOVE"), $translate.instant("CAMERA_NO_PREV_EVENT"));
        break;
      case "noNextEvent":
        showAlert($translate.instant("CAMERA_EVENT_MOVE"), $translate.instant("CAMERA_NO_NEXT_EVENT"));
        break;
      case "eventsChanged":
        $scope.events = data;
        break;
      case "loadingDataAlert":
        break;
      case "timeInputError":
        if (data === "time") {
          showAlert($translate.instant("CAMERA_INPUT_ERROR"), $translate.instant("CAMERA_ENTER_TIME"));
        } else if (data === "minute") {
          showAlert($translate.instant("CAMERA_INPUT_ERROR"), $translate.instant("CAMERA_ENTER_MINUTE"));
        } else if (data === "second") {
          showAlert($translate.instant("CAMERA_INPUT_ERROR"), $translate.instant("CAMERA_ENTER_SECOND"));
        }
        break;
      case "isIncorrectPlayPasswordChanged":
        $scope.isIncorrectPlayPassword = data;
        $scope.$apply();
        break;
    }
  }
  $scope.shareStatus = $stateParams.shared === true || $stateParams.shared === "true" ? true : false;
  $scope.resetCVRPassword = function () {
    var treatmentUrl = document.URL;
    var loginUrl = paycoUrl + "login.nhn";
    var confirmUrl = paycoUrl + "auth/confirmPwd.nhn";
    var httpUrl = location.origin;
    if (httpUrl == undefined) {
      httpUrl = location.protocol + "//" + location.hostname;
    }
    if ($scope.countryDomain === "ja") {
      var url = "/checkpw?nextUrl=resetCVRPassword";
      window.open(url, $translate.instant("CAMERA_PASSWORD_INIT"), "scrollbars=yes,toolbar=no,resizable=yes,width=420,height=538,left=600,top=200");
    } else {
      var url = "/#/passwordConfirm";
      openInfoWin(url, "popup", 470, 280, "no"); // window.open
    }
  };
  $scope.getCameraConfig = function () {
    var apiCallFn = $scope.shareStatus == false ? CameraConfig.get : CameraConfig.getSharedConfig;
    apiCallFn({
      id: $stateParams.cameraId
    }, function (data) {
      angular.extend($scope.config, data);
      $scope.config.tzCode = $scope.config.timezone.split(",")[0];
      $scope.tzCode = $scope.config.tzCode;
      if (data && data.cameraSchedule) {
        $scope.scheduleOn = data.cameraSchedule.scheduleOn;
      }
      if (playerObj) {
        playerObj.setData("cameraConfig", $scope.config);
      }
    });
  };
  $window.confirmPaycoPasswordCallback = function () {
    CameraConfig.deleteSecurePassword({
      id: $stateParams.cameraId
    }, function (data) {
      if (data.code == "ok") {
        $scope.isIncorrectPassword = false;
        $scope.isIncorrectPlayPassword = false;
        $scope.getCameraConfig();
        $rootScope.createConfirm({
          title: $translate.instant("CAMERA_SECURITY_UP"),
          description: $translate.instant("CAMERA_CONFIRMED"),
          confirmText: $translate.instant("9rRqk7Vo_02145"),
          btnCount: 1
        });
      } else {
        showAlert($translate.instant("CAMERA_SECURITY_UP"), $translate.instant("ACCESS_FAIL"));
      }
    }, function (error) {
      location.href = "/error";
    });
  };
  $scope.cancelCVRPlay = function () {
    if (playControl.getData("isLive")) {
      $scope.timeline.setData("cursorOn", false);
      playerObj.requestPlay();
    }
  };
  $scope.showCvrSecureAgain = function () {
    var cvrPlayManager = playControl.cvrPlaySecureManager;
    cvrPlayManager.securePassword = "";
    $scope.isIncorrectPlayPassword = !$scope.isIncorrectPlayPassword;
    cvrPlayManager.isShowCVRPlayPasswordConfirm = true;
  };
  $scope.goDetail = function (id) {
    var trident = navigator.userAgent.match(/Trident\/(\d)/i);
    if (trident != null) {
      document.documentElement.scrollTop = 0;
    } else {
      $("body").scrollTop(0);
    }
    if ($stateParams.shopId) {
      $state.go("main.cameraDetail", {
        cameraId: id,
        type: "shop",
        id: $stateParams.shopId
      }, {
        reload: true,
        inherit: true,
        notify: true
      });
    } else {
      $state.go("main.cameraDetail", {
        cameraId: id,
        type: "camera"
      }, {
        reload: true,
        inherit: true,
        notify: true
      });
    }
  };
  $scope.plyBtnStatus = true;
  $scope.pauseBtn = function () {
    playControl.playInfoBar.pauseBtn();
    $scope.isPlaying = playControl.getData("isPlaying");
  };
  $scope.livePlayStart = function () {
    if ($scope.config.streamStatus != "off") {
      playControl.player.play();
    }
  };
  var loadCurrentCamera = function loadCurrentCamera() {
    var deferred = $q.defer();
    if ($scope.shareStatus == false) {
      Camera.get({
        id: $stateParams.cameraId
      }, function (res) {
        $scope.currentCamera = res;
        if (playerObj) {
          playerObj.setData("cameraData", $scope.currentCamera);
        }
        deferred.resolve();
      }, function (error) {
        deferred.reject();
      });
    } else {
      Share.get({
        id: $stateParams.cameraId
      }, function (res) {
        $scope.currentCamera = res;
        if (playerObj) {
          playerObj.setData("cameraData", $scope.currentCamera);
        }
        deferred.resolve();
      }, function (error) {
        deferred.reject();
      });
    }
    return deferred.promise;
  };
  $scope.eventSources = [];
  $scope.compareTime = function (time) {
    if ($scope.timelineDataLastDate < time) {
      $scope.timelineDataLastDate = time;
    }
  };
  $scope.setupDomain = function (domain) {
    $scope.timeline.setupDomain(domain);
  };
  $scope.hideCursorNavigation = function () {
    $scope.isCursorLeft = false;
    $scope.isCursorRight = false;
  };
  $scope.currentTime = new Date();
  $scope.reloadTimer = $interval(function () {
    if ($scope.timeline.currentDomain == undefined) {
      return;
    }
    if ($scope.timeline.currentDomain[1] > Date.now()) {
      $scope.setupDomain([$scope.timeline.currentDomain[0], $scope.timeline.currentDomain[1]]);
    }
  }, 10000);
  $scope.formattedInternalDate = function (date) {
    var md;
    if ($scope.timeline.tz !== undefined) {
      md = moment(new Date(date)).tz($scope.timeline.tz);
    } else {
      md = moment(new Date(date));
    }
    return md.format("YYYYMMDD");
  };
  $scope.stopTimer = function () {
    playControl.playTimer.stopTimer();
  };
  $scope.startLiveTimer = function () {
    playControl.playTimer.startLiveTimer(playControl.timeline);
  };
  $scope.clickedCVRArea = function (time, status) {
    playControl.timeline.clickedCVRArea(time, status);
  };
  $scope.goCvr = function (time, status) {
    $scope.timeline.requestPlay(time, status);
  };
  $scope.isTurnOffCamera = function () {
    return Utils.isTurnOffCamera($scope.currentCamera);
  };
  var isFullScreen = function isFullScreen() {
    return !!(document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement);
  };
  $scope.moveToMonitorList = function () {
    if ($stateParams.demo) {
      window.history.back();
      //$state.go('main.monitors', {demo: 'ok'});
    } else {
      $state.go("main.monitors", {
        demo: "nok"
      });
    }
  };
  $scope.config = {};
  $scope.loadCameraSetting = function (callback) {
    var apiCallFn = $scope.shareStatus == false ? CameraConfig.get : CameraConfig.getSharedConfig;
    apiCallFn({
      id: $stateParams.cameraId
    }, function (data) {
      angular.extend($scope.config, data);
      if ($scope.config.resolution) {
        $scope.config.resolution = $scope.config.resolution.toUpperCase();
      }
      if ($scope.config.timezone != undefined) {
        $scope.config.tzCode = $scope.config.timezone.split(",")[0];
        $scope.tzCode = $scope.config.tzCode;
        $scope.config.tzDisplayName = $scope.config.timezone.split(",")[1] + $scope.config.timezone.split(",")[3];
      }
      if (playerObj) {
        playerObj.setData("cameraConfig", $scope.config);
      }
      if (typeof callback === "function") {
        callback();
      }
    }, function (err) {
      // error
      $state.go("main", {}, {
        reload: true
      });
    });
  };
  $scope.selectCamera = function () {
    if (document.cancelFullScreen) {
      document.cancelFullScreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.webkitCancelFullScreen) {
      document.webkitCancelFullScreen();
    } else if (document.msCancelFullScreen) {
      document.msCancelFullScreen();
    }
    if ($scope.shareStatus) {
      $state.go("main.cameraDetail", {
        cameraId: $stateParams.cameraId,
        type: "monitor",
        shopId: $stateParams.shopId,
        shared: true
      });
    } else {
      if ($stateParams.shopId) {
        $state.go("main.cameraDetail", {
          cameraId: $stateParams.cameraId,
          type: "shop",
          id: $stateParams.shopId
        });
      } else {
        $state.go("main.cameraDetail", {
          cameraId: $stateParams.cameraId,
          type: "camera"
        });
      }
    }
  };
  $scope.loadCameraSetting(function () {
    loadCurrentCamera().then(function () {
      $scope.cameraName = $scope.currentCamera.labelName;
      playerObj = new tCam.player({
        elementIdMap: {
          root: "camdtl_wrap"
        },
        category: "b2bmonitor",
        playerType: "hls",
        cameraData: $scope.currentCamera,
        cameraConfig: $scope.config,
        country: $rootScope.me.country,
        playEventCb: playerEventHandler,
        playTime: 0,
        mute: true,
        isShared: $scope.shareStatus
      });
      if (playerObj) {
        playControl = playerObj.control;
        $scope.timeline = playControl.timeline;
        $scope.player = playControl.player;
      }
    });
  });
}]);
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
app.controller("MonitorDownloadCtrl", ["$scope", "$rootScope", "CloudMonitor", "$translate", function ($scope, $rootScope, CloudMonitor, $translate) {
  $scope.pcSpecificationModalVisible = false;
  $scope.installProgramModalVisible = false;
  $scope.openModal = function (type) {
    if (type === "pcSpecification") {
      $scope.pcSpecificationModalVisible = true;
      $scope.installProgramModalVisible = false;
      return;
    }
    if (type === "installProgram") {
      $scope.installProgramModalVisible = true;
      $scope.pcSpecificationModalVisible = false;
      return;
    }
  };
  $scope.closeModal = function (type) {
    if (type === "pcSpecification") {
      $scope.pcSpecificationModalVisible = false;
      return;
    }
    if (type === "installProgram") {
      $scope.installProgramModalVisible = false;
      return;
    }
  };
  $scope.handleClickDownload = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          window.location.href = "/json/biz/v1/clmonitor/client/app/windows";
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  $scope.handleClickManual = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          window.location.href = "/json/biz/v1/clmonitor/client/manual/windows";
        case 1:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
}]);
"use strict";

app.controller("MonitorCtrl", ["$scope", "$state", "User", "$translate", "$rootScope", "$timeout", "$interval", "$stateParams", "$q", "Monitor", "Camera", "Demos", "Shop", "Utils", function ($scope, $state, User, $translate, $rootScope, $timeout, $interval, $stateParams, $q, Monitor, Camera, Demos, Shop, Utils) {
  /*****
       [Drag & Drop]
       [Gnb & FullScreen Control]
       [Setting]
       [Cloud Monitor Play]
       [Monitor Service Event]
       [Initiate]
       *****/
  var commonToken = null,
    movingCamDetail,
    isReCreatePlayer,
    monitorPlayer,
    eventIntervalId = null,
    clockIntervalId = null,
    cameraInfoMap = {},
    nextPlayCamIndex = 0,
    curUserDefineIndex = 0,
    isAnimating = false,
    readyToGnbHide = false,
    gnbHideTimeout = null,
    shopList = [],
    currentMonitoringCameras = [],
    pageIntervalId = null,
    retryIntervalId = null,
    items,
    selections,
    tooltip_timeout,
    extendIntervalId = null;
  var tokenExtendInterval = 29 * 1000;
  $scope.bFullScreen = false;
  $scope.imgProtocol = "https://";
  $scope.countryDomain = window.country;
  $scope.userDefineMode = false;
  $scope.userDefineUnselectCams = [];
  $scope.userDefineSetCamPage = [];
  $scope.showUserDefineSetCamPage = [];
  $scope.userDefinePagingFirstIndex = 0;
  $scope.userDefinePagingSelectIndex = 0;
  $scope.userDefineCamFirstIndex = 0;
  $scope.intervalOptions = [30, 60, 90, 120, 180];
  $scope.isShowModeSelector = false;
  $scope.isShowIntervalSelector = false;
  $scope.isShowTimeLocSelector = false;
  $scope.isShowTimeHourSelector = false;
  $scope.isSetMode = false;
  $scope.curState = 1;
  $scope.setCamPage = [];
  $scope.showSetCamPage = [];
  $scope.setCamPagingFirstIndex = 0;
  $scope.setCamPagingSelectIndex = 0;
  $scope.debugMode = 0;
  $scope.buffertime = 0;
  $scope.sampleCamFirstIndex = 0;
  $scope.sampleCameras = [];
  $scope.tempConfigData = {
    mode: "",
    interval: 5000,
    timeLoc: "",
    timeHour: "",
    customModeSettings: {
      dimension: 2,
      cameras: []
    },
    pagingModeSettings: {
      dimension: 2
    },
    eventModeSettings: {
      dimension: 2
    },
    streamType: ""
  };
  $scope.monitorConfigData = null;
  $scope.allCamStatus = {};
  $scope.iotCamStatus = "";
  function findShopId(cameraId) {
    var i, j, shopLen, camLen;
    if (!shopList || !shopList.length) {
      return "";
    }
    for (i = 0, shopLen = shopList.length; i < shopLen; i += 1) {
      for (j = 0, camLen = shopList[i].cameraIds.length; j < camLen; j += 1) {
        if (cameraId === shopList[i].cameraIds[j]) {
          return shopList[i].shopId;
        }
      }
    }
    return "";
  }
  function getTokenRetry() {
    commonToken = null;
    setTimeout(function () {
      getToken($scope.monitorConfigData.cloudMonitorCameraList).then(function () {
        currentMonitoringCameras = [];
        $timeout(function () {
          restartMonitor();
        }, 100);
      });
    }, 1000);
  }
  function extendTokenIntervalStart() {
    extendTokenIntervalStop();
    if (commonToken) {
      extendIntervalId = setInterval(function () {
        if ($stateParams.demo === "ok") {
          Demos.extendToken({
            id: commonToken
          }, {}, function (data) {
            if (data.code != "ok") {
              getTokenRetry();
            }
          }, errorHandlerExtendToken);
        } else {
          Camera.extendToken({
            id: commonToken
          }, {}, function (data) {
            if (data.code != "ok") {
              getTokenRetry();
            }
          }, errorHandlerExtendToken);
        }
      }, tokenExtendInterval);
    } else {
      getTokenRetry();
    }
  }
  function extendTokenIntervalStop() {
    if (extendIntervalId) {
      clearInterval(extendIntervalId);
      extendIntervalId = null;
    }
  }
  function getToken(cameraList) {
    var deferred = $q.defer();
    var cameraIds = "",
      i,
      len = cameraList.length;
    for (i = 0; i < len; i += 1) {
      if (i === 0) {
        cameraIds += cameraList[i].cameraId;
      } else {
        cameraIds += "," + cameraList[i].cameraId;
      }
    }
    var getTokenCallback = function getTokenCallback(data) {
      if (data.token || data.tokenInfo) {
        if (data.token) {
          commonToken = data.token;
        } else {
          commonToken = data.tokenInfo.token;
        }
        extendTokenIntervalStart();
        deferred.resolve();
      } else {
        deferred.reject();
      }
    };
    if ($stateParams.demo === "ok") {
      Demos.getMonitorDemoToken({
        cameraIds: cameraIds
      }, getTokenCallback, sessionErrorHandler);
    } else {
      Camera.getTokenList({
        cameraIds: cameraIds
      }, getTokenCallback, errorHandlerExtendToken);
    }
    return deferred.promise;
  }

  // TODO: 사용되지 않는것으로 판단
  function getCameraErrorStatus(cameraId) {
    if (cameraInfoMap && cameraInfoMap[cameraId]) {
      if (cameraInfoMap[cameraId].streamStatusConfig === "off" && cameraInfoMap[cameraId].controlStatus === "on" && cameraInfoMap[cameraId].streamStatus === "off") {
        return "status_off";
      } else if (cameraInfoMap[cameraId].recordType != "event" && cameraInfoMap[cameraId].streamStatusConfig === "on" && cameraInfoMap[cameraId].controlStatus === "on" && cameraInfoMap[cameraId].streamStatus === "off") {
        return "status_delay";
      } else if (cameraInfoMap[cameraId].streamStatusConfig && cameraInfoMap[cameraId].controlStatus != "on" && cameraInfoMap[cameraId].streamStatus === "off") {
        return "status_disconnect";
      } else {
        return "status_normal";
      }
    }
    return "status_normal";
  }
  var showAlert = function showAlert(title, message) {
    $(".display_show").css("display", "");
    $scope.showAlert = true;
    $scope.alertTitle = title;
    $scope.alertMessage = message;
  };
  $scope.hideAlert = function () {
    $scope.showAlert = false;
  };
  var showAlertOut = function showAlertOut(title, message) {
    $(".display_show").css("display", "");
    $scope.showAlertOut = true;
    $scope.alertTitle = title;
    $scope.alertMessage = message;
  };
  $scope.hideAlertOut = function () {
    $scope.showAlertOut = false;
    $state.go("main");
  };
  $scope.$on("$destroy", function () {
    shopList = [];
    if ($stateParams.demo === "ok") {
      if (window.monitorDemoState && window.monitorDemoState.from === "main") {
        window.monitorDemoState.state = "out";
      }
    }
    $(window).off("resize", resizeHandler);
    $("#hoverGnb").off("mouseover", topMenuHoverIn);
    if (Utils.isIE()) {
      $(document).off("mousemove", mousemoveEventHandler);
    } else {
      $("#toastGnb").off("mouseleave", topGnbHoverOut);
      $("#hoverGnb").off("mouseleave", topMenuHoverOut);
      $("#monitor_setting").off("mouseleave", topMenuHoverOut);
      $("#fullmode_setting").off("mouseleave", topMenuHoverOut);
    }
    document.removeEventListener("webkitfullscreenchange", fullscreenHandler, false);
    document.removeEventListener("mozfullscreenchange", fullscreenHandler, false);
    document.removeEventListener("fullscreenchange", fullscreenHandler, false);
    document.removeEventListener("MSFullscreenChange", fullscreenHandler, false);
    document.removeEventListener("keyup", keyupHandler, false);
    document.removeEventListener("mousedown", mouseDownEventHandler, false);
    document.removeEventListener("mouseup", mouseUpEventHandler, false);
    document.removeEventListener("dragstart", dragStartEventHandler, false);
    document.removeEventListener("dragend", dragEndEventHandler, false);
    initLoginIntervalFlag();
    extendTokenIntervalStop();
    pageRefreshIntervalStop();
    eventMonitorIntervalStop();
    clockIntervalStop();
    if (retryIntervalId) {
      clearInterval(retryIntervalId);
      retryIntervalId = null;
    }
    Monitor.disconnectMonitorControlChannel();
    if (monitorPlayer) {
      monitorPlayer.destroy();
      monitorPlayer = null;
    }
    cameraInfoMap = null;
    if (gnbHideTimeout) {
      $timeout.cancel(gnbHideTimeout);
      gnbHideTimeout = null;
    }
    $("#toastFooter").show();
    $("#toastGnb").stop();
    $("#toastGnb").show();
    $("#toastGnb").css({
      top: "0px"
    });
    window.drag = null;
    window.drop = null;
    window.allowDropList = null;
    window.allowDropUserCam = null;
    if (!movingCamDetail) {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      } else if (document.msCancelFullScreen) {
        document.msCancelFullScreen();
      }
    } else {
      movingCamDetail = false;
    }
  });

  /********************************* [Drag & Drop] Start ***********************************/
  function initDragDropEl() {
    var i, len;
    //get the collection of draggable items and add their draggable attributes
    items = document.querySelectorAll('[data-draggable="item"]');
    len = items.length;
    for (i = 0; i < len; i += 1) {
      items[i].setAttribute("aria-grabbed", "false");
      items[i].setAttribute("tabindex", "0");
    }
    selections = {
      items: [],
      owner: null,
      droptarget: null
    };
  }
  function addSelection(item) {
    $scope.isShowMonitorTooltip = false;
    item.setAttribute("aria-grabbed", "true"); //set this item's grabbed state

    selections.items.push(item); //add it to the items array
    if (item.dataset && item.dataset.cameraid && item.dataset.cameraid.indexOf("_") != -1) {
      $scope.isShowMonitorTooltip = true;
      $scope.tooltipMessage = $translate.instant("STR_REMOVE_FROM_LIST");
      if (tooltip_timeout) {
        $timeout.cancel(tooltip_timeout);
      }
      tooltip_timeout = $timeout(function () {
        $scope.isShowMonitorTooltip = false;
      }, 2000);
    }
  }
  function removeSelection(item) {
    var i,
      len = selections.items.length;
    item.setAttribute("aria-grabbed", "false"); //reset this item's grabbed state
    for (i = 0; i < len; i += 1) {
      if (selections.items[i] == item) {
        selections.items.splice(i, 1);
        break;
      }
    }
  }
  function clearSelections() {
    if (selections.items.length) {
      //reset the grabbed state on every selected item
      var i,
        len = selections.items.length;
      for (i = 0; i < len; i += 1) {
        selections.items[i].setAttribute("aria-grabbed", "false");
      }
      selections.items = []; //then reset the items array
    }
  }
  function hasModifier(e) {
    return e.ctrlKey || e.metaKey || e.shiftKey;
  }
  function getDraggableContainer(element) {
    var elDraggable = null;
    if (element.className.indexOf("drag_child_child") != -1) {
      elDraggable = element.parentNode.parentNode;
    } else if (element.className.indexOf("drag_child") != -1) {
      elDraggable = element.parentNode;
    } else if (element.getAttribute("draggable")) {
      elDraggable = element;
    }
    return elDraggable;
  }
  function mouseDownEventHandler(e) {
    if (!$scope.userDefineMode) {
      return;
    }
    if (e.target.id === "select_cam_ul") {
      return;
    }
    var elDraggable = getDraggableContainer(e.target);
    if (elDraggable) {
      //if the multiple selection modifier is not pressed
      //and the item's grabbed state is currently false
      if (!hasModifier(e) && elDraggable.getAttribute("aria-grabbed") == "false") {
        //clear all existing selections
        clearSelections();
        //then add this new selection
        addSelection(elDraggable);
      }
    } else if (!hasModifier(e)) {
      //else [if the element is anything else] and the selection modifier is not pressed
      //clear all existing selections
      clearSelections();
    }
  }
  function mouseUpEventHandler(e) {
    if (!$scope.userDefineMode) {
      return;
    }
    if (e.target.id === "select_cam_ul") {
      return;
    }
    var elDraggable = getDraggableContainer(e.target);
    if (elDraggable && hasModifier(e)) {
      //if the element is a draggable item and the multipler selection modifier is pressed
      if (elDraggable.getAttribute("aria-grabbed") == "true") {
        //if the item's grabbed state is currently true
        //unselect this item
        removeSelection(elDraggable);
      } else {
        //else [if the item's grabbed state is false]
        //add this additional selection
        addSelection(elDraggable);
      }
    }
  }
  function dragEndEventHandler(e) {
    e.preventDefault();
    $scope.userCamDragTargetId = "";
  }
  function dragStartEventHandler(e) {
    if (!$scope.userDefineMode) {
      return;
    }
    var elDraggable = getDraggableContainer(e.target);
    if (hasModifier(e) && elDraggable && elDraggable.getAttribute("aria-grabbed") == "false") {
      addSelection(elDraggable);
    }
    e.dataTransfer.setData("text", "");
  }
  document.addEventListener("mousedown", mouseDownEventHandler, false);
  document.addEventListener("mouseup", mouseUpEventHandler, false);
  document.addEventListener("dragstart", dragStartEventHandler, false);
  document.addEventListener("dragend", dragEndEventHandler, false);
  function getSelectedCamIds(selectEls, targetId) {
    var arr = [],
      id,
      i,
      len = selectEls.length;
    for (i = len - 1; i >= 0; i -= 1) {
      id = selectEls[i].id || selectEls[i].dataset.cameraid;
      if (id) {
        id = id.replace(/\_/g, "");
      }
      if (id != targetId) {
        arr.push(id);
      }
    }
    return arr;
  }
  function hasData(arr, value) {
    var i,
      len = arr.length;
    for (i = 0; i < len; i += 1) {
      if (arr[i] === value) {
        return true;
      }
    }
    return false;
  }
  window.drop = function (event) {
    event.preventDefault();
    if (!isDropUserCamAllowed) {
      return;
    } else {
      isDropUserCamAllowed = false;
    }
    if (!$scope.userCamDragTargetId) {
      $scope.userCamDragTargetId = "";
    }
    var dragTargetId = $scope.userCamDragTargetId.replace(/\_/g, "");
    var dataArr = getSelectedCamIds(selections.items, dragTargetId);
    if (!dataArr || !dataArr.length || !dataArr[0]) {
      $scope.userCamDragTargetId = null;
      $scope.$apply();
      return;
    }
    var dimension = $scope.tempConfigData.customModeSettings.dimension;
    var i,
      len = $scope.tempConfigData.customModeSettings.cameras[$scope.userDefinePagingSelectIndex].length;
    for (i = len - 1; i >= 0; i -= 1) {
      if (!$scope.tempConfigData.customModeSettings.cameras[$scope.userDefinePagingSelectIndex][i] || hasData(dataArr, $scope.tempConfigData.customModeSettings.cameras[$scope.userDefinePagingSelectIndex][i])) {
        $scope.tempConfigData.customModeSettings.cameras[$scope.userDefinePagingSelectIndex].splice(i, 1);
      }
    }
    if ($scope.tempConfigData.customModeSettings.cameras[$scope.userDefinePagingSelectIndex].length + dataArr.length <= dimension * dimension) {
      insertDataNextToId($scope.tempConfigData.customModeSettings.cameras[$scope.userDefinePagingSelectIndex], dragTargetId, dataArr);
    } else {
      showAlert($translate.instant("STR_USER_SET_CAM"), $translate.instant("STR_PAGE_FULL"));
    }
    len = dimension * dimension - $scope.tempConfigData.customModeSettings.cameras[$scope.userDefinePagingSelectIndex].length;
    for (i = 0; i < len; i += 1) {
      $scope.tempConfigData.customModeSettings.cameras[$scope.userDefinePagingSelectIndex].push("");
    }
    $scope.userCamDragTargetId = null;
    makeUserNotSelectCameras();
    clearSelections();
    $scope.$apply();
    $timeout(function () {
      initDragDropEl();
    }, 100);
  };
  var isDropUserCamAllowed = false;
  window.allowDropUserCam = function (event) {
    event.preventDefault();
    var cameraId = event.currentTarget.id || event.currentTarget.dataset.cameraid;
    if (!cameraId) {
      return;
    }
    if (cameraId === "_") {
      var lastCamId = findCurrentPageLastUserCam();
      $scope.userCamDragTargetId = lastCamId ? "_" + lastCamId : null;
    } else {
      $scope.userCamDragTargetId = cameraId;
    }
    $scope.$apply();
    isDropUserCamAllowed = true;
  };
  var isDropListCamAllowed = false;
  window.dropSelectCam = function (event) {
    event.preventDefault();
    if (!isDropListCamAllowed) {
      return;
    } else {
      isDropListCamAllowed = false;
    }
    var dataArr = getSelectedCamIds(selections.items, "");
    if (!dataArr.length) {
      return;
    }
    var i,
      j,
      camLen = dataArr.length,
      len = $scope.tempConfigData.customModeSettings.cameras[$scope.userDefinePagingSelectIndex].length;
    for (j = 0; j < camLen; j += 1) {
      for (i = 0; i < len; i += 1) {
        if ($scope.tempConfigData.customModeSettings.cameras[$scope.userDefinePagingSelectIndex][i] === dataArr[j]) {
          $scope.tempConfigData.customModeSettings.cameras[$scope.userDefinePagingSelectIndex].splice(i, 1);
          $scope.tempConfigData.customModeSettings.cameras[$scope.userDefinePagingSelectIndex].push("");
        }
      }
    }
    makeUserNotSelectCameras();
    clearSelections();
    $scope.$apply();
    $timeout(function () {
      initDragDropEl();
    }, 100);
  };
  window.allowDropList = function (event) {
    event.preventDefault();
    isDropListCamAllowed = true;
  };
  function insertDataNextToId(list, id, dataArr) {
    var findIdx = -1,
      i,
      len = list.length;
    for (i = 0; i < len; i += 1) {
      if (list[i] === id) {
        findIdx = i;
        break;
      }
    }
    if (findIdx === -1) {
      findIdx = len - 1;
    }
    for (i = 0, len = dataArr.length; i < len; i += 1) {
      list.splice(findIdx + 1, 0, dataArr[i]);
    }
  }
  function findCurrentPageLastUserCam() {
    var i,
      len = $scope.tempConfigData.customModeSettings.cameras[$scope.userDefinePagingSelectIndex].length;
    for (i = len - 1; i >= 0; i -= 1) {
      if ($scope.tempConfigData.customModeSettings.cameras[$scope.userDefinePagingSelectIndex][i]) {
        return $scope.tempConfigData.customModeSettings.cameras[$scope.userDefinePagingSelectIndex][i];
      }
    }
    return null;
  }
  /********************************* [Drag & Drop] End ***********************************/

  /********************************* [Gnb & FullScreen Control] Start ***********************************/
  function hoverGnbShow() {
    var $gnb = $("#toastGnb");
    readyToGnbHide = false;
    if (gnbHideTimeout) {
      $timeout.cancel(gnbHideTimeout);
      gnbHideTimeout = null;
    }
    if (($gnb.is(":hover") || $("#hoverGnb").is(":hover") || $("#monitor_setting").is(":hover") || $("#fullmode_setting").is(":hover")) && !isAnimating) {
      isAnimating = true;
      $scope.gnbShow = true;
      $scope.$apply();
      $gnb.show();
      $gnb.animate({
        top: "0px"
      }, 350, function () {
        $gnb.show();
        isAnimating = false;
      });
    }
  }
  function hoverGnbHide() {
    var $gnb = $("#toastGnb");
    if (!$gnb.is(":hover") && !$("#hoverGnb").is(":hover") && !$("#monitor_setting").is(":hover") && !$("#fullmode_setting").is(":hover")) {
      readyToGnbHide = true;
      if (gnbHideTimeout) {
        $timeout.cancel(gnbHideTimeout);
      }
      gnbHideTimeout = $timeout(function () {
        if (!$gnb.is(":hover") && !$("#hoverGnb").is(":hover") && !$("#monitor_setting").is(":hover") && !$("#fullmode_setting").is(":hover")) {
          if (readyToGnbHide === true) {
            isAnimating = true;
            $scope.gnbShow = false;
            $scope.$apply();
            $gnb.animate({
              top: "-100px"
            }, 350, function () {
              $gnb.hide();
              isAnimating = false;
            });
            readyToGnbHide = false;
          }
        }
      }, 500);
    }
  }
  function topGnbHoverOut(e) {
    hoverGnbHide();
  }
  function topMenuHoverIn(e) {
    hoverGnbShow();
  }
  function topMenuHoverOut(e) {
    hoverGnbHide();
  }
  function mousemoveEventHandler(e) {
    if (e.clientY > 185) {
      hoverGnbHide();
    }
  }
  function isFullScreen() {
    return !!(document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement);
  }
  $scope.fullModeChange = function () {
    if (isFullScreen()) {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      } else if (document.msCancelFullScreen) {
        document.msCancelFullScreen();
      }
    } else {
      var element = document.querySelector("body div");
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen();
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen();
      }
    }
  };
  function fullscreenHandler(event) {
    if (isFullScreen()) {
      $scope.bFullScreen = true;
    } else {
      $scope.bFullScreen = false;
    }
  }
  function keyupHandler(event) {
    if (event.which == 122) {
      event.preventDefault();
      var element = document.querySelector("body div");
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen();
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen();
      }
      return false;
    }
  }
  /********************************* [Gnb & FullScreen Control] End ***********************************/

  /********************************* [Setting] Start **************************************/
  function setModeStr(mode) {
    if (mode === "event") {
      $scope.modeStr = $translate.instant("STR_EVENT_NEW_CAM_ONLY");
    } else if (mode === "custom") {
      $scope.modeStr = $translate.instant("STR_USER_SET_CAM");
    } else {
      $scope.modeStr = $translate.instant("STR_ALL_CAMERA");
    }
  }
  $scope.onClickSetWrapper = function (event) {
    var className = event.target.className;
    if (className.indexOf("dropdown") == -1 && className.indexOf("dropdown_wrap") == -1) {
      $scope.hideAllSelector();
    }
  };
  $scope.hideAllSelector = function () {
    $scope.isShowModeSelector = false;
    $scope.isShowIntervalSelector = false;
    $scope.isShowTimeLocSelector = false;
    $scope.isShowTimeHourSelector = false;
    $scope.isShowStreamTypeSelector = false;
    $scope.isShowDimensionSelector = false;
  };
  $scope.selectMode = function (mode) {
    $scope.tempConfigData.mode = mode;
    if (mode == "custom") {
      $scope.tooltipMessage = $translate.instant("STR_MULTI_PULL");
      if (tooltip_timeout) {
        $timeout.cancel(tooltip_timeout);
      }
      $scope.isShowMonitorTooltip = true;
      $scope.userDefineMode = true;
      $timeout(function () {
        initDragDropEl();
      }, 100);
    } else {
      $scope.userDefineMode = false;
    }
    $timeout(function () {
      setSetCamSize($scope.getCurrentSettingDimension());
      if (!$scope.userDefineMode) {
        initSetCamPaging();
        makeSampleCameras();
      }
    }, 0);
    setModeStr(mode);
    $scope.hideAllSelector();
  };
  $scope.selectInterval = function (interval) {
    $scope.tempConfigData.interval = interval * 1000;
    $scope.hideAllSelector();
  };
  $scope.selectDimension = function (dimension) {
    setCurrentSettingDimension(dimension);
    setSetCamSize($scope.getCurrentSettingDimension());
    makeTempUserDefinedCameras();
    initSetCamPaging();
    makeSampleCameras();
    $scope.hideAllSelector();
  };
  $scope.selectTimeLoc = function (loc) {
    $scope.tempConfigData.timeLoc = loc;
    $scope.hideAllSelector();
  };
  $scope.selectTimeHour = function (hour) {
    $scope.tempConfigData.timeHour = hour;
    $scope.hideAllSelector();
  };
  $scope.selectStreamType = function (type) {
    var mainMaxDimension = 4;
    $scope.tempConfigData.streamType = type;
    if ($scope.tempConfigData.streamType === "main") {
      if ($scope.getCurrentSettingDimension() > mainMaxDimension) {
        $scope.selectDimension(mainMaxDimension);
      }
      if ($scope.tempConfigData.pagingModeSettings.dimension > mainMaxDimension) {
        $scope.tempConfigData.pagingModeSettings.dimension = mainMaxDimension;
      }
      if ($scope.tempConfigData.eventModeSettings.dimension > mainMaxDimension) {
        $scope.tempConfigData.eventModeSettings.dimension = mainMaxDimension;
      }
      if ($scope.tempConfigData.customModeSettings.dimension > mainMaxDimension) {
        $scope.tempConfigData.customModeSettings.dimension = mainMaxDimension;
        makeTempUserDefinedCameras();
      }
    }
    $scope.hideAllSelector();
  };
  $scope.selectSetCamPage = function (page) {
    var dimension = $scope.getCurrentSettingDimension();
    $scope.setCamPagingSelectIndex = page - 1;
    $scope.sampleCamFirstIndex = dimension * dimension * $scope.setCamPagingSelectIndex;
    makeSampleCameras();
  };
  $scope.prevSetCamPage = function () {
    var dimension = $scope.getCurrentSettingDimension();
    if ($scope.setCamPagingSelectIndex + 1 === $scope.showSetCamPage[0]) {
      if ($scope.movePagingIndex(-1)) {
        $scope.setCamPagingSelectIndex -= 1;
      }
    } else {
      if ($scope.setCamPage[$scope.setCamPagingSelectIndex - 1]) {
        $scope.setCamPagingSelectIndex -= 1;
      }
    }
    $scope.sampleCamFirstIndex = dimension * dimension * $scope.setCamPagingSelectIndex;
    makeSampleCameras();
  };
  $scope.nextSetCamPage = function () {
    var dimension = $scope.getCurrentSettingDimension();
    if ($scope.setCamPagingSelectIndex + 1 === $scope.showSetCamPage[$scope.showSetCamPage.length - 1]) {
      if ($scope.movePagingIndex(1)) {
        $scope.setCamPagingSelectIndex += 1;
      }
    } else {
      if ($scope.setCamPage[$scope.setCamPagingSelectIndex + 1]) {
        $scope.setCamPagingSelectIndex += 1;
      }
    }
    $scope.sampleCamFirstIndex = dimension * dimension * $scope.setCamPagingSelectIndex;
    makeSampleCameras();
  };
  $scope.selectUserCamPage = function (page) {
    $scope.userDefinePagingSelectIndex = page - 1;
    makeUserNotSelectCameras();
  };
  $scope.prevUserCamPage = function () {
    var dimension = $scope.getCurrentSettingDimension();
    if ($scope.userDefinePagingSelectIndex + 1 === $scope.showUserDefineSetCamPage[0]) {
      if ($scope.moveUserPagingIndex(-1)) {
        $scope.userDefinePagingSelectIndex -= 1;
      }
    } else {
      if ($scope.userDefineSetCamPage[$scope.userDefinePagingSelectIndex - 1]) {
        $scope.userDefinePagingSelectIndex -= 1;
      }
    }
    $scope.userDefineCamFirstIndex = dimension * dimension * $scope.userDefinePagingSelectIndex;
    makeUserNotSelectCameras();
  };
  $scope.nextUserCamPage = function () {
    var dimension = $scope.getCurrentSettingDimension();
    if ($scope.userDefinePagingSelectIndex + 1 === $scope.showUserDefineSetCamPage[$scope.showUserDefineSetCamPage.length - 1]) {
      if ($scope.moveUserPagingIndex(1)) {
        $scope.userDefinePagingSelectIndex += 1;
      }
    } else {
      if ($scope.userDefineSetCamPage[$scope.userDefinePagingSelectIndex + 1]) {
        $scope.userDefinePagingSelectIndex += 1;
      }
    }
    $scope.userDefineCamFirstIndex = dimension * dimension * $scope.userDefinePagingSelectIndex;
    makeUserNotSelectCameras();
  };
  $scope.addUserCamPage = function () {
    if ($scope.tempConfigData.customModeSettings.cameras.length >= 100) {
      return;
    }
    var i,
      len,
      camPage = [],
      dimension = $scope.tempConfigData.customModeSettings.dimension;
    len = dimension * dimension;
    for (i = 0; i < len; i += 1) {
      camPage.push("");
    }
    $scope.tempConfigData.customModeSettings.cameras.push(camPage);
    $scope.userDefineSetCamPage = [];
    len = $scope.tempConfigData.customModeSettings.cameras.length;
    for (i = 0; i < len; i += 1) {
      $scope.userDefineSetCamPage.push(i + 1);
    }
    $scope.showUserDefineSetCamPage = $scope.userDefineSetCamPage.slice($scope.userDefinePagingFirstIndex, $scope.userDefinePagingFirstIndex + 10);
  };
  $scope.removeUserCamPage = function (page) {
    if ($scope.tempConfigData.customModeSettings.cameras.length < 2) {
      showAlert($translate.instant("STR_PAGE_REMOVE"), $translate.instant("STR_NOT_REMOVE_PAGE"));
      return;
    }
    $scope.tempConfigData.customModeSettings.cameras.splice(page, 1);
    $scope.userDefineSetCamPage = [];
    var i,
      len = $scope.tempConfigData.customModeSettings.cameras.length;
    for (i = 0; i < len; i += 1) {
      $scope.userDefineSetCamPage.push(i + 1);
    }
    $scope.userDefinePagingSelectIndex = page - 1 >= 0 ? page - 1 : 0;
    $scope.userDefinePagingFirstIndex -= 1;
    if ($scope.userDefinePagingFirstIndex < 0) {
      $scope.userDefinePagingFirstIndex = 0;
    }
    makeUserNotSelectCameras();
    $scope.showUserDefineSetCamPage = $scope.userDefineSetCamPage.slice($scope.userDefinePagingFirstIndex, $scope.userDefinePagingFirstIndex + 10);
  };
  $scope.checkSharedWithCamId = function (id) {
    var camObj = null,
      i,
      len = $scope.monitorConfigData.cloudMonitorCameraList.length;
    for (i = 0; i < len; i += 1) {
      if ($scope.monitorConfigData.cloudMonitorCameraList[i].cameraId === id) {
        camObj = $scope.monitorConfigData.cloudMonitorCameraList[i];
        break;
      }
    }
    if (camObj) {
      if (isSharedCamera(camObj.categoryList)) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };
  function initUserSetCamPaging() {
    $scope.userDefineSetCamPage = [];
    var i,
      len = $scope.tempConfigData.customModeSettings.cameras.length;
    for (i = 0; i < len; i += 1) {
      $scope.userDefineSetCamPage.push(i + 1);
    }
    $scope.userDefinePagingFirstIndex = 0;
    $scope.userDefinePagingSelectIndex = 0;
    $scope.userDefineCamFirstIndex = 0;
    makeUserNotSelectCameras();
    $scope.showUserDefineSetCamPage = $scope.userDefineSetCamPage.slice($scope.userDefinePagingFirstIndex, $scope.userDefinePagingFirstIndex + 10);
  }
  function initSetCamPaging() {
    var dimension = $scope.getCurrentSettingDimension();
    $scope.setCamPage = [];
    var i,
      len = Math.ceil($scope.monitorConfigData.cloudMonitorCameraList.length / (dimension * dimension));
    for (i = 0; i < len; i += 1) {
      $scope.setCamPage.push(i + 1);
    }
    $scope.setCamPagingFirstIndex = 0;
    $scope.setCamPagingSelectIndex = 0;
    $scope.sampleCamFirstIndex = 0;
    $scope.showSetCamPage = $scope.setCamPage.slice($scope.setCamPagingFirstIndex, $scope.setCamPagingFirstIndex + 10);
  }
  $scope.moveUserPagingIndex = function (move) {
    var isMove = true;
    $scope.userDefinePagingFirstIndex += move;
    if ($scope.userDefinePagingFirstIndex < 0) {
      $scope.userDefinePagingFirstIndex = 0;
      isMove = false;
    } else if ($scope.userDefinePagingFirstIndex + 10 >= $scope.userDefineSetCamPage.length) {
      $scope.userDefinePagingFirstIndex = $scope.userDefineSetCamPage.length - 10;
      isMove = false;
    }
    $scope.showUserDefineSetCamPage = $scope.userDefineSetCamPage.slice($scope.userDefinePagingFirstIndex, $scope.userDefinePagingFirstIndex + 10);
    return isMove;
  };
  $scope.movePagingIndex = function (move) {
    var isMove = true;
    $scope.setCamPagingFirstIndex += move;
    if ($scope.setCamPagingFirstIndex < 0) {
      $scope.setCamPagingFirstIndex = 0;
      isMove = false;
    } else if ($scope.setCamPagingFirstIndex + 10 >= $scope.setCamPage.length) {
      $scope.setCamPagingFirstIndex = $scope.setCamPage.length - 10;
      isMove = false;
    }
    $scope.showSetCamPage = $scope.setCamPage.slice($scope.setCamPagingFirstIndex, $scope.setCamPagingFirstIndex + 10);
    return isMove;
  };
  function makeSampleCameras() {
    var cameraList = [],
      dimension = $scope.getCurrentSettingDimension();
    if ($scope.monitorConfigData.cloudMonitorCameraList) {
      cameraList = $scope.monitorConfigData.cloudMonitorCameraList.filter(function (obj) {
        if (obj && obj.cameraId) {
          return true;
        }
        return false;
      });
    }
    cameraList.sort(function (a, b) {
      var aLabel = "",
        bLabel = "";
      if (a && a.labelName && a.labelName.toLowerCase) {
        aLabel = a.labelName.toLowerCase();
      }
      if (b && b.labelName && b.labelName.toLowerCase) {
        bLabel = b.labelName.toLowerCase();
      }
      return aLabel < bLabel ? -1 : aLabel > bLabel ? 1 : 0;
    });
    $scope.sampleCameras = cameraList.slice($scope.sampleCamFirstIndex, $scope.sampleCamFirstIndex + dimension * dimension);
    if ($scope.sampleCameras.length < dimension * dimension) {
      var i,
        len = dimension * dimension - $scope.sampleCameras.length;
      for (i = 0; i < len; i += 1) {
        $scope.sampleCameras.push([{
          thumbnail: "",
          labelName: ""
        }]);
      }
    }
  }
  $scope.nextIndex = 10; // 다음 인덱스
  function makeUserNotSelectCameras() {
    $scope.userNotSelectCameras = $scope.monitorConfigData.cloudMonitorCameraList.map(function (obj) {
      var j, innerLen;
      for (j = 0, innerLen = $scope.tempConfigData.customModeSettings.cameras[$scope.userDefinePagingSelectIndex].length; j < innerLen; j += 1) {
        if ($scope.tempConfigData.customModeSettings.cameras[$scope.userDefinePagingSelectIndex][j] === obj.cameraId) {
          return null;
        }
      }
      return {
        cameraId: obj.cameraId,
        labelName: obj.labelName,
        thumbnailPath: obj.thumbnailPath
      };
    });
    var i;
    for (i = $scope.userNotSelectCameras.length - 1; i >= 0; i -= 1) {
      if (!$scope.userNotSelectCameras[i]) {
        $scope.userNotSelectCameras.splice(i, 1);
      }
    }
    $scope.nextIndex = 10; // 다음 인덱스
  }
  $scope.loadMore = function () {
    if (Array.isArray($scope.userNotSelectCameras)) {
      $scope.nextIndex += 10;
    }
  };
  $scope.isTrustedCamera = function (cameraId) {
    if (!cameraId) {
      return "";
    }
    return $scope.monitorConfigData.cloudMonitorCameraList.find(function (camera) {
      return cameraId == camera.cameraId;
    });
  };
  $scope.getThumbnail = function (cameraId) {
    if (!cameraId) {
      return "";
    }
    var findCamera = $scope.isTrustedCamera(cameraId);
    if (!findCamera) {
      return "";
    }
    return $scope.imgProtocol + findCamera.thumbnail;
  };
  $scope.getLabelName = function (cameraId) {
    if (!cameraId) {
      return "";
    }
    var i,
      len = $scope.monitorConfigData.cloudMonitorCameraList.length,
      labelName = "";
    for (i = 0; i < len; i += 1) {
      if ($scope.monitorConfigData.cloudMonitorCameraList[i].cameraId === cameraId) {
        labelName = $scope.monitorConfigData.cloudMonitorCameraList[i].labelName;
        break;
      }
    }
    return labelName;
  };
  function isSharedCamera(categoryList) {
    if (!categoryList || !categoryList.length) {
      return false;
    }
    var i,
      len = categoryList.length;
    for (i = 0; i < len; i += 1) {
      if (categoryList[i] === "myCamera") {
        return false;
      }
    }
    return true;
  }
  function removeDuplicateInArray(arrayData) {
    var object = {};
    var result = [];
    arrayData.forEach(function (item) {
      if (!item) {
        return;
      }
      if (!object[item]) {
        object[item] = 1;
        result.push(item);
      }
    });
    return result;
  }
  function rebaseTempUserDefinedCameras() {
    if ($scope.tempConfigData.customModeSettings.cameras.length) {
      var i,
        j,
        pageLen = 0,
        len = 0,
        concatCams = [],
        makePageLen = 0,
        dimension = $scope.tempConfigData.customModeSettings.dimension;
      pageLen = $scope.tempConfigData.customModeSettings.cameras.length;
      for (i = 0; i < pageLen; i += 1) {
        /* remove empty slot and concat all page */
        len = $scope.tempConfigData.customModeSettings.cameras[i].length;
        for (j = len - 1; j >= 0; j -= 1) {
          if (!$scope.tempConfigData.customModeSettings.cameras[i][j]) {
            $scope.tempConfigData.customModeSettings.cameras[i].splice(j, 1);
          }
        }
        concatCams = concatCams.concat($scope.tempConfigData.customModeSettings.cameras[i]);
      }
      makePageLen = Math.ceil(concatCams.length / (dimension * dimension)); /* make userDefinedCameras */
      $scope.tempConfigData.customModeSettings.cameras = [];
      for (i = 0; i < makePageLen; i += 1) {
        $scope.tempConfigData.customModeSettings.cameras.push(concatCams.slice(i * dimension * dimension, i * dimension * dimension + dimension * dimension));
      }
      for (i = 0, makePageLen = $scope.tempConfigData.customModeSettings.cameras.length; i < makePageLen; i += 1) {
        $scope.tempConfigData.customModeSettings.cameras[i] = removeDuplicateInArray($scope.tempConfigData.customModeSettings.cameras[i]);
      }
    }
    if (!$scope.tempConfigData.customModeSettings.cameras.length) {
      $scope.tempConfigData.customModeSettings.cameras.push([]);
    }
  }
  function makeTempUserDefinedCameras() {
    if (!$scope.tempConfigData.customModeSettings.cameras.length) {
      $scope.tempConfigData.customModeSettings.cameras = $scope.monitorConfigData.cloudMonitorSettings.customModeSettings.cameras.concat([]).map(function (obj) {
        return obj.concat([]);
      });
    } else {
      rebaseTempUserDefinedCameras();
    }
    var i,
      j,
      pageLen = 0,
      len = 0,
      customDimension = $scope.tempConfigData.customModeSettings.dimension;
    pageLen = $scope.tempConfigData.customModeSettings.cameras.length;
    for (i = 0; i < pageLen; i += 1) {
      if (customDimension * customDimension > $scope.tempConfigData.customModeSettings.cameras[i].length) {
        len = customDimension * customDimension - $scope.tempConfigData.customModeSettings.cameras[i].length;
        for (j = 0; j < len; j += 1) {
          $scope.tempConfigData.customModeSettings.cameras[i].push("");
        }
      }
    }
    initUserSetCamPaging();
  }
  $scope.showSetMode = function (isShow) {
    $scope.hideAllSelector();
    if (isShow) {
      $scope.tempConfigData = {
        mode: $scope.monitorConfigData.cloudMonitorSettings.currentViewMode,
        interval: $scope.monitorConfigData.cloudMonitorSettings.interval,
        customModeSettings: {
          dimension: $scope.monitorConfigData.cloudMonitorSettings.customModeSettings.dimension,
          cameras: []
        },
        pagingModeSettings: {
          dimension: $scope.monitorConfigData.cloudMonitorSettings.pagingModeSettings.dimension
        },
        eventModeSettings: {
          dimension: $scope.monitorConfigData.cloudMonitorSettings.eventModeSettings.dimension
        },
        timeLoc: $scope.monitorConfigData.cloudMonitorSettings.currentTime.enable,
        timeHour: $scope.monitorConfigData.cloudMonitorSettings.currentTime.hourMode,
        streamType: $scope.monitorConfigData.cloudMonitorSettings.streamType
      };
      setModeStr($scope.tempConfigData.mode);
      makeTempUserDefinedCameras();
      makeUserNotSelectCameras();
      if ($scope.tempConfigData.mode == "custom") {
        $scope.tooltipMessage = $translate.instant("STR_MULTI_PULL");
        if (tooltip_timeout) {
          $timeout.cancel(tooltip_timeout);
        }
        $scope.isShowMonitorTooltip = true;
        $scope.userDefineMode = true;
        $timeout(function () {
          initDragDropEl();
        }, 100);
      } else {
        $scope.userDefineMode = false;
      }
      initSetCamPaging();
      makeSampleCameras();
      $timeout(function () {
        setSetCamSize($scope.getCurrentSettingDimension());
      }, 100);
    } else {
      setTimeout(function () {
        if (monitorPlayer) {
          monitorPlayer.gridSizeChange($("#flashWrap").width(), $("#flashWrap").height());
        }
      }, 100);
    }
    $scope.isSetMode = isShow;
  };
  $scope.squenceDropDownClick = function () {
    if ($scope.tempConfigData.mode == "event") {
      return;
    } else {
      $scope.hideAllSelector();
      $scope.isShowIntervalSelector = !$scope.isShowIntervalSelector;
    }
  };
  $scope.saveSetting = function () {
    if ($scope.tempConfigData.mode === "custom") {
      var i,
        j,
        isEmpty = true,
        camLen,
        len = $scope.tempConfigData.customModeSettings.cameras.length;
      for (i = 0; i < len; i += 1) {
        camLen = $scope.tempConfigData.customModeSettings.cameras[i].length;
        isEmpty = true;
        for (j = 0; j < camLen; j += 1) {
          if ($scope.tempConfigData.customModeSettings.cameras[i][j]) {
            isEmpty = false;
            break;
          }
        }
        if (isEmpty) {
          showAlert($translate.instant("STR_USER_SET_CAM"), $translate.instant("STR_NO_SAVE_EMPTY_PAGE"));
          return;
        }
      }
    }
    $scope.monitorConfigData.cloudMonitorSettings.currentViewMode = $scope.tempConfigData.mode;
    $scope.monitorConfigData.cloudMonitorSettings.customModeSettings.dimension = $scope.tempConfigData.customModeSettings.dimension;
    $scope.monitorConfigData.cloudMonitorSettings.pagingModeSettings.dimension = $scope.tempConfigData.pagingModeSettings.dimension;
    $scope.monitorConfigData.cloudMonitorSettings.eventModeSettings.dimension = $scope.tempConfigData.eventModeSettings.dimension;
    $scope.monitorConfigData.cloudMonitorSettings.interval = $scope.tempConfigData.interval;
    $scope.monitorConfigData.cloudMonitorSettings.customModeSettings.cameras = $scope.tempConfigData.customModeSettings.cameras;
    $scope.monitorConfigData.cloudMonitorSettings.currentTime.enable = $scope.tempConfigData.timeLoc;
    $scope.monitorConfigData.cloudMonitorSettings.currentTime.hourMode = $scope.tempConfigData.timeHour;
    $scope.monitorConfigData.cloudMonitorSettings.streamType = $scope.tempConfigData.streamType;
    currentMonitoringCameras = [];
    if ($stateParams.demo != "ok") {
      $.ajax({
        url: "/json/biz/cloudMonitor/settings",
        type: "POST",
        data: JSON.stringify($scope.monitorConfigData.cloudMonitorSettings),
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        success: function success(data) {},
        error: function error() {}
      });
    }
    if ($scope.monitorConfigData.cloudMonitorSettings.currentTime.enable) {
      clockIntervalStart();
    } else {
      clockIntervalStop();
    }
    $scope.showSetMode(false);
    if (!Utils.isIE()) {
      $timeout(function () {
        restartMonitor();
      }, 100);
    }
  };
  function setSetCamSize(dimension) {
    $scope.setCamListWidth = document.body.offsetWidth / 100 * 60;
    if ($scope.setCamListWidth < 800) {
      $scope.setCamListWidth = 800;
    }
    $scope.setCamListHeight = document.body.offsetHeight / 100 * 70;
    if ($scope.setCamListHeight < 600) {
      $scope.setCamListHeight = 600;
    }
    $scope.setfullCamWidth = 100 / dimension;
    $scope.setfullCamHeight = 100 / dimension;
  }
  $scope.getCurrentSettingDimensionTxt = function () {
    var dimension = $scope.getCurrentSettingDimension(),
      txt;
    switch (dimension) {
      case 1:
        txt = "1x1";
        break;
      case 2:
        txt = "2x2";
        break;
      case 3:
        txt = "3x3";
        break;
      case 4:
        txt = "4x4";
        break;
      case 5:
        txt = "5x5";
        break;
      case 6:
        txt = "6x6";
        break;
      default:
        txt = "1x1";
        break;
    }
    return txt;
  };
  $scope.getCurrentSettingDimension = function () {
    if ($scope.tempConfigData.mode === "paging") {
      return $scope.tempConfigData.pagingModeSettings.dimension;
    } else if ($scope.tempConfigData.mode === "event") {
      return $scope.tempConfigData.eventModeSettings.dimension;
    } else {
      return $scope.tempConfigData.customModeSettings.dimension;
    }
  };
  function setCurrentSettingDimension(dimension) {
    if ($scope.tempConfigData.mode === "paging") {
      $scope.tempConfigData.pagingModeSettings.dimension = dimension;
    } else if ($scope.tempConfigData.mode === "event") {
      $scope.tempConfigData.eventModeSettings.dimension = dimension;
    } else {
      $scope.tempConfigData.customModeSettings.dimension = dimension;
    }
  }
  function getCurrentDimension() {
    if ($scope.monitorConfigData.cloudMonitorSettings.currentViewMode === "paging") {
      return $scope.monitorConfigData.cloudMonitorSettings.pagingModeSettings.dimension;
    } else if ($scope.monitorConfigData.cloudMonitorSettings.currentViewMode === "event") {
      return $scope.monitorConfigData.cloudMonitorSettings.eventModeSettings.dimension;
    } else {
      return $scope.monitorConfigData.cloudMonitorSettings.customModeSettings.dimension;
    }
  }
  /********************************* [Setting] End **************************************/

  /********************************* [Cloud Monitor Play] Start **********************************/
  $scope.goDetail = function (id) {
    if (!id) {
      return;
    }
    var trident = navigator.userAgent.match(/Trident\/(\d)/i);
    if (trident != null) {
      document.documentElement.scrollTop = 0;
    } else {
      $("body").scrollTop(0);
    }
    $("#wrap").hide();
    movingCamDetail = true;
    var camObj = null,
      i,
      len = $scope.monitorConfigData.cloudMonitorCameraList.length;
    for (i = 0; i < len; i += 1) {
      if ($scope.monitorConfigData.cloudMonitorCameraList[i].cameraId === id) {
        camObj = $scope.monitorConfigData.cloudMonitorCameraList[i];
        break;
      }
    }
    if ($stateParams.demo === "ok") {
      $state.go("main.monitorDetail", {
        cameraId: id,
        type: "camera",
        demo: true
      });
    } else {
      var shopId = findShopId(id);
      if (isSharedCamera(camObj.categoryList)) {
        $state.go("main.monitorDetail", {
          cameraId: id,
          type: "camera",
          shared: true,
          shopId: shopId
        });
      } else {
        $state.go("main.monitorDetail", {
          cameraId: id,
          type: "camera",
          shopId: shopId
        });
      }
    }
  };
  function restartMonitor() {
    if (!$scope.monitorConfigData.cloudMonitorCameraList || !$scope.monitorConfigData.cloudMonitorCameraList.length) {
      showAlertOut($translate.instant("STR_CLOUD_MONITOR"), $translate.instant("STR_NEED_SERVICE"));
      return;
    }
    nextPlayCamIndex = 0;
    curUserDefineIndex = 0;
    isReCreatePlayer = true;
    startMonitorByNotify();
    var controlCameras = getControlCameras(getMonitorCameras()),
      streamMode = $scope.monitorConfigData && $scope.monitorConfigData.cloudMonitorSettings ? $scope.monitorConfigData.cloudMonitorSettings.streamType : "";
    startPlayerhView(controlCameras);
    pageRefreshIntervalStart($scope.monitorConfigData.cloudMonitorSettings.interval);
    if (streamMode === "sub") {
      subStreamRetryIntervalStart(10 * 1000);
    } else {
      if (retryIntervalId) {
        clearInterval(retryIntervalId);
        retryIntervalId = null;
      }
    }
  }
  function clockIntervalStart() {
    clockIntervalStop();
    clockIntervalId = $interval(function () {
      if ($scope) {
        $scope.clockDate = Date.now();
      }
    }, 1000);
  }
  function pageRefreshIntervalStop() {
    if (pageIntervalId) {
      clearInterval(pageIntervalId);
      pageIntervalId = null;
    }
  }
  function getMonitorCameras() {
    if (!$scope.monitorConfigData) {
      return null;
    }
    var cameraIds,
      wasCameras = [],
      dimension = getCurrentDimension();
    if ($scope.monitorConfigData.cloudMonitorSettings.currentViewMode === "paging") {
      wasCameras = JSON.parse(JSON.stringify($scope.monitorConfigData.cloudMonitorCameraList));
      wasCameras.sort(function (a, b) {
        var aLabel, bLabel;
        aLabel = a.labelName.toLowerCase();
        bLabel = b.labelName.toLowerCase();
        return aLabel < bLabel ? -1 : aLabel > bLabel ? 1 : 0;
      });
      wasCameras = wasCameras.splice(nextPlayCamIndex, dimension * dimension);
      nextPlayCamIndex = nextPlayCamIndex += dimension * dimension;
      if (nextPlayCamIndex >= $scope.monitorConfigData.cloudMonitorCameraList.length) {
        nextPlayCamIndex = 0;
      }
    } else if ($scope.monitorConfigData.cloudMonitorSettings.currentViewMode === "event") {
      wasCameras = $scope.monitorConfigData.cloudMonitorCameraList;
    } else {
      //custom
      cameraIds = $scope.monitorConfigData.cloudMonitorSettings.customModeSettings.cameras[curUserDefineIndex];
      if (cameraIds) {
        var i,
          len = cameraIds.length;
        for (i = 0; i < len; i += 1) {
          if (cameraIds[i]) {
            wasCameras.push({
              cameraId: cameraIds[i],
              labelName: $scope.getLabelName(cameraIds[i])
            });
          }
        }
      }
      curUserDefineIndex += 1;
      if (curUserDefineIndex >= $scope.monitorConfigData.cloudMonitorSettings.customModeSettings.cameras.length) {
        curUserDefineIndex = 0;
      }
    }
    return wasCameras;
  }
  function getControlCameras(wasCameras) {
    var i,
      len,
      controlCameras = [];
    if (!wasCameras || !wasCameras.length) {
      return controlCameras;
    }
    for (i = 0, len = wasCameras.length; i < len; i += 1) {
      controlCameras.push({
        cameraId: wasCameras[i].cameraId,
        eventTimestamp: cameraInfoMap[wasCameras[i].cameraId] ? cameraInfoMap[wasCameras[i].cameraId].motionTimestamp : 0
      });
    }
    return controlCameras;
  }
  function sortCamerasByEventTime(controlCameras) {
    /********* Control Camera Model
           {cameraId : '', controlServerAddr : '', eventTimestamp}
           **********/

    var i,
      j,
      curLen,
      len,
      sortedCameras = [];
    for (i = 0, len = controlCameras.length; i < len; i += 1) {
      if (cameraInfoMap[controlCameras[i].cameraId]) {
        cameraInfoMap[controlCameras[i].cameraId].motionTimestamp = controlCameras[i].eventTimestamp;
      }
      for (j = 0, curLen = currentMonitoringCameras.length; j < curLen; j += 1) {
        if (currentMonitoringCameras[j].cameraId === controlCameras[i].cameraId) {
          currentMonitoringCameras[j].eventTimestamp = controlCameras[i].eventTimestamp;
          break;
        }
      }
      if (controlCameras[i].eventTimestamp) {
        sortedCameras.push(controlCameras[i]);
      }
    }
    sortedCameras.sort(function (a, b) {
      return a.eventTimestamp > b.eventTimestamp ? -1 : a.eventTimestamp < b.eventTimestamp ? 1 : 0;
    });
    return sortedCameras;
  }
  function getEventCamerasByNameOrder(controlCameras) {
    controlCameras.sort(function (a, b) {
      var aLabel, bLabel;
      aLabel = $scope.getLabelName(a.cameraId);
      bLabel = $scope.getLabelName(b.cameraId);
      return aLabel < bLabel ? -1 : aLabel > bLabel ? 1 : 0;
    });
    var dimension = getCurrentDimension();
    controlCameras = controlCameras.splice(0, dimension * dimension);
    currentMonitoringCameras = controlCameras;
    if (streamMode === "sub") {
      // Request sub stream url
      var mediaUrlNeedCameras = [];
      if (currentMonitoringCameras && currentMonitoringCameras.length) {
        currentMonitoringCameras.forEach(function (camera) {
          if (camera.cameraId && cameraInfoMap[camera.cameraId]) {
            if (cameraInfoMap[camera.cameraId].controlStatus === "on" && !cameraInfoMap[camera.cameraId].subStreamServer && !cameraInfoMap[camera.cameraId].subStreamNotSupport) {
              mediaUrlNeedCameras.push(camera.cameraId);
            }
          }
        });
      }
      if (mediaUrlNeedCameras.length) {
        Monitor.requestMediaURL(mediaUrlNeedCameras);
      }
    }
    var dimension = getCurrentDimension();
    var cameras = [];
    currentMonitoringCameras.forEach(function (camera) {
      cameras.push(buildPlayCamObj(camera.cameraId));
    });
    var normalCameras = $scope.monitorConfigData.cloudMonitorCameraList.map(function (camera) {
      return camera.cameraId;
    });
    cameras.forEach(function (camera) {
      if (normalCameras.find(function (normalCamera) {
        return camera.cameraId == normalCamera;
      })) {
        camera.normalStatus = "on";
      } else {
        camera.normalStatus = "return";
      }
    });
    if (isReCreatePlayer) {
      if (monitorPlayer) {
        monitorPlayer.destroy();
        monitorPlayer = null;
      }
      Camera.getStreamingServer({
        count: 6,
        country: $rootScope.me.country
      }, function (data) {
        if (data.code === "ok") {
          monitorPlayer = tCam.monitorplayer({
            elId: "monitor_player",
            width: $("#flashWrap").width(),
            height: $("#flashWrap").height(),
            streamType: streamMode,
            serverUrls: data.servers,
            commonToken: commonToken,
            cameras: cameras,
            dimension: dimension,
            eventHandler: function eventHandler(eventObj) {
              if (eventObj.type === "click" && eventObj.id && $stateParams.demo !== "ok") {
                $scope.goDetail(eventObj.id);
              }
            }
          });
        }
      });
    } else {
      if (!Utils.isIE()) {
        if (monitorPlayer) {
          monitorPlayer.changeCameras(cameras);
        }
      }
    }
  }
  function clockIntervalStop() {
    if (clockIntervalId) {
      $interval.cancel(clockIntervalId);
      clockIntervalId = null;
    }
  }
  function eventMonitorIntervalStop() {
    if (eventIntervalId) {
      clearInterval(eventIntervalId);
      eventIntervalId = null;
    }
  }
  function subStreamRetryIntervalStart(interval) {
    if (retryIntervalId) {
      clearInterval(retryIntervalId);
      retryIntervalId = null;
    }
    retryIntervalId = setInterval(function () {
      var mediaUrlNeedCameras = [];
      if (!currentMonitoringCameras || !currentMonitoringCameras.length) {
        return;
      }
      var cameraInfo,
        i,
        len = currentMonitoringCameras.length,
        serverUrl;
      for (i = 0; i < len; i += 1) {
        cameraInfo = cameraInfoMap[currentMonitoringCameras[i].cameraId];
        if (cameraInfo) {
          serverUrl = cameraInfo.subStreamServer;
          if (cameraInfo.controlStatus === "on" && !serverUrl && !cameraInfo.subStreamNotSupport) {
            mediaUrlNeedCameras.push(currentMonitoringCameras[i].cameraId);
          }
        }
      }
      if (mediaUrlNeedCameras.length) {
        Monitor.requestMediaURL(mediaUrlNeedCameras);
      }
    }, interval);
  }
  function pageRefreshIntervalStart(interval) {
    if (pageIntervalId) {
      clearInterval(pageIntervalId);
      pageIntervalId = null;
    }
    if ($scope.monitorConfigData.cloudMonitorSettings.currentViewMode === "event") {
      return;
    }
    pageIntervalId = setInterval(function () {
      if ($scope.monitorConfigData.cloudMonitorSettings.currentViewMode === "paging") {
        var dimension = getCurrentDimension();
        if ($scope.monitorConfigData.cloudMonitorCameraList.length <= dimension * dimension) {
          return;
        }
      } else if ($scope.monitorConfigData.cloudMonitorSettings.currentViewMode === "custom") {
        if ($scope.monitorConfigData.cloudMonitorSettings.customModeSettings.cameras.length <= 1) {
          return;
        }
      }
      var controlCameras = getControlCameras(getMonitorCameras());
      startPlayerhView(controlCameras);
    }, interval);
  }
  function startMonitorByNotify() {
    var i,
      len,
      cameraIds = [],
      cameraInfoMap = {};
    if ($scope.monitorConfigData.cloudMonitorCameraList) {
      for (i = 0, len = $scope.monitorConfigData.cloudMonitorCameraList.length; i < len; i += 1) {
        cameraIds.push($scope.monitorConfigData.cloudMonitorCameraList[i].cameraId);
        cameraInfoMap[$scope.monitorConfigData.cloudMonitorCameraList[i].cameraId] = {
          recordType: $scope.monitorConfigData.cloudMonitorCameraList[i].recordType,
          gopsize: $scope.monitorConfigData.cloudMonitorCameraList[i].gopsize,
          bitrate: $scope.monitorConfigData.cloudMonitorCameraList[i].bitrate,
          framerate: $scope.monitorConfigData.cloudMonitorCameraList[i].framerate
        };
      }
      Monitor.requestStartMonitor(cameraIds, cameraInfoMap);
    }
  }
  function findNewEventCamera(controlCameras) {
    var dimension = getCurrentDimension();
    if (!currentMonitoringCameras) {
      currentMonitoringCameras = controlCameras.splice(0, dimension * dimension);
    } else {
      var i,
        j,
        curLen = currentMonitoringCameras.length,
        len = controlCameras.length,
        newCameras = [],
        isFind;
      for (i = len - 1; i >= 0; i -= 1) {
        isFind = false;
        for (j = 0; j < curLen; j += 1) {
          if (currentMonitoringCameras[j].cameraId === controlCameras[i].cameraId) {
            isFind = true;
            break;
          }
        }
        if (isFind === false) {
          if (currentMonitoringCameras && currentMonitoringCameras[0]) {
            if (currentMonitoringCameras[0].eventTimestamp < controlCameras[i].eventTimestamp) {
              newCameras.push(controlCameras[i]);
            }
          } else {
            newCameras.push(controlCameras[i]);
          }
        }
      }
      var newLen = newCameras.length;
      if (newLen) {
        currentMonitoringCameras = newCameras.concat(currentMonitoringCameras);
        currentMonitoringCameras = currentMonitoringCameras.splice(0, dimension * dimension);
        if (!Utils.isIE()) {
          if (!isReCreatePlayer) {
            if (monitorPlayer) {
              newCameras.forEach(function (camera) {
                monitorPlayer.unshiftCamera(buildPlayCamObj(camera.cameraId));
              });
            }
          }
        }
      }
    }
    return currentMonitoringCameras;
  }
  function compareNewCameraIsSame(cameras) {
    if (!currentMonitoringCameras || !currentMonitoringCameras.length || !cameras || !cameras.length) {
      return false;
    }
    var i,
      len,
      isSame = true;
    if (currentMonitoringCameras.length === cameras.length) {
      len = currentMonitoringCameras.length;
      for (i = 0; i < len; i += 1) {
        if (currentMonitoringCameras[i].cameraId != cameras[i].cameraId) {
          isSame = false;
          break;
        }
      }
    } else {
      isSame = false;
    }
    return isSame;
  }
  function updateCurrentCameraMotionStatus(cameraId, motionTimestamp) {
    var i, len;
    if (currentMonitoringCameras && currentMonitoringCameras.length) {
      len = currentMonitoringCameras.length;
      for (i = 0; i < len; i += 1) {
        if (currentMonitoringCameras[i].cameraId === cameraId) {
          currentMonitoringCameras[i].eventTimestamp = motionTimestamp;
        }
      }
    }
  }

  // FIXME: 시간 복잡도 너무 높음
  function updateCameraInfo(type, cameraId, statusJSON) {
    if (!cameraInfoMap[cameraId]) {
      cameraInfoMap[cameraId] = {};
      var modelId,
        i,
        len = $scope.monitorConfigData ? $scope.monitorConfigData.cloudMonitorCameraList.length : 0;
      for (i = 0; i < len; i += 1) {
        if ($scope.monitorConfigData.cloudMonitorCameraList[i].cameraId === cameraId) {
          modelId = $scope.monitorConfigData.cloudMonitorCameraList[i].cameraModelId;
          if (modelId === "KTNC-BULLET-100N" || modelId === "XC-IL521FL" || modelId === "NHNGATEWAY" || modelId === "KTNC-DOME-100N" || modelId === "IP-XC-ID521FL" || modelId === "IP-XC-IL521FL" || modelId === "XC-ID521FL" || modelId === "FND-101N" || modelId === "FNB-101N" || modelId === "toastcam_v1" || modelId === "gateway") {
            cameraInfoMap[cameraId].subStreamNotSupport = true;
          }
        }
      }
    }
    if (type === "control") {
      cameraInfoMap[cameraId].streamStatusConfig = "on"; //TODO:
      cameraInfoMap[cameraId].controlStatus = statusJSON.status ? "on" : "off";
    } else if (type === "media_status") {
      cameraInfoMap[cameraId].streamStatus = statusJSON.status ? "on" : "off";
    } else if (type === "media_url") {
      cameraInfoMap[cameraId].streamServer = statusJSON.url;
    } else if (type === "sub_media_url") {
      cameraInfoMap[cameraId].subStreamServer = statusJSON.url;
    } else if (type === "motion") {
      cameraInfoMap[cameraId].motionStatus = statusJSON.status ? "on" : "off";
      cameraInfoMap[cameraId].motionTimestamp = statusJSON.status ? parseInt(statusJSON.timestamp, 10) : 0;
      updateCurrentCameraMotionStatus(cameraId, statusJSON.timestamp);
    }
  }
  function startPlayerhView(cameras) {
    var controlCameras;
    if ($scope.monitorConfigData.cloudMonitorSettings.currentViewMode === "event") {
      //Get cameras to monitor start
      controlCameras = sortCamerasByEventTime(cameras);
      controlCameras = findNewEventCamera(controlCameras);
      if (!controlCameras.length) {
        controlCameras = getEventCamerasByNameOrder(cameras);
      }
      startCamerasMonitor(controlCameras);
    } else {
      controlCameras = cameras;
      if (!compareNewCameraIsSame(controlCameras)) {
        startCamerasMonitor(controlCameras);
      }
    }
    isReCreatePlayer = false;
  }
  function findInfoByCameraId(cameraId) {
    var i,
      len = currentMonitoringCameras.length;
    for (i = 0; i < len; i += 1) {
      if (currentMonitoringCameras[i].cameraId === cameraId) {
        return currentMonitoringCameras[i];
      }
    }
    return null;
  }
  /********************************* [Cloud Monitor Play] End **********************************/

  /********************************[Monitor Service Event] Start **************************************/
  $scope.$on(Monitor.CONTROL_STREAM_DISCONNECTED, function (event, data) {
    showAlertOut($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
  });
  $scope.$on(Monitor.CONTROL_STREAM_CONNECTED, function (event, data) {
    nextPlayCamIndex = 0;
    isReCreatePlayer = true;
    startMonitorByNotify();
    pageRefreshIntervalStart($scope.monitorConfigData.cloudMonitorSettings.interval);
    var streamMode = $scope.monitorConfigData && $scope.monitorConfigData.cloudMonitorSettings ? $scope.monitorConfigData.cloudMonitorSettings.streamType : "";
    if (streamMode === "sub") {
      subStreamRetryIntervalStart(10 * 1000);
    } else {
      if (retryIntervalId) {
        clearInterval(retryIntervalId);
        retryIntervalId = null;
      }
    }
  });
  function makeOrderData() {
    var key;
    $scope.camStatusArray = [];
    for (key in $scope.allCamStatus) {
      $scope.allCamStatus[key].cameraId = key;
      $scope.camStatusArray.push($scope.allCamStatus[key]);
    }
    $scope.camStatusArray.sort(function (a, b) {
      var aLabel = $scope.getLabelName(a.cameraId),
        bLabel = $scope.getLabelName(b.cameraId);
      if (a && a.cameraId && aLabel.toLowerCase) {
        aLabel = aLabel.toLowerCase();
      }
      if (b && b.cameraId && bLabel.toLowerCase) {
        bLabel = bLabel.toLowerCase();
      }
      return aLabel < bLabel ? -1 : aLabel > bLabel ? 1 : 0;
    });
  }
  $scope.$on(Monitor.EVENT_UPDATE_STATUS, function (eventObj, dataObj) {
    var event = dataObj.type,
      data = dataObj.data,
      streamMode = $scope.monitorConfigData && $scope.monitorConfigData.cloudMonitorSettings ? $scope.monitorConfigData.cloudMonitorSettings.streamType : "";
    switch (event) {
      case "media_delayed":
        if ($scope.debugMode) {
          var timeObj = new Date();
          var log = "cameraId(" + data.deviceid + "), Delayed event (" + JSON.stringify(data.detail) + "), time(" + timeObj.getHours() + ":" + timeObj.getMinutes() + ":" + timeObj.getSeconds() + ")<br>";
          $scope.iotCamStatus = $scope.iotCamStatus + log;
        }
        break;
      case "get_all_status":
        var key,
          controlCameras = [],
          i,
          len,
          wasCameras = getMonitorCameras();
        if (wasCameras) {
          for (i = 0, len = wasCameras.length; i < len; i += 1) {
            controlCameras.push({
              cameraId: wasCameras[i].cameraId,
              eventTimestamp: data[wasCameras[i].cameraId] && data[wasCameras[i].cameraId].motion_status && data[wasCameras[i].cameraId].motion_status.status == 1 ? parseInt(data[wasCameras[i].cameraId].motion_status.timestamp, 10) : 0
            });
          }
        }
        for (key in data) {
          var mediaUrl = data[key].media_url ? data[key].media_url : "",
            subMediaUrl = data[key].sub_media_url ? data[key].sub_media_url : "";
          updateCameraInfo("control", key, data[key].control_status);
          updateCameraInfo("media_status", key, {
            status: data[key].media_status.status
          });
          updateCameraInfo("media_url", key, {
            url: mediaUrl
          });
          updateCameraInfo("sub_media_url", key, {
            url: subMediaUrl
          });
          updateCameraInfo("motion", key, data[key].motion_status);
          if ($scope.debugMode) {
            if (!$scope.allCamStatus[key]) {
              $scope.allCamStatus[key] = {};
            }
            $scope.allCamStatus[key].control = data[key].control_status;
            $scope.allCamStatus[key].media = data[key].media_status;
            $scope.allCamStatus[key].media.url = mediaUrl;
            $scope.allCamStatus[key].motion = data[key].motion_status;
            makeOrderData();
            $scope.$apply();
          }
        }
        startPlayerhView(controlCameras);
        break;
      case "get_media_url":
        var key;
        for (key in data.urls) {
          if (data.urls[key]) {
            updateCameraInfo("sub_media_url", key, {
              url: data.urls[key]
            });
            var camera = findInfoByCameraId(key);
            if (camera) {
              if (monitorPlayer) {
                monitorPlayer.updateCameraStatus(buildPlayCamObj(camera.cameraId));
              }
            }
            if ($scope.debugMode) {
              if (!$scope.allCamStatus[key]) {
                $scope.allCamStatus[key] = {
                  media: {}
                };
              }
              $scope.allCamStatus[key].media.url = data.urls[key];
              $scope.allCamStatus[key].media.isSub = true;
              makeOrderData();
              $scope.$apply();
            }
          }
        }
        break;
      case "iot_event":
        if ($scope.debugMode) {
          var status = "";
          switch (data.detail.type) {
            case "humid":
              status = "humid(" + data.detail.humid + ")";
              break;
            case "doorlock":
              status = "isopen(" + data.detail.isopen + ")";
              break;
            case "motion":
              status = "isstart(" + data.detail.isstart + ")";
              break;
            case "battery":
              status = "level(" + data.detail.level + ")";
              break;
            case "magnetic":
              status = "isopen(" + data.detail.isopen + ")";
              break;
            case "temp":
              status = "temp(" + data.detail.temp + ")";
              break;
            case "temp_humid":
              status = "temp(" + data.detail.temp + "),humid(" + data.detail.humid + ")";
              break;
            case "plug":
              status = "status(" + data.detail.status + ")";
              break;
            case "gas":
              status = "status(" + data.detail.status + ")";
              break;
            case "smoke":
              status = "status(" + data.detail.status + ")";
              break;
            case "powerfail":
              status = "status(" + data.detail.status + ")";
              break;
            case "tamper":
              status = "isdetect(" + data.detail.isdetect + ")";
              break;
            case "meter":
              status = "measure(" + data.detail.measure + ")";
              break;
          }
          var timeObj = new Date();
          var log = "cameraId(" + data.deviceid + "), IOT event type(" + data.detail.type + "), sensorid(" + data.detail.sensorid + "), " + status + ", time(" + timeObj.getHours() + ":" + timeObj.getMinutes() + ":" + timeObj.getSeconds() + ")<br>";
          $scope.iotCamStatus = $scope.iotCamStatus + log;
        }
        break;
      case "control_status":
        updateCameraInfo("control", data.deviceid, data.detail);
        if (monitorPlayer) {
          monitorPlayer.updateCameraStatus(buildPlayCamObj(data.deviceid));
        }
        if ($scope.debugMode) {
          if (!$scope.allCamStatus[data.deviceid]) {
            $scope.allCamStatus[data.deviceid] = {};
          }
          $scope.allCamStatus[data.deviceid].control = data.detail;
          makeOrderData();
          $scope.$apply();
        }
        break;
      case "motion_status":
        updateCameraInfo("motion", data.deviceid, data.detail);
        if (monitorPlayer) {
          monitorPlayer.updateCameraStatus(buildPlayCamObj(data.deviceid));
        }
        var controlCameras;
        if ($scope.monitorConfigData.cloudMonitorSettings.currentViewMode === "event") {
          //Get cameras to monitor start
          controlCameras = findNewEventCamera([{
            cameraId: data.deviceid,
            eventTimestamp: parseInt(data.detail.timestamp, 10)
          }]);
        }
        if ($scope.debugMode) {
          if (!$scope.allCamStatus[data.deviceid]) {
            $scope.allCamStatus[data.deviceid] = {};
          }
          $scope.allCamStatus[data.deviceid].motion = data.detail;
          makeOrderData();
          $scope.$apply();
        }
        break;
      case "media_status":
        updateCameraInfo("media_status", data.deviceid, {
          status: data.detail.status
        });
        if (monitorPlayer) {
          monitorPlayer.updateCameraStatus(buildPlayCamObj(data.deviceid));
        }
        if (data.detail.status == 1) {
          data.detail.url = data.detail.url;
          updateCameraInfo("media_url", data.deviceid, {
            url: data.detail.url
          });
          if (streamMode !== "sub" || cameraInfoMap[data.deviceid].subStreamNotSupport) {
            var camera = findInfoByCameraId(data.deviceid);
            if (camera) {
              if (monitorPlayer) {
                monitorPlayer.updateCameraStatus(buildPlayCamObj(camera.cameraId));
                monitorPlayer.playCamera(camera.cameraId);
              }
            }
          }
        }
        if ($scope.debugMode) {
          if (!$scope.allCamStatus[data.deviceid]) {
            $scope.allCamStatus[data.deviceid] = {
              media: {}
            };
          }
          $scope.allCamStatus[data.deviceid].media.status = data.detail.status;
          if ($scope.allCamStatus[data.deviceid].media.status) {
            $scope.allCamStatus[data.deviceid].media.isSub = false;
          }
          makeOrderData();
          $scope.$apply();
        }
        break;
      case "sub_media_status":
        if (data.detail.status == 1) {
          data.detail.url = data.detail.url;
          updateCameraInfo("sub_media_url", data.deviceid, {
            url: data.detail.url
          });
          if (streamMode === "sub" && !cameraInfoMap[data.deviceid].subStreamNotSupport) {
            var camera = findInfoByCameraId(data.deviceid);
            if (camera) {
              if (monitorPlayer) {
                monitorPlayer.updateCameraStatus(buildPlayCamObj(camera.cameraId));
                monitorPlayer.playCamera(camera.cameraId);
              }
            }
          }
        } else {
          updateCameraInfo("sub_media_url", data.deviceid, {
            url: ""
          });
          if (streamMode === "sub" && !cameraInfoMap[data.deviceid].subStreamNotSupport) {
            Monitor.requestMediaURL([data.deviceid]);
          }
        }
        if ($scope.debugMode) {
          if (!$scope.allCamStatus[data.deviceid]) {
            $scope.allCamStatus[data.deviceid] = {
              media: {}
            };
          }
          $scope.allCamStatus[data.deviceid].media.url = data.detail.url ? data.detail.url : "";
          makeOrderData();
          $scope.$apply();
        }
        break;
      case "start_monitor" | "start_monitor_jp":
        var cameraList = $scope.monitorConfigData.cloudMonitorCameraList;
        var cameraId = data.deviceid;
        var tempCameraInfoMap = cameraList.filter(function (e) {
          return e.cameraId === cameraId;
        }).reduce(function (newObj, obj) {
          newObj[obj.cameraId] = {
            recordType: obj.recordType
          };
          return newObj;
        }, {});
        var cameraIds = [data.deviceid];
        Monitor.requestStartMonitor(cameraIds, tempCameraInfoMap);
        break;
      default:
        break;
    }
  });
  /********************************[Monitor Service Event] End **************************************/

  /********************************[Initiate] Start *************************************************/
  function initFullScreenHandler() {
    $("#hoverGnb").on("mouseover", topMenuHoverIn);
    if (Utils.isIE()) {
      $(document).on("mousemove", mousemoveEventHandler);
    } else {
      $("#toastGnb").on("mouseleave", topGnbHoverOut);
      $("#hoverGnb").on("mouseleave", topMenuHoverOut);
      $("#monitor_setting").on("mouseleave", topMenuHoverOut);
      $("#fullmode_setting").on("mouseleave", topMenuHoverOut);
    }
    if (document.addEventListener) {
      document.addEventListener("webkitfullscreenchange", fullscreenHandler, false);
      document.addEventListener("mozfullscreenchange", fullscreenHandler, false);
      document.addEventListener("fullscreenchange", fullscreenHandler, false);
      document.addEventListener("MSFullscreenChange", fullscreenHandler, false);
      document.addEventListener("keyup", keyupHandler, false);
    }
    if (isFullScreen()) {
      $scope.bFullScreen = true;
    } else {
      $scope.bFullScreen = false;
    }
  }
  function initiateCloudMonitor() {
    getToken($scope.monitorConfigData.cloudMonitorCameraList).then(function () {
      setModeStr($scope.monitorConfigData.cloudMonitorSettings.currentViewMode);
      if ($scope.monitorConfigData.cloudMonitorSettings.currentTime.enable) {
        clockIntervalStart();
      }
      Monitor.connectMonitorControlChannel();
    });
  }
  function buildPlayCamObj(cameraId) {
    var playObj = {
      cameraId: cameraId,
      labelName: "",
      cameraModelId: "",
      recordType: "",
      categoryList: [],
      controlStatus: "",
      streamStatus: "",
      streamStatusConfig: "",
      streamServer: "",
      subStreamServer: "",
      motionStatus: "",
      motionTimestamp: 0,
      hlsUrl: "",
      encodingType: "",
      mediaServerUrl: "",
      mediaServerProtocol: ""
    };
    var camInfoObj = cameraInfoMap[cameraId];
    if (camInfoObj) {
      playObj.streamStatusConfig = camInfoObj.streamStatusConfig;
      playObj.controlStatus = camInfoObj.controlStatus;
      playObj.streamStatus = camInfoObj.streamStatus;
      playObj.streamServer = camInfoObj.streamServer;
      playObj.subStreamServer = camInfoObj.subStreamServer;
      playObj.motionStatus = camInfoObj.motionStatus;
      playObj.motionTimestamp = camInfoObj.motionTimestamp;
    }
    var camConfig,
      i,
      len = $scope.monitorConfigData ? $scope.monitorConfigData.cloudMonitorCameraList.length : 0;
    for (i = 0; i < len; i += 1) {
      if ($scope.monitorConfigData.cloudMonitorCameraList[i].cameraId === cameraId) {
        camConfig = $scope.monitorConfigData.cloudMonitorCameraList[i];
        break;
      }
    }
    if (camConfig) {
      playObj.cameraModelId = camConfig.cameraModelId;
      playObj.recordType = camConfig.recordType;
      playObj.thumbnailPath = camConfig.thumbnailPath;
      playObj.categoryList = camConfig.categoryList ? camConfig.categoryList : [];
      playObj.labelName = camConfig.labelName;
      playObj.hlsUrl = camConfig.hlsUrl;
      playObj.mediaServerUrl = camConfig.mediaServerUrl;
      playObj.mediaServerProtocol = camConfig.mediaServerProtocol;
      playObj.encodingType = camConfig.encodingType;
    }
    return playObj;
  }
  function startCamerasMonitor(controlCameras) {
    var streamMode = $scope.monitorConfigData && $scope.monitorConfigData.cloudMonitorSettings ? $scope.monitorConfigData.cloudMonitorSettings.streamType : "";
    currentMonitoringCameras = controlCameras;
    if (streamMode === "sub") {
      // Request sub stream url
      var mediaUrlNeedCameras = [];
      if (currentMonitoringCameras && currentMonitoringCameras.length) {
        currentMonitoringCameras.forEach(function (camera) {
          if (camera.cameraId && cameraInfoMap[camera.cameraId]) {
            if (cameraInfoMap[camera.cameraId].controlStatus === "on" && !cameraInfoMap[camera.cameraId].subStreamServer && !cameraInfoMap[camera.cameraId].subStreamNotSupport) {
              mediaUrlNeedCameras.push(camera.cameraId);
            }
          }
        });
      }
      if (mediaUrlNeedCameras.length) {
        Monitor.requestMediaURL(mediaUrlNeedCameras);
      }
    }
    var dimension = getCurrentDimension();
    var cameras = [];
    currentMonitoringCameras.forEach(function (camera) {
      cameras.push(buildPlayCamObj(camera.cameraId));
    });
    var normalCameras = $scope.monitorConfigData.cloudMonitorCameraList.map(function (camera) {
      return camera.cameraId;
    });
    cameras.forEach(function (camera) {
      if (normalCameras.find(function (normalCamera) {
        return camera.cameraId == normalCamera;
      })) {
        camera.normalStatus = "on";
      } else {
        camera.normalStatus = "return";
      }
    });
    if (isReCreatePlayer) {
      if (monitorPlayer) {
        monitorPlayer.destroy();
        monitorPlayer = null;
      }
      Camera.getStreamingServer({
        count: 6,
        country: $rootScope.me.country
      }, function (data) {
        if (data.code === "ok") {
          monitorPlayer = tCam.monitorplayer({
            elId: "monitor_player",
            width: $("#flashWrap").width(),
            height: $("#flashWrap").height(),
            streamType: streamMode,
            serverUrls: data.servers,
            h265ServerUrls: data.h265Servers,
            commonToken: commonToken,
            cameras: cameras,
            dimension: dimension,
            eventHandler: function eventHandler(eventObj) {
              if (eventObj.type === "click" && eventObj.id && $stateParams.demo !== "ok") {
                $scope.goDetail(eventObj.id);
              }
            }
          });
        }
      });
    } else {
      if (!Utils.isIE()) {
        if (monitorPlayer) {
          monitorPlayer.changeCameras(cameras);
        }
      }
    }
  }

  /********************************* [Cloud Monitor Play] End **********************************/

  /********************************[Initiate] Start *************************************************/

  function sessionErrorHandler(error) {
    if (monitorPlayer) {
      monitorPlayer.destroy();
      monitorPlayer = null;
    }
    $scope.$root.createSessionDlg("flashWrap");
  }
  var loopFlag = 0;
  function errorHandlerExtendToken(error) {
    if (loopFlag == 0) {
      // 1초에 한번씩으로 token 요청 제한
      loopFlag = 1;
      setTimeout(function () {
        loopFlag = 0;
        getTokenRetry();
      }, 1000);
    }
  }
  function loadCloudMonitorInfo() {
    if ($stateParams.demo === "ok") {
      $scope.monitorConfigData = {
        cloudMonitorCameraList: [],
        cloudMonitorSettings: {
          currentViewMode: "paging",
          interval: 10000,
          currentTime: {
            enable: true,
            hourMode: "12h"
          },
          customModeSettings: {
            dimension: 2,
            cameras: [[]]
          },
          pagingModeSettings: {
            dimension: 2
          },
          eventModeSettings: {
            dimension: 2
          },
          streamType: "main"
        }
      };
      Demos.getMonitorDemoList({}, function (data) {
        if (!data || !data.length) {
          showAlertOut($translate.instant("STR_CLOUD_MONITOR"), $translate.instant("STR_NO_MONITOR_CAMERAS"));
        }
        var i,
          len = data.length;
        for (i = 0; i < len; i += 1) {
          var _data$i, _data$i2, _data$i3;
          $scope.monitorConfigData.cloudMonitorCameraList.push({
            cameraId: data[i].id,
            thumbnailPath: data[i].thumbnailPath,
            categoryList: ["demo", "myCamera"],
            labelName: data[i].labelName,
            hlsUrl: (_data$i = data[i]) === null || _data$i === void 0 ? void 0 : _data$i.hlsUrl,
            mediaServerUrl: (_data$i2 = data[i]) === null || _data$i2 === void 0 ? void 0 : _data$i2.mediaServerUrl,
            mediaServerProtocol: (_data$i3 = data[i]) === null || _data$i3 === void 0 ? void 0 : _data$i3.mediaServerProtocol
          });
        }
        initiateCloudMonitor();
      }, sessionErrorHandler);
    } else {
      if ($rootScope.monitorConfigData) {
        $scope.monitorConfigData = $rootScope.monitorConfigData;
        if ($scope.monitorConfigData.cloudMonitorSettings.customModeSettings.cameras.length === 0) {
          $scope.monitorConfigData.cloudMonitorSettings.customModeSettings.cameras.push([]);
        }
        if (!$scope.monitorConfigData.cloudMonitorSettings.streamType) {
          $scope.monitorConfigData.cloudMonitorSettings.streamType = "sub";
        }
        initiateCloudMonitor();
      } else {
        Monitor.api.getInfo({}, function (data) {
          if (data.code === "ok") {
            $scope.monitorConfigData = data;
            if (!$scope.monitorConfigData.cloudMonitorCameraList || !$scope.monitorConfigData.cloudMonitorCameraList.length) {
              if ($scope.monitorConfigData.isCloudMonitorUser) {
                $scope.showAlertPop($translate.instant("STR_CLOUD_MONITOR"), $translate.instant("STR_NO_MONITOR_CAMERAS"));
              } else {
                $scope.showAlertPop($translate.instant("STR_CLOUD_MONITOR"), $translate.instant("STR_NEED_SERVICE"));
              }
              return;
            }
            if ($scope.monitorConfigData.cloudMonitorSettings.customModeSettings.cameras.length === 0) {
              $scope.monitorConfigData.cloudMonitorSettings.customModeSettings.cameras.push([]);
            }
            if (!$scope.monitorConfigData.cloudMonitorSettings.streamType) {
              $scope.monitorConfigData.cloudMonitorSettings.streamType = "sub";
            }
            initiateCloudMonitor();
          } else {
            $scope.showAlertPop($translate.instant("STR_CLOUD_MONITOR"), data.msg);
          }
        }, sessionErrorHandler);
      }
    }
  }
  $scope.getNumber = function (max) {
    return Array.from({
      length: max
    }, function (_, idx) {
      return idx + 1;
    });
  };
  $scope.showAlertPop = function (title, message) {
    $("#showAlertPop").css("display", "block");
    $("#popTitle").html(title);
    $("#popBody").html(message);
  };
  function resizeHandler() {
    if (monitorPlayer) {
      monitorPlayer.gridSizeChange($("#flashWrap").width(), $("#flashWrap").height());
    }
  }
  $(window).on("resize", resizeHandler);

  // 1800000 // 30m
  var loginInterval = 900000; // 15m
  var loginIntervalFlag = null;
  function initLoginIntervalFlag() {
    clearInterval(loginIntervalFlag);
    loginIntervalFlag = null;
  }
  function initLoginSessionExpander() {
    if ($stateParams.demo === "ok") {
      loginIntervalFlag = null;
      return;
    }
    loginIntervalFlag = setInterval(function () {
      User.loginSessionExpand({}, {}, function (data) {}, function (e) {
        void 0;
      });
    }, loginInterval);
  }
  setTimeout(function () {
    $("#toastGnb").hide();
    $("#toastGnb").css({
      top: "-100px"
    });
    $("#toastFooter").hide();
  }, 100);
  initFullScreenHandler();
  loadCloudMonitorInfo();
  initLoginSessionExpander();
  Shop.dashboardShops().$promise.then(function (res) {
    shopList = res.shops && res.shops.length ? res.shops : [];
  });
  /********************************[Initiate] End *************************************************/
}]);
"use strict";

app.controller("NoticeCtrl", ["$scope", "User", "Notice", "$sce", "Utils", function ($scope, User, Notice, $sce, Utils) {
  var browserLanguage = Utils.getBrowserLanguage();
  $scope.getPath = "notice";
  $scope.logout = function () {
    User.logout(function (data) {
      logoutSuccess();
    });
  };
  $scope.noticeSelectNum = 0;
  $scope.renderHtml = function (html_code) {
    return $sce.trustAsHtml(html_code);
  };
  $scope.setNoticeList = function (noticeInfo) {
    $scope.noticeList = [];
    for (var i = 0; i < noticeInfo.length; i++) {
      var notice = {};
      notice.num = i + 1;
      notice.subject = noticeInfo[i].title;
      notice.content = noticeInfo[i].content.replace(/<br>/g, "\n");
      notice.date = moment(noticeInfo[i].regDate, "x").format("YYYY-MM-DD");
      $scope.noticeList.push(notice);
    }
    setTimeout(function () {
      $scope.viewContent(1);
    }, 65);
  };
  $scope.getNoticeList = function () {
    var searchParam = {};
    var boardTypeVal = "";
    if (browserLanguage === "ja_JP") {
      boardTypeVal = "bizcam_ja";
    } else {
      boardTypeVal = "bizcam";
    }
    searchParam["boardType"] = boardTypeVal;
    searchParam["pageNumber"] = 1;
    searchParam["pageCount"] = 50;
    Notice.getList(searchParam).$promise.then(function (data) {
      var dateFilterList = [];
      if (data.notices.length > 0) {
        for (var i = 0; i < data.notices.length; i++) {
          if (data.notices[i].regDate < moment().format("x")) {
            dateFilterList.push(data.notices[i]);
          }
        }
        $scope.setNoticeList(dateFilterList);
      }
    }, function (err) {});
  };
  $scope.getNoticeList();
  $scope.viewContent = function (num) {
    var _$scope$noticeList;
    var isShow = $("#contentDetail" + num).is(":visible");
    $(".contentDetail").hide();
    $scope.noticeSelectNum = num - 1;
    $("#noticeDetail" + num).empty();
    isShow ? $("#contentDetail" + num).hide() : $("#contentDetail" + num).show();
    $("#noticeDetail" + num).append((_$scope$noticeList = $scope.noticeList[num - 1]) === null || _$scope$noticeList === void 0 ? void 0 : _$scope$noticeList.content);
  };
}]);
app.controller("NoticeMobileCtrl", ["$scope", "$state", "User", "Notice", "Utils", function ($scope, $state, User, Notice, Utils) {
  var _document$getElementB;
  $scope.getPath = "noticeMobile";
  var browserLanguage = Utils.getBrowserLanguage();
  setTimeout(function () {
    $("#mobileViewSizeCheck").attr("content", "user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, width=device-width");
  }, 65);
  var isMobileDevice = function isMobileDevice() {
    var ua = navigator.userAgent.toLowerCase();

    // User-Agent 기반 감지
    var phoneKeywords = ["samsung-", "sch-", "shw-", "sph-", "sgh-", "lg-", "canu", "im-", "ev-", "iphone", "nokia", "blackberry", "lgtelecom", "natebrowser", "sonyericsson", "mobile", "android"];
    var isScreenSmall = window.matchMedia("(max-width: 768px)").matches;
    return phoneKeywords.some(function (keyword) {
      return ua.includes(keyword);
    }) || isScreenSmall;
  };
  var isTabletDevice = function isTabletDevice() {
    var ua = navigator.userAgent.toLowerCase();
    if (ua.includes("ipad") || ua.includes("android") && !ua.includes("mobile") || window.matchMedia("(min-width: 768px) and (max-width: 1024px)").matches) {
      return true;
    }
    var galaxyTabModel = ["shw-"];
    return galaxyTabModel.some(function (model) {
      return ua.includes(model);
    });
  };
  setTimeout(function () {
    var isTablet = isTabletDevice();
    isTablet ? $("#mobile_notice_phone").remove() : $("#mobile_notice_tablet").remove();
  }, 1);
  $scope.clickedTopMenu = function () {
    $scope.isTopMenuLayer = !$scope.isTopMenuLayer;
    menuOpen($scope.isTopMenuLayer);
  };
  $scope.clickedUserMenu = function () {
    $scope.isUserMenuLayer = !$scope.isUserMenuLayer;
    openUserMenu($scope.isUserMenuLayer);
  };
  (_document$getElementB = document.getElementById("wrap")) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.addEventListener("click", function (e) {
    $scope.isUserMenuLayer = false;
    document.getElementById("topUserMenu").classList.remove("clicked");
  });
  $scope.logout = function () {
    User.logout(function (data) {
      logoutSuccess();
    });
  };
  $scope.noticeSelectNum = 0;
  $scope.setNoticeList = function (noticeInfo) {
    $scope.noticeList = [];
    for (var i = 0; i < noticeInfo.length; i++) {
      var notice = {};
      notice.num = i + 1;
      notice.subject = noticeInfo[i].title;
      notice.content = noticeInfo[i].content;
      notice.date = moment(noticeInfo[i].regDate, "x").format("YYYY-MM-DD");
      $scope.noticeList.push(notice);
    }
  };
  $scope.getNoticeList = function () {
    var boardTypeVal,
      searchParam = {};
    if ($state.params && $state.params.lang) {
      if ($state.params.lang === "ja_JP") {
        boardTypeVal = "bizcam_ja";
      } else {
        boardTypeVal = "bizcam";
      }
    } else {
      if (browserLanguage === "ja_JP") {
        boardTypeVal = "bizcam_ja";
      } else {
        boardTypeVal = "bizcam";
      }
    }
    searchParam["boardType"] = boardTypeVal;
    searchParam["pageNumber"] = 1;
    searchParam["pageCount"] = 50;
    Notice.getList(searchParam).$promise.then(function (data) {
      var dateFilterList = [];
      for (var i = 0; i < data.notices.length; i++) {
        if (data.notices[i].regDate < moment().format("x")) {
          dateFilterList.push(data.notices[i]);
        }
      }
      $scope.setNoticeList(dateFilterList);
    }, function (err) {});
  };
  $scope.getNoticeList();
  var flip = 0;
  var openNum = 0;
  $scope.viewContent = function (num) {
    if (num != openNum) {
      $("#noticeDetail" + num).empty();
      $("#noticeDetail" + num).append($scope.noticeList[num - 1].content);
      $("#contentDetail" + num).show();
      $("#noticeDetail" + num).show();
      $("#content_detail").show();
      $("#notice_" + num).hide();
      openNum = num;
    } else {
      if ($("#contentDetail" + num).children("td").children("div").eq(2).attr("class").indexOf("day") != -1) {
        $("#contentDetail" + num).hide();
        $("#notice_" + num).show();
      } else {
        $("#contentDetail" + num).hide();
        $("#notice_" + num).show();
      }
      openNum = 0;
    }
  };
}]);
"use strict";

d3.selection.prototype.moveToFront = function () {
  return this.each(function () {
    this.parentNode.appendChild(this);
  });
};
var posTimelineDragCnt = 0;
var dragX = 0;
var getBrowserLanguage = function getBrowserLanguage() {
  var langMap = {
    en: "en_US",
    ko: "ko_KR",
    ja: "ja_JP"
  };
  var htmlLang = $("html").attr("lang");
  return langMap[htmlLang] || "en_US";
};
var PosTimeline = function PosTimeline(width, height, timeRange, $q, $translate) {
  var that = this;
  this.width = width;
  this.height = height;
  this.timeRange = timeRange;
  this.eventData = [];
  this.cvrData = [];
  this.forceDomain = true;
  this.isLoading = false;
  this.$q = $q;
  this.$translate = $translate;
  this.timelineColorObj = {
    1: "#3EA1D4",
    101: "#E94C58",
    102: "#3EA1D4",
    103: "#E94C58",
    104: "#E94C58",
    105: "#E94C58",
    201: "#8CA828",
    202: "#8CA828",
    203: "#f8b651",
    204: "#f8b651",
    205: "#8CA828"
  };
  var currentSvg = d3.select(".timebar .timebar_area svg");
  if (currentSvg !== undefined) {
    currentSvg.remove();
  }
  this.svg = d3.select(".timebar .timebar_area").append("svg").attr("width", width).attr("height", height).attr("class", "no-select");
  this.mainContainer = this.svg.append("g").attr({
    transform: "translate(0, -19)"
  });
  var cvrBgDrag = d3.behavior.drag().on("dragstart", function () {
    changeTimeRangeFlag = true;
    dragThumCancle = true;
    thumnailDraw = false;
  }).on("drag", function () {
    if (timelineDrawFlag == false) {
      return;
    }
    beforeSgid = "";
    $("#time_info_tri").hide();
    $("#showThumbnailListNew").hide();
    removeWidthStop = true;
    draging++;
    dragFlag = true;
    var x = 0;
    if (navigator.userAgent.indexOf("MSIE") !== -1 || navigator.appVersion.indexOf("Trident/") > 0) {
      x = d3.event.dx; // *2.22;
    } else {
      x = d3.event.dx; // *1.91;
    }
    serivceDayOver = true;
    var nowTime = new Date().valueOf();
    var overTime = -0.987;
    if (that.delegate.timeRange == 60) {
      overTime = -0.918;
    } else if (that.delegate.timeRange == 360) {
      overTime = -0.59;
    } else if (that.delegate.timeRange == 1440) {
      overTime = 0.9;
    }
    var serviceTime = 0;
    if (that.delegate.currentCamera.recorderType == "nvr") {
      if (that.delegate.timeRange == 10) {
        overTime = 1000 * 60 * 6;
      } else if (that.delegate.timeRange == 360) {
        overTime = 1000 * 60 * 60 * 5;
      } else if (that.delegate.timeRange == 1440) {
        overTime = 1000 * 60 * 60 * 24;
      } else {
        // 1시간
        overTime = 1000 * 60 * 30;
      }
      serviceTime = nowTime - 1000 * 60 * 60 * 24 * that.delegate.serviceDay;
      serviceTime = that.delegate.currentCamera.regDate > serviceTime ? that.delegate.currentCamera.regDate - overTime : serviceTime - overTime;
    } else {
      serviceTime = nowTime - 1000 * 60 * 60 * 24 * (that.delegate.serviceDay + overTime);
    }
    if (serviceTime > that.removedBufferDomain[0]) {
      serivceDayOver = false;
    } else {
      serivceDayOver = true;
    }
    dragX += x;
    if (dragX > getMaxDragX()) {
      return;
    } else if (dragX < -getMaxDragX()) {
      return;
    }
    if (serivceDayOver == false && dragX > 0) {
      return;
    }
    that.updateCursor(that.delegate.currentTime);
    $(".openClose").children("image").attr("transform", "translate(" + dragX + ", 0)");
    $(".eventArea").attr("transform", "translate(" + dragX + ", 0)");
    // $(".cancelGroup").attr("transform","translate("+dragX+", 0)");
    $(".cvr").attr("transform", "translate(" + dragX + ", 0)");
    $(".axis").attr("transform", "translate(" + dragX + ", 75)");
    $(".cursor").attr("transform", "translate(" + dragX + ", 0)");
    $(".cvrBG").attr("x", dragX * -1);
    $(".cvrBG2").attr("x", dragX * -1);
  }).on("dragend", function () {
    posTimelineDragCnt = 0;
    beforeSgid = "";
    if (dragX < -10) {} else if (dragX > 10) {} else {
      dragFlag = false;
    }
    setTimeout(function () {
      dragFlag = false;
      if (timelineClick == false) {
        that.delegate.lineMoveFlag = true;
        dragTimeLine = true;
        dragEndStatus = true;
        that.dragDomain();
        $(".axis").attr("transform", "translate(0, 75)");
        $(".cvr").attr("transform", "translate(0, 0)");
        $(".cursor").attr("transform", "translate(0, 0)");
        $(".cvrBG").attr("x", "0");
        $(".cvrBG2").attr("x", "0");
        if (that.delegate.isPlaying == false) {
          that.updateCursor(that.delegate.currentTime);
        }
      }
      timelineClick = false;
    }, 150);
    setTimeout(function () {
      changeTimeRangeFlag = false;
      timelineDrawFlag = true;
    }, 1410);
    dragThumCancle = false;
  });
  this.openClose = this.mainContainer.append("g").attr("class", "openClose");
  this.payServiceEvents = this.mainContainer.append("g").attr("class", "events");
  // this.cancelGroupEvents = this.mainContainer.append('g').attr('class', 'cancelGroup');
  this.scaleEvents = this.mainContainer.append("g").attr("class", "scales");
  this.mainContainer.append("g").append("rect").attr({
    x: 0,
    y: 25,
    width: this.width,
    height: 48,
    "class": "cvrBG"
  }).call(cvrBgDrag);
  this.mainContainer.append("g").append("rect").attr({
    x: 0,
    y: 70,
    width: this.width,
    height: 48,
    "class": "cvrBG2"
  }).call(cvrBgDrag);
  this.cvrs = this.mainContainer.append("g").attr("class", "cvr");
  this.isDblZooming = false;
  this.previousDblClickTime = 0;
  this.currentDomain = timeRange.currentDomain;
  this.svg.on("dblclick", function () {
    posTimelineDragCnt = 0;
    dblClickFlag = true;
    var now = new Date();
    $("#showThumbnailListNew").hide();
    $("#time_info_tri").hide();
    if (now.getTime() - that.previousDblClickTime < 500) return;
    that.previousDblClickTime = now.getTime();
    if (that.isLoading) return;
    var cursorTime = that.delegate.currentTime.getTime();
    if (cursorTime <= that.currentDomain[0] || cursorTime >= that.currentDomain[1]) {
      return;
    }
    var timeRanges = [10, 60, 360, 1440];
    var current = timeRanges.indexOf(that.timeRange);
    if (current === 0) {
      that.isDblZooming = true;
    } else if (current === 3) {
      that.isDblZooming = false;
    }
    var newTimeRange;
    if (that.isDblZooming) {
      newTimeRange = timeRanges[current + 1];
    } else {
      newTimeRange = timeRanges[current - 1];
    }
    that.dblZoomDomain(cursorTime, newTimeRange);
  });
};
var getMaxDragX = function getMaxDragX() {
  return parseInt($(".cvrBG").attr("width"));
};
PosTimeline.prototype.setBoundDateFormat = function (format) {
  this.boundDateFormat = format;
};
PosTimeline.prototype.setTimezone = function (timezone) {
  if (timezone !== undefined && timezone !== "") {
    var tokens = timezone.split(",");
    this.tz = tokens[2];
  }
};
PosTimeline.bufferDomain = function (minutes) {
  var buffer = 0;
  switch (minutes) {
    case 5:
      buffer = 30000;
      break;
    case 60:
      buffer = 5 * 60 * 1000;
      break;
    case 360:
      buffer = 30 * 60 * 1000;
      break;
    case 1440:
      buffer = 90 * 60 * 1000;
      break;
    default:
      break;
  }
  return buffer;
};
PosTimeline.removeBufferDomain = function (domain, timeRange) {
  var buffer = PosTimeline.bufferDomain(timeRange);
  var originStart = domain[0] + buffer;
  var originEnd = domain[1] - buffer;
  return [originStart, originEnd];
};
PosTimeline.bufferCursorCheckDomain = function (minutes) {
  var buffer = 0;
  switch (minutes) {
    case 5:
      buffer = 5 * 60 * 1000;
      break;
    case 10:
      buffer = 10 * 60 * 1000;
      break;
    case 60:
      buffer = 60 * 60 * 1000 + 150000;
      break;
    case 360:
      buffer = 60 * 60 * 1000 * 6 + 650000;
      break;
    case 1440:
      buffer = 60 * 60 * 1000 * 24 + 650000;
      break;
    default:
      break;
  }
  return buffer;
};
PosTimeline.removeBufferCursorCheckDomain = function (domain, timeRange) {
  var buffer = PosTimeline.bufferCursorCheckDomain(timeRange);
  var originStart = domain[0] + buffer;
  var originEnd = domain[1] - buffer;
  return [originStart, originEnd];
};
PosTimeline.dateDomain = function (minutes, ratio) {
  var now = Date.now();
  if (ratio === undefined) {
    ratio = 0.8;
  }
  var ms = minutes * 60 * 1000;
  var start = now - parseInt(ms * ratio);
  var end = now + parseInt(ms * (1 - ratio));
  return PosTimeline.bufferedDomain([start, end], minutes);
};
PosTimeline.bufferedDomain = function (domain, minutes) {
  var ticks = {
    1: 0.2,
    5: 1,
    10: 2,
    60: 10,
    360: 60,
    1440: 180
  };
  var ms = ticks[minutes] * 60 * 1000;
  var buffer = PosTimeline.bufferDomain(minutes);
  var newStart = Math.ceil(domain[0] / ms) * ms - buffer;
  var newEnd = Math.ceil(domain[1] / ms) * ms + buffer;
  startTimeline = newStart;
  return [newStart, newEnd];
};
PosTimeline.prototype.zoomDomain = function (time, timeRange) {
  thumnailViewFlag = false;
  this.timeRange = timeRange;
  if (this.delegate !== undefined) {
    this.delegate.timeRange = timeRange;
  }
  var range = 1000 * 60 * timeRange;
  var diff = timeRange / 2 * 60 * 1000;
  var start = time - diff - diff * 0.8;
  var end = time + diff - diff * 0.8;
  return this.changeDomain(PosTimeline.bufferedDomain([start - range, end + range], timeRange), 500, time);
};
PosTimeline.prototype.dblZoomDomain = function (time, timeRange) {
  this.timeRange = timeRange;
  if (this.delegate !== undefined) {
    this.delegate.timeRange = timeRange;
  }
  var range = 1000 * 60 * timeRange;
  var diff = timeRange / 2 * 60 * 1000;
  var start = time - diff - diff * 0.8;
  var end = time + diff - diff * 0.8;
  var newDomain = PosTimeline.bufferedDomain([start - range, end + range], timeRange);
  while (time < newDomain[0] || time > newDomain[1]) {
    var ms = timeRange * 60 * 1000;
    if (time < newDomain[0]) {
      newDomain = [newDomain[0] + ms, newDomain[1] + ms];
    }
    if (time > newDomain[1]) {
      newDomain = [newDomain[0] - ms, newDomain[1] - ms];
    }
  }
  if (dblClicklive == false) {
    this.delegate.clickedCVRArea(new Date(dblClickTime));
  } else {
    this.delegate.goLive();
  }
  return this.changeDomain(newDomain);
};
PosTimeline.prototype.prevDomain = function () {
  posTimelineDragCnt = 0;
  dragThumCancle = false;
  var diff = this.timeRange * 60 * 1000;
  var newDomain = [this.currentDomain[0] - diff, this.currentDomain[1] - diff];
  return this.changeDomain(newDomain);
};
PosTimeline.prototype.nextDomain = function () {
  posTimelineDragCnt = 0;
  dragThumCancle = false;
  var diff = this.timeRange * 60 * 1000;
  var newDomain = [this.currentDomain[0] + diff, this.currentDomain[1] + diff];
  return this.changeDomain(newDomain);
};
PosTimeline.prototype.dragDomain = function () {
  var diff = this.timeRange * 60 * 1000;
  var newDomain = [this.currentDomain[0] + diff, this.currentDomain[1] + diff];
  dragX = 0;
  var range = 0;
  var timelineFix = 0;
  switch (this.timeRange) {
    case 10:
      range = 1800000;
      break;
    case 60:
      range = 11400000;
      timelineFix = 200000;
      break;
    case 360:
      range = 68400000;
      timelineFix = 1200000;
      break;
    case 1440:
      range = 270000000;
      timelineFix = 3600000;
      break;
  }
  var startDo = this.x.invert(parseInt($(".cvrBG").attr("x"))).getTime() - this.timeRange * 60 * 1000 - timelineFix;
  var endDo = startDo + range;
  var newDomain = [startDo, endDo];
  return this.changeDragDomain(newDomain);
};
PosTimeline.prototype.setTimeRange = function (minutes, callback) {
  this.timeRange = parseInt(minutes);
  var x = this.svg.select(".cursor").select("line").attr("x1");
  var cursorTime = this.x.invert(x).getTime();
  return this.zoomDomain(cursorTime, minutes);
};
PosTimeline.prototype.setTimeRangeAtDateString = function (dateString, timeRange) {
  this.timeRange = 1440;
  var format = d3.time.format("%Y%m%d%H%M%S");
  var startDate = format.parse(dateString + "000000");
  var endDate = format.parse(dateString + "240000");
  var range = 1000 * 60 * timeRange;
  var startTime = startDate.getTime();
  var endTime = endDate.getTime();
  var newDomain = PosTimeline.bufferedDomain([startTime - range, endTime + range], this.timeRange);
  return this.changeDomain(newDomain);
};
PosTimeline.prototype.changeDomain = function (domain, duration, time) {
  var $q = this.$q;
  var that = this;
  var deferred = $q.defer();
  this.svg.select(".cursor").classed("hide", true);
  this.currentDomain = domain;
  this.removedBufferDomain = PosTimeline.removeBufferDomain(this.currentDomain, this.timeRange);
  setTimeout(function () {
    if (that.delegate !== undefined && that.delegate.setupDomain !== undefined) {
      that.delegate.setupDomain(that.currentDomain);
    }
  }, 1000);
  var extent;
  if (this.brush !== undefined) {
    extent = this.brush.extent();
  }
  this.x.domain(domain);
  if (this.brush !== undefined && extent !== undefined) {
    this.brush.extent(extent);
    this.brush(d3.select(".brush").transition().duration(500));
  }
  if (duration === undefined) {
    duration = 500;
  }
  if (this.cursorTime >= this.removedBufferDomain[0] && this.cursorTime <= this.removedBufferDomain[1]) {
    this.forceDomain = true;
  } else {
    this.forceDomain = false;
  }
  this.nowAnimating = true;
  this.updateAxis(duration);
  this.updateBar(duration);
  this.updateEvents(duration);
  this.updateOpenClose(duration);
  setTimeout(function () {}, 500);
  this.nowAnimating = false;
  deferred.resolve();
  switch (this.timeRange) {
    case 10:
      range = 600000;
      fixRange = 0;
      break;
    case 60:
      range = 600000 * 6;
      fixRange = 0;
      break;
    case 360:
      range = 600000 * 6 * 6;
      fixRange = 1055000;
      break;
    case 1440:
      range = 600000 * 6 * 6 * 4;
      fixRange = 3120000;
      break;
  }
  if (domain[0] + range <= this.delegate.currentTime.valueOf() && domain[1] - range >= this.delegate.currentTime.valueOf()) {
    if (this.delegate.isPlaying == false) {
      $(".cursor").hide();
      this.svg.select(".cursor").classed("hide", false);
      $(".cursor").fadeIn(500);
    }
  }
  if (clickDateChange == true) {
    clickDateChange = false;
    setTimeout(function () {
      $(".events").empty();
      // $(".cancelGroup").empty();
      $(".events").fadeIn(200);
    }, 280);
  }
  return deferred.promise;
};
PosTimeline.prototype.changeDragDomain = function (domain, duration, time) {
  var $q = this.$q;
  var that = this;
  var deferred = $q.defer();
  this.svg.select(".cursor").classed("hide", true);
  this.currentDomain = domain;
  this.removedBufferDomain = PosTimeline.removeBufferDomain(this.currentDomain, this.timeRange);
  if (this.delegate !== undefined && this.delegate.setupDomain !== undefined) {
    this.delegate.setupDomain(this.currentDomain);
  }
  var extent;
  if (this.brush !== undefined) {
    extent = this.brush.extent();
  }
  this.x.domain(domain);
  if (this.brush !== undefined && extent !== undefined) {
    this.brush.extent(extent);
  }
  if (duration === undefined) {
    duration = 500;
  }
  if (this.cursorTime >= this.removedBufferDomain[0] && this.cursorTime <= this.removedBufferDomain[1]) {
    this.forceDomain = true;
  } else {
    this.forceDomain = false;
  }
  this.nowAnimating = true;
  this.updateAxis(-100, "drag");
  this.updateBar(0);
  this.nowAnimating = false;
  if ($(".cursor").attr("class").indexOf("hide") != -1) {
    that.updateCursor(that.delegate.currentTime);
    this.svg.select(".cursor").classed("hide", false);
  }
  return deferred.promise;
};
PosTimeline.prototype.draw = function () {
  this.drawAxis();
  this.drawCursor();
  this.drawEvents();
};
PosTimeline.prototype.redrawWithWidth = function (width) {
  if (width == 0) {
    width = nowWitdh;
  }
  this.width = width;
  this.svg.attr({
    width: width
  });
  if (this.axisContainer != undefined) {
    this.axisContainer.remove();
    this.axisContainer = undefined;
    this.drawAxis(this.currentDomain);
    this.cursor.moveToFront();
    this.updateBar(0);
    nowWitdh = width;
  }
};
PosTimeline.prototype.getDateTicks = function () {
  var todayWord = this.$translate.instant("EVENT_LIST_DATE_TODAY");
  var yesterdayWord = this.$translate.instant("EVENT_LIST_DATE_YESTERDAY");
  var that = this;
  var tick = d3.svg.axis().scale(this.x).orient("bottom").tickSize(11, 0).tickPadding(3).tickFormat(function (d, i) {
    var md;
    if (that.tz !== undefined) {
      md = moment(d).tz(that.tz).locale(getBrowserLanguage());
    } else {
      md = moment(d).locale(getBrowserLanguage());
    }
    var now = new Date();
    var todayCheck = new Date(md.year(), md.month(), md.date());
    var todayFlag = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    var dateFormat = that.boundDateFormat;
    if (dateFormat === undefined) {
      dateFormat = "HH:mm";
    } else if (todayCheck.getTime() == todayFlag.getTime()) {
      dateFormat = todayWord + "(ddd)";
    } else if ((todayFlag - todayCheck) / (1000 * 60 * 60 * 24) == 1) {
      dateFormat = yesterdayWord + "(ddd)";
    } else {
      dateFormat = that.boundDateFormat;
    }
    if (that.timeRange == 10) {
      if (parseInt(md.minutes()) % 10 == 0) {
        return md.format(dateFormat);
      } else {
        return "";
      }
    } else if (that.timeRange == 60) {
      if (md.minutes() == "00") {
        return md.format(dateFormat);
      } else {
        return "";
      }
    } else if (that.timeRange == 360) {
      var formatArr = [2, 6, 10, 14, 18, 22];
      if (formatArr.indexOf(md.hours()) > -1) {
        return md.format(dateFormat);
      } else {
        return "";
      }
    } else if (that.timeRange == 1440) {
      var formatArr = [4, 16];
      if (formatArr.indexOf(md.hours()) > -1) {
        return md.format(dateFormat);
      } else {
        return "";
      }
    }
  });
  switch (this.timeRange) {
    case 5:
      tick.ticks(d3.time.minutes, 1);
      break;
    case 10:
      tick.ticks(d3.time.minutes, 10);
      break;
    case 60:
      tick.ticks(d3.time.hours, 1);
      break;
    case 360:
      tick.ticks(d3.time.hours, 2);
      break;
    case 1440:
      tick.ticks(d3.time.hours, 4);
      break;
  }
  return tick;
};
PosTimeline.prototype.getBigTicks = function () {
  var dayWord = this.$translate.instant("EVENT_LIST_DATE_DAY");
  var nightWord = this.$translate.instant("EVENT_LIST_DATE_NIGHT");
  var that = this;
  var tick = d3.svg.axis().scale(this.x).orient("bottom").tickSize(11, 0).tickPadding(3).tickFormat(function (d, i) {
    var md;
    if (that.tz !== undefined) {
      md = moment(d).tz(that.tz).locale(getBrowserLanguage());
    } else {
      md = moment(d).locale(getBrowserLanguage());
    }
    var timeFormat = "HH:mm";
    if (md.hours() >= 6 && md.hours() < 18) {
      timeFormat = timeFormat + " " + dayWord;
    } else {
      timeFormat = timeFormat + " " + nightWord;
    }
    if (that.timeRange == 10) {
      if (parseInt(md.minutes()) % 10 == 0) {
        return md.format(timeFormat);
      } else {
        return md.format("HH:mm");
      }
    } else if (that.timeRange == 60) {
      if (md.minutes() == "00") {
        return md.format(timeFormat);
      } else {
        return md.format("HH:mm");
      }
    } else if (that.timeRange == 360) {
      var formatArr = [2, 6, 10, 14, 18, 22];
      if (formatArr.indexOf(md.hours()) > -1) {
        return md.format(timeFormat);
      } else {
        return md.format("HH:mm");
      }
    } else if (that.timeRange == 1440) {
      var formatArr = [4, 16];
      if (formatArr.indexOf(md.hours()) > -1) {
        return md.format(timeFormat);
      } else {
        return md.format("HH:mm");
      }
    }
  });
  switch (this.timeRange) {
    case 5:
      tick.ticks(d3.time.minutes, 1);
      break;
    case 10:
      tick.ticks(d3.time.minutes, 2);
      break;
    case 60:
      tick.ticks(d3.time.minutes, 10);
      break;
    case 360:
      tick.ticks(d3.time.hours, 1);
      break;
    case 1440:
      tick.ticks(d3.time.hours, 4);
      break;
  }
  return tick;
};
PosTimeline.prototype.getTicks = function () {
  var tick = d3.svg.axis().scale(this.x).orient("bottom").tickSize(10, 0);
  switch (this.timeRange) {
    case 5:
      tick.ticks(d3.time.seconds, 15);
      break;
    case 10:
      tick.ticks(d3.time.seconds, 30);
      break;
    case 60:
      tick.ticks(d3.time.minutes, 5);
      break;
    case 360:
      tick.ticks(d3.time.minutes, 30);
      break;
    case 1440:
      tick.ticks(d3.time.hours, 1);
      break;
  }
  return tick;
};
PosTimeline.prototype.getSmallTicks = function () {
  var tick = d3.svg.axis().scale(this.x).orient("bottom").tickSize(5, 0);
  switch (this.timeRange) {
    case 5:
      tick.ticks(d3.time.seconds, 5);
      break;
    case 10:
      tick.ticks(d3.time.seconds, 5);
      break;
    case 60:
      tick.ticks(d3.time.minutes, 1);
      break;
    case 360:
      tick.ticks(d3.time.minutes, 5);
      break;
    case 1440:
      tick.ticks(d3.time.minutes, 20);
      break;
  }
  return tick;
};
function getDateTickWidth(index) {
  var tick = $(".date-tick-axis .tick text")[index];
  return tick.getBoundingClientRect().width;
}
function adjustDateLocation(d, index) {
  var currentTranslateX = this.x(d.getTime());
  var textWidth = getDateTickWidth(index);
  var margin = 27;
  var adjustedTranslateX = currentTranslateX - textWidth / 2 - margin;
  return "translate(" + adjustedTranslateX + ", 0)";
}
PosTimeline.prototype.drawAxis = function (domain) {
  var that = this;
  if (domain === undefined) {
    this.currentDomain = PosTimeline.dateDomain(this.timeRange);
    this.currentDomain[0] = this.currentDomain[0] - 1000 * 60 * 60;
    this.currentDomain[1] = this.currentDomain[1] + 1000 * 60 * 60;
  }
  this.removedBufferDomain = PosTimeline.removeBufferDomain(this.currentDomain, this.timeRange);
  if (this.delegate !== undefined && this.delegate.setupDomain !== undefined) {
    this.delegate.setupDomain(this.currentDomain);
  }
  this.x = d3.time.scale().domain(this.currentDomain).range([-this.width, this.width * 2]);
  if (this.axisContainer === undefined) {
    this.axisContainer = this.mainContainer.append("g").attr("transform", "translate(0, 75)").attr("class", "axis");
  }
  var dateTickAxis = this.axisContainer.append("g").attr("class", "date-tick-axis").call(this.getDateTicks()).call(function () {
    var ticks = this.selectAll(".tick")[0];
    ticks.forEach(function (tick) {
      var textNode = $(tick).find("text");
      var text = textNode.text();
      var textWidth = textNode[0].getBoundingClientRect().width + 6;
      var locationX = -(textWidth / 2);
      if (text.length > 0) {
        d3.select(tick).insert("rect", "text").attr({
          x: locationX,
          y: 12,
          width: textWidth,
          height: 14,
          fill: "#555"
        });
      }
    });
  });
  this.axisContainer.selectAll(".date-tick-axis .tick").attr("transform", adjustDateLocation.bind(this));
  var bigTickAxis = this.axisContainer.append("g").attr("class", "big-tick-axis").call(this.getBigTicks());
  var tickAxis = this.axisContainer.append("g").attr("class", "tick-axis").call(this.getTicks());
  var smallTickAxis = this.axisContainer.append("g").attr("class", "small-tick-axis").call(this.getSmallTicks());
  var cvrBG = this.svg.select(".cvrBG").attr("width", this.width).attr("height", "50px");
  var cvrBG2 = this.svg.select(".cvrBG2").attr("width", this.width).attr("height", "50px").attr("z-index", "999");
  var that = this;
  cvrBG.on("click", function () {
    posTimelineDragCnt = 0;
    if (firstDataLoadingFlag == false) {
      that.delegate.loadingDataAlert();
      return;
    }
    if (dragFlag == false) {
      liveReloadCnt = 0;
      statusCheck = 0;
      var mouseLocation = d3.mouse(this);
      var selectedTime = that.x.invert(mouseLocation[0]);
      if (serviceDateTime > selectedTime.valueOf()) {
        return;
      }
      dblClicklive = that.delegate.isLive;
      dblClickTime = that.delegate.currentTime.valueOf();
      thumnailDraw = true;
      that.delegate.lineMoveFlag = false;
      dragThumCancle = false;
      timelineClick = true;
      that.delegate.plyBtnStatus = true;
      if (new Date().getTime() - that.previousDblClickTime < 500) return; // animating caused by dbl click.

      var callbackFunc = function callbackFunc() {
        that.forceDomain = true;
        that.updateCursor(selectedTime);
        if (that.delegate != undefined && typeof that.delegate.clickedCVRArea === "function") {
          that.delegate.clickedCVRArea(selectedTime);
        }
        if (that.delegate.currentTime - Date.now() >= 0) {
          // 미래를 선택한 경우
          that.delegate.goLive();
          return;
        }
      };
      that.delegate.checkCVRSeucre(function (isSecureMode) {
        if (isSecureMode) {
          if (document.msFullscreenElement) {
            that.delegate.pressedExitFullScreenButton();
          }
          that.delegate.play.securePassword = "";
          that.delegate.isShowCVRPlayPasswordConfirm = !that.delegate.isShowCVRPlayPasswordConfirm;
          that.delegate.cvrPasswordSuccess = callbackFunc;
        } else {
          callbackFunc();
        }
      });
    }
  }).on("mousemove", function () {
    var mouseLocation = d3.mouse(this);
    var selectedTime = that.x.invert(mouseLocation[0]);
    if (that.delegate != undefined && typeof that.delegate.cvrMouseoverEventsNew === "function") {
      that.delegate.cvrMouseoverEventsNew(mouseLocation[0], selectedTime);
    }
  }).on("mouseout", function () {
    if (that.delegate != undefined && typeof that.delegate.mouseoutEvents === "function") {
      that.delegate.mouseoutEvents();
    }
  });
  cvrBG2.on("mousemove", function () {
    $("#time_info_tri").hide();
    $("#showThumbnailListNew").hide();
  });
};
PosTimeline.prototype.drawCursor = function () {
  var that = this;
  var drag = d3.behavior.drag().on("dragstart", function () {
    cursorDragStatus = true;
    if (firstDataLoadingFlag == false) {
      return;
    }
    $("#showThumbnailListNew").hide();
    $("#time_info_tri").hide();
    if (that.delegate !== undefined && that.delegate.cursorDragStart !== undefined) {
      that.delegate.cursorDragStart();
    }
  }).on("drag", function () {
    cursorDragStatus = true;
    if (firstDataLoadingFlag == false) {
      that.delegate.loadingDataAlert();
      return;
    }
    var x = d3.event.x;
    var time = that.x.invert(x);
    if (serviceDateTime > time) {
      return;
    }
    that.cursor.selectAll("line").attr({
      x1: x,
      x2: x
    });
    that.cursor.selectAll("cursor").attr({
      x1: x,
      x2: x
    });
    that.cursor.selectAll("circle").attr({
      cx: x
    });
    if (that.delegate !== undefined && that.delegate.cursorDragging !== undefined) {
      that.delegate.cursorDragging(time);
    }
  }).on("dragend", function () {
    that.delegate.plyBtnStatus = true;
    cursorDragStatus = false;
    liveReloadCnt = 0;
    statusCheck = 0;
    if (that.delegate !== undefined && that.delegate.cursorDragEnd !== undefined) {
      dragThumCancle = false;
      that.delegate.checkCVRSeucre(function (isSecureMode) {
        if (isSecureMode) {
          if (document.msFullscreenElement) {
            that.delegate.pressedExitFullScreenButton();
          }
          that.delegate.play.securePassword = "";
          that.delegate.isShowCVRPlayPasswordConfirm = !that.delegate.isShowCVRPlayPasswordConfirm;
          that.delegate.cvrPasswordSuccess = that.delegate.cursorDragEnd;
        } else {
          that.delegate.cursorDragEnd();
        }
      });
    }
  });
  this.cursor = this.mainContainer.append("g").attr("class", "cursor").call(drag);
  //$(".cursor").css("width","10px");
  var currentX = this.x(Date.now());
  this.cursor.append("line").attr({
    "class": "mainBack",
    x1: currentX,
    x2: currentX,
    y1: 29,
    y2: 74
  });
  this.cursor.append("line").attr({
    "class": "main",
    x1: currentX,
    x2: currentX,
    y1: 29,
    y2: 74
  });
  this.cursor.append("circle").attr({
    "class": "circle",
    cx: currentX,
    cy: 29,
    r: 6,
    fill: "white"
  });
  $(".circle").attr("stroke", "red");
  $(".circle").attr("stroke-width", "3");
  $(".circle").attr("z-index", "1500");
  $(".line").attr("z-index", "1500");
};
var updateCursorState = false;
PosTimeline.prototype.updateCursor = function (time) {
  var deferred = this.$q.defer();
  var now = Date.now();
  if (time !== undefined) {
    now = time.valueOf();
  }
  this.cursorTime = now;
  this.svg.select(".cursor").classed("hide", this.nowAnimationg);
  if (typeof this.x === "function") {
    var currentX = parseInt(this.x(now));
    this.svg.select(".cursor").selectAll("circle").attr({
      cx: currentX
    });
    this.svg.select(".cursor").selectAll("line").attr({
      x1: currentX,
      x2: currentX
    });
    this.svg.select(".cursor").selectAll("line").attr({
      x1: currentX,
      x2: currentX
    });
    var curosEmptyData = 0;
    deferred.resolve();
    if (this.delegate.timeRange == 60) {
      curosEmptyData = 200000;
    } else if (this.delegate.timeRange == 360) {
      curosEmptyData = 1200000;
    } else if (this.delegate.timeRange == 1440) {
      curosEmptyData = 4800000;
    }
    if (now > this.removedBufferDomain[1] + curosEmptyData) {
      // 커서가 타임라인 우측에 도착했을때
      if (this.forceDomain === true) {
        return this.nextDomain();
      }
      this.svg.select(".cursor").classed("hide", true);
    } else if (now < this.removedBufferDomain[0] - curosEmptyData) {
      // 커서가 타임라인 좌측에 도착했을때
      if (this.forceDomain === true) {
        return this.prevDomain();
      }
      this.svg.select(".cursor").classed("hide", true);
    } else {
      if (this.delagate !== undefined && this.delegate.hideCursorNavigation !== undefined) {
        this.delegate.hideCursorNavigation();
      }
    }
    if (!this.delegate.isLive) {
      this.delegate.getCurrentCursorEventList();
    }
  }
  return deferred.promise;
};
var removeWidth0 = true;
var removeWidth = 0;
var removeWidthStop = true;
PosTimeline.prototype.drawRecordBar = function () {
  var that = this;
  if (changeTimeRangeClick == true) {
    $(".cvr").empty();
  }
  changeTimeRangeClick = false;
  if (this.cvrData != undefined) {
    var bars = this.cvrs.selectAll(".record-bar").data(this.cvrData).enter().append("rect").attr({
      "class": "record-bar",
      x: function x(d) {
        if (that.x(d.startTime).toString == "NaN") {}
        if (parseInt(d.startTime) < serviceDateTime) {
          d.startTime = serviceDateTime;
        }
        if (parseInt(d.startTime) < serviceDateTime) {
          d.startTime = serviceDateTime;
        }
        var thatX = that.x(d.startTime);
        //serviceDateTime
        return thatX;
      },
      y: 69,
      width: function width(d) {
        thatEnd = that.x(d.endTime);
        thatStart = that.x(d.startTime);
        var thatWidth = that.x(d.endTime) - that.x(d.startTime);
        if (thatWidth.toString == "NaN") {
          return 0;
        }
        if (thatWidth < 0) {
          thatWidth = 0;
        }
        return thatWidth;
      },
      height: 5
    });
  }
};
var eventId = 0;
var timelineSgidMap = new Map();
var showThumbnail = new Map();
PosTimeline.prototype.drawEvents = function () {
  var that = this;
  var filteredData = [];
  var t = 0;
  var openData = [];
  var closeData = [];
  eventId = 0;
  timelineMap = new Map();
  timelineSgidMap = new Map();
  timelineSgidWidthMap = new Map();
  if (this.eventData != undefined) {
    this.eventData.forEach(function (d) {
      var allFilteredEventIds = that.delegate.getAllFilteredZonesIds(d.eventTps.split(","));
      var isCheckedEvent = _.intersection(d.eventTps.split(","), allFilteredEventIds); // 필터 체크된 이벤트 데이터인지 확인

      if (parseInt(d.endTime) <= parseInt(Date.now()) && isCheckedEvent.length > 0) {
        timelineSgidMap.put("event" + eventId, d.id);
        var idx = 0;
        var eventIdx = 0;
        var obj = {};
        obj.detectType = "eventArea";
        obj.id = d.id;
        obj.startTime = d.startTime;
        if (parseInt(d.endTime) == 0) {
          d.endTime = Date.now().toString();
          obj.id = "1";
        } else {
          obj.endTime = d.endTime;
          obj.id = d.id;
        }

        // if (_.map(that.delegate.eventTypeList, 'id').indexOf(isCheckedEvent[0]) > -1) {
        // 	// 가족 출입, 소리 이벤트 인 경우 id 그대로
        // 	eventIdx = isCheckedEvent[0];
        // } else {
        // 	// 모션존인 경우 uid로 id 찾기
        // 	eventIdx = _.get(_.find(that.delegate.motionZones, function (o) { return o.uid === isCheckedEvent[0] && o.id !== '9'; }), 'id');
        // }
        eventIdx = isCheckedEvent[0];
        obj.color = that.timelineColorObj[eventIdx];
        obj.index = isCheckedEvent[0];
        obj.idx = "zone" + eventId + " num" + eventIdx;
        if (isCheckedEvent.indexOf("203") > -1 && d.isStoreEvent == "OPEN") {
          openData.push(obj);
        }
        if (isCheckedEvent.indexOf("204") > -1 && d.isStoreEvent == "CLOSE") {
          closeData.push(obj);
        }
        var thatXCheck = that.x(d.startTime);
        var thatWidthCheck = that.x(d.endTime) - that.x(d.startTime);
        if (fullscreenFlag == true) {
          if (thatWidthCheck >= 0) {
            filteredData.push(obj);
          }
        } else {
          if (thatWidthCheck >= 0) {
            filteredData.push(obj);
          }
        }
        // }
        eventId++;
      }
    });
  }
  this.openClose.selectAll("image").data(openData).enter().append("svg:image").attr("xlink:href", "/resources/im/ic_open_timeline.png").attr({
    x: function x(d) {
      return (that.x(d.startTime) + that.x(d.endTime)) / 2 - 17;
    },
    y: 20
  });
  this.openClose.selectAll("image").data(closeData).enter().append("svg:image").attr("xlink:href", "/resources/im/ic_close_timeline.png").attr({
    x: function x(d) {
      return (that.x(d.startTime) + that.x(d.endTime)) / 2 - 20;
    },
    y: 20
  });
  var payService = this.payServiceEvents.selectAll(".event-bar").data(filteredData.filter(function (d) {
    return d.endTime !== undefined;
  })).enter().append("rect").attr({
    "class": function _class(d) {
      return ["event-bar", d.detectType, d.idx].join(" ");
    },
    x: function x(d) {
      if (that.x(d.startTime).toString == "NaN") {}
      if (parseInt(d.startTime) < serviceDateTime) {
        d.startTime = serviceDateTime;
      }
      return that.x(d.startTime);
    },
    y: 40,
    i: function i(d) {
      return d.index;
    },
    fill: function fill(d) {
      if (d.color == null || d.color == "null") {
        // return "#929292";
        return "#f0f0f0";
      }
      return d.color;
    },
    width: function width(d) {
      var thatX = that.x(d.startTime);
      var thatWidth = that.x(d.endTime) - that.x(d.startTime);
      timelineSgidWidthMap.put([thatX, thatX + thatWidth], d.id);
      return thatWidth;
    },
    height: 28
  }).style({
    stroke: function stroke(d) {
      if (d.color == null || d.color == "null") {
        return "#999999";
      }
    },
    "stroke-dasharray": function strokeDasharray(d) {
      if (d.color == null || d.color == "null") {
        return "1, 3";
      }
    },
    "stroke-width": function strokeWidth(d) {
      if (d.color == null || d.color == "null") {
        return "1";
      }
    }
  });

  // var cancelGroup = this.cancelGroupEvents.selectAll('.event-bar').data(filteredData.filter(function (d){
  // 	return d.detectType === 'audio'
  // })).enter()
  // .append('rect').attr({
  // 	class: function(d) { return "event-bar audio"},
  // 	x: function(d) {
  // 		if(that.x(d.startTime).toString == "NaN"){
  //
  // 		}
  // 		if(parseInt(d.startTime) < serviceDateTime){
  // 			d.startTime = serviceDateTime;
  // 		}
  // 		if(that.x(d.startTime) < 40){
  // 			return 40;
  // 		}
  // 		return that.x(d.startTime);
  // 	},
  // 	y: 27,
  // 	i: function (d) { return d.index },
  // 	fill: function (d) {
  // 			if(d.color == null || d.color == "null"){
  // 				return "#929292";
  // 			}
  // 			return d.color
  // 		},
  // 	width: function(d) {
  // 		var thatX = that.x(d.startTime);
  // 		var thatWidth = that.x(d.endTime) - that.x(d.startTime);
  // 		timelineSgidWidthMap.put([thatX,thatX + (thatWidth)],d.id);
  // 		return thatWidth;
  // 	},
  // 	height: 36,
  // });

  var scales = this.payServiceEvents.selectAll(".event-bar").data(filteredData.filter(function (d) {
    return d.detectType === "scale";
  })).enter().append("rect").attr({
    "class": function _class(d) {
      return "event-bar " + d.detectType;
    },
    x: function x(d) {
      if (that.x(d.startTime).toString == "NaN") {}
      if (parseInt(d.startTime) < serviceDateTime) {
        d.startTime = serviceDateTime;
      }
      if (d.count < that.scaleAvg * 0.5) {
        return that.x(d.startTime) + 3;
      } else if (d.count < that.scaleAvg * 0.9) {
        return that.x(d.startTime) + 2.5;
      } else if (d.count >= that.scaleAvg * 0.9 && d.count <= this.scaleAvg * 1.1) {
        return that.x(d.startTime) + 2;
      } else if (d.count > that.scaleAvg * 1.5) {
        return that.x(d.startTime) + 1;
      } else {
        return that.x(d.startTime) + 1.5;
      }
    },
    y: 27,
    width: function width(d) {
      if (d.count < that.scaleAvg * 0.5) {
        return that.x(d.endTime) - that.x(d.startTime) - 6;
      } else if (d.count < that.scaleAvg * 0.9) {
        return that.x(d.endTime) - that.x(d.startTime) - 5;
      } else if (d.count >= that.scaleAvg * 0.9 && d.count <= this.scaleAvg * 1.1) {
        return that.x(d.endTime) - that.x(d.startTime) - 4;
      } else if (d.count > that.scaleAvg * 1.5) {
        return that.x(d.endTime) - that.x(d.startTime) - 2;
      } else {
        return that.x(d.endTime) - that.x(d.startTime) - 3;
      }
    },
    height: 38
  });
  var eventMouseover = function eventMouseover(d) {
    if (that.delegate != undefined && typeof that.delegate.cvrMouseoverEventsNew === "function") {
      that.delegate.cvrMouseoverEventsNew(d, this);
    }
  };
  var eventMouseout = function eventMouseout(d) {
    if (that.delegate != undefined && typeof that.delegate.mouseoutEvents === "function") {
      that.delegate.mouseoutEvents();
    }
  };
  var imageDraw = function imageDraw(d) {};
  var eventClick = function eventClick(d) {
    if (new Date().getTime() - that.previousDblClickTime < 500) return; // animating caused by dbl click.

    var selectedTime = new Date(parseInt(d.startTime));
    that.forceDomain = true;
    if (that.delegate != undefined && typeof that.delegate.clickedCVRArea === "function") {
      that.delegate.clickedCVRArea(selectedTime);
    }
    that.updateCursor(selectedTime);
  };
};
PosTimeline.prototype.domainCenterTime = function () {
  if (this.currentDomain !== undefined) {
    return (this.currentDomain[0] + this.currentDomain[1]) / 2 + (this.currentDomain[1] - this.currentDomain[0]) / 8;
  }
  return undefined;
};
PosTimeline.prototype.updateOpenClose = function (duration) {
  var that = this;
  var $q = this.$q;
  var deferred = $q.defer();
  if (duration === undefined) {
    duration = 500;
  }
  duration = duration * 2;
  this.svg.selectAll("image").transition().duration(duration).attr({
    x: function x(d) {
      return (that.x(d.startTime) + that.x(d.endTime)) / 2;
    },
    y: 20,
    width: 14,
    height: 18
  }).each("end", function () {
    deferred.resolve();
  });
  return deferred.promise;
};
PosTimeline.prototype.updateEvents = function (duration) {
  var that = this;
  var $q = this.$q;
  var deferred = $q.defer();
  if (duration === undefined) {
    duration = 500;
  }
  duration = duration * 2;
  if (this.eventData) {
    var filteredData = this.eventData.filter(function (d) {
      var checkData = checkFilters.get(d.index);
      if (checkData != undefined) {
        return d.startTime > that.removedBufferDomain[0] && d.endTime < that.removedBufferDomain[1];
      }
    });
  }
  this.svg.selectAll(".event-bar").transition().duration(duration).attr({
    x: function x(d) {
      if (that.x(d.startTime).toString == "NaN") {}
      if (parseInt(d.startTime) < serviceDateTime) {
        d.startTime = serviceDateTime;
      }
      return that.x(d.startTime);
    },
    y: 40,
    i: function i(d) {
      return d.index;
    },
    fill: function fill(d) {
      if (d.color == null || d.color == "null") {
        return "#f0f0f0";
      }
      return d.color;
    },
    width: function width(d) {
      var thatX = that.x(d.startTime);
      var thatWidth = that.x(d.endTime) - that.x(d.startTime);
      timelineSgidWidthMap.put([thatX, thatX + thatWidth], d.id);
      return thatWidth;
    },
    height: 28
  }).style({
    stroke: function stroke(d) {
      if (d.color == null || d.color == "null") {
        return "#999999";
      }
    },
    "stroke-dasharray": function strokeDasharray(d) {
      if (d.color == null || d.color == "null") {
        return "1, 3";
      }
    },
    "stroke-width": function strokeWidth(d) {
      if (d.color == null || d.color == "null") {
        return "1";
      }
    }
  }).each("end", function () {
    deferred.resolve();
  });
  return deferred.promise;
};
var recheck = 0;
PosTimeline.prototype.redrawEvents = function (events, avg) {
  if (changeTimeRangeClick == true) {
    var that = this;
    this.scaleAvg = avg;
    this.eventData = events;
    setTimeout(function () {
      $(".openClose").empty();
      $(".events").empty();
      // $(".cancelGroup").empty();
      $(".events").fadeIn(200);
      that.drawEvents();
      changeTimeRangeClick = false;
      thumnailViewFlag = true;
      removeWidthStop = false;
    }, 180);
  } else {
    this.scaleAvg = avg;
    this.eventData = events;
    $(".openClose").empty();
    $(".events").empty();
    // $(".cancelGroup").empty();
    this.drawEvents();
    removeWidthStop = false;
    changeTimeRangeClick = false;
    setTimeout(function () {
      $(".events").fadeIn(200);
    }, 180);
  }
};
PosTimeline.prototype.emptyData = function () {
  this.openClose.selectAll("img").remove();
  this.payServiceEvents.selectAll("rect").remove();
  // this.cancelGroupEvents.selectAll('rect').remove();
  this.scaleEvents.selectAll("rect").remove();
  this.cvrs.selectAll(".record-bar").remove();
};
PosTimeline.prototype.updateAxis = function (duration, flag) {
  var $q = this.$q;
  var that = this;
  var deferred = $q.defer();
  if (duration === undefined) {
    duration = 500;
  }
  this.axisContainer.selectAll(".date-tick-axis .tick rect").remove();
  if (flag == "drag") {
    var dateTickPromise = $q(function (resolve, reject) {
      that.svg.select(".date-tick-axis").transition().duration(duration).call(that.getDateTicks()).call(function () {
        var ticks = this.selectAll(".tick")[0];
        ticks.forEach(function (tick) {
          var textNode = $(tick).find("text");
          var text = textNode.text();
          var textWidth = textNode[0].getBoundingClientRect().width + 6;
          var locationX = -(textWidth / 2);
          if (text.length > 0) {
            d3.select(tick).insert("rect", "text").attr({
              x: locationX,
              y: 12,
              width: textWidth,
              height: 14,
              fill: "#555"
            });
          }
        });
        this.selectAll(".date-tick-axis .tick").attr("transform", adjustDateLocation.bind(that));
      });
    });
    var bigTickPromise = $q(function (resolve, reject) {
      that.svg.select(".big-tick-axis").transition().duration(duration).call(that.getBigTicks());
    });
    var tickPromise = $q(function (resolve, reject) {
      that.svg.select(".tick-axis").transition().duration(duration).call(that.getTicks()).each("end", function () {
        resolve();
      });
    });
    var smallTickPromise = $q(function (resolve, reject) {
      that.svg.select(".small-tick-axis").transition().duration(duration).call(that.getSmallTicks());
    });
    $q.all([dateTickPromise, bigTickPromise, tickPromise, smallTickPromise]).then(function () {
      deferred.resolve();
    });
    if (dragEndStatus == true) {
      setTimeout(function () {
        dragThumCancle = false;
      }, 380);
      dragEndStatus = false;
    } else {
      $(".events").fadeOut(150);
      $(".openClose").empty();
      $(".events").empty();
      // $(".cancelGroup").empty();
      setTimeout(function () {
        $(".events").fadeIn(200);
      }, 380);
      $("#timebar_area").hide();
      setTimeout(function () {
        $("#timebar_area").show();
      }, 90);
    }
    return deferred.promise;
  } else {
    var dateTickPromise = $q(function (resolve, reject) {
      that.svg.select(".date-tick-axis").transition().duration(duration).call(that.getDateTicks()).call(function () {
        var ticks = this.selectAll(".tick")[0];
        ticks.forEach(function (tick) {
          var textNode = $(tick).find("text");
          var text = textNode.text();
          var textWidth = textNode[0].getBoundingClientRect().width + 6;
          var locationX = -(textWidth / 2);
          if (text.length > 0) {
            d3.select(tick).insert("rect", "text").attr({
              x: locationX,
              y: 12,
              width: textWidth,
              height: 14,
              fill: "#555"
            });
          }
        });
        this.selectAll(".date-tick-axis .tick").attr("transform", adjustDateLocation.bind(that));
      });
    });
    var bigTickPromise = $q(function (resolve, reject) {
      that.svg.select(".big-tick-axis").transition().duration(duration).call(that.getBigTicks());
    });
    var tickPromise = $q(function (resolve, reject) {
      that.svg.select(".tick-axis").transition().duration(duration).call(that.getTicks()).each("end", function () {
        resolve();
      });
    });
    var smallTickPromise = $q(function (resolve, reject) {
      that.svg.select(".small-tick-axis").transition().duration(duration).call(that.getSmallTicks()).each("end", function () {
        resolve();
      });
    });
    $q.all([dateTickPromise, bigTickPromise, tickPromise, smallTickPromise]).then(function (a, b) {
      deferred.resolve();
    });
    return deferred.promise;
  }
};
PosTimeline.prototype.updateBar = function (duration) {
  var that = this;
  var $q = this.$q;
  var deferred = $q.defer();
  if (duration === undefined) {
    duration = 0;
  }
  this.svg.selectAll(".record-bar").transition().duration(duration).attr({
    x: function x(d) {
      if (that.x(d.startTime).toString == "NaN") {}
      if (parseInt(d.startTime) < serviceDateTime) {
        d.startTime = serviceDateTime;
      }
      var thatX = that.x(d.startTime);
      return thatX;
    },
    width: function width(d) {
      thatEnd = that.x(d.endTime);
      thatStart = that.x(d.startTime);
      thatWidth = thatEnd - thatStart;
      if (thatWidth < 0) {
        thatWidth = 0;
      }
      return thatWidth;
    }
  }).each("end", function () {
    deferred.resolve();
  });
  return deferred.promise;
};
PosTimeline.prototype.hideCursor = function () {
  this.svg.select(".cursor").classed("hide", true);
};
PosTimeline.prototype.showCursor = function () {
  this.svg.select(".cursor").classed("hide", false);
};
"use strict";

app.controller("SettingsFirmwareCtrl", ["$scope", "$rootScope", "Camera", function ($scope, $rootScope, Camera) {
  $scope.isLoading = true;
  $scope.cameraListShow = false;
  var cameraFirmwareToggle = null;
  function getCameraFirmwareSetting() {
    return localStorage.getItem("biz-camera-firmware-update-" + $rootScope.me.userId);
  }
  function setCameraFirmwareSetting(value) {
    localStorage.setItem("biz-camera-firmware-update-" + $rootScope.me.userId, value);
  }
  function createFirmwareToggle(id, value, handler) {
    var toggle = tCam.toggle(id);
    toggle.value = value;
    if (handler) {
      toggle.on("changed", handler);
    }
    return toggle;
  }
  function fetchCameraList() {
    $scope.isLoading = true;
    Camera.getListV3(function (data) {
      $scope.cameraListShow = (data.cameras || []).length > 0;
      $scope.isLoading = false;
    }, function () {
      $scope.isLoading = false;
    });
  }
  function init() {
    if (cameraFirmwareToggle) {
      return;
    }
    cameraFirmwareToggle = createFirmwareToggle("camera-firmware-toggle", getCameraFirmwareSetting() !== "false", function (event) {
      setCameraFirmwareSetting(event.value ? "true" : "false");
    });
  }
  $rootScope.$watch("me", function (value) {
    init();
  });
  if ($rootScope.me && $rootScope.me.userId) {
    init();
  }
  fetchCameraList();
  $scope.$on("$destroy", function () {
    if (cameraFirmwareToggle) {
      cameraFirmwareToggle.destroy();
      cameraFirmwareToggle = null;
    }
  });
}]);
"use strict";

app.controller("SettingsCtrl", ["$scope", "$rootScope", "$interval", "$state", "$translate", function ($scope, $rootScope, $interval, $state, $translate) {
  $scope.$on("$destroy", function () {});
  $scope.init = function () {};
  $scope.init();
}]);
"use strict";

app.controller("SettingsMenuCtrl", ["$scope", "$rootScope", "$location", "$state", "$translate", "$window", "User", function ($scope, $rootScope, $location, $state, $translate, $window, User) {
  $scope.getPath = $location.path();
  $scope.countryDomain = $rootScope.countryDomain;
  $scope.isSignOut = false;
  $scope.isSignOutSuccess = false;
  $rootScope.$watch("countryDomain", function () {
    $scope.countryDomain = $rootScope.countryDomain;
  });
  $scope.clickMenu = function (state) {
    $state.go(state, {}, {
      reload: state,
      inherit: true,
      notify: true
    });
  };
  $window.signOutCheckCallback = function () {
    $scope.isSignOut = !$scope.isSignOut;
    $scope.$apply();
  };
  $scope.signOut = function () {
    $scope.isLoading = true;
    User.signOut(function (data) {
      $scope.isLoading = false;
      if (data.code == "ok") {
        $scope.isSignOut = !$scope.isSignOut;
        $scope.isSignOutSuccess = !$scope.isSignOutSuccess;
      } else {
        $rootScope.createConfirm({
          title: $translate.instant("USER_DELETE_CONFIRM"),
          description: $translate.instant("ACCESS_FAIL"),
          btnCount: 1
        });
      }
    }, function (error) {
      $scope.isLoading = false;
      location.href = "/error";
    });
  };
  $scope.signOutConfirm = function () {
    $window.location.href = "/";
  };
  $scope.signOutCheck = function () {
    var url,
      httpUrl = location.origin;
    if (httpUrl == undefined) {
      httpUrl = location.protocol + "//" + location.hostname;
    }
    if ($rootScope.me && $rootScope.me.country === "JP") {
      url = "/checkpw?nextUrl=signout";
      window.open(url, "checkpw", "scrollbars=yes,toolbar=no,resizable=yes,width=420,height=538,left=600,top=200");
    } else {
      url = paycoUrl + "login.nhn?m=bridge&client_id=" + ci + "&access_token=" + encodeURIComponent(at) + "&nextUrl=" + encodeURIComponent(paycoUrl + "auth/confirmPwd.nhn?serviceProviderCode=BIZCAM&reason=CONFIRM_PWD&treatmentUrl=" + httpUrl + "/signout?deviceType=web&userLocale=ko_KR");
      openInfoWin(url, "popup", 630, 560); // window.open
    }
  };
}]);
"use strict";

app.controller("SettingsPlayCtrl", ["$scope", "$rootScope", function ($scope, $rootScope) {
  var playToggle = null;
  function getPlayLimitSetting() {
    return localStorage.getItem("biz-play-limit-" + $rootScope.me.userId);
  }
  function setPlayLimitSetting(value) {
    localStorage.setItem("biz-play-limit-" + $rootScope.me.userId, value);
  }
  function createPlayToggle(id, value, handler) {
    var toggle = tCam.toggle(id);
    toggle.value = value;
    if (handler) {
      toggle.on("changed", handler);
    }
    return toggle;
  }
  playToggle = createPlayToggle("play-set-toggle", getPlayLimitSetting() !== "false", function (event) {
    setPlayLimitSetting(event.value ? "true" : "false");
  });
  $scope.$on("$destroy", function () {
    if (playToggle) {
      playToggle.destroy();
      playToggle = null;
    }
  });
}]);
"use strict";

app.controller('SettingsPolicyCtrl', ['$scope', '$rootScope', '$interval', '$state', '$translate', 'User', function ($scope, $rootScope, $interval, $state, $translate, User) {
  $scope.countryDomain = window.country;
  $scope.isAgree = false;
  function fetchAgree() {
    User.me(function (data) {
      if (data && data.lbsAgreed === "ok") {
        $scope.isAgree = true;
      } else {
        $scope.isAgree = false;
      }
    }, function (error) {
      $scope.isAgree = false;
      $rootScope.createConfirm({
        title: $translate.instant('ACCESS_NET_FAIL'),
        description: $translate.instant('ACCESS_NET_FAIL_DESC'),
        btnCount: 1
      });
    });
  }
  $scope.togglePositionTerm = function () {
    var toggleVal = $scope.isAgree ? "nok" : "ok";
    var param = {
      isAgreed: toggleVal
    };
    User.lbsAgree(param, function (data) {
      if (data.code !== 'ok') {
        $rootScope.createConfirm({
          title: $translate.instant('FAIL'),
          description: $translate.instant('ACCESS_SET_FAIL'),
          btnCount: 1
        });
      } else {
        $scope.isAgree = toggleVal === 'ok';
      }
    }, function (error) {
      $rootScope.createConfirm({
        title: $translate.instant('ACCESS_NET_FAIL'),
        description: $translate.instant('ACCESS_NET_FAIL_DESC'),
        btnCount: 1
      });
    });
  };
  $scope.positionTermDetail = function () {
    var httpUrl = location.origin;
    if (httpUrl == undefined) {
      httpUrl = location.protocol + "//" + location.hostname;
    }
    var url;
    if ($scope.countryDomain === 'ja') {
      url = httpUrl + "/#/positionTermsJP";
    } else {
      url = httpUrl + "/#/positionTerms";
    }
    openInfoWin(url, "popup", 630, 560, "yes"); // window.open
  };
  fetchAgree();
  $scope.$on('$destroy', function () {});
}]);
"use strict";

app.controller("SettingsProductCtrl", ["$scope", "$rootScope", "$state", "$translate", "$q", "$timeout", "Camera", "Monitor", "User", "Utils", function ($scope, $rootScope, $state, $translate, $q, $timeout, Camera, Monitor, User, Utils) {
  $scope.selectedTab = "camera"; //service
  $scope.isLoading = false;
  $scope.cameras = [];
  $scope.countryDomain = window.country;
  $scope.useCloudMonitor = false;
  $scope.useAiFaceDetect = false;
  $scope.useAiPeopleCount = false;
  $scope.isShowAgingLayer = false;

  // ! 서비스 만료일
  $scope.saveEndDateText = "";
  $scope.saveEndDate = 0;
  $scope.disaplySaveEndDate = "";
  $scope.displaySaveEndDateTimeout = 0;

  // ! 동영상 삭제 요청일
  $scope.hasLastAgingDate = false;
  $scope.lastAgingDate = 0;
  $scope.displayLastAgingDate = "";
  $scope.isAgingDone = false;
  $scope.isShowAgingConfirmLayer = false;

  // ! toast message
  $scope.toast = {
    hasToast: false,
    message: "",
    timeout: 0
  };
  var TIME_DELIMTER = {
    MINUTE: 1000 * 60,
    HOUR: 1000 * 60 * 60,
    DAY: 1000 * 60 * 60 * 24
  };
  var TIME_MESSAGES = {
    MINUTE: $translate.instant("5mw2slvk_02264"),
    // {MM}분
    HOUR: $translate.instant("5mw2slvk_02263"),
    // {HH}시
    DAY: $translate.instant("5mw2slvk_02262") // {DD}일
  };
  $scope.isCountryJA = function () {
    return ($scope.countryDomain || window.country) === "ja";
  };
  $scope.setDisplaySaveEndDate = function () {
    var diff = +new Date($scope.saveEndDate) - +new Date();
    var minute = Math.floor(diff / TIME_DELIMTER.MINUTE);
    var hour = Math.floor(diff / TIME_DELIMTER.HOUR);
    var day = Math.floor(diff / TIME_DELIMTER.DAY);
    var display = [];
    if (day) {
      display.push(TIME_MESSAGES.DAY.replace("{DD}", day)); // {DD}일
    }
    if (hour) {
      hour = hour > 24 ? hour % 24 : hour;
      display.push(TIME_MESSAGES.HOUR.replace("{HH}", hour)); // {HH}시
    }
    if (minute) {
      minute = minute > 60 ? minute % 60 : minute;
      display.push(TIME_MESSAGES.MINUTE.replace("{MM}", minute)); // {MM}분
    }
    $scope.disaplySaveEndDate = display.join(" ");
    $scope.displaySaveEndDateTimeout = $timeout(function () {
      $scope.setDisplaySaveEndDate();
    }, 1000 * 1);
  };
  $scope.showToastMessage = function (message) {
    $scope.toast.message = message;
    $scope.toast.hasToast = true;
    if ($scope.toast.timeout) {
      $timeout.cancel($scope.toast.timeout);
    }
    $scope.toast.timeout = $timeout(function () {
      $scope.toast.hasToast = false;
      $scope.toast.message = "";
    }, 1000 * 3);
  };
  $scope.selectTab = function (tab) {
    $scope.selectedTab = tab;
    if ($scope.selectedTab === "camera") {
      fetchCameraList();
    } else if ($scope.selectedTab === "service") {
      fetchServiceInfo();
    }
  };
  $scope.showAiFaceBetaDlg = function () {
    $scope.selectedAccount = {
      userId: $rootScope.me.userId
    };
    $scope.isShowAiFaceServiceRegDialog = true;
  };
  $scope.getCameraProductStr = function (camera) {
    if (!camera.cloud) {
      return $translate.instant("5mw2slvk_02197");
    }
    if (camera.recorderType === "recorder") {
      return $translate.instant("5mw2slvk_02198");
    }
    var productStr = camera.recordType === "event" ? $translate.instant("9rRqk7Vo_01844") : $translate.instant("CLOUD_STORE");
    productStr += " " + parseInt(camera.serviceType, 10) + $translate.instant("DATE_DATE");
    return productStr;
  };
  $scope.hideCameraCloudInfo = function () {
    $timeout.cancel($scope.displaySaveEndDateTimeout);
    $scope.isShowCamCloudInfo = false;
    $scope.toast.hasToast = false;
  };
  $scope.goToInqueryPage = function () {
    if ($scope.isCountryJA()) {
      // $scope.showToastMessage($translate.instant('5mw2slvk_02247'));
      // $state.go('main.help.inquiry');

      $state.go("main.help.customerCenter");
    } else {
      $state.go("main.help.inquiry", {
        type: "cam_cancel"
      });
    }
  };
  $scope.showCameraCloudInfo = function (camera, callBack) {
    $scope.currentCamera = camera;
    $scope.serviceDay = parseInt($scope.currentCamera.serviceType, 10);

    // ! 카메라 정보 조회
    Camera.getCamera({
      cameraId: camera.id
    }, function (data) {
      $scope.hasLastAgingDate = !!data.lastAgingDate && data.lastAgingDate !== -100;
      $scope.lastAgingDate = $scope.hasLastAgingDate ? data.lastAgingDate : "";
      $scope.displayLastAgingDate = moment(new Date($scope.lastAgingDate)).format("YYYY.MM.DD. HH:mm");
      // ! agingDate 없거나 <= 0 완료 , agingDate > 0 미완료
      $scope.isAgingDone = (data.agingDate || 0) <= 0;
      if (callBack && typeof callBack === "function") {
        callBack();
      }
    });

    // ! 카메라 - 서비스 만료일 조회
    Camera.saveEndDateInfo({
      cameraId: camera.id
    }, function (data) {
      $scope.toast.hasToast = false;
      $scope.saveEndDateText = data.saveEndDateText;
      $scope.saveEndDate = data.saveEndDate;
      $scope.isShowCamCloudInfo = true;
      $timeout.cancel($scope.displaySaveEndDateTimeout);
      $scope.setDisplaySaveEndDate();
      if (callBack && typeof callBack === "function") {
        callBack();
      }
    });
  };
  $scope.showPurchaseConfirmLayer = function () {
    if ($scope.isCountryJA()) {
      // $scope.showToastMessage($translate.instant('5mw2slvk_02247'));
      // $state.go('main.help.inquiry');

      $state.go("main.help.customerCenter");
    } else {
      $state.go("main.help.inquiry", {
        type: "cam_buy"
      });
    }
  };

  // ! 녹화 영상 초기화
  $scope.showAgingLayer = function () {
    $scope.isShowCamCloudInfo = false;
    $scope.isShowAgingLayer = true;
  };
  $scope.hideAgingLayer = function () {
    $scope.isShowAgingLayer = false;
  };
  $scope.agingBackStep = function () {
    $scope.hideAgingLayer();
    $scope.isShowCamCloudInfo = true;
  };

  // ! 삭제 확인 컨펌
  $scope.showAgingConfirmLayer = function () {
    $scope.isShowAgingConfirmLayer = true;
  };
  $scope.hideAginConfirmlayer = function () {
    $scope.isShowAgingConfirmLayer = false;
  };
  $scope.confirmAging = function () {
    // ! 두번째 파라미터에 {} 를 넘겨야, url :cameraId 에 cameraId 가 치환됨
    Camera.requestCameraAging({
      cameraId: $scope.currentCamera.id
    }, {}, function () {
      $scope.hideAginConfirmlayer();

      // ! 삭제 요청 후, 정보 갱신 처리
      $scope.showCameraCloudInfo($scope.currentCamera, function () {
        $scope.showAgingLayer();
      });
    }, function () {
      $rootScope.createConfirm({
        title: $translate.instant("ACCESS_NET_FAIL"),
        description: $translate.instant("ACCESS_NET_FAIL_DESC"),
        btnCount: 1
      });
      $scope.hideAginConfirmlayer();
    });
  };
  function getDayText(timestamp) {
    var d = new Date(timestamp);
    var year = d.getFullYear();
    var month = d.getMonth() + 1;
    var date = d.getDate();
    if (month < 10) {
      month = "0" + month;
    }
    if (date < 10) {
      date = "0" + date;
    }
    return year + "." + month + "." + date;
  }
  function fetchCameraList() {
    $scope.isLoading = true;
    Camera.getListV3(function (data) {
      var cameras = data.cameras;
      if (cameras && cameras.length) {
        $scope.cameras = [];
        cameras.forEach(function (item) {
          var camera = item.camera;
          camera.isExpiredCloud = Utils.isCloudExpired(camera);
          if (camera.saveEndDate) {
            camera.saveEndDateText = getDayText(camera.saveEndDate);
          }
          $scope.cameras.push(camera);
        });
      } else {
        $scope.cameras = [];
      }
      $scope.isLoading = false;
    }, function () {
      $scope.isLoading = false;
    });
  }
  function fetchServiceInfo() {
    var userPromise = User.me().$promise;
    var monitorPromise = Monitor.api.getInfo().$promise;
    $scope.isLoading = true;
    $q.all([userPromise, monitorPromise]).then(function (res) {
      var userRes = res[0];
      var monitorRes = res[1];
      $scope.useAiPeopleCount = userRes.code === "ok" ? userRes.useAiPeopleCount : false;
      $scope.useAiFaceDetect = userRes.code === "ok" ? userRes.useAiFaceDetect : false;
      $scope.useCloudMonitor = monitorRes.code === "ok" ? monitorRes.isCloudMonitorUser : false;
      if ($scope.useCloudMonitor) {
        $scope.monitorEndDate = getDayText(monitorRes.cloudMonitorServiceEndDate);
      }
      $scope.isLoading = false;
    }, function (err) {
      $rootScope.createConfirm({
        title: $translate.instant("ACCESS_NET_FAIL"),
        description: $translate.instant("ACCESS_NET_FAIL_DESC"),
        btnCount: 1
      });
      $scope.isLoading = false;
    });
  }
  fetchCameraList();
  $scope.$on("$destroy", function () {
    $timeout.cancel($scope.displaySaveEndDateTimeout);
  });
}]);
"use strict";

app.controller("DashboardAiShopCtrl", ["$scope", "$state", "$stateParams", "$rootScope", "$translate", "Shop", function ($scope, $state, $stateParams, $rootScope, $translate, Shop) {
  $scope.isSavePossible = true;
  $scope.aiCams = [];
  $scope.shopObject = null;
  $scope.aiStartTime = {
    hour: "00",
    min: "00"
  };
  $scope.aiEndTime = {
    hour: "00",
    min: "00"
  };
  $scope.isPeopleZoneNotComplete = false;
  var aiShopCopy = createAiShopCopy();
  $scope.aiCamCountInfo = {
    people: 0,
    face: 0,
    none: 0
  };
  function createAiShopCopy() {
    return {
      aiStartTime: {
        hour: "00",
        min: "00"
      },
      aiEndTime: {
        hour: "00",
        min: "00"
      },
      is24Hours: false,
      employeeCount: null,
      maxPeopleCount: null,
      maxTableCount: null,
      shopSize: null
    };
  }
  function getAiCameraCount(cameras) {
    var countInfo = {
      people: 0,
      face: 0,
      none: 0
    };
    cameras.forEach(function (item) {
      var _item$cameraInfo;
      if ((_item$cameraInfo = item.cameraInfo) !== null && _item$cameraInfo !== void 0 && _item$cameraInfo.isAiSupport) {
        switch (item.cameraInfo.aiType) {
          case 3:
            countInfo.people += 1;
            countInfo.face += 1;
            break;
          case 2:
            countInfo.face += 1;
            break;
          case 1:
            countInfo.people += 1;
            break;
          default:
            countInfo.none += 1;
            break;
        }
      }
    });
    return countInfo;
  }
  function fetchCameras() {
    $scope.isLoadCams = true;
    Shop.dashboardShopV4({
      shopId: $stateParams.shopId
    }).$promise.then(function (res) {
      var _res$shop;
      $scope.shopObject = res.shop;
      $scope.shopName = res.shop.shopName;
      if ((_res$shop = res.shop) !== null && _res$shop !== void 0 && _res$shop.controllerList) {
        $scope.aiCamCountInfo = getAiCameraCount(res.shop.controllerList);
      }
    })["catch"](function (err) {
      showErrorDialog("ACCESS_NET_FAIL", "ACCESS_NET_FAIL_DESC");
    })["finally"](function () {
      $scope.isLoadCams = false;
    });
  }
  function showErrorDialog(titleKey, descriptionKey) {
    $rootScope.createConfirm({
      title: $translate.instant(titleKey),
      description: $translate.instant(descriptionKey),
      btnCount: 1
    });
  }
  $scope.showAiCamModeSetDlg = function () {
    $scope.isShowAiCamModeSetDialog = true;
  };
  $scope.showAiCamAddDlg = function () {
    $scope.isShowAiCamAddDialog = true;
  };
  document.body.classList.add("wide_scroll");
  $scope.$on("showAiCamAddDlg", function (event, data) {
    $scope.showAiCamAddDlg();
  });
  $scope.$on("updateShop", function (event, data) {
    getAiShopSetting($stateParams.shopId);
    fetchCameras();
  });
  $scope.$on("$destroy", function () {
    $rootScope.destroyConfirm();
    document.body.classList.remove("wide_scroll");
  });
  $scope.goShopConfirm = function () {
    $scope.goShop();
  };
  $scope.goShop = function () {
    var targetShop = {
      shopId: $stateParams.shopId,
      myShop: true
    };
    $state.go("main.dashboard.shop", {
      shop: JSON.stringify(targetShop)
    }, {
      reload: "main.dashboard.shop"
    });
  };
  $scope.saveSetting = function () {
    if (!$scope.aiShop) {
      return;
    }
    $scope.aiShop.openTime = convertToServerTime($scope.aiStartTime);
    $scope.aiShop.closeTime = convertToServerTime($scope.aiEndTime);
    var settingData = {
      openTime: $scope.aiShop.openTime,
      closeTime: $scope.aiShop.closeTime,
      is24Hours: $scope.aiShop.is24Hours
    };
    var countValidate = function countValidate(value) {
      if (value && typeof value === "string" && !/\D/.test(value)) {
        value = Number(value);
      }
      return typeof value === "number" && value >= 0;
    };
    if (countValidate($scope.aiShop.employeeCount)) {
      settingData.employeeCount = $scope.aiShop.employeeCount;
    }
    if (countValidate($scope.aiShop.maxPeopleCount)) {
      settingData.maxPeopleCount = $scope.aiShop.maxPeopleCount;
    }
    if (countValidate($scope.aiShop.maxTableCount)) {
      settingData.maxTableCount = $scope.aiShop.maxTableCount;
    }
    if (countValidate($scope.aiShop.shopSize)) {
      settingData.shopSize = $scope.aiShop.shopSize;
    }
    Shop.setAiShopSetting({
      shopId: $stateParams.shopId
    }, settingData, function (res) {
      if (res.code === "ok") {
        getAiShopSetting($stateParams.shopId);
      } else {
        showAlert($translate.instant("9rRqk7Vo_01874"), $translate.instant("ACCESS_SET_FAIL"));
      }
    }, function (error) {
      showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
    });
  };
  function getAiShopSetting(shopId) {
    Shop.getAiShopSetting({
      shopId: shopId
    }).$promise.then(function (response) {
      if (response.aiCameras) {
        response.aiCameras = response.aiCameras.filter(function (camera) {
          return camera.camera.aiType === 1 || camera.camera.aiType === 3;
        });
        $scope.isPeopleZoneNotComplete = response.aiCameras.some(function (camera) {
          return camera.peopleZoneCount < 1;
        });
        $rootScope.isSetAiZone = response.aiCameras.some(function (camera) {
          return camera.peopleZoneCount > 0 || camera.tableZoneCount > 0;
        });
      }
      $scope.aiShop = response;
      $scope.aiStartTime = converToInputTime($scope.aiShop.openTime);
      $scope.aiEndTime = converToInputTime($scope.aiShop.closeTime);
      aiShopCopy = {
        aiStartTime: {
          hour: $scope.aiStartTime.hour,
          min: $scope.aiStartTime.min
        },
        aiEndTime: {
          hour: $scope.aiEndTime.hour,
          min: $scope.aiEndTime.min
        },
        is24Hours: $scope.aiShop.is24Hours,
        employeeCount: $scope.aiShop.employeeCount,
        maxPeopleCount: $scope.aiShop.maxPeopleCount,
        maxTableCount: $scope.aiShop.maxTableCount,
        shopSize: $scope.aiShop.shopSize
      };
      $scope.checkSavePossible();
    }, function (err) {});
  }
  $scope.inputOnlyNumber = function (e) {
    var isTabKey = e.key.toUpperCase() === "TAB" || e.keyCode === 9 || e.which === 9;
    var target = e.currentTarget;
    if (isTabKey) {
      return;
    }
    target.value = target.value.replace(/\D/g, "");
  };
  $scope.checkSavePossible = function () {
    var getValidValue = function getValidValue(value) {
      if (value && typeof value === "string" && !/\D/.test(value)) {
        value = Number(value);
      }
      return typeof value === "number" && value >= 0 ? value : null;
    };
    if ($scope.aiStartTime.hour !== aiShopCopy.aiStartTime.hour || $scope.aiStartTime.min !== aiShopCopy.aiStartTime.min || $scope.aiEndTime.hour !== aiShopCopy.aiEndTime.hour || $scope.aiEndTime.min !== aiShopCopy.aiEndTime.min || $scope.aiShop.is24Hours !== aiShopCopy.is24Hours || getValidValue($scope.aiShop.employeeCount) !== getValidValue(aiShopCopy.employeeCount) || getValidValue($scope.aiShop.maxPeopleCount) !== getValidValue(aiShopCopy.maxPeopleCount) || getValidValue($scope.aiShop.maxTableCount) !== getValidValue(aiShopCopy.maxTableCount) || getValidValue($scope.aiShop.shopSize) !== getValidValue(aiShopCopy.shopSize)) {
      $scope.isSavePossible = true;
    } else {
      $scope.isSavePossible = false;
    }
  };
  function converToInputTime(serverTime) {
    var hour, min;
    serverTime = Math.ceil(serverTime / (60 * 1000));
    hour = Math.floor(serverTime / 60);
    hour = hour < 10 ? "0" + hour : "" + hour;
    min = serverTime % 60;
    min = min < 10 ? "0" + min : "" + min;
    return {
      hour: hour,
      min: min
    };
  }
  function convertToServerTime(inputTime) {
    var hour, min;
    hour = parseInt(inputTime.hour);
    min = parseInt(inputTime.min);
    return (hour * 60 + min) * 60 * 1000;
  }
  $scope.goPeopleDetail = function (cameraId) {
    $state.go("main.aiZoneSet", {
      cameraId: cameraId,
      type: "shop",
      id: $stateParams.shopId,
      peopleZone: true
    });
  };
  $scope.goSeatDetail = function (cameraId) {
    $state.go("main.aiZoneSet", {
      cameraId: cameraId,
      type: "shop",
      id: $stateParams.shopId,
      seatZone: true
    });
  };
  function showAlert(title, message) {
    $scope.showAlert = true;
    $scope.alertTitle = title;
    $scope.alertMessage = message;
  }
  $scope.hideAlert = function () {
    $scope.showAlert = false;
  };
  if ($stateParams.shopId) {
    $scope.shopId = $stateParams.shopId;
    getAiShopSetting($stateParams.shopId);
    fetchCameras();
  }
}]);
"use strict";

app.controller("DashboardCameraCtrl", ["$scope", "$state", "$stateParams", "Shop", function ($scope, $state, $stateParams, Shop) {
  var isShare = false;
  $scope.currentCamera = {};
  $scope.isCameraSettingOpen = false;
  function getCameras(shopObj) {
    var cameras = [];
    if (!shopObj || !shopObj.controllerList) {
      return cameras;
    }
    shopObj.controllerList.forEach(function (controller) {
      if (controller.deviceType === "CAMERA") {
        cameras.push(controller.cameraInfo);
      }
    });
    return cameras;
  }
  function getShop(shopId) {
    Shop.getShopV2({
      shopId: shopId
    }, function (res) {
      if (res.code === "nok") {
        Shop.getSharedShopV2({
          shopId: shopId
        }, function (res) {
          $scope.shop = res;
          $scope.shop.cameras = getCameras($scope.shop);
          isShare = true;
        }, function (error) {});
      } else {
        $scope.shop = res;
        $scope.shop.cameras = getCameras($scope.shop);
      }
    }, function (error) {});
  }
  $scope.settingOpenCallback = function (_ref) {
    var isOpen = _ref.isOpen,
      cameraData = _ref.cameraData,
      isShared = _ref.isShared;
    $scope.$apply(function () {
      $scope.isCameraSettingOpen = isOpen;
      $scope.currentCamera = cameraData;
      angular.extend($scope.currentCamera, {
        isShared: isShared
      });
    });
  };
  $scope.goDetail = function (cameraId) {
    $state.go("main.cameraDetail", {
      cameraId: cameraId,
      type: isShare ? "sharedshop" : "shop",
      id: $stateParams.shopId,
      shared: isShare
    });
  };
  if ($stateParams.shopId) {
    getShop($stateParams.shopId);
  }
}]);
"use strict";

function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
app.controller("DashboardEventCtrl", ["$scope", "$stateParams", "Shop", "$translate", "$q", "$state", "Utils", function ($scope, $stateParams, Shop, $translate, $q, $state, Utils) {
  $scope.eventListByHour = [];
  $scope.filterList = [];
  $scope.isShowEventFilterDialog = true;
  $scope.shopEventLength = 0;
  $scope.firstShowTimeIndex = -1;
  $scope.selectedEventId = $stateParams.eventId;
  $scope.selectedEventRegDate = $stateParams.regDate;
  $scope.isLoadingEvent = true;
  $scope.isFilterLoading = false;
  $scope.countryDomain = window.country;
  $scope.allFilterOn = true;
  $scope.filterTranslate = {
    CAMERA_SOUND: $translate.instant("5mw2slvk_02288"),
    CAMERA_MOTION: $translate.instant("STR_CAMERA_MOVEMENT"),
    SENSOR_TEMP: $translate.instant("STR_TEMP_SENSOR"),
    SENSOR_HUMID: $translate.instant("STR_HUMID_SENSOR"),
    SENSOR_MOTION: $translate.instant("STR_MOVE_SENSOR"),
    SENSOR_MAGNETIC: $translate.instant("STR_DOOR_SENSOR"),
    SENSOR_SMOKE: $translate.instant("STR_SMOKE_SENSOR"),
    SENSOR_GAS: $translate.instant("STR_GAS_SENSOR"),
    SENSOR_PLUG: $translate.instant("STR_PLUG_SENSOR"),
    DOORLOCK_EVENT: $translate.instant("STR_MAIN_BIZ_44"),
    ALARM_CONFIG: $translate.instant("STR_ALARM_CONFIG_SET")
  };
  $scope.tempCameraFilterList = [];
  $scope.tempFilterList = [];
  $scope.tempAlarmFilterList = [];
  var curDateStr = "";
  var SHOP_EVENT_FILTER_LIST_KEY = "SHOP_EVENT_FILTER_LIST_KEY_" + $stateParams.shopId;
  function getDateString(timestamp) {
    var dateObj = timestamp ? new Date(parseInt(timestamp, 10)) : new Date();
    var date = String(dateObj.getDate()).padStart(2, "0");
    var month = String(dateObj.getMonth() + 1).padStart(2, "0");
    var year = dateObj.getFullYear();
    return "".concat(year).concat(month).concat(date);
  }
  function getShopEventWithDate(dateStr) {
    var filter = "";
    if ($scope.filterList && $scope.filterList.length) {
      $scope.filterList.forEach(function (filterItem) {
        if (filterItem.checked) {
          filter += filterItem.shopEventType + ",";
        }
      });
    }
    var checkCount = $scope.filterList.filter(function (item) {
      return item.checked;
    }).length;
    if (checkCount > 0) {
      $scope.isLoadingEvent = true;
      if (checkCount === $scope.filterList.length) {
        filter = "";
      }
      Shop.dashboardShopEvents({
        shopId: $stateParams.shopId,
        date: dateStr,
        filter: filter
      }, function (res) {
        if (res.shopEvents) {
          $scope.eventListByHour = Array.from({
            length: 24
          }, function (_, i) {
            var time = i < 10 ? "0".concat(i) : "".concat(i);
            var nextTime = i + 1 < 10 ? "0".concat(i + 1) : "".concat(i + 1);
            return {
              time: "".concat(time, ":00~").concat(nextTime, ":00"),
              events: []
            };
          });
          $scope.shopEventLength = res.shopEvents.length;
          res.shopEvents.forEach(function (event) {
            if (event.detectTime.length > 1) {
              var hourKey = parseInt(event.detectTime.slice(0, 2), 10);
              $scope.eventListByHour[hourKey].events.push(event);
            }
          });
          $scope.eventListByHour.reverse(); // To show reverse time

          var findEvent = function findEvent(eventProp, value) {
            return $scope.eventListByHour.findIndex(function (hourlyEvents) {
              return hourlyEvents.events.some(function (event) {
                return event[eventProp] === value;
              });
            });
          };
          $scope.firstShowTimeIndex = -1;
          if ($scope.selectedEventId) {
            $scope.firstShowTimeIndex = findEvent("eventId", $scope.selectedEventId);
          } else if ($scope.selectedEventRegDate) {
            $scope.firstShowTimeIndex = findEvent("regDate", $scope.selectedEventRegDate);
          }
          if ($scope.firstShowTimeIndex === -1) {
            $scope.firstShowTimeIndex = $scope.eventListByHour.findIndex(function (hourlyEvents) {
              return hourlyEvents.events.length;
            });
          }
          $scope.isLoadingEvent = false;
        }
      }, function (error) {
        $scope.isLoadingEvent = false;
      });
    } else {
      $scope.isLoadingEvent = false;
      $scope.eventListByHour = [];
      $scope.shopEventLength = 0;
      $scope.$apply();
    }
  }
  function initCalendar() {
    var dateObj;
    if ($stateParams.regDate) {
      dateObj = new Date(parseInt($stateParams.regDate, 10));
    } else {
      dateObj = new Date();
    }
    $scope.selectDate = dateObj;
    $scope.timelineDatePicker = new Pikaday({
      field: document.getElementById("timelineDate"),
      container: document.getElementById("calendarContainer"),
      format: $translate.instant("CLIP_CREATE_CLIP_DATE_FORMAT"),
      maxDate: new Date(),
      defaultDate: dateObj,
      position: "bottom right",
      onSelect: function onSelect(date) {
        $scope.selectDate = date;
        $scope.eventListByHour = [];
        curDateStr = this.getMoment().format("YYYYMMDD");
        $scope.selectedEventId = null;
        getShopEventWithDate(curDateStr);
      }
    });
  }
  function getEventFilterList() {
    var deferred = $q.defer();
    $scope.isFilterLoading = true;
    Shop.dashboardShopEventFilters({
      shopId: $stateParams.shopId
    }, function (res) {
      var _res$filter;
      if ((_res$filter = res.filter) !== null && _res$filter !== void 0 && _res$filter.length) {
        $scope.filterList = res.filter;
        var storageFilterList = function () {
          try {
            return JSON.parse(localStorage.getItem(SHOP_EVENT_FILTER_LIST_KEY)) || {};
          } catch (error) {
            void 0;
            return {};
          }
        }();
        $scope.tempCameraFilterList = [];
        $scope.tempAlarmFilterList = [];
        $scope.tempFilterList = [];
        $scope.filterList.forEach(function (filterItem) {
          var _storageFilterList$fi;
          filterItem.checked = (_storageFilterList$fi = storageFilterList === null || storageFilterList === void 0 ? void 0 : storageFilterList[filterItem.shopEventType]) !== null && _storageFilterList$fi !== void 0 ? _storageFilterList$fi : true;
          switch (filterItem.shopEventType) {
            case "CAMERA_SOUND":
            case "CAMERA_MOTION":
              $scope.tempCameraFilterList.push(filterItem);
              break;
            case "ALARM_CONFIG":
              $scope.tempAlarmFilterList.push(filterItem);
              break;
            default:
              $scope.tempFilterList.push(filterItem);
          }
        });
      } else {
        $scope.filterList = [];
        $scope.tempCameraFilterList = [];
        $scope.tempAlarmFilterList = [];
        $scope.tempFilterList = [];
      }
      $scope.isFilterLoading = false;
      deferred.resolve();
    }, function (error) {
      deferred.reject();
    });
    return deferred.promise;
  }
  function updateDlgStyle() {
    var marginTopSize = 50;
    var windowHeight = window.innerHeight;
    var maxSize = windowHeight - marginTopSize;
    $scope.shopDlgMaxHeight = maxSize > 960 ? 960 : maxSize;
  }
  $scope.$on("$destroy", function () {
    document.body.classList.remove("blockScroll");
    if ($scope.timelineDatePicker) $scope.timelineDatePicker.destroy();
  });
  $scope.toggleTimelineCalendar = function (event) {
    if ($scope.timelineDatePicker) {
      if ($scope.timelineDatePicker.isVisible()) {
        $scope.timelineDatePicker.hide();
      } else {
        $scope.timelineDatePicker.show();
      }
    }
    if (event.stopPropagation) {
      event.stopPropagation();
    }
  };
  $scope.moveNextDate = function (isPrev) {
    if ($scope.selectDate) {
      if (isPrev) {
        $scope.selectDate.setDate($scope.selectDate.getDate() - 1);
      } else {
        $scope.selectDate.setDate($scope.selectDate.getDate() + 1);
      }
      $scope.timelineDatePicker.setDate($scope.selectDate);
    }
  };
  $scope.playEvent = function (event) {
    if (!event || !(event.landingPage === "event" || event.landingPage === "camera") || !event.monitoringCameraId) {
      return;
    }
    var isShared = $stateParams.shared === true || $stateParams.shared === "true";
    var eventParams = {
      cameraId: event.monitoringCameraId,
      type: isShared ? "sharedshop" : "shop",
      id: $stateParams.shopId,
      time: event.playStartTime || event.regDate,
      shared: isShared,
      eventId: event.eventId
    };
    $state.go("main.cameraDetail", eventParams);
  };
  $scope.toggleEventListBtn = function (e) {
    var parent = e.target.closest("li");
    if (parent) {
      parent.classList.toggle("is_open");
    }
  };
  $scope.showEventFilterSettingLayer = function (isShow) {
    $scope.tempCameraFilterList = [];
    $scope.tempAlarmFilterList = [];
    $scope.tempFilterList = [];
    var storageFilterList = function () {
      try {
        return JSON.parse(localStorage.getItem(SHOP_EVENT_FILTER_LIST_KEY)) || {};
      } catch (error) {
        void 0;
        return {};
      }
    }();
    $scope.filterList.forEach(function (filterItem) {
      var _storageFilterList$fi2;
      filterItem.checked = (_storageFilterList$fi2 = storageFilterList === null || storageFilterList === void 0 ? void 0 : storageFilterList[filterItem.shopEventType]) !== null && _storageFilterList$fi2 !== void 0 ? _storageFilterList$fi2 : true;
      switch (filterItem.shopEventType) {
        case "CAMERA_SOUND":
        case "CAMERA_MOTION":
          $scope.tempCameraFilterList.push(filterItem);
          break;
        case "ALARM_CONFIG":
          $scope.tempAlarmFilterList.push(filterItem);
          break;
        default:
          $scope.tempFilterList.push(filterItem);
      }
    });
    if (isShow) {
      document.body.classList.add("blockScroll");
      updateDlgStyle();
      $scope.isShowEventFilterSettingLayer = true;
    } else {
      document.body.classList.remove("blockScroll");
      $scope.isShowEventFilterSettingLayer = false;
    }
  };
  $scope.getFilterImg = function (sensorId) {
    var filterClassName = {
      CAMERA_SOUND: "cam-sound",
      CAMERA_MOTION: "cam-motion",
      SENSOR_TEMP: "temp",
      SENSOR_HUMID: "hum",
      SENSOR_MOTION: "motion",
      SENSOR_MAGNETIC: "door-open",
      DOORLOCK_EVENT: "doorlock",
      SENSOR_SMOKE: "smoke",
      SENSOR_GAS: "gas",
      SENSOR_PLUG: "plug",
      ALARM_CONFIG: "alarm"
    };
    return filterClassName[sensorId];
  };
  $scope.confirmEventFilterSetting = function () {
    $scope.tempCameraFilterList;
    $scope.tempFilterList;
    $scope.tempAlarmFilterList;
    var concatFilterList = [].concat(_toConsumableArray($scope.tempCameraFilterList), _toConsumableArray($scope.tempFilterList), _toConsumableArray($scope.tempAlarmFilterList));
    var storageData = concatFilterList.reduce(function (acc, item) {
      acc[item.shopEventType] = item.checked;
      return acc;
    }, {});
    localStorage.setItem(SHOP_EVENT_FILTER_LIST_KEY, JSON.stringify(storageData));
    $scope.allFilterOn = concatFilterList.every(function (item) {
      return item.checked;
    });
    $scope.filterList = concatFilterList;
    document.body.classList.remove("blockScroll");
    $scope.isShowEventFilterSettingLayer = false;
    $scope.selectedEventId = null;
    getShopEventWithDate(curDateStr);
  };
  $scope.isCountryJA = function () {
    return window.country === "ja";
  };
  Utils.setCookie("lastEvtCheckTime:" + $stateParams.shopId, new Date().getTime());
  initCalendar();
  getEventFilterList().then(function () {
    curDateStr = $stateParams.regDate ? getDateString($stateParams.regDate) : getDateString();
    getShopEventWithDate(curDateStr);
  });
}]);
"use strict";

app.controller("DashboardPosCtrl", ["PosSummary", "Pos", "$scope", "Shop", "$q", "$state", "$stateParams", "$translate", "$timeout", "$interval", "Camera", "Share", "Clip", "Utils", function (PosSummary, Pos, $scope, Shop, $q, $state, $stateParams, $translate, $timeout, $interval, Camera, Share, Clip, Utils) {
  $scope.accessDate = Date.now();
  $scope.accessDateText = "";
  $scope.todayL = moment().valueOf();
  $scope.yesterdayL = moment().subtract(1, "days").valueOf();
  $scope.beforeYesterdayL = moment().subtract(2, "days").valueOf();
  $scope.weekDays = ["일", "월", "화", "수", "목", "금", "토"];
  $scope.saleType = "amt"; // 매출액/건수 radio버튼

  $scope.startOfWeekString = moment().startOf("week").format("MM.DD");
  $scope.endOfWeekString = moment().endOf("week").format("MM.DD");
  $scope.currentTab = "daily";
  $scope.isTodays = true;
  $scope.todaySales = {};
  $scope.salesData = {};
  $scope.itemSalesNames = ""; // 품목별 매출. 품목명
  $scope.itemSalesInfo = ""; // 품목별 매출.

  $scope.weeklyList = []; // 주간매출목록
  $scope.dailyEventsList = []; // 당일매출목록
  $scope.dailyEventsViewList = []; // 당일매출목록

  $scope.posList = []; // 포스목록

  $scope.isTop5 = true;
  $scope.playStatusType = {
    READY: "ready",
    PLAYING: "playing",
    ERROR: "error"
  };
  $scope.playErrorType = {
    NONE: "none",
    NO_TIMELINE: "noTimeline",
    NO_CLOUD: "noCloud",
    NO_CAM: "noCam"
  };
  $scope.playStatusObj = {
    status: $scope.playStatusType.READY,
    errorStatus: $scope.playErrorType.NONE
  };
  $scope.formatDate = function (dateL, format) {
    return moment(dateL).format(format);
  };
  $scope.checkTodays = function () {
    $scope.isTodays = false;
    if ("daily" === $scope.currentTab) {
      if (moment($scope.accessDate).isSame(moment(), "day")) {
        $scope.isTodays = true;
      }
    } else if ("weekly" === $scope.currentTab) {
      if (moment($scope.accessDate).isSame(moment(), "week")) {
        $scope.isTodays = true;
      }
    } else if ("monthly" === $scope.currentTab) {
      if (moment($scope.accessDate).isSame(moment(), "month")) {
        $scope.isTodays = true;
      }
    }
  };
  document.body.classList.add("wide_scroll");
  $scope.$on("$destroy", function () {
    if ($scope.player) {
      $scope.player.destroy();
    }
    datePicker.destroy();
    $interval.cancel($scope.vedioTimer);
    $(window).off("resize");
    $("body").removeClass("wide_scroll");
  });
  var showAlert = function showAlert(title, message) {
    $(".display_show").css("display", "");
    $scope.showAlert = true;
    $scope.alertTitle = title;
    $scope.alertMessage = message;
  };
  var datePicker = new Pikaday({
    field: document.getElementById("accessDate"),
    bound: false,
    container: document.getElementById("datePickerContainer"),
    //minDate: new Date(moment().subtract(3, "months")),
    maxDate: new Date(),
    defaultDate: new Date(),
    onSelect: function onSelect(date) {
      $scope.$apply(function () {
        $scope.accessDate = date;
        $scope.changeDate();
      });
      this.hide();
    }
  });
  datePicker.hide();

  /**
   * date picker open
   */
  $scope.toggleDatePicker = function (event) {
    event.stopPropagation();
    if (datePicker.isVisible()) {
      datePicker.hide();
    } else {
      datePicker.show();
    }
  };

  // 매장조회
  $scope.getShop = function (shopId) {
    // 매장조회
    Shop.getShopV2({
      shopId: shopId
    }, function (res) {
      $scope.shop = res;
      if (res.code === "nok") {
        Shop.getSharedShopV2({
          shopId: shopId
        }, function (res2) {
          $scope.shop = res2;
        }, function (err) {
          showAlert("통신장애", "서버와 통신중 장애가 발생하였습니다. <br>잠시 후 다시 시도해주세요.");
        });
      }
    }, function (err) {
      showAlert("통신장애", "서버와 통신중 장애가 발생하였습니다. <br>잠시 후 다시 시도해주세요.");
    });
  };

  // 오늘 매출 리포트
  $scope.getTodaySales = function (shopId) {
    PosSummary.getTodaySales({
      shopId: shopId
    }, function (res) {
      $scope.todaySales = res;
      $scope.adjustTodaySales();
    }, function (err) {
      showAlert("통신장애", "서버와 통신중 장애가 발생하였습니다. <br>잠시 후 다시 시도해주세요.");
    });
  };

  // 일간 매출
  $scope.getSalesDaily = function (shopId) {
    $scope.currentTab = "daily";
    var date = moment($scope.accessDate).format("YYYYMMDD");
    // 당일매출목록 조회
    $scope.initDailyEventList();
    $scope.isLoadingComplete = false;
    PosSummary.getSalesDaily({
      shopId: shopId,
      date: date
    }, function (res) {
      $scope.isLoadingComplete = true;
      $scope.salesData = res;
      if ($scope.saleType == "amt") {
        // 일간 - 시간대별 매출 차트
        $scope.initDailyChart();
      } else {
        // 일간 - 시간대별 매출건수 차트
        $scope.initDailyCntChart();
      }
      // 일간 - 최근 7일 매출 차트
      $scope.init7DayChart();
      // 매출요약(우측영역) 품목별 매출
      $scope.setItemSales();
    }, function (err) {
      $scope.isLoadingComplete = true;
      showAlert("통신장애", "서버와 통신중 장애가 발생하였습니다. <br>잠시 후 다시 시도해주세요.");
    });
  };

  // 일자변경시
  $scope.changeDate = function (day) {
    if ("daily" === $scope.currentTab) {
      $scope.accessDate = moment($scope.accessDate).add(day, "days").valueOf();
      $scope.setAccessDateText();
      $scope.getSalesDaily($scope.shopId);
    } else if ("weekly" === $scope.currentTab) {
      $scope.accessDate = moment($scope.accessDate).add(day, "weeks").valueOf();
      $scope.setAccessDateText();
      $scope.getSalesWeekly($scope.shopId);
    } else if ("monthly" === $scope.currentTab) {
      $scope.accessDate = moment($scope.accessDate).add(day, "months").valueOf();
      $scope.setAccessDateText();
      $scope.getSalesMonthly($scope.shopId);
    }
    $scope.checkTodays();
  };

  // 일자변경시 - YYYYMMDD 일자 기준
  $scope.goDaily = function (dateYmd) {
    $scope.accessDate = moment(dateYmd, "YYYYMMDD").valueOf();
    $scope.setAccessDateText();
    $scope.getSalesDaily($scope.shopId);
    // 달력영역 날짜
    $scope.setAccessDateText();
    $scope.checkTodays();
  };

  // 오늘 날짜로 이동
  $scope.goToday = function () {
    $scope.accessDate = moment().valueOf();
    $scope.setAccessDateText();
    if ("daily" === $scope.currentTab) {
      $scope.getSalesDaily($scope.shopId);
    } else if ("weekly" === $scope.currentTab) {
      $scope.getSalesWeekly($scope.shopId);
    } else if ("monthly" === $scope.currentTab) {
      $scope.getSalesMonthly($scope.shopId);
    }
    $scope.checkTodays();
  };
  $scope.goWeekly = function () {
    $scope.changeTab("weekly");
  };
  $scope.goMonthly = function () {
    $scope.changeTab("monthly");
  };

  // 당일매출목록 조회
  $scope.initDailyEventList = function () {
    Pos.getEventList({
      shopId: $scope.shopId,
      date: moment($scope.accessDate).format("YYYYMMDD"),
      pageSize: 0
    }, function (data) {
      $scope.dailyEventsList = data.events;
      $scope.dailyEventsViewList = data.events.slice(0, 5);
      $scope.isTop5 = true;
    }, function (err) {});
  };

  // 이벤트목록 더보기
  $scope.viewMoreEvents = function () {
    $scope.dailyEventsViewList = $scope.dailyEventsList;
    $scope.isTop5 = false;
  };

  // 일간 - 시간대별 매출 차트
  $scope.initDailyChart = function () {
    $("#salesChart1").html("");
    var chartWidth = $("#salesChart1").width();
    // data 설정
    var data = {};
    if ($scope.salesData && $scope.salesData.salesInfo) {
      data.categories = $scope.salesData.salesInfo.compareCategories;
      data.series = $scope.salesData.salesInfo.compareSeries;
      $scope.dailyChartData = data;
      // option 설정
      var options = {};
      options["theme"] = "newTheme";
      options["chart"] = {
        width: chartWidth - 70,
        height: 400,
        title: "",
        format: "1,000"
      };
      options["yAxis"] = {
        title: "매출액(원)",
        min: 0
      };
      options["tooltip"] = {
        suffix: "원"
      };
      options["xAxis"] = {
        title: "",
        labelInterval: 2
      };
      options["series"] = {
        hasDot: false,
        hasSelection: true
      };
      options["legend"] = {
        align: "top"
      };
      options["chartExportMenu"] = {
        visible: false
      };
      $scope.dailyChartOptions = options;
      // //차트 라인 컬러 변경
      var colors = [];
      if (data.series) {
        for (var i = 0; i < data.series.length; i++) {
          colors.push(data.series[i].color);
        }
      }
      $scope.theme = {
        series: {
          colors: colors
        }
      };
      tui.chart.registerTheme("newTheme", $scope.theme);
      // 차트생성 - 일간 - 시간대별 매출 차트
      var lineClick = tui.chart.lineChart(document.getElementById("salesChart1"), data, options); //라인차트
      $("#salesChart1").children(".tui-chart").css("margin", "auto");
    }
  };

  // 일간 - 시간대별 매출건수 차트
  $scope.initDailyCntChart = function () {
    $("#salesChart1").html("");
    var chartWidth = $("#salesChart1").width();
    // data 설정
    var data = {};
    if ($scope.salesData && $scope.salesData.salesInfo) {
      data.categories = $scope.salesData.salesInfo.compareCategories;
      data.series = $scope.salesData.salesInfo.compareCntSeries;
      $scope.dailyChartData = data;
      // option 설정
      var options = {};
      options["theme"] = "newTheme";
      options["chart"] = {
        width: chartWidth - 70,
        height: 400,
        title: "",
        format: "1,000"
      };
      options["yAxis"] = {
        title: "매출건수",
        min: 0
      };
      options["tooltip"] = {
        suffix: "건"
      };
      options["xAxis"] = {
        title: "",
        labelInterval: 2
      };
      options["series"] = {
        hasDot: false,
        hasSelection: true
      };
      options["legend"] = {
        align: "top"
      };
      options["chartExportMenu"] = {
        visible: false
      };
      $scope.dailyChartOptions = options;
      // //차트 라인 컬러 변경
      var colors = [];
      if (data.series) {
        for (var i = 0; i < data.series.length; i++) {
          colors.push(data.series[i].color);
        }
      }
      $scope.theme = {
        series: {
          colors: colors
        }
      };
      tui.chart.registerTheme("newTheme", $scope.theme);
      // 차트생성 - 일간 - 시간대별 매출건수 차트
      var lineClick = tui.chart.lineChart(document.getElementById("salesChart1"), data, options); //라인차트
      $("#salesChart1").children(".tui-chart").css("margin", "auto");
    }
  };

  // 일간 - 최근 7일 매출 차트
  $scope.init7DayChart = function () {
    $("#salesChart2").html("");
    var chartWidth = $("#salesChart2").width();
    // data 설정
    var data = {};
    if ($scope.salesData && $scope.salesData.salesInfo) {
      data.categories = $scope.salesData.salesInfo.historyCategories;
      data.series = $scope.salesData.salesInfo.historySeries;
      // option 설정
      var options = {};
      options["theme"] = "newTheme";
      options["chart"] = {
        width: chartWidth - 70,
        height: 400,
        title: "",
        format: "1,000"
      };
      options["yAxis"] = {
        title: "매출액(원)",
        min: 0
      };
      options["tooltip"] = {
        suffix: "원"
      };
      options["xAxis"] = {
        title: "",
        labelInterval: 1
      };
      options["series"] = {
        hasDot: false,
        hasSelection: true
      };
      options["legend"] = {
        align: "top"
      };
      options["chartExportMenu"] = {
        visible: false
      };
      // //차트 라인 컬러 변경
      var colors = [];
      if (data.series) {
        for (var i = 0; i < data.series.length; i++) {
          colors.push(data.series[i].color);
        }
      }
      $scope.theme = {
        series: {
          colors: colors
        }
      };
      tui.chart.registerTheme("newTheme", $scope.theme);
      // 차트생성
      var lineChart = tui.chart.columnChart(document.getElementById("salesChart2"), data, options); //라인차트
      lineChart.on("selectSeries", function (info) {
        //라인클릭이벤트	카메라이고 판매차트일 때만
        // console.log("selectSeries : " + info);
        var tempIndex = info.index;
        $scope.changeDate(-(6 - tempIndex));
        $("body").scrollTop(0);
      });
      // 기간 텍스트
      $scope.a7DayText = moment($scope.accessDate).subtract(6, "days").format("MM.DD(") + $scope.weekDays[moment($scope.accessDate).subtract(6, "days").weekday()] + ")" + "~" + moment($scope.accessDate).format("MM.DD(") + $scope.weekDays[moment($scope.accessDate).weekday()] + ")";
      $("#salesChart2").children(".tui-chart").css("margin", "auto");
    }
  };

  // 우측영역 매출요약 표시
  $scope.setItemSales = function () {
    $scope.adjustSalesData();
    $scope.itemSalesNames = ""; // 품목별 판매. 품목명
    $scope.itemSalesInfo = ""; // 품목별 매출.
    if ($scope.salesData && $scope.salesData.salesInfo && $scope.salesData.salesInfo.posItems && $scope.salesData.salesInfo.posItems.length) {
      //itemPrice 설정
      for (var i = 0; i < $scope.salesData.salesInfo.posItems.length; i++) {
        var itemTemp = $scope.salesData.salesInfo.posItems[i];
        if (itemTemp.itemCnt === "0") {
          itemTemp.itemPrice = 0;
        } else {
          itemTemp.itemPrice = itemTemp.itemSort / Number(itemTemp.itemCnt);
        }
      }
      // 매출정보 텍스트 생성
      for (var i = 0; i < $scope.salesData.salesInfo.posItems.length && i < 25; i++) {
        var itemTemp = $scope.salesData.salesInfo.posItems[i];
        if (i !== 0) {
          $scope.itemSalesNames += "<br>";
          $scope.itemSalesInfo += "<br>";
        }
        $scope.itemSalesNames += '<span title="' + itemTemp.itemName + '">' + itemTemp.itemName + "</span>";
        itemTemp.itemSales = itemTemp.itemSales.replace("KRW", "\\");
        $scope.itemSalesInfo += itemTemp.itemSales + "<span>/" + itemTemp.itemCnt + "개</span>";
      }
    }
  };

  // 매출팝업 표시
  $scope.setItemSalesPopup = function () {
    $scope.itemPopupSalesNames = ""; // 품목별 판매. 품목명
    $scope.itemPopupPrices = ""; // 품목별 판매. 단가
    $scope.itemPopupCounts = ""; // 품목별 판매. 수량
    $scope.itemPopupSales = ""; // 품목별 판매. 금액(비율)
    if ($scope.salesData && $scope.salesData.salesInfo && $scope.salesData.salesInfo.posItems && $scope.salesData.salesInfo.posItems.length) {
      for (var i = 0; i < $scope.salesData.salesInfo.posItems.length; i++) {
        var itemTemp = $scope.salesData.salesInfo.posItems[i];
        if (i !== 0) {
          $scope.itemPopupSalesNames += "<br>";
          $scope.itemPopupPrices += "<br>";
          $scope.itemPopupCounts += "<br>";
          $scope.itemPopupSales += "<br>";
        }
        $scope.itemPopupSalesNames += itemTemp.itemName;
        $scope.itemPopupPrices += itemTemp.itemPrice;
        $scope.itemPopupCounts += itemTemp.itemCnt;
        $scope.itemPopupSales += itemTemp.itemSales + " (" + itemTemp.itemPercent + ")";
      }
    }
  };

  // 매출 팝업 정렬처리
  $scope.currentSortKey = "itemPrice";
  $scope.itemSortDirection = {
    itemPrice: 1,
    itemCnt: 1,
    itemSort: 1
  };

  // 매출 팝업 정렬처리
  $scope.sortItemSalePopup = function (key) {
    if (key === $scope.currentSortKey) {
      $scope.itemSortDirection[key] *= -1;
    } else {
      $scope.itemSortDirection = {
        itemPrice: 1,
        itemCnt: 1,
        itemSort: 1
      };
    }
    $scope.currentSortKey = key;
    sortItemSale($scope.currentSortKey, $scope.itemSortDirection[key]);
  };

  //포스item 정렬
  //  key 정렬필드명 문자값
  //  direction 1: asc, -1: desc
  var sortItemSale = function sortItemSale(key, direction) {
    if ($scope.salesData && $scope.salesData.salesInfo) {
      $scope.salesData.salesInfo.posItems.sort(function (a, b) {
        return Number(a[key]) < Number(b[key]) ? -1 * direction : Number(a[key]) > Number(b[key]) ? 1 * direction : 0;
      });
    }
    // 팝업 데이터 재생성
    $scope.setItemSalesPopup();
  };

  //매출상세 팝업
  $scope.showPosItems = function () {
    $scope.currentSortKey = "itemCnt";
    $scope.sortItemSalePopup("itemPrice");
    $scope.isShowPosItems = true;
  };
  $scope.closePosItems = function () {
    $scope.isShowPosItems = false;
  };
  // 매출상페 페이지로 이동
  $scope.goPosItems = function () {
    var params = {
      shopId: $scope.shopId,
      currentTab: $scope.currentTab,
      accessDate: moment($scope.accessDate).format("YYYYMMDD")
    };
    $state.go("main.dashboard.posItem", params);
  };

  // 주간 매출
  $scope.getSalesWeekly = function (shopId) {
    $scope.currentTab = "weekly";
    var date = moment($scope.accessDate).startOf("week").format("YYYYMMDD");
    $scope.isLoadingComplete = false;
    PosSummary.getSalesWeekly({
      shopId: shopId,
      date: date
    }, function (res) {
      $scope.isLoadingComplete = true;
      $scope.salesData = res;
      // 주간 매출목록 생성
      $scope.initWeeklyList();
      if ($scope.saleType == "amt") {
        // 일간 - 시간대별 매출 차트
        $scope.initWeeklyChart();
      } else {
        // 일간 - 시간대별 매출건수 차트
        $scope.initWeeklyCntChart();
      }
      // 일간 - 최근 8주 매출 차트
      $scope.init8WeekChart();
      // 매출요약(우측영역) 품목별 매출
      $scope.setItemSales();
    }, function (err) {
      $scope.isLoadingComplete = true;
      showAlert("통신장애", "서버와 통신중 장애가 발생하였습니다. <br>잠시 후 다시 시도해주세요.");
    });
  };
  $scope.getPosEventList = function (idx) {
    // event list
    Pos.getEventList({
      shopId: $scope.shopId,
      date: moment($scope.weeklyList[idx].date).format("YYYYMMDD"),
      pageSize: 0
    }, function (data) {
      $scope.weeklyList[idx].eventList = data.events;
    }, function (err) {});
  };

  // 주간매출목록
  $scope.initWeeklyList = function () {
    $scope.weeklyList = [];
    if ($scope.salesData && $scope.salesData.salesInfo) {
      for (var i = 0; i < 7; i++) {
        $scope.weeklyList[i] = {
          date: moment($scope.accessDate).startOf("week").add(i, "days").valueOf(),
          amt: $scope.salesData.salesInfo.posSalesDailies[i].sales,
          cnt: $scope.salesData.salesInfo.posSalesDailies[i].cnt
        };
      }
    }
  };

  // 주간 - 요일별 매출 차트
  $scope.initWeeklyChart = function () {
    $("#salesChart1").html("");
    var chartWidth = $("#salesChart1").width();
    // data 설정
    var data = {};
    if ($scope.salesData && $scope.salesData.salesInfo) {
      data.categories = $scope.salesData.salesInfo.compareCategories;
      data.series = $scope.salesData.salesInfo.compareSeries;
      // option 설정
      var options = {};
      options["theme"] = "newTheme";
      options["chart"] = {
        width: chartWidth - 70,
        height: 400,
        title: "",
        format: "1,000"
      };
      options["yAxis"] = {
        title: "매출액(원)",
        min: 0
      };
      options["tooltip"] = {
        suffix: "원"
      };
      options["xAxis"] = {
        title: "",
        labelInterval: 1
      };
      options["series"] = {
        hasDot: false,
        hasSelection: true
      };
      options["legend"] = {
        align: "top"
      };
      options["chartExportMenu"] = {
        visible: false
      };
      // //차트 라인 컬러 변경
      var colors = [];
      if (data.series) {
        for (var i = 0; i < data.series.length; i++) {
          colors.push(data.series[i].color);
        }
      }
      $scope.theme = {
        series: {
          colors: colors
        }
      };
      tui.chart.registerTheme("newTheme", $scope.theme);
      // 차트생성 - 일간 - 시간대별 매출 차트
      var lineChart = tui.chart.lineChart(document.getElementById("salesChart1"), data, options); //라인차트
      lineChart.on("selectSeries", function (info) {
        // console.log("selectSeries : " + info);
        var tempIndex = info.index;
        var dateYmd = moment($scope.accessDate).startOf("week").add(tempIndex, "days").format("YYYYMMDD");
        $scope.goDaily(dateYmd);
      });
      $("#salesChart1").children(".tui-chart").css("margin", "auto");
    }
  };

  // 주간 - 요일별 매출건수 차트
  $scope.initWeeklyCntChart = function () {
    $("#salesChart1").html("");
    var chartWidth = $("#salesChart1").width();
    // data 설정
    var data = {};
    if ($scope.salesData && $scope.salesData.salesInfo) {
      data.categories = $scope.salesData.salesInfo.compareCategories;
      data.series = $scope.salesData.salesInfo.compareCntSeries;
      // option 설정
      var options = {};
      options["theme"] = "newTheme";
      options["chart"] = {
        width: chartWidth - 70,
        height: 400,
        title: "",
        format: "1,000"
      };
      options["yAxis"] = {
        title: "매출건수",
        min: 0
      };
      options["tooltip"] = {
        suffix: "건"
      };
      options["xAxis"] = {
        title: "",
        labelInterval: 1
      };
      options["series"] = {
        hasDot: false,
        hasSelection: true
      };
      options["legend"] = {
        align: "top"
      };
      options["chartExportMenu"] = {
        visible: false
      };
      // //차트 라인 컬러 변경
      var colors = [];
      if (data.series) {
        for (var i = 0; i < data.series.length; i++) {
          colors.push(data.series[i].color);
        }
      }
      $scope.theme = {
        series: {
          colors: colors
        }
      };
      tui.chart.registerTheme("newTheme", $scope.theme);
      // 차트생성 - 일간 - 시간대별 매출 차트
      var lineChart = tui.chart.lineChart(document.getElementById("salesChart1"), data, options); //라인차트
      lineChart.on("selectSeries", function (info) {
        // console.log("selectSeries : " + info);
        var tempIndex = info.index;
        var dateYmd = moment($scope.accessDate).startOf("week").add(tempIndex, "days").format("YYYYMMDD");
        $scope.goDaily(dateYmd);
      });
      $("#salesChart1").children(".tui-chart").css("margin", "auto");
    }
  };

  // 주간 - 최근 8주 차트
  $scope.init8WeekChart = function () {
    $("#salesChart2").html("");
    var chartWidth = $("#salesChart2").width();
    // data 설정
    var data = {};
    if ($scope.salesData && $scope.salesData.salesInfo) {
      data.categories = $scope.salesData.salesInfo.historyCategories;
      data.series = $scope.salesData.salesInfo.historySeries;
      // option 설정
      var options = {};
      options["theme"] = "newTheme";
      options["chart"] = {
        width: chartWidth - 70,
        height: 400,
        title: "",
        format: "1,000"
      };
      options["yAxis"] = {
        title: "매출액(원)",
        min: 0
      };
      options["tooltip"] = {
        suffix: "원"
      };
      options["xAxis"] = {
        title: "",
        labelInterval: 1
      };
      options["series"] = {
        hasDot: false,
        hasSelection: true
      };
      options["legend"] = {
        align: "top"
      };
      options["chartExportMenu"] = {
        visible: false
      };
      // //차트 라인 컬러 변경
      var colors = [];
      if (data.series) {
        for (var i = 0; i < data.series.length; i++) {
          colors.push(data.series[i].color);
        }
      }
      $scope.theme = {
        series: {
          colors: colors
        }
      };
      tui.chart.registerTheme("newTheme", $scope.theme);
      // 차트생성
      var lineChart = tui.chart.columnChart(document.getElementById("salesChart2"), data, options); //라인차트
      lineChart.on("selectSeries", function (info) {
        //라인클릭이벤트	카메라이고 판매차트일 때만
        // console.log("selectSeries : " + info);
        var tempIndex = info.index;
        $scope.changeDate(-(7 - tempIndex));
        $("body").scrollTop(0);
      });
      // 기간 텍스트
      $scope.a8WeekText = moment($scope.accessDate).startOf("week").subtract(7, "weeks").format("MM.DD") + "~" + moment($scope.accessDate).startOf("week").format("MM.DD");
      $("#salesChart2").children(".tui-chart").css("margin", "auto");
    }
  };

  // 월간 매출
  $scope.getSalesMonthly = function (shopId) {
    $scope.currentTab = "monthly";
    var date = moment($scope.accessDate).startOf("month").format("YYYYMMDD");
    $scope.isLoadingComplete = false;
    PosSummary.getSalesMonthly({
      shopId: shopId,
      date: date
    }, function (res) {
      $scope.isLoadingComplete = true;
      $scope.salesData = res;
      if ($scope.saleType == "amt") {
        // 월간 - 요일별 매출 차트
        $scope.initMonthlyChart();
      } else {
        // 월간 - 일별 매출건수
        $scope.initMonthlyCntChart();
      }
      // 월간 - 일별 매출건수 달력
      $scope.initMonthlyCalendar();
      // 월간 - 최근 8주 매출 차트
      $scope.init6MonthChart();
      // 매출요약(우측영역) 품목별 매출
      $scope.setItemSales();
    }, function (err) {
      $scope.isLoadingComplete = true;
      showAlert("통신장애", "서버와 통신중 장애가 발생하였습니다. <br>잠시 후 다시 시도해주세요.");
    });
  };

  // 월간 - 일별 매출 차트
  $scope.initMonthlyChart = function () {
    $("#salesChart1").html("");
    var chartWidth = $("#salesChart1").width();
    // data 설정
    var data = {};
    if ($scope.salesData && $scope.salesData.salesInfo) {
      data.categories = $scope.salesData.salesInfo.compareCategories;
      data.series = $scope.salesData.salesInfo.compareSeries;
      // option 설정
      var options = {};
      options["theme"] = "newTheme";
      options["chart"] = {
        width: chartWidth - 70,
        height: 400,
        title: "",
        format: "1,000"
      };
      options["yAxis"] = {
        title: "매출액(원)",
        min: 0
      };
      options["tooltip"] = {
        suffix: "원"
      };
      options["xAxis"] = {
        title: "",
        labelInterval: 2
      };
      options["series"] = {
        hasDot: false,
        hasSelection: true
      };
      options["legend"] = {
        align: "top"
      };
      options["chartExportMenu"] = {
        visible: false
      };
      // //차트 라인 컬러 변경
      var colors = [];
      if (data.series) {
        for (var i = 0; i < data.series.length; i++) {
          colors.push(data.series[i].color);
        }
      }
      $scope.theme = {
        series: {
          colors: colors
        }
      };
      tui.chart.registerTheme("newTheme", $scope.theme);
      // 차트생성 - 일간 - 시간대별 매출 차트
      var lineClick = tui.chart.lineChart(document.getElementById("salesChart1"), data, options); //라인차트
      lineClick.on("selectSeries", function (info) {
        // console.log("selectSeries : " + info);
        var tempIndex = info.index;
        var dateYmd = moment($scope.accessDate).startOf("month").add(tempIndex, "days").format("YYYYMMDD");
        $scope.goDaily(dateYmd);
      });
      $("#salesChart1").children(".tui-chart").css("margin", "auto");
    }
  };

  // 월간 - 일별 매출건수 차트
  $scope.initMonthlyCntChart = function () {
    $("#salesChart1").html("");
    var chartWidth = $("#salesChart1").width();
    // data 설정
    var data = {};
    if ($scope.salesData && $scope.salesData.salesInfo) {
      data.categories = $scope.salesData.salesInfo.compareCategories;
      data.series = $scope.salesData.salesInfo.compareCntSeries;
      // option 설정
      var options = {};
      options["theme"] = "newTheme";
      options["chart"] = {
        width: chartWidth - 70,
        height: 400,
        title: "",
        format: "1,000"
      };
      options["yAxis"] = {
        title: "매출건수",
        min: 0
      };
      options["tooltip"] = {
        suffix: "건"
      };
      options["xAxis"] = {
        title: "",
        labelInterval: 2
      };
      options["series"] = {
        hasDot: false,
        hasSelection: true
      };
      options["legend"] = {
        align: "top"
      };
      options["chartExportMenu"] = {
        visible: false
      };
      // //차트 라인 컬러 변경
      var colors = [];
      for (var i = 0; i < data.series.length; i++) {
        colors.push(data.series[i].color);
      }
      $scope.theme = {
        series: {
          colors: colors
        }
      };
      tui.chart.registerTheme("newTheme", $scope.theme);
      // 차트생성 - 일간 - 시간대별 매출 차트
      var lineClick = tui.chart.lineChart(document.getElementById("salesChart1"), data, options); //라인차트
      lineClick.on("selectSeries", function (info) {
        // console.log("selectSeries : " + info);
        var tempIndex = info.index;
        var dateYmd = moment($scope.accessDate).startOf("month").add(tempIndex, "days").format("YYYYMMDD");
        $scope.goDaily(dateYmd);
      });
      $("#salesChart1").children(".tui-chart").css("margin", "auto");
    }
  };

  // 월간통계 - 일별매출건수 달력
  $scope.calendar = [];
  $scope.initMonthlyCalendar = function () {
    $scope.calendar = [];
    $scope.startDateMoment = moment($scope.accessDate).startOf("month");
    $scope.endDateMoment = moment($scope.accessDate).endOf("month");
    var startDateMoment = moment($scope.accessDate).startOf("month");
    var startingHiddenDay = $scope.startDateMoment.day(); // 1일 시작전 공백 갯수
    var week = [];
    var day = {};

    // 1일 시작전 공백 <td> 생성
    for (var i = 0; i < startingHiddenDay; i++) {
      day = {};
      if (i === 0) {
        day.sunday = true;
      }
      day.hiddenDay = true;
      day.on = false;
      week.push(day);
    }
    // 1일 ~ 말일까지의 <td> 생성

    for (var currMoment = $scope.startDateMoment.clone(), i = 0; currMoment.isBefore($scope.endDateMoment) || currMoment.isSame($scope.endDateMoment); currMoment.add(1, "days"), i++) {
      day = {};
      if (currMoment.day() === 0 && currMoment.date() != 1) {
        $scope.calendar.push(week);
        week = [];
      }
      if (currMoment.day() === 0) {
        day.sunday = true;
      }
      day.hiddenDay = false;
      if (currMoment.isSame($scope.accessDateMoment)) {
        day.on = true;
      } else {
        day.on = false;
      }
      // *** 일자, 건수 ***
      if ($scope.salesData && $scope.salesData.salesInfo) {
        day.data = $scope.salesData.salesInfo.posSalesDailies[i]; // date:일자, cnt:건수
        day.data.dateYmd = currMoment.format("YYYYMMDD");
      }
      week.push(day);
    }
    // 말일 이후 공백 <td> 생성
    for (var i = week.length; i < 7; i++) {
      day = {};
      day.sunday = false;
      day.hiddenDay = true;
      day.on = false;
      week.push(day);
    }
    $scope.calendar.push(week);
  };

  // 월간 - 최근 6개월 차트
  $scope.init6MonthChart = function () {
    $("#salesChart2").html("");
    var chartWidth = $("#salesChart2").width();
    // data 설정
    var data = {};
    if ($scope.salesData && $scope.salesData.salesInfo) {
      data.categories = $scope.salesData.salesInfo.historyCategories;
      data.series = $scope.salesData.salesInfo.historySeries;
      // option 설정
      var options = {};
      options["theme"] = "newTheme";
      options["chart"] = {
        width: chartWidth - 70,
        height: 400,
        title: "",
        format: "1,000"
      };
      options["yAxis"] = {
        title: "매출액(원)",
        min: 0
      };
      options["tooltip"] = {
        suffix: "원"
      };
      options["xAxis"] = {
        title: "",
        labelInterval: 1
      };
      options["series"] = {
        hasDot: false,
        hasSelection: true
      };
      options["legend"] = {
        align: "top"
      };
      options["chartExportMenu"] = {
        visible: false
      };
      // //차트 라인 컬러 변경
      var colors = [];
      if (data.series) {
        for (var i = 0; i < data.series.length; i++) {
          colors.push(data.series[i].color);
        }
      }
      $scope.theme = {
        series: {
          colors: colors
        }
      };
      tui.chart.registerTheme("newTheme", $scope.theme);
      // 차트생성
      var lineChart = tui.chart.columnChart(document.getElementById("salesChart2"), data, options); //라인차트
      lineChart.on("selectSeries", function (info) {
        //라인클릭이벤트	카메라이고 판매차트일 때만
        // console.log("selectSeries : " + info);
        var tempIndex = info.index;
        $scope.changeDate(-(5 - tempIndex));
        $("body").scrollTop(0);
      });
      // 기간 텍스트
      $scope.a6MonthText = moment($scope.accessDate).startOf("month").subtract(5, "months").format("YYYY.MM") + "~" + moment($scope.accessDate).startOf("month").format("YYYY.MM");
      $("#salesChart2").children(".tui-chart").css("margin", "auto");
    }
  };

  // 달력의 날짜표시 영역 설정
  $scope.setAccessDateText = function () {
    var accessDateMoment = moment($scope.accessDate);
    if ($scope.currentTab === "daily") {
      $scope.accessDateText = accessDateMoment.format("YYYY.MM.DD(") + $scope.weekDays[accessDateMoment.weekday()] + ")";
    } else if ($scope.currentTab === "weekly") {
      $scope.accessDateText = accessDateMoment.startOf("week").format("MM.DD") + "~" + accessDateMoment.startOf("week").add(6, "days").format("MM.DD");
    } else if ($scope.currentTab === "monthly") {
      $scope.accessDateText = accessDateMoment.format("YYYY.MM");
    }
  };

  // 일간매출/주간매출/월간매출 버튼 클릭
  $scope.changeTab = function (tab) {
    if ("daily" === tab) {
      // 일간 매출
      $scope.accessDate = moment().valueOf();
      $scope.getSalesDaily($scope.shopId);
    } else if ("weekly" === tab) {
      // 주간매출
      $scope.accessDate = moment().valueOf();
      $scope.getSalesWeekly($scope.shopId);
    } else if ("monthly" === tab) {
      // 월간매출
      $scope.accessDate = moment().valueOf();
      $scope.getSalesMonthly($scope.shopId);
    }
    // 달력영역 날짜
    $scope.setAccessDateText();
    $scope.checkTodays();
  };

  // 포스목록 조회
  $scope.initPosList = function () {
    Pos.getShopPosList({
      shopId: $scope.shopId
    }, function (data) {
      $scope.posList = data.posLit;
    }, function (err) {});
  };

  // 포스명 조회
  $scope.getPosName = function (posId) {
    var pos = $.grep($scope.posList, function (e) {
      return e.posId === posId;
    });
    if (pos.length > 0) {
      return pos[0].posName;
    }
    return "";
  };

  /**
   * init
   */
  (function () {
    // 파라미터 저장
    $scope.shopId = $state.params.shopId;
    $scope.params = {};
    $scope.params.id = $state.params.shopId;
    $scope.params.cameraId = $state.params.cameraId;
    $scope.params.posId = $state.params.posId;
    $scope.params.type = $state.params.type;
    $stateParams.id = $scope.shopId;
    // 매장조회
    $scope.getShop($scope.shopId);
    // 포스목록조회
    $scope.initPosList();
    // 오늘 매출 리포트
    $scope.getTodaySales($scope.shopId);
    $scope.changeTab("daily");
  })();
  $scope.adjustTodaySales = function () {
    if (typeof $scope.todaySales.summary === "undefined") {
      return "";
    }
    if ($scope.todaySales.summary.todayCompare.indexOf("+") >= 0) {
      $scope.todaySales.summary.todaySalesCompareSign = 1;
    } else if ($scope.todaySales.summary.todayCompare.indexOf("-") >= 0) {
      $scope.todaySales.summary.todaySalesCompareSign = -1;
    } else {
      $scope.todaySales.summary.todaySalesCompareSign = 0;
    }
    if ($scope.todaySales.summary.yesterdayCompare.indexOf("+") >= 0) {
      $scope.todaySales.summary.yesterdaySalesCompareSign = 1;
    } else if ($scope.todaySales.summary.yesterdayCompare.indexOf("-") >= 0) {
      $scope.todaySales.summary.yesterdaySalesCompareSign = -1;
    } else {
      $scope.todaySales.summary.yesterdaySalesCompareSign = 0;
    }
    if ($scope.todaySales.summary.beforeYesterdayCompare.indexOf("+") >= 0) {
      $scope.todaySales.summary.beforeYesterdaySalesCompareSign = 1;
    } else if ($scope.todaySales.summary.beforeYesterdayCompare.indexOf("-") >= 0) {
      $scope.todaySales.summary.beforeYesterdaySalesCompareSign = -1;
    } else {
      $scope.todaySales.summary.beforeYesterdaySalesCompareSign = 0;
    }
    if ($scope.todaySales.summary.weekCompare.indexOf("+") >= 0) {
      $scope.todaySales.summary.weekCompareSign = 1;
    } else if ($scope.todaySales.summary.weekCompare.indexOf("-") >= 0) {
      $scope.todaySales.summary.weekCompareSign = -1;
    } else {
      $scope.todaySales.summary.weekCompareSign = 0;
    }
    if ($scope.todaySales.summary.monthCompare.indexOf("+") >= 0) {
      $scope.todaySales.summary.monthCompareSign = 1;
    } else if ($scope.todaySales.summary.monthCompare.indexOf("-") >= 0) {
      $scope.todaySales.summary.monthCompareSign = -1;
    } else {
      $scope.todaySales.summary.monthCompareSign = 0;
    }
    $scope.todaySales.summary.todaySalesCntCompare = $scope.getSignValue($scope.todaySales.summary.todaySalesCntCompare);
    $scope.todaySales.summary.yesterdaySalesCntCompare = $scope.getSignValue($scope.todaySales.summary.yesterdaySalesCntCompare);
    $scope.todaySales.summary.beforeYesterdaySalesCntCompare = $scope.getSignValue($scope.todaySales.summary.beforeYesterdaySalesCntCompare);
    $scope.todaySales.summary.todayCompare = $scope.getSignValue($scope.todaySales.summary.todayCompare);
    $scope.todaySales.summary.yesterdayCompare = $scope.getSignValue($scope.todaySales.summary.yesterdayCompare);
    $scope.todaySales.summary.beforeYesterdayCompare = $scope.getSignValue($scope.todaySales.summary.beforeYesterdayCompare);
    $scope.todaySales.summary.weekCompare = $scope.getSignValue($scope.todaySales.summary.weekCompare);
    $scope.todaySales.summary.monthCompare = $scope.getSignValue($scope.todaySales.summary.monthCompare);
    $scope.todaySales.summary.todayCompareClass = $scope.getXClass("tt_st_move", $scope.todaySales.summary.todayCompare);
    $scope.todaySales.summary.yesterdayCompareClass = $scope.getXClass("tt_st_move", $scope.todaySales.summary.yesterdayCompare);
    $scope.todaySales.summary.beforeYesterdayCompareClass = $scope.getXClass("tt_st_move", $scope.todaySales.summary.beforeYesterdayCompare);
    $scope.todaySales.summary.weekCompareClass = $scope.getTClass($scope.todaySales.summary.weekCompare);
    $scope.todaySales.summary.monthCompareClass = $scope.getBClass($scope.todaySales.summary.monthCompare);
    $scope.todaySales.summary.todaySales = $scope.todaySales.summary.todaySales.replace("KRW", "\\");
    $scope.todaySales.summary.yesterdaySales = $scope.todaySales.summary.yesterdaySales.replace("KRW", "\\");
    $scope.todaySales.summary.beforeYesterdaySales = $scope.todaySales.summary.beforeYesterdaySales.replace("KRW", "\\");
    $scope.todaySales.summary.weekSales = $scope.todaySales.summary.weekSales.replace("KRW", "\\");
    $scope.todaySales.summary.monthSales = $scope.todaySales.summary.monthSales.replace("KRW", "\\");
  };
  $scope.adjustSalesData = function () {
    if (typeof $scope.salesData.salesInfo === "undefined") {
      return "";
    }
    if ($scope.salesData.salesInfo.paymentCnt === "null") {
      $scope.salesData.salesInfo.paymentCnt = 0;
    }
    if ($scope.salesData.salesInfo.cancelCnt === "null") {
      $scope.salesData.salesInfo.cancelCnt = 0;
    }
    if ($scope.salesData.salesInfo.alertCnt === "null") {
      $scope.salesData.salesInfo.alertCnt = 0;
    }
    if ($scope.salesData.salesInfo.totalCompare.indexOf("+") >= 0) {
      $scope.salesData.salesInfo.totalCompareSign = 1;
    } else if ($scope.salesData.salesInfo.totalCompare.indexOf("-") >= 0) {
      $scope.salesData.salesInfo.totalCompareSign = -1;
    } else {
      $scope.salesData.salesInfo.totalCompareSign = 0;
    }
    $scope.salesData.salesInfo.totalSales = $scope.salesData.salesInfo.totalSales.replace("KRW", "\\");
    $scope.salesData.salesInfo.totalCompare = $scope.getSignValue($scope.salesData.salesInfo.totalCompare);
    //$scope.salesData.salesInfo.totalCompareSales = $scope.getSignValue($scope.salesData.salesInfo.totalCompareSales);

    $scope.salesData.salesInfo.totalCompareClass = $scope.getXClass("pos_price", $scope.salesData.salesInfo.totalCompare);
  };
  $scope.getSignValue = function (str) {
    if (str.indexOf("-") >= 0) {
      result = str.replace("-", "▼");
      return result;
    } else if (str.indexOf("+") >= 0) {
      result = str.replace("+", "▲");
      return result;
    } else {
      return str;
    }
  };

  // 실시간 매출 페이지로 이동
  $scope.goPos = function (filter, date) {
    // filter 파라미터
    if (filter) {
      $scope.params.filters = $scope.salesData.salesInfo[filter];
    } else {
      $scope.params.filters = "";
    }

    // date 파라미터
    if (typeof date !== "undefined") {
      $scope.params.date = date;
    } else {
      if ("daily" === $scope.currentTab) {
        $scope.params.date = moment($scope.accessDate).format("YYYYMMDD");
      } else if ("weekly" === $scope.currentTab) {
        $scope.params.date = moment($scope.accessDate).startOf("week").format("YYYYMMDD");
      } else {
        $scope.params.date = moment($scope.accessDate).startOf("month").format("YYYYMMDD");
      }
    }
    $state.go("main.dashboard.posView", $scope.params);
  };

  // 실시간 매출 페이지로 이동
  $scope.goPosSales = function (filter, date) {
    // filter 파라미터
    if (filter) {
      if ($scope.salesData && $scope.salesData.salesInfo) {
        $scope.params.filters = $scope.salesData.salesInfo[filter];
      }
      $scope.params.filterType = filter;
    } else {
      $scope.params.filters = "";
    }

    // date 파라미터
    if (typeof date !== "undefined") {
      $scope.params.date = date;
    } else {
      if ("daily" === $scope.currentTab) {
        $scope.params.date = moment($scope.accessDate).format("YYYYMMDD");
      } else if ("weekly" === $scope.currentTab) {
        $scope.params.date = moment($scope.accessDate).startOf("week").format("YYYYMMDD");
      } else {
        $scope.params.date = moment($scope.accessDate).startOf("month").format("YYYYMMDD");
      }
    }
    $state.go("main.dashboard.posSales", $scope.params);
  };

  // get T Class: pos_move01_t/pos_move02_t/pos_move03_t red/blue/gray
  $scope.getTClass = function (str) {
    if (str.indexOf("▲") >= 0) {
      return "pos_move01_t";
    } else if (str.indexOf("▼") >= 0) {
      return "pos_move02_t";
    } else {
      return "pos_move03_t";
    }
  };

  // get B Class: pos_move01_b/pos_move02_b/pos_move03_b red/blue/gray
  $scope.getBClass = function (str) {
    if (str.indexOf("▲") >= 0) {
      return "pos_move01_b";
    } else if (str.indexOf("▼") >= 0) {
      return "pos_move02_b";
    } else {
      return "pos_move03_b";
    }
  };
  $scope.getXClass = function (clazz, str) {
    if (str.indexOf("▲") >= 0) {
      return clazz + "01";
    } else if (str.indexOf("▼") >= 0) {
      return clazz + "02";
    } else {
      return clazz + "03";
    }
  };

  // 매출액 챠트 / 매출건수 챠트 toggle
  $scope.toggleSaleTypeRadioBtn = function (saleType) {
    if (saleType === "amt") {
      $scope.saleType = "amt";
    } else {
      $scope.saleType = "count";
    }
    if ($scope.currentTab == "daily") {
      if (saleType === "amt") {
        $scope.initDailyChart();
      } else {
        $scope.initDailyCntChart();
      }
    } else if ($scope.currentTab == "weekly") {
      if (saleType === "amt") {
        $scope.initWeeklyChart();
      } else {
        $scope.initWeeklyCntChart();
      }
    } else if ($scope.currentTab == "monthly") {
      if (saleType === "amt") {
        $scope.initMonthlyChart();
      } else {
        $scope.initMonthlyCntChart();
      }
      $scope.initMonthlyCalendar();
    }
  };

  // 주간탭에서 - 일별매출 클릭 시 이벤트목록 토글
  $scope.toggleEventList = function (id, index) {
    $scope.getPosEventList(index);
    if ($("#" + id).is(":visible")) {
      $("#" + id).hide();
    } else {
      $("#" + id).show();
    }
  };

  /////////////////////////////////////////////////////////////////////////////////////////////
  //// 버튼 처리 - POS관리, 알림설정
  /////////////////////////////////////////////////////////////////////////////////////////////
  $scope.shareStatus = true;
  $scope.shareCheck = function () {
    if ($stateParams.type === "sharedshop") {
      $scope.shareStatus = true;
    } else {
      $scope.shareStatus = false;
    }
  };

  //포스 정보 입력 화면
  $scope.showPosInfoInputLayer = function () {
    $scope.isShowPosInfoInputLayer = true;
  };
  $scope.closePosInfoInputLayer = function () {
    $scope.isShowPosInfoInputLayer = false;
  };

  //포스 수정
  $scope.showPosEditManageLayer = function (posInfo) {
    Pos.getPosInfo({
      shopId: $stateParams.id,
      posId: posInfo.posId
    }, function (data) {
      $scope.targetPosInfo = data.pos;
      $scope.editPosName = $scope.targetPosInfo.posName;
      $scope.editPosCamera = $scope.targetPosInfo.cameraId;
    }, function (err) {});
    $scope.isShowPosEditManageLayer = true;
  };
  $scope.closePosEditManageLayer = function () {
    $scope.isShowPosEditManageLayer = false;
  };

  //포스관리 팝업
  $scope.showPosManageLayer = function () {
    if ($scope.shareStatus == true) {
      showAlert("POS 관리", $translate.instant("ACCESS_SHARED_MARKET_DESC"));
      return;
    }
    Pos.getShopPosList({
      shopId: $stateParams.id,
      install: "no"
    }, function (data) {
      $scope.notInstallPosList = data.posLit;
    }, function (err) {});
    $scope.isShowPosManageLayer = true;
  };
  $scope.closePosManageLayer = function () {
    $scope.isShowPosManageLayer = false;
  };
  $scope.saveEditPosInfo = function () {
    $scope.editPosName = $("#editPosName").val();
    $scope.editPosCamera = $("#editPosCamera").val();
    Pos.updatePos({
      shopId: $stateParams.id,
      posId: $scope.targetPosInfo.posId,
      cameraId: $scope.editPosCamera
    }, {
      posName: $scope.editPosName
    }, function (data) {
      $scope.getShopPosList();
      $scope.isShowPosEditManageLayer = false;
      showAlert("POS 수정", "POS 정보가 수정되었습니다.");
    }, function (err) {
      showAlert("POS 수정", "POS 정보 수정에 실패하였습니다. 다시 시도해주세요.");
    });
  };
  $scope.saveCreatePosInfo = function () {
    $scope.createPosName = $("#createPosName").val();
    $scope.selectNotInstallPos = $("#selectNotInstallPos").val();
    $scope.selectPosInCamera = $("#selectPosInCamera").val();
    if ($scope.createPosName == "") {
      showAlert("POS 등록", "POS 이름을 입력하세요.");
      return;
    }
    if ($scope.selectNotInstallPos == "") {
      showAlert("POS 등록", "POS를 선택해주세요.");
      return;
    }
    if ($scope.selectPosInCamera == "") {
      showAlert("POS 등록", "카메라를 선택해주세요.");
      return;
    }
    Pos.insertPos({
      shopId: $stateParams.id,
      posId: $scope.selectNotInstallPos,
      cameraId: $scope.selectPosInCamera
    }, {
      posName: $scope.createPosName
    }, function (data) {
      Pos.getShopPosList({
        shopId: $stateParams.id,
        install: "no"
      }, function (data) {
        $scope.notInstallPosList = data.posLit;
      }, function (err) {});
      $timeout(function () {
        $scope.getShopPosList();
      }, 1000);
      showAlert("POS 등록", "POS가 등록되었습니다.");
    }, function (err) {
      showAlert("POS 등록", "POS 정보 등록에 실패하였습니다. 다시 시도해주세요.");
    });
  };
  $scope.changeAlertSettingAllAlert = function (type) {
    $scope.alertSettingAllAlert = type;
  };
  $scope.changeAlertSettingOnOff = function (type) {
    $scope.alramSettingOnOff = type;
  };

  // 이벤트 리스트에 표기하는 날짜 문자열 반환
  var dateWithDateIndex = function dateWithDateIndex(dateIndex) {
    //var now = moment().tz($scope.timeline.tz);
    var now = moment();
    var dateString = "";
    if (now == undefined) {
      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1; //January is 0!

      var yyyy = today.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }
      var dateString = yyyy + "" + mm + "" + dd;
    } else {
      dateString = now.subtract(dateIndex, "days").format("YYYYMMDD");
    }
    return dateString;
  };
  var eventGroupTmp = [];
  // 이벤트 리스트 날짜 이동 처리
  $scope.pressedEventListDateButton = function (index) {
    $scope.showSelectColor = false;
    $scope.selectedEventDateIndex = index;
    var selectedDate = dateWithDateIndex(index);
    var allFilteredZoneIds = $scope.getAllFilteredZonesIds();
    $scope.eventLists = {};
    if ($scope.shareStatus == false) {
      Pos.getEventList({
        shopId: $stateParams.id,
        date: selectedDate,
        posId: $scope.selectPosVal,
        eventTps: allFilteredZoneIds.join(",")
      }, function (data) {
        $scope.pressEventDailyDataSet(data.events, index);
      }, function (err) {
        setTimeout(function () {
          if (errCnt == 0) {
            location.reload();
            errCnt++;
          } else {
            setTimeout(function () {
              location.reload();
            }, 150);
          }
        }, 150);
      });
    } else {
      Pos.getEventList({
        shopId: $stateParams.id,
        date: selectedDate,
        posId: $scope.selectPosVal,
        eventTps: allFilteredZoneIds.join(",")
      }, function (data) {
        $scope.pressEventDailyDataSet(data.events, index);
      }, function (err) {
        setTimeout(function () {
          if (errCnt == 0) {
            location.reload();
            errCnt++;
          } else {
            setTimeout(function () {
              location.reload();
            }, 150);
          }
        }, 150);
      });
    }
  };

  //이벤트 리스트 날짜 이동시 이벤트 리스트 목록에 출력하는 화면 생성
  $scope.pressEventDailyDataSet = function (data, index) {
    if ($scope.serviceDay == 0) {
      return;
    }
    $("#eventListArea").css("height", $("#eventList_list").height() - 74);
    for (i = 0; i < data.length; i++) {
      var posInfo = _.find($scope.posList, {
        posId: data[i].posId
      });
      data[i]["posName"] = posInfo.posName;
    }
    $scope.eventLists = data;
  };
  $scope.initFilterMarkFlag = true;
  /**
   * 이벤트 존 ajax 호출 및 필터 on / off 셋팅
   * @return {Promise}
   */
  var getEventTypeList = function getEventTypeList() {
    var deferred = $q.defer();
    Pos.getEventType({
      shopId: $stateParams.id,
      posId: $stateParams.posId
    }, function (res) {
      $scope.eventGroup_pay = [];
      $scope.eventGroup_cancel = [];
      $scope.eventGroup_pos = [];
      $scope.eventGroup_open_close = [];
      $scope.eventTypeList = [];
      $scope.eventTypeList = res.eventCodes;
      if ($scope.initFilterMarkFlag) {
        for (i = 0; i < $scope.eventTypeList.length; i++) {
          $scope.eventTypeList[i].filterMark = "on";
        }
        $scope.initFilterMarkFlag = false;
      }
      $scope.eventGroup_pay.push($scope.eventTypeList.filter(function (value) {
        return value.posEventCodeId == "1";
      })[0]);
      $scope.eventGroup_pay.push($scope.eventTypeList.filter(function (value) {
        return value.posEventCodeId == "102";
      })[0]);
      $scope.eventGroup_cancel.push($scope.eventTypeList.filter(function (value) {
        return value.posEventCodeId == "101";
      })[0]);
      $scope.eventGroup_cancel.push($scope.eventTypeList.filter(function (value) {
        return value.posEventCodeId == "103";
      })[0]);
      $scope.eventGroup_cancel.push($scope.eventTypeList.filter(function (value) {
        return value.posEventCodeId == "104";
      })[0]);
      $scope.eventGroup_cancel.push($scope.eventTypeList.filter(function (value) {
        return value.posEventCodeId == "105";
      })[0]);
      $scope.eventGroup_pos.push($scope.eventTypeList.filter(function (value) {
        return value.posEventCodeId == "201";
      })[0]);
      $scope.eventGroup_pos.push($scope.eventTypeList.filter(function (value) {
        return value.posEventCodeId == "202";
      })[0]);
      $scope.eventGroup_pos.push($scope.eventTypeList.filter(function (value) {
        return value.posEventCodeId == "205";
      })[0]);
      $scope.eventGroup_open_close.push($scope.eventTypeList.filter(function (value) {
        return value.posEventCodeId == "203";
      })[0]);
      $scope.eventGroup_open_close.push($scope.eventTypeList.filter(function (value) {
        return value.posEventCodeId == "204";
      })[0]);
      $scope.pressedEventListDateButton($scope.selectedEventDateIndex);
      deferred.resolve();
    }, function (err) {
      showAlert("통신장애", "서버와 통신중 장애가 발생하였습니다. <br>잠시 후 다시 시도해주세요.");
      deferred.reject();
    });
    return deferred.promise;
  };
  $scope.getShopPosList = function (init) {
    var promise;
    if ($stateParams.type === "camera") {
      promise = Camera.getList().$promise;
    } else if ($stateParams.type === "shop" && typeof $stateParams.id !== "undefined") {
      promise = Shop.getShopV2({
        shopId: $stateParams.id
      }).$promise;
    } else if ($stateParams.type === "group" && typeof $stateParams.id !== "undefined") {
      promise = CameraGroup.getGroupDetail({
        groupId: $stateParams.id
      }).$promise;
    } else if ($stateParams.type === "sharedshop" && typeof $stateParams.id !== "undefined") {
      promise = Shop.getSharedShopV2({
        shopId: $stateParams.id
      }).$promise;
    }
    $scope.selectCameraId = $stateParams.cameraId;
    var promise2 = Pos.getShopPosList({
      shopId: $scope.shopId
    }).$promise;
    $q.all([promise, promise2]).then(function (res) {
      if ($stateParams.type === "camera") {
        $scope.cameraList = res[0];
      } else {
        if ($stateParams.type === "shop" || $stateParams.type === "sharedshop") {
          $scope.cameraList = _.map(_.filter(res[0].controllerList, ["deviceType", "CAMERA"]), "cameraInfo");
        } else {
          $scope.cameraList = res[0].cameras;
        }
      }
      $scope.posList = res[1].posLit;
      $scope.posCameraList = [];
      var filterPosCamera;
      for (i = 0; i < $scope.posList.length; i++) {
        if ($scope.cameraList.length > 0) {
          filterPosCamera = {};
          temp = _.find($scope.cameraList, {
            id: $scope.posList[i].cameraId
          });
          if (temp) {
            filterPosCamera["posId"] = $scope.posList[i].posId;
            filterPosCamera["posName"] = $scope.posList[i].posName;
            filterPosCamera["recorderType"] = temp.recorderType;
            filterPosCamera["id"] = temp.id;
            filterPosCamera["thumbnailPath"] = temp.thumbnailPath;
            $scope.posCameraList.push(filterPosCamera);
          }
        }
      }
      $scope.currentPosId = $stateParams.posId;
      $scope.currentPos = _.find($scope.posList, {
        posId: $stateParams.posId
      });
      $scope.selectPosVal = "";
      if (init) {
        getEventTypeList();
      } else {
        $scope.pressedEventListDateButton($scope.selectedEventDateIndex);
      }
    }, function (err) {
      showAlert("통신장애", "서버와 통신중 장애가 발생하였습니다. <br>잠시 후 다시 시도해주세요.");
    });
  };
  /**
   *	페이지 로딩시 갤러리 카메라 목록 호출
   */
  (function () {
    if (typeof $stateParams.type !== "undefined") {
      $scope.getShopPosList(true);
    }
  })();
  $scope.showSaveAlarmSettingConfirmLayer = function () {
    Pos.saveNotifyConfig({
      shopId: $stateParams.id
    }, {
      posNotifyOn: $scope.alramSettingOnOff,
      posNotifyType: $scope.alertSettingAllAlert
    }, function (data) {
      showAlert("알림 설정", "알림 설정이 저장되었습니다.");
      $scope.isShowPosAlramSettingLayer = false;
    }, function (err) {
      showAlert("알림 설정", "알림 설정 저장에 실패하였습니다.");
    });
  };

  //매출 알림 팝업
  $scope.showPosAlramSettingLayer = function () {
    if ($scope.shareStatus == true) {
      showAlert("POS 관리", $translate.instant("ACCESS_SHARED_MARKET_DESC"));
      return;
    }
    Pos.getPosNotifyConfig({
      shopId: $stateParams.id
    }, function (data) {
      $scope.alramSettingOnOff = data.posNotifyOn;
      $scope.alertSettingAllAlert = data.posNotifyType;
    }, function (err) {});
    $scope.isShowPosAlramSettingLayer = true;
  };
  $scope.closePosAlramSettingLayer = function () {
    $scope.isShowPosAlramSettingLayer = false;
  };
  $scope.changeAlertSettingAllAlert = function (type) {
    $scope.alertSettingAllAlert = type;
  };
  $scope.changeAlertSettingOnOff = function (type) {
    $scope.alramSettingOnOff = type;
  };

  /**
   * 비교할 zone data로 삭제된 이벤트를 포함
   * @param  {Array} zoneData
   * @return {Array} allFilteredZoneIdsArr 체크 처리된 zone id array. 모션존은 uid
   */
  $scope.getAllFilteredZonesIds = function (zoneData) {
    // 현재 이벤트 data의 zoneIdxs중 check 된 zoneIndex 여부 확인
    var filteredEventZoneIdsArr = _.map(_.filter($scope.eventTypeList, ["filterMark", "on"]), "posEventCodeId");
    return filteredEventZoneIdsArr;
  };
  $scope.formattedDateNotYo = function (date) {
    var md;
    md = moment(new Date(date));
    var videoDateFormat = "YYYY.MM.DD(ddd)";
    return md.locale(Utils.getBrowserLanguage()).format(videoDateFormat);
  };
  $scope.showPosDetailLayer = function (event, type) {
    $scope.replaceShow = false;
    $scope.currentEventInfo = event;
    $scope.billAreaHeight = "535px";
    if (type) {
      $scope.showPosVideoLayer();
    }
    if (!event.billNo || event.billNo == "") {
      $scope.billDetailInfo = {};
      $scope.billDetailInfo.billNo = "-";
      $scope.billDetailInfo.eventNm = event.eventNm;
      $scope.billDetailInfo.barColor = event.color;
      $scope.billDetailInfo.eventDate = moment(event.start).format("YYYY-MM-DD HH:mm:ss");
      $scope.isShowPosDetailLayer = true;
      return;
    }
    if (!event.salesTm) {
      event.salesTm = moment(event.start).format("YYYYMMDD");
    }
    Pos.getBillDetail({
      shopId: event.shopId,
      posId: event.posId,
      billNo: event.billNo,
      date: event.salesTm
    }, function (data) {
      if (data.code == "ok") {
        $scope.billDetailInfo = data.detail;
        $scope.billDetailInfo.billNo = event.billNo;
      } else {
        $scope.billDetailInfo = {};
        $scope.billDetailInfo.billNo = "-";
      }
      $scope.billDetailInfo.barColor = event.color;
      $scope.billDetailInfo.eventNm = event.eventNm;
      $scope.billDetailInfo.eventDate = moment(event.start).format("YYYY-MM-DD HH:mm:ss");
      $scope.isShowPosDetailLayer = true;
    }, function (err) {
      showAlert("통신장애", "서버와 통신중 장애가 발생하였습니다. <br>잠시 후 다시 시도해주세요.");
    });
  };
  $scope.closePosDetailLayer = function () {
    $scope.isShowPosVideoArea = false;
    $interval.cancel($scope.vedioTimer);
    $scope.isShowPosDetailLayer = false;
    $scope.currentEventInfo = {};
  };
  $scope.goCloudPurchase = function () {
    $state.go("main.help.inquiry", {
      type: "cam_buy"
    });
  };
  $scope.vedioHeightArea = "250px";
  $scope.billAreaHeight = "535px";
  //상세 매출 영상 보기
  $scope.showPosVideoLayer = function () {
    $scope.replaceShow = false;
    $scope.vedioPosInfo = _.find($scope.posList, {
      posId: $scope.currentEventInfo.posId
    });
    $scope.billAreaHeight = "240px";
    $scope.videoCursorPosition = 0;
    $scope.videoDuration = "-1:00";
    $scope.clipStartTime = moment($scope.currentEventInfo.start, "x").subtract(30, "seconds").format("HH:mm:ss");
    $scope.clipEndTime = moment($scope.currentEventInfo.start, "x").add(30, "seconds").format("HH:mm:ss");
    $scope.vedioStartTime = moment($scope.currentEventInfo.start, "x").subtract(30, "seconds");
    $scope.vedioEndTime = moment($scope.currentEventInfo.start, "x").add(30, "seconds");
    $scope.isShowPosVideoLayer = true;
    $scope.isShowPosVideoArea = true;
    $scope.playStatusObj.status = $scope.playStatusType.READY;
    $scope.playStatusObj.errorStatus = $scope.playErrorType.NONE;
    $scope.play($scope.vedioStartTime.toDate());
    $scope.vedioTime = $scope.vedioStartTime;
    setTimeout(function () {
      startVideoTimer();
    }, 1000);
  };
  $scope.closePosVideoLayer = function () {
    $scope.billAreaHeight = "535px";
    $scope.isShowPosVideoLayer = false;
    $scope.isShowPosVideoArea = false;
    $scope.player.pause();
    $interval.cancel($scope.vedioTimer);
  };
  $scope.player = tCam.htmlSimplePlayer({
    elId: "player"
  });
  $scope.isShowFullscreenButton = true;
  $scope.play = function (time) {
    var serviceDateTime = new Date().valueOf() - 1000 * 60 * 60 * 24 * ($scope.serviceDay - 1);
    if (serviceDateTime > time) {
      //return;
      time = new Date(serviceDateTime + 3000);
    }
    if ($scope.player) {
      $scope.player.stop();
    }
    $scope.playStatusObj.status = $scope.playStatusType.READY;
    $scope.playStatusObj.errorStatus = $scope.playErrorType.NONE;
    $scope.clickTime = time;
    var tokenPromise = {},
      detailPromise = {},
      timelinePromise = {};
    if ($scope.shareStatus == true) {
      detailPromise = Share.get({
        id: $stateParams.cameraId
      }).$promise;
      tokenPromise = Share.getToken({
        id: $stateParams.cameraId
      }).$promise;
    } else {
      detailPromise = Camera.get({
        id: $stateParams.cameraId
      }).$promise;
      tokenPromise = Camera.getToken({
        id: $stateParams.cameraId
      }).$promise;
    }
    $scope.isLive = false;
    $q.all([tokenPromise, detailPromise]).then(function (data) {
      if ($scope.isShowPosVideoArea) {
        $scope.token = data[0];
        var camDetail = data[1];
        if (camDetail.code !== "ok") {
          $scope.playStatusObj.status = $scope.playStatusType.ERROR;
          $scope.playStatusObj.errorStatus = $scope.playErrorType.NO_CAM;
          return;
        }
        if (!camDetail.cloud) {
          $scope.playStatusObj.status = $scope.playStatusType.ERROR;
          $scope.playStatusObj.errorStatus = $scope.playErrorType.NO_CLOUD;
          return;
        }
        var playTime = time.getTime();
        var checkStartTime = playTime - 100 * 1000;
        var checkEndTime = playTime + 100 * 1000;
        var params = {
          id: $stateParams.cameraId,
          start: checkStartTime,
          end: checkEndTime
        };
        timelinePromise = $scope.shareStatus ? Share.newTimeline(params).$promise : Camera.newTimeline(params).$promise;
        timelinePromise.then(function (td) {
          var isCvrExist = false;
          if (td.recTimes && td.recTimes.length) {
            isCvrExist = td.recTimes.some(function (recTime) {
              var startTime = parseInt(recTime.startTime, 10);
              var endTime = parseInt(recTime.endTime, 10);
              return startTime <= playTime && endTime >= playTime;
            });
          }
          if (!isCvrExist) {
            $scope.playStatusObj.status = $scope.playStatusType.ERROR;
            $scope.playStatusObj.errorStatus = $scope.playErrorType.NO_TIMELINE;
            return;
          }
          $scope.player.play(Utils.getLiveServerUrl(camDetail.mediaStreamURL) + "/flvplayback/" + $stateParams.cameraId + "?token=" + $scope.token.token + "&time=" + time.getTime());
          $scope.playStatusObj.status = $scope.playStatusType.PLAYING;
          $scope.playStatusObj.errorStatus = $scope.playErrorType.NONE;
          $scope.plyBtnStatus = true;
        });
      }
    });
  };
  var fullScreenMakeView = 0;
  var fullScreenWidth = 0;
  $scope.pressedFullScreenButton = function () {
    //posTimelineDragCnt = 0;
    $scope.isFullscreenButtonClicked = true;
    if (navigator.userAgent.indexOf("MSIE") !== -1 || navigator.appVersion.indexOf("Trident/") > 0) {
      var rv = 0;
      var ua = navigator.userAgent;
      var re = new RegExp("MSIE ([0-9]{1,}[.0-9]{0,})");
      if (re.exec(ua) != null) rv = parseFloat(RegExp.$1);
      if (rv != 0 && rv <= 10) {
        showAlert($translate.instant("EXPLORE_UNDER10_SUBJECT"), $translate.instant("EXPLORE_UNDER10_CONTENT1") + "<br>" + $translate.instant("EXPLORE_UNDER10_CONTENT2") + "<br>" + $translate.instant("EXPLORE_UNDER10_CONTENT3"));
        return;
      }
    }
    var element = document.getElementById("fullscreen");
    $scope.vedioHeightArea = "100%";
    if (element.requestFullscreen) {
      element.requestFullscreen();
    } else if (element.mozRequestFullScreen) {
      element.mozRequestFullScreen();
    } else if (element.webkitRequestFullscreen) {
      element.webkitRequestFullscreen();
    } else if (element.msRequestFullscreen) {
      element.msRequestFullscreen();
    }
    if ($scope.currentZoom > 1) {
      $scope.isShowTimelineToggleArea = false;
    } else {
      $scope.isShowTimelineToggleArea = true;
    }
    fullscreenFlag = true;
    $scope.isShowFullscreenButton = false;
    setTimeout(function () {
      fullScreenWidth = parseInt(d3.select("#videoBar").style("width"));
      var tempPosition = $scope.videoCursorPosition * (fullScreenWidth / 450);
      if (fullScreenWidth < tempPosition) {
        $scope.videoCursorPosition = fullScreenWidth;
      } else if (tempPosition < 0) {
        $scope.videoCursorPosition = 0;
      } else {
        $scope.videoCursorPosition = tempPosition;
      }
    }, 100);
    $("#footer").hide();
    $("#header").hide();
  };
  $scope.pressedExitFullScreenButton = function () {
    $scope.isFullscreenButtonClicked = true;
    $scope.vedioHeightArea = "250px";
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    }
    fullscreenFlag = false;
    $scope.isShowFullscreenButton = true;
    setTimeout(function () {
      barWidth = parseInt(d3.select("#videoBar").style("width"));
      var tempPosition = $scope.videoCursorPosition * (barWidth / fullScreenWidth);
      if (barWidth < tempPosition) {
        $scope.videoCursorPosition = barWidth;
      } else if (tempPosition < 0) {
        $scope.videoCursorPosition = 0;
      } else {
        $scope.videoCursorPosition = tempPosition;
      }
    }, 50);
    $("#footer").show();
    $("#header").show();
  };
  var duration = 60;
  var barWidth = parseInt(d3.select("#videoBar").style("width"));
  var videoDrag = d3.behavior.drag().on("drag", function (e) {
    var x = d3.mouse(this)[0]; // for cursur center
    $scope.videoCursorPosition = x;
  }).on("dragstart", function () {
    $interval.cancel($scope.vedioTimer);
  }).on("dragend", function () {
    var x = d3.mouse(this)[0]; // for cursur center
    $scope.videoCursorPosition = x;
    barWidth = parseInt(d3.select("#videoBar").style("width"));
    var diffTime = Math.round(duration * ($scope.videoCursorPosition / barWidth));
    $scope.vedioTime = moment($scope.vedioStartTime).add(diffTime, "seconds");
    $scope.play($scope.vedioTime.toDate());
    setTimeout(function () {
      startVideoTimer();
    }, 1000);
  });
  d3.select("#videoCursor").call(videoDrag);
  d3.select("#videoBar").on("click", function () {
    var x = d3.mouse(this)[0]; // for cursur center
    $scope.videoCursorPosition = x;
    barWidth = parseInt(d3.select("#videoBar").style("width"));
    var diffTime = Math.round(duration * ($scope.videoCursorPosition / barWidth));
    $scope.vedioTime = moment($scope.vedioStartTime).add(diffTime, "seconds");
    $scope.play($scope.vedioTime.toDate());
  });
  var startVideoTimer = function startVideoTimer() {
    $interval.cancel($scope.vedioTimer);
    $scope.vedioTimer = $interval(function () {
      if ($scope.player.getIsPlaying()) {
        barWidth = parseInt(d3.select("#videoBar").style("width"));
        var tempCurser = $scope.videoCursorPosition + barWidth / 60;
        $scope.vedioTime = moment(moment($scope.vedioTime, "x").add(1, "seconds"));
        var endTime = $scope.vedioEndTime;
        var vidioTimeDiff = moment(endTime).diff($scope.vedioTime, "seconds");
        $scope.videoDuration = "-0:" + vidioTimeDiff;
        if (tempCurser >= barWidth) {
          tempCurser = barWidth;
        }
        $scope.videoCursorPosition = tempCurser;
        if (vidioTimeDiff == 0) {
          $scope.player.pause();
          $scope.replaceShow = true;
          $interval.cancel($scope.vedioTimer);
        }
      }
    }, 1000);
  };
  $scope.replaceShow = false;
  $scope.isPlayed = false;
  $scope.goCameraDetail = function () {
    var goTime = moment($scope.vedioStartTime).format("x");
    $state.go("main.cameraDetail", {
      cameraId: $stateParams.cameraId,
      type: $stateParams.type === "sharedshop" ? $stateParams.type : "shop",
      id: $stateParams.id,
      time: goTime,
      shared: $stateParams.type === "sharedshop"
    });
  };
  $scope.vedioPlay = function () {
    //$scope.player.control.play();
    $scope.play($scope.vedioTime.toDate());
    // $interval.cancel($scope.vedioTimer);
    startVideoTimer();
    $scope.isPlayed = false;
    $scope.isShowAnimate = false;
  };
  $scope.vedioStop = function () {
    $scope.player.pause();
    $scope.isPlayed = true;
    $scope.isShowAnimate = true;
    $interval.cancel($scope.vedioTimer);
  };
  $scope.clipsReplay = function () {
    $scope.play($scope.vedioStartTime.toDate());
    $scope.vedioTime = $scope.vedioStartTime;
    $scope.videoCursorPosition = 0;
    $scope.replaceShow = false;
    startVideoTimer();
  };
  var fullscreenChangeEvent = function fullscreenChangeEvent() {
    //  커서가 bar 밖으로 나가지 않도록 보정
    if (!$scope.isFullscreenButtonClicked) {
      $scope.isFullscreenButtonClicked = false;
      setTimeout(function () {
        $scope.vedioHeightArea = "250px";
        fullscreenFlag = false;
        $scope.isShowFullscreenButton = true;
        barWidth = parseInt(d3.select("#videoBar").style("width"));
        var tempPosition = $scope.videoCursorPosition * (barWidth / fullScreenWidth);
        if (barWidth < tempPosition) {
          $scope.videoCursorPosition = barWidth;
        } else if (tempPosition < 0) {
          $scope.videoCursorPosition = 0;
        } else {
          $scope.videoCursorPosition = tempPosition;
        }
      });
    } else {
      $scope.isFullscreenButtonClicked = false;
    }
  };
  d3.select("#fullscreen").on("fullscreenchange", fullscreenChangeEvent);
  d3.select("#fullscreen").on("webkitfullscreenchange", fullscreenChangeEvent);
  d3.select("#fullscreen").on("mozfullscreenchange", fullscreenChangeEvent);
  d3.select(document).on("MSFullscreenChange", fullscreenChangeEvent);
  $scope.goCameraDetail = function () {
    var goTime = moment($scope.vedioStartTime).format("x");
    $state.go("main.cameraDetail", {
      cameraId: $stateParams.cameraId,
      type: $stateParams.type === "sharedshop" ? $stateParams.type : "shop",
      id: $stateParams.id,
      time: goTime,
      shared: $stateParams.type === "sharedshop"
    });
  };

  // 이벤트 공유 팝업 open
  var eventClipStartTime = 0;
  var eventClipEndTime = 0;
  var eventClipCameraId = "";
  $scope.showEventShareInfoLayer = function () {
    if ($scope.shareStatus == true) {
      showAlert("POS 관리", $translate.instant("ACCESS_SHARED_MARKET_DESC"));
      return;
    }
    eventClipStartTime = moment($scope.currentEventInfo.start, "x").subtract(30, "seconds").format("x");
    eventClipEndTime = moment($scope.currentEventInfo.start, "x").add(30, "seconds").format("x");
    var getCameraId = _.find($scope.posList, {
      posId: $scope.currentEventInfo.posId
    });
    eventClipCameraId = getCameraId.cameraId;
    $scope.isShowEventShareInfoLayer = true;
  };

  // 이벤트 클립 생성
  $scope.createEventClip = function () {
    if (eventClipStartTime > eventClipEndTime) {
      showAlert($translate.instant("CLIPS_ERR_TIME_SUBJECT"), $translate.instant("CLIPS_ERR_TIME_CONTENT"));
      return;
    } else if (eventClipStartTime == eventClipEndTime) {
      showAlert($translate.instant("CLIPS_ERR_TIME_SUBJECT"), $translate.instant("CLIPS_ERR_TIME_CONTENT"));
      return;
    }
    if (eventClipEndTime - eventClipStartTime < 5 * 1000 || eventClipEndTime - eventClipStartTime > 2 * 60 * 60 * 1000) {
      showAlert($translate.instant("CLIPS_ERR_TIME_SUBJECT"), "5초에서 120분 이내의 영상만 클립만들기가 가능합니다.");
      return;
    }
    var params = {
      cameraId: eventClipCameraId,
      labelName: "새로운 클립",
      start: eventClipStartTime,
      end: eventClipEndTime,
      timeOverlay: "NO",
      speedx: "1",
      type: "0"
    };
    Clip.save(params, function (data) {
      if (data.code === "ok") {
        showAlert($translate.instant("MENU_CLIP"), $translate.instant("CLIPS_MAKE"));
        $scope.isShowEventShareInfoLayer = false;
      } else if (data.code === "nok" && data.ableTime !== undefined) {
        showAlert("클립생성용량초과", "클립 저장 공간이 다 찼습니다.<br>클립을 다운로드 하거나 삭제해주세요.");
      } else {
        showAlert($translate.instant("MENU_CLIP"), $translate.instant("CLIPS_MAKE_CANNOT"));
      }
    }, function (err) {
      showAlert("통신장애", "서버와 통신중 장애가 발생하였습니다. <br>잠시 후 다시 시도해주세요.");
    });
  };
  // 이벤트 공유 팝업 close
  $scope.hideEventShareInfoLayer = function () {
    $scope.isShowEventShareInfoLayer = false;
  };

  /**
   * init 2
   */
  (function () {
    $scope.shareCheck();
  })();
}]);
"use strict";

app.controller('DashboardPosItemCtrl', ['PosSummary', 'Pos', '$scope', 'Shop', 'Access', '$filter', '$q', '$state', '$stateParams', '$translate', '$timeout', '$interval', 'Camera', 'Share', 'Clip', function (PosSummary, Pos, $scope, Shop, Access, $filter, $q, $state, $stateParams, $translate, $timeout, $interval, Camera, Share, Clip) {
  $scope.accessDate = Date.now();
  $scope.accessDateText = '';
  $scope.todayL = moment().valueOf();
  $scope.yesterdayL = moment().subtract(1, 'days').valueOf();
  $scope.beforeYesterdayL = moment().subtract(2, 'days').valueOf();
  $scope.weekDays = ['일', '월', '화', '수', '목', '금', '토'];
  $scope.saleType = 'amt'; // 매출액/건수 radio버튼

  $scope.startOfWeekString = moment().startOf('week').format('MM/DD');
  $scope.endOfWeekString = moment().endOf('week').format('MM/DD');
  $scope.currentTab = 'daily';
  $scope.isTodays = true;
  $scope.todaySales = {};
  $scope.salesData = {};
  $scope.itemSalesNames = ''; // 품목별 매출. 품목명
  $scope.itemSalesInfo = ''; // 품목별 매출.

  $scope.weeklyList = []; // 주간매출목록
  $scope.dailyEventsList = []; // 당일매출목록
  $scope.dailyEventsViewList = []; // 당일매출목록

  $scope.posList = []; // 포스목록

  $scope.isTop5 = true;
  $scope.formatDate = function (dateL, format) {
    return moment(dateL).format(format);
  };
  $('body').addClass('wide_scroll');
  $scope.$on('$destroy', function () {
    $(window).off("resize");
    $('body').removeClass('wide_scroll');
  });
  $scope.posItems = [];
  var showAlert = function showAlert(title, message) {
    $(".display_show").css("display", "");
    $scope.showAlert = true;
    $scope.alertTitle = title;
    $scope.alertMessage = message;
  };

  // 매장조회
  $scope.getShop = function (shopId) {
    // 매장조회
    Shop.getShopV2({
      shopId: shopId
    }, function (res) {
      $scope.shop = res;
      if (res.code === 'nok') {
        Shop.getSharedShopV2({
          shopId: shopId
        }, function (res2) {
          $scope.shop = res2;
        }, function (err) {
          showAlert("통신장애", "서버와 통신중 장애가 발생하였습니다. <br>잠시 후 다시 시도해주세요.");
        });
      }
    }, function (err) {
      showAlert("통신장애", "서버와 통신중 장애가 발생하였습니다. <br>잠시 후 다시 시도해주세요.");
    });
  };

  // 일간 매출
  $scope.getSalesDaily = function (shopId) {
    $scope.currentTab = 'daily';
    var date = moment($scope.accessDate).format('YYYYMMDD');
    $scope.isLoadingComplete = false;
    PosSummary.getSalesDaily({
      shopId: shopId,
      date: date
    }, function (res) {
      $scope.isLoadingComplete = true;
      $scope.salesData = res;
      $scope.setItemPrice(); // 가격설정
      $scope.sortItemSale($scope.currentSortKey, $scope.itemSortDirection[$scope.currentSortKey]);
      if ($scope.salesData && $scope.salesData.salesInfo && $scope.salesData.salesInfo.posItems) {
        $scope.posItems = $scope.salesData.salesInfo.posItems;
      }
    }, function (err) {
      $scope.isLoadingComplete = true;
      showAlert("통신장애", "서버와 통신중 장애가 발생하였습니다. <br>잠시 후 다시 시도해주세요.");
    });
  };

  // 주간 매출
  $scope.getSalesWeekly = function (shopId) {
    $scope.currentTab = 'weekly';
    var date = moment($scope.accessDate).startOf('week').format('YYYYMMDD');
    $scope.isLoadingComplete = false;
    PosSummary.getSalesWeekly({
      shopId: shopId,
      date: date
    }, function (res) {
      $scope.isLoadingComplete = true;
      $scope.salesData = res;
      $scope.setItemPrice(); // 가격설정
      $scope.sortItemSale($scope.currentSortKey, $scope.itemSortDirection[$scope.currentSortKey]);
      if ($scope.salesData && $scope.salesData.salesInfo && $scope.salesData.salesInfo.posItems) {
        $scope.posItems = $scope.salesData.salesInfo.posItems;
      }
    }, function (err) {
      $scope.isLoadingComplete = true;
      showAlert("통신장애", "서버와 통신중 장애가 발생하였습니다. <br>잠시 후 다시 시도해주세요.");
    });
  };

  // 월간 매출
  $scope.getSalesMonthly = function (shopId) {
    $scope.currentTab = 'monthly';
    var date = moment($scope.accessDate).startOf('month').format('YYYYMMDD');
    $scope.isLoadingComplete = false;
    PosSummary.getSalesMonthly({
      shopId: shopId,
      date: date
    }, function (res) {
      $scope.isLoadingComplete = true;
      $scope.salesData = res;
      $scope.setItemPrice(); // 가격설정
      $scope.sortItemSale($scope.currentSortKey, $scope.itemSortDirection[$scope.currentSortKey]);
      if ($scope.salesData && $scope.salesData.salesInfo && $scope.salesData.salesInfo.posItems) {
        $scope.posItems = $scope.salesData.salesInfo.posItems;
      }
    }, function (err) {
      $scope.isLoadingComplete = true;
      showAlert("통신장애", "서버와 통신중 장애가 발생하였습니다. <br>잠시 후 다시 시도해주세요.");
    });
  };

  // 가격계산
  $scope.setItemPrice = function () {
    if ($scope.salesData.salesInfo.posItems && $scope.salesData.salesInfo.posItems.length) {
      //itemPrice 설정
      for (var i = 0; i < $scope.salesData.salesInfo.posItems.length; i++) {
        var itemTemp = $scope.salesData.salesInfo.posItems[i];
        if (itemTemp.itemCnt === '0') {
          itemTemp.itemPrice = 0;
        } else {
          itemTemp.itemPrice = itemTemp.itemSort / Number(itemTemp.itemCnt);
        }
      }
    }
  };

  // 매출 팝업 정렬처리
  $scope.currentSortKey = "itemSort";
  $scope.itemSortDirection = {
    itemPrice: 1,
    itemCnt: 1,
    itemSort: -1
  };

  // 매출 팝업 정렬처리
  $scope.sortItemSalePopup = function (key) {
    if (key === $scope.currentSortKey) {
      $scope.itemSortDirection[key] *= -1;
    } else {
      $scope.itemSortDirection = {
        itemPrice: 1,
        itemCnt: 1,
        itemSort: 1
      };
    }
    $scope.currentSortKey = key;
    $scope.sortItemSale($scope.currentSortKey, $scope.itemSortDirection[key]);
  };

  //포스item 정렬
  //  key 정렬필드명 문자값
  //  direction 1: asc, -1: desc
  $scope.sortItemSale = function (key, direction) {
    $scope.salesData.salesInfo.posItems.sort(function (a, b) {
      return Number(a[key]) < Number(b[key]) ? -1 * direction : Number(a[key]) > Number(b[key]) ? 1 * direction : 0;
    });
  };

  //매출상세 팝업
  $scope.showPosItems = function () {
    $scope.currentSortKey = "itemCnt";
    $scope.sortItemSalePopup("itemPrice");
    $scope.isShowPosItems = true;
  };
  $scope.closePosItems = function () {
    $scope.isShowPosItems = false;
  };

  // 포스목록 조회
  $scope.initPosList = function () {
    Pos.getShopPosList({
      shopId: $scope.shopId
    }, function (data) {
      $scope.posList = data.posLit;
    }, function (err) {});
  };

  // 포스명 조회
  $scope.getPosName = function (posId) {
    var pos = $.grep($scope.posList, function (e) {
      return e.posId === posId;
    });
    if (pos.length > 0) {
      return pos[0].posName;
    }
    return '';
  };

  // 달력의 날짜표시 영역 설정
  $scope.setAccessDateText = function () {
    var accessDateMoment = moment($scope.accessDate);
    if ($scope.currentTab === 'daily') {
      $scope.accessDateText = accessDateMoment.format('YYYY.MM.DD(') + $scope.weekDays[accessDateMoment.weekday()] + ')';
    } else if ($scope.currentTab === 'weekly') {
      $scope.accessDateText = accessDateMoment.startOf('week').format('MM.DD') + "~" + accessDateMoment.startOf('week').add(6, 'days').format('MM.DD');
    } else if ($scope.currentTab === 'monthly') {
      $scope.accessDateText = accessDateMoment.format('YYYY.MM');
    }
  };
  $scope.backPage = function () {
    history.go(-1);
  };

  /**
   * init
   */
  (function () {
    // 파라미터 저장
    $scope.shopId = $state.params.shopId;
    $scope.currentTab = $state.params.currentTab;
    $scope.accessDate = moment($state.params.accessDate, 'YYYYMMDD').valueOf();

    // 매장조회
    $scope.getShop($scope.shopId);
    if ('daily' === $scope.currentTab) {
      $scope.setAccessDateText();
      $scope.getSalesDaily($scope.shopId);
    } else if ('weekly' === $scope.currentTab) {
      $scope.setAccessDateText();
      $scope.getSalesWeekly($scope.shopId);
    } else if ('monthly' === $scope.currentTab) {
      $scope.setAccessDateText();
      $scope.getSalesMonthly($scope.shopId);
    }
  })();
}]);
"use strict";

var arrEvents = new Array();
var checkFilters = new Map();
var beforeSgid = "";
var thumname_list = [];
var timeLineMap = new Map();
var show_thumname_idx = 0;
var zonesLength = 0;
var zoomZoneBottom = 149;
var zoomZoneRight = 580;
var errCnt = 0;
var liveReloadCnt = 1;
var offLayer = false;
var thumnailDraw = true;
var changeTimeRangeFlag = false;
var fullscreenFlag = false;
app.controller("DashboardPosSalesCtrl", ["$scope", "$rootScope", "$stateParams", "$state", "$interval", "Camera", "Share", "User", "CameraConfig", "CameraNotifyConfig", "Timezone", "$translate", "$timeout", "Clip", "$sce", "$q", "$compile", "$window", "Shop", "Pos", "Utils", function ($scope, $rootScope, $stateParams, $state, $interval, Camera, Share, User, CameraConfig, CameraNotifyConfig, Timezone, $translate, $timeout, Clip, $sce, $q, $compile, $window, Shop, Pos, Utils) {
  showPage();
  $scope.moveCameraListCount = 10;
  $scope.fristIndex = 30;
  $scope.lastIndex = 60;
  $scope.sortField = "salesTm";
  $scope.sorting = "desc";
  $scope.cameraName = "";
  $scope.timelineData = "";
  $scope.timelineEle = "";
  $scope.nowScale = "1h";
  $scope.tzCode = "";
  $scope.eventListCheckFlag = false;
  $scope.pressedEventListTimeButtonFlag = false;
  $scope.isAudioChat = false;
  $scope.isScreenShot = false;
  $scope.showCameraOffLayer = false;
  $scope.isLive = true;
  $scope.wifiPwdChange = false;
  $scope.showSelectColor = false;
  $scope.shareStatus = true;
  $scope.isAddShare = false;
  $scope.isRemoveShare = false;
  $scope.isPromotionCheck = false;
  $scope.volumeList = [];
  $scope.volumeIdx = 0;
  $scope.timelineDataLastDate = 0;
  $scope.eventListDateIndex = 0;
  $scope.lastEvent = 0;
  $scope.lastRec = 0;
  $scope.liveReplayCheck = 0;
  $scope.serviceDay = 0;
  $scope.cloudEnd = 0;
  $scope.currentTimeNow = {
    time: Date.now()
  };
  $scope.getContextPath = Utils.getContextPath();
  $scope.colorArray = ["#ff7900", "#3ea1d4", "#a4c800", "#efd600", "#767dff", "#ca7af0", "#ff76bd", "#18b57b", "#929292"]; //주황(ID:1),파랑(ID:2),연두(ID:3),노랑(ID:4),진한보라(ID:5),보라(ID:6),핑크(ID:7),녹색(사운드, ID:0),회색(기타, ID:8)
  $scope.colorArrayName = ["org", "sky", "grn", "yel", "blpp", "ppl", "pink"];
  var playserStop = 0;
  var timelineHideTimer;
  var cvrArray = new Array();
  $scope.filterType = $stateParams.filterType;
  $("#showThumbnailListNew").mouseleave(function () {
    $("#time_info_tri").hide();
    $("#showThumbnailListNew").hide();
  });
  $("#view_timeline_area").mouseleave(function () {
    $("#time_info_tri").hide();
    $("#showThumbnailListNew").hide();
  });
  $scope.camera = {
    id: $stateParams.cameraId
  };
  var showAlert = function showAlert(title, message) {
    $(".display_show").css("display", "");
    $scope.showAlert = true;
    $scope.alertTitle = title;
    $scope.alertMessage = message;
  };
  $scope.hideAlert = function () {
    $scope.showAlert = false;
  };
  $scope.isExpiredCloud = function () {
    if ($scope.currentCamera) {
      return Utils.isCloudExpired($scope.currentCamera);
    } else {
      return false;
    }
  };
  document.body.classList.add("wide_scroll");

  // $interval cancel
  $scope.$on("$destroy", function () {
    $("body").removeClass("wide_scroll");
    if ($scope.player) {
      $scope.player.destroy();
    }
    $interval.cancel($scope.reloadTimer); // CVR Fetch
    $interval.cancel($scope.timer); // Cursor 시간
    $interval.cancel($scope.eventThumbTimer); // 타임라인 마우스 오버시 나타나는 썸네일 반복
    $interval.cancel($scope.eventlistTimer); // 이벤트 목록 썸네일 반복
    $interval.cancel(callEvtList); //이벤트 리스트 주기적으로 호출 및 업데이트
    $interval.cancel($scope.vedioTimer);
    posTimelineDragCnt = 0;
    //	clearInterval(calluevtList);//이벤트 리스트 현재 시간 모션들 카운트
    if ($scope.clipEndDatePicker) $scope.clipEndDatePicker.destroy();
    if ($scope.clipStartDatePicker) $scope.clipStartDatePicker.destroy();
    if ($scope.timelineDatePicker) $scope.timelineDatePicker.destroy();
    if ($scope.datePicker) $scope.datePicker.destroy();
    $timeout.cancel(renderClipDatePickerTimer);
  });

  // 1분 주기로 이벤트 리스트 로딩
  callEvtList = $interval(function () {
    if ($scope.shareStatus == true) {
      $scope.shareEnd();
    }
    if ($scope.currentCamera.saveEndDate < new Date().valueOf()) {
      $interval.cancel(callEvtList);
      return;
    }
    var nowTimeCheck = new Date();
    var getTimeMin = nowTimeCheck.getMinutes();
    if (getTimeMin == 0) {
      getTimeMin = 60;
    }
    var nowHours = new Date().getHours();
    var selectedDate = dateWithDateIndex(0);
    var topEvtList = $("#btn_time_" + nowHours + "_" + selectedDate).children("button").children("span").html();
    if (parseInt(topEvtList) > 0) {
      refleshEvtList = 60;
      if ($("#btn_time_" + nowHours + "_" + selectedDate).css("display") == "none" && $scope.eventListDateIndex == 0) {
        refleshEvtList = 1;
      }
    } else {
      refleshEvtList = 2;
    }
  }, 60000);
  var initSizeTimline = function initSizeTimline() {
    $scope.timeline.redrawWithWidth(parseInt($("#view_timeline_ctrl").width()));
  };
  $scope.currentTab = "event";
  $scope.shareCheck = function () {
    if ($stateParams.type === "sharedshop") {
      $scope.shareStatus = true;
    } else {
      $scope.shareStatus = false;
    }
  };
  $scope.viewPageTop = function () {
    setTimeout(function () {
      if ($("html").attr("lang") == "en") {
        for (var i = 0; i < $(".en_en_en").length; i++) {
          $(".en_en_en").eq(i).attr("class", $(".en_en_en").eq(i).attr("class").replace("_en_en_en", "_en"));
        }
        $(".cam_info_bg_en_en_en").addClass("cam_info_bg_en");
        $(".cam_info_bg_en_en_en").removeClass("cam_info_bg");
      } else {
        $(".cam_info_bg").removeClass("cam_info_bg_en_en_en");
      }
      $(".en_en_en").removeClass("en_en_en");
      var trident = navigator.userAgent.match(/Trident\/(\d)/i);
      if (trident != null) {
        document.documentElement.scrollTop = 104;
      } else {
        $(window).scrollTop(104);
      }
    }, 500);
  };
  $scope.goDetail = function (id) {
    var trident = navigator.userAgent.match(/Trident\/(\d)/i);
    if (trident != null) {
      document.documentElement.scrollTop = 0;
    } else {
      $("body").scrollTop(0);
    }
    $state.go("main.dashboard.posView", {
      cameraId: id
    }, {
      reload: true,
      inherit: true,
      notify: true
    });
  };
  $scope.plyBtnStatus = true;
  $scope.pauseBtn = function () {
    $scope.player.pause();
    $scope.isPlaying = false;
    $scope.plyBtnStatus = false;
  };
  $scope.playBtn = function () {
    $scope.isPlaying = true;
    $scope.plyBtnStatus = true;
    $scope.cameraStatusAllOff();
    $scope.clickedCVRArea(new Date($scope.timeline.x.invert($(".cursor").children("line").attr("x1")).getTime()));
  };

  //녹화 지연
  $scope.cameraRecDelay = function () {
    $scope.showNoPlayLayer = true;
    $scope.showCameraOffLayer = false;
    $scope.showCameraStreamLayer = false;
    $scope.showNextPlayLayer = false;
  };

  //카메라 접속 끊김
  $scope.cameraConnectOff = function () {
    $scope.showNoPlayLayer = false;
    $scope.showCameraOffLayer = true;
    $scope.showCameraStreamLayer = false;
    $scope.showNextPlayLayer = false;
    Camera.isLastRecord({
      id: $stateParams.cameraId
    }, function (data) {
      $scope.currentCameraIsLastRecordDataSet(data);
    });
  };

  //저장된 영상 없음
  $scope.cameraNoSave = function () {
    $scope.showNoPlayLayer = false;
    $scope.showCameraOffLayer = false;
    $scope.showCameraStreamLayer = false;
    $scope.showNextPlayLayer = true;
  };

  //녹화가 꺼져 있음
  $scope.cameraRecOff = function () {
    $scope.showNoPlayLayer = false;
    $scope.showCameraOffLayer = false;
    $scope.showCameraStreamLayer = true;
    $scope.showNextPlayLayer = false;
  };

  //정상 플레이
  $scope.cameraStatusAllOff = function () {
    $scope.showNoPlayLayer = false;
    $scope.showCameraOffLayer = false;
    $scope.showCameraStreamLayer = false;
    $scope.showNextPlayLayer = false;
    $scope.isCameraOffLastRec = false;
    $scope.isCameraOffLastEvent = false;
  };
  $scope.cameraStatusChange = function (status) {
    lastCameraStatus = status;
    switch (status) {
      case 0:
        $scope.cameraStatusAllOff();
        break;
      case 1:
        $scope.cameraRecOff();
        break;
      case 2:
        $scope.cameraRecDelay();
        break;
      case 3:
        $scope.cameraConnectOff();
        break;
      case 4:
        $scope.cameraConnectOff();
        break;
      default:
        $scope.cameraStatusAllOff();
        break;
    }
  };
  var userIdLoading = 0;
  $scope.isPlayError = false;
  $scope.player = tCam.htmlSimplePlayer({
    elId: "player",
    eventHandler: function eventHandler(event) {
      if (event.type === "error") {
        $scope.isPlayError = true;
        $scope.$apply();
      }
    }
  });
  $scope.cameraUpagradeAlert = false;
  $scope.eventListDate = [];
  //카메라 세팅
  var loadCurrentCamera = function loadCurrentCamera() {
    $(".display_show").css("display", "");
    $scope.shareCheck();
    if ($scope.shareStatus == false) {
      Camera.get({
        id: $stateParams.cameraId
      }, function (res) {
        $scope.currentCamera = res;
        $scope.currentCameraDataSet();
      });
    } else {
      if ($stateParams.type === "sharedshop" && typeof $stateParams.id !== "undefined") {
        Shop.getSharedShopCamera({
          shopId: $stateParams.id,
          cameraId: $stateParams.cameraId
        }, function (res) {
          $scope.currentCamera = res;
          $scope.currentCameraDataSet();
        });
      } else {
        Share.get({
          id: $stateParams.cameraId
        }, function (res) {
          $scope.currentCamera = res;
          $scope.currentCameraDataSet();
        });
      }
    }
    $timeout(function () {
      initSizeTimline();
    }, 100);
  };
  $scope.cameraStatusSet = function (clickStatus) {
    if ($scope.isLive == true) {
      var cameraStatusNum = 0;
      if ($scope.config.streamStatus == "off") {
        cameraStatusNum = 1;
      } else {
        if ($scope.currentCamera) {
          if ($scope.currentCamera.controlStatus === "CS" || $scope.currentCamera.controlStatus === "on") {
            if ($scope.currentCamera.streamStatus == "off" && clickStatus != "setting") {
              if (Utils.isCloudExpired($scope.currentCamera)) {
                cameraStatusNum = 0;
              } else {
                cameraStatusNum = 2;
              }
            }
          } else if ($scope.currentCamera.controlStatus === "CE" || $scope.currentCamera.controlStatus === "off") {
            if ($scope.currentCamera.streamStatus == "off") {
              cameraStatusNum = 4;
            } else {
              cameraStatusNum = 3;
            }
          }
        }
      }
      $scope.cameraStatusChange(cameraStatusNum);
    }
  };
  $scope.cameraChangeFlag = false;

  // 현재 화면에 호출된 카메라의 데이터 설정
  $scope.currentCameraDataSet = function () {
    $scope.getShareCamerasList();
    $scope.shareCheck();
    $scope.shareView = true;
    $("#timebar_area").children("svg").width() / 2 - 75;
    if ($scope.currentCamera.code == "nok") {
      $scope.isNoCamera = true;
      return;
    }
    $scope.cameraName = $scope.currentCamera.labelName;
    if ($scope.currentCamera.mediaStreamURL != "" || $scope.currentCamera.mediaStreamURL != null) {
      if ($scope.cameraChangeFlag && $scope.isLive == false) {
        $scope.clickedCVRArea($scope.currentTime);
      }
      if ($scope.currentCamera.needUpgrade == "YES" && $scope.currentCamera.controlStatus == "on") {
        if ($scope.shareStatus == false) {
          $scope.cameraUpagradeAlert = true;
        }
      }
    } else {
      $scope.isNetwork = true;
    }
    if ($scope.currentCamera.saveEndDate < new Date().valueOf()) {
      $("#timelinedesc").remove();
      $scope.cloud_out = true;
    } else {
      $scope.cloud_out = false;
      if ($scope.getCookie("service_end") == "service_end") {} else {
        var today = new Date();
        var betweenDay = parseInt(($scope.currentCamera.saveEndDate - today.getTime()) / 1000 / 60 / 60 / 24);
        if (betweenDay <= 7) {
          $scope.cloudEnd = betweenDay;
          $scope.showServiceEnd = true;
        }
      }
    }
    if ($scope.currentCamera.isPromotion == 1) {
      if ($scope.currentCamera.saveEndDate > new Date().valueOf()) {
        $scope.isPromotionCheck = true;
      } else {
        $scope.isPromotionCheck = false;
        $scope.cloud_out = true;
        $("#timelinedesc").remove();
      }
    } else {
      $scope.isPromotionCheck = false;
    }
    if (Utils.isTurnOffCamera($scope.currentCamera)) {
      if ($scope.currentCamera.streamStatus !== "off") {
        Camera.isLastRecord({
          id: $stateParams.cameraId
        }, function (data) {
          $scope.currentCameraIsLastRecordDataSet(data);
        });
      }
      $scope.isPlaying = false;
      $scope.isShowFullscreenButton = true;
      $scope.isShowMike = false;
    } else {
      $scope.isPlaying = true;
    }
    if ($scope.currentCamera.streamStatus == "off" || $scope.currentCamera.controlStatus === "CE") {
      cameraOffCheck = setTimeout(function () {
        Camera.isLastRecord({
          id: $stateParams.cameraId
        }, function (data) {
          $scope.currentCameraIsLastRecordDataSet(data);
        });
      }, 1050);
    }
    $scope.controlsReady = true;
    if (!$scope.isExpiredCloud()) {
      if ($scope.currentCamera.recorderType === "nvr") {
        var now = moment();
        var regDate = moment($scope.currentCamera.regDate);
        $scope.serviceDay = now.diff(regDate, "days") + 1;
      } else {
        $scope.serviceDay = parseInt($scope.currentCamera.serviceType);
      }
      if ($scope.serviceDay <= 7 && $scope.serviceDay >= 1) {
        setTimeout(function () {
          $("#view_timeline_date").find("button").css("padding", "0 12px");
        }, 500);
        $scope.serviceCalendarDay = serviceCalendarDay($scope.serviceDay);
        $scope.todayDate = $scope.serviceCalendarDay[$scope.serviceCalendarDay.length - 1].date;
      } else if ($scope.serviceDay >= 8) {
        if ($scope.serviceDay <= 10) {
          setTimeout(function () {
            $("#view_timeline_date").find("button").css("padding", "0 12px");
          }, 500);
        }
        $scope.serviceCalendarDate = serviceCalendarDate($scope.serviceDay);
        var month = parseInt(new Date($scope.currentCamera.regDate).getMonth() + 1);
        if (month < 10) {
          month = "0" + month;
        }
        $scope.todayDate = $scope.serviceCalendarDate[$scope.serviceCalendarDate.length - 1].date;
      } else {
        $scope.cloud_out = true;
        $("#timelinedesc").remove();
      }
      if ($scope.currentCamera.recorderType === "nvr") {
        setupClipCalendar($scope.serviceDay.toString());
      } else {
        setupClipCalendar($scope.currentCamera.serviceType);
      }
    } else {
      $scope.cloud_out = true;
      $scope.serviceDay = 0;
    }
    //이벤트 날짜 리스트
    var eventListDateDate = eventListDate();
    for (var i = 0; i < eventListDateDate.length; i++) {
      var dateObject = {};
      dateObject.date = eventListDateDate[i].date;
      dateObject.day = eventListDateDate[i].day;
      var dateO = eventListDateDate[i].day.split(" ");
      dateObject.month = dateObject.date.substring(4, 6);
      dateObject.dates = dateObject.date.substring(6, 8);
      var dayCheck = new Date(dateObject.date.substring(0, 4) + "-" + dateObject.date.substring(4, 6) + "-" + dateObject.date.substring(6, 8)).getDay();
      dateObject.days = dayCheck;
      dateObject.today = dateO[3];
      $scope.eventListDate.push(dateObject);
    }
    $(".cvr").empty();
    $scope.cameraStatusSet();
    $scope.me = User.me(function () {
      if (userIdLoading == 0) {
        userIdLoading++;
      }
    });
    $scope.selectedZones = [];
    $scope.selectedAllZones = [];
    $scope.zones = [];
    if ($scope.currentCamera.saveEndDate >= new Date().valueOf()) {
      if ($scope.eventListCheckFlag === false) {
        eventListCheckFlag = true;
      }
    } else {
      $scope.cloudServiceEnd = true;
    }
  };
  $scope.showServiceEndClose = function () {
    if ($("#cloud_out_service").is(":checked") == true) {
      $scope.setCookie("service_end", "service_end", 1);
    }
    $scope.showServiceEnd = false;
  };
  $scope.currentCameraIsLastRecordDataSet = function (data) {
    $scope.currentCamera.lastEventDate = data.lastEventStartTime;
    $scope.currentCamera.lastRecDate = data.lastRectStartTime;
    var videoDateFormat = $translate.instant("CAMERA_DETAIL_EVENT_DATE_FORMAT");
    var videoTimeFormat = $translate.instant("CAMERA_DETAIL_EVENT_TIME_FORMAT");
    if ($scope.currentCamera.lastEventDate != 0) {
      var lastEventMoment = moment($scope.currentCamera.lastEventDate);
      $scope.currentCamera.lastEventDateString = lastEventMoment.locale(Utils.getBrowserLanguage()).format(videoDateFormat);
      $scope.currentCamera.lastEventTimeString = lastEventMoment.locale(Utils.getBrowserLanguage()).format(videoTimeFormat);
      $("#camera_off_lastevnt").show();
      $scope.lastEvent = lastEventMoment._i;
      $scope.isCameraOffLastShowEvent = true;
    } else {
      $scope.isCameraOffLastShowEvent = false;
      $scope.isCameraOffLastEvent = true;
    }
    if ($scope.currentCamera.lastRecDate != 0) {
      var lastRecMoment = moment($scope.currentCamera.lastRecDate);
      $scope.currentCamera.lastRecDateString = lastRecMoment.locale(Utils.getBrowserLanguage()).format(videoDateFormat);
      $scope.currentCamera.lastRecTimeString = lastRecMoment.locale(Utils.getBrowserLanguage()).format(videoTimeFormat);
      $("#camera_off_lastrec").show();
      $scope.lastRec = lastRecMoment._i;
      $scope.isCameraOffLastShowRec = true;
    } else {
      $scope.isCameraOffLastShowRec = false;
      $scope.isCameraOffLastRec = true;
    }
  };
  loadCurrentCamera();
  $scope.eventSources = [];
  $scope.timeRange = 360;
  $scope.timeline = new PosTimeline($("#view_timeline_ctrl").width(), $("#timebar_area").height(), $scope.timeRange, $q, $translate);
  $translate("FORMAT_TIMELINE_BOUND_DATE").then(function (translation) {
    $scope.timeline.setBoundDateFormat(translation);
  });
  $scope.timeline.cursorInterval = 1000;
  $scope.timeline.delegate = $scope;
  $scope.subCvrThumbnail = [];
  $scope.compareTime = function (time) {
    if ($scope.timelineDataLastDate < time) {
      $scope.timelineDataLastDate = time;
    }
  };
  //setupDomain
  $scope.setupDomain = function (domain) {
    if ($scope.shareStatus == true) {
      $scope.shareEnd();
    }
    dataCallStatus = false;
    if (dragThumCancle == true) {
      return;
    }
    var params = {
      cameraId: $scope.selectCameraId,
      shopId: $stateParams.id,
      posId: $scope.selectPosVal,
      start: domain[0],
      end: domain[1]
    };

    //
    /**타임라인 호출
     *10분일땐 1초에 한번
     *1시간일땐 1분에 한번
     *6시간일땐 5분에 한번
     *24시간일땐 10분에 한번 호출
     *예외상황 커서 드래그, cvr, 타임라인 드래그, 라이브보기, 이전 타임라인, 다음 타임라인
     */

    if (this.timeRange == 10) {
      params.scale = "10m";
      $scope.nowScale = "10m";
      params.start = params.start - 100000;
    } else if (this.timeRange == 60) {
      params.scale = "1h";
      $scope.nowScale = "1h";
      if (posTimelineDragCnt > 0 && posTimelineDragCnt < 6) {
        posTimelineDragCnt++;
        return;
      } else if (posTimelineDragCnt == 6) {
        posTimelineDragCnt = 0;
      }
    } else if (this.timeRange == 360) {
      params.scale = "6h";
      $scope.nowScale = "6h";
      if (posTimelineDragCnt > 0 && posTimelineDragCnt < 30) {
        posTimelineDragCnt++;
        return;
      } else if (posTimelineDragCnt == 30) {
        posTimelineDragCnt = 0;
      }
    } else if (this.timeRange == 1440) {
      params.scale = "24h";
      $scope.nowScale = "24h";
      if (posTimelineDragCnt > 0 && posTimelineDragCnt < 60) {
        posTimelineDragCnt++;
        return;
      } else if (posTimelineDragCnt == 60) {
        posTimelineDragCnt = 0;
      }
    }
    posTimelineDragCnt++;
    $scope.timeline.isLoading = true;
    if ($scope.serviceDay != 0) {
      serviceDateTime = new Date().valueOf() - 1000 * 60 * 60 * 24 * ($scope.serviceDay - 1);
    } else {
      serviceDateTime = 0;
    }
    if (params.start < serviceDateTime) {
      params.start = serviceDateTime;
    }
    Pos.getPosTimeline(params, function (d) {
      $scope.drawTimelineData(d);
    }, function (err) {
      $scope.timeline.isLoading = false;
    });
    $scope.drawTimelineData = function (d) {
      var check = 0;
      var eventTime = d.recTimes;
      d.recTimes = [];
      if (eventTime) {
        for (var i = 0; i < eventTime.length; i++) {
          if (i < eventTime.length) {
            if (eventTime[i + 1] != undefined) {
              if (eventTime[i].endTime == eventTime[i + 1].startTime) {
                check++;
              } else {
                var recTime = {};
                recTime.startTime = eventTime[i - check].startTime;
                recTime.endTime = eventTime[i].endTime;
                d.recTimes.push(recTime);
                check = 0;
              }
            } else {
              var recTime = {};
              recTime.startTime = eventTime[i - check].startTime;
              recTime.endTime = eventTime[i].endTime;
              d.recTimes.push(recTime);
              check = 0;
            }
          }
        }
      }
      firstDataLoadingFlag = true;
      $scope.timelineDataSet(d);
      $scope.initCursorEventTime();
    };
    var removedBufferDomain = PosTimeline.removeBufferCursorCheckDomain(domain, $scope.timeRange);
    if (removedBufferDomain[0] > $scope.currentTime.valueOf()) {
      $scope.isCursorLeft = true;
      $scope.isCursorRight = false;
    } else if (removedBufferDomain[1] < $scope.currentTime.valueOf()) {
      $scope.isCursorLeft = false;
      $scope.isCursorRight = true;
    } else {
      $scope.isCursorLeft = false;
      $scope.isCursorRight = false;
      if ($scope.isPlaying == false) {
        $scope.timeline.updateCursor($scope.currentTime);
      }
    }
  };
  $scope.timelineDataSet = function (d) {
    if (dragTimeLine == true) {
      dragTimeLine = false;
      if ($scope.isFullScreen) {
        $("#timebar_area").children("svg").children("g").attr("transform", "translate(0, -15)");
      } else {
        $("#timebar_area").children("svg").children("g").attr("transform", "translate(0, -19)");
      }
      // changedSelectedZone();
      $(".cvr").attr("transform", "");
      $(".cursor").attr("transform", "");
      thumnailDraw = true;
    }
    arrEvents = d.events;
    $scope.events = d.events;
    $scope.timeline.cvrData = d.recTimes;
    $scope.timeline.drawRecordBar();
    $scope.timeline.updateBar(500);
    cvrArray = new Array();
    cvrArray.push($(".cvr").children("rect"));
    $scope.timeline.redrawEvents(d.events, d.avg);
    $scope.timeline.isLoading = false;
    flag = "load";
  };
  $scope.hideCursorNavigation = function () {
    $scope.isCursorLeft = false;
    $scope.isCursorRight = false;
  };
  $scope.currentTime = new Date();
  $scope.reloadTimer = $interval(function () {
    if ($scope.timeline.currentDomain == undefined) {
      return;
    }
    if ($scope.serviceDay != 0) {
      if ($scope.timeline.currentDomain[1] > Date.now() || $scope.timeline.currentDomain[0] < serviceDateTime) {
        $scope.setupDomain([$scope.timeline.currentDomain[0], $scope.timeline.currentDomain[1]]);
      }
    } else {
      $interval.cancel($scope.reloadTimer);
      $interval.cancel($scope.timer);
      $interval.cancel($scope.eventThumbTimer);
      $interval.cancel($scope.eventlistTimer);
    }
  }, 10000);
  $scope.changeTimeFullScreenRange = function () {
    if (changeTimeRangeFlag == true) {
      $scope.loadingDataAlert();
      return;
    }
    if ($scope.timeRange == 10) {
      $scope.changeTimeRange(1440);
      $("#fs_time_range").html($translate.instant("TIMELINE_24HOUR"));
    } else if ($scope.timeRange == 60) {
      $scope.changeTimeRange(10);
      $("#fs_time_range").html($translate.instant("TIMELINE_10MIN"));
    } else if ($scope.timeRange == 360) {
      $scope.changeTimeRange(60);
      $("#fs_time_range").html($translate.instant("TIMELINE_1HOUR"));
    } else {
      $scope.changeTimeRange(360);
      $("#fs_time_range").html($translate.instant("TIMELINE_6HOUR"));
    }
  };
  $scope.loadingDataAlert = function () {
    if (fullscreenFlag === false) {
      showAlert($translate.instant("CAMERA_TIMELINE_LOADING_SUBJECT"), $translate.instant("CAMERA_TIMELINE_LOADING_CONTENT"));
    } else {
      $scope.fullScreenAlert = true;
    }
  };
  $scope.changeTimeRange = function (minutes) {
    posTimelineDragCnt = 0;
    dblClickFlag = false;
    $scope.lineMoveFlag = true;
    changeTimeRangeClick = true;
    dragThumCancle = false;
    if ($scope.timeRange == minutes) {
      return;
    }
    if (changeTimeRangeFlag == true) {
      $scope.loadingDataAlert();
      return;
    }
    changeTimeRangeFlag = true;
    setTimeout(function () {
      changeTimeRangeFlag = false;
      $scope.timeline.updateCursor($scope.currentTime);
      $scope.timeline.svg.select(".cursor").classed("hide", false);
    }, 800);
    $scope.timeRange = minutes;
    if ($scope.timeline.forceDomain) {
      $scope.timeline.setTimeRange(minutes);
    } else {
      $scope.timeline.zoomDomain($scope.timeline.domainCenterTime(), minutes);
    }
  };
  $scope.formattedTime = function (date) {
    if ($scope.timeline.tz !== undefined) {
      return moment(new Date(date)).tz($scope.timeline.tz).format("HH:mm:ss");
    } else {
      return moment(new Date(date)).format("HH:mm:ss");
    }
  };
  $scope.formattedDate = function (date) {
    var md;
    if ($scope.timeline.tz !== undefined) {
      md = moment(new Date(date)).tz($scope.timeline.tz);
    } else {
      md = moment(new Date(date));
    }
    var videoDateFormat = $translate.instant("FORMAT_VIDEO_DATE");
    return md.locale(Utils.getBrowserLanguage()).format(videoDateFormat);
  };
  $scope.formattedBasicDate = function (date) {
    var md;
    if ($scope.timeline.tz !== undefined) {
      md = moment(new Date(date)).tz($scope.timeline.tz);
    } else {
      md = moment(new Date(date));
    }
    var videoDateFormat = $translate.instant("FORMAT_BASIC_DATE");
    return md.locale(Utils.getBrowserLanguage()).format(videoDateFormat);
  };
  $scope.formattedBasicDate2 = function (date) {
    var md;
    if ($scope.timeline.tz !== undefined) {
      md = moment(new Date(date)).tz($scope.timeline.tz);
    } else {
      md = moment(new Date(date));
    }
    var videoDateFormat = $translate.instant("FORMAT_VIDEO_DATE2");
    return md.locale(Utils.getBrowserLanguage()).format(videoDateFormat);
  };
  $scope.formattedDateNotYo = function (date) {
    var md;
    if ($scope.timeline.tz !== undefined) {
      md = moment(new Date(date)).tz($scope.timeline.tz);
    } else {
      md = moment(new Date(date));
    }
    var videoDateFormat = $translate.instant("FORMAT_VIDEO_DATE_NOT_YO");
    return md.locale(Utils.getBrowserLanguage()).format(videoDateFormat);
  };
  $scope.formattedDateNotYo2 = function (date) {
    var md;
    if ($scope.timeline.tz !== undefined) {
      md = moment(new Date(date)).tz($scope.timeline.tz);
    } else {
      md = moment(new Date(date));
    }
    var videoDateFormat = "YYYY.MM.DD(ddd)";
    return md.locale(Utils.getBrowserLanguage()).format(videoDateFormat);
  };
  $scope.formattedInternalDate = function (date) {
    var md;
    if ($scope.timeline.tz !== undefined) {
      md = moment(new Date(date)).tz($scope.timeline.tz);
    } else {
      md = moment(new Date(date));
    }
    return md.format("YYYYMMDD");
  };
  $scope.formattedCalendarDate = function (date) {
    var dateString = "";
    var format = d3.time.format("%Y%m%d");
    var calendarTime = $scope.timeline.domainCenterTime();
    if (calendarTime !== undefined) {
      dateString = format(new Date(calendarTime));
    }
    return dateString;
  };
  $scope.goCameraList = function () {
    $window.history.back();
  };
  $scope.stopTimer = function () {
    $interval.cancel($scope.timer);
  };
  $scope.cursorDragStart = function () {
    $scope.cursorOn = true;
    $scope.stopTimer();
  };
  $scope.cursorDragging = function (time) {
    $scope.currentTime = time;
    $scope.$apply();
  };
  $scope.cursorDragEnd = function () {
    var curosEmptyData = 0;
    $scope.cursorOn = false;
    $scope.showCVRImage = false;
    $scope.lineMoveFlag = false;
    $scope.cameraStatusAllOff();
    if ($scope.currentTime.getTime() - Date.now() >= 0) {
      $scope.goLive();
      return;
    }
    $scope.clickedCVRArea($scope.currentTime);
    var now = Date.now();
    var right = parseInt($scope.timeline.removedBufferDomain[1]);
    var left = parseInt($scope.timeline.removedBufferDomain[0]);
    var x = $scope.timeline.svg.select(".cursor").select("line").attr("x1");
    var cursorTime = $scope.timeline.x.invert(x).getTime();
    if ($scope.timeRange == 60) {
      curosEmptyData = 200000;
    } else if ($scope.timeRange == 360) {
      curosEmptyData = 1200000;
    } else if ($scope.timeRange == 1440) {
      curosEmptyData = 4800000;
    }
    if (cursorTime < left - curosEmptyData) {
      $scope.timeline.prevDomain();
    }
    if (cursorTime > right + curosEmptyData) {
      $scope.timeline.nextDomain();
    }
  };
  $scope.lineMoveFlag = false;
  $scope.liveLinFlag = true;
  $scope.prevLine = function (click) {
    var nowTime = new Date().valueOf();
    var overTime = -0.987;
    if ($scope.timeRange == 60) {
      overTime = -0.918;
    } else if ($scope.timeRange == 360) {
      overTime = -0.59;
    } else if ($scope.timeRange == 1440) {
      overTime = 0.9;
    }
    var serviceTime = nowTime - 1000 * 60 * 60 * 24 * ($scope.serviceDay + overTime);
    if (serviceTime > $scope.timeline.removedBufferDomain[0]) {
      return;
    }
    dblClickFlag = false;
    changeTimeRangeClick = true;
    $scope.lineMoveFlag = true;
    $scope.timeline.prevDomain();
    if ($scope.isPlaying == true) {
      setTimeout(function () {
        if ($scope.isLive == false) {
          $scope.startRecTimer($scope.currentTime.valueOf());
        }
      }, 1050);
    }
  };
  $scope.nextLine = function (click) {
    dblClickFlag = false;
    changeTimeRangeClick = true;
    $scope.lineMoveFlag = true;
    $scope.timeline.nextDomain();
    if ($scope.isPlaying == true) {
      setTimeout(function () {
        if ($scope.isLive == false) {
          $scope.startRecTimer($scope.currentTime.valueOf());
        }
      }, 1050);
    }
  };
  $scope.camInfoBarChange = function () {
    if ($scope.isLive == false) {
      if (parseInt(window.innerWidth) < 1900) {
        $(".cam_info_bg").css("width", "280px");
        $(".cam_info_bg").css("margin-left", " -140px");
        $(".cam_info_bg_en").css("width", "290px");
        $(".cam_info_bg_en").css("margin-left", " -145px");
      } else {
        $(".cam_info_bg").css("width", "280px");
        $(".cam_info_bg").css("margin-left", " -140px");
        $(".cam_info_bg_en").css("width", "290px");
        $(".cam_info_bg_en").css("margin-left", " -145px");
      }
    } else {
      if (parseInt(window.innerWidth) < 1900) {
        $(".cam_info_bg").css("width", "206px");
        $(".cam_info_bg").css("margin-left", " -103px");
        $(".cam_info_bg_en").css("width", "216px");
        $(".cam_info_bg_en").css("margin-left", " -108px");
      } else {
        $(".cam_info_bg").css("width", "206px");
        $(".cam_info_bg").css("margin-left", " -103px");
        $(".cam_info_bg_en").css("width", "216px");
        $(".cam_info_bg_en").css("margin-left", " -108px");
      }
    }
  };
  var tmpTimeData = 0;
  var cursorNowTime = 0;
  var cursorIdx = 0;
  var cvrCheck = false;
  $scope.cvrDrawCheck = function (time) {
    $scope.isLive = false;
    $scope.camInfoBarChange();
    var trueCnt = 0;
    $scope.startRecTime = time;
    var cursorX = parseFloat($scope.timeline.x(time));
    cvrCheck = false;
    var nextTime = new Date().valueOf();
    var checkNextTime = 0;
    for (var i = 0; i < $scope.timeline.cvrData.length; i++) {
      var startX = parseInt($scope.timeline.cvrData[i].startTime);
      var endX = parseInt($scope.timeline.cvrData[i].endTime);
      if (startX > time.valueOf() && checkNextTime == 0) {
        nextTime = startX;
        checkNextTime++;
        clearTimeout(playserStop);
      }
      if ($scope.timeRange == 10) {
        if (parseInt($scope.timeline.cvrData[$scope.timeline.cvrData.length - 1].endTime) <= time.valueOf() + 3000) {
          $scope.setupDomain([$scope.timeline.currentDomain[0], $scope.timeline.currentDomain[1]]);
        }
      } else {
        if (parseInt($scope.timeline.cvrData[$scope.timeline.cvrData.length - 1].endTime) <= time.valueOf() + 30000) {
          $scope.setupDomain([$scope.timeline.currentDomain[0], $scope.timeline.currentDomain[1]]);
        }
      }
      if (startX <= time.valueOf() && endX >= time.valueOf()) {
        cvrCheck = true;
        trueCnt++;
      } else {
        if (trueCnt == 0) {
          cvrCheck = false;
        }
      }
    }
    if (cvrCheck == false) {
      if (new Date().valueOf() - time.valueOf() < 8000) {
        $scope.goLive();
        posTimelineDragCnt = 0;
        return;
      }
      if (new Date().valueOf() - time.valueOf() < 15000) {
        cvrCheck = true;
        posTimelineDragCnt = 0;
      }
    }
    if (cvrCheck == false && $scope.isShowPosDetailLayer) {
      if ($scope.lineMoveFlag == false && $scope.plyBtnStatus == true) {
        $scope.cameraNoSave();
        //$interval.cancel($scope.vedioTimer);
        $scope.lineMoveFlag = false;
        $scope.liveLinFlag = false;
        $scope.isPlaying = false;
        var videoDateFormat = $translate.instant("CAMERA_DETAIL_EVENT_DATE_FORMAT");
        var videoTimeFormat = $translate.instant("CAMERA_DETAIL_EVENT_TIME_FORMAT");
        if (checkNextTime == 1) {
          var lastRecMoment = moment(nextTime);
          $scope.currentCamera.lastRecDateString = lastRecMoment.locale(Utils.getBrowserLanguage()).format(videoDateFormat);
          $scope.currentCamera.lastRecTimeString = lastRecMoment.locale(Utils.getBrowserLanguage()).format(videoTimeFormat);
          $("#camera_off_lastrec").show();
          $scope.isCameraOffLastShowRec = true;
          $scope.currentCamera.lastRecDate = nextTime;
        } else {
          $scope.isCameraOffLastRec = true;
        }
        return;
      }
    }
  };
  var beforeServerTime = 0;
  $scope.startRecTimer = function (time) {
    beforeServerTime = 0;
    $scope.startRecTime = time;
    $scope.currentTime = new Date($scope.startRecTime.valueOf());
    var cntRecTimer = 0;
    $interval.cancel($scope.timer);
    $scope.timer = $interval(function () {
      $scope.currentTime = moment($scope.currentTime).add(1, "s");
      if ($scope.timeline.currentDomain == undefined) {
        return;
      }
      var domain = $scope.timeline.currentDomain;
      switch ($scope.timeRange) {
        case 10:
          range = 600000;
          fixRange = 0;
          break;
        case 60:
          range = 600000 * 6;
          fixRange = 200000;
          break;
        case 360:
          range = 600000 * 6 * 6;
          fixRange = 1245000;
          break;
        case 1440:
          range = 600000 * 6 * 6 * 4;
          fixRange = 3650000;
          break;
      }
      if (domain[0] + range < $scope.currentTime.valueOf() && domain[1] - range - fixRange > $scope.currentTime.valueOf()) {
        $scope.lineMoveFlag = false;
      } else {
        if ($scope.lineMoveFlag == false) {
          changeTimeRangeClick = true;
          $scope.pressedFindCursorButton();
        }
      }
      if ($scope.lineMoveFlag == false) {
        if (domain[0] < $scope.currentTime && domain[1] > $scope.currentTime) {
          $scope.timeline.updateCursor(new Date($scope.currentTime));
        } else {
          changeTimeRangeClick = true;
          $scope.timeline.nextDomain();
        }
      }
    }, $scope.timeline.cursorInterval);
  };
  var range = 0;
  var fixRange = 0;
  $scope.startLiveTimer = function () {
    $scope.timeline.forceDomain = true;
    $interval.cancel($scope.timer);
    // if($scope.serviceDay == 0){
    // 	return;
    // }
    $scope.timer = $interval(function () {
      switch ($scope.timeRange) {
        case 10:
          range = 600000;
          fixRange = 0;
          break;
        case 60:
          range = 600000 * 6;
          fixRange = 200000;
          break;
        case 360:
          range = 600000 * 6 * 6;
          fixRange = 1245000;
          break;
        case 1440:
          range = 600000 * 6 * 6 * 4;
          fixRange = 3650000;
          break;
      }
      if ($scope.plyBtnStatus == false) {
        return;
      }
      $scope.currentTime = new Date();
      if ($scope.timeline.currentDomain == undefined) {
        return;
      }
      var domain = $scope.timeline.currentDomain;
      if (domain[0] + range < $scope.currentTime.getTime() && domain[1] - range - fixRange > $scope.currentTime.getTime()) {
        $scope.timeline.updateCursor();
        $scope.lineMoveFlag = false;
      } else {
        if ($scope.lineMoveFlag == false) {
          changeTimeRangeClick = true;
          $scope.pressedFindCursorButton();
          $scope.lineMoveFlag = true;
        } else {
          if ($scope.cursorLineIn == true) {
            $scope.pressedFindCursorButton();
            $scope.cursorLineIn = false;
          }
        }
      }
    }, $scope.timeline.cursorInterval);
  };
  $scope.clickTime = 0;
  var recodeCheck = 0;
  $scope.clickedCVRArea = function (time, status) {
    posTimelineDragCnt = 0;
    $interval.cancel($scope.timer);
    if ($scope.shareStatus == true) {
      $scope.shareEnd();
    }
    $scope.setupDomain([$scope.timeline.currentDomain[0], $scope.timeline.currentDomain[1]]);
    if (new Date().valueOf() < time.valueOf()) {
      $scope.goLive();
      return;
    }
    if (cursorDragStatus == true) {
      return;
    }
    setTimeout(function () {
      $interval.cancel(recodeCheck);
      serviceDateTime = new Date().valueOf() - 1000 * 60 * 60 * 24 * ($scope.serviceDay - 1);
      if (serviceDateTime > time) {
        //return;
        time = new Date(serviceDateTime + 3000);
      }
      $scope.clickTime = time;
      $scope.cameraStatusAllOff();
      cursorIdx = 0;
      if (status != "f") {
        $scope.cvrDrawCheck(time);
      }
      if (cursorDragStatus == true) {
        return;
      }
      playerCheck = false;
      var tokenPromise = {};
      if ($scope.shareStatus == true) {
        tokenPromise = Share.getToken({
          id: $stateParams.cameraId
        }).$promise;
      } else {
        tokenPromise = Camera.getToken({
          id: $stateParams.cameraId
        }).$promise;
      }
      $scope.startRecTimer(time);
      if (cvrCheck == true || goCvrStatus == true) {
        $scope.isLive = false;
        $scope.camInfoBarChange();
        goCvrStatus = false;
        $scope.cameraStatusAllOff();
        $scope.isPlayError = false;
        $q.all([tokenPromise]).then(function (data) {
          if ($scope.isShowPosVideoArea) {
            $scope.token = data[0];
            var newURL = data[0].cvrHostPort + "/token=" + $scope.token.token + "&time=" + time.getTime();
            mediaIp = Utils.getCvrServerUrl(data[0].cvrHostPort);
            $scope.player.play(mediaIp + "/flvplayback/" + $stateParams.cameraId + "?token=" + $scope.token.token + "&time=" + time.getTime());
            $scope.plyBtnStatus = true;
          }
        });
      } else {}
      $scope.timeline.updateCursor(new Date(time));
      $scope.isCursorLeft = false;
      $scope.isCursorRight = false;
    }, 800);
  };
  var goCvrStatus = false;
  //영상 이동.
  $scope.goCvr = function (time, status) {
    $scope.replaceShow = false;
    $interval.cancel($scope.timer);
    offLayer = $scope.showCameraOffLayer;
    dragThumCancle = false;
    var tmpX = 9999;
    var e = window.event;
    if (e.preventDefault) {
      // Firefox, Chrome
      e.preventDefault();
    } else {
      // Internet Explorer
      e.returnValue = false;
    }
    if (time == undefined) {
      $scope.timeline.updateCursor($scope.currentTime);
      var cursorX = parseFloat($(".cursor").children("line").attr("x1"));
      for (var i = 0; i < cvrArray[0].length; i++) {
        if (cursorX < parseFloat(cvrArray[0].eq(i).attr("x"))) {
          var x = parseFloat(cvrArray[0].eq(i).attr("x"));
          if (tmpX >= x) {
            tmpX = x;
            time = $scope.timeline.x.invert(x).getTime() + 1000;
          }
        }
      }
    }
    if (time == undefined) {
      $scope.timeline.updateCursor($scope.currentTime);
      if (cvrArray[0].length - 1 > 0) {
        var x = parseFloat(cvrArray[0].eq(cvrArray[0].length - 1).attr("x"));
        if (tmpX >= x) {
          tmpX = x;
          time = $scope.timeline.x.invert(x).getTime() + 1000;
        }
      }
    }
    if (time == undefined) {
      time = $scope.lastRec;
      if (time == 0) {
        time = $scope.lastEvent;
      }
    }
    if (time == 0) {
      Camera.isLastRecord({
        id: $stateParams.cameraId
      }, function (data) {
        $scope.currentCamera.lastEventDate = data.lastEventStartTime;
        $scope.currentCamera.lastRecDate = data.lastRectStartTime;
        var videoDateFormat = $translate.instant("CAMERA_DETAIL_EVENT_DATE_FORMAT");
        var videoTimeFormat = $translate.instant("CAMERA_DETAIL_EVENT_TIME_FORMAT");
        var lastRecMoment = moment($scope.currentCamera.lastRecDate);
        $scope.currentCamera.lastRecDateString = lastRecMoment.locale(Utils.getBrowserLanguage()).format(videoDateFormat);
        $scope.currentCamera.lastRecTimeString = lastRecMoment.locale(Utils.getBrowserLanguage()).format(videoTimeFormat);
        var date = new Date(data.lastRectStartTime);
        changeTimeRangeClick = true;
        $scope.cameraStatusAllOff();
        $scope.currentTime = date;
        $scope.timeline.zoomDomain(data.lastRectStartTime, $scope.timeRange);
        goCvrStatus = true;
        $scope.clickedCVRArea(date, status);
      });
    } else {
      var date = new Date(time);
      changeTimeRangeClick = true;
      $scope.cameraStatusAllOff();
      $scope.currentTime = date;
      $scope.timeline.zoomDomain(date.getTime(), $scope.timeRange);
      goCvrStatus = true;
      $scope.clickedCVRArea(date, status);
    }
  };
  $scope.goLive = function () {
    if ($scope.isLive) {
      return;
    }
    posTimelineDragCnt = 0;
    $scope.isLive = true;
    //$scope.camInfoBarChange();
    //$scope.cameraStatusAllOff();
    $scope.currentTime = new Date();
    changeTimeRangeClick = true;
    $scope.lineMoveFlag = false;
    $scope.liveLinFlag = true;
    dragThumCancle = false;
    $scope.timeline.zoomDomain(Date.now(), $scope.timeRange).then(function () {
      $scope.startLiveTimer();
    });
  };
  $scope.mouseoutEvents = function (data, mouseLocation) {
    $interval.cancel($scope.eventThumbTimer);
  };
  $scope.eventThumbStyle = {};
  $scope.sgid = "";
  $scope.startThumSize = 0;
  $scope.endThumSize = 0;
  $scope.lastTimestamp = 0;
  $scope.thumTotal = 0;
  $scope.thumPageCnt = 1;
  $scope.prevTimestamp = 0;
  $scope.thumNailDataList = new Map();
  var showThumClick = 0;
  $scope.showThum = function (check) {
    if (showThumClick == 0) {
      showThumClick++;
      $("#thumnail_prev_btn").show();
      $("#thumnail_next_btn").show();
      if (check == 1) {
        $scope.thumTimeTmp0 = $scope.thumTimeTmp1;
        $scope.thumTimeTmp1 = $scope.lastTimestamp;
        if ($scope.thumPageCnt == 1) {
          $scope.prevTimestamp = 0;
        }
        $scope.thumnailData($scope.sgid, $scope.startThumSize, $scope.endThumSize, $scope.lastTimestamp, "T");
        if ($scope.thumPageCnt + 4 == $scope.thumTotal) {
          $("#thumnail_next_btn").hide();
        }
        $scope.thumPageCnt++;
      } else {
        $scope.thumPageCnt--;
        if ($scope.thumPageCnt == 1) {
          $scope.lastTimestamp = 0;
        } else {
          $scope.lastTimestamp = $scope.thumNailDataList.get($scope.thumPageCnt - 2).startTime;
        }
        $scope.thumnailData($scope.sgid, $scope.startThumSize, $scope.endThumSize, $scope.lastTimestamp, "P");
        if ($scope.thumPageCnt == 1) {
          $("#thumnail_prev_btn").hide();
          $("#thumnail_next_btn").show();
        }
      }
    }
  };
  var dataCallStatus = false;
  $scope.thumnailData = function (sgid, start, end, lastTimestamp, status, x) {
    $scope.sgid = sgid;
    $scope.startThumSize = start;
    $scope.endThumSize = end;
    var filteredMotionZoneIds = _.map(_.filter($scope.motionZones, function (o) {
      return o.filterMark === "on" && o.id !== "9";
    }), "uid");
    var filteredEventZoneIds = _.map(_.filter($scope.eventTypeList, ["filterMark", "on"]), "id");
    var allFilteredZoneIds = _.concat(filteredMotionZoneIds, filteredEventZoneIds);
    var isCheckedDeleteZoneId = _.get(_.find($scope.motionZones, ["id", "9"]), "filterMark") === "on" ? true : false;
    if (isCheckedDeleteZoneId) {
      allFilteredZoneIds.push("d");
    }
    if (dataCallStatus == false) {
      if ($scope.shareStatus == false) {
        Camera.newThumbnail({
          id: $scope.currentCamera.id,
          sgid: sgid,
          scale: $scope.nowScale,
          count: 4,
          lastTimestamp: lastTimestamp,
          zones: allFilteredZoneIds.join(",")
        }, function (data) {
          $scope.thumbnailDataSet(data, sgid, start, end, lastTimestamp, status, x);
        }, function (err) {
          dataCallStatus = false;
        });
      } else {
        Share.newThumbnail({
          id: $scope.currentCamera.id,
          sgid: sgid,
          scale: $scope.nowScale,
          count: 4,
          lastTimestamp: lastTimestamp,
          zones: allFilteredZoneIds.join(",")
        }, function (data) {
          $scope.thumbnailDataSet(data, sgid, start, end, lastTimestamp, status, x);
        }, function (err) {
          dataCallStatus = false;
          $scope.shareEnd();
        });
      }
    }
  };
  $scope.thumbnailDataSet = function (data, sgid, start, end, lastTimestamp, status, x) {
    if (data.events == undefined) {
      $("#showThumbnailListNew").hide();
      $("#time_info_tri").hide();
      return;
    }
    if (data.events.length == 0) {
      $("#showThumbnailListNew").hide();
      $("#time_info_tri").hide();
      return;
    }

    // beforeSgid = sgid;
    $scope.thumTotal = data.totalCount;
    var thumname_move = (start + end) / 2;
    var html = "";
    thumname_list = [];
    if (data.totalCount == 0) {
      dataCallStatus = false;
      return;
    }
    if (data.events == null) {
      return;
    }
    for (var i = 0; i < data.events.length; i++) {
      var eventTime = $scope.setThumEventTime(data.events[i].startTime);
      var path = "";
      if (location.port != "") {
        path = location.protocol + "//" + data.events[i].filePath.replace(".com/", ".com:" + location.port + "/");
      } else {
        path = location.protocol + "//" + data.events[i].filePath;
      }
      html += '<div id="thumnail_' + i + '" style="float:left;font-size:11px;height:103px';
      if (i > 4) {
        html += "display:none;";
      }
      if (data.events[i].index == 0) {
        data.events[i].labelName = $translate.instant("EVENT_SOUND_AREA");
      } else if (data.events[i].index == 8 || data.events[i].color == "") {
        data.events[i].labelName = $translate.instant("EVENT_ETC_AREA");
        data.events[i].color = "#FFFFFF";
      }
      html += '">';
      var imgIndex = "";
      if (data.events[i].detectType === "motion") {
        imgIndex = _.get(_.find($scope.motionZones, function (o) {
          return o.uid === data.events[i].uindex && o.id !== "9";
        }), "id");
      } else {
        imgIndex = _.get(_.find($scope.eventTypeList, ["id", data.events[i].uindex]), "id");
      }
      if (imgIndex == "" || typeof imgIndex === "undefined") {
        imgIndex = "9";
      }
      html += '<div style="font-size:12px;position:relative;top:2px;z-index:4;color:' + data.events[i].color + ';background:rgba(0,0,0,.7);width:147px;left:1px;line-height: 22px;"><img src="/resources/im/ic_area_color0' + imgIndex + '_N.png" style="top: 3px;position: relative;">&nbsp;' + data.events[i].labelName + "<br></div>";
      html += '<span style="margin-left: 1px;top:-20px;position: relative;z-index: 0;"><a ng-click="pressedThumNailEventItem(' + data.events[i].startTime + ",'timeline')\"><img src=\"" + path + '" onerror="imgError()" style="width:145px;height:98px; border:1px solid rgba(0,0,0,.7)"></a></span>';
      var colorId = data.events[i].color;
      if (colorId == "") {
        colorId = "#f0f0f0";
      }
      var eventDate = new Date(parseInt(data.events[i].startTime)).getYear() + "" + new Date(parseInt(data.events[i].startTime)).getMonth() + "" + new Date(parseInt(data.events[i].startTime)).getDate();
      var todayDate = new Date().getYear() + "" + new Date().getMonth() + "" + new Date().getDate();
      if (eventDate == todayDate) {
        html += '<div style="margin:0 auto;width:70px;line-height: 22px;position: relative;top: -44px;z-index:10; background:rgba(0,0,0,.6);"><div style="color:#fff; font-size:12px;"><span>' + eventTime + "</span></div></div></div>";
      } else {
        html += '<div style="margin:0 auto;width:94px;line-height: 22px;position: relative;top: -44px;z-index:10; background:rgba(0,0,0,.6);"><div style="color:#fff; font-size:12px;"><span>' + eventTime + "</span></div></div></div>";
      }
      thumname_list.push("thumnail_" + i);
      if (lastTimestamp == 0 && status == "N") {
        $("#thumnail_prev_btn").hide();
        $("#thumnail_next_btn").hide();
        $("#thumnail_prev").css("height", "");
        $("#thumnail_next").css("height", "");
      }
      if (i == 0) {
        $scope.lastTimestamp = data.events[i].startTime;
      }
      if (status == "N") {
        $scope.thumNailDataList.put(i, data.events[i]);
      } else {
        $scope.thumNailDataList.put($scope.thumPageCnt + 3, data.events[i]);
      }
    }
    $("#thumbnailList").html(html);
    $("#thumbnailList").css("padding", "1px");
    $("#thumbnailList").css("padding-top", "0px");
    for (var i = 0; i < data.events.length; i++) {
      $("#thumnail_" + i).find("img").error(function () {
        $(this).attr("src", "/resources/im/@thumb/thmb_none.jpg");
      });
    }
    switch (data.totalCount) {
      case 1:
        $("#showThumbnailListNew").css("width", "151px");
        break;
      case 2:
        $("#showThumbnailListNew").css("width", "299px");
        break;
      case 3:
        $("#showThumbnailListNew").css("width", "447px");
        break;
      case 4:
        $("#showThumbnailListNew").css("width", "595px");
        break;
      default:
        show_thumname_idx = 0;
        $("#showThumbnailListNew").css("width", "595px");
        $("#thumnail_prev").css("height", "103px");
        $("#thumnail_next").css("height", "103px");
        break;
    }
    $("#showThumbnailListNew").css("height", "104px");
    if (status == "N") {
      if (data.totalCount > 4) {
        show_thumname_idx = 0;
        $("#thumnail_prev_btn").hide();
        $("#thumnail_next_btn").show();
        $("#thumnail_next").show();
        $("#thumnail_prev").show();
      }
      thumname_move = thumname_move - parseInt($("#showThumbnailListNew").width() / 2);
      if (thumname_move <= 0) {
        thumname_move = 0;
      }
      if ($("#view_timeline_ctrl").width() < thumname_move + $("#showThumbnailListNew").width()) {
        thumname_move = parseInt($("#showThumbnailListNew").css("left")) - ($("#showThumbnailListNew").width() - ($("#view_timeline_ctrl").width() - parseInt($("#showThumbnailListNew").css("left"))));
      }
      var timeInfo = x;
      $("#showThumbnailListNew").css("left", parseInt(thumname_move));
      $("#time_info_tri").css("left", parseInt(timeInfo + 3));
      $("#thumbnailList").append('<div class= "timelineafter"></div>');
      $("#showThumbnailListNew").css("top", "-89px");
      if (data.events.length > 0) {
        $("#time_info_tri").show();
        $("#showThumbnailListNew").show();
      }
    }
    $compile($("#showThumbnailListNew"))($scope);
    showThumClick = 0;
    dataCallStatus = false;
  };
  $scope.pressedThumNailEventItem = function (startTime, clickStatus) {
    var targetTime = parseInt(startTime);
    var callbackFunc = function callbackFunc() {
      $scope.clickedCVRArea(new Date(targetTime));
      if (clickStatus == "timeline") {} else {
        $scope.timeline.zoomDomain(targetTime, $scope.timeRange);
      }
      event.cancelBubble = true; // for IE
      if (event.stopPropagation) {
        event.stopPropagation();
      }
    };
    $scope.checkCVRSeucre(function (isSecureMode) {
      if (isSecureMode) {
        $scope.play.securePassword = "";
        $scope.isShowCVRPlayPasswordConfirm = !$scope.isShowCVRPlayPasswordConfirm;
        $scope.cvrPasswordSuccess = callbackFunc;
      } else {
        callbackFunc();
      }
    });
  };
  $scope.eventAnimation = function (path) {
    var newIndex = $scope.eventThumbIndex + 1;
    if (newIndex === 10) newIndex = 0;
    $scope.eventThumbIndex = newIndex;
    var location = Utils.imageBackgroundLocation(newIndex);
    $scope.eventThumbStyle["background-position"] = -location.left + "px " + location.top + "px";
  };
  $scope.setEventTime = function (time) {
    var dateString;
    var today = moment(new Date());
    var targetDate = new Date(parseInt(time));
    var targetMoment = moment(targetDate);
    var dateString = targetMoment.locale(Utils.getBrowserLanguage()).format($translate.instant("CLIPS_SORT_BY_DATE_TITLE_FORMAT"));
    var todayString = today.locale(Utils.getBrowserLanguage()).format($translate.instant("CLIPS_SORT_BY_DATE_TITLE_FORMAT"));
    if (dateString === todayString) {
      dateString = $translate.instant("TIMELINE_TODAY");
    }
    var timeformat = d3.time.format("%H:%M");
    var timeString = timeformat(targetDate);
    $scope.eventTime = dateString + " " + timeString;
  };
  $scope.setThumEventTime = function (time) {
    var dateString;
    var today = moment(new Date());
    var targetDate = new Date(parseInt(time));
    var targetMoment = moment(targetDate);
    var dateString = targetMoment.locale(Utils.getBrowserLanguage()).format($translate.instant("CLIPS_SORT_BY_DATE_TITLE_FORMAT"));
    var todayString = today.locale(Utils.getBrowserLanguage()).format($translate.instant("CLIPS_SORT_BY_DATE_TITLE_FORMAT"));
    if (dateString === todayString) {
      dateString = $translate.instant("TIMELINE_TODAY");
    }
    var timeformat = d3.time.format("%H:%M");
    var timeString = timeformat(targetDate);
    return dateString + " " + timeString;
  };
  $scope.isTurnOffCamera = function () {
    return Utils.isTurnOffCamera($scope.currentCamera);
  };
  $scope.pressedScreenShotButton = function () {
    showAlert($translate.instant("CLICK_CAPTURE_ALERT_SUBEJCT"), $translate.instant("CLICK_CAPTURE_ALERT_CONTENT"));
  };
  var fullScreenMakeView = 0;
  var fullScreenWidth = 0;
  $scope.pressedFullScreenButton = function () {
    //posTimelineDragCnt = 0;
    $scope.isFullscreenButtonClicked = true;
    if (navigator.userAgent.indexOf("MSIE") !== -1 || navigator.appVersion.indexOf("Trident/") > 0) {
      var rv = 0;
      var ua = navigator.userAgent;
      var re = new RegExp("MSIE ([0-9]{1,}[.0-9]{0,})");
      if (re.exec(ua) != null) rv = parseFloat(RegExp.$1);
      if (rv != 0 && rv <= 10) {
        showAlert($translate.instant("EXPLORE_UNDER10_SUBJECT"), $translate.instant("EXPLORE_UNDER10_CONTENT1") + "<br>" + $translate.instant("EXPLORE_UNDER10_CONTENT2") + "<br>" + $translate.instant("EXPLORE_UNDER10_CONTENT3"));
        return;
      }
    }
    var element = document.getElementById("fullscreen");
    $scope.vedioHeightArea = "100%";
    if (element.requestFullscreen) {
      element.requestFullscreen();
    } else if (element.mozRequestFullScreen) {
      element.mozRequestFullScreen();
    } else if (element.webkitRequestFullscreen) {
      element.webkitRequestFullscreen();
    } else if (element.msRequestFullscreen) {
      element.msRequestFullscreen();
    }
    if ($scope.currentZoom > 1) {
      $scope.isShowTimelineToggleArea = false;
    } else {
      $scope.isShowTimelineToggleArea = true;
    }
    fullscreenFlag = true;
    $scope.isShowFullscreenButton = false;
    $scope.isToggleOn = true;
    setTimeout(function () {
      fullScreenWidth = parseInt(d3.select("#videoBar").style("width"));
      var tempPosition = $scope.videoCursorPosition * (fullScreenWidth / 450);
      if (fullScreenWidth < tempPosition) {
        $scope.videoCursorPosition = fullScreenWidth;
      } else if (tempPosition < 0) {
        $scope.videoCursorPosition = 0;
      } else {
        $scope.videoCursorPosition = tempPosition;
      }
    }, 100);
    $("#footer").hide();
    $("#header").hide();
  };
  $scope.pressedExitFullScreenButton = function () {
    $scope.isFullscreenButtonClicked = true;
    $scope.vedioHeightArea = "250px";
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    }
    fullscreenFlag = false;
    $scope.isShowFullscreenButton = true;
    $scope.isShowTimelineToggleArea = true;
    $scope.isToggleOn = false;
    setTimeout(function () {
      barWidth = parseInt(d3.select("#videoBar").style("width"));
      var tempPosition = $scope.videoCursorPosition * (barWidth / fullScreenWidth);
      if (barWidth < tempPosition) {
        $scope.videoCursorPosition = barWidth;
      } else if (tempPosition < 0) {
        $scope.videoCursorPosition = 0;
      } else {
        $scope.videoCursorPosition = tempPosition;
      }
    }, 50);
    $("#footer").show();
    $("#header").show();
  };

  // Calendar

  var serviceCalendarDay = function serviceCalendarDay(num) {
    var days = [];
    var now = Date.now();
    for (var i = num - 1; i >= 0; i--) {
      var past = now - i * 24 * 60 * 60 * 1000;
      var day = {
        date: $scope.formattedInternalDate(new Date(past))
      };
      if (i === 0) {
        day.day = $translate.instant("TIMELINE_TODAY");
      } else {
        day.day = moment(new Date(past)).locale(Utils.getBrowserLanguage()).format("dddd");
      }
      days.push(day);
    }
    return days;
  };
  var serviceCalendarDate = function serviceCalendarDate(num) {
    var dates = [];
    var now = Date.now();
    for (var i = num; i >= 0; i--) {
      var past = now - i * 24 * 60 * 60 * 1000;
      var date = {
        date: $scope.formattedInternalDate(new Date(past))
      };
      if (i === 0) {
        date.day = $translate.instant("TIMELINE_TODAY");
      } else {
        date.day = moment(new Date(past)).locale(Utils.getBrowserLanguage()).format("dddd");
        var md;
        if ($scope.timeline.tz !== undefined) {
          md = moment(new Date(past)).tz($scope.timeline.tz);
        } else {
          md = moment(new Date(past));
        }
        if (i === 29 || md.format("D") === "1") {
          date.day = md.format("M/D");
        } else {
          date.day = md.format("D");
        }
      }
      dates.push(date);
    }
    return dates;
  };
  $scope.pressedCalendarDateButton = function (dateString) {
    clickDateChange = true;
    $scope.lineMoveFlag = true;
    $scope.timeRange = 1440;
    $scope.timeline.setTimeRangeAtDateString(dateString, $scope.timeRange);
    setTimeout(function () {
      posTimelineDragCnt = 0;
      $scope.setupDomain([$scope.timeline.currentDomain[0], $scope.timeline.currentDomain[1]]);
      if ($scope.isPlaying == false) {
        var format = d3.time.format("%Y%m%d%H%M%S");
        var startDate = format.parse(dateString + "000000");
        var endDate = format.parse(dateString + "240000");
        var range = 1000 * 60 * $scope.timeRange;
        var startTime = startDate.getTime();
        var endTime = endDate.getTime();
        if (startTime < $scope.currentTime.valueOf() && endTime > $scope.currentTime.valueOf()) {
          $scope.timeline.updateCursor($scope.currentTime);
          posTimelineDragCnt = 0;
        }
      }
    }, 500);
  };

  // fullscreen

  $scope.isShowFullscreenButton = navigator.userAgent.indexOf("MSIE") === -1;
  var startFullscreenTimer = function startFullscreenTimer() {
    $timeout.cancel($scope.fullscreenTimer);
    $scope.fullscreenTimer = $timeout(function () {
      $scope.zoomVisible = false;
      $scope.controlVisible = false;
      $scope.timelineVisible = false;
    }, 5000);
  };
  var isFullScreen = function isFullScreen() {
    return !!(document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement);
  };
  var isFullscreenActiveArea = function isFullscreenActiveArea() {
    var x = d3.event.pageX;
    var y = d3.event.pageY;
    if (x <= 50 || y >= screen.height - 110) {
      return true;
    }
    return false;
  };
  d3.select("#player").on("mousemove", function () {
    if ($scope.isFullScreen) {
      if (isFullscreenActiveArea()) {
        $timeout.cancel($scope.fullscreenTimer);
        $scope.zoomVisible = true;
        $scope.controlVisible = true;
        $scope.timelineVisible = true;
      } else {
        if ($scope.timelineVisible) {
          startFullscreenTimer();
        }
      }
    }
  });

  // find cursor
  $scope.pressedFindCursorButton = function (check) {
    $scope.isCursorRight = false;
    $scope.isCursorLeft = false;
    posTimelineDragCnt = 0;
    if (check == "click") {
      dblClickFlag = false;
    }
    cursorIdx = 0;
    $scope.lineMoveFlag = true;
    changeTimeRangeClick = true;
    if (dblClickFlag == false) {
      $scope.timeline.zoomDomain($scope.currentTime.valueOf(), this.timeRange);
    }
  };

  // Camera Setting
  $scope.config = {};
  $scope.loadCameraSetting = function (callback, clickStatus) {
    if ($scope.shareStatus == true) {
      CameraConfig.getSharedConfig({
        id: $stateParams.cameraId
      }, function (data) {
        angular.extend($scope.config, data);
        $("#cameraNameView").html($scope.config.name);
        $scope.cameraStatusSet(clickStatus);
        if ($scope.config.cameraSchedule != undefined) {
          $scope.config.parsedStartAt = Utils.configDateSeparate($scope.config.cameraSchedule.startAt);
          $scope.config.parsedStopAt = Utils.configDateSeparate($scope.config.cameraSchedule.stopAt);
          $scope.config.repeatOn = Utils.configRepeatOnSeparate($scope.config.cameraSchedule.repeatOn);
        }
        $scope.timeline.setTimezone($scope.config.timezone);
        if ($scope.config.timezone != undefined) {
          $scope.config.tzCode = $scope.config.timezone.split(",")[0];
          $scope.tzCode = $scope.config.tzCode;
          $scope.config.tzDisplayName = $scope.config.timezone.split(",")[1] + $scope.config.timezone.split(",")[3];
        }
        if (typeof callback === "function") {
          callback();
        }
      });
    } else {
      CameraConfig.get({
        id: $stateParams.cameraId
      }, function (data) {
        angular.extend($scope.config, data);
        $("#cameraNameView").html($scope.config.name);
        $scope.cameraStatusSet(clickStatus);
        if ($scope.config.cameraSchedule != undefined) {
          $scope.config.parsedStartAt = Utils.configDateSeparate($scope.config.cameraSchedule.startAt);
          $scope.config.parsedStopAt = Utils.configDateSeparate($scope.config.cameraSchedule.stopAt);
          $scope.config.repeatOn = Utils.configRepeatOnSeparate($scope.config.cameraSchedule.repeatOn);
        }
        $scope.timeline.setTimezone($scope.config.timezone);
        if ($scope.config.timezone != undefined) {
          $scope.config.tzCode = $scope.config.timezone.split(",")[0];
          $scope.tzCode = $scope.config.tzCode;
          $scope.config.tzDisplayName = $scope.config.timezone.split(",")[1] + $scope.config.timezone.split(",")[3];
        }
        $scope.micVolume = $scope.config.micVolume;
        $scope.volumeList = [];
        for (var i = 0; i < 31; i++) {
          if (i == 0) {
            $scope.volumeList.push(1);
          } else {
            $scope.volumeList.push(Math.ceil(i * 3.4));
          }
        }
        $scope.volumeIdx = $scope.config.micVolume;
        if ($scope.config.usageRate > 100) {
          $scope.config.usageRate = 100;
        }
        if (typeof callback === "function") {
          callback();
        }
      });
    }
  };
  $scope.loadCameraSetting(function () {
    $scope.timeline.draw();
    posTimelineDragCnt = 0;
  });
  $scope.timezoneData = Timezone.query();
  $scope.getShareConfig = function () {
    $scope.shareConfig = Share.shareConfig({
      cameraId: $stateParams.cameraId
    });
  };
  $scope.shareDisable = function () {
    if ($scope.shareStatus == true) {
      showAlert($translate.instant("SHARE_ED_CAMERA"), $translate.instant("ACCESS_SHARED_MARKET_DESC"));
      return true;
    } else {
      return false;
    }
  };
  $scope.getCameraConfig = function () {
    if ($scope.shareStatus == true) {
      CameraConfig.getSharedConfig({
        id: $stateParams.cameraId
      }, function (data) {
        angular.extend($scope.config, data);
        $scope.config.tzCode = $scope.config.timezone.split(",")[0];
        $scope.tzCode = $scope.config.tzCode;
      });
    } else {
      CameraConfig.get({
        id: $stateParams.cameraId
      }, function (data) {
        angular.extend($scope.config, data);
        $scope.config.tzCode = $scope.config.timezone.split(",")[0];
        $scope.tzCode = $scope.config.tzCode;
      });
    }
  };
  $scope.clickedRemoveCamera = function () {
    $("body").scrollTop(10);
    $scope.showRemoveCameraAlert = true;
  };
  $scope.hideRemoveCameraAlert = function () {
    $scope.showRemoveCameraAlert = false;
  };
  $scope.removeCameraConfirm = function () {
    Camera.remove({
      id: $stateParams.cameraId
    }, function () {
      $state.go("main.cameras");
    });
  };
  $scope.clickedCameraNotifySettingButton = function () {
    if ($scope.shareDisable() == true) return;
    $scope.isShowNotificationSetting = !$scope.isShowNotificationSetting;
    $scope.loadNotifyConfig();
  };
  $scope.changeNotifyOn = function (notifyOn) {
    $scope.notify.notifyOn = notifyOn;
    CameraNotifyConfig.update({
      id: $stateParams.cameraId
    }, {
      notifyOn: notifyOn
    });
  };
  $scope.changeEventType = function () {
    var eventType = Utils.notifyEventTypeJoin($scope.notify.eventType);
    CameraNotifyConfig.update({
      id: $stateParams.cameraId
    }, {
      notifyEventType: eventType
    });
  };

  // Event List
  var eventListDate = function eventListDate() {
    var dates = [];
    var now = Date.now();
    for (var i = 0; i <= $scope.serviceDay; i++) {
      var past = now - i * 24 * 60 * 60 * 1000;
      var date = {
        date: $scope.formattedInternalDate(new Date(past))
      };
      date.day = moment(new Date(past)).locale(Utils.getBrowserLanguage()).format($translate.instant("EVENT_LIST_DATE_FORMAT"));
      if (i === 0) {
        date.day += " (" + $translate.instant("EVENT_LIST_DATE_TODAY") + ")";
      }
      dates.push(date);
    }
    return dates;
  };
  $scope.eventlists = {};
  $scope.eventlistDates = [];
  (function () {
    for (var i = 0; i < 30; i++) {
      $scope.eventlistDates[i] = {};
    }
  })();
  $scope.eventThumbnails = {};
  $scope.checkboxAudioEvent = true;
  $scope.eventFilter = {};
  $scope.eventFilter.accessCheck = true;
  $scope.eventListFlag = true;
  var eventGroupTmp = [];
  // 이벤트 리스트 날짜 이동 처리
  $scope.pressedEventListDateButton = function (index) {
    if ($scope.eventListFlag) {
      return;
    }
    $scope.showSelectColor = false;
    $scope.selectedEventDateIndex = index;
    var selectedDate = moment($scope.searchDate).format("YYYYMMDD");
    var allFilteredZoneIds = $scope.getAllFilteredZonesIds();
    if ($scope.shareStatus == false) {
      Pos.getEventList({
        shopId: $stateParams.id,
        date: selectedDate,
        pageSize: 0,
        posId: $scope.selectPosVal,
        eventTps: allFilteredZoneIds.join(","),
        sortField: $scope.sortField,
        sorting: $scope.sorting
      }, function (data) {
        $scope.pressEventDailyDataSet(data.events, index);
      }, function (err) {});
    } else {
      Pos.getEventList({
        shopId: $stateParams.id,
        date: selectedDate,
        pageSize: 0,
        posId: $scope.selectPosVal,
        eventTps: allFilteredZoneIds.join(","),
        sortField: $scope.sortField,
        sorting: $scope.sorting
      }, function (data) {
        $scope.pressEventDailyDataSet(data.events, index);
      }, function (err) {});
    }
  };

  //이벤트 리스트 날짜 이동시 이벤트 리스트 목록에 출력하는 화면 생성
  $scope.pressEventDailyDataSet = function (data, index) {
    if ($scope.serviceDay == 0) {
      return;
    }
    $("#eventListArea").css("height", $("#eventList_list").height() - 74);
    for (i = 0; i < data.length; i++) {
      var posInfo = _.find($scope.posList, {
        posId: data[i].posId
      });
      data[i]["posName"] = posInfo.posName;
    }
    $scope.eventLists = data;
  };
  $scope.ImageExist = function (url) {
    var img = new Image();
    img.src = url;
    if (img.height == 0) {
      return false;
    } else {
      return true;
    }
  };
  var eventListHeightCheckSize = 0;
  var tempIndexCheck = 0;
  var pEventButtonIdx = 0;
  var pEventButtonDate = 0;
  var openEventListflag = false; // 시간대별 이벤트 목록 호출 중복 클릭 방지

  $scope.renderHtml = function (html_code) {
    return $sce.trustAsHtml(html_code);
  };
  $scope.pressedEventItem = function (data) {
    $interval.cancel($scope.timer);
    var targetTime = parseInt(data.start);
    event.cancelBubble = true; // for IE
    if (event.stopPropagation) {
      event.stopPropagation();
    }
    $scope.checkCVRSeucre(function (isSecureMode) {
      if (isSecureMode) {
        $scope.play.securePassword = "";
        $scope.isShowCVRPlayPasswordConfirm = !$scope.isShowCVRPlayPasswordConfirm;
        $scope.cvrPasswordSuccess = function () {
          $scope.goCvr(targetTime, "f");
        };
      } else {
        $scope.goCvr(targetTime, "f");
      }
    });
  };
  var eventListFormatted = function eventListFormatted(event) {
    var start = moment(parseInt(event.startTime)).tz($scope.timeline.tz).format("HH:mm:ss");
    var end = moment(parseInt(event.endTime)).tz($scope.timeline.tz).format("HH:mm:ss");
    return $sce.trustAsHtml(start + "-" + end);
  };

  // 이벤트 리스트에 표기하는 날짜 문자열 반환
  var dateWithDateIndex = function dateWithDateIndex(dateIndex) {
    var now = moment().tz($scope.timeline.tz);
    var dateString = "";
    if (now == undefined) {
      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1; //January is 0!

      var yyyy = today.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }
      var dateString = yyyy + "" + mm + "" + dd;
    } else {
      dateString = now.subtract(dateIndex, "days").format("YYYYMMDD");
    }
    return dateString;
  };
  var timeRangeWithEventIndexes = function timeRangeWithEventIndexes(dateIndex, timeIndex) {
    var dateFormat = "YYYYMMDDHHmmss";
    var now = moment().tz($scope.timeline.tz);
    var dateString = now.subtract(dateIndex, "days").format("YYYYMMDD");
    var startHourString = timeIndex.toString();
    if (timeIndex < 10) startHourString = "0" + timeIndex;
    var endHourString = (timeIndex + 1).toString();
    if (timeIndex + 1 < 10) endHourString = "0" + (timeIndex + 1);
    var startDateTimeString = dateString + startHourString + "0001";
    var endDateTimeString = dateString + endHourString + "0000";
    var start = moment(startDateTimeString, dateFormat).tz($scope.timeline.tz);
    var end = moment(endDateTimeString, dateFormat).tz($scope.timeline.tz);
    return [start.valueOf(), end.valueOf()];
  };

  // Zone
  $scope.zoneAreaColorSet = ["#d90101", "#ff7900", "#3ea1d4", "#a4c800", "#efd600", "#767dff", "#ca74f0", "#ff76bd"];
  $scope.showZoneSetting = function () {
    $scope.zoomVisible = false;
    $scope.controlVisible = false;
    $scope.zoneSettingVisible = true;
    if ($scope.zonearea === undefined) {
      $scope.zonearea = new ZoneArea("zone-area");
      $scope.zonearea.delegate = $scope;
      $scope.zonearea.setZonesData($scope.motionZones);
      $scope.zonearea.setSelectedZones($scope.selectedZones);
    } else {
      $scope.zonearea.setCanvasSize($("#player").width(), $("#player").height(), $scope.motionZones, $scope.selectedZones);
    }
  };

  // clip
  $scope.newClip = {
    playrate: "1",
    isSmart: false,
    timeOverlay: "No",
    outputDuration: "0s"
  };
  $scope.timelineDate = {};
  var setClipStartTimeMoment = function setClipStartTimeMoment(m) {
    $scope.newClip.startTime = m.format("HH : mm : ss");
    var token = $scope.newClip.startTime.split(" : ");
    if (token[0] == "Invalid date") {
      token[0] = "00";
      token[1] = "00";
      token[2] = "00";
    }
    $scope.newClip.startHour = token[0];
    $scope.newClip.startMinute = token[1];
    $scope.newClip.startSecond = token[2];
  };
  var setClipEndTimeMoment = function setClipEndTimeMoment(m) {
    $scope.newClip.endTime = m.format("HH : mm : ss");
    var token = $scope.newClip.endTime.split(" : ");
    if (token[0] == "Invalid date") {
      token[0] = "00";
      token[1] = "00";
      token[2] = "00";
    }
    $scope.newClip.endHour = token[0];
    $scope.newClip.endMinute = token[1];
    $scope.newClip.endSecond = token[2];
  };
  var setTimelineTimeMoment = function setTimelineTimeMoment(m) {
    $scope.timelineDate.time = m.format("HH : mm : ss");
    var token = $scope.timelineDate.time.split(" : ");
    if (token[0] == "Invalid date") {
      token[0] = "00";
      token[1] = "00";
      token[2] = "00";
    }
    $scope.timelineDate.hour = token[0];
    $scope.timelineDate.minute = token[1];
    $scope.timelineDate.second = token[2];
  };
  $scope.hideClipCreate = function () {
    resetClipValue(); //클립&타임랩스 변수값 초기화
    $scope.clipStartDatePicker.destroy(); // pikday destroy
    $scope.clipEndDatePicker.destroy(); // pikday destroy
  };

  // 클립&타임랩스 변수값 초기화
  var resetClipValue = function resetClipValue() {
    $scope.isShowCreateClip = false;
    $scope.isShowingStartTimePicker = false;
    $scope.isShowingEndTimePicker = false;
    $scope.newClip.playrate = 1;
    $scope.newClip.isSmart = false;
    $scope.newClip.timeOverlay = "No";
    $scope.newClip.outputDuration = "0s";
  };

  // 클립&타임랩스 생성 레이어 팝업 호출
  var renderClipDatePickerTimer;
  $scope.pressedShowTimelapseButton = function () {
    isChangedClipName = false; //클립&타임랩스명 변경 flag 초기화
    if ($scope.shareDisable() == true) return;
    resetClipValue(); // 클립&타임랩스 변수값 초기화
    var minDate = moment().subtract(parseInt($scope.currentCamera.serviceType), "d");
    $scope.isShowCreateClip = true;
    renderClipDatePickerTimer = $timeout(function () {
      $scope.clipStartDatePicker = new Pikaday({
        field: document.getElementById("clipStartDate"),
        format: $translate.instant("CLIP_CREATE_CLIP_DATE_FORMAT"),
        minDate: minDate.toDate(),
        maxDate: new Date(),
        // defaultDate: new Date(),
        position: "bottom right",
        onSelect: function onSelect() {
          $scope.newClip.duration = getClipDurationString();
          $scope.newClip.outputDuration = getClipDurationString($scope.newClip.playrate);
          canCreateClip();
        }
      });
      $scope.clipEndDatePicker = new Pikaday({
        field: document.getElementById("clipEndDate"),
        format: $translate.instant("CLIP_CREATE_CLIP_DATE_FORMAT"),
        minDate: minDate.toDate(),
        maxDate: new Date(),
        defaultDate: new Date(),
        position: "bottom right",
        onSelect: function onSelect() {
          $scope.newClip.duration = getClipDurationString();
          $scope.newClip.outputDuration = getClipDurationString($scope.newClip.playrate);
          canCreateClip();
        }
      });
      Clip.availableRange({
        cameraId: $scope.currentCamera.id,
        type: "0"
      }, function (data) {
        $scope.newClip.startDate = moment(parseInt(data.end)).add(-10, "m").locale(Utils.getBrowserLanguage()).format($translate.instant("CLIP_CREATE_CLIP_DATE_FORMAT"));
        $scope.newClip.endDate = moment(parseInt(data.end)).locale(Utils.getBrowserLanguage()).format($translate.instant("CLIP_CREATE_CLIP_DATE_FORMAT"));
        setClipStartTimeMoment(moment(parseInt(data.end)).add(-10, "m"));
        setClipEndTimeMoment(moment(parseInt(data.end)));
        $scope.newClip.duration = getClipDurationString();
        $scope.newClip.outputDuration = getClipDurationString($scope.newClip.playrate);
      });
    }); // $timeout

    $scope.newClip.name = $translate.instant("CLIP_CREATE_CLIP_NEW_NAME");
  };

  // 클립&타임랩스명 변경 이벤트
  var isChangedClipName = false; // 클립&타임랩스명 변경 flag
  $scope.changeClipName = function () {
    isChangedClipName = true;
  };

  // 스마트 타임랩스 체크 변경 이벤트 (클립&타임랩스명 기본값 설정)
  $scope.changeSmartCheck = function () {
    if ($scope.newClip.isSmart && !isChangedClipName) {
      $scope.newClip.name = "새로운 스마트 타임랩스";
    } else if (!$scope.newClip.isSmart && $scope.newClip.playrate != "1" && !isChangedClipName) {
      $scope.newClip.name = $translate.instant("CLIP_CREATE_TIMELAPSE_NEW_NAME");
    } else if (!$scope.newClip.isSmart && $scope.newClip.playrate == "1" && !isChangedClipName) {
      $scope.newClip.name = $translate.instant("CLIP_CREATE_CLIP_NEW_NAME");
    }
  };

  // 타임라인 날짜/시간 바로가기
  $scope.pressedShowTimelineCalendarButton = function () {
    $scope.isShowTimelineCalendar = !$scope.isShowTimelineCalendar;
    $scope.timelineDatePicker._d = $scope.currentTime;
    $scope.timelineDate.date = moment(parseInt($scope.timelineDatePicker._d.getTime())).locale(Utils.getBrowserLanguage()).format($translate.instant("CLIP_CREATE_CLIP_DATE_FORMAT"));
    setTimelineTimeMoment(moment(parseInt($scope.timelineDatePicker._d.getTime())));
  };

  // 타임라인 날짜/시간 바로가기 숨김
  $scope.hideTimelineCalendr = function () {
    $scope.isShowTimelineCalendar = false;
    $scope.isShowingTimelineTimePicker = false;
    $scope.timelineDatePicker.hide();
  };
  var setupClipCalendar = function setupClipCalendar(serviceType) {
    var minDate = moment().subtract(parseInt(serviceType), "d");
    var regDate = moment($scope.currentCamera.regDate);
    $scope.timelineDatePicker = new Pikaday({
      field: document.getElementById("timelineDate"),
      container: document.getElementById("calendarContainer"),
      format: $translate.instant("CLIP_CREATE_CLIP_DATE_FORMAT"),
      minDate: minDate.toDate(),
      maxDate: new Date(),
      defaultDate: $scope.currentTime,
      position: "bottom right"
    });
    var startMoment = moment();
    var endMoment = moment();
    $scope.isShowingStartTimePicker = false;
    $scope.isShowingEndTimePicker = false;
    $scope.isShowingTimelineTimePicker = false;
  };
  $scope.toggleStartClipCalendar = function () {
    if ($scope.clipStartDatePicker.isVisible()) {
      $scope.clipStartDatePicker.hide();
    } else {
      $scope.clipStartDatePicker.show();
    }
    event.cancelBubble = true; // for IE
    if (event.stopPropagation) {
      event.stopPropagation();
    }
  };
  $scope.toggleEndClipCalendar = function () {
    if ($scope.clipEndDatePicker.isVisible()) {
      $scope.clipEndDatePicker.hide();
    } else {
      $scope.clipEndDatePicker.show();
    }
    event.cancelBubble = true; // for IE
    if (event.stopPropagation) {
      event.stopPropagation();
    }
  };
  $scope.toggleTimelineCalendar = function () {
    if ($scope.timelineDatePicker.isVisible()) {
      $scope.timelineDatePicker.hide();
    } else {
      $scope.timelineDatePicker.show();
    }
    event.cancelBubble = true; // for IE
    if (event.stopPropagation) {
      event.stopPropagation();
    }
  };
  $scope.pressedShowClipsButton = function () {
    $state.go("main.clips");
  };
  $scope.toggleStartClipTimePicker = function () {
    if ($scope.isShowingStartTimePicker) {
      var startMoment = moment($scope.newClip.startTime, "HH : mm : ss");
      setClipStartTimeMoment(startMoment);
    }
    $scope.isShowingStartTimePicker = !$scope.isShowingStartTimePicker;
  };
  $scope.toggleEndClipTimePicker = function () {
    if ($scope.isShowingEndTimePicker) {
      var endMoment = moment($scope.newClip.endTime, "HH : mm : ss");
      setClipEndTimeMoment(endMoment);
    }
    $scope.isShowingEndTimePicker = !$scope.isShowingEndTimePicker;
  };
  $scope.toggleTimelineTimePicker = function () {
    if ($scope.isShowingTimelineTimePicker) {
      var timelineMoment = moment($scope.timelineDate.time, "HH : mm : ss");
      setTimelineTimeMoment(timelineMoment);
    }
    $scope.isShowingTimelineTimePicker = !$scope.isShowingTimelineTimePicker;
  };
  $scope.pressedStartClipTimeSelect = function () {
    if ($scope.newClip.startHour.length < 1) {
      showAlert("입력오류", "시간을 입력해주세요.");
      return;
    }
    if ($scope.newClip.startMinute.length < 1) {
      showAlert("입력오류", "분을 입력해주세요.");
      return;
    }
    if ($scope.newClip.startSecond.length < 1) {
      showAlert("입력오류", "초를 입력해주세요.");
      return;
    }
    $scope.newClip.startTime = (parseInt($scope.newClip.startHour) < 10 && $scope.newClip.startHour.length < 2 ? "0" + $scope.newClip.startHour : $scope.newClip.startHour) + " : " + (parseInt($scope.newClip.startMinute) < 10 && $scope.newClip.startMinute.length < 2 ? "0" + $scope.newClip.startMinute : $scope.newClip.startMinute) + " : " + (parseInt($scope.newClip.startSecond) < 10 && $scope.newClip.startSecond.length < 2 ? "0" + $scope.newClip.startSecond : $scope.newClip.startSecond);
    $scope.isShowingStartTimePicker = false;
    $scope.newClip.duration = getClipDurationString();
    $scope.newClip.outputDuration = getClipDurationString($scope.newClip.playrate);
    canCreateClip();
  };
  $scope.pressedEndClipTimeSelect = function () {
    if ($scope.newClip.endHour.length < 1) {
      showAlert("입력오류", "시간을 입력해주세요.");
      return;
    }
    if ($scope.newClip.endMinute.length < 1) {
      showAlert("입력오류", "분을 입력해주세요.");
      return;
    }
    if ($scope.newClip.endSecond.length < 1) {
      showAlert("입력오류", "초를 입력해주세요.");
      return;
    }
    $scope.newClip.endTime = (parseInt($scope.newClip.endHour) < 10 && $scope.newClip.endHour.length < 2 ? "0" + $scope.newClip.endHour : $scope.newClip.endHour) + " : " + (parseInt($scope.newClip.endMinute) < 10 && $scope.newClip.endMinute.length < 2 ? "0" + $scope.newClip.endMinute : $scope.newClip.endMinute) + " : " + (parseInt($scope.newClip.endSecond) < 10 && $scope.newClip.endSecond.length < 2 ? "0" + $scope.newClip.endSecond : $scope.newClip.endSecond);
    $scope.isShowingEndTimePicker = false;
    $scope.newClip.duration = getClipDurationString();
    $scope.newClip.outputDuration = getClipDurationString($scope.newClip.playrate);
    canCreateClip();
  };
  $scope.pressedTimelineTimeSelect = function () {
    if ($scope.timelineDate.hour.length < 1) {
      showAlert("입력오류", "시간을 입력해주세요.");
      return;
    }
    if ($scope.timelineDate.minute.length < 1) {
      showAlert("입력오류", "분을 입력해주세요.");
      return;
    }
    if ($scope.timelineDate.second.length < 1) {
      showAlert("입력오류", "초를 입력해주세요.");
      return;
    }
    $scope.timelineDate.time = (parseInt($scope.timelineDate.hour) < 10 && $scope.timelineDate.hour.length < 2 ? "0" + $scope.timelineDate.hour : $scope.timelineDate.hour) + " : " + (parseInt($scope.timelineDate.minute) < 10 && $scope.timelineDate.minute.length < 2 ? "0" + $scope.timelineDate.minute : $scope.timelineDate.minute) + " : " + (parseInt($scope.timelineDate.second) < 10 && $scope.timelineDate.second.length < 2 ? "0" + $scope.timelineDate.second : $scope.timelineDate.second);
    $scope.isShowingTimelineTimePicker = false;
  };

  //공유

  $scope.shareCnt = 0;
  $scope.shareAddStatus = true;
  $scope.shareAdd = function () {
    if ($scope.shareAddStatus == false) {
      return;
    }
    $scope.shareAddStatus = false;
    var receiverName = $("#receiverName").val();
    if (receiverName.length == 0) {
      showAlert($translate.instant("SHARE_FAIL"), $translate.instant("SHARE_RECEVER_NAME_NECC"));
      $scope.shareAddStatus = true;
      return;
    } else if (receiverName.length >= 11) {
      showAlert($translate.instant("SHARE_FAIL"), $translate.instant("SHARE_RECEVER_NAME_MAX"));
      $scope.shareAddStatus = true;
      return;
    }
    var receiverId = $("#receiverId").val();
    if (receiverId.length == 0) {
      showAlert($translate.instant("SHARE_FAIL"), $translate.instant("SHARE_RECEVER_INFO_NECC"));
      $scope.shareAddStatus = true;
      return;
    }
    if ($scope.shareAddModel.shareOptions[0] === "0") {
      showAlert($translate.instant("SHARE_FAIL"), "실시간 영상, 이벤트 공유는 필수사항입니다.");
      $scope.shareAddStatus = true;
      return;
    }
    if ($scope.shareCnt >= 5) {
      showAlert($translate.instant("SHARE_FAIL"), $translate.instant("SHARE_MAX"));
      $scope.shareAddStatus = true;
      return;
    }
    var receiverId = $("#receiverId").val();
    if ($scope.me.paycoEmail == $("#receiverId").val()) {
      showAlert($translate.instant("SHARE_FAIL2"), $translate.instant("SHARE_NO_MY"));
      $scope.shareAddStatus = true;
      return;
    } else {
      receiverId = receiverId.replace(/-/gi, "");
      receiverId = "82" + receiverId.substring(1, receiverId.length);
      if ($scope.me.paycoMobile.replace(/-/gi, "") == receiverId) {
        showAlert($translate.instant("SHARE_FAIL2"), $translate.instant("SHARE_NO_MY"));
        $scope.shareAddStatus = true;
        return;
      }
    }
    var shareDoubleCheck = 0;
    for (var i = 0; i < $scope.shareCameras.length; i++) {
      if ($scope.shareCameras[i].receiverId == $("#receiverId").val()) {
        shareDoubleCheck++;
      } else {
        var receiverId = $("#receiverId").val();
        receiverId = receiverId.replace(/-/gi, "");
        if (receiverId.length > 3) {
          receiverId = "82" + receiverId.substring(1, receiverId.length);
          if ($scope.shareCameras[i].receiverId.replace(/-/gi, "") == receiverId) {
            shareDoubleCheck++;
          }
        }
      }
    }
    if (shareDoubleCheck > 0) {
      showAlert($translate.instant("SHARE_FAIL2"), $translate.instant("SHARE_SHARED_RECEVEID"));
      $scope.shareAddStatus = true;
      return;
    }
    $scope.isAddShare = true;
  };
  $scope.isAddShareClose = function () {
    $scope.isAddShare = false;
    $scope.shareAddStatus = true;
  };
  $scope.shareAddCheck = function () {
    $scope.isAddShare = false;
    if ($scope.shareCnt >= 5) {
      showAlert($translate.instant("SHARE_FAIL"), $translate.instant("SHARE_MAX"));
    }
    var receiverId = $("#receiverId").val();
    var receiverName = $("#receiverName").val();
    var validPhone = Utils.phoneNumberVaild(Utils.toFormattedPhoneNumber(receiverId));
    var validEmail = Utils.emailValid(Utils.toFormattedPhoneNumber(receiverId));
    if (validPhone == false && validEmail == false) {
      showAlert($translate.instant("SHARE_FAIL3"), $translate.instant("SHARE_FAIL3_MSG"));
      $scope.shareAddStatus = true;
      return;
    }
    if (receiverName.length == 0) {
      showAlert($translate.instant("SHARE_FAIL"), $translate.instant("SHARE_RECEVER_NAME_NECC"));
      $scope.shareAddStatus = true;
      return;
    }
    $("#receiverId").val("");
    $("#receiverName").val("");
    Share.shareCamera({
      cameraId: $scope.currentCamera.id,
      receiverId: receiverId,
      receiverName: receiverName,
      shareOptions: $scope.shareAddModel.shareOptions
    }, function (data) {
      $scope.shareAddStatus = true;
      if (data.code == "ok") {
        $scope.getShareCamerasList();
        showAlert($translate.instant("SHARE_SUCCESS"), $translate.instant("SHARE_SUCCESS_MSG"));
        $scope.getShareCamerasList();
        $("#receiverId").val("");
        $("#receiverName").val("");
        $scope.shareAddModel.shareOptions = ["1", "0"];
      } else {
        if (data.errorCode == "-1") {
          showAlert($translate.instant("SHARE_FAIL2"), $translate.instant("SHARE_ERR_NO_CAMERA"));
        } else if (data.errorCode == "-2") {
          showAlert($translate.instant("SHARE_FAIL2"), $translate.instant("SHARE_ERR_NO_MY_CAMERA"));
        } else if (data.errorCode == "-3") {
          showAlert($translate.instant("SHARE_FAIL2"), $translate.instant("SHARE_SHARED_RECEVEID"));
        } else if (data.errorCode == "-4") {
          showAlert($translate.instant("SHARE_FAIL2"), $translate.instant("SHARE_NO_MY"));
        }
      }
    });
  };
  $scope.shareRemove = function (cameraId, sharedCameraUid) {
    $scope.isRemoveShare = true;
    $scope.removeShareCameraId = cameraId;
    $scope.sharedCameraUid = sharedCameraUid;
    $scope.shareAddStatus = true;
  };
  $scope.shareRemoveCheck = function () {
    $scope.isRemoveShare = false;
    Share.removeMyShared({
      id: $scope.removeShareCameraId,
      sharedCameraUid: $scope.sharedCameraUid
    }, function (data) {
      $scope.getShareCamerasList();
      showAlert($translate.instant("SHARE_REMOVE_SUCCESS"), $translate.instant("SHARE_REMOVE_SUCCESS_MSG"));
      $scope.getShareCamerasList();
      $scope.removeShareCameraId = "";
      $scope.sharedCameraUid = "";
    }, function (err) {
      $scope.removeShareCameraId = "";
      $scope.sharedCameraUid = "";
    });
  };
  $scope.removeSharedCamera = function (sharedCameraUid) {
    $scope.sharedCameraUid = sharedCameraUid;
    $scope.isRemoveShared = true;
  };
  $scope.sharedRemoveCheck = function () {
    $scope.isRemoveShared = false;
    Share.rejectSharedCamera({
      sharedCameraUid: $scope.shareConfig.sharedCameraUid
    }, {
      isRejected: "YES"
    }, function (data) {
      showAlert($translate.instant("SHARE_REMOVE_SUCCESS"), $translate.instant("SHARE_REMOVE_SUCCESS_MSG"));
      $state.go("main.cameras");
      $scope.sharedCameraUid = "";
    }, function (err) {
      $scope.sharedCameraUid = "";
    });
  };
  $scope.getShareCamerasList = function () {
    Share.getMySharedList({
      id: $scope.currentCamera.id
    }, function (data) {
      $scope.shareCameras = $scope.cameraDataSet(data);
      $scope.shareCnt = data.length;
    }, function (err) {
      $scope.errCameras = true;
    });
  };
  $scope.shareEnd = function () {
    Share.get({
      id: $stateParams.cameraId
    }, function (res) {}, function (err) {
      $scope.shareEndCheckErr();
    });
  };
  $scope.shareEndCheckErr = function () {
    $scope.player.stop();
    $interval.cancel($scope.reloadTimer);
    $interval.cancel($scope.timer);
    $interval.cancel($scope.eventThumbTimer);
    $interval.cancel($scope.eventlistTimer);
    $interval.cancel(callEvtList);
    $scope.isNoShared = true;
    return false;
  };
  $scope.cameraDataSet = function (data) {
    for (var i = 0; i < data.length; i++) {
      if (location.port != "") {
        data[i].thumbnailPath = location.protocol + "//" + data[i].thumbnailPath.replace(".com/", ".com:" + location.port + "/");
      } else {
        data[i].thumbnailPath = location.protocol + "//" + data[i].thumbnailPath;
      }
      if (data[i].streamStatus === "off" && data[i].controlStatus === "CS") {
        data[i].streamStatus = data[i].streamStatus === "on";
      }
      data[i].cameraViewState = 0;
      if (data[i].streamStatusConfig == "off") {
        data[i].cameraViewState = 1;
      } else {
        if (data[i].controlStatus == "on") {
          if (data[i].streamStatus == "off") {
            data[i].cameraViewState = 2;
          }
        } else {
          if (data[i].streamStatus == "on") {
            data[i].cameraViewState = 3;
          } else {
            data[i].cameraViewState = 4;
          }
        }
      }
      data[i].number = i;
    }
    return data;
  };
  $scope.renamePhoneNumber = function (phoneNumber) {
    var tmpPhoneNumber = phoneNumber;
    phoneNumber = "0" + phoneNumber.substring(2, phoneNumber.length);
    var validPhone = Utils.phoneNumberVaild(Utils.toFormattedPhoneNumber(phoneNumber));
    if (validPhone == false) {
      return tmpPhoneNumber;
    } else {
      return Utils.toFormattedPhoneNumber(phoneNumber);
    }
  };
  var getClipStartMoment = function getClipStartMoment() {
    var dateMoment = $scope.clipStartDatePicker.getMoment();
    if ($scope.newClip.startTime == "Invalid date") {
      $scope.newClip.startTime = "00 : 00 : 00";
    }
    var timeString = $scope.newClip.startTime;
    return moment(dateMoment.format("YYYYMMDD") + " " + timeString, "YYYYMMDD HH : mm : ss");
  };
  var getClipEndMoment = function getClipEndMoment() {
    var dateMoment = $scope.clipEndDatePicker.getMoment();
    if ($scope.newClip.endTime == "Invalid date") {
      $scope.newClip.endTime = "00 : 00 : 00";
    }
    var timeString = $scope.newClip.endTime;
    return moment(dateMoment.format("YYYYMMDD") + " " + timeString, "YYYYMMDD HH : mm : ss");
  };
  var getTimelineMoment = function getTimelineMoment() {
    var dateMoment = $scope.timelineDatePicker.getMoment();
    if ($scope.timelineDate.time == "Invalid date") {
      $scope.timelineDate.time = "00 : 00 : 00";
    }
    var timeString = $scope.timelineDate.time;
    return moment(dateMoment.format("YYYYMMDD") + " " + timeString, "YYYYMMDD HH : mm : ss");
  };
  var getClipDurationString = function getClipDurationString(playrate) {
    var startMoment = getClipStartMoment();
    var endMoment = getClipEndMoment();
    return Utils.durationStringFromTwoTime(startMoment.toDate().getTime(), endMoment.toDate().getTime(), playrate);
  };
  var pressedTimeUpButton = function pressedTimeUpButton(val, max) {
    val = val.length < 1 ? 0 : val;
    var time = parseInt(val);
    time += 1;
    if (time > max) {
      time = 0;
    }
    if (time.toString().length == 1) {
      return "0" + time.toString();
    } else {
      return time.toString();
    }
  };
  var pressedTimeDownButton = function pressedTimeDownButton(val, max) {
    val = val.length < 1 ? 0 : val;
    var time = parseInt(val);
    time -= 1;
    if (time < 0) {
      time = max;
    }
    if (time.toString().length == 1) {
      return "0" + time.toString();
    } else {
      return time.toString();
    }
  };
  $scope.pressedStartHourUpButton = function () {
    $scope.newClip.startHour = pressedTimeUpButton($scope.newClip.startHour, 23);
  };
  $scope.pressedStartMinuteUpButton = function () {
    $scope.newClip.startMinute = pressedTimeUpButton($scope.newClip.startMinute, 59);
  };
  $scope.pressedStartSecondUpButton = function () {
    $scope.newClip.startSecond = pressedTimeUpButton($scope.newClip.startSecond, 59);
  };
  $scope.pressedStartHourDownButton = function () {
    $scope.newClip.startHour = pressedTimeDownButton($scope.newClip.startHour, 23);
  };
  $scope.pressedStartMinuteDownButton = function () {
    $scope.newClip.startMinute = pressedTimeDownButton($scope.newClip.startMinute, 59);
  };
  $scope.pressedStartSecondDownButton = function () {
    $scope.newClip.startSecond = pressedTimeDownButton($scope.newClip.startSecond, 59);
  };
  $scope.pressedEndHourDownButton = function () {
    $scope.newClip.endHour = pressedTimeDownButton($scope.newClip.endHour, 23);
  };
  $scope.pressedEndMinuteDownButton = function () {
    $scope.newClip.endMinute = pressedTimeDownButton($scope.newClip.endMinute, 59);
  };
  $scope.pressedEndSecondDownButton = function () {
    $scope.newClip.endSecond = pressedTimeDownButton($scope.newClip.endSecond, 59);
  };
  $scope.pressedEndHourUpButton = function () {
    $scope.newClip.endHour = pressedTimeUpButton($scope.newClip.endHour, 23);
  };
  $scope.pressedEndMinuteUpButton = function () {
    $scope.newClip.endMinute = pressedTimeUpButton($scope.newClip.endMinute, 59);
  };
  $scope.pressedEndSecondUpButton = function () {
    $scope.newClip.endSecond = pressedTimeUpButton($scope.newClip.endSecond, 59);
  };
  $scope.pressedTimelineHourUpButton = function () {
    $scope.timelineDate.hour = pressedTimeUpButton($scope.timelineDate.hour, 23);
  };
  $scope.pressedTimelineMinuteUpButton = function () {
    $scope.timelineDate.minute = pressedTimeUpButton($scope.timelineDate.minute, 59);
  };
  $scope.pressedTimelineSecondUpButton = function () {
    $scope.timelineDate.second = pressedTimeUpButton($scope.timelineDate.second, 59);
  };
  $scope.pressedTimelineHourDownButton = function () {
    $scope.timelineDate.hour = pressedTimeDownButton($scope.timelineDate.hour, 23);
  };
  $scope.pressedTimelineMinuteDownButton = function () {
    $scope.timelineDate.minute = pressedTimeDownButton($scope.timelineDate.minute, 59);
  };
  $scope.pressedTimelineSecondDownButton = function () {
    $scope.timelineDate.second = pressedTimeDownButton($scope.timelineDate.second, 59);
  };
  $scope.clipMessage = "";
  //FIXME: 삭제 요망 : 아무 행동 하지 않는 메소드
  var canCreateClip = function canCreateClip() {
    var cameraId = $scope.currentCamera.id;
    var startTime = getClipStartMoment().toDate().getTime();
    var endTime = getClipEndMoment().toDate().getTime();
  };
  $scope.changedZipTime = function () {
    $scope.newClip.duration = getClipDurationString();
    $scope.newClip.outputDuration = getClipDurationString($scope.newClip.playrate);
    if ($scope.newClip.playrate != "1" && !isChangedClipName) {
      $scope.newClip.name = $translate.instant("CLIP_CREATE_TIMELAPSE_NEW_NAME");
    } else if ($scope.newClip.playrate == "1" && !isChangedClipName) {
      $scope.newClip.name = $translate.instant("CLIP_CREATE_CLIP_NEW_NAME");
    }
  };

  // 클립&타임랩스 만들기
  $scope.createClip = function () {
    var startDate = getClipStartMoment().toDate();
    var endDate = getClipEndMoment().toDate();
    var startTime = getClipStartMoment().toDate().getTime();
    var endTime = getClipEndMoment().toDate().getTime();
    var startMoment = getClipStartMoment();
    var endMoment = getClipEndMoment();
    if (startDate.getMonth() < endDate.getMonth()) {} else if (startDate.getMonth() > endDate.getMonth()) {
      showAlert($translate.instant("CLIPS_ERR_DATE_SUBJECT"), $translate.instant("CLIPS_ERR_DATE_CONTENT"));
      return;
    } else {
      if (startDate.getDate() > endDate.getDate()) {
        showAlert($translate.instant("CLIPS_ERR_DATE_SUBJECT"), $translate.instant("CLIPS_ERR_DATE_CONTENT"));
        return;
      }
    }
    if (startTime > endTime) {
      showAlert($translate.instant("CLIPS_ERR_TIME_SUBJECT"), $translate.instant("CLIPS_ERR_TIME_CONTENT"));
      return;
    } else if (startTime == endTime) {
      showAlert($translate.instant("CLIPS_ERR_TIME_SUBJECT"), $translate.instant("CLIPS_ERR_TIME_CONTENT"));
      return;
    }
    if (endMoment - startMoment < 5 * 1000 || endMoment - startMoment > 2 * 60 * 60 * 1000) {
      showAlert($translate.instant("CLIPS_ERR_TIME_SUBJECT"), "5초에서 120분 이내의 영상만 클립만들기가 가능합니다.");
      return;
    }
    if (endMoment > moment()) {
      showAlert($translate.instant("CLIPS_ERR_TIME_SUBJECT"), "종료시간은 현재시간보다 이전이어야 합니다.");
      return;
    }
    var usageTotTime = $scope.config.usageTotTime; // 클립 총 사용시간
    var usageTime = $scope.config.usageTime; // 클립 현재 사용시간
    var createTime = endMoment - startMoment; // 생성하려는 클립 시간
    if (usageTotTime < usageTime + createTime) {
      showAlert("클립생성용량초과", "클립 저장 공간이 다 찼습니다.<br>클립을 다운로드 하거나 삭제해주세요.");
      return;
    }
    var clipType;
    if ($scope.newClip.playrate == "1" && !$scope.newClip.isSmart) {
      clipsType = "0";
    } else if ($scope.newClip.isSmart) {
      clipsType = "2";
    } else {
      clipsType = "1";
    }
    var params = {
      cameraId: $scope.currentCamera.id,
      labelName: $scope.newClip.name,
      start: getClipStartMoment().toDate().getTime(),
      end: getClipEndMoment().toDate().getTime(),
      timeOverlay: $scope.newClip.timeOverlay,
      speedx: $scope.newClip.playrate,
      type: clipsType
    };
    $scope.isShowCreateClip = false;
    Clip.save(params, function (data) {
      if (data.code === "ok") {
        showAlert($translate.instant("MENU_CLIP"), $translate.instant("CLIPS_MAKE"));
      } else if (data.code === "nok" && data.ableTime !== undefined) {
        showAlert("클립생성용량초과", "클립 저장 공간이 다 찼습니다.<br>클립을 다운로드 하거나 삭제해주세요.");
      } else {
        showAlert($translate.instant("MENU_CLIP"), $translate.instant("CLIPS_MAKE_CANNOT"));
      }
    }, function (err) {
      showAlert("통신장애", "서버와 통신중 장애가 발생하였습니다. <br>잠시 후 다시 시도해주세요.");
    });
  };
  $scope.moveTimeline = function () {
    $scope.checkCVRSeucre(function (isSecureMode) {
      if (isSecureMode) {
        $scope.play.securePassword = "";
        $scope.isShowCVRPlayPasswordConfirm = !$scope.isShowCVRPlayPasswordConfirm;
        $scope.cvrPasswordSuccess = function () {
          $scope.goCvr(getTimelineMoment().toDate());
          $scope.isShowTimelineCalendar = false;
        };
      } else {
        $scope.goCvr(getTimelineMoment().toDate());
        $scope.isShowTimelineCalendar = false;
      }
    });
  };

  // 이전 이벤트 리스트 목록
  $scope.prevEventList = function (idx) {
    $scope.eventListDateIndex++;
    if ($scope.eventListDateIndex >= $scope.eventListDate.length) {
      $scope.eventListDateIndex = $scope.eventListDate.length - 1;
      return;
    }
    $scope.pressedEventListDateButton($scope.eventListDateIndex);
    $scope.initFlags();
  };

  // 다음 이벤트 리스트 목록
  $scope.nextEventList = function (idx) {
    if (idx == 0) {
      return;
    }
    $scope.eventListDateIndex--;
    if ($scope.eventListDateIndex < 0) {
      $scope.eventListDateIndex = 0;
      return;
    }
    $scope.pressedEventListDateButton($scope.eventListDateIndex);
    $scope.initFlags();
  };
  $scope.initFlags = function () {
    tempIndexCheck = 0;
    $scope.pressedEventListTimeButtonFlag = false;
  };
  $scope.goCameraManager = function () {
    location.href = "/#/settings/product";
  };
  $scope.resizePlayer = function () {
    // $(".player_off_black").css("height",$("#player").css("height"));
  };
  $scope.alarmSetHide = function () {
    if ($("#alarm_set_no").is(":checked") == true) {
      $scope.setCookie("alarm_set_no", "alarm_set_no");
    }
    $("#alarm_set").remove();
  };
  $scope.cameraManage = function () {
    location.href = "/#/settings/product";
  };
  $scope.setCookie = function (cName, cValue, expireDate) {
    var expire = new Date();
    if (expireDate == "" || expireDate == undefined) {
      expire.setDate(expire.getDate() + 7);
    } else {
      expire.setDate(expire.getDate() + expireDate);
    }
    cookies = cName + "=" + escape(cValue) + "; path=/ "; //쿠키 저장
    cookies += ";expires=" + expire.toGMTString() + ";";
    document.cookie = cookies;
  };
  $scope.getCookie = function (cName) {
    cName = cName + "=";
    var cookieData = document.cookie;
    var start = cookieData.indexOf(cName);
    var cValue = "";
    if (start != -1) {
      start += cName.length;
      var end = cookieData.indexOf(";", start);
      if (end == -1) end = cookieData.length;
      cValue = cookieData.substring(start, end);
    }
    return unescape(cValue);
  };
  $scope.logout = function () {
    User.logout(function (data) {
      logoutSuccess();
    });
  };
  $scope.checkCVRSeucre = function (callback) {
    if ($scope.shareStatus == true) {
      CameraConfig.getSharedConfig({
        id: $stateParams.cameraId
      }, function (data) {
        if (data.secureMode == "on") {
          $scope.stopTimer();
          var passCVRSecure = sessionStorage.getItem("passCVRSecureCameraIds");
          if (passCVRSecure == null || passCVRSecure === "undefined") {
            callback(true);
          } else {
            if (passCVRSecure.indexOf($stateParams.cameraId) > -1) {
              callback(false);
            } else {
              callback(true);
            }
          }
        } else {
          callback(false);
        }
      }, function (err) {
        location.href = "/error";
      });
    } else {
      CameraConfig.get({
        id: $stateParams.cameraId
      }, function (data) {
        if (data.secureMode == "on") {
          $scope.stopTimer();
          var passCVRSecure = sessionStorage.getItem("passCVRSecureCameraIds");
          if (passCVRSecure == null || passCVRSecure === "undefined") {
            callback(true);
          } else {
            if (passCVRSecure.indexOf($stateParams.cameraId) > -1) {
              callback(false);
            } else {
              callback(true);
            }
          }
        } else {
          callback(false);
        }
      }, function (err) {
        location.href = "/error";
      });
    }
  };
  $scope.cancelCVRPlay = function () {
    if ($scope.isLive) {
      $scope.cursorOn = false;
      $scope.goLive();
    }
  };
  var currentPrevTime = 1;
  $scope.goPrevEvent = function () {
    var callbackFunc = function callbackFunc() {
      var currentTime = parseInt($scope.currentTime.valueOf());
      var prevTime = 0;
      arrEvents.filter(function (obj) {
        var allFilteredZoneIds = $scope.getAllFilteredZonesIds(obj.eventTps.split(","));
        var isCheckFilter = _.intersection(allFilteredZoneIds, obj.eventTps.split(",")).length;
        if (isCheckFilter > 0) {
          var startTime = parseInt(obj.startTime);
          if (startTime < currentTime && startTime > prevTime && currentPrevTime != startTime) {
            prevTime = startTime;
          }
        }
      });
      if (prevTime != 0) {
        currentPrevTime = prevTime;
        //cursorEventEndTime = nextTime;
        $scope.goCvr(prevTime);
      } else {
        var regDate = $scope.currentCamera.regDate;
        var serviceDateTime = new Date().valueOf() - 1000 * 60 * 60 * 24 * ($scope.serviceDay - 1);
        var serviceStartDate = regDate > serviceDateTime ? regDate : serviceDateTime;
        var goPrevEvent = function goPrevEvent(queryTime) {
          var allFilteredZoneIds = $scope.getAllFilteredZonesIds();
          Pos.getFindEventGroup({
            shopId: $stateParams.id,
            posId: $scope.selectPosVal,
            direction: "previous",
            scale: $scope.nowScale,
            queryTime: queryTime,
            range: 7,
            eventTps: allFilteredZoneIds.join(",")
          }, function (data) {
            if (data.eventGroup.startTime !== undefined && data.eventGroup.startTime > serviceStartDate) {
              // 이벤트가 있다면 이동
              var allFilteredZoneIds = $scope.getAllFilteredZonesIds(data.eventGroup.eventTps.split(","));
              var isCheckFilter = _.intersection(allFilteredZoneIds, data.eventGroup.eventTps.split(",")).length;
              if (isCheckFilter > 0) {
                $scope.goCvr(parseInt(data.eventGroup.startTime));
              } else {
                goPrevEvent(queryTime - 1000 * 60 * 60 * 24 * 2);
              }
            } else if (data.startTime === undefined && serviceStartDate < queryTime - 1000 * 60 * 60 * 24 * 2) {
              // 서비스 기간내인데 range내에 이벤트가 없으면 2일전으로 재검색
              goPrevEvent(queryTime - 1000 * 60 * 60 * 24 * 2);
            } else {
              showAlert("이벤트이동", "이전 이벤트가 없습니다.");
            }
          }, function (err) {
            location.href = "/error";
          });
        };
        goPrevEvent($scope.currentTime.valueOf());
      }
    };
    $scope.checkCVRSeucre(function (isSecureMode) {
      if (isSecureMode) {
        if (document.msFullscreenElement) {
          $scope.pressedExitFullScreenButton();
        }
        $scope.play.securePassword = "";
        $scope.isShowCVRPlayPasswordConfirm = !$scope.isShowCVRPlayPasswordConfirm;
        $scope.cvrPasswordSuccess = callbackFunc;
      } else {
        callbackFunc();
      }
    });
  };
  var currentNextTime = 1;
  // var goNextTimeout = 0;
  $scope.goNextEvent = function () {
    var callbackFunc = function callbackFunc() {
      // $timeout.cancel(goNextTimeout);
      // $interval.cancel($scope.timer);
      var currentTime = parseInt($scope.currentTime.valueOf());
      var nextTime = 0;
      arrEvents.filter(function (obj) {
        var allFilteredZoneIds = $scope.getAllFilteredZonesIds(obj.eventTps.split(","));
        var isCheckFilter = _.intersection(allFilteredZoneIds, obj.eventTps.split(",")).length;
        if (isCheckFilter > 0) {
          var startTime = parseInt(obj.startTime);
          if (startTime > currentTime && currentNextTime != startTime && (startTime < nextTime && nextTime != 0 || startTime > nextTime && nextTime == 0)) {
            nextTime = startTime;
          }
        }
      });
      if (nextTime != 0) {
        currentNextTime = nextTime;
        $scope.goCvr(nextTime);
      } else {
        var goNextEvent = function goNextEvent(queryTime) {
          var allFilteredZoneIds = $scope.getAllFilteredZonesIds();
          Pos.getFindEventGroup({
            shopId: $stateParams.id,
            posId: $scope.selectPosVal,
            direction: "next",
            scale: $scope.nowScale,
            queryTime: queryTime,
            range: 7,
            eventTps: allFilteredZoneIds.join(",")
          }, function (data) {
            var nowDate = Date.now();
            if (data.eventGroup.startTime !== undefined) {
              var allFilteredZoneIds = $scope.getAllFilteredZonesIds(data.eventGroup.eventTps.split(","));
              var isCheckFilter = _.intersection(allFilteredZoneIds, data.eventGroup.eventTps.split(",")).length;
              if (isCheckFilter > 0) {
                $scope.goCvr(parseInt(data.eventGroup.startTime));
              } else {
                goNextEvent(queryTime + 1000 * 60 * 60 * 24 * 2);
              }
            } else if (data.eventGroup.startTime === undefined && nowDate > queryTime + 1000 * 60 * 60 * 24 * 2) {
              goNextEvent(queryTime + 1000 * 60 * 60 * 24 * 2);
            } else {
              showAlert("이벤트이동", "다음 이벤트가 없습니다.");
            }
          }, function (err) {
            location.href = "/error";
          });
        };
        goNextEvent($scope.currentTime.valueOf());
      }
    };
    $scope.checkCVRSeucre(function (isSecureMode) {
      if (isSecureMode) {
        if (document.msFullscreenElement) {
          $scope.pressedExitFullScreenButton();
        }
        $scope.play.securePassword = "";
        $scope.isShowCVRPlayPasswordConfirm = !$scope.isShowCVRPlayPasswordConfirm;
        $scope.cvrPasswordSuccess = callbackFunc;
      } else {
        callbackFunc();
      }
    });
  };

  // 이벤트 공유 팝업 open
  var eventClipStartTime = 0;
  var eventClipEndTime = 0;
  var eventClipCameraId = "";
  $scope.showEventShareInfoLayer = function () {
    if ($scope.shareStatus == true) {
      showAlert("POS 관리", $translate.instant("ACCESS_SHARED_MARKET_DESC"));
      return;
    }
    eventClipStartTime = moment($scope.currentEventInfo.start, "x").subtract(30, "seconds").format("x");
    eventClipEndTime = moment($scope.currentEventInfo.start, "x").add(30, "seconds").format("x");
    var getCameraId = _.find($scope.posList, {
      posId: $scope.currentEventInfo.posId
    });
    eventClipCameraId = getCameraId.cameraId;
    $scope.isShowEventShareInfoLayer = true;
  };

  // 이벤트 공유 팝업 close
  $scope.hideEventShareInfoLayer = function () {
    $scope.isShowEventShareInfoLayer = false;
  };

  // 이벤트 클립 생성
  $scope.createEventClip = function () {
    if (eventClipStartTime > eventClipEndTime) {
      showAlert($translate.instant("CLIPS_ERR_TIME_SUBJECT"), $translate.instant("CLIPS_ERR_TIME_CONTENT"));
      return;
    } else if (eventClipStartTime == eventClipEndTime) {
      showAlert($translate.instant("CLIPS_ERR_TIME_SUBJECT"), $translate.instant("CLIPS_ERR_TIME_CONTENT"));
      return;
    }
    if (eventClipEndTime - eventClipStartTime < 5 * 1000 || eventClipEndTime - eventClipStartTime > 2 * 60 * 60 * 1000) {
      showAlert($translate.instant("CLIPS_ERR_TIME_SUBJECT"), "5초에서 120분 이내의 영상만 클립만들기가 가능합니다.");
      return;
    }
    var usageTotTime = $scope.config.usageTotTime; // 클립 총 사용시간
    var usageTime = $scope.config.usageTime; // 클립 현재 사용시간
    var createTime = eventClipEndTime - eventClipStartTime; // 생성하려는 클립 시간
    if (usageTotTime < usageTime + createTime) {
      showAlert("클립생성용량초과", "클립 저장 공간이 다 찼습니다.<br>클립을 다운로드 하거나 삭제해주세요.");
      return;
    }
    var params = {
      cameraId: eventClipCameraId,
      labelName: "새로운 클립",
      start: eventClipStartTime,
      end: eventClipEndTime,
      timeOverlay: "NO",
      speedx: "1",
      type: "0"
    };
    Clip.save(params, function (data) {
      if (data.code === "ok") {
        showAlert($translate.instant("MENU_CLIP"), $translate.instant("CLIPS_MAKE"));
        $scope.isShowEventShareInfoLayer = false;
      } else if (data.code === "nok" && data.ableTime !== undefined) {
        showAlert("클립생성용량초과", "클립 저장 공간이 다 찼습니다.<br>클립을 다운로드 하거나 삭제해주세요.");
      } else {
        showAlert($translate.instant("MENU_CLIP"), $translate.instant("CLIPS_MAKE_CANNOT"));
      }
    }, function (err) {
      showAlert("통신장애", "서버와 통신중 장애가 발생하였습니다. <br>잠시 후 다시 시도해주세요.");
    });
  };

  // 풀스크린 상태이고 타임라인 숨김상태일 때 마우스오버 이벤트 함수
  $scope.showTimeline = function () {
    if (isFullScreen()) {
      $scope.isToggleOn = true;
      $scope.isShowControlArea = false;
      isClickTimelineShow = false;
      $timeout.cancel(timelineHideTimer);
    }
  };

  // 풀스크린 적용시 타임라인 컨트롤바에서 mouseleave 이벤트 발생시 5초후 타임라인 숨김 처리
  $scope.hideTimeline = function () {
    if (isFullScreen() && !isClickTimelineShow) {
      timelineHideTimer = $timeout(function () {
        $scope.isShowControlArea = true; // fullscreen 타임라인 숨김인 경우 mouseover 영역 표시
        $scope.isShowTimelineCalendar = false;
        $scope.isToggleOn = false;
      }, 5000);
    }
  };

  // 풀스크린 상태이고 타임라인에 마우스오버 상태인 경우 타임라인 숨김 timeout을 취소
  $scope.cancelTimelineHide = function () {
    if (isFullScreen()) {
      $timeout.cancel(timelineHideTimer);
    }
  };
  var isClickTimelineShow = false; //클릭 이벤트로 타임라인 표시할 경우 timeout 적용되지 않도록하기 위한 flag
  // 풀스크린 상태일경우 타임라인 토글 이벤트 함수
  $scope.toggleTimeline = function () {
    $scope.isToggleOn = !$scope.isToggleOn;
    if ($scope.isToggleOn) {
      $scope.isShowControlArea = false;
    } else {
      $scope.isShowTimelineCalendar = false;
      $scope.isShowControlArea = true;
    }
    isClickTimelineShow = true;
    $timeout.cancel(timelineHideTimer);
  };

  // control button 숨김 timer 취소
  $scope.cancelHideButtonTimer = function () {
    if (!isFullScreen()) {
      $timeout.cancel(controlAreaHideTimer);
    }
  };

  // 카메라 상태변경
  var isChangeStreamStatusFlag = false;
  $scope.toggleCameraStatus = function () {
    $scope.isShowCameraOffConfirmLayer = false;
    $scope.isShowCameraOnConfirmLayer = false;
    if ($scope.shareDisable()) return;
    if (isChangeStreamStatusFlag) return;
    isChangeStreamStatusFlag = true;
    var paramStreamStatus = $scope.config.streamStatus === "on" ? "off" : "on";
    CameraConfig.update({
      id: $stateParams.cameraId
    }, {
      streamStatus: paramStreamStatus
    }, function (data) {
      if (data.code == "ok") {
        $scope.config.streamStatus = paramStreamStatus;
        if ($scope.config.streamStatus == "off") {
          $scope.cameraRecOff();
        } else {
          $scope.cameraStatusAllOff();
        }
      } else {
        showAlert("카메라 녹화 설정", "카메라 녹화 꺼짐/켜짐 설정 변경에 실패하였습니다.  <br>잠시 후 다시 시도해주세요.");
      }
      isChangeStreamStatusFlag = false;
    }, function (err) {
      isChangeStreamStatusFlag = false;
      showAlert("통신장애", "서버와 통신중 장애가 발생하였습니다. <br>잠시 후 다시 시도해주세요.");
    });
  };

  // 토스트 마켓 상품 상세 페이지 이동
  $scope.goMaket = function () {
    $window.location.href = $rootScope.ENV_VARS.marketUrl + "/product/CAM/" + $rootScope.ENV_VARS.marketDealNo + "?itemSerial=" + $scope.currentCamera.id;
  };

  // 구매 확인 레이어 팝업 호출
  $scope.showPurchaseConfirmLayer = function () {
    // ie에서 풀스크린상태일 경우 레이어 팝업이 보이지 않는 문제로.. 풀스크린 해제
    if (document.msFullscreenElement) {
      $scope.pressedExitFullScreenButton();
    }
    $scope.isShowPurchaseConfirmLayer = true;
  };

  // 구매 확인 레이어 팝업 닫기
  $scope.hidePurchageConfirmLayer = function () {
    $scope.isShowPurchaseConfirmLayer = false;
  };

  // 서비스 해지 확인 레이어 팝업 호출
  $scope.showRefundConfirmLayer = function () {
    $scope.isShowRefundConfirmLayer = true;
  };

  // 서비스 해지 확인 레이어 팝업 닫기
  $scope.hideRefundConfirmLayer = function () {
    $scope.isShowRefundConfirmLayer = false;
  };

  // 토스트마켓 서비스 해지 페이지 이동
  $scope.goMarketRefund = function () {
    $window.location.href = $rootScope.ENV_VARS.marketUrl + "/usage";
  };

  // 카메라 이름 변경 취소
  $scope.cancelCameraNameChange = function () {
    $scope.config.name = $scope.currentCamera.labelName;
    $scope.isEditingCameraName = false;
  };

  // 카메라 off 확인 레이어 팝업 닫기
  $scope.hideCameraOffConfirmLayer = function () {
    $scope.isShowCameraOffConfirmLayer = false;
  };

  // 카메라 on 확인 레이어 팝업 닫기
  $scope.hideCameraOnConfirmLayer = function () {
    $scope.isShowCameraOnConfirmLayer = false;
  };

  // 카메라 on / off 확인 레이어 팝업 열기
  $scope.showCameraOnOffConfirmLayer = function () {
    if ($scope.config.streamStatus == "off") {
      $scope.isShowCameraOnConfirmLayer = true;
      $scope.isShowCameraOffConfirmLayer = false;
    } else {
      $scope.isShowCameraOffConfirmLayer = true;
      $scope.isShowCameraOnConfirmLayer = false;
    }
  };
  $scope.getDateIndex = function (date) {
    for (i = 0; i < $scope.eventListDate.length; i++) {
      if ($scope.eventListDate[i].date == date) {
        $scope.selectedEventDateIndex = i;
        return i;
      }
    }
  };
  $scope.initFilterMarkFlag = true;
  /**
   * 이벤트 존 ajax 호출 및 필터 on / off 셋팅
   * @return {Promise}
   */
  var getEventTypeList = function getEventTypeList() {
    var deferred = $q.defer();
    Pos.getEventType({
      shopId: $stateParams.id,
      posId: $stateParams.posId
    }, function (res) {
      $scope.eventGroup_pay = [];
      $scope.eventGroup_cancel = [];
      $scope.eventGroup_pos = [];
      $scope.eventGroup_open_close = [];
      $scope.eventTypeList = [];
      $scope.eventTypeList = res.eventCodes;
      if ($scope.initFilterMarkFlag) {
        for (i = 0; i < $scope.eventTypeList.length; i++) {
          if ($stateParams.filters && $stateParams.filters != "") {
            $scope.eventTypeList[i].filterMark = "off";
          } else {
            $scope.eventTypeList[i].filterMark = "on";
          }
        }
        $scope.initFilterMarkFlag = false;
      }
      if ($stateParams.filters && $stateParams.filters != "") {
        var filterList = $stateParams.filters.split(",");
        for (i = 0; i < filterList.length; i++) {
          var checkedFilter = _.find($scope.eventTypeList, {
            posEventCodeId: filterList[i]
          });
          if (checkedFilter) {
            checkedFilter.filterMark = "on";
          }
        }
      }
      var eventGroupTemp = {};
      eventGroupTemp = $scope.eventTypeList.filter(function (value) {
        return value.posEventCodeId == "1";
      })[0];
      if (eventGroupTemp) {
        $scope.eventGroup_pay.push(eventGroupTemp);
      }
      eventGroupTemp = $scope.eventTypeList.filter(function (value) {
        return value.posEventCodeId == "102";
      })[0];
      if (eventGroupTemp) {
        $scope.eventGroup_pay.push(eventGroupTemp);
      }
      eventGroupTemp = $scope.eventTypeList.filter(function (value) {
        return value.posEventCodeId == "101";
      })[0];
      if (eventGroupTemp) {
        $scope.eventGroup_cancel.push(eventGroupTemp);
      }
      eventGroupTemp = $scope.eventTypeList.filter(function (value) {
        return value.posEventCodeId == "103";
      })[0];
      if (eventGroupTemp) {
        $scope.eventGroup_cancel.push(eventGroupTemp);
      }
      eventGroupTemp = $scope.eventTypeList.filter(function (value) {
        return value.posEventCodeId == "104";
      })[0];
      if (eventGroupTemp) {
        $scope.eventGroup_cancel.push(eventGroupTemp);
      }
      eventGroupTemp = $scope.eventTypeList.filter(function (value) {
        return value.posEventCodeId == "105";
      })[0];
      if (eventGroupTemp) {
        $scope.eventGroup_cancel.push(eventGroupTemp);
      }
      eventGroupTemp = $scope.eventTypeList.filter(function (value) {
        return value.posEventCodeId == "201";
      })[0];
      if (eventGroupTemp) {
        $scope.eventGroup_pos.push(eventGroupTemp);
      }
      eventGroupTemp = $scope.eventTypeList.filter(function (value) {
        return value.posEventCodeId == "202";
      })[0];
      if (eventGroupTemp) {
        $scope.eventGroup_pos.push(eventGroupTemp);
      }
      eventGroupTemp = $scope.eventTypeList.filter(function (value) {
        return value.posEventCodeId == "205";
      })[0];
      if (eventGroupTemp) {
        $scope.eventGroup_pos.push(eventGroupTemp);
      }
      eventGroupTemp = $scope.eventTypeList.filter(function (value) {
        return value.posEventCodeId == "203";
      })[0];
      if (eventGroupTemp) {
        $scope.eventGroup_open_close.push(eventGroupTemp);
      }
      eventGroupTemp = $scope.eventTypeList.filter(function (value) {
        return value.posEventCodeId == "204";
      })[0];
      if (eventGroupTemp) {
        $scope.eventGroup_open_close.push(eventGroupTemp);
      }
      if ($stateParams.date && $stateParams.date != "") {
        $scope.searchDate = moment($stateParams.date, "YYYYMMDD");
        $scope.eventListFlag = false;
        $("#date_today").attr("checked", true);
      } else {
        $scope.searchDate = moment();
        $scope.eventListFlag = true;
        $("#date_time").attr("checked", true);
      }
      if (moment($scope.searchDate).format("YYYYMMDD") != moment().format("YYYYMMDD")) {
        $scope.isToday = false;
      } else {
        $scope.isToday = true;
      }
      $scope.searchDateL = $scope.searchDate.valueOf();
      $scope.startLiveTimer();
      $scope.toggleEventFilter("all");
      if ($scope.eventListFlag) {
        setTimeout(function () {
          $("#timelinedesc").fadeIn(2500, function () {
            $("#timelinedesc").fadeOut(2000);
          });
        }, 2000);
        $scope.initpressedEventListDateButton();
      } else {
        $scope.pressedEventListDateButton(0);
      }
      var serviceMinDay = new Date().valueOf() - 1000 * 60 * 60 * 24 * ($scope.serviceDay - 1);
      $scope.datePicker = new Pikaday({
        field: document.getElementById("searchDate"),
        bound: false,
        container: document.getElementById("datePickerContainer"),
        minDate: moment(serviceMinDay).toDate(),
        maxDate: new Date(),
        defaultDate: new Date(),
        onSelect: function onSelect(date) {
          $scope.$apply(function () {
            $scope.changeDate(0, date);
          });
          this.hide();
        }
      });
      $scope.datePicker.hide();
      deferred.resolve();
    }, function (err) {
      showAlert("통신장애", "서버와 통신중 장애가 발생하였습니다. <br>잠시 후 다시 시도해주세요.");
      deferred.reject();
    });
    return deferred.promise;
  };

  /**
   * 이벤트 필터 체크 변경시 호출 함수
   * @param  {String} zoneId
   * @param  {String} eventType motion/sound/access
   */
  $scope.toggleEventFilter = function (eventType) {
    if (eventType === "pay") {
      // 선택여부에 따른 전체 선택 체크박스 체크 처리
      $scope.eventGroup_pay_all = !_.includes(_.map($scope.eventGroup_pay, "filterMark"), "off");
    } else if (eventType === "cancel") {
      $scope.eventGroup_cancel_all = !_.includes(_.map($scope.eventGroup_cancel, "filterMark"), "off");
    } else if (eventType === "pos") {
      $scope.eventGroup_pos_all = !_.includes(_.map($scope.eventGroup_pos, "filterMark"), "off");
    } else if (eventType === "open_close") {
      $scope.eventGroup_openClose_all = !_.includes(_.map($scope.eventGroup_open_close, "filterMark"), "off");
    } else {
      $scope.eventGroup_pay_all = !_.includes(_.map($scope.eventGroup_pay, "filterMark"), "off");
      $scope.eventGroup_cancel_all = !_.includes(_.map($scope.eventGroup_cancel, "filterMark"), "off");
      $scope.eventGroup_pos_all = !_.includes(_.map($scope.eventGroup_pos, "filterMark"), "off");
      $scope.eventGroup_openClose_all = !_.includes(_.map($scope.eventGroup_open_close, "filterMark"), "off");
    }

    // 공유 카메라가 아닌 경우 필터 저장
    // if ($scope.shareStatus === false) {
    // 	saveFilter();
    // }
    if (eventType != "all") {
      $scope.timeline.redrawEvents($scope.events); //타임라인 이벤트 그리기
      if ($scope.eventListFlag) {
        if ($scope.isLive) {
          $scope.initpressedEventListDateButton();
        } else {
          cursorEventFlag = true;
          cursorEventEndTime = 0;
          $scope.getCurrentCursorEventList();
        }
      } else {
        $scope.pressedEventListDateButton($scope.selectedEventDateIndex);
      }
    }
  };

  /**
   * 필터 전체 선택 check toggle 함수
   */
  $scope.eventGroup_pay_all = false;
  $scope.eventGroup_cancel_all = false;
  $scope.eventGroup_pos_all = false;
  $scope.eventGroup_openClose_all = false;
  $scope.toggleAllMotionFilter = function (type) {
    if (type == "pay") {
      angular.forEach($scope.eventGroup_pay, function (obj) {
        if ($scope.eventGroup_pay_all) {
          obj.filterMark = "on";
        } else {
          obj.filterMark = "off";
        }
      });
    } else if (type == "cancel") {
      angular.forEach($scope.eventGroup_cancel, function (obj) {
        if ($scope.eventGroup_cancel_all) {
          obj.filterMark = "on";
        } else {
          obj.filterMark = "off";
        }
      });
    } else if (type == "pos") {
      angular.forEach($scope.eventGroup_pos, function (obj) {
        if ($scope.eventGroup_pos_all) {
          obj.filterMark = "on";
        } else {
          obj.filterMark = "off";
        }
      });
    } else {
      angular.forEach($scope.eventGroup_open_close, function (obj) {
        if ($scope.eventGroup_openClose_all) {
          obj.filterMark = "on";
        } else {
          obj.filterMark = "off";
        }
      });
    }
    // 공유 카메라가 아닌 경우 필터 저장
    // if ($scope.shareStatus === false) {
    // 	saveFilter();
    // }
    $scope.timeline.redrawEvents($scope.events); //타임라인 이벤트 그리기
    if ($scope.eventListFlag) {
      if ($scope.isLive) {
        $scope.initpressedEventListDateButton();
      } else {
        cursorEventFlag = true;
        cursorEventEndTime = 0;
        $scope.getCurrentCursorEventList();
      }
    } else {
      $scope.pressedEventListDateButton($scope.selectedEventDateIndex);
    }
  };

  /**
   * 공유받은 카메라가 아닌 경우 이벤트 필터 저장 ajax 호출 처리 및
   * 타임라인 이벤트 그리기, 이벤트 리스트 필터링 및 섬네일 필터링 함수 호출
   */
  var saveFilter = function saveFilter() {
    var zoneData = _.concat($scope.eventTypeList, $scope.motionZones);
    var params = {
      zoneIndex: _.map(zoneData, "id").join(","),
      filterMark: _.map(zoneData, "filterMark").join(",")
    };
    Camera.updateAlarmZonesFiltersOnOff({
      cameraId: $scope.currentCamera.id
    }, params, function (res) {
      // success
    }, function (err) {
      showAlert("통신장애", "서버와 통신중 장애가 발생하였습니다. <br>잠시 후 다시 시도해주세요.");
    });
  };

  /**
   * 이벤트 리스트 목록의 상세 모션별 아이콘
   * @param {Number} zoneId
   * @return {Bolean} check 여부
   */
  $scope.showEventIcons = function (zoneId) {
    var allEventZones = _.map(_.filter(_.concat($scope.eventTypeList, $scope.motionZones), ["filterMark", "on"]), "id");
    return allEventZones.indexOf(zoneId.toString()) > -1;
  };

  /**
   * 이벤트 목록의  썸네일 중 필터체크 된 이벤트가 없을 경우 썸네일 숨김
   * @param  {[type]} eventData [description]
   * @return {[type]}           [description]
   */
  $scope.isShowEventThumbnail = function (eventData) {
    var allFilteredZoneIds = $scope.getAllFilteredZonesIds(eventData.zoneUidxs.split(","));
    return _.intersection(eventData.zoneUidxs.split(","), allFilteredZoneIds).length > 0;
  };

  /**
   * 비교할 zone data로 삭제된 이벤트를 포함
   * @param  {Array} zoneData
   * @return {Array} allFilteredZoneIdsArr 체크 처리된 zone id array. 모션존은 uid
   */
  $scope.getAllFilteredZonesIds = function (zoneData) {
    // 현재 이벤트 data의 zoneIdxs중 check 된 zoneIndex 여부 확인
    var filteredEventZoneIdsArr = _.map(_.filter($scope.eventTypeList, ["filterMark", "on"]), "posEventCodeId");
    if (filteredEventZoneIdsArr.length == 0) {
      filteredEventZoneIdsArr.push(0);
    }
    return filteredEventZoneIdsArr;
  };
  $scope.getShopPosList = function (init) {
    var promise;
    if ($stateParams.type === "shop" && typeof $stateParams.id !== "undefined") {
      promise = Shop.getShopV2({
        shopId: $stateParams.id
      }).$promise;
    } else if ($stateParams.type === "sharedshop" && typeof $stateParams.id !== "undefined") {
      promise = Shop.getSharedShopV2({
        shopId: $stateParams.id
      }).$promise;
    }
    $scope.selectCameraId = $stateParams.cameraId;
    var promise2 = Pos.getShopPosList({
      shopId: $stateParams.id
    }).$promise;
    $q.all([promise, promise2]).then(function (res) {
      $scope.currentShop = res[0];
      if ($stateParams.type === "shop" || $stateParams.type === "sharedshop") {
        $scope.cameraList = _.map(_.filter(res[0].controllerList, ["deviceType", "CAMERA"]), "cameraInfo");
      } else {
        $scope.cameraList = res[0].cameras;
      }
      $scope.posList = res[1].posLit;
      $scope.posCameraList = [];
      var filterPosCamera;
      for (i = 0; i < $scope.posList.length; i++) {
        if ($scope.cameraList.length > 0) {
          filterPosCamera = {};
          temp = _.find($scope.cameraList, {
            id: $scope.posList[i].cameraId
          });
          if (temp) {
            filterPosCamera["posId"] = $scope.posList[i].posId;
            filterPosCamera["posName"] = $scope.posList[i].posName;
            filterPosCamera["recorderType"] = temp.recorderType;
            filterPosCamera["id"] = temp.id;
            filterPosCamera["thumbnailPath"] = temp.thumbnailPath;
            $scope.posCameraList.push(filterPosCamera);
          }
        }
      }
      $scope.currentPosId = $stateParams.posId;
      $scope.currentPos = _.find($scope.posList, {
        posId: $stateParams.posId
      });
      $scope.selectPosVal = "";
      if (init) {
        getEventTypeList();
      } else {
        $scope.pressedEventListDateButton($scope.selectedEventDateIndex);
      }
    }, function (err) {
      showAlert("통신장애", "서버와 통신중 장애가 발생하였습니다. <br>잠시 후 다시 시도해주세요.");
    });
  };
  /**
   *	페이지 로딩시 갤러리 카메라 목록 호출
   */
  (function () {
    if (typeof $stateParams.type !== "undefined") {
      $scope.getShopPosList(true);
    }
  })();
  $scope.changeSelectPosList = function () {
    var selCameraId = _.find($scope.posList, {
      posId: $scope.selectPosVal
    });
    if (selCameraId) {
      $scope.selectCameraId = selCameraId.cameraId;
    } else {
      $scope.selectCameraId = $stateParams.cameraId;
    }
    posTimelineDragCnt = 100;
    $scope.setupDomain($scope.timeline.currentDomain);
    if ($scope.eventListFlag) {
      cursorEventFlag = true;
      cursorEventEndTime = 0;
      $scope.getCurrentCursorEventList();
    } else {
      $scope.pressedEventListDateButton($scope.selectedEventDateIndex);
    }
  };
  $scope.toggleEventListRadioBtn = function (type) {
    if (type == "today") {
      $scope.eventListFlag = false;
      if (moment($scope.searchDate).format("YYYYMMDD") == moment().format("YYYYMMDD")) {
        var index = moment().format("H");
        $scope.pressedEventListDateButton(parseInt(index));
      } else {
        $scope.pressedEventListDateButton(0);
      }
    } else {
      $scope.eventListFlag = true;
      setTimeout(function () {
        $("#timelinedesc").fadeOut(2000);
      }, 2000);
    }
  };

  /**
   * 전체 화면 모드 카메라 썸네일 목록 영영 토글 처리
   */
  $scope.toggleCameraGallery = function () {
    $scope.isAddShowGalleryClass = !$scope.isAddShowGalleryClass;
  };
  $scope.moveServiceDate = function (type) {
    if (type == "prev") {
      $scope.lastIndex = $scope.lastIndex - 30;
      $scope.fristIndex = $scope.fristIndex - 30;
    } else {
      $scope.lastIndex = $scope.lastIndex + 30;
      $scope.fristIndex = $scope.fristIndex + 30;
    }
  };
  $scope.showCVRSecureModeInfoLayer = function () {
    $scope.isShowCVRSecureModeInfo = true;
  };
  $scope.showSaveAlarmSettingConfirmLayer = function () {
    Pos.saveNotifyConfig({
      shopId: $stateParams.id
    }, {
      posNotifyOn: $scope.alramSettingOnOff,
      posNotifyType: $scope.alertSettingAllAlert
    }, function (data) {
      showAlert("알림 설정", "알림 설정이 저장되었습니다.");
      $scope.isShowPosAlramSettingLayer = false;
    }, function (err) {
      showAlert("알림 설정", "알림 설정 저장에 실패하였습니다.");
    });
  };

  //매출 알림 팝업
  $scope.showPosAlramSettingLayer = function () {
    if ($scope.shareStatus == true) {
      showAlert("POS 관리", $translate.instant("ACCESS_SHARED_MARKET_DESC"));
      return;
    }
    Pos.getPosNotifyConfig({
      shopId: $stateParams.id
    }, function (data) {
      $scope.alramSettingOnOff = data.posNotifyOn;
      $scope.alertSettingAllAlert = data.posNotifyType;
    }, function (err) {});
    $scope.isShowPosAlramSettingLayer = true;
  };
  $scope.closePosAlramSettingLayer = function () {
    $scope.isShowPosAlramSettingLayer = false;
  };

  //포스 정보 입력 화면
  $scope.showPosInfoInputLayer = function () {
    $scope.isShowPosInfoInputLayer = true;
  };
  $scope.closePosInfoInputLayer = function () {
    $scope.isShowPosInfoInputLayer = false;
  };

  //포스 수정
  $scope.showPosEditManageLayer = function (posInfo) {
    Pos.getPosInfo({
      shopId: $stateParams.id,
      posId: posInfo.posId
    }, function (data) {
      $scope.targetPosInfo = data.pos;
      $scope.editPosName = $scope.targetPosInfo.posName;
      $scope.editPosCamera = $scope.targetPosInfo.cameraId;
    }, function (err) {});
    $scope.isShowPosEditManageLayer = true;
  };
  $scope.closePosEditManageLayer = function () {
    $scope.isShowPosEditManageLayer = false;
  };

  //포스관리 팝업
  $scope.showPosManageLayer = function () {
    if ($scope.shareStatus == true) {
      showAlert("POS 관리", $translate.instant("ACCESS_SHARED_MARKET_DESC"));
      return;
    }
    Pos.getShopPosList({
      shopId: $stateParams.id,
      install: "no"
    }, function (data) {
      $scope.notInstallPosList = data.posLit;
    }, function (err) {});
    $scope.isShowPosManageLayer = true;
  };
  $scope.closePosManageLayer = function () {
    $scope.isShowPosManageLayer = false;
  };
  $scope.initSaveEditPosInfo = function () {
    $scope.isShowInitSaveEditPosInfoLayer = true;
  };
  $scope.closeInitSaveEditPosInfo = function () {
    $scope.isShowInitSaveEditPosInfoLayer = false;
  };
  $scope.saveEditPosInfo = function () {
    $scope.editPosName = $("#editPosName").val();
    $scope.editPosCamera = $("#editPosCamera").val();
    Pos.updatePos({
      shopId: $stateParams.id,
      posId: $scope.targetPosInfo.posId,
      cameraId: $scope.editPosCamera
    }, {
      posName: $scope.editPosName
    }, function (data) {
      $scope.getShopPosList();
      $scope.isShowPosEditManageLayer = false;
      $scope.isShowInitSaveEditPosInfoLayer = false;
      showAlert("POS 수정", "POS 정보가 수정되었습니다.");
    }, function (err) {
      showAlert("POS 수정", "POS 정보 수정에 실패하였습니다. 다시 시도해주세요.");
    });
  };
  $scope.saveCreatePosInfo = function () {
    $scope.createPosName = $("#createPosName").val();
    $scope.selectNotInstallPos = $("#selectNotInstallPos").val();
    $scope.selectPosInCamera = $("#selectPosInCamera").val();
    if ($scope.createPosName == "") {
      showAlert("POS 등록", "POS 이름을 입력하세요.");
      return;
    }
    if ($scope.selectNotInstallPos == "") {
      showAlert("POS 등록", "POS를 선택해주세요.");
      return;
    }
    if ($scope.selectPosInCamera == "") {
      showAlert("POS 등록", "카메라를 선택해주세요.");
      return;
    }
    Pos.insertPos({
      shopId: $stateParams.id,
      posId: $scope.selectNotInstallPos,
      cameraId: $scope.selectPosInCamera
    }, {
      posName: $scope.createPosName
    }, function (data) {
      Pos.getShopPosList({
        shopId: $stateParams.id,
        install: "no"
      }, function (data) {
        $scope.notInstallPosList = data.posLit;
      }, function (err) {});
      $timeout(function () {
        $scope.getShopPosList();
      }, 1000);
      showAlert("POS 등록", "POS가 등록되었습니다.");
    }, function (err) {
      showAlert("POS 등록", "POS 정보 등록에 실패하였습니다. 다시 시도해주세요.");
    });
  };
  $scope.changeAlertSettingAllAlert = function (type) {
    $scope.alertSettingAllAlert = type;
  };
  $scope.changeAlertSettingOnOff = function (type) {
    $scope.alramSettingOnOff = type;
  };
  $scope.showPosDetailLayer = function (event, type) {
    $scope.currentEventInfo = event;
    $scope.billAreaHeight = "535px";
    if (!event.billNo || event.billNo == "") {
      if (type) {
        $scope.showPosVideoLayer();
      }
      $scope.billDetailInfo = {};
      $scope.billDetailInfo.billNo = "-";
      $scope.billDetailInfo.eventNm = event.eventNm;
      $scope.billDetailInfo.barColor = event.color;
      $scope.billDetailInfo.eventDate = moment(event.start).format("YYYY-MM-DD HH:mm:ss");
      $scope.isShowPosDetailLayer = true;
      return;
    }
    if (!event.salesTm) {
      event.salesTm = moment(event.start).format("YYYYMMDD");
    }
    Pos.getBillDetail({
      shopId: event.shopId,
      posId: event.posId,
      billNo: event.billNo,
      date: event.salesTm
    }, function (data) {
      if (data.code == "ok") {
        $scope.billDetailInfo = data.detail;
        $scope.billDetailInfo.billNo = event.billNo;
      } else {
        $scope.billDetailInfo = {};
        $scope.billDetailInfo.billNo = "-";
      }
      if (type) {
        $scope.showPosVideoLayer();
      }
      $scope.billDetailInfo.eventNm = event.eventNm;
      $scope.billDetailInfo.barColor = event.color;
      $scope.billDetailInfo.eventDate = moment(event.start).format("YYYY-MM-DD HH:mm:ss");
      $scope.isShowPosDetailLayer = true;
    }, function (err) {
      showAlert("통신장애", "서버와 통신중 장애가 발생하였습니다. <br>잠시 후 다시 시도해주세요.");
    });
  };
  $scope.closePosDetailLayer = function () {
    $scope.isShowPosVideoArea = false;
    $interval.cancel($scope.vedioTimer);
    $scope.isShowPosDetailLayer = false;
    $scope.currentEventInfo = {};
  };
  $scope.setCurrentTab = function (type) {
    var allFilteredZoneIds = $scope.getAllFilteredZonesIds().join(",");
    if (type == "summary") {
      //shopId?cameraId&posId&type&filter
      $state.go("main.dashboard.pos", {
        shopId: $stateParams.id,
        cameraId: $stateParams.cameraId,
        posId: $stateParams.posId,
        type: $stateParams.type,
        filter: allFilteredZoneIds
      });
    }
  };
  var cursorEventEndTime = 0;
  var cursorEventFlag = true;
  //이벤트 리스트 날짜 이동시 이벤트 리스트 목록에 출력하는 화면 생성
  $scope.setEventDailyDataSet = function (data) {
    if ($scope.serviceDay == 0) {
      return;
    }
    for (i = 0; i < data.length; i++) {
      var posInfo = _.find($scope.posList, {
        posId: data[i].posId
      });
      data[i]["posName"] = posInfo.posName;
    }
    $scope.eventCursorLists = [];
    $scope.eventCursorLists = data;
  };
  $scope.getCurrentCursorEventList = function () {
    var time = moment($scope.currentTime).format("x");
    var time2 = moment(moment($scope.currentTime).add(3, "s")).format("x");
    if (time >= cursorEventEndTime && cursorEventFlag) {
      var params = {
        cameraId: $scope.selectCameraId,
        shopId: $stateParams.id,
        posId: $scope.selectPosVal,
        scale: $scope.nowScale,
        start: time,
        end: time2,
        eventTps: $scope.getAllFilteredZonesIds().join(",")
      };
      Pos.getPosTimeline(params, function (data) {
        if (data.events.length > 0) {
          $scope.groupIds = data.events[0].id;
          if ($scope.groupIds) {
            var params = {
              shopId: $stateParams.id,
              posId: $scope.selectPosVal,
              groupIds: $scope.groupIds,
              eventTps: $scope.getAllFilteredZonesIds().join(","),
              sortField: $scope.sortField,
              sorting: $scope.sorting
            };
            Pos.getGroupDetailPos(params, function (data) {
              if (data.events.length > 0) {
                $scope.setEventDailyDataSet(data.events);
                cursorEventEndTime = data.events[0].end;
              } else {
                $scope.groupIds = "";
                $scope.eventCursorLists = [];
                $scope.setCursorEventEndTime();
              }
            }, function (err) {});
          }
        } else {
          $scope.groupIds = "";
          $scope.eventCursorLists = [];
          $scope.setCursorEventEndTime();
        }
      }, function (err) {});
    }
  };
  $scope.setCursorEventEndTime = function () {
    var time = moment($scope.currentTime).format("x");
    var allFilteredZoneIds = $scope.getAllFilteredZonesIds();
    var currentTime = parseInt($scope.currentTime.valueOf());
    var nextTime = 0;
    var groupIds = "";
    arrEvents.filter(function (obj) {
      var allFilteredZoneIds = $scope.getAllFilteredZonesIds(obj.eventTps.split(","));
      var isCheckFilter = _.intersection(allFilteredZoneIds, obj.eventTps.split(",")).length;
      if (isCheckFilter > 0) {
        var startTime = parseInt(obj.startTime);
        if (startTime > currentTime && currentNextTime != startTime && (startTime < nextTime && nextTime != 0 || startTime > nextTime && nextTime == 0)) {
          nextTime = startTime;
        }
      }
    });
    if (nextTime != 0) {
      cursorEventEndTime = nextTime;
    } else {
      cursorEventEndTime = 0;
      cursorEventFlag = false;
    }
  };
  $scope.initCursorEventTime = function () {
    cursorEventFlag = true;
    cursorEventEndTime = 0;
  };

  /**
   * date picker open
   */
  $scope.toggleDatePicker = function (event) {
    event.stopPropagation();
    if ($scope.datePicker.isVisible()) {
      $scope.datePicker.hide();
    } else {
      $scope.datePicker.show();
    }
  };

  /**
   * 오늘 날짜 조회로 변경
   */
  $scope.changeDate = function (index, setDate) {
    if (typeof index === "undefined") {
      $scope.searchDate = moment();
      $scope.isToday = true;
    } else {
      var validDate;
      if (setDate) {
        validDate = moment(setDate).toDate();
      } else {
        validDate = moment($scope.searchDate).add(index, "d").toDate();
      }
      var serviceDateTime = new Date().valueOf() - 1000 * 60 * 60 * 24 * ($scope.serviceDay - 1);
      if (moment(validDate).format("YYYYMMDD") > moment().format("YYYYMMDD")) {
        return;
      } else if (moment(validDate).format("YYYYMMDD") < moment(serviceDateTime).format("YYYYMMDD")) {
        return;
      }
      $scope.searchDate = validDate;
      if (moment($scope.searchDate).format("YYYYMMDD") != moment().format("YYYYMMDD")) {
        $scope.isToday = false;
      } else {
        $scope.isToday = true;
      }
    }
    $scope.pressedEventListDateButton(0);
    $scope.goCvr($scope.searchDate);
  };
  $scope.goToday = function () {
    if ($scope.isToday) {
      return;
    }
    $scope.searchDate = Date.now();
    var index = moment().format("H");
    $scope.isToday = true;
    $scope.pressedEventListDateButton(parseInt(index));
    $scope.goCvr($scope.searchDate);
  };
  $scope.minIndex = 0;
  $scope.maxIndex = 13;
  $scope.eventMoveBtn = function (index) {
    var check = $scope.minIndex + index;
    if (check < 0) {
      return;
    }
    if (check > 15) {
      return;
    }
    $scope.minIndex = $scope.minIndex + index;
    $scope.maxIndex = $scope.maxIndex + index;
  };
  $scope.initEventMoveIndex = function (index) {
    if (index > 15) {
      index = 15;
    }
    $scope.minIndex = 0 + index;
    $scope.maxIndex = 13 + index;
  };
  $scope.initpressedEventListDateButton = function () {
    var selectedDate = moment($scope.searchDate).format("YYYYMMDD");
    var allFilteredZoneIds = $scope.getAllFilteredZonesIds();
    $scope.eventLists = {};
    Pos.getEventList({
      shopId: $stateParams.id,
      date: selectedDate,
      pageSize: 0,
      posId: $scope.selectPosVal,
      eventTps: allFilteredZoneIds.join(","),
      sortField: $scope.sortField,
      sorting: $scope.sorting
    }, function (data) {
      var dateList = [];
      var diffDate = moment().subtract("3", "hour").format("YYYYMMDDHHmm");
      for (i = 0; i < data.events.length; i++) {
        var eventDate = moment(data.events[i].start, "x").format("YYYYMMDDHHmm");
        if (eventDate > diffDate) {
          dateList.push(data.events[i]);
        }
      }
      $scope.setEventDailyDataSet(dateList);
    }, function (err) {});
  };
  $scope.initGoLive = function () {
    $scope.searchDate = moment();
    $scope.isToday = true;
    $scope.initpressedEventListDateButton();
    $scope.goLive();
  };
  $scope.vedioHeightArea = "250px";
  $scope.billAreaHeight = "535px";
  //상세 매출 영상 보기
  $scope.showPosVideoLayer = function () {
    $scope.vedioPosInfo = _.find($scope.posList, {
      posId: $scope.currentEventInfo.posId
    });
    $scope.billAreaHeight = "240px";
    $scope.videoCursorPosition = 0;
    $scope.videoDuration = "-1:00";
    $scope.clipStartTime = moment($scope.currentEventInfo.start, "x").subtract(30, "seconds").format("HH:mm:ss");
    $scope.clipEndTime = moment($scope.currentEventInfo.start, "x").add(30, "seconds").format("HH:mm:ss");
    $scope.vedioStartTime = moment($scope.currentEventInfo.start, "x").subtract(30, "seconds");
    $scope.vedioEndTime = moment($scope.currentEventInfo.start, "x").add(30, "seconds");
    var goplayTime = moment($scope.currentEventInfo.start, "x").subtract(30, "seconds").format("x");
    $scope.goCvr(parseInt(goplayTime));
    $scope.vedioTime = $scope.vedioStartTime;
    setTimeout(function () {
      startVideoTimer();
    }, 1000);
    $scope.isShowPosVideoArea = true;
  };
  $scope.closePosVideoLayer = function () {
    $scope.billAreaHeight = "535px";
    $scope.isShowPosVideoArea = false;
    $interval.cancel($scope.vedioTimer);
  };
  var duration = 60;
  var barWidth = parseInt(d3.select("#videoBar").style("width"));
  var videoDrag = d3.behavior.drag().on("drag", function (e) {
    var x = d3.mouse(this)[0]; // for cursur center
    $scope.videoCursorPosition = x;
  }).on("dragstart", function () {
    $interval.cancel($scope.vedioTimer);
  }).on("dragend", function () {
    var x = d3.mouse(this)[0]; // for cursur center
    $scope.videoCursorPosition = x;
    barWidth = parseInt(d3.select("#videoBar").style("width"));
    var diffTime = Math.round(duration * ($scope.videoCursorPosition / barWidth));
    var newTime = moment($scope.vedioStartTime).add(diffTime, "seconds").format("x");
    $scope.vedioTime = moment($scope.vedioStartTime).add(diffTime, "seconds");
    $scope.goCvr(parseInt(newTime));
    setTimeout(function () {
      startVideoTimer();
    }, 1000);
  });
  d3.select("#videoCursor").call(videoDrag);
  d3.select("#videoBar").on("click", function () {
    var x = d3.mouse(this)[0]; // for cursur center
    $scope.videoCursorPosition = x;
    barWidth = parseInt(d3.select("#videoBar").style("width"));
    var diffTime = Math.round(duration * ($scope.videoCursorPosition / barWidth));
    var newTime = moment($scope.vedioStartTime).add(diffTime, "seconds").format("x");
    $scope.vedioTime = moment($scope.vedioStartTime).add(diffTime, "seconds");
    $scope.goCvr(parseInt(newTime));
  });
  var startVideoTimer = function startVideoTimer() {
    $interval.cancel($scope.vedioTimer);
    $scope.vedioTimer = $interval(function () {
      if ($scope.player.getIsPlaying()) {
        barWidth = parseInt(d3.select("#videoBar").style("width"));
        var tempCurser = $scope.videoCursorPosition + barWidth / 60;
        $scope.vedioTime = moment(moment($scope.vedioTime, "x").add(1, "seconds"));
        var endTime = $scope.vedioEndTime;
        var vidioTimeDiff = moment(endTime).diff($scope.vedioTime, "seconds");
        $scope.videoDuration = "-0:" + vidioTimeDiff;
        if (tempCurser >= barWidth) {
          tempCurser = barWidth;
        }
        $scope.videoCursorPosition = tempCurser;
        if (vidioTimeDiff == 0) {
          $scope.player.pause();
          $scope.replaceShow = true;
          $interval.cancel($scope.vedioTimer);
        }
      }
    }, 1000);
  };
  $scope.replaceShow = false;
  $scope.isPlayed = false;
  $scope.goCameraDetail = function () {
    var goTime = moment($scope.vedioStartTime).format("x");
    $state.go("main.cameraDetail", {
      cameraId: $stateParams.cameraId,
      type: $stateParams.type === "sharedshop" ? $stateParams.type : "shop",
      id: $stateParams.id,
      time: goTime,
      shared: $stateParams.type === "sharedshop"
    });
  };
  $scope.vedioPlay = function () {
    $scope.goCvr(parseInt(moment($scope.vedioTime).format("x")));
    // $interval.cancel($scope.vedioTimer);
    startVideoTimer();
    $scope.isPlayed = false;
    $scope.isShowAnimate = false;
  };
  $scope.vedioStop = function () {
    $scope.player.pause();
    $scope.isPlayed = true;
    $scope.isShowAnimate = true;
    $interval.cancel($scope.vedioTimer);
  };
  $scope.clipsReplay = function () {
    $scope.goCvr(parseInt(moment($scope.vedioStartTime).format("x")));
    $scope.vedioTime = $scope.vedioStartTime;
    $scope.videoCursorPosition = 0;
    $scope.replaceShow = false;
    startVideoTimer();
  };
  $scope.changeEventListSorting = function (type) {
    $scope.sortField = type;
    if ($scope.sorting == "desc") {
      $scope.sorting = "asc";
    } else {
      $scope.sorting = "desc";
    }
    if ($scope.eventListFlag) {
      if ($scope.isLive) {
        $scope.initpressedEventListDateButton();
      } else {
        cursorEventFlag = true;
        cursorEventEndTime = 0;
        $scope.getCurrentCursorEventList();
      }
    } else {
      $scope.pressedEventListDateButton($scope.selectedEventDateIndex);
    }
  };
  var fullscreenChangeEvent = function fullscreenChangeEvent() {
    //  커서가 bar 밖으로 나가지 않도록 보정
    if (!$scope.isFullscreenButtonClicked) {
      $scope.isFullscreenButtonClicked = false;
      setTimeout(function () {
        $scope.vedioHeightArea = "250px";
        fullscreenFlag = false;
        $scope.isShowFullscreenButton = true;
        $scope.isShowTimelineToggleArea = true;
        $scope.isToggleOn = false;
        barWidth = parseInt(d3.select("#videoBar").style("width"));
        var tempPosition = $scope.videoCursorPosition * (barWidth / fullScreenWidth);
        if (barWidth < tempPosition) {
          $scope.videoCursorPosition = barWidth;
        } else if (tempPosition < 0) {
          $scope.videoCursorPosition = 0;
        } else {
          $scope.videoCursorPosition = tempPosition;
        }
      });
    } else {
      $scope.isFullscreenButtonClicked = false;
    }
  };
  d3.select("#fullscreen").on("webkitfullscreenchange", fullscreenChangeEvent);
  d3.select("#fullscreen").on("mozfullscreenchange", fullscreenChangeEvent);
  d3.select(document).on("MSFullscreenChange", fullscreenChangeEvent);
  $scope.backPage = function () {
    history.go(-1);
  };
}]);
"use strict";

var arrEvents = new Array();
var checkFilters = new Map();
var beforeSgid = "";
var thumname_list = [];
var timeLineMap = new Map();
var show_thumname_idx = 0;
var zonesLength = 0;
var zoomZoneBottom = 149;
var zoomZoneRight = 580;
var errCnt = 0;
var liveReloadCnt = 1;
var offLayer = false;
var thumnailDraw = true;
var changeTimeRangeFlag = false;
var fullscreenFlag = false;
app.controller("DashboardPosViewCtrl", ["$scope", "$rootScope", "$stateParams", "$state", "$interval", "Camera", "Share", "User", "CameraConfig", "CameraNotifyConfig", "Timezone", "$translate", "$timeout", "Clip", "$sce", "$q", "$compile", "$window", "Shop", "Pos", "Utils", function ($scope, $rootScope, $stateParams, $state, $interval, Camera, Share, User, CameraConfig, CameraNotifyConfig, Timezone, $translate, $timeout, Clip, $sce, $q, $compile, $window, Shop, Pos, Utils) {
  showPage();
  $scope.moveCameraListCount = 10;
  $scope.fristIndex = 30;
  $scope.lastIndex = 60;
  $scope.sortField = "salesTm";
  $scope.sorting = "desc";
  $scope.cameraName = "";
  $scope.timelineData = "";
  $scope.timelineEle = "";
  $scope.nowScale = "1h";
  $scope.tzCode = "";
  $scope.eventListCheckFlag = false;
  $scope.pressedEventListTimeButtonFlag = false;
  $scope.isAudioChat = false;
  $scope.isScreenShot = false;
  $scope.showCameraOffLayer = false;
  $scope.isLive = true;
  $scope.wifiPwdChange = false;
  $scope.showSelectColor = false;
  $scope.shareStatus = true;
  $scope.isAddShare = false;
  $scope.isRemoveShare = false;
  $scope.isPromotionCheck = false;
  $scope.volumeList = [];
  $scope.volumeIdx = 0;
  $scope.timelineDataLastDate = 0;
  $scope.eventListDateIndex = 0;
  $scope.lastEvent = 0;
  $scope.lastRec = 0;
  $scope.liveReplayCheck = 0;
  $scope.serviceDay = 0;
  $scope.cloudEnd = 0;
  $scope.currentTimeNow = {
    time: Date.now()
  };
  $scope.getContextPath = Utils.getContextPath();
  $scope.colorArray = ["#ff7900", "#3ea1d4", "#a4c800", "#efd600", "#767dff", "#ca7af0", "#ff76bd", "#18b57b", "#929292"]; //주황(ID:1),파랑(ID:2),연두(ID:3),노랑(ID:4),진한보라(ID:5),보라(ID:6),핑크(ID:7),녹색(사운드, ID:0),회색(기타, ID:8)

  $scope.colorArrayName = ["org", "sky", "grn", "yel", "blpp", "ppl", "pink"];
  var playserStop = 0;
  var timelineHideTimer;
  var cvrArray = new Array();
  $scope.playStatusType = {
    READY: "ready",
    PLAYING: "playing",
    ERROR: "error"
  };
  $scope.playErrorType = {
    NONE: "none",
    NO_TIMELINE: "noTimeline",
    NO_CLOUD: "noCloud",
    NO_CAM: "noCam"
  };
  $scope.playStatusObj = {
    status: $scope.playStatusType.READY,
    errorStatus: $scope.playErrorType.NONE
  };
  $("#showThumbnailListNew").mouseleave(function () {
    $("#time_info_tri").hide();
    $("#showThumbnailListNew").hide();
  });
  $("#view_timeline_area").mouseleave(function () {
    $("#time_info_tri").hide();
    $("#showThumbnailListNew").hide();
  });
  $scope.camera = {
    id: $stateParams.cameraId
  };
  var showAlert = function showAlert(title, message) {
    $(".display_show").css("display", "");
    $scope.showAlert = true;
    $scope.alertTitle = title;
    $scope.alertMessage = message;
  };
  $scope.hideAlert = function () {
    $scope.showAlert = false;
  };
  $scope.isExpiredCloud = function () {
    if ($scope.currentCamera) {
      return Utils.isCloudExpired($scope.currentCamera);
    } else {
      return false;
    }
  };
  document.body.classList.add("wide_scroll");

  // $interval cancel
  $scope.$on("$destroy", function () {
    $("body").removeClass("wide_scroll");
    if ($scope.player) {
      $scope.player.destroy();
    }
    $interval.cancel($scope.reloadTimer); // CVR Fetch
    $interval.cancel($scope.timer); // Cursor 시간
    $interval.cancel($scope.eventThumbTimer); // 타임라인 마우스 오버시 나타나는 썸네일 반복
    $interval.cancel($scope.eventlistTimer); // 이벤트 목록 썸네일 반복
    $interval.cancel(callEvtList); //이벤트 리스트 주기적으로 호출 및 업데이트
    $interval.cancel($scope.vedioTimer);
    posTimelineDragCnt = 0;
    //	clearInterval(calluevtList);//이벤트 리스트 현재 시간 모션들 카운트
    if ($scope.clipEndDatePicker) $scope.clipEndDatePicker.destroy();
    if ($scope.clipStartDatePicker) $scope.clipStartDatePicker.destroy();
    if ($scope.timelineDatePicker) $scope.timelineDatePicker.destroy();
    if ($scope.datePicker) $scope.datePicker.destroy();
    $timeout.cancel(renderClipDatePickerTimer);
  });

  // 1분 주기로 이벤트 리스트 로딩
  callEvtList = $interval(function () {
    if ($scope.shareStatus == true) {
      $scope.shareEnd();
    }
    if ($scope.currentCamera.saveEndDate < new Date().valueOf()) {
      $interval.cancel(callEvtList);
      return;
    }
    var nowTimeCheck = new Date();
    var getTimeMin = nowTimeCheck.getMinutes();
    if (getTimeMin == 0) {
      getTimeMin = 60;
    }
    var nowHours = new Date().getHours();
    var selectedDate = dateWithDateIndex(0);
    var refleshEvtList = 0;
    var topEvtList = $("#btn_time_" + nowHours + "_" + selectedDate).children("button").children("span").html();
    if (parseInt(topEvtList) > 0) {
      refleshEvtList = 60;
      if ($("#btn_time_" + nowHours + "_" + selectedDate).css("display") == "none" && $scope.eventListDateIndex == 0) {
        refleshEvtList = 1;
      }
    } else {
      refleshEvtList = 2;
    }
  }, 60000);
  var playCheackCnt = 0;
  var cvrReplay = 0;
  var flashStatusFlush = false;
  var flashStatusEmpty = false;
  var statusCheck = 0;
  var initSizeTimline = function initSizeTimline() {
    var currentDomainData = $scope.timeline;
    $scope.timeline.redrawWithWidth(parseInt($("#view_timeline_ctrl").width()));
  };
  $scope.currentTab = "event";
  $scope.shareCheck = function () {
    if ($stateParams.type === "sharedshop") {
      $scope.shareStatus = true;
    } else {
      $scope.shareStatus = false;
    }
  };
  $scope.viewPageTop = function () {
    setTimeout(function () {
      if ($("html").attr("lang") == "en") {
        for (var i = 0; i < $(".en_en_en").length; i++) {
          $(".en_en_en").eq(i).attr("class", $(".en_en_en").eq(i).attr("class").replace("_en_en_en", "_en"));
          //	cam_info_bg_en_en_en
        }
        $(".cam_info_bg_en_en_en").addClass("cam_info_bg_en");
        $(".cam_info_bg_en_en_en").removeClass("cam_info_bg");
      } else {
        $(".cam_info_bg").removeClass("cam_info_bg_en_en_en");
      }
      $(".en_en_en").removeClass("en_en_en");
      var trident = navigator.userAgent.match(/Trident\/(\d)/i);
      if (trident != null) {
        document.documentElement.scrollTop = 104;
      } else {
        $(window).scrollTop(104);
      }
    }, 500);
  };

  //$scope.viewPageTop();

  $scope.goDetail = function (id) {
    var trident = navigator.userAgent.match(/Trident\/(\d)/i);
    if (trident != null) {
      document.documentElement.scrollTop = 0;
    } else {
      $("body").scrollTop(0);
    }
    $state.go("main.dashboard.posView", {
      cameraId: id
    }, {
      reload: true,
      inherit: true,
      notify: true
    });
  };
  $scope.plyBtnStatus = true;
  $scope.pauseBtn = function () {
    $scope.player.pause();
    $scope.isPlaying = false;
    $scope.plyBtnStatus = false;
  };
  $scope.playBtn = function () {
    $scope.isPlaying = true;
    $scope.plyBtnStatus = true;
    $scope.cameraStatusAllOff();
    $scope.clickedCVRArea(new Date($scope.timeline.x.invert($(".cursor").children("line").attr("x1")).getTime()));
  };

  //녹화 지연
  $scope.cameraRecDelay = function () {
    $scope.showNoPlayLayer = true;
    $scope.showCameraOffLayer = false;
    $scope.showCameraStreamLayer = false;
    $scope.showNextPlayLayer = false;
  };

  //카메라 접속 끊김
  $scope.cameraConnectOff = function () {
    $scope.showNoPlayLayer = false;
    $scope.showCameraOffLayer = true;
    $scope.showCameraStreamLayer = false;
    $scope.showNextPlayLayer = false;
    Camera.isLastRecord({
      id: $stateParams.cameraId
    }, function (data) {
      $scope.currentCameraIsLastRecordDataSet(data);
    });
  };

  //저장된 영상 없음
  $scope.cameraNoSave = function () {
    $scope.showNoPlayLayer = false;
    $scope.showCameraOffLayer = false;
    $scope.showCameraStreamLayer = false;
    $scope.showNextPlayLayer = true;
  };

  //녹화가 꺼져 있음
  $scope.cameraRecOff = function () {
    $scope.showNoPlayLayer = false;
    $scope.showCameraOffLayer = false;
    $scope.showCameraStreamLayer = true;
    $scope.showNextPlayLayer = false;
  };

  //정상 플레이
  $scope.cameraStatusAllOff = function () {
    $scope.showNoPlayLayer = false;
    $scope.showCameraOffLayer = false;
    $scope.showCameraStreamLayer = false;
    $scope.showNextPlayLayer = false;
    $scope.isCameraOffLastRec = false;
    $scope.isCameraOffLastEvent = false;
  };
  $scope.livePlay = function (check) {
    $scope.cameraStatusAllOff();
    $scope.plyBtnStatus = true;
    if (check != "init") {
      if ($scope.shareStatus == false) {
        // $scope.currentCamera = Camera.get({ id: $stateParams.cameraId }, function () {
        Camera.get({
          id: $stateParams.cameraId
        }, function (res) {
          $scope.currentCamera = res;
          $scope.livePlayDataSet(check);
        });
      } else {
        if ($stateParams.type === "sharedshop" && typeof $stateParams.id !== "undefined") {
          // $scope.currentCamera = Shop.getSharedShopCamera({shopId: $stateParams.id, cameraId: $stateParams.cameraId }, function () {
          Shop.getSharedShopCamera({
            shopId: $stateParams.id,
            cameraId: $stateParams.cameraId
          }, function (res) {
            $scope.currentCamera = res;
            $scope.livePlayDataSet(check);
          });
        } else {
          // $scope.currentCamera = Share.get({ id: $stateParams.cameraId }, function () {
          Share.get({
            id: $stateParams.cameraId
          }, function (res) {
            $scope.currentCamera = res;
            $scope.livePlayDataSet(check);
          });
        }
      }
    }
  };
  $scope.livePlayDataSet = function (check) {
    if ($scope.shareStatus == true) {
      CameraConfig.getSharedConfig({
        id: $stateParams.cameraId
      }, function (data) {
        angular.extend($scope.config, data);
        $scope.config.tzCode = $scope.tzCode;
        $scope.livePlayConfigDataSet(check);
      });
    } else {
      CameraConfig.get({
        id: $stateParams.cameraId
      }, function (data) {
        angular.extend($scope.config, data);
        $scope.config.tzCode = $scope.tzCode;
        $scope.livePlayConfigDataSet(check);
      });
    }
  };
  $scope.cameraStatusChange = function (status) {
    lastCameraStatus = status;
    switch (status) {
      case 0:
        $scope.cameraStatusAllOff();
        break;
      case 1:
        $scope.cameraRecOff();
        break;
      case 2:
        $scope.cameraRecDelay();
        break;
      case 3:
        $scope.cameraConnectOff();
        break;
      case 4:
        $scope.cameraConnectOff();
        break;
      default:
        $scope.cameraStatusAllOff();
        break;
    }
  };
  $scope.livePlayConfigDataSet = function (check) {
    var cameraStatus = true;
    var cameraStatusNum = 0;
    if ($scope.config.streamStatus == "off") {
      cameraStatusNum = 1;
      setTimeout(function () {
        $scope.pauseBtn();
        $scope.timeline.updateCursor(new Date().valueOf());
      }, 500);
    } else {
      if ($scope.currentCamera.controlStatus === "CS" || $scope.currentCamera.controlStatus === "on") {
        if ($scope.currentCamera.streamStatus == "off" && check != "NetStream.Play.Stop") {
          cameraStatusNum = 2;
          cameraStatus = false;
          setTimeout(function () {
            $scope.pauseBtn();
            $scope.timeline.updateCursor(new Date().valueOf());
          }, 500);
        } else {
          cameraStatusNum = 0;
          cameraStatus = true;
        }
      } else if ($scope.currentCamera.controlStatus === "CE" || $scope.currentCamera.controlStatus === "off") {
        if ($scope.currentCamera.streamStatus == "off") {
          cameraStatusNum = 4;
          cameraStatus = false;
          setTimeout(function () {
            $scope.pauseBtn();
            $scope.timeline.updateCursor(new Date().valueOf());
          }, 500);
        } else {
          cameraStatusNum = 0;
          cameraStatus = true;
        }
      }
    }
    $scope.cameraStatusChange(cameraStatusNum);
    if ($scope.config.cameraSchedule != undefined) {
      $scope.config.parsedStartAt = Utils.configDateSeparate($scope.config.cameraSchedule.startAt);
      $scope.config.parsedStopAt = Utils.configDateSeparate($scope.config.cameraSchedule.stopAt);
      $scope.config.repeatOn = Utils.configRepeatOnSeparate($scope.config.cameraSchedule.repeatOn);
    }
  };
  var userIdLoading = 0;
  $scope.player = tCam.htmlSimplePlayer({
    elId: "player"
  });
  $scope.cameraUpagradeAlert = false;
  $scope.eventListDate = [];
  //카메라 세팅
  var loadCurrentCamera = function loadCurrentCamera() {
    $(".display_show").css("display", "");
    $scope.shareCheck();
    if ($scope.shareStatus == false) {
      // $scope.currentCamera = Camera.get({ id: $stateParams.cameraId }, function () {
      Camera.get({
        id: $stateParams.cameraId
      }, function (res) {
        $scope.currentCamera = res;
        $scope.currentCameraDataSet();
      });
    } else {
      if ($stateParams.type === "sharedshop" && typeof $stateParams.id !== "undefined") {
        // $scope.currentCamera = Shop.getSharedShopCamera({shopId: $stateParams.id, cameraId: $stateParams.cameraId }, function () {
        Shop.getSharedShopCamera({
          shopId: $stateParams.id,
          cameraId: $stateParams.cameraId
        }, function (res) {
          $scope.currentCamera = res;
          $scope.currentCameraDataSet();
        });
      } else {
        // $scope.currentCamera = Share.get({ id: $stateParams.cameraId }, function () {
        Share.get({
          id: $stateParams.cameraId
        }, function (res) {
          $scope.currentCamera = res;
          $scope.currentCameraDataSet();
        });
      }
    }
    $timeout(function () {
      initSizeTimline();
    }, 100);
  };
  $scope.cameraStatusSet = function (clickStatus) {
    if ($scope.isLive == true) {
      var cameraStatusNum = 0;
      if ($scope.config.streamStatus == "off") {
        cameraStatusNum = 1;
      } else {
        if ($scope.currentCamera) {
          if ($scope.currentCamera.controlStatus === "CS" || $scope.currentCamera.controlStatus === "on") {
            if ($scope.currentCamera.streamStatus == "off" && clickStatus != "setting") {
              if (Utils.isCloudExpired($scope.currentCamera)) {
                cameraStatusNum = 0;
              } else {
                cameraStatusNum = 2;
              }
            }
          } else if ($scope.currentCamera.controlStatus === "CE" || $scope.currentCamera.controlStatus === "off") {
            if ($scope.currentCamera.streamStatus == "off") {
              cameraStatusNum = 4;
            } else {
              cameraStatusNum = 3;
            }
          }
        }
      }
      $scope.cameraStatusChange(cameraStatusNum);
    }
  };
  $scope.cameraChangeFlag = false;

  // 현재 화면에 호출된 카메라의 데이터 설정
  $scope.currentCameraDataSet = function () {
    $scope.getShareCamerasList();
    $scope.shareCheck();
    $scope.shareView = true;
    $("#timebar_area").children("svg").width() / 2 - 75;
    //$("#timelinedesc").css("left",$("#timebar_area").children("svg").width()/2 - 75);

    if ($scope.currentCamera.code == "nok") {
      $scope.isNoCamera = true;
      return;
    }
    $scope.cameraName = $scope.currentCamera.labelName;
    if ($scope.currentCamera.mediaStreamURL != "" || $scope.currentCamera.mediaStreamURL != null) {
      if ($scope.cameraChangeFlag && $scope.isLive == false) {
        $scope.clickedCVRArea($scope.currentTime);
      } else {
        $scope.livePlay("init"); //TODO
      }
      if ($scope.currentCamera.needUpgrade == "YES" && $scope.currentCamera.controlStatus == "on") {
        if ($scope.shareStatus == false) {
          $scope.cameraUpagradeAlert = true;
        }
      }
    } else {
      $scope.isNetwork = true;
    }
    if ($scope.currentCamera.saveEndDate < new Date().valueOf()) {
      $("#timelinedesc").remove();
      $scope.cloud_out = true;
    } else {
      $scope.cloud_out = false;
      if ($scope.getCookie("service_end") == "service_end") {} else {
        var today = new Date();
        var betweenDay = parseInt(($scope.currentCamera.saveEndDate - today.getTime()) / 1000 / 60 / 60 / 24);
        if (betweenDay <= 7) {
          $scope.cloudEnd = betweenDay;
          $scope.showServiceEnd = true;
        }
      }
    }
    if ($scope.currentCamera.isPromotion == 1) {
      if ($scope.currentCamera.saveEndDate > new Date().valueOf()) {
        $scope.isPromotionCheck = true;
      } else {
        $scope.isPromotionCheck = false;
        $scope.cloud_out = true;
        $("#timelinedesc").remove();
      }
    } else {
      $scope.isPromotionCheck = false;
    }
    if (Utils.isTurnOffCamera($scope.currentCamera)) {
      if ($scope.currentCamera.streamStatus !== "off") {
        Camera.isLastRecord({
          id: $stateParams.cameraId
        }, function (data) {
          $scope.currentCameraIsLastRecordDataSet(data);
        });
      }
      $scope.isPlaying = false;
      $scope.isShowFullscreenButton = true;
      $scope.isShowMike = false;
    } else {
      $scope.isPlaying = true;
    }
    if ($scope.currentCamera.streamStatus == "off" || $scope.currentCamera.controlStatus === "CE") {
      cameraOffCheck = setTimeout(function () {
        Camera.isLastRecord({
          id: $stateParams.cameraId
        }, function (data) {
          $scope.currentCameraIsLastRecordDataSet(data);
        });
      }, 1050);
    }
    $scope.controlsReady = true;
    if (!$scope.isExpiredCloud()) {
      var serviceDays = [];
      if ($scope.currentCamera.recorderType === "nvr") {
        var now = moment();
        var regDate = moment($scope.currentCamera.regDate);
        $scope.serviceDay = now.diff(regDate, "days") + 1;
      } else {
        $scope.serviceDay = parseInt($scope.currentCamera.serviceType);
      }
      if ($scope.serviceDay <= 7 && $scope.serviceDay >= 1) {
        setTimeout(function () {
          $("#view_timeline_date").find("button").css("padding", "0 12px");
        }, 500);
        $scope.serviceCalendarDay = serviceCalendarDay($scope.serviceDay);
        $scope.todayDate = $scope.serviceCalendarDay[$scope.serviceCalendarDay.length - 1].date;
      } else if ($scope.serviceDay >= 8) {
        if ($scope.serviceDay <= 10) {
          setTimeout(function () {
            $("#view_timeline_date").find("button").css("padding", "0 12px");
          }, 500);
        }
        $scope.serviceCalendarDate = serviceCalendarDate($scope.serviceDay);
        //var regDateString = (new Date($scope.currentCamera.regDate)).getFullYear()+"-"+(new Date($scope.currentCamera.regDate)).getMonth()+1+"-"+ (new Date($scope.currentCamera.regDate)).getDate()

        var year = new Date($scope.currentCamera.regDate).getFullYear();
        var month = parseInt(new Date($scope.currentCamera.regDate).getMonth() + 1);
        var day = new Date($scope.currentCamera.regDate).getDate();
        if (month < 10) {
          month = "0" + month;
        }
        var regDateString = year + "-" + month + "-" + day;
        $scope.todayDate = $scope.serviceCalendarDate[$scope.serviceCalendarDate.length - 1].date;
      } else {
        $scope.cloud_out = true;
        $("#timelinedesc").remove();
      }
      if ($scope.currentCamera.recorderType === "nvr") {
        setupClipCalendar($scope.serviceDay.toString());
      } else {
        setupClipCalendar($scope.currentCamera.serviceType);
      }
    } else {
      $scope.cloud_out = true;
      $scope.serviceDay = 0;
    }
    //이벤트 날짜 리스트
    var eventListDateDate = eventListDate();
    for (var i = 0; i < eventListDateDate.length; i++) {
      var dateObject = {};
      dateObject.date = eventListDateDate[i].date;
      dateObject.day = eventListDateDate[i].day;
      var dateO = eventListDateDate[i].day.split(" ");
      dateObject.month = dateObject.date.substring(4, 6);
      dateObject.dates = dateObject.date.substring(6, 8);
      var dayCheck = new Date(dateObject.date.substring(0, 4) + "-" + dateObject.date.substring(4, 6) + "-" + dateObject.date.substring(6, 8)).getDay();
      dateObject.days = dayCheck;
      dateObject.today = dateO[3];
      $scope.eventListDate.push(dateObject);
    }
    $(".cvr").empty();
    $scope.cameraStatusSet();
    $scope.me = User.me(function () {
      if (userIdLoading == 0) {
        userIdLoading++;
      }
    });
    $scope.selectedZones = [];
    $scope.selectedAllZones = [];
    $scope.zones = [];
    if ($scope.currentCamera.saveEndDate >= new Date().valueOf()) {
      if ($scope.eventListCheckFlag === false) {
        eventListCheckFlag = true;
      }
    } else {
      $scope.cloudServiceEnd = true;
    }
  };
  $scope.showServiceEndClose = function () {
    if ($("#cloud_out_service").is(":checked") == true) {
      $scope.setCookie("service_end", "service_end", 1);
    }
    $scope.showServiceEnd = false;
  };
  $scope.currentCameraIsLastRecordDataSet = function (data) {
    $scope.currentCamera.lastEventDate = data.lastEventStartTime;
    $scope.currentCamera.lastRecDate = data.lastRectStartTime;
    var videoDateFormat = $translate.instant("CAMERA_DETAIL_EVENT_DATE_FORMAT");
    var videoTimeFormat = $translate.instant("CAMERA_DETAIL_EVENT_TIME_FORMAT");
    if ($scope.currentCamera.lastEventDate != 0) {
      var lastEventMoment = moment($scope.currentCamera.lastEventDate);
      $scope.currentCamera.lastEventDateString = lastEventMoment.locale(Utils.getBrowserLanguage()).format(videoDateFormat);
      $scope.currentCamera.lastEventTimeString = lastEventMoment.locale(Utils.getBrowserLanguage()).format(videoTimeFormat);
      $("#camera_off_lastevnt").show();
      $scope.lastEvent = lastEventMoment._i;
      $scope.isCameraOffLastShowEvent = true;
    } else {
      $scope.isCameraOffLastShowEvent = false;
      $scope.isCameraOffLastEvent = true;
    }
    if ($scope.currentCamera.lastRecDate != 0) {
      var lastRecMoment = moment($scope.currentCamera.lastRecDate);
      $scope.currentCamera.lastRecDateString = lastRecMoment.locale(Utils.getBrowserLanguage()).format(videoDateFormat);
      $scope.currentCamera.lastRecTimeString = lastRecMoment.locale(Utils.getBrowserLanguage()).format(videoTimeFormat);
      $("#camera_off_lastrec").show();
      $scope.lastRec = lastRecMoment._i;
      $scope.isCameraOffLastShowRec = true;
    } else {
      $scope.isCameraOffLastShowRec = false;
      $scope.isCameraOffLastRec = true;
    }
  };
  loadCurrentCamera();
  $scope.eventSources = [];
  $scope.timeRange = 360;
  $scope.timeline = new PosTimeline($("#view_timeline_ctrl").width(), $("#timebar_area").height(), $scope.timeRange, $q, $translate);
  $translate("FORMAT_TIMELINE_BOUND_DATE").then(function (translation) {
    $scope.timeline.setBoundDateFormat(translation);
  });
  $scope.timeline.cursorInterval = 1000;
  $scope.timeline.delegate = $scope;
  $scope.subCvrThumbnail = [];
  $scope.compareTime = function (time) {
    if ($scope.timelineDataLastDate < time) {
      $scope.timelineDataLastDate = time;
    }
  };
  //setupDomain
  $scope.setupDomain = function (domain) {
    if ($scope.shareStatus == true) {
      $scope.shareEnd();
    }
    dataCallStatus = false;
    if (dragThumCancle == true) {
      return;
    }
    var params = {
      cameraId: $scope.selectCameraId,
      shopId: $stateParams.id,
      posId: $scope.selectPosVal,
      start: domain[0],
      end: domain[1]
    };

    //
    /**타임라인 호출
     *10분일땐 1초에 한번
     *1시간일땐 1분에 한번
     *6시간일땐 5분에 한번
     *24시간일땐 10분에 한번 호출
     *예외상황 커서 드래그, cvr, 타임라인 드래그, 라이브보기, 이전 타임라인, 다음 타임라인
     */

    if (this.timeRange == 10) {
      params.scale = "10m";
      $scope.nowScale = "10m";
      params.start = params.start - 100000;
    } else if (this.timeRange == 60) {
      params.scale = "1h";
      $scope.nowScale = "1h";
      // params.start = params.start - 10000000;
      if (posTimelineDragCnt > 0 && posTimelineDragCnt < 6) {
        posTimelineDragCnt++;
        return;
      } else if (posTimelineDragCnt == 6) {
        posTimelineDragCnt = 0;
      }
    } else if (this.timeRange == 360) {
      params.scale = "6h";
      $scope.nowScale = "6h";
      if (posTimelineDragCnt > 0 && posTimelineDragCnt < 30) {
        posTimelineDragCnt++;
        return;
      } else if (posTimelineDragCnt == 30) {
        posTimelineDragCnt = 0;
      }
    } else if (this.timeRange == 1440) {
      params.scale = "24h";
      $scope.nowScale = "24h";
      if (posTimelineDragCnt > 0 && posTimelineDragCnt < 60) {
        posTimelineDragCnt++;
        return;
      } else if (posTimelineDragCnt == 60) {
        posTimelineDragCnt = 0;
      }
    }
    posTimelineDragCnt++;
    $scope.timeline.isLoading = true;
    if ($scope.serviceDay != 0) {
      serviceDateTime = new Date().valueOf() - 1000 * 60 * 60 * 24 * ($scope.serviceDay - 1);
    } else {
      serviceDateTime = 0;
    }
    if (params.start < serviceDateTime) {
      params.start = serviceDateTime;
    }
    Pos.getPosTimeline(params, function (d) {
      $scope.drawTimelineData(d);
    }, function (err) {
      $scope.timeline.isLoading = false;
    });
    $scope.drawTimelineData = function (d) {
      var check = 0;
      var eventTime = d.recTimes;
      d.recTimes = [];
      if (eventTime) {
        for (var i = 0; i < eventTime.length; i++) {
          if (i < eventTime.length) {
            if (eventTime[i + 1] != undefined) {
              if (eventTime[i].endTime == eventTime[i + 1].startTime) {
                check++;
              } else {
                var recTime = {};
                recTime.startTime = eventTime[i - check].startTime;
                recTime.endTime = eventTime[i].endTime;
                d.recTimes.push(recTime);
                check = 0;
              }
            } else {
              var recTime = {};
              recTime.startTime = eventTime[i - check].startTime;
              recTime.endTime = eventTime[i].endTime;
              d.recTimes.push(recTime);
              check = 0;
            }
          }
        }
      }
      firstDataLoadingFlag = true;
      $scope.timelineDataSet(d);
      $scope.initCursorEventTime();
    };
    var removedBufferDomain = PosTimeline.removeBufferCursorCheckDomain(domain, $scope.timeRange);
    if (removedBufferDomain[0] > $scope.currentTime.valueOf()) {
      $scope.isCursorLeft = true;
      $scope.isCursorRight = false;
    } else if (removedBufferDomain[1] < $scope.currentTime.valueOf()) {
      $scope.isCursorLeft = false;
      $scope.isCursorRight = true;
    } else {
      $scope.isCursorLeft = false;
      $scope.isCursorRight = false;
      if ($scope.isPlaying == false) {
        $scope.timeline.updateCursor($scope.currentTime);
      }
    }
  };
  $scope.timelineDataSet = function (d) {
    if (dragTimeLine == true) {
      dragTimeLine = false;
      if ($scope.isFullScreen) {
        $("#timebar_area").children("svg").children("g").attr("transform", "translate(0, -15)");
      } else {
        $("#timebar_area").children("svg").children("g").attr("transform", "translate(0, -19)");
      }
      // changedSelectedZone();
      $(".cvr").attr("transform", "");
      $(".cursor").attr("transform", "");
      thumnailDraw = true;
    }
    arrEvents = d.events;
    $scope.events = d.events;
    $scope.timeline.cvrData = d.recTimes;
    $scope.timeline.drawRecordBar();
    $scope.timeline.updateBar(500);
    cvrArray = new Array();
    cvrArray.push($(".cvr").children("rect"));
    $scope.timeline.redrawEvents(d.events, d.avg);
    $scope.timeline.isLoading = false;
    flag = "load";
  };
  $scope.hideCursorNavigation = function () {
    $scope.isCursorLeft = false;
    $scope.isCursorRight = false;
  };
  $scope.currentTime = new Date();
  $scope.reloadTimer = $interval(function () {
    if ($scope.timeline.currentDomain == undefined) {
      return;
    }
    if ($scope.serviceDay != 0) {
      if ($scope.timeline.currentDomain[1] > Date.now() || $scope.timeline.currentDomain[0] < serviceDateTime) {
        $scope.setupDomain([$scope.timeline.currentDomain[0], $scope.timeline.currentDomain[1]]);
      }
    } else {
      $interval.cancel($scope.reloadTimer);
      $interval.cancel($scope.timer);
      $interval.cancel($scope.eventThumbTimer);
      $interval.cancel($scope.eventlistTimer);
    }
  }, 10000);
  $scope.changeTimeFullScreenRange = function () {
    if (changeTimeRangeFlag == true) {
      $scope.loadingDataAlert();
      return;
    }
    if ($scope.timeRange == 10) {
      $scope.changeTimeRange(1440);
      $("#fs_time_range").html($translate.instant("TIMELINE_24HOUR"));
    } else if ($scope.timeRange == 60) {
      $scope.changeTimeRange(10);
      $("#fs_time_range").html($translate.instant("TIMELINE_10MIN"));
    } else if ($scope.timeRange == 360) {
      $scope.changeTimeRange(60);
      $("#fs_time_range").html($translate.instant("TIMELINE_1HOUR"));
    } else {
      $scope.changeTimeRange(360);
      $("#fs_time_range").html($translate.instant("TIMELINE_6HOUR"));
    }
  };
  $scope.loadingDataAlert = function () {
    if (fullscreenFlag === false) {
      showAlert($translate.instant("CAMERA_TIMELINE_LOADING_SUBJECT"), $translate.instant("CAMERA_TIMELINE_LOADING_CONTENT"));
    } else {
      $scope.fullScreenAlert = true;
    }
  };
  $scope.changeTimeRange = function (minutes) {
    posTimelineDragCnt = 0;
    dblClickFlag = false;
    $scope.lineMoveFlag = true;
    changeTimeRangeClick = true;
    dragThumCancle = false;
    if ($scope.timeRange == minutes) {
      return;
    }
    if (changeTimeRangeFlag == true) {
      $scope.loadingDataAlert();
      return;
    }
    changeTimeRangeFlag = true;
    setTimeout(function () {
      changeTimeRangeFlag = false;
      $scope.timeline.updateCursor($scope.currentTime);
      $scope.timeline.svg.select(".cursor").classed("hide", false);
    }, 800);
    $scope.timeRange = minutes;
    if ($scope.timeline.forceDomain) {
      $scope.timeline.setTimeRange(minutes);
    } else {
      $scope.timeline.zoomDomain($scope.timeline.domainCenterTime(), minutes);
    }
  };
  $scope.formattedTime = function (date) {
    if ($scope.timeline.tz !== undefined) {
      return moment(new Date(date)).tz($scope.timeline.tz).format("HH:mm:ss");
    } else {
      return moment(new Date(date)).format("HH:mm:ss");
    }
  };
  $scope.formattedDate = function (date) {
    var md;
    if ($scope.timeline.tz !== undefined) {
      md = moment(new Date(date)).tz($scope.timeline.tz);
    } else {
      md = moment(new Date(date));
    }
    var videoDateFormat = $translate.instant("FORMAT_VIDEO_DATE");
    return md.locale(Utils.getBrowserLanguage()).format(videoDateFormat);
  };
  $scope.formattedBasicDate = function (date) {
    var md;
    if ($scope.timeline.tz !== undefined) {
      md = moment(new Date(date)).tz($scope.timeline.tz);
    } else {
      md = moment(new Date(date));
    }
    var videoDateFormat = $translate.instant("FORMAT_BASIC_DATE");
    return md.locale(Utils.getBrowserLanguage()).format(videoDateFormat);
  };
  $scope.formattedBasicDate2 = function (date) {
    var md;
    if ($scope.timeline.tz !== undefined) {
      md = moment(new Date(date)).tz($scope.timeline.tz);
    } else {
      md = moment(new Date(date));
    }
    var videoDateFormat = $translate.instant("FORMAT_VIDEO_DATE2");
    return md.locale(Utils.getBrowserLanguage()).format(videoDateFormat);
  };
  $scope.formattedDateNotYo = function (date) {
    var md;
    if ($scope.timeline.tz !== undefined) {
      md = moment(new Date(date)).tz($scope.timeline.tz);
    } else {
      md = moment(new Date(date));
    }
    var videoDateFormat = $translate.instant("FORMAT_VIDEO_DATE_NOT_YO");
    return md.locale(Utils.getBrowserLanguage()).format(videoDateFormat);
  };
  $scope.formattedDateNotYo2 = function (date) {
    var md;
    if ($scope.timeline.tz !== undefined) {
      md = moment(new Date(date)).tz($scope.timeline.tz);
    } else {
      md = moment(new Date(date));
    }
    var videoDateFormat = "YYYY.MM.DD.(ddd)";
    return md.locale(Utils.getBrowserLanguage()).format(videoDateFormat);
  };
  $scope.formattedInternalDate = function (date) {
    var md;
    if ($scope.timeline.tz !== undefined) {
      md = moment(new Date(date)).tz($scope.timeline.tz);
    } else {
      md = moment(new Date(date));
    }
    return md.format("YYYYMMDD");
  };
  $scope.formattedCalendarDate = function (date) {
    var dateString = "";
    var format = d3.time.format("%Y%m%d");
    var calendarTime = $scope.timeline.domainCenterTime();
    if (calendarTime !== undefined) {
      dateString = format(new Date(calendarTime));
    }
    return dateString;
  };
  $scope.goCameraList = function () {
    $window.history.back();
  };
  $scope.stopTimer = function () {
    $interval.cancel($scope.timer);
  };
  $scope.cursorDragStart = function () {
    $scope.cursorOn = true;
    $scope.stopTimer();
  };
  $scope.cursorDragging = function (time) {
    $scope.currentTime = time;
    $scope.$apply();
  };
  $scope.cursorDragEnd = function () {
    var curosEmptyData = 0;
    $scope.cursorOn = false;
    $scope.showCVRImage = false;
    $scope.lineMoveFlag = false;
    $scope.cameraStatusAllOff();
    if ($scope.currentTime.getTime() - Date.now() >= 0) {
      $scope.goLive();
      return;
    }
    $scope.clickedCVRArea($scope.currentTime);
    var now = Date.now();
    var right = parseInt($scope.timeline.removedBufferDomain[1]);
    var left = parseInt($scope.timeline.removedBufferDomain[0]);
    var x = $scope.timeline.svg.select(".cursor").select("line").attr("x1");
    var cursorTime = $scope.timeline.x.invert(x).getTime();
    if ($scope.timeRange == 60) {
      curosEmptyData = 200000;
    } else if ($scope.timeRange == 360) {
      curosEmptyData = 1200000;
    } else if ($scope.timeRange == 1440) {
      curosEmptyData = 4800000;
    }
    if (cursorTime < left - curosEmptyData) {
      $scope.timeline.prevDomain();
    }
    if (cursorTime > right + curosEmptyData) {
      $scope.timeline.nextDomain();
    }
  };
  $scope.lineMoveFlag = false;
  $scope.liveLinFlag = true;
  $scope.prevLine = function (click) {
    var nowTime = new Date().valueOf();
    var overTime = -0.987;
    if ($scope.timeRange == 60) {
      overTime = -0.918;
    } else if ($scope.timeRange == 360) {
      overTime = -0.59;
    } else if ($scope.timeRange == 1440) {
      overTime = 0.9;
    }
    var serviceTime = nowTime - 1000 * 60 * 60 * 24 * ($scope.serviceDay + overTime);
    if (serviceTime > $scope.timeline.removedBufferDomain[0]) {
      return;
    }
    dblClickFlag = false;
    changeTimeRangeClick = true;
    $scope.lineMoveFlag = true;
    $scope.timeline.prevDomain();
    if ($scope.isPlaying == true) {
      setTimeout(function () {
        if ($scope.isLive == false) {
          $scope.startRecTimer($scope.currentTime.valueOf());
        }
      }, 1050);
    }
  };
  $scope.nextLine = function (click) {
    dblClickFlag = false;
    changeTimeRangeClick = true;
    $scope.lineMoveFlag = true;
    $scope.timeline.nextDomain();
    if ($scope.isPlaying == true) {
      setTimeout(function () {
        if ($scope.isLive == false) {
          $scope.startRecTimer($scope.currentTime.valueOf());
        }
      }, 1050);
    }
  };
  $scope.camInfoBarChange = function () {
    if ($scope.isLive == false) {
      if (parseInt(window.innerWidth) < 1900) {
        $(".cam_info_bg").css("width", "280px");
        $(".cam_info_bg").css("margin-left", " -140px");
        $(".cam_info_bg_en").css("width", "290px");
        $(".cam_info_bg_en").css("margin-left", " -145px");
      } else {
        $(".cam_info_bg").css("width", "280px");
        $(".cam_info_bg").css("margin-left", " -140px");
        $(".cam_info_bg_en").css("width", "290px");
        $(".cam_info_bg_en").css("margin-left", " -145px");
      }
    } else {
      if (parseInt(window.innerWidth) < 1900) {
        $(".cam_info_bg").css("width", "206px");
        $(".cam_info_bg").css("margin-left", " -103px");
        $(".cam_info_bg_en").css("width", "216px");
        $(".cam_info_bg_en").css("margin-left", " -108px");
      } else {
        $(".cam_info_bg").css("width", "206px");
        $(".cam_info_bg").css("margin-left", " -103px");
        $(".cam_info_bg_en").css("width", "216px");
        $(".cam_info_bg_en").css("margin-left", " -108px");
      }
    }
  };
  var tmpTimeData = 0;
  var cursorNowTime = 0;
  var cursorIdx = 0;
  var cvrCheck = false;
  $scope.cvrDrawCheck = function (time) {
    $scope.isLive = false;
    $scope.camInfoBarChange();
    var trueCnt = 0;
    $scope.startRecTime = time;
    var cursorX = parseFloat($scope.timeline.x(time));
    cvrCheck = false;
    var nextTime = new Date().valueOf();
    var checkNextTime = 0;
    for (var i = 0; i < $scope.timeline.cvrData.length; i++) {
      var startX = parseInt($scope.timeline.cvrData[i].startTime);
      var endX = parseInt($scope.timeline.cvrData[i].endTime);
      if (startX > time.valueOf() && checkNextTime == 0) {
        nextTime = startX;
        checkNextTime++;
        clearTimeout(playserStop);
      }
      if ($scope.timeRange == 10) {
        if (parseInt($scope.timeline.cvrData[$scope.timeline.cvrData.length - 1].endTime) <= time.valueOf() + 3000) {
          $scope.setupDomain([$scope.timeline.currentDomain[0], $scope.timeline.currentDomain[1]]);
        }
      } else {
        if (parseInt($scope.timeline.cvrData[$scope.timeline.cvrData.length - 1].endTime) <= time.valueOf() + 30000) {
          $scope.setupDomain([$scope.timeline.currentDomain[0], $scope.timeline.currentDomain[1]]);
        }
      }
      if (startX <= time.valueOf() && endX >= time.valueOf()) {
        cvrCheck = true;
        trueCnt++;
      } else {
        if (trueCnt == 0) {
          cvrCheck = false;
        }
      }
    }
    if (cvrCheck == false) {
      if (new Date().valueOf() - time.valueOf() < 8000) {
        $scope.goLive();
        posTimelineDragCnt = 0;
        return;
      }
      if (new Date().valueOf() - time.valueOf() < 15000) {
        cvrCheck = true;
        posTimelineDragCnt = 0;
      }
    }
    if (cvrCheck == false && $scope.isShowPosDetailLayer) {
      if ($scope.lineMoveFlag == false && $scope.plyBtnStatus == true) {
        $scope.cameraNoSave();
        //$interval.cancel($scope.vedioTimer);
        $scope.lineMoveFlag = false;
        $scope.liveLinFlag = false;
        $scope.isPlaying = false;
        var videoDateFormat = $translate.instant("CAMERA_DETAIL_EVENT_DATE_FORMAT");
        var videoTimeFormat = $translate.instant("CAMERA_DETAIL_EVENT_TIME_FORMAT");
        if (checkNextTime == 1) {
          var lastRecMoment = moment(nextTime);
          $scope.currentCamera.lastRecDateString = lastRecMoment.locale(Utils.getBrowserLanguage()).format(videoDateFormat);
          $scope.currentCamera.lastRecTimeString = lastRecMoment.locale(Utils.getBrowserLanguage()).format(videoTimeFormat);
          $("#camera_off_lastrec").show();
          $scope.isCameraOffLastShowRec = true;
          $scope.currentCamera.lastRecDate = nextTime;
        } else {
          $scope.isCameraOffLastRec = true;
        }
        return;
      }
    }
  };
  var beforeServerTime = 0;
  $scope.startRecTimer = function (time) {
    beforeServerTime = 0;
    $scope.startRecTime = time;
    $scope.currentTime = new Date($scope.startRecTime.valueOf());
    var cntRecTimer = 0;
    $interval.cancel($scope.timer);
    $scope.timer = $interval(function () {
      $scope.currentTime = moment($scope.currentTime).add(1, "s");
      if ($scope.timeline.currentDomain == undefined) {
        return;
      }
      var domain = $scope.timeline.currentDomain;
      switch ($scope.timeRange) {
        case 10:
          range = 600000;
          fixRange = 0;
          break;
        case 60:
          range = 600000 * 6;
          fixRange = 200000;
          break;
        case 360:
          range = 600000 * 6 * 6;
          fixRange = 1245000;
          break;
        case 1440:
          range = 600000 * 6 * 6 * 4;
          fixRange = 3650000;
          break;
      }
      if (domain[0] + range < $scope.currentTime.valueOf() && domain[1] - range - fixRange > $scope.currentTime.valueOf()) {
        $scope.lineMoveFlag = false;
      } else {
        if ($scope.lineMoveFlag == false) {
          changeTimeRangeClick = true;
          $scope.pressedFindCursorButton();
        }
      }
      if ($scope.lineMoveFlag == false) {
        if (domain[0] < $scope.currentTime && domain[1] > $scope.currentTime) {
          $scope.timeline.updateCursor(new Date($scope.currentTime));
        } else {
          changeTimeRangeClick = true;
          $scope.timeline.nextDomain();
        }
      }
    }, $scope.timeline.cursorInterval);
  };
  var range = 0;
  var fixRange = 0;
  $scope.startLiveTimer = function () {
    $scope.timeline.forceDomain = true;
    $interval.cancel($scope.timer);
    $scope.timer = $interval(function () {
      switch ($scope.timeRange) {
        case 10:
          range = 600000;
          fixRange = 0;
          break;
        case 60:
          range = 600000 * 6;
          fixRange = 200000;
          break;
        case 360:
          range = 600000 * 6 * 6;
          fixRange = 1245000;
          break;
        case 1440:
          range = 600000 * 6 * 6 * 4;
          fixRange = 3650000;
          break;
      }
      if ($scope.plyBtnStatus == false) {
        return;
      }
      $scope.currentTime = new Date();
      if ($scope.timeline.currentDomain == undefined) {
        return;
      }
      var domain = $scope.timeline.currentDomain;
      if (domain[0] + range < $scope.currentTime.getTime() && domain[1] - range - fixRange > $scope.currentTime.getTime()) {
        $scope.timeline.updateCursor();
        $scope.lineMoveFlag = false;
      } else {
        if ($scope.lineMoveFlag == false) {
          changeTimeRangeClick = true;
          $scope.pressedFindCursorButton();
          $scope.lineMoveFlag = true;
        } else {
          if ($scope.cursorLineIn == true) {
            $scope.pressedFindCursorButton();
            $scope.cursorLineIn = false;
          }
        }
      }
    }, $scope.timeline.cursorInterval);
  };
  $scope.clickTime = 0;
  var recodeCheck = 0;
  $scope.clickedCVRArea = function (time, status) {
    posTimelineDragCnt = 0;
    $interval.cancel($scope.timer);
    if ($scope.shareStatus == true) {
      $scope.shareEnd();
    }
    if ($scope.player) {
      $scope.player.stop();
    }
    $scope.setupDomain([$scope.timeline.currentDomain[0], $scope.timeline.currentDomain[1]]);
    if (new Date().valueOf() < time.valueOf()) {
      $scope.goLive();
      return;
    }
    if (cursorDragStatus == true) {
      return;
    }
    $scope.playStatusObj.status = $scope.playStatusType.READY;
    $scope.playStatusObj.errorStatus = $scope.playErrorType.NONE;
    setTimeout(function () {
      $interval.cancel(recodeCheck);
      serviceDateTime = new Date().valueOf() - 1000 * 60 * 60 * 24 * ($scope.serviceDay - 1);
      if (serviceDateTime > time) {
        //return;
        time = new Date(serviceDateTime + 3000);
      }
      $scope.clickTime = time;
      $scope.cameraStatusAllOff();
      cursorIdx = 0;
      if (status != "f") {
        $scope.cvrDrawCheck(time);
      }
      if (cursorDragStatus == true) {
        return;
      }
      playerCheck = false;
      var tokenPromise = {},
        detailPromise = {},
        timelinePromise = {};
      if ($scope.shareStatus == true) {
        detailPromise = Share.get({
          id: $stateParams.cameraId
        }).$promise;
        tokenPromise = Share.getToken({
          id: $stateParams.cameraId
        }).$promise;
      } else {
        detailPromise = Camera.get({
          id: $stateParams.cameraId
        }).$promise;
        tokenPromise = Camera.getToken({
          id: $stateParams.cameraId
        }).$promise;
      }
      $scope.startRecTimer(time);
      //if(cvrCheck == true || goCvrStatus == true){

      $scope.isLive = false;
      $scope.camInfoBarChange();
      goCvrStatus = false;
      $scope.cameraStatusAllOff();
      $q.all([tokenPromise, detailPromise]).then(function (data) {
        var camDetail = data[1];
        if (camDetail.code !== "ok") {
          $scope.playStatusObj.status = $scope.playStatusType.ERROR;
          $scope.playStatusObj.errorStatus = $scope.playErrorType.NO_CAM;
          return;
        }
        if (!camDetail.cloud) {
          $scope.playStatusObj.status = $scope.playStatusType.ERROR;
          $scope.playStatusObj.errorStatus = $scope.playErrorType.NO_CLOUD;
          return;
        }
        var playTime = time.getTime();
        var checkStartTime = playTime - 100 * 1000;
        var checkEndTime = playTime + 100 * 1000;
        var params = {
          id: $stateParams.cameraId,
          start: checkStartTime,
          end: checkEndTime
        };
        timelinePromise = $scope.shareStatus ? Share.newTimeline(params).$promise : Camera.newTimeline(params).$promise;
        timelinePromise.then(function (td) {
          var isCvrExist = false;
          if (td.recTimes && td.recTimes.length) {
            isCvrExist = td.recTimes.some(function (recTime) {
              var startTime = parseInt(recTime.startTime, 10);
              var endTime = parseInt(recTime.endTime, 10);
              return startTime <= playTime && endTime >= playTime;
            });
          }
          if (!isCvrExist) {
            $scope.playStatusObj.status = $scope.playStatusType.ERROR;
            $scope.playStatusObj.errorStatus = $scope.playErrorType.NO_TIMELINE;
            return;
          }
          if ($scope.isShowPosVideoArea) {
            $scope.token = data[0];
            $scope.player.play(Utils.getLiveServerUrl(camDetail.mediaStreamURL) + "/flvplayback/" + $stateParams.cameraId + "?token=" + $scope.token.token + "&time=" + time.getTime());
            $scope.plyBtnStatus = true;
          }
          $scope.playStatusObj.status = $scope.playStatusType.PLAYING;
          $scope.playStatusObj.errorStatus = $scope.playErrorType.NONE;
        });
      });
      //}else{
      //}

      $scope.timeline.updateCursor(new Date(time));
      $scope.isCursorLeft = false;
      $scope.isCursorRight = false;
    }, 800);
  };
  var goCvrStatus = false;
  //영상 이동.
  $scope.goCvr = function (time, status) {
    $scope.replaceShow = false;
    $interval.cancel($scope.timer);
    offLayer = $scope.showCameraOffLayer;
    dragThumCancle = false;
    var tmpX = 9999;
    var e = window.event;
    if (e.preventDefault) {
      // Firefox, Chrome
      e.preventDefault();
    } else {
      // Internet Explorer
      e.returnValue = false;
    }
    if (time == undefined) {
      $scope.timeline.updateCursor($scope.currentTime);
      var cursorX = parseFloat($(".cursor").children("line").attr("x1"));
      for (var i = 0; i < cvrArray[0].length; i++) {
        if (cursorX < parseFloat(cvrArray[0].eq(i).attr("x"))) {
          var x = parseFloat(cvrArray[0].eq(i).attr("x"));
          if (tmpX >= x) {
            tmpX = x;
            time = $scope.timeline.x.invert(x).getTime() + 1000;
          }
        }
      }
    }
    if (time == undefined) {
      $scope.timeline.updateCursor($scope.currentTime);
      if (cvrArray[0].length - 1 > 0) {
        var x = parseFloat(cvrArray[0].eq(cvrArray[0].length - 1).attr("x"));
        if (tmpX >= x) {
          tmpX = x;
          time = $scope.timeline.x.invert(x).getTime() + 1000;
        }
      }
    }
    if (time == undefined) {
      time = $scope.lastRec;
      if (time == 0) {
        time = $scope.lastEvent;
      }
    }
    if (time == 0) {
      Camera.isLastRecord({
        id: $stateParams.cameraId
      }, function (data) {
        $scope.currentCamera.lastEventDate = data.lastEventStartTime;
        $scope.currentCamera.lastRecDate = data.lastRectStartTime;
        var videoDateFormat = $translate.instant("CAMERA_DETAIL_EVENT_DATE_FORMAT");
        var videoTimeFormat = $translate.instant("CAMERA_DETAIL_EVENT_TIME_FORMAT");
        var lastRecMoment = moment($scope.currentCamera.lastRecDate);
        $scope.currentCamera.lastRecDateString = lastRecMoment.locale(Utils.getBrowserLanguage()).format(videoDateFormat);
        $scope.currentCamera.lastRecTimeString = lastRecMoment.locale(Utils.getBrowserLanguage()).format(videoTimeFormat);
        var date = new Date(data.lastRectStartTime);
        changeTimeRangeClick = true;
        $scope.cameraStatusAllOff();
        $scope.currentTime = date;
        $scope.timeline.zoomDomain(data.lastRectStartTime, $scope.timeRange);
        goCvrStatus = true;
        $scope.clickedCVRArea(date, status);
      });
    } else {
      var date = new Date(time);
      changeTimeRangeClick = true;
      $scope.cameraStatusAllOff();
      $scope.currentTime = date;
      $scope.timeline.zoomDomain(date.getTime(), $scope.timeRange);
      goCvrStatus = true;
      $scope.clickedCVRArea(date, status);
    }
  };
  $scope.goLive = function () {
    if ($scope.isLive) {
      return;
    }
    posTimelineDragCnt = 0;
    $scope.isLive = true;
    $scope.currentTime = new Date();
    changeTimeRangeClick = true;
    $scope.lineMoveFlag = false;
    $scope.liveLinFlag = true;
    dragThumCancle = false;
    $scope.timeline.zoomDomain(Date.now(), $scope.timeRange).then(function () {
      $scope.startLiveTimer();
      //$scope.livePlay();
    });
  };
  $scope.mouseoutEvents = function (data, mouseLocation) {
    $interval.cancel($scope.eventThumbTimer);
  };
  $scope.eventThumbStyle = {};
  $scope.sgid = "";
  $scope.startThumSize = 0;
  $scope.endThumSize = 0;
  $scope.lastTimestamp = 0;
  $scope.thumTotal = 0;
  $scope.thumPageCnt = 1;
  $scope.prevTimestamp = 0;
  $scope.thumNailDataList = new Map();
  var showThumClick = 0;
  $scope.showThum = function (check) {
    if (showThumClick == 0) {
      showThumClick++;
      $("#thumnail_prev_btn").show();
      $("#thumnail_next_btn").show();
      if (check == 1) {
        $scope.thumTimeTmp0 = $scope.thumTimeTmp1;
        $scope.thumTimeTmp1 = $scope.lastTimestamp;
        if ($scope.thumPageCnt == 1) {
          $scope.prevTimestamp = 0;
        }
        $scope.thumnailData($scope.sgid, $scope.startThumSize, $scope.endThumSize, $scope.lastTimestamp, "T");
        if ($scope.thumPageCnt + 4 == $scope.thumTotal) {
          $("#thumnail_next_btn").hide();
        }
        $scope.thumPageCnt++;
      } else {
        $scope.thumPageCnt--;
        if ($scope.thumPageCnt == 1) {
          $scope.lastTimestamp = 0;
        } else {
          $scope.lastTimestamp = $scope.thumNailDataList.get($scope.thumPageCnt - 2).startTime;
        }
        $scope.thumnailData($scope.sgid, $scope.startThumSize, $scope.endThumSize, $scope.lastTimestamp, "P");
        if ($scope.thumPageCnt == 1) {
          $("#thumnail_prev_btn").hide();
          $("#thumnail_next_btn").show();
        }
      }
    }
  };
  var dataCallStatus = false;
  $scope.thumnailData = function (sgid, start, end, lastTimestamp, status, x) {
    $scope.sgid = sgid;
    $scope.startThumSize = start;
    $scope.endThumSize = end;
    var filteredMotionZoneIds = _.map(_.filter($scope.motionZones, function (o) {
      return o.filterMark === "on" && o.id !== "9";
    }), "uid");
    var filteredEventZoneIds = _.map(_.filter($scope.eventTypeList, ["filterMark", "on"]), "id");
    var allFilteredZoneIds = _.concat(filteredMotionZoneIds, filteredEventZoneIds);
    var isCheckedDeleteZoneId = _.get(_.find($scope.motionZones, ["id", "9"]), "filterMark") === "on" ? true : false;
    if (isCheckedDeleteZoneId) {
      allFilteredZoneIds.push("d");
    }
    if (dataCallStatus == false) {
      if ($scope.shareStatus == false) {
        Camera.newThumbnail({
          id: $scope.currentCamera.id,
          sgid: sgid,
          scale: $scope.nowScale,
          count: 4,
          lastTimestamp: lastTimestamp,
          zones: allFilteredZoneIds.join(",")
        }, function (data) {
          $scope.thumbnailDataSet(data, sgid, start, end, lastTimestamp, status, x);
        }, function (err) {
          dataCallStatus = false;
        });
      } else {
        Share.newThumbnail({
          id: $scope.currentCamera.id,
          sgid: sgid,
          scale: $scope.nowScale,
          count: 4,
          lastTimestamp: lastTimestamp,
          zones: allFilteredZoneIds.join(",")
        }, function (data) {
          $scope.thumbnailDataSet(data, sgid, start, end, lastTimestamp, status, x);
        }, function (err) {
          dataCallStatus = false;
          $scope.shareEnd();
        });
      }
    }
  };
  $scope.thumbnailDataSet = function (data, sgid, start, end, lastTimestamp, status, x) {
    if (data.events == undefined) {
      $("#showThumbnailListNew").hide();
      $("#time_info_tri").hide();
      return;
    }
    if (data.events.length == 0) {
      $("#showThumbnailListNew").hide();
      $("#time_info_tri").hide();
      return;
    }

    // beforeSgid = sgid;
    $scope.thumTotal = data.totalCount;
    var thumname_move = (start + end) / 2;
    var html = "";
    thumname_list = [];
    if (data.totalCount == 0) {
      dataCallStatus = false;
      return;
    }
    if (data.events == null) {
      return;
    }
    for (var i = 0; i < data.events.length; i++) {
      var eventTime = $scope.setThumEventTime(data.events[i].startTime);
      var path = "";
      if (location.port != "") {
        path = location.protocol + "//" + data.events[i].filePath.replace(".com/", ".com:" + location.port + "/");
      } else {
        path = location.protocol + "//" + data.events[i].filePath;
      }
      html += '<div id="thumnail_' + i + '" style="float:left;font-size:11px;height:103px';
      if (i > 4) {
        html += "display:none;";
      }
      if (data.events[i].index == 0) {
        data.events[i].labelName = $translate.instant("EVENT_SOUND_AREA");
      } else if (data.events[i].index == 8 || data.events[i].color == "") {
        data.events[i].labelName = $translate.instant("EVENT_ETC_AREA");
        data.events[i].color = "#FFFFFF";
      }
      html += '">';
      var imgIndex = "";
      if (data.events[i].detectType === "motion") {
        imgIndex = _.get(_.find($scope.motionZones, function (o) {
          return o.uid === data.events[i].uindex && o.id !== "9";
        }), "id");
      } else {
        imgIndex = _.get(_.find($scope.eventTypeList, ["id", data.events[i].uindex]), "id");
      }
      if (imgIndex == "" || typeof imgIndex === "undefined") {
        imgIndex = "9";
      }
      html += '<div style="font-size:12px;position:relative;top:2px;z-index:4;color:' + data.events[i].color + ';background:rgba(0,0,0,.7);width:147px;left:1px;line-height: 22px;"><img src="/resources/im/ic_area_color0' + imgIndex + '_N.png" style="top: 3px;position: relative;">&nbsp;' + data.events[i].labelName + "<br></div>";
      html += '<span style="margin-left: 1px;top:-20px;position: relative;z-index: 0;"><a ng-click="pressedThumNailEventItem(' + data.events[i].startTime + ",'timeline')\"><img src=\"" + path + '" onerror="imgError()" style="width:145px;height:98px; border:1px solid rgba(0,0,0,.7)"></a></span>';
      var colorId = data.events[i].color;
      if (colorId == "") {
        colorId = "#f0f0f0";
      }
      var eventDate = new Date(parseInt(data.events[i].startTime)).getYear() + "" + new Date(parseInt(data.events[i].startTime)).getMonth() + "" + new Date(parseInt(data.events[i].startTime)).getDate();
      var todayDate = new Date().getYear() + "" + new Date().getMonth() + "" + new Date().getDate();
      if (eventDate == todayDate) {
        html += '<div style="margin:0 auto;width:70px;line-height: 22px;position: relative;top: -44px;z-index:10; background:rgba(0,0,0,.6);"><div style="color:#fff; font-size:12px;"><span>' + eventTime + "</span></div></div></div>";
      } else {
        html += '<div style="margin:0 auto;width:94px;line-height: 22px;position: relative;top: -44px;z-index:10; background:rgba(0,0,0,.6);"><div style="color:#fff; font-size:12px;"><span>' + eventTime + "</span></div></div></div>";
      }
      thumname_list.push("thumnail_" + i);
      if (lastTimestamp == 0 && status == "N") {
        $("#thumnail_prev_btn").hide();
        $("#thumnail_next_btn").hide();
        $("#thumnail_prev").css("height", "");
        $("#thumnail_next").css("height", "");
      }
      if (i == 0) {
        $scope.lastTimestamp = data.events[i].startTime;
      }
      if (status == "N") {
        $scope.thumNailDataList.put(i, data.events[i]);
      } else {
        $scope.thumNailDataList.put($scope.thumPageCnt + 3, data.events[i]);
      }
    }
    $("#thumbnailList").html(html);
    $("#thumbnailList").css("padding", "1px");
    $("#thumbnailList").css("padding-top", "0px");
    for (var i = 0; i < data.events.length; i++) {
      $("#thumnail_" + i).find("img").error(function () {
        $(this).attr("src", "/resources/im/@thumb/thmb_none.jpg");
      });
    }
    switch (data.totalCount) {
      case 1:
        $("#showThumbnailListNew").css("width", "151px");
        break;
      case 2:
        $("#showThumbnailListNew").css("width", "299px");
        break;
      case 3:
        $("#showThumbnailListNew").css("width", "447px");
        break;
      case 4:
        $("#showThumbnailListNew").css("width", "595px");
        break;
      default:
        show_thumname_idx = 0;
        $("#showThumbnailListNew").css("width", "595px");
        $("#thumnail_prev").css("height", "103px");
        $("#thumnail_next").css("height", "103px");
        break;
    }
    $("#showThumbnailListNew").css("height", "104px");
    if (status == "N") {
      if (data.totalCount > 4) {
        show_thumname_idx = 0;
        $("#thumnail_prev_btn").hide();
        $("#thumnail_next_btn").show();
        $("#thumnail_next").show();
        $("#thumnail_prev").show();
      }
      thumname_move = thumname_move - parseInt($("#showThumbnailListNew").width() / 2);
      if (thumname_move <= 0) {
        thumname_move = 0;
      }
      if ($("#view_timeline_ctrl").width() < thumname_move + $("#showThumbnailListNew").width()) {
        thumname_move = parseInt($("#showThumbnailListNew").css("left")) - ($("#showThumbnailListNew").width() - ($("#view_timeline_ctrl").width() - parseInt($("#showThumbnailListNew").css("left"))));
      }
      var timeInfo = x;
      $("#showThumbnailListNew").css("left", parseInt(thumname_move));
      $("#time_info_tri").css("left", parseInt(timeInfo + 3));
      $("#thumbnailList").append('<div class= "timelineafter"></div>');
      $("#showThumbnailListNew").css("top", "-89px");
      if (data.events.length > 0) {
        $("#time_info_tri").show();
        $("#showThumbnailListNew").show();
      }
    }
    $compile($("#showThumbnailListNew"))($scope);
    showThumClick = 0;
    dataCallStatus = false;
  };
  $scope.pressedThumNailEventItem = function (startTime, clickStatus) {
    var targetTime = parseInt(startTime);
    var callbackFunc = function callbackFunc() {
      $scope.clickedCVRArea(new Date(targetTime));
      if (clickStatus == "timeline") {} else {
        $scope.timeline.zoomDomain(targetTime, $scope.timeRange);
      }
      event.cancelBubble = true; // for IE
      if (event.stopPropagation) {
        event.stopPropagation();
      }
    };
    $scope.checkCVRSeucre(function (isSecureMode) {
      if (isSecureMode) {
        $scope.play.securePassword = "";
        $scope.isShowCVRPlayPasswordConfirm = !$scope.isShowCVRPlayPasswordConfirm;
        $scope.cvrPasswordSuccess = callbackFunc;
      } else {
        callbackFunc();
      }
    });
  };
  $scope.eventAnimation = function (path) {
    var newIndex = $scope.eventThumbIndex + 1;
    if (newIndex === 10) newIndex = 0;
    $scope.eventThumbIndex = newIndex;
    var location = Utils.imageBackgroundLocation(newIndex);
    $scope.eventThumbStyle["background-position"] = -location.left + "px " + location.top + "px";
  };
  $scope.setEventTime = function (time) {
    var dateString;
    var today = moment(new Date());
    var targetDate = new Date(parseInt(time));
    var targetMoment = moment(targetDate);
    var dateString = targetMoment.locale(Utils.getBrowserLanguage()).format($translate.instant("CLIPS_SORT_BY_DATE_TITLE_FORMAT"));
    var todayString = today.locale(Utils.getBrowserLanguage()).format($translate.instant("CLIPS_SORT_BY_DATE_TITLE_FORMAT"));
    if (dateString === todayString) {
      dateString = $translate.instant("TIMELINE_TODAY");
    }
    var timeformat = d3.time.format("%H:%M");
    var timeString = timeformat(targetDate);
    $scope.eventTime = dateString + " " + timeString;
  };
  $scope.setThumEventTime = function (time) {
    var dateString;
    var today = moment(new Date());
    var targetDate = new Date(parseInt(time));
    var targetMoment = moment(targetDate);
    var dateString = targetMoment.locale(Utils.getBrowserLanguage()).format($translate.instant("CLIPS_SORT_BY_DATE_TITLE_FORMAT"));
    var todayString = today.locale(Utils.getBrowserLanguage()).format($translate.instant("CLIPS_SORT_BY_DATE_TITLE_FORMAT"));
    if (dateString === todayString) {
      dateString = $translate.instant("TIMELINE_TODAY");
    }
    var timeformat = d3.time.format("%H:%M");
    var timeString = timeformat(targetDate);
    return dateString + " " + timeString;
  };
  $scope.isTurnOffCamera = function () {
    return Utils.isTurnOffCamera($scope.currentCamera);
  };
  $scope.pressedScreenShotButton = function () {
    showAlert($translate.instant("CLICK_CAPTURE_ALERT_SUBEJCT"), $translate.instant("CLICK_CAPTURE_ALERT_CONTENT"));
  };
  var fullScreenMakeView = 0;
  var fullScreenWidth = 0;
  $scope.pressedFullScreenButton = function () {
    //posTimelineDragCnt = 0;
    $scope.isFullscreenButtonClicked = true;
    if (navigator.userAgent.indexOf("MSIE") !== -1 || navigator.appVersion.indexOf("Trident/") > 0) {
      var rv = 0;
      var ua = navigator.userAgent;
      var re = new RegExp("MSIE ([0-9]{1,}[.0-9]{0,})");
      if (re.exec(ua) != null) rv = parseFloat(RegExp.$1);
      if (rv != 0 && rv <= 10) {
        showAlert($translate.instant("EXPLORE_UNDER10_SUBJECT"), $translate.instant("EXPLORE_UNDER10_CONTENT1") + "<br>" + $translate.instant("EXPLORE_UNDER10_CONTENT2") + "<br>" + $translate.instant("EXPLORE_UNDER10_CONTENT3"));
        return;
      }
    }
    var element = document.getElementById("fullscreen");
    $scope.vedioHeightArea = "100%";
    if (element.requestFullscreen) {
      element.requestFullscreen();
    } else if (element.mozRequestFullScreen) {
      element.mozRequestFullScreen();
    } else if (element.webkitRequestFullscreen) {
      element.webkitRequestFullscreen();
    } else if (element.msRequestFullscreen) {
      element.msRequestFullscreen();
    }
    if ($scope.currentZoom > 1) {
      $scope.isShowTimelineToggleArea = false;
    } else {
      $scope.isShowTimelineToggleArea = true;
    }
    fullscreenFlag = true;
    $scope.isShowFullscreenButton = false;
    $scope.isToggleOn = true;
    setTimeout(function () {
      fullScreenWidth = parseInt(d3.select("#videoBar").style("width"));
      // $scope.videoCursorPosition = $scope.videoCursorPosition* (fullScreenWidth/450);

      var tempPosition = $scope.videoCursorPosition * (fullScreenWidth / 450);
      if (fullScreenWidth < tempPosition) {
        $scope.videoCursorPosition = fullScreenWidth;
      } else if (tempPosition < 0) {
        $scope.videoCursorPosition = 0;
      } else {
        $scope.videoCursorPosition = tempPosition;
      }
    }, 100);
    $("#footer").hide();
    $("#header").hide();
  };
  $scope.pressedExitFullScreenButton = function () {
    $scope.isFullscreenButtonClicked = true;
    $scope.vedioHeightArea = "250px";
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    }
    fullscreenFlag = false;
    $scope.isShowFullscreenButton = true;
    $scope.isShowTimelineToggleArea = true;
    $scope.isToggleOn = false;
    setTimeout(function () {
      barWidth = parseInt(d3.select("#videoBar").style("width"));
      var tempPosition = $scope.videoCursorPosition * (barWidth / fullScreenWidth);
      if (barWidth < tempPosition) {
        $scope.videoCursorPosition = barWidth;
      } else if (tempPosition < 0) {
        $scope.videoCursorPosition = 0;
      } else {
        $scope.videoCursorPosition = tempPosition;
      }
    }, 50);
    // $("#view_timeline_ctrl").show();
    // $("#view_timeline_date").show();
    // $("#view_btn_area").show();
    // $("#view_camdtl_tab").show();
    $("#footer").show();
    $("#header").show();
  };

  // Calendar

  var serviceCalendarDay = function serviceCalendarDay(num) {
    var days = [];
    var now = Date.now();
    for (var i = num - 1; i >= 0; i--) {
      var past = now - i * 24 * 60 * 60 * 1000;
      var day = {
        date: $scope.formattedInternalDate(new Date(past))
      };
      if (i === 0) {
        day.day = $translate.instant("TIMELINE_TODAY");
      } else {
        day.day = moment(new Date(past)).locale(Utils.getBrowserLanguage()).format("dddd");
      }
      days.push(day);
    }
    return days;
  };
  var serviceCalendarDate = function serviceCalendarDate(num) {
    var dates = [];
    var now = Date.now();
    for (var i = num; i >= 0; i--) {
      var past = now - i * 24 * 60 * 60 * 1000;
      var date = {
        date: $scope.formattedInternalDate(new Date(past))
      };
      if (i === 0) {
        date.day = $translate.instant("TIMELINE_TODAY");
      } else {
        date.day = moment(new Date(past)).locale(Utils.getBrowserLanguage()).format("dddd");
        var md;
        if ($scope.timeline.tz !== undefined) {
          md = moment(new Date(past)).tz($scope.timeline.tz);
        } else {
          md = moment(new Date(past));
        }
        if (i === 29 || md.format("D") === "1") {
          date.day = md.format("M/D");
        } else {
          date.day = md.format("D");
        }
      }
      dates.push(date);
    }
    return dates;
  };
  $scope.pressedCalendarDateButton = function (dateString) {
    clickDateChange = true;
    $scope.lineMoveFlag = true;
    $scope.timeRange = 1440;
    $scope.timeline.setTimeRangeAtDateString(dateString, $scope.timeRange);
    setTimeout(function () {
      posTimelineDragCnt = 0;
      $scope.setupDomain([$scope.timeline.currentDomain[0], $scope.timeline.currentDomain[1]]);
      if ($scope.isPlaying == false) {
        var format = d3.time.format("%Y%m%d%H%M%S");
        var startDate = format.parse(dateString + "000000");
        var endDate = format.parse(dateString + "240000");
        var range = 1000 * 60 * $scope.timeRange;
        var startTime = startDate.getTime();
        var endTime = endDate.getTime();
        if (startTime < $scope.currentTime.valueOf() && endTime > $scope.currentTime.valueOf()) {
          $scope.timeline.updateCursor($scope.currentTime);
          posTimelineDragCnt = 0;
        }
      }
    }, 500);
  };

  // fullscreen

  $scope.isShowFullscreenButton = navigator.userAgent.indexOf("MSIE") === -1;
  var startFullscreenTimer = function startFullscreenTimer() {
    $timeout.cancel($scope.fullscreenTimer);
    $scope.fullscreenTimer = $timeout(function () {
      $scope.zoomVisible = false;
      $scope.controlVisible = false;
      $scope.timelineVisible = false;
    }, 5000);
  };
  var isFullScreen = function isFullScreen() {
    return !!(document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement);
  };
  var isFullscreenActiveArea = function isFullscreenActiveArea() {
    var x = d3.event.pageX;
    var y = d3.event.pageY;
    if (x <= 50 || y >= screen.height - 110) {
      return true;
    }
    return false;
  };
  d3.select("#player").on("mousemove", function () {
    if ($scope.isFullScreen) {
      if (isFullscreenActiveArea()) {
        $timeout.cancel($scope.fullscreenTimer);
        $scope.zoomVisible = true;
        $scope.controlVisible = true;
        $scope.timelineVisible = true;
      } else {
        if ($scope.timelineVisible) {
          startFullscreenTimer();
        }
      }
    }
  });

  // find cursor
  $scope.pressedFindCursorButton = function (check) {
    $scope.isCursorRight = false;
    $scope.isCursorLeft = false;
    posTimelineDragCnt = 0;
    if (check == "click") {
      dblClickFlag = false;
    }
    cursorIdx = 0;
    $scope.lineMoveFlag = true;
    changeTimeRangeClick = true;
    if (dblClickFlag == false) {
      $scope.timeline.zoomDomain($scope.currentTime.valueOf(), this.timeRange);
    }
  };

  // Camera Setting
  $scope.config = {};
  $scope.loadCameraSetting = function (callback, clickStatus) {
    if ($scope.shareStatus == true) {
      CameraConfig.getSharedConfig({
        id: $stateParams.cameraId
      }, function (data) {
        angular.extend($scope.config, data);
        $("#cameraNameView").html($scope.config.name);
        $scope.cameraStatusSet(clickStatus);
        if ($scope.config.cameraSchedule != undefined) {
          $scope.config.parsedStartAt = Utils.configDateSeparate($scope.config.cameraSchedule.startAt);
          $scope.config.parsedStopAt = Utils.configDateSeparate($scope.config.cameraSchedule.stopAt);
          $scope.config.repeatOn = Utils.configRepeatOnSeparate($scope.config.cameraSchedule.repeatOn);
        }
        $scope.timeline.setTimezone($scope.config.timezone);
        if ($scope.config.timezone != undefined) {
          $scope.config.tzCode = $scope.config.timezone.split(",")[0];
          $scope.tzCode = $scope.config.tzCode;
          $scope.config.tzDisplayName = $scope.config.timezone.split(",")[1] + $scope.config.timezone.split(",")[3];
        }
        if (typeof callback === "function") {
          callback();
        }
      });
    } else {
      CameraConfig.get({
        id: $stateParams.cameraId
      }, function (data) {
        angular.extend($scope.config, data);
        $("#cameraNameView").html($scope.config.name);
        $scope.cameraStatusSet(clickStatus);
        if ($scope.config.cameraSchedule != undefined) {
          $scope.config.parsedStartAt = Utils.configDateSeparate($scope.config.cameraSchedule.startAt);
          $scope.config.parsedStopAt = Utils.configDateSeparate($scope.config.cameraSchedule.stopAt);
          $scope.config.repeatOn = Utils.configRepeatOnSeparate($scope.config.cameraSchedule.repeatOn);
        }
        $scope.timeline.setTimezone($scope.config.timezone);
        if ($scope.config.timezone != undefined) {
          $scope.config.tzCode = $scope.config.timezone.split(",")[0];
          $scope.tzCode = $scope.config.tzCode;
          $scope.config.tzDisplayName = $scope.config.timezone.split(",")[1] + $scope.config.timezone.split(",")[3];
        }
        $scope.micVolume = $scope.config.micVolume;
        $scope.volumeList = [];
        for (var i = 0; i < 31; i++) {
          if (i == 0) {
            $scope.volumeList.push(1);
          } else {
            $scope.volumeList.push(Math.ceil(i * 3.4));
          }
        }
        $scope.volumeIdx = $scope.config.micVolume;
        if ($scope.config.usageRate > 100) {
          $scope.config.usageRate = 100;
        }
        if (typeof callback === "function") {
          callback();
        }
      });
    }
  };
  $scope.loadCameraSetting(function () {
    $scope.timeline.draw();
    posTimelineDragCnt = 0;
  });
  $scope.timezoneData = Timezone.query();
  $scope.getShareConfig = function () {
    $scope.shareConfig = Share.shareConfig({
      cameraId: $stateParams.cameraId
    });
  };
  $scope.shareDisable = function () {
    if ($scope.shareStatus == true) {
      showAlert($translate.instant("SHARE_ED_CAMERA"), $translate.instant("ACCESS_SHARED_MARKET_DESC"));
      return true;
    } else {
      return false;
    }
  };
  $scope.getCameraConfig = function () {
    if ($scope.shareStatus == true) {
      CameraConfig.getSharedConfig({
        id: $stateParams.cameraId
      }, function (data) {
        angular.extend($scope.config, data);
        $scope.config.tzCode = $scope.config.timezone.split(",")[0];
        $scope.tzCode = $scope.config.tzCode;
      });
    } else {
      CameraConfig.get({
        id: $stateParams.cameraId
      }, function (data) {
        angular.extend($scope.config, data);
        $scope.config.tzCode = $scope.config.timezone.split(",")[0];
        $scope.tzCode = $scope.config.tzCode;
      });
    }
  };
  $scope.changedCameraStatus = function (streamStatus) {
    $scope.config.streamStatus = streamStatus;
    CameraConfig.update({
      id: $stateParams.cameraId
    }, {
      streamStatus: $scope.config.streamStatus
    }, function (data) {
      if (data.code == "ok") {
        if ($scope.config.streamStatus == "off") {
          $scope.cameraRecOff();
          $scope.cameraStatusAllOff();
        } else {
          $scope.livePlay("changeRec");
        }
      }
      $scope.getCameraConfig();
    }, function (err) {
      $scope.getCameraConfig();
    });
  };
  $scope.cameraUpgrade = function (obj) {
    if (event.preventDefault) {
      event.preventDefault();
    } else {
      event.returnValue = false;
    }
    Camera.upgradeCamera({
      cameraId: $scope.currentCamera.id
    }, function (data) {
      $scope.isUpgrading = true;
    });
  };
  $scope.scheduleCancle = function () {
    $scope.loadCameraSetting();
  };
  $scope.clickedRemoveCamera = function () {
    $("body").scrollTop(10);
    $scope.showRemoveCameraAlert = true;
  };
  $scope.hideRemoveCameraAlert = function () {
    $scope.showRemoveCameraAlert = false;
  };
  $scope.removeCameraConfirm = function () {
    Camera.remove({
      id: $stateParams.cameraId
    }, function () {
      $state.go("main.cameras");
    });
  };
  $scope.clickedCameraNotifySettingButton = function () {
    if ($scope.shareDisable() == true) return;
    $scope.isShowNotificationSetting = !$scope.isShowNotificationSetting;
    $scope.loadNotifyConfig();
  };
  $scope.changeNotifyOn = function (notifyOn) {
    $scope.notify.notifyOn = notifyOn;
    CameraNotifyConfig.update({
      id: $stateParams.cameraId
    }, {
      notifyOn: notifyOn
    });
  };
  $scope.changeEventType = function () {
    var eventType = Utils.notifyEventTypeJoin($scope.notify.eventType);
    CameraNotifyConfig.update({
      id: $stateParams.cameraId
    }, {
      notifyEventType: eventType
    });
  };

  // Event List
  var eventListDate = function eventListDate() {
    var dates = [];
    var now = Date.now();
    for (var i = 0; i <= $scope.serviceDay; i++) {
      var past = now - i * 24 * 60 * 60 * 1000;
      var date = {
        date: $scope.formattedInternalDate(new Date(past))
      };
      date.day = moment(new Date(past)).locale(Utils.getBrowserLanguage()).format($translate.instant("EVENT_LIST_DATE_FORMAT"));
      if (i === 0) {
        date.day += " (" + $translate.instant("EVENT_LIST_DATE_TODAY") + ")";
      }
      dates.push(date);
    }
    return dates;
  };
  $scope.eventlists = {};
  $scope.eventlistDates = [];
  (function () {
    for (var i = 0; i < 30; i++) {
      $scope.eventlistDates[i] = {};
    }
  })();
  $scope.eventThumbnails = {};
  // $scope.eventDetectType = ['motion', 'audio', 'access'];

  $scope.checkboxAudioEvent = true;
  $scope.eventFilter = {};
  $scope.eventFilter.accessCheck = true;
  $scope.eventListFlag = true;
  var eventGroupTmp = [];
  // 이벤트 리스트 날짜 이동 처리
  $scope.pressedEventListDateButton = function (index) {
    if ($scope.eventListFlag) {
      return;
    }
    $scope.showSelectColor = false;
    $scope.selectedEventDateIndex = index;
    var selectedDate = moment($scope.searchDate).format("YYYYMMDD");
    var allFilteredZoneIds = $scope.getAllFilteredZonesIds();
    if ($scope.shareStatus == false) {
      Pos.getEventList({
        shopId: $stateParams.id,
        date: selectedDate,
        pageSize: 0,
        posId: $scope.selectPosVal,
        eventTps: allFilteredZoneIds.join(","),
        sortField: $scope.sortField,
        sorting: $scope.sorting
      }, function (data) {
        $scope.pressEventDailyDataSet(data.events, index);
      }, function (err) {});
    } else {
      Pos.getEventList({
        shopId: $stateParams.id,
        date: selectedDate,
        pageSize: 0,
        posId: $scope.selectPosVal,
        eventTps: allFilteredZoneIds.join(","),
        sortField: $scope.sortField,
        sorting: $scope.sorting
      }, function (data) {
        $scope.pressEventDailyDataSet(data.events, index);
      }, function (err) {});
    }
  };

  //이벤트 리스트 날짜 이동시 이벤트 리스트 목록에 출력하는 화면 생성
  $scope.pressEventDailyDataSet = function (data, index) {
    if ($scope.serviceDay == 0) {
      return;
    }
    $("#eventListArea").css("height", $("#eventList_list").height() - 74);
    for (i = 0; i < data.length; i++) {
      var posInfo = _.find($scope.posList, {
        posId: data[i].posId
      });
      data[i]["posName"] = posInfo.posName;
    }
    $scope.eventLists = data;
  };
  $scope.ImageExist = function (url) {
    var img = new Image();
    img.src = url;
    if (img.height == 0) {
      return false;
    } else {
      return true;
    }
  };
  $scope.renderHtml = function (html_code) {
    return $sce.trustAsHtml(html_code);
  };
  $scope.pressedEventItem = function (data) {
    $interval.cancel($scope.timer);
    var targetTime = parseInt(data.start);
    event.cancelBubble = true; // for IE
    if (event.stopPropagation) {
      event.stopPropagation();
    }
    $scope.checkCVRSeucre(function (isSecureMode) {
      if (isSecureMode) {
        $scope.play.securePassword = "";
        $scope.isShowCVRPlayPasswordConfirm = !$scope.isShowCVRPlayPasswordConfirm;
        $scope.cvrPasswordSuccess = function () {
          $scope.goCvr(targetTime, "f");
        };
      } else {
        $scope.goCvr(targetTime, "f");
      }
    });
  };
  var eventListFormatted = function eventListFormatted(event) {
    var start = moment(parseInt(event.startTime)).tz($scope.timeline.tz).format("HH:mm:ss");
    var end = moment(parseInt(event.endTime)).tz($scope.timeline.tz).format("HH:mm:ss");
    return $sce.trustAsHtml(start + "-" + end);
  };

  // 이벤트 리스트에 표기하는 날짜 문자열 반환
  var dateWithDateIndex = function dateWithDateIndex(dateIndex) {
    var now = moment().tz($scope.timeline.tz);
    var dateString = "";
    if (now == undefined) {
      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1; //January is 0!

      var yyyy = today.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }
      var dateString = yyyy + "" + mm + "" + dd;
    } else {
      dateString = now.subtract(dateIndex, "days").format("YYYYMMDD");
    }
    return dateString;
  };
  var timeRangeWithEventIndexes = function timeRangeWithEventIndexes(dateIndex, timeIndex) {
    var dateFormat = "YYYYMMDDHHmmss";
    var now = moment().tz($scope.timeline.tz);
    var dateString = now.subtract(dateIndex, "days").format("YYYYMMDD");
    var startHourString = timeIndex.toString();
    if (timeIndex < 10) startHourString = "0" + timeIndex;
    var endHourString = (timeIndex + 1).toString();
    if (timeIndex + 1 < 10) endHourString = "0" + (timeIndex + 1);
    var startDateTimeString = dateString + startHourString + "0001";
    var endDateTimeString = dateString + endHourString + "0000";
    var start = moment(startDateTimeString, dateFormat).tz($scope.timeline.tz);
    var end = moment(endDateTimeString, dateFormat).tz($scope.timeline.tz);
    return [start.valueOf(), end.valueOf()];
  };

  // Zone
  $scope.zoneAreaColorSet = ["#d90101", "#ff7900", "#3ea1d4", "#a4c800", "#efd600", "#767dff", "#ca74f0", "#ff76bd"];
  $scope.showZoneSetting = function () {
    $scope.zoomVisible = false;
    $scope.controlVisible = false;
    $scope.zoneSettingVisible = true;
    if ($scope.zonearea === undefined) {
      $scope.zonearea = new ZoneArea("zone-area");
      $scope.zonearea.delegate = $scope;
      $scope.zonearea.setZonesData($scope.motionZones);
      $scope.zonearea.setSelectedZones($scope.selectedZones);
    } else {
      $scope.zonearea.setCanvasSize($("#player").width(), $("#player").height(), $scope.motionZones, $scope.selectedZones);
    }
  };

  // clip
  $scope.newClip = {
    playrate: "1",
    isSmart: false,
    timeOverlay: "No",
    outputDuration: "0s"
  };
  $scope.timelineDate = {};
  var setClipStartTimeMoment = function setClipStartTimeMoment(m) {
    $scope.newClip.startTime = m.format("HH : mm : ss");
    var token = $scope.newClip.startTime.split(" : ");
    if (token[0] == "Invalid date") {
      token[0] = "00";
      token[1] = "00";
      token[2] = "00";
    }
    $scope.newClip.startHour = token[0];
    $scope.newClip.startMinute = token[1];
    $scope.newClip.startSecond = token[2];
  };
  var setClipEndTimeMoment = function setClipEndTimeMoment(m) {
    $scope.newClip.endTime = m.format("HH : mm : ss");
    var token = $scope.newClip.endTime.split(" : ");
    if (token[0] == "Invalid date") {
      token[0] = "00";
      token[1] = "00";
      token[2] = "00";
    }
    $scope.newClip.endHour = token[0];
    $scope.newClip.endMinute = token[1];
    $scope.newClip.endSecond = token[2];
  };
  var setTimelineTimeMoment = function setTimelineTimeMoment(m) {
    $scope.timelineDate.time = m.format("HH : mm : ss");
    var token = $scope.timelineDate.time.split(" : ");
    if (token[0] == "Invalid date") {
      token[0] = "00";
      token[1] = "00";
      token[2] = "00";
    }
    $scope.timelineDate.hour = token[0];
    $scope.timelineDate.minute = token[1];
    $scope.timelineDate.second = token[2];
  };
  $scope.hideClipCreate = function () {
    resetClipValue(); //클립&타임랩스 변수값 초기화
    $scope.clipStartDatePicker.destroy(); // pikday destroy
    $scope.clipEndDatePicker.destroy(); // pikday destroy
  };

  // 클립&타임랩스 변수값 초기화
  var resetClipValue = function resetClipValue() {
    $scope.isShowCreateClip = false;
    $scope.isShowingStartTimePicker = false;
    $scope.isShowingEndTimePicker = false;
    $scope.newClip.playrate = 1;
    $scope.newClip.isSmart = false;
    $scope.newClip.timeOverlay = "No";
    $scope.newClip.outputDuration = "0s";
  };

  // 클립&타임랩스 생성 레이어 팝업 호출
  var renderClipDatePickerTimer;
  $scope.pressedShowTimelapseButton = function () {
    isChangedClipName = false; //클립&타임랩스명 변경 flag 초기화
    if ($scope.shareDisable() == true) return;
    resetClipValue(); // 클립&타임랩스 변수값 초기화
    var minDate = moment().subtract(parseInt($scope.currentCamera.serviceType), "d");
    $scope.isShowCreateClip = true;
    renderClipDatePickerTimer = $timeout(function () {
      $scope.clipStartDatePicker = new Pikaday({
        field: document.getElementById("clipStartDate"),
        format: $translate.instant("CLIP_CREATE_CLIP_DATE_FORMAT"),
        minDate: minDate.toDate(),
        maxDate: new Date(),
        // defaultDate: new Date(),
        position: "bottom right",
        onSelect: function onSelect() {
          $scope.newClip.duration = getClipDurationString();
          $scope.newClip.outputDuration = getClipDurationString($scope.newClip.playrate);
          // setStartClipThumbnail();
          canCreateClip();
        }
      });
      $scope.clipEndDatePicker = new Pikaday({
        field: document.getElementById("clipEndDate"),
        format: $translate.instant("CLIP_CREATE_CLIP_DATE_FORMAT"),
        minDate: minDate.toDate(),
        maxDate: new Date(),
        defaultDate: new Date(),
        position: "bottom right",
        onSelect: function onSelect() {
          $scope.newClip.duration = getClipDurationString();
          $scope.newClip.outputDuration = getClipDurationString($scope.newClip.playrate);
          canCreateClip();
        }
      });
      Clip.availableRange({
        cameraId: $scope.currentCamera.id,
        type: "0"
      }, function (data) {
        $scope.newClip.startDate = moment(parseInt(data.end)).add(-10, "m").locale(Utils.getBrowserLanguage()).format($translate.instant("CLIP_CREATE_CLIP_DATE_FORMAT"));
        $scope.newClip.endDate = moment(parseInt(data.end)).locale(Utils.getBrowserLanguage()).format($translate.instant("CLIP_CREATE_CLIP_DATE_FORMAT"));
        setClipStartTimeMoment(moment(parseInt(data.end)).add(-10, "m"));
        setClipEndTimeMoment(moment(parseInt(data.end)));
        $scope.newClip.duration = getClipDurationString();
        $scope.newClip.outputDuration = getClipDurationString($scope.newClip.playrate);
      });
    }); // $timeout

    $scope.newClip.name = $translate.instant("CLIP_CREATE_CLIP_NEW_NAME");
  };

  // 클립&타임랩스명 변경 이벤트
  var isChangedClipName = false; // 클립&타임랩스명 변경 flag
  $scope.changeClipName = function () {
    isChangedClipName = true;
  };

  // 스마트 타임랩스 체크 변경 이벤트 (클립&타임랩스명 기본값 설정)
  $scope.changeSmartCheck = function () {
    if ($scope.newClip.isSmart && !isChangedClipName) {
      $scope.newClip.name = $translate.instant("CAMERA_NEW_TIMELAPS");
    } else if (!$scope.newClip.isSmart && $scope.newClip.playrate != "1" && !isChangedClipName) {
      $scope.newClip.name = $translate.instant("CLIP_CREATE_TIMELAPSE_NEW_NAME");
    } else if (!$scope.newClip.isSmart && $scope.newClip.playrate == "1" && !isChangedClipName) {
      $scope.newClip.name = $translate.instant("CLIP_CREATE_CLIP_NEW_NAME");
    }
  };

  // 타임라인 날짜/시간 바로가기
  $scope.pressedShowTimelineCalendarButton = function () {
    $scope.isShowTimelineCalendar = !$scope.isShowTimelineCalendar;
    // $scope.timelineDatePicker._d = new Date();
    $scope.timelineDatePicker._d = $scope.currentTime;
    $scope.timelineDate.date = moment(parseInt($scope.timelineDatePicker._d.getTime())).locale(Utils.getBrowserLanguage()).format($translate.instant("CLIP_CREATE_CLIP_DATE_FORMAT"));
    setTimelineTimeMoment(moment(parseInt($scope.timelineDatePicker._d.getTime())));
  };

  // 타임라인 날짜/시간 바로가기 숨김
  $scope.hideTimelineCalendr = function () {
    $scope.isShowTimelineCalendar = false;
    $scope.isShowingTimelineTimePicker = false;
    $scope.timelineDatePicker.hide();
  };
  var setupClipCalendar = function setupClipCalendar(serviceType) {
    var minDate = moment().subtract(parseInt(serviceType), "d");
    var regDate = moment($scope.currentCamera.regDate);
    $scope.timelineDatePicker = new Pikaday({
      field: document.getElementById("timelineDate"),
      container: document.getElementById("calendarContainer"),
      format: $translate.instant("CLIP_CREATE_CLIP_DATE_FORMAT"),
      minDate: minDate.toDate(),
      maxDate: new Date(),
      defaultDate: $scope.currentTime,
      position: "bottom right"
    });
    var startMoment = moment();
    var endMoment = moment();
    $scope.isShowingStartTimePicker = false;
    $scope.isShowingEndTimePicker = false;
    $scope.isShowingTimelineTimePicker = false;
  };
  $scope.toggleStartClipCalendar = function () {
    if ($scope.clipStartDatePicker.isVisible()) {
      $scope.clipStartDatePicker.hide();
    } else {
      $scope.clipStartDatePicker.show();
    }
    event.cancelBubble = true; // for IE
    if (event.stopPropagation) {
      event.stopPropagation();
    }
  };
  $scope.toggleEndClipCalendar = function () {
    if ($scope.clipEndDatePicker.isVisible()) {
      $scope.clipEndDatePicker.hide();
    } else {
      $scope.clipEndDatePicker.show();
    }
    event.cancelBubble = true; // for IE
    if (event.stopPropagation) {
      event.stopPropagation();
    }
  };
  $scope.toggleTimelineCalendar = function () {
    if ($scope.timelineDatePicker.isVisible()) {
      $scope.timelineDatePicker.hide();
    } else {
      $scope.timelineDatePicker.show();
    }
    event.cancelBubble = true; // for IE
    if (event.stopPropagation) {
      event.stopPropagation();
    }
  };
  $scope.pressedShowClipsButton = function () {
    $state.go("main.clips");
  };
  $scope.toggleStartClipTimePicker = function () {
    if ($scope.isShowingStartTimePicker) {
      var startMoment = moment($scope.newClip.startTime, "HH : mm : ss");
      setClipStartTimeMoment(startMoment);
    }
    $scope.isShowingStartTimePicker = !$scope.isShowingStartTimePicker;
  };
  $scope.toggleEndClipTimePicker = function () {
    if ($scope.isShowingEndTimePicker) {
      var endMoment = moment($scope.newClip.endTime, "HH : mm : ss");
      setClipEndTimeMoment(endMoment);
    }
    $scope.isShowingEndTimePicker = !$scope.isShowingEndTimePicker;
  };
  $scope.toggleTimelineTimePicker = function () {
    if ($scope.isShowingTimelineTimePicker) {
      var timelineMoment = moment($scope.timelineDate.time, "HH : mm : ss");
      setTimelineTimeMoment(timelineMoment);
    }
    $scope.isShowingTimelineTimePicker = !$scope.isShowingTimelineTimePicker;
  };
  $scope.pressedStartClipTimeSelect = function () {
    if ($scope.newClip.startHour.length < 1) {
      showAlert($translate.instant("CAMERA_INPUT_ERROR"), $translate.instant("CAMERA_ENTER_TIME"));
      return;
    }
    if ($scope.newClip.startMinute.length < 1) {
      showAlert($translate.instant("CAMERA_INPUT_ERROR"), $translate.instant("CAMERA_ENTER_MINUTE"));
      return;
    }
    if ($scope.newClip.startSecond.length < 1) {
      showAlert($translate.instant("CAMERA_INPUT_ERROR"), $translate.instant("CAMERA_ENTER_SECOND"));
      return;
    }

    // $scope.newClip.startTime = $scope.newClip.startHour + " : " + $scope.newClip.startMinute + " : " + $scope.newClip.startSecond;
    $scope.newClip.startTime = (parseInt($scope.newClip.startHour) < 10 && $scope.newClip.startHour.length < 2 ? "0" + $scope.newClip.startHour : $scope.newClip.startHour) + " : " + (parseInt($scope.newClip.startMinute) < 10 && $scope.newClip.startMinute.length < 2 ? "0" + $scope.newClip.startMinute : $scope.newClip.startMinute) + " : " + (parseInt($scope.newClip.startSecond) < 10 && $scope.newClip.startSecond.length < 2 ? "0" + $scope.newClip.startSecond : $scope.newClip.startSecond);
    $scope.isShowingStartTimePicker = false;
    $scope.newClip.duration = getClipDurationString();
    $scope.newClip.outputDuration = getClipDurationString($scope.newClip.playrate);
    // setStartClipThumbnail();
    canCreateClip();
  };
  $scope.pressedEndClipTimeSelect = function () {
    if ($scope.newClip.endHour.length < 1) {
      showAlert($translate.instant("CAMERA_INPUT_ERROR"), $translate.instant("CAMERA_ENTER_TIME"));
      return;
    }
    if ($scope.newClip.endMinute.length < 1) {
      showAlert($translate.instant("CAMERA_INPUT_ERROR"), $translate.instant("CAMERA_ENTER_MINUTE"));
      return;
    }
    if ($scope.newClip.endSecond.length < 1) {
      showAlert($translate.instant("CAMERA_INPUT_ERROR"), $translate.instant("CAMERA_ENTER_SECOND"));
      return;
    }

    // $scope.newClip.endTime = $scope.newClip.endHour + " : " + $scope.newClip.endMinute + " : " + $scope.newClip.endSecond;
    $scope.newClip.endTime = (parseInt($scope.newClip.endHour) < 10 && $scope.newClip.endHour.length < 2 ? "0" + $scope.newClip.endHour : $scope.newClip.endHour) + " : " + (parseInt($scope.newClip.endMinute) < 10 && $scope.newClip.endMinute.length < 2 ? "0" + $scope.newClip.endMinute : $scope.newClip.endMinute) + " : " + (parseInt($scope.newClip.endSecond) < 10 && $scope.newClip.endSecond.length < 2 ? "0" + $scope.newClip.endSecond : $scope.newClip.endSecond);
    $scope.isShowingEndTimePicker = false;
    $scope.newClip.duration = getClipDurationString();
    $scope.newClip.outputDuration = getClipDurationString($scope.newClip.playrate);
    // setEndClipThumbnail();
    canCreateClip();
  };
  $scope.pressedTimelineTimeSelect = function () {
    if ($scope.timelineDate.hour.length < 1) {
      showAlert($translate.instant("CAMERA_INPUT_ERROR"), $translate.instant("CAMERA_ENTER_TIME"));
      return;
    }
    if ($scope.timelineDate.minute.length < 1) {
      showAlert($translate.instant("CAMERA_INPUT_ERROR"), $translate.instant("CAMERA_ENTER_MINUTE"));
      return;
    }
    if ($scope.timelineDate.second.length < 1) {
      showAlert($translate.instant("CAMERA_INPUT_ERROR"), $translate.instant("CAMERA_ENTER_SECOND"));
      return;
    }
    $scope.timelineDate.time = (parseInt($scope.timelineDate.hour) < 10 && $scope.timelineDate.hour.length < 2 ? "0" + $scope.timelineDate.hour : $scope.timelineDate.hour) + " : " + (parseInt($scope.timelineDate.minute) < 10 && $scope.timelineDate.minute.length < 2 ? "0" + $scope.timelineDate.minute : $scope.timelineDate.minute) + " : " + (parseInt($scope.timelineDate.second) < 10 && $scope.timelineDate.second.length < 2 ? "0" + $scope.timelineDate.second : $scope.timelineDate.second);
    $scope.isShowingTimelineTimePicker = false;
  };

  //공유

  $scope.shareCnt = 0;
  $scope.shareAddStatus = true;
  $scope.shareAdd = function () {
    if ($scope.shareAddStatus == false) {
      return;
    }
    $scope.shareAddStatus = false;
    var receiverName = $("#receiverName").val();
    if (receiverName.length == 0) {
      showAlert($translate.instant("SHARE_FAIL"), $translate.instant("SHARE_RECEVER_NAME_NECC"));
      $scope.shareAddStatus = true;
      return;
    } else if (receiverName.length >= 11) {
      showAlert($translate.instant("SHARE_FAIL"), $translate.instant("SHARE_RECEVER_NAME_MAX"));
      $scope.shareAddStatus = true;
      return;
    }
    var receiverId = $("#receiverId").val();
    if (receiverId.length == 0) {
      showAlert($translate.instant("SHARE_FAIL"), $translate.instant("SHARE_RECEVER_INFO_NECC"));
      $scope.shareAddStatus = true;
      return;
    }
    if ($scope.shareAddModel.shareOptions[0] === "0") {
      showAlert($translate.instant("SHARE_FAIL"), $translate.instant("CAMERA_REAL_EVENT_NECESSARY"));
      $scope.shareAddStatus = true;
      return;
    }
    if ($scope.shareCnt >= 5) {
      showAlert($translate.instant("SHARE_FAIL"), $translate.instant("SHARE_MAX"));
      $scope.shareAddStatus = true;
      return;
    }
    var receiverId = $("#receiverId").val();
    if ($scope.me.paycoEmail == $("#receiverId").val()) {
      showAlert($translate.instant("SHARE_FAIL2"), $translate.instant("SHARE_NO_MY"));
      $scope.shareAddStatus = true;
      return;
    } else {
      receiverId = receiverId.replace(/-/gi, "");
      receiverId = "82" + receiverId.substring(1, receiverId.length);
      if ($scope.me.paycoMobile.replace(/-/gi, "") == receiverId) {
        showAlert($translate.instant("SHARE_FAIL2"), $translate.instant("SHARE_NO_MY"));
        $scope.shareAddStatus = true;
        return;
      }
    }
    var shareDoubleCheck = 0;
    for (var i = 0; i < $scope.shareCameras.length; i++) {
      if ($scope.shareCameras[i].receiverId == $("#receiverId").val()) {
        shareDoubleCheck++;
      } else {
        var receiverId = $("#receiverId").val();
        receiverId = receiverId.replace(/-/gi, "");
        if (receiverId.length > 3) {
          receiverId = "82" + receiverId.substring(1, receiverId.length);
          if ($scope.shareCameras[i].receiverId.replace(/-/gi, "") == receiverId) {
            shareDoubleCheck++;
          }
        }
      }
    }
    if (shareDoubleCheck > 0) {
      showAlert($translate.instant("SHARE_FAIL2"), $translate.instant("SHARE_SHARED_RECEVEID"));
      $scope.shareAddStatus = true;
      return;
    }
    $scope.isAddShare = true;
  };
  $scope.isAddShareClose = function () {
    $scope.isAddShare = false;
    $scope.shareAddStatus = true;
  };
  $scope.shareAddCheck = function () {
    $scope.isAddShare = false;
    if ($scope.shareCnt >= 5) {
      showAlert($translate.instant("SHARE_FAIL"), $translate.instant("SHARE_MAX"));
    }
    var receiverId = $("#receiverId").val();
    var receiverName = $("#receiverName").val();
    var validPhone = Utils.phoneNumberVaild(Utils.toFormattedPhoneNumber(receiverId));
    var validEmail = Utils.emailValid(Utils.toFormattedPhoneNumber(receiverId));
    if (validPhone == false && validEmail == false) {
      showAlert($translate.instant("SHARE_FAIL3"), $translate.instant("SHARE_FAIL3_MSG"));
      $scope.shareAddStatus = true;
      return;
    }
    if (receiverName.length == 0) {
      showAlert($translate.instant("SHARE_FAIL"), $translate.instant("SHARE_RECEVER_NAME_NECC"));
      $scope.shareAddStatus = true;
      return;
    }
    $("#receiverId").val("");
    $("#receiverName").val("");
    Share.shareCamera({
      cameraId: $scope.currentCamera.id,
      receiverId: receiverId,
      receiverName: receiverName,
      shareOptions: $scope.shareAddModel.shareOptions
    }, function (data) {
      $scope.shareAddStatus = true;
      if (data.code == "ok") {
        $scope.getShareCamerasList();
        showAlert($translate.instant("SHARE_SUCCESS"), $translate.instant("SHARE_SUCCESS_MSG"));
        $scope.getShareCamerasList();
        $("#receiverId").val("");
        $("#receiverName").val("");
        $scope.shareAddModel.shareOptions = ["1", "0"];
      } else {
        if (data.errorCode == "-1") {
          showAlert($translate.instant("SHARE_FAIL2"), $translate.instant("SHARE_ERR_NO_CAMERA"));
        } else if (data.errorCode == "-2") {
          showAlert($translate.instant("SHARE_FAIL2"), $translate.instant("SHARE_ERR_NO_MY_CAMERA"));
        } else if (data.errorCode == "-3") {
          showAlert($translate.instant("SHARE_FAIL2"), $translate.instant("SHARE_SHARED_RECEVEID"));
        } else if (data.errorCode == "-4") {
          showAlert($translate.instant("SHARE_FAIL2"), $translate.instant("SHARE_NO_MY"));
        }
      }
    });
  };
  $scope.shareRemove = function (cameraId, sharedCameraUid) {
    $scope.isRemoveShare = true;
    $scope.removeShareCameraId = cameraId;
    $scope.sharedCameraUid = sharedCameraUid;
    $scope.shareAddStatus = true;
  };
  $scope.shareRemoveCheck = function () {
    $scope.isRemoveShare = false;
    Share.removeMyShared({
      id: $scope.removeShareCameraId,
      sharedCameraUid: $scope.sharedCameraUid
    }, function (data) {
      $scope.getShareCamerasList();
      showAlert($translate.instant("SHARE_REMOVE_SUCCESS"), $translate.instant("SHARE_REMOVE_SUCCESS_MSG"));
      $scope.getShareCamerasList();
      $scope.removeShareCameraId = "";
      $scope.sharedCameraUid = "";
    }, function (err) {
      $scope.removeShareCameraId = "";
      $scope.sharedCameraUid = "";
    });
  };
  $scope.removeSharedCamera = function (sharedCameraUid) {
    $scope.sharedCameraUid = sharedCameraUid;
    $scope.isRemoveShared = true;
  };
  $scope.sharedRemoveCheck = function () {
    $scope.isRemoveShared = false;
    Share.rejectSharedCamera({
      sharedCameraUid: $scope.shareConfig.sharedCameraUid
    }, {
      isRejected: "YES"
    }, function (data) {
      showAlert($translate.instant("SHARE_REMOVE_SUCCESS"), $translate.instant("SHARE_REMOVE_SUCCESS_MSG"));
      $state.go("main.cameras");
      $scope.sharedCameraUid = "";
    }, function (err) {
      $scope.sharedCameraUid = "";
    });
  };
  $scope.getShareCamerasList = function () {
    Share.getMySharedList({
      id: $scope.currentCamera.id
    }, function (data) {
      $scope.shareCameras = $scope.cameraDataSet(data);
      $scope.shareCnt = data.length;
    }, function (err) {
      $scope.errCameras = true;
    });
  };
  $scope.shareEnd = function () {
    Share.get({
      id: $stateParams.cameraId
    }, function (res) {}, function (err) {
      $scope.shareEndCheckErr();
    });
  };
  $scope.shareEndCheckErr = function () {
    $scope.player.stop();
    $interval.cancel($scope.reloadTimer);
    $interval.cancel($scope.timer);
    $interval.cancel($scope.eventThumbTimer);
    $interval.cancel($scope.eventlistTimer);
    $interval.cancel(callEvtList);
    $scope.isNoShared = true;
    return false;
  };
  $scope.cameraDataSet = function (data) {
    for (var i = 0; i < data.length; i++) {
      if (location.port != "") {
        data[i].thumbnailPath = location.protocol + "//" + data[i].thumbnailPath.replace(".com/", ".com:" + location.port + "/");
      } else {
        data[i].thumbnailPath = location.protocol + "//" + data[i].thumbnailPath;
      }
      if (data[i].streamStatus === "off" && data[i].controlStatus === "CS") {
        data[i].streamStatus = data[i].streamStatus === "on";
      }
      data[i].cameraViewState = 0;
      if (data[i].streamStatusConfig == "off") {
        data[i].cameraViewState = 1;
      } else {
        if (data[i].controlStatus == "on") {
          if (data[i].streamStatus == "off") {
            data[i].cameraViewState = 2;
          }
        } else {
          if (data[i].streamStatus == "on") {
            data[i].cameraViewState = 3;
          } else {
            data[i].cameraViewState = 4;
          }
        }
      }
      data[i].number = i;
    }
    return data;
  };
  $scope.renamePhoneNumber = function (phoneNumber) {
    var tmpPhoneNumber = phoneNumber;
    phoneNumber = "0" + phoneNumber.substring(2, phoneNumber.length);
    var validPhone = Utils.phoneNumberVaild(Utils.toFormattedPhoneNumber(phoneNumber));
    if (validPhone == false) {
      return tmpPhoneNumber;
    } else {
      return Utils.toFormattedPhoneNumber(phoneNumber);
    }
  };
  var getClipStartMoment = function getClipStartMoment() {
    var dateMoment = $scope.clipStartDatePicker.getMoment();
    if ($scope.newClip.startTime == "Invalid date") {
      $scope.newClip.startTime = "00 : 00 : 00";
    }
    var timeString = $scope.newClip.startTime;
    return moment(dateMoment.format("YYYYMMDD") + " " + timeString, "YYYYMMDD HH : mm : ss");
  };
  var getClipEndMoment = function getClipEndMoment() {
    var dateMoment = $scope.clipEndDatePicker.getMoment();
    if ($scope.newClip.endTime == "Invalid date") {
      $scope.newClip.endTime = "00 : 00 : 00";
    }
    var timeString = $scope.newClip.endTime;
    return moment(dateMoment.format("YYYYMMDD") + " " + timeString, "YYYYMMDD HH : mm : ss");
  };
  var getTimelineMoment = function getTimelineMoment() {
    var dateMoment = $scope.timelineDatePicker.getMoment();
    if ($scope.timelineDate.time == "Invalid date") {
      $scope.timelineDate.time = "00 : 00 : 00";
    }
    var timeString = $scope.timelineDate.time;
    return moment(dateMoment.format("YYYYMMDD") + " " + timeString, "YYYYMMDD HH : mm : ss");
  };
  var getClipDurationString = function getClipDurationString(playrate) {
    var startMoment = getClipStartMoment();
    var endMoment = getClipEndMoment();
    return Utils.durationStringFromTwoTime(startMoment.toDate().getTime(), endMoment.toDate().getTime(), playrate);
  };
  var pressedTimeUpButton = function pressedTimeUpButton(val, max) {
    val = val.length < 1 ? 0 : val;
    var time = parseInt(val);
    time += 1;
    if (time > max) {
      time = 0;
    }
    if (time.toString().length == 1) {
      return "0" + time.toString();
    } else {
      return time.toString();
    }
  };
  var pressedTimeDownButton = function pressedTimeDownButton(val, max) {
    val = val.length < 1 ? 0 : val;
    var time = parseInt(val);
    time -= 1;
    if (time < 0) {
      time = max;
    }
    if (time.toString().length == 1) {
      return "0" + time.toString();
    } else {
      return time.toString();
    }
  };
  $scope.pressedStartHourUpButton = function () {
    $scope.newClip.startHour = pressedTimeUpButton($scope.newClip.startHour, 23);
  };
  $scope.pressedStartMinuteUpButton = function () {
    $scope.newClip.startMinute = pressedTimeUpButton($scope.newClip.startMinute, 59);
  };
  $scope.pressedStartSecondUpButton = function () {
    $scope.newClip.startSecond = pressedTimeUpButton($scope.newClip.startSecond, 59);
  };
  $scope.pressedStartHourDownButton = function () {
    $scope.newClip.startHour = pressedTimeDownButton($scope.newClip.startHour, 23);
  };
  $scope.pressedStartMinuteDownButton = function () {
    $scope.newClip.startMinute = pressedTimeDownButton($scope.newClip.startMinute, 59);
  };
  $scope.pressedStartSecondDownButton = function () {
    $scope.newClip.startSecond = pressedTimeDownButton($scope.newClip.startSecond, 59);
  };
  $scope.pressedEndHourDownButton = function () {
    $scope.newClip.endHour = pressedTimeDownButton($scope.newClip.endHour, 23);
  };
  $scope.pressedEndMinuteDownButton = function () {
    $scope.newClip.endMinute = pressedTimeDownButton($scope.newClip.endMinute, 59);
  };
  $scope.pressedEndSecondDownButton = function () {
    $scope.newClip.endSecond = pressedTimeDownButton($scope.newClip.endSecond, 59);
  };
  $scope.pressedEndHourUpButton = function () {
    $scope.newClip.endHour = pressedTimeUpButton($scope.newClip.endHour, 23);
  };
  $scope.pressedEndMinuteUpButton = function () {
    $scope.newClip.endMinute = pressedTimeUpButton($scope.newClip.endMinute, 59);
  };
  $scope.pressedEndSecondUpButton = function () {
    $scope.newClip.endSecond = pressedTimeUpButton($scope.newClip.endSecond, 59);
  };
  $scope.pressedTimelineHourUpButton = function () {
    $scope.timelineDate.hour = pressedTimeUpButton($scope.timelineDate.hour, 23);
  };
  $scope.pressedTimelineMinuteUpButton = function () {
    $scope.timelineDate.minute = pressedTimeUpButton($scope.timelineDate.minute, 59);
  };
  $scope.pressedTimelineSecondUpButton = function () {
    $scope.timelineDate.second = pressedTimeUpButton($scope.timelineDate.second, 59);
  };
  $scope.pressedTimelineHourDownButton = function () {
    $scope.timelineDate.hour = pressedTimeDownButton($scope.timelineDate.hour, 23);
  };
  $scope.pressedTimelineMinuteDownButton = function () {
    $scope.timelineDate.minute = pressedTimeDownButton($scope.timelineDate.minute, 59);
  };
  $scope.pressedTimelineSecondDownButton = function () {
    $scope.timelineDate.second = pressedTimeDownButton($scope.timelineDate.second, 59);
  };
  $scope.clipMessage = "";
  var canCreateClip = function canCreateClip() {
    var cameraId = $scope.currentCamera.id;
    var startTime = getClipStartMoment().toDate().getTime();
    var endTime = getClipEndMoment().toDate().getTime();
  };
  $scope.changedZipTime = function () {
    $scope.newClip.duration = getClipDurationString();
    $scope.newClip.outputDuration = getClipDurationString($scope.newClip.playrate);
    if ($scope.newClip.playrate != "1" && !isChangedClipName) {
      $scope.newClip.name = $translate.instant("CLIP_CREATE_TIMELAPSE_NEW_NAME");
    } else if ($scope.newClip.playrate == "1" && !isChangedClipName) {
      $scope.newClip.name = $translate.instant("CLIP_CREATE_CLIP_NEW_NAME");
    }
  };

  // 클립&타임랩스 만들기
  $scope.createClip = function () {
    var startDate = getClipStartMoment().toDate();
    var endDate = getClipEndMoment().toDate();
    var startTime = getClipStartMoment().toDate().getTime();
    var endTime = getClipEndMoment().toDate().getTime();
    var startMoment = getClipStartMoment();
    var endMoment = getClipEndMoment();
    if (startDate.getMonth() < endDate.getMonth()) {} else if (startDate.getMonth() > endDate.getMonth()) {
      showAlert($translate.instant("CLIPS_ERR_DATE_SUBJECT"), $translate.instant("CLIPS_ERR_DATE_CONTENT"));
      return;
    } else {
      if (startDate.getDate() > endDate.getDate()) {
        showAlert($translate.instant("CLIPS_ERR_DATE_SUBJECT"), $translate.instant("CLIPS_ERR_DATE_CONTENT"));
        return;
      }
    }
    if (startTime > endTime) {
      showAlert($translate.instant("CLIPS_ERR_TIME_SUBJECT"), $translate.instant("CLIPS_ERR_TIME_CONTENT"));
      return;
    } else if (startTime == endTime) {
      showAlert($translate.instant("CLIPS_ERR_TIME_SUBJECT"), $translate.instant("CLIPS_ERR_TIME_CONTENT"));
      return;
    }
    if (endMoment - startMoment < 5 * 1000 || endMoment - startMoment > 2 * 60 * 60 * 1000) {
      showAlert($translate.instant("CLIPS_ERR_TIME_SUBJECT"), $translate.instant("CAMERA_5SEC_120MIN_CLIP"));
      return;
    }
    if (endMoment > moment()) {
      showAlert($translate.instant("CLIPS_ERR_TIME_SUBJECT"), $translate.instant("CAMERA_END_TIME_AHEAD"));
      return;
    }
    var usageTotTime = $scope.config.usageTotTime; // 클립 총 사용시간
    var usageTime = $scope.config.usageTime; // 클립 현재 사용시간
    var createTime = endMoment - startMoment; // 생성하려는 클립 시간
    if (usageTotTime < usageTime + createTime) {
      showAlert($translate.instant("CAMERA_CLIP_FULL"), $translate.instant("CAMERA_CLIP_FULL_DESC"));
      return;
    }
    var clipType;
    if ($scope.newClip.playrate == "1" && !$scope.newClip.isSmart) {
      clipsType = "0";
    } else if ($scope.newClip.isSmart) {
      clipsType = "2";
    } else {
      clipsType = "1";
    }
    var params = {
      cameraId: $scope.currentCamera.id,
      labelName: $scope.newClip.name,
      start: getClipStartMoment().toDate().getTime(),
      end: getClipEndMoment().toDate().getTime(),
      timeOverlay: $scope.newClip.timeOverlay,
      speedx: $scope.newClip.playrate,
      type: clipsType
    };
    $scope.isShowCreateClip = false;
    Clip.save(params, function (data) {
      if (data.code === "ok") {
        showAlert($translate.instant("MENU_CLIP"), $translate.instant("CLIPS_MAKE"));
      } else if (data.code === "nok" && data.ableTime !== undefined) {
        showAlert($translate.instant("CAMERA_CLIP_FULL"), $translate.instant("CAMERA_CLIP_FULL_DESC"));
      } else {
        showAlert($translate.instant("MENU_CLIP"), $translate.instant("CLIPS_MAKE_CANNOT"));
      }
    }, function (err) {
      showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
    });
  };
  $scope.moveTimeline = function () {
    $scope.checkCVRSeucre(function (isSecureMode) {
      if (isSecureMode) {
        $scope.play.securePassword = "";
        $scope.isShowCVRPlayPasswordConfirm = !$scope.isShowCVRPlayPasswordConfirm;
        $scope.cvrPasswordSuccess = function () {
          $scope.goCvr(getTimelineMoment().toDate());
          $scope.isShowTimelineCalendar = false;
        };
      } else {
        $scope.goCvr(getTimelineMoment().toDate());
        $scope.isShowTimelineCalendar = false;
      }
    });
  };

  // 이전 이벤트 리스트 목록
  $scope.prevEventList = function (idx) {
    $scope.eventListDateIndex++;
    if ($scope.eventListDateIndex >= $scope.eventListDate.length) {
      $scope.eventListDateIndex = $scope.eventListDate.length - 1;
      return;
    }
    $scope.pressedEventListDateButton($scope.eventListDateIndex);
    $scope.initFlags();
  };

  // 다음 이벤트 리스트 목록
  $scope.nextEventList = function (idx) {
    if (idx == 0) {
      return;
    }
    $scope.eventListDateIndex--;
    if ($scope.eventListDateIndex < 0) {
      $scope.eventListDateIndex = 0;
      return;
    }
    $scope.pressedEventListDateButton($scope.eventListDateIndex);
    $scope.initFlags();
  };
  $scope.initFlags = function () {
    tempIndexCheck = 0;
    $scope.pressedEventListTimeButtonFlag = false;
  };
  $scope.goCameraManager = function () {
    location.href = "/#/settings/product";
  };
  $scope.resizePlayer = function () {
    // $(".player_off_black").css("height",$("#player").css("height"));
  };
  $scope.alarmSetHide = function () {
    if ($("#alarm_set_no").is(":checked") == true) {
      $scope.setCookie("alarm_set_no", "alarm_set_no");
    }
    $("#alarm_set").remove();
  };
  $scope.cameraManage = function () {
    location.href = "/#/settings/product";
  };
  $scope.setCookie = function (cName, cValue, expireDate) {
    var expire = new Date();
    if (expireDate == "" || expireDate == undefined) {
      expire.setDate(expire.getDate() + 7);
    } else {
      expire.setDate(expire.getDate() + expireDate);
    }
    cookies = cName + "=" + escape(cValue) + "; path=/ "; //쿠키 저장
    cookies += ";expires=" + expire.toGMTString() + ";";
    document.cookie = cookies;
  };
  $scope.getCookie = function (cName) {
    cName = cName + "=";
    var cookieData = document.cookie;
    var start = cookieData.indexOf(cName);
    var cValue = "";
    if (start != -1) {
      start += cName.length;
      var end = cookieData.indexOf(";", start);
      if (end == -1) end = cookieData.length;
      cValue = cookieData.substring(start, end);
    }
    return unescape(cValue);
  };
  $scope.logout = function () {
    User.logout(function (data) {
      logoutSuccess();
    });
  };
  $scope.checkCVRSeucre = function (callback) {
    if ($scope.shareStatus == true) {
      CameraConfig.getSharedConfig({
        id: $stateParams.cameraId
      }, function (data) {
        if (data.secureMode == "on") {
          $scope.stopTimer();
          var passCVRSecure = sessionStorage.getItem("passCVRSecureCameraIds");
          if (passCVRSecure == null || passCVRSecure === "undefined") {
            callback(true);
          } else {
            if (passCVRSecure.indexOf($stateParams.cameraId) > -1) {
              callback(false);
            } else {
              callback(true);
            }
          }
        } else {
          callback(false);
        }
      }, function (err) {
        location.href = "/error";
      });
    } else {
      CameraConfig.get({
        id: $stateParams.cameraId
      }, function (data) {
        if (data.secureMode == "on") {
          $scope.stopTimer();
          var passCVRSecure = sessionStorage.getItem("passCVRSecureCameraIds");
          if (passCVRSecure == null || passCVRSecure === "undefined") {
            callback(true);
          } else {
            if (passCVRSecure.indexOf($stateParams.cameraId) > -1) {
              callback(false);
            } else {
              callback(true);
            }
          }
        } else {
          callback(false);
        }
      }, function (err) {
        location.href = "/error";
      });
    }
  };
  $scope.cancelCVRPlay = function () {
    if ($scope.isLive) {
      $scope.cursorOn = false;
      $scope.goLive();
    }
  };
  var currentPrevTime = 1;
  $scope.goPrevEvent = function () {
    var callbackFunc = function callbackFunc() {
      var currentTime = parseInt($scope.currentTime.valueOf());
      var prevTime = 0;
      arrEvents.filter(function (obj) {
        var allFilteredZoneIds = $scope.getAllFilteredZonesIds(obj.eventTps.split(","));
        var isCheckFilter = _.intersection(allFilteredZoneIds, obj.eventTps.split(",")).length;
        if (isCheckFilter > 0) {
          var startTime = parseInt(obj.startTime);
          if (startTime < currentTime && startTime > prevTime && startTime < currentTime - 5 * 1000) {
            prevTime = startTime;
          }
        }
      });
      if (prevTime != 0) {
        currentPrevTime = prevTime;
        //cursorEventEndTime = nextTime;
        $scope.goCvr(prevTime);
      } else {
        var regDate = $scope.currentCamera.regDate;
        var serviceDateTime = new Date().valueOf() - 1000 * 60 * 60 * 24 * ($scope.serviceDay - 1);
        var serviceStartDate = regDate > serviceDateTime ? regDate : serviceDateTime;
        var goPrevEvent = function goPrevEvent(queryTime) {
          var allFilteredZoneIds = $scope.getAllFilteredZonesIds();
          Pos.getFindEventGroup({
            shopId: $stateParams.id,
            posId: $scope.selectPosVal,
            direction: "previous",
            scale: $scope.nowScale,
            queryTime: queryTime,
            range: 7,
            eventTps: allFilteredZoneIds.join(",")
          }, function (data) {
            if (data.eventGroup.startTime !== undefined && data.eventGroup.startTime > serviceStartDate) {
              // 이벤트가 있다면 이동
              var allFilteredZoneIds = $scope.getAllFilteredZonesIds(data.eventGroup.eventTps.split(","));
              var isCheckFilter = _.intersection(allFilteredZoneIds, data.eventGroup.eventTps.split(",")).length;
              if (isCheckFilter > 0) {
                $scope.goCvr(parseInt(data.eventGroup.startTime));
              } else {
                goPrevEvent(queryTime - 1000 * 60 * 60 * 24 * 2);
              }
            } else if (data.startTime === undefined && serviceStartDate < queryTime - 1000 * 60 * 60 * 24 * 2) {
              // 서비스 기간내인데 range내에 이벤트가 없으면 2일전으로 재검색
              goPrevEvent(queryTime - 1000 * 60 * 60 * 24 * 2);
            } else {
              showAlert($translate.instant("CAMERA_EVENT_MOVE"), $translate.instant("CAMERA_NO_PREV_EVENT"));
            }
          }, function (err) {
            location.href = "/error";
          });
        };
        goPrevEvent($scope.currentTime.valueOf());
      }
    };
    $scope.checkCVRSeucre(function (isSecureMode) {
      if (isSecureMode) {
        if (document.msFullscreenElement) {
          $scope.pressedExitFullScreenButton();
        }
        $scope.play.securePassword = "";
        $scope.isShowCVRPlayPasswordConfirm = !$scope.isShowCVRPlayPasswordConfirm;
        $scope.cvrPasswordSuccess = callbackFunc;
      } else {
        callbackFunc();
      }
    });
  };

  // var goNextTimeout = 0;
  $scope.goNextEvent = function () {
    var callbackFunc = function callbackFunc() {
      // $timeout.cancel(goNextTimeout);
      // $interval.cancel($scope.timer);
      var currentTime = parseInt($scope.currentTime.valueOf());
      var nextTime = 0;
      arrEvents.filter(function (obj) {
        var allFilteredZoneIds = $scope.getAllFilteredZonesIds(obj.eventTps.split(","));
        var isCheckFilter = _.intersection(allFilteredZoneIds, obj.eventTps.split(",")).length;
        if (isCheckFilter > 0) {
          var startTime = parseInt(obj.startTime);
          if (startTime > currentTime && (startTime < nextTime && nextTime != 0 || startTime > nextTime && nextTime == 0)) {
            nextTime = startTime;
          }
        }
      });
      if (nextTime != 0) {
        //cursorEventEndTime = nextTime;
        $scope.goCvr(nextTime);
        // $scope.clickedCVRArea(new Date(nextTime));
        // }, 300);
      } else {
        var goNextEvent = function goNextEvent(queryTime) {
          var allFilteredZoneIds = $scope.getAllFilteredZonesIds();
          Pos.getFindEventGroup({
            shopId: $stateParams.id,
            posId: $scope.selectPosVal,
            direction: "next",
            scale: $scope.nowScale,
            queryTime: queryTime,
            range: 7,
            eventTps: allFilteredZoneIds.join(",")
          }, function (data) {
            var nowDate = Date.now();
            if (data.eventGroup.startTime !== undefined) {
              var allFilteredZoneIds = $scope.getAllFilteredZonesIds(data.eventGroup.eventTps.split(","));
              var isCheckFilter = _.intersection(allFilteredZoneIds, data.eventGroup.eventTps.split(",")).length;
              if (isCheckFilter > 0) {
                $scope.goCvr(parseInt(data.eventGroup.startTime));
              } else {
                goNextEvent(queryTime + 1000 * 60 * 60 * 24 * 2);
              }
            } else if (data.eventGroup.startTime === undefined && nowDate > queryTime + 1000 * 60 * 60 * 24 * 2) {
              goNextEvent(queryTime + 1000 * 60 * 60 * 24 * 2);
            } else {
              showAlert($translate.instant("CAMERA_EVENT_MOVE"), $translate.instant("CAMERA_NO_NEXT_EVENT"));
            }
          }, function (err) {
            location.href = "/error";
          });
        };
        goNextEvent($scope.currentTime.valueOf());
      }
    };
    $scope.checkCVRSeucre(function (isSecureMode) {
      if (isSecureMode) {
        if (document.msFullscreenElement) {
          $scope.pressedExitFullScreenButton();
        }
        $scope.play.securePassword = "";
        $scope.isShowCVRPlayPasswordConfirm = !$scope.isShowCVRPlayPasswordConfirm;
        $scope.cvrPasswordSuccess = callbackFunc;
      } else {
        callbackFunc();
      }
    });
  };

  // 이벤트 공유 팝업 open
  var eventClipStartTime = 0;
  var eventClipEndTime = 0;
  var eventClipCameraId = "";
  $scope.showEventShareInfoLayer = function () {
    if ($scope.shareStatus == true) {
      showAlert($translate.instant("POS_MANAGE"), $translate.instant("ACCESS_SHARED_MARKET_DESC"));
      return;
    }
    eventClipStartTime = moment($scope.currentEventInfo.start, "x").subtract(30, "seconds").format("x");
    eventClipEndTime = moment($scope.currentEventInfo.start, "x").add(30, "seconds").format("x");
    var getCameraId = _.find($scope.posList, {
      posId: $scope.currentEventInfo.posId
    });
    eventClipCameraId = getCameraId.cameraId;
    $scope.isShowEventShareInfoLayer = true;
  };

  // 이벤트 공유 팝업 close
  $scope.hideEventShareInfoLayer = function () {
    $scope.isShowEventShareInfoLayer = false;
  };

  // 이벤트 클립 생성
  $scope.createEventClip = function () {
    if (eventClipStartTime > eventClipEndTime) {
      showAlert($translate.instant("CLIPS_ERR_TIME_SUBJECT"), $translate.instant("CLIPS_ERR_TIME_CONTENT"));
      return;
    } else if (eventClipStartTime == eventClipEndTime) {
      showAlert($translate.instant("CLIPS_ERR_TIME_SUBJECT"), $translate.instant("CLIPS_ERR_TIME_CONTENT"));
      return;
    }
    if (eventClipEndTime - eventClipStartTime < 5 * 1000 || eventClipEndTime - eventClipStartTime > 2 * 60 * 60 * 1000) {
      showAlert($translate.instant("CLIPS_ERR_TIME_SUBJECT"), $translate.instant("CAMERA_5SEC_120MIN_CLIP"));
      return;
    }
    var usageTotTime = $scope.config.usageTotTime; // 클립 총 사용시간
    var usageTime = $scope.config.usageTime; // 클립 현재 사용시간
    var createTime = eventClipEndTime - eventClipStartTime; // 생성하려는 클립 시간
    if (usageTotTime < usageTime + createTime) {
      showAlert($translate.instant("CAMERA_CLIP_FULL"), $translate.instant("CAMERA_CLIP_FULL_DESC"));
      return;
    }
    var params = {
      cameraId: eventClipCameraId,
      labelName: $translate.instant("CLIP_CREATE_CLIP_NEW_NAME"),
      start: eventClipStartTime,
      end: eventClipEndTime,
      timeOverlay: "NO",
      speedx: "1",
      type: "0"
    };
    Clip.save(params, function (data) {
      if (data.code === "ok") {
        showAlert($translate.instant("MENU_CLIP"), $translate.instant("CLIPS_MAKE"));
        $scope.isShowEventShareInfoLayer = false;
      } else if (data.code === "nok" && data.ableTime !== undefined) {
        showAlert($translate.instant("CAMERA_CLIP_FULL"), $translate.instant("CAMERA_CLIP_FULL_DESC"));
      } else {
        showAlert($translate.instant("MENU_CLIP"), $translate.instant("CLIPS_MAKE_CANNOT"));
      }
    }, function (err) {
      showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
    });
  };

  // 풀스크린 상태이고 타임라인 숨김상태일 때 마우스오버 이벤트 함수
  $scope.showTimeline = function () {
    if (isFullScreen()) {
      $scope.isToggleOn = true;
      $scope.isShowControlArea = false;
      isClickTimelineShow = false;
      $timeout.cancel(timelineHideTimer);
    }
  };

  // 풀스크린 적용시 타임라인 컨트롤바에서 mouseleave 이벤트 발생시 5초후 타임라인 숨김 처리
  $scope.hideTimeline = function () {
    if (isFullScreen() && !isClickTimelineShow) {
      timelineHideTimer = $timeout(function () {
        $scope.isShowControlArea = true; // fullscreen 타임라인 숨김인 경우 mouseover 영역 표시
        $scope.isShowTimelineCalendar = false;
        $scope.isToggleOn = false;
      }, 5000);
    }
  };

  // 풀스크린 상태이고 타임라인에 마우스오버 상태인 경우 타임라인 숨김 timeout을 취소
  $scope.cancelTimelineHide = function () {
    if (isFullScreen()) {
      $timeout.cancel(timelineHideTimer);
    }
  };
  var isClickTimelineShow = false; //클릭 이벤트로 타임라인 표시할 경우 timeout 적용되지 않도록하기 위한 flag
  // 풀스크린 상태일경우 타임라인 토글 이벤트 함수
  $scope.toggleTimeline = function () {
    $scope.isToggleOn = !$scope.isToggleOn;
    if ($scope.isToggleOn) {
      $scope.isShowControlArea = false;
    } else {
      $scope.isShowTimelineCalendar = false;
      $scope.isShowControlArea = true;
    }
    isClickTimelineShow = true;
    $timeout.cancel(timelineHideTimer);
  };

  // control button 숨김 timer 취소
  $scope.cancelHideButtonTimer = function () {
    if (!isFullScreen()) {
      $timeout.cancel(controlAreaHideTimer);
    }
  };

  // 카메라 상태변경
  var isChangeStreamStatusFlag = false;
  $scope.toggleCameraStatus = function () {
    $scope.isShowCameraOffConfirmLayer = false;
    $scope.isShowCameraOnConfirmLayer = false;
    if ($scope.shareDisable()) return;
    if (isChangeStreamStatusFlag) return;
    isChangeStreamStatusFlag = true;
    var paramStreamStatus = $scope.config.streamStatus === "on" ? "off" : "on";
    CameraConfig.update({
      id: $stateParams.cameraId
    }, {
      streamStatus: paramStreamStatus
    }, function (data) {
      if (data.code == "ok") {
        $scope.config.streamStatus = paramStreamStatus;
        if ($scope.config.streamStatus == "off") {
          $scope.cameraRecOff();
        } else {
          $scope.cameraStatusAllOff();
          $scope.livePlay("changeRec");
        }
      } else {
        showAlert($translate.instant("CAMERA_SETTING_POWER"), $translate.instant("CAMERA_RECORD_SET_CHANGE_FAIL"));
      }
      isChangeStreamStatusFlag = false;
    }, function (err) {
      isChangeStreamStatusFlag = false;
      showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
    });
  };

  // 토스트 마켓 상품 상세 페이지 이동
  $scope.goMaket = function () {
    $window.location.href = $rootScope.ENV_VARS.marketUrl + "/product/CAM/" + $rootScope.ENV_VARS.marketDealNo + "?itemSerial=" + $scope.currentCamera.id;
  };

  // 구매 확인 레이어 팝업 호출
  $scope.showPurchaseConfirmLayer = function () {
    // ie에서 풀스크린상태일 경우 레이어 팝업이 보이지 않는 문제로.. 풀스크린 해제
    if (document.msFullscreenElement) {
      $scope.pressedExitFullScreenButton();
    }
    $scope.isShowPurchaseConfirmLayer = true;
  };

  // 구매 확인 레이어 팝업 닫기
  $scope.hidePurchageConfirmLayer = function () {
    $scope.isShowPurchaseConfirmLayer = false;
  };

  // 서비스 해지 확인 레이어 팝업 호출
  $scope.showRefundConfirmLayer = function () {
    $scope.isShowRefundConfirmLayer = true;
  };

  // 서비스 해지 확인 레이어 팝업 닫기
  $scope.hideRefundConfirmLayer = function () {
    $scope.isShowRefundConfirmLayer = false;
  };

  // 토스트마켓 서비스 해지 페이지 이동
  $scope.goMarketRefund = function () {
    $window.location.href = $rootScope.ENV_VARS.marketUrl + "/usage";
  };

  // 카메라 이름 변경 취소
  $scope.cancelCameraNameChange = function () {
    $scope.config.name = $scope.currentCamera.labelName;
    $scope.isEditingCameraName = false;
  };

  // 카메라 off 확인 레이어 팝업 닫기
  $scope.hideCameraOffConfirmLayer = function () {
    $scope.isShowCameraOffConfirmLayer = false;
  };

  // 카메라 on 확인 레이어 팝업 닫기
  $scope.hideCameraOnConfirmLayer = function () {
    $scope.isShowCameraOnConfirmLayer = false;
  };

  // 카메라 on / off 확인 레이어 팝업 열기
  $scope.showCameraOnOffConfirmLayer = function () {
    if ($scope.config.streamStatus == "off") {
      $scope.isShowCameraOnConfirmLayer = true;
      $scope.isShowCameraOffConfirmLayer = false;
    } else {
      $scope.isShowCameraOffConfirmLayer = true;
      $scope.isShowCameraOnConfirmLayer = false;
    }
  };
  $scope.getDateIndex = function (date) {
    for (i = 0; i < $scope.eventListDate.length; i++) {
      if ($scope.eventListDate[i].date == date) {
        $scope.selectedEventDateIndex = i;
        return i;
      }
    }
  };
  $scope.initFilterMarkFlag = true;
  /**
   * 이벤트 존 ajax 호출 및 필터 on / off 셋팅
   * @return {Promise}
   */
  var getEventTypeList = function getEventTypeList() {
    var deferred = $q.defer();
    Pos.getEventType({
      shopId: $stateParams.id,
      posId: $stateParams.posId
    }, function (res) {
      $scope.eventGroup_pay = [];
      $scope.eventGroup_cancel = [];
      $scope.eventGroup_pos = [];
      $scope.eventGroup_open_close = [];
      $scope.eventTypeList = [];
      $scope.eventTypeList = res.eventCodes;
      if ($scope.initFilterMarkFlag) {
        for (i = 0; i < $scope.eventTypeList.length; i++) {
          if ($stateParams.filters && $stateParams.filters != "") {
            $scope.eventTypeList[i].filterMark = "off";
          } else {
            $scope.eventTypeList[i].filterMark = "on";
          }
        }
        $scope.initFilterMarkFlag = false;
      }
      if ($stateParams.filters && $stateParams.filters != "") {
        var filterList = $stateParams.filters.split(",");
        for (i = 0; i < filterList.length; i++) {
          var checkedFilter = _.find($scope.eventTypeList, {
            posEventCodeId: filterList[i]
          });
          if (checkedFilter) {
            checkedFilter.filterMark = "on";
          }
        }
      }
      var eventGroupTemp = {};
      eventGroupTemp = $scope.eventTypeList.filter(function (value) {
        return value.posEventCodeId == "1";
      })[0];
      if (eventGroupTemp) {
        $scope.eventGroup_pay.push(eventGroupTemp);
      }
      eventGroupTemp = $scope.eventTypeList.filter(function (value) {
        return value.posEventCodeId == "102";
      })[0];
      if (eventGroupTemp) {
        $scope.eventGroup_pay.push(eventGroupTemp);
      }
      eventGroupTemp = $scope.eventTypeList.filter(function (value) {
        return value.posEventCodeId == "101";
      })[0];
      if (eventGroupTemp) {
        $scope.eventGroup_cancel.push(eventGroupTemp);
      }
      eventGroupTemp = $scope.eventTypeList.filter(function (value) {
        return value.posEventCodeId == "103";
      })[0];
      if (eventGroupTemp) {
        $scope.eventGroup_cancel.push(eventGroupTemp);
      }
      eventGroupTemp = $scope.eventTypeList.filter(function (value) {
        return value.posEventCodeId == "104";
      })[0];
      if (eventGroupTemp) {
        $scope.eventGroup_cancel.push(eventGroupTemp);
      }
      eventGroupTemp = $scope.eventTypeList.filter(function (value) {
        return value.posEventCodeId == "105";
      })[0];
      if (eventGroupTemp) {
        $scope.eventGroup_cancel.push(eventGroupTemp);
      }
      eventGroupTemp = $scope.eventTypeList.filter(function (value) {
        return value.posEventCodeId == "201";
      })[0];
      if (eventGroupTemp) {
        $scope.eventGroup_pos.push(eventGroupTemp);
      }
      eventGroupTemp = $scope.eventTypeList.filter(function (value) {
        return value.posEventCodeId == "202";
      })[0];
      if (eventGroupTemp) {
        $scope.eventGroup_pos.push(eventGroupTemp);
      }
      eventGroupTemp = $scope.eventTypeList.filter(function (value) {
        return value.posEventCodeId == "205";
      })[0];
      if (eventGroupTemp) {
        $scope.eventGroup_pos.push(eventGroupTemp);
      }
      eventGroupTemp = $scope.eventTypeList.filter(function (value) {
        return value.posEventCodeId == "203";
      })[0];
      if (eventGroupTemp) {
        $scope.eventGroup_open_close.push(eventGroupTemp);
      }
      eventGroupTemp = $scope.eventTypeList.filter(function (value) {
        return value.posEventCodeId == "204";
      })[0];
      if (eventGroupTemp) {
        $scope.eventGroup_open_close.push(eventGroupTemp);
      }
      if ($stateParams.date && $stateParams.date != "") {
        $scope.searchDate = moment($stateParams.date, "YYYYMMDD");
        $scope.eventListFlag = false;
        $("#date_today").attr("checked", true);
      } else {
        $scope.searchDate = moment();
        $scope.eventListFlag = true;
        $("#date_time").attr("checked", true);
      }
      if (moment($scope.searchDate).format("YYYYMMDD") != moment().format("YYYYMMDD")) {
        $scope.isToday = false;
      } else {
        $scope.isToday = true;
      }
      $scope.startLiveTimer();
      $scope.toggleEventFilter("all");
      if ($scope.eventListFlag) {
        setTimeout(function () {
          $("#timelinedesc").fadeIn(2500, function () {
            $("#timelinedesc").fadeOut(2000);
          });
        }, 2000);
        $scope.initpressedEventListDateButton();
      } else {
        $scope.pressedEventListDateButton(0);
      }
      var serviceMinDay = new Date().valueOf() - 1000 * 60 * 60 * 24 * ($scope.serviceDay - 1);
      $scope.datePicker = new Pikaday({
        field: document.getElementById("searchDate"),
        bound: false,
        container: document.getElementById("datePickerContainer"),
        // minDate: moment(serviceMinDay).toDate(),
        maxDate: new Date(),
        defaultDate: new Date(),
        onSelect: function onSelect(date) {
          $scope.$apply(function () {
            $scope.changeDate(0, date);
          });
          this.hide();
        }
      });
      $scope.datePicker.hide();
      deferred.resolve();
    }, function (err) {
      showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
      deferred.reject();
    });
    return deferred.promise;
  };

  /**
   * 이벤트 필터 체크 변경시 호출 함수
   * @param  {String} zoneId
   * @param  {String} eventType motion/sound/access
   */
  $scope.toggleEventFilter = function (eventType) {
    if (eventType === "pay") {
      // 선택여부에 따른 전체 선택 체크박스 체크 처리
      $scope.eventGroup_pay_all = !_.includes(_.map($scope.eventGroup_pay, "filterMark"), "off");
    } else if (eventType === "cancel") {
      $scope.eventGroup_cancel_all = !_.includes(_.map($scope.eventGroup_cancel, "filterMark"), "off");
    } else if (eventType === "pos") {
      $scope.eventGroup_pos_all = !_.includes(_.map($scope.eventGroup_pos, "filterMark"), "off");
    } else if (eventType === "open_close") {
      $scope.eventGroup_openClose_all = !_.includes(_.map($scope.eventGroup_open_close, "filterMark"), "off");
    } else {
      $scope.eventGroup_pay_all = !_.includes(_.map($scope.eventGroup_pay, "filterMark"), "off");
      $scope.eventGroup_cancel_all = !_.includes(_.map($scope.eventGroup_cancel, "filterMark"), "off");
      $scope.eventGroup_pos_all = !_.includes(_.map($scope.eventGroup_pos, "filterMark"), "off");
      $scope.eventGroup_openClose_all = !_.includes(_.map($scope.eventGroup_open_close, "filterMark"), "off");
    }
    if (eventType != "all") {
      $scope.timeline.redrawEvents($scope.events); //타임라인 이벤트 그리기
      if ($scope.eventListFlag) {
        if ($scope.isLive) {
          $scope.initpressedEventListDateButton();
        } else {
          cursorEventFlag = true;
          cursorEventEndTime = 0;
          $scope.getCurrentCursorEventList();
        }
      } else {
        $scope.pressedEventListDateButton($scope.selectedEventDateIndex);
      }
    }
  };

  /**
   * 필터 전체 선택 check toggle 함수
   */
  $scope.eventGroup_pay_all = false;
  $scope.eventGroup_cancel_all = false;
  $scope.eventGroup_pos_all = false;
  $scope.eventGroup_openClose_all = false;
  $scope.toggleAllMotionFilter = function (type) {
    if (type == "pay") {
      angular.forEach($scope.eventGroup_pay, function (obj) {
        if ($scope.eventGroup_pay_all) {
          obj.filterMark = "on";
        } else {
          obj.filterMark = "off";
        }
      });
    } else if (type == "cancel") {
      angular.forEach($scope.eventGroup_cancel, function (obj) {
        if ($scope.eventGroup_cancel_all) {
          obj.filterMark = "on";
        } else {
          obj.filterMark = "off";
        }
      });
    } else if (type == "pos") {
      angular.forEach($scope.eventGroup_pos, function (obj) {
        if ($scope.eventGroup_pos_all) {
          obj.filterMark = "on";
        } else {
          obj.filterMark = "off";
        }
      });
    } else {
      angular.forEach($scope.eventGroup_open_close, function (obj) {
        if ($scope.eventGroup_openClose_all) {
          obj.filterMark = "on";
        } else {
          obj.filterMark = "off";
        }
      });
    }
    $scope.timeline.redrawEvents($scope.events); //타임라인 이벤트 그리기
    if ($scope.eventListFlag) {
      if ($scope.isLive) {
        $scope.initpressedEventListDateButton();
      } else {
        cursorEventFlag = true;
        cursorEventEndTime = 0;
        $scope.getCurrentCursorEventList();
      }
    } else {
      $scope.pressedEventListDateButton($scope.selectedEventDateIndex);
    }
  };

  /**
   * 공유받은 카메라가 아닌 경우 이벤트 필터 저장 ajax 호출 처리 및
   * 타임라인 이벤트 그리기, 이벤트 리스트 필터링 및 섬네일 필터링 함수 호출
   */
  var saveFilter = function saveFilter() {
    var zoneData = _.concat($scope.eventTypeList, $scope.motionZones);
    var params = {
      zoneIndex: _.map(zoneData, "id").join(","),
      filterMark: _.map(zoneData, "filterMark").join(",")
    };
    Camera.updateAlarmZonesFiltersOnOff({
      cameraId: $scope.currentCamera.id
    }, params, function (res) {
      // success
    }, function (err) {
      showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
    });
  };

  /**
   * 이벤트 리스트 목록의 상세 모션별 아이콘
   * @param {Number} zoneId
   * @return {Bolean} check 여부
   */
  $scope.showEventIcons = function (zoneId) {
    var allEventZones = _.map(_.filter(_.concat($scope.eventTypeList, $scope.motionZones), ["filterMark", "on"]), "id");
    return allEventZones.indexOf(zoneId.toString()) > -1;
  };

  /**
   * 이벤트 목록의  썸네일 중 필터체크 된 이벤트가 없을 경우 썸네일 숨김
   * @param  {[type]} eventData [description]
   * @return {[type]}           [description]
   */
  $scope.isShowEventThumbnail = function (eventData) {
    var allFilteredZoneIds = $scope.getAllFilteredZonesIds(eventData.zoneUidxs.split(","));
    return _.intersection(eventData.zoneUidxs.split(","), allFilteredZoneIds).length > 0;
  };

  /**
   * 비교할 zone data로 삭제된 이벤트를 포함
   * @param  {Array} zoneData
   * @return {Array} allFilteredZoneIdsArr 체크 처리된 zone id array. 모션존은 uid
   */
  $scope.getAllFilteredZonesIds = function (zoneData) {
    // 현재 이벤트 data의 zoneIdxs중 check 된 zoneIndex 여부 확인
    var filteredEventZoneIdsArr = _.map(_.filter($scope.eventTypeList, ["filterMark", "on"]), "posEventCodeId");
    if (filteredEventZoneIdsArr.length == 0) {
      filteredEventZoneIdsArr.push(0);
    }
    return filteredEventZoneIdsArr;
  };
  $scope.getShopPosList = function (init) {
    var promise;
    if ($stateParams.type === "shop" && typeof $stateParams.id !== "undefined") {
      promise = Shop.getShopV2({
        shopId: $stateParams.id
      }).$promise;
    } else if ($stateParams.type === "sharedshop" && typeof $stateParams.id !== "undefined") {
      promise = Shop.getSharedShopV2({
        shopId: $stateParams.id
      }).$promise;
    }
    $scope.selectCameraId = $stateParams.cameraId;
    var promise2 = Pos.getShopPosList({
      shopId: $stateParams.id
    }).$promise;
    $q.all([promise, promise2]).then(function (res) {
      $scope.currentShop = res[0];
      if ($stateParams.type === "shop" || $stateParams.type === "sharedshop") {
        $scope.cameraList = _.map(_.filter(res[0].controllerList, ["deviceType", "CAMERA"]), "cameraInfo");
      } else {
        $scope.cameraList = res[0].cameras;
      }
      $scope.posList = res[1].posLit;
      $scope.posCameraList = [];
      var filterPosCamera;
      for (i = 0; i < $scope.posList.length; i++) {
        if ($scope.cameraList.length > 0) {
          filterPosCamera = {};
          temp = _.find($scope.cameraList, {
            id: $scope.posList[i].cameraId
          });
          if (temp) {
            filterPosCamera["posId"] = $scope.posList[i].posId;
            filterPosCamera["posName"] = $scope.posList[i].posName;
            filterPosCamera["recorderType"] = temp.recorderType;
            filterPosCamera["id"] = temp.id;
            filterPosCamera["thumbnailPath"] = temp.thumbnailPath;
            $scope.posCameraList.push(filterPosCamera);
          }
        }
      }
      $scope.currentPosId = $stateParams.posId;
      $scope.currentPos = _.find($scope.posList, {
        posId: $stateParams.posId
      });
      $scope.selectPosVal = "";
      if (init) {
        getEventTypeList();
      } else {
        $scope.pressedEventListDateButton($scope.selectedEventDateIndex);
      }
    }, function (err) {
      showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
    });
  };
  /**
   *	페이지 로딩시 갤러리 카메라 목록 호출
   */
  (function () {
    if (typeof $stateParams.type !== "undefined") {
      $scope.getShopPosList(true);
    }
  })();
  $scope.changeSelectPosList = function () {
    var selCameraId = _.find($scope.posList, {
      posId: $scope.selectPosVal
    });
    if (selCameraId) {
      $scope.selectCameraId = selCameraId.cameraId;
    } else {
      $scope.selectCameraId = $stateParams.cameraId;
    }
    posTimelineDragCnt = 100;
    $scope.setupDomain($scope.timeline.currentDomain);
    if ($scope.eventListFlag) {
      cursorEventFlag = true;
      cursorEventEndTime = 0;
      $scope.getCurrentCursorEventList();
    } else {
      $scope.pressedEventListDateButton($scope.selectedEventDateIndex);
    }
  };
  $scope.toggleEventListRadioBtn = function (type) {
    if (type == "today") {
      $scope.eventListFlag = false;
      if (moment($scope.searchDate).format("YYYYMMDD") == moment().format("YYYYMMDD")) {
        var index = moment().format("H");
        $scope.pressedEventListDateButton(parseInt(index));
        //$scope.initEventMoveIndex(parseInt(index));
      } else {
        $scope.pressedEventListDateButton(0);
      }
    } else {
      $scope.eventListFlag = true;
      setTimeout(function () {
        $("#timelinedesc").fadeOut(2000);
      }, 2000);
    }
  };

  /**
   * 전체 화면 모드 카메라 썸네일 목록 영영 토글 처리
   */
  $scope.toggleCameraGallery = function () {
    $scope.isAddShowGalleryClass = !$scope.isAddShowGalleryClass;
  };
  $scope.moveServiceDate = function (type) {
    if (type == "prev") {
      $scope.lastIndex = $scope.lastIndex - 30;
      $scope.fristIndex = $scope.fristIndex - 30;
    } else {
      $scope.lastIndex = $scope.lastIndex + 30;
      $scope.fristIndex = $scope.fristIndex + 30;
    }
  };
  $scope.showCVRSecureModeInfoLayer = function () {
    $scope.isShowCVRSecureModeInfo = true;
  };
  $scope.showSaveAlarmSettingConfirmLayer = function () {
    Pos.saveNotifyConfig({
      shopId: $stateParams.id
    }, {
      posNotifyOn: $scope.alramSettingOnOff,
      posNotifyType: $scope.alertSettingAllAlert
    }, function (data) {
      showAlert($translate.instant("ALARM_SETTING"), $translate.instant("ACCESS_ALARM_SET_SAVE"));
      $scope.isShowPosAlramSettingLayer = false;
    }, function (err) {
      showAlert($translate.instant("ALARM_SETTING"), $translate.instant("ALARM_SETTING_SAVE_FAIL"));
    });
  };

  //매출 알림 팝업
  $scope.showPosAlramSettingLayer = function () {
    if ($scope.shareStatus == true) {
      showAlert($translate.instant("POS_MANAGE"), $translate.instant("ACCESS_SHARED_MARKET_DESC"));
      return;
    }
    Pos.getPosNotifyConfig({
      shopId: $stateParams.id
    }, function (data) {
      $scope.alramSettingOnOff = data.posNotifyOn;
      $scope.alertSettingAllAlert = data.posNotifyType;
    }, function (err) {});
    $scope.isShowPosAlramSettingLayer = true;
  };
  $scope.closePosAlramSettingLayer = function () {
    $scope.isShowPosAlramSettingLayer = false;
  };

  //포스 정보 입력 화면
  $scope.showPosInfoInputLayer = function () {
    $scope.isShowPosInfoInputLayer = true;
  };
  $scope.closePosInfoInputLayer = function () {
    $scope.isShowPosInfoInputLayer = false;
  };

  //포스 수정
  $scope.showPosEditManageLayer = function (posInfo) {
    Pos.getPosInfo({
      shopId: $stateParams.id,
      posId: posInfo.posId
    }, function (data) {
      $scope.targetPosInfo = data.pos;
      $scope.editPosName = $scope.targetPosInfo.posName;
      $scope.editPosCamera = $scope.targetPosInfo.cameraId;
    }, function (err) {});
    $scope.isShowPosEditManageLayer = true;
  };
  $scope.closePosEditManageLayer = function () {
    $scope.isShowPosEditManageLayer = false;
  };

  //포스관리 팝업
  $scope.showPosManageLayer = function () {
    if ($scope.shareStatus == true) {
      showAlert($translate.instant("POS_MANAGE"), $translate.instant("ACCESS_SHARED_MARKET_DESC"));
      return;
    }
    Pos.getShopPosList({
      shopId: $stateParams.id,
      install: "no"
    }, function (data) {
      $scope.notInstallPosList = data.posLit;
    }, function (err) {});
    $scope.isShowPosManageLayer = true;
  };
  $scope.closePosManageLayer = function () {
    $scope.isShowPosManageLayer = false;
  };
  $scope.initSaveEditPosInfo = function () {
    $scope.isShowInitSaveEditPosInfoLayer = true;
  };
  $scope.closeInitSaveEditPosInfo = function () {
    $scope.isShowInitSaveEditPosInfoLayer = false;
  };
  $scope.saveEditPosInfo = function () {
    $scope.editPosName = $("#editPosName").val();
    $scope.editPosCamera = $("#editPosCamera").val();
    Pos.updatePos({
      shopId: $stateParams.id,
      posId: $scope.targetPosInfo.posId,
      cameraId: $scope.editPosCamera
    }, {
      posName: $scope.editPosName
    }, function (data) {
      $scope.getShopPosList();
      $scope.isShowPosEditManageLayer = false;
      $scope.isShowInitSaveEditPosInfoLayer = false;
      showAlert($translate.instant("POS_CHANGE"), $translate.instant("POS_CHANGE_DESC"));
    }, function (err) {
      showAlert($translate.instant("POS_CHANGE"), $translate.instant("POS_CHANGE_FAIL"));
    });
  };
  $scope.saveCreatePosInfo = function () {
    $scope.createPosName = $("#createPosName").val();
    $scope.selectNotInstallPos = $("#selectNotInstallPos").val();
    $scope.selectPosInCamera = $("#selectPosInCamera").val();
    if ($scope.createPosName == "") {
      showAlert($translate.instant("POS_REGIST"), $translate.instant("POS_NAME_INPUT"));
      return;
    }
    if ($scope.selectNotInstallPos == "") {
      showAlert($translate.instant("POS_REGIST"), $translate.instant("POS_SELECT"));
      return;
    }
    if ($scope.selectPosInCamera == "") {
      showAlert($translate.instant("POS_REGIST"), $translate.instant("POS_CAMERA_SELECT"));
      return;
    }
    Pos.insertPos({
      shopId: $stateParams.id,
      posId: $scope.selectNotInstallPos,
      cameraId: $scope.selectPosInCamera
    }, {
      posName: $scope.createPosName
    }, function (data) {
      Pos.getShopPosList({
        shopId: $stateParams.id,
        install: "no"
      }, function (data) {
        $scope.notInstallPosList = data.posLit;
      }, function (err) {});
      $timeout(function () {
        $scope.getShopPosList();
      }, 1000);
      showAlert($translate.instant("POS_REGIST"), $translate.instant("POS_REGIST_DESC"));
    }, function (err) {
      showAlert($translate.instant("POS_REGIST"), $translate.instant("POS_REGIST_FAIL"));
    });
  };
  $scope.changeAlertSettingAllAlert = function (type) {
    $scope.alertSettingAllAlert = type;
  };
  $scope.changeAlertSettingOnOff = function (type) {
    $scope.alramSettingOnOff = type;
  };
  $scope.showPosDetailLayer = function (event, type) {
    $scope.currentEventInfo = event;
    $scope.billAreaHeight = "535px";
    if (!event.billNo || event.billNo == "") {
      if (type) {
        $scope.showPosVideoLayer();
      }
      $scope.billDetailInfo = {};
      $scope.billDetailInfo.billNo = "-";
      $scope.billDetailInfo.eventNm = event.eventNm;
      $scope.billDetailInfo.barColor = event.color;
      $scope.billDetailInfo.eventDate = moment(event.start).format("YYYY-MM-DD HH:mm:ss");
      $scope.isShowPosDetailLayer = true;
      return;
    }
    if (!event.salesTm) {
      event.salesTm = moment(event.start).format("YYYYMMDD");
    }
    Pos.getBillDetail({
      shopId: event.shopId,
      posId: event.posId,
      billNo: event.billNo,
      date: event.salesTm
    }, function (data) {
      if (data.code == "ok") {
        $scope.billDetailInfo = data.detail;
        $scope.billDetailInfo.billNo = event.billNo;
      } else {
        $scope.billDetailInfo = {};
        $scope.billDetailInfo.billNo = "-";
      }
      if (type) {
        $scope.showPosVideoLayer();
      }
      $scope.billDetailInfo.eventNm = event.eventNm;
      $scope.billDetailInfo.barColor = event.color;
      $scope.billDetailInfo.eventDate = moment(event.start).format("YYYY-MM-DD HH:mm:ss");
      $scope.isShowPosDetailLayer = true;
    }, function (err) {
      showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
    });
  };
  $scope.closePosDetailLayer = function () {
    $scope.isShowPosVideoArea = false;
    $interval.cancel($scope.vedioTimer);
    $scope.isShowPosDetailLayer = false;
    $scope.currentEventInfo = {};
  };
  $scope.goCloudPurchase = function () {
    $state.go("main.help.inquiry", {
      type: "cam_buy"
    });
  };
  $scope.setCurrentTab = function (type) {
    var allFilteredZoneIds = $scope.getAllFilteredZonesIds().join(",");
    if (type == "summary") {
      //shopId?cameraId&posId&type&filter
      $state.go("main.dashboard.pos", {
        shopId: $stateParams.id,
        cameraId: $stateParams.cameraId,
        posId: $stateParams.posId,
        type: $stateParams.type,
        filter: allFilteredZoneIds
      });
    }
  };
  var cursorEventEndTime = 0;
  var cursorEventFlag = true;
  //이벤트 리스트 날짜 이동시 이벤트 리스트 목록에 출력하는 화면 생성
  $scope.setEventDailyDataSet = function (data) {
    if ($scope.serviceDay == 0) {
      return;
    }
    for (i = 0; i < data.length; i++) {
      var posInfo = _.find($scope.posList, {
        posId: data[i].posId
      });
      data[i]["posName"] = posInfo.posName;
    }
    $scope.eventCursorLists = [];
    $scope.eventCursorLists = data;
  };
  $scope.getCurrentCursorEventList = function () {
    var time = moment($scope.currentTime).format("x");
    var time2 = moment(moment($scope.currentTime).add(3, "s")).format("x");
    if (time >= cursorEventEndTime && cursorEventFlag) {
      var params = {
        cameraId: $scope.selectCameraId,
        shopId: $stateParams.id,
        posId: $scope.selectPosVal,
        scale: $scope.nowScale,
        start: time,
        end: time2,
        eventTps: $scope.getAllFilteredZonesIds().join(",")
      };
      Pos.getPosTimeline(params, function (data) {
        if (data.events.length > 0) {
          $scope.groupIds = data.events[0].id;
          if ($scope.groupIds) {
            var params = {
              shopId: $stateParams.id,
              posId: $scope.selectPosVal,
              groupIds: $scope.groupIds,
              eventTps: $scope.getAllFilteredZonesIds().join(","),
              sortField: $scope.sortField,
              sorting: $scope.sorting
            };
            Pos.getGroupDetailPos(params, function (data) {
              if (data.events.length > 0) {
                $scope.setEventDailyDataSet(data.events);
                cursorEventEndTime = data.events[0].end;
              } else {
                $scope.groupIds = "";
                $scope.eventCursorLists = [];
                $scope.setCursorEventEndTime();
              }
            }, function (err) {});
          }
        } else {
          $scope.groupIds = "";
          $scope.eventCursorLists = [];
          $scope.setCursorEventEndTime();
        }
      }, function (err) {});
    }
  };
  $scope.setCursorEventEndTime = function () {
    var time = moment($scope.currentTime).format("x");
    var allFilteredZoneIds = $scope.getAllFilteredZonesIds();
    var currentTime = parseInt($scope.currentTime.valueOf());
    var nextTime = 0;
    var groupIds = "";
    arrEvents.filter(function (obj) {
      var allFilteredZoneIds = $scope.getAllFilteredZonesIds(obj.eventTps.split(","));
      var isCheckFilter = _.intersection(allFilteredZoneIds, obj.eventTps.split(",")).length;
      if (isCheckFilter > 0) {
        var startTime = parseInt(obj.startTime);
        if (startTime > currentTime && (startTime < nextTime && nextTime != 0 || startTime > nextTime && nextTime == 0)) {
          nextTime = startTime;
        }
      }
    });
    if (nextTime != 0) {
      cursorEventEndTime = nextTime;
    } else {
      cursorEventEndTime = 0;
      cursorEventFlag = false;
    }
  };
  $scope.initCursorEventTime = function () {
    cursorEventFlag = true;
    cursorEventEndTime = 0;
  };

  /**
   * date picker open
   */
  $scope.toggleDatePicker = function (event) {
    event.stopPropagation();
    if ($scope.datePicker.isVisible()) {
      $scope.datePicker.hide();
    } else {
      $scope.datePicker.show();
    }
  };

  /**
   * 오늘 날짜 조회로 변경
   */
  $scope.changeDate = function (index, setDate) {
    if (typeof index === "undefined") {
      $scope.searchDate = moment();
      $scope.isToday = true;
    } else {
      var validDate;
      if (setDate) {
        validDate = moment(setDate).toDate();
      } else {
        validDate = moment($scope.searchDate).add(index, "d").toDate();
      }
      $scope.searchDate = validDate;
      if (moment($scope.searchDate).format("YYYYMMDD") != moment().format("YYYYMMDD")) {
        $scope.isToday = false;
      } else {
        $scope.isToday = true;
      }
    }
    $scope.pressedEventListDateButton(0);
    $scope.goCvr($scope.searchDate);
  };
  $scope.goToday = function () {
    if ($scope.isToday) {
      return;
    }
    $scope.searchDate = Date.now();
    var index = moment().format("H");
    $scope.isToday = true;
    $scope.pressedEventListDateButton(parseInt(index));
    $scope.goCvr($scope.searchDate);
  };
  $scope.minIndex = 0;
  $scope.maxIndex = 13;
  $scope.eventMoveBtn = function (index) {
    var check = $scope.minIndex + index;
    if (check < 0) {
      return;
    }
    if (check > 15) {
      return;
    }
    $scope.minIndex = $scope.minIndex + index;
    $scope.maxIndex = $scope.maxIndex + index;
  };
  $scope.initEventMoveIndex = function (index) {
    if (index > 15) {
      index = 15;
    }
    $scope.minIndex = 0 + index;
    $scope.maxIndex = 13 + index;
  };
  $scope.initpressedEventListDateButton = function () {
    var selectedDate = moment($scope.searchDate).format("YYYYMMDD");
    var allFilteredZoneIds = $scope.getAllFilteredZonesIds();
    $scope.eventLists = {};
    Pos.getEventList({
      shopId: $stateParams.id,
      date: selectedDate,
      pageSize: 0,
      posId: $scope.selectPosVal,
      eventTps: allFilteredZoneIds.join(","),
      sortField: $scope.sortField,
      sorting: $scope.sorting
    }, function (data) {
      var dateList = [];
      var diffDate = moment().subtract("3", "hour").format("YYYYMMDDHHmm");
      for (i = 0; i < data.events.length; i++) {
        var eventDate = moment(data.events[i].start, "x").format("YYYYMMDDHHmm");
        if (eventDate > diffDate) {
          dateList.push(data.events[i]);
        }
      }
      $scope.setEventDailyDataSet(dateList);
    }, function (err) {});
  };
  $scope.initGoLive = function () {
    $scope.searchDate = moment();
    $scope.isToday = true;
    $scope.initpressedEventListDateButton();
    $scope.goLive();
  };
  $scope.vedioHeightArea = "250px";
  $scope.billAreaHeight = "535px";
  //상세 매출 영상 보기
  $scope.showPosVideoLayer = function () {
    $scope.vedioPosInfo = _.find($scope.posList, {
      posId: $scope.currentEventInfo.posId
    });
    $scope.billAreaHeight = "240px";
    $scope.videoCursorPosition = 0;
    $scope.videoDuration = "-1:00";
    $scope.clipStartTime = moment($scope.currentEventInfo.start, "x").subtract(30, "seconds").format("HH:mm:ss");
    $scope.clipEndTime = moment($scope.currentEventInfo.start, "x").add(30, "seconds").format("HH:mm:ss");
    $scope.vedioStartTime = moment($scope.currentEventInfo.start, "x").subtract(30, "seconds");
    $scope.vedioEndTime = moment($scope.currentEventInfo.start, "x").add(30, "seconds");
    $scope.playStatusObj.status = $scope.playStatusType.READY;
    $scope.playStatusObj.errorStatus = $scope.playErrorType.NONE;
    var goplayTime = moment($scope.currentEventInfo.start, "x").subtract(30, "seconds").format("x");
    $scope.goCvr(parseInt(goplayTime));
    $scope.vedioTime = $scope.vedioStartTime;
    setTimeout(function () {
      startVideoTimer();
    }, 1000);
    //$scope.isShowPosVideoLayer = true;
    $scope.isShowPosVideoArea = true;
  };
  $scope.closePosVideoLayer = function () {
    $scope.billAreaHeight = "535px";
    // $scope.isShowPosVideoLayer = false;
    $scope.isShowPosVideoArea = false;
    $interval.cancel($scope.vedioTimer);
  };
  var duration = 60;
  var barWidth = parseInt(d3.select("#videoBar").style("width"));
  var videoDrag = d3.behavior.drag().on("drag", function (e) {
    var x = d3.mouse(this)[0]; // for cursur center
    $scope.videoCursorPosition = x;
  }).on("dragstart", function () {
    $interval.cancel($scope.vedioTimer);
  }).on("dragend", function () {
    var x = d3.mouse(this)[0]; // for cursur center
    $scope.videoCursorPosition = x;
    barWidth = parseInt(d3.select("#videoBar").style("width"));
    var diffTime = Math.round(duration * ($scope.videoCursorPosition / barWidth));
    var newTime = moment($scope.vedioStartTime).add(diffTime, "seconds").format("x");
    $scope.vedioTime = moment($scope.vedioStartTime).add(diffTime, "seconds");
    $scope.goCvr(parseInt(newTime));
    setTimeout(function () {
      startVideoTimer();
    }, 1000);
  });
  d3.select("#videoCursor").call(videoDrag);
  d3.select("#videoBar").on("click", function () {
    var x = d3.mouse(this)[0]; // for cursur center
    $scope.videoCursorPosition = x;
    barWidth = parseInt(d3.select("#videoBar").style("width"));
    var diffTime = Math.round(duration * ($scope.videoCursorPosition / barWidth));
    var newTime = moment($scope.vedioStartTime).add(diffTime, "seconds").format("x");
    $scope.vedioTime = moment($scope.vedioStartTime).add(diffTime, "seconds");
    $scope.goCvr(parseInt(newTime));
  });
  var startVideoTimer = function startVideoTimer() {
    $interval.cancel($scope.vedioTimer);
    $scope.vedioTimer = $interval(function () {
      if ($scope.player.getIsPlaying()) {
        barWidth = parseInt(d3.select("#videoBar").style("width"));
        var tempCurser = $scope.videoCursorPosition + barWidth / 60;
        $scope.vedioTime = moment(moment($scope.vedioTime, "x").add(1, "seconds"));
        var endTime = $scope.vedioEndTime;
        var vidioTimeDiff = moment(endTime).diff($scope.vedioTime, "seconds");
        $scope.videoDuration = "-0:" + vidioTimeDiff;
        if (tempCurser >= barWidth) {
          tempCurser = barWidth;
        }
        $scope.videoCursorPosition = tempCurser;
        if (vidioTimeDiff == 0) {
          $scope.player.pause();
          $scope.replaceShow = true;
          $interval.cancel($scope.vedioTimer);
        }
      }
    }, 1000);
  };
  $scope.replaceShow = false;
  $scope.isPlayed = false;
  $scope.goCameraDetail = function () {
    var goTime = moment($scope.vedioStartTime).format("x");
    $state.go("main.cameraDetail", {
      cameraId: $stateParams.cameraId,
      type: $stateParams.type === "sharedshop" ? $stateParams.type : "shop",
      id: $stateParams.id,
      time: goTime,
      shared: $stateParams.type === "sharedshop"
    });
  };
  $scope.vedioPlay = function () {
    $scope.goCvr(parseInt(moment($scope.vedioTime).format("x")));
    // $interval.cancel($scope.vedioTimer);
    startVideoTimer();
    $scope.isPlayed = false;
    $scope.isShowAnimate = false;
  };
  $scope.vedioStop = function () {
    $scope.player.pause();
    $scope.isPlayed = true;
    $scope.isShowAnimate = true;
    $interval.cancel($scope.vedioTimer);
  };
  $scope.clipsReplay = function () {
    $scope.goCvr(parseInt(moment($scope.vedioStartTime).format("x")));
    $scope.vedioTime = $scope.vedioStartTime;
    $scope.videoCursorPosition = 0;
    $scope.replaceShow = false;
    startVideoTimer();
  };
  $scope.changeEventListSorting = function (type) {
    $scope.sortField = type;
    if ($scope.sorting == "desc") {
      $scope.sorting = "asc";
    } else {
      $scope.sorting = "desc";
    }
    if ($scope.eventListFlag) {
      if ($scope.isLive) {
        $scope.initpressedEventListDateButton();
      } else {
        cursorEventFlag = true;
        cursorEventEndTime = 0;
        $scope.getCurrentCursorEventList();
      }
    } else {
      $scope.pressedEventListDateButton($scope.selectedEventDateIndex);
    }
  };
  var fullscreenChangeEvent = function fullscreenChangeEvent() {
    //  커서가 bar 밖으로 나가지 않도록 보정
    if (!$scope.isFullscreenButtonClicked) {
      $scope.isFullscreenButtonClicked = false;
      setTimeout(function () {
        $scope.vedioHeightArea = "250px";
        fullscreenFlag = false;
        $scope.isShowFullscreenButton = true;
        $scope.isShowTimelineToggleArea = true;
        $scope.isToggleOn = false;
        barWidth = parseInt(d3.select("#videoBar").style("width"));
        var tempPosition = $scope.videoCursorPosition * (barWidth / fullScreenWidth);
        if (barWidth < tempPosition) {
          $scope.videoCursorPosition = barWidth;
        } else if (tempPosition < 0) {
          $scope.videoCursorPosition = 0;
        } else {
          $scope.videoCursorPosition = tempPosition;
        }
      });
    } else {
      $scope.isFullscreenButtonClicked = false;
    }
  };
  d3.select("#fullscreen").on("webkitfullscreenchange", fullscreenChangeEvent);
  d3.select("#fullscreen").on("mozfullscreenchange", fullscreenChangeEvent);
  d3.select(document).on("MSFullscreenChange", fullscreenChangeEvent);
}]);
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
app.controller("DashboardShopCtrl", ["$scope", "$rootScope", "$compile", "$window", "$filter", "$stateParams", "$timeout", "$interval", "Shop", "Device", "Access", "Camera", "$location", "$translate", "$q", "$state", "PosSummary", "Sensor", "Monitor", "AiFace", "NgUtils", "Utils", "User", "DomainUtils", ( /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2($scope, $rootScope, $compile, $window, $filter, $stateParams, $timeout, $interval, Shop, Device, Access, Camera, $location, $translate, $q, $state, PosSummary, Sensor, Monitor, AiFace, NgUtils, Utils, User, DomainUtils) {
    var isDlgAppendedInstant, iotDashboardItem, confirmedEventStorageKey, dashboardShopObj, shopListUpdateListener, isUpdateIoTConfirmed, aiIntervalId, aiFaceIntervalId, aiStatsDlg, aiGraphsDlg, tuiChart, rejectShareId, aiStatList, fetchExtraService, showAlert, appendDlg, appendDialogs, initShop, getShopControllerStatus, getLastEvtCheckTime, showShopDashboardEvent, updateIoTDevices, updateAIFaceEvent, fetchAIFaceData, updateAIData, checkAIPeopleCountDataSame, makeAIPeopleLineGraph, makeAIPeopleCountGraph, showShopDashboard, setShopObjectProperties, processShopDevices, processCamera, processShopFeatures, pushDashboardItem, updateAIDataPeriodically, fetchAIFaceDataPeriodically, processDevices, getDeviceId, getDeviceOrder, pushStaffData, fetchPosData, pushDidData, pushNotInstalledItems, checkSensorAndDoorlockExists, goPosSubPage, getConfirmedEventFromLocalStorage, setConfirmedEventToLocalStorage, checkInView, confirmIoTDevice, setWindowScrollEvent, updateDlgStyle, getNumArrayWithDayJSON, getMilSecondsWithHourMinStr, getHourMinStrWithMilSeconds, getShopAlarmConfig, setCurEditTempAlarmConf, getCameraData, setCameraAlarmOff, PUSH_UNSUPPORTED_RECORD_TYPE, PUSH_SUPPORT_RECORD_TYPES_STATUS, getPushSupportRecordTypeStatus, getCameraAlarmConfList, setCameraPushDisabled, getSecureAlarmConfig, getShopPlugAlarmConfig, getPosAlarmConfig, getShopTempAlarmConfig, deleteShareId, shopShareId, resizeHandler;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          resizeHandler = function _resizeHandler() {
            if (tuiChart) {
              var $aiGraphEl = $("#ai_people_count_graph");
              tuiChart.resize({
                width: $aiGraphEl.width() - 70,
                height: 400
              });
            }
            if ($scope.aiFaceDashboardEvent) {
              updateAIFaceEvent();
            }
          };
          getShopTempAlarmConfig = function _getShopTempAlarmConf() {
            Shop.getShopTempAlarmConfig({
              shopId: $scope.shopObject.shopId
            }, function (res) {
              $scope.shopTempAlarmData = _.find(res.configList, {
                type: "shop"
              });
              $scope.shopTempAlarmConfigList = _.filter(res.configList, {
                type: "sensor"
              });
            }, function (err) {
              showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
            });
          };
          getPosAlarmConfig = function _getPosAlarmConfig() {
            Shop.getShopPosAlarmConfig({
              shopId: $scope.shopObject.shopId
            }, function (res) {
              $scope.posAlarmConfig = {
                posNotifyOn: res.posNotifyOn,
                //on/off
                posNotifyType: res.posNotifyType //all/alert
              };
            }, function (err) {
              showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
            });
          };
          getShopPlugAlarmConfig = function _getShopPlugAlarmConf() {
            $scope.shopPlugAlarmConfigList = [];
            Shop.getShopPlugAlarmConfig({
              shopId: $scope.shopObject.shopId
            }, function (res) {
              if (res.configList) {
                $scope.shopPlugAlarmConfData = _.find(res.configList, {
                  type: "shop"
                });
                $scope.shopPlugAlarmConfigList = _.filter(res.configList, {
                  type: "sensor"
                });
              }
            }, function (err) {
              showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
            });
          };
          getSecureAlarmConfig = function _getSecureAlarmConfig() {
            $scope.sensorAlarmConfList = [];
            $scope.doorlockAlarmConfList = [];
            $scope.cameraAlarmConfList = [];
            Shop.getShopSecAlarmConfig({
              shopId: $scope.shopObject.shopId
            }, function (res) {
              if (res.configList) {
                $scope.shopAlarmConfData = _.find(res.configList, {
                  type: "shop"
                });
                $scope.sensorAlarmConfList = _.filter(res.configList, {
                  type: "sensor"
                });
                $scope.doorlockAlarmConfList = _.filter(res.configList, {
                  type: "doorlock"
                });
                $scope.cameraAlarmConfList = _.filter(res.configList, {
                  type: "camera"
                }).map(function (camera) {
                  camera._pushSupportRecordTypeStatus = PUSH_SUPPORT_RECORD_TYPES_STATUS.LOADING;
                  return camera;
                });
                getCameraAlarmConfList(res.configList).then(function (cameraAlarmConfList) {
                  $scope.cameraAlarmConfList = cameraAlarmConfList;
                });
              }
            }, function (err) {
              showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
            });
          };
          setCameraPushDisabled = function _setCameraPushDisable(cameraAlarmConfList) {
            var deferred = $q.defer();
            var alarmOffList = _.filter(cameraAlarmConfList, {
              _pushSupportRecordTypeStatus: "N",
              notifyOn: "on"
            });
            var promiseList = _.map(alarmOffList, function (camera) {
              return setCameraAlarmOff(camera.id);
            });
            $q.all(promiseList).then(function () {
              deferred.resolve();
            })["catch"](function () {
              deferred.reject();
            });
            return deferred.promise;
          };
          getCameraAlarmConfList = function _getCameraAlarmConfLi(configList) {
            var deferred = $q.defer();
            var cameraAlarmConfList = _.filter(configList, {
              type: "camera"
            }).map(function (camera) {
              camera._pushSupportRecordTypeStatus = PUSH_SUPPORT_RECORD_TYPES_STATUS.LOADING;
              return camera;
            });
            var promiseList = _.map(cameraAlarmConfList, function (camera) {
              return getCameraData(camera.id);
            });
            $q.all(promiseList).then(function (result) {
              _.forEach(result, function (data, index) {
                cameraAlarmConfList[index]._pushSupportRecordTypeStatus = getPushSupportRecordTypeStatus(data.recordType);
              });
              deferred.resolve(cameraAlarmConfList);
            })["catch"](function () {
              deferred.reject();
            });
            return deferred.promise;
          };
          getPushSupportRecordTypeStatus = function _getPushSupportRecord(recordType) {
            return PUSH_UNSUPPORTED_RECORD_TYPE.test(recordType) ? PUSH_SUPPORT_RECORD_TYPES_STATUS.N : PUSH_SUPPORT_RECORD_TYPES_STATUS.Y;
          };
          setCameraAlarmOff = function _setCameraAlarmOff(cameraId) {
            var deferred = $q.defer();
            CameraNotifyConfig.update({
              cameraId: cameraId
            }, {
              notifyOn: "off"
            }, function (data) {
              if (data.code != "ok") {
                deferred.reject();
              } else {
                deferred.resolve();
              }
            }, function (error) {
              deferred.reject(error);
            });
            return deferred.promise;
          };
          getCameraData = function _getCameraData(id) {
            var deferred = $q.defer();
            Camera.get({
              id: id
            }, function (res) {
              deferred.resolve(res);
            }, function (error) {
              deferred.reject(error);
            });
            return deferred.promise;
          };
          setCurEditTempAlarmConf = function _setCurEditTempAlarmC(alarmConf) {
            if (!alarmConf) {
              return;
            }
            Shop.getTempAlarmConfig({
              sensorId: alarmConf.id
            }, function (res) {
              $scope.curEditTempAlarmConf = {
                id: alarmConf.id,
                name: alarmConf.name,
                sensorId: res.sensorId,
                notifyOn: res.notifyOn,
                alarmConfig: res.alarmConfig,
                minTemp: res.minTemp,
                maxTemp: res.maxTemp,
                minHumid: res.minHumid,
                maxHumid: res.maxHumid
              };
            }, function (err) {
              showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
            });
          };
          getShopAlarmConfig = function _getShopAlarmConfig() {
            Shop.getShopAlarmConfig({
              shopId: $scope.shopObject.shopId
            }, function (res) {
              if (!res.notifyConfig) {
                return;
              }
              $scope.shopAlarmConfig = res.notifyConfig;
              $scope.shopAlarmConfig.notifySettingType == "staff" ? $scope.shopAlarmConfig.notifySettingType = "schedule" : "";
              for (var key in $scope.alarmNotifyRepeat) {
                $scope.alarmNotifyRepeat[key] = false;
              }
              for (var i = 0, len = $scope.shopAlarmConfig.notifySchedule.repeatOn.length; i < len; i += 1) {
                switch ($scope.shopAlarmConfig.notifySchedule.repeatOn[i]) {
                  case 1:
                    $scope.alarmNotifyRepeat.SUN = true;
                    break;
                  case 2:
                    $scope.alarmNotifyRepeat.MON = true;
                    break;
                  case 3:
                    $scope.alarmNotifyRepeat.TUE = true;
                    break;
                  case 4:
                    $scope.alarmNotifyRepeat.WED = true;
                    break;
                  case 5:
                    $scope.alarmNotifyRepeat.THU = true;
                    break;
                  case 6:
                    $scope.alarmNotifyRepeat.FRI = true;
                    break;
                  case 7:
                    $scope.alarmNotifyRepeat.SAT = true;
                    break;
                  default:
                    break;
                }
              }
              var startTime = getHourMinStrWithMilSeconds($scope.shopAlarmConfig.notifySchedule.startAt),
                endTime = getHourMinStrWithMilSeconds($scope.shopAlarmConfig.notifySchedule.stopAt);
              $scope.alarmNotifyStartTime.hour = startTime.hour;
              $scope.alarmNotifyStartTime.min = startTime.min;
              $scope.alarmNotifyEndTime.hour = endTime.hour;
              $scope.alarmNotifyEndTime.min = endTime.min;
            }, function (err) {
              showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
            });
          };
          getHourMinStrWithMilSeconds = function _getHourMinStrWithMil(milSeconds) {
            var min, hour;
            hour = Math.floor(milSeconds / (1000 * 60 * 60));
            min = Math.floor((milSeconds - hour * 1000 * 60 * 60) / (1000 * 60));
            return {
              hour: hour < 10 ? "0" + hour : "" + hour,
              min: min < 10 ? "0" + min : "" + min
            };
          };
          getMilSecondsWithHourMinStr = function _getMilSecondsWithHou(hour, min) {
            var minNum = parseInt(min, 10),
              hourNum = parseInt(hour, 10);
            return minNum * (1000 * 60) + hourNum * (1000 * 60 * 60);
          };
          getNumArrayWithDayJSON = function _getNumArrayWithDayJS(dayJSON) {
            var repeatOn = [];
            if (!dayJSON) {
              return repeatOn;
            }
            for (var key in dayJSON) {
              switch (key) {
                case "SUN":
                  dayJSON[key] ? repeatOn.push(1) : null;
                  break;
                case "MON":
                  dayJSON[key] ? repeatOn.push(2) : null;
                  break;
                case "TUE":
                  dayJSON[key] ? repeatOn.push(3) : null;
                  break;
                case "WED":
                  dayJSON[key] ? repeatOn.push(4) : null;
                  break;
                case "THU":
                  dayJSON[key] ? repeatOn.push(5) : null;
                  break;
                case "FRI":
                  dayJSON[key] ? repeatOn.push(6) : null;
                  break;
                case "SAT":
                  dayJSON[key] ? repeatOn.push(7) : null;
                  break;
                default:
                  break;
              }
            }
            return repeatOn;
          };
          updateDlgStyle = function _updateDlgStyle() {
            var marginTopSize = 50;
            var windowHeight = $(window).height();
            $scope.shopDlgMaxHeight = windowHeight - marginTopSize + "px";
          };
          setWindowScrollEvent = function _setWindowScrollEvent(isOn) {
            if (isOn) {
              $(window).on("scroll", function (e) {
                confirmIoTDevice();
              });
            } else {
              $(window).off("scroll");
            }
          };
          confirmIoTDevice = function _confirmIoTDevice() {
            if (!isUpdateIoTConfirmed && iotDashboardItem && iotDashboardItem.devices && iotDashboardItem.devices[0]) {
              var iotSector = document.getElementById("iot_sector");
              if (iotSector && checkInView(iotSector)) {
                isUpdateIoTConfirmed = true;
                iotDashboardItem.devices.forEach(function (device) {
                  setConfirmedEventToLocalStorage(device);
                });
              }
            }
          };
          checkInView = function _checkInView(el) {
            var $el = $(el),
              $window = $(window),
              st = document.documentElement.scrollTop || document.body.scrollTop,
              ot = $el.offset().top,
              wh = window.innerHeight && window.innerHeight < $window.height() ? window.innerHeight : $window.height();
            return ot > st && $el.height() / 2 + ot < st + wh;
          };
          setConfirmedEventToLocalStorage = function _setConfirmedEventToL(device) {
            var confirmedEventMap, deviceId;
            if (device.deviceType === "SENSOR") {
              deviceId = device.sensorInfo.id;
            } else if (device.deviceType === "CAMERA") {
              deviceId = device.cameraInfo.id;
            } else {
              return;
            }
            confirmedEventMap = getConfirmedEventFromLocalStorage();
            confirmedEventMap[deviceId] = device.eventRegDate;
            localStorage.setItem(confirmedEventStorageKey, JSON.stringify(confirmedEventMap));
          };
          getConfirmedEventFromLocalStorage = function _getConfirmedEventFro() {
            var confirmedEventStr;
            confirmedEventStr = localStorage.getItem(confirmedEventStorageKey);
            return confirmedEventStr ? JSON.parse(confirmedEventStr) : {};
          };
          goPosSubPage = function _goPosSubPage(pageName, shop) {
            if ($scope.isShared === true) {
              if (shop.shareOption[3] == 1) {
                if (shop.posId && shop.posId != "") {
                  $state.go(pageName, {
                    shopId: shop.shopId,
                    cameraId: shop.posCameraId,
                    posId: shop.posId,
                    type: "sharedshop"
                  });
                } else {
                  showAlert($translate.instant("SHARE_SHOP"), $translate.instant("SHARE_SHOP_NO_POS"));
                }
              } else {
                showAlert($translate.instant("SHARE_SHOP"), $translate.instant("SHARE_SHOP_NO_AUTH"));
              }
            } else {
              if (shop.posId && shop.posId != "") {
                $state.go(pageName, {
                  shopId: shop.shopId,
                  cameraId: shop.posCameraId,
                  posId: shop.posId,
                  type: "shop"
                });
              } else {
                void 0;
              }
            }
          };
          checkSensorAndDoorlockExists = function _checkSensorAndDoorlo2(shopInfo) {
            var devices = processDevices(shopInfo);
            var doorlockExists = false;
            var sensorExists = false;
            devices.forEach(function (device) {
              if (device.deviceType === "SENSOR") {
                if (device.sensorInfo.sensorType === "DOORLOCK") {
                  doorlockExists = true;
                } else {
                  sensorExists = true;
                }
              }
            });
            return {
              doorlockExists: doorlockExists,
              sensorExists: sensorExists
            };
          };
          pushNotInstalledItems = function _pushNotInstalledItem(shopInfo, isPushCamera, isPushAi, isPushAiFace, isPushStaff, isPushPos, isPushDid) {
            var _$scope$shopObject$ai3, _$scope$shopObject$ai4;
            if (!isPushCamera && !$scope.iothubList.length) {
              pushDashboardItem($scope.objectEnum.CAMERA, false);
            }
            if (!isPushAi && !$scope.isShared && ((_$scope$shopObject$ai3 = $scope.shopObject.aiDisplayMode) === null || _$scope$shopObject$ai3 === void 0 ? void 0 : _$scope$shopObject$ai3.peopleCount) !== 0) {
              pushDashboardItem($scope.objectEnum.AI, false);
            }
            if (!isPushAiFace && !$scope.isShared && ((_$scope$shopObject$ai4 = $scope.shopObject.aiDisplayMode) === null || _$scope$shopObject$ai4 === void 0 ? void 0 : _$scope$shopObject$ai4.faceDetect) !== 0) {
              pushDashboardItem($scope.objectEnum.AIFACE, false);
            }
            if (!isPushStaff && !$scope.isShared) {
              pushDashboardItem($scope.objectEnum.STAFF, false);
            }
            if ($scope.countryDomain !== "ja" && !isPushPos && !$scope.isShared) {
              pushDashboardItem($scope.objectEnum.POS, false);
            }
            if (!isPushDid && !$scope.isShared) {
              pushDashboardItem($scope.objectEnum.DID, false);
            }
            var _checkSensorAndDoorlo = checkSensorAndDoorlockExists(shopInfo),
              doorlockExists = _checkSensorAndDoorlo.doorlockExists,
              sensorExists = _checkSensorAndDoorlo.sensorExists;
            if (!sensorExists && !$scope.isShared) {
              pushDashboardItem($scope.objectEnum.SENSOR, false);
            }
            if (!doorlockExists && !$scope.isShared) {
              pushDashboardItem($scope.objectEnum.DOORLOCK, false);
            }
          };
          pushDidData = function _pushDidData(shopInfo) {
            pushDashboardItem($scope.objectEnum.DID, true, {
              title: $translate.instant("STR_DID_MONITOR"),
              status: shopInfo.did.title,
              dids: shopInfo.did.dids
            });
          };
          fetchPosData = function _fetchPosData(shopId) {
            $scope.accessDate = Date.now();
            $scope.accessDateText = "";
            $scope.todayL = moment().valueOf();
            $scope.yesterdayL = moment().subtract(1, "days").valueOf();
            $scope.beforeYesterdayL = moment().subtract(2, "days").valueOf();
            PosSummary.getTodaySales({
              shopId: shopId
            }, function (res) {
              var posItem = _.find($scope.dashboardItems, {
                object: $scope.objectEnum.POS
              });
              if (posItem) {
                posItem.sales = res;
              }
            });
          };
          pushStaffData = function _pushStaffData(shopInfo) {
            pushDashboardItem($scope.objectEnum.STAFF, true, {
              dateStr: shopInfo.staff.title,
              inStaffs: shopInfo.staff.status.ER || [],
              outStaffs: shopInfo.staff.status.ET || []
            });
          };
          getDeviceOrder = function _getDeviceOrder(deviceType) {
            if (deviceType === "CAMERA") return 3;
            if (deviceType === "SENSOR") return 2;
            return 1;
          };
          getDeviceId = function _getDeviceId(device) {
            if (device.deviceType === "SENSOR") return device.sensorInfo.id;
            if (device.deviceType === "IOTHUB") return device.iotHubInfo.id;
            return device.cameraInfo.id;
          };
          processDevices = function _processDevices(shopInfo) {
            var _shopInfo$shopEventBy;
            var devices = (_shopInfo$shopEventBy = shopInfo.shopEventByDevices) !== null && _shopInfo$shopEventBy !== void 0 && _shopInfo$shopEventBy.length && shopInfo.shopEventByDevices[0] ? shopInfo.shopEventByDevices : [];
            var confirmedEventMap = getConfirmedEventFromLocalStorage();
            if (Object.keys(confirmedEventMap).length) {
              devices.forEach(function (device) {
                var deviceId = getDeviceId(device);
                if (confirmedEventMap[deviceId] == device.eventRegDate) {
                  device.isConfirmed = true;
                }
              });
            }
            return devices.sort(function (a, b) {
              var aOrder = getDeviceOrder(a.deviceType);
              var bOrder = getDeviceOrder(b.deviceType);
              return aOrder > bOrder ? -1 : 1;
            });
          };
          fetchAIFaceDataPeriodically = function _fetchAIFaceDataPerio() {
            fetchAIFaceData();
            aiFaceIntervalId = $interval(fetchAIFaceData, 10000);
          };
          updateAIDataPeriodically = function _updateAIDataPeriodic() {
            updateAIData();
            aiIntervalId = $interval(updateAIData, 10000);
          };
          pushDashboardItem = function _pushDashboardItem(objectEnum, exist) {
            var additionalProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            $scope.dashboardItems.push(_objectSpread({
              object: objectEnum,
              exist: exist
            }, additionalProps));
          };
          processShopFeatures = function _processShopFeatures(dashboardShopObj, shopInfo) {
            var _$scope$shopObject$ai, _$scope$shopObject$ai2, _shopInfo$staff, _shopInfo$did;
            var shopId = dashboardShopObj.shopId;
            var isPushCamera = false,
              isPushAi = false,
              isPushAiFace = false,
              isPushStaff = false,
              isPushPos = false,
              isPushDid = false;
            if ($scope.isShopAiSetted && ((_$scope$shopObject$ai = $scope.shopObject.aiDisplayMode) === null || _$scope$shopObject$ai === void 0 ? void 0 : _$scope$shopObject$ai.peopleCount) === 1) {
              pushDashboardItem($scope.objectEnum.AI, true);
              updateAIDataPeriodically();
              isPushAi = true;
            }
            if (((_$scope$shopObject$ai2 = $scope.shopObject.aiDisplayMode) === null || _$scope$shopObject$ai2 === void 0 ? void 0 : _$scope$shopObject$ai2.faceDetect) === 1) {
              pushDashboardItem($scope.objectEnum.AIFACE, true);
              fetchAIFaceDataPeriodically();
              isPushAiFace = true;
            }
            if ($scope.cameraList.length) {
              pushDashboardItem($scope.objectEnum.CAMERA, true, {
                cameras: $scope.cameraList
              });
              isPushCamera = true;
            }
            var devices = processDevices(shopInfo);
            pushDashboardItem($scope.objectEnum.IOT, true, {
              devices: devices
            });
            confirmIoTDevice();
            if ((_shopInfo$staff = shopInfo.staff) !== null && _shopInfo$staff !== void 0 && _shopInfo$staff.status) {
              pushStaffData(shopInfo);
              isPushStaff = true;
            }
            if ($scope.countryDomain !== "ja" && dashboardShopObj.posExists) {
              pushDashboardItem($scope.objectEnum.POS, true, {
                sales: null
              });
              fetchPosData(shopId);
              isPushPos = true;
            }
            if ((_shopInfo$did = shopInfo.did) !== null && _shopInfo$did !== void 0 && _shopInfo$did.dids.length) {
              pushDidData(shopInfo);
              isPushDid = true;
            }
            pushNotInstalledItems(shopInfo, isPushCamera, isPushAi, isPushAiFace, isPushStaff, isPushPos, isPushDid);
          };
          processCamera = function _processCamera(controller) {
            var _controller$cameraInf = controller.cameraInfo,
              serviceType = _controller$cameraInf.serviceType,
              recordType = _controller$cameraInf.recordType,
              recorderType = _controller$cameraInf.recorderType;
            if (serviceType === "0d" && recordType === "na" && recorderType === "cvr") {
              controller.cameraInfo.thumbnailPath = "".concat(location.hostname, "/resources/img/img_camera_blackout.svg");
              controller.cameraInfo.addServiceType = "black";
            } else if (recorderType === "0d" && recordType === "live" && recorderType === "cvr") {
              controller.cameraInfo.addServiceType = "live";
            } else if (recorderType !== "0d" && recordType === "event" && recorderType === "cvr") {
              controller.cameraInfo.addServiceType = "event";
            } else if (recorderType !== "0d" && recordType === "24h" && recorderType === "cvr") {
              controller.cameraInfo.addServiceType = "24h";
            } else {
              controller.cameraInfo.addServiceType = "else";
            }
            $scope.cameraList.push(controller.cameraInfo);
          };
          processShopDevices = function _processShopDevices(shopInfo) {
            $scope.cameraList = [];
            $scope.iothubList = [];
            if ($scope.shopObject.controllerList) {
              $scope.shopObject.controllerList.forEach(function (controller) {
                if (controller.deviceType === "CAMERA") {
                  processCamera(controller);
                } else if (controller.deviceType === "IOTHUB") {
                  $scope.iothubList.push(controller.iotHubInfo);
                }
              });
            }
          };
          setShopObjectProperties = function _setShopObjectPropert(shopInfo) {
            var _shopInfo$ai2, _shopInfo$ai3, _shopInfo$ai3$faceDet;
            $scope.shopName = $scope.shopObject.shopName;
            $scope.shopId = $scope.shopObject.shopId;
            $scope.shopObject.aiDisplayMode = ((_shopInfo$ai2 = shopInfo.ai) === null || _shopInfo$ai2 === void 0 ? void 0 : _shopInfo$ai2.displayMode) || null;
            $scope.shopObject.faceDetectAccount = ((_shopInfo$ai3 = shopInfo.ai) === null || _shopInfo$ai3 === void 0 ? void 0 : (_shopInfo$ai3$faceDet = _shopInfo$ai3.faceDetect) === null || _shopInfo$ai3$faceDet === void 0 ? void 0 : _shopInfo$ai3$faceDet.account) || null;
            $scope.shopLoadError = false;
          };
          showShopDashboard = function _showShopDashboard(shopInfo, dashboardShopObj) {
            var _shopInfo$ai, _shopInfo$ai$peopleCo;
            $rootScope.curDashboardShopObj = dashboardShopObj;
            $scope.isShopAiSetted = ((_shopInfo$ai = shopInfo.ai) === null || _shopInfo$ai === void 0 ? void 0 : (_shopInfo$ai$peopleCo = _shopInfo$ai.peopleCount) === null || _shopInfo$ai$peopleCo === void 0 ? void 0 : _shopInfo$ai$peopleCo.isSetted) || false;
            $scope.currentShop = $scope.shopObject = shopInfo.shop;
            if ($scope.shopObject) {
              setShopObjectProperties(shopInfo);
              processShopDevices(shopInfo);
              processShopFeatures(dashboardShopObj, shopInfo);
            } else {
              $scope.shopLoadError = true;
            }
            getShopControllerStatus(dashboardShopObj.shopId);
          };
          makeAIPeopleCountGraph = function _makeAIPeopleCountGra(graphData) {
            var aiGraphEl = document.getElementById("ai_people_count_graph");
            var color = "#4a96e6";
            if (!aiGraphEl) return;
            aiGraphEl.innerHTML = "";
            var chartWidth = aiGraphEl.clientWidth;
            if (!graphData) return;
            var data = {
              categories: graphData.xAxis.items,
              series: [{
                name: $translate.instant("9rRqk7Vo_01942"),
                data: graphData.data,
                color: color
              }]
            };
            var options = {
              theme: "newTheme",
              chart: {
                width: chartWidth - 70,
                height: 400,
                title: "",
                format: "1,000"
              },
              yAxis: {
                title: "(".concat($translate.instant("MAN_COUNT"), ")"),
                max: graphData.yAxis.max,
                min: graphData.yAxis.min
              },
              tooltip: {
                suffix: $translate.instant("MAN_COUNT")
              },
              xAxis: {
                title: "(".concat($translate.instant("HOUR_COUNT"), ")")
              },
              series: {
                showDot: false,
                hasSelection: true
              },
              legend: {
                visible: false
              },
              chartExportMenu: {
                visible: false
              }
            };
            $scope.theme = {
              series: {
                colors: [color]
              }
            };
            tui.chart.registerTheme("newTheme", $scope.theme);
            tui.chart.columnChart(aiGraphEl, data, options);
            var customEventArea = aiGraphEl.querySelector(".tui-chart-series-custom-event-area");
            if (customEventArea) {
              customEventArea.style.display = "none";
            }
            aiGraphEl.querySelector(".tui-chart").style.margin = "auto";
          };
          makeAIPeopleLineGraph = function _makeAIPeopleLineGrap(graphData) {
            var elementId = "ai_people_count_graph";
            var aiGraphEl = document.getElementById(elementId);
            var color = "#4a96e6";
            if (!aiGraphEl) {
              return;
            }
            aiGraphEl.innerHTML = "";
            var chartWidth = aiGraphEl.clientWidth;
            var data = {
              categories: graphData.xAxis.items,
              series: [{
                name: "",
                data: graphData.data
              }]
            };
            var options = {
              chart: {
                width: chartWidth - 70,
                height: 400
              },
              yAxis: {
                title: "(".concat($translate.instant("MAN_COUNT"), ")"),
                min: graphData.yAxis.min,
                max: graphData.yAxis.max
              },
              xAxis: {
                title: "(".concat($translate.instant("HOUR"), ")"),
                labelInterval: 1
              },
              tooltip: {
                suffix: "(".concat($translate.instant("MAN_COUNT"), ")")
              },
              series: {
                showDot: true,
                zoomable: false
              },
              legend: {
                visible: false
              },
              chartExportMenu: {
                visible: false
              }
            };
            tui.chart.registerTheme("peoplecount", {
              series: {
                colors: [color]
              }
            });
            options.theme = "peoplecount";
            tui.chart.lineChart(aiGraphEl, data, options);
          };
          checkAIPeopleCountDataSame = function _checkAIPeopleCountDa(prevData, newData) {
            if (prevData.data.length !== newData.data.length) {
              return false;
            }
            return prevData.data.every(function (value, index) {
              return value === newData.data[index];
            });
          };
          updateAIData = function _updateAIData(forceRedraw) {
            var aiItem = _.find($scope.dashboardItems, {
              object: $scope.objectEnum.AI
            });
            var param = {
              shopId: $scope.shopId,
              interval: 5,
              scale: "IN_HOUR"
            };
            if ($scope.aiGraphMode !== "hour") {
              delete param.interval;
              delete param.scale;
            }
            var handleSuccess = function handleSuccess(response) {
              if (!aiItem || !response.ai) return;
              aiItem.aiData = response.ai;
              if (aiStatsDlg) {
                aiStatsDlg.updateAiData(aiItem.aiData.summariesByCamera);
              }
              var redrawGraph = forceRedraw || !checkAIPeopleCountDataSame(aiStatList, aiItem.aiData.chart.peopleArea);
              if (redrawGraph) {
                aiStatList = aiItem.aiData.chart.peopleArea;
                $timeout(function () {
                  if ($scope.aiGraphMode === "hour") {
                    makeAIPeopleLineGraph(aiItem.aiData.chart.peopleArea);
                  } else {
                    makeAIPeopleCountGraph(aiItem.aiData.chart.peopleArea);
                  }
                  $scope.showGraphModeBtn = true;
                }, forceRedraw ? 100 : 500);
              }
              if (aiGraphsDlg) {
                var aiCountSummary = aiItem.aiData.aiCountSummary;
                if (aiCountSummary) {
                  aiCountSummary.updateDateStr = $scope.aiDataTimeConverter(aiCountSummary.updateDate);
                }
                aiGraphsDlg.updateAiCountSummary(aiCountSummary || null);
              }
            };
            var handleError = function handleError(err) {};
            Shop.getAiShopData(param).$promise.then(handleSuccess, handleError);
          };
          fetchAIFaceData = function _fetchAIFaceData() {
            AiFace.aiFaceDashboardEvents({
              shopId: $scope.shopId,
              shopEventLimit: 3
            }).$promise.then(function (res) {
              $scope.aiFaceDashboardEvent = res.code === "ok" ? res.faceDetect : {};
              setTimeout(updateAIFaceEvent, 300);
            }, function (err) {});
          };
          updateAIFaceEvent = function _updateAIFaceEvent() {
            var elements = document.querySelectorAll(".ai_evt_wrapper");
            elements.forEach(function (el) {
              var blurEl = el.querySelector(".blur_layer");
              if (blurEl) {
                blurEl.style.display = el.scrollWidth > el.clientWidth ? "block" : "none";
              }
              var evtEl = el.parentElement.querySelector(".evt_time");
              if (evtEl) {
                el.style.width = "calc(100% - ".concat(evtEl.clientWidth + 10, "px)");
              }
            });
          };
          updateIoTDevices = function _updateIoTDevices(selectSensorId) {
            var devices = [];
            isUpdateIoTConfirmed = false;
            var setDeviceInfo = function setDeviceInfo(device, deviceId, confirmedEventMap) {
              if (confirmedEventMap[deviceId] === device.eventRegDate) {
                device.isConfirmed = true;
              }
              if (device.deviceType === "SENSOR" && deviceId === selectSensorId) {
                $scope.selectSensor = device.sensorInfo;
              }
            };
            Shop.dashboardShopV4({
              shopId: $scope.shopObject.shopId
            }, function (res) {
              devices = res.shopEventByDevices && res.shopEventByDevices.length ? res.shopEventByDevices : [];
              var confirmedEventMap = getConfirmedEventFromLocalStorage();
              var eventMapLen = Object.keys(confirmedEventMap).length;
              if (eventMapLen) {
                devices.forEach(function (device) {
                  var deviceId;
                  switch (device.deviceType) {
                    case "SENSOR":
                      deviceId = device.sensorInfo.id;
                      break;
                    case "IOTHUB":
                      deviceId = device.iotHubInfo.id;
                      break;
                    default:
                      deviceId = device.cameraInfo.id;
                  }
                  setDeviceInfo(device, deviceId, confirmedEventMap);
                });
              }
              var iotDashboardItem = _.find($scope.dashboardItems, {
                object: $scope.objectEnum.IOT
              });
              if (!iotDashboardItem) return;
              iotDashboardItem.devices = devices;
              confirmIoTDevice();
            });
          };
          showShopDashboardEvent = function _showShopDashboardEve(shopInfo) {
            $timeout(function () {
              var eventCount = shopInfo.eventCount || 0;
              $scope.uncheckEvtsCount = Math.min(eventCount, 99);
            }, 100);
            $scope.warningEvents = shopInfo.warningEvents || [];
            if ($scope.warningEvents.length > 0) {
              $scope.warningEvents.forEach(function (evt) {
                evt.confirmed = Boolean(localStorage.getItem(evt.eventId));
              });
            }
          };
          getLastEvtCheckTime = function _getLastEvtCheckTime(shopId) {
            var lastEvtCheckTime = function () {
              var cookieValue = Utils.getCookie("lastEvtCheckTime:" + shopId);
              var intValue = parseInt(cookieValue, 10);
              return isNaN(intValue) ? 0 : intValue;
            }();
            var date = new Date();
            date.setDate(date.getDate() - 1);
            var earlyTime = date.getTime();
            return earlyTime < lastEvtCheckTime ? lastEvtCheckTime : earlyTime;
          };
          getShopControllerStatus = function _getShopControllerSta(shopId) {
            var resetStatusMessage = function resetStatusMessage() {
              $scope.controllStatusNoticeShow = false;
              $scope.controllStatusMsg = "";
            };
            var handleSuccess = function handleSuccess(res) {
              if (res.status !== true) {
                $scope.controllStatusNoticeShow = true;
                $scope.controllStatusMsg = res.msg;
                $timeout(resetStatusMessage, 5000);
              } else {
                resetStatusMessage();
              }
            };
            var handleError = function handleError() {
              resetStatusMessage();
              showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
            };
            if (!appConfig.sensorDisableUI || $scope.isShared) {
              resetStatusMessage();
              return;
            }
            Sensor.getControllerStatus({
              shopId: shopId
            }, handleSuccess, handleError);
          };
          initShop = function _initShop(dashboardShopObj) {
            var setShopStatus = function setShopStatus(isShared, configStatus) {
              $scope.isShared = isShared;
              $scope.configStatus = configStatus || "shopInfo";
            };
            var handlePromise = function handlePromise(promise, successCallback) {
              promise.then(successCallback, handleError);
            };
            var handleError = function handleError(err) {
              $scope.isShopLoaded = true;
              $scope.shopLoadError = true;
              $rootScope.dashboardShopList = null;
              $scope.$root.createSessionDlg();
            };
            if (dashboardShopObj.myShop) {
              setShopStatus(false, null);
            } else {
              setShopStatus(true, "shopShare");
            }
            $scope.dashboardItems = [];
            $scope.isShopLoaded = false;
            var shopPromise = Shop.dashboardShopV4({
              shopId: dashboardShopObj.shopId
            }).$promise;
            handlePromise(shopPromise, function (res) {
              if (res.shop && res.shop.shopId === dashboardShopObj.shopId) {
                showShopDashboard(res, dashboardShopObj);
              }
              $scope.isShopLoaded = true;
            });
            var evtCheckTime = getLastEvtCheckTime(dashboardShopObj.shopId);
            var shopEventPromise = Shop.dashboardShopEventV3({
              shopId: dashboardShopObj.shopId,
              timestamp: evtCheckTime,
              warningEventLimit: 1
            }).$promise;
            handlePromise(shopEventPromise, function (res) {
              showShopDashboardEvent(res, dashboardShopObj.shopId);
            });
          };
          appendDialogs = function _appendDialogs(container, dialogs) {
            dialogs.forEach(function (dialog) {
              container.append($compile("<" + dialog + "></" + dialog + ">")($scope));
            });
          };
          appendDlg = function _appendDlg() {
            if (!$scope.isDlgAppended && !isDlgAppendedInstant) {
              isDlgAppendedInstant = true;
              var $cont = $("#dlg_container");
              $cont.empty();
              var dialogComponents = ["iothub-set-dialog", "sensor-detail-dialog", "did-detail-dialog", "shop-modify-dialog", "staff-regist-dialog", "ai-cam-mode-set-dialog", "ai-cam-add-dialog", "ai-face-set-people-dialog", "ai-face-event-play-dialog", "ai-face-service-reg-dialog", "ai-face-people-event-play-dialog", "lock-face-cam-select-dialog", "lock-face-people-select-dialog"];
              appendDialogs($cont, dialogComponents);
              $timeout(function () {
                $scope.isDlgAppended = true;
              }, 1000);
            }
          };
          showAlert = function _showAlert(title, message, handler) {
            var noCloseBtn = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
            var closeHandler = arguments.length > 4 ? arguments[4] : undefined;
            $rootScope.createConfirm({
              title: title,
              description: message,
              btnCount: 1,
              handler: handler,
              noCloseBtn: noCloseBtn,
              closeHandler: closeHandler
            });
          };
          $scope.protocol = $location.protocol() + "://";
          $scope.dashboardItems = [];
          $scope.shopName = "";
          $scope.shopObject = null;
          $scope.cameraList = [];
          $scope.iothubList = [];
          $scope.accessDate = Date.now();
          $scope.isToday = true;
          $scope.currentTime = moment().format("HH:mm");
          $scope.isShared = false;
          $scope.isShowShopSetting = false;
          $scope.configStatus = "shopInfo"; //shopShare
          $scope.shopAddModel = {};
          $scope.searchedAddress = null;
          $scope.searchQueryStr = "";
          $scope.selectedSearchAddress = null;
          $scope.inputDetailAddress = "";
          $scope.controllStatusNoticeShow = false;
          $scope.controllStatusMsg = "";
          $scope.sensorDisableUI = appConfig.sensorDisableUI;
          $scope.selectIotHubConfig = null;
          $scope.isShopLoaded = false;
          $scope.shopLoadError = false;
          $scope.currentCamera = {};
          $scope.isCameraSettingOpen = false;
          $scope.uncheckEventText = $translate.instant("UNCHECK_EVENT_TEXT");
          $scope.uncheckEvtsCount = 0;
          $scope.warningEvents = [];
          $scope.sensorAlarmConfList = [];
          $scope.doorlockAlarmConfList = [];
          $scope.cameraAlarmConfList = [];
          $scope.shopPlugAlarmConfigList = [];
          $scope.shopAlarmConfig = {
            notifySettingType: "schedule",
            notifyAutoOn: "off"
          };
          $scope.posAlarmConfig = {};
          $scope.alarmNotifyRepeat = {
            SUN: false,
            MON: false,
            TUE: false,
            WED: false,
            THU: false,
            FRI: false,
            SAT: false
          };
          $scope.alarmNotifyStartTime = {
            hour: "00",
            min: "00"
          };
          $scope.alarmNotifyEndTime = {
            hour: "00",
            min: "00"
          };
          $scope.isShopAiSetted = false;
          $scope.aiGraphMode = "hour";
          $scope.showGraphModeBtn = false;
          $scope.objectEnum = {
            EVENT: "event",
            CAMERA: "camera",
            IOT: "iot",
            STAFF: "staff",
            POS: "pos",
            DOORLOCK: "doorlock",
            SENSOR: "sensor",
            DID: "did",
            AI: "ai",
            AIFACE: "aiface"
          };
          $scope.isDlgAppended = false;
          $scope.extraService = {};
          $scope.aiMenuShow = DomainUtils.isAllowedAiDomain();
          isDlgAppendedInstant = false;
          iotDashboardItem = null;
          confirmedEventStorageKey = "confirmed-event-key";
          dashboardShopObj = null;
          shopListUpdateListener = null;
          isUpdateIoTConfirmed = false;
          $scope.camAiSeat = {};
          $scope.totalCamAiSeatCount = 0;
          aiIntervalId = null;
          aiFaceIntervalId = null;
          aiStatsDlg = null;
          aiGraphsDlg = null;
          tuiChart = null;
          rejectShareId = null;
          aiStatList = null;
          fetchExtraService = /*#__PURE__*/function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
              var data;
              return _regeneratorRuntime().wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    _context.prev = 0;
                    _context.next = 3;
                    return User.extraService().$promise;
                  case 3:
                    data = _context.sent;
                    $scope.extraService = data;
                    _context.next = 10;
                    break;
                  case 7:
                    _context.prev = 7;
                    _context.t0 = _context["catch"](0);
                    void 0;
                  case 10:
                  case "end":
                    return _context.stop();
                }
              }, _callee, null, [[0, 7]]);
            }));
            return function fetchExtraService() {
              return _ref2.apply(this, arguments);
            };
          }();
          $("body").removeClass("blockScroll");
          $scope.countryDomain = window.country;
          setWindowScrollEvent(true);
          _context2.next = 117;
          return fetchExtraService();
        case 117:
          $scope.$on("$destroy", function () {
            $rootScope.destroyConfirm();
            setWindowScrollEvent(false);
            iotDashboardItem = null;
            dashboardShopObj = null;
            isUpdateIoTConfirmed = false;
            $(window).off("resize", resizeHandler);
            if (aiStatsDlg) {
              aiStatsDlg.destroy();
              aiStatsDlg = null;
            }
            if (aiGraphsDlg) {
              aiGraphsDlg.destroy();
              aiGraphsDlg = null;
            }
            //unsubscribe
            if (shopListUpdateListener) {
              shopListUpdateListener();
            }
            if (aiIntervalId) {
              $interval.cancel(aiIntervalId);
            }
            if (aiFaceIntervalId) {
              $interval.cancel(aiFaceIntervalId);
            }
          });
          $scope.confirmWarnEvent = function (evt) {
            localStorage.setItem(evt.eventId, true);
            $scope.goSubPage("main.dashboard.event", evt);
          };
          /****** AI Shop Start *******/
          $scope.aiDataTimeConverter = function (timestamp) {
            if (typeof timestamp !== "number") {
              return "";
            }
            var date = new Date(timestamp);
            var month = String(1 + date.getMonth()).padStart(2, "0");
            var day = String(date.getDate()).padStart(2, "0");
            var hour = String(date.getHours()).padStart(2, "0");
            var min = String(date.getMinutes()).padStart(2, "0");
            var seconds = String(date.getSeconds()).padStart(2, "0");
            return month + "." + day + " " + hour + ":" + min + ":" + seconds;
          };
          $scope.getUseTablePercent = function (useTableCount, allTableCount) {
            if (allTableCount === 0) {
              return "-";
            }
            var percentData = useTableCount / allTableCount * 100;
            return isNaN(percentData) ? "-" : (Math.floor(percentData * 10) / 10).toFixed(1);
          };
          $scope.setGraphTimeUnit = function (interval) {
            $scope.aiGraphMode = interval;
            updateAIData(true);
          };

          /********** AI Shop End ***********/

          $scope.showAiCamModeSetDlg = function () {
            $scope.isShowAiCamModeSetDialog = true;
          };
          $scope.showAiCamAddDlg = function () {
            $scope.isShowAiCamAddDialog = true;
          };
          $scope.showPeopleEvtPlayer = function (param) {
            $scope.isShowAiFaceSetPeopleDialog = false;
            $scope.eventInfo = param.eventInfo;
            $scope.person = param.person;
            $scope.isShowAiFacePeopleEventPlayDialog = true;
          };
          $scope.showLockFaceCamDlg = function () {
            $scope.isShowLockFaceCamDialog = true;
          };
          $scope.showLockFacePeopleDlg = function () {
            $scope.isShowLockFacePeopleDialog = true;
          };
          $scope.showAiCamStatsDlg = function () {
            var aiItem = _.find($scope.dashboardItems, {
              object: $scope.objectEnum.AI
            });
            if (aiStatsDlg) {
              aiStatsDlg.destroy();
            }
            aiStatsDlg = tCam.aiStatsDialog({
              elId: "wrap",
              dlgStyle: {
                width: "800px",
                padding: "32px",
                boxSizing: "border-box"
              },
              txtMap: {
                title: $translate.instant("9rRqk7Vo_01900"),
                countUnit: $translate.instant("MAN_COUNT")
              },
              pCameraSummaries: aiItem && aiItem.aiData ? aiItem.aiData.summariesByCamera : null,
              eventHandler: function eventHandler(event) {
                if (event.event === "close" && aiStatsDlg) {
                  aiStatsDlg.destroy();
                  aiStatsDlg = null;
                } else if (event.event === "click_cam") {
                  $scope.goDetail(event.data, $scope.shopObject.shopId);
                }
              }
            });
          };
          $scope.showAiGrapthDlg = function () {
            var _aiItem$aiData;
            if (aiGraphsDlg) {
              aiGraphsDlg.destroy();
            }
            aiGraphsDlg = tCam.aiGraphsDialog({
              elId: "wrap",
              dlgStyle: {
                width: "768px",
                height: "640px",
                boxSizing: "border-box"
              },
              shopRegdate: $scope.shopObject.regDate,
              txtMap: {
                title: $translate.instant("9rRqk7Vo_02255"),
                manTotal: $translate.instant("9rRqk7Vo_01953"),
                tableTotal: $translate.instant("9rRqk7Vo_02260"),
                hourGraphDesc: $translate.instant("9rRqk7Vo_02252"),
                dayGraphDesc: $translate.instant("9rRqk7Vo_02253"),
                weekly: $translate.instant("9rRqk7Vo_01944"),
                daily: $translate.instant("9rRqk7Vo_01945"),
                today: $translate.instant("EVENT_LIST_DATE_TODAY"),
                hour: $translate.instant("HOUR"),
                min: $translate.instant("MINUTE"),
                man: $translate.instant("9rRqk7Vo_01942"),
                manCount: $translate.instant("MAN_COUNT"),
                hourCount: $translate.instant("HOUR_COUNT"),
                dayCount: $translate.instant("9rRqk7Vo_02193"),
                dayMap: [$translate.instant("DAY_SUN"), $translate.instant("DAY_MON"), $translate.instant("DAY_TUE"), $translate.instant("DAY_WED"), $translate.instant("DAY_THU"), $translate.instant("DAY_FRI"), $translate.instant("DAY_SAT")]
              },
              pRequestShopChart: function pRequestShopChart(mode, startDate, endDate) {
                if (mode === "hourly") {
                  return Shop.getAiChartByMin({
                    shopId: $scope.shopId,
                    dayToTime: startDate.getTime(),
                    interval: 60
                  }).$promise;
                } else if (mode === "min") {
                  return Shop.getAiChartByMin({
                    shopId: $scope.shopId,
                    dayToTime: startDate.getTime(),
                    interval: 10
                  }).$promise;
                } else {
                  return Shop.getAiChartByDay({
                    shopId: $scope.shopId,
                    startTime: startDate.getTime()
                  }).$promise;
                }
              }
            });
            var aiItem = _.find($scope.dashboardItems, {
              object: $scope.objectEnum.AI
            });
            if (aiItem !== null && aiItem !== void 0 && (_aiItem$aiData = aiItem.aiData) !== null && _aiItem$aiData !== void 0 && _aiItem$aiData.aiCountSummary) {
              aiItem.aiData.aiCountSummary.updateDateStr = $scope.aiDataTimeConverter(aiItem.aiData.aiCountSummary.updateDate);
              aiGraphsDlg.updateAiCountSummary(aiItem.aiData.aiCountSummary);
            } else {
              aiGraphsDlg.updateAiCountSummary(null);
            }
          };
          $scope.goAiFaceInquiry = function () {
            $rootScope.createConfirm({
              description: "별도의 서비스 신청 후 이용가능한 메뉴입니다.<br>1:1 문의를 통해 서비스를 신청해주세요.",
              confText: "문의하기",
              btnCount: 1,
              handler: function handler() {
                $state.go("main.help.inquiry");
              }
            });
          };
          $scope.goAiShopModify = function () {
            $state.go("main.dashboard.aishop", {
              shopId: dashboardShopObj.shopId
            });
          };
          $scope.goAiFaceSet = function () {
            $state.go("main.aiface.content", {
              user: $scope.shopObject.faceDetectAccount ? $scope.shopObject.faceDetectAccount.userId : ""
            });
          };
          $scope.goAiMonitor = function () {
            var isLocalEnv = /(local-bizcam\.toastcam\.com)/.test(window.location.href || "");
            var url = isLocalEnv ? "/dist/aimonitor" : "/aimonitor";
            var queryString = ["shopId=" + dashboardShopObj.shopId, "myShop=" + dashboardShopObj.myShop].join("&");
            window.open(url + "?" + queryString);
          };
          $scope.showAiFaceSetPeopleDlg = function (detectPerson, isEdit, event) {
            $scope.selectPersonId = detectPerson.id;
            $scope.isPersonEditMode = isEdit;
            $scope.isShowAiFaceSetPeopleDialog = true;
            $scope.selectedAccount = {
              userId: detectPerson.userId
            };
            event.preventDefault();
            event.stopPropagation();
          };
          $scope.showAiFaceServRegDlg = function () {
            $scope.isShowAiFaceServiceRegDialog = true;
            $scope.selectedAccount = {
              userId: $rootScope.me.userId
            };
          };
          $scope.$on("hideAiServRegDlg", function (event, isRegisted) {
            if (isRegisted === true) {
              $scope.reload();
            }
          });
          $scope.reload = function () {
            $state.reload();
          };
          $scope.openDidDetail = function (did) {
            if (!did) {
              return;
            }
            $scope.selectDid = did;
            $scope.isShowDidSetDialog = true;
          };
          $scope.openSensorDetailWithId = function (sensorId) {
            var device;
            if (!sensorId) {
              return;
            }
            if (!iotDashboardItem || !iotDashboardItem.devices) {
              return;
            }
            iotDashboardItem.devices.forEach(function (item) {
              if (item.deviceType === "SENSOR" && item.sensorInfo.id === sensorId) {
                device = item;
              }
            });
            if (!device) {
              return;
            }
            device.sensorInfo.eventRegDate = device.eventRegDate;
            $scope.selectSensor = device.sensorInfo;
            $scope.isShowSensorSetDialog = true;
          };
          $scope.clickIoTDevice = function (device) {
            if (device.deviceType === "SENSOR") {
              $scope.openSensorDetailWithId(device.sensorInfo.id);
            } else if (device.deviceType === "CAMERA") {
              var cloud = false,
                i,
                len = $scope.cameraList.length;
              for (i = 0; i < len; i += 1) {
                if ($scope.cameraList[i].id === device.cameraInfo.id) {
                  cloud = $scope.cameraList[i].cloud;
                  break;
                }
              }
              if (cloud) {
                if ($scope.isShared) {
                  $state.go("main.cameraDetail", {
                    cameraId: device.cameraInfo.id,
                    type: "sharedshop",
                    id: $scope.shopObject.shopId,
                    time: device.eventRegDate,
                    shared: true
                  });
                } else {
                  $state.go("main.cameraDetail", {
                    cameraId: device.cameraInfo.id,
                    type: "shop",
                    id: $scope.shopObject.shopId,
                    time: device.eventRegDate
                  });
                }
              } else {
                if ($scope.isShared) {
                  $state.go("main.cameraDetail", {
                    cameraId: device.cameraInfo.id,
                    type: "sharedshop",
                    id: $scope.shopObject.shopId,
                    shared: true
                  });
                } else {
                  $state.go("main.cameraDetail", {
                    cameraId: device.cameraInfo.id,
                    type: "shop",
                    id: $scope.shopObject.shopId
                  });
                }
              }
            } else if (device.deviceType === "IOTHUB") {
              Device.deviceConfig({
                deviceType: device.deviceType,
                deviceId: device.iotHubInfo.id
              }, function (res) {
                $scope.selectIotHubConfig = res.config;
                $scope.isShowIothubSetDialog = true;
              }, function (error) {
                showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
              });
            }
          };
          $scope.searchAddress = function (queryStr) {
            Shop.queryAddress({
              q: queryStr,
              startRank: 1,
              returnCount: 100
            }, function (res) {
              if (res && res.addresses && res.addresses.length) {
                $scope.addrSearchResults = res.addresses;
              } else {
                $scope.addrSearchResults = [];
              }
            }, function (error) {
              showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
            });
          };
          $scope.selectSearchAddress = function (selectAddress) {
            $scope.selectedSearchAddress = selectAddress;
            if ($scope.selectedSearchAddress) {
              $scope.selectedZipCodeAddress = $scope.selectedSearchAddress.zipCode + " " + $scope.selectedSearchAddress.roadAddress;
            }
          };
          $scope.showSearchAddressDialog = function (isShow) {
            $scope.isShowSearchAddressDialog = isShow;
          };
          $scope.adjustSearchAddress = function (detailAddr) {
            $scope.shopAddModel.zipCode = $scope.selectedSearchAddress.zipCode;
            $scope.shopAddModel.address1 = $scope.selectedSearchAddress.roadAddress;
            $scope.shopAddModel.address2 = detailAddr;
            $scope.addrSearchResults = null;
            $scope.selectedSearchAddress = null;
            $scope.inputDetailAddress = "";
            $scope.isShowSearchAddressDialog = false;
          };
          $scope.keydownEvent = function ($event) {
            if ($event.key == "\\") {
              $event.preventDefault(); // form submit prevent
              return false;
            }
            if ($event.key == "Enter" && $event.isComposing === false) {
              $scope.searchController(true);
              $event.preventDefault(); // form submit prevent
            }
          };
          $scope.iotControllersTotalCount = null;
          $scope.getIotControllersTotalCount = function () {
            Device.iotControllersCountV1({}, function (res) {
              if (res.code === "ok") {
                $scope.iotControllersTotalCount = res.totalCount;
                $scope.pagingUtil.setTotalCount(res.totalCount);
              }
            });
          };
          $scope.makeParam = function () {
            var param = Object.assign({}, $scope.popupSearchData);
            param.pageNumber = $scope.pagingUtil.pageNumber();
            param.count = 16;
            param.totalCount = true;
            return param;
          };
          $scope.isLoadCams = true;
          $scope.searchController = function (initFlag) {
            if (initFlag) {
              $scope.shopControllers.splice(0);
              $scope.isLoadCams = true;
              $scope.pagingUtil.setPage(1);
            }
            var param = $scope.makeParam();
            Device.iotControllersV1(param, function (res) {
              if (res.code === "ok") {
                res.list.forEach(function (controller) {
                  controller.isChecked = $scope.myShopControllers.some(function (myController) {
                    return controller.controllerId == myController.deviceId;
                  }) ? true : false;
                });
                $scope.shopControllers = $scope.shopControllers.concat(res.list);
                $scope.isLoadCams = false;
              }
            }, function (err) {
              showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
            });
          };
          $scope.myShopControllers = [];
          $scope.shopControllers = [];
          $scope.showShopSetting = function (isShow) {
            $scope.isShowShopSetting = isShow;
            if (isShow === true) {
              document.body.classList.add("blockScroll");
              if ($scope.configStatus === "shopShare") {
                Shop.getShareReceivers({
                  shopId: $scope.shopObject.shopId
                }, function (res) {
                  $scope.shareReceivers = res;
                  $scope.shareAddModel = {
                    shareOptions: ["1", "0", "0", "0"]
                  };
                }, function (err) {
                  showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
                });
              } else if ($scope.configStatus === "shopInfo") {
                $scope.shopControllers.splice(0, $scope.shopControllers.length);
                $scope.pagingUtil = NgUtils.pagingUtil();
                $scope.pagingUtil.init();
                $scope.pagingUtil.setTotalCount(999999);
                $scope.pagingUtil.setCallBackFunc($scope.searchController);
                $scope.isLoadCams = true;

                //전체 카메라 개수 totalCount init
                if ($scope.iotControllersTotalCount === null) $scope.getIotControllersTotalCount();
                $scope.popupSearchData = {
                  keyword: ""
                };
                $scope.shopAddModel = {
                  shopName: $scope.shopObject.shopName,
                  zipCode: $scope.shopObject.zipCode,
                  address1: $scope.shopObject.address1,
                  address2: $scope.shopObject.address2,
                  timezone: $scope.shopObject.timezone,
                  language: $scope.shopObject.language,
                  access: $scope.shopObject.access
                };
                $scope.myShopControllers = _.cloneDeep($scope.shopObject.controllerList);
                $scope.searchController();
              } else if ($scope.configStatus === "shopAlarm") {
                getShopAlarmConfig();
              }
              updateDlgStyle();
            } else {
              $("body").removeClass("blockScroll");
            }
          };
          $scope.settingChange = function (status) {
            if (status === "shopShare" || status === "shopInfo" || status === "shopAlarm") {
              $scope.configStatus = status;
            }
            if (status === "shopShare") {
              Shop.getShareReceivers({
                shopId: $scope.shopObject.shopId
              }, function (res) {
                $scope.shareReceivers = res;
                $scope.shareAddModel = {
                  shareOptions: ["1", "0", "0", "0"]
                };
                //$scope.isShowShopShareConfig = true;
              }, function (err) {
                showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
              });
            } else if (status === "shopAlarm") {
              getShopAlarmConfig();
            }
          };
          /**
           * 매장알림 설정
           */
          $scope.saveShopAlarmConfig = function () {
            if (!$scope.shopAlarmConfig) {
              return;
            }
            var paramData = {
              notifyAutoOn: $scope.shopAlarmConfig.notifyAutoOn,
              notifySettingType: $scope.shopAlarmConfig.notifySettingType,
              startAt: getMilSecondsWithHourMinStr($scope.alarmNotifyStartTime.hour, $scope.alarmNotifyStartTime.min),
              stopAt: getMilSecondsWithHourMinStr($scope.alarmNotifyEndTime.hour, $scope.alarmNotifyEndTime.min),
              repeatOn: getNumArrayWithDayJSON($scope.alarmNotifyRepeat),
              secNotifyOn: $scope.shopAlarmConfig.secNotifyOn,
              inoutNotifyOn: $scope.shopAlarmConfig.inoutNotifyOn,
              faceDetectNotifyOn: $scope.shopAlarmConfig.faceDetectNotifyOn,
              posNotifyOn: $scope.shopAlarmConfig.posNotifyOn,
              airNotifyOn: $scope.shopAlarmConfig.airNotifyOn,
              posNotifyType: $scope.shopAlarmConfig.posNotifyType,
              pushOn: $scope.shopAlarmConfig.pushOn
            };
            Shop.updateShopAlarmConfig({
              shopId: $scope.shopObject.shopId
            }, paramData, function (res) {
              $scope.isShowShopSetting = false;
            }, function (err) {
              showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
            });
          };
          $scope.toggleSecAlarmConf = function (alarmConf) {
            if (!alarmConf) {
              return;
            }
            var targetAlarmConf = null;
            if (alarmConf.type == "shop") {
              targetAlarmConf = alarmConf;
            } else if (alarmConf.type == "sensor") {
              if (alarmConf.sensorType == "PLUG") {
                targetAlarmConf = _.find($scope.shopPlugAlarmConfigList, {
                  id: alarmConf.id
                });
              } else {
                targetAlarmConf = _.find($scope.sensorAlarmConfList, {
                  id: alarmConf.id
                });
              }
            } else if (alarmConf.type == "camera") {
              targetAlarmConf = _.find($scope.cameraAlarmConfList, {
                id: alarmConf.id
              });
            } else if (alarmConf.type == "doorlock") {
              targetAlarmConf = _.find($scope.doorlockAlarmConfList, {
                id: alarmConf.id
              });
            }
            if (targetAlarmConf) {
              targetAlarmConf.notifyOn = targetAlarmConf.notifyOn === "on" ? "off" : "on";
            }
          };
          $scope.saveSecAlarmConf = function () {
            var i,
              len,
              idList = "",
              typeList = "",
              notifyOnList = "";
            if ($scope.shopAlarmConfData) {
              idList += $scope.shopAlarmConfData.id + ",";
              typeList += $scope.shopAlarmConfData.type + ",";
              notifyOnList += $scope.shopAlarmConfData.notifyOn + ",";
            }
            if ($scope.sensorAlarmConfList) {
              for (i = 0, len = $scope.sensorAlarmConfList.length; i < len; i += 1) {
                idList += $scope.sensorAlarmConfList[i].id + ",";
                typeList += $scope.sensorAlarmConfList[i].type + ",";
                notifyOnList += $scope.sensorAlarmConfList[i].notifyOn + ",";
              }
            }
            if ($scope.doorlockAlarmConfList) {
              for (i = 0, len = $scope.doorlockAlarmConfList.length; i < len; i += 1) {
                idList += $scope.doorlockAlarmConfList[i].id + ",";
                typeList += $scope.doorlockAlarmConfList[i].type + ",";
                notifyOnList += $scope.doorlockAlarmConfList[i].notifyOn + ",";
              }
            }
            if ($scope.cameraAlarmConfList) {
              for (i = 0, len = $scope.cameraAlarmConfList.length; i < len; i += 1) {
                idList += $scope.cameraAlarmConfList[i].id + ",";
                typeList += $scope.cameraAlarmConfList[i].type + ",";
                notifyOnList += $scope.cameraAlarmConfList[i].notifyOn + ",";
              }
            }
            Shop.updateShopSecAlarmConfig({
              shopId: $scope.shopObject.shopId
            }, {
              id: idList,
              type: typeList,
              notifyOn: notifyOnList
            }, function (res) {
              $scope.setShopAlarmDialogStatus("main", true);
            }, function (err) {
              showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
            });
          };
          $scope.savePlugAlarmConf = function () {
            var i,
              len,
              idList = "",
              typeList = "",
              notifyOnList = "";
            if ($scope.shopPlugAlarmConfData) {
              idList += $scope.shopPlugAlarmConfData.id + ",";
              typeList += $scope.shopPlugAlarmConfData.type + ",";
              notifyOnList += $scope.shopPlugAlarmConfData.notifyOn + ",";
            }
            if ($scope.shopPlugAlarmConfigList) {
              for (i = 0, len = $scope.shopPlugAlarmConfigList.length; i < len; i += 1) {
                idList += $scope.shopPlugAlarmConfigList[i].id + ",";
                typeList += $scope.shopPlugAlarmConfigList[i].type + ",";
                notifyOnList += $scope.shopPlugAlarmConfigList[i].notifyOn + ",";
              }
            }
            Shop.setShopPlugAlarmConfig({
              shopId: $scope.shopObject.shopId
            }, {
              id: idList,
              type: typeList,
              notifyOn: notifyOnList
            }, function (res) {
              $scope.setShopAlarmDialogStatus("main", true);
            }, function (err) {
              showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
            });
          };
          $scope.saveTempAlarmConf = function () {
            Shop.updateShopTempAlarmConfig({
              shopId: $scope.shopObject.shopId
            }, {
              id: $scope.shopTempAlarmData.id,
              type: $scope.shopTempAlarmData.type,
              notifyOn: $scope.shopTempAlarmData.notifyOn
            }, function (res) {
              $scope.setShopAlarmDialogStatus("main", true);
            }, function (err) {
              showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
            });
          };
          $scope.getSensorTypeStr = function (sensorType) {
            if (sensorType === "MOTION") {
              return $translate.instant("EVENT_LIST_MOTION");
            } else if (sensorType === "MAGNETIC") {
              return $translate.instant("STR_DOOR_OPEN");
            } else if (sensorType === "TEMP_HUMID") {
              return $translate.instant("STR_TEMP_HUMID");
            } else if (sensorType === "SMOKE") {
              return $translate.instant("STR_SMOKE");
            } else if (sensorType === "GAS") {
              return $translate.instant("STR_GAS");
            } else if (sensorType === "PLUG") {
              return $translate.instant("STR_PLUG");
            }
          };
          PUSH_UNSUPPORTED_RECORD_TYPE = /live/i;
          PUSH_SUPPORT_RECORD_TYPES_STATUS = {
            LOADING: "LOADING",
            Y: "Y",
            N: "N"
          }; // ! 카메라 정보 조회
          // ! 푸시 설정 미지원, 푸시 비활성화 처리
          $scope.savePosAlarmConfig = function () {
            Shop.updateShopPosAlarmConfig({
              shopId: $scope.shopObject.shopId
            }, {
              posNotifyOn: $scope.posAlarmConfig.posNotifyOn,
              posNotifyType: $scope.posAlarmConfig.posNotifyType
            }, function (res) {
              $scope.setShopAlarmDialogStatus("main", true);
            }, function (err) {
              showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
            });
          };
          $scope.togglePosAlarm = function () {
            if (!$scope.posAlarmConfig) {
              return;
            }
            $scope.posAlarmConfig.posNotifyOn = $scope.posAlarmConfig.posNotifyOn === "on" ? "off" : "on";
          };
          $scope.toggleTempAlarm = function () {
            if (!$scope.shopTempAlarmData) {
              return;
            }
            $scope.shopTempAlarmData.notifyOn = $scope.shopTempAlarmData.notifyOn === "on" ? "off" : "on";
          };
          $scope.toggelTempSensorAlarm = function () {
            if (!$scope.curEditTempAlarmConf) {
              return;
            }
            $scope.curEditTempAlarmConf.notifyOn = $scope.curEditTempAlarmConf.notifyOn === "on" ? "off" : "on";
          };
          $scope.saveTempSensorAlarmConf = function () {
            if (!$scope.curEditTempAlarmConf) {
              return;
            }
            $scope.curEditTempAlarmConf.minTemp = parseInt($scope.curEditTempAlarmConf.minTemp, 10);
            $scope.curEditTempAlarmConf.maxTemp = parseInt($scope.curEditTempAlarmConf.maxTemp, 10);
            $scope.curEditTempAlarmConf.minHumid = parseInt($scope.curEditTempAlarmConf.minHumid, 10);
            $scope.curEditTempAlarmConf.maxHumid = parseInt($scope.curEditTempAlarmConf.maxHumid, 10);
            if (isNaN($scope.curEditTempAlarmConf.minTemp) || isNaN($scope.curEditTempAlarmConf.maxTemp) || isNaN($scope.curEditTempAlarmConf.minHumid) || isNaN($scope.curEditTempAlarmConf.maxHumid)) {
              showAlert($translate.instant("SHARE_FAIL3"), $translate.instant("SHARE_FAIL3_MSG"));
              return;
            }
            if ($scope.curEditTempAlarmConf.maxTemp < $scope.curEditTempAlarmConf.minTemp) {
              showAlert($translate.instant("SHARE_FAIL3"), $translate.instant("SHARE_FAIL3_MSG"));
              return;
            }
            if ($scope.curEditTempAlarmConf.maxHumid < $scope.curEditTempAlarmConf.minHumid) {
              showAlert($translate.instant("SHARE_FAIL3"), $translate.instant("SHARE_FAIL3_MSG"));
              return;
            }
            Shop.updateTempAlarmConfig({
              sensorId: $scope.curEditTempAlarmConf.id
            }, {
              notifyOn: $scope.curEditTempAlarmConf.notifyOn,
              alarmConfig: $scope.curEditTempAlarmConf.alarmConfig,
              minTemp: $scope.curEditTempAlarmConf.minTemp,
              maxTemp: $scope.curEditTempAlarmConf.maxTemp,
              minHumid: $scope.curEditTempAlarmConf.minHumid,
              maxHumid: $scope.curEditTempAlarmConf.maxHumid
            }, function (res) {
              if (res.code === "ok") {
                var tempAlarmConf = _.find($scope.shopTempAlarmConfigList, {
                  id: $scope.curEditTempAlarmConf.id
                });
                if (tempAlarmConf) {
                  tempAlarmConf.notifyOn = $scope.curEditTempAlarmConf.notifyOn;
                }
              }
              $scope.setShopAlarmDialogStatus("temp", false);
            }, function (err) {
              showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
            });
          };
          $scope.setShopAlarmDialogStatus = function (state, isRefresh, data) {
            $scope.isShowShopSetting = false;
            $scope.isShowSecureAlarmDialog = false;
            $scope.isShowTempAlarmDialog = false;
            $scope.isShowTempEventDialog = false;
            $scope.isShowPosAlarmDialog = false;
            $scope.isShowPlugAlarmDialog = false;
            if (state === "main") {
              if (isRefresh) {
                getShopAlarmConfig();
              }
              $scope.isShowShopSetting = true;
            } else if (state === "secure") {
              getSecureAlarmConfig();
              $scope.isShowSecureAlarmDialog = true;
            } else if (state === "temp") {
              if (isRefresh) {
                getShopTempAlarmConfig();
              }
              $scope.isShowTempAlarmDialog = true;
            } else if (state === "temp_event") {
              if (data) {
                setCurEditTempAlarmConf(data);
              }
              $scope.isShowTempEventDialog = true;
            } else if (state === "pos") {
              getPosAlarmConfig();
              $scope.isShowPosAlarmDialog = true;
            } else if (state === "access") {
              $scope.showShopAccessConfigDialog();
            } else if (state === "plug") {
              getShopPlugAlarmConfig();
              $scope.isShowPlugAlarmDialog = true;
            }
          };
          $scope.formattedDate = function (date) {
            var format = d3.time.format($translate.instant("DATE_FORMAT_3"));
            return format(new Date(date));
          };
          $scope.formattedTime = function (date) {
            var targetDate = moment($scope.accessDate).format("YYYYMMDD");
            var todayTime = moment().format("YYYYMMDD");
            var paramDate = moment(date).format("YYYYMMDD");
            var hourFormat = d3.time.format("%H");
            var minFormat = d3.time.format("%M");
            var hourVal = "00";
            var minVal = "00";
            var todayVal = false;
            if (targetDate == paramDate) {
              hourVal = hourFormat(new Date(date));
              minVal = minFormat(new Date(date));
            }
            if (todayTime == targetDate) {
              if (moment().format("YYYYMMDDHHmm") < moment(date).format("YYYYMMDDHHmm")) {
                hourVal = hourFormat(new Date());
                minVal = minFormat(new Date());
                todayVal = true;
              }
            }
            var returnVal = {
              hour: hourVal,
              min: minVal,
              today: todayVal
            };
            return returnVal;
          };
          $scope.initShowAccessModifyLayer = function () {
            if (!$scope.currentShop.shopStaffs) {
              return;
            }
            $scope.saveStaffAccessDateList = [];
            $scope.shopStaffsInfo = $scope.currentShop.shopStaffs;
            var defultVal = {
              hour: "00",
              min: "00",
              today: false
            };
            for (i = 0; i < $scope.shopStaffsInfo.length; i++) {
              if ($scope.shopStaffsInfo[i].staffEvent.length == 0) {
                $scope.shopStaffsInfo[i].accessTimeIn = defultVal;
                $scope.shopStaffsInfo[i].accessTimeOut = defultVal;
              } else {
                $scope.shopStaffsInfo[i].accessTimeIn = $scope.formattedTime($scope.shopStaffsInfo[i].staffEvent[0].enterDate);
                $scope.shopStaffsInfo[i].accessTimeOut = $scope.formattedTime($scope.shopStaffsInfo[i].staffEvent[$scope.shopStaffsInfo[i].staffEvent.length - 1].exitDate);
              }
            }
          };
          $scope.sliceStrFromNumber = function (str) {
            if (str) {
              return str.replace(/^(\+|\-)\s/g, "");
            } else {
              return "";
            }
          };
          $scope.goDetail = function (cameraId, shopId) {
            if ($scope.isShared) {
              $state.go("main.cameraDetail", {
                cameraId: cameraId,
                type: "sharedshop",
                id: shopId,
                shared: true
              });
            } else {
              $state.go("main.cameraDetail", {
                cameraId: cameraId,
                type: "shop",
                id: shopId
              });
            }
          };
          $scope.playEvent = function (event) {
            if (event && (event.landingPage === "event" || event.landingPage === "camera")) {
              if ($scope.isShared) {
                $state.go("main.cameraDetail", {
                  cameraId: event.cameraId,
                  type: "sharedshop",
                  id: $scope.shopObject.shopId,
                  time: event.regDate,
                  shared: true
                });
              } else {
                $state.go("main.cameraDetail", {
                  cameraId: event.cameraId,
                  type: "shop",
                  id: $scope.shopObject.shopId,
                  time: event.regDate
                });
              }
            }
          };
          $scope.playAiEvent = function (event) {
            $scope.eventInfo = event;
            $scope.isShowAiFaceEventPlayDialog = true;
          };
          $scope.hideAlert = function () {
            $scope.showAlert = false;
          };
          $scope.goSubPage = function (pageName, event) {
            if (pageName === "main.dashboard.pos") {
              if ($scope.shopObject) {
                goPosSubPage(pageName, $scope.shopObject);
              }
            } else if (pageName === "main.dashboard.event") {
              if ($scope.shopObject) {
                if (event) {
                  $state.go(pageName, {
                    shopId: $scope.shopObject.shopId,
                    shared: $scope.isShared,
                    eventId: event.eventId
                  });
                } else {
                  $state.go(pageName, {
                    shopId: $scope.shopObject.shopId,
                    shared: $scope.isShared
                  });
                }
              }
            } else if (pageName === "main.dashboard.aifaceEvent") {
              if ($scope.shopObject) {
                if (event) {
                  var cloud = false,
                    i,
                    len = $scope.cameraList.length;
                  for (i = 0; i < len; i += 1) {
                    if ($scope.cameraList[i].id === event.deviceId) {
                      cloud = $scope.cameraList[i].cloud;
                      break;
                    }
                  }
                  if (cloud) {
                    if ($scope.isShared) {
                      $state.go("main.cameraDetail", {
                        cameraId: event.deviceId,
                        type: "sharedshop",
                        id: $scope.shopObject.shopId,
                        time: event.detectDate - 4000,
                        shared: true
                      });
                    } else {
                      $state.go("main.cameraDetail", {
                        cameraId: event.deviceId,
                        type: "shop",
                        id: $scope.shopObject.shopId,
                        time: event.detectDate - 4000
                      });
                    }
                  } else {
                    if ($scope.isShared) {
                      $state.go("main.cameraDetail", {
                        cameraId: event.deviceId,
                        type: "sharedshop",
                        id: $scope.shopObject.shopId,
                        shared: true
                      });
                    } else {
                      $state.go("main.cameraDetail", {
                        cameraId: event.deviceId,
                        type: "shop",
                        id: $scope.shopObject.shopId
                      });
                    }
                  }
                  //$state.go(pageName, {shopId: $scope.shopObject.shopId, shared: $scope.isShared, eventId: event.eventId});
                } else {
                  $state.go(pageName, {
                    shopId: $scope.shopObject.shopId,
                    shared: $scope.isShared
                  });
                }
              }
            } else if (pageName === "main.dashboard.aifacePeopleEvent") {
              if ($scope.shopObject) {
                $state.go(pageName, {
                  shopId: $scope.shopObject.shopId,
                  shared: $scope.isShared
                });
              }
            } else {
              if ($scope.shopObject) {
                $state.go(pageName, {
                  shopId: $scope.shopObject.shopId,
                  shared: $scope.isShared,
                  aiShop: $scope.isShopAiSetted
                });
              }
            }
          };

          /**
           * 출입 관리 직원 목록 호출
           */
          $scope.getAccessStaffs = function (shopId) {
            $scope.isLoadingComplete = false;
            Access.getAccessStaffs({
              searchDate: $filter("date")($scope.accessDate, "yyyyMMdd")
            }).$promise.then(function (res) {
              $scope.shops = res.myShops;
              $scope.sharedShops = res.sharedShops;
              $scope.hiredShops = [];
              var filterHiredShop, filterHiredShop2;
              for (i = 0; i < res.hiredShops.length; i++) {
                if ($scope.shops.length > 0) {
                  filterHiredShop = _.find($scope.shops, {
                    shopId: res.hiredShops[i].shopId
                  });
                }
                if ($scope.sharedShops.length > 0 && !filterHiredShop) {
                  filterHiredShop2 = _.find($scope.sharedShops, {
                    shopId: res.hiredShops[i].shopId
                  });
                }
                if (!filterHiredShop && !filterHiredShop2) {
                  $scope.hiredShops.push(res.hiredShops[i]);
                }
              }

              // shop 데이터 병합
              $scope.allShops = [];
              if ($scope.shops && $scope.shops.length > 0) {
                $scope.allShops = $scope.shops;
              }
              if ($scope.sharedShops && $scope.sharedShops.length > 0) {
                $scope.allShops = $scope.allShops.concat($scope.sharedShops);
              }
              if ($scope.hiredShops && $scope.hiredShops.length > 0) {
                $scope.allShops = $scope.allShops.concat($scope.hiredShops);
              }
              if (typeof shopId === "undefined" || shopId === "") {
                $scope.currentShop = $scope.shops[0];
                if ($scope.currentShop == null) {
                  $scope.currentShop = $scope.sharedShops[0];
                }
                if ($scope.currentShop == null) {
                  $scope.currentShop = $scope.hiredShops[0];
                }
              } else {
                $scope.currentShop = $scope.shops.filter(function (value) {
                  return value.shopId === shopId;
                })[0];
                if ($scope.currentShop == null) {
                  $scope.currentShop = $scope.sharedShops.filter(function (value) {
                    return value.shopId === shopId;
                  })[0];
                }
                if ($scope.currentShop == null) {
                  $scope.currentShop = $scope.hiredShops.filter(function (value) {
                    return value.shopId === shopId;
                  })[0];
                }
              }
              if ($scope.currentShop) {
                $scope.initShowAccessModifyLayer();
              }
            }, function (err) {
              showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
            })["finally"](function () {
              $scope.isLoadingComplete = true;
              $scope.currentTime = moment().format("HH:mm");
              $scope.currentTimedotArea();
            });
          };
          $scope.currentTimedotArea = function () {
            $timeout(function () {
              var currentTimedotArea = $(".currentTimeDot").parent()[0];
              if (currentTimedotArea) {
                $scope.divX = $(currentTimedotArea).offset().left;
                $scope.divY = $(currentTimedotArea).offset().top;
                $(".dotted_time").css("left", $scope.divX);
                $(".dotted_time").css("top", $scope.divY);
              }
            });
          };
          $scope.staffNameJoin = function (staffs) {
            if (!staffs || !staffs.length) {
              return "";
            }
            return staffs.join(',<span class="space"></span>');
          };

          /**
           * 매장 출입설정 dialog open
           */
          $scope.showShopAccessConfigDialog = function () {
            $scope.isShowStaffRegistDialog = true;
          };
          $scope.$on("showAiCamAddDlg", function (event, data) {
            $scope.showAiCamAddDlg();
          });
          $scope.$on("showPeopleEvtPlayerDlg", function (event, param) {
            $scope.showPeopleEvtPlayer(param);
          });
          $scope.$on("showLockFaceCamDlg", function (event, data) {
            $scope.showLockFaceCamDlg();
          });
          $scope.$on("showLockFacePeopleDlg", function (event, data) {
            $scope.showLockFacePeopleDlg();
          });
          $scope.$on("deviceUpdate", function (event, selectSensorId) {
            updateIoTDevices(selectSensorId);
          });
          $scope.$on("didUpdate", function (event, data) {
            Shop.dashboardDidList({
              shopId: $scope.currentShop.shopId
            }, function (res) {
              var didItem = _.find($scope.dashboardItems, {
                object: $scope.objectEnum.DID
              });
              if (didItem) {
                if (res.dids && res.dids.length) {
                  didItem.dids = res.dids;
                  didItem.status = res.title;
                } else {
                  $scope.dashboardItems = _.without($scope.dashboardItems, didItem);
                }
              }
            });
          });
          $scope.$on("sensorDetail", function (event, sensorId) {
            $scope.isShowIothubSetDialog = false;
            $scope.openSensorDetailWithId(sensorId);
          });

          /**
           * 매장 수정하기 레이어 열기
           */
          $scope.showModifyShopDialog = function () {
            $scope.isShowAddShopDialog = true;
          };

          /**
           * 매장 추가/수정 레이어 닫기
           */
          $scope.hideAddShopDialog = function () {
            $scope.isShowAddShopDialog = false;
          };

          /**
           * 매장 추가/수정 저장
           */
          $scope.saveShop = function (isShopEditMode) {
            var title = isShopEditMode ? $translate.instant("SHOP_CHANGE") : $translate.instant("SHOP_ADD");
            var params,
              cameras = [],
              iothubs = [];
            if ($scope.shopControllers) {
              cameras = $scope.myShopControllers.filter(function (controller) {
                return controller.deviceType === "CAMERA";
              }).map(function (controller) {
                return controller.deviceId;
              });
              iothubs = $scope.myShopControllers.filter(function (controller) {
                return controller.deviceType === "IOTHUB";
              }).map(function (controller) {
                return controller.deviceId;
              });
            }
            if ($scope.countryDomain === "ko") {
              params = {
                shopName: $scope.shopAddModel.shopName,
                zipCode: "",
                //$scope.shopAddModel.zipCode,
                address1: "",
                //$scope.shopAddModel.address1,
                address2: "",
                //$scope.shopAddModel.address2,
                timezone: $scope.shopAddModel.timezone,
                language: $scope.shopAddModel.language,
                access: $scope.shopAddModel.access,
                cameraIds: cameras.join(","),
                iotHubIds: iothubs.join(",")
              };
            } else {
              params = {
                shopName: $scope.shopAddModel.shopName,
                zipCode: "",
                address1: "",
                address2: "",
                cameraIds: cameras.join(","),
                iotHubIds: iothubs.join(",")
              };
            }
            if (!params.shopName || params.shopName.trim() === "") {
              showAlert(title, $translate.instant("SHOP_NAME_INPUT"));
              return;
            }
            if (params.cameraIds.length < 1 && params.iotHubIds.length < 1) {
              showAlert(title, $translate.instant("POS_CAMERA_SELECT"));
              return;
            }

            // 2023-01-03 매장 주소 입력 제거
            // if ($scope.countryDomain === 'ko') {
            //     if (!params.zipCode || !params.address1 || !params.address2) {
            //         showAlert(title, $translate.instant("STR_INPUT_ADDRESS"));
            //         return;
            //     }
            // }

            if ($scope.countryDomain === "ko") {
              if (isShopEditMode) {
                Shop.updateShopV2({
                  shopId: $scope.shopObject.shopId
                }, params, function (res) {
                  if (res.code === "ok") {
                    showAlert(title, $translate.instant("SHOP_SET_CHANGED"));
                    if (dashboardShopObj) {
                      $rootScope.dashboardShopList = null;
                      $state.go("main.dashboard.shop", {
                        shop: JSON.stringify(dashboardShopObj)
                      }, {
                        reload: true
                      });
                    }
                  } else {
                    showAlert(title, $translate.instant("SHOP_SET_CHANGE_FAIL"));
                  }
                }, function (err) {
                  showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
                });
              } else {
                Shop.regShopV2(params, function (res) {
                  if (res.code === "ok") {
                    $scope.isShowAddShopDialog = false;
                    showAlert(title, $translate.instant("SHOP_ADDED"));
                    $rootScope.dashboardShopList = null;
                    if (dashboardShopObj) {
                      $state.go("main.dashboard.shop", {
                        shop: JSON.stringify(dashboardShopObj)
                      }, {
                        reload: true
                      });
                    } else {
                      $("body").removeClass("blockScroll");
                      $location.url("/dashboard/shop/");
                      $window.location.reload();
                    }
                  } else {
                    showAlert(title, $translate.instant("SHOP_ADD_FAIL"));
                  }
                }, function (err) {
                  showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
                });
              }
            } else {
              if (isShopEditMode) {
                Shop.updateShopV2({
                  shopId: $scope.shopObject.shopId
                }, params, function (res) {
                  if (res.code === "ok") {
                    showAlert(title, $translate.instant("SHOP_SET_CHANGED"));
                    if (dashboardShopObj) {
                      $rootScope.dashboardShopList = null;
                      $state.go("main.dashboard.shop", {
                        shop: JSON.stringify(dashboardShopObj)
                      }, {
                        reload: true
                      });
                    }
                  } else {
                    showAlert(title, $translate.instant("SHOP_SET_CHANGE_FAIL"));
                  }
                }, function (err) {
                  showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
                });
              } else {
                Shop.regShopV2(params, function (res) {
                  $scope.isShowAddShopDialog = false;
                  showAlert(title, $translate.instant("SHOP_ADDED"));
                  $rootScope.dashboardShopList = null;
                  if (dashboardShopObj) {
                    $state.go("main.dashboard.shop", {
                      shop: JSON.stringify(dashboardShopObj)
                    }, {
                      reload: true
                    });
                  } else {
                    $("body").removeClass("blockScroll");
                    $location.url("/dashboard/shop/");
                    $window.location.reload();
                  }
                }, function (err) {
                  showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
                });
              }
            }
          };

          /**
           * 매장 삭제 확인 팝업 열기
           */
          $scope.showShopDeleteConfirm = function () {
            $rootScope.createConfirm({
              title: $translate.instant("SHOP_REMOVE"),
              description: "'" + $scope.shopObject.shopName + "' " + $translate.instant("SHOP_IS_REMOVE") + "<br>" + $translate.instant("SHOP_REMOVE_INFO_DELETE"),
              handler: $scope.deleteShop
            });
          };

          /**
           * 매장 삭제
           */
          $scope.deleteShop = function () {
            var _$scope$shopObject;
            var deletedShopId = (_$scope$shopObject = $scope.shopObject) === null || _$scope$shopObject === void 0 ? void 0 : _$scope$shopObject.shopId;
            Shop.deleteShop({
              shopId: $scope.shopObject.shopId
            }, function () {
              if (deletedShopId && $rootScope.dashboardShopList) {
                $rootScope.dashboardShopList = $rootScope.dashboardShopList.filter(function (shop) {
                  return shop.shopId !== deletedShopId;
                });
              }
              $scope.shopObject = undefined;
              $scope.isShowAddShopDialog = false;
              $("body").removeClass("blockScroll");

              // 3. URL 정리
              $location.search("shopId", null);
              $location.search("shop", null);
              $location.search("posExists", null);
              showAlert($translate.instant("SHOP_REMOVE"), $translate.instant("SHOP_REMOVE_DESC"), undefined, true, function () {
                return $state.go("main.dashboard.shop", {}, {
                  reload: true
                });
              });
            }, function (err) {
              showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
            });
          };

          /**
           * 매장 추가/수정 팝업 카메라 목록에서 다른 매장에 이미
           * 등록된 카메라 선택했을 시 알림 팝업 호출
           * @param  {Object} camera
           */
          $scope.validController = function (controller, isShopEditMode) {
            /**
             * 등록일 경우엔 shopId가 없으면 팝업 열고,
             * 수정일 경우엔 현재 shopId와 다르거나 shopId가 존재하면 팝업 열기
             */
            $scope.controllerListCheckedToggle(controller);
            if (controller.isChecked !== true) return;
            if (!isShopEditMode && typeof controller.shopId !== "undefined" && controller.shopId !== null || isShopEditMode && controller.shopId !== $scope.shopObject.shopId && typeof controller.shopId !== "undefined" && controller.shopId !== null) {
              $scope.isShowCheckedCameraConfirm = true;
              $scope.checkedCamera = controller;
            }
          };
          $scope.controllerListCheckedToggle = function (controller) {
            var index = $scope.myShopControllers.findIndex(function (myController) {
              return myController.deviceId == controller.controllerId;
            });
            if (index >= 0) {
              $scope.myShopControllers.splice(index, 1);
            } else {
              controller.deviceId = controller.controllerId;
              controller.deviceType = controller.controllerType;
              $scope.myShopControllers.push(controller);
            }
          };

          /**
           * 매장 추가/수정 팝업에서 카메라 체크 확인 팝업 닫기
           */
          $scope.hideCheckedCameraConfirm = function () {
            $scope.isShowCheckedCameraConfirm = false;
          };

          /**
           * 매장 추가/수정 팝업에서 카메라 체크 취소
           */
          $scope.cancelCameraCheck = function () {
            $scope.checkedCamera.isChecked = false;
            $scope.controllerListCheckedToggle($scope.checkedCamera);
            $scope.isShowCheckedCameraConfirm = false;
          };

          /**
           * 매장 공유 설정 dialog open
           */
          $scope.showShopShareConfig = function () {
            Shop.getShareReceivers({
              shopId: $scope.shopObject.shopId
            }, function (res) {
              $scope.shareReceivers = res;
              $scope.shareAddModel = {
                shareOptions: ["1", "0", "0", "0"]
              };
              $scope.isShowShopShareConfig = true;
            }, function (err) {
              showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
            });
          };

          /**
           * 매장 공유 설정 dialog close
           */
          $scope.hideShopShareConfig = function () {
            $scope.isShowShopShareConfig = false;
          };
          deleteShareId = "";
          /**
           * 매장 공유 해제 팝업 열기
           */
          $scope.showShopShareCancelDialog = function (shareId) {
            deleteShareId = shareId;
            $rootScope.createConfirm({
              title: $translate.instant("SHARE_REMOVE_TITLE"),
              description: $translate.instant("SHARE_REMOVE_MSG1") + " " + $translate.instant("SHARE_REMOVE_MSG2"),
              handler: $scope.cancelShopShare
            });
          };

          /**
           * 매장 공유 해제
           * @return {[type]} [description]
           */
          $scope.cancelShopShare = function () {
            Shop.deleteShopShare({
              shareId: deleteShareId
            }, function (res) {
              if (res.code === "ok") {
                $scope.shareReceivers = Shop.getShareReceivers({
                  shopId: $scope.shopObject.shopId
                });
              } else {
                showAlert($translate.instant("SHARE_RELEASE"), $translate.instant("SHARE_RELEASE_FAIL"));
              }
            }, function (err) {
              showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
            });
          };

          /**
           * 매장 공유 옵션 설정 변경 팝업 열기
           */
          shopShareId = "";
          $scope.showShopShareOptionConfigDialog = function (shareId) {
            Shop.getShopShareOption({
              shareId: shareId
            }, function (res) {
              // debugger
              var checkList = [{
                id: "shareOpt1",
                text: $translate.instant("STR_SHARE_EVENT_NECESSARY"),
                value: res.shareOptions[0] === "1",
                disabled: true
              }, {
                id: "shareOpt2",
                text: $translate.instant("CAMERA_CLIP_TIME_SHARE"),
                value: res.shareOptions[1] === "1"
              }, {
                id: "shareOpt3",
                text: $translate.instant("SHOP_SHARE_ALL_INFO"),
                value: res.shareOptions[2] === "1"
              }, {
                id: "shareOpt4",
                text: $translate.instant("SHOP_SHARE_SUM_INFO"),
                value: res.shareOptions[3] === "1"
              }, {
                id: "shareOpt5",
                text: $translate.instant("STR_DID_SHARE"),
                value: res.shareOptions[4] === "1"
              }];
              checkList.splice(2, 1); //remove 근태관리
              if ($scope.countryDomain !== "ko") {
                checkList.splice(2, 1); //remove pos option
              }
              shopShareId = res.shareId;
              $rootScope.createConfirm({
                title: $translate.instant("CAMERA_SHARE_SET_CHANGE"),
                width: 460,
                theme: "checker",
                pCheckList: checkList,
                handler: $scope.saveShopShareOption
              });
            }, function (err) {
              showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
            });
          };

          /**
           * 매장 공유 옵션 설정 변경 저장
           * @return {[type]} [description]
           */
          $scope.saveShopShareOption = function (event) {
            var values = [];
            event.value.forEach(function (item) {
              values.push(item.value ? "1" : "0");
            });
            values.splice(2, 0, "0"); // remove 근태관리
            if ($scope.countryDomain !== "ko") {
              values.splice(2, 0, "0");
            }
            var params = {
              shareOptions: values.join(",")
            };
            Shop.updateShopShareOption({
              shareId: shopShareId
            }, params, function (res) {
              if (res.code !== "ok") {
                showAlert($translate.instant("CAMERA_SHARE_SET_CHANGE"), $translate.instant("CAMERA_SHARE_SET_CHANGE_FAIL"));
              }
            }, function (err) {
              showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
            });
          };

          /**
           * 매장 공유 추가 팝업 open
           * @return {[type]} [description]
           */
          $scope.showShopShareAddDialog = function () {
            $scope.isShowShopShareAddDialog = true;
          };

          /**
           * 매장 공유 추가 팝업 close
           * @return {[type]} [description]
           */
          $scope.hideShopShareAddDialog = function () {
            $scope.isShowShopShareAddDialog = false;
          };

          /**
           * 클라우드 모니터 권한체크 및 처리
           */
          $scope.checkMonitorAccess = function () {
            Monitor.api.getInfo({}, function (data) {
              if (data.code === "ok") {
                if (data.isCloudMonitorUser) {
                  $rootScope.createConfirm({
                    theme: "center",
                    title: $translate.instant("STR_MONITOR_SHOP_SHARE"),
                    description: $translate.instant("STR_MONITOR_SHARE_GO"),
                    handler: $scope.addShopShare
                  });
                } else {
                  $scope.addShopShare();
                }
              } else {
                showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
              }
            }, function (err) {
              showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
            });
          };

          /**
           * 매장 공유 추가 저장
           */
          $scope.addShopShare = function () {
            var params = {
              receiverName: $scope.shareAddModel.nickName,
              receiverId: $scope.shareAddModel.paycoId,
              shareOptions: $scope.shareAddModel.shareOptions.join(",")
            };
            var validPhone = Utils.phoneNumberVaild(Utils.toFormattedPhoneNumber(params.receiverId));
            var validEmail = Utils.emailValid(Utils.toFormattedPhoneNumber(params.receiverId));
            if (validPhone == false && validEmail == false) {
              if ($scope.isShowSalesBtn) {
                showAlert($translate.instant("CAMERA_SHARE_ADD"), $translate.instant("ACCESS_ENTER_NUMBER"));
              } else {
                showAlert($translate.instant("CAMERA_SHARE_ADD"), $translate.instant("CORRECT_EMAIL"));
              }
              return;
            } else if (validPhone == true && validEmail == false) {
              params.receiverId = params.receiverId.replace(/-/gi, ""); // mibile 계정일 경우 "-" 제거
            }

            // 공유 최대 갯수 확인
            // user me 에서 페이코 계정 비교 후 자기계정인지 확인
            // 이미 공유된 계정인지 확인
            // 82 국가 번호 붙여주기?
            Shop.regShopShare({
              shopId: $scope.shopObject.shopId
            }, params, function (res) {
              $scope.shareReceivers = Shop.getShareReceivers({
                shopId: $scope.shopObject.shopId
              });
              $scope.shareAddModel = {
                shareOptions: ["1", "0", "0", "0"]
              };
            }, function (err) {
              showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
            });
          };
          $scope.settingOpenCallback = function (_ref3) {
            var isOpen = _ref3.isOpen,
              cameraData = _ref3.cameraData,
              isShared = _ref3.isShared;
            $scope.$apply(function () {
              $scope.isCameraSettingOpen = isOpen;
              $scope.currentCamera = cameraData;
              angular.extend($scope.currentCamera, {
                isShared: isShared
              });
            });
          };

          /**
           * 공유받은 매장 팝업 open
           */
          $scope.showSharedShopDialog = function () {
            rejectShareId = $scope.shopObject.shareId;
            $scope.isShowSharedShopDialog = true;
          };

          /**
           * 공유받은 매장 팝업 close
           */
          $scope.hideSharedShopDialog = function () {
            $scope.isShowSharedShopDialog = false;
          };

          /**
           * 공유받은 매장 해제 확인 팝업 open
           */
          $scope.showSharedShopRejectConfirm = function (shopId) {
            $rootScope.createConfirm({
              title: $translate.instant("SHOP_SHARE_CONFIRM"),
              description: $translate.instant("SHOP_SHARE_RELEASE"),
              handler: $scope.rejectSharedShop
            });
          };

          /**
           * 공유받은 매장 해제 처리
           */
          $scope.rejectSharedShop = function () {
            if ($scope.shopObject) {
              rejectShareId = $scope.shopObject.shareId;
            }
            Shop.rejectShopShare({
              shareId: rejectShareId
            }, {}, function (res) {
              if (res.code === "ok") {
                $scope.hideSharedShopDialog();
                $rootScope.dashboardShopList = null;
                $state.go("main.dashboard.shop", {
                  shop: null
                }, {
                  reload: true
                });
              } else {
                showAlert($translate.instant("SHARE_SHOP_RELEASE"), $translate.instant("SHARE_SHOP_RELEASE_FAIL"));
              }
            }, function (err) {
              showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
            });
          };
          $scope.closeControllerStatusNotice = function (event) {
            if (event.target) {
              var className = event.target.className;
              if (className.indexOf("close_white_btn") != -1) {
                $scope.controllStatusNoticeShow = false;
                $scope.controllStatusMsg = "";
              }
            }
          };
          $scope.goHome = function () {
            $state.go("main");
          };
          $scope.goInquiry = function () {
            $state.go("main.help.inquiry", {
              type: $scope.countryDomain != "ja" ? "cam_buy" : "cam_buy_jp"
            });
          };
          $(window).resize(resizeHandler);
          $rootScope.$watch("isLnbOff", function (newValue, prevValue) {
            if (newValue !== prevValue) {
              setTimeout(function () {
                resizeHandler();
              }, 100);
            }
          });
          shopListUpdateListener = $scope.$on("updateShopList", function (event, data) {
            if (!dashboardShopObj) {
              if ($rootScope.dashboardShopList && $rootScope.dashboardShopList.length) {
                dashboardShopObj = $rootScope.dashboardShopList[0];
                if (dashboardShopObj) {
                  initShop(dashboardShopObj);
                }
              }
            }
          });
          $scope.$on("updateShop", function (event, data) {
            initShop(dashboardShopObj);
          });
          if ($stateParams.shopId && $stateParams.myShop !== undefined && $stateParams.posExists !== undefined) {
            dashboardShopObj = {
              shopId: $stateParams.shopId,
              myShop: $stateParams.myShop === "true",
              posExists: $stateParams.posExists === "true"
            };
            if (dashboardShopObj) {
              initShop(dashboardShopObj);
            } else {
              $scope.isShopLoaded = true;
            }
          } else {
            if ($rootScope.dashboardShopList && $rootScope.dashboardShopList.length) {
              dashboardShopObj = $rootScope.dashboardShopList[0];
              if (dashboardShopObj) {
                dashboardShopObj = {
                  shopId: dashboardShopObj.shopId,
                  myShop: dashboardShopObj.myShop,
                  posExists: dashboardShopObj.posExists
                };
                initShop(dashboardShopObj);
              } else {
                $scope.isShopLoaded = true;
              }
            } else {
              $scope.isShopLoaded = true;
            }
          }
          appendDlg();
        case 223:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function (_x, _x2, _x3, _x4, _x5, _x6, _x7, _x8, _x9, _x10, _x11, _x12, _x13, _x14, _x15, _x16, _x17, _x18, _x19, _x20, _x21, _x22, _x23, _x24) {
    return _ref.apply(this, arguments);
  };
}())]);
"use strict";

app.controller("DashboardShopListCtrl", ["$scope", "$rootScope", "$stateParams", "$state", "$translate", "Shop", function ($scope, $rootScope, $stateParams, $state, $translate, Shop) {
  $scope.allShopList = [];
  $scope.loadShop = false;
  $scope.isShowCS = window.country !== "ja";
  $scope.curShopId = $stateParams.shopId ? $stateParams.shopId : null;
  $scope.ORDER_TYPE_ENUM = {
    REG_ASC: "1",
    REG_DESC: "2",
    NAME_ASC: "3",
    NAME_DESC: "4"
  };
  $scope.searchShop = {
    shopName: ""
  };
  var shopSearchObj = null;
  var orderDropObj = null;
  function shopSearchHandler(event) {
    if ($scope.searchShop.shopName != event.value) {
      $scope.searchShop.shopName = event.value;
      $scope.$apply();
    }
  }
  shopSearchObj = tCam.search("search_shop");
  shopSearchObj.on("changed", shopSearchHandler);
  shopSearchObj.placeholder = $translate.instant("SEARCH");
  shopSearchObj.boxStyle = {
    width: "228px",
    height: "44px",
    border: "1px solid #f5f5f5",
    borderRadius: "6px",
    backgroundColor: "#f5f5f5",
    marginTop: "16px"
  };
  shopSearchObj.design = "search";
  orderDropObj = tCam.dropdown("shop_order_dropdown");
  orderDropObj.dropElementId = "shop_order_list";
  orderDropObj.dropPosition = "left";
  $scope.$on("$destroy", function () {
    $rootScope.dashboardCurShopId = null;
    $("body").off("click", globalClickCallback);
    if ($state.$current.self.name.indexOf("main.dashboard") == -1) {
      $rootScope.searchShop = null;
      if (shopSearchObj) {
        shopSearchObj.destroy();
        shopSearchObj = null;
      }
      if (orderDropObj) {
        orderDropObj.destroy();
        orderDropObj = null;
      }
    } else {
      $rootScope.searchShop = {
        shopName: $scope.searchShop.shopName
      };
    }
  });
  function globalClickCallback(event) {
    if (!event.target.className || !event.target.className.indexOf || event.target.className.indexOf("drops_element") === -1 && event.target.className.indexOf("drop_btn") === -1) {
      if (orderDropObj) {
        orderDropObj.value = false;
      }
    }
  }
  $scope.showShopDashboard = function (shopId, event) {
    event.stopPropagation();
    event.preventDefault();
    var targetShop = _.find($rootScope.dashboardShopList, {
      shopId: shopId
    });
    if (!targetShop) {
      return;
    }
    targetShop = {
      shopId: targetShop.shopId,
      myShop: targetShop.myShop,
      posExists: targetShop.posExists
    };
    $scope.curShopId = shopId;
    $state.go("main.dashboard.shop", {
      shopId: targetShop.shopId,
      myShop: targetShop.myShop,
      posExists: targetShop.posExists
    }, {
      reload: "main.dashboard.shop"
    });
  };
  $scope.showShopSearchInput = function (isShow) {
    if (!$scope.allShopList.length) {
      return;
    }
    if (isShow && shopSearchObj) {
      setTimeout(function () {
        shopSearchObj.setFocus();
      }, 0);
    }
    if (orderDropObj) {
      orderDropObj.value = false;
    }
  };
  $scope.showAddShopDialog = function () {
    $scope.isShowAddShopDialog = true;
  };
  $scope.shopOrderingByType = function (shopList, type) {
    if (!shopList || !shopList.length) {
      return;
    }
    var compareShops = function compareShops(a, b, key) {
      var asc = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      if (!a.myShop === !b.myShop) {
        if (asc) {
          return a[key] < b[key] ? -1 : a[key] > b[key] ? 1 : 0;
        } else {
          return a[key] > b[key] ? -1 : a[key] < b[key] ? 1 : 0;
        }
      } else {
        return !a.myShop ? 1 : -1;
      }
    };
    switch (type) {
      case $scope.ORDER_TYPE_ENUM.REG_ASC:
        shopList.sort(function (a, b) {
          return compareShops(a, b, "regDate", false);
        });
        break;
      case $scope.ORDER_TYPE_ENUM.REG_DESC:
        shopList.sort(function (a, b) {
          return compareShops(a, b, "regDate", true);
        });
        break;
      case $scope.ORDER_TYPE_ENUM.NAME_ASC:
        shopList.sort(function (a, b) {
          return compareShops(a, b, "shopName");
        });
        break;
      case $scope.ORDER_TYPE_ENUM.NAME_DESC:
        shopList.sort(function (a, b) {
          return compareShops(a, b, "shopName", false);
        });
        break;
      default:
        shopList.sort(function (a, b) {
          return compareShops(a, b, "regDate", false);
        });
    }
    $scope.selectedShopOrderType = type;
    setOrderTypeFromLocalStorage($scope.selectedShopOrderType);
    if (orderDropObj) {
      orderDropObj.value = false;
    }
  };
  $scope.deleteSearchShopName = function () {
    $scope.searchShop = {
      shopName: ""
    };
  };
  function createAllShopList(shops) {
    var result = [];
    for (var i = 0, len = shops.length; i < len; i += 1) {
      result.push({
        shopName: shops[i].shopName,
        shopId: shops[i].shopId,
        myShop: shops[i].myShop,
        regDate: shops[i].regDate
      });
    }
    return result;
  }
  function getOrderTypeFromLocalStorage() {
    var clientUid = "";
    if ($rootScope.me && $rootScope.me.uid) {
      clientUid = $rootScope.me.uid;
    }
    var itemKey = "SHOP_ORDERING_" + clientUid,
      orderData = localStorage.getItem(itemKey);
    if (orderData) {
      return orderData;
    } else {
      return $scope.ORDER_TYPE_ENUM.REG_ASC;
    }
  }
  function setOrderTypeFromLocalStorage(type) {
    var clientUid = "";
    if ($rootScope.me && $rootScope.me.uid) {
      clientUid = $rootScope.me.uid;
    }
    var itemKey = "SHOP_ORDERING_" + clientUid;
    localStorage.setItem(itemKey, type);
  }
  function orderingShop() {
    $scope.selectedShopOrderType = getOrderTypeFromLocalStorage();
    $scope.shopOrderingByType($rootScope.dashboardShopList, $scope.selectedShopOrderType);
    $scope.shopOrderingByType($scope.allShopList, $scope.selectedShopOrderType);
  }
  function loadPrevShopSearchValue() {
    if ($rootScope.searchShop && $rootScope.searchShop.shopName) {
      $scope.searchShop.shopName = $rootScope.searchShop.shopName;
    }
    if (shopSearchObj) {
      shopSearchObj.value = $scope.searchShop.shopName;
    }
  }
  function activeDropdown(isActive) {
    if (orderDropObj) {
      orderDropObj.active = isActive;
    }
  }
  function getAllShopList() {
    $scope.loadShop = true;
    Shop.appDashboardShops().$promise.then(function (res) {
      var hasShop = res.shops && res.shops.length;
      $scope.loadShop = false;
      $rootScope.dashboardShopList = hasShop ? res.shops : [];
      $scope.allShopList = hasShop ? createAllShopList(res.shops) : [];
      activeDropdown(hasShop);
      orderingShop();
      loadPrevShopSearchValue();
      $rootScope.$broadcast("updateShopList");
    }, function (error) {
      $scope.loadShop = false;
      $scope.$root.createSessionDlg();
    });
  }
  $("body").on("click", globalClickCallback);
  if ($rootScope.dashboardCurShopId) {
    $scope.curShopId = $rootScope.dashboardCurShopId;
  }
  if ($rootScope.dashboardShopList) {
    $scope.allShopList = createAllShopList($rootScope.dashboardShopList);
    activeDropdown($scope.allShopList && $scope.allShopList.length);
    orderingShop();
    loadPrevShopSearchValue();
  } else {
    getAllShopList();
  }
}]);
"use strict";

app.controller("DashboardStaffCtrl", ["$scope", "Access", "GMap", "$filter", "$state", "$translate", "$timeout", "Utils", function ($scope, Access, GMap, $filter, $state, $translate, $timeout, Utils) {
  $scope.isUseGeofence = appConfig.useGeofence;
  $scope.accessDate = Date.now();
  $scope.isToday = true;
  $scope.currentTime = moment().format("HH:mm");
  $scope.shopId = $state.params.shopId;
  $scope.isLoaded = false;
  $scope.$on("$destroy", function () {
    $scope.datePicker.destroy();
    $(window).off("resize");
    if ($scope.isUseGeofence) {
      GMap.removeMapInstances();
    }
  });
  if (window.country === "ko") {
    $scope.isOnlyUseEmail = false;
  } else if (window.country === "ja") {
    $scope.isOnlyUseEmail = true;
  } else if (window.country === "en") {
    $scope.isOnlyUseEmail = false;
  } else {
    $scope.isOnlyUseEmail = false;
  }
  var showAlert = function showAlert(title, message) {
    $(".display_show").css("display", "");
    $scope.showAlert = true;
    $scope.alertTitle = title;
    $scope.alertMessage = message;
  };
  var updateMarketCloseTime = function updateMarketCloseTime(closeTime) {
    var hour = 0,
      min = 0;
    if (closeTime) {
      hour = Math.floor(closeTime / 60);
      min = closeTime % 60;
    }
    $("#market_close_hour").val("" + hour);
    $("#market_close_min").val("" + min);
  };
  $scope.datePicker = new Pikaday({
    field: document.getElementById("accessDate"),
    bound: false,
    container: document.getElementById("datePickerContainer"),
    // minDate: minDate.toDate(),
    maxDate: new Date(),
    defaultDate: new Date(),
    onSelect: function onSelect(date) {
      $scope.$apply(function () {
        $scope.accessDate = date;
        $scope.getAccessStaffs($scope.currentShop.shopId);
      });
      this.hide();
    }
  });
  $scope.datePicker.hide();
  $scope.showShopList = function (isShow) {
    $scope.isShowShopList = isShow;
  };
  $scope.selectShop = function (shopId, shopName) {
    if (shopName) {
      $("#shop_select_input").val(shopName);
    }
    if (shopId === "all") {
      $state.go("main.accessall");
    } else {
      if ($scope.currentShop.shopId === shopId) {
        $scope.showShopList(false);
      } else {
        $state.go("main.dashboard.staff", {
          shopId: shopId
        });
      }
    }
  };

  /**
   * 출입 관리 직원 목록 호출
   */
  $scope.getAccessStaffs = function (shopId) {
    $scope.isLoadingComplete = false;
    Access.getAccessStaffs({
      searchDate: $filter("date")($scope.accessDate, "yyyyMMdd"),
      searchStaff: $("input[name=searchStaff]").val()
    }).$promise.then(function (res) {
      $scope.isLoaded = true;
      $scope.shops = res.myShops;
      $scope.sharedShops = res.sharedShops;
      $scope.hiredShops = [];
      var filterHiredShop, filterHiredShop2;
      for (i = 0; i < res.hiredShops.length; i++) {
        if ($scope.shops.length > 0) {
          filterHiredShop = _.find($scope.shops, {
            shopId: res.hiredShops[i].shopId
          });
        }
        if ($scope.sharedShops.length > 0 && !filterHiredShop) {
          filterHiredShop2 = _.find($scope.sharedShops, {
            shopId: res.hiredShops[i].shopId
          });
        }
        if (!filterHiredShop && !filterHiredShop2) {
          $scope.hiredShops.push(res.hiredShops[i]);
        }
      }

      // shop 데이터 병합
      $scope.allShops = [];
      if ($scope.shops && $scope.shops.length > 0) {
        $scope.allShops = $scope.shops;
      }
      if ($scope.sharedShops && $scope.sharedShops.length > 0) {
        $scope.allShops = $scope.allShops.concat($scope.sharedShops);
      }
      if ($scope.hiredShops && $scope.hiredShops.length > 0) {
        $scope.allShops = $scope.allShops.concat($scope.hiredShops);
      }
      if (typeof shopId === "undefined" || shopId === "") {
        $scope.currentShop = $scope.shops[0];
        if ($scope.currentShop == null) {
          $scope.currentShop = $scope.sharedShops[0];
        }
        if ($scope.currentShop == null) {
          $scope.currentShop = $scope.hiredShops[0];
        }
      } else {
        $scope.currentShop = $scope.shops.filter(function (value) {
          return value.shopId === shopId;
        })[0];
        if ($scope.currentShop == null) {
          $scope.currentShop = $scope.sharedShops.filter(function (value) {
            return value.shopId === shopId;
          })[0];
        }
        if ($scope.currentShop == null) {
          $scope.currentShop = $scope.hiredShops.filter(function (value) {
            return value.shopId === shopId;
          })[0];
        }
      }
      if (typeof $scope.currentShop !== "undefined" && typeof $scope.currentShop.shopRegDate !== "undefined") {
        var shopRegDate = moment($scope.currentShop.shopRegDate).format("YYYYMMDD");
        var before3MonthMoment = moment().subtract(3, "months");
        if (shopRegDate > before3MonthMoment.format("YYYYMMDD")) {
          $scope.datePicker.setMinDate(new Date($scope.currentShop.shopRegDate));
        } else {
          $scope.datePicker.setMinDate(new Date(before3MonthMoment));
        }
      } else {
        $scope.datePicker.setMinDate(new Date());
      }
      if ($scope.currentShop) {
        $scope.initShowAccessModifyLayer();
      }
    }, function (err) {
      $scope.isLoaded = true;
      showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
    })["finally"](function () {
      $scope.isLoadingComplete = true;
      $scope.currentTime = moment().format("HH:mm");
      $scope.currentTimedotArea();
    });
  };
  $(window).on("resize", function () {
    $scope.currentTimedotArea();
    if (this.resizeTO) clearTimeout(this.resizeTO);
    this.resizeTO = setTimeout(function () {
      $scope.initTimeLine();
    }, 500);
  });
  $scope.initTimeLine = function () {
    var shopId = $state.params.shopId;
    $scope.getAccessStaffs(shopId);
  };
  $scope.currentTimedotArea = function () {
    $timeout(function () {
      var currentTimedotArea = $(".currentTimeDot").parent()[0];
      if (currentTimedotArea) {
        $scope.divX = $(currentTimedotArea).offset().left;
        $scope.divY = $(currentTimedotArea).offset().top;
        $(".dotted_time").css("left", $scope.divX);
        $(".dotted_time").css("top", $scope.divY);
      }
    });
  };
  /**
   * init
   */
  (function () {
    var shopId = $state.params.shopId;
    $scope.getAccessStaffs(shopId);
  })();

  /**
   * date picker open
   */
  $scope.toggleDatePicker = function (event) {
    event.stopPropagation();
    if ($scope.datePicker.isVisible()) {
      $scope.datePicker.hide();
    } else {
      $scope.datePicker.show();
    }
  };

  /**
   * 출입 관리 안내 팝업 open
   */
  $scope.showAccessInfoDialog = function () {
    showAlert($translate.instant("ACCESS_RECORD"), $translate.instant("ACCESS_RECORD_DESC"));
  };

  /**
   * 출입관리  내매장/공유받은매장 tab 변경 사용안함
   */
  $scope.changeTab = function (shopType) {
    $scope.currentTab = shopType;
    $scope.getAccessStaffs();
  };

  /**
   * 매장 출입설정 dialog open
   */
  $scope.showShopAccessConfigDialog = function () {
    $scope.isShowStaffRegistDialog = true;
  };

  /**
   * 오늘 날짜 조회로 변경
   */
  $scope.changeDate = function (index) {
    if (typeof index === "undefined") {
      $scope.accessDate = Date.now();
      $scope.isToday = true;
    } else {
      var culDate = moment($scope.accessDate).add(index, "d").format("YYYYMMDD");
      var minDate = moment().format("YYYYMMDD");
      var today = moment().format("YYYYMMDD");
      if (typeof $scope.currentShop !== "undefined" && typeof $scope.currentShop.shopRegDate !== "undefined") {
        minDate = moment($scope.currentShop.shopRegDate).format("YYYYMMDD");
      }
      if (today < culDate || minDate > culDate) {
        return;
      }
      $scope.accessDate = moment($scope.accessDate).add(index, "d").toDate();
      $scope.isToday = false;
      if (today == culDate) {
        $scope.isToday = true;
      }
    }
    $scope.getAccessStaffs($scope.currentShop.shopId);
  };

  /**
   * 직원검색
   */
  $scope.searchStaffs = function () {
    $scope.getAccessStaffs($state.params.shopId);
  };
  var renderDatePickerTimer;

  /**
   * 출입 직원 기록 엑셀 다운로드 open
   * @param {Object} currentShopInfo
   */
  $scope.showAccessStaffExcelDownloadConfirm = function () {
    var minDate;
    if (typeof $scope.currentShop !== "undefined" && typeof $scope.currentShop.shopRegDate !== "undefined") {
      minDate = new Date($scope.currentShop.shopRegDate);
      minDate = new Date($scope.currentShop.shopRegDate);
    } else {
      minDate = new Date();
      minDate = new Date();
    }
    renderDatePickerTimer = $timeout(function () {
      $scope.downStartDatePicker = new Pikaday({
        field: document.getElementById("downloadStartDt"),
        format: $translate.instant("CLIP_CREATE_CLIP_DATE_FORMAT"),
        minDate: minDate,
        maxDate: new Date(),
        defaultDate: new Date(),
        onSelect: function onSelect(date) {
          $scope.$apply(function () {
            $scope.downloadStartDt = moment(date).format($translate.instant("CLIP_CREATE_CLIP_DATE_FORMAT"));
          });
          this.hide();
        }
      });
      $scope.downEndDatePicker = new Pikaday({
        field: document.getElementById("downloadEndDt"),
        format: $translate.instant("CLIP_CREATE_CLIP_DATE_FORMAT"),
        minDate: minDate,
        maxDate: new Date(),
        defaultDate: new Date(),
        onSelect: function onSelect(date) {
          $scope.$apply(function () {
            $scope.downloadEndDt = moment(date).format($translate.instant("CLIP_CREATE_CLIP_DATE_FORMAT"));
          });
          this.hide();
        }
      });
      $scope.downStartDatePicker.hide();
      $scope.downEndDatePicker.hide();
      $scope.downloadEndDt = moment().format($translate.instant("CLIP_CREATE_CLIP_DATE_FORMAT"));
      $scope.downloadStartDt = moment().format($translate.instant("CLIP_CREATE_CLIP_DATE_FORMAT"));
      $scope.downloadDate_type = "today";
    });
    $scope.isShowAccessStaffExcelDownloadConfirm = true;
  };

  /**
   * 출입 직원 기록 엑셀 다운로드 close
   */
  $scope.hideAccessStaffExcelDownloadConfirm = function () {
    $scope.downStartDatePicker.destroy(); // pikday destroy
    $scope.downEndDatePicker.destroy(); // pikday destroy
    $scope.isShowAccessStaffExcelDownloadConfirm = false;
  };

  /**
   * date picker open
   */
  $scope.toggleDownStartCalendar = function (event) {
    event.stopPropagation();
    if ($scope.downloadDate_type != "custom") {
      return;
    }
    if ($scope.downStartDatePicker.isVisible()) {
      $scope.downStartDatePicker.hide();
    } else {
      $scope.downStartDatePicker.show();
    }
  };

  /**
   * date picker open
   */
  $scope.toggleDownEndCalendar = function (event) {
    event.stopPropagation();
    if ($scope.downloadDate_type != "custom") {
      return;
    }
    if ($scope.downEndDatePicker.isVisible()) {
      $scope.downEndDatePicker.hide();
    } else {
      $scope.downEndDatePicker.show();
    }
  };

  /**
   * 다운로드 날짜 type 변경
   */
  $scope.changeDateTypeRadio = function (type) {
    $scope.downloadDate_type = type;
    var dateStartMoment, dateEndMoment;
    if ($scope.downloadDate_type == "preMonthly") {
      dateStartMoment = moment().subtract(1, "months").format("YYYYMM") + "01";
      dateEndMoment = moment().subtract(1, "months").format("YYYYMM") + moment().subtract(1, "months").endOf("month").format("DD");
    } else if ($scope.downloadDate_type == "curMonthly") {
      dateStartMoment = moment().format("YYYYMM") + "01";
      dateEndMoment = moment().format("YYYYMMDD");
    } else {
      dateStartMoment = moment().format("YYYYMMDD");
      dateEndMoment = moment().format("YYYYMMDD");
    }
    $scope.downloadStartDt = moment(dateStartMoment, "YYYYMMDD").format($translate.instant("CLIP_CREATE_CLIP_DATE_FORMAT"));
    $scope.downloadEndDt = moment(dateEndMoment, "YYYYMMDD").format($translate.instant("CLIP_CREATE_CLIP_DATE_FORMAT"));
    $("#downloadStartDt").val($scope.downloadStartDt);
    $("#downloadEndDt").val($scope.downloadEndDt);
  };

  /**
   * 출입 직원 기록 엑셀 다운로드
   */
  $scope.accessStaffExcelDownload = function () {
    var dateStartMoment, dateEndMoment;
    dateStartMoment = $scope.downStartDatePicker.getMoment().format("YYYYMMDD");
    dateEndMoment = $scope.downEndDatePicker.getMoment().format("YYYYMMDD");
    if (dateStartMoment > dateEndMoment) {
      showAlert($translate.instant("ACCESS_DOWNLOAD"), $translate.instant("ACCESS_START_DAY_FIRST"));
      return;
    }
    if ($scope.downloadDate_type == "custom") {
      dateStartMoment = $scope.downStartDatePicker.getMoment().format("YYYYMMDD");
      dateEndMoment = $scope.downEndDatePicker.getMoment().format("YYYYMMDD");
    } else if ($scope.downloadDate_type == "preMonthly") {
      dateStartMoment = moment().subtract(1, "months").format("YYYYMM") + "01";
      dateEndMoment = moment().subtract(1, "months").format("YYYYMM") + moment().subtract(1, "months").endOf("month").format("DD");
    } else if ($scope.downloadDate_type == "curMonthly") {
      dateStartMoment = moment().format("YYYYMM") + "01";
      dateEndMoment = moment().format("YYYYMMDD");
    } else {
      dateStartMoment = moment().format("YYYYMMDD");
      dateEndMoment = moment().format("YYYYMMDD");
    }
    window.location.href = "/json/biz/shop/access/staffs/excel?shopId=" + $scope.currentShop.shopId + "&startDate=" + dateStartMoment + "&endDate=" + dateEndMoment;
    $scope.hideAccessStaffExcelDownloadConfirm();
  };
  $scope.formattedInternalDate = function (date) {
    var md;
    if ($scope.timeline.tz !== undefined) {
      md = moment(new Date(date)).tz($scope.timeline.tz);
    } else {
      md = moment(new Date(date));
    }
    return md.format("YYYYMMDD");
  };

  /**
   * 출입 설정 카메라 선택 팝업 오픈
   */
  $scope.showShowAccessModifyLayer = function () {
    $scope.initShowAccessModifyLayer();
    $scope.isShowAccessModifyLayer = true;
  };

  /**
   * 출입 설정 카메라 선택 팝업 닫기
   */
  $scope.closeShowAccessModifyLayer = function () {
    $scope.shopStaffsInfo = null;
    $scope.isShowAccessModifyLayer = false;
  };
  $scope.initShowAccessModifyLayer = function () {
    if (!$scope.currentShop.shopStaffs) {
      return;
    }
    $scope.saveStaffAccessDateList = [];
    $scope.shopStaffsInfo = $scope.currentShop.shopStaffs;
    var defultVal = {
      hour: "00",
      min: "00",
      today: false
    };
    for (i = 0; i < $scope.shopStaffsInfo.length; i++) {
      if ($scope.shopStaffsInfo[i].staffEvent.length == 0) {
        $scope.shopStaffsInfo[i].accessTimeIn = defultVal;
        $scope.shopStaffsInfo[i].accessTimeOut = defultVal;
      } else {
        $scope.shopStaffsInfo[i].accessTimeIn = $scope.formattedTime($scope.shopStaffsInfo[i].staffEvent[0].enterDate);
        $scope.shopStaffsInfo[i].accessTimeOut = $scope.formattedTime($scope.shopStaffsInfo[i].staffEvent[$scope.shopStaffsInfo[i].staffEvent.length - 1].exitDate);
      }
    }
  };
  $scope.formattedDate = function (date) {
    var format = d3.time.format($translate.instant("DATE_FORMAT_3"));
    return format(new Date(date));
  };
  $scope.formattedTime = function (date) {
    var targetDate = moment($scope.accessDate).format("YYYYMMDD");
    var todayTime = moment().format("YYYYMMDD");
    var paramDate = moment(date).format("YYYYMMDD");
    var hourFormat = d3.time.format("%H");
    var minFormat = d3.time.format("%M");
    var hourVal = "00";
    var minVal = "00";
    var todayVal = false;
    if (targetDate == paramDate) {
      hourVal = hourFormat(new Date(date));
      minVal = minFormat(new Date(date));
    }
    if (todayTime == targetDate) {
      if (moment().format("YYYYMMDDHHmm") < moment(date).format("YYYYMMDDHHmm")) {
        hourVal = hourFormat(new Date());
        minVal = minFormat(new Date());
        todayVal = true;
      }
    }
    var returnVal = {
      hour: hourVal,
      min: minVal,
      today: todayVal
    };
    return returnVal;
  };
  $scope.changeStaffAccessDate = function (staffId) {
    var flag = true;
    for (i = 0; i < $scope.saveStaffAccessDateList.length; i++) {
      if ($scope.saveStaffAccessDateList[i] == staffId) {
        flag = false;
      }
    }
    if (flag) {
      $scope.saveStaffAccessDateList.push(staffId);
    }
  };
  $scope.saveModifyStaffAccessDate = function () {
    if ($scope.saveStaffAccessDateList.length == 0) {
      showAlert($translate.instant("ACCESS_CHANGE"), $translate.instant("ACCESS_NO_CHANGE"));
      return;
    }
    var paramListString = "";
    for (i = 0; i < $scope.saveStaffAccessDateList.length; i++) {
      if (i != 0) {
        paramListString += ",";
      }
      var inDate = moment($scope.accessDate).format("YYYYMMDD") + $("#inAt_hour_" + $scope.saveStaffAccessDateList[i]).val() + $("#inAt_minute_" + $scope.saveStaffAccessDateList[i]).val();
      var outDate = moment($scope.accessDate).format("YYYYMMDD") + $("#outAt_hour_" + $scope.saveStaffAccessDateList[i]).val() + $("#outAt_minute_" + $scope.saveStaffAccessDateList[i]).val();
      if (inDate >= outDate) {
        showAlert($translate.instant("ACCESS_CHANGE"), $translate.instant("ACCESS_CLOSE_TIME_AHEAD"));
        return;
      }
      paramListString += $scope.saveStaffAccessDateList[i] + ":" + moment(inDate, "YYYYMMDDHHmm", true).format("x") + ":" + moment(outDate, "YYYYMMDDHHmm", true).format("x");
    }
    var param = {
      inouts: paramListString
    };
    Access.saveAccessStaffsDate({
      shopId: $scope.currentShop.shopId
    }, param, function (res) {
      if (res.code === "ok") {
        showAlert($translate.instant("ACCESS_CHANGE"), $translate.instant("ACCESS_RECORD_CHANGE_COMPLETE"));
        $scope.closeShowAccessModifyLayer();
        $scope.getAccessStaffs($scope.currentShop.shopId);
      } else {
        showAlert($translate.instant("ACCESS_CHANGE"), $translate.instant("ACCESS_RECORD_CHANGE_FAIL"));
      }
    }, function (err) {
      showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
    });
  };

  // 직원별 기록
  $scope.moveStaffHistoryPage = function (shopInfo, staffId) {
    var staffId;
    var shopId = shopInfo.shopId;
    if (staffId) {
      staffId = staffId;
    } else {
      var staffindex = 0;
      for (i = 0; i < shopInfo.shopStaffs.length; i++) {
        if (shopInfo.shopStaffs[i].userId != "" && shopInfo.shopStaffs[i].userId) {
          staffindex = i;
          break;
        }
      }
      staffId = shopInfo.shopStaffs[staffindex].userId;
    }
    var searchDate = moment($scope.accessDate).format("YYYYMMDD");
    var shopName = $translate.instant("SHOP_NAME");
    if ($scope.currentShop) {
      shopName = $scope.currentShop.shopName;
    }
    $state.go("main.dashboard.staffWeekly", {
      shopId: shopId,
      staffId: staffId,
      searchDate: searchDate,
      shopName: shopName
    });
  };
  $scope.showAccessNotificationSettingLayer = function () {
    Access.getAccessAlramConfig({
      shopId: $scope.currentShop.shopId
    }, function (res) {
      $scope.notify = {
        notifyEventType: Utils.notifyEventTypeSeparate(res.notifyEventType),
        scheduleOn: res.notifySchedule.scheduleOn,
        alarmOn: res.notifySchedule.alarmOn,
        alarmAlways: res.notifySchedule.alarmAlways,
        startAt: Utils.configDateSeparate(res.notifySchedule.startAt),
        stopAt: Utils.configDateSeparate(res.notifySchedule.stopAt),
        repeatOn: Utils.configRepeatOnSeparate(res.notifySchedule.repeatOn)
      };
      $scope.isShowAccessNotificationSettingLayer = true;
    }, function (err) {
      showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
    });
  };
  $scope.hideAccessNotificationSettingLayer = function () {
    $scope.isShowAccessNotificationSettingLayer = false;
  };

  // 알림설정 저장 확인 팝업 open
  $scope.showSaveAlarmSettingConfirmLayer = function () {
    var isCheckedDays = _.includes($scope.notify.repeatOn, false); // 일반 알림은 값 반전
    if (!isCheckedDays && $scope.notify.alarmOn === "on" && $scope.notify.alarmAlways === "off") {
      showAlert($translate.instant("ACCESS_ALARM_SET"), $translate.instant("ACCESS_ALARM_SET_DESC"));
      return;
    }
    $scope.isShowSaveAlarmSettingConfirmLayer = true;
  };

  // 알림설정 저장 확인 팝업 close
  $scope.hideSaveAlarmSettingConfirmLayer = function () {
    $scope.isShowSaveAlarmSettingConfirmLayer = false;
  };

  // 알림설정 저장
  $scope.saveAlarmSetting = function () {
    var params = angular.copy($scope.notify);
    params.notifyEventType = Utils.notifyEventTypeJoin(params.notifyEventType);
    params.startAt = Utils.configDateJoin(params.startAt);
    params.stopAt = Utils.configDateJoin(params.stopAt);
    params.repeatOn = Utils.configRepeatOnJoin(params.repeatOn);
    Access.saveAccessAlramConfig({
      shopId: $scope.currentShop.shopId
    }, params, function (data) {
      if (data.code === "ok") {
        showAlert($translate.instant("STR_ALARM_SET_SHOW"), $translate.instant("STR_MODIFY_ACCESS_ALARM"));
        $scope.isShowSaveAlarmSettingConfirmLayer = false;
      } else {
        showAlert($translate.instant("FAIL"), $translate.instant("ACCESS_SET_FAIL"));
      }
    }, function (err) {
      showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
    });
  };
}]);
"use strict";

app.controller('DashboardStaffMonthlyCtrl', ['$scope', 'Shop', 'Access', 'AccessStaffWeekly', 'AccessStaffMonthly', '$filter', '$q', '$state', '$translate', '$timeout', function ($scope, Shop, Access, AccessStaffWeekly, AccessStaffMonthly, $filter, $q, $state, $translate, $timeout) {
  $scope.today = moment().startOf('day').valueOf();
  $scope.accessDate = Date.now();
  $scope.startDate = Date.now();
  $scope.endDate = Date.now();
  $scope.timelineDate = Date.now();
  $scope.timelineStaff = {};
  $scope.isLastTime = false;

  // 선택된 직원정보
  $scope.staffName = '';
  $scope.paycoMaskingId = '';

  // 매장 직원목록
  $scope.shopStaffs = [];

  // 출입기록 monthly
  $scope.accessInfoMonthly = {};
  $scope.dataLoaded = false;
  $scope.isLoadingComplete = true;

  // 달력
  $scope.calendar = [];
  $scope.$on('$destroy', function () {
    datePicker.destroy();
    $(window).off("resize");
  });
  var showAlert = function showAlert(title, message) {
    $(".display_show").css("display", "");
    $scope.showAlert = true;
    $scope.alertTitle = title;
    $scope.alertMessage = message;
  };
  var datePicker = new Pikaday({
    field: document.getElementById('accessDate'),
    bound: false,
    container: document.getElementById('datePickerContainer'),
    minDate: new Date(moment().subtract(3, "months")),
    maxDate: new Date(),
    defaultDate: new Date(),
    onSelect: function onSelect(date) {
      $scope.$apply(function () {
        $scope.changeDate(moment(date).format("YYYYMMDD"));
      });
      this.hide();
    }
  });
  datePicker.hide();

  /**
   * 출입 관리 직원 목록 호출
   */
  $scope.getAccessStaffs = function (shopId, staffId, searchDate) {
    $scope.isLoadingComplete = false;
    AccessStaffMonthly.getAccessStaffMonthly({
      shopId: shopId,
      staffId: staffId,
      searchDate: searchDate
    }).$promise.then(function (res) {
      $scope.accessInfoMonthly = res.accessInfoMonthly;
      $scope.setTimeLineStaff($scope.timelineDateL);
      $scope.calendar = [];
      $scope.initCalendar();
      $scope.dataLoaded = true; // 데이터 초기화완료. 데이터 출입기록이 없습니다 메시지 표시됨.
      $scope.getCurrentStaffInfo($scope.shopId);
    }, function (err) {
      showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
    })["finally"](function () {
      $scope.isLoadingComplete = true;
    });
  };

  /**
   * 현재 직원정보 조회
   */
  $scope.getCurrentStaffInfo = function (shopId) {
    if ($scope.accessInfoMonthly.paycoIdMasking != null && $scope.accessInfoMonthly.paycoIdMasking !== '') {
      $scope.staffName = $scope.accessInfoMonthly.staffName;
      $scope.paycoMaskingId = $scope.accessInfoMonthly.paycoIdMasking;
      return;
    }
    var endDate = moment().format("YYYYMMDD");
    var startDate = moment().subtract(3, 'months').format("YYYYMMDD");
    $scope.isLoadingComplete = false;
    AccessStaffWeekly.getShopStaffs({
      shopId: shopId,
      startDate: startDate,
      endDate: endDate
    }).$promise.then(function (res) {
      $scope.shopStaffsFor3Month = res.shopStaffs;
      // 직원정보 조회
      if ($scope.shopStaffsFor3Month != null) {
        for (var i = 0; i < $scope.shopStaffsFor3Month.length; i++) {
          var staffTemp = $scope.shopStaffsFor3Month[i];
          if ($scope.staffId === staffTemp.userId) {
            $scope.staffName = staffTemp.staffName;
            $scope.paycoMaskingId = staffTemp.paycoMaskingId;
            break;
          }
        }
      }
    }, function (err) {
      showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
    })["finally"](function () {
      $scope.isLoadingComplete = true;
    });
  };

  /**
   * 점포 직원목록을 조회한다.
   */
  $scope.getShopStaffs = function (shopId, startDate, endDate) {
    $scope.isLoadingComplete = false;
    AccessStaffWeekly.getShopStaffs({
      shopId: shopId,
      startDate: startDate,
      endDate: endDate
    }).$promise.then(function (res) {
      $scope.shopStaffs = res.shopStaffs;
    }, function (err) {
      showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
    })["finally"](function () {
      $scope.isLoadingComplete = true;
    });
  };

  /**
   * 검색일자로 해당 주 월요일과 일요일을 구한다.
   */
  $scope.initSearchDate = function () {
    $scope.searchDate = $state.params.searchDate;
    $scope.accessDateMoment = moment($scope.searchDate, "YYYYMMDD");
    $scope.accessDate = $scope.accessDateMoment.toDate(); // accessDate 초기화
    $scope.startDateMoment = $scope.accessDateMoment.clone().startOf("month");
    $scope.startDate = $scope.startDateMoment.toDate();
    $scope.endDateMoment = $scope.accessDateMoment.clone().endOf("month"); // 일요일
    $scope.endDate = $scope.endDateMoment.toDate();
    $scope.timelineDateL = $scope.accessDate.getTime();
    $scope.isLastTime = ($scope.startDateMoment.isSame(moment()) || $scope.startDateMoment.isBefore(moment())) && ($scope.endDateMoment.isSame(moment()) || $scope.endDateMoment.isAfter(moment()));
  };

  // 달력 생성
  // 스타일정보와 근무시간 정보도 설정한다.
  $scope.initCalendar = function () {
    var startingHiddenDay = $scope.startDateMoment.day(); // 1일 시작전 공백 갯수
    var week = [];
    var day = {};

    // 1일 시작전 공백 <td> 생성
    for (var i = 0; i < startingHiddenDay; i++) {
      day = {};
      if (i === 0) {
        day.sunday = true;
      }
      day.hiddenDay = true;
      day.on = false;
      week.push(day);
    }
    // 1일 ~ 말일까지의 <td> 생성
    for (var currMoment = $scope.startDateMoment.clone(); currMoment.isBefore($scope.endDateMoment) || currMoment.isSame($scope.endDateMoment); currMoment.add(1, "days")) {
      day = {};
      if (currMoment.day() === 0 && currMoment.date() != 1) {
        $scope.calendar.push(week);
        week = [];
      }
      if (currMoment.day() === 0) {
        day.sunday = true;
      }
      day.hiddenDay = false;
      if (currMoment.isSame($scope.accessDateMoment)) {
        day.on = true;
      } else {
        day.on = false;
      }
      day.staff = $scope.findStaffEvent(currMoment.valueOf());
      week.push(day);
    }
    // 말일 이후 공백 <td> 생성
    for (var i = week.length; i < 7; i++) {
      day = {};
      day.sunday = false;
      day.hiddenDay = true;
      day.on = false;
      week.push(day);
    }
    $scope.calendar.push(week);
  };

  // 검색일자 유효성 체크
  $scope.checkDate = function (searchDate) {
    var nowMoment = moment();
    var searchDateMoment = moment(searchDate, 'YYYYMMDD');
    if (searchDateMoment.startOf('month').isAfter(nowMoment.startOf('month'))) {
      // 이번달 이후 검색은 불가처리
      return false;
    }
    var before3MonthMoment = moment().subtract(3, "months");
    if (searchDateMoment.isBefore(before3MonthMoment)) {
      // 3개월 이전 검색은 불가처리
      showAlert($translate.instant("ACCESS_ALARM"), $translate.instant("ACCESS_ALARM_MONTH3_RECORD"));
      return false;
    }
    return true;
  };

  // 타임라인 설정
  $scope.setTimeLineStaff = function (timelineDateL) {
    if ($scope.accessInfoMonthly && $scope.accessInfoMonthly.shopAccessDays) {
      for (var i = 0, leng = $scope.accessInfoMonthly.shopAccessDays.length; i < leng; i++) {
        var staff = $scope.accessInfoMonthly.shopAccessDays[i];
        if (staff.shopAccessDate === timelineDateL) {
          $scope.timelineStaff = staff;
          break;
        }
      }
    }
  };

  // staff event 검색
  $scope.findStaffEvent = function (dateL) {
    if ($scope.accessInfoMonthly && $scope.accessInfoMonthly.shopAccessDays) {
      for (var i = 0, leng = $scope.accessInfoMonthly.shopAccessDays.length; i < leng; i++) {
        var staff = $scope.accessInfoMonthly.shopAccessDays[i];
        if (staff.shopAccessDate === dateL) {
          return staff;
        }
      }
    }
    return {};
  };

  /**
   * my shop을 조회하고, 현재조회중인 점포가 내 점포인지 확인한다.
   */
  $scope.getMyShop = function () {
    $scope.isLoadingComplete = false;
    Shop.query().$promise.then(function (res) {
      $scope.myShops = res;
      $scope.isMyShop = false;
      if ($scope.myShops) {
        for (var i = 0; i < $scope.myShops.length; i++) {
          var myShop = $scope.myShops[i];
          if (myShop.shopId === $scope.shopId) {
            $scope.isMyShop = true;
            break;
          }
        }
      }
    }, function (err) {
      showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
    })["finally"](function () {
      $scope.isLoadingComplete = true;
    });
  };

  /**
   * init
   */
  (function () {
    $scope.shopId = $state.params.shopId;
    $scope.staffId = $state.params.staffId;
    $scope.shopName = $state.params.shopName;
    $scope.initSearchDate();
    if (!$scope.checkDate($scope.searchDate)) {
      return;
    }
    $scope.getAccessStaffs($scope.shopId, $scope.staffId, $scope.searchDate);
    $scope.getShopStaffs($scope.shopId, $scope.startDateMoment.format("YYYYMMDD"), $scope.endDateMoment.format("YYYYMMDD"));
    $scope.getMyShop();
  })();
  $(window).resize(function () {
    if (this.resizeTO) clearTimeout(this.resizeTO);
    this.resizeTO = setTimeout(function () {
      $scope.initTimeLine();
    }, 500);
  });
  $scope.initTimeLine = function () {
    $state.reload();
  };
  /**
   * date picker open
   */
  $scope.toggleDatePicker = function (event) {
    event.stopPropagation();
    if (datePicker.isVisible()) {
      datePicker.hide();
    } else {
      datePicker.show();
    }
  };
  $scope.goAccManagePage = function () {
    $state.go('main.dashboard.staff', {
      shopId: $scope.shopId
    });
  };

  // 직원목록에서 직원 선택 시 해당 직원 주간 출입기록조회로 이동
  $scope.goOtherStaffPage = function (staffId) {
    $state.go('main.dashboard.staffMonthly', {
      shopId: $scope.shopId,
      staffId: staffId,
      searchDate: $scope.searchDate,
      shopName: $scope.shopName
    });
  };

  // 오늘 검색
  $scope.goToday = function () {
    var searchDate = moment().format("YYYYMMDD");
    $scope.changeDate(searchDate);
  };

  // 이전 주
  $scope.prevMonth = function () {
    var searchDate = $scope.accessDateMoment.clone().subtract(1, 'months').format("YYYYMMDD");
    $scope.changeDate(searchDate);
  };

  // 다음 주
  $scope.nextMonth = function () {
    var searchDate = $scope.accessDateMoment.clone().add(1, 'months').format("YYYYMMDD");
    $scope.changeDate(searchDate);
  };

  // 다른날짜로 검색
  $scope.changeDate = function (searchDate) {
    // 검색일자 유효성 체크
    if (!$scope.checkDate(searchDate)) {
      return;
    }
    $state.go('main.dashboard.staffMonthly', {
      shopId: $scope.shopId,
      staffId: $scope.staffId,
      searchDate: searchDate,
      shopName: $scope.shopName
    });
  };

  // 주별보기로 이동
  $scope.goWeekly = function (searchDate) {
    $state.go('main.dashboard.staffWeekly', {
      shopId: $scope.shopId,
      staffId: $scope.staffId,
      searchDate: moment().format("YYYYMMDD"),
      shopName: $scope.shopName
    });
  };

  // 달력의 항목 선택. 타임라인을 해당 데이터로 변경한다.
  $scope.changeTimeline = function (day) {
    if (day.staff) {
      if (!$scope.checkDate(moment(day.staff.shopAccessDate).format("YYYYMMDD"))) {
        return;
      }
      $state.go('main.dashboard.staffMonthly', {
        shopId: $scope.shopId,
        staffId: $scope.staffId,
        searchDate: moment(day.staff.shopAccessDate).format("YYYYMMDD"),
        shopName: $scope.shopName
      });
    }
  };

  // 출입수정 확인 버튼 클릭
  $scope.confirmUpdateAccess = function () {
    var paramListString = '';
    var inputError = false;
    if ($("#changedYn").val() == 'Y') {
      if (paramListString.length != 0) {
        paramListString += ",";
      }
      var accessDateMoment = moment(parseInt($("#shopAccessDate").val(), 10));
      var inDate = moment(accessDateMoment.format("YYYYMMDD") + $("#inAt_hour").val() + $("#inAt_minute").val(), "YYYYMMDDHHmm").format("x");
      var outDate = moment(accessDateMoment.format("YYYYMMDD") + $("#outAt_hour").val() + $("#outAt_minute").val(), "YYYYMMDDHHmm").format("x");
      paramListString += $scope.accessInfoMonthly.userId + ":" + inDate + ":" + outDate;
      if (inDate >= outDate) {
        showAlert($translate.instant("ACCESS_CHANGE"), $translate.instant("ACCESS_CLOSE_TIME_AHEAD"));
        inputError = true;
        return;
      }
    }
    if (inputError) {
      return;
    }

    // console.log("paramListString: " + paramListString);

    var param = {
      inouts: paramListString
    };
    Access.saveAccessStaffsDate({
      shopId: $scope.shopId
    }, param, function (res) {
      if (res.code === 'ok') {
        // 출입수정 모드 해제
        $scope.updateAccessMode = false;
        // 출입수정 시간선택 레이어 숨김
        $(".revise_ly").hide();
        showAlert($translate.instant("ACCESS_CHANGE"), $translate.instant("ACCESS_RECORD_CHANGE_COMPLETE"));
        // 변경사항 반영을 위해 데이터 재조회
        $state.go('main.dashboard.staffMonthly', {
          shopId: $scope.shopId,
          staffId: $scope.staffId,
          searchDate: $scope.searchDate,
          shopName: $scope.shopName
        }, {
          reload: true
        });
      } else {
        showAlert($translate.instant("ACCESS_CHANGE"), $translate.instant("ACCESS_RECORD_CHANGE_FAIL"));
      }
    }, function (err) {
      showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
    });
  };

  // 출입수정 버튼 클릭
  $scope.updateAccess = function () {
    $scope.updateAccessMode = true;
  };

  // 출입수정 취소 버튼 클릭
  $scope.cancelUpdateAccess = function () {
    // 출입수정 모드 해제
    $scope.updateAccessMode = false;
    // 출입수정 시간선택 레이어 숨김
    $(".revise_ly").hide();
  };

  // 수정 버튼 클릭 시
  $scope.toggleUpdateLayer = function (layerId) {
    if ($("#" + layerId).is(":visible")) {
      $("#" + layerId).hide();
    } else {
      $("#" + layerId).show();
    }
  };

  // 출입수정 시간 변경 시
  $scope.changeStaffAccessDate = function () {
    $("#changedYn").val('Y');
  };
  $scope.getHour = function (dateL) {
    return moment(dateL).format('HH');
  };
  $scope.getMinute = function (dateL) {
    return moment(dateL).format('mm');
  };
}]);
"use strict";

app.controller('DashboardStaffWeeklyCtrl', ['$scope', 'Shop', 'Access', 'AccessStaffWeekly', '$filter', '$q', '$state', '$translate', '$timeout', function ($scope, Shop, Access, AccessStaffWeekly, $filter, $q, $state, $translate, $timeout) {
  $scope.today = moment().startOf('day').valueOf();
  $scope.accessDate = Date.now();
  $scope.startDate = Date.now();
  $scope.endDate = Date.now();
  $scope.isLastTime = false;
  $scope.accessUpdateMode = false;

  // 선택된 직원정보
  $scope.staffName = '';
  $scope.paycoMaskingId = '';

  // 매장 직원목록
  $scope.shopStaffs = [];

  // 출입기록 weekly
  $scope.accessInfoWeekly = {};
  $scope.dataLoaded = false;
  $scope.isLoadingComplete = true;
  $scope.$on('$destroy', function () {
    datePicker.destroy();
    $(window).off("resize");
  });
  var showAlert = function showAlert(title, message) {
    $(".display_show").css("display", "");
    $scope.showAlert = true;
    $scope.alertTitle = title;
    $scope.alertMessage = message;
  };
  var datePicker = new Pikaday({
    field: document.getElementById('accessDate'),
    bound: false,
    container: document.getElementById('datePickerContainer'),
    minDate: new Date(moment().subtract(3, "months")),
    maxDate: new Date(),
    defaultDate: new Date(),
    onSelect: function onSelect(date) {
      $scope.$apply(function () {
        $scope.changeDate(moment(date).format("YYYYMMDD"));
      });
      this.hide();
    }
  });
  datePicker.hide();

  /**
   * 출입 관리 직원 목록 호출
   */
  $scope.getAccessStaffs = function (shopId, staffId, searchDate) {
    $scope.isLoadingComplete = false;
    AccessStaffWeekly.getAccessStaffWeekly({
      shopId: shopId,
      staffId: staffId,
      searchDate: searchDate
    }).$promise.then(function (res) {
      $scope.accessInfoWeekly = res.accessInfoWeekly;
      $scope.dataLoaded = true; // 데이터 초기화완료. 데이터 출입기록이 없습니다 메시지 표시됨.
      $scope.getCurrentStaffInfo($scope.shopId);
    }, function (err) {
      showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
    })["finally"](function () {
      $scope.isLoadingComplete = true;
    });
  };

  /**
   * 현재 직원정보 조회
   */
  $scope.getCurrentStaffInfo = function (shopId) {
    if ($scope.accessInfoWeekly.paycoIdMasking != null && $scope.accessInfoWeekly.paycoIdMasking !== '') {
      $scope.staffName = $scope.accessInfoWeekly.staffName;
      $scope.paycoMaskingId = $scope.accessInfoWeekly.paycoIdMasking;
      return;
    }
    var endDate = moment().format("YYYYMMDD");
    var startDate = moment().subtract(3, 'months').format("YYYYMMDD");
    $scope.isLoadingComplete = false;
    AccessStaffWeekly.getShopStaffs({
      shopId: shopId,
      startDate: startDate,
      endDate: endDate
    }).$promise.then(function (res) {
      $scope.shopStaffsFor3Month = res.shopStaffs;
      // 직원정보 조회
      if ($scope.shopStaffsFor3Month != null) {
        for (var i = 0; i < $scope.shopStaffsFor3Month.length; i++) {
          var staffTemp = $scope.shopStaffsFor3Month[i];
          if ($scope.staffId === staffTemp.userId) {
            $scope.staffName = staffTemp.staffName;
            $scope.paycoMaskingId = staffTemp.paycoMaskingId;
            break;
          }
        }
      }
    }, function (err) {
      showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
    })["finally"](function () {
      $scope.isLoadingComplete = true;
    });
  };

  /**
   * 점포 직원목록을 조회한다.
   */
  $scope.getShopStaffs = function (shopId, startDate, endDate) {
    $scope.isLoadingComplete = false;
    AccessStaffWeekly.getShopStaffs({
      shopId: shopId,
      startDate: startDate,
      endDate: endDate
    }).$promise.then(function (res) {
      $scope.shopStaffs = res.shopStaffs;
    }, function (err) {
      showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
    })["finally"](function () {
      $scope.isLoadingComplete = true;
    });
  };

  /**
   * my shop을 조회하고, 현재조회중인 점포가 내 점포인지 확인한다.
   */
  $scope.getMyShop = function () {
    $scope.isLoadingComplete = false;
    Shop.query().$promise.then(function (res) {
      $scope.myShops = res;
      $scope.isMyShop = false;
      for (var i = 0; i < $scope.myShops.length; i++) {
        var myShop = $scope.myShops[i];
        if (myShop.shopId === $scope.shopId) {
          $scope.isMyShop = true;
          break;
        }
      }
    }, function (err) {
      showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
    })["finally"](function () {
      $scope.isLoadingComplete = true;
    });
  };

  /**
   * 검색일자로 해당 주 월요일과 일요일을 구한다.
   */
  $scope.initSearchDate = function () {
    $scope.searchDate = $state.params.searchDate;
    $scope.accessDateMoment = moment($scope.searchDate, "YYYYMMDD");
    $scope.accessDate = $scope.accessDateMoment.toDate(); // accessDate 초기화
    if ($scope.accessDateMoment.day() === 0) {
      // 일요일인 경우 별도 처리 - moment는 일요일 부터 토요일을 1주일로 처리한다.
      $scope.startDateMoment = $scope.accessDateMoment.clone().subtract(1, "days").day("Monday"); // 월요일
      $scope.startDate = $scope.startDateMoment.toDate();
      $scope.endDateMoment = $scope.accessDateMoment.clone(); // 일요일
      $scope.endDate = $scope.endDateMoment.toDate();
    } else {
      $scope.startDateMoment = $scope.accessDateMoment.clone().day("Monday"); // 월요일
      $scope.startDate = $scope.startDateMoment.toDate();
      $scope.endDateMoment = $scope.startDateMoment.clone().day(7); // 일요일
      $scope.endDate = $scope.endDateMoment.toDate();
    }
    $scope.isLastTime = ($scope.startDateMoment.isSame(moment()) || $scope.startDateMoment.isBefore(moment())) && ($scope.endDateMoment.isSame(moment()) || $scope.endDateMoment.isAfter(moment()));
  };

  // 검색일자 유효성 체크
  $scope.checkDate = function (searchDate) {
    var nowMoment = moment();
    var searchDateMoment = moment(searchDate, 'YYYYMMDD');
    if (searchDateMoment.isAfter(nowMoment)) {
      // 오늘날짜 이후 검색은 불가처리
      return false;
    }
    var before3MonthMoment = moment().subtract(3, "months");
    if (searchDateMoment.isBefore(before3MonthMoment)) {
      // 3개월 이전 검색은 불가처리
      showAlert($translate.instant("ACCESS_ALARM"), $translate.instant("ACCESS_ALARM_MONTH3_RECORD"));
      return false;
    }
    return true;
  };

  /**
   * init
   */
  (function () {
    $scope.shopId = $state.params.shopId;
    $scope.staffId = $state.params.staffId;
    $scope.shopName = $state.params.shopName;
    $scope.initSearchDate();
    if (!$scope.checkDate($scope.searchDate)) {
      return;
    }
    $scope.getAccessStaffs($scope.shopId, $scope.staffId, $scope.searchDate);
    $scope.getShopStaffs($scope.shopId, $scope.startDateMoment.format("YYYYMMDD"), $scope.endDateMoment.format("YYYYMMDD"));
    $scope.getMyShop();
  })();

  /**
   * date picker open
   */
  $scope.toggleDatePicker = function (event) {
    event.stopPropagation();
    if (datePicker.isVisible()) {
      datePicker.hide();
    } else {
      datePicker.show();
    }
  };
  $scope.goAccManagePage = function () {
    $state.go('main.dashboard.staff', {
      shopId: $scope.shopId
    });
  };

  // 직원목록에서 직원 선택 시 해당 직원 주간 출입기록조회로 이동
  $scope.goOtherStaffPage = function (staffId) {
    $state.go('main.dashboard.staffWeekly', {
      shopId: $scope.shopId,
      staffId: staffId,
      searchDate: $scope.searchDate,
      shopName: $scope.shopName
    });
  };

  // 오늘 검색
  $scope.goToday = function () {
    var searchDate = moment().format("YYYYMMDD");
    $scope.changeDate(searchDate);
  };

  // 이전 주
  $scope.prevWeek = function () {
    var searchDate = $scope.accessDateMoment.clone().subtract(7, 'days').format("YYYYMMDD");
    $scope.changeDate(searchDate);
  };

  // 다음 주
  $scope.nextWeek = function () {
    var searchDate = $scope.accessDateMoment.clone().add(7, 'days').format("YYYYMMDD");
    $scope.changeDate(searchDate);
  };

  // 다른날짜로 검색
  $scope.changeDate = function (searchDate) {
    // 검색일자 유효성 체크
    if (!$scope.checkDate(searchDate)) {
      return;
    }
    $state.go('main.dashboard.staffWeekly', {
      shopId: $scope.shopId,
      staffId: $scope.staffId,
      searchDate: searchDate,
      shopName: $scope.shopName
    });
  };

  // 월별보기로 이동
  $scope.goMonthly = function (searchDate) {
    $state.go('main.dashboard.staffMonthly', {
      shopId: $scope.shopId,
      staffId: $scope.staffId,
      searchDate: moment().format("YYYYMMDD"),
      shopName: $scope.shopName
    });
  };

  // 출입수정 버튼 클릭
  $scope.updateAccess = function () {
    $scope.updateAccessMode = true;
  };

  // 출입수정 확인 버튼 클릭
  $scope.confirmUpdateAccess = function () {
    var paramListString = '';
    var inputError = false;
    $(".revise_ly").each(function (i) {
      if ($("#changedYn_" + i).val() == 'Y') {
        if (paramListString.length != 0) {
          paramListString += ",";
        }
        // console.log($("#shopAccessDate_"+i).val());
        var accessDateMoment = moment(parseInt($("#shopAccessDate_" + i).val(), 10));
        // console.log(accessDateMoment);
        // console.log(accessDateMoment.format("YYYYMMDD") + $("#inAt_hour_"+ i).val() + $("#inAt_minute_"+ i).val());
        // console.log(accessDateMoment.format("YYYYMMDD") + $("#outAt_hour_"+ i).val() + $("#outAt_minute_"+ i).val());
        var inDate = moment(accessDateMoment.format("YYYYMMDD") + $("#inAt_hour_" + i).val() + $("#inAt_minute_" + i).val(), "YYYYMMDDHHmm").format("x");
        var outDate = moment(accessDateMoment.format("YYYYMMDD") + $("#outAt_hour_" + i).val() + $("#outAt_minute_" + i).val(), "YYYYMMDDHHmm").format("x");
        paramListString += $scope.accessInfoWeekly.userId + ":" + inDate + ":" + outDate;
        if (inDate >= outDate) {
          showAlert($translate.instant("ACCESS_CHANGE"), $translate.instant("ACCESS_CLOSE_TIME_AHEAD"));
          inputError = true;
          return;
        }
      }
    });
    if (inputError) {
      return;
    }

    // console.log("paramListString: " + paramListString);

    var param = {
      inouts: paramListString
    };
    Access.saveAccessStaffsDate({
      shopId: $scope.shopId
    }, param, function (res) {
      if (res.code === 'ok') {
        // 출입수정 모드 해제
        $scope.updateAccessMode = false;
        // 출입수정 시간선택 레이어 숨김
        $(".revise_ly").hide();
        showAlert($translate.instant("ACCESS_CHANGE"), $translate.instant("ACCESS_RECORD_CHANGE_COMPLETE"));
        // 변경사항 반영을 위해 데이터 재조회
        $scope.getAccessStaffs($scope.shopId, $scope.staffId, $scope.searchDate);
      } else {
        showAlert($translate.instant("ACCESS_CHANGE"), $translate.instant("ACCESS_RECORD_CHANGE_FAIL"));
      }
    }, function (err) {
      showAlert($translate.instant("ACCESS_NET_FAIL"), $translate.instant("ACCESS_NET_FAIL_DESC"));
    });
  };

  // 출입수정 취소 버튼 클릭
  $scope.cancelUpdateAccess = function () {
    // 출입수정 모드 해제
    $scope.updateAccessMode = false;
    // 출입수정 시간선택 레이어 숨김
    $(".revise_ly").hide();
  };

  // 수정 버튼 클릭 시
  $scope.toggleUpdateLayer = function (layerId) {
    if ($("#" + layerId).is(":visible")) {
      $("#" + layerId).hide();
    } else {
      $("#" + layerId).show();
    }
  };

  // 출입수정 시간 변경 시
  $scope.changeStaffAccessDate = function (index) {
    $("#changedYn_" + index).val('Y');
  };
  $scope.getHour = function (dateL) {
    return moment(dateL).format('HH');
  };
  $scope.getMinute = function (dateL) {
    return moment(dateL).format('mm');
  };
  $(window).resize(function () {
    if (this.resizeTO) clearTimeout(this.resizeTO);
    this.resizeTO = setTimeout(function () {
      $scope.initTimeLine();
    }, 500);
  });
  $scope.initTimeLine = function () {
    $state.reload();
  };
}]);